
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8a08"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8a08"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ih19M", function(module, exports) {
"use strict";

module.exports = (parcelRequire("0qhf8"));

});
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("6afFj", function(module, exports) {
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

module.exports = (parcelRequire("foRq4"));

});
parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b36288e2db101ba3$var$Mg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Ng = null, $b36288e2db101ba3$var$Og = null, $b36288e2db101ba3$var$Pg = null;
function $b36288e2db101ba3$var$Qg() {
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Ng = null;
}
function $b36288e2db101ba3$var$Rg(a) {
    var b = $b36288e2db101ba3$var$Mg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Mg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$Tg(a, b) {
    $b36288e2db101ba3$var$Ng = a;
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$Ug = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$Vg(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Og) {
            if (null === $b36288e2db101ba3$var$Ng) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Og = a;
            $b36288e2db101ba3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Og.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$Wg = null;
function $b36288e2db101ba3$var$Xg(a) {
    null === $b36288e2db101ba3$var$Wg ? $b36288e2db101ba3$var$Wg = [
        a
    ] : $b36288e2db101ba3$var$Wg.push(a);
}
function $b36288e2db101ba3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$Zg(a, d);
}
function $b36288e2db101ba3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$$g = !1;
function $b36288e2db101ba3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$Zg(a, c);
}
function $b36288e2db101ba3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$jh = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$L(), d = $b36288e2db101ba3$var$lh(a), e = $b36288e2db101ba3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$dh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, d, c), $b36288e2db101ba3$var$eh(b, a, d));
    }
};
function $b36288e2db101ba3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$ph(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$Vg(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$jh;
    $b36288e2db101ba3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$Vg(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$nh.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $b36288e2db101ba3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$sh(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$sh(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$zh(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Bh = $b36288e2db101ba3$var$vh(!0), $b36288e2db101ba3$var$Ch = $b36288e2db101ba3$var$vh(!1), $b36288e2db101ba3$var$Dh = {}, $b36288e2db101ba3$var$Eh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh);
function $b36288e2db101ba3$var$Hh(a) {
    if (a === $b36288e2db101ba3$var$Dh) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$Ih(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Gh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, $b36288e2db101ba3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, b);
}
function $b36288e2db101ba3$var$Jh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Gh);
}
function $b36288e2db101ba3$var$Kh(a) {
    $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
    var b = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, c));
}
function $b36288e2db101ba3$var$Lh(a) {
    $b36288e2db101ba3$var$Fh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh));
}
var $b36288e2db101ba3$var$M = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nh = [];
function $b36288e2db101ba3$var$Oh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Nh.length; a++)$b36288e2db101ba3$var$Nh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Nh.length = 0;
}
var $b36288e2db101ba3$var$Ph = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Qh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Rh = 0, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$P = null, $b36288e2db101ba3$var$Sh = !1, $b36288e2db101ba3$var$Th = !1, $b36288e2db101ba3$var$Uh = 0, $b36288e2db101ba3$var$Vh = 0;
function $b36288e2db101ba3$var$Q() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Xh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Rh = f;
    $b36288e2db101ba3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Ph.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Yh : $b36288e2db101ba3$var$Zh;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Th) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$$h;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Th);
    }
    $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
    b = null !== $b36288e2db101ba3$var$O && null !== $b36288e2db101ba3$var$O.next;
    $b36288e2db101ba3$var$Rh = 0;
    $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
    $b36288e2db101ba3$var$Sh = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$bi() {
    var a = 0 !== $b36288e2db101ba3$var$Uh;
    $b36288e2db101ba3$var$Uh = 0;
    return a;
}
function $b36288e2db101ba3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$di() {
    if (null === $b36288e2db101ba3$var$O) {
        var a = $b36288e2db101ba3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$O.next;
    var b = null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState : $b36288e2db101ba3$var$P.next;
    if (null !== b) $b36288e2db101ba3$var$P = b, $b36288e2db101ba3$var$O = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$O = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$O.memoizedState,
            baseState: $b36288e2db101ba3$var$O.baseState,
            baseQueue: $b36288e2db101ba3$var$O.baseQueue,
            queue: $b36288e2db101ba3$var$O.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    }
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$N.lanes |= m;
                $b36288e2db101ba3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$N.lanes |= f, $b36288e2db101ba3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$gi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$hi() {}
function $b36288e2db101ba3$var$ii(a, b) {
    var c = $b36288e2db101ba3$var$N, d = $b36288e2db101ba3$var$di(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$Ug = !0);
    d = d.queue;
    $b36288e2db101ba3$var$ji($b36288e2db101ba3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$P && $b36288e2db101ba3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
}
function $b36288e2db101ba3$var$ki(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
    });
}
function $b36288e2db101ba3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$pi(a) {
    var b = $b36288e2db101ba3$var$Zg(a, 1);
    null !== b && $b36288e2db101ba3$var$mh(b, a, 1, -1);
}
function $b36288e2db101ba3$var$qi(a) {
    var b = $b36288e2db101ba3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ri.bind(null, $b36288e2db101ba3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$si() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$ti(a, b, c, d) {
    var e = $b36288e2db101ba3$var$ci();
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$ui(a, b, c, d) {
    var e = $b36288e2db101ba3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$O) {
        var g = $b36288e2db101ba3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Wh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$li(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$vi(a, b) {
    return $b36288e2db101ba3$var$ti(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$ji(a, b) {
    return $b36288e2db101ba3$var$ui(2048, 8, a, b);
}
function $b36288e2db101ba3$var$wi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 2, a, b);
}
function $b36288e2db101ba3$var$xi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 4, a, b);
}
function $b36288e2db101ba3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$ui(4, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$Ai() {}
function $b36288e2db101ba3$var$Bi(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Ci(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Di(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$Ug = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$N.lanes |= c, $b36288e2db101ba3$var$hh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$Ei(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Qh.transition;
    $b36288e2db101ba3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Qh.transition = d;
    }
}
function $b36288e2db101ba3$var$Fi() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, c);
    else if (c = $b36288e2db101ba3$var$Yg(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$L();
        $b36288e2db101ba3$var$mh(c, a, d, e);
        $b36288e2db101ba3$var$Ji(c, b, d);
    }
}
function $b36288e2db101ba3$var$ri(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$Yg(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$L(), $b36288e2db101ba3$var$mh(c, a, d, e), $b36288e2db101ba3$var$Ji(c, b, d));
    }
}
function $b36288e2db101ba3$var$Hi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$N || null !== b && b === $b36288e2db101ba3$var$N;
}
function $b36288e2db101ba3$var$Ii(a, b) {
    $b36288e2db101ba3$var$Th = $b36288e2db101ba3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$ai = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Q,
    useContext: $b36288e2db101ba3$var$Q,
    useEffect: $b36288e2db101ba3$var$Q,
    useImperativeHandle: $b36288e2db101ba3$var$Q,
    useInsertionEffect: $b36288e2db101ba3$var$Q,
    useLayoutEffect: $b36288e2db101ba3$var$Q,
    useMemo: $b36288e2db101ba3$var$Q,
    useReducer: $b36288e2db101ba3$var$Q,
    useRef: $b36288e2db101ba3$var$Q,
    useState: $b36288e2db101ba3$var$Q,
    useDebugValue: $b36288e2db101ba3$var$Q,
    useDeferredValue: $b36288e2db101ba3$var$Q,
    useTransition: $b36288e2db101ba3$var$Q,
    useMutableSource: $b36288e2db101ba3$var$Q,
    useSyncExternalStore: $b36288e2db101ba3$var$Q,
    useId: $b36288e2db101ba3$var$Q,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Yh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ti(4194308, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$Gi.bind(null, $b36288e2db101ba3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$qi,
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$qi(!1), b = a[0];
        a = $b36288e2db101ba3$var$Ei.bind(null, a[1]);
        $b36288e2db101ba3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$N, e = $b36288e2db101ba3$var$ci();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$vi($b36288e2db101ba3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$ci(), b = $b36288e2db101ba3$var$R.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Zh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$fi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$$h = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$gi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return null === $b36288e2db101ba3$var$O ? b.memoizedState = a : $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Oi(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Pi || ($b36288e2db101ba3$var$Pi = !0, $b36288e2db101ba3$var$Qi = d);
        $b36288e2db101ba3$var$Mi(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Ri(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Mi(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Si ? $b36288e2db101ba3$var$Si = new Set([
            this
        ]) : $b36288e2db101ba3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$ch(-1, 1), b.tag = 2, $b36288e2db101ba3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Xi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$Ug = !1;
function $b36288e2db101ba3$var$Yi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Ch(b, null, c, d) : $b36288e2db101ba3$var$Bh(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$Tg(b, e);
    d = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$cj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$Ug = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$$i(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$dj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj);
            $b36288e2db101ba3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= d;
    $b36288e2db101ba3$var$Yi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$dj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$Tg(b, e);
    c = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$Tg(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$jj(a, b), $b36288e2db101ba3$var$ph(b, c, d), $b36288e2db101ba3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Vg(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$qh(b, g, d, l);
        $b36288e2db101ba3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof m && ($b36288e2db101ba3$var$kh(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$Vg(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$qh(b, g, d, k);
        $b36288e2db101ba3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof y && ($b36288e2db101ba3$var$kh(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$kj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$kj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$$i(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Bh(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Bh(b, null, h, f)) : $b36288e2db101ba3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$Ih(a, b.containerInfo);
}
function $b36288e2db101ba3$var$mj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Yi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$qj(g, d, 0, null), a = $b36288e2db101ba3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$oj(c), b.memoizedState = $b36288e2db101ba3$var$nj, a) : $b36288e2db101ba3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$wh(h, f) : (f = $b36288e2db101ba3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$rj(a, b) {
    b = $b36288e2db101ba3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$tj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Bh(b, a.child, null, c);
    a = $b36288e2db101ba3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$oj(g);
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Li(f, d, void 0);
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$Ug || h) {
        d = $b36288e2db101ba3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$Zg(a, e), $b36288e2db101ba3$var$mh(d, a, e, -1));
        }
        $b36288e2db101ba3$var$uj();
        d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$Sg(a.return, b, c);
}
function $b36288e2db101ba3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Yi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$wj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$lj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Kh(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$pj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
                a = $b36288e2db101ba3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$ej(a, b, c);
    }
    return $b36288e2db101ba3$var$$i(a, b, c);
}
var $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj, $b36288e2db101ba3$var$Dj;
$b36288e2db101ba3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Bj = function() {};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Ej(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$Jh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Bj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Lh(b);
            var e = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
                $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$M.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$Bj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Ej(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Hj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$M.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$gj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Jj(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Lh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M), null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Kj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Oj = !1;
function $b36288e2db101ba3$var$Pj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Oj;
    $b36288e2db101ba3$var$Oj = !1;
    return n;
}
function $b36288e2db101ba3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Yj = !1;
function $b36288e2db101ba3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$ak(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$ak(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Mj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Yj = !0;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Nj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Zj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Zj(a, b, c);
    }
}
function $b36288e2db101ba3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Lj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Yj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$ak(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$ek(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Qj(3, a, a.return), $b36288e2db101ba3$var$Rj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Qj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            break;
        case 13:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$gk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$fk(a);
    }
}
function $b36288e2db101ba3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$jk(a, b, c);
}
function $b36288e2db101ba3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Kj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Kj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$kk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$kk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$jk(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Kj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$lk(a, b, c);
    }
}
function $b36288e2db101ba3$var$lk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Sj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$hk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$mk = Math.ceil, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$pk = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$gj = 0, $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$qk = null, $b36288e2db101ba3$var$hh = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = 0, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$gk = 0, $b36288e2db101ba3$var$Hj = Infinity, $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = null, $b36288e2db101ba3$var$Si = null, $b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = null, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, $b36288e2db101ba3$var$Bk = -1, $b36288e2db101ba3$var$Ck = 0;
function $b36288e2db101ba3$var$L() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Bk ? $b36288e2db101ba3$var$Bk : $b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Ck && ($b36288e2db101ba3$var$Ck = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Ck;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$mh(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$zk) throw $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$R) a === $b36288e2db101ba3$var$R && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$rk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Ek(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Ek(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Fk.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Fk.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Gk(c, $b36288e2db101ba3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Hk(a, b) {
    $b36288e2db101ba3$var$Bk = -1;
    $b36288e2db101ba3$var$Ck = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Ik() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Jk(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Kk();
        if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Lk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Mk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Nk(a, h);
        }
        $b36288e2db101ba3$var$Qg();
        $b36288e2db101ba3$var$nk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Ok(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Pk(e) && (b = $b36288e2db101ba3$var$Jk(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Ok(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$gk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Hk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Ok(a, b) {
    var c = $b36288e2db101ba3$var$tk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Lk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Jk(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$uk = c, null !== b && $b36288e2db101ba3$var$Gj(b));
    return a;
}
function $b36288e2db101ba3$var$Gj(a) {
    null === $b36288e2db101ba3$var$uk ? $b36288e2db101ba3$var$uk = a : $b36288e2db101ba3$var$uk.push.apply($b36288e2db101ba3$var$uk, a);
}
function $b36288e2db101ba3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Dk(a, b) {
    b &= ~$b36288e2db101ba3$var$sk;
    b &= ~$b36288e2db101ba3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Fk(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Ok(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, b), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Rk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Sk(a) {
    null !== $b36288e2db101ba3$var$xk && 0 === $b36288e2db101ba3$var$xk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$pk.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$pk.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Ij() {
    $b36288e2db101ba3$var$gj = $b36288e2db101ba3$var$fj.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$fj);
}
function $b36288e2db101ba3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$Jh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Oh();
                break;
            case 5:
                $b36288e2db101ba3$var$Lh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$Jh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 10:
                $b36288e2db101ba3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Ij();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$R = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$wh(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$gj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$qk = null;
    $b36288e2db101ba3$var$sk = $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$hh = 0;
    $b36288e2db101ba3$var$uk = $b36288e2db101ba3$var$tk = null;
    if (null !== $b36288e2db101ba3$var$Wg) {
        for(b = 0; b < $b36288e2db101ba3$var$Wg.length; b++)if (c = $b36288e2db101ba3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$Wg = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$Qg();
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
            if ($b36288e2db101ba3$var$Sh) {
                for(var d = $b36288e2db101ba3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Sh = !1;
            }
            $b36288e2db101ba3$var$Rh = 0;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            $b36288e2db101ba3$var$ok.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$qk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Ti(f, l, b);
                            $b36288e2db101ba3$var$uj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Wi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ki(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = [
                    f
                ] : $b36288e2db101ba3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Oi(f, k, b);
                            $b36288e2db101ba3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Ri(f, h, b);
                                $b36288e2db101ba3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Tk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Kk() {
    var a = $b36288e2db101ba3$var$nk.current;
    $b36288e2db101ba3$var$nk.current = $b36288e2db101ba3$var$ai;
    return null === a ? $b36288e2db101ba3$var$ai : a;
}
function $b36288e2db101ba3$var$uj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$R || 0 === ($b36288e2db101ba3$var$hh & 268435455) && 0 === ($b36288e2db101ba3$var$rk & 268435455) || $b36288e2db101ba3$var$Dk($b36288e2db101ba3$var$R, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Jk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Kk();
    if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Lk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Uk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Nk(a, e);
    }
    $b36288e2db101ba3$var$Qg();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$nk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$R = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Uk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Mk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Vk(a) {
    var b = $b36288e2db101ba3$var$Wk(a.alternate, a, $b36288e2db101ba3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Tk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$ok.current = null;
}
function $b36288e2db101ba3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Fj(c, b, $b36288e2db101ba3$var$gj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Qk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$pk.transition;
    try {
        $b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Xk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$pk.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Xk(a, b, c, d) {
    do $b36288e2db101ba3$var$Ik();
    while (null !== $b36288e2db101ba3$var$xk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$R && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$wk || ($b36288e2db101ba3$var$wk = !0, $b36288e2db101ba3$var$Gk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$pk.transition;
        $b36288e2db101ba3$var$pk.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$ok.current = null;
        $b36288e2db101ba3$var$Pj(a, c);
        $b36288e2db101ba3$var$ek(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$ik(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$pk.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$wk && ($b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = a, $b36288e2db101ba3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Si = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Pi) throw $b36288e2db101ba3$var$Pi = !1, a = $b36288e2db101ba3$var$Qi, $b36288e2db101ba3$var$Qi = null, a;
    0 !== ($b36288e2db101ba3$var$yk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$zk++ : ($b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = a) : $b36288e2db101ba3$var$zk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Ik() {
    if (null !== $b36288e2db101ba3$var$xk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$yk), b = $b36288e2db101ba3$var$pk.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$pk.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$xk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$xk;
                $b36288e2db101ba3$var$xk = null;
                $b36288e2db101ba3$var$yk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Tj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$pk.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Yk(a, b, c) {
    b = $b36288e2db101ba3$var$Ki(c, b);
    b = $b36288e2db101ba3$var$Oi(a, b, 1);
    a = $b36288e2db101ba3$var$dh(a, b, 1);
    b = $b36288e2db101ba3$var$L();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Ek(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(d))) {
                a = $b36288e2db101ba3$var$Ki(c, a);
                a = $b36288e2db101ba3$var$Ri(b, a, 1);
                b = $b36288e2db101ba3$var$dh(b, a, 1);
                a = $b36288e2db101ba3$var$L();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$R === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$gk ? $b36288e2db101ba3$var$Lk(a, 0) : $b36288e2db101ba3$var$sk |= c);
    $b36288e2db101ba3$var$Ek(a, b);
}
function $b36288e2db101ba3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$L();
    a = $b36288e2db101ba3$var$Zg(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Ek(a, c));
}
function $b36288e2db101ba3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Zk(a, c);
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Zk(a, c);
}
var $b36288e2db101ba3$var$Wk;
$b36288e2db101ba3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$zj(a, b, c);
            $b36288e2db101ba3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$jj(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$Tg(b, c);
            e = $b36288e2db101ba3$var$Xh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$ah(b), e.updater = $b36288e2db101ba3$var$nh, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$rh(b, d, a, c), b = $b36288e2db101ba3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$$k(d);
                a = $b36288e2db101ba3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$aj(null, b, d, $b36288e2db101ba3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$lj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$bh(a, b);
                $b36288e2db101ba3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$$i(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Kh(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$pj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Bh(b, null, d, c) : $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$Zi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$Tg(b, c), e = $b36288e2db101ba3$var$Vg(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Lg(d, b.pendingProps), e = $b36288e2db101ba3$var$Lg(d.type, e), $b36288e2db101ba3$var$aj(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$jj(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$Tg(b, c), $b36288e2db101ba3$var$ph(b, d, e), $b36288e2db101ba3$var$rh(b, d, e, c), $b36288e2db101ba3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$yj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$ej(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Gk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$al(a, b, c, d);
}
function $b36288e2db101ba3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$$k(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Ah(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Ah(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$qj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$xh(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$zh(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$ah(f);
    return a;
}
function $b36288e2db101ba3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$el(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$el(null);
    c = a.current;
    d = $b36288e2db101ba3$var$L();
    e = $b36288e2db101ba3$var$lh(c);
    f = $b36288e2db101ba3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$dh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Ek(a, d);
    return a;
}
function $b36288e2db101ba3$var$gl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$L(), g = $b36288e2db101ba3$var$lh(e);
    c = $b36288e2db101ba3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$dh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$mh(a, e, g, f), $b36288e2db101ba3$var$eh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$jl(a, b) {
    $b36288e2db101ba3$var$il(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$il(a, b);
}
function $b36288e2db101ba3$var$kl() {
    return null;
}
var $b36288e2db101ba3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.render = $b36288e2db101ba3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$gl(a, b, null, null);
};
$b36288e2db101ba3$var$nl.prototype.unmount = $b36288e2db101ba3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Sk(function() {
            $b36288e2db101ba3$var$gl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$nl(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$ql() {}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$fl(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$ql);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$hl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$cl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$ql);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$gl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$gl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$rl(c, b, a, e, d);
    return $b36288e2db101ba3$var$hl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Ek(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Sk(function() {
                var b = $b36288e2db101ba3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$L();
                    $b36288e2db101ba3$var$mh(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$jl(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$jl(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$lh(a), c = $b36288e2db101ba3$var$Zg(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(c, a, b, d);
        }
        $b36288e2db101ba3$var$jl(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Sk;
var $b36288e2db101ba3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Rk
    ]
}, $b36288e2db101ba3$var$ul = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$vl = {
    bundleType: $b36288e2db101ba3$var$ul.bundleType,
    version: $b36288e2db101ba3$var$ul.version,
    rendererPackageName: $b36288e2db101ba3$var$ul.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$ul.findFiberByHostInstance || $b36288e2db101ba3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$wl.isDisabled && $b36288e2db101ba3$var$wl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$wl.inject($b36288e2db101ba3$var$vl), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$wl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$tl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$dl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Sk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$nl(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$pl(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$pl(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$sl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});




parcelRegister("1LCZd", function(module, exports) {

$parcel$export(module.exports, "__RouterContext", function () { return $14986c2201283622$export$63baa8ccbe60bb07; });
$parcel$export(module.exports, "Router", function () { return $14986c2201283622$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Redirect", function () { return $14986c2201283622$export$2d8d895a0a0f636e; });
$parcel$export(module.exports, "Route", function () { return $14986c2201283622$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Switch", function () { return $14986c2201283622$export$b5d5cf8927ab7262; });
$parcel$export(module.exports, "withRouter", function () { return $14986c2201283622$export$369b6b2b30582e8e; });

var $aMjFm = parcelRequire("aMjFm");

var $gMqD6 = parcelRequire("gMqD6");

var $bh6RR = parcelRequire("bh6RR");



var $4mTVz = parcelRequire("4mTVz");

var $2Blw4 = parcelRequire("2Blw4");

var $kusfH = parcelRequire("kusfH");

var $4WYaH = parcelRequire("4WYaH");
parcelRequire("84U9M");

var $hCIyK = parcelRequire("hCIyK");

var $adG4d = parcelRequire("adG4d");
// TODO: Replace with React.createContext once we can assume React 16+
var $14986c2201283622$var$createNamedContext = function createNamedContext(name) {
    var context = (0, (/*@__PURE__*/$parcel$interopDefault($aMjFm)))();
    context.Provider.displayName = name + ".Provider";
    context.Consumer.displayName = name + ".Consumer";
    return context;
};
var $14986c2201283622$export$63baa8ccbe60bb07 = /*#__PURE__*/ $14986c2201283622$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $14986c2201283622$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    };
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$63baa8ccbe60bb07.Provider, {
            children: this.props.children || null,
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        });
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $14986c2201283622$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $4mTVz.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
var $14986c2201283622$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $14986c2201283622$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$63baa8ccbe60bb07.Consumer, null, function(context$$1) {
        !context$$1 && (0, $2Blw4.default)(false);
        if (!when || context$$1.staticContext) return null;
        var method = context$$1.history.block;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $14986c2201283622$var$messageType;
var $14986c2201283622$var$cache = {};
var $14986c2201283622$var$cacheLimit = 10000;
var $14986c2201283622$var$cacheCount = 0;
function $14986c2201283622$var$compilePath(path) {
    if ($14986c2201283622$var$cache[path]) return $14986c2201283622$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($kusfH))).compile(path);
    if ($14986c2201283622$var$cacheCount < $14986c2201283622$var$cacheLimit) {
        $14986c2201283622$var$cache[path] = generator;
        $14986c2201283622$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $14986c2201283622$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $14986c2201283622$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $14986c2201283622$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$63baa8ccbe60bb07.Consumer, null, function(context$$1) {
        !context$$1 && (0, $2Blw4.default)(false);
        var history = context$$1.history, staticContext = context$$1.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $4mTVz.createLocation)(computedMatch ? typeof to === "string" ? $14986c2201283622$export$82476f982757e71e(to, computedMatch.params) : (0, $4WYaH.default)({}, to, {
            pathname: $14986c2201283622$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (!(0, $4mTVz.locationsAreEqual)(prevProps.to, location)) method(location);
            },
            to: to
        });
    });
}
var $14986c2201283622$var$cache$1 = {};
var $14986c2201283622$var$cacheLimit$1 = 10000;
var $14986c2201283622$var$cacheCount$1 = 0;
function $14986c2201283622$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $14986c2201283622$var$cache$1[cacheKey] || ($14986c2201283622$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($kusfH)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($14986c2201283622$var$cacheCount$1 < $14986c2201283622$var$cacheLimit$1) {
        pathCache[path] = result;
        $14986c2201283622$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $14986c2201283622$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (matched) return matched;
        var _compilePath = $14986c2201283622$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $14986c2201283622$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.count(children) === 0;
}
/**
 * The public API for matching a single path and rendering.
 */ var $14986c2201283622$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$63baa8ccbe60bb07.Consumer, null, function(context$$1) {
            !context$$1 && (0, $2Blw4.default)(false);
            var location = _this.props.location || context$$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $14986c2201283622$export$81336c211d5ff295(location.pathname, _this.props) : context$$1.match;
            var props = (0, $4WYaH.default)({}, context$$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && children.length === 0) children = null;
            if (typeof children === "function") {
                children = children(props);
                if (children === undefined) {
                    var path;
                    children = null;
                }
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, children && !$14986c2201283622$var$isEmptyChildren(children) ? children : props.match ? component ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(component, props) : render ? render(props) : null : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
function $14986c2201283622$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $14986c2201283622$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $4WYaH.default)({}, location, {
        pathname: $14986c2201283622$var$addLeadingSlash(basename) + location.pathname
    });
}
function $14986c2201283622$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $14986c2201283622$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $4WYaH.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $14986c2201283622$var$createURL(location) {
    return typeof location === "string" ? location : (0, $4mTVz.createPath)(location);
}
function $14986c2201283622$var$staticHandler(methodName) {
    return function() {
        (0, $2Blw4.default)(false);
    };
}
function $14986c2201283622$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $14986c2201283622$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $14986c2201283622$var$noop;
        };
        _this.handleBlock = function() {
            return $14986c2201283622$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, context = _this$props.context;
        context.action = action;
        context.location = $14986c2201283622$var$addBasename(basename, (0, $4mTVz.createLocation)(location));
        context.url = $14986c2201283622$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $hCIyK.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $14986c2201283622$var$addLeadingSlash(basename + $14986c2201283622$var$createURL(path));
            },
            action: "POP",
            location: $14986c2201283622$var$stripBasename(basename, (0, $4mTVz.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $14986c2201283622$var$staticHandler("go"),
            goBack: $14986c2201283622$var$staticHandler("goBack"),
            goForward: $14986c2201283622$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$55185c17a0fcbe46, (0, $4WYaH.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $14986c2201283622$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$63baa8ccbe60bb07.Consumer, null, function(context$$1) {
            !context$$1 && (0, $2Blw4.default)(false);
            var location = _this.props.location || context$$1.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.forEach(_this.props.children, function(child) {
                if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $14986c2201283622$export$81336c211d5ff295(location.pathname, (0, $4WYaH.default)({}, child.props, {
                        path: path
                    })) : context$$1.match;
                }
            });
            return match ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $14986c2201283622$export$369b6b2b30582e8e(Component) {
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $hCIyK.default)(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($14986c2201283622$export$e7b0ac011bb776c6, {
            children: function children(routeComponentProps) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, (0, $4WYaH.default)({}, remainingProps, routeComponentProps, {
                    ref: wrappedComponentRef
                }));
            }
        });
    };
    C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(C, Component);
}
var $14986c2201283622$var$global, $14986c2201283622$var$key, $14986c2201283622$var$buildNames, $14986c2201283622$var$initialBuildName, $14986c2201283622$var$secondaryBuildName;

});
parcelRegister("aMjFm", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $bh6RR = parcelRequire("bh6RR");
var $020669e08a343786$var$_react2 = $020669e08a343786$var$_interopRequireDefault($bh6RR);

var $kybBw = parcelRequire("kybBw");
var $020669e08a343786$var$_implementation2 = $020669e08a343786$var$_interopRequireDefault($kybBw);
function $020669e08a343786$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = $020669e08a343786$var$_react2.default.createContext || $020669e08a343786$var$_implementation2.default;
module.exports = module.exports["default"];

});
parcelRegister("kybBw", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $bh6RR = parcelRequire("bh6RR");
var $ef5ffbf807fe386c$var$_react2 = $ef5ffbf807fe386c$var$_interopRequireDefault($bh6RR);

var $eCfBx = parcelRequire("eCfBx");
var $ef5ffbf807fe386c$var$_propTypes2 = $ef5ffbf807fe386c$var$_interopRequireDefault($eCfBx);

var $8iQaz = parcelRequire("8iQaz");
var $ef5ffbf807fe386c$var$_gud2 = $ef5ffbf807fe386c$var$_interopRequireDefault($8iQaz);

var $hDDTP = parcelRequire("hDDTP");
var $ef5ffbf807fe386c$var$_warning2 = $ef5ffbf807fe386c$var$_interopRequireDefault($hDDTP);
function $ef5ffbf807fe386c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ef5ffbf807fe386c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ef5ffbf807fe386c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ef5ffbf807fe386c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $ef5ffbf807fe386c$var$MAX_SIGNED_31_BIT_INT = 1073741823;
// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $ef5ffbf807fe386c$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $ef5ffbf807fe386c$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $ef5ffbf807fe386c$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $ef5ffbf807fe386c$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + (0, $ef5ffbf807fe386c$var$_gud2.default)() + "__";
    var Provider = function(_Component) {
        $ef5ffbf807fe386c$var$_inherits(Provider, _Component);
        function Provider() {
            var _temp, _this, _ret;
            $ef5ffbf807fe386c$var$_classCallCheck(this, Provider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $ef5ffbf807fe386c$var$_possibleConstructorReturn(this, _Component.call.apply(_Component, [
                this
            ].concat(args))), _this), _this.emitter = $ef5ffbf807fe386c$var$createEventEmitter(_this.props.value), _temp), $ef5ffbf807fe386c$var$_possibleConstructorReturn(_this, _ret);
        }
        Provider.prototype.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits = void 0;
                if ($ef5ffbf807fe386c$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $ef5ffbf807fe386c$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        Provider.prototype.render = function render() {
            return this.props.children;
        };
        return Provider;
    }($bh6RR.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = $ef5ffbf807fe386c$var$_propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function(_Component2) {
        $ef5ffbf807fe386c$var$_inherits(Consumer, _Component2);
        function Consumer() {
            var _temp2, _this2, _ret2;
            $ef5ffbf807fe386c$var$_classCallCheck(this, Consumer);
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _ret2 = (_temp2 = (_this2 = $ef5ffbf807fe386c$var$_possibleConstructorReturn(this, _Component2.call.apply(_Component2, [
                this
            ].concat(args))), _this2), _this2.state = {
                value: _this2.getValue()
            }, _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            }, _temp2), $ef5ffbf807fe386c$var$_possibleConstructorReturn(_this2, _ret2);
        }
        Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ef5ffbf807fe386c$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ef5ffbf807fe386c$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        Consumer.prototype.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        Consumer.prototype.render = function render() {
            return $ef5ffbf807fe386c$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }($bh6RR.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = $ef5ffbf807fe386c$var$_propTypes2.default.object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
module.exports.default = $ef5ffbf807fe386c$var$createReactContext;
module.exports = module.exports["default"];

});
parcelRegister("eCfBx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa40b802dd2fccfc$var$ReactIs, $aa40b802dd2fccfc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("2tbKl"))();

});
parcelRegister("2tbKl", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $c3YnH = parcelRequire("c3YnH");
function $1cc766ccf0672393$var$emptyFunction() {}
function $1cc766ccf0672393$var$emptyFunctionWithReset() {}
$1cc766ccf0672393$var$emptyFunctionWithReset.resetWarningCache = $1cc766ccf0672393$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $c3YnH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1cc766ccf0672393$var$emptyFunctionWithReset,
        resetWarningCache: $1cc766ccf0672393$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("c3YnH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $8c849a51633fc8b0$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $8c849a51633fc8b0$var$ReactPropTypesSecret;

});



parcelRegister("8iQaz", function(module, exports) {
// @flow
"use strict";
var $60b878ee81542b71$var$key = "__global_unique_id__";
module.exports = function() {
    return $parcel$global[$60b878ee81542b71$var$key] = ($parcel$global[$60b878ee81542b71$var$key] || 0) + 1;
};

});

parcelRegister("hDDTP", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ "use strict";

var $hwQ1g = parcelRequire("hwQ1g");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $cd75075d4c5abaef$var$warning = $hwQ1g;
var $cd75075d4c5abaef$var$printWarning;
module.exports = $cd75075d4c5abaef$var$warning;

});
parcelRegister("hwQ1g", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $cc2dc6c8e0012641$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $cc2dc6c8e0012641$var$emptyFunction = function emptyFunction() {};
$cc2dc6c8e0012641$var$emptyFunction.thatReturns = $cc2dc6c8e0012641$var$makeEmptyFunction;
$cc2dc6c8e0012641$var$emptyFunction.thatReturnsFalse = $cc2dc6c8e0012641$var$makeEmptyFunction(false);
$cc2dc6c8e0012641$var$emptyFunction.thatReturnsTrue = $cc2dc6c8e0012641$var$makeEmptyFunction(true);
$cc2dc6c8e0012641$var$emptyFunction.thatReturnsNull = $cc2dc6c8e0012641$var$makeEmptyFunction(null);
$cc2dc6c8e0012641$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$cc2dc6c8e0012641$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $cc2dc6c8e0012641$var$emptyFunction;

});




parcelRegister("gMqD6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c375c92967c25393$export$2e2bcd8739ae039; });

var $hloi6 = parcelRequire("hloi6");
function $c375c92967c25393$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $hloi6.default)(subClass, superClass);
}

});
parcelRegister("hloi6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca073d81f2a471af$export$2e2bcd8739ae039; });
function $ca073d81f2a471af$export$2e2bcd8739ae039(o, p) {
    $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ca073d81f2a471af$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("4mTVz", function(module, exports) {

$parcel$export(module.exports, "createPath", function () { return $32e4998d9dcb6f96$export$fe53371bee54353d; });
$parcel$export(module.exports, "createLocation", function () { return $32e4998d9dcb6f96$export$90c043f1c57770b8; });
$parcel$export(module.exports, "locationsAreEqual", function () { return $32e4998d9dcb6f96$export$c3e8bb440bd55b18; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $32e4998d9dcb6f96$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $32e4998d9dcb6f96$export$b71fdd3798280242; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $32e4998d9dcb6f96$export$2b76ad033c6e6d08; });

var $4WYaH = parcelRequire("4WYaH");

var $7RhLE = parcelRequire("7RhLE");

var $kDNtR = parcelRequire("kDNtR");


var $2Blw4 = parcelRequire("2Blw4");
function $32e4998d9dcb6f96$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $32e4998d9dcb6f96$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $32e4998d9dcb6f96$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $32e4998d9dcb6f96$var$stripBasename(path, prefix) {
    return $32e4998d9dcb6f96$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $32e4998d9dcb6f96$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $32e4998d9dcb6f96$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $32e4998d9dcb6f96$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $32e4998d9dcb6f96$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $4WYaH.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $7RhLE.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $32e4998d9dcb6f96$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $kDNtR.default)(a.state, b.state);
}
function $32e4998d9dcb6f96$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $32e4998d9dcb6f96$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $32e4998d9dcb6f96$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $32e4998d9dcb6f96$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $32e4998d9dcb6f96$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $32e4998d9dcb6f96$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $32e4998d9dcb6f96$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $32e4998d9dcb6f96$var$PopStateEvent = "popstate";
var $32e4998d9dcb6f96$var$HashChangeEvent = "hashchange";
function $32e4998d9dcb6f96$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $32e4998d9dcb6f96$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$32e4998d9dcb6f96$var$canUseDOM && (0, $2Blw4.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $32e4998d9dcb6f96$var$supportsHistory();
    var needsHashChangeListener = !$32e4998d9dcb6f96$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $32e4998d9dcb6f96$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $32e4998d9dcb6f96$var$stripTrailingSlash($32e4998d9dcb6f96$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $32e4998d9dcb6f96$var$stripBasename(path, basename);
        return $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $32e4998d9dcb6f96$var$createTransitionManager();
    function setState(nextState) {
        (0, $4WYaH.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($32e4998d9dcb6f96$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($32e4998d9dcb6f96$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($32e4998d9dcb6f96$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $32e4998d9dcb6f96$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($32e4998d9dcb6f96$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($32e4998d9dcb6f96$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($32e4998d9dcb6f96$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($32e4998d9dcb6f96$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $32e4998d9dcb6f96$var$HashChangeEvent$1 = "hashchange";
var $32e4998d9dcb6f96$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $32e4998d9dcb6f96$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $32e4998d9dcb6f96$var$stripLeadingSlash,
        decodePath: $32e4998d9dcb6f96$var$addLeadingSlash
    },
    slash: {
        encodePath: $32e4998d9dcb6f96$var$addLeadingSlash,
        decodePath: $32e4998d9dcb6f96$var$addLeadingSlash
    }
};
function $32e4998d9dcb6f96$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $32e4998d9dcb6f96$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $32e4998d9dcb6f96$var$pushHashPath(path) {
    window.location.hash = path;
}
function $32e4998d9dcb6f96$var$replaceHashPath(path) {
    window.location.replace($32e4998d9dcb6f96$var$stripHash(window.location.href) + "#" + path);
}
function $32e4998d9dcb6f96$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$32e4998d9dcb6f96$var$canUseDOM && (0, $2Blw4.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $32e4998d9dcb6f96$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $32e4998d9dcb6f96$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $32e4998d9dcb6f96$var$stripTrailingSlash($32e4998d9dcb6f96$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $32e4998d9dcb6f96$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($32e4998d9dcb6f96$var$getHashPath());
        if (basename) path = $32e4998d9dcb6f96$var$stripBasename(path, basename);
        return $32e4998d9dcb6f96$export$90c043f1c57770b8(path);
    }
    var transitionManager = $32e4998d9dcb6f96$var$createTransitionManager();
    function setState(nextState) {
        (0, $4WYaH.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $32e4998d9dcb6f96$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $32e4998d9dcb6f96$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $32e4998d9dcb6f96$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($32e4998d9dcb6f96$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($32e4998d9dcb6f96$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $32e4998d9dcb6f96$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $32e4998d9dcb6f96$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $32e4998d9dcb6f96$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $32e4998d9dcb6f96$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $32e4998d9dcb6f96$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $32e4998d9dcb6f96$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $32e4998d9dcb6f96$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $32e4998d9dcb6f96$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($32e4998d9dcb6f96$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $32e4998d9dcb6f96$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $32e4998d9dcb6f96$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $32e4998d9dcb6f96$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($32e4998d9dcb6f96$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($32e4998d9dcb6f96$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($32e4998d9dcb6f96$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $32e4998d9dcb6f96$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $32e4998d9dcb6f96$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $32e4998d9dcb6f96$var$createTransitionManager();
    function setState(nextState) {
        (0, $4WYaH.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $32e4998d9dcb6f96$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $32e4998d9dcb6f96$export$90c043f1c57770b8(entry, undefined, createKey()) : $32e4998d9dcb6f96$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $32e4998d9dcb6f96$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $32e4998d9dcb6f96$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("4WYaH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39ab41060f0dd572$export$2e2bcd8739ae039; });
function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $39ab41060f0dd572$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("7RhLE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b8b43e396b05c37$export$2e2bcd8739ae039; });
function $5b8b43e396b05c37$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $5b8b43e396b05c37$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $5b8b43e396b05c37$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $5b8b43e396b05c37$var$isAbsolute(to);
    var isFromAbs = from && $5b8b43e396b05c37$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $5b8b43e396b05c37$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $5b8b43e396b05c37$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $5b8b43e396b05c37$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $5b8b43e396b05c37$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$5b8b43e396b05c37$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $5b8b43e396b05c37$export$2e2bcd8739ae039 = $5b8b43e396b05c37$var$resolvePathname;

});

parcelRegister("kDNtR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f06dd50279713a67$export$2e2bcd8739ae039; });
function $f06dd50279713a67$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $f06dd50279713a67$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $f06dd50279713a67$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $f06dd50279713a67$var$valueOf(a);
        var bValue = $f06dd50279713a67$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $f06dd50279713a67$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $f06dd50279713a67$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $f06dd50279713a67$export$2e2bcd8739ae039 = $f06dd50279713a67$var$valueEqual;

});

parcelRegister("2Blw4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e4fba22ff93a100$export$2e2bcd8739ae039; });
var $1e4fba22ff93a100$var$isProduction = true;
var $1e4fba22ff93a100$var$prefix = "Invariant failed";
function $1e4fba22ff93a100$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($1e4fba22ff93a100$var$isProduction) throw new Error($1e4fba22ff93a100$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($1e4fba22ff93a100$var$prefix, ": ").concat(provided) : $1e4fba22ff93a100$var$prefix;
    throw new Error(value);
}

});


parcelRegister("kusfH", function(module, exports) {

var $gtVAt = parcelRequire("gtVAt");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $eeac86488245adff$var$pathToRegexp;
module.exports.parse = $eeac86488245adff$var$parse;
module.exports.compile = $eeac86488245adff$var$compile;
module.exports.tokensToFunction = $eeac86488245adff$var$tokensToFunction;
module.exports.tokensToRegExp = $eeac86488245adff$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $eeac86488245adff$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $eeac86488245adff$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $eeac86488245adff$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $eeac86488245adff$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $eeac86488245adff$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $eeac86488245adff$var$compile(str, options) {
    return $eeac86488245adff$var$tokensToFunction($eeac86488245adff$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $eeac86488245adff$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $eeac86488245adff$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $eeac86488245adff$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $eeac86488245adff$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $eeac86488245adff$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($gtVAt(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $eeac86488245adff$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $eeac86488245adff$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $eeac86488245adff$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $eeac86488245adff$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $eeac86488245adff$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $eeac86488245adff$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $eeac86488245adff$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $eeac86488245adff$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($eeac86488245adff$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $eeac86488245adff$var$flags(options));
    return $eeac86488245adff$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $eeac86488245adff$var$stringToRegexp(path, keys, options) {
    return $eeac86488245adff$var$tokensToRegExp($eeac86488245adff$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $eeac86488245adff$var$tokensToRegExp(tokens, keys, options) {
    if (!$gtVAt(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $eeac86488245adff$var$escapeString(token);
        else {
            var prefix = $eeac86488245adff$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $eeac86488245adff$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $eeac86488245adff$var$attachKeys(new RegExp("^" + route, $eeac86488245adff$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $eeac86488245adff$var$pathToRegexp(path, keys, options) {
    if (!$gtVAt(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $eeac86488245adff$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($gtVAt(path)) return $eeac86488245adff$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $eeac86488245adff$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("gtVAt", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};

});


parcelRegister("84U9M", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lL2uv"));

});
parcelRegister("lL2uv", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $fd6feb675d02976e$export$2b8d127b894957b9; }, function (v) { return $fd6feb675d02976e$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $fd6feb675d02976e$export$cea3a54a6425200c; }, function (v) { return $fd6feb675d02976e$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $fd6feb675d02976e$export$a7c73072b1a182ae; }, function (v) { return $fd6feb675d02976e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $fd6feb675d02976e$export$9f27bc3417b4524d; }, function (v) { return $fd6feb675d02976e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $fd6feb675d02976e$export$db77ccec0bb4ccac; }, function (v) { return $fd6feb675d02976e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $fd6feb675d02976e$export$8392c0c9d3dcbd35; }, function (v) { return $fd6feb675d02976e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $fd6feb675d02976e$export$ffb0004e005737fa; }, function (v) { return $fd6feb675d02976e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $fd6feb675d02976e$export$b624eff549462981; }, function (v) { return $fd6feb675d02976e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $fd6feb675d02976e$export$7897aa7841a5380c; }, function (v) { return $fd6feb675d02976e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $fd6feb675d02976e$export$602eac185826482c; }, function (v) { return $fd6feb675d02976e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $fd6feb675d02976e$export$e2c29f18771995cb; }, function (v) { return $fd6feb675d02976e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $fd6feb675d02976e$export$5f8d39834fd61797; }, function (v) { return $fd6feb675d02976e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $fd6feb675d02976e$export$74bf444e3cd11ea5; }, function (v) { return $fd6feb675d02976e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $fd6feb675d02976e$export$92387174baf9b227; }, function (v) { return $fd6feb675d02976e$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $fd6feb675d02976e$export$ec112efeb987d9c6; }, function (v) { return $fd6feb675d02976e$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $fd6feb675d02976e$export$b706b080d889d2c9; }, function (v) { return $fd6feb675d02976e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $fd6feb675d02976e$export$5be5a87408f70ddc; }, function (v) { return $fd6feb675d02976e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $fd6feb675d02976e$export$45a5e7f76e0caa8d; }, function (v) { return $fd6feb675d02976e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $fd6feb675d02976e$export$455c2e768291efa6; }, function (v) { return $fd6feb675d02976e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $fd6feb675d02976e$export$9522e17588c12572; }, function (v) { return $fd6feb675d02976e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $fd6feb675d02976e$export$2110ac352bb060b9; }, function (v) { return $fd6feb675d02976e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $fd6feb675d02976e$export$56885ab8b9c456ab; }, function (v) { return $fd6feb675d02976e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $fd6feb675d02976e$export$d927fcb6adf8f9de; }, function (v) { return $fd6feb675d02976e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $fd6feb675d02976e$export$b82d16f27459e05a; }, function (v) { return $fd6feb675d02976e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $fd6feb675d02976e$export$522c17b4f5e123e8; }, function (v) { return $fd6feb675d02976e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $fd6feb675d02976e$export$1aabd8a0274ecfd6; }, function (v) { return $fd6feb675d02976e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $fd6feb675d02976e$export$9b621391a187a31a; }, function (v) { return $fd6feb675d02976e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $fd6feb675d02976e$export$f5bbd400c2f4426f; }, function (v) { return $fd6feb675d02976e$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fd6feb675d02976e$export$2b8d127b894957b9;
var $fd6feb675d02976e$export$cea3a54a6425200c;
var $fd6feb675d02976e$export$a7c73072b1a182ae;
var $fd6feb675d02976e$export$9f27bc3417b4524d;
var $fd6feb675d02976e$export$db77ccec0bb4ccac;
var $fd6feb675d02976e$export$8392c0c9d3dcbd35;
var $fd6feb675d02976e$export$ffb0004e005737fa;
var $fd6feb675d02976e$export$b624eff549462981;
var $fd6feb675d02976e$export$7897aa7841a5380c;
var $fd6feb675d02976e$export$602eac185826482c;
var $fd6feb675d02976e$export$e2c29f18771995cb;
var $fd6feb675d02976e$export$5f8d39834fd61797;
var $fd6feb675d02976e$export$74bf444e3cd11ea5;
var $fd6feb675d02976e$export$92387174baf9b227;
var $fd6feb675d02976e$export$ec112efeb987d9c6;
var $fd6feb675d02976e$export$b706b080d889d2c9;
var $fd6feb675d02976e$export$5be5a87408f70ddc;
var $fd6feb675d02976e$export$45a5e7f76e0caa8d;
var $fd6feb675d02976e$export$455c2e768291efa6;
var $fd6feb675d02976e$export$9522e17588c12572;
var $fd6feb675d02976e$export$2110ac352bb060b9;
var $fd6feb675d02976e$export$56885ab8b9c456ab;
var $fd6feb675d02976e$export$d927fcb6adf8f9de;
var $fd6feb675d02976e$export$b82d16f27459e05a;
var $fd6feb675d02976e$export$522c17b4f5e123e8;
var $fd6feb675d02976e$export$1aabd8a0274ecfd6;
var $fd6feb675d02976e$export$9b621391a187a31a;
var $fd6feb675d02976e$export$f5bbd400c2f4426f;
"use strict";
var $fd6feb675d02976e$var$b = "function" === typeof Symbol && Symbol.for, $fd6feb675d02976e$var$c = $fd6feb675d02976e$var$b ? Symbol.for("react.element") : 60103, $fd6feb675d02976e$var$d = $fd6feb675d02976e$var$b ? Symbol.for("react.portal") : 60106, $fd6feb675d02976e$var$e = $fd6feb675d02976e$var$b ? Symbol.for("react.fragment") : 60107, $fd6feb675d02976e$var$f = $fd6feb675d02976e$var$b ? Symbol.for("react.strict_mode") : 60108, $fd6feb675d02976e$var$g = $fd6feb675d02976e$var$b ? Symbol.for("react.profiler") : 60114, $fd6feb675d02976e$var$h = $fd6feb675d02976e$var$b ? Symbol.for("react.provider") : 60109, $fd6feb675d02976e$var$k = $fd6feb675d02976e$var$b ? Symbol.for("react.context") : 60110, $fd6feb675d02976e$var$l = $fd6feb675d02976e$var$b ? Symbol.for("react.async_mode") : 60111, $fd6feb675d02976e$var$m = $fd6feb675d02976e$var$b ? Symbol.for("react.concurrent_mode") : 60111, $fd6feb675d02976e$var$n = $fd6feb675d02976e$var$b ? Symbol.for("react.forward_ref") : 60112, $fd6feb675d02976e$var$p = $fd6feb675d02976e$var$b ? Symbol.for("react.suspense") : 60113, $fd6feb675d02976e$var$q = $fd6feb675d02976e$var$b ? Symbol.for("react.suspense_list") : 60120, $fd6feb675d02976e$var$r = $fd6feb675d02976e$var$b ? Symbol.for("react.memo") : 60115, $fd6feb675d02976e$var$t = $fd6feb675d02976e$var$b ? Symbol.for("react.lazy") : 60116, $fd6feb675d02976e$var$v = $fd6feb675d02976e$var$b ? Symbol.for("react.block") : 60121, $fd6feb675d02976e$var$w = $fd6feb675d02976e$var$b ? Symbol.for("react.fundamental") : 60117, $fd6feb675d02976e$var$x = $fd6feb675d02976e$var$b ? Symbol.for("react.responder") : 60118, $fd6feb675d02976e$var$y = $fd6feb675d02976e$var$b ? Symbol.for("react.scope") : 60119;
function $fd6feb675d02976e$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $fd6feb675d02976e$var$c:
                switch(a = a.type, a){
                    case $fd6feb675d02976e$var$l:
                    case $fd6feb675d02976e$var$m:
                    case $fd6feb675d02976e$var$e:
                    case $fd6feb675d02976e$var$g:
                    case $fd6feb675d02976e$var$f:
                    case $fd6feb675d02976e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $fd6feb675d02976e$var$k:
                            case $fd6feb675d02976e$var$n:
                            case $fd6feb675d02976e$var$t:
                            case $fd6feb675d02976e$var$r:
                            case $fd6feb675d02976e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $fd6feb675d02976e$var$d:
                return u;
        }
    }
}
function $fd6feb675d02976e$var$A(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$m;
}
$fd6feb675d02976e$export$2b8d127b894957b9 = $fd6feb675d02976e$var$l;
$fd6feb675d02976e$export$cea3a54a6425200c = $fd6feb675d02976e$var$m;
$fd6feb675d02976e$export$a7c73072b1a182ae = $fd6feb675d02976e$var$k;
$fd6feb675d02976e$export$9f27bc3417b4524d = $fd6feb675d02976e$var$h;
$fd6feb675d02976e$export$db77ccec0bb4ccac = $fd6feb675d02976e$var$c;
$fd6feb675d02976e$export$8392c0c9d3dcbd35 = $fd6feb675d02976e$var$n;
$fd6feb675d02976e$export$ffb0004e005737fa = $fd6feb675d02976e$var$e;
$fd6feb675d02976e$export$b624eff549462981 = $fd6feb675d02976e$var$t;
$fd6feb675d02976e$export$7897aa7841a5380c = $fd6feb675d02976e$var$r;
$fd6feb675d02976e$export$602eac185826482c = $fd6feb675d02976e$var$d;
$fd6feb675d02976e$export$e2c29f18771995cb = $fd6feb675d02976e$var$g;
$fd6feb675d02976e$export$5f8d39834fd61797 = $fd6feb675d02976e$var$f;
$fd6feb675d02976e$export$74bf444e3cd11ea5 = $fd6feb675d02976e$var$p;
$fd6feb675d02976e$export$92387174baf9b227 = function(a) {
    return $fd6feb675d02976e$var$A(a) || $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$l;
};
$fd6feb675d02976e$export$ec112efeb987d9c6 = $fd6feb675d02976e$var$A;
$fd6feb675d02976e$export$b706b080d889d2c9 = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$k;
};
$fd6feb675d02976e$export$5be5a87408f70ddc = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$h;
};
$fd6feb675d02976e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $fd6feb675d02976e$var$c;
};
$fd6feb675d02976e$export$455c2e768291efa6 = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$n;
};
$fd6feb675d02976e$export$9522e17588c12572 = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$e;
};
$fd6feb675d02976e$export$2110ac352bb060b9 = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$t;
};
$fd6feb675d02976e$export$56885ab8b9c456ab = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$r;
};
$fd6feb675d02976e$export$d927fcb6adf8f9de = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$d;
};
$fd6feb675d02976e$export$b82d16f27459e05a = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$g;
};
$fd6feb675d02976e$export$522c17b4f5e123e8 = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$f;
};
$fd6feb675d02976e$export$1aabd8a0274ecfd6 = function(a) {
    return $fd6feb675d02976e$var$z(a) === $fd6feb675d02976e$var$p;
};
$fd6feb675d02976e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $fd6feb675d02976e$var$e || a === $fd6feb675d02976e$var$m || a === $fd6feb675d02976e$var$g || a === $fd6feb675d02976e$var$f || a === $fd6feb675d02976e$var$p || a === $fd6feb675d02976e$var$q || "object" === typeof a && null !== a && (a.$$typeof === $fd6feb675d02976e$var$t || a.$$typeof === $fd6feb675d02976e$var$r || a.$$typeof === $fd6feb675d02976e$var$h || a.$$typeof === $fd6feb675d02976e$var$k || a.$$typeof === $fd6feb675d02976e$var$n || a.$$typeof === $fd6feb675d02976e$var$w || a.$$typeof === $fd6feb675d02976e$var$x || a.$$typeof === $fd6feb675d02976e$var$y || a.$$typeof === $fd6feb675d02976e$var$v);
};
$fd6feb675d02976e$export$f5bbd400c2f4426f = $fd6feb675d02976e$var$z;

});


parcelRegister("hCIyK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd488cd9c287f883$export$2e2bcd8739ae039; });
function $cd488cd9c287f883$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("adG4d", function(module, exports) {
"use strict";

var $aX2tJ = parcelRequire("aX2tJ");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $770bbfe5492d7fd4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $770bbfe5492d7fd4$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $770bbfe5492d7fd4$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$TYPE_STATICS = {};
$770bbfe5492d7fd4$var$TYPE_STATICS[$aX2tJ.ForwardRef] = $770bbfe5492d7fd4$var$FORWARD_REF_STATICS;
$770bbfe5492d7fd4$var$TYPE_STATICS[$aX2tJ.Memo] = $770bbfe5492d7fd4$var$MEMO_STATICS;
function $770bbfe5492d7fd4$var$getStatics(component) {
    // React v16.11 and below
    if ($aX2tJ.isMemo(component)) return $770bbfe5492d7fd4$var$MEMO_STATICS;
     // React v16.12 and above
    return $770bbfe5492d7fd4$var$TYPE_STATICS[component["$$typeof"]] || $770bbfe5492d7fd4$var$REACT_STATICS;
}
var $770bbfe5492d7fd4$var$defineProperty = Object.defineProperty;
var $770bbfe5492d7fd4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $770bbfe5492d7fd4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $770bbfe5492d7fd4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $770bbfe5492d7fd4$var$getPrototypeOf = Object.getPrototypeOf;
var $770bbfe5492d7fd4$var$objectPrototype = Object.prototype;
function $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($770bbfe5492d7fd4$var$objectPrototype) {
            var inheritedComponent = $770bbfe5492d7fd4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $770bbfe5492d7fd4$var$objectPrototype) $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $770bbfe5492d7fd4$var$getOwnPropertyNames(sourceComponent);
        if ($770bbfe5492d7fd4$var$getOwnPropertySymbols) keys = keys.concat($770bbfe5492d7fd4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $770bbfe5492d7fd4$var$getStatics(targetComponent);
        var sourceStatics = $770bbfe5492d7fd4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$770bbfe5492d7fd4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $770bbfe5492d7fd4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $770bbfe5492d7fd4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $770bbfe5492d7fd4$var$hoistNonReactStatics;

});
parcelRegister("aX2tJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4aTru"));

});
parcelRegister("4aTru", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $30a31a517a2d5cc7$export$2b8d127b894957b9; }, function (v) { return $30a31a517a2d5cc7$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $30a31a517a2d5cc7$export$cea3a54a6425200c; }, function (v) { return $30a31a517a2d5cc7$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $30a31a517a2d5cc7$export$a7c73072b1a182ae; }, function (v) { return $30a31a517a2d5cc7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $30a31a517a2d5cc7$export$9f27bc3417b4524d; }, function (v) { return $30a31a517a2d5cc7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $30a31a517a2d5cc7$export$db77ccec0bb4ccac; }, function (v) { return $30a31a517a2d5cc7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $30a31a517a2d5cc7$export$8392c0c9d3dcbd35; }, function (v) { return $30a31a517a2d5cc7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $30a31a517a2d5cc7$export$ffb0004e005737fa; }, function (v) { return $30a31a517a2d5cc7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $30a31a517a2d5cc7$export$b624eff549462981; }, function (v) { return $30a31a517a2d5cc7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $30a31a517a2d5cc7$export$7897aa7841a5380c; }, function (v) { return $30a31a517a2d5cc7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $30a31a517a2d5cc7$export$602eac185826482c; }, function (v) { return $30a31a517a2d5cc7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $30a31a517a2d5cc7$export$e2c29f18771995cb; }, function (v) { return $30a31a517a2d5cc7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $30a31a517a2d5cc7$export$5f8d39834fd61797; }, function (v) { return $30a31a517a2d5cc7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $30a31a517a2d5cc7$export$74bf444e3cd11ea5; }, function (v) { return $30a31a517a2d5cc7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $30a31a517a2d5cc7$export$92387174baf9b227; }, function (v) { return $30a31a517a2d5cc7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $30a31a517a2d5cc7$export$ec112efeb987d9c6; }, function (v) { return $30a31a517a2d5cc7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $30a31a517a2d5cc7$export$b706b080d889d2c9; }, function (v) { return $30a31a517a2d5cc7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $30a31a517a2d5cc7$export$5be5a87408f70ddc; }, function (v) { return $30a31a517a2d5cc7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $30a31a517a2d5cc7$export$45a5e7f76e0caa8d; }, function (v) { return $30a31a517a2d5cc7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $30a31a517a2d5cc7$export$455c2e768291efa6; }, function (v) { return $30a31a517a2d5cc7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $30a31a517a2d5cc7$export$9522e17588c12572; }, function (v) { return $30a31a517a2d5cc7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $30a31a517a2d5cc7$export$2110ac352bb060b9; }, function (v) { return $30a31a517a2d5cc7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $30a31a517a2d5cc7$export$56885ab8b9c456ab; }, function (v) { return $30a31a517a2d5cc7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $30a31a517a2d5cc7$export$d927fcb6adf8f9de; }, function (v) { return $30a31a517a2d5cc7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $30a31a517a2d5cc7$export$b82d16f27459e05a; }, function (v) { return $30a31a517a2d5cc7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $30a31a517a2d5cc7$export$522c17b4f5e123e8; }, function (v) { return $30a31a517a2d5cc7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $30a31a517a2d5cc7$export$1aabd8a0274ecfd6; }, function (v) { return $30a31a517a2d5cc7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $30a31a517a2d5cc7$export$9b621391a187a31a; }, function (v) { return $30a31a517a2d5cc7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $30a31a517a2d5cc7$export$f5bbd400c2f4426f; }, function (v) { return $30a31a517a2d5cc7$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $30a31a517a2d5cc7$export$2b8d127b894957b9;
var $30a31a517a2d5cc7$export$cea3a54a6425200c;
var $30a31a517a2d5cc7$export$a7c73072b1a182ae;
var $30a31a517a2d5cc7$export$9f27bc3417b4524d;
var $30a31a517a2d5cc7$export$db77ccec0bb4ccac;
var $30a31a517a2d5cc7$export$8392c0c9d3dcbd35;
var $30a31a517a2d5cc7$export$ffb0004e005737fa;
var $30a31a517a2d5cc7$export$b624eff549462981;
var $30a31a517a2d5cc7$export$7897aa7841a5380c;
var $30a31a517a2d5cc7$export$602eac185826482c;
var $30a31a517a2d5cc7$export$e2c29f18771995cb;
var $30a31a517a2d5cc7$export$5f8d39834fd61797;
var $30a31a517a2d5cc7$export$74bf444e3cd11ea5;
var $30a31a517a2d5cc7$export$92387174baf9b227;
var $30a31a517a2d5cc7$export$ec112efeb987d9c6;
var $30a31a517a2d5cc7$export$b706b080d889d2c9;
var $30a31a517a2d5cc7$export$5be5a87408f70ddc;
var $30a31a517a2d5cc7$export$45a5e7f76e0caa8d;
var $30a31a517a2d5cc7$export$455c2e768291efa6;
var $30a31a517a2d5cc7$export$9522e17588c12572;
var $30a31a517a2d5cc7$export$2110ac352bb060b9;
var $30a31a517a2d5cc7$export$56885ab8b9c456ab;
var $30a31a517a2d5cc7$export$d927fcb6adf8f9de;
var $30a31a517a2d5cc7$export$b82d16f27459e05a;
var $30a31a517a2d5cc7$export$522c17b4f5e123e8;
var $30a31a517a2d5cc7$export$1aabd8a0274ecfd6;
var $30a31a517a2d5cc7$export$9b621391a187a31a;
var $30a31a517a2d5cc7$export$f5bbd400c2f4426f;
"use strict";
var $30a31a517a2d5cc7$var$b = "function" === typeof Symbol && Symbol.for, $30a31a517a2d5cc7$var$c = $30a31a517a2d5cc7$var$b ? Symbol.for("react.element") : 60103, $30a31a517a2d5cc7$var$d = $30a31a517a2d5cc7$var$b ? Symbol.for("react.portal") : 60106, $30a31a517a2d5cc7$var$e = $30a31a517a2d5cc7$var$b ? Symbol.for("react.fragment") : 60107, $30a31a517a2d5cc7$var$f = $30a31a517a2d5cc7$var$b ? Symbol.for("react.strict_mode") : 60108, $30a31a517a2d5cc7$var$g = $30a31a517a2d5cc7$var$b ? Symbol.for("react.profiler") : 60114, $30a31a517a2d5cc7$var$h = $30a31a517a2d5cc7$var$b ? Symbol.for("react.provider") : 60109, $30a31a517a2d5cc7$var$k = $30a31a517a2d5cc7$var$b ? Symbol.for("react.context") : 60110, $30a31a517a2d5cc7$var$l = $30a31a517a2d5cc7$var$b ? Symbol.for("react.async_mode") : 60111, $30a31a517a2d5cc7$var$m = $30a31a517a2d5cc7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $30a31a517a2d5cc7$var$n = $30a31a517a2d5cc7$var$b ? Symbol.for("react.forward_ref") : 60112, $30a31a517a2d5cc7$var$p = $30a31a517a2d5cc7$var$b ? Symbol.for("react.suspense") : 60113, $30a31a517a2d5cc7$var$q = $30a31a517a2d5cc7$var$b ? Symbol.for("react.suspense_list") : 60120, $30a31a517a2d5cc7$var$r = $30a31a517a2d5cc7$var$b ? Symbol.for("react.memo") : 60115, $30a31a517a2d5cc7$var$t = $30a31a517a2d5cc7$var$b ? Symbol.for("react.lazy") : 60116, $30a31a517a2d5cc7$var$v = $30a31a517a2d5cc7$var$b ? Symbol.for("react.block") : 60121, $30a31a517a2d5cc7$var$w = $30a31a517a2d5cc7$var$b ? Symbol.for("react.fundamental") : 60117, $30a31a517a2d5cc7$var$x = $30a31a517a2d5cc7$var$b ? Symbol.for("react.responder") : 60118, $30a31a517a2d5cc7$var$y = $30a31a517a2d5cc7$var$b ? Symbol.for("react.scope") : 60119;
function $30a31a517a2d5cc7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $30a31a517a2d5cc7$var$c:
                switch(a = a.type, a){
                    case $30a31a517a2d5cc7$var$l:
                    case $30a31a517a2d5cc7$var$m:
                    case $30a31a517a2d5cc7$var$e:
                    case $30a31a517a2d5cc7$var$g:
                    case $30a31a517a2d5cc7$var$f:
                    case $30a31a517a2d5cc7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $30a31a517a2d5cc7$var$k:
                            case $30a31a517a2d5cc7$var$n:
                            case $30a31a517a2d5cc7$var$t:
                            case $30a31a517a2d5cc7$var$r:
                            case $30a31a517a2d5cc7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $30a31a517a2d5cc7$var$d:
                return u;
        }
    }
}
function $30a31a517a2d5cc7$var$A(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$m;
}
$30a31a517a2d5cc7$export$2b8d127b894957b9 = $30a31a517a2d5cc7$var$l;
$30a31a517a2d5cc7$export$cea3a54a6425200c = $30a31a517a2d5cc7$var$m;
$30a31a517a2d5cc7$export$a7c73072b1a182ae = $30a31a517a2d5cc7$var$k;
$30a31a517a2d5cc7$export$9f27bc3417b4524d = $30a31a517a2d5cc7$var$h;
$30a31a517a2d5cc7$export$db77ccec0bb4ccac = $30a31a517a2d5cc7$var$c;
$30a31a517a2d5cc7$export$8392c0c9d3dcbd35 = $30a31a517a2d5cc7$var$n;
$30a31a517a2d5cc7$export$ffb0004e005737fa = $30a31a517a2d5cc7$var$e;
$30a31a517a2d5cc7$export$b624eff549462981 = $30a31a517a2d5cc7$var$t;
$30a31a517a2d5cc7$export$7897aa7841a5380c = $30a31a517a2d5cc7$var$r;
$30a31a517a2d5cc7$export$602eac185826482c = $30a31a517a2d5cc7$var$d;
$30a31a517a2d5cc7$export$e2c29f18771995cb = $30a31a517a2d5cc7$var$g;
$30a31a517a2d5cc7$export$5f8d39834fd61797 = $30a31a517a2d5cc7$var$f;
$30a31a517a2d5cc7$export$74bf444e3cd11ea5 = $30a31a517a2d5cc7$var$p;
$30a31a517a2d5cc7$export$92387174baf9b227 = function(a) {
    return $30a31a517a2d5cc7$var$A(a) || $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$l;
};
$30a31a517a2d5cc7$export$ec112efeb987d9c6 = $30a31a517a2d5cc7$var$A;
$30a31a517a2d5cc7$export$b706b080d889d2c9 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$k;
};
$30a31a517a2d5cc7$export$5be5a87408f70ddc = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$h;
};
$30a31a517a2d5cc7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $30a31a517a2d5cc7$var$c;
};
$30a31a517a2d5cc7$export$455c2e768291efa6 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$n;
};
$30a31a517a2d5cc7$export$9522e17588c12572 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$e;
};
$30a31a517a2d5cc7$export$2110ac352bb060b9 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$t;
};
$30a31a517a2d5cc7$export$56885ab8b9c456ab = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$r;
};
$30a31a517a2d5cc7$export$d927fcb6adf8f9de = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$d;
};
$30a31a517a2d5cc7$export$b82d16f27459e05a = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$g;
};
$30a31a517a2d5cc7$export$522c17b4f5e123e8 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$f;
};
$30a31a517a2d5cc7$export$1aabd8a0274ecfd6 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$p;
};
$30a31a517a2d5cc7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $30a31a517a2d5cc7$var$e || a === $30a31a517a2d5cc7$var$m || a === $30a31a517a2d5cc7$var$g || a === $30a31a517a2d5cc7$var$f || a === $30a31a517a2d5cc7$var$p || a === $30a31a517a2d5cc7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $30a31a517a2d5cc7$var$t || a.$$typeof === $30a31a517a2d5cc7$var$r || a.$$typeof === $30a31a517a2d5cc7$var$h || a.$$typeof === $30a31a517a2d5cc7$var$k || a.$$typeof === $30a31a517a2d5cc7$var$n || a.$$typeof === $30a31a517a2d5cc7$var$w || a.$$typeof === $30a31a517a2d5cc7$var$x || a.$$typeof === $30a31a517a2d5cc7$var$y || a.$$typeof === $30a31a517a2d5cc7$var$v);
};
$30a31a517a2d5cc7$export$f5bbd400c2f4426f = $30a31a517a2d5cc7$var$z;

});




parcelRegister("hUmGa", function(module, exports) {

$parcel$export(module.exports, "observer", function () { return $d099423b37aa9cc4$export$b6ae1bc530f4c149; });

var $9Qp9d = parcelRequire("9Qp9d");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("7M59E");
var $4kfuq = parcelRequire("4kfuq");
var $2Rk4z = parcelRequire("2Rk4z");
var $d099423b37aa9cc4$var$symbolId = 0;
function $d099423b37aa9cc4$var$createSymbol(name) {
    if (typeof Symbol === "function") return Symbol(name);
    var symbol = "__$mobx-react " + name + " (" + $d099423b37aa9cc4$var$symbolId + ")";
    $d099423b37aa9cc4$var$symbolId++;
    return symbol;
}
var $d099423b37aa9cc4$var$createdSymbols = {};
function $d099423b37aa9cc4$var$newSymbol(name) {
    if (!$d099423b37aa9cc4$var$createdSymbols[name]) $d099423b37aa9cc4$var$createdSymbols[name] = $d099423b37aa9cc4$var$createSymbol(name);
    return $d099423b37aa9cc4$var$createdSymbols[name];
}
function $d099423b37aa9cc4$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($d099423b37aa9cc4$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$d099423b37aa9cc4$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $d099423b37aa9cc4$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
} // based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $d099423b37aa9cc4$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    displayName: 1,
    propTypes: 1
};
function $d099423b37aa9cc4$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$d099423b37aa9cc4$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Helper to set `prop` to `this` as non-enumerable (hidden prop)
 * @param target
 * @param prop
 * @param value
 */ function $d099423b37aa9cc4$var$setHiddenProp(target, prop, value) {
    if (!Object.hasOwnProperty.call(target, prop)) Object.defineProperty(target, prop, {
        enumerable: false,
        configurable: true,
        writable: true,
        value: value
    });
    else target[prop] = value;
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $d099423b37aa9cc4$var$mobxMixins = /*#__PURE__*/ $d099423b37aa9cc4$var$newSymbol("patchMixins");
var $d099423b37aa9cc4$var$mobxPatchedDefinition = /*#__PURE__*/ $d099423b37aa9cc4$var$newSymbol("patchedDefinition");
function $d099423b37aa9cc4$var$getMixins(target, methodName) {
    var mixins = target[$d099423b37aa9cc4$var$mobxMixins] = target[$d099423b37aa9cc4$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $d099423b37aa9cc4$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $d099423b37aa9cc4$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $d099423b37aa9cc4$var$wrapper.call.apply($d099423b37aa9cc4$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $d099423b37aa9cc4$var$patch(target, methodName, mixinMethod) {
    var mixins = $d099423b37aa9cc4$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$d099423b37aa9cc4$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $d099423b37aa9cc4$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $d099423b37aa9cc4$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $d099423b37aa9cc4$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$d099423b37aa9cc4$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $d099423b37aa9cc4$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $d099423b37aa9cc4$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $d099423b37aa9cc4$var$mobxAdminProperty = (0, $9Qp9d.$mobx) || "$mobx"; // BC
var $d099423b37aa9cc4$var$mobxObserverProperty = /*#__PURE__*/ $d099423b37aa9cc4$var$newSymbol("isMobXReactObserver");
var $d099423b37aa9cc4$var$mobxIsUnmounted = /*#__PURE__*/ $d099423b37aa9cc4$var$newSymbol("isUnmounted");
var $d099423b37aa9cc4$var$skipRenderKey = /*#__PURE__*/ $d099423b37aa9cc4$var$newSymbol("skipRender");
var $d099423b37aa9cc4$var$isForcingUpdateKey = /*#__PURE__*/ $d099423b37aa9cc4$var$newSymbol("isForcingUpdate");
function $d099423b37aa9cc4$var$makeClassComponentObserver(componentClass) {
    var target = componentClass.prototype;
    if (componentClass[$d099423b37aa9cc4$var$mobxObserverProperty]) {
        var displayName = $d099423b37aa9cc4$var$getDisplayName(target);
        console.warn("The provided component class (" + displayName + ")\n                has already been declared as an observer component.");
    } else componentClass[$d099423b37aa9cc4$var$mobxObserverProperty] = true;
    if (target.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $bh6RR.PureComponent)) {
        if (!target.shouldComponentUpdate) target.shouldComponentUpdate = $d099423b37aa9cc4$var$observerSCU;
        else if (target.shouldComponentUpdate !== $d099423b37aa9cc4$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    } // this.props and this.state are made observable, just to make sure @computed fields that
    // are defined inside the component, and which rely on state or props, re-compute if state or props change
    // (otherwise the computed wouldn't update and become stale on props change, since props are not observable)
    // However, this solution is not without it's own problems: https://github.com/mobxjs/mobx-react/issues?utf8=%E2%9C%93&q=is%3Aissue+label%3Aobservable-props-or-not+
    $d099423b37aa9cc4$var$makeObservableProp(target, "props");
    $d099423b37aa9cc4$var$makeObservableProp(target, "state");
    if (componentClass.contextType) $d099423b37aa9cc4$var$makeObservableProp(target, "context");
    var originalRender = target.render;
    if (typeof originalRender !== "function") {
        var _displayName = $d099423b37aa9cc4$var$getDisplayName(target);
        throw new Error("[mobx-react] class component (" + _displayName + ") is missing `render` method." + "\n`observer` requires `render` being a function defined on prototype." + "\n`render = () => {}` or `render = function() {}` is not supported.");
    }
    target.render = function() {
        this.render = (0, $4kfuq.isUsingStaticRendering)() ? originalRender : $d099423b37aa9cc4$var$createReactiveRender.call(this, originalRender);
        return this.render();
    };
    $d099423b37aa9cc4$var$patch(target, "componentDidMount", function() {
        this[$d099423b37aa9cc4$var$mobxIsUnmounted] = false;
        if (!this.render[$d099423b37aa9cc4$var$mobxAdminProperty]) // Reaction is re-created automatically during render, but a component can re-mount and skip render #3395.
        // To re-create the reaction and re-subscribe to relevant observables we have to force an update.
        (0, $bh6RR.Component).prototype.forceUpdate.call(this);
    });
    $d099423b37aa9cc4$var$patch(target, "componentWillUnmount", function() {
        if ((0, $4kfuq.isUsingStaticRendering)()) return;
        var reaction = this.render[$d099423b37aa9cc4$var$mobxAdminProperty];
        if (reaction) {
            reaction.dispose(); // Forces reaction to be re-created on next render
            this.render[$d099423b37aa9cc4$var$mobxAdminProperty] = null;
        } else {
            // Render may have been hot-swapped and/or overridden by a subclass.
            var _displayName2 = $d099423b37aa9cc4$var$getDisplayName(this);
            console.warn("The reactive render of an observer class component (" + _displayName2 + ")\n                was overridden after MobX attached. This may result in a memory leak if the\n                overridden reactive render was not properly disposed.");
        }
        this[$d099423b37aa9cc4$var$mobxIsUnmounted] = true;
    });
    return componentClass;
} // Generates a friendly name for debugging
function $d099423b37aa9cc4$var$getDisplayName(comp) {
    return comp.displayName || comp.name || comp.constructor && (comp.constructor.displayName || comp.constructor.name) || "<component>";
}
function $d099423b37aa9cc4$var$createReactiveRender(originalRender) {
    var _this = this;
    /**
   * If props are shallowly modified, react will render anyway,
   * so atom.reportChanged() should not result in yet another re-render
   */ $d099423b37aa9cc4$var$setHiddenProp(this, $d099423b37aa9cc4$var$skipRenderKey, false);
    /**
   * forceUpdate will re-assign this.props. We don't want that to cause a loop,
   * so detect these changes
   */ $d099423b37aa9cc4$var$setHiddenProp(this, $d099423b37aa9cc4$var$isForcingUpdateKey, false);
    var initialName = $d099423b37aa9cc4$var$getDisplayName(this);
    var boundOriginalRender = originalRender.bind(this);
    var isRenderingPending = false;
    var createReaction = function createReaction() {
        var reaction = new (0, $9Qp9d.Reaction)(initialName + ".render()", function() {
            if (!isRenderingPending) {
                // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.test.tsx)
                // This unidiomatic React usage but React will correctly warn about this so we continue as usual
                // See #85 / Pull #44
                isRenderingPending = true;
                if (_this[$d099423b37aa9cc4$var$mobxIsUnmounted] !== true) {
                    var hasError = true;
                    try {
                        $d099423b37aa9cc4$var$setHiddenProp(_this, $d099423b37aa9cc4$var$isForcingUpdateKey, true);
                        if (!_this[$d099423b37aa9cc4$var$skipRenderKey]) (0, $bh6RR.Component).prototype.forceUpdate.call(_this);
                        hasError = false;
                    } finally{
                        $d099423b37aa9cc4$var$setHiddenProp(_this, $d099423b37aa9cc4$var$isForcingUpdateKey, false);
                        if (hasError) {
                            reaction.dispose(); // Forces reaction to be re-created on next render
                            _this.render[$d099423b37aa9cc4$var$mobxAdminProperty] = null;
                        }
                    }
                }
            }
        });
        reaction["reactComponent"] = _this;
        return reaction;
    };
    function reactiveRender() {
        var _reactiveRender$mobxA;
        isRenderingPending = false; // Create reaction lazily to support re-mounting #3395
        var reaction = (_reactiveRender$mobxA = reactiveRender[$d099423b37aa9cc4$var$mobxAdminProperty]) != null ? _reactiveRender$mobxA : reactiveRender[$d099423b37aa9cc4$var$mobxAdminProperty] = createReaction();
        var exception = undefined;
        var rendering = undefined;
        reaction.track(function() {
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                rendering = (0, $9Qp9d._allowStateChanges)(false, boundOriginalRender);
            } catch (e) {
                exception = e;
            }
        });
        if (exception) throw exception;
        return rendering;
    }
    return reactiveRender;
}
function $d099423b37aa9cc4$var$observerSCU(nextProps, nextState) {
    if ((0, $4kfuq.isUsingStaticRendering)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
     // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
     // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$d099423b37aa9cc4$var$shallowEqual(this.props, nextProps);
}
function $d099423b37aa9cc4$var$makeObservableProp(target, propName) {
    var valueHolderKey = $d099423b37aa9cc4$var$newSymbol("reactProp_" + propName + "_valueHolder");
    var atomHolderKey = $d099423b37aa9cc4$var$newSymbol("reactProp_" + propName + "_atomHolder");
    function getAtom() {
        if (!this[atomHolderKey]) $d099423b37aa9cc4$var$setHiddenProp(this, atomHolderKey, (0, $9Qp9d.createAtom)("reactive " + propName));
        return this[atomHolderKey];
    }
    Object.defineProperty(target, propName, {
        configurable: true,
        enumerable: true,
        get: function get() {
            var prevReadState = false; // Why this check? BC?
            // @ts-expect-error
            if ((0, $9Qp9d._allowStateReadsStart) && (0, $9Qp9d._allowStateReadsEnd)) prevReadState = (0, $9Qp9d._allowStateReadsStart)(true);
            getAtom.call(this).reportObserved(); // Why this check? BC?
            // @ts-expect-error
            if ((0, $9Qp9d._allowStateReadsStart) && (0, $9Qp9d._allowStateReadsEnd)) (0, $9Qp9d._allowStateReadsEnd)(prevReadState);
            return this[valueHolderKey];
        },
        set: function set(v) {
            if (!this[$d099423b37aa9cc4$var$isForcingUpdateKey] && !$d099423b37aa9cc4$var$shallowEqual(this[valueHolderKey], v)) {
                $d099423b37aa9cc4$var$setHiddenProp(this, valueHolderKey, v);
                $d099423b37aa9cc4$var$setHiddenProp(this, $d099423b37aa9cc4$var$skipRenderKey, true);
                getAtom.call(this).reportChanged();
                $d099423b37aa9cc4$var$setHiddenProp(this, $d099423b37aa9cc4$var$skipRenderKey, false);
            } else $d099423b37aa9cc4$var$setHiddenProp(this, valueHolderKey, v);
        }
    });
}
/**
 * Observer function / decorator
 */ function $d099423b37aa9cc4$export$b6ae1bc530f4c149(component) {
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`");
    if (Object.prototype.isPrototypeOf.call((0, $bh6RR.Component), component) || Object.prototype.isPrototypeOf.call((0, $bh6RR.PureComponent), component)) // Class component
    return $d099423b37aa9cc4$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $2Rk4z.observer)(component);
}
function $d099423b37aa9cc4$var$_extends() {
    $d099423b37aa9cc4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d099423b37aa9cc4$var$_extends.apply(this, arguments);
}
function $d099423b37aa9cc4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d099423b37aa9cc4$var$_excluded = [
    "children"
];
var $d099423b37aa9cc4$export$f07786cea590ef31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({});
function $d099423b37aa9cc4$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $d099423b37aa9cc4$var$_objectWithoutPropertiesLoose(props, $d099423b37aa9cc4$var$_excluded);
    var parentValue = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($d099423b37aa9cc4$export$f07786cea590ef31);
    var mutableProviderRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef($d099423b37aa9cc4$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($d099423b37aa9cc4$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$d099423b37aa9cc4$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $d099423b37aa9cc4$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function(props, ref) {
        var newProps = $d099423b37aa9cc4$var$_extends({}, props);
        var context = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($d099423b37aa9cc4$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(component, newProps);
    });
    if (makeReactive) Injector = $d099423b37aa9cc4$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $d099423b37aa9cc4$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $d099423b37aa9cc4$var$getInjectName(component, injectNames);
    return Injector;
}
function $d099423b37aa9cc4$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $d099423b37aa9cc4$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $d099423b37aa9cc4$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $d099423b37aa9cc4$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $d099423b37aa9cc4$var$createStoreInjector($d099423b37aa9cc4$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $d099423b37aa9cc4$var$protoStoreKey = /*#__PURE__*/ $d099423b37aa9cc4$var$newSymbol("disposeOnUnmountProto");
var $d099423b37aa9cc4$var$instStoreKey = /*#__PURE__*/ $d099423b37aa9cc4$var$newSymbol("disposeOnUnmountInst");
function $d099423b37aa9cc4$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$d099423b37aa9cc4$var$protoStoreKey] || [], this[$d099423b37aa9cc4$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
function $d099423b37aa9cc4$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $d099423b37aa9cc4$export$4e749cb731da87a9(target, fn);
    });
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor); // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component || c === (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).PureComponent || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).PureComponent || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
     // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string"; // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$d099423b37aa9cc4$var$protoStoreKey] || !!target[$d099423b37aa9cc4$var$instStoreKey];
    var store = isDecorator ? target[$d099423b37aa9cc4$var$protoStoreKey] || (target[$d099423b37aa9cc4$var$protoStoreKey] = []) : target[$d099423b37aa9cc4$var$instStoreKey] || (target[$d099423b37aa9cc4$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction); // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $d099423b37aa9cc4$var$patch(target, "componentWillUnmount", $d099423b37aa9cc4$var$runDisposersOnWillUnmount);
     // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
function $d099423b37aa9cc4$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $9Qp9d.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false); // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
} // Copied from React.PropTypes
function $d099423b37aa9cc4$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
     // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
     // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
} // Copied from React.PropTypes
function $d099423b37aa9cc4$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($d099423b37aa9cc4$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
} // This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $d099423b37aa9cc4$var$getPreciseType(propValue) {
    var propType = $d099423b37aa9cc4$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $d099423b37aa9cc4$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $d099423b37aa9cc4$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $9Qp9d.untracked)(function() {
            if (allowNativeType) {
                if ($d099423b37aa9cc4$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $9Qp9d.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $9Qp9d.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $9Qp9d.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $d099423b37aa9cc4$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $d099423b37aa9cc4$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $d099423b37aa9cc4$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $9Qp9d.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $d099423b37aa9cc4$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $d099423b37aa9cc4$var$observableArray = /*#__PURE__*/ $d099423b37aa9cc4$var$createObservableTypeCheckerCreator(false, "Array");
var $d099423b37aa9cc4$var$observableArrayOf = /*#__PURE__*/ $d099423b37aa9cc4$var$createObservableArrayOfTypeChecker.bind(null, false);
var $d099423b37aa9cc4$var$observableMap = /*#__PURE__*/ $d099423b37aa9cc4$var$createObservableTypeCheckerCreator(false, "Map");
var $d099423b37aa9cc4$var$observableObject = /*#__PURE__*/ $d099423b37aa9cc4$var$createObservableTypeCheckerCreator(false, "Object");
var $d099423b37aa9cc4$var$arrayOrObservableArray = /*#__PURE__*/ $d099423b37aa9cc4$var$createObservableTypeCheckerCreator(true, "Array");
var $d099423b37aa9cc4$var$arrayOrObservableArrayOf = /*#__PURE__*/ $d099423b37aa9cc4$var$createObservableArrayOfTypeChecker.bind(null, true);
var $d099423b37aa9cc4$var$objectOrObservableObject = /*#__PURE__*/ $d099423b37aa9cc4$var$createObservableTypeCheckerCreator(true, "Object");
var $d099423b37aa9cc4$export$e0c95a451cd220b7 = {
    observableArray: $d099423b37aa9cc4$var$observableArray,
    observableArrayOf: $d099423b37aa9cc4$var$observableArrayOf,
    observableMap: $d099423b37aa9cc4$var$observableMap,
    observableObject: $d099423b37aa9cc4$var$observableObject,
    arrayOrObservableArray: $d099423b37aa9cc4$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $d099423b37aa9cc4$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $d099423b37aa9cc4$var$objectOrObservableObject
};
if (!(0, $bh6RR.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $9Qp9d.observable)) throw new Error("mobx-react requires mobx to be available");

});
parcelRegister("9Qp9d", function(module, exports) {

$parcel$export(module.exports, "$mobx", function () { return $mobx; });
$parcel$export(module.exports, "createAtom", function () { return createAtom; });
$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "isObservableObject", function () { return isObservableObject; });
$parcel$export(module.exports, "isObservableArray", function () { return isObservableArray; });
$parcel$export(module.exports, "isObservableMap", function () { return isObservableMap; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "_allowStateReadsStart", function () { return allowStateReadsStart; });
$parcel$export(module.exports, "_allowStateReadsEnd", function () { return allowStateReadsEnd; });
$parcel$export(module.exports, "_allowStateChanges", function () { return allowStateChanges; });
$parcel$export(module.exports, "untracked", function () { return untracked; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "reaction", function () { return reaction; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "makeAutoObservable", function () { return makeAutoObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.isPendingUnobservation_ = false;
        this.isBeingObserved_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // onBecomeObservedListeners
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return Atom;
}();
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    // Backwards/Legacy behavior, expects makeObservable(this)
    if (kind == "field") {
        addInitializer(function() {
            storeAnnotation(this, name, ann);
        });
        return;
    }
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var _Symbol$toPrimitive;
var CREATE = "create";
_Symbol$toPrimitive = Symbol.toPrimitive;
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    _inheritsLoose(ObservableValue, _Atom);
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
var _Symbol$toPrimitive$1;
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ _Symbol$toPrimitive$1 = Symbol.toPrimitive;
var ComputedValue = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    // during tracking it's an array with new observed observers
    // to check for cycles
    // N.B: unminified as it is used by MST
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        this.newObserving_ = null;
        this.isBeingObserved_ = false;
        this.isPendingUnobservation_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.isComputing_ = false;
        this.isRunningSetter_ = false;
        this.derivation = void 0;
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ ;
    _proto.get = function get() {
        if (this.isComputing_) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter_) die(33, this.name_);
            this.isRunningSetter_ = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter_ = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing_ = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing_ = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive$1] = function() {
        return this.valueOf();
    };
    return ComputedValue;
}();
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving_ = new Array(derivation.observing_.length + 100);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue_ === 0) {
            dep.diffValue_ = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue_ === 0) removeObserver(_dep, derivation);
        _dep.diffValue_ = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue_ === 1) {
            _dep2.diffValue_ = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    this.version = 6;
    this.UNCHANGED = {};
    this.trackingDerivation = null;
    this.trackingContext = null;
    this.runId = 0;
    this.mobxGuid = 0;
    this.inBatch = 0;
    this.pendingUnobservations = [];
    this.pendingReactions = [];
    this.isRunningReactions = false;
    this.allowStateChanges = false;
    this.allowStateReads = true;
    this.enforceActions = true;
    this.spyListeners = [];
    this.globalReactionErrorHandlers = [];
    this.computedRequiresReaction = false;
    this.reactionRequiresObservable = false;
    this.observableRequiresReaction = false;
    this.disableErrorBoundaries = false;
    this.suppressReactionErrors = false;
    this.useProxies = true;
    this.verifyProxies = false;
    this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation_ === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation_ = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation_ = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved_) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved_ = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved_ && globalState.trackingContext) {
                observable.isBeingObserved_ = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved_;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "	".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.isDisposed_ = false;
        this.isScheduled_ = false;
        this.isTrackPending_ = false;
        this.isRunning_ = false;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled_) {
            this.isScheduled_ = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.isScheduled = function isScheduled() {
        return this.isScheduled_;
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed_) {
            startBatch();
            this.isScheduled_ = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending_ = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed_) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning_ = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning_ = false;
        this.isTrackPending_ = false;
        if (this.isDisposed_) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed_) {
            this.isDisposed_ = true;
            if (!this.isRunning_) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return Reaction;
}();
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts2$signal, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed_) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2$signal = _opts2.signal) != null && _opts2$signal.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts4$signal, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var oldValue;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed_) return;
        var changed = false;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            oldValue = value;
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4$signal = _opts4.signal) != null && _opts4$signal.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed_) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null ? void 0 : (_opts$signal3 = opts.signal) == null ? void 0 : _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    // this is the prop that gets proxied, so can't replace it!
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks recieve correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks recieve correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var _Symbol$iterator, _Symbol$toStringTag;
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
var ObservableMap = /*#__PURE__*/ function() {
    // hasMap, not hashMap >-).
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[_Symbol$iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (other.constructor !== Map) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
    return ObservableMap;
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var _Symbol$iterator$1, _Symbol$toStringTag$1;
var ObservableSetMarker = {};
_Symbol$iterator$1 = Symbol.iterator;
_Symbol$toStringTag$1 = Symbol.toStringTag;
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
        // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[_Symbol$iterator$1] = function() {
        return this.values();
    };
    _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag$1,
            get: function get() {
                return "Set";
            }
        }
    ]);
    return ObservableSet;
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_, _this$pendingKeys_$ge;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_$ge = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_$ge.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2, _this$pendingKeys_2$g;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2$g = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2$g.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray, _Symbol$toStringTag, _Symbol$iterator) {
    _inheritsLoose(LegacyObservableArray, _StubArray);
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _assertThisInitialized(_this);
            addHiddenFinalProp(_assertThisInitialized(_this), $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_assertThisInitialized(_this), "0", ENTRY_0);
        });
        return _this;
    }
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[_Symbol$iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
    return LegacyObservableArray;
}(StubArray, Symbol.toStringTag, Symbol.iterator);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("7M59E", function(module, exports) {

$parcel$export(module.exports, "isUsingStaticRendering", function () { return (parcelRequire("4kfuq")).isUsingStaticRendering; });
$parcel$export(module.exports, "observer", function () { return (parcelRequire("2Rk4z")).observer; });
parcelRequire("iMx6w");
parcelRequire("cKn6u");
var $6afFj = parcelRequire("6afFj");

var $dePwb = parcelRequire("dePwb");
parcelRequire("bl0rV");

var $gd6cn = parcelRequire("gd6cn");

var $4kfuq = parcelRequire("4kfuq");

var $7K64t = parcelRequire("7K64t");

var $2Rk4z = parcelRequire("2Rk4z");

var $lOBJP = parcelRequire("lOBJP");

var $8phiE = parcelRequire("8phiE");

var $EJE81 = parcelRequire("EJE81");

var $4aESq = parcelRequire("4aESq");
var $5a9103b4ec14c4eb$var$_a;
(0, $dePwb.observerBatching)((0, $6afFj.unstable_batchedUpdates));
var $5a9103b4ec14c4eb$export$469d51fb8d268227 = ($5a9103b4ec14c4eb$var$_a = (0, $7K64t.observerFinalizationRegistry)["finalizeAllImmediately"]) !== null && $5a9103b4ec14c4eb$var$_a !== void 0 ? $5a9103b4ec14c4eb$var$_a : function() {};
function $5a9103b4ec14c4eb$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $gd6cn.useObserver)(fn, baseComponentName);
}
function $5a9103b4ec14c4eb$export$7613124ee4202834(enable) {
    (0, $4kfuq.enableStaticRendering)(enable);
}

});
parcelRegister("iMx6w", function(module, exports) {

var $9Qp9d = parcelRequire("9Qp9d");

var $bh6RR = parcelRequire("bh6RR");
if (!(0, $bh6RR.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $9Qp9d.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");

});

parcelRegister("cKn6u", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("6afFj")).unstable_batchedUpdates; });

var $6afFj = parcelRequire("6afFj");

});

parcelRegister("dePwb", function(module, exports) {

$parcel$export(module.exports, "observerBatching", function () { return $9a348b9c3493d4c7$export$294943bbc3c74f4f; });

var $9Qp9d = parcelRequire("9Qp9d");
function $9a348b9c3493d4c7$export$fb2daceae6f5097a(callback) {
    callback();
}
function $9a348b9c3493d4c7$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $9a348b9c3493d4c7$export$fb2daceae6f5097a;
    (0, $9Qp9d.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $9a348b9c3493d4c7$export$13ce1459b9a04b51 = function() {
    return true;
};

});

parcelRegister("bl0rV", function(module, exports) {
var $84120123f03e990e$var$deprecatedMessages = [];
function $84120123f03e990e$export$be38475be17599d(msg) {
    if (!$84120123f03e990e$var$deprecatedMessages.includes(msg)) {
        $84120123f03e990e$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}

});

parcelRegister("gd6cn", function(module, exports) {

$parcel$export(module.exports, "useObserver", function () { return $bcd2ab294246f4b6$export$b9c7ecd090a87b14; });

var $9Qp9d = parcelRequire("9Qp9d");

var $bh6RR = parcelRequire("bh6RR");

var $6bybi = parcelRequire("6bybi");

var $7K64t = parcelRequire("7K64t");

var $4kfuq = parcelRequire("4kfuq");
var $bcd2ab294246f4b6$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $bcd2ab294246f4b6$var$observerComponentNameFor(baseComponentName) {
    return "observer".concat(baseComponentName);
}
/**
 * We use class to make it easier to detect in heap snapshots by name
 */ var $bcd2ab294246f4b6$var$ObjectToBeRetainedByReact = /** @class */ function() {
    function ObjectToBeRetainedByReact() {}
    return ObjectToBeRetainedByReact;
}();
function $bcd2ab294246f4b6$var$objectToBeRetainedByReactFactory() {
    return new $bcd2ab294246f4b6$var$ObjectToBeRetainedByReact();
}
function $bcd2ab294246f4b6$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $4kfuq.isUsingStaticRendering)()) return fn();
    var _a = $bcd2ab294246f4b6$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState($bcd2ab294246f4b6$var$objectToBeRetainedByReactFactory), 1), objectRetainedByReact = _a[0];
    // Force update, see #2982
    var _b = $bcd2ab294246f4b6$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(), 2), setState = _b[1];
    var forceUpdate = function() {
        return setState([]);
    };
    // StrictMode/ConcurrentMode/Suspense may mean that our component is
    // rendered and abandoned multiple times, so we need to track leaked
    // Reactions.
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    if (!admRef.current) // First render
    admRef.current = {
        reaction: null,
        mounted: false,
        changedBeforeMount: false
    };
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or component was not committed and reaction was disposed by registry
        adm.reaction = new (0, $9Qp9d.Reaction)($bcd2ab294246f4b6$var$observerComponentNameFor(baseComponentName), function() {
            // Observable has changed, meaning we want to re-render
            // BUT if we're a component that hasn't yet got to the useEffect()
            // stage, we might be a component that _started_ to render, but
            // got dropped, and we don't want to make state changes then.
            // (It triggers warnings in StrictMode, for a start.)
            if (adm.mounted) // We have reached useEffect(), so we're mounted, and can trigger an update
            forceUpdate();
            else // We haven't yet reached useEffect(), so we'll need to trigger a re-render
            // when (and if) useEffect() arrives.
            adm.changedBeforeMount = true;
        });
        (0, $7K64t.observerFinalizationRegistry).register(objectRetainedByReact, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useDebugValue(adm.reaction, (0, $6bybi.printDebugValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(function() {
        (0, $7K64t.observerFinalizationRegistry).unregister(adm);
        adm.mounted = true;
        if (adm.reaction) {
            if (adm.changedBeforeMount) {
                // Got a change before mount, force an update
                adm.changedBeforeMount = false;
                forceUpdate();
            }
        } else {
            // The reaction we set up in our render has been disposed.
            // This can be due to bad timings of renderings, e.g. our
            // component was paused for a _very_ long time, and our
            // reaction got cleaned up
            // Re-create the reaction
            adm.reaction = new (0, $9Qp9d.Reaction)($bcd2ab294246f4b6$var$observerComponentNameFor(baseComponentName), function() {
                // We've definitely already been mounted at this point
                forceUpdate();
            });
            forceUpdate();
        }
        return function() {
            adm.reaction.dispose();
            adm.reaction = null;
            adm.mounted = false;
            adm.changedBeforeMount = false;
        };
    }, []);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var rendering;
    var exception;
    adm.reaction.track(function() {
        try {
            rendering = fn();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return rendering;
}

});
parcelRegister("6bybi", function(module, exports) {

$parcel$export(module.exports, "printDebugValue", function () { return $480e48d2c20cba13$export$ef795f1f307682c7; });

var $9Qp9d = parcelRequire("9Qp9d");
function $480e48d2c20cba13$export$ef795f1f307682c7(v) {
    return (0, $9Qp9d.getDependencyTree)(v);
}

});

parcelRegister("7K64t", function(module, exports) {

$parcel$export(module.exports, "observerFinalizationRegistry", function () { return $5a3189e947046441$export$10e8a12fbfd8583c; });

var $emnU7 = parcelRequire("emnU7");
var $5a3189e947046441$export$10e8a12fbfd8583c = new (0, $emnU7.UniversalFinalizationRegistry)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});

});
parcelRegister("emnU7", function(module, exports) {

$parcel$export(module.exports, "UniversalFinalizationRegistry", function () { return $a745a9a18234605e$export$da5d55a244964b51; });
var $a745a9a18234605e$export$e901ba0ffe10ba41 = 10000;
var $a745a9a18234605e$export$1ae22ce5a82f26b6 = 10000;
var $a745a9a18234605e$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $a745a9a18234605e$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $a745a9a18234605e$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $a745a9a18234605e$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $a745a9a18234605e$export$b7a00d372cedeedd;

});


parcelRegister("4kfuq", function(module, exports) {

$parcel$export(module.exports, "enableStaticRendering", function () { return $32650b982051c03a$export$5d52eaa7c0f24c9e; });
$parcel$export(module.exports, "isUsingStaticRendering", function () { return $32650b982051c03a$export$55979271896d643e; });
var $32650b982051c03a$var$globalIsUsingStaticRendering = false;
function $32650b982051c03a$export$5d52eaa7c0f24c9e(enable) {
    $32650b982051c03a$var$globalIsUsingStaticRendering = enable;
}
function $32650b982051c03a$export$55979271896d643e() {
    return $32650b982051c03a$var$globalIsUsingStaticRendering;
}

});


parcelRegister("2Rk4z", function(module, exports) {

$parcel$export(module.exports, "observer", function () { return $21501a06c2ccd796$export$b6ae1bc530f4c149; });

var $bh6RR = parcelRequire("bh6RR");

var $4kfuq = parcelRequire("4kfuq");

var $gd6cn = parcelRequire("gd6cn");
var $21501a06c2ccd796$var$warnObserverOptionsDeprecated = true;
var $21501a06c2ccd796$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $21501a06c2ccd796$var$ReactForwardRefSymbol = $21501a06c2ccd796$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $bh6RR.forwardRef) === "function" && (0, $bh6RR.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $21501a06c2ccd796$var$ReactMemoSymbol = $21501a06c2ccd796$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $bh6RR.memo) === "function" && (0, $bh6RR.memo)(function(props) {
    return null;
})["$$typeof"];
function $21501a06c2ccd796$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($21501a06c2ccd796$var$ReactMemoSymbol && baseComponent["$$typeof"] === $21501a06c2ccd796$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $4kfuq.isUsingStaticRendering)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($21501a06c2ccd796$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $21501a06c2ccd796$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $gd6cn.useObserver)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    // Don't set `displayName` for anonymous components,
    // so the `displayName` can be customized by user, see #3192.
    if (baseComponentName !== "") observerComponent.displayName = baseComponentName;
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $bh6RR.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $bh6RR.memo)(observerComponent);
    $21501a06c2ccd796$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $21501a06c2ccd796$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $21501a06c2ccd796$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$21501a06c2ccd796$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}

});

parcelRegister("lOBJP", function(module, exports) {

var $gd6cn = parcelRequire("gd6cn");
function $fe1b8a84b8ab49eb$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $gd6cn.useObserver)(component);
}
$fe1b8a84b8ab49eb$export$c1cbdee04e18ea8b.displayName = "Observer";
function $fe1b8a84b8ab49eb$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}

});

parcelRegister("8phiE", function(module, exports) {

var $9Qp9d = parcelRequire("9Qp9d");

var $bh6RR = parcelRequire("bh6RR");
function $61ee13e9961ec895$export$aa207039f277c5f(initializer, annotations) {
    return (0, $bh6RR.useState)(function() {
        return (0, $9Qp9d.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}

});

parcelRegister("EJE81", function(module, exports) {

var $9Qp9d = parcelRequire("9Qp9d");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("bl0rV");

var $4aESq = parcelRequire("4aESq");
function $07a724eebe66715d$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $4aESq.useAsObservableSource)(current);
    return (0, $bh6RR.useState)(function() {
        return (0, $9Qp9d.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}

});
parcelRegister("4aESq", function(module, exports) {

$parcel$export(module.exports, "useAsObservableSource", function () { return $3097cdde7a3d7465$export$e0ded3646391939c; });
parcelRequire("bl0rV");

var $9Qp9d = parcelRequire("9Qp9d");

var $bh6RR = parcelRequire("bh6RR");
var $3097cdde7a3d7465$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $3097cdde7a3d7465$export$e0ded3646391939c(current) {
    var _a = $3097cdde7a3d7465$var$__read((0, $bh6RR.useState)(function() {
        return (0, $9Qp9d.observable)(current, {}, {
            deep: false
        });
    }), 1), res = _a[0];
    (0, $9Qp9d.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}

});




parcelRegister("5aMF5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bh6RR = parcelRequire("bh6RR");

var $1LCZd = parcelRequire("1LCZd");

var $b9VmI = parcelRequire("b9VmI");
var $3c43a21bb57bd607$var$INCORRECT_VERSION_ERROR = new Error("use-react-router may only be used with react-router@^5.");
var $3c43a21bb57bd607$var$MISSING_CONTEXT_ERROR = new Error("useReactRouter may only be called within a <Router /> context.");
function $3c43a21bb57bd607$var$useRouter() {
    if (!$1LCZd.__RouterContext) throw $3c43a21bb57bd607$var$INCORRECT_VERSION_ERROR;
    var context = $bh6RR.useContext($1LCZd.__RouterContext);
    if (!context) throw $3c43a21bb57bd607$var$MISSING_CONTEXT_ERROR;
    var forceUpdate = $b9VmI.default();
    $bh6RR.useEffect(function() {
        return context.history.listen(forceUpdate);
    }, [
        context
    ]);
    return context;
}
module.exports.default = $3c43a21bb57bd607$var$useRouter;

});
parcelRegister("b9VmI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81fd088ddb15c7bb$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $81fd088ddb15c7bb$var$__read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
var $81fd088ddb15c7bb$var$createNewObject = function() {
    return {};
};
function $81fd088ddb15c7bb$export$2e2bcd8739ae039() {
    var _a = $81fd088ddb15c7bb$var$__read((0, $bh6RR.useState)($81fd088ddb15c7bb$var$createNewObject), 2), setValue = _a[1];
    return (0, $bh6RR.useCallback)(function() {
        setValue($81fd088ddb15c7bb$var$createNewObject());
    }, []);
}

});


parcelRegister("iOlMk", function(module, exports) {

$parcel$export(module.exports, "tokenStore", function () { return $db1dca41c0ec0960$export$22cf5cddd7d3c933; });
$parcel$export(module.exports, "refreshTokenStore", function () { return $db1dca41c0ec0960$export$90c2d26dad3e06cd; });
$parcel$export(module.exports, "setToken", function () { return $db1dca41c0ec0960$export$57e714f81a2c3d86; });
$parcel$export(module.exports, "setRefreshToken", function () { return $db1dca41c0ec0960$export$5861dadde5f81636; });
$parcel$export(module.exports, "logout", function () { return $db1dca41c0ec0960$export$a0973bcfe11b05c9; });
$parcel$export(module.exports, "getCurrentUserEffect", function () { return $db1dca41c0ec0960$export$80608dc77508717; });
$parcel$export(module.exports, "currentUser", function () { return $db1dca41c0ec0960$export$5671b2216dc5440f; });

var $b7l7Q = parcelRequire("b7l7Q");

var $44bXl = parcelRequire("44bXl");

var $2F0j2 = parcelRequire("2F0j2");

var $3DzKC = parcelRequire("3DzKC");

var $hcepo = parcelRequire("hcepo");

var $kEUo3 = parcelRequire("kEUo3");
parcelRequire("PW6XX");

var $5lJLQ = parcelRequire("5lJLQ");

var $lVvdy = parcelRequire("lVvdy");

var $dsDBD = parcelRequire("dsDBD");
parcelRequire("60top");
parcelRequire("jCgCX");
parcelRequire("keeSY");

var $eYBKQ = parcelRequire("eYBKQ");

var $2kmDV = parcelRequire("2kmDV");
// const currentToken = localStorage.getItem("kdf_ems_token")
// if (isValidToken(JSON.parse(currentToken)) && !window.ReactNativeWebView) {
//   const tokenData = jwtDecode(JSON.parse(currentToken));
//   const isExpiredToken = dayjs(tokenData.exp * 1000).diff(dayjs(), 'hour') < 150;
//
//   if (isExpiredToken) {
//     localStorage.setItem("kdf_ems_token", 'null')
//   }
// }
const $db1dca41c0ec0960$var$tokenLocalStorage = (0, (/*@__PURE__*/$parcel$interopDefault($44bXl)))("kdf_ems_token");
const $db1dca41c0ec0960$var$refreshTokenLocalStorage = (0, (/*@__PURE__*/$parcel$interopDefault($44bXl)))("kdf_ems_refresh_token");
const $db1dca41c0ec0960$export$22cf5cddd7d3c933 = (0, $b7l7Q.createStore)($db1dca41c0ec0960$var$tokenLocalStorage.init());
const $db1dca41c0ec0960$export$90c2d26dad3e06cd = (0, $b7l7Q.createStore)($db1dca41c0ec0960$var$refreshTokenLocalStorage.init());
const $db1dca41c0ec0960$export$57e714f81a2c3d86 = (0, $b7l7Q.createEvent)("setToken");
const $db1dca41c0ec0960$export$5861dadde5f81636 = (0, $b7l7Q.createEvent)("setRefreshToken");
const $db1dca41c0ec0960$export$a0973bcfe11b05c9 = (0, $b7l7Q.createEvent)("logout");
const $db1dca41c0ec0960$var$sentryScope = $hcepo.getCurrentScope();
const $db1dca41c0ec0960$var$onLogout = async ()=>{
    const token = $db1dca41c0ec0960$export$22cf5cddd7d3c933.getState();
    (0, $eYBKQ.removeItemLocalStorage)((0, $2kmDV.SCHEDULE_FILTERS_STORAGE_KEY));
    const clearVoximplantSupport = ()=>{
        (0, $lVvdy.setVoximplantSupportData)({
            client_id: Date.now() + ""
        });
        if (window.VoxKitWidget) (0, $lVvdy.reInitVoximplant)();
    };
    if (!token) {
        clearVoximplantSupport();
        return;
    }
    try {
        await (0, $dsDBD.default).logout();
        $db1dca41c0ec0960$var$sentryScope.clear();
        clearVoximplantSupport();
    } catch (e) {
        console.log(e);
    }
};
$db1dca41c0ec0960$export$a0973bcfe11b05c9.watch(()=>$db1dca41c0ec0960$var$onLogout());
$db1dca41c0ec0960$export$22cf5cddd7d3c933.watch((state)=>{
    $db1dca41c0ec0960$var$tokenLocalStorage.watcher(state);
});
$db1dca41c0ec0960$export$90c2d26dad3e06cd.watch((state)=>{
    $db1dca41c0ec0960$var$refreshTokenLocalStorage.watcher(state);
});
$db1dca41c0ec0960$export$22cf5cddd7d3c933.on($db1dca41c0ec0960$export$57e714f81a2c3d86, (state, newToken)=>{
    return newToken;
});
$db1dca41c0ec0960$export$90c2d26dad3e06cd.on($db1dca41c0ec0960$export$5861dadde5f81636, (state, newToken)=>{
    return newToken;
});
$db1dca41c0ec0960$export$22cf5cddd7d3c933.on($db1dca41c0ec0960$export$a0973bcfe11b05c9, ()=>null);
$db1dca41c0ec0960$export$90c2d26dad3e06cd.on($db1dca41c0ec0960$export$a0973bcfe11b05c9, ()=>null);
const $db1dca41c0ec0960$export$80608dc77508717 = (0, $b7l7Q.createEffect)("get current user").use(async ()=>await (0, $dsDBD.default).getCurrentUser());
const $db1dca41c0ec0960$export$5671b2216dc5440f = (0, $b7l7Q.createStore)(null);
const $db1dca41c0ec0960$export$58a64cd2781ebc5 = $db1dca41c0ec0960$export$5671b2216dc5440f.map((user)=>{
    if (user && user.doctor) {
        const doctor = user.doctor;
        return doctor.id;
    }
    return null;
});
$db1dca41c0ec0960$export$5671b2216dc5440f.on($db1dca41c0ec0960$export$80608dc77508717.done, (oldUser, { result: newUser })=>{
    newUser;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).isEqual(oldUser, newUser)) return oldUser;
    if (newUser) {
        var _newUser$doctor7, _newUser$doctor7$phot, _newUser$doctor8, _newUser, _newUser$photo, _newUser2;
        if (!oldUser || oldUser && oldUser.id !== newUser.id) (0, (/*@__PURE__*/$parcel$interopDefault($3DzKC))).identify(newUser.id, {
            // $FlowFixMe
            name: newUser.doctor ? (0, $2F0j2.getLastNameWithInitials)(newUser.doctor) : newUser.username
        });
        var _newUser$doctor, _newUser$doctor2, _newUser$doctor3, _newUser$doctor4, _newUser$doctor5, _newUser$doctor6;
        $db1dca41c0ec0960$var$sentryScope.setUser({
            id: newUser.id,
            username: newUser.username
        });
        $db1dca41c0ec0960$var$sentryScope.setTag("user_id", newUser.id);
        $db1dca41c0ec0960$var$sentryScope.setTag("username", newUser.username);
        $db1dca41c0ec0960$var$sentryScope.setTag("doctor_id", (_newUser$doctor = newUser.doctor) === null || _newUser$doctor === void 0 ? void 0 : _newUser$doctor.id);
        $db1dca41c0ec0960$var$sentryScope.setContext("Doctor Data", {
            id: (_newUser$doctor2 = newUser.doctor) === null || _newUser$doctor2 === void 0 ? void 0 : _newUser$doctor2.id,
            name: (0, $2F0j2.getLastNameWithInitials)(newUser.doctor),
            organizations: (_newUser$doctor3 = newUser.doctor) === null || _newUser$doctor3 === void 0 ? void 0 : _newUser$doctor3.organizations,
            cities: (_newUser$doctor4 = newUser.doctor) === null || _newUser$doctor4 === void 0 ? void 0 : _newUser$doctor4.cities,
            specialities: (_newUser$doctor5 = newUser.doctor) === null || _newUser$doctor5 === void 0 ? void 0 : _newUser$doctor5.specialities.map((spec)=>JSON.stringify(spec)),
            schedule_step: (_newUser$doctor6 = newUser.doctor) === null || _newUser$doctor6 === void 0 ? void 0 : _newUser$doctor6.schedule_step
        });
        const oldClientId = window.VoxKitWidgetSettings.client_data.client_id;
        const doctorPhoto = !((_newUser$doctor7 = newUser.doctor) !== null && _newUser$doctor7 !== void 0 && (_newUser$doctor7$phot = _newUser$doctor7.photo) !== null && _newUser$doctor7$phot !== void 0 && _newUser$doctor7$phot.startsWith("#")) ? (_newUser$doctor8 = newUser.doctor) === null || _newUser$doctor8 === void 0 ? void 0 : _newUser$doctor8.photo : !((_newUser = newUser) !== null && _newUser !== void 0 && (_newUser$photo = _newUser.photo) !== null && _newUser$photo !== void 0 && _newUser$photo.startsWith("#")) ? (_newUser2 = newUser) === null || _newUser2 === void 0 ? void 0 : _newUser2.photo : "";
        (0, $lVvdy.setVoximplantSupportData)({
            client_id: newUser.doctor ? newUser.doctor.id + "" : newUser.id + "",
            client_phone: newUser.username,
            client_display_name: newUser.doctor ? (0, $2F0j2.getLastNameWithInitials)(newUser.doctor) : newUser.username,
            client_avatar: doctorPhoto,
            client_email: {}
        }, true, true);
        if (parseInt(oldClientId) !== (newUser.doctor ? newUser.doctor.id : newUser.id)) (0, $lVvdy.reInitVoximplant)();
    }
    setInterval(()=>{
        (0, $5lJLQ.clearAllCache)();
    }, 28800000);
    return newUser;
});
$db1dca41c0ec0960$export$22cf5cddd7d3c933.on($db1dca41c0ec0960$export$80608dc77508717.fail, ()=>{
    (0, $5lJLQ.clearAllCache)();
    return null;
});
$db1dca41c0ec0960$export$5671b2216dc5440f.on($db1dca41c0ec0960$export$a0973bcfe11b05c9, ()=>{
    (0, $5lJLQ.clearAllCache)();
    return null;
});
$db1dca41c0ec0960$export$22cf5cddd7d3c933.watch((token)=>{
    if (token) $db1dca41c0ec0960$export$80608dc77508717({
        token: token
    });
});
const $db1dca41c0ec0960$export$c542b5e295206b2a = async (currentToken)=>{
    const token = currentToken || $db1dca41c0ec0960$export$22cf5cddd7d3c933.getState();
    const refreshToken = $db1dca41c0ec0960$export$90c2d26dad3e06cd.getState();
    if (!token) return;
    try {
        const result = await (0, $dsDBD.default).postRefreshToken(token);
        $db1dca41c0ec0960$export$57e714f81a2c3d86(result.token);
        $db1dca41c0ec0960$export$5861dadde5f81636(result.refreshToken);
    } catch (e) {
        console.log(e);
        $db1dca41c0ec0960$export$a0973bcfe11b05c9();
    }
}; // if (isValidToken(JSON.parse(currentToken)) && !window.ReactNativeWebView) {
 //   const tokenData = jwtDecode(JSON.parse(currentToken));
 //   const isExpiredToken = dayjs(tokenData.exp * 1000).diff(dayjs(), 'hour') < 150;
 //
 //   if (isExpiredToken) {
 //     refreshToken(JSON.parse(currentToken));
 //   }
 // }
 // setInterval(refreshToken, 10000);

});
parcelRegister("b7l7Q", function(module, exports) {

$parcel$export(module.exports, "createNode", function () { return $fd2b3ae2ecea5570$export$270e7ba5936d3c48; });
$parcel$export(module.exports, "launch", function () { return $fd2b3ae2ecea5570$export$9a7f3579b2beee84; });
$parcel$export(module.exports, "createEvent", function () { return $fd2b3ae2ecea5570$export$c30017717ce2168e; });
$parcel$export(module.exports, "createStore", function () { return $fd2b3ae2ecea5570$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combine", function () { return $fd2b3ae2ecea5570$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "createEffect", function () { return $fd2b3ae2ecea5570$export$7ea7134f704deda4; });
$parcel$export(module.exports, "merge", function () { return $fd2b3ae2ecea5570$export$4950aa0f605343fb; });
$parcel$export(module.exports, "sample", function () { return $fd2b3ae2ecea5570$export$4812e460280c6ef2; });
$parcel$export(module.exports, "restore", function () { return $fd2b3ae2ecea5570$export$db239ef39aadc7fe; });
$parcel$export(module.exports, "scopeBind", function () { return $fd2b3ae2ecea5570$export$18f6b3f66cc08bf; });
$parcel$export(module.exports, "step", function () { return $fd2b3ae2ecea5570$export$35d34bc0ed591a92; });
$parcel$export(module.exports, "clearNode", function () { return $fd2b3ae2ecea5570$export$51cfe97d637c237c; });
$parcel$export(module.exports, "is", function () { return $fd2b3ae2ecea5570$export$226b3eccf92c9ed9; });
$parcel$export(module.exports, "forward", function () { return $fd2b3ae2ecea5570$export$174bb771924e7eb1; });
function $fd2b3ae2ecea5570$var$e(e, t) {
    for(let r in e)t(e[r], r);
}
function $fd2b3ae2ecea5570$var$t(e, t) {
    e.forEach(t);
}
function $fd2b3ae2ecea5570$var$r(e, t) {
    if (!e) throw Error(t);
}
function $fd2b3ae2ecea5570$export$2f9294bfc17c771e(e, t) {
    let r = $fd2b3ae2ecea5570$var$L(e).meta || {};
    $fd2b3ae2ecea5570$var$he = {
        id: $fd2b3ae2ecea5570$var$L(e).id,
        parent: $fd2b3ae2ecea5570$var$he,
        value: e,
        template: r.template || $fd2b3ae2ecea5570$var$be(),
        sidRoot: r.sidRoot || $fd2b3ae2ecea5570$var$he && $fd2b3ae2ecea5570$var$he.sidRoot,
        meta: r
    };
    try {
        return t();
    } finally{
        $fd2b3ae2ecea5570$var$ye("region"), $fd2b3ae2ecea5570$var$he = $fd2b3ae2ecea5570$var$V($fd2b3ae2ecea5570$var$he);
    }
}
function $fd2b3ae2ecea5570$export$270e7ba5936d3c48({ node: e = [], from: r, source: a, parent: n = r || a, to: i, target: o, child: l = i || o, scope: s = {}, meta: f = {}, family: d = {
    type: "regular"
}, regional: u } = {}) {
    let c = $fd2b3ae2ecea5570$var$Se(n), p = $fd2b3ae2ecea5570$var$Se(d.links), m = $fd2b3ae2ecea5570$var$Se(d.owners), g = [];
    $fd2b3ae2ecea5570$var$t(e, (e)=>e && $fd2b3ae2ecea5570$var$le(g, e));
    let h = {
        id: $fd2b3ae2ecea5570$var$pe(),
        seq: g,
        next: $fd2b3ae2ecea5570$var$Se(l),
        meta: f,
        scope: s,
        family: {
            type: d.type || "crosslink",
            links: p,
            owners: m
        }
    };
    return $fd2b3ae2ecea5570$var$t(p, (e)=>$fd2b3ae2ecea5570$var$le($fd2b3ae2ecea5570$var$T(e), h)), $fd2b3ae2ecea5570$var$t(m, (e)=>$fd2b3ae2ecea5570$var$le($fd2b3ae2ecea5570$var$B(e), h)), $fd2b3ae2ecea5570$var$t(c, (e)=>$fd2b3ae2ecea5570$var$le(e.next, h)), u && $fd2b3ae2ecea5570$var$he && $fd2b3ae2ecea5570$var$we($fd2b3ae2ecea5570$var$H($fd2b3ae2ecea5570$var$he), [
        h
    ]), h;
}
function $fd2b3ae2ecea5570$export$9a7f3579b2beee84(e, r, a) {
    let n, i = $fd2b3ae2ecea5570$var$nt, o = null, l = $fd2b3ae2ecea5570$var$et;
    if (e.target && (r = e.params, a = e.defer, n = e.meta, i = "page" in e ? e.page : i, e.stack && (o = e.stack), l = $fd2b3ae2ecea5570$var$G(e) || l, e = e.target), l && $fd2b3ae2ecea5570$var$et && l !== $fd2b3ae2ecea5570$var$et && ($fd2b3ae2ecea5570$var$et = null), Array.isArray(e)) for(let t = 0; t < e.length; t++)$fd2b3ae2ecea5570$var$Qe("pure", i, $fd2b3ae2ecea5570$var$L(e[t]), o, r[t], l, n);
    else $fd2b3ae2ecea5570$var$Qe("pure", i, $fd2b3ae2ecea5570$var$L(e), o, r, l, n);
    if (a && !$fd2b3ae2ecea5570$var$tt) return;
    let s, f, d, u, c, p, m = {
        isRoot: $fd2b3ae2ecea5570$var$tt,
        currentPage: $fd2b3ae2ecea5570$var$nt,
        scope: $fd2b3ae2ecea5570$var$et,
        isWatch: $fd2b3ae2ecea5570$var$rt,
        isPure: $fd2b3ae2ecea5570$var$at
    };
    $fd2b3ae2ecea5570$var$tt = 0;
    e: for(; u = $fd2b3ae2ecea5570$var$Ke();){
        let { idx: e, stack: r, type: a } = u;
        d = r.node, $fd2b3ae2ecea5570$var$nt = c = r.page, $fd2b3ae2ecea5570$var$et = $fd2b3ae2ecea5570$var$G(r), c ? p = c.reg : $fd2b3ae2ecea5570$var$et && (p = $fd2b3ae2ecea5570$var$et.reg);
        let n = !!c, i = !!$fd2b3ae2ecea5570$var$et, o = {
            fail: 0,
            scope: d.scope
        };
        s = f = 0;
        for(let t = e; t < d.seq.length && !s; t++){
            let l = d.seq[t];
            if (l.order) {
                let { priority: n, barrierID: i } = l.order, o = i ? c ? `${c.fullID}_${i}` : i : 0;
                if (t !== e || a !== n) {
                    i ? $fd2b3ae2ecea5570$var$Ze.has(o) || ($fd2b3ae2ecea5570$var$Ze.add(o), $fd2b3ae2ecea5570$var$Xe(t, r, n, i)) : $fd2b3ae2ecea5570$var$Xe(t, r, n);
                    continue e;
                }
                i && $fd2b3ae2ecea5570$var$Ze.delete(o);
            }
            switch(l.type){
                case "mov":
                    {
                        let e, t = l.data;
                        switch(t.from){
                            case $fd2b3ae2ecea5570$var$P:
                                e = $fd2b3ae2ecea5570$var$H(r);
                                break;
                            case "a":
                            case "b":
                                e = r[t.from];
                                break;
                            case "value":
                                e = t.store;
                                break;
                            case "store":
                                if (p && !p[t.store.id]) {
                                    if (n) {
                                        let e = $fd2b3ae2ecea5570$var$st(c, t.store.id);
                                        r.page = c = e, e ? p = e.reg : i ? ($fd2b3ae2ecea5570$var$pt($fd2b3ae2ecea5570$var$et, t.store, 0, 1, t.softRead), p = $fd2b3ae2ecea5570$var$et.reg) : p = void 0;
                                    } else i && $fd2b3ae2ecea5570$var$pt($fd2b3ae2ecea5570$var$et, t.store, 0, 1, t.softRead);
                                }
                                e = $fd2b3ae2ecea5570$var$We(p && p[t.store.id] || t.store);
                        }
                        switch(t.to){
                            case $fd2b3ae2ecea5570$var$P:
                                r.value = e;
                                break;
                            case "a":
                            case "b":
                                r[t.to] = e;
                                break;
                            case "store":
                                $fd2b3ae2ecea5570$var$dt(c, $fd2b3ae2ecea5570$var$et, d, t.target).current = e;
                        }
                        break;
                    }
                case "compute":
                    let e1 = l.data;
                    if (e1.fn) {
                        $fd2b3ae2ecea5570$var$rt = "watch" === $fd2b3ae2ecea5570$var$J(d, "op"), $fd2b3ae2ecea5570$var$at = e1.pure;
                        let t = e1.safe ? (0, e1.fn)($fd2b3ae2ecea5570$var$H(r), o.scope, r) : $fd2b3ae2ecea5570$var$mt(o, e1.fn, r);
                        e1.filter ? f = !t : r.value = t, $fd2b3ae2ecea5570$var$rt = m.isWatch, $fd2b3ae2ecea5570$var$at = m.isPure;
                    }
            }
            s = o.fail || f;
        }
        if ($fd2b3ae2ecea5570$var$ft && $fd2b3ae2ecea5570$var$ft(r, o), !s) {
            let e = $fd2b3ae2ecea5570$var$H(r), a = $fd2b3ae2ecea5570$var$G(r);
            if ($fd2b3ae2ecea5570$var$t(d.next, (t)=>{
                $fd2b3ae2ecea5570$var$Qe("child", c, t, r, e, a);
            }), a) {
                $fd2b3ae2ecea5570$var$J(d, "needFxCounter") && $fd2b3ae2ecea5570$var$Qe("child", c, a.fxCount, r, e, a), $fd2b3ae2ecea5570$var$J(d, "storeChange") && $fd2b3ae2ecea5570$var$Qe("child", c, a.storeChange, r, e, a), $fd2b3ae2ecea5570$var$J(d, "warnSerialize") && $fd2b3ae2ecea5570$var$Qe("child", c, a.warnSerializeNode, r, e, a);
                let n = a.additionalLinks[d.id];
                n && $fd2b3ae2ecea5570$var$t(n, (t)=>{
                    $fd2b3ae2ecea5570$var$Qe("child", c, t, r, e, a);
                });
            }
        }
    }
    $fd2b3ae2ecea5570$var$tt = m.isRoot, $fd2b3ae2ecea5570$var$nt = m.currentPage, $fd2b3ae2ecea5570$var$et = $fd2b3ae2ecea5570$var$G(m);
}
function $fd2b3ae2ecea5570$var$o(t, r = "combine") {
    let a = r + "(", n = "", i = 0;
    return $fd2b3ae2ecea5570$var$e(t, (e)=>{
        i < 25 && (null != e && (a += n, a += $fd2b3ae2ecea5570$var$X(e) ? $fd2b3ae2ecea5570$var$Q(e).fullName : e.toString()), i += 1, n = ", ");
    }), a + ")";
}
function $fd2b3ae2ecea5570$export$71fac2a1f979e2c1(e, t) {
    e.shortName = t, Object.assign($fd2b3ae2ecea5570$var$Q(e), $fd2b3ae2ecea5570$var$s(t, $fd2b3ae2ecea5570$var$V(e)));
}
function $fd2b3ae2ecea5570$var$s(e, t) {
    let r, a, n = e;
    if (t) {
        let n = $fd2b3ae2ecea5570$var$Q(t);
        0 === e.length ? (r = n.path, a = n.fullName) : (r = n.path.concat([
            e
        ]), a = 0 === n.fullName.length ? e : n.fullName + "/" + e);
    } else r = 0 === e.length ? [] : [
        e
    ], a = e;
    return {
        shortName: n,
        fullName: a,
        path: r
    };
}
function $fd2b3ae2ecea5570$var$f(e, t) {
    let r = t ? e : e[0];
    $fd2b3ae2ecea5570$var$ze(r);
    let a = r.or, n = r.and;
    if (n) {
        let r = t ? n : n[0];
        if ($fd2b3ae2ecea5570$var$Me(r) && "and" in r) {
            let r = $fd2b3ae2ecea5570$var$f(n, t);
            e = r[0], a = {
                ...a,
                ...r[1]
            };
        } else e = n;
    }
    return [
        e,
        a
    ];
}
function $fd2b3ae2ecea5570$var$d(e, ...t) {
    let r = $fd2b3ae2ecea5570$var$be();
    if (r) {
        let a = r.handlers[e];
        if (a) return a(r, ...t);
    }
}
function $fd2b3ae2ecea5570$export$c30017717ce2168e(e, t) {
    let r = $fd2b3ae2ecea5570$var$gt({
        or: t,
        and: "string" == typeof e ? {
            name: e
        } : e
    }), a = (e, ...t)=>($fd2b3ae2ecea5570$var$se(!$fd2b3ae2ecea5570$var$J(a, "derived"), "call of derived event", "createEvent"), $fd2b3ae2ecea5570$var$se(!$fd2b3ae2ecea5570$var$at, "unit call from pure function", "operators like sample"), $fd2b3ae2ecea5570$var$nt ? ((e, t, r, a)=>{
            let n = $fd2b3ae2ecea5570$var$nt, i = null;
            if (t) for(i = $fd2b3ae2ecea5570$var$nt; i && i.template !== t;)i = $fd2b3ae2ecea5570$var$V(i);
            $fd2b3ae2ecea5570$var$lt(i);
            let o = e.create(r, a);
            return $fd2b3ae2ecea5570$var$lt(n), o;
        })(a, o, e, t) : a.create(e, t)), o = $fd2b3ae2ecea5570$var$be(), l = Object.assign(a, {
        graphite: $fd2b3ae2ecea5570$export$270e7ba5936d3c48({
            meta: $fd2b3ae2ecea5570$var$$t(r.actualOp || "event", a, r),
            regional: 1
        }),
        create: (e)=>($fd2b3ae2ecea5570$export$9a7f3579b2beee84({
                target: a,
                params: e,
                scope: $fd2b3ae2ecea5570$var$et
            }), e),
        watch: (e)=>$fd2b3ae2ecea5570$var$Mt(a, e),
        map: (e)=>$fd2b3ae2ecea5570$var$zt(a, $fd2b3ae2ecea5570$var$_, e, [
                $fd2b3ae2ecea5570$var$Le()
            ]),
        filter: (e)=>$fd2b3ae2ecea5570$var$zt(a, "filter", e.fn ? e : e.fn, [
                $fd2b3ae2ecea5570$var$Le($fd2b3ae2ecea5570$var$qe, 1)
            ]),
        filterMap: (e)=>$fd2b3ae2ecea5570$var$zt(a, "filterMap", e, [
                $fd2b3ae2ecea5570$var$Le(),
                $fd2b3ae2ecea5570$var$_e((e)=>!$fd2b3ae2ecea5570$var$$e(e), 1)
            ]),
        prepend (e) {
            let t = $fd2b3ae2ecea5570$export$c30017717ce2168e("* \u2192 " + a.shortName, {
                parent: $fd2b3ae2ecea5570$var$V(a)
            });
            return $fd2b3ae2ecea5570$var$d("eventPrepend", $fd2b3ae2ecea5570$var$L(t)), $fd2b3ae2ecea5570$var$wt(t, a, [
                $fd2b3ae2ecea5570$var$Le()
            ], "prepend", e), $fd2b3ae2ecea5570$var$xt(a, t), t;
        }
    });
    return null != r && r.domain && r.domain.hooks.event(l), $fd2b3ae2ecea5570$var$K(l, "id", l.graphite.id), $fd2b3ae2ecea5570$var$ye(l.graphite), l;
}
function $fd2b3ae2ecea5570$var$c(e, a, n, i) {
    return $fd2b3ae2ecea5570$var$Ce(n, a, "first argument"), $fd2b3ae2ecea5570$var$r($fd2b3ae2ecea5570$var$xe(i), "second argument should be a function"), $fd2b3ae2ecea5570$var$se(!$fd2b3ae2ecea5570$var$J(e, "derived"), `${a} in derived store`, `${a} in store created via createStore`), $fd2b3ae2ecea5570$var$t(Array.isArray(n) ? n : [
        n
    ], (t)=>{
        e.off(t), $fd2b3ae2ecea5570$var$U(e).set(t, $fd2b3ae2ecea5570$var$kt($fd2b3ae2ecea5570$var$jt(t, e, "on", $fd2b3ae2ecea5570$var$Oe, i)));
    }), e;
}
function $fd2b3ae2ecea5570$export$f51a9068ac82ea43(e, a) {
    let o = $fd2b3ae2ecea5570$var$gt(a), l = $fd2b3ae2ecea5570$var$Be(e), s = $fd2b3ae2ecea5570$export$c30017717ce2168e({
        named: "updates",
        derived: 1
    });
    $fd2b3ae2ecea5570$var$d("storeBase", l);
    let f = l.id, m = {
        subscribers: new Map,
        updates: s,
        defaultState: e,
        stateRef: l,
        getState () {
            let e, t = l;
            if ($fd2b3ae2ecea5570$var$nt) {
                let t = $fd2b3ae2ecea5570$var$nt;
                for(; t && !t.reg[f];)t = $fd2b3ae2ecea5570$var$V(t);
                t && (e = t);
            }
            return !e && $fd2b3ae2ecea5570$var$et && ($fd2b3ae2ecea5570$var$pt($fd2b3ae2ecea5570$var$et, l, 1), e = $fd2b3ae2ecea5570$var$et), e && (t = e.reg[f]), $fd2b3ae2ecea5570$var$We(t);
        },
        setState: (e)=>$fd2b3ae2ecea5570$export$9a7f3579b2beee84({
                target: m,
                params: e,
                defer: 1,
                scope: $fd2b3ae2ecea5570$var$et
            }),
        reset: (...e)=>($fd2b3ae2ecea5570$var$t(e, (e)=>$fd2b3ae2ecea5570$var$c(m, ".reset", e, ()=>m.defaultState)), m),
        on: (e, t)=>$fd2b3ae2ecea5570$var$c(m, ".on", e, t),
        off (e) {
            let t = $fd2b3ae2ecea5570$var$U(m).get(e);
            return t && (t(), $fd2b3ae2ecea5570$var$U(m).delete(e)), m;
        },
        map (e, t) {
            let r, a;
            $fd2b3ae2ecea5570$var$Me(e) && (r = e, e = e.fn), $fd2b3ae2ecea5570$var$se($fd2b3ae2ecea5570$var$$e(t), "second argument of store.map", "updateFilter");
            let n = m.getState();
            $fd2b3ae2ecea5570$var$be() ? a = null : $fd2b3ae2ecea5570$var$$e(n) || (a = e(n, t));
            let i = $fd2b3ae2ecea5570$export$f51a9068ac82ea43(a, {
                name: `${m.shortName} \u2192 *`,
                derived: 1,
                and: r
            }), o = $fd2b3ae2ecea5570$var$jt(m, i, $fd2b3ae2ecea5570$var$_, $fd2b3ae2ecea5570$var$Ie, e);
            return $fd2b3ae2ecea5570$var$He($fd2b3ae2ecea5570$var$W(i), {
                type: $fd2b3ae2ecea5570$var$_,
                fn: e,
                from: l
            }), $fd2b3ae2ecea5570$var$W(i).noInit = 1, $fd2b3ae2ecea5570$var$d("storeMap", l, o), i;
        },
        watch (e, t) {
            if (!t || !$fd2b3ae2ecea5570$var$X(e)) {
                let t = $fd2b3ae2ecea5570$var$Mt(m, e);
                return $fd2b3ae2ecea5570$var$d("storeWatch", l, e) || e(m.getState()), t;
            }
            return $fd2b3ae2ecea5570$var$r($fd2b3ae2ecea5570$var$xe(t), "second argument should be a function"), e.watch((e)=>t(m.getState(), e));
        }
    }, g = $fd2b3ae2ecea5570$var$$t("store", m, o), h = m.defaultConfig.updateFilter;
    m.graphite = $fd2b3ae2ecea5570$export$270e7ba5936d3c48({
        scope: {
            state: l,
            fn: h
        },
        node: [
            $fd2b3ae2ecea5570$var$_e((e, t, r)=>(r.scope && !r.scope.reg[l.id] && (r.b = 1), e)),
            $fd2b3ae2ecea5570$var$Pe(l),
            $fd2b3ae2ecea5570$var$_e((e, t, { a: r, b: a })=>!$fd2b3ae2ecea5570$var$$e(e) && (e !== r || a), 1),
            h && $fd2b3ae2ecea5570$var$Le($fd2b3ae2ecea5570$var$Ie, 1),
            $fd2b3ae2ecea5570$var$Re({
                from: $fd2b3ae2ecea5570$var$P,
                target: l
            })
        ],
        child: s,
        meta: {
            ...g,
            defaultState: e
        },
        regional: 1
    }), $fd2b3ae2ecea5570$var$K(m, "id", m.graphite.id), $fd2b3ae2ecea5570$var$K(m, "rootStateRefId", f);
    let y = $fd2b3ae2ecea5570$var$J(m, "serialize"), b = $fd2b3ae2ecea5570$var$J(m, "derived"), v = "ignore" === y, k = $fd2b3ae2ecea5570$var$J(m, "sid");
    return k && ($fd2b3ae2ecea5570$var$K(m, "storeChange", 1), l.sid = k), k || v || b || $fd2b3ae2ecea5570$var$K(m, "warnSerialize", 1), $fd2b3ae2ecea5570$var$r(b || !$fd2b3ae2ecea5570$var$$e(e), "current state can't be undefined, use null instead"), $fd2b3ae2ecea5570$var$we(m, [
        s
    ]), null != o && o.domain && o.domain.hooks.store(m), b || (m.reinit = $fd2b3ae2ecea5570$export$c30017717ce2168e({
        named: "reinit"
    }), m.reset(m.reinit)), l.meta = m.graphite.meta, $fd2b3ae2ecea5570$var$ye(m.graphite), m;
}
function $fd2b3ae2ecea5570$export$1be1fc439b849fdf(...e) {
    let t, a, n;
    [e, n] = $fd2b3ae2ecea5570$var$f(e);
    let i, o, l, s = e[e.length - 1];
    if ($fd2b3ae2ecea5570$var$xe(s) ? (a = e.slice(0, -1), t = s) : a = e, 1 === a.length) {
        let e = a[0];
        $fd2b3ae2ecea5570$var$Z(e) || (i = e, o = 1);
    }
    if (!o && (i = a, t)) {
        l = 1;
        let e = t;
        t = (t)=>e(...t);
    }
    return $fd2b3ae2ecea5570$var$r($fd2b3ae2ecea5570$var$Me(i), "shape should be an object"), $fd2b3ae2ecea5570$var$Ct(Array.isArray(i), !l, i, n, t);
}
function $fd2b3ae2ecea5570$export$e9d45223cdf1e997(...e) {
    return $fd2b3ae2ecea5570$var$se(0, "createStoreObject", "combine"), $fd2b3ae2ecea5570$export$1be1fc439b849fdf(...e);
}
function $fd2b3ae2ecea5570$var$h() {
    let e = {};
    return e.req = new Promise((t, r)=>{
        e.rs = t, e.rj = r;
    }), e.req.catch(()=>{}), e;
}
function $fd2b3ae2ecea5570$export$7ea7134f704deda4(e, t = {}) {
    let a = $fd2b3ae2ecea5570$var$gt($fd2b3ae2ecea5570$var$xe(e) ? {
        handler: e
    } : e, t), o = $fd2b3ae2ecea5570$export$c30017717ce2168e($fd2b3ae2ecea5570$var$xe(e) ? {
        handler: e
    } : e, {
        ...t,
        actualOp: "effect"
    }), l = $fd2b3ae2ecea5570$var$L(o);
    $fd2b3ae2ecea5570$var$K(l, "op", o.kind = "effect"), o.use = (e)=>($fd2b3ae2ecea5570$var$r($fd2b3ae2ecea5570$var$xe(e), ".use argument should be a function"), g.scope.handler = e, o), o.use.getCurrent = ()=>g.scope.handler;
    let s = o.finally = $fd2b3ae2ecea5570$export$c30017717ce2168e({
        named: "finally",
        derived: 1
    }), f = o.done = s.filterMap({
        named: "done",
        fn ({ status: e, params: t, result: r }) {
            if ("done" === e) return {
                params: t,
                result: r
            };
        }
    }), d = o.fail = s.filterMap({
        named: "fail",
        fn ({ status: e, params: t, error: r }) {
            if ("fail" === e) return {
                params: t,
                error: r
            };
        }
    }), c = o.doneData = f.map({
        named: "doneData",
        fn: ({ result: e })=>e
    }), m = o.failData = d.map({
        named: "failData",
        fn: ({ error: e })=>e
    }), g = $fd2b3ae2ecea5570$export$270e7ba5936d3c48({
        scope: {
            handler: o.defaultConfig.handler || (()=>$fd2b3ae2ecea5570$var$r(0, `no handler used in ${o.getType()}`))
        },
        node: [
            $fd2b3ae2ecea5570$var$_e((e, t, r)=>{
                let a = t.handler, n = $fd2b3ae2ecea5570$var$G(r);
                if (n) {
                    let e = n.handlers.unitMap.get(o) || n.handlers.sidMap[o.sid];
                    e && (a = e);
                }
                return e.handler = a, e;
            }, 0, 1),
            $fd2b3ae2ecea5570$var$_e(({ params: e, req: t, handler: r, args: a = [
                e
            ] }, n, i)=>{
                let o = $fd2b3ae2ecea5570$var$It(i), l = $fd2b3ae2ecea5570$var$Ot(e, t, 1, s, i, o), f = $fd2b3ae2ecea5570$var$Ot(e, t, 0, s, i, o), [d, u] = $fd2b3ae2ecea5570$var$At(r, f, a);
                d && ($fd2b3ae2ecea5570$var$Me(u) && $fd2b3ae2ecea5570$var$xe(u.then) ? u.then(l, f) : l(u));
            }, 0, 1)
        ],
        meta: {
            op: "fx",
            fx: "runner"
        }
    });
    l.scope.runner = g, $fd2b3ae2ecea5570$var$le(l.seq, $fd2b3ae2ecea5570$var$_e((e, { runner: t }, r)=>{
        let a = $fd2b3ae2ecea5570$var$V(r) ? {
            params: e,
            req: {
                rs (e) {},
                rj (e) {}
            }
        } : e;
        return r.meta || (r.meta = {
            fxID: $fd2b3ae2ecea5570$var$me()
        }), $fd2b3ae2ecea5570$export$9a7f3579b2beee84({
            target: t,
            params: a,
            defer: 1,
            scope: $fd2b3ae2ecea5570$var$G(r),
            meta: r.meta
        }), a.params;
    }, 0, 1)), o.create = (e)=>{
        let t = $fd2b3ae2ecea5570$var$h(), r = {
            params: e,
            req: t
        };
        if ($fd2b3ae2ecea5570$var$et && !$fd2b3ae2ecea5570$var$rt) {
            let e = $fd2b3ae2ecea5570$var$et;
            t.req.finally(()=>{
                $fd2b3ae2ecea5570$var$ot(e);
            }).catch(()=>{});
        }
        return $fd2b3ae2ecea5570$export$9a7f3579b2beee84({
            target: o,
            params: r,
            scope: $fd2b3ae2ecea5570$var$et
        }), t.req;
    };
    let y = o.inFlight = $fd2b3ae2ecea5570$export$f51a9068ac82ea43(0, {
        serialize: "ignore",
        named: ($fd2b3ae2ecea5570$var$J(o, "name") || o.graphite.id) + ".inFlight"
    }).on(o, (e)=>e + 1).on(s, (e)=>e - 1).map({
        fn: (e)=>e,
        named: "inFlight"
    });
    $fd2b3ae2ecea5570$var$K(s, "needFxCounter", "dec"), $fd2b3ae2ecea5570$var$K(o, "needFxCounter", 1);
    let b = o.pending = y.map({
        fn: (e)=>e > 0,
        named: "pending"
    });
    return $fd2b3ae2ecea5570$var$we(o, [
        s,
        f,
        d,
        c,
        m,
        b,
        y
    ]), null != a && a.domain && a.domain.hooks.effect(o), o;
}
function $fd2b3ae2ecea5570$export$5ddf9e484e541d6f(e) {
    let t;
    [e, t] = $fd2b3ae2ecea5570$var$f(e, 1);
    let { source: r, effect: a, mapParams: n } = e, o = $fd2b3ae2ecea5570$export$7ea7134f704deda4(e, t);
    $fd2b3ae2ecea5570$var$K(o, "attached", 1);
    let l, { runner: d } = $fd2b3ae2ecea5570$var$L(o).scope, u = $fd2b3ae2ecea5570$var$_e((e, t, a)=>{
        let l, { params: s, req: f, handler: d } = e, u = o.finally, c = $fd2b3ae2ecea5570$var$It(a), p = $fd2b3ae2ecea5570$var$Ot(s, f, 0, u, a, c), m = a.a, g = $fd2b3ae2ecea5570$var$te(d), h = 1;
        if (n ? [h, l] = $fd2b3ae2ecea5570$var$At(n, p, [
            s,
            m
        ]) : l = r && g ? m : s, h) {
            if (!g) return e.args = [
                m,
                l
            ], 1;
            $fd2b3ae2ecea5570$export$9a7f3579b2beee84({
                target: d,
                params: {
                    params: l,
                    req: {
                        rs: $fd2b3ae2ecea5570$var$Ot(s, f, 1, u, a, c),
                        rj: p
                    }
                },
                page: a.page,
                defer: 1,
                meta: a.meta
            });
        }
    }, 1, 1);
    if (r) {
        let e;
        $fd2b3ae2ecea5570$var$Z(r) ? (e = r, $fd2b3ae2ecea5570$var$we(e, [
            o
        ])) : (e = $fd2b3ae2ecea5570$export$1be1fc439b849fdf(r), $fd2b3ae2ecea5570$var$we(o, [
            e
        ])), l = [
            $fd2b3ae2ecea5570$var$Pe($fd2b3ae2ecea5570$var$W(e)),
            u
        ];
    } else l = [
        u
    ];
    d.seq.splice(1, 0, ...l), o.use(a);
    let c = $fd2b3ae2ecea5570$var$V(a);
    return c && (Object.assign($fd2b3ae2ecea5570$var$Q(o), $fd2b3ae2ecea5570$var$s(o.shortName, c)), o.defaultConfig.parent = c), $fd2b3ae2ecea5570$var$xt(a, o, "effect"), o;
}
function $fd2b3ae2ecea5570$export$9cdc2b9a8d94c842(...t) {
    let [[r, a], n] = $fd2b3ae2ecea5570$var$f(t), i = {};
    return $fd2b3ae2ecea5570$var$e(a, (e, t)=>{
        let a = i[t] = $fd2b3ae2ecea5570$export$c30017717ce2168e(t, {
            parent: $fd2b3ae2ecea5570$var$V(r),
            config: n
        });
        r.on(a, e), $fd2b3ae2ecea5570$var$xt(r, a);
    }), i;
}
function $fd2b3ae2ecea5570$export$d4fc37724c119bb4(r, a) {
    let o = $fd2b3ae2ecea5570$var$gt({
        or: a,
        and: "string" == typeof r ? {
            name: r
        } : r
    }), l = $fd2b3ae2ecea5570$export$270e7ba5936d3c48({
        family: {
            type: "domain"
        },
        regional: 1,
        parent: (null == o ? void 0 : o.domain) || (null == o ? void 0 : o.parent)
    }), s = {
        history: {},
        graphite: l,
        hooks: {}
    };
    l.meta = $fd2b3ae2ecea5570$var$$t("domain", s, {
        parent: (null == o ? void 0 : o.domain) || (null == o ? void 0 : o.parent),
        or: o
    }), $fd2b3ae2ecea5570$var$e({
        Event: $fd2b3ae2ecea5570$export$c30017717ce2168e,
        Effect: $fd2b3ae2ecea5570$export$7ea7134f704deda4,
        Store: $fd2b3ae2ecea5570$export$f51a9068ac82ea43,
        Domain: $fd2b3ae2ecea5570$export$d4fc37724c119bb4
    }, (e, r)=>{
        let a = r.toLowerCase(), n = $fd2b3ae2ecea5570$export$c30017717ce2168e({
            named: `on${r}`
        });
        s.hooks[a] = n;
        let o = new Set;
        s.history[`${a}s`] = o, n.create = (e)=>($fd2b3ae2ecea5570$export$9a7f3579b2beee84(n, e), e), $fd2b3ae2ecea5570$var$le($fd2b3ae2ecea5570$var$L(n).seq, $fd2b3ae2ecea5570$var$_e((e, t, r)=>(r.scope = null, e))), n.watch((e)=>{
            $fd2b3ae2ecea5570$var$we(s, [
                e
            ]), o.add(e), e.ownerSet || (e.ownerSet = o), $fd2b3ae2ecea5570$var$V(e) || (e.parent = s);
        }), $fd2b3ae2ecea5570$var$we(s, [
            n
        ]), s[`onCreate${r}`] = (e)=>($fd2b3ae2ecea5570$var$t(o, e), n.watch(e)), s[`create${r}`] = s[a] = (t, r)=>{
            let a = $fd2b3ae2ecea5570$var$gt({
                and: r,
                or: t
            });
            return null != a && a.domain ? e(t, r) : n(e(t, {
                parent: s,
                or: a
            }));
        };
    });
    let f = $fd2b3ae2ecea5570$var$V(s);
    return f && $fd2b3ae2ecea5570$var$e(s.hooks, (e, t)=>$fd2b3ae2ecea5570$var$wt(e, f.hooks[t])), null != o && o.domain && o.domain.hooks.domain(s), s;
}
function $fd2b3ae2ecea5570$export$4b2432e2d8723823(e) {
    $fd2b3ae2ecea5570$var$ze(e);
    let t = $fd2b3ae2ecea5570$var$E in e ? e[$fd2b3ae2ecea5570$var$E]() : e;
    $fd2b3ae2ecea5570$var$r(t.subscribe, "expect observable to have .subscribe");
    let a = $fd2b3ae2ecea5570$export$c30017717ce2168e(), n = $fd2b3ae2ecea5570$var$kt(a);
    return t.subscribe({
        next: a,
        error: n,
        complete: n
    }), a;
}
function $fd2b3ae2ecea5570$export$4950aa0f605343fb(e, t) {
    $fd2b3ae2ecea5570$var$Ce(e, "merge", "first argument");
    let r = $fd2b3ae2ecea5570$export$c30017717ce2168e({
        name: $fd2b3ae2ecea5570$var$o(e, "merge"),
        derived: 1,
        and: t
    });
    return $fd2b3ae2ecea5570$var$wt(e, r, [], "merge"), r;
}
function $fd2b3ae2ecea5570$var$M(e, a) {
    let n = 0;
    return $fd2b3ae2ecea5570$var$t($fd2b3ae2ecea5570$var$Nt, (t)=>{
        t in e && ($fd2b3ae2ecea5570$var$r(null != e[t], $fd2b3ae2ecea5570$var$Dt(a, t)), n = 1);
    }), n;
}
function $fd2b3ae2ecea5570$export$4812e460280c6ef2(...e) {
    let t, r, a, n, [[i, o, l], s] = $fd2b3ae2ecea5570$var$f(e), d = 1;
    return $fd2b3ae2ecea5570$var$$e(o) && $fd2b3ae2ecea5570$var$Me(i) && $fd2b3ae2ecea5570$var$M(i, "sample") && (o = i.clock, l = i.fn, d = !i.greedy, n = i.filter, t = i.target, r = i.name, a = i.sid, i = i.source), $fd2b3ae2ecea5570$var$Rt("sample", o, i, n, t, l, r, s, d, 1, 0, a);
}
function $fd2b3ae2ecea5570$export$864d727b48066337(...e) {
    let [[t, r], a] = $fd2b3ae2ecea5570$var$f(e);
    return r || (r = t, t = r.source), $fd2b3ae2ecea5570$var$M(r, "guard"), $fd2b3ae2ecea5570$var$Rt("guard", r.clock, t, r.filter, r.target, null, r.name, a, !r.greedy, 0, 1);
}
function $fd2b3ae2ecea5570$export$db239ef39aadc7fe(t, r, a) {
    if ($fd2b3ae2ecea5570$var$Z(t)) return $fd2b3ae2ecea5570$var$se(0, "restore($store)"), t;
    if ($fd2b3ae2ecea5570$var$ee(t) || $fd2b3ae2ecea5570$var$te(t)) {
        let e = $fd2b3ae2ecea5570$var$V(t), n = $fd2b3ae2ecea5570$export$f51a9068ac82ea43(r, {
            parent: e,
            name: t.shortName,
            and: a
        });
        return $fd2b3ae2ecea5570$var$wt($fd2b3ae2ecea5570$var$te(t) ? t.doneData : t, n), e && e.hooks.store(n), n;
    }
    let n = Array.isArray(t) ? [] : {};
    return $fd2b3ae2ecea5570$var$e(t, (e, t)=>n[t] = $fd2b3ae2ecea5570$var$Z(e) ? e : $fd2b3ae2ecea5570$export$f51a9068ac82ea43(e, {
            name: t
        })), n;
}
function $fd2b3ae2ecea5570$export$65980d18b75784e2(...t) {
    let a, i, o = "split", [[l, s], c] = $fd2b3ae2ecea5570$var$f(t), p = !s;
    p && (a = l.cases, s = l.match, i = l.clock, l = l.source);
    let m = $fd2b3ae2ecea5570$var$Z(s), g = !$fd2b3ae2ecea5570$var$X(s) && $fd2b3ae2ecea5570$var$xe(s), h = !m && !g && $fd2b3ae2ecea5570$var$Me(s);
    $fd2b3ae2ecea5570$var$r($fd2b3ae2ecea5570$var$X(l), "source must be a unit"), a || (a = {}), p ? $fd2b3ae2ecea5570$var$e(a, (e, t)=>$fd2b3ae2ecea5570$var$Ae(o, e, `cases.${t}`)) : ($fd2b3ae2ecea5570$var$r(h, "match should be an object"), $fd2b3ae2ecea5570$var$e(s, (e, t)=>a[t] = $fd2b3ae2ecea5570$export$c30017717ce2168e({
            derived: 1,
            named: `cases.${t}`,
            and: c
        })), a.__ = $fd2b3ae2ecea5570$export$c30017717ce2168e({
        derived: 1,
        named: "cases.__",
        and: c
    }));
    let y, b = new Set([].concat(l, i || [], Object.values(a))), v = Object.keys(m || g ? a : s);
    if (m || g) m && b.add(s), y = [
        m && $fd2b3ae2ecea5570$var$Pe($fd2b3ae2ecea5570$var$W(s), 0, 1),
        $fd2b3ae2ecea5570$var$Fe({
            safe: m,
            filter: 1,
            pure: !m,
            fn (e, t, r) {
                let a = String(m ? r.a : s(e));
                $fd2b3ae2ecea5570$var$_t(t, $fd2b3ae2ecea5570$var$ie(v, a) ? a : "__", e, r);
            }
        })
    ];
    else if (h) {
        let t = $fd2b3ae2ecea5570$var$Be({});
        t.type = "shape";
        let r, a = [];
        $fd2b3ae2ecea5570$var$e(s, (e, n)=>{
            if ($fd2b3ae2ecea5570$var$X(e)) {
                r = 1, $fd2b3ae2ecea5570$var$le(a, n), b.add(e);
                let i = $fd2b3ae2ecea5570$var$wt(e, [], [
                    $fd2b3ae2ecea5570$var$Pe(t),
                    $fd2b3ae2ecea5570$var$_e((e, t, { a: r })=>r[n] = e)
                ]);
                if ($fd2b3ae2ecea5570$var$Z(e)) {
                    t.current[n] = e.getState();
                    let r = $fd2b3ae2ecea5570$var$W(e);
                    $fd2b3ae2ecea5570$var$He(t, {
                        from: r,
                        field: n,
                        type: "field"
                    }), $fd2b3ae2ecea5570$var$d("splitMatchStore", r, i);
                }
            }
        }), r && $fd2b3ae2ecea5570$var$d("splitBase", t), y = [
            r && $fd2b3ae2ecea5570$var$Pe(t, 0, 1),
            $fd2b3ae2ecea5570$var$Le((e, t, r)=>{
                for(let n = 0; n < v.length; n++){
                    let i = v[n];
                    if ($fd2b3ae2ecea5570$var$ie(a, i) ? r.a[i] : s[i](e)) return void $fd2b3ae2ecea5570$var$_t(t, i, e, r);
                }
                $fd2b3ae2ecea5570$var$_t(t, "__", e, r);
            }, 1)
        ];
    } else $fd2b3ae2ecea5570$var$r(0, "expect match to be unit, function or object");
    let k = $fd2b3ae2ecea5570$export$270e7ba5936d3c48({
        meta: {
            op: o
        },
        parent: i ? [] : l,
        scope: a,
        node: y,
        family: {
            owners: Array.from(b)
        },
        regional: 1
    });
    if (i && $fd2b3ae2ecea5570$var$Rt(o, i, l, null, k, null, o, c, 0, 0, 0), !p) return a;
}
function $fd2b3ae2ecea5570$export$bcf8c46c380b2b4c(e, { scope: t, params: r } = {}) {
    if (!$fd2b3ae2ecea5570$var$X(e)) return Promise.reject(new Error("first argument should be unit"));
    if (!($fd2b3ae2ecea5570$var$te(e) || $fd2b3ae2ecea5570$var$ee(e) || $fd2b3ae2ecea5570$var$Z(e) || $fd2b3ae2ecea5570$var$ae(e))) return Promise.reject(new Error("first argument accepts only effects, events, stores or scopes"));
    $fd2b3ae2ecea5570$var$ae(e) && (t = e);
    let a = $fd2b3ae2ecea5570$var$h();
    a.parentFork = $fd2b3ae2ecea5570$var$et;
    let { fxCount: n } = t;
    $fd2b3ae2ecea5570$var$le(n.scope.defers, a);
    let o = [], l = [];
    return $fd2b3ae2ecea5570$var$ae(e) || ($fd2b3ae2ecea5570$var$le(o, e), $fd2b3ae2ecea5570$var$le(l, $fd2b3ae2ecea5570$var$te(e) ? {
        params: r,
        req: {
            rs (e) {
                a.value = {
                    status: "done",
                    value: e
                };
            },
            rj (e) {
                a.value = {
                    status: "fail",
                    value: e
                };
            }
        }
    } : r)), $fd2b3ae2ecea5570$var$le(o, n), $fd2b3ae2ecea5570$var$le(l, null), $fd2b3ae2ecea5570$export$9a7f3579b2beee84({
        target: o,
        params: l,
        scope: t
    }), a.req;
}
function $fd2b3ae2ecea5570$var$A(e, r, a) {
    let n = [];
    (function e(i) {
        $fd2b3ae2ecea5570$var$ie(n, i) || ($fd2b3ae2ecea5570$var$le(n, i), "store" === $fd2b3ae2ecea5570$var$J(i, "op") && (a || $fd2b3ae2ecea5570$var$J(i, "sid")) && r(i, $fd2b3ae2ecea5570$var$J(i, "sid")), $fd2b3ae2ecea5570$var$t(i.next, e), $fd2b3ae2ecea5570$var$t($fd2b3ae2ecea5570$var$T(i), e), $fd2b3ae2ecea5570$var$t($fd2b3ae2ecea5570$var$B(i), e));
    })(e);
}
function $fd2b3ae2ecea5570$var$I(e, a) {
    let n = Array.isArray(e) ? new Map(e) : e, i = new Map, o = 0;
    if (n instanceof Map) {
        let e = {};
        return $fd2b3ae2ecea5570$var$t(n, (t, n)=>{
            $fd2b3ae2ecea5570$var$r($fd2b3ae2ecea5570$var$X(n), "Map key should be a unit"), a && a(n, t), n.sid && (n.sid in e && (o = 1), e[n.sid] = t), i.set(n, t);
        }), {
            sidMap: e,
            unitMap: i,
            hasSidDoubles: o
        };
    }
    return {
        sidMap: n,
        unitMap: i
    };
}
function $fd2b3ae2ecea5570$export$7a5058c6b79333e0(e, a) {
    let i, o = e;
    $fd2b3ae2ecea5570$var$re(e) && (i = e, o = a);
    let l = ((e)=>{
        let r = $fd2b3ae2ecea5570$export$270e7ba5936d3c48({
            scope: {
                defers: [],
                inFlight: 0,
                fxID: 0
            },
            node: [
                $fd2b3ae2ecea5570$var$_e((e, t, r)=>{
                    $fd2b3ae2ecea5570$var$V(r) ? "dec" === $fd2b3ae2ecea5570$var$J($fd2b3ae2ecea5570$var$V(r).node, "needFxCounter") ? t.inFlight -= 1 : (t.inFlight += 1, t.fxID += 1) : t.fxID += 1;
                }),
                $fd2b3ae2ecea5570$var$Fe({
                    priority: "sampler",
                    batch: 1
                }),
                $fd2b3ae2ecea5570$var$_e((e, r)=>{
                    let { defers: a, fxID: n } = r;
                    r.inFlight > 0 || 0 === a.length || Promise.resolve().then(()=>{
                        r.fxID === n && $fd2b3ae2ecea5570$var$t(a.splice(0, a.length), (e)=>{
                            $fd2b3ae2ecea5570$var$ot(e.parentFork), e.rs(e.value);
                        });
                    });
                }, 0, 1)
            ]
        }), a = $fd2b3ae2ecea5570$export$270e7ba5936d3c48({
            node: [
                $fd2b3ae2ecea5570$var$_e((e, t, r)=>{
                    let a = $fd2b3ae2ecea5570$var$V(r);
                    if (a) {
                        let t = a.node;
                        if (!$fd2b3ae2ecea5570$var$J(t, "isCombine") || $fd2b3ae2ecea5570$var$V(a) && "combine" !== $fd2b3ae2ecea5570$var$J($fd2b3ae2ecea5570$var$V(a).node, "op")) {
                            let a = $fd2b3ae2ecea5570$var$G(r), n = t.scope.state.id, i = $fd2b3ae2ecea5570$var$J(t, "sid");
                            a.sidIdMap[i] = n, a.values.sidMap[i] = e;
                            let o = $fd2b3ae2ecea5570$var$J(t, "serialize");
                            o && a.sidSerializeSettings.set(i, "ignore" === o ? {
                                ignore: 1
                            } : {
                                ignore: 0,
                                write: o.write
                            });
                        }
                    }
                })
            ]
        }), i = $fd2b3ae2ecea5570$export$270e7ba5936d3c48({
            node: [
                $fd2b3ae2ecea5570$var$_e((e, t, r)=>{
                    let a = $fd2b3ae2ecea5570$var$G(r);
                    if (a) {
                        let e = $fd2b3ae2ecea5570$var$V(r);
                        e && (!$fd2b3ae2ecea5570$var$J(e.node, "isCombine") || $fd2b3ae2ecea5570$var$V(e) && "combine" !== $fd2b3ae2ecea5570$var$J($fd2b3ae2ecea5570$var$V(e).node, "op")) && (a.warnSerialize = 1);
                    }
                })
            ]
        }), o = {
            cloneOf: e,
            reg: {},
            values: {
                sidMap: {},
                idMap: {}
            },
            sidIdMap: {},
            sidSerializeSettings: new Map,
            getState (e) {
                if ("current" in e) return $fd2b3ae2ecea5570$var$dt($fd2b3ae2ecea5570$var$nt, o, null, e).current;
                let t = $fd2b3ae2ecea5570$var$L(e);
                return $fd2b3ae2ecea5570$var$dt($fd2b3ae2ecea5570$var$nt, o, t, t.scope.state, 1).current;
            },
            kind: "scope",
            graphite: $fd2b3ae2ecea5570$export$270e7ba5936d3c48({
                family: {
                    type: "domain",
                    links: [
                        r,
                        a,
                        i
                    ]
                },
                meta: {
                    unit: "fork"
                },
                scope: {
                    forkInFlightCounter: r
                }
            }),
            additionalLinks: {},
            handlers: {
                sidMap: {},
                unitMap: new Map
            },
            fxCount: r,
            storeChange: a,
            warnSerializeNode: i,
            activeEffects: []
        };
        return o;
    })(i);
    if (o) {
        let e = o.scope;
        if (e) {
            let r = e.activeEffects;
            e.activeEffects = [], l.activeEffects = r, $fd2b3ae2ecea5570$var$t(r, (e)=>e.ref = l);
        }
        if (o.values) {
            let { sidMap: e, unitMap: a, hasSidDoubles: n } = $fd2b3ae2ecea5570$var$I(o.values, (e)=>$fd2b3ae2ecea5570$var$r($fd2b3ae2ecea5570$var$Z(e), "Values map can contain only stores as keys"));
            Object.assign(l.values.sidMap, e), $fd2b3ae2ecea5570$var$t(a, (e, t)=>{
                l.values.idMap[t.stateRef.id] = e;
            }), l.fromSerialize = !(Array.isArray(o.values) || o.values instanceof Map), l.hasSidDoubles = n;
        }
        o.handlers && (l.handlers = $fd2b3ae2ecea5570$var$I(o.handlers, (e)=>$fd2b3ae2ecea5570$var$r($fd2b3ae2ecea5570$var$te(e), "Handlers map can contain only effects as keys")));
    }
    return l;
}
function $fd2b3ae2ecea5570$export$fa8d919ba61d84db(e, { values: a }) {
    $fd2b3ae2ecea5570$var$r($fd2b3ae2ecea5570$var$Me(a), "values property should be an object");
    let { sidMap: n, unitMap: o } = $fd2b3ae2ecea5570$var$I(a), l = Object.getOwnPropertyNames(n), s = {};
    $fd2b3ae2ecea5570$var$t(o, (e, t)=>{
        s[t.stateRef.id] = t;
    });
    let f, d, u, c = [], p = [];
    $fd2b3ae2ecea5570$var$ae(e) ? (f = e, u = 1, $fd2b3ae2ecea5570$var$r(f.cloneOf, "scope should be created from domain"), d = $fd2b3ae2ecea5570$var$L(f.cloneOf)) : $fd2b3ae2ecea5570$var$re(e) ? d = $fd2b3ae2ecea5570$var$L(e) : $fd2b3ae2ecea5570$var$r(0, "first argument of hydrate should be domain or scope"), $fd2b3ae2ecea5570$var$A(d, (e, t)=>{
        if (t && $fd2b3ae2ecea5570$var$ie(l, t)) {
            $fd2b3ae2ecea5570$var$le(c, e);
            let r = $fd2b3ae2ecea5570$var$J(e, "serialize");
            r && "ignore" !== r && (n[t] = r.read(n[t])), $fd2b3ae2ecea5570$var$le(p, n[t]);
        } else e.scope.state.id in s && ($fd2b3ae2ecea5570$var$le(c, e), $fd2b3ae2ecea5570$var$le(p, o.get(s[e.scope.state.id])));
    }, 1), $fd2b3ae2ecea5570$export$9a7f3579b2beee84({
        target: c,
        params: p,
        scope: f
    }), u && Object.assign(f.values.sidMap, n);
}
function $fd2b3ae2ecea5570$export$18f6b3f66cc08bf(e, { scope: t, safe: a } = {}) {
    $fd2b3ae2ecea5570$var$r(t || $fd2b3ae2ecea5570$var$et || a, "scopeBind cannot be called outside of forked .watch");
    let n = t || $fd2b3ae2ecea5570$var$et;
    return $fd2b3ae2ecea5570$var$te(e) ? (t)=>{
        let r = $fd2b3ae2ecea5570$var$h();
        return $fd2b3ae2ecea5570$export$9a7f3579b2beee84({
            target: e,
            params: {
                params: t,
                req: r
            },
            scope: n
        }), r.req;
    } : (t)=>($fd2b3ae2ecea5570$export$9a7f3579b2beee84({
            target: e,
            params: t,
            scope: n
        }), t);
}
function $fd2b3ae2ecea5570$export$dfdc1655ccc5b9cb(t, a = {}) {
    t.warnSerialize && console.error("There is a store without sid in this scope, its value is omitted"), $fd2b3ae2ecea5570$var$r(!t.hasSidDoubles, "duplicate sid found in this scope");
    let n = a.ignore ? a.ignore.map(({ sid: e })=>e) : [], i = {};
    return $fd2b3ae2ecea5570$var$e(t.values.sidMap, (e, r)=>{
        var a;
        if ($fd2b3ae2ecea5570$var$ie(n, r)) return;
        let o = t.sidIdMap[r], l = null !== (a = t.sidSerializeSettings.get(r)) && void 0 !== a ? a : {
            ignore: 0,
            write: $fd2b3ae2ecea5570$var$Lt
        };
        l.ignore || (i[r] = (0, l.write)(o && o in t.reg ? t.reg[o].current : e));
    }), "onlyChanges" in a && !a.onlyChanges && ($fd2b3ae2ecea5570$var$r(t.cloneOf, "scope should be created from domain"), $fd2b3ae2ecea5570$var$A($fd2b3ae2ecea5570$var$L(t.cloneOf), (e, r)=>{
        r in i || $fd2b3ae2ecea5570$var$ie(n, r) || $fd2b3ae2ecea5570$var$J(e, "isCombine") || "ignore" === $fd2b3ae2ecea5570$var$J(e, "serialize") || (i[r] = t.getState(e));
    })), i;
}
function $fd2b3ae2ecea5570$export$940333bc61f71f83({ unit: e, fn: t, scope: r }) {
    let a = [
        $fd2b3ae2ecea5570$export$35d34bc0ed591a92.run({
            fn: (e)=>t(e)
        })
    ];
    if (r) {
        let t = $fd2b3ae2ecea5570$export$270e7ba5936d3c48({
            node: a
        }), i = e.graphite.id, o = r.additionalLinks, l = o[i] || [];
        return o[i] = l, l.push(t), $fd2b3ae2ecea5570$var$F(()=>{
            let e = l.indexOf(t);
            -1 !== e && l.splice(e, 1), $fd2b3ae2ecea5570$export$51cfe97d637c237c(t);
        });
    }
    {
        let t = $fd2b3ae2ecea5570$export$270e7ba5936d3c48({
            node: a,
            parent: [
                e
            ],
            family: {
                owners: e
            }
        });
        return $fd2b3ae2ecea5570$var$F(()=>{
            $fd2b3ae2ecea5570$export$51cfe97d637c237c(t);
        });
    }
}
function $fd2b3ae2ecea5570$var$F(e) {
    let t = ()=>e();
    return t.unsubscribe = ()=>e(), t;
}
let $fd2b3ae2ecea5570$var$E = "undefined" != typeof Symbol && Symbol.observable || "@@observable", $fd2b3ae2ecea5570$var$_ = "map", $fd2b3ae2ecea5570$var$P = "stack", $fd2b3ae2ecea5570$var$L = (e)=>e.graphite || e, $fd2b3ae2ecea5570$var$T = (e)=>e.family.owners, $fd2b3ae2ecea5570$var$B = (e)=>e.family.links, $fd2b3ae2ecea5570$var$W = (e)=>e.stateRef, $fd2b3ae2ecea5570$var$H = (e)=>e.value, $fd2b3ae2ecea5570$var$U = (e)=>e.subscribers, $fd2b3ae2ecea5570$var$V = (e)=>e.parent, $fd2b3ae2ecea5570$var$G = (e)=>e.scope, $fd2b3ae2ecea5570$var$J = (e, t)=>$fd2b3ae2ecea5570$var$L(e).meta[t], $fd2b3ae2ecea5570$var$K = (e, t, r)=>$fd2b3ae2ecea5570$var$L(e).meta[t] = r, $fd2b3ae2ecea5570$var$Q = (e)=>e.compositeName, $fd2b3ae2ecea5570$var$X = (e)=>($fd2b3ae2ecea5570$var$xe(e) || $fd2b3ae2ecea5570$var$Me(e)) && "kind" in e;
const $fd2b3ae2ecea5570$var$Y = (e)=>(t)=>$fd2b3ae2ecea5570$var$X(t) && t.kind === e;
let $fd2b3ae2ecea5570$var$Z = $fd2b3ae2ecea5570$var$Y("store"), $fd2b3ae2ecea5570$var$ee = $fd2b3ae2ecea5570$var$Y("event"), $fd2b3ae2ecea5570$var$te = $fd2b3ae2ecea5570$var$Y("effect"), $fd2b3ae2ecea5570$var$re = $fd2b3ae2ecea5570$var$Y("domain"), $fd2b3ae2ecea5570$var$ae = $fd2b3ae2ecea5570$var$Y("scope");
var $fd2b3ae2ecea5570$export$226b3eccf92c9ed9 = {
    __proto__: null,
    unit: $fd2b3ae2ecea5570$var$X,
    store: $fd2b3ae2ecea5570$var$Z,
    event: $fd2b3ae2ecea5570$var$ee,
    effect: $fd2b3ae2ecea5570$var$te,
    domain: $fd2b3ae2ecea5570$var$re,
    scope: $fd2b3ae2ecea5570$var$ae,
    attached: (e)=>$fd2b3ae2ecea5570$var$te(e) && 1 == $fd2b3ae2ecea5570$var$J(e, "attached")
};
let $fd2b3ae2ecea5570$var$ie = (e, t)=>e.includes(t), $fd2b3ae2ecea5570$var$oe = (e, t)=>{
    let r = e.indexOf(t);
    -1 !== r && e.splice(r, 1);
}, $fd2b3ae2ecea5570$var$le = (e, t)=>e.push(t), $fd2b3ae2ecea5570$var$se = (e, t, r)=>!e && console.error(`${t} is deprecated${r ? `, use ${r} instead` : ""}`);
const $fd2b3ae2ecea5570$var$fe = ()=>{
    let e = 0;
    return ()=>"" + ++e;
};
let $fd2b3ae2ecea5570$var$de, $fd2b3ae2ecea5570$var$ue = $fd2b3ae2ecea5570$var$fe(), $fd2b3ae2ecea5570$var$ce = $fd2b3ae2ecea5570$var$fe(), $fd2b3ae2ecea5570$var$pe = $fd2b3ae2ecea5570$var$fe(), $fd2b3ae2ecea5570$var$me = $fd2b3ae2ecea5570$var$fe(), $fd2b3ae2ecea5570$export$7980e214724429d7 = (e)=>{
    $fd2b3ae2ecea5570$var$de = e;
}, $fd2b3ae2ecea5570$var$he = null, $fd2b3ae2ecea5570$var$ye = (e)=>{
    $fd2b3ae2ecea5570$var$de && $fd2b3ae2ecea5570$var$de(e, $fd2b3ae2ecea5570$var$he);
}, $fd2b3ae2ecea5570$var$be = ()=>$fd2b3ae2ecea5570$var$he && $fd2b3ae2ecea5570$var$he.template, $fd2b3ae2ecea5570$var$ve = (e)=>(e && $fd2b3ae2ecea5570$var$he && $fd2b3ae2ecea5570$var$he.sidRoot && (e = `${$fd2b3ae2ecea5570$var$he.sidRoot}|${e}`), e), $fd2b3ae2ecea5570$export$84070f57da009beb = ({ sid: e, name: t, loc: r, method: i, fn: o })=>$fd2b3ae2ecea5570$export$2f9294bfc17c771e($fd2b3ae2ecea5570$export$270e7ba5936d3c48({
        meta: {
            sidRoot: $fd2b3ae2ecea5570$var$ve(e),
            sid: e,
            name: t,
            loc: r,
            method: i,
            type: "factory"
        }
    }), o), $fd2b3ae2ecea5570$var$we = (e, r)=>{
    let a = $fd2b3ae2ecea5570$var$L(e);
    $fd2b3ae2ecea5570$var$t(r, (e)=>{
        let t = $fd2b3ae2ecea5570$var$L(e);
        "domain" !== a.family.type && (t.family.type = "crosslink"), $fd2b3ae2ecea5570$var$le($fd2b3ae2ecea5570$var$T(t), a), $fd2b3ae2ecea5570$var$le($fd2b3ae2ecea5570$var$B(a), t);
    });
}, $fd2b3ae2ecea5570$var$Se = (e = [])=>(Array.isArray(e) ? e : [
        e
    ]).flat().map($fd2b3ae2ecea5570$var$L), $fd2b3ae2ecea5570$var$Me = (e)=>"object" == typeof e && null !== e, $fd2b3ae2ecea5570$var$xe = (e)=>"function" == typeof e, $fd2b3ae2ecea5570$var$$e = (e)=>void 0 === e, $fd2b3ae2ecea5570$var$ze = (e)=>$fd2b3ae2ecea5570$var$r($fd2b3ae2ecea5570$var$Me(e) || $fd2b3ae2ecea5570$var$xe(e), "expect first argument be an object");
const $fd2b3ae2ecea5570$var$je = (e, t, a, n)=>$fd2b3ae2ecea5570$var$r(!(!$fd2b3ae2ecea5570$var$Me(e) && !$fd2b3ae2ecea5570$var$xe(e) || !("family" in e) && !("graphite" in e)), `${t}: expect ${a} to be a unit (store, event or effect)${n}`);
let $fd2b3ae2ecea5570$var$Ce = (e, r, a)=>{
    Array.isArray(e) ? $fd2b3ae2ecea5570$var$t(e, (e, t)=>$fd2b3ae2ecea5570$var$je(e, r, `${t} item of ${a}`, "")) : $fd2b3ae2ecea5570$var$je(e, r, a, " or array of units");
}, $fd2b3ae2ecea5570$var$Ae = (e, r, a = "target")=>$fd2b3ae2ecea5570$var$t($fd2b3ae2ecea5570$var$Se(r), (t)=>$fd2b3ae2ecea5570$var$se(!$fd2b3ae2ecea5570$var$J(t, "derived"), `${e}: derived unit in "${a}"`, "createEvent/createStore")), $fd2b3ae2ecea5570$var$Ie = (e, { fn: t }, { a: r })=>t(e, r), $fd2b3ae2ecea5570$var$Oe = (e, { fn: t }, { a: r })=>t(r, e), $fd2b3ae2ecea5570$var$qe = (e, { fn: t })=>t(e);
const $fd2b3ae2ecea5570$var$Ne = (e, t, r, a)=>{
    let n = {
        id: $fd2b3ae2ecea5570$var$ce(),
        type: e,
        data: t
    };
    return r && (n.order = {
        priority: r
    }, a && (n.order.barrierID = ++$fd2b3ae2ecea5570$var$De)), n;
};
let $fd2b3ae2ecea5570$var$De = 0, $fd2b3ae2ecea5570$var$Re = ({ from: e = "store", store: t, target: r, to: a = r ? "store" : $fd2b3ae2ecea5570$var$P, batch: n, priority: i })=>$fd2b3ae2ecea5570$var$Ne("mov", {
        from: e,
        store: t,
        to: a,
        target: r
    }, i, n), $fd2b3ae2ecea5570$var$Fe = ({ fn: e, batch: t, priority: r, safe: a = 0, filter: n = 0, pure: i = 0 })=>$fd2b3ae2ecea5570$var$Ne("compute", {
        fn: e,
        safe: a,
        filter: n,
        pure: i
    }, r, t), $fd2b3ae2ecea5570$var$Ee = ({ fn: e })=>$fd2b3ae2ecea5570$var$Fe({
        fn: e,
        priority: "effect"
    }), $fd2b3ae2ecea5570$var$_e = (e, t, r)=>$fd2b3ae2ecea5570$var$Fe({
        fn: e,
        safe: 1,
        filter: t,
        priority: r && "effect"
    }), $fd2b3ae2ecea5570$var$Pe = (e, t, r)=>$fd2b3ae2ecea5570$var$Re({
        store: e,
        to: t ? $fd2b3ae2ecea5570$var$P : "a",
        priority: r && "sampler",
        batch: 1
    }), $fd2b3ae2ecea5570$var$Le = (e = $fd2b3ae2ecea5570$var$qe, t)=>$fd2b3ae2ecea5570$var$Fe({
        fn: e,
        pure: 1,
        filter: t
    }), $fd2b3ae2ecea5570$export$35d34bc0ed591a92 = {
    mov: $fd2b3ae2ecea5570$var$Re,
    compute: $fd2b3ae2ecea5570$var$Fe,
    filter: ({ fn: e, pure: t })=>$fd2b3ae2ecea5570$var$Fe({
            fn: e,
            filter: 1,
            pure: t
        }),
    run: $fd2b3ae2ecea5570$var$Ee
}, $fd2b3ae2ecea5570$var$Be = (e)=>({
        id: $fd2b3ae2ecea5570$var$ce(),
        current: e
    }), $fd2b3ae2ecea5570$var$We = ({ current: e })=>e, $fd2b3ae2ecea5570$var$He = (e, t)=>{
    e.before || (e.before = []), $fd2b3ae2ecea5570$var$le(e.before, t);
}, $fd2b3ae2ecea5570$var$Ue = null;
const $fd2b3ae2ecea5570$var$Ve = (e, t)=>{
    if (!e) return t;
    if (!t) return e;
    let r;
    return (e.v.type === t.v.type && e.v.id > t.v.id || $fd2b3ae2ecea5570$var$Ye(e.v.type) > $fd2b3ae2ecea5570$var$Ye(t.v.type)) && (r = e, e = t, t = r), r = $fd2b3ae2ecea5570$var$Ve(e.r, t), e.r = e.l, e.l = r, e;
}, $fd2b3ae2ecea5570$var$Ge = [];
let $fd2b3ae2ecea5570$var$Je = 0;
for(; $fd2b3ae2ecea5570$var$Je < 6;)$fd2b3ae2ecea5570$var$le($fd2b3ae2ecea5570$var$Ge, {
    first: null,
    last: null,
    size: 0
}), $fd2b3ae2ecea5570$var$Je += 1;
const $fd2b3ae2ecea5570$var$Ke = ()=>{
    for(let e = 0; e < 6; e++){
        let t = $fd2b3ae2ecea5570$var$Ge[e];
        if (t.size > 0) {
            if (3 === e || 4 === e) {
                t.size -= 1;
                let e = $fd2b3ae2ecea5570$var$Ue.v;
                return $fd2b3ae2ecea5570$var$Ue = $fd2b3ae2ecea5570$var$Ve($fd2b3ae2ecea5570$var$Ue.l, $fd2b3ae2ecea5570$var$Ue.r), e;
            }
            1 === t.size && (t.last = null);
            let r = t.first;
            return t.first = r.r, t.size -= 1, r.v;
        }
    }
}, $fd2b3ae2ecea5570$var$Qe = (e, t, r, a, n, i, o)=>$fd2b3ae2ecea5570$var$Xe(0, {
        a: null,
        b: null,
        node: r,
        parent: a,
        value: n,
        page: t,
        scope: i,
        meta: o
    }, e), $fd2b3ae2ecea5570$var$Xe = (e, t, r, a = 0)=>{
    let n = $fd2b3ae2ecea5570$var$Ye(r), i = $fd2b3ae2ecea5570$var$Ge[n], o = {
        v: {
            idx: e,
            stack: t,
            type: r,
            id: a
        },
        l: null,
        r: null
    };
    3 === n || 4 === n ? $fd2b3ae2ecea5570$var$Ue = $fd2b3ae2ecea5570$var$Ve($fd2b3ae2ecea5570$var$Ue, o) : (0 === i.size ? i.first = o : i.last.r = o, i.last = o), i.size += 1;
}, $fd2b3ae2ecea5570$var$Ye = (e)=>{
    switch(e){
        case "child":
            return 0;
        case "pure":
            return 1;
        case "read":
            return 2;
        case "barrier":
            return 3;
        case "sampler":
            return 4;
        case "effect":
            return 5;
        default:
            return -1;
    }
}, $fd2b3ae2ecea5570$var$Ze = new Set;
let $fd2b3ae2ecea5570$var$et, $fd2b3ae2ecea5570$var$tt = 1, $fd2b3ae2ecea5570$var$rt = 0, $fd2b3ae2ecea5570$var$at = 0, $fd2b3ae2ecea5570$var$nt = null, $fd2b3ae2ecea5570$var$ot = (e)=>{
    $fd2b3ae2ecea5570$var$et = e;
}, $fd2b3ae2ecea5570$var$lt = (e)=>{
    $fd2b3ae2ecea5570$var$nt = e;
};
const $fd2b3ae2ecea5570$var$st = (e, t)=>{
    if (e) {
        for(; e && !e.reg[t];)e = $fd2b3ae2ecea5570$var$V(e);
        if (e) return e;
    }
    return null;
};
let $fd2b3ae2ecea5570$var$ft, $fd2b3ae2ecea5570$var$dt = (e, t, r, a, n)=>{
    let i = $fd2b3ae2ecea5570$var$st(e, a.id);
    return i ? i.reg[a.id] : t ? ($fd2b3ae2ecea5570$var$pt(t, a, n), t.reg[a.id]) : a;
}, $fd2b3ae2ecea5570$export$aa4047e72657c4f7 = (e)=>{
    $fd2b3ae2ecea5570$var$ft = e;
};
const $fd2b3ae2ecea5570$var$ct = (e)=>e;
let $fd2b3ae2ecea5570$var$pt = (e, r, a, n, i)=>{
    var o;
    let l = e.reg;
    if (l[r.id]) return;
    let s = r.sid, f = null == r || null === (o = r.meta) || void 0 === o ? void 0 : o.serialize, d = e.fromSerialize && "ignore" !== f && (null == f ? void 0 : f.read) || $fd2b3ae2ecea5570$var$ct, u = {
        id: r.id,
        current: r.current,
        meta: r.meta
    };
    if (u.id in e.values.idMap) u.current = e.values.idMap[u.id];
    else if (s && s in e.values.sidMap && !(s in e.sidIdMap)) u.current = d(e.values.sidMap[s]);
    else if (r.before && !i) {
        let i = 0, o = a || !r.noInit || n;
        $fd2b3ae2ecea5570$var$t(r.before, (t)=>{
            switch(t.type){
                case $fd2b3ae2ecea5570$var$_:
                    {
                        let r = t.from;
                        if (r || t.fn) {
                            r && $fd2b3ae2ecea5570$var$pt(e, r, a, n);
                            let i = r && l[r.id].current;
                            o && (u.current = t.fn ? t.fn(i) : i);
                        }
                        break;
                    }
                case "field":
                    i || (i = 1, u.current = Array.isArray(u.current) ? [
                        ...u.current
                    ] : {
                        ...u.current
                    }), $fd2b3ae2ecea5570$var$pt(e, t.from, a, n), o && (u.current[t.field] = l[l[t.from.id].id].current);
            }
        });
    }
    s && (e.sidIdMap[s] = r.id), l[r.id] = u;
};
const $fd2b3ae2ecea5570$var$mt = (e, t, r)=>{
    try {
        return t($fd2b3ae2ecea5570$var$H(r), e.scope, r);
    } catch (t) {
        console.error(t), e.fail = 1, e.failReason = t;
    }
};
let $fd2b3ae2ecea5570$var$gt = (t, r = {})=>($fd2b3ae2ecea5570$var$Me(t) && ($fd2b3ae2ecea5570$var$gt(t.or, r), $fd2b3ae2ecea5570$var$e(t, (e, t)=>{
        $fd2b3ae2ecea5570$var$$e(e) || "or" === t || "and" === t || (r[t] = e);
    }), $fd2b3ae2ecea5570$var$gt(t.and, r)), r);
const $fd2b3ae2ecea5570$var$ht = (e, t)=>{
    $fd2b3ae2ecea5570$var$oe(e.next, t), $fd2b3ae2ecea5570$var$oe($fd2b3ae2ecea5570$var$T(e), t), $fd2b3ae2ecea5570$var$oe($fd2b3ae2ecea5570$var$B(e), t);
}, $fd2b3ae2ecea5570$var$yt = (e, t, r)=>{
    let a;
    e.next.length = 0, e.seq.length = 0, e.scope = null;
    let n = $fd2b3ae2ecea5570$var$B(e);
    for(; a = n.pop();)$fd2b3ae2ecea5570$var$ht(a, e), (t || r && "sample" !== $fd2b3ae2ecea5570$var$J(e, "op") || "crosslink" === a.family.type) && $fd2b3ae2ecea5570$var$yt(a, t, "on" !== $fd2b3ae2ecea5570$var$J(a, "op") && r);
    for(n = $fd2b3ae2ecea5570$var$T(e); a = n.pop();)$fd2b3ae2ecea5570$var$ht(a, e), r && "crosslink" === a.family.type && $fd2b3ae2ecea5570$var$yt(a, t, "on" !== $fd2b3ae2ecea5570$var$J(a, "op") && r);
}, $fd2b3ae2ecea5570$var$bt = (e)=>e.clear();
let $fd2b3ae2ecea5570$export$51cfe97d637c237c = (e, { deep: t } = {})=>{
    let r = 0;
    if (e.ownerSet && e.ownerSet.delete(e), $fd2b3ae2ecea5570$var$Z(e)) $fd2b3ae2ecea5570$var$bt($fd2b3ae2ecea5570$var$U(e));
    else if ($fd2b3ae2ecea5570$var$re(e)) {
        r = 1;
        let t = e.history;
        $fd2b3ae2ecea5570$var$bt(t.events), $fd2b3ae2ecea5570$var$bt(t.effects), $fd2b3ae2ecea5570$var$bt(t.stores), $fd2b3ae2ecea5570$var$bt(t.domains);
    }
    $fd2b3ae2ecea5570$var$yt($fd2b3ae2ecea5570$var$L(e), !!t, r);
}, $fd2b3ae2ecea5570$var$kt = (e)=>{
    let t = ()=>$fd2b3ae2ecea5570$export$51cfe97d637c237c(e);
    return t.unsubscribe = t, t;
}, $fd2b3ae2ecea5570$var$wt = (e, t, r, a, i)=>$fd2b3ae2ecea5570$export$270e7ba5936d3c48({
        node: r,
        parent: e,
        child: t,
        scope: {
            fn: i
        },
        meta: {
            op: a
        },
        family: {
            owners: [
                e,
                t
            ],
            links: t
        },
        regional: 1
    }), $fd2b3ae2ecea5570$export$174bb771924e7eb1 = (e)=>{
    let t = "forward", [{ from: r, to: a }, i] = $fd2b3ae2ecea5570$var$f(e, 1);
    return $fd2b3ae2ecea5570$var$Ce(r, t, '"from"'), $fd2b3ae2ecea5570$var$Ce(a, t, '"to"'), $fd2b3ae2ecea5570$var$Ae(t, a, "to"), $fd2b3ae2ecea5570$var$kt($fd2b3ae2ecea5570$export$270e7ba5936d3c48({
        parent: r,
        child: a,
        meta: {
            op: t,
            config: i
        },
        family: {},
        regional: 1
    }));
}, $fd2b3ae2ecea5570$var$Mt = (e, t)=>($fd2b3ae2ecea5570$var$r($fd2b3ae2ecea5570$var$xe(t), ".watch argument should be a function"), $fd2b3ae2ecea5570$var$kt($fd2b3ae2ecea5570$export$270e7ba5936d3c48({
        scope: {
            fn: t
        },
        node: [
            $fd2b3ae2ecea5570$var$Ee({
                fn: $fd2b3ae2ecea5570$var$qe
            })
        ],
        parent: e,
        meta: {
            op: "watch"
        },
        family: {
            owners: e
        },
        regional: 1
    }))), $fd2b3ae2ecea5570$var$xt = (e, t, r = "event")=>{
    $fd2b3ae2ecea5570$var$V(e) && $fd2b3ae2ecea5570$var$V(e).hooks[r](t);
}, $fd2b3ae2ecea5570$var$$t = (e, t, r)=>{
    let a = $fd2b3ae2ecea5570$var$gt(r), n = "domain" === e, i = $fd2b3ae2ecea5570$var$ue(), { sid: o = null, named: l = null, domain: f = null, parent: d = f } = a, u = l || a.name || (n ? "" : i), c = $fd2b3ae2ecea5570$var$s(u, d), p = {
        op: t.kind = e,
        name: t.shortName = u,
        sid: t.sid = $fd2b3ae2ecea5570$var$ve(o),
        named: l,
        unitId: t.id = i,
        serialize: a.serialize,
        derived: a.derived,
        config: a
    };
    if (t.parent = d, t.compositeName = c, t.defaultConfig = a, t.thru = (e)=>($fd2b3ae2ecea5570$var$se(0, "thru", "js pipe"), e(t)), t.getType = ()=>c.fullName, !n) {
        t.subscribe = (e)=>($fd2b3ae2ecea5570$var$ze(e), t.watch($fd2b3ae2ecea5570$var$xe(e) ? e : (t)=>e.next && e.next(t))), t[$fd2b3ae2ecea5570$var$E] = ()=>t;
        let e = $fd2b3ae2ecea5570$var$be();
        e && (p.nativeTemplate = e);
    }
    return p;
};
const $fd2b3ae2ecea5570$var$zt = (e, t, r, a)=>{
    let n;
    $fd2b3ae2ecea5570$var$Me(r) && (n = r, r = r.fn);
    let i = $fd2b3ae2ecea5570$export$c30017717ce2168e({
        name: `${e.shortName} \u2192 *`,
        derived: 1,
        and: n
    });
    return $fd2b3ae2ecea5570$var$wt(e, i, a, t, r), i;
}, $fd2b3ae2ecea5570$var$jt = (e, t, r, a, n)=>{
    let i = $fd2b3ae2ecea5570$var$W(t), o = $fd2b3ae2ecea5570$var$Re({
        store: i,
        to: "a",
        priority: "read"
    });
    r === $fd2b3ae2ecea5570$var$_ && (o.data.softRead = 1);
    let l = [
        o,
        $fd2b3ae2ecea5570$var$Le(a)
    ];
    return $fd2b3ae2ecea5570$var$d("storeOnMap", i, l, $fd2b3ae2ecea5570$var$Z(e) && $fd2b3ae2ecea5570$var$W(e)), $fd2b3ae2ecea5570$var$wt(e, t, l, r, n);
}, $fd2b3ae2ecea5570$var$Ct = (t, a, n, i, l)=>{
    let s = t ? (e)=>[
            ...e
        ] : (e)=>({
            ...e
        }), f = t ? [] : {}, u = s(f), c = $fd2b3ae2ecea5570$var$Be(u), m = $fd2b3ae2ecea5570$var$Be(1);
    c.type = t ? "list" : "shape", c.noInit = 1, $fd2b3ae2ecea5570$var$d("combineBase", c, m);
    let g = $fd2b3ae2ecea5570$export$f51a9068ac82ea43(u, {
        name: $fd2b3ae2ecea5570$var$o(n),
        derived: 1,
        and: i
    }), h = $fd2b3ae2ecea5570$var$W(g);
    h.noInit = 1, $fd2b3ae2ecea5570$var$K(g, "isCombine", 1);
    let y = $fd2b3ae2ecea5570$var$Pe(c);
    y.order = {
        priority: "barrier"
    };
    let b = $fd2b3ae2ecea5570$var$Re({
        store: h,
        to: "b",
        priority: "read"
    });
    b.data.softRead = 1;
    let v = [
        $fd2b3ae2ecea5570$var$_e((e, t, r)=>(r.scope && !r.scope.reg[c.id] && (r.c = 1), e)),
        y,
        $fd2b3ae2ecea5570$var$Re({
            store: m,
            to: "b"
        }),
        $fd2b3ae2ecea5570$var$_e((e, { key: t }, r)=>{
            if (r.c || e !== r.a[t]) return a && r.b && (r.a = s(r.a)), r.a[t] = e, 1;
        }, 1),
        $fd2b3ae2ecea5570$var$Re({
            from: "a",
            target: c
        }),
        $fd2b3ae2ecea5570$var$Re({
            from: "value",
            store: 0,
            target: m
        }),
        $fd2b3ae2ecea5570$var$Re({
            from: "value",
            store: 1,
            target: m,
            priority: "barrier",
            batch: 1
        }),
        $fd2b3ae2ecea5570$var$Pe(c, 1),
        l && $fd2b3ae2ecea5570$var$Le(),
        b
    ];
    return $fd2b3ae2ecea5570$var$e(n, (e, t)=>{
        if (!$fd2b3ae2ecea5570$var$Z(e)) return $fd2b3ae2ecea5570$var$r(!$fd2b3ae2ecea5570$var$X(e) && !$fd2b3ae2ecea5570$var$$e(e), `combine expects a store in a field ${t}`), void (u[t] = f[t] = e);
        f[t] = e.defaultState, u[t] = e.getState();
        let a = $fd2b3ae2ecea5570$var$wt(e, g, v, "combine", l);
        a.scope.key = t;
        let n = $fd2b3ae2ecea5570$var$W(e);
        $fd2b3ae2ecea5570$var$He(c, {
            type: "field",
            field: t,
            from: n
        }), $fd2b3ae2ecea5570$var$d("combineField", n, a);
    }), g.defaultShape = n, $fd2b3ae2ecea5570$var$He(h, {
        type: $fd2b3ae2ecea5570$var$_,
        from: c,
        fn: l
    }), $fd2b3ae2ecea5570$var$be() || (g.defaultState = l ? h.current = l(u) : f), g;
};
let $fd2b3ae2ecea5570$var$At = (e, t, r)=>{
    try {
        return [
            1,
            e(...r)
        ];
    } catch (e) {
        return t(e), [
            0,
            null
        ];
    }
}, $fd2b3ae2ecea5570$var$It = (e)=>{
    let t = $fd2b3ae2ecea5570$var$G(e), r = {
        ref: t
    };
    return t && $fd2b3ae2ecea5570$var$le(t.activeEffects, r), r;
}, $fd2b3ae2ecea5570$var$Ot = (e, t, r, a, n, o)=>(l)=>{
        o.ref && $fd2b3ae2ecea5570$var$oe(o.ref.activeEffects, o), $fd2b3ae2ecea5570$export$9a7f3579b2beee84({
            target: [
                a,
                $fd2b3ae2ecea5570$var$qt
            ],
            params: [
                r ? {
                    status: "done",
                    params: e,
                    result: l
                } : {
                    status: "fail",
                    params: e,
                    error: l
                },
                {
                    value: l,
                    fn: r ? t.rs : t.rj
                }
            ],
            defer: 1,
            page: n.page,
            scope: o.ref,
            meta: n.meta
        });
    };
const $fd2b3ae2ecea5570$var$qt = $fd2b3ae2ecea5570$export$270e7ba5936d3c48({
    node: [
        $fd2b3ae2ecea5570$var$Ee({
            fn: ({ fn: e, value: t })=>e(t)
        })
    ],
    meta: {
        op: "fx",
        fx: "sidechain"
    }
}), $fd2b3ae2ecea5570$var$Nt = [
    "source",
    "clock",
    "target"
], $fd2b3ae2ecea5570$var$Dt = (e, t)=>e + `: ${t} should be defined`;
let $fd2b3ae2ecea5570$var$Rt = (e, t, a, n, i, o, l, s, f, c, g, h)=>{
    let y = !!i;
    $fd2b3ae2ecea5570$var$r(!$fd2b3ae2ecea5570$var$$e(a) || !$fd2b3ae2ecea5570$var$$e(t), $fd2b3ae2ecea5570$var$Dt(e, "either source or clock"));
    let b = 0;
    $fd2b3ae2ecea5570$var$$e(a) ? b = 1 : $fd2b3ae2ecea5570$var$X(a) || (a = $fd2b3ae2ecea5570$export$1be1fc439b849fdf(a)), $fd2b3ae2ecea5570$var$$e(t) ? t = a : ($fd2b3ae2ecea5570$var$Ce(t, e, "clock"), Array.isArray(t) && (t = $fd2b3ae2ecea5570$export$4950aa0f605343fb(t))), b && (a = t), s || l || (l = a.shortName);
    let v = "none";
    (g || n) && ($fd2b3ae2ecea5570$var$X(n) ? v = "unit" : ($fd2b3ae2ecea5570$var$r($fd2b3ae2ecea5570$var$xe(n), "`filter` should be function or unit"), v = "fn")), i ? ($fd2b3ae2ecea5570$var$Ce(i, e, "target"), $fd2b3ae2ecea5570$var$Ae(e, i)) : "none" === v && c && $fd2b3ae2ecea5570$var$Z(a) && $fd2b3ae2ecea5570$var$Z(t) ? i = $fd2b3ae2ecea5570$export$f51a9068ac82ea43(o ? o($fd2b3ae2ecea5570$var$We($fd2b3ae2ecea5570$var$W(a)), $fd2b3ae2ecea5570$var$We($fd2b3ae2ecea5570$var$W(t))) : $fd2b3ae2ecea5570$var$We($fd2b3ae2ecea5570$var$W(a)), {
        name: l,
        sid: h,
        or: s
    }) : (i = $fd2b3ae2ecea5570$export$c30017717ce2168e({
        name: l,
        derived: 1,
        or: s
    }), $fd2b3ae2ecea5570$var$d("sampleTarget", $fd2b3ae2ecea5570$var$L(i)));
    let k = $fd2b3ae2ecea5570$var$Be(), w = [];
    if ("unit" === v) {
        let [r, a] = $fd2b3ae2ecea5570$var$Et(n, i, t, k, e);
        w = [
            ...$fd2b3ae2ecea5570$var$Ft(a),
            ...$fd2b3ae2ecea5570$var$Ft(r)
        ];
    }
    let [M, x] = $fd2b3ae2ecea5570$var$Et(a, i, t, k, e), $ = $fd2b3ae2ecea5570$var$wt(t, i, [
        $fd2b3ae2ecea5570$var$d("sampleSourceLoader"),
        $fd2b3ae2ecea5570$var$Re({
            from: $fd2b3ae2ecea5570$var$P,
            target: k
        }),
        ...$fd2b3ae2ecea5570$var$Ft(x),
        $fd2b3ae2ecea5570$var$Pe(M, 1, f),
        ...w,
        $fd2b3ae2ecea5570$var$Pe(k),
        "fn" === v && $fd2b3ae2ecea5570$var$Le((e, t, { a: r })=>n(e, r), 1),
        o && $fd2b3ae2ecea5570$var$Le($fd2b3ae2ecea5570$var$Ie),
        $fd2b3ae2ecea5570$var$d("sampleSourceUpward", y)
    ], e, o);
    return $fd2b3ae2ecea5570$var$we(a, [
        $
    ]), Object.assign($.meta, s, {
        joint: 1
    }), i;
};
const $fd2b3ae2ecea5570$var$Ft = (e)=>[
        $fd2b3ae2ecea5570$var$Pe(e),
        $fd2b3ae2ecea5570$var$_e((e, t, { a: r })=>r, 1)
    ], $fd2b3ae2ecea5570$var$Et = (e, t, r, a, i)=>{
    let o = $fd2b3ae2ecea5570$var$Z(e), l = o ? $fd2b3ae2ecea5570$var$W(e) : $fd2b3ae2ecea5570$var$Be(), s = $fd2b3ae2ecea5570$var$Be(o);
    return o || $fd2b3ae2ecea5570$export$270e7ba5936d3c48({
        parent: e,
        node: [
            $fd2b3ae2ecea5570$var$Re({
                from: $fd2b3ae2ecea5570$var$P,
                target: l
            }),
            $fd2b3ae2ecea5570$var$Re({
                from: "value",
                store: 1,
                target: s
            })
        ],
        family: {
            owners: [
                e,
                t,
                r
            ],
            links: t
        },
        meta: {
            op: i
        },
        regional: 1
    }), $fd2b3ae2ecea5570$var$d("sampleSource", s, l, a), [
        l,
        s
    ];
}, $fd2b3ae2ecea5570$var$_t = (e, t, r, a)=>{
    let n = e[t];
    n && $fd2b3ae2ecea5570$export$9a7f3579b2beee84({
        target: n,
        params: Array.isArray(n) ? n.map(()=>r) : r,
        defer: 1,
        stack: a
    });
}, $fd2b3ae2ecea5570$export$83d89fbfd8236492 = "22.8.8", $fd2b3ae2ecea5570$var$Lt = (e)=>e;

});

parcelRegister("44bXl", function(module, exports) {
function $2f60cf6552f1de23$var$connectLocalStorage(key) {
    var holder = {};
    holder.onError = function(errorHandler) {
        holder.errorHandler = errorHandler;
        return holder;
    };
    holder.init = function() {
        try {
            var savedState = localStorage.getItem(key);
            if (savedState !== null) return JSON.parse(savedState);
        } catch (err) {
            holder.onError && holder.onError(err);
        }
        return null;
    };
    holder.watcher = function(storeValue) {
        try {
            var saveState = JSON.stringify(storeValue);
            localStorage.setItem(key, saveState);
        } catch (err) {
            holder.onError && holder.onError(err);
        }
    };
    return holder;
}
module.exports = $2f60cf6552f1de23$var$connectLocalStorage;

});

parcelRegister("2F0j2", function(module, exports) {

$parcel$export(module.exports, "getLastNameWithInitials", function () { return $1effa5dff51b2f97$export$b195190343cd5646; });
const $1effa5dff51b2f97$export$b195190343cd5646 = (doctor)=>{
    if (!doctor) return "";
    const first_nameLetter = doctor.first_name.length > 0 && doctor.first_name[0];
    const middle_nameLetter = doctor.last_name.length > 0 && doctor.middle_name[0];
    return `${doctor.last_name} ${first_nameLetter ? first_nameLetter + "." : ""}${middle_nameLetter ? middle_nameLetter + "." : ""}`;
};
const $1effa5dff51b2f97$export$6737d22fa98d51b0 = (fullName)=>{
    if (!fullName) return "";
    const splitFullName = fullName.split(" ");
    return `${splitFullName[0]} ${splitFullName[1][0] + ". "}${splitFullName[2][0] + "."}`;
};

});

parcelRegister("3DzKC", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    var a, i;
    module.exports = factory();
})(module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 0);
    /******/ }({
        /***/ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js": /*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayLikeToArray.js ***!
  \*****************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                return arr2;
            }
            module1.exports = _arrayLikeToArray;
            module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
        /***/ },
        /***/ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js": /*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js ***!
  \******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var arrayLikeToArray = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return arrayLikeToArray(arr);
            }
            module1.exports = _arrayWithoutHoles;
            module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
        /***/ },
        /***/ "./node_modules/@babel/runtime/helpers/classCallCheck.js": /*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/classCallCheck.js ***!
  \***************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            module1.exports = _classCallCheck;
            module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
        /***/ },
        /***/ "./node_modules/@babel/runtime/helpers/createClass.js": /*!************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/createClass.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            function _defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                return Constructor;
            }
            module1.exports = _createClass;
            module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
        /***/ },
        /***/ "./node_modules/@babel/runtime/helpers/defineProperty.js": /*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/defineProperty.js ***!
  \***************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            module1.exports = _defineProperty;
            module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
        /***/ },
        /***/ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js": /*!**********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/interopRequireDefault.js ***!
  \**********************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    "default": obj
                };
            }
            module1.exports = _interopRequireDefault;
            module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
        /***/ },
        /***/ "./node_modules/@babel/runtime/helpers/interopRequireWildcard.js": /*!***********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/interopRequireWildcard.js ***!
  \***********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var _typeof = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"];
            function _getRequireWildcardCache(nodeInterop) {
                if (typeof WeakMap !== "function") return null;
                var cacheBabelInterop = new WeakMap();
                var cacheNodeInterop = new WeakMap();
                return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
                    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
                })(nodeInterop);
            }
            function _interopRequireWildcard(obj, nodeInterop) {
                if (!nodeInterop && obj && obj.__esModule) return obj;
                if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
                    "default": obj
                };
                var cache = _getRequireWildcardCache(nodeInterop);
                if (cache && cache.has(obj)) return cache.get(obj);
                var newObj = {};
                var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
                    else newObj[key] = obj[key];
                }
                newObj["default"] = obj;
                if (cache) cache.set(obj, newObj);
                return newObj;
            }
            module1.exports = _interopRequireWildcard;
            module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
        /***/ },
        /***/ "./node_modules/@babel/runtime/helpers/iterableToArray.js": /*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/iterableToArray.js ***!
  \****************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            module1.exports = _iterableToArray;
            module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
        /***/ },
        /***/ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js": /*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/nonIterableSpread.js ***!
  \******************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            module1.exports = _nonIterableSpread;
            module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
        /***/ },
        /***/ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js": /*!************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/objectWithoutProperties.js ***!
  \************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var objectWithoutPropertiesLoose = __webpack_require__(/*! ./objectWithoutPropertiesLoose.js */ "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js");
            function _objectWithoutProperties(source, excluded) {
                if (source == null) return {};
                var target = objectWithoutPropertiesLoose(source, excluded);
                var key, i;
                if (Object.getOwnPropertySymbols) {
                    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                    for(i = 0; i < sourceSymbolKeys.length; i++){
                        key = sourceSymbolKeys[i];
                        if (excluded.indexOf(key) >= 0) continue;
                        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                        target[key] = source[key];
                    }
                }
                return target;
            }
            module1.exports = _objectWithoutProperties;
            module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
        /***/ },
        /***/ "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js": /*!*****************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js ***!
  \*****************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            function _objectWithoutPropertiesLoose(source, excluded) {
                if (source == null) return {};
                var target = {};
                var sourceKeys = Object.keys(source);
                var key, i;
                for(i = 0; i < sourceKeys.length; i++){
                    key = sourceKeys[i];
                    if (excluded.indexOf(key) >= 0) continue;
                    target[key] = source[key];
                }
                return target;
            }
            module1.exports = _objectWithoutPropertiesLoose;
            module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
        /***/ },
        /***/ "./node_modules/@babel/runtime/helpers/toConsumableArray.js": /*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toConsumableArray.js ***!
  \******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var arrayWithoutHoles = __webpack_require__(/*! ./arrayWithoutHoles.js */ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js");
            var iterableToArray = __webpack_require__(/*! ./iterableToArray.js */ "./node_modules/@babel/runtime/helpers/iterableToArray.js");
            var unsupportedIterableToArray = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js");
            var nonIterableSpread = __webpack_require__(/*! ./nonIterableSpread.js */ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js");
            function _toConsumableArray(arr) {
                return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
            }
            module1.exports = _toConsumableArray;
            module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
        /***/ },
        /***/ "./node_modules/@babel/runtime/helpers/typeof.js": /*!*******************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            function _typeof(obj) {
                "@babel/helpers - typeof";
                if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                    module1.exports = _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
                } else {
                    module1.exports = _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
                }
                return _typeof(obj);
            }
            module1.exports = _typeof;
            module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
        /***/ },
        /***/ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js": /*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js ***!
  \***************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var arrayLikeToArray = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
            }
            module1.exports = _unsupportedIterableToArray;
            module1.exports["default"] = module1.exports, module1.exports.__esModule = true;
        /***/ },
        /***/ "./node_modules/webpack/buildin/global.js": /*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var g;
            // This works in non-strict mode
            g = function() {
                return this;
            }();
            try {
                // This works if eval is allowed (see CSP)
                g = g || new Function("return this")();
            } catch (e) {
                // This works if the window reference is available
                if (typeof window === "object") g = window;
            }
            // g can still be undefined, but nothing to do about it...
            // We return undefined, instead of nothing here, so it's
            // easier to handle this case. if(!global) { ...}
            module1.exports = g;
        /***/ },
        /***/ "./packages/@apphub:logrocket-console/src/index.js": /*!*********************************************************!*\
  !*** ./packages/@apphub:logrocket-console/src/index.js ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = void 0;
            var _registerConsole = _interopRequireDefault(__webpack_require__(/*! ./registerConsole */ "./packages/@apphub:logrocket-console/src/registerConsole.js"));
            var _default = _registerConsole.default;
            exports.default = _default;
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/@apphub:logrocket-console/src/registerConsole.js": /*!*******************************************************************!*\
  !*** ./packages/@apphub:logrocket-console/src/registerConsole.js ***!
  \*******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = registerConsole;
            var _typeof2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));
            var _enhanceFunc = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/enhanceFunc */ "./packages/@apphub:logrocket-utils/src/enhanceFunc.js"));
            var _logrocketExceptions = __webpack_require__(/*! @apphub/logrocket-exceptions */ "./packages/@apphub:logrocket-exceptions/src/index.js");
            // eslint-disable-line no-restricted-imports
            function registerConsole(logger) {
                var unsubFunctions = [];
                var methods = [
                    "log",
                    "warn",
                    "info",
                    "error",
                    "debug"
                ];
                methods.forEach(function(method) {
                    unsubFunctions.push((0, _enhanceFunc.default)(console, method, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        logger.addEvent("lr.core.LogEvent", function() {
                            var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            var isEnabled = consoleOptions.isEnabled;
                            if ((0, _typeof2.default)(isEnabled) === "object" && isEnabled[method] === false || isEnabled === false) return null;
                            if (method === "error" && consoleOptions.shouldAggregateConsoleErrors) _logrocketExceptions.Capture.captureMessage(logger, args[0], {}, true);
                            return {
                                logLevel: method.toUpperCase(),
                                args: args
                            };
                        });
                    }));
                });
                return function() {
                    unsubFunctions.forEach(function(unsubFunction) {
                        return unsubFunction();
                    });
                };
            }
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/@apphub:logrocket-exceptions/src/Capture.js": /*!**************************************************************!*\
  !*** ./packages/@apphub:logrocket-exceptions/src/Capture.js ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.captureMessage = captureMessage;
            exports.captureException = captureException;
            var _typeof2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));
            var _TraceKit = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/TraceKit */ "./packages/@apphub:logrocket-utils/src/TraceKit.js"));
            var _stackTraceFromError = _interopRequireDefault(__webpack_require__(/*! ./stackTraceFromError */ "./packages/@apphub:logrocket-exceptions/src/stackTraceFromError.js"));
            /* eslint-disable no-param-reassign */ // eslint-disable-line no-restricted-imports
            function isScalar(value) {
                return /boolean|number|string/.test((0, _typeof2.default)(value));
            }
            function scrub(data, options) {
                if (options) {
                    var optionalScalars = [
                        // and 'debug'. Defaults to 'error'.
                        "level",
                        "logger"
                    ];
                    for(var _i = 0, _optionalScalars = optionalScalars; _i < _optionalScalars.length; _i++){
                        var field = _optionalScalars[_i];
                        var value = options[field];
                        if (isScalar(value)) data[field] = value.toString();
                    }
                    var optionalMaps = [
                        "tags",
                        "extra"
                    ];
                    for(var _i2 = 0, _optionalMaps = optionalMaps; _i2 < _optionalMaps.length; _i2++){
                        var _field = _optionalMaps[_i2];
                        var dirty = options[_field] || {};
                        var scrubbed = {};
                        for(var _i3 = 0, _Object$keys = Object.keys(dirty); _i3 < _Object$keys.length; _i3++){
                            var key = _Object$keys[_i3];
                            var _value = dirty[key];
                            if (isScalar(_value)) scrubbed[key.toString()] = _value.toString();
                        }
                        data[_field] = scrubbed;
                    }
                }
            }
            function captureMessage(logger, message) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var isConsole = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                var data = {
                    exceptionType: isConsole ? "CONSOLE" : "MESSAGE",
                    message: message,
                    browserHref: window.location ? window.location.href : ""
                };
                scrub(data, options);
                logger.addEvent("lr.core.Exception", function() {
                    return data;
                });
            }
            function captureException(logger, exception) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var preppedTrace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                var trace = preppedTrace || _TraceKit.default.computeStackTrace(exception);
                var data = {
                    exceptionType: "WINDOW",
                    errorType: trace.name,
                    message: trace.message,
                    browserHref: window.location ? window.location.href : ""
                };
                scrub(data, options);
                var addEventOptions = {
                    _stackTrace: (0, _stackTraceFromError.default)(trace)
                };
                logger.addEvent("lr.core.Exception", function() {
                    return data;
                }, addEventOptions);
            }
        /***/ },
        /***/ "./packages/@apphub:logrocket-exceptions/src/index.js": /*!************************************************************!*\
  !*** ./packages/@apphub:logrocket-exceptions/src/index.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireWildcard = __webpack_require__(/*! @babel/runtime/helpers/interopRequireWildcard */ "./node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            Object.defineProperty(exports, "registerExceptions", {
                enumerable: true,
                get: function get() {
                    return _registerExceptions.default;
                }
            });
            exports.Capture = void 0;
            var _registerExceptions = _interopRequireDefault(__webpack_require__(/*! ./registerExceptions */ "./packages/@apphub:logrocket-exceptions/src/registerExceptions.js"));
            var Capture = _interopRequireWildcard(__webpack_require__(/*! ./Capture */ "./packages/@apphub:logrocket-exceptions/src/Capture.js"));
            exports.Capture = Capture;
        /***/ },
        /***/ "./packages/@apphub:logrocket-exceptions/src/raven/raven.js": /*!******************************************************************!*\
  !*** ./packages/@apphub:logrocket-exceptions/src/raven/raven.js ***!
  \******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(global) {
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _classCallCheck2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js"));
                var _createClass2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js"));
                var _TraceKit = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/TraceKit */ "./packages/@apphub:logrocket-utils/src/TraceKit.js"));
                /* eslint-disable */ /*
Some contents of this file were originaly from raven-js, BSD-2 Clause

Copyright (c) 2018 Sentry (https://sentry.io) and individual contributors.
All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
* Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ var objectPrototype = Object.prototype;
                function isUndefined(what) {
                    return what === void 0;
                }
                function isFunction(what) {
                    return typeof what === "function";
                }
                function each(obj, callback) {
                    var i, j;
                    if (isUndefined(obj.length)) {
                        for(i in obj)if (hasKey(obj, i)) callback.call(null, i, obj[i]);
                    } else {
                        j = obj.length;
                        if (j) for(i = 0; i < j; i++)callback.call(null, i, obj[i]);
                    }
                }
                /**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */ function hasKey(object, key) {
                    return objectPrototype.hasOwnProperty.call(object, key);
                }
                /**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */ function fill(obj, name, replacement, track) {
                    var orig = obj[name];
                    obj[name] = replacement(orig);
                    if (track) track.push([
                        obj,
                        name,
                        orig
                    ]);
                }
                var _window = typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
                var _document = _window.document;
                var Handler = /*#__PURE__*/ function() {
                    function Handler(_ref) {
                        var captureException = _ref.captureException;
                        (0, _classCallCheck2.default)(this, Handler);
                        this._errorHandler = this._errorHandler.bind(this);
                        this._ignoreOnError = 0;
                        this._wrappedBuiltIns = [];
                        this.captureException = captureException;
                        _TraceKit.default.report.subscribe(this._errorHandler);
                        this._instrumentTryCatch();
                    }
                    (0, _createClass2.default)(Handler, [
                        {
                            key: "uninstall",
                            value: function uninstall() {
                                _TraceKit.default.report.unsubscribe(this._errorHandler); // restore any wrapped builtins
                                var builtin;
                                while(this._wrappedBuiltIns.length){
                                    builtin = this._wrappedBuiltIns.shift();
                                    var obj = builtin[0], name = builtin[1], orig = builtin[2];
                                    obj[name] = orig;
                                }
                            }
                        },
                        {
                            key: "_errorHandler",
                            value: function _errorHandler(report) {
                                if (!this._ignoreOnError) this.captureException(report);
                            }
                        },
                        {
                            key: "_ignoreNextOnError",
                            value: function _ignoreNextOnError() {
                                var _this = this;
                                this._ignoreOnError += 1;
                                setTimeout(function() {
                                    // onerror should trigger before setTimeout
                                    _this._ignoreOnError -= 1;
                                });
                            }
                        },
                        {
                            key: "context",
                            value: function context(options, func, args) {
                                if (isFunction(options)) {
                                    args = func || [];
                                    func = options;
                                    options = undefined;
                                }
                                return this.wrap(options, func).apply(this, args);
                            }
                        },
                        {
                            key: "wrap",
                            value: /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} func A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */ function wrap(options, func, _before) {
                                var self1 = this; // 1 argument has been passed, and it's not a function
                                // so just return it
                                if (isUndefined(func) && !isFunction(options)) return options;
                                 // options is optional
                                if (isFunction(options)) {
                                    func = options;
                                    options = undefined;
                                } // At this point, we've passed along 2 arguments, and the second one
                                // is not a function either, so we'll just return the second argument.
                                if (!isFunction(func)) return func;
                                 // We don't wanna wrap it twice!
                                try {
                                    if (func.__lr__) return func;
                                     // If this has already been wrapped in the past, return that
                                    if (func.__lr_wrapper__) return func.__lr_wrapper__;
                                     // If func is not extensible, return the function as-is to prevent TypeErrors
                                    // when trying to add new props & to assure immutable funcs aren't changed
                                    if (!Object.isExtensible(func)) return func;
                                } catch (e) {
                                    // Just accessing custom props in some Selenium environments
                                    // can cause a "Permission denied" exception (see lr-js#495).
                                    // Bail on wrapping and return the function as-is (defers to window.onerror).
                                    return func;
                                }
                                function wrapped() {
                                    var args = [], i = arguments.length, deep = !options || options && options.deep !== false;
                                    if (_before && isFunction(_before)) _before.apply(this, arguments);
                                     // Recursively wrap all of a function's arguments that are
                                    // functions themselves.
                                    while(i--)args[i] = deep ? self1.wrap(options, arguments[i]) : arguments[i];
                                    try {
                                        // Attempt to invoke user-land function. This is part of the LogRocket SDK.
                                        // If you're seeing this frame in a stack trace, it means that LogRocket caught
                                        // an unhandled error thrown by your application code, reported it, then bubbled
                                        // it up. This is expected behavior and is not a bug with LogRocket.
                                        return func.apply(this, args);
                                    } catch (e) {
                                        self1._ignoreNextOnError();
                                        self1.captureException(_TraceKit.default.computeStackTrace(e), options);
                                        throw e;
                                    }
                                } // copy over properties of the old function
                                for(var property in func)if (hasKey(func, property)) wrapped[property] = func[property];
                                wrapped.prototype = func.prototype;
                                func.__lr_wrapper__ = wrapped; // Signal that this function has been wrapped already
                                // for both debugging and to prevent it to being wrapped twice
                                wrapped.__lr__ = true;
                                wrapped.__inner__ = func;
                                return wrapped;
                            }
                        },
                        {
                            key: "_instrumentTryCatch",
                            value: /**
     * Install any queued plugins
     */ function _instrumentTryCatch() {
                                var self1 = this;
                                var wrappedBuiltIns = self1._wrappedBuiltIns;
                                function wrapTimeFn(orig) {
                                    return function(fn, t) {
                                        // preserve arity
                                        // Make a copy of the arguments to prevent deoptimization
                                        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
                                        var args = new Array(arguments.length);
                                        for(var i = 0; i < args.length; ++i)args[i] = arguments[i];
                                        var originalCallback = args[0];
                                        if (isFunction(originalCallback)) args[0] = self1.wrap(originalCallback);
                                         // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
                                        // also supports only two arguments and doesn't care what this is, so we
                                        // can just call the original function directly.
                                        if (orig.apply) return orig.apply(this, args);
                                        else return orig(args[0], args[1]);
                                    };
                                }
                                function wrapEventTarget(global) {
                                    var proto = _window[global] && _window[global].prototype;
                                    if (proto && proto.hasOwnProperty && proto.hasOwnProperty("addEventListener")) {
                                        fill(proto, "addEventListener", function(orig) {
                                            return function(evtName, fn, capture, secure) {
                                                // preserve arity
                                                try {
                                                    if (fn && fn.handleEvent) fn.handleEvent = self1.wrap(fn.handleEvent);
                                                } catch (err) {} // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
                                                // so that we don't have more than one wrapper function
                                                var before;
                                                return orig.call(this, evtName, self1.wrap(fn, undefined, before), capture, secure);
                                            };
                                        }, wrappedBuiltIns);
                                        fill(proto, "removeEventListener", function(orig) {
                                            return function(evt, fn, capture, secure) {
                                                try {
                                                    fn = fn && (fn.__lr_wrapper__ ? fn.__lr_wrapper__ : fn);
                                                } catch (e) {}
                                                return orig.call(this, evt, fn, capture, secure);
                                            };
                                        }, wrappedBuiltIns);
                                    }
                                }
                                fill(_window, "setTimeout", wrapTimeFn, wrappedBuiltIns);
                                fill(_window, "setInterval", wrapTimeFn, wrappedBuiltIns);
                                if (_window.requestAnimationFrame) fill(_window, "requestAnimationFrame", function(orig) {
                                    return function(cb) {
                                        return orig(self1.wrap(cb));
                                    };
                                }, wrappedBuiltIns);
                                 // event targets borrowed from bugsnag-js:
                                // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
                                var eventTargets = [
                                    "EventTarget",
                                    "Window",
                                    "Node",
                                    "ApplicationCache",
                                    "AudioTrackList",
                                    "ChannelMergerNode",
                                    "CryptoOperation",
                                    "EventSource",
                                    "FileReader",
                                    "HTMLUnknownElement",
                                    "IDBDatabase",
                                    "IDBRequest",
                                    "IDBTransaction",
                                    "KeyOperation",
                                    "MediaController",
                                    "MessagePort",
                                    "ModalWindow",
                                    "Notification",
                                    "SVGElementInstance",
                                    "Screen",
                                    "TextTrack",
                                    "TextTrackCue",
                                    "TextTrackList",
                                    "WebSocket",
                                    "WebSocketWorker",
                                    "Worker",
                                    "XMLHttpRequest",
                                    "XMLHttpRequestEventTarget",
                                    "XMLHttpRequestUpload"
                                ];
                                for(var i = 0; i < eventTargets.length; i++)wrapEventTarget(eventTargets[i]);
                                var $ = _window.jQuery || _window.$;
                                if ($ && $.fn && $.fn.ready) fill($.fn, "ready", function(orig) {
                                    return function(fn) {
                                        return orig.call(this, self1.wrap(fn));
                                    };
                                }, wrappedBuiltIns);
                            }
                        }
                    ]);
                    return Handler;
                }();
                exports.default = Handler;
                module1.exports = exports.default;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(/*! ./../../../../node_modules/webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"));
        /***/ },
        /***/ "./packages/@apphub:logrocket-exceptions/src/registerExceptions.js": /*!*************************************************************************!*\
  !*** ./packages/@apphub:logrocket-exceptions/src/registerExceptions.js ***!
  \*************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireWildcard = __webpack_require__(/*! @babel/runtime/helpers/interopRequireWildcard */ "./node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = registerCore;
            var _raven = _interopRequireDefault(__webpack_require__(/*! ./raven/raven */ "./packages/@apphub:logrocket-exceptions/src/raven/raven.js"));
            var Capture = _interopRequireWildcard(__webpack_require__(/*! ./Capture */ "./packages/@apphub:logrocket-exceptions/src/Capture.js"));
            function registerCore(logger) {
                var raven = new _raven.default({
                    captureException: function captureException(errorReport) {
                        Capture.captureException(logger, null, null, errorReport);
                    }
                });
                var rejectionHandler = function rejectionHandler(evt) {
                    // http://2ality.com/2016/04/unhandled-rejections.html
                    logger.addEvent("lr.core.Exception", function() {
                        return {
                            exceptionType: "UNHANDLED_REJECTION",
                            message: evt.reason || "Unhandled Promise rejection"
                        };
                    });
                };
                window.addEventListener("unhandledrejection", rejectionHandler);
                return function() {
                    window.removeEventListener("unhandledrejection", rejectionHandler);
                    raven.uninstall();
                };
            }
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/@apphub:logrocket-exceptions/src/stackTraceFromError.js": /*!**************************************************************************!*\
  !*** ./packages/@apphub:logrocket-exceptions/src/stackTraceFromError.js ***!
  \**************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = stackTraceFromError;
            function stackTraceFromError(errorReport) {
                function makeNotNull(val) {
                    return val === null ? undefined : val;
                }
                return errorReport.stack ? errorReport.stack.map(function(frame) {
                    return {
                        lineNumber: makeNotNull(frame.line),
                        columnNumber: makeNotNull(frame.column),
                        fileName: makeNotNull(frame.url),
                        functionName: makeNotNull(frame.func)
                    };
                }) : undefined;
            }
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/@apphub:logrocket-network/src/fetchIntercept.js": /*!******************************************************************!*\
  !*** ./packages/@apphub:logrocket-network/src/fetchIntercept.js ***!
  \******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = void 0;
            var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js"));
            var _registerXHR = __webpack_require__(/*! ./registerXHR */ "./packages/@apphub:logrocket-network/src/registerXHR.js");
            var interceptors = [];
            function makeInterceptor(fetch, fetchId) {
                var reversedInterceptors = interceptors.reduce(function(array, interceptor) {
                    return [
                        interceptor
                    ].concat(array);
                }, []); // if a browser supports fetch, it supports promise
                // eslint-disable-next-line compat/compat
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                var promise = Promise.resolve(args); // Register request interceptors
                reversedInterceptors.forEach(function(_ref) {
                    var request = _ref.request, requestError = _ref.requestError;
                    if (request || requestError) promise = promise.then(function(args) {
                        return request.apply(void 0, [
                            fetchId
                        ].concat((0, _toConsumableArray2.default)(args)));
                    }, function(args) {
                        return requestError.apply(void 0, [
                            fetchId
                        ].concat((0, _toConsumableArray2.default)(args)));
                    });
                });
                promise = promise.then(function(args) {
                    (0, _registerXHR.setActive)(false);
                    var res;
                    var err;
                    try {
                        res = fetch.apply(void 0, (0, _toConsumableArray2.default)(args));
                    } catch (_err) {
                        err = _err;
                    }
                    (0, _registerXHR.setActive)(true);
                    if (err) throw err;
                    return res;
                });
                reversedInterceptors.forEach(function(_ref2) {
                    var response = _ref2.response, responseError = _ref2.responseError;
                    if (response || responseError) promise = promise.then(function(res) {
                        return response(fetchId, res);
                    }, function(err) {
                        return responseError && responseError(fetchId, err);
                    });
                });
                return promise;
            }
            function attach(env) {
                if (!env.fetch || !env.Promise) // Make sure fetch is available in the given environment. If it's not, then
                // default to using XHR intercept.
                return;
                var isPolyfill = env.fetch.polyfill; // eslint-disable-next-line no-param-reassign
                env.fetch = function(fetch) {
                    var fetchId = 0;
                    return function() {
                        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                        return makeInterceptor.apply(void 0, [
                            fetch,
                            fetchId++
                        ].concat(args));
                    };
                }(env.fetch); // Forward the polyfill properly from fetch (set by github/whatwg-fetch).
                if (isPolyfill) // eslint-disable-next-line no-param-reassign
                env.fetch.polyfill = isPolyfill;
            } // TODO: React Native
            //   attach(global);
            var didAttach = false;
            var _default = {
                register: function register(interceptor) {
                    if (!didAttach) {
                        didAttach = true;
                        attach(window);
                    }
                    interceptors.push(interceptor);
                    return function() {
                        var index = interceptors.indexOf(interceptor);
                        if (index >= 0) interceptors.splice(index, 1);
                    };
                },
                clear: function clear() {
                    interceptors = [];
                }
            };
            exports.default = _default;
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/@apphub:logrocket-network/src/index.js": /*!*********************************************************!*\
  !*** ./packages/@apphub:logrocket-network/src/index.js ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = registerNetwork;
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
            var _typeof2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));
            var _registerFetch = _interopRequireDefault(__webpack_require__(/*! ./registerFetch */ "./packages/@apphub:logrocket-network/src/registerFetch.js"));
            var _registerNetworkInformation = _interopRequireDefault(__webpack_require__(/*! ./registerNetworkInformation */ "./packages/@apphub:logrocket-network/src/registerNetworkInformation.js"));
            var _registerXHR = _interopRequireDefault(__webpack_require__(/*! ./registerXHR */ "./packages/@apphub:logrocket-network/src/registerXHR.js"));
            var _mapValues = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/mapValues */ "./packages/@apphub:logrocket-utils/src/mapValues.js"));
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    if (enumerableOnly) symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    });
                    keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i] != null ? arguments[i] : {};
                    if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                        (0, _defineProperty2.default)(target, key, source[key]);
                    });
                    else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                    else ownKeys(Object(source)).forEach(function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    });
                }
                return target;
            }
            // eslint-disable-line no-restricted-imports
            function registerNetwork(logger) {
                var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    isReactNative: false
                };
                var isReactNative = config.isReactNative, shouldAugmentNPS = config.shouldAugmentNPS, shouldParseXHRBlob = config.shouldParseXHRBlob;
                var ignoredNetwork = {}; // truncate if > 4MB in size
                var truncate = function truncate(data) {
                    var limit = 4096000;
                    var str = data;
                    if ((0, _typeof2.default)(data) === "object" && data != null) {
                        var proto = Object.getPrototypeOf(data);
                        if (proto === Object.prototype || proto === null) // plain object - jsonify for the size check
                        str = JSON.stringify(data);
                    }
                    if (str && str.length && str.length > limit && typeof str === "string") {
                        var beginning = str.substring(0, 1000);
                        return "".concat(beginning, " ... LogRocket truncating to first 1000 characters.\n      Keep data under 4MB to prevent truncation. https://docs.logrocket.com/reference#network");
                    }
                    return data;
                };
                var addRequest = function addRequest(reqId, request) {
                    var method = request.method;
                    logger.addEvent("lr.network.RequestEvent", function() {
                        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, _ref$requestSanitizer = _ref.requestSanitizer, requestSanitizer = _ref$requestSanitizer === void 0 ? function(f) {
                            return f;
                        } : _ref$requestSanitizer;
                        if (!isEnabled) return null;
                        var sanitized = null;
                        try {
                            // only try catch user defined functions
                            sanitized = requestSanitizer(_objectSpread(_objectSpread({}, request), {}, {
                                reqId: reqId
                            }));
                        } catch (err) {
                            console.error(err);
                        }
                        if (sanitized) {
                            var url = sanitized.url;
                            if (typeof document !== "undefined" && typeof document.createElement === "function") {
                                // Writing and then reading from an a tag turns a relative
                                // url into an absolute one.
                                var a = document.createElement("a");
                                a.href = sanitized.url;
                                url = a.href;
                            }
                            return {
                                reqId: reqId,
                                // default
                                url: url,
                                // sanitized
                                headers: (0, _mapValues.default)(sanitized.headers, function(headerValue) {
                                    // sanitized
                                    return "".concat(headerValue);
                                }),
                                body: truncate(sanitized.body),
                                // sanitized
                                method: method,
                                // default
                                referrer: sanitized.referrer || undefined,
                                // sanitized
                                mode: sanitized.mode || undefined,
                                // sanitized
                                credentials: sanitized.credentials || undefined // sanitized
                            };
                        }
                        ignoredNetwork[reqId] = true;
                        return null;
                    });
                };
                var addResponse = function addResponse(reqId, response) {
                    var method = response.method, status = response.status;
                    logger.addEvent("lr.network.ResponseEvent", function() {
                        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$isEnabled = _ref2.isEnabled, isEnabled = _ref2$isEnabled === void 0 ? true : _ref2$isEnabled, _ref2$responseSanitiz = _ref2.responseSanitizer, responseSanitizer = _ref2$responseSanitiz === void 0 ? function(f) {
                            return f;
                        } : _ref2$responseSanitiz;
                        if (!isEnabled) return null;
                        else if (ignoredNetwork[reqId]) {
                            delete ignoredNetwork[reqId];
                            return null;
                        }
                        var sanitized = null;
                        try {
                            // only try catch user defined functions
                            sanitized = responseSanitizer(_objectSpread(_objectSpread({}, response), {}, {
                                reqId: reqId
                            }));
                        } catch (err) {
                            console.error(err); // fall through to redacted log
                        }
                        if (sanitized) return {
                            reqId: reqId,
                            // default
                            status: sanitized.status,
                            // sanitized
                            headers: (0, _mapValues.default)(sanitized.headers, function(headerValue) {
                                // sanitized
                                return "".concat(headerValue);
                            }),
                            body: truncate(sanitized.body),
                            // sanitized
                            method: method // default
                        };
                        return {
                            reqId: reqId,
                            // default
                            status: status,
                            // default
                            headers: {},
                            // redacted
                            body: null,
                            // redacted
                            method: method // default
                        };
                    });
                };
                var isIgnored = function isIgnored(reqId) {
                    return logger.isDisabled || ignoredNetwork[reqId] === true;
                };
                var unsubFetch = (0, _registerFetch.default)({
                    addRequest: addRequest,
                    addResponse: addResponse,
                    isIgnored: isIgnored
                });
                var unsubXHR = (0, _registerXHR.default)({
                    addRequest: addRequest,
                    addResponse: addResponse,
                    isIgnored: isIgnored,
                    logger: logger,
                    shouldAugmentNPS: shouldAugmentNPS,
                    shouldParseXHRBlob: shouldParseXHRBlob
                });
                var unsubNetworkInformation = isReactNative ? function() {} : (0, _registerNetworkInformation.default)(logger);
                return function() {
                    unsubNetworkInformation();
                    unsubFetch();
                    unsubXHR();
                };
            }
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/@apphub:logrocket-network/src/registerFetch.js": /*!*****************************************************************!*\
  !*** ./packages/@apphub:logrocket-network/src/registerFetch.js ***!
  \*****************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = registerFetch;
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
            var _mapValues = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/mapValues */ "./packages/@apphub:logrocket-utils/src/mapValues.js"));
            var _fetchIntercept = _interopRequireDefault(__webpack_require__(/*! ./fetchIntercept */ "./packages/@apphub:logrocket-network/src/fetchIntercept.js"));
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    if (enumerableOnly) symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    });
                    keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i] != null ? arguments[i] : {};
                    if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                        (0, _defineProperty2.default)(target, key, source[key]);
                    });
                    else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                    else ownKeys(Object(source)).forEach(function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    });
                }
                return target;
            }
            function makeObjectFromHeaders(headers) {
                // If using real fetch, we must stringify the Headers object.
                if (headers == null || typeof headers.forEach !== "function") return headers;
                var result = {};
                headers.forEach(function(value, key) {
                    if (result[key]) result[key] = "".concat(result[key], ",").concat(value);
                    else result[key] = "".concat(value);
                });
                return result;
            } // XHR specification is unclear of what types to allow in value so using toString method for now
            var stringifyHeaders = function stringifyHeaders(headers) {
                return (0, _mapValues.default)(makeObjectFromHeaders(headers), function(value) {
                    return "".concat(value);
                });
            };
            function pluckFetchFields() {
                var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return {
                    url: arg.url,
                    headers: stringifyHeaders(arg.headers),
                    method: arg.method && arg.method.toUpperCase(),
                    referrer: arg.referrer || undefined,
                    mode: arg.mode || undefined,
                    credentials: arg.credentials || undefined
                };
            }
            function registerFetch(_ref) {
                var addRequest = _ref.addRequest, addResponse = _ref.addResponse, isIgnored = _ref.isIgnored;
                var LOGROCKET_FETCH_LABEL = "fetch-";
                var fetchMethodMap = {};
                var unregister = _fetchIntercept.default.register({
                    request: function request(fetchId) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        var p;
                        if (typeof Request !== "undefined" && args[0] instanceof Request) {
                            var clonedText; // Request.clone() and Request.text() may throw in Safari (e.g., when
                            // request body contains FormData)
                            try {
                                clonedText = args[0].clone().text();
                            } catch (err) {
                                // if a browser supports fetch, it supports promise
                                // eslint-disable-next-line compat/compat
                                clonedText = Promise.resolve("LogRocket fetch error: ".concat(err.message));
                            }
                            p = clonedText.then(function(body) {
                                return _objectSpread(_objectSpread({}, pluckFetchFields(args[0])), {}, {
                                    body: body
                                });
                            }, function(err) {
                                return _objectSpread(_objectSpread({}, pluckFetchFields(args[0])), {}, {
                                    body: "LogRocket fetch error: ".concat(err.message)
                                });
                            });
                        } else // if a browser supports fetch, it supports promise
                        // eslint-disable-next-line compat/compat
                        p = Promise.resolve(_objectSpread(_objectSpread({}, pluckFetchFields(args[1])), {}, {
                            url: "".concat(args[0]),
                            body: (args[1] || {}).body
                        }));
                        return p.then(function(req) {
                            fetchMethodMap[fetchId] = req.method;
                            addRequest("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), req);
                            return args;
                        });
                    },
                    requestError: function requestError(fetchId, error) {
                        // if a browser supports fetch, it supports promise
                        // eslint-disable-next-line compat/compat
                        return Promise.reject(error);
                    },
                    response: function response(fetchId, _response) {
                        var clonedText;
                        if (isIgnored("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId))) // Don't even try to read ignored requests
                        return _response;
                        try {
                            // TODO: enhance function on original response and future clones for:
                            // text(), json(), blob(), formdata(), arraybuffer()
                            clonedText = _response.clone().text();
                        } catch (err) {
                            // safari has a bug where cloning can fail
                            // if a browser supports fetch, it supports promise
                            // eslint-disable-next-line compat/compat
                            clonedText = Promise.resolve("LogRocket fetch error: ".concat(err.message));
                        }
                        clonedText.catch(function(error) {
                            // don't drop request & log to console when the request is aborted,
                            // as it may have already completed
                            // https://github.com/LogRocket/logrocket/issues/34
                            if (error.name === "AbortError" && error instanceof DOMException) return;
                            throw error;
                        }).then(function(data) {
                            var responseHash = {
                                url: _response.url,
                                status: _response.status,
                                headers: stringifyHeaders(_response.headers),
                                body: data,
                                method: fetchMethodMap[fetchId]
                            };
                            delete fetchMethodMap[fetchId];
                            addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), responseHash);
                        });
                        return _response;
                    },
                    responseError: function responseError(fetchId, error) {
                        var response = {
                            url: undefined,
                            status: 0,
                            headers: {},
                            body: "".concat(error)
                        };
                        addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), response); // if a browser supports fetch, it supports promise
                        // eslint-disable-next-line compat/compat
                        return Promise.reject(error);
                    }
                });
                return unregister;
            }
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/@apphub:logrocket-network/src/registerNetworkInformation.js": /*!******************************************************************************!*\
  !*** ./packages/@apphub:logrocket-network/src/registerNetworkInformation.js ***!
  \******************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = registerNetworkInformation;
            var EFFECTIVE_TYPE_VALS = {
                "slow-2g": "SLOW2G",
                "2g": "TWOG",
                "3g": "THREEG",
                "4g": "FOURG"
            };
            function registerNetworkInformation(logger) {
                var lastStatus = undefined;
                function sendNetworkInformation() {
                    var newStatus = {
                        online: window.navigator.onLine,
                        effectiveType: "UNKOWN"
                    };
                    if (!window.navigator.onLine) newStatus.effectiveType = "NONE";
                    else if (window.navigator.connection && window.navigator.connection.effectiveType) newStatus.effectiveType = EFFECTIVE_TYPE_VALS[window.navigator.connection.effectiveType] || "UNKNOWN";
                    if (lastStatus && newStatus.online === lastStatus.online && newStatus.effectiveType === lastStatus.effectiveType) return;
                    lastStatus = newStatus;
                    logger.addEvent("lr.network.NetworkStatusEvent", function() {
                        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled;
                        if (!isEnabled) return null;
                        return newStatus;
                    });
                }
                setTimeout(sendNetworkInformation);
                if (window.navigator.connection && typeof window.navigator.connection.addEventListener === "function") window.navigator.connection.addEventListener("change", sendNetworkInformation);
                window.addEventListener("online", sendNetworkInformation);
                window.addEventListener("offline", sendNetworkInformation);
                return function() {
                    window.removeEventListener("offline", sendNetworkInformation);
                    window.removeEventListener("online", sendNetworkInformation);
                    if (window.navigator.connection && typeof window.navigator.connection.removeEventListener === "function") window.navigator.connection.removeEventListener("change", sendNetworkInformation);
                };
            }
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/@apphub:logrocket-network/src/registerXHR.js": /*!***************************************************************!*\
  !*** ./packages/@apphub:logrocket-network/src/registerXHR.js ***!
  \***************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.setActive = setActive;
            exports.default = registerXHR;
            var _mapValues = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/mapValues */ "./packages/@apphub:logrocket-utils/src/mapValues.js"));
            var _enhanceFunc = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/enhanceFunc */ "./packages/@apphub:logrocket-utils/src/enhanceFunc.js"));
            var _startsWith = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/startsWith */ "./packages/@apphub:logrocket-utils/src/startsWith.js"));
            var _nps = __webpack_require__(/*! @apphub/logrocket-utils/src/constants/nps */ "./packages/@apphub:logrocket-utils/src/constants/nps.js");
            // eslint-disable-line no-restricted-imports
            // eslint-disable-line no-restricted-imports
            // eslint-disable-line no-restricted-imports
            var isActive = true;
            function setActive(shouldBeActive) {
                isActive = shouldBeActive;
            }
            var currentXHRId = 0;
            function registerXHR(_ref) {
                var addRequest = _ref.addRequest, addResponse = _ref.addResponse, isIgnored = _ref.isIgnored, logger = _ref.logger, _ref$shouldAugmentNPS = _ref.shouldAugmentNPS, shouldAugmentNPS = _ref$shouldAugmentNPS === void 0 ? true : _ref$shouldAugmentNPS, _ref$shouldParseXHRBl = _ref.shouldParseXHRBlob, shouldParseXHRBlob = _ref$shouldParseXHRBl === void 0 ? false : _ref$shouldParseXHRBl;
                var _XHR = XMLHttpRequest;
                var xhrMap = new WeakMap();
                var unsubscribedFromXhr = false;
                var LOGROCKET_XHR_LABEL = "xhr-";
                window._lrXMLHttpRequest = XMLHttpRequest; // eslint-disable-next-line no-native-reassign
                XMLHttpRequest = function XMLHttpRequest1(mozAnon, mozSystem) {
                    var xhrObject = new _XHR(mozAnon, mozSystem);
                    if (!isActive) return xhrObject;
                    xhrMap.set(xhrObject, {
                        xhrId: ++currentXHRId,
                        headers: {}
                    });
                    var openOriginal = xhrObject.open;
                    function openShim() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        try {
                            var url = args[1];
                            if (window.URL && typeof window.URL === "function" && url.search(_nps.WOOTRIC_RESPONSES_REGEX) === 0) {
                                var logrocketSessionURL = new window.URL(logger.recordingURL);
                                logrocketSessionURL.searchParams.set("nps", "wootric");
                                var urlObj = new window.URL(url);
                                var responseText = urlObj.searchParams.get("response[text]");
                                var feedback = responseText ? "".concat(responseText, "\n\n") : "";
                                urlObj.searchParams.set("response[text]", "".concat(feedback, "<").concat(logrocketSessionURL.href, "|View LogRocket session>"));
                                args[1] = urlObj.href; // eslint-disable-line no-param-reassign
                            }
                        } catch (e) {
                        /* do nothing */ }
                        return openOriginal.apply(this, args);
                    }
                    var sendOriginal = xhrObject.send;
                    function sendShim() {
                        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                        try {
                            var currentXHR = xhrMap.get(xhrObject);
                            if (window.URL && typeof window.URL === "function" && currentXHR && currentXHR.url && currentXHR.url.search(_nps.DELIGHTED_RESPONSES_REGEX) === 0 && args.length && args[0].indexOf(_nps.DELIGHTED_FEEDBACK_PREFIX) !== -1) {
                                var recordingURL = new window.URL(logger.recordingURL);
                                recordingURL.searchParams.set("nps", "delighted");
                                var logrocketSessionURL = encodeURIComponent(recordingURL.href);
                                var data = args[0].split("&").map(function(dataString) {
                                    if ((0, _startsWith.default)(dataString, _nps.DELIGHTED_FEEDBACK_PREFIX)) {
                                        var isEmpty = dataString === _nps.DELIGHTED_FEEDBACK_PREFIX;
                                        return "".concat(dataString).concat(isEmpty ? "" : "\n\n", "<").concat(logrocketSessionURL, "|View LogRocket session>");
                                    }
                                    return dataString;
                                }).join("&");
                                args[0] = data; // eslint-disable-line no-param-reassign
                            }
                        } catch (e) {
                        /* do nothing */ }
                        return sendOriginal.apply(this, args);
                    }
                    if (shouldAugmentNPS) {
                        xhrObject.open = openShim;
                        xhrObject.send = sendShim;
                    } // ..., 'open', (method, url, async, username, password) => {
                    (0, _enhanceFunc.default)(xhrObject, "open", function(method, url) {
                        if (unsubscribedFromXhr) return;
                        var currentXHR = xhrMap.get(xhrObject);
                        currentXHR.method = method;
                        currentXHR.url = url;
                    });
                    (0, _enhanceFunc.default)(xhrObject, "send", function(data) {
                        if (unsubscribedFromXhr) return;
                        var currentXHR = xhrMap.get(xhrObject);
                        if (!currentXHR) return;
                        var request = {
                            url: currentXHR.url,
                            method: currentXHR.method && currentXHR.method.toUpperCase(),
                            headers: (0, _mapValues.default)(currentXHR.headers || {}, function(headerValues) {
                                return headerValues.join(", ");
                            }),
                            body: data
                        };
                        addRequest("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), request);
                    });
                    (0, _enhanceFunc.default)(xhrObject, "setRequestHeader", function(header, value) {
                        if (unsubscribedFromXhr) return;
                        var currentXHR = xhrMap.get(xhrObject);
                        if (!currentXHR) return;
                        currentXHR.headers = currentXHR.headers || {};
                        currentXHR.headers[header] = currentXHR.headers[header] || [];
                        currentXHR.headers[header].push(value);
                    });
                    var xhrListeners = {
                        readystatechange: function readystatechange() {
                            if (unsubscribedFromXhr) return;
                            if (xhrObject.readyState === 4) {
                                var currentXHR = xhrMap.get(xhrObject);
                                if (!currentXHR) return;
                                 // Do not read ignored requests at all.
                                if (isIgnored("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId))) return;
                                var headerString = xhrObject.getAllResponseHeaders() || "";
                                var headers = headerString.split(/[\r\n]+/).reduce(function(previous, current) {
                                    var next = previous;
                                    var headerParts = current.split(": ");
                                    if (headerParts.length > 0) {
                                        var key = headerParts.shift(); // first index of the array
                                        var value = headerParts.join(": "); // rest of the array repaired
                                        if (previous[key]) next[key] += ", ".concat(value);
                                        else next[key] = value;
                                    }
                                    return next;
                                }, {});
                                var body; // IE 11 sometimes throws when trying to access large responses
                                try {
                                    switch(xhrObject.responseType){
                                        case "json":
                                            body = logger._shouldCloneResponse ? JSON.parse(JSON.stringify(xhrObject.response)) : xhrObject.response;
                                            break;
                                        case "arraybuffer":
                                        case "blob":
                                            body = xhrObject.response;
                                            break;
                                        case "document":
                                            body = xhrObject.responseXML;
                                            break;
                                        case "text":
                                        case "":
                                            body = xhrObject.responseText;
                                            break;
                                        default:
                                            body = "";
                                    }
                                } catch (err) {
                                    body = "LogRocket: Error accessing response.";
                                }
                                var response = {
                                    url: currentXHR.url,
                                    status: xhrObject.status,
                                    headers: headers,
                                    body: body,
                                    method: (currentXHR.method || "").toUpperCase()
                                };
                                if (shouldParseXHRBlob && response.body instanceof Blob) {
                                    var blobReader = new FileReader();
                                    blobReader.readAsText(response.body);
                                    blobReader.onload = function() {
                                        try {
                                            response.body = JSON.parse(blobReader.result);
                                        } catch (_unused) {} // eslint-disable-line no-empty
                                        addResponse("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), response);
                                    };
                                } else addResponse("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), response);
                            }
                        } // // Unused Event Listeners
                    };
                    Object.keys(xhrListeners).forEach(function(key) {
                        xhrObject.addEventListener(key, xhrListeners[key]);
                    });
                    return xhrObject;
                }; // this allows "instanceof XMLHttpRequest" to work
                XMLHttpRequest.prototype = _XHR.prototype; // Persist the static variables.
                [
                    "UNSENT",
                    "OPENED",
                    "HEADERS_RECEIVED",
                    "LOADING",
                    "DONE"
                ].forEach(function(variable) {
                    XMLHttpRequest[variable] = _XHR[variable];
                });
                return function() {
                    unsubscribedFromXhr = true; // eslint-disable-next-line no-native-reassign
                    XMLHttpRequest = _XHR;
                };
            }
        /***/ },
        /***/ "./packages/@apphub:logrocket-redux/src/createEnhancer.js": /*!****************************************************************!*\
  !*** ./packages/@apphub:logrocket-redux/src/createEnhancer.js ***!
  \****************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = createEnhancer;
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
            var _now = _interopRequireDefault(__webpack_require__(/*! @apphub/now */ "./packages/@apphub:now/src/index.js"));
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    if (enumerableOnly) symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    });
                    keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i] != null ? arguments[i] : {};
                    if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                        (0, _defineProperty2.default)(target, key, source[key]);
                    });
                    else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                    else ownKeys(Object(source)).forEach(function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    });
                }
                return target;
            }
            var storeIdCounter = 0;
            function createEnhancer(logger) {
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$stateSanitizer = _ref.stateSanitizer, stateSanitizer = _ref$stateSanitizer === void 0 ? function(f) {
                    return f;
                } : _ref$stateSanitizer, _ref$actionSanitizer = _ref.actionSanitizer, actionSanitizer = _ref$actionSanitizer === void 0 ? function(f) {
                    return f;
                } : _ref$actionSanitizer;
                // an enhancer is a function that returns a Store
                return function(createStore) {
                    return function(reducer, initialState, enhancer) {
                        var store = createStore(reducer, initialState, enhancer);
                        var originalDispatch = store.dispatch;
                        var storeId = storeIdCounter++;
                        logger.addEvent("lr.redux.InitialState", function() {
                            var sanitizedState;
                            try {
                                // only try catch user defined functions
                                sanitizedState = stateSanitizer(store.getState());
                            } catch (err) {
                                console.error(err.toString());
                            }
                            return {
                                state: sanitizedState,
                                storeId: storeId
                            };
                        });
                        var dispatch = function dispatch(action) {
                            var start = (0, _now.default)();
                            var err;
                            var res;
                            try {
                                res = originalDispatch(action);
                            } catch (_err) {
                                err = _err;
                            } finally{
                                var duration = (0, _now.default)() - start;
                                logger.addEvent("lr.redux.ReduxAction", function() {
                                    var sanitizedState = null;
                                    var sanitizedAction = null;
                                    try {
                                        // only try catch user defined functions
                                        sanitizedState = stateSanitizer(store.getState());
                                        sanitizedAction = actionSanitizer(action);
                                    } catch (err) {
                                        console.error(err.toString());
                                    }
                                    if (sanitizedState && sanitizedAction) return {
                                        storeId: storeId,
                                        action: sanitizedAction,
                                        duration: duration,
                                        stateDelta: sanitizedState
                                    };
                                    return null;
                                });
                            }
                            if (err) throw err;
                            return res;
                        };
                        return _objectSpread(_objectSpread({}, store), {}, {
                            dispatch: dispatch
                        });
                    };
                };
            }
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/@apphub:logrocket-redux/src/createMiddleware.js": /*!******************************************************************!*\
  !*** ./packages/@apphub:logrocket-redux/src/createMiddleware.js ***!
  \******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = createMiddleware;
            var _now = _interopRequireDefault(__webpack_require__(/*! @apphub/now */ "./packages/@apphub:now/src/index.js"));
            var storeIdCounter = 0;
            function createMiddleware(logger) {
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$stateSanitizer = _ref.stateSanitizer, stateSanitizer = _ref$stateSanitizer === void 0 ? function(f) {
                    return f;
                } : _ref$stateSanitizer, _ref$actionSanitizer = _ref.actionSanitizer, actionSanitizer = _ref$actionSanitizer === void 0 ? function(f) {
                    return f;
                } : _ref$actionSanitizer;
                return function(store) {
                    var storeId = storeIdCounter++;
                    logger.addEvent("lr.redux.InitialState", function() {
                        var sanitizedState;
                        try {
                            // only try catch user defined functions
                            sanitizedState = stateSanitizer(store.getState());
                        } catch (err) {
                            console.error(err.toString());
                        }
                        return {
                            state: sanitizedState,
                            storeId: storeId
                        };
                    });
                    return function(next) {
                        return function(action) {
                            var start = (0, _now.default)();
                            var err;
                            var res;
                            try {
                                res = next(action);
                            } catch (_err) {
                                err = _err;
                            } finally{
                                var duration = (0, _now.default)() - start;
                                logger.addEvent("lr.redux.ReduxAction", function() {
                                    var sanitizedState = null;
                                    var sanitizedAction = null;
                                    try {
                                        // only try catch user defined functions
                                        sanitizedState = stateSanitizer(store.getState());
                                        sanitizedAction = actionSanitizer(action);
                                    } catch (err) {
                                        console.error(err.toString());
                                    }
                                    if (sanitizedState && sanitizedAction) return {
                                        storeId: storeId,
                                        action: sanitizedAction,
                                        duration: duration,
                                        stateDelta: sanitizedState
                                    };
                                    return null;
                                });
                            }
                            if (err) throw err;
                            return res;
                        };
                    };
                };
            }
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/@apphub:logrocket-redux/src/index.js": /*!*******************************************************!*\
  !*** ./packages/@apphub:logrocket-redux/src/index.js ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            Object.defineProperty(exports, "createEnhancer", {
                enumerable: true,
                get: function get() {
                    return _createEnhancer.default;
                }
            });
            Object.defineProperty(exports, "createMiddleware", {
                enumerable: true,
                get: function get() {
                    return _createMiddleware.default;
                }
            });
            var _createEnhancer = _interopRequireDefault(__webpack_require__(/*! ./createEnhancer */ "./packages/@apphub:logrocket-redux/src/createEnhancer.js"));
            var _createMiddleware = _interopRequireDefault(__webpack_require__(/*! ./createMiddleware */ "./packages/@apphub:logrocket-redux/src/createMiddleware.js"));
        /***/ },
        /***/ "./packages/@apphub:logrocket-utils/src/TraceKit.js": /*!**********************************************************!*\
  !*** ./packages/@apphub:logrocket-utils/src/TraceKit.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(global) {
                /*
 TraceKit - Cross brower stack traces - github.com/occ/TraceKit

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var TraceKit = {
                    collectWindowErrors: true,
                    debug: false
                }; // This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
                var _window = typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {}; // global reference to slice
                var _slice = [].slice;
                var UNKNOWN_FUNCTION = "?"; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
                var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;
                function getLocationHref() {
                    if (typeof document === "undefined" || typeof document.location === "undefined") return "";
                    return document.location.href;
                }
                /**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */ TraceKit.report = function reportModuleWrapper() {
                    var handlers = [], lastArgs = null, lastException = null, lastExceptionStack = null;
                    /**
   * Add a crash handler.
   * @param {Function} handler
   */ function subscribe(handler) {
                        installGlobalHandler();
                        handlers.push(handler);
                    }
                    /**
   * Remove a crash handler.
   * @param {Function} handler
   */ function unsubscribe(handler) {
                        for(var i = handlers.length - 1; i >= 0; --i)if (handlers[i] === handler) handlers.splice(i, 1);
                    }
                    /**
   * Remove all crash handlers.
   */ function unsubscribeAll() {
                        uninstallGlobalHandler();
                        handlers = [];
                    }
                    /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */ function notifyHandlers(stack, isWindowError) {
                        var exception = null;
                        if (isWindowError && !TraceKit.collectWindowErrors) return;
                        for(var i in handlers){
                            if (handlers.hasOwnProperty(i)) try {
                                handlers[i].apply(null, [
                                    stack
                                ].concat(_slice.call(arguments, 2)));
                            } catch (inner) {
                                exception = inner;
                            }
                        }
                        if (exception) throw exception;
                    }
                    var _oldOnerrorHandler, _onErrorHandlerInstalled;
                    /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} message Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */ function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
                        var stack = null;
                        if (lastExceptionStack) {
                            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
                            processLastException();
                        } else if (ex) {
                            // New chrome and blink send along a real error object
                            // Let's just report that like a normal error.
                            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
                            stack = TraceKit.computeStackTrace(ex);
                            notifyHandlers(stack, true);
                        } else {
                            var location = {
                                "url": url,
                                "line": lineNo,
                                "column": colNo
                            };
                            var name = undefined;
                            var msg = message; // must be new var or will modify original `arguments`
                            var groups;
                            if (({}).toString.call(message) === "[object String]") {
                                var groups = message.match(ERROR_TYPES_RE);
                                if (groups) {
                                    name = groups[1];
                                    msg = groups[2];
                                }
                            }
                            location.func = UNKNOWN_FUNCTION;
                            stack = {
                                "name": name,
                                "message": msg,
                                "url": getLocationHref(),
                                "stack": [
                                    location
                                ]
                            };
                            notifyHandlers(stack, true);
                        }
                        if (_oldOnerrorHandler) return _oldOnerrorHandler.apply(this, arguments);
                        return false;
                    }
                    function installGlobalHandler() {
                        if (_onErrorHandlerInstalled) return;
                        _oldOnerrorHandler = _window.onerror;
                        _window.onerror = traceKitWindowOnError;
                        _onErrorHandlerInstalled = true;
                    }
                    function uninstallGlobalHandler() {
                        if (!_onErrorHandlerInstalled) return;
                        _window.onerror = _oldOnerrorHandler;
                        _onErrorHandlerInstalled = false;
                        _oldOnerrorHandler = undefined;
                    }
                    function processLastException() {
                        var _lastExceptionStack = lastExceptionStack, _lastArgs = lastArgs;
                        lastArgs = null;
                        lastExceptionStack = null;
                        lastException = null;
                        notifyHandlers.apply(null, [
                            _lastExceptionStack,
                            false
                        ].concat(_lastArgs));
                    }
                    /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */ function report(ex, rethrow) {
                        var args = _slice.call(arguments, 1);
                        if (lastExceptionStack) {
                            if (lastException === ex) return; // already caught by an inner catch block, ignore
                            else processLastException();
                        }
                        var stack = TraceKit.computeStackTrace(ex);
                        lastExceptionStack = stack;
                        lastException = ex;
                        lastArgs = args; // If the stack trace is incomplete, wait for 2 seconds for
                        // slow slow IE to see if onerror occurs or not before reporting
                        // this exception; otherwise, we will end up with an incomplete
                        // stack trace
                        setTimeout(function() {
                            if (lastException === ex) processLastException();
                        }, stack.incomplete ? 2000 : 0);
                        if (rethrow !== false) throw ex; // re-throw to propagate to the top level (and cause window.onerror)
                    }
                    report.subscribe = subscribe;
                    report.unsubscribe = unsubscribe;
                    report.uninstall = unsubscribeAll;
                    return report;
                }();
                /**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */ TraceKit.computeStackTrace = function computeStackTraceWrapper() {
                    /**
   * Escapes special characters, except for whitespace, in a string to be
   * used inside a regular expression as a string literal.
   * @param {string} text The string.
   * @return {string} The escaped string literal.
   */ function escapeRegExp(text) {
                        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, "\\$&");
                    }
                    /**
   * Escapes special characters in a string to be used inside a regular
   * expression as a string literal. Also ensures that HTML entities will
   * be matched the same as their literal friends.
   * @param {string} body The string.
   * @return {string} The escaped string.
   */ function escapeCodeAsRegExpForMatchingInsideHTML(body) {
                        return escapeRegExp(body).replace("<", "(?:<|&lt;)").replace(">", "(?:>|&gt;)").replace("&", "(?:&|&amp;)").replace('"', '(?:"|&quot;)').replace(/\s+/g, "\\s+");
                    } // Contents of Exception in various browsers.
                    //
                    // SAFARI:
                    // ex.message = Can't find variable: qq
                    // ex.line = 59
                    // ex.sourceId = 580238192
                    // ex.sourceURL = http://...
                    // ex.expressionBeginOffset = 96
                    // ex.expressionCaretOffset = 98
                    // ex.expressionEndOffset = 98
                    // ex.name = ReferenceError
                    //
                    // FIREFOX:
                    // ex.message = qq is not defined
                    // ex.fileName = http://...
                    // ex.lineNumber = 59
                    // ex.columnNumber = 69
                    // ex.stack = ...stack trace... (see the example below)
                    // ex.name = ReferenceError
                    //
                    // CHROME:
                    // ex.message = qq is not defined
                    // ex.name = ReferenceError
                    // ex.type = not_defined
                    // ex.arguments = ['aa']
                    // ex.stack = ...stack trace...
                    //
                    // INTERNET EXPLORER:
                    // ex.message = ...
                    // ex.name = ReferenceError
                    //
                    // OPERA:
                    // ex.message = ...message... (see the example below)
                    // ex.name = ReferenceError
                    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
                    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
                    /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */ function computeStackTraceFromStackProp(ex) {
                        if (typeof ex.stack === "undefined" || !ex.stack) return;
                        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i, winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, lines = ex.stack.split("\n"), stack = [], parts, element, reference = /^(.*) is undefined$/.exec(ex.message);
                        for(var i = 0, j = lines.length; i < j; ++i){
                            if (parts = chrome.exec(lines[i])) {
                                var isNative = parts[2] && parts[2].indexOf("native") !== -1;
                                element = {
                                    "url": !isNative ? parts[2] : null,
                                    "func": parts[1] || UNKNOWN_FUNCTION,
                                    "args": isNative ? [
                                        parts[2]
                                    ] : [],
                                    "line": parts[3] ? +parts[3] : null,
                                    "column": parts[4] ? +parts[4] : null
                                };
                            } else if (parts = winjs.exec(lines[i])) element = {
                                "url": parts[2],
                                "func": parts[1] || UNKNOWN_FUNCTION,
                                "args": [],
                                "line": +parts[3],
                                "column": parts[4] ? +parts[4] : null
                            };
                            else if (parts = gecko.exec(lines[i])) element = {
                                "url": parts[3],
                                "func": parts[1] || UNKNOWN_FUNCTION,
                                "args": parts[2] ? parts[2].split(",") : [],
                                "line": parts[4] ? +parts[4] : null,
                                "column": parts[5] ? +parts[5] : null
                            };
                            else continue;
                            if (!element.func && element.line) element.func = UNKNOWN_FUNCTION;
                            stack.push(element);
                        }
                        if (!stack.length) return null;
                        if (!stack[0].column && typeof ex.columnNumber !== "undefined") // FireFox uses this awesome columnNumber property for its top frame
                        // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                        // so adding 1
                        stack[0].column = ex.columnNumber + 1;
                        return {
                            "name": ex.name,
                            "message": ex.message,
                            "url": getLocationHref(),
                            "stack": stack
                        };
                    }
                    /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */ function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
                        var initial = {
                            "url": url,
                            "line": lineNo
                        };
                        if (initial.url && initial.line) {
                            stackInfo.incomplete = false;
                            if (!initial.func) initial.func = UNKNOWN_FUNCTION;
                            if (stackInfo.stack.length > 0) {
                                if (stackInfo.stack[0].url === initial.url) {
                                    if (stackInfo.stack[0].line === initial.line) return false; // already in stack trace
                                    else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                                        stackInfo.stack[0].line = initial.line;
                                        return false;
                                    }
                                }
                            }
                            stackInfo.stack.unshift(initial);
                            stackInfo.partial = true;
                            return true;
                        } else stackInfo.incomplete = true;
                        return false;
                    }
                    /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */ function computeStackTraceByWalkingCallerChain(ex, depth) {
                        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i, stack = [], funcs = {}, recursion = false, parts, item, source;
                        for(var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller){
                            if (curr === computeStackTrace || curr === TraceKit.report) continue;
                            item = {
                                "url": null,
                                "func": UNKNOWN_FUNCTION,
                                "line": null,
                                "column": null
                            };
                            if (curr.name) item.func = curr.name;
                            else if (parts = functionName.exec(curr.toString())) item.func = parts[1];
                            if (typeof item.func === "undefined") try {
                                item.func = parts.input.substring(0, parts.input.indexOf("{"));
                            } catch (e) {}
                            if (funcs["" + curr]) recursion = true;
                            else funcs["" + curr] = true;
                            stack.push(item);
                        }
                        if (depth) // console.log('depth is ' + depth);
                        // console.log('stack is ' + stack.length);
                        stack.splice(0, depth);
                        var result = {
                            "name": ex.name,
                            "message": ex.message,
                            "url": getLocationHref(),
                            "stack": stack
                        };
                        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
                        return result;
                    }
                    /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */ function computeStackTrace(ex, depth) {
                        var stack = null;
                        depth = depth == null ? 0 : +depth;
                        try {
                            stack = computeStackTraceFromStackProp(ex);
                            if (stack) return stack;
                        } catch (e) {
                            if (TraceKit.debug) throw e;
                        }
                        try {
                            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
                            if (stack) return stack;
                        } catch (e) {
                            if (TraceKit.debug) throw e;
                        }
                        return {
                            "name": ex.name,
                            "message": ex.message,
                            "url": getLocationHref()
                        };
                    }
                    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
                    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
                    return computeStackTrace;
                }();
                var _default = TraceKit;
                exports.default = _default;
                module1.exports = exports.default;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(/*! ./../../../node_modules/webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"));
        /***/ },
        /***/ "./packages/@apphub:logrocket-utils/src/constants/nps.js": /*!***************************************************************!*\
  !*** ./packages/@apphub:logrocket-utils/src/constants/nps.js ***!
  \***************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.DELIGHTED_FEEDBACK_PREFIX = exports.DELIGHTED_RESPONSES_REGEX = exports.WOOTRIC_RESPONSES_REGEX = void 0;
            var WOOTRIC_RESPONSES_REGEX = /^https:\/\/production.wootric.com\/responses/;
            exports.WOOTRIC_RESPONSES_REGEX = WOOTRIC_RESPONSES_REGEX;
            var DELIGHTED_RESPONSES_REGEX = /^https:\/\/web.delighted.com\/e\/[a-zA-Z-]*\/c/;
            exports.DELIGHTED_RESPONSES_REGEX = DELIGHTED_RESPONSES_REGEX;
            var DELIGHTED_FEEDBACK_PREFIX = "comment=";
            exports.DELIGHTED_FEEDBACK_PREFIX = DELIGHTED_FEEDBACK_PREFIX;
        /***/ },
        /***/ "./packages/@apphub:logrocket-utils/src/enhanceFunc.js": /*!*************************************************************!*\
  !*** ./packages/@apphub:logrocket-utils/src/enhanceFunc.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = enhanceFunc;
            /* eslint no-param-reassign: ["error", { "props": false }] */ function enhanceFunc(obj, method, handler) {
                var original = obj[method];
                function shim() {
                    var res;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    if (original) res = original.apply(this, args);
                    handler.apply(this, args);
                    return res;
                }
                obj[method] = shim;
                return function() {
                    obj[method] = original;
                };
            }
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/@apphub:logrocket-utils/src/mapValues.js": /*!***********************************************************!*\
  !*** ./packages/@apphub:logrocket-utils/src/mapValues.js ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = mapValues;
            function mapValues(obj, f) {
                if (obj == null) return {};
                var res = {};
                Object.keys(obj).forEach(function(key) {
                    res[key] = f(obj[key]);
                });
                return res;
            }
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/@apphub:logrocket-utils/src/startsWith.js": /*!************************************************************!*\
  !*** ./packages/@apphub:logrocket-utils/src/startsWith.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = startsWith;
            function startsWith(value, search) {
                var pos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                return value && search && value.substring(pos, pos + search.length) === search;
            }
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/@apphub:now/src/index.js": /*!*******************************************!*\
  !*** ./packages/@apphub:now/src/index.js ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = void 0;
            /* eslint-disable compat/compat */ var dateNow = Date.now.bind(Date);
            var loadTime = dateNow();
            var _default = typeof performance !== "undefined" && performance.now ? performance.now.bind(performance) : function() {
                return dateNow() - loadTime;
            };
            exports.default = _default;
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/logrocket/src/LogRocket.js": /*!*********************************************!*\
  !*** ./packages/logrocket/src/LogRocket.js ***!
  \*********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.MAX_QUEUE_SIZE = void 0;
            var _classCallCheck2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js"));
            var _createClass2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js"));
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
            var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));
            var _logrocketNetwork = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-network */ "./packages/@apphub:logrocket-network/src/index.js"));
            var _logrocketExceptions = __webpack_require__(/*! @apphub/logrocket-exceptions */ "./packages/@apphub:logrocket-exceptions/src/index.js");
            var _logrocketConsole = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-console */ "./packages/@apphub:logrocket-console/src/index.js"));
            var _logrocketRedux = __webpack_require__(/*! @apphub/logrocket-redux */ "./packages/@apphub:logrocket-redux/src/index.js");
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    if (enumerableOnly) symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    });
                    keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i] != null ? arguments[i] : {};
                    if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                        (0, _defineProperty2.default)(target, key, source[key]);
                    });
                    else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                    else ownKeys(Object(source)).forEach(function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    });
                }
                return target;
            }
            var MAX_QUEUE_SIZE = 1000;
            exports.MAX_QUEUE_SIZE = MAX_QUEUE_SIZE;
            var considerIngestServerOption = function considerIngestServerOption() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, ingestServer = _ref.ingestServer, options = (0, _objectWithoutProperties2.default)(_ref, [
                    "ingestServer"
                ]);
                if (ingestServer) return _objectSpread({
                    serverURL: "".concat(ingestServer, "/i"),
                    statsURL: "".concat(ingestServer, "/s")
                }, options);
                return options;
            };
            var LogRocket = /*#__PURE__*/ function() {
                function LogRocket() {
                    var _this = this;
                    (0, _classCallCheck2.default)(this, LogRocket);
                    this._buffer = [];
                    // TODO: tests for these exposed methods.
                    [
                        "log",
                        "info",
                        "warn",
                        "error",
                        "debug"
                    ].forEach(function(method) {
                        _this[method] = function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            _this.addEvent("lr.core.LogEvent", function() {
                                var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                if (method === "error" && consoleOptions.shouldAggregateConsoleErrors) _logrocketExceptions.Capture.captureMessage(_this, args[0], {}, true);
                                return {
                                    logLevel: method.toUpperCase(),
                                    args: args
                                };
                            }, {
                                shouldCaptureStackTrace: true
                            });
                        };
                    });
                    this._isInitialized = false;
                    this._installed = []; // expose a callback to get the session URL from the global context
                    window._lr_surl_cb = this.getSessionURL.bind(this);
                }
                (0, _createClass2.default)(LogRocket, [
                    {
                        key: "addEvent",
                        value: function addEvent(type, getMessage) {
                            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            var time = Date.now();
                            this._run(function(logger) {
                                logger.addEvent(type, getMessage, _objectSpread(_objectSpread({}, opts), {}, {
                                    timeOverride: time
                                }));
                            });
                        }
                    },
                    {
                        key: "onLogger",
                        value: function onLogger(logger) {
                            this._logger = logger;
                            while(this._buffer.length > 0){
                                var f = this._buffer.shift();
                                f(this._logger);
                            }
                        }
                    },
                    {
                        key: "_run",
                        value: function _run(f) {
                            if (this._isDisabled) return;
                            if (this._logger) f(this._logger);
                            else {
                                if (this._buffer.length >= MAX_QUEUE_SIZE) {
                                    this._isDisabled = true;
                                    console.warn("LogRocket: script did not load. Check that you have a valid network connection.");
                                    this.uninstall();
                                    return;
                                }
                                this._buffer.push(f.bind(this));
                            }
                        }
                    },
                    {
                        key: "init",
                        value: function init(appID) {
                            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            if (!this._isInitialized) {
                                var _opts$shouldAugmentNP = opts.shouldAugmentNPS, shouldAugmentNPS = _opts$shouldAugmentNP === void 0 ? true : _opts$shouldAugmentNP, _opts$shouldParseXHRB = opts.shouldParseXHRBlob, shouldParseXHRBlob = _opts$shouldParseXHRB === void 0 ? false : _opts$shouldParseXHRB;
                                this._installed.push((0, _logrocketExceptions.registerExceptions)(this));
                                this._installed.push((0, _logrocketNetwork.default)(this, {
                                    shouldAugmentNPS: !!shouldAugmentNPS,
                                    shouldParseXHRBlob: !!shouldParseXHRBlob
                                }));
                                this._installed.push((0, _logrocketConsole.default)(this));
                                this._isInitialized = true;
                                this._run(function(logger) {
                                    logger.init(appID, considerIngestServerOption(opts));
                                });
                            }
                        }
                    },
                    {
                        key: "start",
                        value: function start() {
                            this._run(function(logger) {
                                logger.start();
                            });
                        }
                    },
                    {
                        key: "uninstall",
                        value: function uninstall() {
                            this._installed.forEach(function(f) {
                                return f();
                            });
                            this._buffer = [];
                            this._run(function(logger) {
                                logger.uninstall();
                            });
                        }
                    },
                    {
                        key: "identify",
                        value: function identify(id, opts) {
                            this._run(function(logger) {
                                logger.identify(id, opts);
                            });
                        }
                    },
                    {
                        key: "startNewSession",
                        value: function startNewSession() {
                            this._run(function(logger) {
                                logger.startNewSession();
                            });
                        }
                    },
                    {
                        key: "track",
                        value: function track(customEventName, eventProperties) {
                            this._run(function(logger) {
                                logger.track(customEventName, eventProperties);
                            });
                        }
                    },
                    {
                        key: "getSessionURL",
                        value: function getSessionURL(cb) {
                            if (typeof cb !== "function") throw new Error("LogRocket: must pass callback to getSessionURL()");
                            this._run(function(logger) {
                                if (logger.getSessionURL) logger.getSessionURL(cb);
                                else cb(logger.recordingURL);
                            });
                        }
                    },
                    {
                        key: "getVersion",
                        value: function getVersion(cb) {
                            this._run(function(logger) {
                                cb(logger.version);
                            });
                        }
                    },
                    {
                        key: "captureMessage",
                        value: function captureMessage(message) {
                            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            _logrocketExceptions.Capture.captureMessage(this, message, options);
                        }
                    },
                    {
                        key: "captureException",
                        value: function captureException(exception) {
                            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            _logrocketExceptions.Capture.captureException(this, exception, options);
                        }
                    },
                    {
                        key: "version",
                        get: function get() {
                            return this._logger && this._logger.version;
                        }
                    },
                    {
                        key: "sessionURL",
                        get: function get() {
                            return this._logger && this._logger.recordingURL;
                        }
                    },
                    {
                        key: "recordingURL",
                        get: function get() {
                            return this._logger && this._logger.recordingURL;
                        }
                    },
                    {
                        key: "recordingID",
                        get: function get() {
                            return this._logger && this._logger.recordingID;
                        }
                    },
                    {
                        key: "threadID",
                        get: function get() {
                            return this._logger && this._logger.threadID;
                        }
                    },
                    {
                        key: "tabID",
                        get: function get() {
                            return this._logger && this._logger.tabID;
                        }
                    },
                    {
                        key: "reduxEnhancer",
                        value: function reduxEnhancer() {
                            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            return (0, _logrocketRedux.createEnhancer)(this, options);
                        }
                    },
                    {
                        key: "reduxMiddleware",
                        value: function reduxMiddleware() {
                            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            return (0, _logrocketRedux.createMiddleware)(this, options);
                        }
                    },
                    {
                        key: "isDisabled",
                        get: function get() {
                            return !!(this._isDisabled || this._logger && this._logger._isDisabled);
                        }
                    }
                ]);
                return LogRocket;
            }();
            exports.default = LogRocket;
        /***/ },
        /***/ "./packages/logrocket/src/makeLogRocket.js": /*!*************************************************!*\
  !*** ./packages/logrocket/src/makeLogRocket.js ***!
  \*************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = makeLogRocket;
            var _LogRocket = _interopRequireDefault(__webpack_require__(/*! ./LogRocket */ "./packages/logrocket/src/LogRocket.js"));
            var REACT_NATIVE_NOTICE = "LogRocket does not yet support React Native.";
            var makeNoopPolyfill = function makeNoopPolyfill() {
                return {
                    init: function init() {},
                    uninstall: function uninstall() {},
                    log: function log() {},
                    info: function info() {},
                    warn: function warn() {},
                    error: function error() {},
                    debug: function debug() {},
                    addEvent: function addEvent() {},
                    identify: function identify() {},
                    start: function start() {},
                    get threadID () {
                        return null;
                    },
                    get recordingID () {
                        return null;
                    },
                    get recordingURL () {
                        return null;
                    },
                    reduxEnhancer: function reduxEnhancer() {
                        return function(store) {
                            return function() {
                                return store.apply(void 0, arguments);
                            };
                        };
                    },
                    reduxMiddleware: function reduxMiddleware() {
                        return function() {
                            return function(next) {
                                return function(action) {
                                    return next(action);
                                };
                            };
                        };
                    },
                    track: function track() {},
                    getSessionURL: function getSessionURL() {},
                    getVersion: function getVersion() {},
                    startNewSession: function startNewSession() {},
                    onLogger: function onLogger() {},
                    setClock: function setClock() {},
                    captureMessage: function captureMessage() {},
                    captureException: function captureException() {}
                };
            };
            function makeLogRocket() {
                var getLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function() {};
                if (typeof navigator !== "undefined" && navigator.product === "ReactNative") throw new Error(REACT_NATIVE_NOTICE);
                if (typeof window !== "undefined") {
                    if (window._disableLogRocket) return makeNoopPolyfill();
                    if (window.MutationObserver && window.WeakMap) {
                        // Save window globals that we rely on.
                        window._lrMutationObserver = window.MutationObserver;
                        var instance = new _LogRocket.default();
                        getLogger(instance);
                        return instance;
                    }
                }
                return makeNoopPolyfill();
            }
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/logrocket/src/module-npm.js": /*!**********************************************!*\
  !*** ./packages/logrocket/src/module-npm.js ***!
  \**********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = void 0;
            var _setup = _interopRequireDefault(__webpack_require__(/*! ./setup */ "./packages/logrocket/src/setup.js"));
            var instance = (0, _setup.default)();
            var _default = instance;
            exports.default = _default;
            module1.exports = exports.default;
        /***/ },
        /***/ "./packages/logrocket/src/setup.js": /*!*****************************************!*\
  !*** ./packages/logrocket/src/setup.js ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = setup;
            var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));
            var _makeLogRocket = _interopRequireDefault(__webpack_require__(/*! ./makeLogRocket */ "./packages/logrocket/src/makeLogRocket.js"));
            var CDN_SERVER_MAP = {
                "cdn.logrocket.io": "https://r.logrocket.io",
                "cdn.lr-ingest.io": "https://r.lr-ingest.io",
                "cdn.lr-in.com": "https://r.lr-in.com",
                "cdn-staging.logrocket.io": "https://staging-i.logrocket.io",
                "cdn-staging.lr-ingest.io": "https://staging-i.lr-ingest.io",
                "cdn-staging.lr-in.com": "https://staging-i.lr-in.com"
            };
            function setup() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, enterpriseServer = _ref.enterpriseServer, _ref$sdkVersion = _ref.sdkVersion, sdkVersion = _ref$sdkVersion === void 0 ? "2.2.1" : _ref$sdkVersion, opts = (0, _objectWithoutProperties2.default)(_ref, [
                    "enterpriseServer",
                    "sdkVersion"
                ]);
                var scriptOrigin = "https://cdn.logrocket.io";
                var scriptIngest;
                if (sdkVersion === "script") try {
                    // eslint-disable-next-line compat/compat
                    var scriptTag = document.currentScript;
                    var matches = scriptTag.src.match(/^(https?:\/\/([^\\]+))\/.+$/);
                    var scriptHostname = matches && matches[2];
                    if (scriptHostname && CDN_SERVER_MAP[scriptHostname]) {
                        scriptOrigin = matches && matches[1];
                        scriptIngest = CDN_SERVER_MAP[scriptHostname];
                    }
                } catch (_) {
                /* no-op */ }
                else {
                    // NPM
                    scriptOrigin = "https://cdn.lr-in.com";
                    scriptIngest = "https://r.lr-in.com";
                }
                var sdkServer = opts.sdkServer || enterpriseServer;
                var ingestServer = opts.ingestServer || enterpriseServer || scriptIngest;
                var instance = (0, _makeLogRocket.default)(function() {
                    var script = document.createElement("script");
                    if (ingestServer) {
                        if (typeof window.__SDKCONFIG__ === "undefined") window.__SDKCONFIG__ = {};
                        window.__SDKCONFIG__.serverURL = "".concat(ingestServer, "/i");
                        window.__SDKCONFIG__.statsURL = "".concat(ingestServer, "/s");
                    }
                    if (sdkServer) script.src = "".concat(sdkServer, "/logger.min.js");
                    else if (window.__SDKCONFIG__ && window.__SDKCONFIG__.loggerURL) script.src = window.__SDKCONFIG__.loggerURL;
                    else if (window._lrAsyncScript) script.src = window._lrAsyncScript;
                    else script.src = "".concat(scriptOrigin, "/logger-1.min.js");
                    script.async = true;
                    document.head.appendChild(script);
                    script.onload = function() {
                        // Brave browser: Advertises its user-agent as Chrome ##.##... then
                        // loads logger.min.js, but blocks the execution of the script
                        // causing _LRlogger to be undefined.  Let's make sure its there first.
                        if (typeof window._LRLogger === "function") instance.onLogger(new window._LRLogger({
                            sdkVersion: sdkVersion
                        }));
                        else {
                            console.warn("LogRocket: script execution has been blocked by a product or service.");
                            instance.uninstall();
                        }
                    };
                    script.onerror = function() {
                        console.warn("LogRocket: script could not load. Check that you have a valid network connection.");
                        instance.uninstall();
                    };
                });
                return instance;
            }
            module1.exports = exports.default;
        /***/ },
        /***/ 0: /*!****************************************************!*\
  !*** multi ./packages/logrocket/src/module-npm.js ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = __webpack_require__(/*! /root/project/packages/logrocket/src/module-npm.js */ "./packages/logrocket/src/module-npm.js");
        /***/ }
    });
});

});

parcelRegister("hcepo", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $c84ebbe33d4a7e6c$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureMessage", function () { return $c84ebbe33d4a7e6c$export$45654777c133ae80; });
$parcel$export(module.exports, "captureEvent", function () { return $c84ebbe33d4a7e6c$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "configureScope", function () { return $c84ebbe33d4a7e6c$export$99d44f04437e9cb8; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $c84ebbe33d4a7e6c$export$efda9a273d7a036d; });
$parcel$export(module.exports, "setContext", function () { return $c84ebbe33d4a7e6c$export$2f04de43fe27971a; });
$parcel$export(module.exports, "setExtras", function () { return $c84ebbe33d4a7e6c$export$bb4922da0dd51b92; });
$parcel$export(module.exports, "setExtra", function () { return $c84ebbe33d4a7e6c$export$8e8e7789d42ed61d; });
$parcel$export(module.exports, "setTags", function () { return $c84ebbe33d4a7e6c$export$74a8fb34822092e6; });
$parcel$export(module.exports, "setTag", function () { return $c84ebbe33d4a7e6c$export$a37d07ee78eb4569; });
$parcel$export(module.exports, "setUser", function () { return $c84ebbe33d4a7e6c$export$8b6bb3dd62a01be2; });
$parcel$export(module.exports, "withScope", function () { return $c84ebbe33d4a7e6c$export$ec58d9285c204497; });
$parcel$export(module.exports, "withIsolationScope", function () { return $c84ebbe33d4a7e6c$export$9a4fed82c350c2bd; });
$parcel$export(module.exports, "withActiveSpan", function () { return $c84ebbe33d4a7e6c$export$e57ac09b143d92a2; });
$parcel$export(module.exports, "startTransaction", function () { return $c84ebbe33d4a7e6c$export$e262da7ae6480481; });
$parcel$export(module.exports, "getCurrentScope", function () { return $c84ebbe33d4a7e6c$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getClient", function () { return $c84ebbe33d4a7e6c$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "flush", function () { return $c84ebbe33d4a7e6c$export$4909b86c8034bf73; });
$parcel$export(module.exports, "close", function () { return $c84ebbe33d4a7e6c$export$8360e631d277ea4d; });
$parcel$export(module.exports, "lastEventId", function () { return $c84ebbe33d4a7e6c$export$5d4e9fd7fac8e617; });
$parcel$export(module.exports, "isInitialized", function () { return $c84ebbe33d4a7e6c$export$3f95c6f800b78024; });
$parcel$export(module.exports, "startSession", function () { return $c84ebbe33d4a7e6c$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "endSession", function () { return $c84ebbe33d4a7e6c$export$17a5be43989a0bc1; });
$parcel$export(module.exports, "captureSession", function () { return $c84ebbe33d4a7e6c$export$667e7b4d445d566b; });

var $lNVQ9 = parcelRequire("lNVQ9");
var $jPeZ4 = parcelRequire("jPeZ4");
var $7p8hL = parcelRequire("7p8hL");
var $iGf0k = parcelRequire("iGf0k");
var $iJH3x = parcelRequire("iJH3x");

var $kNF8J = parcelRequire("kNF8J");

var $fB2fA = parcelRequire("fB2fA");

var $fxUGN = parcelRequire("fxUGN");

var $e4zhx = parcelRequire("e4zhx");

var $5XnTz = parcelRequire("5XnTz");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $c84ebbe33d4a7e6c$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fxUGN.getCurrentHub)().captureException(exception, (0, $5XnTz.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $c84ebbe33d4a7e6c$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fxUGN.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $c84ebbe33d4a7e6c$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fxUGN.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ function $c84ebbe33d4a7e6c$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function $c84ebbe33d4a7e6c$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c84ebbe33d4a7e6c$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $c84ebbe33d4a7e6c$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $c84ebbe33d4a7e6c$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $c84ebbe33d4a7e6c$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $c84ebbe33d4a7e6c$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $c84ebbe33d4a7e6c$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $c84ebbe33d4a7e6c$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $fxUGN.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $c84ebbe33d4a7e6c$export$9a4fed82c350c2bd(callback) {
    return (0, $fxUGN.runWithAsyncContext)(()=>{
        return callback((0, $fxUGN.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $c84ebbe33d4a7e6c$export$e57ac09b143d92a2(span, callback) {
    return $c84ebbe33d4a7e6c$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $c84ebbe33d4a7e6c$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fxUGN.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $c84ebbe33d4a7e6c$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $c84ebbe33d4a7e6c$export$c7be4b0125a10cba();
    const client = $c84ebbe33d4a7e6c$export$6bb76d6eba7e258c();
    if (!client) (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $iJH3x.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $c84ebbe33d4a7e6c$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $c84ebbe33d4a7e6c$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $iGf0k.timestampInSeconds)();
    function finishCheckIn(status) {
        $c84ebbe33d4a7e6c$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $iGf0k.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $jPeZ4.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $c84ebbe33d4a7e6c$export$4909b86c8034bf73(timeout) {
    const client = $c84ebbe33d4a7e6c$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $c84ebbe33d4a7e6c$export$8360e631d277ea4d(timeout) {
    const client = $c84ebbe33d4a7e6c$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 * @deprecated This function will be removed in the next major version of the Sentry SDK.
 */ function $c84ebbe33d4a7e6c$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fxUGN.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $c84ebbe33d4a7e6c$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fxUGN.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $c84ebbe33d4a7e6c$export$3f95c6f800b78024() {
    return !!$c84ebbe33d4a7e6c$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $c84ebbe33d4a7e6c$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fxUGN.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $c84ebbe33d4a7e6c$export$c0d84948cecf78d8(context) {
    const client = $c84ebbe33d4a7e6c$export$6bb76d6eba7e258c();
    const isolationScope = (0, $fxUGN.getIsolationScope)();
    const currentScope = $c84ebbe33d4a7e6c$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $kNF8J.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $lNVQ9.GLOBAL_OBJ).navigator || {};
    const session = (0, $e4zhx.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $e4zhx.updateSession)(currentSession, {
        status: "exited"
    });
    $c84ebbe33d4a7e6c$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $c84ebbe33d4a7e6c$export$17a5be43989a0bc1() {
    const isolationScope = (0, $fxUGN.getIsolationScope)();
    const currentScope = $c84ebbe33d4a7e6c$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $e4zhx.closeSession)(session);
    $c84ebbe33d4a7e6c$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $c84ebbe33d4a7e6c$var$_sendSessionUpdate() {
    const isolationScope = (0, $fxUGN.getIsolationScope)();
    const currentScope = $c84ebbe33d4a7e6c$export$c7be4b0125a10cba();
    const client = $c84ebbe33d4a7e6c$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $c84ebbe33d4a7e6c$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $c84ebbe33d4a7e6c$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $c84ebbe33d4a7e6c$var$_sendSessionUpdate();
}

});
parcelRegister("lNVQ9", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $fdfb0a727947e40b$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $fdfb0a727947e40b$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $fdfb0a727947e40b$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $fdfb0a727947e40b$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $fdfb0a727947e40b$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $fdfb0a727947e40b$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $fdfb0a727947e40b$var$isGlobalObj(window) || typeof self == "object" && $fdfb0a727947e40b$var$isGlobalObj(self) || typeof $parcel$global == "object" && $fdfb0a727947e40b$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $fdfb0a727947e40b$export$256479dc0cea61c4() {
    return $fdfb0a727947e40b$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $fdfb0a727947e40b$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $fdfb0a727947e40b$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRegister("jPeZ4", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $e6ee673aafa8fdf7$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $e6ee673aafa8fdf7$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $e6ee673aafa8fdf7$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $e6ee673aafa8fdf7$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $e6ee673aafa8fdf7$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $e6ee673aafa8fdf7$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $e6ee673aafa8fdf7$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $e6ee673aafa8fdf7$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $e6ee673aafa8fdf7$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $e6ee673aafa8fdf7$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $e6ee673aafa8fdf7$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $e6ee673aafa8fdf7$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $e6ee673aafa8fdf7$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $e6ee673aafa8fdf7$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $e6ee673aafa8fdf7$export$c9f5652083b8129d; });
$parcel$export(module.exports, "isVueViewModel", function () { return $e6ee673aafa8fdf7$export$7916fad0ebc23f48; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $e6ee673aafa8fdf7$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$e6127cc7fe7395c3(wat) {
    switch($e6ee673aafa8fdf7$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $e6ee673aafa8fdf7$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$var$isBuiltin(wat, className) {
    return $e6ee673aafa8fdf7$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$9f9636d330b71954(wat) {
    return $e6ee673aafa8fdf7$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$ef9e2056653f0c8e(wat) {
    return $e6ee673aafa8fdf7$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$12e869b2a583f783(wat) {
    return $e6ee673aafa8fdf7$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$844ec244b1367d54(wat) {
    return $e6ee673aafa8fdf7$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$c3825b437cbdea5c(wat) {
    return wat === null || $e6ee673aafa8fdf7$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$53b83ca8eaab0383(wat) {
    return $e6ee673aafa8fdf7$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $e6ee673aafa8fdf7$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $e6ee673aafa8fdf7$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$49841c62b9eff15(wat) {
    return $e6ee673aafa8fdf7$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $e6ee673aafa8fdf7$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$bc2894c7158efbac(wat) {
    return $e6ee673aafa8fdf7$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("7p8hL", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $56414b82335a4971$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $56414b82335a4971$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $56414b82335a4971$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $56414b82335a4971$export$af88d00dbe7f521; });

var $aY8mH = parcelRequire("aY8mH");

var $lNVQ9 = parcelRequire("lNVQ9");
/** Prefix for logging strings */ const $56414b82335a4971$var$PREFIX = "Sentry Logger ";
const $56414b82335a4971$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $56414b82335a4971$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $56414b82335a4971$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $lNVQ9.GLOBAL_OBJ))) return callback();
    const console = (0, $lNVQ9.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($56414b82335a4971$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $56414b82335a4971$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $56414b82335a4971$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $aY8mH.DEBUG_BUILD) $56414b82335a4971$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $56414b82335a4971$export$cda52e2a8927a2ca(()=>{
                (0, $lNVQ9.GLOBAL_OBJ).console[name](`${$56414b82335a4971$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $56414b82335a4971$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $56414b82335a4971$export$af88d00dbe7f521 = $56414b82335a4971$var$makeLogger();

});
parcelRegister("aY8mH", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $7fc5ff1878f804ef$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7fc5ff1878f804ef$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});


parcelRegister("iGf0k", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $d997c9cd0e0ba837$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $d997c9cd0e0ba837$export$ee52dced521e3e18; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return $d997c9cd0e0ba837$export$baf075a948ffc0bf; });

var $lNVQ9 = parcelRequire("lNVQ9");
const $d997c9cd0e0ba837$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $d997c9cd0e0ba837$export$7740643b9eeaf0c4() {
    return Date.now() / $d997c9cd0e0ba837$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $d997c9cd0e0ba837$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $lNVQ9.GLOBAL_OBJ);
    if (!performance || !performance.now) return $d997c9cd0e0ba837$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $d997c9cd0e0ba837$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $d997c9cd0e0ba837$export$ee52dced521e3e18 = $d997c9cd0e0ba837$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $d997c9cd0e0ba837$export$c5907b5a8838db13 = $d997c9cd0e0ba837$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $d997c9cd0e0ba837$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $d997c9cd0e0ba837$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $lNVQ9.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $d997c9cd0e0ba837$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $d997c9cd0e0ba837$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $d997c9cd0e0ba837$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $d997c9cd0e0ba837$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

});

parcelRegister("iJH3x", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $da3dd405dd9de941$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $da3dd405dd9de941$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $da3dd405dd9de941$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $da3dd405dd9de941$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $da3dd405dd9de941$export$6de4ffac6a2f1098; });
$parcel$export(module.exports, "arrayify", function () { return $da3dd405dd9de941$export$3131421a7d01b4fb; });

var $aajbp = parcelRequire("aajbp");

var $bMiqE = parcelRequire("bMiqE");

var $lNVQ9 = parcelRequire("lNVQ9");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $da3dd405dd9de941$export$19f53698e68b2496() {
    const gbl = (0, $lNVQ9.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $da3dd405dd9de941$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $da3dd405dd9de941$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $da3dd405dd9de941$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $da3dd405dd9de941$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $da3dd405dd9de941$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $da3dd405dd9de941$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $da3dd405dd9de941$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $da3dd405dd9de941$export$d364f2020ab30578(input) {
    const match = input.match($da3dd405dd9de941$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $da3dd405dd9de941$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $bMiqE.snipLine)(line, 0));
    frame.context_line = (0, $bMiqE.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $bMiqE.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $da3dd405dd9de941$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $aajbp.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $da3dd405dd9de941$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("aajbp", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $7669b7e736cbe888$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $7669b7e736cbe888$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $7669b7e736cbe888$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $7669b7e736cbe888$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "urlEncode", function () { return $7669b7e736cbe888$export$9ef804feabbcbaf1; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $7669b7e736cbe888$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $7669b7e736cbe888$export$b0244d5063c0b61b; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $7669b7e736cbe888$export$d25f2688db1bb433; });

var $04wr6 = parcelRequire("04wr6");

var $aY8mH = parcelRequire("aY8mH");

var $jPeZ4 = parcelRequire("jPeZ4");

var $7p8hL = parcelRequire("7p8hL");

var $bMiqE = parcelRequire("bMiqE");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $7669b7e736cbe888$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $7669b7e736cbe888$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $7669b7e736cbe888$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $aY8mH.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $7669b7e736cbe888$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $7669b7e736cbe888$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $7669b7e736cbe888$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $7669b7e736cbe888$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $7669b7e736cbe888$export$62ff257738bf57f5(value) {
    if ((0, $jPeZ4.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$7669b7e736cbe888$var$getOwnProperties(value)
    };
    else if ((0, $jPeZ4.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $7669b7e736cbe888$var$serializeEventTarget(value.target),
            currentTarget: $7669b7e736cbe888$var$serializeEventTarget(value.currentTarget),
            ...$7669b7e736cbe888$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $jPeZ4.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $7669b7e736cbe888$var$serializeEventTarget(target) {
    try {
        return (0, $jPeZ4.isElement)(target) ? (0, $04wr6.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $7669b7e736cbe888$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $7669b7e736cbe888$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($7669b7e736cbe888$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $bMiqE.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $bMiqE.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $7669b7e736cbe888$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $7669b7e736cbe888$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $7669b7e736cbe888$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($7669b7e736cbe888$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $7669b7e736cbe888$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($7669b7e736cbe888$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $7669b7e736cbe888$var$isPojo(input) {
    if (!(0, $jPeZ4.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $7669b7e736cbe888$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $jPeZ4.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("04wr6", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $00d988f9c8458ac3$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $00d988f9c8458ac3$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getDomElement", function () { return $00d988f9c8458ac3$export$c660c1f3ab49225c; });
$parcel$export(module.exports, "getComponentName", function () { return $00d988f9c8458ac3$export$26727cfcc4d7e0fc; });

var $jPeZ4 = parcelRequire("jPeZ4");

var $lNVQ9 = parcelRequire("lNVQ9");
// eslint-disable-next-line deprecation/deprecation
const $00d988f9c8458ac3$var$WINDOW = (0, $lNVQ9.getGlobalObject)();
const $00d988f9c8458ac3$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $00d988f9c8458ac3$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $00d988f9c8458ac3$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $00d988f9c8458ac3$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $00d988f9c8458ac3$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($00d988f9c8458ac3$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $jPeZ4.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $00d988f9c8458ac3$export$1cfafeee2987818b() {
    try {
        return $00d988f9c8458ac3$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $00d988f9c8458ac3$export$c660c1f3ab49225c(selector) {
    if ($00d988f9c8458ac3$var$WINDOW.document && $00d988f9c8458ac3$var$WINDOW.document.querySelector) return $00d988f9c8458ac3$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $00d988f9c8458ac3$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$00d988f9c8458ac3$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("bMiqE", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $8932790146efca4b$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $8932790146efca4b$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $8932790146efca4b$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $8932790146efca4b$export$a7a5ec66062ea5d; });

var $jPeZ4 = parcelRequire("jPeZ4");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $8932790146efca4b$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $8932790146efca4b$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8932790146efca4b$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $jPeZ4.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $8932790146efca4b$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $jPeZ4.isString)(value)) return false;
    if ((0, $jPeZ4.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $jPeZ4.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $8932790146efca4b$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$8932790146efca4b$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("kNF8J", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $f2484bc1af2beef2$export$849dbeeeda01ae98; });
const $f2484bc1af2beef2$export$849dbeeeda01ae98 = "production";

});

parcelRegister("fB2fA", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $b5ac0e92c8e8cfe8$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b5ac0e92c8e8cfe8$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("fxUGN", function(module, exports) {

$parcel$export(module.exports, "Hub", function () { return $b515e967128040df$export$8c41bb232f1008b1; });
$parcel$export(module.exports, "makeMain", function () { return $b515e967128040df$export$4188a14ad302d1bc; });
$parcel$export(module.exports, "getMainCarrier", function () { return $b515e967128040df$export$19eade501500c6c1; });
$parcel$export(module.exports, "getHubFromCarrier", function () { return $b515e967128040df$export$bfa8a924a84a76b7; });
$parcel$export(module.exports, "getCurrentHub", function () { return $b515e967128040df$export$a07cdf6544bbd7c; });
$parcel$export(module.exports, "getIsolationScope", function () { return $b515e967128040df$export$68f3af03034c9e90; });
$parcel$export(module.exports, "runWithAsyncContext", function () { return $b515e967128040df$export$70d775fb1f267027; });

var $7p8hL = parcelRequire("7p8hL");
var $iGf0k = parcelRequire("iGf0k");
var $lNVQ9 = parcelRequire("lNVQ9");
var $jPeZ4 = parcelRequire("jPeZ4");
var $iJH3x = parcelRequire("iJH3x");

var $kNF8J = parcelRequire("kNF8J");

var $fB2fA = parcelRequire("fB2fA");

var $2W3Nl = parcelRequire("2W3Nl");

var $e4zhx = parcelRequire("e4zhx");

var $fIs9O = parcelRequire("fIs9O");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $b515e967128040df$export$24a86ef7798177e4 = parseFloat((0, $fIs9O.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $b515e967128040df$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ class $b515e967128040df$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $b515e967128040df$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $2W3Nl.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $2W3Nl.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $jPeZ4.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $iJH3x.uuid4)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $iJH3x.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $iJH3x.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $b515e967128040df$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $iGf0k.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $7p8hL.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $b515e967128040df$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $b515e967128040df$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $fB2fA.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $7p8hL.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $7p8hL.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $e4zhx.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $kNF8J.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $lNVQ9.GLOBAL_OBJ).navigator || {};
        const session = (0, $e4zhx.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $e4zhx.updateSession)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $b515e967128040df$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $b515e967128040df$export$19eade501500c6c1() {
    (0, $lNVQ9.GLOBAL_OBJ).__SENTRY__ = (0, $lNVQ9.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $lNVQ9.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ function $b515e967128040df$export$4188a14ad302d1bc(hub) {
    const registry = $b515e967128040df$export$19eade501500c6c1();
    const oldHub = $b515e967128040df$export$bfa8a924a84a76b7(registry);
    $b515e967128040df$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ function $b515e967128040df$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $b515e967128040df$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $b515e967128040df$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $b515e967128040df$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $b515e967128040df$export$a07cdf6544bbd7c().getIsolationScope();
}
function $b515e967128040df$var$getGlobalHub(registry = $b515e967128040df$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$b515e967128040df$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $b515e967128040df$export$bfa8a924a84a76b7(registry).isOlderThan($b515e967128040df$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $b515e967128040df$export$849f05434e95d2f2(registry, new $b515e967128040df$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $b515e967128040df$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ function $b515e967128040df$export$236689a79f5aa020(carrier, parent = $b515e967128040df$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$b515e967128040df$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $b515e967128040df$export$bfa8a924a84a76b7(carrier).isOlderThan($b515e967128040df$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $b515e967128040df$export$849f05434e95d2f2(carrier, new $b515e967128040df$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $b515e967128040df$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $b515e967128040df$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $b515e967128040df$export$70d775fb1f267027(callback, options = {}) {
    const registry = $b515e967128040df$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $b515e967128040df$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $b515e967128040df$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $lNVQ9.getGlobalSingleton)("hub", ()=>new $b515e967128040df$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $b515e967128040df$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("2W3Nl", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $2233f125d7bebf60$export$775b6bb06e53a214; });
$parcel$export(module.exports, "getGlobalScope", function () { return $2233f125d7bebf60$export$aa55d5ab8e05984f; });

var $iGf0k = parcelRequire("iGf0k");
var $jPeZ4 = parcelRequire("jPeZ4");
var $7p8hL = parcelRequire("7p8hL");
var $iJH3x = parcelRequire("iJH3x");

var $jXhtG = parcelRequire("jXhtG");

var $e4zhx = parcelRequire("e4zhx");

var $6Moko = parcelRequire("6Moko");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $2233f125d7bebf60$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $2233f125d7bebf60$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $2233f125d7bebf60$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $2233f125d7bebf60$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $2233f125d7bebf60$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $2233f125d7bebf60$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $e4zhx.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   * @deprecated Use extra or tags instead.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $2233f125d7bebf60$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $jPeZ4.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $2233f125d7bebf60$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $2233f125d7bebf60$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $iGf0k.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $6Moko.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $jXhtG.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $jXhtG.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $iJH3x.uuid4)();
        if (!this._client) {
            (0, $7p8hL.logger).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $iJH3x.uuid4)();
        if (!this._client) {
            (0, $7p8hL.logger).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $iJH3x.uuid4)();
        if (!this._client) {
            (0, $7p8hL.logger).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $2233f125d7bebf60$export$aa55d5ab8e05984f() {
    if (!$2233f125d7bebf60$var$globalScope) $2233f125d7bebf60$var$globalScope = new $2233f125d7bebf60$export$775b6bb06e53a214();
    return $2233f125d7bebf60$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $2233f125d7bebf60$export$c83048efd17527d6(scope) {
    $2233f125d7bebf60$var$globalScope = scope;
}
function $2233f125d7bebf60$var$generatePropagationContext() {
    return {
        traceId: (0, $iJH3x.uuid4)(),
        spanId: (0, $iJH3x.uuid4)().substring(16)
    };
}

});
parcelRegister("jXhtG", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", function () { return $e87115bd731ce6b2$export$3c4238858b85e8ac; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return $e87115bd731ce6b2$export$8e4e25f54d456511; });
$parcel$export(module.exports, "notifyEventProcessors", function () { return $e87115bd731ce6b2$export$bf2a096c3e883e79; });

var $lNVQ9 = parcelRequire("lNVQ9");
var $jPeZ4 = parcelRequire("jPeZ4");
var $7p8hL = parcelRequire("7p8hL");
var $amxcu = parcelRequire("amxcu");

var $fB2fA = parcelRequire("fB2fA");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $e87115bd731ce6b2$export$3c4238858b85e8ac() {
    return (0, $lNVQ9.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $e87115bd731ce6b2$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $e87115bd731ce6b2$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $e87115bd731ce6b2$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $amxcu.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $fB2fA.DEBUG_BUILD) && processor.id && result === null && (0, $7p8hL.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $jPeZ4.isThenable)(result)) result.then((final)=>$e87115bd731ce6b2$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $e87115bd731ce6b2$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("amxcu", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $78b5b660bf84b8fb$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $78b5b660bf84b8fb$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $78b5b660bf84b8fb$export$78e43115b553f358; });

var $jPeZ4 = parcelRequire("jPeZ4");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $78b5b660bf84b8fb$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($78b5b660bf84b8fb$var$States || ($78b5b660bf84b8fb$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $78b5b660bf84b8fb$export$1fda8aa4d135f8aa(value) {
    return new $78b5b660bf84b8fb$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $78b5b660bf84b8fb$export$78e43115b553f358(reason) {
    return new $78b5b660bf84b8fb$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $78b5b660bf84b8fb$export$6f292d4960313241 {
    constructor(executor){
        $78b5b660bf84b8fb$export$6f292d4960313241.prototype.__init.call(this);
        $78b5b660bf84b8fb$export$6f292d4960313241.prototype.__init2.call(this);
        $78b5b660bf84b8fb$export$6f292d4960313241.prototype.__init3.call(this);
        $78b5b660bf84b8fb$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $78b5b660bf84b8fb$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $78b5b660bf84b8fb$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $78b5b660bf84b8fb$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($78b5b660bf84b8fb$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($78b5b660bf84b8fb$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $78b5b660bf84b8fb$var$States.PENDING) return;
            if ((0, $jPeZ4.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $78b5b660bf84b8fb$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $78b5b660bf84b8fb$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $78b5b660bf84b8fb$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("e4zhx", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $a3eccea17ef3455c$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $a3eccea17ef3455c$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $a3eccea17ef3455c$export$56521d9ba90f62ee; });

var $aajbp = parcelRequire("aajbp");
var $iGf0k = parcelRequire("iGf0k");
var $iJH3x = parcelRequire("iJH3x");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $a3eccea17ef3455c$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $iGf0k.timestampInSeconds)();
    const session = {
        sid: (0, $iJH3x.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$a3eccea17ef3455c$var$sessionToJSON(session)
    };
    if (context) $a3eccea17ef3455c$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $a3eccea17ef3455c$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $iGf0k.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $iJH3x.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $a3eccea17ef3455c$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $a3eccea17ef3455c$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $a3eccea17ef3455c$var$sessionToJSON(session) {
    return (0, $aajbp.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("6Moko", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $0146192ca4e06701$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $0146192ca4e06701$export$25ac7e259a513db4; });

var $iJH3x = parcelRequire("iJH3x");
var $aajbp = parcelRequire("aajbp");

var $2Grcj = parcelRequire("2Grcj");

var $7oVpT = parcelRequire("7oVpT");

var $4RP7L = parcelRequire("4RP7L");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $0146192ca4e06701$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $0146192ca4e06701$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $0146192ca4e06701$var$applySpanToEvent(event, span);
    $0146192ca4e06701$var$applyFingerprintToEvent(event, fingerprint);
    $0146192ca4e06701$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $0146192ca4e06701$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $0146192ca4e06701$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $0146192ca4e06701$export$b1a120a2871faa46(data, "extra", extra);
    $0146192ca4e06701$export$b1a120a2871faa46(data, "tags", tags);
    $0146192ca4e06701$export$b1a120a2871faa46(data, "user", user);
    $0146192ca4e06701$export$b1a120a2871faa46(data, "contexts", contexts);
    $0146192ca4e06701$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $0146192ca4e06701$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $0146192ca4e06701$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $aajbp.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $aajbp.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $aajbp.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $aajbp.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $0146192ca4e06701$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $0146192ca4e06701$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $0146192ca4e06701$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $4RP7L.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $7oVpT.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $2Grcj.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $4RP7L.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $0146192ca4e06701$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $iJH3x.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("2Grcj", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", function () { return $1f4499e04745e139$export$366bad00d6815eed; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $1f4499e04745e139$export$a117f995597e25df; });

var $aajbp = parcelRequire("aajbp");

var $kNF8J = parcelRequire("kNF8J");

var $hcepo = parcelRequire("hcepo");

var $7oVpT = parcelRequire("7oVpT");

var $4RP7L = parcelRequire("4RP7L");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $1f4499e04745e139$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $aajbp.dropUndefinedKeys)({
        environment: options.environment || (0, $kNF8J.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $1f4499e04745e139$export$a117f995597e25df(span) {
    const client = (0, $hcepo.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $1f4499e04745e139$export$366bad00d6815eed((0, $4RP7L.spanToJSON)(span).trace_id || "", client, (0, $hcepo.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $7oVpT.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $4RP7L.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $4RP7L.spanIsSampled)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}

});
parcelRegister("7oVpT", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", function () { return $563750088b1823ba$export$c4c6a79b1260ca1b; });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $563750088b1823ba$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRegister("4RP7L", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", function () { return $38b3c4e0cbc28389$export$208d5b368507fb8b; });
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", function () { return $38b3c4e0cbc28389$export$eb571cd9b5d98de8; });
$parcel$export(module.exports, "spanToTraceContext", function () { return $38b3c4e0cbc28389$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanToJSON", function () { return $38b3c4e0cbc28389$export$92d8c23565496537; });
$parcel$export(module.exports, "spanToTraceHeader", function () { return $38b3c4e0cbc28389$export$7e9f8ae9e4a328ab; });
$parcel$export(module.exports, "spanIsSampled", function () { return $38b3c4e0cbc28389$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "spanTimeInputToSeconds", function () { return $38b3c4e0cbc28389$export$3f7581298f56c6d7; });

var $aajbp = parcelRequire("aajbp");
var $6jMr3 = parcelRequire("6jMr3");
var $iGf0k = parcelRequire("iGf0k");
// These are aligned with OpenTelemetry trace flags
const $38b3c4e0cbc28389$export$208d5b368507fb8b = 0x0;
const $38b3c4e0cbc28389$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $38b3c4e0cbc28389$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $38b3c4e0cbc28389$export$92d8c23565496537(span);
    return (0, $aajbp.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $38b3c4e0cbc28389$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $38b3c4e0cbc28389$export$5caecac1caaf3a71(span);
    return (0, $6jMr3.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $38b3c4e0cbc28389$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $38b3c4e0cbc28389$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $38b3c4e0cbc28389$var$ensureTimestampInSeconds(input.getTime());
    return (0, $iGf0k.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $38b3c4e0cbc28389$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $38b3c4e0cbc28389$export$92d8c23565496537(span) {
    if ($38b3c4e0cbc28389$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $38b3c4e0cbc28389$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $38b3c4e0cbc28389$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $38b3c4e0cbc28389$export$eb571cd9b5d98de8);
}

});
parcelRegister("6jMr3", function(module, exports) {

$parcel$export(module.exports, "extractTraceparentData", function () { return $499a16ae6432059e$export$8e9a29865c0a1226; });
$parcel$export(module.exports, "tracingContextFromHeaders", function () { return $499a16ae6432059e$export$ca5c066532785b6e; });
$parcel$export(module.exports, "propagationContextFromHeaders", function () { return $499a16ae6432059e$export$261f383d16a93e39; });
$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $499a16ae6432059e$export$f35d907436da45cf; });

var $9dJTa = parcelRequire("9dJTa");

var $iJH3x = parcelRequire("iJH3x");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $499a16ae6432059e$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $499a16ae6432059e$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($499a16ae6432059e$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $499a16ae6432059e$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $499a16ae6432059e$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9dJTa.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $iJH3x.uuid4)(),
            spanId: (0, $iJH3x.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $iJH3x.uuid4)(),
            parentSpanId: parentSpanId || (0, $iJH3x.uuid4)().substring(16),
            spanId: (0, $iJH3x.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $499a16ae6432059e$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $499a16ae6432059e$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9dJTa.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $iJH3x.uuid4)(),
        spanId: (0, $iJH3x.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $iJH3x.uuid4)(),
        parentSpanId: parentSpanId || (0, $iJH3x.uuid4)().substring(16),
        spanId: (0, $iJH3x.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $499a16ae6432059e$export$f35d907436da45cf(traceId = (0, $iJH3x.uuid4)(), spanId = (0, $iJH3x.uuid4)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("9dJTa", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", function () { return $6b68ec80a732e936$export$9ca9946bd449ac06; });
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $6b68ec80a732e936$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $6b68ec80a732e936$export$56766feef403f365; });

var $aY8mH = parcelRequire("aY8mH");

var $jPeZ4 = parcelRequire("jPeZ4");

var $7p8hL = parcelRequire("7p8hL");
const $6b68ec80a732e936$export$9ca9946bd449ac06 = "baggage";
const $6b68ec80a732e936$export$6e69537d67fa20f = "sentry-";
const $6b68ec80a732e936$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $6b68ec80a732e936$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $6b68ec80a732e936$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $jPeZ4.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $6b68ec80a732e936$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $6b68ec80a732e936$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($6b68ec80a732e936$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($6b68ec80a732e936$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $6b68ec80a732e936$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$6b68ec80a732e936$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $6b68ec80a732e936$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $6b68ec80a732e936$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $6b68ec80a732e936$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $6b68ec80a732e936$export$bdd844ddb2def819) {
            (0, $aY8mH.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});






parcelRegister("fIs9O", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $b710ce850dd5d8ac$export$31499a9cd224b78c; });
const $b710ce850dd5d8ac$export$31499a9cd224b78c = "7.105.0";

});


parcelRegister("5XnTz", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $4564ff902648190c$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $4564ff902648190c$export$76b5f966996d1653; });

var $iJH3x = parcelRequire("iJH3x");
var $iGf0k = parcelRequire("iGf0k");
var $lNVQ9 = parcelRequire("lNVQ9");
var $5vnYi = parcelRequire("5vnYi");
var $bMiqE = parcelRequire("bMiqE");

var $kNF8J = parcelRequire("kNF8J");

var $jXhtG = parcelRequire("jXhtG");

var $2W3Nl = parcelRequire("2W3Nl");

var $6Moko = parcelRequire("6Moko");

var $4RP7L = parcelRequire("4RP7L");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $4564ff902648190c$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $iJH3x.uuid4)(),
        timestamp: event.timestamp || (0, $iGf0k.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $4564ff902648190c$var$applyClientOptions(prepared, options);
    $4564ff902648190c$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $4564ff902648190c$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $4564ff902648190c$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $iJH3x.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $2W3Nl.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $6Moko.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $6Moko.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $6Moko.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $jXhtG.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $jXhtG.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $4564ff902648190c$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $4564ff902648190c$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $4564ff902648190c$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $kNF8J.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $bMiqE.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $bMiqE.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $bMiqE.truncate)(request.url, maxValueLength);
}
const $4564ff902648190c$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $4564ff902648190c$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $lNVQ9.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $4564ff902648190c$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $4564ff902648190c$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $4564ff902648190c$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $4564ff902648190c$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $4564ff902648190c$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $5vnYi.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $5vnYi.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $5vnYi.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $5vnYi.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $5vnYi.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $4RP7L.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $5vnYi.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $4564ff902648190c$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $2W3Nl.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $4564ff902648190c$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($4564ff902648190c$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($4564ff902648190c$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $4564ff902648190c$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $2W3Nl.Scope) || typeof hint === "function";
}
const $4564ff902648190c$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $4564ff902648190c$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$4564ff902648190c$var$captureContextKeys.includes(key));
}

});
parcelRegister("5vnYi", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $402271403d2a143f$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $402271403d2a143f$export$23fbbb20bed71033; });

var $jPeZ4 = parcelRequire("jPeZ4");

var $eKRqJ = parcelRequire("eKRqJ");

var $aajbp = parcelRequire("aajbp");

var $kEJYx = parcelRequire("kEJYx");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $402271403d2a143f$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $402271403d2a143f$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $402271403d2a143f$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $402271403d2a143f$export$a3295358bff77e(object, depth);
    if ($402271403d2a143f$var$jsonSize(normalized) > maxSize) return $402271403d2a143f$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $402271403d2a143f$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $eKRqJ.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $jPeZ4.isNaN)(value)) return value;
    const stringified = $402271403d2a143f$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $402271403d2a143f$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $aajbp.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $402271403d2a143f$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $402271403d2a143f$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $jPeZ4.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $jPeZ4.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $kEJYx.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $402271403d2a143f$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $402271403d2a143f$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $402271403d2a143f$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $402271403d2a143f$var$jsonSize(value) {
    return $402271403d2a143f$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $402271403d2a143f$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}

});
parcelRegister("eKRqJ", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $abdeceb456a49826$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $abdeceb456a49826$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("kEJYx", function(module, exports) {

$parcel$export(module.exports, "createStackParser", function () { return $f09b34d7784ccad9$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $f09b34d7784ccad9$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $f09b34d7784ccad9$export$aad197c7121a6651; });

var $9usNZ = parcelRequire("9usNZ");
const $f09b34d7784ccad9$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $f09b34d7784ccad9$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $f09b34d7784ccad9$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $f09b34d7784ccad9$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $f09b34d7784ccad9$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($f09b34d7784ccad9$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $f09b34d7784ccad9$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $f09b34d7784ccad9$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $f09b34d7784ccad9$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $f09b34d7784ccad9$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $f09b34d7784ccad9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($f09b34d7784ccad9$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($f09b34d7784ccad9$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $f09b34d7784ccad9$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $f09b34d7784ccad9$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $f09b34d7784ccad9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $f09b34d7784ccad9$var$defaultFunctionName;
        return fn.name || $f09b34d7784ccad9$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $f09b34d7784ccad9$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $f09b34d7784ccad9$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $9usNZ.node)(getModule)
    ];
}

});
parcelRegister("9usNZ", function(module, exports) {

$parcel$export(module.exports, "node", function () { return $6e8d4284125ab5ec$export$35059013cd4a06db; });
/**
 * Does this filename look like it's part of the app code?
 */ function $6e8d4284125ab5ec$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $6e8d4284125ab5ec$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $6e8d4284125ab5ec$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});





parcelRegister("kEUo3", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("PW6XX", function(module, exports) {

$parcel$export(module.exports, "AvailableApplicationFlavors", function () { return $09c1d73d438f7517$export$7868b6c53639285e; });
$parcel$export(module.exports, "getValueByFlavor", function () { return $09c1d73d438f7517$export$4ef79fbe0aed5e45; });
const $09c1d73d438f7517$export$7868b6c53639285e = {
    DEFAULT: "default",
    TELEMED: "telemed",
    SUNRISE: "sunrise",
    CEG: "ceg"
};
const $09c1d73d438f7517$export$aa9c85cab0dfe7c7 = ()=>"default";
const $09c1d73d438f7517$export$4ef79fbe0aed5e45 = (valuesMap)=>{
    const appFlavour = $09c1d73d438f7517$export$aa9c85cab0dfe7c7();
    const value = valuesMap[appFlavour];
    if (value !== undefined) return value;
    return valuesMap[$09c1d73d438f7517$export$7868b6c53639285e.DEFAULT];
};

});

parcelRegister("5lJLQ", function(module, exports) {

$parcel$export(module.exports, "clearAllCache", function () { return $3e526b059c746927$export$9382d7b8b0fb7d41; });
$parcel$export(module.exports, "default", function () { return $3e526b059c746927$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $kEUo3 = parcelRequire("kEUo3");

var $jCoLF = parcelRequire("jCoLF");

var $iOlMk = parcelRequire("iOlMk");

var $5oGqh = parcelRequire("5oGqh");
parcelRequire("bh6RR");

var $1WnR3 = parcelRequire("1WnR3");

var $igCUb = parcelRequire("igCUb");

var $7HoMU = parcelRequire("7HoMU");
const $3e526b059c746927$var$ToastBody = (0, $jCoLF.default)((0, $1WnR3.DefaultToastBody)).withConfig({
    displayName: "apiService__ToastBody",
    componentId: "sc-1n2uvjb-0"
})([
    "width:320px;"
]);
const $3e526b059c746927$var$RESPONSE_CACHE = {};
const $3e526b059c746927$var$GET_CACHE = {};
const $3e526b059c746927$var$toastManager = (0, $5oGqh.useToast)();
const $3e526b059c746927$export$9382d7b8b0fb7d41 = ()=>{
    for(let key in $3e526b059c746927$var$RESPONSE_CACHE)delete $3e526b059c746927$var$RESPONSE_CACHE[key];
    for(let key in $3e526b059c746927$var$GET_CACHE)delete $3e526b059c746927$var$GET_CACHE[key];
};
class $3e526b059c746927$var$ApiService {
    constructor(urlPrefix, requestPrepare, responseCallback, host){
        this.requestPrepare = requestPrepare;
        this.responseCallback = responseCallback;
        this.urlPrefix = urlPrefix;
        this.host = host || window.location.origin;
        this.abortControllers = {};
    }
    abortAll(reason) {
        Object.values(this.abortControllers).forEach((controller)=>{
            controller.abort(reason);
        });
    }
    async getFullUrlAndParams(method, url, params, body, headers, contentType, host, withoutLastSlash) {
        let urlPrefix = this.urlPrefix;
        if (this.requestPrepare) {
            const newParams = await this.requestPrepare(method, url, params, body, headers);
            // eslint-disable-next-line no-param-reassign
            method = newParams.method;
            // eslint-disable-next-line no-param-reassign,no-param-reassign
            url = newParams.url;
            // eslint-disable-next-line no-param-reassign
            params = newParams.params;
            // eslint-disable-next-line no-param-reassign
            body = newParams.body;
            // eslint-disable-next-line no-param-reassign
            headers = newParams.headers || {};
        }
        let urlString = `${urlPrefix}/${url ? url + "/" : ""}`;
        if (withoutLastSlash) urlString = `${urlPrefix}/${url}`;
        const fullUrl = new URL(urlString, host || this.host);
        // Формируем параметры fetch
        const requestParams = {
            method: method,
            headers: {
                "APP-TYPE": "doctor",
                // TODO: Кастомный заголовок для отсеивания ботов, в будущем должен зависеть от площадки
                ...headers
            }
        };
        // Для возможности отключить поле content-type. Pixel не обрабатывает запросы с content-type.
        if (contentType) {
            requestParams.headers["Content-Type"] = "application/json; charset=utf-8";
            requestParams.headers["Accept"] = "application/json, application/xml, text/plain, text/html, *.*";
        }
        // Для возможности отключить поле content-type. Pixel не обрабатывает запросы с content-type.
        if ((0, $iOlMk.tokenStore) !== null && (0, $iOlMk.tokenStore) !== void 0 && (0, $iOlMk.tokenStore).getState()) requestParams.headers["Authorization"] = `JWT ${(0, $iOlMk.tokenStore).getState()}`;
        // Для методов, предполагающих тело запроса добавляем тело запроса
        if (body && [
            "POST",
            "PUT",
            "PATCH",
            "DELETE"
        ].includes(method)) {
            if (body instanceof FormData) requestParams.body = body;
            else requestParams.body = JSON.stringify(body);
        }
        if (params) fullUrl.search = new URLSearchParams((0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).pickBy(params, (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).identity));
        return [
            fullUrl,
            requestParams
        ];
    }
    async request(method, url, params, body, headers, contentType, host, cache, checkCache, abortPrevious, abortReason, withoutLastSlash) {
        const requestUrl = this.urlPrefix + url;
        const [fullUrl, requestParams] = await this.getFullUrlAndParams(method, url, params, body, headers, contentType, host, withoutLastSlash);
        if (this.abortControllers[requestUrl] && abortPrevious) this.abortControllers[requestUrl].abort(abortReason);
        this.abortControllers[requestUrl] = new AbortController();
        const fullUrlString = fullUrl.toString();
        if (cache && $3e526b059c746927$var$RESPONSE_CACHE[fullUrlString]) return (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).cloneDeep($3e526b059c746927$var$RESPONSE_CACHE[fullUrlString]);
        if (checkCache) return false;
        const makeRequest = async ()=>{
            let response;
            let json;
            const handleError = async (error)=>{
                if ((0, $igCUb.default).isFetchError(error)) {
                    console.error(error);
                    (0, $7HoMU.captureExceptionToSentry)(error);
                    await (0, $igCUb.default).waitConnection();
                    return await makeRequest();
                }
                throw error;
            // Raven.captureMessage('Fetch error', {
            //   level: 'error',
            //   extra: {
            //     error,
            //     fullUrl,
            //     requestParams,
            //   },
            // });
            };
            try {
                response = await fetch(fullUrl, {
                    signal: this.abortControllers[requestUrl].signal,
                    ...requestParams
                });
                json = await response.json();
            } catch (error) {
                if ((error.message === "Unexpected end of JSON input" || error.message === "Failed to execute 'json' on 'Response': Unexpected end of JSON input") && response.ok) return [
                    response,
                    ""
                ];
                if (error.message === "The string did not match the expected pattern." && response.ok) return [
                    response,
                    ""
                ];
                [response, json] = await handleError(error);
            }
            return [
                response,
                json
            ];
        };
        let [response, result] = await makeRequest();
        if (window.loggingRequest) window.loggingRequest({
            url: response.url,
            status: response.status,
            params: params,
            body: body
        });
        delete this.abortControllers[requestUrl];
        if (this.responseCallback) {
            const res = await this.responseCallback({
                status: response.status,
                result: result
            }, method, url, params, body, headers);
            if (res || res === null) return res;
        }
        // Обрабатываем ошибки со статусом 40х, 50х
        if (response.status >= 400) {
            const error = new Error(response.statusText);
            error.code = response.status;
            error.data = response;
            error.result = result;
            const isLoggedOut = !((0, $iOlMk.tokenStore) && (0, $iOlMk.tokenStore).getState());
            if (error.code === 401 && !isLoggedOut) {
                $3e526b059c746927$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    children: [
                        "\u0412\u0440\u0435\u043C\u044F \u0441\u0435\u0441\u0441\u0438\u0438 \u0438\u0441\u0442\u0435\u043A\u043B\u043E.",
                        /*#__PURE__*/ (0, $ih19M.jsx)("br", {}),
                        "\u0412\u043E\u0439\u0434\u0438\u0442\u0435 \u0432 \u0441\u0432\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u0435\u0449\u0435 \u0440\u0430\u0437."
                    ]
                }), {
                    container: {
                        component: $3e526b059c746927$var$ToastBody
                    },
                    duration: 10000
                });
                (0, $iOlMk.logout)();
            }
            if (error.code === 500) $3e526b059c746927$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                children: "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430"
            }), {
                container: {
                    component: $3e526b059c746927$var$ToastBody
                },
                duration: 10000
            });
            // if (error.code === 400) {
            //   toastManager.showToast(
            //     <div>
            //       {error.details}
            //     </div>,
            //     {
            //       container: {
            //         component: ToastBody
            //       },
            //       duration: 10000
            //     }
            //   );
            // }
            throw error;
        }
        if (cache) $3e526b059c746927$var$RESPONSE_CACHE[fullUrlString] = (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).cloneDeep(result);
        return result;
    }
    get(url, params = {}, headers = {}, contentType = true, host = "", cache = false, abortPrevious = false, abortReason = "", withoutLastSlash = false) {
        return this.getFullUrlAndParams(null, url, params, {}, headers, contentType, host, withoutLastSlash).then(async ([fullUrl])=>{
            const fullUrlString = fullUrl.toString();
            if (cache && $3e526b059c746927$var$GET_CACHE[fullUrlString]) // Необходимо делать cloneDeep значения, так как Promise возвращает одну и ту же ссылку на объект.
            return $3e526b059c746927$var$GET_CACHE[fullUrlString].then((result)=>(0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).cloneDeep(result));
            const request = this.request("GET", url, params, {}, headers, contentType, host, cache, false, abortPrevious, abortReason, withoutLastSlash);
            if (cache) $3e526b059c746927$var$GET_CACHE[fullUrlString] = request;
            return request;
        });
    }
    checkCache(url, params = {}, headers = {}, contentType = true, host = "") {
        return this.request("GET", url, params, {}, headers, contentType, host, true, true);
    }
    post(url, params, body, headers = {}, contentType = true, host = "", abortPrevious = false, abortReason = "", withoutLastSlash = false) {
        return this.request("POST", url, params, body, headers, contentType, host, false, false, abortPrevious, abortReason, withoutLastSlash);
    }
    patch(url, params, body, headers = {}, contentType = true, host = "", abortPrevious = false, abortReason = "") {
        return this.request("PATCH", url, params, body, headers, contentType, host, false, false, abortPrevious, abortReason);
    }
    put(url, params, body, headers = {}, contentType, abortPrevious = false, abortReason = "") {
        return this.request("PUT", url, params, body, headers, contentType, "", false, false, abortPrevious, abortReason);
    }
    delete(url, params, body, headers = {}, abortPrevious = false, abortReason = "") {
        return this.request("DELETE", url, params, body, headers, true, "", false, false, abortPrevious, abortReason);
    }
    async clearCacheForRequest(url, params, headers, contentType, host) {
        const [fullUrl] = await this.getFullUrlAndParams(null, url, params, {}, headers, contentType, host);
        const fullUrlString = fullUrl.toString();
        if ($3e526b059c746927$var$RESPONSE_CACHE[fullUrlString]) delete $3e526b059c746927$var$RESPONSE_CACHE[fullUrlString];
        if ($3e526b059c746927$var$GET_CACHE[fullUrlString]) delete $3e526b059c746927$var$GET_CACHE[fullUrlString];
    }
}
var $3e526b059c746927$export$2e2bcd8739ae039 = $3e526b059c746927$var$ApiService;

});
parcelRegister("jCoLF", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $e484c752f3f06549$export$dbf350e5966cf602; });
$parcel$export(module.exports, "default", function () { return $e484c752f3f06549$export$2e2bcd8739ae039; });

var $1xzjt = parcelRequire("1xzjt");

var $4yYy5 = parcelRequire("4yYy5");

var $bh6RR = parcelRequire("bh6RR");

var $36HXn = parcelRequire("36HXn");

var $3zV5k = parcelRequire("3zV5k");

var $1XykX = parcelRequire("1XykX");


var $fjRTt = parcelRequire("fjRTt");

var $1CDLR = parcelRequire("1CDLR");

var $4TNnu = parcelRequire("4TNnu");
// 
var $e484c752f3f06549$var$interleave = function(strings, interpolations) {
    var result = [
        strings[0]
    ];
    for(var i = 0, len = interpolations.length; i < len; i += 1)result.push(interpolations[i], strings[i + 1]);
    return result;
};
var $e484c752f3f06549$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $e484c752f3f06549$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $e484c752f3f06549$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $e484c752f3f06549$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $e484c752f3f06549$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $e484c752f3f06549$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $e484c752f3f06549$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
// 
var $e484c752f3f06549$var$isPlainObject = function(x) {
    return (typeof x === "undefined" ? "undefined" : $e484c752f3f06549$var$_typeof(x)) === "object" && x.constructor === Object;
};
// 
var $e484c752f3f06549$var$EMPTY_ARRAY = Object.freeze([]);
var $e484c752f3f06549$var$EMPTY_OBJECT = Object.freeze({});
// 
function $e484c752f3f06549$var$isFunction(test) {
    return typeof test === "function";
}
// 
function $e484c752f3f06549$var$getComponentName(target) {
    return (0, target.displayName) || target.name || "Component";
}
// 
function $e484c752f3f06549$var$isStatelessFunction(test) {
    return typeof test === "function" && !(test.prototype && test.prototype.isReactComponent);
}
// 
function $e484c752f3f06549$export$7ba318d8d2f06c76(target) {
    return target && typeof target.styledComponentId === "string";
}
// 
var $e484c752f3f06549$var$SC_ATTR = (typeof $4TNnu !== "undefined" && undefined, "data-styled");
var $e484c752f3f06549$var$SC_VERSION_ATTR = "data-styled-version";
var $e484c752f3f06549$var$SC_STREAM_ATTR = "data-styled-streamed";
var $e484c752f3f06549$var$IS_BROWSER = typeof window !== "undefined" && "HTMLElement" in window;
var $e484c752f3f06549$var$DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === "boolean" && SC_DISABLE_SPEEDY || typeof $4TNnu !== "undefined" && undefined || false;
// Shared empty execution context when generating static styles
var $e484c752f3f06549$var$STATIC_EXECUTION_CONTEXT = {};
// 
/**
 * Parse errors.md and turn it into a simple hash of code: message
 */ var $e484c752f3f06549$var$ERRORS = {};
/**
 * super basic version of sprintf
 */ function $e484c752f3f06549$var$format() {
    var a = arguments.length <= 0 ? undefined : arguments[0];
    var b = [];
    for(var c = 1, len = arguments.length; c < len; c += 1)b.push(arguments.length <= c ? undefined : arguments[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */ var $e484c752f3f06549$var$StyledComponentsError = function(_Error) {
    $e484c752f3f06549$var$inherits(StyledComponentsError, _Error);
    function StyledComponentsError(code) {
        $e484c752f3f06549$var$classCallCheck(this, StyledComponentsError);
        for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
        var _this;
        var _this = $e484c752f3f06549$var$possibleConstructorReturn(this, _Error.call(this, "An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#" + code + " for more information." + (interpolations.length > 0 ? " Additional arguments: " + interpolations.join(", ") : "")));
        return $e484c752f3f06549$var$possibleConstructorReturn(_this);
    }
    return StyledComponentsError;
}(Error);
// 
var $e484c752f3f06549$var$SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
var $e484c752f3f06549$var$extractComps = function(maybeCSS) {
    var css = "" + (maybeCSS || ""); // Definitely a string, and a clone
    var existingComponents = [];
    css.replace($e484c752f3f06549$var$SC_COMPONENT_ID, function(match, componentId, matchIndex) {
        existingComponents.push({
            componentId: componentId,
            matchIndex: matchIndex
        });
        return match;
    });
    return existingComponents.map(function(_ref, i) {
        var componentId = _ref.componentId, matchIndex = _ref.matchIndex;
        var nextComp = existingComponents[i + 1];
        var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
        return {
            componentId: componentId,
            cssFromDOM: cssFromDOM
        };
    });
};
// 
var $e484c752f3f06549$var$COMMENT_REGEX = /^\s*\/\/.*$/gm;
// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var $e484c752f3f06549$var$stylisSplitter = new (0, (/*@__PURE__*/$parcel$interopDefault($1xzjt)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: false,
    compress: false,
    semicolon: true
});
var $e484c752f3f06549$var$stylis = new (0, (/*@__PURE__*/$parcel$interopDefault($1xzjt)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: true,
    compress: false,
    semicolon: false // NOTE: This means "autocomplete missing semicolons"
});
// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture
var $e484c752f3f06549$var$parsingRules = [];
// eslint-disable-next-line consistent-return
var $e484c752f3f06549$var$returnRulesPlugin = function returnRulesPlugin(context) {
    if (context === -2) {
        var parsedRules = $e484c752f3f06549$var$parsingRules;
        $e484c752f3f06549$var$parsingRules = [];
        return parsedRules;
    }
};
var $e484c752f3f06549$var$parseRulesPlugin = (0, (/*@__PURE__*/$parcel$interopDefault($4yYy5)))(function(rule) {
    $e484c752f3f06549$var$parsingRules.push(rule);
});
var $e484c752f3f06549$var$_componentId = void 0;
var $e484c752f3f06549$var$_selector = void 0;
var $e484c752f3f06549$var$_selectorRegexp = void 0;
var $e484c752f3f06549$var$selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
    if (// the first self-ref is always untouched
    offset > 0 && // there should be at least two self-refs to do a replacement (.b > .b)
    string.slice(0, offset).indexOf($e484c752f3f06549$var$_selector) !== -1 && // no consecutive self refs (.b.b); that is a precedence boost and treated differently
    string.slice(offset - $e484c752f3f06549$var$_selector.length, offset) !== $e484c752f3f06549$var$_selector) return "." + $e484c752f3f06549$var$_componentId;
    return match;
};
/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */ var $e484c752f3f06549$var$selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
    if (context === 2 && selectors.length && selectors[0].lastIndexOf($e484c752f3f06549$var$_selector) > 0) // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace($e484c752f3f06549$var$_selectorRegexp, $e484c752f3f06549$var$selfReferenceReplacer);
};
$e484c752f3f06549$var$stylis.use([
    $e484c752f3f06549$var$selfReferenceReplacementPlugin,
    $e484c752f3f06549$var$parseRulesPlugin,
    $e484c752f3f06549$var$returnRulesPlugin
]);
$e484c752f3f06549$var$stylisSplitter.use([
    $e484c752f3f06549$var$parseRulesPlugin,
    $e484c752f3f06549$var$returnRulesPlugin
]);
var $e484c752f3f06549$var$splitByRules = function splitByRules(css) {
    return $e484c752f3f06549$var$stylisSplitter("", css);
};
function $e484c752f3f06549$var$stringifyRules(rules, selector, prefix) {
    var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "&";
    var flatCSS = rules.join("").replace($e484c752f3f06549$var$COMMENT_REGEX, ""); // replace JS comments
    var cssStr = selector && prefix ? prefix + " " + selector + " { " + flatCSS + " }" : flatCSS;
    // stylis has no concept of state to be passed to plugins
    // but since JS is single=threaded, we can rely on that to ensure
    // these properties stay in sync with the current stylis run
    $e484c752f3f06549$var$_componentId = componentId;
    $e484c752f3f06549$var$_selector = selector;
    $e484c752f3f06549$var$_selectorRegexp = new RegExp("\\" + $e484c752f3f06549$var$_selector + "\\b", "g");
    return $e484c752f3f06549$var$stylis(prefix || !selector ? "" : selector, cssStr);
}
// 
/* eslint-disable camelcase, no-undef */ var $e484c752f3f06549$var$getNonce = function() {
    return typeof __webpack_nonce__ !== "undefined" ? __webpack_nonce__ : null;
};
// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */ /* adds a new ID:name pairing to a names dictionary */ var $e484c752f3f06549$var$addNameForId = function addNameForId(names, id, name) {
    if (name) {
        // eslint-disable-next-line no-param-reassign
        var namesForId = names[id] || (names[id] = Object.create(null));
        namesForId[name] = true;
    }
};
/* resets an ID entirely by overwriting it in the dictionary */ var $e484c752f3f06549$var$resetIdNames = function resetIdNames(names, id) {
    // eslint-disable-next-line no-param-reassign
    names[id] = Object.create(null);
};
/* factory for a names dictionary checking the existance of an ID:name pairing */ var $e484c752f3f06549$var$hasNameForId = function hasNameForId(names) {
    return function(id, name) {
        return names[id] !== undefined && names[id][name];
    };
};
/* stringifies names for the html/element output */ var $e484c752f3f06549$var$stringifyNames = function stringifyNames(names) {
    var str = "";
    // eslint-disable-next-line guard-for-in
    for(var id in names)str += Object.keys(names[id]).join(" ") + " ";
    return str.trim();
};
/* clones the nested names dictionary */ var $e484c752f3f06549$var$cloneNames = function cloneNames(names) {
    var clone = Object.create(null);
    // eslint-disable-next-line guard-for-in
    for(var id in names)clone[id] = $e484c752f3f06549$var$_extends({}, names[id]);
    return clone;
};
// 
/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */ /* retrieve a sheet for a given style tag */ var $e484c752f3f06549$var$sheetForTag = function sheetForTag(tag) {
    // $FlowFixMe
    if (tag.sheet) return tag.sheet;
    /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */ var size = tag.ownerDocument.styleSheets.length;
    for(var i = 0; i < size; i += 1){
        var sheet = tag.ownerDocument.styleSheets[i];
        // $FlowFixMe
        if (sheet.ownerNode === tag) return sheet;
    }
    /* we should always be able to find a tag */ throw new $e484c752f3f06549$var$StyledComponentsError(10);
};
/* insert a rule safely and return whether it was actually injected */ var $e484c752f3f06549$var$safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
    /* abort early if cssRule string is falsy */ if (!cssRule) return false;
    var maxIndex = sheet.cssRules.length;
    try {
        /* use insertRule and cap passed index with maxIndex (no of cssRules) */ sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
    } catch (err) {
        /* any error indicates an invalid rule */ return false;
    }
    return true;
};
/* deletes `size` rules starting from `removalIndex` */ var $e484c752f3f06549$var$deleteRules = function deleteRules(sheet, removalIndex, size) {
    var lowerBound = removalIndex - size;
    for(var i = removalIndex; i > lowerBound; i -= 1)sheet.deleteRule(i);
};
// 
/* this marker separates component styles and is important for rehydration */ var $e484c752f3f06549$var$makeTextMarker = function makeTextMarker(id) {
    return "\n/* sc-component-id: " + id + " */\n";
};
/* add up all numbers in array up until and including the index */ var $e484c752f3f06549$var$addUpUntilIndex = function addUpUntilIndex(sizes, index) {
    var totalUpToIndex = 0;
    for(var i = 0; i <= index; i += 1)totalUpToIndex += sizes[i];
    return totalUpToIndex;
};
/* create a new style tag after lastEl */ var $e484c752f3f06549$var$makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
    var targetDocument = document;
    if (target) targetDocument = target.ownerDocument;
    else if (tagEl) targetDocument = tagEl.ownerDocument;
    var el = targetDocument.createElement("style");
    el.setAttribute($e484c752f3f06549$var$SC_ATTR, "");
    el.setAttribute($e484c752f3f06549$var$SC_VERSION_ATTR, "4.4.1");
    var nonce = $e484c752f3f06549$var$getNonce();
    if (nonce) el.setAttribute("nonce", nonce);
    /* Work around insertRule quirk in EdgeHTML */ el.appendChild(targetDocument.createTextNode(""));
    if (target && !tagEl) /* Append to target when no previous element was passed */ target.appendChild(el);
    else {
        if (!tagEl || !target || !tagEl.parentNode) throw new $e484c752f3f06549$var$StyledComponentsError(6);
        /* Insert new style tag after the previous one */ tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
    }
    return el;
};
/* takes a css factory function and outputs an html styled tag factory */ var $e484c752f3f06549$var$wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
    return function(additionalAttrs) {
        var nonce = $e484c752f3f06549$var$getNonce();
        var attrs = [
            nonce && 'nonce="' + nonce + '"',
            $e484c752f3f06549$var$SC_ATTR + '="' + $e484c752f3f06549$var$stringifyNames(names) + '"',
            $e484c752f3f06549$var$SC_VERSION_ATTR + '="' + "4.4.1" + '"',
            additionalAttrs
        ];
        var htmlAttr = attrs.filter(Boolean).join(" ");
        return "<style " + htmlAttr + ">" + css() + "</style>";
    };
};
/* takes a css factory function and outputs an element factory */ var $e484c752f3f06549$var$wrapAsElement = function wrapAsElement(css, names) {
    return function() {
        var _props;
        var props = (_props = {}, _props[$e484c752f3f06549$var$SC_ATTR] = $e484c752f3f06549$var$stringifyNames(names), _props[$e484c752f3f06549$var$SC_VERSION_ATTR] = "4.4.1", _props);
        var nonce = $e484c752f3f06549$var$getNonce();
        if (nonce) // $FlowFixMe
        props.nonce = nonce;
        // eslint-disable-next-line react/no-danger
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("style", $e484c752f3f06549$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: css()
            }
        }));
    };
};
var $e484c752f3f06549$var$getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
    return function() {
        return Object.keys(markers);
    };
};
/* speedy tags utilise insertRule */ var $e484c752f3f06549$var$makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var sizes = [];
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whether getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = sizes.length;
        sizes.push(0);
        $e484c752f3f06549$var$resetIdNames(names, id);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var sheet = $e484c752f3f06549$var$sheetForTag(el);
        var insertIndex = $e484c752f3f06549$var$addUpUntilIndex(sizes, marker);
        var injectedRules = 0;
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var cssRule = cssRules[i];
            var mayHaveImport = extractImport; /* @import rules are reordered to appear first */ 
            if (mayHaveImport && cssRule.indexOf("@import") !== -1) importRules.push(cssRule);
            else if ($e484c752f3f06549$var$safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
                mayHaveImport = false;
                injectedRules += 1;
            }
        }
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + "-import", importRules);
        }
        sizes[marker] += injectedRules; /* add up no of injected rules */ 
        $e484c752f3f06549$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        // $FlowFixMe
        if (el.isConnected === false) return;
        var size = sizes[marker];
        var sheet = $e484c752f3f06549$var$sheetForTag(el);
        var removalIndex = $e484c752f3f06549$var$addUpUntilIndex(sizes, marker) - 1;
        $e484c752f3f06549$var$deleteRules(sheet, removalIndex, size);
        sizes[marker] = 0;
        $e484c752f3f06549$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + "-import");
    };
    var css = function css() {
        var _sheetForTag = $e484c752f3f06549$var$sheetForTag(el), cssRules = _sheetForTag.cssRules;
        var str = "";
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            str += $e484c752f3f06549$var$makeTextMarker(id);
            var marker = markers[id];
            var end = $e484c752f3f06549$var$addUpUntilIndex(sizes, marker);
            var size = sizes[marker];
            for(var i = end - size; i < end; i += 1){
                var rule = cssRules[i];
                if (rule !== undefined) str += rule.cssText;
            }
        }
        return str;
    };
    return {
        clone: function clone() {
            throw new $e484c752f3f06549$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $e484c752f3f06549$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $e484c752f3f06549$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $e484c752f3f06549$var$wrapAsElement(css, names),
        toHTML: $e484c752f3f06549$var$wrapAsHtmlTag(css, names)
    };
};
var $e484c752f3f06549$var$makeTextNode = function makeTextNode(targetDocument, id) {
    return targetDocument.createTextNode($e484c752f3f06549$var$makeTextMarker(id));
};
var $e484c752f3f06549$var$makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whether getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = $e484c752f3f06549$var$makeTextNode(el.ownerDocument, id);
        el.appendChild(markers[id]);
        names[id] = Object.create(null);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var rule = cssRules[i];
            var mayHaveImport = extractImport;
            if (mayHaveImport && rule.indexOf("@import") !== -1) importRules.push(rule);
            else {
                mayHaveImport = false;
                var separator = i === cssRulesSize - 1 ? "" : " ";
                marker.appendData("" + rule + separator);
            }
        }
        $e484c752f3f06549$var$addNameForId(names, id, name);
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + "-import", importRules);
        }
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        /* create new empty text node and replace the current one */ var newMarker = $e484c752f3f06549$var$makeTextNode(el.ownerDocument, id);
        el.replaceChild(newMarker, marker);
        markers[id] = newMarker;
        $e484c752f3f06549$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + "-import");
    };
    var css = function css() {
        var str = "";
        // eslint-disable-next-line guard-for-in
        for(var id in markers)str += markers[id].data;
        return str;
    };
    return {
        clone: function clone() {
            throw new $e484c752f3f06549$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $e484c752f3f06549$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $e484c752f3f06549$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $e484c752f3f06549$var$wrapAsElement(css, names),
        toHTML: $e484c752f3f06549$var$wrapAsHtmlTag(css, names)
    };
};
var $e484c752f3f06549$var$makeServerTag = function makeServerTag(namesArg, markersArg) {
    var names = namesArg === undefined ? Object.create(null) : namesArg;
    var markers = markersArg === undefined ? Object.create(null) : markersArg;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        return markers[id] = [
            ""
        ];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        marker[0] += cssRules.join(" ");
        $e484c752f3f06549$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        marker[0] = "";
        $e484c752f3f06549$var$resetIdNames(names, id);
    };
    var css = function css() {
        var str = "";
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            var cssForId = markers[id][0];
            if (cssForId) str += $e484c752f3f06549$var$makeTextMarker(id) + cssForId;
        }
        return str;
    };
    var clone = function clone() {
        var namesClone = $e484c752f3f06549$var$cloneNames(names);
        var markersClone = Object.create(null);
        // eslint-disable-next-line guard-for-in
        for(var id in markers)markersClone[id] = [
            markers[id][0]
        ];
        return makeServerTag(namesClone, markersClone);
    };
    var tag = {
        clone: clone,
        css: css,
        getIds: $e484c752f3f06549$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $e484c752f3f06549$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: null,
        toElement: $e484c752f3f06549$var$wrapAsElement(css, names),
        toHTML: $e484c752f3f06549$var$wrapAsHtmlTag(css, names)
    };
    return tag;
};
var $e484c752f3f06549$var$makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
    if ($e484c752f3f06549$var$IS_BROWSER && !forceServer) {
        var el = $e484c752f3f06549$var$makeStyleTag(target, tagEl, insertBefore);
        if ($e484c752f3f06549$var$DISABLE_SPEEDY) return $e484c752f3f06549$var$makeBrowserTag(el, getImportRuleTag);
        else return $e484c752f3f06549$var$makeSpeedyTag(el, getImportRuleTag);
    }
    return $e484c752f3f06549$var$makeServerTag();
};
var $e484c752f3f06549$var$rehydrate = function rehydrate(tag, els, extracted) {
    /* add all extracted components to the new tag */ for(var i = 0, len = extracted.length; i < len; i += 1){
        var _extracted$i = extracted[i], componentId = _extracted$i.componentId, cssFromDOM = _extracted$i.cssFromDOM;
        var cssRules = $e484c752f3f06549$var$splitByRules(cssFromDOM);
        tag.insertRules(componentId, cssRules);
    }
    /* remove old HTMLStyleElements, since they have been rehydrated */ for(var _i = 0, _len = els.length; _i < _len; _i += 1){
        var el = els[_i];
        if (el.parentNode) el.parentNode.removeChild(el);
    }
};
// 
var $e484c752f3f06549$var$SPLIT_REGEX = /\s+/;
/* determine the maximum number of components before tags are sharded */ var $e484c752f3f06549$var$MAX_SIZE = void 0;
if ($e484c752f3f06549$var$IS_BROWSER) /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */ $e484c752f3f06549$var$MAX_SIZE = $e484c752f3f06549$var$DISABLE_SPEEDY ? 40 : 1000;
else /* for servers we do not need to shard at all */ $e484c752f3f06549$var$MAX_SIZE = -1;
var $e484c752f3f06549$var$sheetRunningId = 0;
var $e484c752f3f06549$var$master = void 0;
var $e484c752f3f06549$var$StyleSheet = function() {
    /* a map from ids to tags */ /* deferred rules for a given id */ /* this is used for not reinjecting rules via hasNameForId() */ /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */ /* a list of tags belonging to this StyleSheet */ /* a tag for import rules */ /* current capacity until a new tag must be created */ /* children (aka clones) of this StyleSheet inheriting all and future injections */ function StyleSheet() {
        var _this = this;
        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e484c752f3f06549$var$IS_BROWSER ? document.head : null;
        var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        $e484c752f3f06549$var$classCallCheck(this, StyleSheet);
        this.getImportRuleTag = function() {
            var importRuleTag = _this.importRuleTag;
            if (importRuleTag !== undefined) return importRuleTag;
            var firstTag = _this.tags[0];
            var insertBefore = true;
            return _this.importRuleTag = $e484c752f3f06549$var$makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
        };
        $e484c752f3f06549$var$sheetRunningId += 1;
        this.id = $e484c752f3f06549$var$sheetRunningId;
        this.forceServer = forceServer;
        this.target = forceServer ? null : target;
        this.tagMap = {};
        this.deferred = {};
        this.rehydratedNames = {};
        this.ignoreRehydratedNames = {};
        this.tags = [];
        this.capacity = 1;
        this.clones = [];
    }
    /* rehydrate all SSR'd style tags */ StyleSheet.prototype.rehydrate = function rehydrate$$1() {
        if (!$e484c752f3f06549$var$IS_BROWSER || this.forceServer) return this;
        var els = [];
        var extracted = [];
        var isStreamed = false;
        /* retrieve all of our SSR style elements from the DOM */ var nodes = document.querySelectorAll("style[" + $e484c752f3f06549$var$SC_ATTR + "][" + $e484c752f3f06549$var$SC_VERSION_ATTR + '="' + "4.4.1" + '"]');
        var nodesSize = nodes.length;
        /* abort rehydration if no previous style tags were found */ if (!nodesSize) return this;
        for(var i = 0; i < nodesSize; i += 1){
            var el = nodes[i];
            /* check if style tag is a streamed tag */ if (!isStreamed) isStreamed = !!el.getAttribute($e484c752f3f06549$var$SC_STREAM_ATTR);
            /* retrieve all component names */ var elNames = (el.getAttribute($e484c752f3f06549$var$SC_ATTR) || "").trim().split($e484c752f3f06549$var$SPLIT_REGEX);
            var elNamesSize = elNames.length;
            for(var j = 0, name; j < elNamesSize; j += 1){
                name = elNames[j];
                /* add rehydrated name to sheet to avoid re-adding styles */ this.rehydratedNames[name] = true;
            }
            /* extract all components and their CSS */ extracted.push.apply(extracted, $e484c752f3f06549$var$extractComps(el.textContent));
            /* store original HTMLStyleElement */ els.push(el);
        }
        /* abort rehydration if nothing was extracted */ var extractedSize = extracted.length;
        if (!extractedSize) return this;
        /* create a tag to be used for rehydration */ var tag = this.makeTag(null);
        $e484c752f3f06549$var$rehydrate(tag, els, extracted);
        /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */ this.capacity = Math.max(1, $e484c752f3f06549$var$MAX_SIZE - extractedSize);
        this.tags.push(tag);
        /* retrieve all component ids */ for(var _j = 0; _j < extractedSize; _j += 1)this.tagMap[extracted[_j].componentId] = tag;
        return this;
    };
    /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */ /* reset the internal "master" instance */ StyleSheet.reset = function reset() {
        var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        $e484c752f3f06549$var$master = new StyleSheet(undefined, forceServer).rehydrate();
    };
    /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */ StyleSheet.prototype.clone = function clone() {
        var sheet = new StyleSheet(this.target, this.forceServer);
        /* add to clone array */ this.clones.push(sheet);
        /* clone all tags */ sheet.tags = this.tags.map(function(tag) {
            var ids = tag.getIds();
            var newTag = tag.clone();
            /* reconstruct tagMap */ for(var i = 0; i < ids.length; i += 1)sheet.tagMap[ids[i]] = newTag;
            return newTag;
        });
        /* clone other maps */ sheet.rehydratedNames = $e484c752f3f06549$var$_extends({}, this.rehydratedNames);
        sheet.deferred = $e484c752f3f06549$var$_extends({}, this.deferred);
        return sheet;
    };
    /* force StyleSheet to create a new tag on the next injection */ StyleSheet.prototype.sealAllTags = function sealAllTags() {
        this.capacity = 1;
        this.tags.forEach(function(tag) {
            // eslint-disable-next-line no-param-reassign
            tag.sealed = true;
        });
    };
    StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
        var lastEl = tag ? tag.styleTag : null;
        var insertBefore = false;
        return $e484c752f3f06549$var$makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
    };
    /* get a tag for a given componentId, assign the componentId to one, or shard */ StyleSheet.prototype.getTagForId = function getTagForId(id) {
        /* simply return a tag, when the componentId was already assigned one */ var prev = this.tagMap[id];
        if (prev !== undefined && !prev.sealed) return prev;
        var tag = this.tags[this.tags.length - 1];
        /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */ this.capacity -= 1;
        if (this.capacity === 0) {
            this.capacity = $e484c752f3f06549$var$MAX_SIZE;
            tag = this.makeTag(tag);
            this.tags.push(tag);
        }
        return this.tagMap[id] = tag;
    };
    /* mainly for createGlobalStyle to check for its id */ StyleSheet.prototype.hasId = function hasId(id) {
        return this.tagMap[id] !== undefined;
    };
    /* caching layer checking id+name to already have a corresponding tag and injected rules */ StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
        /* exception for rehydrated names which are checked separately */ if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) return true;
        var tag = this.tagMap[id];
        return tag !== undefined && tag.hasNameForId(id, name);
    };
    /* registers a componentId and registers it on its tag */ StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
        /* don't inject when the id is already registered */ if (this.tagMap[id] !== undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].deferredInject(id, cssRules);
        this.getTagForId(id).insertMarker(id);
        this.deferred[id] = cssRules;
    };
    /* injects rules for a given id with a name that will need to be cached */ StyleSheet.prototype.inject = function inject(id, cssRules, name) {
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].inject(id, cssRules, name);
        var tag = this.getTagForId(id);
        /* add deferred rules for component */ if (this.deferred[id] !== undefined) {
            // Combine passed cssRules with previously deferred CSS rules
            // NOTE: We cannot mutate the deferred array itself as all clones
            // do the same (see clones[i].inject)
            var rules = this.deferred[id].concat(cssRules);
            tag.insertRules(id, rules, name);
            this.deferred[id] = undefined;
        } else tag.insertRules(id, cssRules, name);
    };
    /* removes all rules for a given id, which doesn't remove its marker but resets it */ StyleSheet.prototype.remove = function remove(id) {
        var tag = this.tagMap[id];
        if (tag === undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].remove(id);
        /* remove all rules from the tag */ tag.removeRules(id);
        /* ignore possible rehydrated names */ this.ignoreRehydratedNames[id] = true;
        /* delete possible deferred rules */ this.deferred[id] = undefined;
    };
    StyleSheet.prototype.toHTML = function toHTML() {
        return this.tags.map(function(tag) {
            return tag.toHTML();
        }).join("");
    };
    StyleSheet.prototype.toReactElements = function toReactElements() {
        var id = this.id;
        return this.tags.map(function(tag, i) {
            var key = "sc-" + id + "-" + i;
            return (0, $bh6RR.cloneElement)(tag.toElement(), {
                key: key
            });
        });
    };
    $e484c752f3f06549$var$createClass(StyleSheet, null, [
        {
            key: "master",
            get: function get$$1() {
                return $e484c752f3f06549$var$master || ($e484c752f3f06549$var$master = new StyleSheet().rehydrate());
            }
        },
        {
            key: "instance",
            get: function get$$1() {
                return StyleSheet.master;
            }
        }
    ]);
    return StyleSheet;
}();
// 
var $e484c752f3f06549$var$Keyframes = function() {
    function Keyframes(name, rules) {
        var _this = this;
        $e484c752f3f06549$var$classCallCheck(this, Keyframes);
        this.inject = function(styleSheet) {
            if (!styleSheet.hasNameForId(_this.id, _this.name)) styleSheet.inject(_this.id, _this.rules, _this.name);
        };
        this.toString = function() {
            throw new $e484c752f3f06549$var$StyledComponentsError(12, String(_this.name));
        };
        this.name = name;
        this.rules = rules;
        this.id = "sc-keyframes-" + name;
    }
    Keyframes.prototype.getName = function getName() {
        return this.name;
    };
    return Keyframes;
}();
// 
/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */ var $e484c752f3f06549$var$uppercasePattern = /([A-Z])/g;
var $e484c752f3f06549$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $e484c752f3f06549$var$hyphenateStyleName(string) {
    return string.replace($e484c752f3f06549$var$uppercasePattern, "-$1").toLowerCase().replace($e484c752f3f06549$var$msPattern, "-ms-");
}
// 
// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function $e484c752f3f06549$var$addUnitIfNeeded(name, value) {
    // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
    // $FlowFixMe
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !(name in (0, $36HXn.default))) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
    return String(value).trim();
}
// 
/**
 * It's falsish not falsy because 0 is allowed.
 */ var $e484c752f3f06549$var$isFalsish = function isFalsish(chunk) {
    return chunk === undefined || chunk === null || chunk === false || chunk === "";
};
var $e484c752f3f06549$var$objToCssArray = function objToCssArray(obj, prevKey) {
    var rules = [];
    var keys = Object.keys(obj);
    keys.forEach(function(key) {
        if (!$e484c752f3f06549$var$isFalsish(obj[key])) {
            if ($e484c752f3f06549$var$isPlainObject(obj[key])) {
                rules.push.apply(rules, objToCssArray(obj[key], key));
                return rules;
            } else if ($e484c752f3f06549$var$isFunction(obj[key])) {
                rules.push($e484c752f3f06549$var$hyphenateStyleName(key) + ":", obj[key], ";");
                return rules;
            }
            rules.push($e484c752f3f06549$var$hyphenateStyleName(key) + ": " + $e484c752f3f06549$var$addUnitIfNeeded(key, obj[key]) + ";");
        }
        return rules;
    });
    return prevKey ? [
        prevKey + " {"
    ].concat(rules, [
        "}"
    ]) : rules;
};
function $e484c752f3f06549$var$flatten(chunk, executionContext, styleSheet) {
    if (Array.isArray(chunk)) {
        var ruleSet = [];
        for(var i = 0, len = chunk.length, result; i < len; i += 1){
            result = $e484c752f3f06549$var$flatten(chunk[i], executionContext, styleSheet);
            if (result === null) continue;
            else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);
            else ruleSet.push(result);
        }
        return ruleSet;
    }
    if ($e484c752f3f06549$var$isFalsish(chunk)) return null;
    /* Handle other components */ if ($e484c752f3f06549$export$7ba318d8d2f06c76(chunk)) return "." + chunk.styledComponentId;
    /* Either execute or defer the function */ if ($e484c752f3f06549$var$isFunction(chunk)) {
        if ($e484c752f3f06549$var$isStatelessFunction(chunk) && executionContext) {
            var _result = chunk(executionContext);
            return $e484c752f3f06549$var$flatten(_result, executionContext, styleSheet);
        } else return chunk;
    }
    if (chunk instanceof $e484c752f3f06549$var$Keyframes) {
        if (styleSheet) {
            chunk.inject(styleSheet);
            return chunk.getName();
        } else return chunk;
    }
    /* Handle objects */ return $e484c752f3f06549$var$isPlainObject(chunk) ? $e484c752f3f06549$var$objToCssArray(chunk) : chunk.toString();
}
// 
function $e484c752f3f06549$export$dbf350e5966cf602(styles) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    if ($e484c752f3f06549$var$isFunction(styles) || $e484c752f3f06549$var$isPlainObject(styles)) // $FlowFixMe
    return $e484c752f3f06549$var$flatten($e484c752f3f06549$var$interleave($e484c752f3f06549$var$EMPTY_ARRAY, [
        styles
    ].concat(interpolations)));
    // $FlowFixMe
    return $e484c752f3f06549$var$flatten($e484c752f3f06549$var$interleave(styles, interpolations));
}
// 
function $e484c752f3f06549$var$constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $e484c752f3f06549$var$EMPTY_OBJECT;
    if (!(0, $3zV5k.isValidElementType)(tag)) throw new $e484c752f3f06549$var$StyledComponentsError(1, String(tag));
    /* This is callable directly as a template function */ // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
        return componentConstructor(tag, options, $e484c752f3f06549$export$dbf350e5966cf602.apply(undefined, arguments));
    };
    /* If config methods are called, wrap up a new template function and merge options */ templateFunction.withConfig = function(config) {
        return $e484c752f3f06549$var$constructWithOptions(componentConstructor, tag, $e484c752f3f06549$var$_extends({}, options, config));
    };
    /* Modify/inject new props at runtime */ templateFunction.attrs = function(attrs) {
        return $e484c752f3f06549$var$constructWithOptions(componentConstructor, tag, $e484c752f3f06549$var$_extends({}, options, {
            attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
        }));
    };
    return templateFunction;
}
// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $e484c752f3f06549$var$murmurhash(c) {
    for(var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;)b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
    switch(e){
        case 3:
            a ^= (c.charCodeAt(d + 2) & 255) << 16;
        case 2:
            a ^= (c.charCodeAt(d + 1) & 255) << 8;
        case 1:
            a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
    }
    a ^= a >>> 13;
    a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
    return (a ^ a >>> 15) >>> 0;
}
// 
/* eslint-disable no-bitwise */ /* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */ var $e484c752f3f06549$var$charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */ var $e484c752f3f06549$var$getAlphabeticChar = function getAlphabeticChar(code) {
    return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */ function $e484c752f3f06549$var$generateAlphabeticName(code) {
    var name = "";
    var x = void 0;
    /* get a char and divide by alphabet-length */ for(x = code; x > $e484c752f3f06549$var$charsLength; x = Math.floor(x / $e484c752f3f06549$var$charsLength))name = $e484c752f3f06549$var$getAlphabeticChar(x % $e484c752f3f06549$var$charsLength) + name;
    return $e484c752f3f06549$var$getAlphabeticChar(x % $e484c752f3f06549$var$charsLength) + name;
}
// 
function $e484c752f3f06549$var$hasFunctionObjectKey(obj) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for(var key in obj){
        if ($e484c752f3f06549$var$isFunction(obj[key])) return true;
    }
    return false;
}
function $e484c752f3f06549$var$isStaticRules(rules, attrs) {
    for(var i = 0; i < rules.length; i += 1){
        var rule = rules[i];
        // recursive case
        if (Array.isArray(rule) && !$e484c752f3f06549$var$isStaticRules(rule, attrs)) return false;
        else if ($e484c752f3f06549$var$isFunction(rule) && !$e484c752f3f06549$export$7ba318d8d2f06c76(rule)) // functions are allowed to be static if they're just being
        // used to get the classname of a nested styled component
        return false;
    }
    if (attrs.some(function(x) {
        return $e484c752f3f06549$var$isFunction(x) || $e484c752f3f06549$var$hasFunctionObjectKey(x);
    })) return false;
    return true;
}
// 
/* combines hashStr (murmurhash) and nameGenerator for convenience */ var $e484c752f3f06549$var$hasher = function hasher(str) {
    return $e484c752f3f06549$var$generateAlphabeticName($e484c752f3f06549$var$murmurhash(str));
};
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */ var $e484c752f3f06549$var$ComponentStyle = function() {
    function ComponentStyle(rules, attrs, componentId) {
        $e484c752f3f06549$var$classCallCheck(this, ComponentStyle);
        this.rules = rules;
        this.isStatic = $e484c752f3f06549$var$isStaticRules(rules, attrs);
        this.componentId = componentId;
        if (!$e484c752f3f06549$var$StyleSheet.master.hasId(componentId)) $e484c752f3f06549$var$StyleSheet.master.deferredInject(componentId, []);
    }
    /*
   * Flattens a rule set into valid CSS
   * Hashes it, wraps the whole chunk in a .hash1234 {}
   * Returns the hash to be injected on render()
   * */ ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
        var isStatic = this.isStatic, componentId = this.componentId, lastClassName = this.lastClassName;
        if ($e484c752f3f06549$var$IS_BROWSER && isStatic && typeof lastClassName === "string" && styleSheet.hasNameForId(componentId, lastClassName)) return lastClassName;
        var flatCSS = $e484c752f3f06549$var$flatten(this.rules, executionContext, styleSheet);
        var name = $e484c752f3f06549$var$hasher(this.componentId + flatCSS.join(""));
        if (!styleSheet.hasNameForId(componentId, name)) styleSheet.inject(this.componentId, $e484c752f3f06549$var$stringifyRules(flatCSS, "." + name, undefined, componentId), name);
        this.lastClassName = name;
        return name;
    };
    ComponentStyle.generateName = function generateName(str) {
        return $e484c752f3f06549$var$hasher(str);
    };
    return ComponentStyle;
}();
// 
var $e484c752f3f06549$var$LIMIT = 200;
var $e484c752f3f06549$var$createWarnTooManyClasses = function(displayName) {
    var generatedClasses = {};
    var warningSeen = false;
    return function(className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= $e484c752f3f06549$var$LIMIT) {
                // Unable to find latestRule in test environment.
                /* eslint-disable no-console, prefer-template */ console.warn("Over " + $e484c752f3f06549$var$LIMIT + " classes were generated for component " + displayName + ". \n" + "Consider using the attrs method, together with a style object for frequently changed styles.\n" + "Example:\n" + "  const Component = styled.div.attrs(props => ({\n" + "    style: {\n" + "      background: props.background,\n" + "    },\n" + "  }))`width: 100%;`\n\n" + "  <Component />");
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
};
// 
var $e484c752f3f06549$var$determineTheme = function(props, fallbackTheme) {
    var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $e484c752f3f06549$var$EMPTY_OBJECT;
    // Props should take precedence over ThemeProvider, which should take precedence over
    // defaultProps, but React automatically puts defaultProps on props.
    /* eslint-disable react/prop-types, flowtype-errors/show-errors */ var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
    var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
    /* eslint-enable */ return theme;
};
// 
var $e484c752f3f06549$var$escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var $e484c752f3f06549$var$dashesAtEnds = /(^-|-$)/g;
/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */ function $e484c752f3f06549$var$escape(str) {
    return str// Replace all possible CSS selectors
    .replace($e484c752f3f06549$var$escapeRegex, "-")// Remove extraneous hyphens at the start and end
    .replace($e484c752f3f06549$var$dashesAtEnds, "");
}
// 
function $e484c752f3f06549$var$isTag(target) {
    return typeof target === "string" && true;
}
// 
function $e484c752f3f06549$var$generateDisplayName(target) {
    // $FlowFixMe
    return $e484c752f3f06549$var$isTag(target) ? "styled." + target : "Styled(" + $e484c752f3f06549$var$getComponentName(target) + ")";
}
var $e484c752f3f06549$var$_TYPE_STATICS;
var $e484c752f3f06549$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDerivedStateFromProps: true,
    propTypes: true,
    type: true
};
var $e484c752f3f06549$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $e484c752f3f06549$var$TYPE_STATICS = ($e484c752f3f06549$var$_TYPE_STATICS = {}, $e484c752f3f06549$var$_TYPE_STATICS[0, $3zV5k.ForwardRef] = {
    $$typeof: true,
    render: true
}, $e484c752f3f06549$var$_TYPE_STATICS);
var $e484c752f3f06549$var$defineProperty$1 = Object.defineProperty, $e484c752f3f06549$var$getOwnPropertyNames = Object.getOwnPropertyNames, $e484c752f3f06549$var$_Object$getOwnPropert = Object.getOwnPropertySymbols, $e484c752f3f06549$var$getOwnPropertySymbols = $e484c752f3f06549$var$_Object$getOwnPropert === undefined ? function() {
    return [];
} : $e484c752f3f06549$var$_Object$getOwnPropert, $e484c752f3f06549$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, $e484c752f3f06549$var$getPrototypeOf = Object.getPrototypeOf, $e484c752f3f06549$var$objectPrototype = Object.prototype;
var $e484c752f3f06549$var$arrayPrototype = Array.prototype;
function $e484c752f3f06549$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        var inheritedComponent = $e484c752f3f06549$var$getPrototypeOf(sourceComponent);
        if (inheritedComponent && inheritedComponent !== $e484c752f3f06549$var$objectPrototype) $e484c752f3f06549$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        var keys = $e484c752f3f06549$var$arrayPrototype.concat($e484c752f3f06549$var$getOwnPropertyNames(sourceComponent), // $FlowFixMe
        $e484c752f3f06549$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $e484c752f3f06549$var$TYPE_STATICS[targetComponent.$$typeof] || $e484c752f3f06549$var$REACT_STATICS;
        var sourceStatics = $e484c752f3f06549$var$TYPE_STATICS[sourceComponent.$$typeof] || $e484c752f3f06549$var$REACT_STATICS;
        var i = keys.length;
        var descriptor = void 0;
        var key = void 0;
        // eslint-disable-next-line no-plusplus
        while(i--){
            key = keys[i];
            if (// $FlowFixMe
            !$e484c752f3f06549$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && // $FlowFixMe
            !(targetStatics && targetStatics[key])) {
                descriptor = $e484c752f3f06549$var$getOwnPropertyDescriptor(sourceComponent, key);
                if (descriptor) try {
                    // Avoid failures from read-only properties
                    $e484c752f3f06549$var$defineProperty$1(targetComponent, key, descriptor);
                } catch (e) {
                /* fail silently */ }
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
// 
function $e484c752f3f06549$var$isDerivedReactComponent(fn) {
    return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}
// 
// Helper to call a given function, only once
var $e484c752f3f06549$var$once = function(cb) {
    var called = false;
    return function() {
        if (!called) {
            called = true;
            cb.apply(undefined, arguments);
        }
    };
};
// 
var $e484c752f3f06549$export$2c657da244d00bd6 = (0, $bh6RR.createContext)();
var $e484c752f3f06549$export$b631efc24e9d5e2f = $e484c752f3f06549$export$2c657da244d00bd6.Consumer;
/**
 * Provide a theme to an entire react component tree via context
 */ var $e484c752f3f06549$export$d8964aec282183a3 = function(_Component) {
    $e484c752f3f06549$var$inherits(ThemeProvider, _Component);
    function ThemeProvider(props) {
        $e484c752f3f06549$var$classCallCheck(this, ThemeProvider);
        var _this = $e484c752f3f06549$var$possibleConstructorReturn(this, _Component.call(this, props));
        _this.getContext = (0, $1XykX.default)(_this.getContext.bind(_this));
        _this.renderInner = _this.renderInner.bind(_this);
        return _this;
    }
    ThemeProvider.prototype.render = function render() {
        if (!this.props.children) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$2c657da244d00bd6.Consumer, null, this.renderInner);
    };
    ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
        var context = this.getContext(this.props.theme, outerTheme);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$2c657da244d00bd6.Provider, {
            value: context
        }, this.props.children);
    };
    /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */ ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
        if ($e484c752f3f06549$var$isFunction(theme)) {
            var mergedTheme = theme(outerTheme);
            return mergedTheme;
        }
        if (theme === null || Array.isArray(theme) || (typeof theme === "undefined" ? "undefined" : $e484c752f3f06549$var$_typeof(theme)) !== "object") throw new $e484c752f3f06549$var$StyledComponentsError(8);
        return $e484c752f3f06549$var$_extends({}, outerTheme, theme);
    };
    ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
        return this.getTheme(theme, outerTheme);
    };
    return ThemeProvider;
}((0, $bh6RR.Component));
// 
var $e484c752f3f06549$var$CLOSING_TAG_R = /^\s*<\/[a-z]/i;
var $e484c752f3f06549$export$ae8c7d15c8b89a20 = function() {
    function ServerStyleSheet() {
        $e484c752f3f06549$var$classCallCheck(this, ServerStyleSheet);
        /* The master sheet might be reset, so keep a reference here */ this.masterSheet = $e484c752f3f06549$var$StyleSheet.master;
        this.instance = this.masterSheet.clone();
        this.sealed = false;
    }
    /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */ ServerStyleSheet.prototype.seal = function seal() {
        if (!this.sealed) {
            /* Remove sealed StyleSheets from the master sheet */ var index = this.masterSheet.clones.indexOf(this.instance);
            this.masterSheet.clones.splice(index, 1);
            this.sealed = true;
        }
    };
    ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
        if (this.sealed) throw new $e484c752f3f06549$var$StyledComponentsError(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, children);
    };
    ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
        this.seal();
        return this.instance.toHTML();
    };
    ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
        this.seal();
        return this.instance.toReactElements();
    };
    ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
        var _this = this;
        var instance, instanceTagIndex, streamAttr, transformer;
        throw new $e484c752f3f06549$var$StyledComponentsError(3);
    };
    return ServerStyleSheet;
}();
// 
var $e484c752f3f06549$export$8c190ef828af4c86 = (0, $bh6RR.createContext)();
var $e484c752f3f06549$export$91317688fc694efa = $e484c752f3f06549$export$8c190ef828af4c86.Consumer;
var $e484c752f3f06549$export$a473771da2f0ff7c = function(_Component) {
    $e484c752f3f06549$var$inherits(StyleSheetManager, _Component);
    function StyleSheetManager(props) {
        $e484c752f3f06549$var$classCallCheck(this, StyleSheetManager);
        var _this = $e484c752f3f06549$var$possibleConstructorReturn(this, _Component.call(this, props));
        _this.getContext = (0, $1XykX.default)(_this.getContext);
        return _this;
    }
    StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
        if (sheet) return sheet;
        else if (target) return new $e484c752f3f06549$var$StyleSheet(target);
        else throw new $e484c752f3f06549$var$StyledComponentsError(4);
    };
    StyleSheetManager.prototype.render = function render() {
        var _props = this.props, children = _props.children, sheet = _props.sheet, target = _props.target;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$8c190ef828af4c86.Provider, {
            value: this.getContext(sheet, target)
        }, children);
    };
    return StyleSheetManager;
}((0, $bh6RR.Component));
// 
var $e484c752f3f06549$var$identifiers = {};
/* We depend on components having unique IDs */ function $e484c752f3f06549$var$generateId(_ComponentStyle, _displayName, parentComponentId) {
    var displayName = typeof _displayName !== "string" ? "sc" : $e484c752f3f06549$var$escape(_displayName);
    /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */ var nr = ($e484c752f3f06549$var$identifiers[displayName] || 0) + 1;
    $e484c752f3f06549$var$identifiers[displayName] = nr;
    var componentId = displayName + "-" + _ComponentStyle.generateName(displayName + nr);
    return parentComponentId ? parentComponentId + "-" + componentId : componentId;
}
// $FlowFixMe
var $e484c752f3f06549$var$StyledComponent = function(_Component) {
    $e484c752f3f06549$var$inherits(StyledComponent, _Component);
    function StyledComponent() {
        $e484c752f3f06549$var$classCallCheck(this, StyledComponent);
        var _this = $e484c752f3f06549$var$possibleConstructorReturn(this, _Component.call(this));
        _this.attrs = {};
        _this.renderOuter = _this.renderOuter.bind(_this);
        _this.renderInner = _this.renderInner.bind(_this);
        return _this;
    }
    StyledComponent.prototype.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$91317688fc694efa, null, this.renderOuter);
    };
    StyledComponent.prototype.renderOuter = function renderOuter() {
        var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e484c752f3f06549$var$StyleSheet.master;
        this.styleSheet = styleSheet;
        // No need to subscribe a static component to theme changes, it won't change anything
        if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$b631efc24e9d5e2f, null, this.renderInner);
    };
    StyledComponent.prototype.renderInner = function renderInner(theme) {
        var _props$forwardedCompo = this.props.forwardedComponent, componentStyle = _props$forwardedCompo.componentStyle, defaultProps = _props$forwardedCompo.defaultProps, displayName = _props$forwardedCompo.displayName, foldedComponentIds = _props$forwardedCompo.foldedComponentIds, styledComponentId = _props$forwardedCompo.styledComponentId, target = _props$forwardedCompo.target;
        var generatedClassName = void 0;
        if (componentStyle.isStatic) generatedClassName = this.generateAndInjectStyles($e484c752f3f06549$var$EMPTY_OBJECT, this.props);
        else generatedClassName = this.generateAndInjectStyles($e484c752f3f06549$var$determineTheme(this.props, theme, defaultProps) || $e484c752f3f06549$var$EMPTY_OBJECT, this.props);
        var elementToBeCreated = this.props.as || this.attrs.as || target;
        var isTargetTag = $e484c752f3f06549$var$isTag(elementToBeCreated);
        var propsForElement = {};
        var computedProps = $e484c752f3f06549$var$_extends({}, this.props, this.attrs);
        var key = void 0;
        // eslint-disable-next-line guard-for-in
        for(key in computedProps){
            if (key === "forwardedComponent" || key === "as") continue;
            else if (key === "forwardedRef") propsForElement.ref = computedProps[key];
            else if (key === "forwardedAs") propsForElement.as = computedProps[key];
            else if (!isTargetTag || (0, $fjRTt.default)(key)) // Don't pass through non HTML tags through to HTML elements
            propsForElement[key] = computedProps[key];
        }
        if (this.props.style && this.attrs.style) propsForElement.style = $e484c752f3f06549$var$_extends({}, this.attrs.style, this.props.style);
        propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, this.props.className, this.attrs.className).filter(Boolean).join(" ");
        return (0, $bh6RR.createElement)(elementToBeCreated, propsForElement);
    };
    StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
        var _this2 = this;
        var context = $e484c752f3f06549$var$_extends({}, props, {
            theme: theme
        });
        if (!attrs.length) return context;
        this.attrs = {};
        attrs.forEach(function(attrDef) {
            var resolvedAttrDef = attrDef;
            var attrDefWasFn = false;
            var attr = void 0;
            var key = void 0;
            if ($e484c752f3f06549$var$isFunction(resolvedAttrDef)) {
                // $FlowFixMe
                resolvedAttrDef = resolvedAttrDef(context);
                attrDefWasFn = true;
            }
            /* eslint-disable guard-for-in */ // $FlowFixMe
            for(key in resolvedAttrDef){
                attr = resolvedAttrDef[key];
                if (!attrDefWasFn) {
                    if ($e484c752f3f06549$var$isFunction(attr) && !$e484c752f3f06549$var$isDerivedReactComponent(attr) && !$e484c752f3f06549$export$7ba318d8d2f06c76(attr)) attr = attr(context);
                }
                _this2.attrs[key] = attr;
                context[key] = attr;
            }
        /* eslint-enable */ });
        return context;
    };
    StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
        var _props$forwardedCompo2 = props.forwardedComponent, attrs = _props$forwardedCompo2.attrs, componentStyle = _props$forwardedCompo2.componentStyle, warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;
        // statically styled-components don't need to build an execution context object,
        // and shouldn't be increasing the number of class names
        if (componentStyle.isStatic && !attrs.length) return componentStyle.generateAndInjectStyles($e484c752f3f06549$var$EMPTY_OBJECT, this.styleSheet);
        var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);
        return className;
    };
    return StyledComponent;
}((0, $bh6RR.Component));
function $e484c752f3f06549$var$createStyledComponent(target, options, rules) {
    var isTargetStyledComp = $e484c752f3f06549$export$7ba318d8d2f06c76(target);
    var isClass = !$e484c752f3f06549$var$isTag(target);
    var _options$displayName = options.displayName, displayName = _options$displayName === undefined ? $e484c752f3f06549$var$generateDisplayName(target) : _options$displayName, _options$componentId = options.componentId, componentId = _options$componentId === undefined ? $e484c752f3f06549$var$generateId($e484c752f3f06549$var$ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId, _options$ParentCompon = options.ParentComponent, ParentComponent = _options$ParentCompon === undefined ? $e484c752f3f06549$var$StyledComponent : _options$ParentCompon, _options$attrs = options.attrs, attrs = _options$attrs === undefined ? $e484c752f3f06549$var$EMPTY_ARRAY : _options$attrs;
    var styledComponentId = options.displayName && options.componentId ? $e484c752f3f06549$var$escape(options.displayName) + "-" + options.componentId : options.componentId || componentId;
    // fold the underlying StyledComponent attrs up (implicit extend)
    var finalAttrs = // $FlowFixMe
    isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;
    var componentStyle = new $e484c752f3f06549$var$ComponentStyle(isTargetStyledComp ? // $FlowFixMe
    target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);
    /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */ var WrappedStyledComponent = void 0;
    var forwardRef = function forwardRef(props, ref) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ParentComponent, $e484c752f3f06549$var$_extends({}, props, {
            forwardedComponent: WrappedStyledComponent,
            forwardedRef: ref
        }));
    };
    forwardRef.displayName = displayName;
    WrappedStyledComponent = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(forwardRef);
    WrappedStyledComponent.displayName = displayName;
    // $FlowFixMe
    WrappedStyledComponent.attrs = finalAttrs;
    // $FlowFixMe
    WrappedStyledComponent.componentStyle = componentStyle;
    // $FlowFixMe
    WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : $e484c752f3f06549$var$EMPTY_ARRAY;
    // $FlowFixMe
    WrappedStyledComponent.styledComponentId = styledComponentId;
    // fold the underlying StyledComponent target up since we folded the styles
    // $FlowFixMe
    WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;
    // $FlowFixMe
    WrappedStyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId, optionsToCopy = $e484c752f3f06549$var$objectWithoutProperties(options, [
            "componentId"
        ]);
        var newComponentId = previousComponentId && previousComponentId + "-" + ($e484c752f3f06549$var$isTag(tag) ? tag : $e484c752f3f06549$var$escape($e484c752f3f06549$var$getComponentName(tag)));
        var newOptions = $e484c752f3f06549$var$_extends({}, optionsToCopy, {
            attrs: finalAttrs,
            componentId: newComponentId,
            ParentComponent: ParentComponent
        });
        return $e484c752f3f06549$var$createStyledComponent(tag, newOptions, rules);
    };
    // $FlowFixMe
    Object.defineProperty(WrappedStyledComponent, "defaultProps", {
        get: function get$$1() {
            return this._foldedDefaultProps;
        },
        set: function set$$1(obj) {
            // $FlowFixMe
            this._foldedDefaultProps = isTargetStyledComp ? (0, $1CDLR.default)(target.defaultProps, obj) : obj;
        }
    });
    // $FlowFixMe
    WrappedStyledComponent.toString = function() {
        return "." + WrappedStyledComponent.styledComponentId;
    };
    if (isClass) $e484c752f3f06549$var$hoistNonReactStatics(WrappedStyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        foldedComponentIds: true,
        styledComponentId: true,
        target: true,
        withComponent: true
    });
    return WrappedStyledComponent;
}
// 
// Thanks to ReactDOMFactories for this handy list!
var $e484c752f3f06549$var$domElements = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
// 
var $e484c752f3f06549$var$styled = function styled(tag) {
    return $e484c752f3f06549$var$constructWithOptions($e484c752f3f06549$var$createStyledComponent, tag);
};
// Shorthands for all valid HTML Elements
$e484c752f3f06549$var$domElements.forEach(function(domElement) {
    $e484c752f3f06549$var$styled[domElement] = $e484c752f3f06549$var$styled(domElement);
});
// 
var $e484c752f3f06549$var$GlobalStyle = function() {
    function GlobalStyle(rules, componentId) {
        $e484c752f3f06549$var$classCallCheck(this, GlobalStyle);
        this.rules = rules;
        this.componentId = componentId;
        this.isStatic = $e484c752f3f06549$var$isStaticRules(rules, $e484c752f3f06549$var$EMPTY_ARRAY);
        if (!$e484c752f3f06549$var$StyleSheet.master.hasId(componentId)) $e484c752f3f06549$var$StyleSheet.master.deferredInject(componentId, []);
    }
    GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
        var flatCSS = $e484c752f3f06549$var$flatten(this.rules, executionContext, styleSheet);
        var css = $e484c752f3f06549$var$stringifyRules(flatCSS, "");
        styleSheet.inject(this.componentId, css);
    };
    GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
        var componentId = this.componentId;
        if (styleSheet.hasId(componentId)) styleSheet.remove(componentId);
    };
    // TODO: overwrite in-place instead of remove+create?
    GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
        this.removeStyles(styleSheet);
        this.createStyles(executionContext, styleSheet);
    };
    return GlobalStyle;
}();
// 
// place our cache into shared context so it'll persist between HMRs
if ($e484c752f3f06549$var$IS_BROWSER) window.scCGSHMRCache = {};
function $e484c752f3f06549$export$f0f03736edb61697(strings) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    var rules = $e484c752f3f06549$export$dbf350e5966cf602.apply(undefined, [
        strings
    ].concat(interpolations));
    var id = "sc-global-" + $e484c752f3f06549$var$murmurhash(JSON.stringify(rules));
    var style = new $e484c752f3f06549$var$GlobalStyle(rules, id);
    var GlobalStyleComponent = function(_React$Component) {
        $e484c752f3f06549$var$inherits(GlobalStyleComponent, _React$Component);
        function GlobalStyleComponent(props) {
            $e484c752f3f06549$var$classCallCheck(this, GlobalStyleComponent);
            var _this = $e484c752f3f06549$var$possibleConstructorReturn(this, _React$Component.call(this, props));
            var _this$constructor = _this.constructor, globalStyle = _this$constructor.globalStyle, styledComponentId = _this$constructor.styledComponentId;
            if ($e484c752f3f06549$var$IS_BROWSER) window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
            /**
       * This fixes HMR compatibility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */ _this.state = {
                globalStyle: globalStyle,
                styledComponentId: styledComponentId
            };
            return _this;
        }
        GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            if (window.scCGSHMRCache[this.state.styledComponentId]) window.scCGSHMRCache[this.state.styledComponentId] -= 1;
            /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */ if (window.scCGSHMRCache[this.state.styledComponentId] === 0) this.state.globalStyle.removeStyles(this.styleSheet);
        };
        GlobalStyleComponent.prototype.render = function render() {
            var _this2 = this;
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$91317688fc694efa, null, function(styleSheet) {
                _this2.styleSheet = styleSheet || $e484c752f3f06549$var$StyleSheet.master;
                var globalStyle = _this2.state.globalStyle;
                if (globalStyle.isStatic) {
                    globalStyle.renderStyles($e484c752f3f06549$var$STATIC_EXECUTION_CONTEXT, _this2.styleSheet);
                    return null;
                } else return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$b631efc24e9d5e2f, null, function(theme) {
                    // $FlowFixMe
                    var defaultProps = _this2.constructor.defaultProps;
                    var context = $e484c752f3f06549$var$_extends({}, _this2.props);
                    if (typeof theme !== "undefined") context.theme = $e484c752f3f06549$var$determineTheme(_this2.props, theme, defaultProps);
                    globalStyle.renderStyles(context, _this2.styleSheet);
                    return null;
                });
            });
        };
        return GlobalStyleComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
    GlobalStyleComponent.globalStyle = style;
    GlobalStyleComponent.styledComponentId = id;
    return GlobalStyleComponent;
}
// 
var $e484c752f3f06549$var$replaceWhitespace = function replaceWhitespace(str) {
    return str.replace(/\s|\\n/g, "");
};
function $e484c752f3f06549$export$d25ddfdf17c3ad3e(strings) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    var rules = $e484c752f3f06549$export$dbf350e5966cf602.apply(undefined, [
        strings
    ].concat(interpolations));
    var name = $e484c752f3f06549$var$generateAlphabeticName($e484c752f3f06549$var$murmurhash($e484c752f3f06549$var$replaceWhitespace(JSON.stringify(rules))));
    return new $e484c752f3f06549$var$Keyframes(name, $e484c752f3f06549$var$stringifyRules(rules, name, "@keyframes"));
}
// 
var $e484c752f3f06549$export$e8748c6a27b910dc = function(Component$$1) {
    var WithTheme = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function(props, ref) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$b631efc24e9d5e2f, null, function(theme) {
            // $FlowFixMe
            var defaultProps = Component$$1.defaultProps;
            var themeProp = $e484c752f3f06549$var$determineTheme(props, theme, defaultProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component$$1, $e484c752f3f06549$var$_extends({}, props, {
                theme: themeProp,
                ref: ref
            }));
        });
    });
    $e484c752f3f06549$var$hoistNonReactStatics(WithTheme, Component$$1);
    WithTheme.displayName = "WithTheme(" + $e484c752f3f06549$var$getComponentName(Component$$1) + ")";
    return WithTheme;
};
// 
/* eslint-disable */ var $e484c752f3f06549$export$84079c323bb0915e = {
    StyleSheet: $e484c752f3f06549$var$StyleSheet
};
var //
$e484c752f3f06549$export$2e2bcd8739ae039 = $e484c752f3f06549$var$styled;

});
parcelRegister("1xzjt", function(module, exports) {
!function(e) {
    module.exports = e(null);
}(function e(a) {
    "use strict";
    var r = /^\0+/g, c = /[\0\r\f]/g, s = /: */g, t = /zoo|gra/, i = /([,: ])(transform)/g, f = /,+\s*(?![^(]*[)])/g, n = / +\s*(?![^(]*[)])/g, l = / *[\0] */g, o = /,\r+?/g, h = /([\t\r\n ])*\f?&/g, u = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g, d = /\W+/g, b = /@(k\w+)\s*(\S*)\s*/, p = /::(place)/g, k = /:(read-only)/g, g = /\s+(?=[{\];=:>])/g, A = /([[}=:>])\s+/g, C = /(\{[^{]+?);(?=\})/g, w = /\s{2,}/g, v = /([^\(])(:+) */g, m = /[svh]\w+-[tblr]{2}/, x = /\(\s*(.*)\s*\)/g, $ = /([\s\S]*?);/g, y = /-self|flex-/g, O = /[^]*?(:[rp][el]a[\w-]+)[^]*/, j = /stretch|:\s*\w+\-(?:conte|avail)/, z = /([^-])(image-set\()/, N = "-webkit-", S = "-moz-", F = "-ms-", W = 59, q = 125, B = 123, D = 40, E = 41, G = 91, H = 93, I = 10, J = 13, K = 9, L = 64, M = 32, P = 38, Q = 45, R = 95, T = 42, U = 44, V = 58, X = 39, Y = 34, Z = 47, _ = 62, ee = 43, ae = 126, re = 0, ce = 12, se = 11, te = 107, ie = 109, fe = 115, ne = 112, le = 111, oe = 105, he = 99, ue = 100, de = 112, be = 1, pe = 1, ke = 0, ge = 1, Ae = 1, Ce = 1, we = 0, ve = 0, me = 0, xe = [], $e = [], ye = 0, Oe = null, je = -2, ze = -1, Ne = 0, Se = 1, Fe = 2, We = 3, qe = 0, Be = 1, De = "", Ee = "", Ge = "";
    function He(e, a, s, t, i) {
        for(var f, n, o = 0, h = 0, u = 0, d = 0, g = 0, A = 0, C = 0, w = 0, m = 0, $ = 0, y = 0, O = 0, j = 0, z = 0, R = 0, we = 0, $e = 0, Oe = 0, je = 0, ze = s.length, Je = ze - 1, Re = "", Te = "", Ue = "", Ve = "", Xe = "", Ye = ""; R < ze;){
            if (C = s.charCodeAt(R), R === Je) {
                if (h + d + u + o !== 0) {
                    if (0 !== h) C = h === Z ? I : Z;
                    d = u = o = 0, ze++, Je++;
                }
            }
            if (h + d + u + o === 0) {
                if (R === Je) {
                    if (we > 0) Te = Te.replace(c, "");
                    if (Te.trim().length > 0) {
                        switch(C){
                            case M:
                            case K:
                            case W:
                            case J:
                            case I:
                                break;
                            default:
                                Te += s.charAt(R);
                        }
                        C = W;
                    }
                }
                if (1 === $e) switch(C){
                    case B:
                    case q:
                    case W:
                    case Y:
                    case X:
                    case D:
                    case E:
                    case U:
                        $e = 0;
                    case K:
                    case J:
                    case I:
                    case M:
                        break;
                    default:
                        for($e = 0, je = R, g = C, R--, C = W; je < ze;)switch(s.charCodeAt(je++)){
                            case I:
                            case J:
                            case W:
                                ++R, C = g, je = ze;
                                break;
                            case V:
                                if (we > 0) ++R, C = g;
                            case B:
                                je = ze;
                        }
                }
                switch(C){
                    case B:
                        for(g = (Te = Te.trim()).charCodeAt(0), y = 1, je = ++R; R < ze;){
                            switch(C = s.charCodeAt(R)){
                                case B:
                                    y++;
                                    break;
                                case q:
                                    y--;
                                    break;
                                case Z:
                                    switch(A = s.charCodeAt(R + 1)){
                                        case T:
                                        case Z:
                                            R = Qe(A, R, Je, s);
                                    }
                                    break;
                                case G:
                                    C++;
                                case D:
                                    C++;
                                case Y:
                                case X:
                                    for(; R++ < Je && s.charCodeAt(R) !== C;);
                            }
                            if (0 === y) break;
                            R++;
                        }
                        if (Ue = s.substring(je, R), g === re) g = (Te = Te.replace(r, "").trim()).charCodeAt(0);
                        switch(g){
                            case L:
                                if (we > 0) Te = Te.replace(c, "");
                                switch(A = Te.charCodeAt(1)){
                                    case ue:
                                    case ie:
                                    case fe:
                                    case Q:
                                        f = a;
                                        break;
                                    default:
                                        f = xe;
                                }
                                if (je = (Ue = He(a, f, Ue, A, i + 1)).length, me > 0 && 0 === je) je = Te.length;
                                if (ye > 0) {
                                    if (f = Ie(xe, Te, Oe), n = Pe(We, Ue, f, a, pe, be, je, A, i, t), Te = f.join(""), void 0 !== n) {
                                        if (0 === (je = (Ue = n.trim()).length)) A = 0, Ue = "";
                                    }
                                }
                                if (je > 0) switch(A){
                                    case fe:
                                        Te = Te.replace(x, Me);
                                    case ue:
                                    case ie:
                                    case Q:
                                        Ue = Te + "{" + Ue + "}";
                                        break;
                                    case te:
                                        if (Ue = (Te = Te.replace(b, "$1 $2" + (Be > 0 ? De : ""))) + "{" + Ue + "}", 1 === Ae || 2 === Ae && Le("@" + Ue, 3)) Ue = "@" + N + Ue + "@" + Ue;
                                        else Ue = "@" + Ue;
                                        break;
                                    default:
                                        if (Ue = Te + Ue, t === de) Ve += Ue, Ue = "";
                                }
                                else Ue = "";
                                break;
                            default:
                                Ue = He(a, Ie(a, Te, Oe), Ue, t, i + 1);
                        }
                        Xe += Ue, O = 0, $e = 0, z = 0, we = 0, Oe = 0, j = 0, Te = "", Ue = "", C = s.charCodeAt(++R);
                        break;
                    case q:
                    case W:
                        if ((je = (Te = (we > 0 ? Te.replace(c, "") : Te).trim()).length) > 1) {
                            if (0 === z) {
                                if ((g = Te.charCodeAt(0)) === Q || g > 96 && g < 123) je = (Te = Te.replace(" ", ":")).length;
                            }
                            if (ye > 0) {
                                if (void 0 !== (n = Pe(Se, Te, a, e, pe, be, Ve.length, t, i, t))) {
                                    if (0 === (je = (Te = n.trim()).length)) Te = "\x00\x00";
                                }
                            }
                            switch(g = Te.charCodeAt(0), A = Te.charCodeAt(1), g){
                                case re:
                                    break;
                                case L:
                                    if (A === oe || A === he) {
                                        Ye += Te + s.charAt(R);
                                        break;
                                    }
                                default:
                                    if (Te.charCodeAt(je - 1) === V) break;
                                    Ve += Ke(Te, g, A, Te.charCodeAt(2));
                            }
                        }
                        O = 0, $e = 0, z = 0, we = 0, Oe = 0, Te = "", C = s.charCodeAt(++R);
                }
            }
            switch(C){
                case J:
                case I:
                    if (h + d + u + o + ve === 0) switch($){
                        case E:
                        case X:
                        case Y:
                        case L:
                        case ae:
                        case _:
                        case T:
                        case ee:
                        case Z:
                        case Q:
                        case V:
                        case U:
                        case W:
                        case B:
                        case q:
                            break;
                        default:
                            if (z > 0) $e = 1;
                    }
                    if (h === Z) h = 0;
                    else if (ge + O === 0 && t !== te && Te.length > 0) we = 1, Te += "\x00";
                    if (ye * qe > 0) Pe(Ne, Te, a, e, pe, be, Ve.length, t, i, t);
                    be = 1, pe++;
                    break;
                case W:
                case q:
                    if (h + d + u + o === 0) {
                        be++;
                        break;
                    }
                default:
                    switch(be++, Re = s.charAt(R), C){
                        case K:
                        case M:
                            if (d + o + h === 0) switch(w){
                                case U:
                                case V:
                                case K:
                                case M:
                                    Re = "";
                                    break;
                                default:
                                    if (C !== M) Re = " ";
                            }
                            break;
                        case re:
                            Re = "\\0";
                            break;
                        case ce:
                            Re = "\\f";
                            break;
                        case se:
                            Re = "\\v";
                            break;
                        case P:
                            if (d + h + o === 0 && ge > 0) Oe = 1, we = 1, Re = "\f" + Re;
                            break;
                        case 108:
                            if (d + h + o + ke === 0 && z > 0) switch(R - z){
                                case 2:
                                    if (w === ne && s.charCodeAt(R - 3) === V) ke = w;
                                case 8:
                                    if (m === le) ke = m;
                            }
                            break;
                        case V:
                            if (d + h + o === 0) z = R;
                            break;
                        case U:
                            if (h + u + d + o === 0) we = 1, Re += "\r";
                            break;
                        case Y:
                        case X:
                            if (0 === h) d = d === C ? 0 : 0 === d ? C : d;
                            break;
                        case G:
                            if (d + h + u === 0) o++;
                            break;
                        case H:
                            if (d + h + u === 0) o--;
                            break;
                        case E:
                            if (d + h + o === 0) u--;
                            break;
                        case D:
                            if (d + h + o === 0) {
                                if (0 === O) switch(2 * w + 3 * m){
                                    case 533:
                                        break;
                                    default:
                                        y = 0, O = 1;
                                }
                                u++;
                            }
                            break;
                        case L:
                            if (h + u + d + o + z + j === 0) j = 1;
                            break;
                        case T:
                        case Z:
                            if (d + o + u > 0) break;
                            switch(h){
                                case 0:
                                    switch(2 * C + 3 * s.charCodeAt(R + 1)){
                                        case 235:
                                            h = Z;
                                            break;
                                        case 220:
                                            je = R, h = T;
                                    }
                                    break;
                                case T:
                                    if (C === Z && w === T && je + 2 !== R) {
                                        if (33 === s.charCodeAt(je + 2)) Ve += s.substring(je, R + 1);
                                        Re = "", h = 0;
                                    }
                            }
                    }
                    if (0 === h) {
                        if (ge + d + o + j === 0 && t !== te && C !== W) switch(C){
                            case U:
                            case ae:
                            case _:
                            case ee:
                            case E:
                            case D:
                                if (0 === O) {
                                    switch(w){
                                        case K:
                                        case M:
                                        case I:
                                        case J:
                                            Re += "\x00";
                                            break;
                                        default:
                                            Re = "\x00" + Re + (C === U ? "" : "\x00");
                                    }
                                    we = 1;
                                } else switch(C){
                                    case D:
                                        if (z + 7 === R && 108 === w) z = 0;
                                        O = ++y;
                                        break;
                                    case E:
                                        if (0 == (O = --y)) we = 1, Re += "\x00";
                                }
                                break;
                            case K:
                            case M:
                                switch(w){
                                    case re:
                                    case B:
                                    case q:
                                    case W:
                                    case U:
                                    case ce:
                                    case K:
                                    case M:
                                    case I:
                                    case J:
                                        break;
                                    default:
                                        if (0 === O) we = 1, Re += "\x00";
                                }
                        }
                        if (Te += Re, C !== M && C !== K) $ = C;
                    }
            }
            m = w, w = C, R++;
        }
        if (je = Ve.length, me > 0) {
            if (0 === je && 0 === Xe.length && 0 === a[0].length == false) {
                if (t !== ie || 1 === a.length && (ge > 0 ? Ee : Ge) === a[0]) je = a.join(",").length + 2;
            }
        }
        if (je > 0) {
            if (f = 0 === ge && t !== te ? function(e) {
                for(var a, r, s = 0, t = e.length, i = Array(t); s < t; ++s){
                    for(var f = e[s].split(l), n = "", o = 0, h = 0, u = 0, d = 0, b = f.length; o < b; ++o){
                        if (0 === (h = (r = f[o]).length) && b > 1) continue;
                        if (u = n.charCodeAt(n.length - 1), d = r.charCodeAt(0), a = "", 0 !== o) switch(u){
                            case T:
                            case ae:
                            case _:
                            case ee:
                            case M:
                            case D:
                                break;
                            default:
                                a = " ";
                        }
                        switch(d){
                            case P:
                                r = a + Ee;
                            case ae:
                            case _:
                            case ee:
                            case M:
                            case E:
                            case D:
                                break;
                            case G:
                                r = a + r + Ee;
                                break;
                            case V:
                                switch(2 * r.charCodeAt(1) + 3 * r.charCodeAt(2)){
                                    case 530:
                                        if (Ce > 0) {
                                            r = a + r.substring(8, h - 1);
                                            break;
                                        }
                                    default:
                                        if (o < 1 || f[o - 1].length < 1) r = a + Ee + r;
                                }
                                break;
                            case U:
                                a = "";
                            default:
                                if (h > 1 && r.indexOf(":") > 0) r = a + r.replace(v, "$1" + Ee + "$2");
                                else r = a + r + Ee;
                        }
                        n += r;
                    }
                    i[s] = n.replace(c, "").trim();
                }
                return i;
            }(a) : a, ye > 0) {
                if (void 0 !== (n = Pe(Fe, Ve, f, e, pe, be, je, t, i, t)) && 0 === (Ve = n).length) return Ye + Ve + Xe;
            }
            if (Ve = f.join(",") + "{" + Ve + "}", Ae * ke != 0) {
                if (2 === Ae && !Le(Ve, 2)) ke = 0;
                switch(ke){
                    case le:
                        Ve = Ve.replace(k, ":" + S + "$1") + Ve;
                        break;
                    case ne:
                        Ve = Ve.replace(p, "::" + N + "input-$1") + Ve.replace(p, "::" + S + "$1") + Ve.replace(p, ":" + F + "input-$1") + Ve;
                }
                ke = 0;
            }
        }
        return Ye + Ve + Xe;
    }
    function Ie(e, a, r) {
        var c = a.trim().split(o), s = c, t = c.length, i = e.length;
        switch(i){
            case 0:
            case 1:
                for(var f = 0, n = 0 === i ? "" : e[0] + " "; f < t; ++f)s[f] = Je(n, s[f], r, i).trim();
                break;
            default:
                f = 0;
                var l = 0;
                for(s = []; f < t; ++f)for(var h = 0; h < i; ++h)s[l++] = Je(e[h] + " ", c[f], r, i).trim();
        }
        return s;
    }
    function Je(e, a, r, c) {
        var s = a, t = s.charCodeAt(0);
        if (t < 33) t = (s = s.trim()).charCodeAt(0);
        switch(t){
            case P:
                switch(ge + c){
                    case 0:
                    case 1:
                        if (0 === e.trim().length) break;
                    default:
                        return s.replace(h, "$1" + e.trim());
                }
                break;
            case V:
                switch(s.charCodeAt(1)){
                    case 103:
                        if (Ce > 0 && ge > 0) return s.replace(u, "$1").replace(h, "$1" + Ge);
                        break;
                    default:
                        return e.trim() + s.replace(h, "$1" + e.trim());
                }
            default:
                if (r * ge > 0 && s.indexOf("\f") > 0) return s.replace(h, (e.charCodeAt(0) === V ? "" : "$1") + e.trim());
        }
        return e + s;
    }
    function Ke(e, a, r, c) {
        var l, o = 0, h = e + ";", u = 2 * a + 3 * r + 4 * c;
        if (944 === u) return function(e) {
            var a = e.length, r = e.indexOf(":", 9) + 1, c = e.substring(0, r).trim(), s = e.substring(r, a - 1).trim();
            switch(e.charCodeAt(9) * Be){
                case 0:
                    break;
                case Q:
                    if (110 !== e.charCodeAt(10)) break;
                default:
                    for(var t = s.split((s = "", f)), i = 0, r = 0, a = t.length; i < a; r = 0, ++i){
                        for(var l = t[i], o = l.split(n); l = o[r];){
                            var h = l.charCodeAt(0);
                            if (1 === Be && (h > L && h < 90 || h > 96 && h < 123 || h === R || h === Q && l.charCodeAt(1) !== Q)) switch(isNaN(parseFloat(l)) + (-1 !== l.indexOf("("))){
                                case 1:
                                    switch(l){
                                        case "infinite":
                                        case "alternate":
                                        case "backwards":
                                        case "running":
                                        case "normal":
                                        case "forwards":
                                        case "both":
                                        case "none":
                                        case "linear":
                                        case "ease":
                                        case "ease-in":
                                        case "ease-out":
                                        case "ease-in-out":
                                        case "paused":
                                        case "reverse":
                                        case "alternate-reverse":
                                        case "inherit":
                                        case "initial":
                                        case "unset":
                                        case "step-start":
                                        case "step-end":
                                            break;
                                        default:
                                            l += De;
                                    }
                            }
                            o[r++] = l;
                        }
                        s += (0 === i ? "" : ",") + o.join(" ");
                    }
            }
            if (s = c + s + ";", 1 === Ae || 2 === Ae && Le(s, 1)) return N + s + s;
            return s;
        }(h);
        else if (0 === Ae || 2 === Ae && !Le(h, 1)) return h;
        switch(u){
            case 1015:
                return 97 === h.charCodeAt(10) ? N + h + h : h;
            case 951:
                return 116 === h.charCodeAt(3) ? N + h + h : h;
            case 963:
                return 110 === h.charCodeAt(5) ? N + h + h : h;
            case 1009:
                if (100 !== h.charCodeAt(4)) break;
            case 969:
            case 942:
                return N + h + h;
            case 978:
                return N + h + S + h + h;
            case 1019:
            case 983:
                return N + h + S + h + F + h + h;
            case 883:
                if (h.charCodeAt(8) === Q) return N + h + h;
                if (h.indexOf("image-set(", 11) > 0) return h.replace(z, "$1" + N + "$2") + h;
                return h;
            case 932:
                if (h.charCodeAt(4) === Q) switch(h.charCodeAt(5)){
                    case 103:
                        return N + "box-" + h.replace("-grow", "") + N + h + F + h.replace("grow", "positive") + h;
                    case 115:
                        return N + h + F + h.replace("shrink", "negative") + h;
                    case 98:
                        return N + h + F + h.replace("basis", "preferred-size") + h;
                }
                return N + h + F + h + h;
            case 964:
                return N + h + F + "flex-" + h + h;
            case 1023:
                if (99 !== h.charCodeAt(8)) break;
                return l = h.substring(h.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), N + "box-pack" + l + N + h + F + "flex-pack" + l + h;
            case 1005:
                return t.test(h) ? h.replace(s, ":" + N) + h.replace(s, ":" + S) + h : h;
            case 1e3:
                switch(o = (l = h.substring(13).trim()).indexOf("-") + 1, l.charCodeAt(0) + l.charCodeAt(o)){
                    case 226:
                        l = h.replace(m, "tb");
                        break;
                    case 232:
                        l = h.replace(m, "tb-rl");
                        break;
                    case 220:
                        l = h.replace(m, "lr");
                        break;
                    default:
                        return h;
                }
                return N + h + F + l + h;
            case 1017:
                if (-1 === h.indexOf("sticky", 9)) return h;
            case 975:
                switch(o = (h = e).length - 10, u = (l = (33 === h.charCodeAt(o) ? h.substring(0, o) : h).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | l.charCodeAt(7))){
                    case 203:
                        if (l.charCodeAt(8) < 111) break;
                    case 115:
                        h = h.replace(l, N + l) + ";" + h;
                        break;
                    case 207:
                    case 102:
                        h = h.replace(l, N + (u > 102 ? "inline-" : "") + "box") + ";" + h.replace(l, N + l) + ";" + h.replace(l, F + l + "box") + ";" + h;
                }
                return h + ";";
            case 938:
                if (h.charCodeAt(5) === Q) switch(h.charCodeAt(6)){
                    case 105:
                        return l = h.replace("-items", ""), N + h + N + "box-" + l + F + "flex-" + l + h;
                    case 115:
                        return N + h + F + "flex-item-" + h.replace(y, "") + h;
                    default:
                        return N + h + F + "flex-line-pack" + h.replace("align-content", "").replace(y, "") + h;
                }
                break;
            case 973:
            case 989:
                if (h.charCodeAt(3) !== Q || 122 === h.charCodeAt(4)) break;
            case 931:
            case 953:
                if (true === j.test(e)) {
                    if (115 === (l = e.substring(e.indexOf(":") + 1)).charCodeAt(0)) return Ke(e.replace("stretch", "fill-available"), a, r, c).replace(":fill-available", ":stretch");
                    else return h.replace(l, N + l) + h.replace(l, S + l.replace("fill-", "")) + h;
                }
                break;
            case 962:
                if (h = N + h + (102 === h.charCodeAt(5) ? F + h : "") + h, r + c === 211 && 105 === h.charCodeAt(13) && h.indexOf("transform", 10) > 0) return h.substring(0, h.indexOf(";", 27) + 1).replace(i, "$1" + N + "$2") + h;
        }
        return h;
    }
    function Le(e, a) {
        var r = e.indexOf(1 === a ? ":" : "{"), c = e.substring(0, 3 !== a ? r : 10), s = e.substring(r + 1, e.length - 1);
        return Oe(2 !== a ? c : c.replace(O, "$1"), s, a);
    }
    function Me(e, a) {
        var r = Ke(a, a.charCodeAt(0), a.charCodeAt(1), a.charCodeAt(2));
        return r !== a + ";" ? r.replace($, " or ($1)").substring(4) : "(" + a + ")";
    }
    function Pe(e, a, r, c, s, t, i, f, n, l) {
        for(var o, h = 0, u = a; h < ye; ++h)switch(o = $e[h].call(Te, e, u, r, c, s, t, i, f, n, l)){
            case void 0:
            case false:
            case true:
            case null:
                break;
            default:
                u = o;
        }
        if (u !== a) return u;
    }
    function Qe(e, a, r, c) {
        for(var s = a + 1; s < r; ++s)switch(c.charCodeAt(s)){
            case Z:
                if (e === T) {
                    if (c.charCodeAt(s - 1) === T && a + 2 !== s) return s + 1;
                }
                break;
            case I:
                if (e === Z) return s + 1;
        }
        return s;
    }
    function Re(e) {
        for(var a in e){
            var r = e[a];
            switch(a){
                case "keyframe":
                    Be = 0 | r;
                    break;
                case "global":
                    Ce = 0 | r;
                    break;
                case "cascade":
                    ge = 0 | r;
                    break;
                case "compress":
                    we = 0 | r;
                    break;
                case "semicolon":
                    ve = 0 | r;
                    break;
                case "preserve":
                    me = 0 | r;
                    break;
                case "prefix":
                    if (Oe = null, !r) Ae = 0;
                    else if ("function" != typeof r) Ae = 1;
                    else Ae = 2, Oe = r;
            }
        }
        return Re;
    }
    function Te(a, r) {
        if (void 0 !== this && this.constructor === Te) return e(a);
        var s = a, t = s.charCodeAt(0);
        if (t < 33) t = (s = s.trim()).charCodeAt(0);
        if (Be > 0) De = s.replace(d, t === G ? "" : "-");
        if (t = 1, 1 === ge) Ge = s;
        else Ee = s;
        var i, f = [
            Ge
        ];
        if (ye > 0) {
            if (void 0 !== (i = Pe(ze, r, f, f, pe, be, 0, 0, 0, 0)) && "string" == typeof i) r = i;
        }
        var n = He(xe, f, r, 0, 0);
        if (ye > 0) {
            if (void 0 !== (i = Pe(je, n, f, f, pe, be, n.length, 0, 0, 0)) && "string" != typeof (n = i)) t = 0;
        }
        return De = "", Ge = "", Ee = "", ke = 0, pe = 1, be = 1, we * t == 0 ? n : n.replace(c, "").replace(g, "").replace(A, "$1").replace(C, "$1").replace(w, " ");
    }
    if (Te.use = function e(a) {
        switch(a){
            case void 0:
            case null:
                ye = $e.length = 0;
                break;
            default:
                if ("function" == typeof a) $e[ye++] = a;
                else if ("object" == typeof a) for(var r = 0, c = a.length; r < c; ++r)e(a[r]);
                else qe = 0 | !!a;
        }
        return e;
    }, Te.set = Re, void 0 !== a) Re(a);
    return Te;
});

});

parcelRegister("4yYy5", function(module, exports) {
(function(factory) {
    module.exports = factory();
})(function() {
    "use strict";
    return function(insertRule) {
        var delimiter = "/*|*/";
        var needle = delimiter + "}";
        function toSheet(block) {
            if (block) try {
                insertRule(block + "}");
            } catch (e) {}
        }
        return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
            switch(context){
                // property
                case 1:
                    // @import
                    if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ";"), "";
                    break;
                // selector
                case 2:
                    if (ns === 0) return content + delimiter;
                    break;
                // at-rule
                case 3:
                    switch(ns){
                        // @font-face, @page
                        case 102:
                        case 112:
                            return insertRule(selectors[0] + content), "";
                        default:
                            return content + (at === 0 ? delimiter : "");
                    }
                case -2:
                    content.split(needle).forEach(toSheet);
            }
        };
    };
});

});

parcelRegister("36HXn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24340788875123c5$export$2e2bcd8739ae039; });
var $24340788875123c5$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $24340788875123c5$export$2e2bcd8739ae039 = $24340788875123c5$var$unitlessKeys;

});

parcelRegister("3zV5k", function(module, exports) {
"use strict";

module.exports = (parcelRequire("l6ZS9"));

});
parcelRegister("l6ZS9", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $f5ea271189140e8d$export$2b8d127b894957b9; }, function (v) { return $f5ea271189140e8d$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $f5ea271189140e8d$export$cea3a54a6425200c; }, function (v) { return $f5ea271189140e8d$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $f5ea271189140e8d$export$a7c73072b1a182ae; }, function (v) { return $f5ea271189140e8d$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $f5ea271189140e8d$export$9f27bc3417b4524d; }, function (v) { return $f5ea271189140e8d$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $f5ea271189140e8d$export$db77ccec0bb4ccac; }, function (v) { return $f5ea271189140e8d$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $f5ea271189140e8d$export$8392c0c9d3dcbd35; }, function (v) { return $f5ea271189140e8d$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f5ea271189140e8d$export$ffb0004e005737fa; }, function (v) { return $f5ea271189140e8d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $f5ea271189140e8d$export$b624eff549462981; }, function (v) { return $f5ea271189140e8d$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $f5ea271189140e8d$export$7897aa7841a5380c; }, function (v) { return $f5ea271189140e8d$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $f5ea271189140e8d$export$602eac185826482c; }, function (v) { return $f5ea271189140e8d$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $f5ea271189140e8d$export$e2c29f18771995cb; }, function (v) { return $f5ea271189140e8d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f5ea271189140e8d$export$5f8d39834fd61797; }, function (v) { return $f5ea271189140e8d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f5ea271189140e8d$export$74bf444e3cd11ea5; }, function (v) { return $f5ea271189140e8d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $f5ea271189140e8d$export$92387174baf9b227; }, function (v) { return $f5ea271189140e8d$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $f5ea271189140e8d$export$ec112efeb987d9c6; }, function (v) { return $f5ea271189140e8d$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $f5ea271189140e8d$export$b706b080d889d2c9; }, function (v) { return $f5ea271189140e8d$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $f5ea271189140e8d$export$5be5a87408f70ddc; }, function (v) { return $f5ea271189140e8d$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $f5ea271189140e8d$export$45a5e7f76e0caa8d; }, function (v) { return $f5ea271189140e8d$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $f5ea271189140e8d$export$455c2e768291efa6; }, function (v) { return $f5ea271189140e8d$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $f5ea271189140e8d$export$9522e17588c12572; }, function (v) { return $f5ea271189140e8d$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $f5ea271189140e8d$export$2110ac352bb060b9; }, function (v) { return $f5ea271189140e8d$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $f5ea271189140e8d$export$56885ab8b9c456ab; }, function (v) { return $f5ea271189140e8d$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $f5ea271189140e8d$export$d927fcb6adf8f9de; }, function (v) { return $f5ea271189140e8d$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $f5ea271189140e8d$export$b82d16f27459e05a; }, function (v) { return $f5ea271189140e8d$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $f5ea271189140e8d$export$522c17b4f5e123e8; }, function (v) { return $f5ea271189140e8d$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $f5ea271189140e8d$export$1aabd8a0274ecfd6; }, function (v) { return $f5ea271189140e8d$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $f5ea271189140e8d$export$9b621391a187a31a; }, function (v) { return $f5ea271189140e8d$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $f5ea271189140e8d$export$f5bbd400c2f4426f; }, function (v) { return $f5ea271189140e8d$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f5ea271189140e8d$export$2b8d127b894957b9;
var $f5ea271189140e8d$export$cea3a54a6425200c;
var $f5ea271189140e8d$export$a7c73072b1a182ae;
var $f5ea271189140e8d$export$9f27bc3417b4524d;
var $f5ea271189140e8d$export$db77ccec0bb4ccac;
var $f5ea271189140e8d$export$8392c0c9d3dcbd35;
var $f5ea271189140e8d$export$ffb0004e005737fa;
var $f5ea271189140e8d$export$b624eff549462981;
var $f5ea271189140e8d$export$7897aa7841a5380c;
var $f5ea271189140e8d$export$602eac185826482c;
var $f5ea271189140e8d$export$e2c29f18771995cb;
var $f5ea271189140e8d$export$5f8d39834fd61797;
var $f5ea271189140e8d$export$74bf444e3cd11ea5;
var $f5ea271189140e8d$export$92387174baf9b227;
var $f5ea271189140e8d$export$ec112efeb987d9c6;
var $f5ea271189140e8d$export$b706b080d889d2c9;
var $f5ea271189140e8d$export$5be5a87408f70ddc;
var $f5ea271189140e8d$export$45a5e7f76e0caa8d;
var $f5ea271189140e8d$export$455c2e768291efa6;
var $f5ea271189140e8d$export$9522e17588c12572;
var $f5ea271189140e8d$export$2110ac352bb060b9;
var $f5ea271189140e8d$export$56885ab8b9c456ab;
var $f5ea271189140e8d$export$d927fcb6adf8f9de;
var $f5ea271189140e8d$export$b82d16f27459e05a;
var $f5ea271189140e8d$export$522c17b4f5e123e8;
var $f5ea271189140e8d$export$1aabd8a0274ecfd6;
var $f5ea271189140e8d$export$9b621391a187a31a;
var $f5ea271189140e8d$export$f5bbd400c2f4426f;
"use strict";
var $f5ea271189140e8d$var$b = "function" === typeof Symbol && Symbol.for, $f5ea271189140e8d$var$c = $f5ea271189140e8d$var$b ? Symbol.for("react.element") : 60103, $f5ea271189140e8d$var$d = $f5ea271189140e8d$var$b ? Symbol.for("react.portal") : 60106, $f5ea271189140e8d$var$e = $f5ea271189140e8d$var$b ? Symbol.for("react.fragment") : 60107, $f5ea271189140e8d$var$f = $f5ea271189140e8d$var$b ? Symbol.for("react.strict_mode") : 60108, $f5ea271189140e8d$var$g = $f5ea271189140e8d$var$b ? Symbol.for("react.profiler") : 60114, $f5ea271189140e8d$var$h = $f5ea271189140e8d$var$b ? Symbol.for("react.provider") : 60109, $f5ea271189140e8d$var$k = $f5ea271189140e8d$var$b ? Symbol.for("react.context") : 60110, $f5ea271189140e8d$var$l = $f5ea271189140e8d$var$b ? Symbol.for("react.async_mode") : 60111, $f5ea271189140e8d$var$m = $f5ea271189140e8d$var$b ? Symbol.for("react.concurrent_mode") : 60111, $f5ea271189140e8d$var$n = $f5ea271189140e8d$var$b ? Symbol.for("react.forward_ref") : 60112, $f5ea271189140e8d$var$p = $f5ea271189140e8d$var$b ? Symbol.for("react.suspense") : 60113, $f5ea271189140e8d$var$q = $f5ea271189140e8d$var$b ? Symbol.for("react.suspense_list") : 60120, $f5ea271189140e8d$var$r = $f5ea271189140e8d$var$b ? Symbol.for("react.memo") : 60115, $f5ea271189140e8d$var$t = $f5ea271189140e8d$var$b ? Symbol.for("react.lazy") : 60116, $f5ea271189140e8d$var$v = $f5ea271189140e8d$var$b ? Symbol.for("react.block") : 60121, $f5ea271189140e8d$var$w = $f5ea271189140e8d$var$b ? Symbol.for("react.fundamental") : 60117, $f5ea271189140e8d$var$x = $f5ea271189140e8d$var$b ? Symbol.for("react.responder") : 60118, $f5ea271189140e8d$var$y = $f5ea271189140e8d$var$b ? Symbol.for("react.scope") : 60119;
function $f5ea271189140e8d$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $f5ea271189140e8d$var$c:
                switch(a = a.type, a){
                    case $f5ea271189140e8d$var$l:
                    case $f5ea271189140e8d$var$m:
                    case $f5ea271189140e8d$var$e:
                    case $f5ea271189140e8d$var$g:
                    case $f5ea271189140e8d$var$f:
                    case $f5ea271189140e8d$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $f5ea271189140e8d$var$k:
                            case $f5ea271189140e8d$var$n:
                            case $f5ea271189140e8d$var$t:
                            case $f5ea271189140e8d$var$r:
                            case $f5ea271189140e8d$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $f5ea271189140e8d$var$d:
                return u;
        }
    }
}
function $f5ea271189140e8d$var$A(a) {
    return $f5ea271189140e8d$var$z(a) === $f5ea271189140e8d$var$m;
}
$f5ea271189140e8d$export$2b8d127b894957b9 = $f5ea271189140e8d$var$l;
$f5ea271189140e8d$export$cea3a54a6425200c = $f5ea271189140e8d$var$m;
$f5ea271189140e8d$export$a7c73072b1a182ae = $f5ea271189140e8d$var$k;
$f5ea271189140e8d$export$9f27bc3417b4524d = $f5ea271189140e8d$var$h;
$f5ea271189140e8d$export$db77ccec0bb4ccac = $f5ea271189140e8d$var$c;
$f5ea271189140e8d$export$8392c0c9d3dcbd35 = $f5ea271189140e8d$var$n;
$f5ea271189140e8d$export$ffb0004e005737fa = $f5ea271189140e8d$var$e;
$f5ea271189140e8d$export$b624eff549462981 = $f5ea271189140e8d$var$t;
$f5ea271189140e8d$export$7897aa7841a5380c = $f5ea271189140e8d$var$r;
$f5ea271189140e8d$export$602eac185826482c = $f5ea271189140e8d$var$d;
$f5ea271189140e8d$export$e2c29f18771995cb = $f5ea271189140e8d$var$g;
$f5ea271189140e8d$export$5f8d39834fd61797 = $f5ea271189140e8d$var$f;
$f5ea271189140e8d$export$74bf444e3cd11ea5 = $f5ea271189140e8d$var$p;
$f5ea271189140e8d$export$92387174baf9b227 = function(a) {
    return $f5ea271189140e8d$var$A(a) || $f5ea271189140e8d$var$z(a) === $f5ea271189140e8d$var$l;
};
$f5ea271189140e8d$export$ec112efeb987d9c6 = $f5ea271189140e8d$var$A;
$f5ea271189140e8d$export$b706b080d889d2c9 = function(a) {
    return $f5ea271189140e8d$var$z(a) === $f5ea271189140e8d$var$k;
};
$f5ea271189140e8d$export$5be5a87408f70ddc = function(a) {
    return $f5ea271189140e8d$var$z(a) === $f5ea271189140e8d$var$h;
};
$f5ea271189140e8d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f5ea271189140e8d$var$c;
};
$f5ea271189140e8d$export$455c2e768291efa6 = function(a) {
    return $f5ea271189140e8d$var$z(a) === $f5ea271189140e8d$var$n;
};
$f5ea271189140e8d$export$9522e17588c12572 = function(a) {
    return $f5ea271189140e8d$var$z(a) === $f5ea271189140e8d$var$e;
};
$f5ea271189140e8d$export$2110ac352bb060b9 = function(a) {
    return $f5ea271189140e8d$var$z(a) === $f5ea271189140e8d$var$t;
};
$f5ea271189140e8d$export$56885ab8b9c456ab = function(a) {
    return $f5ea271189140e8d$var$z(a) === $f5ea271189140e8d$var$r;
};
$f5ea271189140e8d$export$d927fcb6adf8f9de = function(a) {
    return $f5ea271189140e8d$var$z(a) === $f5ea271189140e8d$var$d;
};
$f5ea271189140e8d$export$b82d16f27459e05a = function(a) {
    return $f5ea271189140e8d$var$z(a) === $f5ea271189140e8d$var$g;
};
$f5ea271189140e8d$export$522c17b4f5e123e8 = function(a) {
    return $f5ea271189140e8d$var$z(a) === $f5ea271189140e8d$var$f;
};
$f5ea271189140e8d$export$1aabd8a0274ecfd6 = function(a) {
    return $f5ea271189140e8d$var$z(a) === $f5ea271189140e8d$var$p;
};
$f5ea271189140e8d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $f5ea271189140e8d$var$e || a === $f5ea271189140e8d$var$m || a === $f5ea271189140e8d$var$g || a === $f5ea271189140e8d$var$f || a === $f5ea271189140e8d$var$p || a === $f5ea271189140e8d$var$q || "object" === typeof a && null !== a && (a.$$typeof === $f5ea271189140e8d$var$t || a.$$typeof === $f5ea271189140e8d$var$r || a.$$typeof === $f5ea271189140e8d$var$h || a.$$typeof === $f5ea271189140e8d$var$k || a.$$typeof === $f5ea271189140e8d$var$n || a.$$typeof === $f5ea271189140e8d$var$w || a.$$typeof === $f5ea271189140e8d$var$x || a.$$typeof === $f5ea271189140e8d$var$y || a.$$typeof === $f5ea271189140e8d$var$v);
};
$f5ea271189140e8d$export$f5bbd400c2f4426f = $f5ea271189140e8d$var$z;

});


parcelRegister("1XykX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16d5efbf3de5c533$export$2e2bcd8739ae039; });
var $16d5efbf3de5c533$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $16d5efbf3de5c533$var$isEqual(first, second) {
    if (first === second) return true;
    if ($16d5efbf3de5c533$var$safeIsNaN(first) && $16d5efbf3de5c533$var$safeIsNaN(second)) return true;
    return false;
}
function $16d5efbf3de5c533$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$16d5efbf3de5c533$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $16d5efbf3de5c533$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $16d5efbf3de5c533$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $16d5efbf3de5c533$export$2e2bcd8739ae039 = $16d5efbf3de5c533$var$memoizeOne;

});

parcelRegister("fjRTt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2726f8b35d70887$export$2e2bcd8739ae039; });

var $6v5BY = parcelRequire("6v5BY");
var $b2726f8b35d70887$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $b2726f8b35d70887$var$index = (0, $6v5BY.default)(function(prop) {
    return $b2726f8b35d70887$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $b2726f8b35d70887$export$2e2bcd8739ae039 = $b2726f8b35d70887$var$index;

});
parcelRegister("6v5BY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bb9fdaae69fff99$export$2e2bcd8739ae039; });
function $4bb9fdaae69fff99$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $4bb9fdaae69fff99$export$2e2bcd8739ae039 = $4bb9fdaae69fff99$var$memoize;

});


parcelRegister("1CDLR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12e830c0dadf1c2c$export$2e2bcd8739ae039; });

var $kw4Kd = parcelRequire("kw4Kd");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ function $12e830c0dadf1c2c$var$__spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $12e830c0dadf1c2c$var$assignProp(carry, key, newVal, originalObject) {
    var propType = originalObject.propertyIsEnumerable(key) ? "enumerable" : "nonenumerable";
    if (propType === "enumerable") carry[key] = newVal;
    if (propType === "nonenumerable") Object.defineProperty(carry, key, {
        value: newVal,
        enumerable: false,
        writable: true,
        configurable: true
    });
}
function $12e830c0dadf1c2c$var$mergeRecursively(origin, newComer, extensions) {
    // work directly on newComer if its not an object
    if (!(0, $kw4Kd.isPlainObject)(newComer)) {
        // extend merge rules
        if (extensions && (0, $kw4Kd.isArray)(extensions)) extensions.forEach(function(extend) {
            newComer = extend(origin, newComer);
        });
        return newComer;
    }
    // define newObject to merge all values upon
    var newObject = {};
    if ((0, $kw4Kd.isPlainObject)(origin)) {
        var props_1 = Object.getOwnPropertyNames(origin);
        var symbols_1 = Object.getOwnPropertySymbols(origin);
        newObject = $12e830c0dadf1c2c$var$__spreadArrays(props_1, symbols_1).reduce(function(carry, key) {
            // @ts-ignore
            var targetVal = origin[key];
            if (!(0, $kw4Kd.isSymbol)(key) && !Object.getOwnPropertyNames(newComer).includes(key) || (0, $kw4Kd.isSymbol)(key) && !Object.getOwnPropertySymbols(newComer).includes(key)) $12e830c0dadf1c2c$var$assignProp(carry, key, targetVal, origin);
            return carry;
        }, {});
    }
    var props = Object.getOwnPropertyNames(newComer);
    var symbols = Object.getOwnPropertySymbols(newComer);
    var result = $12e830c0dadf1c2c$var$__spreadArrays(props, symbols).reduce(function(carry, key) {
        // re-define the origin and newComer as targetVal and newVal
        var newVal = newComer[key];
        var targetVal = (0, $kw4Kd.isPlainObject)(origin) ? origin[key] : undefined;
        // extend merge rules
        if (extensions && (0, $kw4Kd.isArray)(extensions)) extensions.forEach(function(extend) {
            newVal = extend(targetVal, newVal);
        });
        // When newVal is an object do the merge recursively
        if (targetVal !== undefined && (0, $kw4Kd.isPlainObject)(newVal)) newVal = $12e830c0dadf1c2c$var$mergeRecursively(targetVal, newVal, extensions);
        $12e830c0dadf1c2c$var$assignProp(carry, key, newVal, newComer);
        return carry;
    }, newObject);
    return result;
}
/**
 * Merge anything recursively.
 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
 * Basic types overwrite objects or other basic types.
 *
 * @param {(IConfig | any)} origin
 * @param {...any[]} newComers
 * @returns the result
 */ function $12e830c0dadf1c2c$export$4950aa0f605343fb(origin) {
    var newComers = [];
    for(var _i = 1; _i < arguments.length; _i++)newComers[_i - 1] = arguments[_i];
    var extensions = null;
    var base = origin;
    if ((0, $kw4Kd.isPlainObject)(origin) && origin.extensions && Object.keys(origin).length === 1) {
        base = {};
        extensions = origin.extensions;
    }
    return newComers.reduce(function(result, newComer) {
        return $12e830c0dadf1c2c$var$mergeRecursively(result, newComer, extensions);
    }, base);
}
function $12e830c0dadf1c2c$export$e989d07ee174d99d(originVal, newVal) {
    if ((0, $kw4Kd.isArray)(originVal) && (0, $kw4Kd.isArray)(newVal)) // concat logic
    return originVal.concat(newVal);
    return newVal; // always return newVal as fallback!!
}
var $12e830c0dadf1c2c$export$2e2bcd8739ae039 = $12e830c0dadf1c2c$export$4950aa0f605343fb;

});
parcelRegister("kw4Kd", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $eefa79f5dc77cc8e$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isArray", function () { return $eefa79f5dc77cc8e$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isSymbol", function () { return $eefa79f5dc77cc8e$export$a244864fd9645c7f; });
/**
 * Returns the object type of the given payload
 *
 * @param {*} payload
 * @returns {string}
 */ function $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
/**
 * Returns whether the payload is undefined
 *
 * @param {*} payload
 * @returns {payload is undefined}
 */ function $eefa79f5dc77cc8e$export$fce6876652108ab(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "Undefined";
}
/**
 * Returns whether the payload is null
 *
 * @param {*} payload
 * @returns {payload is null}
 */ function $eefa79f5dc77cc8e$export$630801d484da15df(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "Null";
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */ function $eefa79f5dc77cc8e$export$53b83ca8eaab0383(payload) {
    if ($eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) !== "Object") return false;
    return payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype;
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */ function $eefa79f5dc77cc8e$export$a6cdc56e425d0d0a(payload) {
    return $eefa79f5dc77cc8e$export$53b83ca8eaab0383(payload);
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is { [K in any]: never }}
 */ function $eefa79f5dc77cc8e$export$83b788b1a3698c03(payload) {
    return $eefa79f5dc77cc8e$export$53b83ca8eaab0383(payload) && Object.keys(payload).length === 0;
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */ function $eefa79f5dc77cc8e$export$36f6b23005e191ac(payload) {
    return $eefa79f5dc77cc8e$export$53b83ca8eaab0383(payload) && Object.keys(payload).length > 0;
}
/**
 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */ function $eefa79f5dc77cc8e$export$ae004ceb3d455f9a(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "Object";
}
/**
 * Returns whether the payload is an object like a type passed in < >
 *
 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
 *
 * @template T this must be passed in < >
 * @param {*} payload
 * @returns {payload is T}
 */ function $eefa79f5dc77cc8e$export$c10d0b04eaa80a43(payload) {
    return $eefa79f5dc77cc8e$export$ae004ceb3d455f9a(payload);
}
/**
 * Returns whether the payload is a function (regular or async)
 *
 * @param {*} payload
 * @returns {payload is AnyFunction}
 */ function $eefa79f5dc77cc8e$export$f6e2535fb5126e54(payload) {
    return typeof payload === "function";
}
/**
 * Returns whether the payload is an array
 *
 * @param {any} payload
 * @returns {payload is any[]}
 */ function $eefa79f5dc77cc8e$export$43bee75e5e14138e(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "Array";
}
/**
 * Returns whether the payload is a an array with at least 1 item
 *
 * @param {*} payload
 * @returns {payload is any[]}
 */ function $eefa79f5dc77cc8e$export$8064717326baf93d(payload) {
    return $eefa79f5dc77cc8e$export$43bee75e5e14138e(payload) && payload.length > 0;
}
/**
 * Returns whether the payload is a an empty array
 *
 * @param {*} payload
 * @returns {payload is []}
 */ function $eefa79f5dc77cc8e$export$4c0262a4f954db45(payload) {
    return $eefa79f5dc77cc8e$export$43bee75e5e14138e(payload) && payload.length === 0;
}
/**
 * Returns whether the payload is a string
 *
 * @param {*} payload
 * @returns {payload is string}
 */ function $eefa79f5dc77cc8e$export$844ec244b1367d54(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "String";
}
/**
 * Returns whether the payload is a string, BUT returns false for ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */ function $eefa79f5dc77cc8e$export$ab65b4820ba194f1(payload) {
    return $eefa79f5dc77cc8e$export$844ec244b1367d54(payload) && payload !== "";
}
/**
 * Returns whether the payload is ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */ function $eefa79f5dc77cc8e$export$78d1711480f95c3e(payload) {
    return payload === "";
}
/**
 * Returns whether the payload is a number (but not NaN)
 *
 * This will return `false` for `NaN`!!
 *
 * @param {*} payload
 * @returns {payload is number}
 */ function $eefa79f5dc77cc8e$export$7e4aa119212bc614(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "Number" && !isNaN(payload);
}
/**
 * Returns whether the payload is a boolean
 *
 * @param {*} payload
 * @returns {payload is boolean}
 */ function $eefa79f5dc77cc8e$export$f9ce7b637dfbe238(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "Boolean";
}
/**
 * Returns whether the payload is a regular expression (RegExp)
 *
 * @param {*} payload
 * @returns {payload is RegExp}
 */ function $eefa79f5dc77cc8e$export$49841c62b9eff15(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "RegExp";
}
/**
 * Returns whether the payload is a Map
 *
 * @param {*} payload
 * @returns {payload is Map<any, any>}
 */ function $eefa79f5dc77cc8e$export$5c90113a285f2241(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "Map";
}
/**
 * Returns whether the payload is a WeakMap
 *
 * @param {*} payload
 * @returns {payload is WeakMap<any, any>}
 */ function $eefa79f5dc77cc8e$export$45e3ca7880506f6(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "WeakMap";
}
/**
 * Returns whether the payload is a Set
 *
 * @param {*} payload
 * @returns {payload is Set<any>}
 */ function $eefa79f5dc77cc8e$export$6750766a7c7ec627(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "Set";
}
/**
 * Returns whether the payload is a WeakSet
 *
 * @param {*} payload
 * @returns {payload is WeakSet<any>}
 */ function $eefa79f5dc77cc8e$export$6001bf5c91b8444(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "WeakSet";
}
/**
 * Returns whether the payload is a Symbol
 *
 * @param {*} payload
 * @returns {payload is symbol}
 */ function $eefa79f5dc77cc8e$export$a244864fd9645c7f(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "Symbol";
}
/**
 * Returns whether the payload is a Date, and that the date is valid
 *
 * @param {*} payload
 * @returns {payload is Date}
 */ function $eefa79f5dc77cc8e$export$871608497c498473(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "Date" && !isNaN(payload);
}
/**
 * Returns whether the payload is a Blob
 *
 * @param {*} payload
 * @returns {payload is Blob}
 */ function $eefa79f5dc77cc8e$export$5bcd6e94ed871c88(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "Blob";
}
/**
 * Returns whether the payload is a File
 *
 * @param {*} payload
 * @returns {payload is File}
 */ function $eefa79f5dc77cc8e$export$be78b3111c50efdd(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "File";
}
/**
 * Returns whether the payload is a Promise
 *
 * @param {*} payload
 * @returns {payload is Promise<any>}
 */ function $eefa79f5dc77cc8e$export$4369c812aac99591(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "Promise";
}
/**
 * Returns whether the payload is an Error
 *
 * @param {*} payload
 * @returns {payload is Error}
 */ function $eefa79f5dc77cc8e$export$e6127cc7fe7395c3(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "Error";
}
/**
 * Returns whether the payload is literally the value `NaN` (it's `NaN` and also a `number`)
 *
 * @param {*} payload
 * @returns {payload is typeof NaN}
 */ function $eefa79f5dc77cc8e$export$87fc7a69ba8e466(payload) {
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === "Number" && isNaN(payload);
}
/**
 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
 *
 * @param {*} payload
 * @returns {(payload is boolean | null | undefined | number | string | symbol)}
 */ function $eefa79f5dc77cc8e$export$c3825b437cbdea5c(payload) {
    return $eefa79f5dc77cc8e$export$f9ce7b637dfbe238(payload) || $eefa79f5dc77cc8e$export$630801d484da15df(payload) || $eefa79f5dc77cc8e$export$fce6876652108ab(payload) || $eefa79f5dc77cc8e$export$7e4aa119212bc614(payload) || $eefa79f5dc77cc8e$export$844ec244b1367d54(payload) || $eefa79f5dc77cc8e$export$a244864fd9645c7f(payload);
}
/**
 * Returns true whether the payload is null or undefined
 *
 * @param {*} payload
 * @returns {(payload is null | undefined)}
 */ var $eefa79f5dc77cc8e$export$bedb7023a7733221 = $eefa79f5dc77cc8e$export$532a90c0e5e8e48c($eefa79f5dc77cc8e$export$630801d484da15df, $eefa79f5dc77cc8e$export$fce6876652108ab);
function $eefa79f5dc77cc8e$export$532a90c0e5e8e48c(a, b, c, d, e) {
    return function(value) {
        return a(value) || b(value) || !!c && c(value) || !!d && d(value) || !!e && e(value);
    };
}
/**
 * Does a generic check to check that the given payload is of a given type.
 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
 * It will, however, differentiate between object and null
 *
 * @template T
 * @param {*} payload
 * @param {T} type
 * @throws {TypeError} Will throw type error if type is an invalid type
 * @returns {payload is T}
 */ function $eefa79f5dc77cc8e$export$26b9f946b448f23e(payload, type) {
    if (!(type instanceof Function)) throw new TypeError("Type must be a function");
    if (!Object.prototype.hasOwnProperty.call(type, "prototype")) throw new TypeError("Type is not a class");
    // Classes usually have names (as functions usually have names)
    var name = type.name;
    return $eefa79f5dc77cc8e$export$e2b5c5db9e2009fd(payload) === name || Boolean(payload && payload.constructor === type);
}

});


parcelRegister("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});


parcelRegister("5oGqh", function(module, exports) {

$parcel$export(module.exports, "useToast", function () { return $3ee019eb183f55dd$export$a407b657d3044108; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $kpuXf = parcelRequire("kpuXf");

var $1WnR3 = parcelRequire("1WnR3");

var $hPMYy = parcelRequire("hPMYy");
const $3ee019eb183f55dd$export$a407b657d3044108 = ()=>{
    const showToast = (content, options = {}, data = {})=>{
        const { type: type = "default", onClose: onClose, onClick: onClick, ...restOptions } = options;
        const toastId = (0, $kpuXf.default)((t)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $1WnR3.Toast), {
                type: type,
                toastData: t,
                onClose: onClose,
                onClick: onClick,
                children: typeof content === "function" ? content(t) : content
            }), {
            icon: null,
            ...restOptions
        });
        (0, $hPMYy.addToast)({
            toastId: toastId,
            data: data
        });
        setTimeout(()=>{
            (0, $hPMYy.removeToast)((toastObject)=>toastObject.toastId === toastId);
        }, options.duration || (0, $1WnR3.defaultToastDuration));
        return toastId;
    };
    const closeToast = (toastId)=>{
        (0, $kpuXf.default).dismiss(toastId);
        (0, $hPMYy.removeToast)((toastObject)=>toastObject.toastId === toastId);
    };
    return {
        showToast: showToast,
        closeToast: closeToast
    };
};

});
parcelRegister("kpuXf", function(module, exports) {

$parcel$export(module.exports, "useToaster", function () { return $edbe27691ee42a08$export$f46171b59bb094f9; });
$parcel$export(module.exports, "default", function () { return $edbe27691ee42a08$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $6vkQq = parcelRequire("6vkQq");
function $edbe27691ee42a08$var$_extends() {
    $edbe27691ee42a08$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $edbe27691ee42a08$var$_extends.apply(this, arguments);
}
function $edbe27691ee42a08$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $edbe27691ee42a08$var$_taggedTemplateLiteralLoose(strings, raw) {
    if (!raw) raw = strings.slice(0);
    strings.raw = raw;
    return strings;
}
var $edbe27691ee42a08$var$isFunction = function isFunction(valOrFunction) {
    return typeof valOrFunction === "function";
};
var $edbe27691ee42a08$var$resolveValueOrFunction = function resolveValueOrFunction(valOrFunction, arg) {
    return $edbe27691ee42a08$var$isFunction(valOrFunction) ? valOrFunction(arg) : valOrFunction;
};
var $edbe27691ee42a08$var$genId = /*#__PURE__*/ function() {
    var count = 0;
    return function() {
        return (++count).toString();
    };
}();
var $edbe27691ee42a08$var$TOAST_LIMIT = 20;
var $edbe27691ee42a08$export$e4a712fff93fb00f;
(function(ActionType) {
    ActionType[ActionType["ADD_TOAST"] = 0] = "ADD_TOAST";
    ActionType[ActionType["UPDATE_TOAST"] = 1] = "UPDATE_TOAST";
    ActionType[ActionType["UPSERT_TOAST"] = 2] = "UPSERT_TOAST";
    ActionType[ActionType["DISMISS_TOAST"] = 3] = "DISMISS_TOAST";
    ActionType[ActionType["REMOVE_TOAST"] = 4] = "REMOVE_TOAST";
    ActionType[ActionType["START_PAUSE"] = 5] = "START_PAUSE";
    ActionType[ActionType["END_PAUSE"] = 6] = "END_PAUSE";
})($edbe27691ee42a08$export$e4a712fff93fb00f || ($edbe27691ee42a08$export$e4a712fff93fb00f = {}));
var $edbe27691ee42a08$var$reducer = function reducer(state, action) {
    switch(action.type){
        case $edbe27691ee42a08$export$e4a712fff93fb00f.ADD_TOAST:
            return $edbe27691ee42a08$var$_extends({}, state, {
                toasts: [
                    action.toast
                ].concat(state.toasts).slice(0, $edbe27691ee42a08$var$TOAST_LIMIT)
            });
        case $edbe27691ee42a08$export$e4a712fff93fb00f.UPDATE_TOAST:
            return $edbe27691ee42a08$var$_extends({}, state, {
                toasts: state.toasts.map(function(t) {
                    return t.id === action.toast.id ? $edbe27691ee42a08$var$_extends({}, t, action.toast) : t;
                })
            });
        case $edbe27691ee42a08$export$e4a712fff93fb00f.UPSERT_TOAST:
            var toast = action.toast;
            return state.toasts.find(function(t) {
                return t.id === toast.id;
            }) ? reducer(state, {
                type: $edbe27691ee42a08$export$e4a712fff93fb00f.UPDATE_TOAST,
                toast: toast
            }) : reducer(state, {
                type: $edbe27691ee42a08$export$e4a712fff93fb00f.ADD_TOAST,
                toast: toast
            });
        case $edbe27691ee42a08$export$e4a712fff93fb00f.DISMISS_TOAST:
            return $edbe27691ee42a08$var$_extends({}, state, {
                toasts: state.toasts.map(function(t) {
                    return t.id === action.toastId || action.toastId === undefined ? $edbe27691ee42a08$var$_extends({}, t, {
                        visible: false
                    }) : t;
                })
            });
        case $edbe27691ee42a08$export$e4a712fff93fb00f.REMOVE_TOAST:
            if (action.toastId === undefined) return $edbe27691ee42a08$var$_extends({}, state, {
                toasts: []
            });
            return $edbe27691ee42a08$var$_extends({}, state, {
                toasts: state.toasts.filter(function(t) {
                    return t.id !== action.toastId;
                })
            });
        case $edbe27691ee42a08$export$e4a712fff93fb00f.START_PAUSE:
            return $edbe27691ee42a08$var$_extends({}, state, {
                pausedAt: action.time
            });
        case $edbe27691ee42a08$export$e4a712fff93fb00f.END_PAUSE:
            var diff = action.time - (state.pausedAt || 0);
            return $edbe27691ee42a08$var$_extends({}, state, {
                pausedAt: undefined,
                toasts: state.toasts.map(function(t) {
                    return $edbe27691ee42a08$var$_extends({}, t, {
                        pauseDuration: t.pauseDuration + diff
                    });
                })
            });
    }
};
var $edbe27691ee42a08$var$listeners = [];
var $edbe27691ee42a08$var$memoryState = {
    toasts: [],
    pausedAt: undefined
};
var $edbe27691ee42a08$export$635e15bbd66f01ea = function dispatch(action) {
    $edbe27691ee42a08$var$memoryState = $edbe27691ee42a08$var$reducer($edbe27691ee42a08$var$memoryState, action);
    $edbe27691ee42a08$var$listeners.forEach(function(listener) {
        listener($edbe27691ee42a08$var$memoryState);
    });
};
var $edbe27691ee42a08$var$defaultTimeouts = {
    blank: 4000,
    error: 4000,
    success: 2000,
    loading: 30000
};
var $edbe27691ee42a08$export$3960353ab538dc47 = function useStore(toastOptions) {
    if (toastOptions === void 0) toastOptions = {};
    var _useState = (0, $bh6RR.useState)($edbe27691ee42a08$var$memoryState), state = _useState[0], setState = _useState[1];
    (0, $bh6RR.useEffect)(function() {
        $edbe27691ee42a08$var$listeners.push(setState);
        return function() {
            var index = $edbe27691ee42a08$var$listeners.indexOf(setState);
            if (index > -1) $edbe27691ee42a08$var$listeners.splice(index, 1);
        };
    }, [
        state
    ]);
    var mergedToasts = state.toasts.map(function(t) {
        var _toastOptions$t$type, _toastOptions, _toastOptions$t$type2;
        return $edbe27691ee42a08$var$_extends({}, toastOptions, toastOptions[t.type], t, {
            duration: t.duration || ((_toastOptions$t$type = toastOptions[t.type]) == null ? void 0 : _toastOptions$t$type.duration) || ((_toastOptions = toastOptions) == null ? void 0 : _toastOptions.duration) || $edbe27691ee42a08$var$defaultTimeouts[t.type],
            style: $edbe27691ee42a08$var$_extends({}, toastOptions.style, (_toastOptions$t$type2 = toastOptions[t.type]) == null ? void 0 : _toastOptions$t$type2.style, t.style)
        });
    });
    return $edbe27691ee42a08$var$_extends({}, state, {
        toasts: mergedToasts
    });
};
var $edbe27691ee42a08$var$createToast = function createToast(message, type, opts) {
    if (type === void 0) type = "blank";
    return $edbe27691ee42a08$var$_extends({
        id: (opts == null ? void 0 : opts.id) || $edbe27691ee42a08$var$genId(),
        createdAt: Date.now(),
        visible: true,
        type: type,
        role: "status",
        ariaLive: "polite",
        message: message,
        pauseDuration: 0
    }, opts);
};
var $edbe27691ee42a08$var$createHandler = function createHandler(type) {
    return function(message, options) {
        var toast = $edbe27691ee42a08$var$createToast(message, type, options);
        $edbe27691ee42a08$export$635e15bbd66f01ea({
            type: $edbe27691ee42a08$export$e4a712fff93fb00f.UPSERT_TOAST,
            toast: toast
        });
        return toast.id;
    };
};
var $edbe27691ee42a08$export$b410431fab84fa58 = function toast(message, opts) {
    return $edbe27691ee42a08$var$createHandler("blank")(message, opts);
};
$edbe27691ee42a08$export$b410431fab84fa58.error = /*#__PURE__*/ $edbe27691ee42a08$var$createHandler("error");
$edbe27691ee42a08$export$b410431fab84fa58.success = /*#__PURE__*/ $edbe27691ee42a08$var$createHandler("success");
$edbe27691ee42a08$export$b410431fab84fa58.loading = /*#__PURE__*/ $edbe27691ee42a08$var$createHandler("loading");
$edbe27691ee42a08$export$b410431fab84fa58.dismiss = function(toastId) {
    $edbe27691ee42a08$export$635e15bbd66f01ea({
        type: $edbe27691ee42a08$export$e4a712fff93fb00f.DISMISS_TOAST,
        toastId: toastId
    });
    setTimeout(function() {
        $edbe27691ee42a08$export$635e15bbd66f01ea({
            type: $edbe27691ee42a08$export$e4a712fff93fb00f.REMOVE_TOAST,
            toastId: toastId
        });
    }, 1000);
};
$edbe27691ee42a08$export$b410431fab84fa58.remove = function(toastId) {
    return $edbe27691ee42a08$export$635e15bbd66f01ea({
        type: $edbe27691ee42a08$export$e4a712fff93fb00f.REMOVE_TOAST,
        toastId: toastId
    });
};
$edbe27691ee42a08$export$b410431fab84fa58.promise = function(promise, msgs, opts) {
    var id = $edbe27691ee42a08$export$b410431fab84fa58.loading(msgs.loading, $edbe27691ee42a08$var$_extends({}, opts, opts == null ? void 0 : opts.loading));
    promise.then(function(p) {
        $edbe27691ee42a08$export$b410431fab84fa58.success($edbe27691ee42a08$var$resolveValueOrFunction(msgs.success, p), $edbe27691ee42a08$var$_extends({
            id: id
        }, opts, opts == null ? void 0 : opts.success));
        return p;
    })["catch"](function(e) {
        $edbe27691ee42a08$export$b410431fab84fa58.error($edbe27691ee42a08$var$resolveValueOrFunction(msgs.error, e), $edbe27691ee42a08$var$_extends({
            id: id
        }, opts, opts == null ? void 0 : opts.error));
    });
    return promise;
};
var $edbe27691ee42a08$export$f46171b59bb094f9 = function useToaster(toastOptions) {
    var _useStore = $edbe27691ee42a08$export$3960353ab538dc47(toastOptions), toasts = _useStore.toasts, pausedAt = _useStore.pausedAt;
    var visibleToasts = toasts.filter(function(t) {
        return t.visible;
    });
    (0, $bh6RR.useEffect)(function() {
        if (pausedAt) return;
        var now = Date.now();
        var timeouts = toasts.map(function(t) {
            var durationLeft = (t.duration || 0) + t.pauseDuration - (now - t.createdAt);
            if (durationLeft < 0) {
                if (t.visible) $edbe27691ee42a08$export$b410431fab84fa58.dismiss(t.id);
                return;
            }
            return setTimeout(function() {
                return $edbe27691ee42a08$export$b410431fab84fa58.dismiss(t.id);
            }, durationLeft);
        });
        return function() {
            timeouts.forEach(function(timeout) {
                return timeout && clearTimeout(timeout);
            });
        };
    }, [
        toasts,
        pausedAt
    ]);
    var handlers = (0, $bh6RR.useMemo)(function() {
        return {
            startPause: function startPause() {
                $edbe27691ee42a08$export$635e15bbd66f01ea({
                    type: $edbe27691ee42a08$export$e4a712fff93fb00f.START_PAUSE,
                    time: Date.now()
                });
            },
            endPause: function endPause() {
                if (pausedAt) $edbe27691ee42a08$export$635e15bbd66f01ea({
                    type: $edbe27691ee42a08$export$e4a712fff93fb00f.END_PAUSE,
                    time: Date.now()
                });
            },
            updateHeight: function updateHeight(toastId, height) {
                return $edbe27691ee42a08$export$635e15bbd66f01ea({
                    type: $edbe27691ee42a08$export$e4a712fff93fb00f.UPDATE_TOAST,
                    toast: {
                        id: toastId,
                        height: height
                    }
                });
            },
            calculateOffset: function calculateOffset(toastId, opts) {
                var _ref = opts || {}, _ref$reverseOrder = _ref.reverseOrder, reverseOrder = _ref$reverseOrder === void 0 ? false : _ref$reverseOrder, _ref$margin = _ref.margin, margin = _ref$margin === void 0 ? 8 : _ref$margin;
                var index = visibleToasts.findIndex(function(toast) {
                    return toast.id === toastId;
                });
                var offset = index !== -1 ? visibleToasts.slice.apply(visibleToasts, reverseOrder ? [
                    index + 1
                ] : [
                    0,
                    index
                ]).reduce(function(acc, t) {
                    return acc + (t.height || 0) + margin;
                }, 0) : 0;
                return offset;
            }
        };
    }, [
        visibleToasts,
        pausedAt
    ]);
    return {
        toasts: toasts,
        visibleToasts: visibleToasts,
        handlers: handlers
    };
};
function $edbe27691ee42a08$var$_templateObject4() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ",
        ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ",
        " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n\n  &:after,\n  &:before {\n    content: '';\n    animation: ",
        " 0.15s ease-out forwards;\n    animation-delay: 150ms;\n    position: absolute;\n    border-radius: 3px;\n    opacity: 0;\n    background: ",
        ";\n    bottom: 9px;\n    left: 4px;\n    height: 2px;\n    width: 12px;\n  }\n\n  &:before {\n    animation: ",
        " 0.15s ease-out forwards;\n    animation-delay: 180ms;\n    transform: rotate(90deg);\n  }\n"
    ]);
    $edbe27691ee42a08$var$_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function $edbe27691ee42a08$var$_templateObject3() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\n  from {\n    transform: scale(0) rotate(90deg);\n	 opacity: 0;\n  }\n\n  to {\n    transform: scale(1) rotate(90deg);\n	 opacity: 1;\n  }\n"
    ]);
    $edbe27691ee42a08$var$_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function $edbe27691ee42a08$var$_templateObject2() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\n  from {\n    transform: scale(0);\n	 opacity: 0;\n  }\n\n  to {\n    transform: scale(1);\n	 opacity: 1;\n  }\n"
    ]);
    $edbe27691ee42a08$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $edbe27691ee42a08$var$_templateObject() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\n  from {\n    transform: scale(0) rotate(45deg);\n	 opacity: 0;\n  }\n\n  to {\n    transform: scale(1) rotate(45deg);\n	 opacity: 1;\n  }\n"
    ]);
    $edbe27691ee42a08$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $edbe27691ee42a08$var$circleAnimation = /*#__PURE__*/ (0, $6vkQq.keyframes)(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject());
var $edbe27691ee42a08$var$firstLineAnimation = /*#__PURE__*/ (0, $6vkQq.keyframes)(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject2());
var $edbe27691ee42a08$var$secondLineAnimation = /*#__PURE__*/ (0, $6vkQq.keyframes)(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject3());
var $edbe27691ee42a08$export$19bc16ee58e19b3d = /*#__PURE__*/ (0, $6vkQq.styled)("div")(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject4(), function(p) {
    return p.primary || "#ff4b4b";
}, $edbe27691ee42a08$var$circleAnimation, $edbe27691ee42a08$var$firstLineAnimation, function(p) {
    return p.secondary || "#fff";
}, $edbe27691ee42a08$var$secondLineAnimation);
function $edbe27691ee42a08$var$_templateObject2$1() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\n  width: 12px;\n  height: 12px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: ",
        ";\n  border-right-color: ",
        ";\n  animation: ",
        " 1s linear infinite;\n"
    ]);
    $edbe27691ee42a08$var$_templateObject2$1 = function _templateObject2() {
        return data;
    };
    return data;
}
function $edbe27691ee42a08$var$_templateObject$1() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    $edbe27691ee42a08$var$_templateObject$1 = function _templateObject() {
        return data;
    };
    return data;
}
var $edbe27691ee42a08$var$rotate = /*#__PURE__*/ (0, $6vkQq.keyframes)(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject$1());
var $edbe27691ee42a08$export$647aae5028016fe9 = /*#__PURE__*/ (0, $6vkQq.styled)("div")(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject2$1(), function(p) {
    return p.secondary || "#e0e0e0";
}, function(p) {
    return p.primary || "#616161";
}, $edbe27691ee42a08$var$rotate);
function $edbe27691ee42a08$var$_templateObject3$1() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ",
        ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ",
        " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    animation: ",
        " 0.2s ease-out forwards;\n    opacity: 0;\n    animation-delay: 200ms;\n    position: absolute;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    border-color: ",
        ";\n    bottom: 6px;\n    left: 6px;\n    height: 10px;\n    width: 6px;\n  }\n"
    ]);
    $edbe27691ee42a08$var$_templateObject3$1 = function _templateObject3() {
        return data;
    };
    return data;
}
function $edbe27691ee42a08$var$_templateObject2$2() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\n  0% {\n		height: 0;\n		width: 0;\n		opacity: 0;\n  }\n\n  40% {\n		height: 0;\n		width: 6px;\n		opacity: 1;\n  }\n\n  100% {\n    opacity: 1;\n		height: 10px;\n  }\n"
    ]);
    $edbe27691ee42a08$var$_templateObject2$2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $edbe27691ee42a08$var$_templateObject$2() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\n  from {\n    transform: scale(0) rotate(45deg);\n	 opacity: 0;\n  }\n\n  to {\n    transform: scale(1) rotate(45deg);\n	 opacity: 1;\n  }\n"
    ]);
    $edbe27691ee42a08$var$_templateObject$2 = function _templateObject() {
        return data;
    };
    return data;
}
var $edbe27691ee42a08$var$circleAnimation$1 = /*#__PURE__*/ (0, $6vkQq.keyframes)(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject$2());
var $edbe27691ee42a08$var$checkmarkAnimation = /*#__PURE__*/ (0, $6vkQq.keyframes)(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject2$2());
var $edbe27691ee42a08$export$906a919e30cdbd5c = /*#__PURE__*/ (0, $6vkQq.styled)("div")(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject3$1(), function(p) {
    return p.primary || "#61d345";
}, $edbe27691ee42a08$var$circleAnimation$1, $edbe27691ee42a08$var$checkmarkAnimation, function(p) {
    return p.secondary || "#fff";
});
function $edbe27691ee42a08$var$_templateObject2$3() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 20px;\n  min-height: 20px;\n"
    ]);
    $edbe27691ee42a08$var$_templateObject2$3 = function _templateObject2() {
        return data;
    };
    return data;
}
function $edbe27691ee42a08$var$_templateObject$3() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\n  position: absolute;\n"
    ]);
    $edbe27691ee42a08$var$_templateObject$3 = function _templateObject() {
        return data;
    };
    return data;
}
var $edbe27691ee42a08$var$StatusWrapper = /*#__PURE__*/ (0, $6vkQq.styled)("div")(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject$3());
var $edbe27691ee42a08$var$IndicatorWrapper = /*#__PURE__*/ (0, $6vkQq.styled)("div")(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject2$3());
var $edbe27691ee42a08$var$Indicator = function Indicator(_ref) {
    var type = _ref.type, theme = _ref.theme;
    if (type === "blank") return null;
    return (0, $bh6RR.createElement)($edbe27691ee42a08$var$IndicatorWrapper, null, (0, $bh6RR.createElement)($edbe27691ee42a08$export$647aae5028016fe9, Object.assign({}, theme)), type !== "loading" && (0, $bh6RR.createElement)($edbe27691ee42a08$var$StatusWrapper, null, type === "error" ? (0, $bh6RR.createElement)($edbe27691ee42a08$export$19bc16ee58e19b3d, Object.assign({}, theme)) : (0, $bh6RR.createElement)($edbe27691ee42a08$export$906a919e30cdbd5c, Object.assign({}, theme))));
};
function $edbe27691ee42a08$var$_templateObject2$4() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\n  position: relative;\n  transform: scale(0.6);\n  opacity: 0.4;\n  min-width: 20px;\n  animation: ",
        " 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n"
    ]);
    $edbe27691ee42a08$var$_templateObject2$4 = function _templateObject2() {
        return data;
    };
    return data;
}
function $edbe27691ee42a08$var$_templateObject$4() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\nfrom {\n  transform: scale(0.6);\n  opacity: 0.4;\n}\n\nto {\n  transform: scale(1);\n  opacity: 1;\n}\n"
    ]);
    $edbe27691ee42a08$var$_templateObject$4 = function _templateObject() {
        return data;
    };
    return data;
}
var $edbe27691ee42a08$var$enter = /*#__PURE__*/ (0, $6vkQq.keyframes)(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject$4());
var $edbe27691ee42a08$var$AnimatedIconWrapper = /*#__PURE__*/ (0, $6vkQq.styled)("div")(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject2$4(), $edbe27691ee42a08$var$enter);
function $edbe27691ee42a08$var$_templateObject4$1() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "",
        ""
    ]);
    $edbe27691ee42a08$var$_templateObject4$1 = function _templateObject4() {
        return data;
    };
    return data;
}
function $edbe27691ee42a08$var$_templateObject3$2() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "",
        ""
    ]);
    $edbe27691ee42a08$var$_templateObject3$2 = function _templateObject3() {
        return data;
    };
    return data;
}
function $edbe27691ee42a08$var$_templateObject2$5() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\n  display: flex;\n  justify-content: center;\n  margin: 4px 10px;\n  color: inherit;\n  flex: 1;\n"
    ]);
    $edbe27691ee42a08$var$_templateObject2$5 = function _templateObject2() {
        return data;
    };
    return data;
}
function $edbe27691ee42a08$var$_templateObject$5() {
    var data = $edbe27691ee42a08$var$_taggedTemplateLiteralLoose([
        "\n  display: flex;\n  align-items: center;\n  background: #fff;\n  color: #363636;\n  line-height: 1.3;\n  will-change: transform;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);\n  max-width: 350px;\n  margin: 16px;\n  pointer-events: auto;\n  padding: 8px 10px;\n  border-radius: 8px;\n"
    ]);
    $edbe27691ee42a08$var$_templateObject$5 = function _templateObject() {
        return data;
    };
    return data;
}
var $edbe27691ee42a08$var$enterAnimation = function enterAnimation(factor) {
    return "\n0% {transform: translate3d(0," + factor * -80 + "px,0) scale(.6); opacity:.5;}\n100% {transform: translate3d(0,0,0) scale(1); opacity:1;}\n";
};
var $edbe27691ee42a08$var$exitAnimation = function exitAnimation(factor) {
    return "\n0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}\n100% {transform: translate3d(0," + factor * -130 + "px,-1px) scale(.5); opacity:0;}\n";
};
var $edbe27691ee42a08$var$ToastBarBase = /*#__PURE__*/ (0, $6vkQq.styled)("div", (0, $bh6RR.forwardRef))(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject$5());
var $edbe27691ee42a08$var$Message = /*#__PURE__*/ (0, $6vkQq.styled)("div")(/*#__PURE__*/ $edbe27691ee42a08$var$_templateObject2$5());
var $edbe27691ee42a08$var$getPositionStyle = function getPositionStyle(position, offset) {
    var top = position.includes("top");
    var verticalStyle = top ? {
        top: 0
    } : {
        bottom: 0
    };
    var horizontalStyle = position.includes("left") ? {
        left: 0
    } : position.includes("right") ? {
        right: 0
    } : {
        left: 0,
        pointerEvents: "none",
        right: 0,
        justifyContent: "center"
    };
    return $edbe27691ee42a08$var$_extends({
        position: "fixed",
        transition: "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: "translateY(" + offset * (top ? 1 : -1) + "px)"
    }, verticalStyle, horizontalStyle);
};
var $edbe27691ee42a08$var$getAnimationStyle = function getAnimationStyle(position, visible) {
    var top = position.includes("top");
    var factor = top ? 1 : -1;
    return visible ? {
        animation: (0, $6vkQq.keyframes)($edbe27691ee42a08$var$_templateObject3$2(), $edbe27691ee42a08$var$enterAnimation(factor)) + " 0.35s cubic-bezier(.21,1.02,.73,1) forwards"
    } : {
        animation: (0, $6vkQq.keyframes)($edbe27691ee42a08$var$_templateObject4$1(), $edbe27691ee42a08$var$exitAnimation(factor)) + " 0.8s forwards cubic-bezier(.06,.71,.55,1)",
        pointerEvents: "none"
    };
};
var $edbe27691ee42a08$export$af68597b0c62c1df = /*#__PURE__*/ (0, $bh6RR.memo)(function(_ref) {
    var toast = _ref.toast, position = _ref.position, props = $edbe27691ee42a08$var$_objectWithoutPropertiesLoose(_ref, [
        "toast",
        "position"
    ]);
    var ref = (0, $bh6RR.useCallback)(function(el) {
        if (el) setTimeout(function() {
            var boundingRect = el.getBoundingClientRect();
            props.onHeight(boundingRect.height);
        });
    }, []);
    var positionStyle = $edbe27691ee42a08$var$getPositionStyle(position, props.offset);
    var animationStyle = toast != null && toast.height ? $edbe27691ee42a08$var$getAnimationStyle(position, toast.visible) : {
        opacity: 0
    };
    var renderIcon = function renderIcon() {
        var icon = toast.icon, type = toast.type, iconTheme = toast.iconTheme;
        if (icon !== undefined) {
            if (typeof icon === "string") return (0, $bh6RR.createElement)($edbe27691ee42a08$var$AnimatedIconWrapper, null, icon);
            else return icon;
        }
        return (0, $bh6RR.createElement)($edbe27691ee42a08$var$Indicator, {
            theme: iconTheme,
            type: type
        });
    };
    return (0, $bh6RR.createElement)("div", {
        style: $edbe27691ee42a08$var$_extends({
            display: "flex",
            zIndex: toast.visible ? 9999 : undefined
        }, positionStyle)
    }, (0, $bh6RR.createElement)($edbe27691ee42a08$var$ToastBarBase, {
        ref: ref,
        className: toast.className,
        style: $edbe27691ee42a08$var$_extends({}, animationStyle, toast.style)
    }, renderIcon(), (0, $bh6RR.createElement)($edbe27691ee42a08$var$Message, {
        role: toast.role,
        "aria-live": toast.ariaLive
    }, $edbe27691ee42a08$var$resolveValueOrFunction(toast.message, toast))));
});
(0, $6vkQq.setup)((0, $bh6RR.createElement));
var $edbe27691ee42a08$export$fb98e3a2a4cd92d7 = function Toaster(_ref) {
    var reverseOrder = _ref.reverseOrder, _ref$position = _ref.position, position = _ref$position === void 0 ? "top-center" : _ref$position, containerStyle = _ref.containerStyle, toastOptions = _ref.toastOptions;
    var _useToaster = $edbe27691ee42a08$export$f46171b59bb094f9(toastOptions), toasts = _useToaster.toasts, handlers = _useToaster.handlers;
    return (0, $bh6RR.createElement)("div", {
        style: $edbe27691ee42a08$var$_extends({
            position: "fixed",
            zIndex: 9999
        }, containerStyle),
        onMouseEnter: handlers.startPause,
        onMouseLeave: handlers.endPause
    }, toasts.map(function(t) {
        return (0, $bh6RR.createElement)($edbe27691ee42a08$export$af68597b0c62c1df, {
            key: t.id,
            onHeight: function onHeight(height) {
                return handlers.updateHeight(t.id, height);
            },
            toast: t,
            offset: handlers.calculateOffset(t.id, {
                reverseOrder: reverseOrder
            }),
            position: position
        });
    }));
};
var $edbe27691ee42a08$export$2e2bcd8739ae039 = $edbe27691ee42a08$export$b410431fab84fa58;

});
parcelRegister("6vkQq", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $4bc5cea4aa09b251$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "setup", function () { return $4bc5cea4aa09b251$export$de27182ff8187d6c; });
$parcel$export(module.exports, "styled", function () { return $4bc5cea4aa09b251$export$3817b7a54a07cec7; });
let $4bc5cea4aa09b251$var$e = {
    data: ""
}, $4bc5cea4aa09b251$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $4bc5cea4aa09b251$var$e, $4bc5cea4aa09b251$export$54aba348a7896325 = (e)=>{
    let r = $4bc5cea4aa09b251$var$t(e), l = r.data;
    return r.data = "", l;
}, $4bc5cea4aa09b251$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $4bc5cea4aa09b251$var$a = /\/\*[^]*?\*\/|  +/g, $4bc5cea4aa09b251$var$n = /\n+/g, $4bc5cea4aa09b251$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $4bc5cea4aa09b251$var$o(c, n) : n + "{" + $4bc5cea4aa09b251$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $4bc5cea4aa09b251$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $4bc5cea4aa09b251$var$o.p ? $4bc5cea4aa09b251$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $4bc5cea4aa09b251$var$c = {}, $4bc5cea4aa09b251$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $4bc5cea4aa09b251$var$s(e[r]);
        return t;
    }
    return e;
}, $4bc5cea4aa09b251$var$i = (e, t, r, i, p)=>{
    let u = $4bc5cea4aa09b251$var$s(e), d = $4bc5cea4aa09b251$var$c[u] || ($4bc5cea4aa09b251$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$4bc5cea4aa09b251$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $4bc5cea4aa09b251$var$l.exec(e.replace($4bc5cea4aa09b251$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($4bc5cea4aa09b251$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($4bc5cea4aa09b251$var$n, " ").trim();
            return o[0];
        })(e);
        $4bc5cea4aa09b251$var$c[d] = $4bc5cea4aa09b251$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $4bc5cea4aa09b251$var$c.g ? $4bc5cea4aa09b251$var$c.g : null;
    return r && ($4bc5cea4aa09b251$var$c.g = $4bc5cea4aa09b251$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($4bc5cea4aa09b251$var$c[d], t, i, f), d;
}, $4bc5cea4aa09b251$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $4bc5cea4aa09b251$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $4bc5cea4aa09b251$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $4bc5cea4aa09b251$var$i(l.unshift ? l.raw ? $4bc5cea4aa09b251$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $4bc5cea4aa09b251$var$t(r.target), r.g, r.o, r.k);
}
let $4bc5cea4aa09b251$var$d, $4bc5cea4aa09b251$var$f, $4bc5cea4aa09b251$var$g, $4bc5cea4aa09b251$export$442f1a04865e4790 = $4bc5cea4aa09b251$export$dbf350e5966cf602.bind({
    g: 1
}), $4bc5cea4aa09b251$export$d25ddfdf17c3ad3e = $4bc5cea4aa09b251$export$dbf350e5966cf602.bind({
    k: 1
});
function $4bc5cea4aa09b251$export$de27182ff8187d6c(e, t, r, l) {
    $4bc5cea4aa09b251$var$o.p = t, $4bc5cea4aa09b251$var$d = e, $4bc5cea4aa09b251$var$f = r, $4bc5cea4aa09b251$var$g = l;
}
function $4bc5cea4aa09b251$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $4bc5cea4aa09b251$var$f && $4bc5cea4aa09b251$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $4bc5cea4aa09b251$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $4bc5cea4aa09b251$var$g && i[0] && $4bc5cea4aa09b251$var$g(c), $4bc5cea4aa09b251$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}

});


parcelRegister("1WnR3", function(module, exports) {

$parcel$export(module.exports, "defaultToastDuration", function () { return $169db64380e51fed$export$bdffe9155ff84198; });
$parcel$export(module.exports, "DefaultToastBody", function () { return $169db64380e51fed$export$cae913bd595784a; });
$parcel$export(module.exports, "ToastContainer", function () { return $169db64380e51fed$export$f2815235e76a62b9; });
$parcel$export(module.exports, "Toast", function () { return $169db64380e51fed$export$8d8dc7d5f743331b; });
$parcel$export(module.exports, "Toaster", function () { return $169db64380e51fed$export$fb98e3a2a4cd92d7; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $bwRDU = parcelRequire("bwRDU");

var $kpuXf = parcelRequire("kpuXf");

var $hPMYy = parcelRequire("hPMYy");

var $i0wFy = parcelRequire("i0wFy");

var $64P2c = parcelRequire("64P2c");
var $169db64380e51fed$var$closeIcon = function closeIcon(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M11.427 1.427a.25.25 0 0 0-.354-.354L6.25 5.896 1.427 1.073a.25.25 0 0 0-.354.354L5.896 6.25 1.32 10.826a.25.25 0 0 0 .354.354L6.25 6.604l4.576 4.576a.25.25 0 0 0 .354-.354L6.604 6.25l4.823-4.823Z",
            stroke: "#979797",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
$169db64380e51fed$var$closeIcon.defaultProps = {
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $169db64380e51fed$export$bdffe9155ff84198 = (0, $64P2c.parseMilliseconds)("1s");
const $169db64380e51fed$export$cae913bd595784a = (0, $bwRDU.withModifiers)({
    default: ()=>`
        &::before {
            background: ${(0, $i0wFy.colors).magenta};
        }
    `
})((modifier)=>(0, $jCoLF.default).div.withConfig({
        displayName: "toast__DefaultToastBody",
        componentId: "sc-iwbti5-0"
    })([
        'width:100%;position:relative;box-sizing:border-box;padding:12px 32px 12px 16px;background:#fff;border-radius:3px;color:#595959;filter:drop-shadow(0px 2px 10px rgba(0,0,0,0.080305));z-index:1;overflow:hidden;width:300px;&::before{content:"";width:4px;height:100%;position:absolute;top:0;left:0;}',
        ""
    ], modifier));
const $169db64380e51fed$var$Close = (0, $jCoLF.default)($169db64380e51fed$var$closeIcon).withConfig({
    displayName: "toast__Close",
    componentId: "sc-iwbti5-1"
})([
    "position:absolute;width:11px;height:11px;top:4px;right:4px;cursor:pointer;padding:10px;"
]);
const $169db64380e51fed$var$GradientContainer = (0, $jCoLF.default).div.withConfig({
    displayName: "toast__GradientContainer",
    componentId: "sc-iwbti5-2"
})([
    'position:fixed;bottom:80px;right:20px;z-index:9999;&:before,&:after{display:none;content:"";position:absolute;width:100%;height:50px;left:0;z-index:1000;}&:after{background:linear-gradient(0deg,#f5e1e3,transparent);bottom:0;}&:before{top:0;background:linear-gradient(180deg,#f5e1e3,transparent);}'
]);
const $169db64380e51fed$var$JustifyContainer = (0, $jCoLF.default).div.withConfig({
    displayName: "toast__JustifyContainer",
    componentId: "sc-iwbti5-3"
})([
    "display:flex;flex-direction:column;justify-content:end;"
]);
const $169db64380e51fed$var$ToasterContainer = (0, $jCoLF.default).div.withConfig({
    displayName: "toast__ToasterContainer",
    componentId: "sc-iwbti5-4"
})([
    "&::-webkit-scrollbar{display:none;}"
]);
const $169db64380e51fed$export$f2815235e76a62b9 = (0, $jCoLF.default).div.withConfig({
    displayName: "toast__ToastContainer",
    componentId: "sc-iwbti5-5"
})([
    "box-shadow:0 3px 10px rgba(0,0,0,0.1),0 3px 3px rgba(0,0,0,0.05);&:not(:first-child){margin-top:16px;}"
]);
const $169db64380e51fed$export$8d8dc7d5f743331b = (props)=>{
    const { toastData: toastData, onClose: onClose, onClick: onClick, children: children, type: type } = props;
    const ToastBody = toastData.container && toastData.container.component || $169db64380e51fed$export$cae913bd595784a;
    return /*#__PURE__*/ (0, $ih19M.jsxs)(ToastBody, {
        modifiers: type,
        onClick: ()=>onClick === null || onClick === void 0 ? void 0 : onClick(toastData),
        ...toastData.container && toastData.container.props,
        children: [
            children,
            /*#__PURE__*/ (0, $ih19M.jsx)($169db64380e51fed$var$Close, {
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    (0, $hPMYy.removeToast)((toastObject)=>toastObject.toastId === toastData.id);
                    (0, $kpuXf.default).dismiss(toastData.id);
                    if (onClose) onClose();
                }
            })
        ]
    });
};
const $169db64380e51fed$export$fb98e3a2a4cd92d7 = ({ limit: limit = 3 })=>{
    const $container = (0, $bh6RR.useRef)();
    const { toasts: toasts, handlers: { startPause: startPause, endPause: endPause, calculateOffset: calculateOffset, updateHeight: updateHeight } } = (0, $kpuXf.useToaster)({
        duration: $169db64380e51fed$export$bdffe9155ff84198
    });
    (0, $bh6RR.useEffect)(()=>{
        setTimeout(()=>{
            if ($container.current) {
                var _$container$current;
                $container.current.scrollTop = (_$container$current = $container.current) === null || _$container$current === void 0 ? void 0 : _$container$current.scrollHeight;
            }
        });
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsx)($169db64380e51fed$var$GradientContainer, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)($169db64380e51fed$var$JustifyContainer, {
            children: /*#__PURE__*/ (0, $ih19M.jsx)($169db64380e51fed$var$ToasterContainer, {
                ref: $container,
                className: "toaster",
                onMouseEnter: startPause,
                onMouseLeave: endPause,
                children: toasts.filter((_, i)=>i < limit).map((item)=>{
                    const offset = calculateOffset(item, {
                        reverseOrder: false
                    });
                    const ref = (el)=>{
                        if (el && typeof item.height !== "number") {
                            const height = el.getBoundingClientRect().height;
                            updateHeight(item.id, height);
                        }
                    };
                    return /*#__PURE__*/ (0, $ih19M.jsx)($169db64380e51fed$export$f2815235e76a62b9, {
                        ref: ref,
                        className: "toast",
                        style: {
                            transform: `translateY(${offset}px)`,
                            animation: item.animation ? item.animation(item.visible) : item.visible ? "toast-anim-in 0.5s ease-in-out forwards" : "toast-anim-out 0.8s ease-in-out forwards"
                        },
                        ...item.ariaProps,
                        children: item.message(item)
                    }, item.id);
                })
            })
        })
    });
};

});
parcelRegister("bwRDU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.withModifiers = $864c4b2d668c3fab$var$withModifiers;

var $jVMUl = parcelRequire("jVMUl");
function $864c4b2d668c3fab$var$withModifiers(config) {
    return function(callback) {
        var result = callback((0, $jVMUl.applyStyleModifiers)(config));
        return result;
    };
}

});
parcelRegister("jVMUl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e8294746f0b7e0e9$var$_exportNames = {
    applyResponsiveStyleModifiers: true,
    applyStyleModifiers: true,
    styleModifierPropTypes: true,
    responsiveStyleModifierPropTypes: true
};
Object.defineProperty(module.exports, "applyResponsiveStyleModifiers", {
    enumerable: true,
    get: function get() {
        return $e8294746f0b7e0e9$var$_applyResponsiveStyleModifiers.default;
    }
});
Object.defineProperty(module.exports, "applyStyleModifiers", {
    enumerable: true,
    get: function get() {
        return $e8294746f0b7e0e9$var$_applyStyleModifiers.default;
    }
});
Object.defineProperty(module.exports, "styleModifierPropTypes", {
    enumerable: true,
    get: function get() {
        return $e8294746f0b7e0e9$var$_styleModifierPropTypes.default;
    }
});
Object.defineProperty(module.exports, "responsiveStyleModifierPropTypes", {
    enumerable: true,
    get: function get() {
        return $e8294746f0b7e0e9$var$_responsiveStyleModifierPropTypes.default;
    }
});

var $e8294746f0b7e0e9$var$_applyResponsiveStyleModifiers = $e8294746f0b7e0e9$var$_interopRequireDefault((parcelRequire("3Cuir")));

var $e8294746f0b7e0e9$var$_applyStyleModifiers = $e8294746f0b7e0e9$var$_interopRequireDefault((parcelRequire("b3oAQ")));

var $e8294746f0b7e0e9$var$_styleModifierPropTypes = $e8294746f0b7e0e9$var$_interopRequireDefault((parcelRequire("iBIlh")));

var $e8294746f0b7e0e9$var$_responsiveStyleModifierPropTypes = $e8294746f0b7e0e9$var$_interopRequireDefault((parcelRequire("8dWkl")));

var $3pDqt = parcelRequire("3pDqt");
Object.keys($3pDqt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e8294746f0b7e0e9$var$_exportNames, key)) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $3pDqt[key];
        }
    });
});
function $e8294746f0b7e0e9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("3Cuir", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a2c6bf7cb707ed7$var$applyResponsiveStyleModifiers;

var $38X4s = parcelRequire("38X4s");

var $2a2c6bf7cb707ed7$var$_isResponsiveModifiersProp = $2a2c6bf7cb707ed7$var$_interopRequireDefault((parcelRequire("c8Ftc")));

var $2a2c6bf7cb707ed7$var$_modifiedStyles = $2a2c6bf7cb707ed7$var$_interopRequireDefault((parcelRequire("90ICX")));
function $2a2c6bf7cb707ed7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * TODO: (DEPRECATED) The functionality provided here is now incorporated into
 * `styleModifierPropTypes`. This should be removed before the v2 release.
 */ /**
 * Returns a function that evaluates a modifiersConfig object against a component's props,
 * including a size prop. This function will return a string of CSS styles based on those inputs.
 * @export
 * @param {ModifiersConfig} modifiersConfig
 * @param {string} [modifiersPropName="responsiveModifiers"]
 * @returns
 */ function $2a2c6bf7cb707ed7$var$applyResponsiveStyleModifiers(modifiersConfig) {
    var modifiersPropName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "responsiveModifiers";
    return function(props) {
        var responsiveModifiers = props[modifiersPropName];
        if ((0, $2a2c6bf7cb707ed7$var$_isResponsiveModifiersProp.default)(responsiveModifiers)) return (0, $2a2c6bf7cb707ed7$var$_modifiedStyles.default)(responsiveModifiers[props.size || $38X4s.DEFAULT_MODIFIERS_KEY], modifiersConfig, props);
        return null;
    };
}

});
parcelRegister("38X4s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_MODIFIERS_KEY = void 0;
/* eslint-disable import/prefer-default-export */ var $249ff0ba12575199$var$DEFAULT_MODIFIERS_KEY = "_";
module.exports.DEFAULT_MODIFIERS_KEY = $249ff0ba12575199$var$DEFAULT_MODIFIERS_KEY;

});

parcelRegister("c8Ftc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8d66667581e4bb55$var$isResponsiveModifiersProp;

var $8d66667581e4bb55$var$_isObject = $8d66667581e4bb55$var$_interopRequireDefault((parcelRequire("jDBle")));
function $8d66667581e4bb55$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Evaluates if the first argument is of the ResponsiveModifiersProp type
 * @export
 * @param {*} val
 * @returns {val is ResponsiveModifiersProp}
 */ function $8d66667581e4bb55$var$isResponsiveModifiersProp(val) {
    return (0, $8d66667581e4bb55$var$_isObject.default)(val) && !Array.isArray(val);
}

});
parcelRegister("jDBle", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e4bea0192758232a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $e4bea0192758232a$var$isObject;

});


parcelRegister("90ICX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $68f6bb385d4ebf4d$var$modifiedStyles;

var $68f6bb385d4ebf4d$var$_isFunction = $68f6bb385d4ebf4d$var$_interopRequireDefault((parcelRequire("5aJzP")));

var $68f6bb385d4ebf4d$var$_isObject = $68f6bb385d4ebf4d$var$_interopRequireDefault((parcelRequire("jDBle")));

var $68f6bb385d4ebf4d$var$_normalizeModifiers = $68f6bb385d4ebf4d$var$_interopRequireDefault((parcelRequire("5uJTH")));
function $68f6bb385d4ebf4d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Evaluates if the first argument is of the ModifierObjValue type
 * @param {*} val
 * @returns {val is ModifierObjValue}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $68f6bb385d4ebf4d$var$isModifierObjValue(val) {
    return (0, $68f6bb385d4ebf4d$var$_isObject.default)(val) && !!val.styles;
}
/**
 * Extracts and builds the required style string based on the provided values.
 * @export
 * @param {ModifierKeys} [modifierKeys=[]]
 * @param {ModifiersConfig} [modifierConfig={}]
 * @param {ComponentProps} [componentProps]
 * @returns {SimpleInterpolation}
 */ function $68f6bb385d4ebf4d$var$modifiedStyles() {
    var modifierKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var modifierConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var componentProps = arguments.length > 2 ? arguments[2] : undefined;
    var stylesArr = (0, $68f6bb385d4ebf4d$var$_normalizeModifiers.default)(modifierKeys).reduce(function(acc, modifierName) {
        var modifierConfigValue = modifierConfig[modifierName];
        if ((0, $68f6bb385d4ebf4d$var$_isFunction.default)(modifierConfigValue)) {
            var config = modifierConfigValue(componentProps);
            var styles = $68f6bb385d4ebf4d$var$isModifierObjValue(config) ? config.styles : config;
            return Array.isArray(styles) ? acc.concat(styles.join("")) : acc.concat(styles);
        }
        return acc;
    }, []);
    return stylesArr.join(" ");
}

});
parcelRegister("5aJzP", function(module, exports) {

var $4VDrK = parcelRequire("4VDrK");

var $jDBle = parcelRequire("jDBle");
/** `Object#toString` result references. */ var $3c413d87f292fe2c$var$asyncTag = "[object AsyncFunction]", $3c413d87f292fe2c$var$funcTag = "[object Function]", $3c413d87f292fe2c$var$genTag = "[object GeneratorFunction]", $3c413d87f292fe2c$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $3c413d87f292fe2c$var$isFunction(value) {
    if (!$jDBle(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $4VDrK(value);
    return tag == $3c413d87f292fe2c$var$funcTag || tag == $3c413d87f292fe2c$var$genTag || tag == $3c413d87f292fe2c$var$asyncTag || tag == $3c413d87f292fe2c$var$proxyTag;
}
module.exports = $3c413d87f292fe2c$var$isFunction;

});
parcelRegister("4VDrK", function(module, exports) {

var $339hG = parcelRequire("339hG");

var $aZswa = parcelRequire("aZswa");

var $bD5ZI = parcelRequire("bD5ZI");
/** `Object#toString` result references. */ var $396b15940342a7f1$var$nullTag = "[object Null]", $396b15940342a7f1$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $396b15940342a7f1$var$symToStringTag = $339hG ? $339hG.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $396b15940342a7f1$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $396b15940342a7f1$var$undefinedTag : $396b15940342a7f1$var$nullTag;
    return $396b15940342a7f1$var$symToStringTag && $396b15940342a7f1$var$symToStringTag in Object(value) ? $aZswa(value) : $bD5ZI(value);
}
module.exports = $396b15940342a7f1$var$baseGetTag;

});
parcelRegister("339hG", function(module, exports) {

var $dnnhb = parcelRequire("dnnhb");
/** Built-in value references. */ var $2388da93fa592950$var$Symbol = $dnnhb.Symbol;
module.exports = $2388da93fa592950$var$Symbol;

});
parcelRegister("dnnhb", function(module, exports) {

var $8vz42 = parcelRequire("8vz42");
/** Detect free variable `self`. */ var $9bcf7a804d00ded1$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $9bcf7a804d00ded1$var$root = $8vz42 || $9bcf7a804d00ded1$var$freeSelf || Function("return this")();
module.exports = $9bcf7a804d00ded1$var$root;

});
parcelRegister("8vz42", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $631c6b00c6701f20$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $631c6b00c6701f20$var$freeGlobal;

});



parcelRegister("aZswa", function(module, exports) {

var $339hG = parcelRequire("339hG");
/** Used for built-in method references. */ var $8005b8efeeb9f4e7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8005b8efeeb9f4e7$var$hasOwnProperty = $8005b8efeeb9f4e7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8005b8efeeb9f4e7$var$nativeObjectToString = $8005b8efeeb9f4e7$var$objectProto.toString;
/** Built-in value references. */ var $8005b8efeeb9f4e7$var$symToStringTag = $339hG ? $339hG.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $8005b8efeeb9f4e7$var$getRawTag(value) {
    var isOwn = $8005b8efeeb9f4e7$var$hasOwnProperty.call(value, $8005b8efeeb9f4e7$var$symToStringTag), tag = value[$8005b8efeeb9f4e7$var$symToStringTag];
    try {
        value[$8005b8efeeb9f4e7$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $8005b8efeeb9f4e7$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$8005b8efeeb9f4e7$var$symToStringTag] = tag;
        else delete value[$8005b8efeeb9f4e7$var$symToStringTag];
    }
    return result;
}
module.exports = $8005b8efeeb9f4e7$var$getRawTag;

});

parcelRegister("bD5ZI", function(module, exports) {
/** Used for built-in method references. */ var $8777fc9d1b1902f9$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8777fc9d1b1902f9$var$nativeObjectToString = $8777fc9d1b1902f9$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $8777fc9d1b1902f9$var$objectToString(value) {
    return $8777fc9d1b1902f9$var$nativeObjectToString.call(value);
}
module.exports = $8777fc9d1b1902f9$var$objectToString;

});



parcelRegister("5uJTH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $01084fecde2cbdab$var$normalizeModifiers;
/**
 * Normalizes string modifier props to be an array.
 * @export
 * @param {ModifierKeys} modifierKeys
 * @returns {ModifierNames}
 */ function $01084fecde2cbdab$var$normalizeModifiers(modifierKeys) {
    return (Array.isArray(modifierKeys) ? modifierKeys : [
        modifierKeys
    ]).filter(function(i) {
        return typeof i === "string" && !!i;
    });
}

});



parcelRegister("b3oAQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $80c30d3c058127e8$var$applyStyleModifiers;

var $38X4s = parcelRequire("38X4s");

var $80c30d3c058127e8$var$_isResponsiveModifiersProp = $80c30d3c058127e8$var$_interopRequireDefault((parcelRequire("c8Ftc")));

var $80c30d3c058127e8$var$_modifiedStyles = $80c30d3c058127e8$var$_interopRequireDefault((parcelRequire("90ICX")));
function $80c30d3c058127e8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Returns a function that evaluates a modifiersConfig object against a component's props.
 * This function will return a string of CSS styles based on those inputs.
 * @export
 * @param {ModifiersConfig} modifiersConfig
 * @param {string} [modifiersPropName="modifiers"]
 * @returns
 */ function $80c30d3c058127e8$var$applyStyleModifiers(modifiersConfig) {
    var modifiersPropName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "modifiers";
    return function(props) {
        var modifiers = props[modifiersPropName];
        if ((0, $80c30d3c058127e8$var$_isResponsiveModifiersProp.default)(modifiers)) return (0, $80c30d3c058127e8$var$_modifiedStyles.default)(modifiers[props.size || $38X4s.DEFAULT_MODIFIERS_KEY], modifiersConfig, props);
        return (0, $80c30d3c058127e8$var$_modifiedStyles.default)(modifiers, modifiersConfig, props);
    };
}

});

parcelRegister("iBIlh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateResponsiveModifiers = $d8be141e7ce264c6$var$validateResponsiveModifiers;
module.exports.default = $d8be141e7ce264c6$var$styleModifierPropTypes;

var $d8be141e7ce264c6$var$_difference = $d8be141e7ce264c6$var$_interopRequireDefault((parcelRequire("4m0Gq")));

var $d8be141e7ce264c6$var$_flatten = $d8be141e7ce264c6$var$_interopRequireDefault((parcelRequire("crO0M")));

var $d8be141e7ce264c6$var$_forIn = $d8be141e7ce264c6$var$_interopRequireDefault((parcelRequire("6Cdmb")));

var $d8be141e7ce264c6$var$_keys = $d8be141e7ce264c6$var$_interopRequireDefault((parcelRequire("hNYnR")));

var $d8be141e7ce264c6$var$_uniq = $d8be141e7ce264c6$var$_interopRequireDefault((parcelRequire("gwvt8")));

var $d8be141e7ce264c6$var$_normalizeModifiers = $d8be141e7ce264c6$var$_interopRequireDefault((parcelRequire("5uJTH")));

var $d8be141e7ce264c6$var$_isResponsiveModifiersProp = $d8be141e7ce264c6$var$_interopRequireDefault((parcelRequire("c8Ftc")));
function $d8be141e7ce264c6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Returns an error if we have invalid modifiers or sizes with errors
 *
 * @param {string} modifiersPropName
 * @param {string} componentName
 * @param {ModifierNames} invalidModifiers
 * @param {string[]} sizesWithErrors
 * @returns {Error}
 */ function $d8be141e7ce264c6$var$generateError(modifiersPropName, componentName, invalidModifiers, sizesWithErrors) {
    var m = invalidModifiers.length > 1 ? "modifiers" : "modifier";
    var modifierList = invalidModifiers.join(", ");
    var k = sizesWithErrors && sizesWithErrors.length > 1 ? "keys" : "key";
    return new Error("Invalid ".concat(m, " ").concat(modifierList, " used in prop '").concat(modifiersPropName, "'").concat(sizesWithErrors ? " (size ".concat(k, " ").concat(sizesWithErrors.join(", "), ")") : "", " and supplied to ").concat(componentName, ". Validation failed."));
}
/**
 * Returns the invalid modifiers
 *
 * @param {ModifierKeys} modifierKeys
 * @param {ModifiersConfig} modifiersConfig
 * @returns {string[]}
 */ function $d8be141e7ce264c6$var$getInvalidModifiers(modifierKeys, modifiersConfig) {
    return (0, $d8be141e7ce264c6$var$_difference.default)((0, $d8be141e7ce264c6$var$_normalizeModifiers.default)(modifierKeys), (0, $d8be141e7ce264c6$var$_keys.default)(modifiersConfig));
}
/**
 * Checks for invalid modifiers
 *
 * @param {string} modifiersPropName
 * @param {string} componentName
 * @param {ModifierKeys} modifierKeys
 * @param {ModifiersConfig} modifierConfig
 * @returns {Error|Null}
 */ function $d8be141e7ce264c6$var$validateModifiers(modifiersPropName, componentName, modifierKeys, modifierConfig) {
    var invalidModifiers = $d8be141e7ce264c6$var$getInvalidModifiers(modifierKeys, modifierConfig);
    if (invalidModifiers.length > 0) return $d8be141e7ce264c6$var$generateError(modifiersPropName, componentName, invalidModifiers);
    return null;
}
/**
 * Checks for invalid modfiers for responsive modifiers
 *
 * @export
 * @param {string} modifiersPropName
 * @param {string} componentName
 * @param {ResponsiveModifiersProp} responsiveModifiers
 * @param {ModifiersConfig} modifierConfig
 * @returns {Error|Null}
 */ function $d8be141e7ce264c6$var$validateResponsiveModifiers(modifiersPropName, componentName, responsiveModifiers, modifierConfig) {
    var rawInvalidModifiers = [];
    var rawSizesWithErrors = [];
    (0, $d8be141e7ce264c6$var$_forIn.default)(responsiveModifiers, function(modifiers, size) {
        var invalidModifiers = $d8be141e7ce264c6$var$getInvalidModifiers(modifiers, modifierConfig);
        if (invalidModifiers.length > 0) {
            rawInvalidModifiers.push(invalidModifiers);
            rawSizesWithErrors.push(size);
        }
    });
    var invalidModifiers = (0, $d8be141e7ce264c6$var$_uniq.default)((0, $d8be141e7ce264c6$var$_flatten.default)(rawInvalidModifiers));
    var sizesWithErrors = (0, $d8be141e7ce264c6$var$_uniq.default)(rawSizesWithErrors);
    if (invalidModifiers.length > 0) return $d8be141e7ce264c6$var$generateError(modifiersPropName, componentName, invalidModifiers, sizesWithErrors);
    return null;
}
/**
 * Evaluates the modifiers prop against the modifier config. Throws invalid proptype error
 * if a modifier is supplied in prop and not found in modifier config.
 * @export
 * @param {ModifiersConfig} modifierConfig
 * @returns {Validator<ModifierKeys>}
 */ function $d8be141e7ce264c6$var$styleModifierPropTypes(modifierConfig) {
    var validator = function validator(props, modifiersPropName, componentName) {
        var modifiers = props[modifiersPropName];
        if ((0, $d8be141e7ce264c6$var$_isResponsiveModifiersProp.default)(modifiers)) return $d8be141e7ce264c6$var$validateResponsiveModifiers(modifiersPropName, componentName, modifiers, modifierConfig);
        return $d8be141e7ce264c6$var$validateModifiers(modifiersPropName, componentName, modifiers, modifierConfig);
    };
    return validator;
}

});
parcelRegister("4m0Gq", function(module, exports) {

var $ixaJn = parcelRequire("ixaJn");

var $leOVQ = parcelRequire("leOVQ");

var $gzyr9 = parcelRequire("gzyr9");

var $j6xB2 = parcelRequire("j6xB2");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $32b9bf295b0052d2$var$difference = $gzyr9(function(array, values) {
    return $j6xB2(array) ? $ixaJn(array, $leOVQ(values, 1, $j6xB2, true)) : [];
});
module.exports = $32b9bf295b0052d2$var$difference;

});
parcelRegister("ixaJn", function(module, exports) {

var $hrPLD = parcelRequire("hrPLD");

var $cKage = parcelRequire("cKage");

var $5dz2s = parcelRequire("5dz2s");

var $3z0dG = parcelRequire("3z0dG");

var $bb0EM = parcelRequire("bb0EM");

var $trEeL = parcelRequire("trEeL");
/** Used as the size to enable large array optimizations. */ var $d7e3a1f8ba450578$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $d7e3a1f8ba450578$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $cKage, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $3z0dG(values, $bb0EM(iteratee));
    if (comparator) {
        includes = $5dz2s;
        isCommon = false;
    } else if (values.length >= $d7e3a1f8ba450578$var$LARGE_ARRAY_SIZE) {
        includes = $trEeL;
        isCommon = false;
        values = new $hrPLD(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $d7e3a1f8ba450578$var$baseDifference;

});
parcelRegister("hrPLD", function(module, exports) {

var $kbJH9 = parcelRequire("kbJH9");

var $cZGQ5 = parcelRequire("cZGQ5");

var $3H2Uf = parcelRequire("3H2Uf");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $cb3d1d2f030b3948$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $kbJH9;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$cb3d1d2f030b3948$var$SetCache.prototype.add = $cb3d1d2f030b3948$var$SetCache.prototype.push = $cZGQ5;
$cb3d1d2f030b3948$var$SetCache.prototype.has = $3H2Uf;
module.exports = $cb3d1d2f030b3948$var$SetCache;

});
parcelRegister("kbJH9", function(module, exports) {

var $1hHDP = parcelRequire("1hHDP");

var $iuz3k = parcelRequire("iuz3k");

var $4eCHy = parcelRequire("4eCHy");

var $5hEGh = parcelRequire("5hEGh");

var $cplwr = parcelRequire("cplwr");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $eb2847cf8b43e448$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$eb2847cf8b43e448$var$MapCache.prototype.clear = $1hHDP;
$eb2847cf8b43e448$var$MapCache.prototype["delete"] = $iuz3k;
$eb2847cf8b43e448$var$MapCache.prototype.get = $4eCHy;
$eb2847cf8b43e448$var$MapCache.prototype.has = $5hEGh;
$eb2847cf8b43e448$var$MapCache.prototype.set = $cplwr;
module.exports = $eb2847cf8b43e448$var$MapCache;

});
parcelRegister("1hHDP", function(module, exports) {

var $O8Ium = parcelRequire("O8Ium");

var $8KXAf = parcelRequire("8KXAf");

var $eHWVz = parcelRequire("eHWVz");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $0ef93b41d443d840$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $O8Ium,
        "map": new ($eHWVz || $8KXAf),
        "string": new $O8Ium
    };
}
module.exports = $0ef93b41d443d840$var$mapCacheClear;

});
parcelRegister("O8Ium", function(module, exports) {

var $e5yrW = parcelRequire("e5yrW");

var $6Y7I2 = parcelRequire("6Y7I2");

var $49pHl = parcelRequire("49pHl");

var $k3awE = parcelRequire("k3awE");

var $7MuGp = parcelRequire("7MuGp");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $096b6e8d9d98217d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$096b6e8d9d98217d$var$Hash.prototype.clear = $e5yrW;
$096b6e8d9d98217d$var$Hash.prototype["delete"] = $6Y7I2;
$096b6e8d9d98217d$var$Hash.prototype.get = $49pHl;
$096b6e8d9d98217d$var$Hash.prototype.has = $k3awE;
$096b6e8d9d98217d$var$Hash.prototype.set = $7MuGp;
module.exports = $096b6e8d9d98217d$var$Hash;

});
parcelRegister("e5yrW", function(module, exports) {

var $4LcBe = parcelRequire("4LcBe");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $a41c4150a4a0597c$var$hashClear() {
    this.__data__ = $4LcBe ? $4LcBe(null) : {};
    this.size = 0;
}
module.exports = $a41c4150a4a0597c$var$hashClear;

});
parcelRegister("4LcBe", function(module, exports) {

var $6UqUS = parcelRequire("6UqUS");
/* Built-in method references that are verified to be native. */ var $3775533b2ea97104$var$nativeCreate = $6UqUS(Object, "create");
module.exports = $3775533b2ea97104$var$nativeCreate;

});
parcelRegister("6UqUS", function(module, exports) {

var $c6BdQ = parcelRequire("c6BdQ");

var $hWZX1 = parcelRequire("hWZX1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $507cda0e3d4397c2$var$getNative(object, key) {
    var value = $hWZX1(object, key);
    return $c6BdQ(value) ? value : undefined;
}
module.exports = $507cda0e3d4397c2$var$getNative;

});
parcelRegister("c6BdQ", function(module, exports) {

var $5aJzP = parcelRequire("5aJzP");

var $7cCf3 = parcelRequire("7cCf3");

var $jDBle = parcelRequire("jDBle");

var $80CZD = parcelRequire("80CZD");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8d02eb250319088c$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8d02eb250319088c$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8d02eb250319088c$var$funcProto = Function.prototype, $8d02eb250319088c$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8d02eb250319088c$var$funcToString = $8d02eb250319088c$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8d02eb250319088c$var$hasOwnProperty = $8d02eb250319088c$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8d02eb250319088c$var$reIsNative = RegExp("^" + $8d02eb250319088c$var$funcToString.call($8d02eb250319088c$var$hasOwnProperty).replace($8d02eb250319088c$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8d02eb250319088c$var$baseIsNative(value) {
    if (!$jDBle(value) || $7cCf3(value)) return false;
    var pattern = $5aJzP(value) ? $8d02eb250319088c$var$reIsNative : $8d02eb250319088c$var$reIsHostCtor;
    return pattern.test($80CZD(value));
}
module.exports = $8d02eb250319088c$var$baseIsNative;

});
parcelRegister("7cCf3", function(module, exports) {

var $7l7I6 = parcelRequire("7l7I6");
/** Used to detect methods masquerading as native. */ var $53e75170d73e0e3c$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($7l7I6 && $7l7I6.keys && $7l7I6.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $53e75170d73e0e3c$var$isMasked(func) {
    return !!$53e75170d73e0e3c$var$maskSrcKey && $53e75170d73e0e3c$var$maskSrcKey in func;
}
module.exports = $53e75170d73e0e3c$var$isMasked;

});
parcelRegister("7l7I6", function(module, exports) {

var $dnnhb = parcelRequire("dnnhb");
/** Used to detect overreaching core-js shims. */ var $558079b1ab119fea$var$coreJsData = $dnnhb["__core-js_shared__"];
module.exports = $558079b1ab119fea$var$coreJsData;

});


parcelRegister("80CZD", function(module, exports) {
/** Used for built-in method references. */ var $5d4c9208b54c16cf$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $5d4c9208b54c16cf$var$funcToString = $5d4c9208b54c16cf$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $5d4c9208b54c16cf$var$toSource(func) {
    if (func != null) {
        try {
            return $5d4c9208b54c16cf$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $5d4c9208b54c16cf$var$toSource;

});


parcelRegister("hWZX1", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d117e89f87247905$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d117e89f87247905$var$getValue;

});




parcelRegister("6Y7I2", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $512e538f8ec06abe$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $512e538f8ec06abe$var$hashDelete;

});

parcelRegister("49pHl", function(module, exports) {

var $4LcBe = parcelRequire("4LcBe");
/** Used to stand-in for `undefined` hash values. */ var $305befcd54445446$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $305befcd54445446$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $305befcd54445446$var$hasOwnProperty = $305befcd54445446$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $305befcd54445446$var$hashGet(key) {
    var data = this.__data__;
    if ($4LcBe) {
        var result = data[key];
        return result === $305befcd54445446$var$HASH_UNDEFINED ? undefined : result;
    }
    return $305befcd54445446$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $305befcd54445446$var$hashGet;

});

parcelRegister("k3awE", function(module, exports) {

var $4LcBe = parcelRequire("4LcBe");
/** Used for built-in method references. */ var $e98c409e6c78ac8d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e98c409e6c78ac8d$var$hasOwnProperty = $e98c409e6c78ac8d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e98c409e6c78ac8d$var$hashHas(key) {
    var data = this.__data__;
    return $4LcBe ? data[key] !== undefined : $e98c409e6c78ac8d$var$hasOwnProperty.call(data, key);
}
module.exports = $e98c409e6c78ac8d$var$hashHas;

});

parcelRegister("7MuGp", function(module, exports) {

var $4LcBe = parcelRequire("4LcBe");
/** Used to stand-in for `undefined` hash values. */ var $5aa4d120853b2dad$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $5aa4d120853b2dad$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $4LcBe && value === undefined ? $5aa4d120853b2dad$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $5aa4d120853b2dad$var$hashSet;

});


parcelRegister("8KXAf", function(module, exports) {

var $bL5Sn = parcelRequire("bL5Sn");

var $kmOAJ = parcelRequire("kmOAJ");

var $2XtVL = parcelRequire("2XtVL");

var $6Cgwd = parcelRequire("6Cgwd");

var $Sajkl = parcelRequire("Sajkl");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6600d6a94bbfda55$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$6600d6a94bbfda55$var$ListCache.prototype.clear = $bL5Sn;
$6600d6a94bbfda55$var$ListCache.prototype["delete"] = $kmOAJ;
$6600d6a94bbfda55$var$ListCache.prototype.get = $2XtVL;
$6600d6a94bbfda55$var$ListCache.prototype.has = $6Cgwd;
$6600d6a94bbfda55$var$ListCache.prototype.set = $Sajkl;
module.exports = $6600d6a94bbfda55$var$ListCache;

});
parcelRegister("bL5Sn", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $88f8a458a1ebfb99$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $88f8a458a1ebfb99$var$listCacheClear;

});

parcelRegister("kmOAJ", function(module, exports) {

var $kFngF = parcelRequire("kFngF");
/** Used for built-in method references. */ var $ed3d1b1aa1c6eb21$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ed3d1b1aa1c6eb21$var$splice = $ed3d1b1aa1c6eb21$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ed3d1b1aa1c6eb21$var$listCacheDelete(key) {
    var data = this.__data__, index = $kFngF(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ed3d1b1aa1c6eb21$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $ed3d1b1aa1c6eb21$var$listCacheDelete;

});
parcelRegister("kFngF", function(module, exports) {

var $iaV7A = parcelRequire("iaV7A");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f0b9af7eb68dc1e4$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($iaV7A(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $f0b9af7eb68dc1e4$var$assocIndexOf;

});
parcelRegister("iaV7A", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $d3b5784bbbc55641$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $d3b5784bbbc55641$var$eq;

});



parcelRegister("2XtVL", function(module, exports) {

var $kFngF = parcelRequire("kFngF");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $22784f0ffcbfc03d$var$listCacheGet(key) {
    var data = this.__data__, index = $kFngF(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $22784f0ffcbfc03d$var$listCacheGet;

});

parcelRegister("6Cgwd", function(module, exports) {

var $kFngF = parcelRequire("kFngF");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4d131af2d890865b$var$listCacheHas(key) {
    return $kFngF(this.__data__, key) > -1;
}
module.exports = $4d131af2d890865b$var$listCacheHas;

});

parcelRegister("Sajkl", function(module, exports) {

var $kFngF = parcelRequire("kFngF");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $0a2d0ac185e5d2a7$var$listCacheSet(key, value) {
    var data = this.__data__, index = $kFngF(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $0a2d0ac185e5d2a7$var$listCacheSet;

});


parcelRegister("eHWVz", function(module, exports) {

var $6UqUS = parcelRequire("6UqUS");

var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $ab52caa45642ed43$var$Map = $6UqUS($dnnhb, "Map");
module.exports = $ab52caa45642ed43$var$Map;

});


parcelRegister("iuz3k", function(module, exports) {

var $1EzAZ = parcelRequire("1EzAZ");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d766380f20569b4b$var$mapCacheDelete(key) {
    var result = $1EzAZ(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $d766380f20569b4b$var$mapCacheDelete;

});
parcelRegister("1EzAZ", function(module, exports) {

var $8ROwi = parcelRequire("8ROwi");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $134523692be3fdae$var$getMapData(map, key) {
    var data = map.__data__;
    return $8ROwi(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $134523692be3fdae$var$getMapData;

});
parcelRegister("8ROwi", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $674a762a247d0e5a$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $674a762a247d0e5a$var$isKeyable;

});



parcelRegister("4eCHy", function(module, exports) {

var $1EzAZ = parcelRequire("1EzAZ");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $31567d8d775c5c8a$var$mapCacheGet(key) {
    return $1EzAZ(this, key).get(key);
}
module.exports = $31567d8d775c5c8a$var$mapCacheGet;

});

parcelRegister("5hEGh", function(module, exports) {

var $1EzAZ = parcelRequire("1EzAZ");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3d8e18ae61a2fd42$var$mapCacheHas(key) {
    return $1EzAZ(this, key).has(key);
}
module.exports = $3d8e18ae61a2fd42$var$mapCacheHas;

});

parcelRegister("cplwr", function(module, exports) {

var $1EzAZ = parcelRequire("1EzAZ");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $908883b24173d38c$var$mapCacheSet(key, value) {
    var data = $1EzAZ(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $908883b24173d38c$var$mapCacheSet;

});


parcelRegister("cZGQ5", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $975c698101e172f2$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $975c698101e172f2$var$setCacheAdd(value) {
    this.__data__.set(value, $975c698101e172f2$var$HASH_UNDEFINED);
    return this;
}
module.exports = $975c698101e172f2$var$setCacheAdd;

});

parcelRegister("3H2Uf", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $2b07a45d13b540cb$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $2b07a45d13b540cb$var$setCacheHas;

});


parcelRegister("cKage", function(module, exports) {

var $5woKF = parcelRequire("5woKF");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $9471bd79da173863$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $5woKF(array, value, 0) > -1;
}
module.exports = $9471bd79da173863$var$arrayIncludes;

});
parcelRegister("5woKF", function(module, exports) {

var $758bs = parcelRequire("758bs");

var $e62pF = parcelRequire("e62pF");

var $9aiDm = parcelRequire("9aiDm");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $40532413b5afb432$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9aiDm(array, value, fromIndex) : $758bs(array, $e62pF, fromIndex);
}
module.exports = $40532413b5afb432$var$baseIndexOf;

});
parcelRegister("758bs", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $0154a2785752c54a$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $0154a2785752c54a$var$baseFindIndex;

});

parcelRegister("e62pF", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $a4337f60dbdf0237$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $a4337f60dbdf0237$var$baseIsNaN;

});

parcelRegister("9aiDm", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6ac3808560bb8ba2$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6ac3808560bb8ba2$var$strictIndexOf;

});



parcelRegister("5dz2s", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $3cc958968ea53f8f$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $3cc958968ea53f8f$var$arrayIncludesWith;

});

parcelRegister("3z0dG", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $2984cf9c242fe53a$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $2984cf9c242fe53a$var$arrayMap;

});

parcelRegister("bb0EM", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $82313b399bb9d3fb$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $82313b399bb9d3fb$var$baseUnary;

});

parcelRegister("trEeL", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $058827dcb6837216$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $058827dcb6837216$var$cacheHas;

});


parcelRegister("leOVQ", function(module, exports) {

var $hHReC = parcelRequire("hHReC");

var $luwem = parcelRequire("luwem");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $f76269cdb209b786$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $luwem);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $f76269cdb209b786$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hHReC(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $f76269cdb209b786$var$baseFlatten;

});
parcelRegister("hHReC", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $ce3fbf26bf92081d$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $ce3fbf26bf92081d$var$arrayPush;

});

parcelRegister("luwem", function(module, exports) {

var $339hG = parcelRequire("339hG");

var $j1sTW = parcelRequire("j1sTW");

var $9SpIz = parcelRequire("9SpIz");
/** Built-in value references. */ var $fa5566a8c4301ee3$var$spreadableSymbol = $339hG ? $339hG.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $fa5566a8c4301ee3$var$isFlattenable(value) {
    return $9SpIz(value) || $j1sTW(value) || !!($fa5566a8c4301ee3$var$spreadableSymbol && value && value[$fa5566a8c4301ee3$var$spreadableSymbol]);
}
module.exports = $fa5566a8c4301ee3$var$isFlattenable;

});
parcelRegister("j1sTW", function(module, exports) {

var $cimX3 = parcelRequire("cimX3");

var $6oZwd = parcelRequire("6oZwd");
/** Used for built-in method references. */ var $dd94877d05f10850$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dd94877d05f10850$var$hasOwnProperty = $dd94877d05f10850$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $dd94877d05f10850$var$propertyIsEnumerable = $dd94877d05f10850$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $dd94877d05f10850$var$isArguments = $cimX3(function() {
    return arguments;
}()) ? $cimX3 : function(value) {
    return $6oZwd(value) && $dd94877d05f10850$var$hasOwnProperty.call(value, "callee") && !$dd94877d05f10850$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $dd94877d05f10850$var$isArguments;

});
parcelRegister("cimX3", function(module, exports) {

var $4VDrK = parcelRequire("4VDrK");

var $6oZwd = parcelRequire("6oZwd");
/** `Object#toString` result references. */ var $8f38f8261e818ef2$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $8f38f8261e818ef2$var$baseIsArguments(value) {
    return $6oZwd(value) && $4VDrK(value) == $8f38f8261e818ef2$var$argsTag;
}
module.exports = $8f38f8261e818ef2$var$baseIsArguments;

});
parcelRegister("6oZwd", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $4a94b44c4940d5a5$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $4a94b44c4940d5a5$var$isObjectLike;

});



parcelRegister("9SpIz", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $730d1b366662da48$var$isArray = Array.isArray;
module.exports = $730d1b366662da48$var$isArray;

});



parcelRegister("gzyr9", function(module, exports) {

var $exCsE = parcelRequire("exCsE");

var $49Cyj = parcelRequire("49Cyj");

var $1hQWD = parcelRequire("1hQWD");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $c10aa0a9b39a8ece$var$baseRest(func, start) {
    return $1hQWD($49Cyj(func, start, $exCsE), func + "");
}
module.exports = $c10aa0a9b39a8ece$var$baseRest;

});
parcelRegister("exCsE", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $a961fb58d7bfedbf$var$identity(value) {
    return value;
}
module.exports = $a961fb58d7bfedbf$var$identity;

});

parcelRegister("49Cyj", function(module, exports) {

var $x9jk7 = parcelRequire("x9jk7");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3065e86617321cd4$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $3065e86617321cd4$var$overRest(func, start, transform) {
    start = $3065e86617321cd4$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $3065e86617321cd4$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $x9jk7(func, this, otherArgs);
    };
}
module.exports = $3065e86617321cd4$var$overRest;

});
parcelRegister("x9jk7", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $063a4e165ec1ca49$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $063a4e165ec1ca49$var$apply;

});


parcelRegister("1hQWD", function(module, exports) {

var $kgryG = parcelRequire("kgryG");

var $gmzOJ = parcelRequire("gmzOJ");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $0f0072ae65ebeb8e$var$setToString = $gmzOJ($kgryG);
module.exports = $0f0072ae65ebeb8e$var$setToString;

});
parcelRegister("kgryG", function(module, exports) {

var $cejJn = parcelRequire("cejJn");

var $8zT3F = parcelRequire("8zT3F");

var $exCsE = parcelRequire("exCsE");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $ec0aadcad8adf218$var$baseSetToString = !$8zT3F ? $exCsE : function(func, string) {
    return $8zT3F(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $cejJn(string),
        "writable": true
    });
};
module.exports = $ec0aadcad8adf218$var$baseSetToString;

});
parcelRegister("cejJn", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $024c3a358e064fde$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $024c3a358e064fde$var$constant;

});

parcelRegister("8zT3F", function(module, exports) {

var $6UqUS = parcelRequire("6UqUS");
var $63ec4d08c2de17a4$var$defineProperty = function() {
    try {
        var func = $6UqUS(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $63ec4d08c2de17a4$var$defineProperty;

});


parcelRegister("gmzOJ", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $be9a7bfa9fb4f512$var$HOT_COUNT = 800, $be9a7bfa9fb4f512$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $be9a7bfa9fb4f512$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $be9a7bfa9fb4f512$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $be9a7bfa9fb4f512$var$nativeNow(), remaining = $be9a7bfa9fb4f512$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $be9a7bfa9fb4f512$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $be9a7bfa9fb4f512$var$shortOut;

});



parcelRegister("j6xB2", function(module, exports) {

var $8VVqV = parcelRequire("8VVqV");

var $6oZwd = parcelRequire("6oZwd");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $de88a3656a93aa4e$var$isArrayLikeObject(value) {
    return $6oZwd(value) && $8VVqV(value);
}
module.exports = $de88a3656a93aa4e$var$isArrayLikeObject;

});
parcelRegister("8VVqV", function(module, exports) {

var $5aJzP = parcelRequire("5aJzP");

var $hsi1W = parcelRequire("hsi1W");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $681032a0f414881e$var$isArrayLike(value) {
    return value != null && $hsi1W(value.length) && !$5aJzP(value);
}
module.exports = $681032a0f414881e$var$isArrayLike;

});
parcelRegister("hsi1W", function(module, exports) {
/** Used as references for various `Number` constants. */ var $cb5309a5575a37b9$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $cb5309a5575a37b9$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $cb5309a5575a37b9$var$MAX_SAFE_INTEGER;
}
module.exports = $cb5309a5575a37b9$var$isLength;

});




parcelRegister("crO0M", function(module, exports) {

var $leOVQ = parcelRequire("leOVQ");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $90fecceb12547f2a$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $leOVQ(array, 1) : [];
}
module.exports = $90fecceb12547f2a$var$flatten;

});

parcelRegister("6Cdmb", function(module, exports) {

var $47rxs = parcelRequire("47rxs");

var $7iSmW = parcelRequire("7iSmW");

var $iAAPL = parcelRequire("iAAPL");
/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */ function $013e343e417b49d7$var$forIn(object, iteratee) {
    return object == null ? object : $47rxs(object, $7iSmW(iteratee), $iAAPL);
}
module.exports = $013e343e417b49d7$var$forIn;

});
parcelRegister("47rxs", function(module, exports) {

var $4WWn5 = parcelRequire("4WWn5");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $2ffd2d73f118f911$var$baseFor = $4WWn5();
module.exports = $2ffd2d73f118f911$var$baseFor;

});
parcelRegister("4WWn5", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $39a9db840e8a5122$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $39a9db840e8a5122$var$createBaseFor;

});


parcelRegister("7iSmW", function(module, exports) {

var $exCsE = parcelRequire("exCsE");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $55146360e6f14e65$var$castFunction(value) {
    return typeof value == "function" ? value : $exCsE;
}
module.exports = $55146360e6f14e65$var$castFunction;

});

parcelRegister("iAAPL", function(module, exports) {

var $4WMU2 = parcelRequire("4WMU2");

var $73rrG = parcelRequire("73rrG");

var $8VVqV = parcelRequire("8VVqV");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $d888293c43fbc328$var$keysIn(object) {
    return $8VVqV(object) ? $4WMU2(object, true) : $73rrG(object);
}
module.exports = $d888293c43fbc328$var$keysIn;

});
parcelRegister("4WMU2", function(module, exports) {

var $aWyUO = parcelRequire("aWyUO");

var $j1sTW = parcelRequire("j1sTW");

var $9SpIz = parcelRequire("9SpIz");

var $8TKuU = parcelRequire("8TKuU");

var $kgu66 = parcelRequire("kgu66");

var $7gKnA = parcelRequire("7gKnA");
/** Used for built-in method references. */ var $39a283488d173d50$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $39a283488d173d50$var$hasOwnProperty = $39a283488d173d50$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $39a283488d173d50$var$arrayLikeKeys(value, inherited) {
    var isArr = $9SpIz(value), isArg = !isArr && $j1sTW(value), isBuff = !isArr && !isArg && $8TKuU(value), isType = !isArr && !isArg && !isBuff && $7gKnA(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $aWyUO(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $39a283488d173d50$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $kgu66(key, length)))) result.push(key);
    return result;
}
module.exports = $39a283488d173d50$var$arrayLikeKeys;

});
parcelRegister("aWyUO", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $7f7a679ab009c8e0$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $7f7a679ab009c8e0$var$baseTimes;

});

parcelRegister("8TKuU", function(module, exports) {

var $dnnhb = parcelRequire("dnnhb");

var $lAPp0 = parcelRequire("lAPp0");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $dnnhb.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $lAPp0;
module.exports = isBuffer;

});
parcelRegister("lAPp0", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $fb84d52c0f9b5c17$var$stubFalse() {
    return false;
}
module.exports = $fb84d52c0f9b5c17$var$stubFalse;

});


parcelRegister("kgu66", function(module, exports) {
/** Used as references for various `Number` constants. */ var $ec0ca5ffb2ff14ec$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ec0ca5ffb2ff14ec$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ec0ca5ffb2ff14ec$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ec0ca5ffb2ff14ec$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $ec0ca5ffb2ff14ec$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $ec0ca5ffb2ff14ec$var$isIndex;

});

parcelRegister("7gKnA", function(module, exports) {

var $l1u6d = parcelRequire("l1u6d");

var $bb0EM = parcelRequire("bb0EM");

var $1mm29 = parcelRequire("1mm29");
/* Node.js helper references. */ var $54ae0102d9b8cfdf$var$nodeIsTypedArray = $1mm29 && $1mm29.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $54ae0102d9b8cfdf$var$isTypedArray = $54ae0102d9b8cfdf$var$nodeIsTypedArray ? $bb0EM($54ae0102d9b8cfdf$var$nodeIsTypedArray) : $l1u6d;
module.exports = $54ae0102d9b8cfdf$var$isTypedArray;

});
parcelRegister("l1u6d", function(module, exports) {

var $4VDrK = parcelRequire("4VDrK");

var $hsi1W = parcelRequire("hsi1W");

var $6oZwd = parcelRequire("6oZwd");
/** `Object#toString` result references. */ var $f4e10a0fb2366352$var$argsTag = "[object Arguments]", $f4e10a0fb2366352$var$arrayTag = "[object Array]", $f4e10a0fb2366352$var$boolTag = "[object Boolean]", $f4e10a0fb2366352$var$dateTag = "[object Date]", $f4e10a0fb2366352$var$errorTag = "[object Error]", $f4e10a0fb2366352$var$funcTag = "[object Function]", $f4e10a0fb2366352$var$mapTag = "[object Map]", $f4e10a0fb2366352$var$numberTag = "[object Number]", $f4e10a0fb2366352$var$objectTag = "[object Object]", $f4e10a0fb2366352$var$regexpTag = "[object RegExp]", $f4e10a0fb2366352$var$setTag = "[object Set]", $f4e10a0fb2366352$var$stringTag = "[object String]", $f4e10a0fb2366352$var$weakMapTag = "[object WeakMap]";
var $f4e10a0fb2366352$var$arrayBufferTag = "[object ArrayBuffer]", $f4e10a0fb2366352$var$dataViewTag = "[object DataView]", $f4e10a0fb2366352$var$float32Tag = "[object Float32Array]", $f4e10a0fb2366352$var$float64Tag = "[object Float64Array]", $f4e10a0fb2366352$var$int8Tag = "[object Int8Array]", $f4e10a0fb2366352$var$int16Tag = "[object Int16Array]", $f4e10a0fb2366352$var$int32Tag = "[object Int32Array]", $f4e10a0fb2366352$var$uint8Tag = "[object Uint8Array]", $f4e10a0fb2366352$var$uint8ClampedTag = "[object Uint8ClampedArray]", $f4e10a0fb2366352$var$uint16Tag = "[object Uint16Array]", $f4e10a0fb2366352$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $f4e10a0fb2366352$var$typedArrayTags = {};
$f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$float32Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$float64Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int8Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int16Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int32Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint8Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint8ClampedTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint16Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint32Tag] = true;
$f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$argsTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$arrayTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$arrayBufferTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$boolTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$dataViewTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$dateTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$errorTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$funcTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$mapTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$numberTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$objectTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$regexpTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$setTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$stringTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $f4e10a0fb2366352$var$baseIsTypedArray(value) {
    return $6oZwd(value) && $hsi1W(value.length) && !!$f4e10a0fb2366352$var$typedArrayTags[$4VDrK(value)];
}
module.exports = $f4e10a0fb2366352$var$baseIsTypedArray;

});

parcelRegister("1mm29", function(module, exports) {

var $8vz42 = parcelRequire("8vz42");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $8vz42.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("73rrG", function(module, exports) {

var $jDBle = parcelRequire("jDBle");

var $cUAJW = parcelRequire("cUAJW");

var $9gRmz = parcelRequire("9gRmz");
/** Used for built-in method references. */ var $522e1a52d1a3638a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $522e1a52d1a3638a$var$hasOwnProperty = $522e1a52d1a3638a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $522e1a52d1a3638a$var$baseKeysIn(object) {
    if (!$jDBle(object)) return $9gRmz(object);
    var isProto = $cUAJW(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$522e1a52d1a3638a$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $522e1a52d1a3638a$var$baseKeysIn;

});
parcelRegister("cUAJW", function(module, exports) {
/** Used for built-in method references. */ var $966736caab723063$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $966736caab723063$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $966736caab723063$var$objectProto;
    return value === proto;
}
module.exports = $966736caab723063$var$isPrototype;

});

parcelRegister("9gRmz", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6bff007b7d933e2e$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $6bff007b7d933e2e$var$nativeKeysIn;

});




parcelRegister("hNYnR", function(module, exports) {

var $4WMU2 = parcelRequire("4WMU2");

var $5xRjg = parcelRequire("5xRjg");

var $8VVqV = parcelRequire("8VVqV");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $cf65da43818f725f$var$keys(object) {
    return $8VVqV(object) ? $4WMU2(object) : $5xRjg(object);
}
module.exports = $cf65da43818f725f$var$keys;

});
parcelRegister("5xRjg", function(module, exports) {

var $cUAJW = parcelRequire("cUAJW");

var $97CPW = parcelRequire("97CPW");
/** Used for built-in method references. */ var $409962ffb97dfa14$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $409962ffb97dfa14$var$hasOwnProperty = $409962ffb97dfa14$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $409962ffb97dfa14$var$baseKeys(object) {
    if (!$cUAJW(object)) return $97CPW(object);
    var result = [];
    for(var key in Object(object))if ($409962ffb97dfa14$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $409962ffb97dfa14$var$baseKeys;

});
parcelRegister("97CPW", function(module, exports) {

var $lKQmC = parcelRequire("lKQmC");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6a42e4b2642f3889$var$nativeKeys = $lKQmC(Object.keys, Object);
module.exports = $6a42e4b2642f3889$var$nativeKeys;

});
parcelRegister("lKQmC", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $fd668335d1985147$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $fd668335d1985147$var$overArg;

});




parcelRegister("gwvt8", function(module, exports) {

var $eeoVw = parcelRequire("eeoVw");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $c0780b8eb4a2ea37$var$uniq(array) {
    return array && array.length ? $eeoVw(array) : [];
}
module.exports = $c0780b8eb4a2ea37$var$uniq;

});
parcelRegister("eeoVw", function(module, exports) {

var $hrPLD = parcelRequire("hrPLD");

var $cKage = parcelRequire("cKage");

var $5dz2s = parcelRequire("5dz2s");

var $trEeL = parcelRequire("trEeL");

var $aSXUx = parcelRequire("aSXUx");

var $5tsV1 = parcelRequire("5tsV1");
/** Used as the size to enable large array optimizations. */ var $a5c5b568721d6ff7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $a5c5b568721d6ff7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $cKage, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $5dz2s;
    } else if (length >= $a5c5b568721d6ff7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $aSXUx(array);
        if (set) return $5tsV1(set);
        isCommon = false;
        includes = $trEeL;
        seen = new $hrPLD;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $a5c5b568721d6ff7$var$baseUniq;

});
parcelRegister("aSXUx", function(module, exports) {

var $44JGv = parcelRequire("44JGv");

var $l9FK4 = parcelRequire("l9FK4");

var $5tsV1 = parcelRequire("5tsV1");
/** Used as references for various `Number` constants. */ var $7ecd6b96d57dea5c$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $7ecd6b96d57dea5c$var$createSet = !($44JGv && 1 / $5tsV1(new $44JGv([
    ,
    -0
]))[1] == $7ecd6b96d57dea5c$var$INFINITY) ? $l9FK4 : function(values) {
    return new $44JGv(values);
};
module.exports = $7ecd6b96d57dea5c$var$createSet;

});
parcelRegister("44JGv", function(module, exports) {

var $6UqUS = parcelRequire("6UqUS");

var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $2f7af927ce68d1f1$var$Set = $6UqUS($dnnhb, "Set");
module.exports = $2f7af927ce68d1f1$var$Set;

});

parcelRegister("l9FK4", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $f66ad158235d696c$var$noop() {
// No operation performed.
}
module.exports = $f66ad158235d696c$var$noop;

});

parcelRegister("5tsV1", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $3fc617daaa01c913$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $3fc617daaa01c913$var$setToArray;

});





parcelRegister("8dWkl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5fccc82efb953ee0$var$responsiveStyleModifierPropTypes;

var $5fccc82efb953ee0$var$_isResponsiveModifiersProp = $5fccc82efb953ee0$var$_interopRequireDefault((parcelRequire("c8Ftc")));

var $iBIlh = parcelRequire("iBIlh");
function $5fccc82efb953ee0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * TODO: (DEPRECATED) The functionality provided here is now incorporated into
 * `styleModifierPropTypes`. This should be removed before the v2 release.
 */ /**
 * Evaluates the modifiers prop against the modifier config. Throws invalid proptype error
 * if a modifier is supplied in prop and not found in modifier config.
 * @export
 * @param {ModifiersConfig} modifierConfig
 * @returns {Validator<ModifierKeys>}
 */ function $5fccc82efb953ee0$var$responsiveStyleModifierPropTypes(modifierConfig) {
    var validator = function validator(props, propName, componentName) {
        var responsiveModifiers = props[propName];
        if ((0, $5fccc82efb953ee0$var$_isResponsiveModifiersProp.default)(responsiveModifiers)) return (0, $iBIlh.validateResponsiveModifiers)(propName, componentName, responsiveModifiers, modifierConfig);
        return null;
    };
    return validator;
}

});

parcelRegister("3pDqt", function(module, exports) {
"use strict";

});



parcelRegister("hPMYy", function(module, exports) {

$parcel$export(module.exports, "addToast", function () { return $cfbd30a226022cec$export$2cb648f4e71e8121; });
$parcel$export(module.exports, "removeToast", function () { return $cfbd30a226022cec$export$5b04c550cac587dd; });
$parcel$export(module.exports, "clearToasts", function () { return $cfbd30a226022cec$export$146d3985d6a01a6b; });
$parcel$export(module.exports, "findToast", function () { return $cfbd30a226022cec$export$67080b9d5f0a62ea; });

var $b7l7Q = parcelRequire("b7l7Q");

var $kpuXf = parcelRequire("kpuXf");
const $cfbd30a226022cec$export$e80fa18a42ed98ef = (0, $b7l7Q.createStore)([]);
const $cfbd30a226022cec$var$setToastData = (0, $b7l7Q.createEvent)("setToastData");
const $cfbd30a226022cec$export$2cb648f4e71e8121 = (0, $b7l7Q.createEvent)("addToast");
const $cfbd30a226022cec$export$5b04c550cac587dd = (0, $b7l7Q.createEvent)("removeToast");
const $cfbd30a226022cec$export$146d3985d6a01a6b = (0, $b7l7Q.createEvent)("clearToasts");
const $cfbd30a226022cec$export$67080b9d5f0a62ea = (toastSeeker)=>$cfbd30a226022cec$export$e80fa18a42ed98ef.thru((store)=>store.getState().find(toastSeeker));
$cfbd30a226022cec$export$e80fa18a42ed98ef.on($cfbd30a226022cec$var$setToastData, (state, payload)=>payload);
$cfbd30a226022cec$export$e80fa18a42ed98ef.on($cfbd30a226022cec$export$2cb648f4e71e8121, (state, newToast)=>[
        ...state,
        newToast
    ]);
$cfbd30a226022cec$export$e80fa18a42ed98ef.on($cfbd30a226022cec$export$5b04c550cac587dd, (state, comparator)=>[
        ...state.filter((toastObject)=>!comparator(toastObject))
    ]);
$cfbd30a226022cec$export$e80fa18a42ed98ef.on($cfbd30a226022cec$export$146d3985d6a01a6b, (state)=>{
    state.forEach((toastObject)=>{
        (0, $kpuXf.default).dismiss(toastObject.toastId);
    });
    return [];
});

});

parcelRegister("i0wFy", function(module, exports) {

$parcel$export(module.exports, "colors", function () { return $d1c19185e3e640ee$export$8f45430ccf837300; });
$parcel$export(module.exports, "tableSelectColors", function () { return $d1c19185e3e640ee$export$2ce71a4b3aecbb8e; });

var $6dHL0 = parcelRequire("6dHL0");
const $d1c19185e3e640ee$export$8f45430ccf837300 = {
    pink100: "#D6006D",
    lightMagenta: "#de008e",
    magenta: "#c6007f",
    paleGrey: "#f5faff",
    lightPink: "#f5e1e3",
    palePink: "#fff5f1",
    wheat: "#ffe27a",
    green: "#79e97a",
    lightGreen: "#b9fcb9",
    watermelon: "#f2576a",
    pink: "#c6007f",
    lavenderBlush: "#fff1f6",
    blue: "#3979D6",
    lightBlue: "#39d6c0",
    aquaSqueeze: "#ECF6F4",
    aquaSqueezeLight: "#e2f6f2",
    oldLace: "#FDF7E0",
    sauvignon: "#FFF5F1",
    sauvignonLight: "#fae7e0",
    concrete: "#F3F3F3",
    aliceBlue: "#E9F2FF",
    white: "#ffffff",
    gray025: "#fafafa",
    gray050: "#f3f3f3",
    gray100: "#ebebeb",
    silver: "#bebebe",
    gray150: "#dcd3d2",
    gray200: "#d4d4d4",
    gray300: "#b4b4b4",
    gray400: "#9b9b9b",
    gray500: "#595959",
    gray600: "#4a4a4a",
    gray700: "#7d7d7d",
    gray800: "#cecece",
    gray900: "#f9f9f9",
    black: "#262626",
    nearBlack: "#454545",
    darkBlack: "#000000",
    cinnabar: "#e13838",
    alto: "#dfdfdf",
    darkGray: "#979797",
    paleOrange: "#FDF7E0",
    fauxAliceBlue: "#E9F2FF",
    hintOfRed: "#f5f2f2",
    pomegranate: "#ee2b2b",
    transparentGray: (0, $6dHL0.rgba)("#979797", 0.3),
    transparentGray100: (0, $6dHL0.rgba)("#EBEBEB", 0.3),
    bgColor: "#F9F4F4",
    accent5: "#D6006D",
    accent85: "#FFA3D2",
    accent90: "#F8D3E7",
    accent95: "#FCEBF4",
    accent100: "#FDF2F8",
    neutral15: "#B0B0B0",
    neutral20: "#D4D4D4",
    neutral95: "#FAFAFA",
    neutral90: "#F5F5F5",
    success0: "#31BD2E",
    error0: "#E83134",
    corpAccentGold: "#A0A25D"
};
const $d1c19185e3e640ee$export$2ce71a4b3aecbb8e = {
    green: $d1c19185e3e640ee$export$8f45430ccf837300.aquaSqueeze,
    greenLight: $d1c19185e3e640ee$export$8f45430ccf837300.aquaSqueezeLight,
    yellow: $d1c19185e3e640ee$export$8f45430ccf837300.oldLace,
    red: $d1c19185e3e640ee$export$8f45430ccf837300.sauvignon,
    redLight: $d1c19185e3e640ee$export$8f45430ccf837300.sauvignonLight,
    gray: $d1c19185e3e640ee$export$8f45430ccf837300.concrete,
    blue: $d1c19185e3e640ee$export$8f45430ccf837300.aliceBlue
};

});
parcelRegister("6dHL0", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $4875e63af1e2f289$export$4e46ac54fc82cf3b; });

var $4WYaH = parcelRequire("4WYaH");

var $hqR4t = parcelRequire("hqR4t");

var $gMqD6 = parcelRequire("gMqD6");

var $9wGjo = parcelRequire("9wGjo");

var $lSN3y = parcelRequire("lSN3y");
function $4875e63af1e2f289$var$last() {
    var _ref;
    return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}
function $4875e63af1e2f289$var$negation(a) {
    return -a;
}
function $4875e63af1e2f289$var$addition(a, b) {
    return a + b;
}
function $4875e63af1e2f289$var$subtraction(a, b) {
    return a - b;
}
function $4875e63af1e2f289$var$multiplication(a, b) {
    return a * b;
}
function $4875e63af1e2f289$var$division(a, b) {
    return a / b;
}
function $4875e63af1e2f289$var$max() {
    return Math.max.apply(Math, arguments);
}
function $4875e63af1e2f289$var$min() {
    return Math.min.apply(Math, arguments);
}
function $4875e63af1e2f289$var$comma() {
    return Array.of.apply(Array, arguments);
}
var $4875e63af1e2f289$var$defaultSymbols = {
    symbols: {
        "*": {
            infix: {
                symbol: "*",
                f: $4875e63af1e2f289$var$multiplication,
                notation: "infix",
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: "*",
            regSymbol: "\\*"
        },
        "/": {
            infix: {
                symbol: "/",
                f: $4875e63af1e2f289$var$division,
                notation: "infix",
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: "/",
            regSymbol: "/"
        },
        "+": {
            infix: {
                symbol: "+",
                f: $4875e63af1e2f289$var$addition,
                notation: "infix",
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: "+",
                f: $4875e63af1e2f289$var$last,
                notation: "prefix",
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: "+",
            regSymbol: "\\+"
        },
        "-": {
            infix: {
                symbol: "-",
                f: $4875e63af1e2f289$var$subtraction,
                notation: "infix",
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: "-",
                f: $4875e63af1e2f289$var$negation,
                notation: "prefix",
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: "-",
            regSymbol: "-"
        },
        ",": {
            infix: {
                symbol: ",",
                f: $4875e63af1e2f289$var$comma,
                notation: "infix",
                precedence: 1,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: ",",
            regSymbol: ","
        },
        "(": {
            prefix: {
                symbol: "(",
                f: $4875e63af1e2f289$var$last,
                notation: "prefix",
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: "(",
            regSymbol: "\\("
        },
        ")": {
            postfix: {
                symbol: ")",
                f: undefined,
                notation: "postfix",
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: ")",
            regSymbol: "\\)"
        },
        min: {
            func: {
                symbol: "min",
                f: $4875e63af1e2f289$var$min,
                notation: "func",
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: "min",
            regSymbol: "min\\b"
        },
        max: {
            func: {
                symbol: "max",
                f: $4875e63af1e2f289$var$max,
                notation: "func",
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: "max",
            regSymbol: "max\\b"
        }
    }
};
var $4875e63af1e2f289$var$defaultSymbolMap = $4875e63af1e2f289$var$defaultSymbols;
// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js
/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */ var $4875e63af1e2f289$var$ERRORS = {
    "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
    "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
    "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
    "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
    "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
    "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
    "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
    "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
    "9": "Please provide a number of steps to the modularScale helper.\n\n",
    "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "11": 'Invalid value passed as base to modularScale, expected number or em string but got "%s"\n\n',
    "12": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.\n\n',
    "13": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.\n\n',
    "14": 'Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
    "15": 'Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
    "16": "You must provide a template to this method.\n\n",
    "17": "You passed an unsupported selector state to this method.\n\n",
    "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "23": "fontFace expects a name of a font-family.\n\n",
    "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "25": "fontFace expects localFonts to be an array.\n\n",
    "26": "fontFace expects fileFormats to be an array.\n\n",
    "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
    "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
    "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
    "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "35": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
    "36": "Property must be a string value.\n\n",
    "37": "Syntax Error at %s.\n\n",
    "38": "Formula contains a function that needs parentheses at %s.\n\n",
    "39": "Formula is missing closing parenthesis at %s.\n\n",
    "40": "Formula has too many closing parentheses at %s.\n\n",
    "41": "All values in a formula must have the same unit or be unitless.\n\n",
    "42": "Please provide a number of steps to the modularScale helper.\n\n",
    "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
    "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
    "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
    "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
    "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
    "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "53": "fontFace expects localFonts to be an array.\n\n",
    "54": "fontFace expects fileFormats to be an array.\n\n",
    "55": "fontFace expects a name of a font-family.\n\n",
    "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
    "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "61": "Property must be a string value.\n\n",
    "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "63": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
    "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
    "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
    "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
    "67": "You must provide a template to this method.\n\n",
    "68": "You passed an unsupported selector state to this method.\n\n",
    "69": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.\n\n',
    "70": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.\n\n',
    "71": 'Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.\n\n',
    "72": 'Passed invalid base value %s to %s(), please pass a value like "12px" or 12.\n\n',
    "73": "Please provide a valid CSS variable.\n\n",
    "74": "CSS variable not found and no default was provided.\n\n",
    "75": "important requires a valid style object, got a %s instead.\n\n",
    "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
    "77": 'remToPx expects a value in "rem" but you provided it in "%s".\n\n',
    "78": 'base must be set in "px" or "%" but you set it in "%s".\n'
};
/**
 * super basic version of sprintf
 * @private
 */ function $4875e63af1e2f289$var$format() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */ var $4875e63af1e2f289$var$PolishedError = /*#__PURE__*/ function(_Error) {
    (0, $gMqD6.default)(PolishedError, _Error);
    function PolishedError(code) {
        var _this;
        var _len2, args, _key2;
        _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
        return (0, $hqR4t.default)(_this);
    }
    return PolishedError;
}(/*#__PURE__*/ (0, $9wGjo.default)(Error));
var $4875e63af1e2f289$var$unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g;
// Merges additional math functionality into the defaults.
function $4875e63af1e2f289$var$mergeSymbolMaps(additionalSymbols) {
    var symbolMap = {};
    symbolMap.symbols = additionalSymbols ? (0, $4WYaH.default)({}, $4875e63af1e2f289$var$defaultSymbolMap.symbols, additionalSymbols.symbols) : (0, $4WYaH.default)({}, $4875e63af1e2f289$var$defaultSymbolMap.symbols);
    return symbolMap;
}
function $4875e63af1e2f289$var$exec(operators, values) {
    var _ref;
    var op = operators.pop();
    values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
    return op.precedence;
}
function $4875e63af1e2f289$var$calculate(expression, additionalSymbols) {
    var symbolMap = $4875e63af1e2f289$var$mergeSymbolMaps(additionalSymbols);
    var match;
    var operators = [
        symbolMap.symbols["("].prefix
    ];
    var values = [];
    var pattern = new RegExp("\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
    Object.keys(symbolMap.symbols).map(function(key) {
        return symbolMap.symbols[key];
    })// longer symbols should be listed first
    // $FlowFixMe
    .sort(function(a, b) {
        return b.symbol.length - a.symbol.length;
    })// $FlowFixMe
    .map(function(val) {
        return val.regSymbol;
    }).join("|") + "|(\\S)", "g");
    pattern.lastIndex = 0; // Reset regular expression object
    var afterValue = false;
    do {
        match = pattern.exec(expression);
        var _ref2 = match || [
            ")",
            undefined
        ], token = _ref2[0], bad = _ref2[1];
        var notNumber = symbolMap.symbols[token];
        var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
        var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix;
        // Check for syntax errors:
        if (bad || (afterValue ? notAfterValue : notNewValue)) throw new $4875e63af1e2f289$var$PolishedError(37, match ? match.index : expression.length, expression);
        if (afterValue) {
            // We either have an infix or postfix operator (they should be mutually exclusive)
            var curr = notNumber.postfix || notNumber.infix;
            do {
                var prev = operators[operators.length - 1];
                if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break;
            // Apply previous operator, since it has precedence over current one
            }while ($4875e63af1e2f289$var$exec(operators, values)); // Exit loop after executing an opening parenthesis or function
            afterValue = curr.notation === "postfix";
            if (curr.symbol !== ")") {
                operators.push(curr);
                // Postfix always has precedence over any operator that follows after it
                if (afterValue) $4875e63af1e2f289$var$exec(operators, values);
            }
        } else if (notNumber) {
            // prefix operator or function
            operators.push(notNumber.prefix || notNumber.func);
            if (notNumber.func) {
                // Require an opening parenthesis
                match = pattern.exec(expression);
                if (!match || match[0] !== "(") throw new $4875e63af1e2f289$var$PolishedError(38, match ? match.index : expression.length, expression);
            }
        } else {
            // number
            values.push(+token);
            afterValue = true;
        }
    }while (match && operators.length);
    if (operators.length) throw new $4875e63af1e2f289$var$PolishedError(39, match ? match.index : expression.length, expression);
    else if (match) throw new $4875e63af1e2f289$var$PolishedError(40, match ? match.index : expression.length, expression);
    else return values.pop();
}
function $4875e63af1e2f289$var$reverseString(str) {
    return str.split("").reverse().join("");
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */ function $4875e63af1e2f289$export$1c891a3202c0ba6a(formula, additionalSymbols) {
    var reversedFormula = $4875e63af1e2f289$var$reverseString(formula);
    var formulaMatch = reversedFormula.match($4875e63af1e2f289$var$unitRegExp);
    // Check that all units are the same
    if (formulaMatch && !formulaMatch.every(function(unit) {
        return unit === formulaMatch[0];
    })) throw new $4875e63af1e2f289$var$PolishedError(41);
    var cleanFormula = $4875e63af1e2f289$var$reverseString(reversedFormula.replace($4875e63af1e2f289$var$unitRegExp, ""));
    return "" + $4875e63af1e2f289$var$calculate(cleanFormula, additionalSymbols) + (formulaMatch ? $4875e63af1e2f289$var$reverseString(formulaMatch[0]) : "");
}
var $4875e63af1e2f289$var$cssVariableRegex = /--[\S]*/g;
/**
 * Fetches the value of a passed CSS Variable in the :root scope, or otherwise returns a defaultValue if provided.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'background': cssVar('--background-color'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${cssVar('--background-color')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'background': 'red'
 * }
 */ function $4875e63af1e2f289$export$8b4981022bd80a4e(cssVariable, defaultValue) {
    if (!cssVariable || !cssVariable.match($4875e63af1e2f289$var$cssVariableRegex)) throw new $4875e63af1e2f289$var$PolishedError(73);
    var variableValue;
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== "undefined" && document.documentElement !== null) variableValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
    /* eslint-enable */ if (variableValue) return variableValue.trim();
    else if (defaultValue) return defaultValue;
    throw new $4875e63af1e2f289$var$PolishedError(74);
}
// @private
function $4875e63af1e2f289$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $4875e63af1e2f289$var$positionMap$1 = [
    "Top",
    "Right",
    "Bottom",
    "Left"
];
function $4875e63af1e2f289$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split("-");
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return "" + acc + $4875e63af1e2f289$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
    return property === joinedProperty ? "" + property + position : joinedProperty;
}
function $4875e63af1e2f289$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$4875e63af1e2f289$var$generateProperty(property, $4875e63af1e2f289$var$positionMap$1[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $4875e63af1e2f289$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === void 0 ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === void 0 ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === void 0 ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $4875e63af1e2f289$var$generateStyles(property, valuesWithDefaults);
}
/**
 * Check if a string ends with something
 * @private
 */ function $4875e63af1e2f289$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
var $4875e63af1e2f289$var$cssRegex$1 = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $4875e63af1e2f289$export$ef04e38dc423904(value) {
    if (typeof value !== "string") return value;
    var matchedValue = value.match($4875e63af1e2f289$var$cssRegex$1);
    return matchedValue ? parseFloat(value) : value;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $4875e63af1e2f289$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval, base) {
        if (base === void 0) base = "16px";
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === "string") {
            if (!$4875e63af1e2f289$var$endsWith(pxval, "px")) throw new $4875e63af1e2f289$var$PolishedError(69, to, pxval);
            newPxval = $4875e63af1e2f289$export$ef04e38dc423904(pxval);
        }
        if (typeof base === "string") {
            if (!$4875e63af1e2f289$var$endsWith(base, "px")) throw new $4875e63af1e2f289$var$PolishedError(70, to, base);
            newBase = $4875e63af1e2f289$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === "string") throw new $4875e63af1e2f289$var$PolishedError(71, pxval, to);
        if (typeof newBase === "string") throw new $4875e63af1e2f289$var$PolishedError(72, base, to);
        return "" + newPxval / newBase + to;
    };
};
var $4875e63af1e2f289$var$pixelsto = $4875e63af1e2f289$var$pxtoFactory;
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $4875e63af1e2f289$var$em = $4875e63af1e2f289$var$pixelsto("em");
var $4875e63af1e2f289$export$c63c6f932822f543 = $4875e63af1e2f289$var$em;
var $4875e63af1e2f289$var$cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0],
 *   '--unit': getValueAndUnit('100px')[1],
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]};
 *   --unit: ${getValueAndUnit('100px')[1]};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100,
 *   '--unit': 'px',
 * }
 */ function $4875e63af1e2f289$export$feec6b849ef388ab(value) {
    if (typeof value !== "string") return [
        value,
        ""
    ];
    var matchedValue = value.match($4875e63af1e2f289$var$cssRegex);
    if (matchedValue) return [
        parseFloat(value),
        matchedValue[2]
    ];
    return [
        value,
        undefined
    ];
}
/**
 * Helper for targeting rules in a style block generated by polished modules that need !important-level specificity. Can optionally specify a rule (or rules) to target specific rules.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...important(cover())
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${important(cover())}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute !important',
 *   'top': '0 !important',
 *   'right: '0 !important',
 *   'bottom': '0 !important',
 *   'left: '0 !important'
 * }
 */ function $4875e63af1e2f289$export$929888ab0c9f043c(styleBlock, rules) {
    if (typeof styleBlock !== "object" || styleBlock === null) throw new $4875e63af1e2f289$var$PolishedError(75, typeof styleBlock);
    var newStyleBlock = {};
    Object.keys(styleBlock).forEach(function(key) {
        if (typeof styleBlock[key] === "object" && styleBlock[key] !== null) newStyleBlock[key] = $4875e63af1e2f289$export$929888ab0c9f043c(styleBlock[key], rules);
        else if (!rules || rules && (rules === key || rules.indexOf(key) >= 0)) newStyleBlock[key] = styleBlock[key] + " !important";
        else newStyleBlock[key] = styleBlock[key];
    });
    return newStyleBlock;
}
var $4875e63af1e2f289$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $4875e63af1e2f289$var$getRatio(ratioName) {
    return $4875e63af1e2f289$var$ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing an em or rem value up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */ function $4875e63af1e2f289$export$c82a8a23c9e8bdb6(steps, base, ratio) {
    if (base === void 0) base = "1em";
    if (ratio === void 0) ratio = 1.333;
    if (typeof steps !== "number") throw new $4875e63af1e2f289$var$PolishedError(42);
    if (typeof ratio === "string" && !$4875e63af1e2f289$var$ratioNames[ratio]) throw new $4875e63af1e2f289$var$PolishedError(43);
    var _ref = typeof base === "string" ? $4875e63af1e2f289$export$feec6b849ef388ab(base) : [
        base,
        ""
    ], realBase = _ref[0], unit = _ref[1];
    var realRatio = typeof ratio === "string" ? $4875e63af1e2f289$var$getRatio(ratio) : ratio;
    if (typeof realBase === "string") throw new $4875e63af1e2f289$var$PolishedError(44, base);
    return "" + realBase * Math.pow(realRatio, steps) + (unit || "");
}
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $4875e63af1e2f289$var$rem = $4875e63af1e2f289$var$pixelsto("rem");
var $4875e63af1e2f289$export$fb1897a40d146f7f = $4875e63af1e2f289$var$rem;
var $4875e63af1e2f289$var$defaultFontSize = 16;
function $4875e63af1e2f289$var$convertBase(base) {
    var deconstructedValue = $4875e63af1e2f289$export$feec6b849ef388ab(base);
    if (deconstructedValue[1] === "px") return parseFloat(base);
    if (deconstructedValue[1] === "%") return parseFloat(base) / 100 * $4875e63af1e2f289$var$defaultFontSize;
    throw new $4875e63af1e2f289$var$PolishedError(78, deconstructedValue[1]);
}
function $4875e63af1e2f289$var$getBaseFromDoc() {
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== "undefined" && document.documentElement !== null) {
        var rootFontSize = getComputedStyle(document.documentElement).fontSize;
        return rootFontSize ? $4875e63af1e2f289$var$convertBase(rootFontSize) : $4875e63af1e2f289$var$defaultFontSize;
    }
    /* eslint-enable */ /* istanbul ignore next */ return $4875e63af1e2f289$var$defaultFontSize;
}
/**
 * Convert rem values to px. By default, the base value is pulled from the font-size property on the root element (if it is set in % or px). It defaults to 16px if not found on the root. You can also override the base value by providing your own base in % or px.
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': remToPx('1.6rem')
 *   'height': remToPx('1.6rem', '10px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${remToPx('1.6rem')}
 *   height: ${remToPx('1.6rem', '10px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '25.6px',
 *   'height': '16px',
 * }
 */ function $4875e63af1e2f289$export$7e5d3caf0359a67a(value, base) {
    var deconstructedValue = $4875e63af1e2f289$export$feec6b849ef388ab(value);
    if (deconstructedValue[1] !== "rem" && deconstructedValue[1] !== "") throw new $4875e63af1e2f289$var$PolishedError(77, deconstructedValue[1]);
    var newBase = base ? $4875e63af1e2f289$var$convertBase(base) : $4875e63af1e2f289$var$getBaseFromDoc();
    return deconstructedValue[0] * newBase + "px";
}
var $4875e63af1e2f289$var$functionsMap$3 = {
    back: "cubic-bezier(0.600, -0.280, 0.735, 0.045)",
    circ: "cubic-bezier(0.600,  0.040, 0.980, 0.335)",
    cubic: "cubic-bezier(0.550,  0.055, 0.675, 0.190)",
    expo: "cubic-bezier(0.950,  0.050, 0.795, 0.035)",
    quad: "cubic-bezier(0.550,  0.085, 0.680, 0.530)",
    quart: "cubic-bezier(0.895,  0.030, 0.685, 0.220)",
    quint: "cubic-bezier(0.755,  0.050, 0.855, 0.060)",
    sine: "cubic-bezier(0.470,  0.000, 0.745, 0.715)"
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeIn('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeIn('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $4875e63af1e2f289$export$929e5a82286172a6(functionName) {
    return $4875e63af1e2f289$var$functionsMap$3[functionName.toLowerCase().trim()];
}
var $4875e63af1e2f289$var$functionsMap$2 = {
    back: "cubic-bezier(0.680, -0.550, 0.265, 1.550)",
    circ: "cubic-bezier(0.785,  0.135, 0.150, 0.860)",
    cubic: "cubic-bezier(0.645,  0.045, 0.355, 1.000)",
    expo: "cubic-bezier(1.000,  0.000, 0.000, 1.000)",
    quad: "cubic-bezier(0.455,  0.030, 0.515, 0.955)",
    quart: "cubic-bezier(0.770,  0.000, 0.175, 1.000)",
    quint: "cubic-bezier(0.860,  0.000, 0.070, 1.000)",
    sine: "cubic-bezier(0.445,  0.050, 0.550, 0.950)"
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeInOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeInOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
 * }
 */ function $4875e63af1e2f289$export$c07234257a03d5e9(functionName) {
    return $4875e63af1e2f289$var$functionsMap$2[functionName.toLowerCase().trim()];
}
var $4875e63af1e2f289$var$functionsMap$1 = {
    back: "cubic-bezier(0.175,  0.885, 0.320, 1.275)",
    cubic: "cubic-bezier(0.215,  0.610, 0.355, 1.000)",
    circ: "cubic-bezier(0.075,  0.820, 0.165, 1.000)",
    expo: "cubic-bezier(0.190,  1.000, 0.220, 1.000)",
    quad: "cubic-bezier(0.250,  0.460, 0.450, 0.940)",
    quart: "cubic-bezier(0.165,  0.840, 0.440, 1.000)",
    quint: "cubic-bezier(0.230,  1.000, 0.320, 1.000)",
    sine: "cubic-bezier(0.390,  0.575, 0.565, 1.000)"
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
 * }
 */ function $4875e63af1e2f289$export$57636bb43b1ccbb0(functionName) {
    return $4875e63af1e2f289$var$functionsMap$1[functionName.toLowerCase().trim()];
}
/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */ function $4875e63af1e2f289$export$cf95c51b03f10bae(fromSize, toSize, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = "320px";
    if (maxScreen === void 0) maxScreen = "1200px";
    var _getValueAndUnit = $4875e63af1e2f289$export$feec6b849ef388ab(fromSize), unitlessFromSize = _getValueAndUnit[0], fromSizeUnit = _getValueAndUnit[1];
    var _getValueAndUnit2 = $4875e63af1e2f289$export$feec6b849ef388ab(toSize), unitlessToSize = _getValueAndUnit2[0], toSizeUnit = _getValueAndUnit2[1];
    var _getValueAndUnit3 = $4875e63af1e2f289$export$feec6b849ef388ab(minScreen), unitlessMinScreen = _getValueAndUnit3[0], minScreenUnit = _getValueAndUnit3[1];
    var _getValueAndUnit4 = $4875e63af1e2f289$export$feec6b849ef388ab(maxScreen), unitlessMaxScreen = _getValueAndUnit4[0], maxScreenUnit = _getValueAndUnit4[1];
    if (typeof unitlessMinScreen !== "number" || typeof unitlessMaxScreen !== "number" || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) throw new $4875e63af1e2f289$var$PolishedError(47);
    if (typeof unitlessFromSize !== "number" || typeof unitlessToSize !== "number" || fromSizeUnit !== toSizeUnit) throw new $4875e63af1e2f289$var$PolishedError(48);
    if (fromSizeUnit !== minScreenUnit || toSizeUnit !== maxScreenUnit) throw new $4875e63af1e2f289$var$PolishedError(76);
    var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
    var base = unitlessToSize - slope * unitlessMaxScreen;
    return "calc(" + base.toFixed(2) + (fromSizeUnit || "") + " + " + (100 * slope).toFixed(2) + "vw)";
}
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $4875e63af1e2f289$export$8c467e8859fdef13(parent) {
    var _ref;
    if (parent === void 0) parent = "&";
    var pseudoSelector = parent + "::after";
    return _ref = {}, _ref[pseudoSelector] = {
        clear: "both",
        content: '""',
        display: "table"
    }, _ref;
}
/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */ function $4875e63af1e2f289$export$4bdbf921f0c0fd8c(offset) {
    if (offset === void 0) offset = 0;
    return {
        position: "absolute",
        top: offset,
        right: offset,
        bottom: offset,
        left: offset
    };
}
/**
 * CSS to represent truncated text with an ellipsis. You can optionally pass a max-width and number of lines before truncating.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $4875e63af1e2f289$export$a5b94313d6908893(width, lines) {
    if (lines === void 0) lines = 1;
    var styles = {
        display: "inline-block",
        maxWidth: width || "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        wordWrap: "normal"
    };
    return lines > 1 ? (0, $4WYaH.default)({}, styles, {
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: lines,
        display: "-webkit-box",
        whiteSpace: "normal"
    }) : styles;
}
function $4875e63af1e2f289$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $4875e63af1e2f289$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4875e63af1e2f289$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4875e63af1e2f289$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4875e63af1e2f289$var$_arrayLikeToArray(o, minLen);
}
function $4875e63af1e2f289$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */ function $4875e63af1e2f289$export$de4c2ac00f6121cf(cssProp, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = "320px";
    if (maxScreen === void 0) maxScreen = "1200px";
    if (!Array.isArray(cssProp) && typeof cssProp !== "object" || cssProp === null) throw new $4875e63af1e2f289$var$PolishedError(49);
    if (Array.isArray(cssProp)) {
        var mediaQueries = {};
        var fallbacks = {};
        for(var _iterator = $4875e63af1e2f289$var$_createForOfIteratorHelperLoose(cssProp), _step; !(_step = _iterator()).done;){
            var _extends2, _extends3;
            var obj = _step.value;
            if (!obj.prop || !obj.fromSize || !obj.toSize) throw new $4875e63af1e2f289$var$PolishedError(50);
            fallbacks[obj.prop] = obj.fromSize;
            mediaQueries["@media (min-width: " + minScreen + ")"] = (0, $4WYaH.default)({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = $4875e63af1e2f289$export$cf95c51b03f10bae(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
            mediaQueries["@media (min-width: " + maxScreen + ")"] = (0, $4WYaH.default)({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
        }
        return (0, $4WYaH.default)({}, fallbacks, mediaQueries);
    } else {
        var _ref, _ref2, _ref3;
        if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) throw new $4875e63af1e2f289$var$PolishedError(51);
        return _ref3 = {}, _ref3[cssProp.prop] = cssProp.fromSize, _ref3["@media (min-width: " + minScreen + ")"] = (_ref = {}, _ref[cssProp.prop] = $4875e63af1e2f289$export$cf95c51b03f10bae(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref), _ref3["@media (min-width: " + maxScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = cssProp.toSize, _ref2), _ref3;
    }
}
var $4875e63af1e2f289$var$dataURIRegex = /^\s*data:([a-z]+\/[a-z-]+(;[a-z-]+=[a-z-]+)?)?(;charset=[a-z0-9-]+)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
var $4875e63af1e2f289$var$formatHintMap = {
    woff: "woff",
    woff2: "woff2",
    ttf: "truetype",
    otf: "opentype",
    eot: "embedded-opentype",
    svg: "svg",
    svgz: "svg"
};
function $4875e63af1e2f289$var$generateFormatHint(format, formatHint) {
    if (!formatHint) return "";
    return ' format("' + $4875e63af1e2f289$var$formatHintMap[format] + '")';
}
function $4875e63af1e2f289$var$isDataURI(fontFilePath) {
    return !!fontFilePath.replace(/\s+/g, " ").match($4875e63af1e2f289$var$dataURIRegex);
}
function $4875e63af1e2f289$var$generateFileReferences(fontFilePath, fileFormats, formatHint) {
    if ($4875e63af1e2f289$var$isDataURI(fontFilePath)) return 'url("' + fontFilePath + '")' + $4875e63af1e2f289$var$generateFormatHint(fileFormats[0], formatHint);
    var fileFontReferences = fileFormats.map(function(format) {
        return 'url("' + fontFilePath + "." + format + '")' + $4875e63af1e2f289$var$generateFormatHint(format, formatHint);
    });
    return fileFontReferences.join(", ");
}
function $4875e63af1e2f289$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return 'local("' + font + '")';
    });
    return localFontReferences.join(", ");
}
function $4875e63af1e2f289$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($4875e63af1e2f289$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($4875e63af1e2f289$var$generateFileReferences(fontFilePath, fileFormats, formatHint));
    return fontReferences.join(", ");
}
/**
 * CSS for a @font-face declaration. Defaults to check for local copies of the font on the user's machine. You can disable this by passing `null` to localFonts.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $4875e63af1e2f289$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === void 0 ? [
        "eot",
        "woff2",
        "woff",
        "ttf",
        "svg"
    ] : _ref$fileFormats, _ref$formatHint = _ref.formatHint, formatHint = _ref$formatHint === void 0 ? false : _ref$formatHint, _ref$localFonts = _ref.localFonts, localFonts = _ref$localFonts === void 0 ? [
        fontFamily
    ] : _ref$localFonts, unicodeRange = _ref.unicodeRange, fontDisplay = _ref.fontDisplay, fontVariationSettings = _ref.fontVariationSettings, fontFeatureSettings = _ref.fontFeatureSettings;
    // Error Handling
    if (!fontFamily) throw new $4875e63af1e2f289$var$PolishedError(55);
    if (!fontFilePath && !localFonts) throw new $4875e63af1e2f289$var$PolishedError(52);
    if (localFonts && !Array.isArray(localFonts)) throw new $4875e63af1e2f289$var$PolishedError(53);
    if (!Array.isArray(fileFormats)) throw new $4875e63af1e2f289$var$PolishedError(54);
    var fontFaceDeclaration = {
        "@font-face": {
            fontFamily: fontFamily,
            src: $4875e63af1e2f289$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight,
            fontDisplay: fontDisplay,
            fontVariationSettings: fontVariationSettings,
            fontFeatureSettings: fontFeatureSettings
        }
    };
    // Removes undefined fields for cleaner css object.
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $4875e63af1e2f289$export$27bef6389954e24d() {
    return {
        textIndent: "101%",
        overflow: "hidden",
        whiteSpace: "nowrap"
    };
}
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $4875e63af1e2f289$export$36e2157ae4e3cbdd() {
    return {
        border: "0",
        clip: "rect(0 0 0 0)",
        height: "1px",
        margin: "-1px",
        overflow: "hidden",
        padding: "0",
        position: "absolute",
        whiteSpace: "nowrap",
        width: "1px"
    };
}
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $4875e63af1e2f289$export$e79006618d7c6cc3(ratio) {
    if (ratio === void 0) ratio = 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
function $4875e63af1e2f289$var$constructGradientValue(literals) {
    var template = "";
    for(var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)substitutions[_key - 1] = arguments[_key];
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i];
        if (i === substitutions.length - 1 && substitutions[i]) {
            var definedValues = substitutions.filter(function(substitute) {
                return !!substitute;
            });
            // Adds leading coma if properties preceed color-stops
            if (definedValues.length > 1) {
                template = template.slice(0, -1);
                template += ", " + substitutions[i];
            // No trailing space if color-stops is the only param provided
            } else if (definedValues.length === 1) template += "" + substitutions[i];
        } else if (substitutions[i]) template += substitutions[i] + " ";
    }
    return template.trim();
}
var $4875e63af1e2f289$var$_templateObject$1;
/**
 * CSS for declaring a linear gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#FFF',
 *   'backgroundImage': 'linear-gradient(to top right, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $4875e63af1e2f289$export$46def8197cf4dd4c(_ref) {
    var colorStops = _ref.colorStops, fallback = _ref.fallback, _ref$toDirection = _ref.toDirection, toDirection = _ref$toDirection === void 0 ? "" : _ref$toDirection;
    if (!colorStops || colorStops.length < 2) throw new $4875e63af1e2f289$var$PolishedError(56);
    return {
        backgroundColor: fallback || colorStops[0].replace(/,\s+/g, ",").split(" ")[0].replace(/,(?=\S)/g, ", "),
        backgroundImage: $4875e63af1e2f289$var$constructGradientValue($4875e63af1e2f289$var$_templateObject$1 || ($4875e63af1e2f289$var$_templateObject$1 = (0, $lSN3y.default)([
            "linear-gradient(",
            "",
            ")"
        ])), toDirection, colorStops.join(", ").replace(/,(?=\S)/g, ", "))
    };
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $4875e63af1e2f289$export$a3295358bff77e() {
    var _ref;
    return [
        (_ref = {
            html: {
                lineHeight: "1.15",
                textSizeAdjust: "100%"
            },
            body: {
                margin: "0"
            },
            main: {
                display: "block"
            },
            h1: {
                fontSize: "2em",
                margin: "0.67em 0"
            },
            hr: {
                boxSizing: "content-box",
                height: "0",
                overflow: "visible"
            },
            pre: {
                fontFamily: "monospace, monospace",
                fontSize: "1em"
            },
            a: {
                backgroundColor: "transparent"
            },
            "abbr[title]": {
                borderBottom: "none",
                textDecoration: "underline"
            }
        }, _ref["b,\n    strong"] = {
            fontWeight: "bolder"
        }, _ref["code,\n    kbd,\n    samp"] = {
            fontFamily: "monospace, monospace",
            fontSize: "1em"
        }, _ref.small = {
            fontSize: "80%"
        }, _ref["sub,\n    sup"] = {
            fontSize: "75%",
            lineHeight: "0",
            position: "relative",
            verticalAlign: "baseline"
        }, _ref.sub = {
            bottom: "-0.25em"
        }, _ref.sup = {
            top: "-0.5em"
        }, _ref.img = {
            borderStyle: "none"
        }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
            fontFamily: "inherit",
            fontSize: "100%",
            lineHeight: "1.15",
            margin: "0"
        }, _ref["button,\n    input"] = {
            overflow: "visible"
        }, _ref["button,\n    select"] = {
            textTransform: "none"
        }, _ref['button,\n    html [type="button"],\n    [type="reset"],\n    [type="submit"]'] = {
            WebkitAppearance: "button"
        }, _ref['button::-moz-focus-inner,\n    [type="button"]::-moz-focus-inner,\n    [type="reset"]::-moz-focus-inner,\n    [type="submit"]::-moz-focus-inner'] = {
            borderStyle: "none",
            padding: "0"
        }, _ref['button:-moz-focusring,\n    [type="button"]:-moz-focusring,\n    [type="reset"]:-moz-focusring,\n    [type="submit"]:-moz-focusring'] = {
            outline: "1px dotted ButtonText"
        }, _ref.fieldset = {
            padding: "0.35em 0.625em 0.75em"
        }, _ref.legend = {
            boxSizing: "border-box",
            color: "inherit",
            display: "table",
            maxWidth: "100%",
            padding: "0",
            whiteSpace: "normal"
        }, _ref.progress = {
            verticalAlign: "baseline"
        }, _ref.textarea = {
            overflow: "auto"
        }, _ref['[type="checkbox"],\n    [type="radio"]'] = {
            boxSizing: "border-box",
            padding: "0"
        }, _ref['[type="number"]::-webkit-inner-spin-button,\n    [type="number"]::-webkit-outer-spin-button'] = {
            height: "auto"
        }, _ref['[type="search"]'] = {
            WebkitAppearance: "textfield",
            outlineOffset: "-2px"
        }, _ref['[type="search"]::-webkit-search-decoration'] = {
            WebkitAppearance: "none"
        }, _ref["::-webkit-file-upload-button"] = {
            WebkitAppearance: "button",
            font: "inherit"
        }, _ref.details = {
            display: "block"
        }, _ref.summary = {
            display: "list-item"
        }, _ref.template = {
            display: "none"
        }, _ref["[hidden]"] = {
            display: "none"
        }, _ref),
        {
            "abbr[title]": {
                textDecoration: "underline dotted"
            }
        }
    ];
}
var $4875e63af1e2f289$var$_templateObject;
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $4875e63af1e2f289$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, _ref$extent = _ref.extent, extent = _ref$extent === void 0 ? "" : _ref$extent, fallback = _ref.fallback, _ref$position = _ref.position, position = _ref$position === void 0 ? "" : _ref$position, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? "" : _ref$shape;
    if (!colorStops || colorStops.length < 2) throw new $4875e63af1e2f289$var$PolishedError(57);
    return {
        backgroundColor: fallback || colorStops[0].split(" ")[0],
        backgroundImage: $4875e63af1e2f289$var$constructGradientValue($4875e63af1e2f289$var$_templateObject || ($4875e63af1e2f289$var$_templateObject = (0, $lSN3y.default)([
            "radial-gradient(",
            "",
            "",
            "",
            ")"
        ])), position, shape, extent, colorStops.join(", "))
    };
}
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $4875e63af1e2f289$export$19389033401d366a(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
    var _ref;
    if (extension === void 0) extension = "png";
    if (retinaSuffix === void 0) retinaSuffix = "_2x";
    if (!filename) throw new $4875e63af1e2f289$var$PolishedError(58);
    // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, "");
    var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
    return _ref = {
        backgroundImage: "url(" + filename + "." + ext + ")"
    }, _ref[$4875e63af1e2f289$export$e79006618d7c6cc3()] = (0, $4WYaH.default)({
        backgroundImage: "url(" + rFilename + ")"
    }, backgroundSize ? {
        backgroundSize: backgroundSize
    } : {}), _ref;
}
/* eslint-disable key-spacing */ var $4875e63af1e2f289$var$functionsMap = {
    easeInBack: "cubic-bezier(0.600, -0.280, 0.735, 0.045)",
    easeInCirc: "cubic-bezier(0.600,  0.040, 0.980, 0.335)",
    easeInCubic: "cubic-bezier(0.550,  0.055, 0.675, 0.190)",
    easeInExpo: "cubic-bezier(0.950,  0.050, 0.795, 0.035)",
    easeInQuad: "cubic-bezier(0.550,  0.085, 0.680, 0.530)",
    easeInQuart: "cubic-bezier(0.895,  0.030, 0.685, 0.220)",
    easeInQuint: "cubic-bezier(0.755,  0.050, 0.855, 0.060)",
    easeInSine: "cubic-bezier(0.470,  0.000, 0.745, 0.715)",
    easeOutBack: "cubic-bezier(0.175,  0.885, 0.320, 1.275)",
    easeOutCubic: "cubic-bezier(0.215,  0.610, 0.355, 1.000)",
    easeOutCirc: "cubic-bezier(0.075,  0.820, 0.165, 1.000)",
    easeOutExpo: "cubic-bezier(0.190,  1.000, 0.220, 1.000)",
    easeOutQuad: "cubic-bezier(0.250,  0.460, 0.450, 0.940)",
    easeOutQuart: "cubic-bezier(0.165,  0.840, 0.440, 1.000)",
    easeOutQuint: "cubic-bezier(0.230,  1.000, 0.320, 1.000)",
    easeOutSine: "cubic-bezier(0.390,  0.575, 0.565, 1.000)",
    easeInOutBack: "cubic-bezier(0.680, -0.550, 0.265, 1.550)",
    easeInOutCirc: "cubic-bezier(0.785,  0.135, 0.150, 0.860)",
    easeInOutCubic: "cubic-bezier(0.645,  0.045, 0.355, 1.000)",
    easeInOutExpo: "cubic-bezier(1.000,  0.000, 0.000, 1.000)",
    easeInOutQuad: "cubic-bezier(0.455,  0.030, 0.515, 0.955)",
    easeInOutQuart: "cubic-bezier(0.770,  0.000, 0.175, 1.000)",
    easeInOutQuint: "cubic-bezier(0.860,  0.000, 0.070, 1.000)",
    easeInOutSine: "cubic-bezier(0.445,  0.050, 0.550, 0.950)"
};
/* eslint-enable key-spacing */ function $4875e63af1e2f289$var$getTimingFunction(functionName) {
    return $4875e63af1e2f289$var$functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @deprecated - This will be deprecated in v5 in favor of `easeIn`, `easeOut`, `easeInOut`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $4875e63af1e2f289$export$61210fa83792a81(timingFunction) {
    return $4875e63af1e2f289$var$getTimingFunction(timingFunction);
}
var $4875e63af1e2f289$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    var fullWidth = "" + width[0] + (width[1] || "");
    var halfWidth = "" + width[0] / 2 + (width[1] || "");
    var fullHeight = "" + height[0] + (height[1] || "");
    var halfHeight = "" + height[0] / 2 + (height[1] || "");
    switch(pointingDirection){
        case "top":
            return "0 " + halfWidth + " " + fullHeight + " " + halfWidth;
        case "topLeft":
            return fullWidth + " " + fullHeight + " 0 0";
        case "left":
            return halfHeight + " " + fullWidth + " " + halfHeight + " 0";
        case "bottomLeft":
            return fullWidth + " 0 0 " + fullHeight;
        case "bottom":
            return fullHeight + " " + halfWidth + " 0 " + halfWidth;
        case "bottomRight":
            return "0 0 " + fullWidth + " " + fullHeight;
        case "right":
            return halfHeight + " 0 " + halfHeight + " " + fullWidth;
        case "topRight":
        default:
            return "0 " + fullWidth + " " + fullHeight + " 0";
    }
};
var $4875e63af1e2f289$var$getBorderColor = function getBorderColor(pointingDirection, foregroundColor) {
    switch(pointingDirection){
        case "top":
        case "bottomRight":
            return {
                borderBottomColor: foregroundColor
            };
        case "right":
        case "bottomLeft":
            return {
                borderLeftColor: foregroundColor
            };
        case "bottom":
        case "topLeft":
            return {
                borderTopColor: foregroundColor
            };
        case "left":
        case "topRight":
            return {
                borderRightColor: foregroundColor
            };
        default:
            throw new $4875e63af1e2f289$var$PolishedError(59);
    }
};
/**
 * CSS to represent triangle with any pointing direction with an optional background color.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent transparent transparent red',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */ function $4875e63af1e2f289$export$9eed783d03e0135c(_ref) {
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? "transparent" : _ref$backgroundColor;
    var widthAndUnit = $4875e63af1e2f289$export$feec6b849ef388ab(width);
    var heightAndUnit = $4875e63af1e2f289$export$feec6b849ef388ab(height);
    if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) throw new $4875e63af1e2f289$var$PolishedError(60);
    return (0, $4WYaH.default)({
        width: "0",
        height: "0",
        borderColor: backgroundColor
    }, $4875e63af1e2f289$var$getBorderColor(pointingDirection, foregroundColor), {
        borderStyle: "solid",
        borderWidth: $4875e63af1e2f289$var$getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit)
    });
}
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $4875e63af1e2f289$export$dca3d8ad656c34d2(wrap) {
    if (wrap === void 0) wrap = "break-word";
    var wordBreak = wrap === "break-word" ? "break-all" : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
function $4875e63af1e2f289$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $4875e63af1e2f289$var$convertToInt(red, green, blue) {
    return $4875e63af1e2f289$var$colorToInt(red) + "," + $4875e63af1e2f289$var$colorToInt(green) + "," + $4875e63af1e2f289$var$colorToInt(blue);
}
function $4875e63af1e2f289$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $4875e63af1e2f289$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = (hue % 360 + 360) % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $4875e63af1e2f289$var$namedColorMap = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "00ffff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "0000ff",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "00ffff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "ff00ff",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "639",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */ function $4875e63af1e2f289$var$nameToHex(color) {
    if (typeof color !== "string") return color;
    var normalizedColorName = color.toLowerCase();
    return $4875e63af1e2f289$var$namedColorMap[normalizedColorName] ? "#" + $4875e63af1e2f289$var$namedColorMap[normalizedColorName] : color;
}
var $4875e63af1e2f289$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $4875e63af1e2f289$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $4875e63af1e2f289$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $4875e63af1e2f289$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $4875e63af1e2f289$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var $4875e63af1e2f289$var$rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var $4875e63af1e2f289$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var $4875e63af1e2f289$var$hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $4875e63af1e2f289$export$2f48baff6995707a(color) {
    if (typeof color !== "string") throw new $4875e63af1e2f289$var$PolishedError(3);
    var normalizedColor = $4875e63af1e2f289$var$nameToHex(color);
    if (normalizedColor.match($4875e63af1e2f289$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($4875e63af1e2f289$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($4875e63af1e2f289$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($4875e63af1e2f289$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $4875e63af1e2f289$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $4875e63af1e2f289$var$rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $4875e63af1e2f289$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $4875e63af1e2f289$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $4875e63af1e2f289$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new $4875e63af1e2f289$var$PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $4875e63af1e2f289$var$hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $4875e63af1e2f289$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $4875e63af1e2f289$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new $4875e63af1e2f289$var$PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
        };
    }
    throw new $4875e63af1e2f289$var$PolishedError(5);
}
function $4875e63af1e2f289$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */ function $4875e63af1e2f289$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $4875e63af1e2f289$var$rgbToHsl($4875e63af1e2f289$export$2f48baff6995707a(color));
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $4875e63af1e2f289$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
var $4875e63af1e2f289$var$reduceHexValue$1 = $4875e63af1e2f289$var$reduceHexValue;
function $4875e63af1e2f289$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function $4875e63af1e2f289$var$colorToHex(color) {
    return $4875e63af1e2f289$var$numberToHex(Math.round(color * 255));
}
function $4875e63af1e2f289$var$convertToHex(red, green, blue) {
    return $4875e63af1e2f289$var$reduceHexValue$1("#" + $4875e63af1e2f289$var$colorToHex(red) + $4875e63af1e2f289$var$colorToHex(green) + $4875e63af1e2f289$var$colorToHex(blue));
}
function $4875e63af1e2f289$var$hslToHex(hue, saturation, lightness) {
    return $4875e63af1e2f289$var$hslToRgb(hue, saturation, lightness, $4875e63af1e2f289$var$convertToHex);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $4875e63af1e2f289$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === "number" && typeof saturation === "number" && typeof lightness === "number") return $4875e63af1e2f289$var$hslToHex(value, saturation, lightness);
    else if (typeof value === "object" && saturation === undefined && lightness === undefined) return $4875e63af1e2f289$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new $4875e63af1e2f289$var$PolishedError(1);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $4875e63af1e2f289$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === "number" && typeof saturation === "number" && typeof lightness === "number" && typeof alpha === "number") return alpha >= 1 ? $4875e63af1e2f289$var$hslToHex(value, saturation, lightness) : "rgba(" + $4875e63af1e2f289$var$hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    else if (typeof value === "object" && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $4875e63af1e2f289$var$hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + $4875e63af1e2f289$var$hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new $4875e63af1e2f289$var$PolishedError(2);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $4875e63af1e2f289$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === "number" && typeof green === "number" && typeof blue === "number") return $4875e63af1e2f289$var$reduceHexValue$1("#" + $4875e63af1e2f289$var$numberToHex(value) + $4875e63af1e2f289$var$numberToHex(green) + $4875e63af1e2f289$var$numberToHex(blue));
    else if (typeof value === "object" && green === undefined && blue === undefined) return $4875e63af1e2f289$var$reduceHexValue$1("#" + $4875e63af1e2f289$var$numberToHex(value.red) + $4875e63af1e2f289$var$numberToHex(value.green) + $4875e63af1e2f289$var$numberToHex(value.blue));
    throw new $4875e63af1e2f289$var$PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $4875e63af1e2f289$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === "string" && typeof secondValue === "number") {
        var rgbValue = $4875e63af1e2f289$export$2f48baff6995707a(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === "number" && typeof secondValue === "number" && typeof thirdValue === "number" && typeof fourthValue === "number") return fourthValue >= 1 ? $4875e63af1e2f289$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === "object" && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $4875e63af1e2f289$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new $4875e63af1e2f289$var$PolishedError(7);
}
var $4875e63af1e2f289$var$isRgb = function isRgb(color) {
    return typeof color.red === "number" && typeof color.green === "number" && typeof color.blue === "number" && (typeof color.alpha !== "number" || typeof color.alpha === "undefined");
};
var $4875e63af1e2f289$var$isRgba = function isRgba(color) {
    return typeof color.red === "number" && typeof color.green === "number" && typeof color.blue === "number" && typeof color.alpha === "number";
};
var $4875e63af1e2f289$var$isHsl = function isHsl(color) {
    return typeof color.hue === "number" && typeof color.saturation === "number" && typeof color.lightness === "number" && (typeof color.alpha !== "number" || typeof color.alpha === "undefined");
};
var $4875e63af1e2f289$var$isHsla = function isHsla(color) {
    return typeof color.hue === "number" && typeof color.saturation === "number" && typeof color.lightness === "number" && typeof color.alpha === "number";
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $4875e63af1e2f289$export$42fe740cdf79b2df(color) {
    if (typeof color !== "object") throw new $4875e63af1e2f289$var$PolishedError(8);
    if ($4875e63af1e2f289$var$isRgba(color)) return $4875e63af1e2f289$export$4e46ac54fc82cf3b(color);
    if ($4875e63af1e2f289$var$isRgb(color)) return $4875e63af1e2f289$export$8972dc0e6ad9238f(color);
    if ($4875e63af1e2f289$var$isHsla(color)) return $4875e63af1e2f289$export$810b04175080204c(color);
    if ($4875e63af1e2f289$var$isHsl(color)) return $4875e63af1e2f289$export$8f4a7c0bb78e6ea8(color);
    throw new $4875e63af1e2f289$var$PolishedError(8);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $4875e63af1e2f289$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $4875e63af1e2f289$var$curried(f, length, combined);
    };
}
// eslint-disable-next-line no-redeclare
function $4875e63af1e2f289$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $4875e63af1e2f289$var$curried(f, f.length, []);
}
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $4875e63af1e2f289$var$adjustHue(degree, color) {
    if (color === "transparent") return color;
    var hslColor = $4875e63af1e2f289$export$1286688e1b3fde9c(color);
    return $4875e63af1e2f289$export$42fe740cdf79b2df((0, $4WYaH.default)({}, hslColor, {
        hue: hslColor.hue + parseFloat(degree)
    }));
}
// prettier-ignore
var $4875e63af1e2f289$var$curriedAdjustHue = $4875e63af1e2f289$var$curry /* ::<number | string, string, string> */ ($4875e63af1e2f289$var$adjustHue);
var $4875e63af1e2f289$export$2b372a09365374d6 = $4875e63af1e2f289$var$curriedAdjustHue;
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $4875e63af1e2f289$export$bd4f6f7e1823bc9e(color) {
    if (color === "transparent") return color;
    var hslColor = $4875e63af1e2f289$export$1286688e1b3fde9c(color);
    return $4875e63af1e2f289$export$42fe740cdf79b2df((0, $4WYaH.default)({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
function $4875e63af1e2f289$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $4875e63af1e2f289$var$darken(amount, color) {
    if (color === "transparent") return color;
    var hslColor = $4875e63af1e2f289$export$1286688e1b3fde9c(color);
    return $4875e63af1e2f289$export$42fe740cdf79b2df((0, $4WYaH.default)({}, hslColor, {
        lightness: $4875e63af1e2f289$var$guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
}
// prettier-ignore
var $4875e63af1e2f289$var$curriedDarken = $4875e63af1e2f289$var$curry /* ::<number | string, string, string> */ ($4875e63af1e2f289$var$darken);
var $4875e63af1e2f289$export$4b073707ff63303 = $4875e63af1e2f289$var$curriedDarken;
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $4875e63af1e2f289$var$desaturate(amount, color) {
    if (color === "transparent") return color;
    var hslColor = $4875e63af1e2f289$export$1286688e1b3fde9c(color);
    return $4875e63af1e2f289$export$42fe740cdf79b2df((0, $4WYaH.default)({}, hslColor, {
        saturation: $4875e63af1e2f289$var$guard(0, 1, hslColor.saturation - parseFloat(amount))
    }));
}
// prettier-ignore
var $4875e63af1e2f289$var$curriedDesaturate = $4875e63af1e2f289$var$curry /* ::<number | string, string, string> */ ($4875e63af1e2f289$var$desaturate);
var $4875e63af1e2f289$export$fb75607d98509d9 = $4875e63af1e2f289$var$curriedDesaturate;
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $4875e63af1e2f289$export$c852d90bf7403b62(color) {
    if (color === "transparent") return 0;
    var rgbColor = $4875e63af1e2f289$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 *
 * @example
 * const contrastRatio = getContrast('#444', '#fff');
 */ function $4875e63af1e2f289$export$850ce485a60d103b(color1, color2) {
    var luminance1 = $4875e63af1e2f289$export$c852d90bf7403b62(color1);
    var luminance2 = $4875e63af1e2f289$export$c852d90bf7403b62(color2);
    return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
}
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $4875e63af1e2f289$export$6f416a6db2dfcd5c(color) {
    if (color === "transparent") return color;
    return $4875e63af1e2f289$export$42fe740cdf79b2df((0, $4WYaH.default)({}, $4875e63af1e2f289$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
/**
 * Converts a HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $4875e63af1e2f289$export$97fc773b219a4ae(color) {
    if (typeof color === "object" && typeof color.hue === "number" && typeof color.saturation === "number" && typeof color.lightness === "number") {
        if (color.alpha && typeof color.alpha === "number") return $4875e63af1e2f289$export$810b04175080204c({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness,
            alpha: color.alpha
        });
        return $4875e63af1e2f289$export$8f4a7c0bb78e6ea8({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness
        });
    }
    throw new $4875e63af1e2f289$var$PolishedError(45);
}
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $4875e63af1e2f289$export$6897c284b6f9f4dc(color) {
    if (color === "transparent") return color;
    // parse color string to rgb
    var value = $4875e63af1e2f289$export$2f48baff6995707a(color);
    return $4875e63af1e2f289$export$42fe740cdf79b2df((0, $4WYaH.default)({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $4875e63af1e2f289$var$lighten(amount, color) {
    if (color === "transparent") return color;
    var hslColor = $4875e63af1e2f289$export$1286688e1b3fde9c(color);
    return $4875e63af1e2f289$export$42fe740cdf79b2df((0, $4WYaH.default)({}, hslColor, {
        lightness: $4875e63af1e2f289$var$guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
}
// prettier-ignore
var $4875e63af1e2f289$var$curriedLighten = $4875e63af1e2f289$var$curry /* ::<number | string, string, string> */ ($4875e63af1e2f289$var$lighten);
var $4875e63af1e2f289$export$c0816ed86df316af = $4875e63af1e2f289$var$curriedLighten;
/**
 * Determines which contrast guidelines have been met for two colors.
 * Based on the [contrast calculations recommended by W3](https://www.w3.org/WAI/WCAG21/Understanding/contrast-enhanced.html).
 *
 * @example
 * const scores = meetsContrastGuidelines('#444', '#fff');
 */ function $4875e63af1e2f289$export$bc0d548020bc5a2(color1, color2) {
    var contrastRatio = $4875e63af1e2f289$export$850ce485a60d103b(color1, color2);
    return {
        AA: contrastRatio >= 4.5,
        AALarge: contrastRatio >= 3,
        AAA: contrastRatio >= 7,
        AAALarge: contrastRatio >= 4.5
    };
}
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $4875e63af1e2f289$var$mix(weight, color, otherColor) {
    if (color === "transparent") return otherColor;
    if (otherColor === "transparent") return color;
    if (weight === 0) return otherColor;
    var parsedColor1 = $4875e63af1e2f289$export$2f48baff6995707a(color);
    var color1 = (0, $4WYaH.default)({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === "number" ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $4875e63af1e2f289$export$2f48baff6995707a(otherColor);
    var color2 = (0, $4WYaH.default)({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === "number" ? parsedColor2.alpha : 1
    });
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
    };
    return $4875e63af1e2f289$export$4e46ac54fc82cf3b(mixedColor);
}
// prettier-ignore
var $4875e63af1e2f289$var$curriedMix = $4875e63af1e2f289$var$curry /* ::<number | string, string, string, string> */ ($4875e63af1e2f289$var$mix);
var $4875e63af1e2f289$export$2c9e8a9632a706b2 = $4875e63af1e2f289$var$curriedMix;
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $4875e63af1e2f289$var$opacify(amount, color) {
    if (color === "transparent") return color;
    var parsedColor = $4875e63af1e2f289$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === "number" ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $4WYaH.default)({}, parsedColor, {
        alpha: $4875e63af1e2f289$var$guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return $4875e63af1e2f289$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $4875e63af1e2f289$var$curriedOpacify = $4875e63af1e2f289$var$curry /* ::<number | string, string, string> */ ($4875e63af1e2f289$var$opacify);
var $4875e63af1e2f289$export$f4f50e3877dd0530 = $4875e63af1e2f289$var$curriedOpacify;
var $4875e63af1e2f289$var$defaultReturnIfLightColor = "#000";
var $4875e63af1e2f289$var$defaultReturnIfDarkColor = "#fff";
/**
 * Returns black or white (or optional passed colors) for best
 * contrast depending on the luminosity of the given color.
 * When passing custom return colors, strict mode ensures that the
 * return color always meets or exceeds WCAG level AA or greater. If this test
 * fails, the default return color (black or white) is returned in place of the
 * custom return color. You can optionally turn off strict mode.
 *
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 *   color: readableColor('red', '#333', '#ddd', true)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 *   color: ${readableColor('red', '#333', '#ddd', true)};
 * `
 *
 * // CSS in JS Output
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 *   color: "#000";
 * }
 */ function $4875e63af1e2f289$export$61654c1796c44811(color, returnIfLightColor, returnIfDarkColor, strict) {
    if (returnIfLightColor === void 0) returnIfLightColor = $4875e63af1e2f289$var$defaultReturnIfLightColor;
    if (returnIfDarkColor === void 0) returnIfDarkColor = $4875e63af1e2f289$var$defaultReturnIfDarkColor;
    if (strict === void 0) strict = true;
    var isColorLight = $4875e63af1e2f289$export$c852d90bf7403b62(color) > 0.179;
    var preferredReturnColor = isColorLight ? returnIfLightColor : returnIfDarkColor;
    if (!strict || $4875e63af1e2f289$export$850ce485a60d103b(color, preferredReturnColor) >= 4.5) return preferredReturnColor;
    return isColorLight ? $4875e63af1e2f289$var$defaultReturnIfLightColor : $4875e63af1e2f289$var$defaultReturnIfDarkColor;
}
/**
 * Converts a RgbColor or RgbaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb` or `rgba`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100 }),
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 * }
 */ function $4875e63af1e2f289$export$34b0917fcca19deb(color) {
    if (typeof color === "object" && typeof color.red === "number" && typeof color.green === "number" && typeof color.blue === "number") {
        if (typeof color.alpha === "number") return $4875e63af1e2f289$export$4e46ac54fc82cf3b({
            red: color.red,
            green: color.green,
            blue: color.blue,
            alpha: color.alpha
        });
        return $4875e63af1e2f289$export$8972dc0e6ad9238f({
            red: color.red,
            green: color.green,
            blue: color.blue
        });
    }
    throw new $4875e63af1e2f289$var$PolishedError(46);
}
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $4875e63af1e2f289$var$saturate(amount, color) {
    if (color === "transparent") return color;
    var hslColor = $4875e63af1e2f289$export$1286688e1b3fde9c(color);
    return $4875e63af1e2f289$export$42fe740cdf79b2df((0, $4WYaH.default)({}, hslColor, {
        saturation: $4875e63af1e2f289$var$guard(0, 1, hslColor.saturation + parseFloat(amount))
    }));
}
// prettier-ignore
var $4875e63af1e2f289$var$curriedSaturate = $4875e63af1e2f289$var$curry /* ::<number | string, string, string> */ ($4875e63af1e2f289$var$saturate);
var $4875e63af1e2f289$export$5fcac96f5a87e3db = $4875e63af1e2f289$var$curriedSaturate;
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $4875e63af1e2f289$var$setHue(hue, color) {
    if (color === "transparent") return color;
    return $4875e63af1e2f289$export$42fe740cdf79b2df((0, $4WYaH.default)({}, $4875e63af1e2f289$export$1286688e1b3fde9c(color), {
        hue: parseFloat(hue)
    }));
}
// prettier-ignore
var $4875e63af1e2f289$var$curriedSetHue = $4875e63af1e2f289$var$curry /* ::<number | string, string, string> */ ($4875e63af1e2f289$var$setHue);
var $4875e63af1e2f289$export$3bf58ce3e497a846 = $4875e63af1e2f289$var$curriedSetHue;
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $4875e63af1e2f289$var$setLightness(lightness, color) {
    if (color === "transparent") return color;
    return $4875e63af1e2f289$export$42fe740cdf79b2df((0, $4WYaH.default)({}, $4875e63af1e2f289$export$1286688e1b3fde9c(color), {
        lightness: parseFloat(lightness)
    }));
}
// prettier-ignore
var $4875e63af1e2f289$var$curriedSetLightness = $4875e63af1e2f289$var$curry /* ::<number | string, string, string> */ ($4875e63af1e2f289$var$setLightness);
var $4875e63af1e2f289$export$7ef5d725337b805d = $4875e63af1e2f289$var$curriedSetLightness;
/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $4875e63af1e2f289$var$setSaturation(saturation, color) {
    if (color === "transparent") return color;
    return $4875e63af1e2f289$export$42fe740cdf79b2df((0, $4WYaH.default)({}, $4875e63af1e2f289$export$1286688e1b3fde9c(color), {
        saturation: parseFloat(saturation)
    }));
}
// prettier-ignore
var $4875e63af1e2f289$var$curriedSetSaturation = $4875e63af1e2f289$var$curry /* ::<number | string, string, string> */ ($4875e63af1e2f289$var$setSaturation);
var $4875e63af1e2f289$export$b40fe421ea7a4f7e = $4875e63af1e2f289$var$curriedSetSaturation;
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $4875e63af1e2f289$var$shade(percentage, color) {
    if (color === "transparent") return color;
    return $4875e63af1e2f289$export$2c9e8a9632a706b2(parseFloat(percentage), "rgb(0, 0, 0)", color);
}
// prettier-ignore
var $4875e63af1e2f289$var$curriedShade = $4875e63af1e2f289$var$curry /* ::<number | string, string, string> */ ($4875e63af1e2f289$var$shade);
var $4875e63af1e2f289$export$3e32adda0df4ef5d = $4875e63af1e2f289$var$curriedShade;
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $4875e63af1e2f289$var$tint(percentage, color) {
    if (color === "transparent") return color;
    return $4875e63af1e2f289$export$2c9e8a9632a706b2(parseFloat(percentage), "rgb(255, 255, 255)", color);
}
// prettier-ignore
var $4875e63af1e2f289$var$curriedTint = $4875e63af1e2f289$var$curry /* ::<number | string, string, string> */ ($4875e63af1e2f289$var$tint);
var $4875e63af1e2f289$export$fc176dd65a27d98b = $4875e63af1e2f289$var$curriedTint;
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $4875e63af1e2f289$var$transparentize(amount, color) {
    if (color === "transparent") return color;
    var parsedColor = $4875e63af1e2f289$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === "number" ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $4WYaH.default)({}, parsedColor, {
        alpha: $4875e63af1e2f289$var$guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
    });
    return $4875e63af1e2f289$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $4875e63af1e2f289$var$curriedTransparentize = $4875e63af1e2f289$var$curry /* ::<number | string, string, string> */ ($4875e63af1e2f289$var$transparentize);
var $4875e63af1e2f289$export$d11da87e55cc498f = $4875e63af1e2f289$var$curriedTransparentize;
/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $4875e63af1e2f289$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new $4875e63af1e2f289$var$PolishedError(64);
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new $4875e63af1e2f289$var$PolishedError(65);
        if (Array.isArray(arg) && arg.length > 8) throw new $4875e63af1e2f289$var$PolishedError(66);
        return Array.isArray(arg) ? arg.join(" ") : arg;
    }).join(", ");
    return {
        animation: code
    };
}
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $4875e63af1e2f289$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(", ")
    };
}
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $4875e63af1e2f289$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(", ")
    };
}
var $4875e63af1e2f289$var$sideMap = [
    "top",
    "right",
    "bottom",
    "left"
];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */ function $4875e63af1e2f289$export$1edee58a52776cd9(sideKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if (typeof sideKeyword === "string" && $4875e63af1e2f289$var$sideMap.indexOf(sideKeyword) >= 0) {
        var _ref;
        return _ref = {}, _ref["border" + $4875e63af1e2f289$var$capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + $4875e63af1e2f289$var$capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + $4875e63af1e2f289$var$capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
    } else {
        values.unshift(sideKeyword);
        return {
            borderWidth: values[0],
            borderStyle: values[1],
            borderColor: values[2]
        };
    }
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $4875e63af1e2f289$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $4875e63af1e2f289$export$4fc00c04dd60af95.apply(void 0, [
        "borderColor"
    ].concat(values));
}
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $4875e63af1e2f289$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $4875e63af1e2f289$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new $4875e63af1e2f289$var$PolishedError(62);
    if (uppercaseSide === "Top" || uppercaseSide === "Bottom") {
        var _ref;
        return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
    }
    if (uppercaseSide === "Left" || uppercaseSide === "Right") {
        var _ref2;
        return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
    }
    throw new $4875e63af1e2f289$var$PolishedError(63);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $4875e63af1e2f289$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $4875e63af1e2f289$export$4fc00c04dd60af95.apply(void 0, [
        "borderStyle"
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $4875e63af1e2f289$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $4875e63af1e2f289$export$4fc00c04dd60af95.apply(void 0, [
        "borderWidth"
    ].concat(values));
}
function $4875e63af1e2f289$var$generateSelectors(template, state) {
    var stateSuffix = state ? ":" + state : "";
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $4875e63af1e2f289$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new $4875e63af1e2f289$var$PolishedError(67);
    if (states.length === 0) return $4875e63af1e2f289$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new $4875e63af1e2f289$var$PolishedError(68);
        selectors.push($4875e63af1e2f289$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(",");
    return selectors;
}
var $4875e63af1e2f289$var$stateMap$1 = [
    undefined,
    null,
    "active",
    "focus",
    "hover"
];
function $4875e63af1e2f289$var$template$1(state) {
    return "button" + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $4875e63af1e2f289$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $4875e63af1e2f289$var$statefulSelectors(states, $4875e63af1e2f289$var$template$1, $4875e63af1e2f289$var$stateMap$1);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $4875e63af1e2f289$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $4875e63af1e2f289$export$4fc00c04dd60af95.apply(void 0, [
        "margin"
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $4875e63af1e2f289$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $4875e63af1e2f289$export$4fc00c04dd60af95.apply(void 0, [
        "padding"
    ].concat(values));
}
var $4875e63af1e2f289$var$positionMap = [
    "absolute",
    "fixed",
    "relative",
    "static",
    "sticky"
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $4875e63af1e2f289$export$5880b8b5730aff45(firstValue) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($4875e63af1e2f289$var$positionMap.indexOf(firstValue) >= 0 && firstValue) return (0, $4WYaH.default)({}, $4875e63af1e2f289$export$4fc00c04dd60af95.apply(void 0, [
        ""
    ].concat(values)), {
        position: firstValue
    });
    else return $4875e63af1e2f289$export$4fc00c04dd60af95.apply(void 0, [
        "",
        firstValue
    ].concat(values));
}
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $4875e63af1e2f289$export$346677f925de839c(height, width) {
    if (width === void 0) width = height;
    return {
        height: height,
        width: width
    };
}
var $4875e63af1e2f289$var$stateMap = [
    undefined,
    null,
    "active",
    "focus",
    "hover"
];
function $4875e63af1e2f289$var$template(state) {
    return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $4875e63af1e2f289$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $4875e63af1e2f289$var$statefulSelectors(states, $4875e63af1e2f289$var$template, $4875e63af1e2f289$var$stateMap);
}
/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same transition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */ function $4875e63af1e2f289$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    if (Array.isArray(properties[0]) && properties.length === 2) {
        var value = properties[1];
        if (typeof value !== "string") throw new $4875e63af1e2f289$var$PolishedError(61);
        var transitionsString = properties[0].map(function(property) {
            return property + " " + value;
        }).join(", ");
        return {
            transition: transitionsString
        };
    } else return {
        transition: properties.join(", ")
    };
}

});
parcelRegister("hqR4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb0e0834598ff6d6$export$2e2bcd8739ae039; });
function $cb0e0834598ff6d6$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("9wGjo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ef7ec73429a860b$export$2e2bcd8739ae039; });

var $k5JCq = parcelRequire("k5JCq");

var $hloi6 = parcelRequire("hloi6");

var $5uXgk = parcelRequire("5uXgk");

var $9XnML = parcelRequire("9XnML");
function $6ef7ec73429a860b$export$2e2bcd8739ae039(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $6ef7ec73429a860b$export$2e2bcd8739ae039 = function _wrapNativeSuper(Class) {
        if (Class === null || !(0, $5uXgk.default)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $9XnML.default)(Class, arguments, (0, $k5JCq.default)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $hloi6.default)(Wrapper, Class);
    };
    return $6ef7ec73429a860b$export$2e2bcd8739ae039(Class);
}

});
parcelRegister("k5JCq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea07a931d040ec2a$export$2e2bcd8739ae039; });
function $ea07a931d040ec2a$export$2e2bcd8739ae039(o) {
    $ea07a931d040ec2a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ea07a931d040ec2a$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5uXgk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $400db96293dc0d4f$export$2e2bcd8739ae039; });
function $400db96293dc0d4f$export$2e2bcd8739ae039(fn) {
    try {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    } catch (e) {
        return typeof fn === "function";
    }
}

});

parcelRegister("9XnML", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73fc1313706687df$export$2e2bcd8739ae039; });

var $hloi6 = parcelRequire("hloi6");

var $1TADt = parcelRequire("1TADt");
function $73fc1313706687df$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $1TADt.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $hloi6.default)(p, r.prototype), p;
}

});
parcelRegister("1TADt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1617589007256c62$export$2e2bcd8739ae039; });
function $1617589007256c62$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1617589007256c62$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});



parcelRegister("lSN3y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fee4b1b342cd7d37$export$2e2bcd8739ae039; });
function $fee4b1b342cd7d37$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    strings.raw = raw;
    return strings;
}

});



parcelRegister("64P2c", function(module, exports) {

$parcel$export(module.exports, "parseMilliseconds", function () { return $46cab42b1f0c3144$export$441be63dd8276c0f; });
const $46cab42b1f0c3144$export$441be63dd8276c0f = (string)=>{
    const ms = 1;
    const s = 1000 * ms;
    const m = 60 * s;
    const h = 60 * m;
    const d = 24 * h;
    const w = 7 * d;
    const timeAsMilliseconds = {
        ms: ms,
        s: s,
        m: m,
        h: h,
        d: d,
        w: w
    };
    const matches = string.match(/(\d+)([ms|s|m|h|d|w]*)/g);
    return matches.reduce((acc, next)=>{
        const key = next.replace(/\d+/, "");
        return acc + parseInt(next) * timeAsMilliseconds[key];
    }, 0);
};

});



parcelRegister("igCUb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4c7e666b88ec736$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $9Qp9d = parcelRequire("9Qp9d");
const $d4c7e666b88ec736$var$API_URL = (0, location.origin);
const $d4c7e666b88ec736$var$delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
class $d4c7e666b88ec736$var$ConnectionStability {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isConnectionModalVisible", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isAsyaAvailable", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isOuterServiceAvailable", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "requestCache", {});
        (0, $9Qp9d.makeAutoObservable)(this);
    }
    async tryMakeRequest(name, URL) {
        try {
            if (!this.requestCache[name]) this.requestCache[name] = fetch(URL, {
                mode: "no-cors",
                cache: "no-cache",
                redirect: "follow",
                referrerPolicy: "no-referrer"
            });
            await this.requestCache[name];
            delete this.requestCache[name];
            return true;
        } catch (e) {
            if (this.isFetchError(e)) {
                delete this.requestCache[name];
                return false;
            }
        }
        return false;
    }
    async waitConnection() {
        this.setAsyaAvailable(await this.tryMakeRequest("asya", $d4c7e666b88ec736$var$API_URL + "/mobile-api/configs"));
        this.setOuterServiceAvailable(await this.tryMakeRequest("outer", "https://google.com"));
        if (!this.isAsyaAvailable) {
            if (!this.isConnectionModalVisible) this.showConnectionErrorModal();
            await $d4c7e666b88ec736$var$delay(5000);
            return await this.waitConnection();
        } else {
            this.closeConnectionErrorModal();
            return true;
        }
    }
    isFetchError(error) {
        return error && error.message === "Failed to fetch";
    }
    setAsyaAvailable(value) {
        this.isAsyaAvailable = value;
    }
    setOuterServiceAvailable(value) {
        this.isOuterServiceAvailable = value;
    }
    showConnectionErrorModal() {
        this.isConnectionModalVisible = true;
    }
    closeConnectionErrorModal() {
        this.isConnectionModalVisible = false;
    }
}
var $d4c7e666b88ec736$export$2e2bcd8739ae039 = new $d4c7e666b88ec736$var$ConnectionStability();

});
parcelRegister("jqdsN", function(module, exports) {

var $7keJs = parcelRequire("7keJs");
function $e23ae39501459ba4$var$_defineProperty(obj, key, value) {
    key = $7keJs(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $e23ae39501459ba4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7keJs", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $5555d428bd3bf37b$var$_typeof = $crtHL.default;

var $2PEUm = parcelRequire("2PEUm");
function $5555d428bd3bf37b$var$toPropertyKey(t) {
    var i = $2PEUm(t, "string");
    return "symbol" == $5555d428bd3bf37b$var$_typeof(i) ? i : String(i);
}
module.exports = $5555d428bd3bf37b$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("crtHL", function(module, exports) {
function $90ef0c6889924fa4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $90ef0c6889924fa4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $90ef0c6889924fa4$var$_typeof(o);
}
module.exports = $90ef0c6889924fa4$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2PEUm", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $210013a7b1d5e66c$var$_typeof = $crtHL.default;
function $210013a7b1d5e66c$var$toPrimitive(t, r) {
    if ("object" != $210013a7b1d5e66c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $210013a7b1d5e66c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $210013a7b1d5e66c$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("7HoMU", function(module, exports) {

$parcel$export(module.exports, "captureExceptionToSentry", function () { return $59afc6e9c0b19c7e$export$a965f51e04781f3e; });
$parcel$export(module.exports, "captureEventToSentry", function () { return $59afc6e9c0b19c7e$export$1d1a4381e321ee7c; });

var $le8XK = parcelRequire("le8XK");
const $59afc6e9c0b19c7e$export$a965f51e04781f3e = (err)=>{
    if (typeof $le8XK !== "undefined") $le8XK.captureException(err);
};
const $59afc6e9c0b19c7e$export$1d1a4381e321ee7c = (event)=>{
    if (typeof $le8XK !== "undefined") $le8XK.captureEvent(event);
};

});
parcelRegister("le8XK", function(module, exports) {

$parcel$export(module.exports, "init", function () { return (parcelRequire("cwhMb")).init; });
$parcel$export(module.exports, "Profiler", function () { return (parcelRequire("bycal")).Profiler; });
$parcel$export(module.exports, "useProfiler", function () { return (parcelRequire("bycal")).useProfiler; });
$parcel$export(module.exports, "withProfiler", function () { return (parcelRequire("bycal")).withProfiler; });
$parcel$export(module.exports, "ErrorBoundary", function () { return (parcelRequire("d1YDb")).ErrorBoundary; });
$parcel$export(module.exports, "withErrorBoundary", function () { return (parcelRequire("d1YDb")).withErrorBoundary; });
$parcel$export(module.exports, "createReduxEnhancer", function () { return (parcelRequire("4wVlt")).createReduxEnhancer; });
$parcel$export(module.exports, "reactRouterV3BrowserTracingIntegration", function () { return (parcelRequire("hPR7J")).reactRouterV3BrowserTracingIntegration; });
$parcel$export(module.exports, "reactRouterV3Instrumentation", function () { return (parcelRequire("hPR7J")).reactRouterV3Instrumentation; });
$parcel$export(module.exports, "reactRouterV4BrowserTracingIntegration", function () { return (parcelRequire("iYjt0")).reactRouterV4BrowserTracingIntegration; });
$parcel$export(module.exports, "reactRouterV4Instrumentation", function () { return (parcelRequire("iYjt0")).reactRouterV4Instrumentation; });
$parcel$export(module.exports, "reactRouterV5BrowserTracingIntegration", function () { return (parcelRequire("iYjt0")).reactRouterV5BrowserTracingIntegration; });
$parcel$export(module.exports, "reactRouterV5Instrumentation", function () { return (parcelRequire("iYjt0")).reactRouterV5Instrumentation; });
$parcel$export(module.exports, "withSentryRouting", function () { return (parcelRequire("iYjt0")).withSentryRouting; });
$parcel$export(module.exports, "reactRouterV6BrowserTracingIntegration", function () { return (parcelRequire("2PGsT")).reactRouterV6BrowserTracingIntegration; });
$parcel$export(module.exports, "reactRouterV6Instrumentation", function () { return (parcelRequire("2PGsT")).reactRouterV6Instrumentation; });
$parcel$export(module.exports, "withSentryReactRouterV6Routing", function () { return (parcelRequire("2PGsT")).withSentryReactRouterV6Routing; });
$parcel$export(module.exports, "wrapCreateBrowserRouter", function () { return (parcelRequire("2PGsT")).wrapCreateBrowserRouter; });
$parcel$export(module.exports, "wrapUseRoutes", function () { return (parcelRequire("2PGsT")).wrapUseRoutes; });

var $9M4YH = parcelRequire("9M4YH");

var $cwhMb = parcelRequire("cwhMb");

var $bycal = parcelRequire("bycal");

var $d1YDb = parcelRequire("d1YDb");

var $4wVlt = parcelRequire("4wVlt");

var $hPR7J = parcelRequire("hPR7J");

var $iYjt0 = parcelRequire("iYjt0");

var $2PGsT = parcelRequire("2PGsT");
$parcel$exportWildcard(module.exports, $9M4YH);

});
parcelRegister("9M4YH", function(module, exports) {

$parcel$export(module.exports, "Integrations", function () { return $71dc754958868e2c$export$99d02219d259eb94; });
$parcel$export(module.exports, "FunctionToString", function () { return (parcelRequire("5Bu1f")).FunctionToString; });
$parcel$export(module.exports, "Hub", function () { return (parcelRequire("fxUGN")).Hub; });
$parcel$export(module.exports, "InboundFilters", function () { return (parcelRequire("cCK0h")).InboundFilters; });
$parcel$export(module.exports, "ModuleMetadata", function () { return (parcelRequire("3rOP2")).ModuleMetadata; });
$parcel$export(module.exports, "SDK_VERSION", function () { return (parcelRequire("fIs9O")).SDK_VERSION; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return (parcelRequire("kuS4l")).SEMANTIC_ATTRIBUTE_SENTRY_OP; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return (parcelRequire("kuS4l")).SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return (parcelRequire("kuS4l")).SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return (parcelRequire("kuS4l")).SEMANTIC_ATTRIBUTE_SENTRY_SOURCE; });
$parcel$export(module.exports, "Scope", function () { return (parcelRequire("2W3Nl")).Scope; });
$parcel$export(module.exports, "addBreadcrumb", function () { return (parcelRequire("hcepo")).addBreadcrumb; });
$parcel$export(module.exports, "addEventProcessor", function () { return (parcelRequire("huK8b")).addEventProcessor; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return (parcelRequire("jXhtG")).addGlobalEventProcessor; });
$parcel$export(module.exports, "addIntegration", function () { return (parcelRequire("genhe")).addIntegration; });
$parcel$export(module.exports, "addTracingExtensions", function () { return (parcelRequire("jEn5j")).addTracingExtensions; });
$parcel$export(module.exports, "captureEvent", function () { return (parcelRequire("hcepo")).captureEvent; });
$parcel$export(module.exports, "captureException", function () { return (parcelRequire("hcepo")).captureException; });
$parcel$export(module.exports, "captureMessage", function () { return (parcelRequire("hcepo")).captureMessage; });
$parcel$export(module.exports, "captureSession", function () { return (parcelRequire("hcepo")).captureSession; });
$parcel$export(module.exports, "close", function () { return (parcelRequire("hcepo")).close; });
$parcel$export(module.exports, "configureScope", function () { return (parcelRequire("hcepo")).configureScope; });
$parcel$export(module.exports, "continueTrace", function () { return (parcelRequire("mtWu0")).continueTrace; });
$parcel$export(module.exports, "createTransport", function () { return (parcelRequire("kcgw9")).createTransport; });
$parcel$export(module.exports, "endSession", function () { return (parcelRequire("hcepo")).endSession; });
$parcel$export(module.exports, "extractTraceparentData", function () { return (parcelRequire("7flMU")).extractTraceparentData; });
$parcel$export(module.exports, "flush", function () { return (parcelRequire("hcepo")).flush; });
$parcel$export(module.exports, "functionToStringIntegration", function () { return (parcelRequire("5Bu1f")).functionToStringIntegration; });
$parcel$export(module.exports, "getActiveSpan", function () { return (parcelRequire("mtWu0")).getActiveSpan; });
$parcel$export(module.exports, "getActiveTransaction", function () { return (parcelRequire("7flMU")).getActiveTransaction; });
$parcel$export(module.exports, "getClient", function () { return (parcelRequire("hcepo")).getClient; });
$parcel$export(module.exports, "getCurrentHub", function () { return (parcelRequire("fxUGN")).getCurrentHub; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("hcepo")).getCurrentScope; });
$parcel$export(module.exports, "getHubFromCarrier", function () { return (parcelRequire("fxUGN")).getHubFromCarrier; });
$parcel$export(module.exports, "getSpanStatusFromHttpCode", function () { return (parcelRequire("bMwjP")).getSpanStatusFromHttpCode; });
$parcel$export(module.exports, "inboundFiltersIntegration", function () { return (parcelRequire("cCK0h")).inboundFiltersIntegration; });
$parcel$export(module.exports, "isInitialized", function () { return (parcelRequire("hcepo")).isInitialized; });
$parcel$export(module.exports, "lastEventId", function () { return (parcelRequire("hcepo")).lastEventId; });
$parcel$export(module.exports, "makeMain", function () { return (parcelRequire("fxUGN")).makeMain; });
$parcel$export(module.exports, "makeMultiplexedTransport", function () { return (parcelRequire("kDOUc")).makeMultiplexedTransport; });
$parcel$export(module.exports, "metrics", function () { return (parcelRequire("kxfHu")).metrics; });
$parcel$export(module.exports, "moduleMetadataIntegration", function () { return (parcelRequire("3rOP2")).moduleMetadataIntegration; });
$parcel$export(module.exports, "parameterize", function () { return (parcelRequire("fTge7")).parameterize; });
$parcel$export(module.exports, "setContext", function () { return (parcelRequire("hcepo")).setContext; });
$parcel$export(module.exports, "setCurrentClient", function () { return (parcelRequire("dKXuR")).setCurrentClient; });
$parcel$export(module.exports, "setExtra", function () { return (parcelRequire("hcepo")).setExtra; });
$parcel$export(module.exports, "setExtras", function () { return (parcelRequire("hcepo")).setExtras; });
$parcel$export(module.exports, "setHttpStatus", function () { return (parcelRequire("bMwjP")).setHttpStatus; });
$parcel$export(module.exports, "setMeasurement", function () { return (parcelRequire("g6vjT")).setMeasurement; });
$parcel$export(module.exports, "setTag", function () { return (parcelRequire("hcepo")).setTag; });
$parcel$export(module.exports, "setTags", function () { return (parcelRequire("hcepo")).setTags; });
$parcel$export(module.exports, "setUser", function () { return (parcelRequire("hcepo")).setUser; });
$parcel$export(module.exports, "spanStatusfromHttpCode", function () { return (parcelRequire("bMwjP")).spanStatusfromHttpCode; });
$parcel$export(module.exports, "startInactiveSpan", function () { return (parcelRequire("mtWu0")).startInactiveSpan; });
$parcel$export(module.exports, "startSession", function () { return (parcelRequire("hcepo")).startSession; });
$parcel$export(module.exports, "startSpan", function () { return (parcelRequire("mtWu0")).startSpan; });
$parcel$export(module.exports, "startSpanManual", function () { return (parcelRequire("mtWu0")).startSpanManual; });
$parcel$export(module.exports, "startTransaction", function () { return (parcelRequire("hcepo")).startTransaction; });
$parcel$export(module.exports, "trace", function () { return (parcelRequire("mtWu0")).trace; });
$parcel$export(module.exports, "withActiveSpan", function () { return (parcelRequire("hcepo")).withActiveSpan; });
$parcel$export(module.exports, "withIsolationScope", function () { return (parcelRequire("hcepo")).withIsolationScope; });
$parcel$export(module.exports, "withScope", function () { return (parcelRequire("hcepo")).withScope; });
$parcel$export(module.exports, "WINDOW", function () { return (parcelRequire("d9NWo")).WINDOW; });
$parcel$export(module.exports, "BrowserClient", function () { return (parcelRequire("lCly9")).BrowserClient; });
$parcel$export(module.exports, "makeFetchTransport", function () { return (parcelRequire("2dhpd")).makeFetchTransport; });
$parcel$export(module.exports, "makeXHRTransport", function () { return (parcelRequire("cqNDo")).makeXHRTransport; });
$parcel$export(module.exports, "chromeStackLineParser", function () { return (parcelRequire("jkCYa")).chromeStackLineParser; });
$parcel$export(module.exports, "defaultStackLineParsers", function () { return (parcelRequire("jkCYa")).defaultStackLineParsers; });
$parcel$export(module.exports, "defaultStackParser", function () { return (parcelRequire("jkCYa")).defaultStackParser; });
$parcel$export(module.exports, "geckoStackLineParser", function () { return (parcelRequire("jkCYa")).geckoStackLineParser; });
$parcel$export(module.exports, "opera10StackLineParser", function () { return (parcelRequire("jkCYa")).opera10StackLineParser; });
$parcel$export(module.exports, "opera11StackLineParser", function () { return (parcelRequire("jkCYa")).opera11StackLineParser; });
$parcel$export(module.exports, "winjsStackLineParser", function () { return (parcelRequire("jkCYa")).winjsStackLineParser; });
$parcel$export(module.exports, "eventFromException", function () { return (parcelRequire("4JUzU")).eventFromException; });
$parcel$export(module.exports, "eventFromMessage", function () { return (parcelRequire("4JUzU")).eventFromMessage; });
$parcel$export(module.exports, "exceptionFromError", function () { return (parcelRequire("4JUzU")).exceptionFromError; });
$parcel$export(module.exports, "createUserFeedbackEnvelope", function () { return (parcelRequire("C3Qws")).createUserFeedbackEnvelope; });
$parcel$export(module.exports, "captureUserFeedback", function () { return (parcelRequire("cet0p")).captureUserFeedback; });
$parcel$export(module.exports, "defaultIntegrations", function () { return (parcelRequire("cet0p")).defaultIntegrations; });
$parcel$export(module.exports, "forceLoad", function () { return (parcelRequire("cet0p")).forceLoad; });
$parcel$export(module.exports, "getDefaultIntegrations", function () { return (parcelRequire("cet0p")).getDefaultIntegrations; });
$parcel$export(module.exports, "init", function () { return (parcelRequire("cet0p")).init; });
$parcel$export(module.exports, "onLoad", function () { return (parcelRequire("cet0p")).onLoad; });
$parcel$export(module.exports, "showReportDialog", function () { return (parcelRequire("cet0p")).showReportDialog; });
$parcel$export(module.exports, "wrap", function () { return (parcelRequire("cet0p")).wrap; });
$parcel$export(module.exports, "Breadcrumbs", function () { return (parcelRequire("53mM0")).Breadcrumbs; });
$parcel$export(module.exports, "breadcrumbsIntegration", function () { return (parcelRequire("53mM0")).breadcrumbsIntegration; });
$parcel$export(module.exports, "Dedupe", function () { return (parcelRequire("gxQnK")).Dedupe; });
$parcel$export(module.exports, "dedupeIntegration", function () { return (parcelRequire("gxQnK")).dedupeIntegration; });
$parcel$export(module.exports, "GlobalHandlers", function () { return (parcelRequire("i26WM")).GlobalHandlers; });
$parcel$export(module.exports, "globalHandlersIntegration", function () { return (parcelRequire("i26WM")).globalHandlersIntegration; });
$parcel$export(module.exports, "HttpContext", function () { return (parcelRequire("39bVV")).HttpContext; });
$parcel$export(module.exports, "httpContextIntegration", function () { return (parcelRequire("39bVV")).httpContextIntegration; });
$parcel$export(module.exports, "LinkedErrors", function () { return (parcelRequire("gb6W3")).LinkedErrors; });
$parcel$export(module.exports, "linkedErrorsIntegration", function () { return (parcelRequire("gb6W3")).linkedErrorsIntegration; });
$parcel$export(module.exports, "TryCatch", function () { return (parcelRequire("aLmV4")).TryCatch; });
$parcel$export(module.exports, "browserApiErrorsIntegration", function () { return (parcelRequire("aLmV4")).browserApiErrorsIntegration; });
$parcel$export(module.exports, "Replay", function () { return (parcelRequire("am4Ss")).Replay; });
$parcel$export(module.exports, "getReplay", function () { return (parcelRequire("am4Ss")).getReplay; });
$parcel$export(module.exports, "replayIntegration", function () { return (parcelRequire("am4Ss")).replayIntegration; });
$parcel$export(module.exports, "ReplayCanvas", function () { return (parcelRequire("1Jtuk")).ReplayCanvas; });
$parcel$export(module.exports, "replayCanvasIntegration", function () { return (parcelRequire("1Jtuk")).replayCanvasIntegration; });
$parcel$export(module.exports, "Feedback", function () { return (parcelRequire("62zNO")).Feedback; });
$parcel$export(module.exports, "feedbackIntegration", function () { return (parcelRequire("62zNO")).feedbackIntegration; });
$parcel$export(module.exports, "sendFeedback", function () { return (parcelRequire("62zNO")).sendFeedback; });
$parcel$export(module.exports, "BrowserTracing", function () { return (parcelRequire("52HK7")).BrowserTracing; });
$parcel$export(module.exports, "browserTracingIntegration", function () { return (parcelRequire("cd71e")).browserTracingIntegration; });
$parcel$export(module.exports, "defaultRequestInstrumentationOptions", function () { return (parcelRequire("l7Nlw")).defaultRequestInstrumentationOptions; });
$parcel$export(module.exports, "instrumentOutgoingRequests", function () { return (parcelRequire("l7Nlw")).instrumentOutgoingRequests; });
$parcel$export(module.exports, "startBrowserTracingNavigationSpan", function () { return (parcelRequire("cd71e")).startBrowserTracingNavigationSpan; });
$parcel$export(module.exports, "startBrowserTracingPageLoadSpan", function () { return (parcelRequire("cd71e")).startBrowserTracingPageLoadSpan; });
$parcel$export(module.exports, "makeBrowserOfflineTransport", function () { return (parcelRequire("58sat")).makeBrowserOfflineTransport; });
$parcel$export(module.exports, "onProfilingStartRouteTransaction", function () { return (parcelRequire("33qkX")).onProfilingStartRouteTransaction; });
$parcel$export(module.exports, "BrowserProfilingIntegration", function () { return (parcelRequire("6qNgj")).BrowserProfilingIntegration; });
$parcel$export(module.exports, "browserProfilingIntegration", function () { return (parcelRequire("6qNgj")).browserProfilingIntegration; });

var $hcepo = parcelRequire("hcepo");
var $huK8b = parcelRequire("huK8b");
var $jXhtG = parcelRequire("jXhtG");
var $genhe = parcelRequire("genhe");
var $jEn5j = parcelRequire("jEn5j");
var $mtWu0 = parcelRequire("mtWu0");
var $kcgw9 = parcelRequire("kcgw9");
var $7flMU = parcelRequire("7flMU");
var $5Bu1f = parcelRequire("5Bu1f");
var $fxUGN = parcelRequire("fxUGN");
var $bMwjP = parcelRequire("bMwjP");
var $cCK0h = parcelRequire("cCK0h");
var $gEBGI = parcelRequire("gEBGI");
var $kDOUc = parcelRequire("kDOUc");
var $kxfHu = parcelRequire("kxfHu");
var $3rOP2 = parcelRequire("3rOP2");
var $fTge7 = parcelRequire("fTge7");
var $2W3Nl = parcelRequire("2W3Nl");
var $fIs9O = parcelRequire("fIs9O");
var $kuS4l = parcelRequire("kuS4l");
var $dKXuR = parcelRequire("dKXuR");
var $g6vjT = parcelRequire("g6vjT");

var $d9NWo = parcelRequire("d9NWo");

var $lCly9 = parcelRequire("lCly9");

var $2dhpd = parcelRequire("2dhpd");

var $cqNDo = parcelRequire("cqNDo");

var $jkCYa = parcelRequire("jkCYa");

var $4JUzU = parcelRequire("4JUzU");

var $C3Qws = parcelRequire("C3Qws");

var $cet0p = parcelRequire("cet0p");

var $53mM0 = parcelRequire("53mM0");

var $gxQnK = parcelRequire("gxQnK");

var $i26WM = parcelRequire("i26WM");

var $39bVV = parcelRequire("39bVV");

var $gb6W3 = parcelRequire("gb6W3");

var $aLmV4 = parcelRequire("aLmV4");

var $8WmGo = parcelRequire("8WmGo");

var $am4Ss = parcelRequire("am4Ss");

var $1Jtuk = parcelRequire("1Jtuk");

var $62zNO = parcelRequire("62zNO");

var $52HK7 = parcelRequire("52HK7");
var $cd71e = parcelRequire("cd71e");
var $l7Nlw = parcelRequire("l7Nlw");

var $58sat = parcelRequire("58sat");

var $33qkX = parcelRequire("33qkX");

var $6qNgj = parcelRequire("6qNgj");
let $71dc754958868e2c$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
if ((0, $d9NWo.WINDOW).Sentry && (0, $d9NWo.WINDOW).Sentry.Integrations) $71dc754958868e2c$var$windowIntegrations = (0, $d9NWo.WINDOW).Sentry.Integrations;
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $71dc754958868e2c$export$99d02219d259eb94 = {
    ...$71dc754958868e2c$var$windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, $gEBGI.Integrations),
    ...$8WmGo
};

});
parcelRegister("huK8b", function(module, exports) {

$parcel$export(module.exports, "BaseClient", function () { return $cbc905a8d0f56eed$export$4f22f74eddb7716a; });
$parcel$export(module.exports, "addEventProcessor", function () { return $cbc905a8d0f56eed$export$9aac0b9f77928fbf; });

var $2pR2a = parcelRequire("2pR2a");
var $iJH3x = parcelRequire("iJH3x");
var $jPeZ4 = parcelRequire("jPeZ4");
var $7p8hL = parcelRequire("7p8hL");
var $i8Xwi = parcelRequire("i8Xwi");
var $amxcu = parcelRequire("amxcu");
var $1BeOm = parcelRequire("1BeOm");

var $eua5O = parcelRequire("eua5O");

var $fB2fA = parcelRequire("fB2fA");

var $16rrK = parcelRequire("16rrK");

var $hcepo = parcelRequire("hcepo");

var $fxUGN = parcelRequire("fxUGN");

var $genhe = parcelRequire("genhe");

var $9vL5z = parcelRequire("9vL5z");

var $e4zhx = parcelRequire("e4zhx");

var $2Grcj = parcelRequire("2Grcj");

var $5XnTz = parcelRequire("5XnTz");
const $cbc905a8d0f56eed$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $cbc905a8d0f56eed$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $i8Xwi.makeDsn)(options.dsn);
        else (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $eua5O.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $iJH3x.checkOrSetAlreadyCaught)(exception)) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log($cbc905a8d0f56eed$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $jPeZ4.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $jPeZ4.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $iJH3x.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log($cbc905a8d0f56eed$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $e4zhx.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $amxcu.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $genhe.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $genhe.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $16rrK.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $2pR2a.addItemToEnvelope)(env, (0, $2pR2a.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $16rrK.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $9vL5z.createMetricEnvelope)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $genhe.setupIntegrations)(this, integrations);
        (0, $genhe.afterSetupIntegrations)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $e4zhx.updateSession)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $amxcu.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $fxUGN.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $5XnTz.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $2Grcj.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $fB2fA.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $7p8hL.logger).log(sentryError.message);
                else (0, $7p8hL.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $cbc905a8d0f56eed$var$isTransactionEvent(event);
        const isError = $cbc905a8d0f56eed$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $amxcu.rejectedSyncPromise)(new (0, $1BeOm.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $1BeOm.SentryError)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $cbc905a8d0f56eed$var$processBeforeSend(options, prepared, hint);
            return $cbc905a8d0f56eed$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $1BeOm.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $1BeOm.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $1BeOm.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).error("Error while sending event:", reason);
        });
        else (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $cbc905a8d0f56eed$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $jPeZ4.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $jPeZ4.isPlainObject)(event) && event !== null) throw new (0, $1BeOm.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $1BeOm.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $jPeZ4.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $1BeOm.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $cbc905a8d0f56eed$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($cbc905a8d0f56eed$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($cbc905a8d0f56eed$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $cbc905a8d0f56eed$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $cbc905a8d0f56eed$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $cbc905a8d0f56eed$export$9aac0b9f77928fbf(callback) {
    const client = (0, $hcepo.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}

});
parcelRegister("2pR2a", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", function () { return $1c270dff4e81b546$export$f93f7f385160c44e; });
$parcel$export(module.exports, "addItemToEnvelope", function () { return $1c270dff4e81b546$export$d650323442802f6f; });
$parcel$export(module.exports, "forEachEnvelopeItem", function () { return $1c270dff4e81b546$export$c56c55acf0136fd3; });
$parcel$export(module.exports, "envelopeContainsItemType", function () { return $1c270dff4e81b546$export$604a45d95a155e2b; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $1c270dff4e81b546$export$32f9b428425aac85; });
$parcel$export(module.exports, "parseEnvelope", function () { return $1c270dff4e81b546$export$3338d0c7b6e17a2b; });
$parcel$export(module.exports, "createAttachmentEnvelopeItem", function () { return $1c270dff4e81b546$export$d8fc80952cc31fa4; });
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", function () { return $1c270dff4e81b546$export$b11169581eeaf237; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $1c270dff4e81b546$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $1c270dff4e81b546$export$92b6093782fe661b; });

var $i8Xwi = parcelRequire("i8Xwi");

var $5vnYi = parcelRequire("5vnYi");

var $aajbp = parcelRequire("aajbp");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $1c270dff4e81b546$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $1c270dff4e81b546$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $1c270dff4e81b546$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $1c270dff4e81b546$export$604a45d95a155e2b(envelope, types) {
    return $1c270dff4e81b546$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $1c270dff4e81b546$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $1c270dff4e81b546$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $1c270dff4e81b546$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $1c270dff4e81b546$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $5vnYi.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $1c270dff4e81b546$var$concatBuffers(parts);
}
function $1c270dff4e81b546$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $1c270dff4e81b546$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $1c270dff4e81b546$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $1c270dff4e81b546$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $aajbp.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $1c270dff4e81b546$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    // TODO: This is a temporary workaround until we have a proper data category for metrics
    statsd: "unknown"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $1c270dff4e81b546$export$b11169581eeaf237(type) {
    return $1c270dff4e81b546$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from from the metadata or an events */ function $1c270dff4e81b546$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $1c270dff4e81b546$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $i8Xwi.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $aajbp.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

});
parcelRegister("i8Xwi", function(module, exports) {

$parcel$export(module.exports, "dsnToString", function () { return $d35724bfe3f83ca5$export$44d472fbb931a776; });
$parcel$export(module.exports, "dsnFromString", function () { return $d35724bfe3f83ca5$export$b892860177f70a30; });
$parcel$export(module.exports, "makeDsn", function () { return $d35724bfe3f83ca5$export$128827c3562ec0cb; });

var $aY8mH = parcelRequire("aY8mH");

var $7p8hL = parcelRequire("7p8hL");
/** Regular expression used to parse a Dsn. */ const $d35724bfe3f83ca5$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $d35724bfe3f83ca5$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $d35724bfe3f83ca5$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $d35724bfe3f83ca5$export$b892860177f70a30(str) {
    const match = $d35724bfe3f83ca5$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $7p8hL.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $d35724bfe3f83ca5$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $d35724bfe3f83ca5$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $d35724bfe3f83ca5$var$validateDsn(dsn) {
    if (!(0, $aY8mH.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $7p8hL.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $7p8hL.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$d35724bfe3f83ca5$var$isValidProtocol(protocol)) {
        (0, $7p8hL.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $7p8hL.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $d35724bfe3f83ca5$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $d35724bfe3f83ca5$export$b892860177f70a30(from) : $d35724bfe3f83ca5$var$dsnFromComponents(from);
    if (!components || !$d35724bfe3f83ca5$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("1BeOm", function(module, exports) {

$parcel$export(module.exports, "SentryError", function () { return $12a4bc613f21a53c$export$5949942ba2a7c0e2; });
/** An error emitted by Sentry SDKs and related utilities. */ class $12a4bc613f21a53c$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}

});

parcelRegister("eua5O", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", function () { return $a8bbb23d93bee0b3$export$9964600bfe84e6a3; });
$parcel$export(module.exports, "getReportDialogEndpoint", function () { return $a8bbb23d93bee0b3$export$671c7ed8e40a7a57; });

var $i8Xwi = parcelRequire("i8Xwi");
var $aajbp = parcelRequire("aajbp");
const $a8bbb23d93bee0b3$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $a8bbb23d93bee0b3$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $a8bbb23d93bee0b3$var$_getIngestEndpoint(dsn) {
    return `${$a8bbb23d93bee0b3$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $a8bbb23d93bee0b3$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $aajbp.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $a8bbb23d93bee0b3$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $a8bbb23d93bee0b3$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$a8bbb23d93bee0b3$var$_getIngestEndpoint(dsn)}?${$a8bbb23d93bee0b3$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $a8bbb23d93bee0b3$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $i8Xwi.makeDsn)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$a8bbb23d93bee0b3$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $i8Xwi.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});

parcelRegister("16rrK", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", function () { return $0cdba44744836c2f$export$124b03c077baa2f3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $0cdba44744836c2f$export$c31057337a18010f; });

var $2pR2a = parcelRequire("2pR2a");
var $i8Xwi = parcelRequire("i8Xwi");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $0cdba44744836c2f$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $0cdba44744836c2f$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2pR2a.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $i8Xwi.dsnToString)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $2pR2a.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $0cdba44744836c2f$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2pR2a.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $0cdba44744836c2f$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $2pR2a.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $2pR2a.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}

});

parcelRegister("genhe", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", function () { return $bd10027c43dd945c$export$68bc4c01ab8ae766; });
$parcel$export(module.exports, "setupIntegrations", function () { return $bd10027c43dd945c$export$51abed9797baa598; });
$parcel$export(module.exports, "setupIntegration", function () { return $bd10027c43dd945c$export$e7390a03b70a6f2f; });
$parcel$export(module.exports, "afterSetupIntegrations", function () { return $bd10027c43dd945c$export$35abcfd71227c6ca; });
$parcel$export(module.exports, "addIntegration", function () { return $bd10027c43dd945c$export$2d8f5188773bcddd; });
$parcel$export(module.exports, "convertIntegrationFnToClass", function () { return $bd10027c43dd945c$export$afa219bf23651160; });
$parcel$export(module.exports, "defineIntegration", function () { return $bd10027c43dd945c$export$2323046b9414659f; });

var $iJH3x = parcelRequire("iJH3x");
var $7p8hL = parcelRequire("7p8hL");

var $fB2fA = parcelRequire("fB2fA");

var $jXhtG = parcelRequire("jXhtG");

var $hcepo = parcelRequire("hcepo");

var $fxUGN = parcelRequire("fxUGN");
const $bd10027c43dd945c$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $bd10027c43dd945c$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $bd10027c43dd945c$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $iJH3x.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $bd10027c43dd945c$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $bd10027c43dd945c$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $bd10027c43dd945c$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $bd10027c43dd945c$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $bd10027c43dd945c$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $bd10027c43dd945c$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($bd10027c43dd945c$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $jXhtG.addGlobalEventProcessor), (0, $fxUGN.getCurrentHub));
        $bd10027c43dd945c$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $bd10027c43dd945c$export$2d8f5188773bcddd(integration) {
    const client = (0, $hcepo.getClient)();
    if (!client || !client.addIntegration) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $bd10027c43dd945c$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $bd10027c43dd945c$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $bd10027c43dd945c$export$2323046b9414659f(fn) {
    return fn;
}

});

parcelRegister("9vL5z", function(module, exports) {

$parcel$export(module.exports, "createMetricEnvelope", function () { return $6ecb892daa9f5151$export$f23eb96e33154901; });

var $2pR2a = parcelRequire("2pR2a");
var $i8Xwi = parcelRequire("i8Xwi");

var $lsJ5g = parcelRequire("lsJ5g");
/**
 * Create envelope from a metric aggregate.
 */ function $6ecb892daa9f5151$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $i8Xwi.dsnToString)(dsn);
    const item = $6ecb892daa9f5151$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $2pR2a.createEnvelope)(headers, [
        item
    ]);
}
function $6ecb892daa9f5151$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $lsJ5g.serializeMetricBuckets)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}

});
parcelRegister("lsJ5g", function(module, exports) {

$parcel$export(module.exports, "getBucketKey", function () { return $f9ff2f384e51ee2d$export$b8bd8c4dffa5aa2d; });
$parcel$export(module.exports, "simpleHash", function () { return $f9ff2f384e51ee2d$export$b211ce59c0ea1cfb; });
$parcel$export(module.exports, "serializeMetricBuckets", function () { return $f9ff2f384e51ee2d$export$66decd709db01dc8; });
$parcel$export(module.exports, "sanitizeTags", function () { return $f9ff2f384e51ee2d$export$ae49af12dbdf2477; });

var $aajbp = parcelRequire("aajbp");

var $3ssal = parcelRequire("3ssal");
/**
 * Generate bucket key from metric properties.
 */ function $f9ff2f384e51ee2d$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $aajbp.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $f9ff2f384e51ee2d$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $f9ff2f384e51ee2d$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/**
 * Sanitizes tags.
 */ function $f9ff2f384e51ee2d$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = key.replace((0, $3ssal.NAME_AND_TAG_KEY_NORMALIZATION_REGEX), "_");
        tags[sanitizedKey] = String(unsanitizedTags[key]).replace((0, $3ssal.TAG_VALUE_NORMALIZATION_REGEX), "");
    }
    return tags;
}

});
parcelRegister("3ssal", function(module, exports) {

$parcel$export(module.exports, "COUNTER_METRIC_TYPE", function () { return $2849d5c929c56e16$export$ffbd59c90957aeda; });
$parcel$export(module.exports, "GAUGE_METRIC_TYPE", function () { return $2849d5c929c56e16$export$41106537ee4dbdd; });
$parcel$export(module.exports, "SET_METRIC_TYPE", function () { return $2849d5c929c56e16$export$d2e7506772279f4e; });
$parcel$export(module.exports, "DISTRIBUTION_METRIC_TYPE", function () { return $2849d5c929c56e16$export$9818d6472d7991f0; });
$parcel$export(module.exports, "NAME_AND_TAG_KEY_NORMALIZATION_REGEX", function () { return $2849d5c929c56e16$export$73db7eda248c6468; });
$parcel$export(module.exports, "TAG_VALUE_NORMALIZATION_REGEX", function () { return $2849d5c929c56e16$export$2699a97e88d47e55; });
$parcel$export(module.exports, "DEFAULT_BROWSER_FLUSH_INTERVAL", function () { return $2849d5c929c56e16$export$9fcf9b73aae4b12; });
const $2849d5c929c56e16$export$ffbd59c90957aeda = "c";
const $2849d5c929c56e16$export$41106537ee4dbdd = "g";
const $2849d5c929c56e16$export$d2e7506772279f4e = "s";
const $2849d5c929c56e16$export$9818d6472d7991f0 = "d";
/**
 * Normalization regex for metric names and metric tag names.
 *
 * This enforces that names and tag keys only contain alphanumeric characters,
 * underscores, forward slashes, periods, and dashes.
 *
 * See: https://develop.sentry.dev/sdk/metrics/#normalization
 */ const $2849d5c929c56e16$export$73db7eda248c6468 = /[^a-zA-Z0-9_/.-]+/g;
/**
 * Normalization regex for metric tag values.
 *
 * This enforces that values only contain words, digits, or the following
 * special characters: _:/@.{}[\]$-
 *
 * See: https://develop.sentry.dev/sdk/metrics/#normalization
 */ const $2849d5c929c56e16$export$2699a97e88d47e55 = /[^\w\d\s_:/@.{}[\]$-]+/g;
/**
 * This does not match spec in https://develop.sentry.dev/sdk/metrics
 * but was chosen to optimize for the most common case in browser environments.
 */ const $2849d5c929c56e16$export$9fcf9b73aae4b12 = 5000;
/**
 * SDKs are required to bucket into 10 second intervals (rollup in seconds)
 * which is the current lower bound of metric accuracy.
 */ const $2849d5c929c56e16$export$8f071e089fcfe0c = 10000;
/**
 * The maximum number of metrics that should be stored in memory.
 */ const $2849d5c929c56e16$export$aa41e9d920739c1a = 10000;

});




parcelRegister("jEn5j", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", function () { return $e4e3a8e3e2634574$export$479dbd817e392a4f; });
$parcel$export(module.exports, "addTracingExtensions", function () { return $e4e3a8e3e2634574$export$653d0ef2bad9cdf9; });

var $7p8hL = parcelRequire("7p8hL");

var $fB2fA = parcelRequire("fB2fA");

var $fxUGN = parcelRequire("fxUGN");

var $4RP7L = parcelRequire("4RP7L");

var $1xsEw = parcelRequire("1xsEw");

var $k6xPV = parcelRequire("k6xPV");

var $g05qq = parcelRequire("g05qq");

var $dmE4i = parcelRequire("dmE4i");
/** Returns all trace headers that are currently on the top scope. */ function $e4e3a8e3e2634574$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, $4RP7L.spanToTraceHeader)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $e4e3a8e3e2634574$var$_startTransaction(transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $dmE4i.Transaction)(transactionContext, this);
    transaction = (0, $g05qq.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $e4e3a8e3e2634574$export$479dbd817e392a4f(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $k6xPV.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $g05qq.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $e4e3a8e3e2634574$export$653d0ef2bad9cdf9() {
    const carrier = (0, $fxUGN.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $e4e3a8e3e2634574$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $e4e3a8e3e2634574$var$traceHeaders;
    (0, $1xsEw.registerErrorInstrumentation)();
}

});
parcelRegister("1xsEw", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", function () { return $11ef1955fda5cb01$export$637857c1d87b640c; });

var $gHATr = parcelRequire("gHATr");
var $a5k97 = parcelRequire("a5k97");
var $7p8hL = parcelRequire("7p8hL");

var $fB2fA = parcelRequire("fB2fA");

var $7flMU = parcelRequire("7flMU");
let $11ef1955fda5cb01$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $11ef1955fda5cb01$export$637857c1d87b640c() {
    if ($11ef1955fda5cb01$var$errorsInstrumented) return;
    $11ef1955fda5cb01$var$errorsInstrumented = true;
    (0, $gHATr.addGlobalErrorInstrumentationHandler)($11ef1955fda5cb01$var$errorCallback);
    (0, $a5k97.addGlobalUnhandledRejectionInstrumentationHandler)($11ef1955fda5cb01$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $11ef1955fda5cb01$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $7flMU.getActiveTransaction)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$11ef1955fda5cb01$var$errorCallback.tag = "sentry_tracingErrorCallback";

});
parcelRegister("gHATr", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $c28d47b27d6ca1cc$export$55b5c3ba2194f0c6; });

var $lNVQ9 = parcelRequire("lNVQ9");

var $7P0P8 = parcelRequire("7P0P8");
let $c28d47b27d6ca1cc$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c28d47b27d6ca1cc$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $7P0P8.addHandler)(type, handler);
    (0, $7P0P8.maybeInstrument)(type, $c28d47b27d6ca1cc$var$instrumentError);
}
function $c28d47b27d6ca1cc$var$instrumentError() {
    $c28d47b27d6ca1cc$var$_oldOnErrorHandler = (0, $lNVQ9.GLOBAL_OBJ).onerror;
    (0, $lNVQ9.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $7P0P8.triggerHandlers)("error", handlerData);
        if ($c28d47b27d6ca1cc$var$_oldOnErrorHandler && !$c28d47b27d6ca1cc$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $c28d47b27d6ca1cc$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $lNVQ9.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("7P0P8", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $5b1def6d87c54391$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $5b1def6d87c54391$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $5b1def6d87c54391$export$b18c893e424d3127; });

var $aY8mH = parcelRequire("aY8mH");

var $7p8hL = parcelRequire("7p8hL");

var $kEJYx = parcelRequire("kEJYx");
// We keep the handlers globally
const $5b1def6d87c54391$var$handlers = {};
const $5b1def6d87c54391$var$instrumented = {};
/** Add a handler function. */ function $5b1def6d87c54391$export$a4e09611e30da72e(type, handler) {
    $5b1def6d87c54391$var$handlers[type] = $5b1def6d87c54391$var$handlers[type] || [];
    $5b1def6d87c54391$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $5b1def6d87c54391$export$b17eab759a1cb5fe() {
    Object.keys($5b1def6d87c54391$var$handlers).forEach((key)=>{
        $5b1def6d87c54391$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $5b1def6d87c54391$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$5b1def6d87c54391$var$instrumented[type]) {
        instrumentFn();
        $5b1def6d87c54391$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $5b1def6d87c54391$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $5b1def6d87c54391$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $aY8mH.DEBUG_BUILD) && (0, $7p8hL.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $kEJYx.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("a5k97", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $7579ff9df4211b1b$export$8bf4fc6858821a4e; });

var $lNVQ9 = parcelRequire("lNVQ9");

var $7P0P8 = parcelRequire("7P0P8");
let $7579ff9df4211b1b$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7579ff9df4211b1b$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $7P0P8.addHandler)(type, handler);
    (0, $7P0P8.maybeInstrument)(type, $7579ff9df4211b1b$var$instrumentUnhandledRejection);
}
function $7579ff9df4211b1b$var$instrumentUnhandledRejection() {
    $7579ff9df4211b1b$var$_oldOnUnhandledRejectionHandler = (0, $lNVQ9.GLOBAL_OBJ).onunhandledrejection;
    (0, $lNVQ9.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $7P0P8.triggerHandlers)("unhandledrejection", handlerData);
        if ($7579ff9df4211b1b$var$_oldOnUnhandledRejectionHandler && !$7579ff9df4211b1b$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $7579ff9df4211b1b$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $lNVQ9.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("7flMU", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", function () { return $546ad5ba9b4ef3c7$export$a7feb32fdd923295; });
$parcel$export(module.exports, "extractTraceparentData", function () { return $546ad5ba9b4ef3c7$export$8e9a29865c0a1226; });

var $6jMr3 = parcelRequire("6jMr3");

var $fxUGN = parcelRequire("fxUGN");
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ function $546ad5ba9b4ef3c7$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $fxUGN.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $546ad5ba9b4ef3c7$export$8e9a29865c0a1226 = (0, $6jMr3.extractTraceparentData);

});


parcelRegister("k6xPV", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", function () { return $ea2e9d667fef2991$export$809a2b7987fd5306; });
$parcel$export(module.exports, "IdleTransaction", function () { return $ea2e9d667fef2991$export$b279e6bd7040371f; });

var $7p8hL = parcelRequire("7p8hL");
var $iGf0k = parcelRequire("iGf0k");

var $fB2fA = parcelRequire("fB2fA");

var $4RP7L = parcelRequire("4RP7L");

var $5mTXR = parcelRequire("5mTXR");

var $dmE4i = parcelRequire("dmE4i");
const $ea2e9d667fef2991$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $ea2e9d667fef2991$var$FINISH_REASON_TAG = "finishReason";
const $ea2e9d667fef2991$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $ea2e9d667fef2991$export$370d6113c18ba86c extends (0, $5mTXR.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $4RP7L.spanToJSON)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $ea2e9d667fef2991$export$b279e6bd7040371f extends (0, $dmE4i.Transaction) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $ea2e9d667fef2991$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $ea2e9d667fef2991$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $ea2e9d667fef2991$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $ea2e9d667fef2991$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $ea2e9d667fef2991$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $4RP7L.spanTimeInputToSeconds)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute($ea2e9d667fef2991$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $fB2fA.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
            (0, $7p8hL.logger).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $4RP7L.spanToJSON)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $4RP7L.spanToJSON)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $fB2fA.DEBUG_BUILD) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $7p8hL.logger).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $7p8hL.logger).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Tracing] flushing IdleTransaction");
        } else (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $ea2e9d667fef2991$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $ea2e9d667fef2991$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $ea2e9d667fef2991$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $iGf0k.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $ea2e9d667fef2991$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = $ea2e9d667fef2991$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRegister("5mTXR", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", function () { return $3e8a6b35cd55fe76$export$10c95c129cd0d4fe; });
$parcel$export(module.exports, "Span", function () { return $3e8a6b35cd55fe76$export$5f1714a13ed34c01; });

var $aajbp = parcelRequire("aajbp");
var $7p8hL = parcelRequire("7p8hL");
var $iGf0k = parcelRequire("iGf0k");
var $iJH3x = parcelRequire("iJH3x");

var $fB2fA = parcelRequire("fB2fA");

var $cmAk3 = parcelRequire("cmAk3");

var $kuS4l = parcelRequire("kuS4l");

var $7oVpT = parcelRequire("7oVpT");

var $4RP7L = parcelRequire("4RP7L");

var $bMwjP = parcelRequire("bMwjP");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $3e8a6b35cd55fe76$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $3e8a6b35cd55fe76$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $iJH3x.uuid4)();
        this._spanId = spanContext.spanId || (0, $iJH3x.uuid4)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $iGf0k.timestampInSeconds)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        this.setAttributes({
            [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanContext.origin || "manual",
            [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $4RP7L.TRACE_FLAG_SAMPLED) : (0, $4RP7L.TRACE_FLAG_NONE)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $3e8a6b35cd55fe76$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $7oVpT.getRootSpan)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $fB2fA.DEBUG_BUILD) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, $4RP7L.spanToJSON)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $7p8hL.logger).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $bMwjP.setHttpStatus)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $7oVpT.getRootSpan)(this);
        if ((0, $fB2fA.DEBUG_BUILD) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $7p8hL.logger).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, $4RP7L.spanTimeInputToSeconds)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $4RP7L.spanToTraceHeader)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $aajbp.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $4RP7L.spanToTraceContext)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $aajbp.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            _metrics_summary: (0, $cmAk3.getMetricSummaryJsonForSpan)(this),
            profile_id: this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}

});
parcelRegister("cmAk3", function(module, exports) {

$parcel$export(module.exports, "getMetricSummaryJsonForSpan", function () { return $9003b6fbb48e37a6$export$2e7205e45c58797d; });
$parcel$export(module.exports, "updateMetricSummaryOnActiveSpan", function () { return $9003b6fbb48e37a6$export$aefd1a302602f922; });

var $aajbp = parcelRequire("aajbp");




var $mtWu0 = parcelRequire("mtWu0");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $9003b6fbb48e37a6$var$SPAN_METRIC_SUMMARY;
function $9003b6fbb48e37a6$var$getMetricStorageForSpan(span) {
    return $9003b6fbb48e37a6$var$SPAN_METRIC_SUMMARY ? $9003b6fbb48e37a6$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $9003b6fbb48e37a6$export$2e7205e45c58797d(span) {
    const storage = $9003b6fbb48e37a6$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $aajbp.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $9003b6fbb48e37a6$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $mtWu0.getActiveSpan)();
    if (span) {
        const storage = $9003b6fbb48e37a6$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$9003b6fbb48e37a6$var$SPAN_METRIC_SUMMARY) $9003b6fbb48e37a6$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $9003b6fbb48e37a6$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}

});
parcelRegister("mtWu0", function(module, exports) {

$parcel$export(module.exports, "trace", function () { return $04394819c9fca2e2$export$357889f174732d38; });
$parcel$export(module.exports, "startSpan", function () { return $04394819c9fca2e2$export$a1bd95187356f372; });
$parcel$export(module.exports, "startSpanManual", function () { return $04394819c9fca2e2$export$c10292ad04b92aea; });
$parcel$export(module.exports, "startInactiveSpan", function () { return $04394819c9fca2e2$export$63dbba021a6b4047; });
$parcel$export(module.exports, "getActiveSpan", function () { return $04394819c9fca2e2$export$1be426a8e585c83e; });
$parcel$export(module.exports, "continueTrace", function () { return $04394819c9fca2e2$export$d2ee9b39b25437b3; });
$parcel$export(module.exports, "getCapturedScopesOnSpan", function () { return $04394819c9fca2e2$export$c08fbc656a245d03; });

var $aajbp = parcelRequire("aajbp");
var $7p8hL = parcelRequire("7p8hL");
var $6jMr3 = parcelRequire("6jMr3");

var $fB2fA = parcelRequire("fB2fA");

var $fxUGN = parcelRequire("fxUGN");

var $4RP7L = parcelRequire("4RP7L");



var $2Grcj = parcelRequire("2Grcj");

var $hcepo = parcelRequire("hcepo");

var $beBC9 = parcelRequire("beBC9");

var $2aCxe = parcelRequire("2aCxe");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $04394819c9fca2e2$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $fxUGN.getCurrentHub)();
    const scope = (0, $hcepo.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $04394819c9fca2e2$var$normalizeContext(context);
    const activeSpan = $04394819c9fca2e2$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $beBC9.handleCallbackErrors)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $04394819c9fca2e2$export$a1bd95187356f372(context, callback) {
    const spanContext = $04394819c9fca2e2$var$normalizeContext(context);
    return (0, $fxUGN.runWithAsyncContext)(()=>{
        return (0, $hcepo.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $fxUGN.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $04394819c9fca2e2$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $beBC9.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $4RP7L.spanToJSON)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $04394819c9fca2e2$export$cb9e396e6b90b703 = $04394819c9fca2e2$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $04394819c9fca2e2$export$c10292ad04b92aea(context, callback) {
    const spanContext = $04394819c9fca2e2$var$normalizeContext(context);
    return (0, $fxUGN.runWithAsyncContext)(()=>{
        return (0, $hcepo.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $fxUGN.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $04394819c9fca2e2$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $beBC9.handleCallbackErrors)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $4RP7L.spanToJSON)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $04394819c9fca2e2$export$63dbba021a6b4047(context) {
    if (!(0, $2aCxe.hasTracingEnabled)()) return undefined;
    const spanContext = $04394819c9fca2e2$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $fxUGN.getCurrentHub)();
    const parentSpan = context.scope ? context.scope.getSpan() : $04394819c9fca2e2$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $hcepo.getCurrentScope)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $04394819c9fca2e2$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $04394819c9fca2e2$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $hcepo.getCurrentScope)().getSpan();
}
const $04394819c9fca2e2$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $hcepo.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $6jMr3.tracingContextFromHeaders)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $fB2fA.DEBUG_BUILD) && traceparentData) (0, $7p8hL.logger).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $aajbp.dropUndefinedKeys)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $fxUGN.runWithAsyncContext)(()=>{
        return callback(transactionContext);
    });
};
function $04394819c9fca2e2$var$createChildSpanOrTransaction(hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $2aCxe.hasTracingEnabled)()) return undefined;
    const isolationScope = (0, $fxUGN.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $2Grcj.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $4RP7L.spanIsSampled)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $04394819c9fca2e2$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $04394819c9fca2e2$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $4RP7L.spanTimeInputToSeconds)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $04394819c9fca2e2$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $04394819c9fca2e2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $04394819c9fca2e2$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $aajbp.addNonEnumerableProperty)(span, $04394819c9fca2e2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $aajbp.addNonEnumerableProperty)(span, $04394819c9fca2e2$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $04394819c9fca2e2$export$c08fbc656a245d03(span) {
    return {
        scope: span[$04394819c9fca2e2$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$04394819c9fca2e2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});
parcelRegister("beBC9", function(module, exports) {

$parcel$export(module.exports, "handleCallbackErrors", function () { return $82de2df3e42e6522$export$18ce21a8b7efd7e9; });

var $jPeZ4 = parcelRequire("jPeZ4");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $82de2df3e42e6522$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $82de2df3e42e6522$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $82de2df3e42e6522$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $jPeZ4.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("2aCxe", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", function () { return $194a682d594ef3a5$export$5008da00b1b6dee6; });

var $hcepo = parcelRequire("hcepo");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $194a682d594ef3a5$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $hcepo.getClient)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}

});



parcelRegister("kuS4l", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $eec08cf4a9d1f728$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $eec08cf4a9d1f728$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $eec08cf4a9d1f728$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $eec08cf4a9d1f728$export$cca8dd30f57f805e; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function () { return $eec08cf4a9d1f728$export$1efec95406bbe327; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $eec08cf4a9d1f728$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $eec08cf4a9d1f728$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $eec08cf4a9d1f728$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $eec08cf4a9d1f728$export$cca8dd30f57f805e = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ const $eec08cf4a9d1f728$export$1efec95406bbe327 = "profile_id";

});

parcelRegister("bMwjP", function(module, exports) {

$parcel$export(module.exports, "getSpanStatusFromHttpCode", function () { return $893d3f3f26c160d8$export$5fd4dc48a2131589; });
$parcel$export(module.exports, "spanStatusfromHttpCode", function () { return $893d3f3f26c160d8$export$ac65c70d78fcdb55; });
$parcel$export(module.exports, "setHttpStatus", function () { return $893d3f3f26c160d8$export$2ad6630ec8164254; });
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $893d3f3f26c160d8$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($893d3f3f26c160d8$export$beb8e6a823e89c5d || ($893d3f3f26c160d8$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $893d3f3f26c160d8$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $893d3f3f26c160d8$export$ac65c70d78fcdb55 = $893d3f3f26c160d8$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $893d3f3f26c160d8$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    const spanStatus = $893d3f3f26c160d8$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== "unknown_error") span.setStatus(spanStatus);
}

});


parcelRegister("dmE4i", function(module, exports) {

$parcel$export(module.exports, "Transaction", function () { return $9bac6924de9644f4$export$febc5573c75cefb0; });

var $aajbp = parcelRequire("aajbp");
var $7p8hL = parcelRequire("7p8hL");

var $fB2fA = parcelRequire("fB2fA");

var $fxUGN = parcelRequire("fxUGN");

var $cmAk3 = parcelRequire("cmAk3");

var $kuS4l = parcelRequire("kuS4l");

var $4RP7L = parcelRequire("4RP7L");

var $2Grcj = parcelRequire("2Grcj");

var $5mTXR = parcelRequire("5mTXR");

var $mtWu0 = parcelRequire("mtWu0");
/** JSDoc */ class $9bac6924de9644f4$export$febc5573c75cefb0 extends (0, $5mTXR.Span) {
    /**
   * The reference to the current hub.
   */ // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $fxUGN.getCurrentHub)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
                source: this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
            },
            ...this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
                sampleRate: this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $5mTXR.SpanRecorder)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $4RP7L.spanTimeInputToSeconds)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $aajbp.dropUndefinedKeys)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $2Grcj.getDynamicSamplingContextFromSpan)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts["profile"] !== undefined) return this._contexts["profile"].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $4RP7L.spanToJSON)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $4RP7L.spanToJSON)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $mtWu0.getCapturedScopesOnSpan)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $4RP7L.spanToTraceContext)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $aajbp.dropUndefinedKeys)({
                    dynamicSamplingContext: (0, $2Grcj.getDynamicSamplingContextFromSpan)(this)
                })
            },
            _metrics_summary: (0, $cmAk3.getMetricSummaryJsonForSpan)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}

});


parcelRegister("g05qq", function(module, exports) {

$parcel$export(module.exports, "sampleTransaction", function () { return $ba60dac5bdaeb625$export$b3258c3993bc9b71; });
$parcel$export(module.exports, "isValidSampleRate", function () { return $ba60dac5bdaeb625$export$2603c8d332a51c42; });

var $jPeZ4 = parcelRequire("jPeZ4");
var $7p8hL = parcelRequire("7p8hL");

var $fB2fA = parcelRequire("fB2fA");

var $kuS4l = parcelRequire("kuS4l");

var $2aCxe = parcelRequire("2aCxe");

var $4RP7L = parcelRequire("4RP7L");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $ba60dac5bdaeb625$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $2aCxe.hasTracingEnabled)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$ba60dac5bdaeb625$export$2603c8d332a51c42(sampleRate)) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $fB2fA.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
    (0, $7p8hL.logger).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $4RP7L.spanToJSON)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $ba60dac5bdaeb625$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $jPeZ4.isNaN)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}

});


parcelRegister("kcgw9", function(module, exports) {

$parcel$export(module.exports, "createTransport", function () { return $eb41bdb1959aeb17$export$d09f50d9ab7f7b69; });

var $2pR2a = parcelRequire("2pR2a");
var $3iBML = parcelRequire("3iBML");
var $7p8hL = parcelRequire("7p8hL");
var $5JTUi = parcelRequire("5JTUi");
var $amxcu = parcelRequire("amxcu");
var $1BeOm = parcelRequire("1BeOm");

var $fB2fA = parcelRequire("fB2fA");
const $eb41bdb1959aeb17$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $eb41bdb1959aeb17$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $5JTUi.makePromiseBuffer)(options.bufferSize || $eb41bdb1959aeb17$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $2pR2a.forEachEnvelopeItem)(envelope, (item, type)=>{
            const envelopeItemDataCategory = (0, $2pR2a.envelopeItemTypeToDataCategory)(type);
            if ((0, $3iBML.isRateLimited)(rateLimits, envelopeItemDataCategory)) {
                const event = $eb41bdb1959aeb17$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", envelopeItemDataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $amxcu.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $2pR2a.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $2pR2a.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $eb41bdb1959aeb17$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $2pR2a.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $2pR2a.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $3iBML.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $1BeOm.SentryError)) {
                (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $amxcu.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $eb41bdb1959aeb17$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

});
parcelRegister("3iBML", function(module, exports) {

$parcel$export(module.exports, "parseRetryAfterHeader", function () { return $26705cf24c573ca3$export$615352e17ed7741; });
$parcel$export(module.exports, "isRateLimited", function () { return $26705cf24c573ca3$export$6c91fec22056810a; });
$parcel$export(module.exports, "updateRateLimits", function () { return $26705cf24c573ca3$export$699aff705e0d49d4; });
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $26705cf24c573ca3$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $26705cf24c573ca3$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $26705cf24c573ca3$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $26705cf24c573ca3$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $26705cf24c573ca3$export$6c91fec22056810a(limits, category, now = Date.now()) {
    return $26705cf24c573ca3$export$b89fc7b2e4c799e7(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $26705cf24c573ca3$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories] = limit.split(":", 2);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";"))updatedRateLimits[category] = now + delay;
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $26705cf24c573ca3$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});

parcelRegister("5JTUi", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", function () { return $42dc85ac8fbeb3b6$export$85a4f67f852183e6; });

var $1BeOm = parcelRequire("1BeOm");

var $amxcu = parcelRequire("amxcu");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $42dc85ac8fbeb3b6$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $amxcu.rejectedSyncPromise)(new (0, $1BeOm.SentryError)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $amxcu.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $amxcu.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});


parcelRegister("5Bu1f", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", function () { return $4147b1a48574d3e2$export$7918117e9202e4fb; });
$parcel$export(module.exports, "FunctionToString", function () { return $4147b1a48574d3e2$export$da4704525c20ae79; });

var $aajbp = parcelRequire("aajbp");

var $hcepo = parcelRequire("hcepo");

var $genhe = parcelRequire("genhe");
let $4147b1a48574d3e2$var$originalFunctionToString;
const $4147b1a48574d3e2$var$INTEGRATION_NAME = "FunctionToString";
const $4147b1a48574d3e2$var$SETUP_CLIENTS = new WeakMap();
const $4147b1a48574d3e2$var$_functionToStringIntegration = ()=>{
    return {
        name: $4147b1a48574d3e2$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $4147b1a48574d3e2$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $aajbp.getOriginalFunction)(this);
                    const context = $4147b1a48574d3e2$var$SETUP_CLIENTS.has((0, $hcepo.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $4147b1a48574d3e2$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $4147b1a48574d3e2$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $4147b1a48574d3e2$export$7918117e9202e4fb = (0, $genhe.defineIntegration)($4147b1a48574d3e2$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $4147b1a48574d3e2$export$da4704525c20ae79 = (0, $genhe.convertIntegrationFnToClass)($4147b1a48574d3e2$var$INTEGRATION_NAME, $4147b1a48574d3e2$export$7918117e9202e4fb);

});

parcelRegister("cCK0h", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", function () { return $930cb7fdff5cd696$export$cb3c5c2ceb9818ba; });
$parcel$export(module.exports, "InboundFilters", function () { return $930cb7fdff5cd696$export$2ffbb5359dcc6be4; });

var $iJH3x = parcelRequire("iJH3x");
var $7p8hL = parcelRequire("7p8hL");
var $bMiqE = parcelRequire("bMiqE");

var $fB2fA = parcelRequire("fB2fA");

var $genhe = parcelRequire("genhe");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $930cb7fdff5cd696$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
const $930cb7fdff5cd696$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $930cb7fdff5cd696$var$INTEGRATION_NAME = "InboundFilters";
const $930cb7fdff5cd696$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $930cb7fdff5cd696$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $930cb7fdff5cd696$var$_mergeOptions(options, clientOptions);
            return $930cb7fdff5cd696$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $930cb7fdff5cd696$export$cb3c5c2ceb9818ba = (0, $genhe.defineIntegration)($930cb7fdff5cd696$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $930cb7fdff5cd696$export$2ffbb5359dcc6be4 = (0, $genhe.convertIntegrationFnToClass)($930cb7fdff5cd696$var$INTEGRATION_NAME, $930cb7fdff5cd696$export$cb3c5c2ceb9818ba);
function $930cb7fdff5cd696$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $930cb7fdff5cd696$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $930cb7fdff5cd696$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $930cb7fdff5cd696$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $930cb7fdff5cd696$var$_isSentryError(event)) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $iJH3x.getEventDescription)(event)}`);
        return true;
    }
    if ($930cb7fdff5cd696$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $iJH3x.getEventDescription)(event)}`);
        return true;
    }
    if ($930cb7fdff5cd696$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $iJH3x.getEventDescription)(event)}`);
        return true;
    }
    if ($930cb7fdff5cd696$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $iJH3x.getEventDescription)(event)}.\nUrl: ${$930cb7fdff5cd696$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$930cb7fdff5cd696$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $iJH3x.getEventDescription)(event)}.\nUrl: ${$930cb7fdff5cd696$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $930cb7fdff5cd696$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $930cb7fdff5cd696$var$_getPossibleEventMessages(event).some((message)=>(0, $bMiqE.stringMatchesSomePattern)(message, ignoreErrors));
}
function $930cb7fdff5cd696$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $bMiqE.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $930cb7fdff5cd696$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $930cb7fdff5cd696$var$_getEventFilterUrl(event);
    return !url ? false : (0, $bMiqE.stringMatchesSomePattern)(url, denyUrls);
}
function $930cb7fdff5cd696$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $930cb7fdff5cd696$var$_getEventFilterUrl(event);
    return !url ? true : (0, $bMiqE.stringMatchesSomePattern)(url, allowUrls);
}
function $930cb7fdff5cd696$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $fB2fA.DEBUG_BUILD) && possibleMessages.length === 0) (0, $7p8hL.logger).error(`Could not extract message for event ${(0, $iJH3x.getEventDescription)(event)}`);
    return possibleMessages;
}
function $930cb7fdff5cd696$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $930cb7fdff5cd696$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $930cb7fdff5cd696$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $930cb7fdff5cd696$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).error(`Cannot extract url for event ${(0, $iJH3x.getEventDescription)(event)}`);
        return null;
    }
}

});

parcelRegister("gEBGI", function(module, exports) {

$parcel$export(module.exports, "Integrations", function () { return $c1fd9dd14703de13$export$99d02219d259eb94; });

var $jEn5j = parcelRequire("jEn5j");

var $k6xPV = parcelRequire("k6xPV");

var $5mTXR = parcelRequire("5mTXR");


var $7flMU = parcelRequire("7flMU");

var $bMwjP = parcelRequire("bMwjP");

var $mtWu0 = parcelRequire("mtWu0");

var $2Grcj = parcelRequire("2Grcj");

var $g6vjT = parcelRequire("g6vjT");

var $g05qq = parcelRequire("g05qq");

var $kuS4l = parcelRequire("kuS4l");

var $16rrK = parcelRequire("16rrK");

var $hcepo = parcelRequire("hcepo");

var $fxUGN = parcelRequire("fxUGN");



var $2W3Nl = parcelRequire("2W3Nl");

var $jXhtG = parcelRequire("jXhtG");

var $eua5O = parcelRequire("eua5O");

var $huK8b = parcelRequire("huK8b");


var $dKXuR = parcelRequire("dKXuR");

var $kcgw9 = parcelRequire("kcgw9");

var $9LClL = parcelRequire("9LClL");

var $kDOUc = parcelRequire("kDOUc");

var $fIs9O = parcelRequire("fIs9O");

var $genhe = parcelRequire("genhe");


var $5XnTz = parcelRequire("5XnTz");


var $3U98K = parcelRequire("3U98K");

var $2aCxe = parcelRequire("2aCxe");

var $djmte = parcelRequire("djmte");


var $fTge7 = parcelRequire("fTge7");

var $4RP7L = parcelRequire("4RP7L");

var $7oVpT = parcelRequire("7oVpT");

var $5M0hM = parcelRequire("5M0hM");

var $kNF8J = parcelRequire("kNF8J");

var $3rOP2 = parcelRequire("3rOP2");


var $cCK0h = parcelRequire("cCK0h");

var $5Bu1f = parcelRequire("5Bu1f");


var $dmm8E = parcelRequire("dmm8E");

var $kxfHu = parcelRequire("kxfHu");
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $c1fd9dd14703de13$export$99d02219d259eb94 = $dmm8E;

});
parcelRegister("g6vjT", function(module, exports) {

$parcel$export(module.exports, "setMeasurement", function () { return $bb9580602b83b405$export$7cc31b475d33a706; });

var $7flMU = parcelRequire("7flMU");
/**
 * Adds a measurement to the current active transaction.
 */ function $bb9580602b83b405$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $7flMU.getActiveTransaction)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}

});

parcelRegister("dKXuR", function(module, exports) {

$parcel$export(module.exports, "initAndBind", function () { return $a03db910823c75f8$export$5333c3f1c58d9bc1; });
$parcel$export(module.exports, "setCurrentClient", function () { return $a03db910823c75f8$export$ecb76f41d43c0e43; });

var $7p8hL = parcelRequire("7p8hL");

var $fB2fA = parcelRequire("fB2fA");

var $hcepo = parcelRequire("hcepo");

var $fxUGN = parcelRequire("fxUGN");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $a03db910823c75f8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $fB2fA.DEBUG_BUILD) (0, $7p8hL.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $7p8hL.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $hcepo.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $a03db910823c75f8$export$ecb76f41d43c0e43(client);
    $a03db910823c75f8$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $a03db910823c75f8$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $fxUGN.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $a03db910823c75f8$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}

});

parcelRegister("9LClL", function(module, exports) {

$parcel$export(module.exports, "makeOfflineTransport", function () { return $71c6405903cef811$export$405ec66a0e87547a; });

var $2pR2a = parcelRequire("2pR2a");
var $7p8hL = parcelRequire("7p8hL");
var $3iBML = parcelRequire("3iBML");

var $fB2fA = parcelRequire("fB2fA");
const $71c6405903cef811$export$638fddefcf0452da = 100; // 100 ms
const $71c6405903cef811$export$998db03eaf5cf3f3 = 5000; // 5 seconds
const $71c6405903cef811$var$MAX_DELAY = 3.6e6; // 1 hour
function $71c6405903cef811$var$log(msg, error) {
    (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).info(`[Offline]: ${msg}`, error);
}
/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */ function $71c6405903cef811$export$405ec66a0e87547a(createTransport) {
    return (options)=>{
        const transport = createTransport(options);
        const store = options.createStore ? options.createStore(options) : undefined;
        let retryDelay = $71c6405903cef811$export$998db03eaf5cf3f3;
        let flushTimer;
        function shouldQueue(env, error, retryDelay) {
            // We don't queue Session Replay envelopes because they are:
            // - Ordered and Replay relies on the response status to know when they're successfully sent.
            // - Likely to fill the queue quickly and block other events from being sent.
            // We also want to drop client reports because they can be generated when we retry sending events while offline.
            if ((0, $2pR2a.envelopeContainsItemType)(env, [
                "replay_event",
                "replay_recording",
                "client_report"
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay);
            return true;
        }
        function flushIn(delay) {
            if (!store) return;
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = setTimeout(async ()=>{
                flushTimer = undefined;
                const found = await store.pop();
                if (found) {
                    $71c6405903cef811$var$log("Attempting to send previously queued event");
                    send(found).catch((e)=>{
                        $71c6405903cef811$var$log("Failed to retry sending", e);
                    });
                }
            }, delay);
            // We need to unref the timer in node.js, otherwise the node process never exit.
            if (typeof flushTimer !== "number" && flushTimer.unref) flushTimer.unref();
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $71c6405903cef811$var$MAX_DELAY);
        }
        async function send(envelope) {
            try {
                const result = await transport.send(envelope);
                let delay = $71c6405903cef811$export$638fddefcf0452da;
                if (result) {
                    // If there's a retry-after header, use that as the next delay.
                    if (result.headers && result.headers["retry-after"]) delay = (0, $3iBML.parseRetryAfterHeader)(result.headers["retry-after"]);
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $71c6405903cef811$export$998db03eaf5cf3f3;
                return result;
            } catch (e) {
                if (store && await shouldQueue(envelope, e, retryDelay)) {
                    await store.insert(envelope);
                    flushWithBackOff();
                    $71c6405903cef811$var$log("Error sending. Event queued", e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (t)=>transport.flush(t)
        };
    };
}

});

parcelRegister("kDOUc", function(module, exports) {

$parcel$export(module.exports, "makeMultiplexedTransport", function () { return $f06eeff131967b99$export$53bbcd410607e756; });

var $i8Xwi = parcelRequire("i8Xwi");
var $2pR2a = parcelRequire("2pR2a");

var $eua5O = parcelRequire("eua5O");
/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */ function $f06eeff131967b99$export$b92f55f7516d9100(env, types) {
    let event;
    (0, $2pR2a.forEachEnvelopeItem)(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : undefined;
        // bail out if we found an event
        return !!event;
    });
    return event;
}
/**
 * Creates a transport that overrides the release on all events.
 */ function $f06eeff131967b99$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            send: async (envelope)=>{
                const event = $f06eeff131967b99$export$b92f55f7516d9100(envelope, [
                    "event",
                    "transaction",
                    "profile",
                    "replay_event"
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            },
            flush: (timeout)=>transport.flush(timeout)
        };
    };
}
/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */ function $f06eeff131967b99$export$53bbcd410607e756(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = {};
        function getTransport(dsn, release) {
            // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
            // use at the same time
            const key = release ? `${dsn}:${release}` : dsn;
            if (!otherTransports[key]) {
                const validatedDsn = (0, $i8Xwi.dsnFromString)(dsn);
                if (!validatedDsn) return undefined;
                const url = (0, $eua5O.getEnvelopeEndpointWithUrlEncodedAuth)(validatedDsn);
                otherTransports[key] = release ? $f06eeff131967b99$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
            }
            return otherTransports[key];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types && types.length ? types : [
                    "event"
                ];
                return $f06eeff131967b99$export$b92f55f7516d9100(envelope, eventTypes);
            }
            const transports = matcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === "string") return getTransport(result, undefined);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            // If we have no transports to send to, use the fallback transport
            if (transports.length === 0) transports.push(fallbackTransport);
            const results = await Promise.all(transports.map((transport)=>transport.send(envelope)));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...Object.keys(otherTransports).map((dsn)=>otherTransports[dsn]),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}

});

parcelRegister("3U98K", function(module, exports) {

$parcel$export(module.exports, "createSpanEnvelope", function () { return $2d7db119720b7a5c$export$19a0081d4b39d77; });

var $2pR2a = parcelRequire("2pR2a");
/**
 * Create envelope from Span item.
 */ function $2d7db119720b7a5c$export$19a0081d4b39d77(spans) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    const items = spans.map($2d7db119720b7a5c$var$createSpanItem);
    return (0, $2pR2a.createEnvelope)(headers, items);
}
function $2d7db119720b7a5c$var$createSpanItem(span) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}

});

parcelRegister("djmte", function(module, exports) {

$parcel$export(module.exports, "isSentryRequestUrl", function () { return $9b0e7ae41199fe5a$export$d92e61f5600202af; });
/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ function $9b0e7ae41199fe5a$export$d92e61f5600202af(url, hubOrClient) {
    const client = hubOrClient && $9b0e7ae41199fe5a$var$isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $9b0e7ae41199fe5a$var$checkDsn(url, dsn) || $9b0e7ae41199fe5a$var$checkTunnel(url, tunnel);
}
function $9b0e7ae41199fe5a$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $9b0e7ae41199fe5a$var$removeTrailingSlash(url) === $9b0e7ae41199fe5a$var$removeTrailingSlash(tunnel);
}
function $9b0e7ae41199fe5a$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $9b0e7ae41199fe5a$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
function $9b0e7ae41199fe5a$var$isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}

});

parcelRegister("fTge7", function(module, exports) {

$parcel$export(module.exports, "parameterize", function () { return $b918945e0af0b410$export$4cb5eb704d6ec224; });
/**
 * Tagged template function which returns paramaterized representation of the message
 * For example: parameterize`This is a log statement with ${x} and ${y} params`, would return:
 * "__sentry_template_string__": 'This is a log statement with %s and %s params',
 * "__sentry_template_values__": ['first', 'second']
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 * @returns String with template information in __sentry_template_string__ and __sentry_template_values__ properties
 */ function $b918945e0af0b410$export$4cb5eb704d6ec224(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join("\x00").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}

});

parcelRegister("5M0hM", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", function () { return $4341a82d22959d45$export$b9f95b027256052c; });

var $fIs9O = parcelRequire("fIs9O");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $4341a82d22959d45$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $fIs9O.SDK_VERSION)
            })),
        version: (0, $fIs9O.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("3rOP2", function(module, exports) {

$parcel$export(module.exports, "moduleMetadataIntegration", function () { return $282b50ec94663ad3$export$b3b128c3ae01ded0; });
$parcel$export(module.exports, "ModuleMetadata", function () { return $282b50ec94663ad3$export$6cd9b4efeff4101a; });

var $2pR2a = parcelRequire("2pR2a");

var $genhe = parcelRequire("genhe");

var $aUFOR = parcelRequire("aUFOR");
const $282b50ec94663ad3$var$INTEGRATION_NAME = "ModuleMetadata";
const $282b50ec94663ad3$var$_moduleMetadataIntegration = ()=>{
    return {
        name: $282b50ec94663ad3$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (typeof client.on !== "function") return;
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on("beforeEnvelope", (envelope)=>{
                (0, $2pR2a.forEachEnvelopeItem)(envelope, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            (0, $aUFOR.stripMetadataFromStackFrames)(event);
                            item[1] = event;
                        }
                    }
                });
            });
        },
        processEvent (event, _hint, client) {
            const stackParser = client.getOptions().stackParser;
            (0, $aUFOR.addMetadataToStackFrames)(stackParser, event);
            return event;
        }
    };
};
const $282b50ec94663ad3$export$b3b128c3ae01ded0 = (0, $genhe.defineIntegration)($282b50ec94663ad3$var$_moduleMetadataIntegration);
/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 *
 * @deprecated Use `moduleMetadataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $282b50ec94663ad3$export$6cd9b4efeff4101a = (0, $genhe.convertIntegrationFnToClass)($282b50ec94663ad3$var$INTEGRATION_NAME, $282b50ec94663ad3$export$b3b128c3ae01ded0);

});
parcelRegister("aUFOR", function(module, exports) {

$parcel$export(module.exports, "addMetadataToStackFrames", function () { return $020ce576ccb94c96$export$94b52ecabddf6844; });
$parcel$export(module.exports, "stripMetadataFromStackFrames", function () { return $020ce576ccb94c96$export$5d4932fac9735eed; });

var $lNVQ9 = parcelRequire("lNVQ9");
/** Keys are source filename/url, values are metadata objects. */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $020ce576ccb94c96$var$filenameMetadataMap = new Map();
/** Set of stack strings that have already been parsed. */ const $020ce576ccb94c96$var$parsedStacks = new Set();
function $020ce576ccb94c96$var$ensureMetadataStacksAreParsed(parser) {
    if (!(0, $lNVQ9.GLOBAL_OBJ)._sentryModuleMetadata) return;
    for (const stack of Object.keys((0, $lNVQ9.GLOBAL_OBJ)._sentryModuleMetadata)){
        const metadata = (0, $lNVQ9.GLOBAL_OBJ)._sentryModuleMetadata[stack];
        if ($020ce576ccb94c96$var$parsedStacks.has(stack)) continue;
        // Ensure this stack doesn't get parsed again
        $020ce576ccb94c96$var$parsedStacks.add(stack);
        const frames = parser(stack);
        // Go through the frames starting from the top of the stack and find the first one with a filename
        for (const frame of frames.reverse())if (frame.filename) {
            // Save the metadata for this filename
            $020ce576ccb94c96$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $020ce576ccb94c96$export$fb4062399a51f94a(parser, filename) {
    $020ce576ccb94c96$var$ensureMetadataStacksAreParsed(parser);
    return $020ce576ccb94c96$var$filenameMetadataMap.get(filename);
}
/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ function $020ce576ccb94c96$export$94b52ecabddf6844(parser, event) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            if (!exception.stacktrace) return;
            for (const frame of exception.stacktrace.frames || []){
                if (!frame.filename) continue;
                const metadata = $020ce576ccb94c96$export$fb4062399a51f94a(parser, frame.filename);
                if (metadata) frame.module_metadata = metadata;
            }
        });
    } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Strips metadata from stack frames.
 */ function $020ce576ccb94c96$export$5d4932fac9735eed(event) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            if (!exception.stacktrace) return;
            for (const frame of exception.stacktrace.frames || [])delete frame.module_metadata;
        });
    } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}

});


parcelRegister("dmm8E", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", function () { return (parcelRequire("5Bu1f")).FunctionToString; });
$parcel$export(module.exports, "InboundFilters", function () { return (parcelRequire("cCK0h")).InboundFilters; });
$parcel$export(module.exports, "LinkedErrors", function () { return (parcelRequire("jnja9")).LinkedErrors; });

var $5Bu1f = parcelRequire("5Bu1f");

var $cCK0h = parcelRequire("cCK0h");

var $jnja9 = parcelRequire("jnja9");
 /* eslint-disable deprecation/deprecation */ 
});
parcelRegister("jnja9", function(module, exports) {

$parcel$export(module.exports, "LinkedErrors", function () { return $e1af079f55c11e3c$export$8d1e60aaf616fb4f; });

var $2pzm3 = parcelRequire("2pzm3");
var $01B4H = parcelRequire("01B4H");

var $genhe = parcelRequire("genhe");
const $e1af079f55c11e3c$var$DEFAULT_KEY = "cause";
const $e1af079f55c11e3c$var$DEFAULT_LIMIT = 5;
const $e1af079f55c11e3c$var$INTEGRATION_NAME = "LinkedErrors";
const $e1af079f55c11e3c$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $e1af079f55c11e3c$var$DEFAULT_LIMIT;
    const key = options.key || $e1af079f55c11e3c$var$DEFAULT_KEY;
    return {
        name: $e1af079f55c11e3c$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $2pzm3.applyAggregateErrorsToEvent)((0, $01B4H.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $e1af079f55c11e3c$export$ebabb00eb7f3a395 = (0, $genhe.defineIntegration)($e1af079f55c11e3c$var$_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $e1af079f55c11e3c$export$8d1e60aaf616fb4f = (0, $genhe.convertIntegrationFnToClass)($e1af079f55c11e3c$var$INTEGRATION_NAME, $e1af079f55c11e3c$export$ebabb00eb7f3a395);

});
parcelRegister("2pzm3", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", function () { return $1c19574953c1d061$export$b91c38ed7d8ae9b2; });

var $jPeZ4 = parcelRequire("jPeZ4");

var $bMiqE = parcelRequire("bMiqE");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $1c19574953c1d061$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $jPeZ4.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $1c19574953c1d061$var$truncateAggregateExceptions($1c19574953c1d061$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $1c19574953c1d061$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $jPeZ4.isInstanceOf)(error[key], Error)) {
        $1c19574953c1d061$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $1c19574953c1d061$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $1c19574953c1d061$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $jPeZ4.isInstanceOf)(childError, Error)) {
            $1c19574953c1d061$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $1c19574953c1d061$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $1c19574953c1d061$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $1c19574953c1d061$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $1c19574953c1d061$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $1c19574953c1d061$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $bMiqE.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});

parcelRegister("01B4H", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $004cda6800447c6d$export$a6c2d27607295951; });

var $jPeZ4 = parcelRequire("jPeZ4");

var $iJH3x = parcelRequire("iJH3x");

var $5vnYi = parcelRequire("5vnYi");

var $aajbp = parcelRequire("aajbp");
/**
 * Extracts stack frames from the error.stack string
 */ function $004cda6800447c6d$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $004cda6800447c6d$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $004cda6800447c6d$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $004cda6800447c6d$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $aajbp.extractExceptionKeysForMessage)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function $004cda6800447c6d$export$9dd56ed1ef0c3420(getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === "function" ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    let extras;
    if (!(0, $jPeZ4.isError)(exception)) {
        if ((0, $jPeZ4.isPlainObject)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ["__serialized__"]: (0, $5vnYi.normalizeToSize)(exception, normalizeDepth)
            };
            const message = $004cda6800447c6d$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $004cda6800447c6d$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $iJH3x.addExceptionTypeValue)(event, undefined, undefined);
    (0, $iJH3x.addExceptionMechanism)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $004cda6800447c6d$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $004cda6800447c6d$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $jPeZ4.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}

});



parcelRegister("kxfHu", function(module, exports) {

$parcel$export(module.exports, "metrics", function () { return $ef331182e429f04f$export$b0c5c2fac8144e54; });

var $7p8hL = parcelRequire("7p8hL");

var $fB2fA = parcelRequire("fB2fA");

var $hcepo = parcelRequire("hcepo");

var $4RP7L = parcelRequire("4RP7L");

var $3ssal = parcelRequire("3ssal");

var $f3VPi = parcelRequire("f3VPi");
function $ef331182e429f04f$var$addToMetricsAggregator(metricType, name, value, data = {}) {
    const client = (0, $hcepo.getClient)();
    const scope = (0, $hcepo.getCurrentScope)();
    if (client) {
        if (!client.metricsAggregator) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn("No metrics aggregator enabled. Please add the MetricsAggregator integration to use metrics APIs");
            return;
        }
        const { unit: unit, tags: tags, timestamp: timestamp } = data;
        const { release: release, environment: environment } = client.getOptions();
        // eslint-disable-next-line deprecation/deprecation
        const transaction = scope.getTransaction();
        const metricTags = {};
        if (release) metricTags.release = release;
        if (environment) metricTags.environment = environment;
        if (transaction) metricTags.transaction = (0, $4RP7L.spanToJSON)(transaction).description || "";
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Adding value of ${value} to ${metricType} metric ${name}`);
        client.metricsAggregator.add(metricType, name, value, unit, {
            ...metricTags,
            ...tags
        }, timestamp);
    }
}
/**
 * Adds a value to a counter metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function $ef331182e429f04f$export$a2647aa13413c947(name, value = 1, data) {
    $ef331182e429f04f$var$addToMetricsAggregator((0, $3ssal.COUNTER_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a distribution metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function $ef331182e429f04f$export$fd8e353f0040520a(name, value, data) {
    $ef331182e429f04f$var$addToMetricsAggregator((0, $3ssal.DISTRIBUTION_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a set metric. Value must be a string or integer.
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function $ef331182e429f04f$export$adaa4cf7ef1b65be(name, value, data) {
    $ef331182e429f04f$var$addToMetricsAggregator((0, $3ssal.SET_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a gauge metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function $ef331182e429f04f$export$b0660673397c6c28(name, value, data) {
    $ef331182e429f04f$var$addToMetricsAggregator((0, $3ssal.GAUGE_METRIC_TYPE), name, value, data);
}
const $ef331182e429f04f$export$b0c5c2fac8144e54 = {
    increment: $ef331182e429f04f$export$a2647aa13413c947,
    distribution: $ef331182e429f04f$export$fd8e353f0040520a,
    set: $ef331182e429f04f$export$adaa4cf7ef1b65be,
    gauge: $ef331182e429f04f$export$b0660673397c6c28,
    MetricsAggregator: /** @deprecated Use `metrics.metricsAggregratorIntegration()` instead. */ // eslint-disable-next-line deprecation/deprecation
    $f3VPi.MetricsAggregator,
    metricsAggregatorIntegration: $f3VPi.metricsAggregatorIntegration
};

});
parcelRegister("f3VPi", function(module, exports) {

$parcel$export(module.exports, "metricsAggregatorIntegration", function () { return $af73fdf2291ffe4d$export$4c88deba5759110b; });
$parcel$export(module.exports, "MetricsAggregator", function () { return $af73fdf2291ffe4d$export$a2510bffabd4ed26; });

var $genhe = parcelRequire("genhe");

var $cmnxy = parcelRequire("cmnxy");
const $af73fdf2291ffe4d$var$INTEGRATION_NAME = "MetricsAggregator";
const $af73fdf2291ffe4d$var$_metricsAggregatorIntegration = ()=>{
    return {
        name: $af73fdf2291ffe4d$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            client.metricsAggregator = new (0, $cmnxy.BrowserMetricsAggregator)(client);
        }
    };
};
const $af73fdf2291ffe4d$export$4c88deba5759110b = (0, $genhe.defineIntegration)($af73fdf2291ffe4d$var$_metricsAggregatorIntegration);
/**
 * Enables Sentry metrics monitoring.
 *
 * @experimental This API is experimental and might having breaking changes in the future.
 * @deprecated Use `metricsAggegratorIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $af73fdf2291ffe4d$export$a2510bffabd4ed26 = (0, $genhe.convertIntegrationFnToClass)($af73fdf2291ffe4d$var$INTEGRATION_NAME, $af73fdf2291ffe4d$export$4c88deba5759110b);

});
parcelRegister("cmnxy", function(module, exports) {

$parcel$export(module.exports, "BrowserMetricsAggregator", function () { return $8ff9ccba51b4eb5a$export$ba883a03ada27e19; });

var $iGf0k = parcelRequire("iGf0k");

var $3ssal = parcelRequire("3ssal");

var $3ZprI = parcelRequire("3ZprI");

var $cmAk3 = parcelRequire("cmAk3");

var $lsJ5g = parcelRequire("lsJ5g");
/**
 * A simple metrics aggregator that aggregates metrics in memory and flushes them periodically.
 * Default flush interval is 5 seconds.
 *
 * @experimental This API is experimental and might change in the future.
 */ class $8ff9ccba51b4eb5a$export$ba883a03ada27e19 {
    // TODO(@anonrig): Use FinalizationRegistry to have a proper way of flushing the buckets
    // when the aggregator is garbage collected.
    // Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/FinalizationRegistry
    constructor(_client){
        this._client = _client;
        this._buckets = new Map();
        this._interval = setInterval(()=>this.flush(), (0, $3ssal.DEFAULT_BROWSER_FLUSH_INTERVAL));
    }
    /**
   * @inheritDoc
   */ add(metricType, unsanitizedName, value, unit = "none", unsanitizedTags = {}, maybeFloatTimestamp = (0, $iGf0k.timestampInSeconds)()) {
        const timestamp = Math.floor(maybeFloatTimestamp);
        const name = unsanitizedName.replace((0, $3ssal.NAME_AND_TAG_KEY_NORMALIZATION_REGEX), "_");
        const tags = (0, $lsJ5g.sanitizeTags)(unsanitizedTags);
        const bucketKey = (0, $lsJ5g.getBucketKey)(metricType, name, unit, tags);
        let bucketItem = this._buckets.get(bucketKey);
        // If this is a set metric, we need to calculate the delta from the previous weight.
        const previousWeight = bucketItem && metricType === (0, $3ssal.SET_METRIC_TYPE) ? bucketItem.metric.weight : 0;
        if (bucketItem) {
            bucketItem.metric.add(value);
            // TODO(abhi): Do we need this check?
            if (bucketItem.timestamp < timestamp) bucketItem.timestamp = timestamp;
        } else {
            bucketItem = {
                // @ts-expect-error we don't need to narrow down the type of value here, saves bundle size.
                metric: new (0, $3ZprI.METRIC_MAP)[metricType](value),
                timestamp: timestamp,
                metricType: metricType,
                name: name,
                unit: unit,
                tags: tags
            };
            this._buckets.set(bucketKey, bucketItem);
        }
        // If value is a string, it's a set metric so calculate the delta from the previous weight.
        const val = typeof value === "string" ? bucketItem.metric.weight - previousWeight : value;
        (0, $cmAk3.updateMetricSummaryOnActiveSpan)(metricType, name, val, unit, unsanitizedTags, bucketKey);
    }
    /**
   * @inheritDoc
   */ flush() {
        // short circuit if buckets are empty.
        if (this._buckets.size === 0) return;
        if (this._client.captureAggregateMetrics) {
            // TODO(@anonrig): Use Object.values() when we support ES6+
            const metricBuckets = Array.from(this._buckets).map(([, bucketItem])=>bucketItem);
            this._client.captureAggregateMetrics(metricBuckets);
        }
        this._buckets.clear();
    }
    /**
   * @inheritDoc
   */ close() {
        clearInterval(this._interval);
        this.flush();
    }
}

});
parcelRegister("3ZprI", function(module, exports) {

$parcel$export(module.exports, "METRIC_MAP", function () { return $2e7acea7fdc4805b$export$c3e86dbb157e974e; });

var $3ssal = parcelRequire("3ssal");

var $lsJ5g = parcelRequire("lsJ5g");
/**
 * A metric instance representing a counter.
 */ class $2e7acea7fdc4805b$export$2598fd6c664a7ae3 {
    constructor(_value){
        this._value = _value;
    }
    /** @inheritDoc */ get weight() {
        return 1;
    }
    /** @inheritdoc */ add(value) {
        this._value += value;
    }
    /** @inheritdoc */ toString() {
        return `${this._value}`;
    }
}
/**
 * A metric instance representing a gauge.
 */ class $2e7acea7fdc4805b$export$56f7b30259c6ff43 {
    constructor(value){
        this._last = value;
        this._min = value;
        this._max = value;
        this._sum = value;
        this._count = 1;
    }
    /** @inheritDoc */ get weight() {
        return 5;
    }
    /** @inheritdoc */ add(value) {
        this._last = value;
        if (value < this._min) this._min = value;
        if (value > this._max) this._max = value;
        this._sum += value;
        this._count++;
    }
    /** @inheritdoc */ toString() {
        return `${this._last}:${this._min}:${this._max}:${this._sum}:${this._count}`;
    }
}
/**
 * A metric instance representing a distribution.
 */ class $2e7acea7fdc4805b$export$94f4651a38b34288 {
    constructor(first){
        this._value = [
            first
        ];
    }
    /** @inheritDoc */ get weight() {
        return this._value.length;
    }
    /** @inheritdoc */ add(value) {
        this._value.push(value);
    }
    /** @inheritdoc */ toString() {
        return this._value.join(":");
    }
}
/**
 * A metric instance representing a set.
 */ class $2e7acea7fdc4805b$export$4d1d31acf43c5a17 {
    constructor(first){
        this.first = first;
        this._value = new Set([
            first
        ]);
    }
    /** @inheritDoc */ get weight() {
        return this._value.size;
    }
    /** @inheritdoc */ add(value) {
        this._value.add(value);
    }
    /** @inheritdoc */ toString() {
        return Array.from(this._value).map((val)=>typeof val === "string" ? (0, $lsJ5g.simpleHash)(val) : val).join(":");
    }
}
const $2e7acea7fdc4805b$export$c3e86dbb157e974e = {
    [(0, $3ssal.COUNTER_METRIC_TYPE)]: $2e7acea7fdc4805b$export$2598fd6c664a7ae3,
    [(0, $3ssal.GAUGE_METRIC_TYPE)]: $2e7acea7fdc4805b$export$56f7b30259c6ff43,
    [(0, $3ssal.DISTRIBUTION_METRIC_TYPE)]: $2e7acea7fdc4805b$export$94f4651a38b34288,
    [(0, $3ssal.SET_METRIC_TYPE)]: $2e7acea7fdc4805b$export$4d1d31acf43c5a17
};

});





parcelRegister("d9NWo", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $9942dad0ef640f5d$export$56d8a8a25bd48b81; });
$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $9942dad0ef640f5d$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $9942dad0ef640f5d$export$4997ffc0176396a6; });


var $hcepo = parcelRequire("hcepo");

var $iJH3x = parcelRequire("iJH3x");
var $aajbp = parcelRequire("aajbp");
var $lNVQ9 = parcelRequire("lNVQ9");
const $9942dad0ef640f5d$export$56d8a8a25bd48b81 = (0, $lNVQ9.GLOBAL_OBJ);
let $9942dad0ef640f5d$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9942dad0ef640f5d$export$b79738ab10c590b2() {
    return $9942dad0ef640f5d$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9942dad0ef640f5d$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9942dad0ef640f5d$var$ignoreOnError++;
    setTimeout(()=>{
        $9942dad0ef640f5d$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9942dad0ef640f5d$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $aajbp.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$9942dad0ef640f5d$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9942dad0ef640f5d$export$1265a142ff5ba165();
            (0, $hcepo.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $iJH3x.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $iJH3x.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $hcepo.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $aajbp.markFunctionWrapped)(sentryWrapped, fn);
    (0, $aajbp.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

});

parcelRegister("lCly9", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $fbcddcf0484b7dc1$export$1df9218a526d318d; });

var $5M0hM = parcelRequire("5M0hM");
var $huK8b = parcelRequire("huK8b");

var $jf1xd = parcelRequire("jf1xd");
var $i8Xwi = parcelRequire("i8Xwi");
var $f2UY0 = parcelRequire("f2UY0");
var $7p8hL = parcelRequire("7p8hL");

var $e2xQm = parcelRequire("e2xQm");

var $4JUzU = parcelRequire("4JUzU");

var $d9NWo = parcelRequire("d9NWo");

var $C3Qws = parcelRequire("C3Qws");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $fbcddcf0484b7dc1$export$1df9218a526d318d extends (0, $huK8b.BaseClient) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $d9NWo.WINDOW).SENTRY_SDK_SOURCE || (0, $f2UY0.getSDKSource)();
        (0, $5M0hM.applySdkMetadata)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $d9NWo.WINDOW).document) (0, $d9NWo.WINDOW).document.addEventListener("visibilitychange", ()=>{
            if ((0, $d9NWo.WINDOW).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $4JUzU.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $4JUzU.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $C3Qws.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).log("Sending outcomes:", outcomes);
        const envelope = (0, $jf1xd.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $i8Xwi.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}

});
parcelRegister("jf1xd", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", function () { return $e0209bd3c4210a90$export$f3b9ed77c03eeb00; });

var $2pR2a = parcelRequire("2pR2a");

var $iGf0k = parcelRequire("iGf0k");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $e0209bd3c4210a90$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $iGf0k.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $2pR2a.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("f2UY0", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $af433b59a7df7d87$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $af433b59a7df7d87$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $af433b59a7df7d87$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $af433b59a7df7d87$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("e2xQm", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $a38b8136690a07eb$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a38b8136690a07eb$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("4JUzU", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $373740a2b504e6a7$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $373740a2b504e6a7$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $373740a2b504e6a7$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $373740a2b504e6a7$export$5425b53185d13d6c; });

var $hcepo = parcelRequire("hcepo");

var $iJH3x = parcelRequire("iJH3x");
var $aajbp = parcelRequire("aajbp");
var $jPeZ4 = parcelRequire("jPeZ4");
var $5vnYi = parcelRequire("5vnYi");
var $amxcu = parcelRequire("amxcu");
/**
 * This function creates an exception from a JavaScript Error
 */ function $373740a2b504e6a7$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $373740a2b504e6a7$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $373740a2b504e6a7$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $373740a2b504e6a7$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $hcepo.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $jPeZ4.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $373740a2b504e6a7$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $5vnYi.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $373740a2b504e6a7$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $373740a2b504e6a7$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $373740a2b504e6a7$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $373740a2b504e6a7$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $373740a2b504e6a7$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $373740a2b504e6a7$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $373740a2b504e6a7$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($373740a2b504e6a7$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $373740a2b504e6a7$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $373740a2b504e6a7$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $373740a2b504e6a7$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $iJH3x.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $amxcu.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $373740a2b504e6a7$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $373740a2b504e6a7$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $amxcu.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $373740a2b504e6a7$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $jPeZ4.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $373740a2b504e6a7$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $jPeZ4.isDOMError)(exception) || (0, $jPeZ4.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $373740a2b504e6a7$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $jPeZ4.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $373740a2b504e6a7$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $iJH3x.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $jPeZ4.isError)(exception)) // we have a real Error object, do nothing
    return $373740a2b504e6a7$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $jPeZ4.isPlainObject)(exception) || (0, $jPeZ4.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $373740a2b504e6a7$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $iJH3x.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $373740a2b504e6a7$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $iJH3x.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $iJH3x.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $373740a2b504e6a7$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $373740a2b504e6a7$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $jPeZ4.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $373740a2b504e6a7$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $aajbp.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $jPeZ4.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $jPeZ4.isEvent)(exception)) {
        const className = $373740a2b504e6a7$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $373740a2b504e6a7$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

});

parcelRegister("C3Qws", function(module, exports) {

$parcel$export(module.exports, "createUserFeedbackEnvelope", function () { return $0726887ccb9f8c5b$export$24a4dfcb686ee5bf; });

var $2pR2a = parcelRequire("2pR2a");
var $i8Xwi = parcelRequire("i8Xwi");
/**
 * Creates an envelope from a user feedback.
 */ function $0726887ccb9f8c5b$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $i8Xwi.dsnToString)(dsn)
        }
    };
    const item = $0726887ccb9f8c5b$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $2pR2a.createEnvelope)(headers, [
        item
    ]);
}
function $0726887ccb9f8c5b$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRegister("2dhpd", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", function () { return $19ca4c0e6dec818d$export$b2311068c46d7cc8; });

var $kcgw9 = parcelRequire("kcgw9");

var $amxcu = parcelRequire("amxcu");

var $3kGHd = parcelRequire("3kGHd");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $19ca4c0e6dec818d$export$b2311068c46d7cc8(options, nativeFetch = (0, $3kGHd.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $3kGHd.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $amxcu.rejectedSyncPromise)(e);
        }
    }
    return (0, $kcgw9.createTransport)(options, makeRequest);
}

});
parcelRegister("3kGHd", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", function () { return $26d45be3ebe158ef$export$8be2119ce08e3379; });
$parcel$export(module.exports, "clearCachedFetchImplementation", function () { return $26d45be3ebe158ef$export$d499686d2dd738c6; });

var $37Ut6 = parcelRequire("37Ut6");
var $7p8hL = parcelRequire("7p8hL");

var $e2xQm = parcelRequire("e2xQm");

var $d9NWo = parcelRequire("d9NWo");
let $26d45be3ebe158ef$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $26d45be3ebe158ef$export$8be2119ce08e3379() {
    if ($26d45be3ebe158ef$var$cachedFetchImpl) return $26d45be3ebe158ef$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $37Ut6.isNativeFetch)((0, $d9NWo.WINDOW).fetch)) return $26d45be3ebe158ef$var$cachedFetchImpl = (0, $d9NWo.WINDOW).fetch.bind((0, $d9NWo.WINDOW));
    const document = (0, $d9NWo.WINDOW).document;
    let fetchImpl = (0, $d9NWo.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $26d45be3ebe158ef$var$cachedFetchImpl = fetchImpl.bind((0, $d9NWo.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $26d45be3ebe158ef$export$d499686d2dd738c6() {
    $26d45be3ebe158ef$var$cachedFetchImpl = undefined;
}

});
parcelRegister("37Ut6", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", function () { return $246dd40315c38dfa$export$edf3cb81fd7d2a3e; });
$parcel$export(module.exports, "isNativeFetch", function () { return $246dd40315c38dfa$export$18cf36ed71d733e7; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $246dd40315c38dfa$export$c82d238e23c40b21; });

var $aY8mH = parcelRequire("aY8mH");

var $7p8hL = parcelRequire("7p8hL");

var $lNVQ9 = parcelRequire("lNVQ9");
// eslint-disable-next-line deprecation/deprecation
const $246dd40315c38dfa$var$WINDOW = (0, $lNVQ9.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $246dd40315c38dfa$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $246dd40315c38dfa$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $246dd40315c38dfa$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $246dd40315c38dfa$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $246dd40315c38dfa$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $246dd40315c38dfa$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $246dd40315c38dfa$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$246dd40315c38dfa$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($246dd40315c38dfa$export$18cf36ed71d733e7($246dd40315c38dfa$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $246dd40315c38dfa$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $246dd40315c38dfa$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $aY8mH.DEBUG_BUILD) && (0, $7p8hL.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $246dd40315c38dfa$export$531055a6c684a70a() {
    return "ReportingObserver" in $246dd40315c38dfa$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $246dd40315c38dfa$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$246dd40315c38dfa$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}

});



parcelRegister("cqNDo", function(module, exports) {

$parcel$export(module.exports, "makeXHRTransport", function () { return $90ce6a199ec29c5e$export$5e1441cee30d5a39; });

var $kcgw9 = parcelRequire("kcgw9");

var $amxcu = parcelRequire("amxcu");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $90ce6a199ec29c5e$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $90ce6a199ec29c5e$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $amxcu.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $90ce6a199ec29c5e$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $kcgw9.createTransport)(options, makeRequest);
}

});

parcelRegister("jkCYa", function(module, exports) {

$parcel$export(module.exports, "chromeStackLineParser", function () { return $e12e1d1a91689b2d$export$263a749fff749872; });
$parcel$export(module.exports, "geckoStackLineParser", function () { return $e12e1d1a91689b2d$export$cdba47a5dd2804d; });
$parcel$export(module.exports, "winjsStackLineParser", function () { return $e12e1d1a91689b2d$export$179460296da408e8; });
$parcel$export(module.exports, "opera10StackLineParser", function () { return $e12e1d1a91689b2d$export$f892b52c880ffc7a; });
$parcel$export(module.exports, "opera11StackLineParser", function () { return $e12e1d1a91689b2d$export$af11af13f09fb0dc; });
$parcel$export(module.exports, "defaultStackLineParsers", function () { return $e12e1d1a91689b2d$export$7197c0fe6554c079; });
$parcel$export(module.exports, "defaultStackParser", function () { return $e12e1d1a91689b2d$export$2b2b997d81bf3907; });

var $kEJYx = parcelRequire("kEJYx");
// global reference to slice
const $e12e1d1a91689b2d$var$UNKNOWN_FUNCTION = "?";
const $e12e1d1a91689b2d$var$OPERA10_PRIORITY = 10;
const $e12e1d1a91689b2d$var$OPERA11_PRIORITY = 20;
const $e12e1d1a91689b2d$var$CHROME_PRIORITY = 30;
const $e12e1d1a91689b2d$var$WINJS_PRIORITY = 40;
const $e12e1d1a91689b2d$var$GECKO_PRIORITY = 50;
function $e12e1d1a91689b2d$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $e12e1d1a91689b2d$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e12e1d1a91689b2d$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $e12e1d1a91689b2d$var$chrome = (line)=>{
    const parts = $e12e1d1a91689b2d$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $e12e1d1a91689b2d$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e12e1d1a91689b2d$var$extractSafariExtensionDetails(parts[1] || $e12e1d1a91689b2d$var$UNKNOWN_FUNCTION, parts[2]);
        return $e12e1d1a91689b2d$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e12e1d1a91689b2d$export$263a749fff749872 = [
    $e12e1d1a91689b2d$var$CHROME_PRIORITY,
    $e12e1d1a91689b2d$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e12e1d1a91689b2d$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e12e1d1a91689b2d$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e12e1d1a91689b2d$var$gecko = (line)=>{
    const parts = $e12e1d1a91689b2d$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $e12e1d1a91689b2d$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $e12e1d1a91689b2d$var$UNKNOWN_FUNCTION;
        [func, filename] = $e12e1d1a91689b2d$var$extractSafariExtensionDetails(func, filename);
        return $e12e1d1a91689b2d$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e12e1d1a91689b2d$export$cdba47a5dd2804d = [
    $e12e1d1a91689b2d$var$GECKO_PRIORITY,
    $e12e1d1a91689b2d$var$gecko
];
const $e12e1d1a91689b2d$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e12e1d1a91689b2d$var$winjs = (line)=>{
    const parts = $e12e1d1a91689b2d$var$winjsRegex.exec(line);
    return parts ? $e12e1d1a91689b2d$var$createFrame(parts[2], parts[1] || $e12e1d1a91689b2d$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e12e1d1a91689b2d$export$179460296da408e8 = [
    $e12e1d1a91689b2d$var$WINJS_PRIORITY,
    $e12e1d1a91689b2d$var$winjs
];
const $e12e1d1a91689b2d$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e12e1d1a91689b2d$var$opera10 = (line)=>{
    const parts = $e12e1d1a91689b2d$var$opera10Regex.exec(line);
    return parts ? $e12e1d1a91689b2d$var$createFrame(parts[2], parts[3] || $e12e1d1a91689b2d$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $e12e1d1a91689b2d$export$f892b52c880ffc7a = [
    $e12e1d1a91689b2d$var$OPERA10_PRIORITY,
    $e12e1d1a91689b2d$var$opera10
];
const $e12e1d1a91689b2d$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e12e1d1a91689b2d$var$opera11 = (line)=>{
    const parts = $e12e1d1a91689b2d$var$opera11Regex.exec(line);
    return parts ? $e12e1d1a91689b2d$var$createFrame(parts[5], parts[3] || parts[4] || $e12e1d1a91689b2d$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $e12e1d1a91689b2d$export$af11af13f09fb0dc = [
    $e12e1d1a91689b2d$var$OPERA11_PRIORITY,
    $e12e1d1a91689b2d$var$opera11
];
const $e12e1d1a91689b2d$export$7197c0fe6554c079 = [
    $e12e1d1a91689b2d$export$263a749fff749872,
    $e12e1d1a91689b2d$export$cdba47a5dd2804d,
    $e12e1d1a91689b2d$export$179460296da408e8
];
const $e12e1d1a91689b2d$export$2b2b997d81bf3907 = (0, $kEJYx.createStackParser)(...$e12e1d1a91689b2d$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e12e1d1a91689b2d$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $e12e1d1a91689b2d$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("cet0p", function(module, exports) {

$parcel$export(module.exports, "defaultIntegrations", function () { return $8e7d4ac45300dbf7$export$5ef831fccfce35e5; });
$parcel$export(module.exports, "getDefaultIntegrations", function () { return $8e7d4ac45300dbf7$export$5783b2920b1d62b9; });
$parcel$export(module.exports, "init", function () { return $8e7d4ac45300dbf7$export$2cd8252107eb640b; });
$parcel$export(module.exports, "showReportDialog", function () { return $8e7d4ac45300dbf7$export$3a8fd680da42627b; });
$parcel$export(module.exports, "forceLoad", function () { return $8e7d4ac45300dbf7$export$a3f323d81eede727; });
$parcel$export(module.exports, "onLoad", function () { return $8e7d4ac45300dbf7$export$4e4d8b287d028b6b; });
$parcel$export(module.exports, "wrap", function () { return $8e7d4ac45300dbf7$export$4997ffc0176396a6; });
$parcel$export(module.exports, "captureUserFeedback", function () { return $8e7d4ac45300dbf7$export$88cefaf72d1e58a3; });

var $hcepo = parcelRequire("hcepo");
var $5Bu1f = parcelRequire("5Bu1f");
var $fxUGN = parcelRequire("fxUGN");
var $genhe = parcelRequire("genhe");
var $eua5O = parcelRequire("eua5O");
var $cCK0h = parcelRequire("cCK0h");
var $dKXuR = parcelRequire("dKXuR");

var $hFlB3 = parcelRequire("hFlB3");
var $7p8hL = parcelRequire("7p8hL");
var $kEJYx = parcelRequire("kEJYx");
var $37Ut6 = parcelRequire("37Ut6");

var $lCly9 = parcelRequire("lCly9");

var $e2xQm = parcelRequire("e2xQm");

var $d9NWo = parcelRequire("d9NWo");

var $53mM0 = parcelRequire("53mM0");

var $gxQnK = parcelRequire("gxQnK");

var $i26WM = parcelRequire("i26WM");

var $39bVV = parcelRequire("39bVV");

var $gb6W3 = parcelRequire("gb6W3");

var $aLmV4 = parcelRequire("aLmV4");

var $jkCYa = parcelRequire("jkCYa");

var $2dhpd = parcelRequire("2dhpd");

var $cqNDo = parcelRequire("cqNDo");
/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $8e7d4ac45300dbf7$export$5ef831fccfce35e5 = [
    (0, $cCK0h.inboundFiltersIntegration)(),
    (0, $5Bu1f.functionToStringIntegration)(),
    (0, $aLmV4.browserApiErrorsIntegration)(),
    (0, $53mM0.breadcrumbsIntegration)(),
    (0, $i26WM.globalHandlersIntegration)(),
    (0, $gb6W3.linkedErrorsIntegration)(),
    (0, $gxQnK.dedupeIntegration)(),
    (0, $39bVV.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function $8e7d4ac45300dbf7$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$8e7d4ac45300dbf7$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $8e7d4ac45300dbf7$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $8e7d4ac45300dbf7$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $d9NWo.WINDOW).SENTRY_RELEASE && (0, $d9NWo.WINDOW).SENTRY_RELEASE.id) options.release = (0, $d9NWo.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $kEJYx.stackParserFromStackParserOptions)(options.stackParser || (0, $jkCYa.defaultStackParser)),
        integrations: (0, $genhe.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $37Ut6.supportsFetch)() ? (0, $2dhpd.makeFetchTransport) : (0, $cqNDo.makeXHRTransport))
    };
    (0, $dKXuR.initAndBind)((0, $lCly9.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $8e7d4ac45300dbf7$var$startSessionTracking();
}
const $8e7d4ac45300dbf7$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $fxUGN.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $d9NWo.WINDOW).document) {
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    // TODO(v8): Remove this entire if statement. `eventId` will be a required option.
    // eslint-disable-next-line deprecation/deprecation
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $d9NWo.WINDOW).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $eua5O.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $d9NWo.WINDOW).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $d9NWo.WINDOW).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $d9NWo.WINDOW).document.head || (0, $d9NWo.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $8e7d4ac45300dbf7$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $8e7d4ac45300dbf7$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8e7d4ac45300dbf7$export$4997ffc0176396a6(fn) {
    return (0, $d9NWo.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $8e7d4ac45300dbf7$var$startSessionTracking() {
    if (typeof (0, $d9NWo.WINDOW).document === "undefined") {
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $hcepo.startSession)({
        ignoreDuration: true
    });
    (0, $hcepo.captureSession)();
    // We want to create a session for every navigation as well
    (0, $hFlB3.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $hcepo.startSession)({
                ignoreDuration: true
            });
            (0, $hcepo.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $8e7d4ac45300dbf7$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $hcepo.getClient)();
    if (client) client.captureUserFeedback(feedback);
}

});
parcelRegister("hFlB3", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", function () { return $cdc704aaa9377f16$export$3f18c56c58114e75; });

var $aajbp = parcelRequire("aajbp");



var $lNVQ9 = parcelRequire("lNVQ9");

var $3iOb8 = parcelRequire("3iOb8");

var $7P0P8 = parcelRequire("7P0P8");
const $cdc704aaa9377f16$var$WINDOW = (0, $lNVQ9.GLOBAL_OBJ);
let $cdc704aaa9377f16$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $cdc704aaa9377f16$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $7P0P8.addHandler)(type, handler);
    (0, $7P0P8.maybeInstrument)(type, $cdc704aaa9377f16$var$instrumentHistory);
}
function $cdc704aaa9377f16$var$instrumentHistory() {
    if (!(0, $3iOb8.supportsHistory)()) return;
    const oldOnPopState = $cdc704aaa9377f16$var$WINDOW.onpopstate;
    $cdc704aaa9377f16$var$WINDOW.onpopstate = function(...args) {
        const to = $cdc704aaa9377f16$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $cdc704aaa9377f16$var$lastHref;
        $cdc704aaa9377f16$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $7P0P8.triggerHandlers)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $cdc704aaa9377f16$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $cdc704aaa9377f16$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $7P0P8.triggerHandlers)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $aajbp.fill)($cdc704aaa9377f16$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $aajbp.fill)($cdc704aaa9377f16$var$WINDOW.history, "replaceState", historyReplacementFunction);
}

});
parcelRegister("3iOb8", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", function () { return $2679f9f0423ee05b$export$67fc34576016d6ec; });

var $lNVQ9 = parcelRequire("lNVQ9");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $2679f9f0423ee05b$var$WINDOW = (0, $lNVQ9.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $2679f9f0423ee05b$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chrome = $2679f9f0423ee05b$var$WINDOW.chrome;
    const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $2679f9f0423ee05b$var$WINDOW && !!$2679f9f0423ee05b$var$WINDOW.history.pushState && !!$2679f9f0423ee05b$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("53mM0", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", function () { return $3adee5e1618f5578$export$c079d904b326663a; });
$parcel$export(module.exports, "Breadcrumbs", function () { return $3adee5e1618f5578$export$2dc68d50d56fbbd; });

var $hcepo = parcelRequire("hcepo");
var $genhe = parcelRequire("genhe");

var $lemS8 = parcelRequire("lemS8");
var $8EmCv = parcelRequire("8EmCv");
var $dQVMO = parcelRequire("dQVMO");
var $hFlB3 = parcelRequire("hFlB3");
var $jOCzY = parcelRequire("jOCzY");
var $04wr6 = parcelRequire("04wr6");
var $iJH3x = parcelRequire("iJH3x");
var $7p8hL = parcelRequire("7p8hL");
var $bn8Da = parcelRequire("bn8Da");
var $bMiqE = parcelRequire("bMiqE");
var $9b8s0 = parcelRequire("9b8s0");

var $e2xQm = parcelRequire("e2xQm");

var $d9NWo = parcelRequire("d9NWo");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $3adee5e1618f5578$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $3adee5e1618f5578$var$INTEGRATION_NAME = "Breadcrumbs";
const $3adee5e1618f5578$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $3adee5e1618f5578$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $8EmCv.addConsoleInstrumentationHandler)($3adee5e1618f5578$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $lemS8.addClickKeypressInstrumentationHandler)($3adee5e1618f5578$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $jOCzY.addXhrInstrumentationHandler)($3adee5e1618f5578$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $dQVMO.addFetchInstrumentationHandler)($3adee5e1618f5578$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $hFlB3.addHistoryInstrumentationHandler)($3adee5e1618f5578$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $3adee5e1618f5578$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $3adee5e1618f5578$export$c079d904b326663a = (0, $genhe.defineIntegration)($3adee5e1618f5578$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $3adee5e1618f5578$export$2dc68d50d56fbbd = (0, $genhe.convertIntegrationFnToClass)($3adee5e1618f5578$var$INTEGRATION_NAME, $3adee5e1618f5578$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $3adee5e1618f5578$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $hcepo.getClient)() !== client) return;
        (0, $hcepo.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $iJH3x.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $3adee5e1618f5578$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $hcepo.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $3adee5e1618f5578$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$3adee5e1618f5578$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$3adee5e1618f5578$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $3adee5e1618f5578$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $3adee5e1618f5578$var$_isEvent(event) ? event.target : event;
            target = (0, $04wr6.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $04wr6.getComponentName)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $hcepo.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $3adee5e1618f5578$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $hcepo.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $9b8s0.severityLevelFromString)(handlerData.level),
            message: (0, $bMiqE.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $bMiqE.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $hcepo.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $3adee5e1618f5578$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $hcepo.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $jOCzY.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $hcepo.addBreadcrumb)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $3adee5e1618f5578$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $hcepo.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $hcepo.addBreadcrumb)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $hcepo.addBreadcrumb)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $3adee5e1618f5578$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $hcepo.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $bn8Da.parseUrl)((0, $d9NWo.WINDOW).location.href);
        let parsedFrom = from ? (0, $bn8Da.parseUrl)(from) : undefined;
        const parsedTo = (0, $bn8Da.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $hcepo.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $3adee5e1618f5578$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("lemS8", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", function () { return $f74ca5b301ab433a$export$5aeffd3db2cf9df7; });

var $iJH3x = parcelRequire("iJH3x");

var $aajbp = parcelRequire("aajbp");

var $lNVQ9 = parcelRequire("lNVQ9");

var $7P0P8 = parcelRequire("7P0P8");
const $f74ca5b301ab433a$var$WINDOW = (0, $lNVQ9.GLOBAL_OBJ);
const $f74ca5b301ab433a$var$DEBOUNCE_DURATION = 1000;
let $f74ca5b301ab433a$var$debounceTimerID;
let $f74ca5b301ab433a$var$lastCapturedEventType;
let $f74ca5b301ab433a$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f74ca5b301ab433a$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $7P0P8.addHandler)(type, handler);
    (0, $7P0P8.maybeInstrument)(type, $f74ca5b301ab433a$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $f74ca5b301ab433a$export$3014bbf0af0e1d4a() {
    if (!$f74ca5b301ab433a$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $7P0P8.triggerHandlers).bind(null, "dom");
    const globalDOMEventHandler = $f74ca5b301ab433a$var$makeDOMEventHandler(triggerDOMHandler, true);
    $f74ca5b301ab433a$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $f74ca5b301ab433a$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $f74ca5b301ab433a$var$WINDOW[target] && $f74ca5b301ab433a$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $aajbp.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $f74ca5b301ab433a$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $aajbp.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $f74ca5b301ab433a$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $f74ca5b301ab433a$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $f74ca5b301ab433a$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $f74ca5b301ab433a$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $f74ca5b301ab433a$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $f74ca5b301ab433a$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($f74ca5b301ab433a$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $aajbp.addNonEnumerableProperty)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $aajbp.addNonEnumerableProperty)(target, "_sentryId", (0, $iJH3x.uuid4)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$f74ca5b301ab433a$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $f74ca5b301ab433a$var$lastCapturedEventType = event.type;
            $f74ca5b301ab433a$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($f74ca5b301ab433a$var$debounceTimerID);
        $f74ca5b301ab433a$var$debounceTimerID = $f74ca5b301ab433a$var$WINDOW.setTimeout(()=>{
            $f74ca5b301ab433a$var$lastCapturedEventTargetId = undefined;
            $f74ca5b301ab433a$var$lastCapturedEventType = undefined;
        }, $f74ca5b301ab433a$var$DEBOUNCE_DURATION);
    };
}
function $f74ca5b301ab433a$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});

parcelRegister("8EmCv", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", function () { return $64c39b056fdae851$export$1d6e0d073f9e6723; });

var $7p8hL = parcelRequire("7p8hL");

var $aajbp = parcelRequire("aajbp");

var $lNVQ9 = parcelRequire("lNVQ9");

var $7P0P8 = parcelRequire("7P0P8");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $64c39b056fdae851$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $7P0P8.addHandler)(type, handler);
    (0, $7P0P8.maybeInstrument)(type, $64c39b056fdae851$var$instrumentConsole);
}
function $64c39b056fdae851$var$instrumentConsole() {
    if (!("console" in (0, $lNVQ9.GLOBAL_OBJ))) return;
    (0, $7p8hL.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $lNVQ9.GLOBAL_OBJ).console)) return;
        (0, $aajbp.fill)((0, $lNVQ9.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $7p8hL.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $7P0P8.triggerHandlers)("console", handlerData);
                const log = (0, $7p8hL.originalConsoleMethods)[level];
                log && log.apply((0, $lNVQ9.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("dQVMO", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", function () { return $a15cf4d580b5ec36$export$f75d3c772c923df0; });

var $aajbp = parcelRequire("aajbp");

var $37Ut6 = parcelRequire("37Ut6");

var $lNVQ9 = parcelRequire("lNVQ9");

var $7P0P8 = parcelRequire("7P0P8");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a15cf4d580b5ec36$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $7P0P8.addHandler)(type, handler);
    (0, $7P0P8.maybeInstrument)(type, $a15cf4d580b5ec36$var$instrumentFetch);
}
function $a15cf4d580b5ec36$var$instrumentFetch() {
    if (!(0, $37Ut6.supportsNativeFetch)()) return;
    (0, $aajbp.fill)((0, $lNVQ9.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $a15cf4d580b5ec36$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $7P0P8.triggerHandlers)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $lNVQ9.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $7P0P8.triggerHandlers)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $7P0P8.triggerHandlers)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $a15cf4d580b5ec36$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $a15cf4d580b5ec36$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($a15cf4d580b5ec36$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $a15cf4d580b5ec36$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $a15cf4d580b5ec36$var$getUrlFromResource(url),
            method: $a15cf4d580b5ec36$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $a15cf4d580b5ec36$var$getUrlFromResource(arg),
        method: $a15cf4d580b5ec36$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}

});

parcelRegister("jOCzY", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $e6d09cd7eb7390d1$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addXhrInstrumentationHandler", function () { return $e6d09cd7eb7390d1$export$26ace48dd54c9aea; });

var $jPeZ4 = parcelRequire("jPeZ4");

var $aajbp = parcelRequire("aajbp");

var $lNVQ9 = parcelRequire("lNVQ9");

var $7P0P8 = parcelRequire("7P0P8");
const $e6d09cd7eb7390d1$var$WINDOW = (0, $lNVQ9.GLOBAL_OBJ);
const $e6d09cd7eb7390d1$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $e6d09cd7eb7390d1$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $7P0P8.addHandler)(type, handler);
    (0, $7P0P8.maybeInstrument)(type, $e6d09cd7eb7390d1$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $e6d09cd7eb7390d1$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$e6d09cd7eb7390d1$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $aajbp.fill)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $jPeZ4.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $e6d09cd7eb7390d1$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$e6d09cd7eb7390d1$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$e6d09cd7eb7390d1$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $7P0P8.triggerHandlers)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $aajbp.fill)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $aajbp.fill)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$e6d09cd7eb7390d1$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $jPeZ4.isString)(header) && (0, $jPeZ4.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $aajbp.fill)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$e6d09cd7eb7390d1$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $7P0P8.triggerHandlers)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $e6d09cd7eb7390d1$var$parseUrl(url) {
    if ((0, $jPeZ4.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("bn8Da", function(module, exports) {

$parcel$export(module.exports, "parseUrl", function () { return $847889964a55ae57$export$7a5253c0f62e0150; });
$parcel$export(module.exports, "getNumberOfUrlSegments", function () { return $847889964a55ae57$export$69dd85280a8d374c; });
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $847889964a55ae57$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $847889964a55ae57$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $847889964a55ae57$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $847889964a55ae57$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

});

parcelRegister("9b8s0", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", function () { return $6aebb2455a2de030$export$d771ef054122c30a; });
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $6aebb2455a2de030$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $6aebb2455a2de030$export$e01cef29b4327697(level) {
    return $6aebb2455a2de030$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $6aebb2455a2de030$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $6aebb2455a2de030$export$411d0ffdba845b6c.includes(level) ? level : "log";
}

});


parcelRegister("gxQnK", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", function () { return $c0b85c68fb20e846$export$6d39aa44cd0c7567; });
$parcel$export(module.exports, "Dedupe", function () { return $c0b85c68fb20e846$export$688d98c249d31ad3; });

var $genhe = parcelRequire("genhe");

var $7p8hL = parcelRequire("7p8hL");

var $e2xQm = parcelRequire("e2xQm");
const $c0b85c68fb20e846$var$INTEGRATION_NAME = "Dedupe";
const $c0b85c68fb20e846$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $c0b85c68fb20e846$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($c0b85c68fb20e846$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $c0b85c68fb20e846$export$6d39aa44cd0c7567 = (0, $genhe.defineIntegration)($c0b85c68fb20e846$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $c0b85c68fb20e846$export$688d98c249d31ad3 = (0, $genhe.convertIntegrationFnToClass)($c0b85c68fb20e846$var$INTEGRATION_NAME, $c0b85c68fb20e846$export$6d39aa44cd0c7567);
function $c0b85c68fb20e846$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($c0b85c68fb20e846$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($c0b85c68fb20e846$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $c0b85c68fb20e846$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$c0b85c68fb20e846$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$c0b85c68fb20e846$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $c0b85c68fb20e846$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $c0b85c68fb20e846$var$_getExceptionFromEvent(previousEvent);
    const currentException = $c0b85c68fb20e846$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$c0b85c68fb20e846$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$c0b85c68fb20e846$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $c0b85c68fb20e846$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $c0b85c68fb20e846$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $c0b85c68fb20e846$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $c0b85c68fb20e846$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $c0b85c68fb20e846$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $c0b85c68fb20e846$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});

parcelRegister("i26WM", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", function () { return $d20dcd72502269a1$export$66acc70e8cf2b71a; });
$parcel$export(module.exports, "GlobalHandlers", function () { return $d20dcd72502269a1$export$204155decbc90e5a; });

var $hcepo = parcelRequire("hcepo");
var $genhe = parcelRequire("genhe");

var $gHATr = parcelRequire("gHATr");
var $a5k97 = parcelRequire("a5k97");
var $04wr6 = parcelRequire("04wr6");
var $jPeZ4 = parcelRequire("jPeZ4");
var $7p8hL = parcelRequire("7p8hL");

var $e2xQm = parcelRequire("e2xQm");

var $4JUzU = parcelRequire("4JUzU");

var $d9NWo = parcelRequire("d9NWo");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $d20dcd72502269a1$var$INTEGRATION_NAME = "GlobalHandlers";
const $d20dcd72502269a1$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $d20dcd72502269a1$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $d20dcd72502269a1$var$_installGlobalOnErrorHandler(client);
                $d20dcd72502269a1$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $d20dcd72502269a1$var$_installGlobalOnUnhandledRejectionHandler(client);
                $d20dcd72502269a1$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $d20dcd72502269a1$export$66acc70e8cf2b71a = (0, $genhe.defineIntegration)($d20dcd72502269a1$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $d20dcd72502269a1$export$204155decbc90e5a = (0, $genhe.convertIntegrationFnToClass)($d20dcd72502269a1$var$INTEGRATION_NAME, $d20dcd72502269a1$export$66acc70e8cf2b71a);
function $d20dcd72502269a1$var$_installGlobalOnErrorHandler(client) {
    (0, $gHATr.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $d20dcd72502269a1$var$getOptions();
        if ((0, $hcepo.getClient)() !== client || (0, $d9NWo.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $jPeZ4.isString)(msg) ? $d20dcd72502269a1$var$_eventFromIncompleteOnError(msg, url, line, column) : $d20dcd72502269a1$var$_enhanceEventWithInitialFrame((0, $4JUzU.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $hcepo.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $d20dcd72502269a1$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $a5k97.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $d20dcd72502269a1$var$getOptions();
        if ((0, $hcepo.getClient)() !== client || (0, $d9NWo.shouldIgnoreOnError)()) return;
        const error = $d20dcd72502269a1$var$_getUnhandledRejectionError(e);
        const event = (0, $jPeZ4.isPrimitive)(error) ? $d20dcd72502269a1$var$_eventFromRejectionWithPrimitive(error) : (0, $4JUzU.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $hcepo.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $d20dcd72502269a1$var$_getUnhandledRejectionError(error) {
    if ((0, $jPeZ4.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $d20dcd72502269a1$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d20dcd72502269a1$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $jPeZ4.isErrorEvent)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $d20dcd72502269a1$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d20dcd72502269a1$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $jPeZ4.isString)(url) && url.length > 0 ? url : (0, $04wr6.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $d20dcd72502269a1$var$globalHandlerLog(type) {
    (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Global Handler attached: ${type}`);
}
function $d20dcd72502269a1$var$getOptions() {
    const client = (0, $hcepo.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});

parcelRegister("39bVV", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", function () { return $24ab78124df306f6$export$1378794447170364; });
$parcel$export(module.exports, "HttpContext", function () { return $24ab78124df306f6$export$5d2ee9a544b09a94; });

var $genhe = parcelRequire("genhe");

var $d9NWo = parcelRequire("d9NWo");
const $24ab78124df306f6$var$INTEGRATION_NAME = "HttpContext";
const $24ab78124df306f6$var$_httpContextIntegration = ()=>{
    return {
        name: $24ab78124df306f6$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $d9NWo.WINDOW).navigator && !(0, $d9NWo.WINDOW).location && !(0, $d9NWo.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $d9NWo.WINDOW).location && (0, $d9NWo.WINDOW).location.href;
            const { referrer: referrer } = (0, $d9NWo.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $d9NWo.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $24ab78124df306f6$export$1378794447170364 = (0, $genhe.defineIntegration)($24ab78124df306f6$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $24ab78124df306f6$export$5d2ee9a544b09a94 = (0, $genhe.convertIntegrationFnToClass)($24ab78124df306f6$var$INTEGRATION_NAME, $24ab78124df306f6$export$1378794447170364);

});

parcelRegister("gb6W3", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", function () { return $bc730da7572b6e3e$export$ebabb00eb7f3a395; });
$parcel$export(module.exports, "LinkedErrors", function () { return $bc730da7572b6e3e$export$8d1e60aaf616fb4f; });

var $genhe = parcelRequire("genhe");

var $2pzm3 = parcelRequire("2pzm3");

var $4JUzU = parcelRequire("4JUzU");
const $bc730da7572b6e3e$var$DEFAULT_KEY = "cause";
const $bc730da7572b6e3e$var$DEFAULT_LIMIT = 5;
const $bc730da7572b6e3e$var$INTEGRATION_NAME = "LinkedErrors";
const $bc730da7572b6e3e$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $bc730da7572b6e3e$var$DEFAULT_LIMIT;
    const key = options.key || $bc730da7572b6e3e$var$DEFAULT_KEY;
    return {
        name: $bc730da7572b6e3e$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $2pzm3.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $4JUzU.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $bc730da7572b6e3e$export$ebabb00eb7f3a395 = (0, $genhe.defineIntegration)($bc730da7572b6e3e$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $bc730da7572b6e3e$export$8d1e60aaf616fb4f = (0, $genhe.convertIntegrationFnToClass)($bc730da7572b6e3e$var$INTEGRATION_NAME, $bc730da7572b6e3e$export$ebabb00eb7f3a395);

});

parcelRegister("aLmV4", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", function () { return $7d60127fc5245572$export$59bfe9f1c76150e; });
$parcel$export(module.exports, "TryCatch", function () { return $7d60127fc5245572$export$f1a018517668e6d3; });

var $genhe = parcelRequire("genhe");

var $aajbp = parcelRequire("aajbp");
var $kEJYx = parcelRequire("kEJYx");

var $d9NWo = parcelRequire("d9NWo");
const $7d60127fc5245572$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $7d60127fc5245572$var$INTEGRATION_NAME = "TryCatch";
const $7d60127fc5245572$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $7d60127fc5245572$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $aajbp.fill)((0, $d9NWo.WINDOW), "setTimeout", $7d60127fc5245572$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $aajbp.fill)((0, $d9NWo.WINDOW), "setInterval", $7d60127fc5245572$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $aajbp.fill)((0, $d9NWo.WINDOW), "requestAnimationFrame", $7d60127fc5245572$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $d9NWo.WINDOW)) (0, $aajbp.fill)(XMLHttpRequest.prototype, "send", $7d60127fc5245572$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $7d60127fc5245572$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($7d60127fc5245572$var$_wrapEventTarget);
            }
        }
    };
};
const $7d60127fc5245572$export$59bfe9f1c76150e = (0, $genhe.defineIntegration)($7d60127fc5245572$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $7d60127fc5245572$export$f1a018517668e6d3 = (0, $genhe.convertIntegrationFnToClass)($7d60127fc5245572$var$INTEGRATION_NAME, $7d60127fc5245572$export$59bfe9f1c76150e);
function $7d60127fc5245572$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $d9NWo.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $kEJYx.getFunctionName)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7d60127fc5245572$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $d9NWo.wrap)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $kEJYx.getFunctionName)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $7d60127fc5245572$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $aajbp.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $kEJYx.getFunctionName)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $aajbp.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $kEJYx.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $d9NWo.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $7d60127fc5245572$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $d9NWo.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $aajbp.fill)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $d9NWo.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $kEJYx.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $d9NWo.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $kEJYx.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $aajbp.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});


parcelRegister("8WmGo", function(module, exports) {

$parcel$export(module.exports, "GlobalHandlers", function () { return (parcelRequire("i26WM")).GlobalHandlers; });
$parcel$export(module.exports, "TryCatch", function () { return (parcelRequire("aLmV4")).TryCatch; });
$parcel$export(module.exports, "Breadcrumbs", function () { return (parcelRequire("53mM0")).Breadcrumbs; });
$parcel$export(module.exports, "LinkedErrors", function () { return (parcelRequire("gb6W3")).LinkedErrors; });
$parcel$export(module.exports, "HttpContext", function () { return (parcelRequire("39bVV")).HttpContext; });
$parcel$export(module.exports, "Dedupe", function () { return (parcelRequire("gxQnK")).Dedupe; });

var $i26WM = parcelRequire("i26WM");

var $aLmV4 = parcelRequire("aLmV4");

var $53mM0 = parcelRequire("53mM0");

var $gb6W3 = parcelRequire("gb6W3");

var $39bVV = parcelRequire("39bVV");

var $gxQnK = parcelRequire("gxQnK");
 /* eslint-disable deprecation/deprecation */ 
});

parcelRegister("am4Ss", function(module, exports) {

$parcel$export(module.exports, "replayIntegration", function () { return $789fbdfdf9798b8b$export$d7706faf7ab354bf; });
$parcel$export(module.exports, "Replay", function () { return $789fbdfdf9798b8b$export$a35c789ed37ee0f7; });
$parcel$export(module.exports, "getReplay", function () { return $789fbdfdf9798b8b$export$b28310b2f161456b; });

var $hvuDy = parcelRequire("hvuDy");
var $fF2BR = parcelRequire("fF2BR");
var $lemS8 = parcelRequire("lemS8");
var $dQVMO = parcelRequire("dQVMO");
var $hFlB3 = parcelRequire("hFlB3");
var $jOCzY = parcelRequire("jOCzY");
var $iGf0k = parcelRequire("iGf0k");
var $7p8hL = parcelRequire("7p8hL");
var $2pR2a = parcelRequire("2pR2a");
var $aajbp = parcelRequire("aajbp");
var $lNVQ9 = parcelRequire("lNVQ9");
var $04wr6 = parcelRequire("04wr6");
var $kVwzp = parcelRequire("kVwzp");
var $3iBML = parcelRequire("3iBML");
var $5vnYi = parcelRequire("5vnYi");
var $bMiqE = parcelRequire("bMiqE");
var $iJH3x = parcelRequire("iJH3x");

var $hcepo = parcelRequire("hcepo");
var $huK8b = parcelRequire("huK8b");
var $fxUGN = parcelRequire("fxUGN");
var $djmte = parcelRequire("djmte");
var $5XnTz = parcelRequire("5XnTz");
var $kuS4l = parcelRequire("kuS4l");
var $4RP7L = parcelRequire("4RP7L");

var $aiNal = parcelRequire("aiNal");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $789fbdfdf9798b8b$var$WINDOW = (0, $lNVQ9.GLOBAL_OBJ);
const $789fbdfdf9798b8b$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $789fbdfdf9798b8b$var$REPLAY_EVENT_NAME = "replay_event";
const $789fbdfdf9798b8b$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $789fbdfdf9798b8b$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $789fbdfdf9798b8b$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $789fbdfdf9798b8b$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $789fbdfdf9798b8b$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $789fbdfdf9798b8b$var$BUFFER_CHECKOUT_TIME = 60000;
const $789fbdfdf9798b8b$var$RETRY_BASE_INTERVAL = 5000;
const $789fbdfdf9798b8b$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $789fbdfdf9798b8b$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $789fbdfdf9798b8b$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $789fbdfdf9798b8b$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $789fbdfdf9798b8b$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $789fbdfdf9798b8b$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $789fbdfdf9798b8b$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $789fbdfdf9798b8b$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $789fbdfdf9798b8b$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $789fbdfdf9798b8b$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $789fbdfdf9798b8b$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $789fbdfdf9798b8b$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($789fbdfdf9798b8b$var$NodeType$1 || ($789fbdfdf9798b8b$var$NodeType$1 = {}));
function $789fbdfdf9798b8b$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $789fbdfdf9798b8b$var$isShadowRoot(n) {
    const host = $789fbdfdf9798b8b$var$_optionalChain$5([
        n,
        "optionalAccess",
        (_)=>_.host
    ]);
    return Boolean($789fbdfdf9798b8b$var$_optionalChain$5([
        host,
        "optionalAccess",
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $789fbdfdf9798b8b$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $789fbdfdf9798b8b$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $789fbdfdf9798b8b$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $789fbdfdf9798b8b$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $789fbdfdf9798b8b$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $789fbdfdf9798b8b$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $789fbdfdf9798b8b$var$stringifyRule(rule) {
    let importStringified;
    if ($789fbdfdf9798b8b$var$isCSSImportRule(rule)) try {
        importStringified = $789fbdfdf9798b8b$var$stringifyStylesheet(rule.styleSheet) || $789fbdfdf9798b8b$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($789fbdfdf9798b8b$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) return $789fbdfdf9798b8b$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $789fbdfdf9798b8b$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $789fbdfdf9798b8b$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $789fbdfdf9798b8b$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $789fbdfdf9798b8b$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $789fbdfdf9798b8b$var$_optionalChain$5([
            this,
            "access",
            (_3)=>_3.getMeta,
            "call",
            (_4)=>_4(n),
            "optionalAccess",
            (_5)=>_5.id
        ]);
        return $789fbdfdf9798b8b$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $789fbdfdf9798b8b$var$createMirror() {
    return new $789fbdfdf9798b8b$var$Mirror();
}
function $789fbdfdf9798b8b$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $789fbdfdf9798b8b$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $789fbdfdf9798b8b$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $789fbdfdf9798b8b$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $789fbdfdf9798b8b$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $789fbdfdf9798b8b$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $789fbdfdf9798b8b$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$789fbdfdf9798b8b$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $789fbdfdf9798b8b$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $789fbdfdf9798b8b$var$toLowerCase(type) : null;
}
function $789fbdfdf9798b8b$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
let $789fbdfdf9798b8b$var$_id = 1;
const $789fbdfdf9798b8b$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $789fbdfdf9798b8b$var$IGNORED_NODE = -2;
function $789fbdfdf9798b8b$var$genId() {
    return $789fbdfdf9798b8b$var$_id++;
}
function $789fbdfdf9798b8b$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $789fbdfdf9798b8b$var$toLowerCase(element.tagName);
    if ($789fbdfdf9798b8b$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $789fbdfdf9798b8b$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $789fbdfdf9798b8b$var$canvasService;
let $789fbdfdf9798b8b$var$canvasCtx;
const $789fbdfdf9798b8b$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $789fbdfdf9798b8b$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $789fbdfdf9798b8b$var$URL_WWW_MATCH = /^www\..*/i;
const $789fbdfdf9798b8b$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $789fbdfdf9798b8b$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($789fbdfdf9798b8b$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($789fbdfdf9798b8b$var$URL_PROTOCOL_MATCH.test(filePath) || $789fbdfdf9798b8b$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($789fbdfdf9798b8b$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$789fbdfdf9798b8b$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $789fbdfdf9798b8b$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $789fbdfdf9798b8b$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $789fbdfdf9798b8b$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($789fbdfdf9798b8b$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($789fbdfdf9798b8b$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $789fbdfdf9798b8b$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $789fbdfdf9798b8b$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function $789fbdfdf9798b8b$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function $789fbdfdf9798b8b$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $789fbdfdf9798b8b$var$getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function $789fbdfdf9798b8b$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $789fbdfdf9798b8b$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $789fbdfdf9798b8b$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $789fbdfdf9798b8b$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $789fbdfdf9798b8b$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $789fbdfdf9798b8b$var$absoluteToStylesheet(value, $789fbdfdf9798b8b$var$getHref());
    else if (tagName === "object" && name === "data") return $789fbdfdf9798b8b$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $789fbdfdf9798b8b$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $789fbdfdf9798b8b$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $789fbdfdf9798b8b$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $789fbdfdf9798b8b$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $789fbdfdf9798b8b$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $789fbdfdf9798b8b$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($789fbdfdf9798b8b$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $789fbdfdf9798b8b$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $789fbdfdf9798b8b$var$distanceToMatch(el, $789fbdfdf9798b8b$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $789fbdfdf9798b8b$var$distanceToMatch(el, $789fbdfdf9798b8b$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $789fbdfdf9798b8b$var$distanceToMatch(el, $789fbdfdf9798b8b$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $789fbdfdf9798b8b$var$distanceToMatch(el, $789fbdfdf9798b8b$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $789fbdfdf9798b8b$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $789fbdfdf9798b8b$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $789fbdfdf9798b8b$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $789fbdfdf9798b8b$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $789fbdfdf9798b8b$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $789fbdfdf9798b8b$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $789fbdfdf9798b8b$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $789fbdfdf9798b8b$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $789fbdfdf9798b8b$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $789fbdfdf9798b8b$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $789fbdfdf9798b8b$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $789fbdfdf9798b8b$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $789fbdfdf9798b8b$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : undefined;
    const isScript = parentTagName === "SCRIPT" ? true : undefined;
    const isTextarea = parentTagName === "TEXTAREA" ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($789fbdfdf9798b8b$var$_optionalChain$5([
                n,
                "access",
                (_6)=>_6.parentNode,
                "access",
                (_7)=>_7.sheet,
                "optionalAccess",
                (_8)=>_8.cssRules
            ])) textContent = $789fbdfdf9798b8b$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $789fbdfdf9798b8b$var$absoluteToStylesheet(textContent, $789fbdfdf9798b8b$var$getHref());
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $789fbdfdf9798b8b$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $789fbdfdf9798b8b$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $789fbdfdf9798b8b$var$maskInputValue({
            isMasked: $789fbdfdf9798b8b$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $789fbdfdf9798b8b$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $789fbdfdf9798b8b$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $789fbdfdf9798b8b$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $789fbdfdf9798b8b$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$789fbdfdf9798b8b$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $789fbdfdf9798b8b$var$transformAttribute(doc, tagName, $789fbdfdf9798b8b$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $789fbdfdf9798b8b$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $789fbdfdf9798b8b$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $789fbdfdf9798b8b$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $789fbdfdf9798b8b$var$absoluteToStylesheet(cssText, $789fbdfdf9798b8b$var$getHref());
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $789fbdfdf9798b8b$var$getInputType(el);
        const value = $789fbdfdf9798b8b$var$getInputValue(el, $789fbdfdf9798b8b$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $789fbdfdf9798b8b$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $789fbdfdf9798b8b$var$shouldMaskInput({
                type: type,
                tagName: $789fbdfdf9798b8b$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $789fbdfdf9798b8b$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$789fbdfdf9798b8b$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$789fbdfdf9798b8b$var$canvasService) {
            $789fbdfdf9798b8b$var$canvasService = doc.createElement("canvas");
            $789fbdfdf9798b8b$var$canvasCtx = $789fbdfdf9798b8b$var$canvasService.getContext("2d");
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = "anonymous";
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $789fbdfdf9798b8b$var$canvasService.width = image.naturalWidth;
                $789fbdfdf9798b8b$var$canvasService.height = image.naturalHeight;
                $789fbdfdf9798b8b$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $789fbdfdf9798b8b$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes.rr_mediaState = n.paused ? "paused" : "played";
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $789fbdfdf9798b8b$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $789fbdfdf9798b8b$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $789fbdfdf9798b8b$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $789fbdfdf9798b8b$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $789fbdfdf9798b8b$var$NodeType$1.Comment) return true;
    else if (sn.type === $789fbdfdf9798b8b$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && sn.attributes.href.endsWith(".js"))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "application-name" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.rel) === "icon" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "robots" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "googlebot" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "author" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "generator" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "framework" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "publisher" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "progid" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "verification" || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $789fbdfdf9798b8b$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $789fbdfdf9798b8b$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($789fbdfdf9798b8b$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $789fbdfdf9798b8b$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $789fbdfdf9798b8b$var$IGNORED_NODE;
    else id = $789fbdfdf9798b8b$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $789fbdfdf9798b8b$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $789fbdfdf9798b8b$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $789fbdfdf9798b8b$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $789fbdfdf9798b8b$var$NodeType$1.Document || serializedNode.type === $789fbdfdf9798b8b$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $789fbdfdf9798b8b$var$NodeType$1.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $789fbdfdf9798b8b$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($789fbdfdf9798b8b$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $789fbdfdf9798b8b$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $789fbdfdf9798b8b$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $789fbdfdf9798b8b$var$isShadowRoot(n.parentNode) && $789fbdfdf9798b8b$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $789fbdfdf9798b8b$var$NodeType$1.Element && serializedNode.tagName === "iframe") $789fbdfdf9798b8b$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $789fbdfdf9798b8b$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $789fbdfdf9798b8b$var$NodeType$1.Element && serializedNode.tagName === "link" && serializedNode.attributes.rel === "stylesheet") $789fbdfdf9798b8b$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $789fbdfdf9798b8b$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $789fbdfdf9798b8b$var$snapshot(n, options) {
    const { mirror: mirror = new $789fbdfdf9798b8b$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $789fbdfdf9798b8b$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $789fbdfdf9798b8b$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $789fbdfdf9798b8b$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $789fbdfdf9798b8b$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $789fbdfdf9798b8b$var$_mirror = {
    map: {},
    getId () {
        console.error($789fbdfdf9798b8b$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($789fbdfdf9798b8b$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($789fbdfdf9798b8b$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($789fbdfdf9798b8b$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($789fbdfdf9798b8b$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $789fbdfdf9798b8b$var$_mirror = new Proxy($789fbdfdf9798b8b$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($789fbdfdf9798b8b$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $789fbdfdf9798b8b$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $789fbdfdf9798b8b$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$789fbdfdf9798b8b$var$hookSetter(target, key, original || {}, true);
}
function $789fbdfdf9798b8b$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $789fbdfdf9798b8b$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $789fbdfdf9798b8b$var$nowTimestamp = ()=>new Date().getTime();
function $789fbdfdf9798b8b$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $789fbdfdf9798b8b$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_)=>_.documentElement,
            "access",
            (_2)=>_2.scrollLeft
        ]) || $789fbdfdf9798b8b$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_3)=>_3.body,
            "optionalAccess",
            (_4)=>_4.parentElement,
            "optionalAccess",
            (_5)=>_5.scrollLeft
        ]) || $789fbdfdf9798b8b$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_6)=>_6.body,
            "optionalAccess",
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $789fbdfdf9798b8b$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_8)=>_8.documentElement,
            "access",
            (_9)=>_9.scrollTop
        ]) || $789fbdfdf9798b8b$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_10)=>_10.body,
            "optionalAccess",
            (_11)=>_11.parentElement,
            "optionalAccess",
            (_12)=>_12.scrollTop
        ]) || $789fbdfdf9798b8b$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_13)=>_13.body,
            "optionalAccess",
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $789fbdfdf9798b8b$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $789fbdfdf9798b8b$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $789fbdfdf9798b8b$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    if (!el) return false;
    const blockedPredicate = $789fbdfdf9798b8b$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $789fbdfdf9798b8b$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $789fbdfdf9798b8b$var$distanceToMatch(el, $789fbdfdf9798b8b$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $789fbdfdf9798b8b$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $789fbdfdf9798b8b$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $789fbdfdf9798b8b$var$IGNORED_NODE;
}
function $789fbdfdf9798b8b$var$isAncestorRemoved(target, mirror) {
    if ($789fbdfdf9798b8b$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $789fbdfdf9798b8b$var$isAncestorRemoved(target.parentNode, mirror);
}
function $789fbdfdf9798b8b$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $789fbdfdf9798b8b$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $789fbdfdf9798b8b$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $789fbdfdf9798b8b$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $789fbdfdf9798b8b$var$hasShadowRoot(n) {
    return Boolean($789fbdfdf9798b8b$var$_optionalChain$4([
        n,
        "optionalAccess",
        (_18)=>_18.shadowRoot
    ]));
}
class $789fbdfdf9798b8b$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $hvuDy._nullishCoalesce)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $789fbdfdf9798b8b$var$getShadowHost(n) {
    let shadowHost = null;
    if ($789fbdfdf9798b8b$var$_optionalChain$4([
        n,
        "access",
        (_19)=>_19.getRootNode,
        "optionalCall",
        (_20)=>_20(),
        "optionalAccess",
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $789fbdfdf9798b8b$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $789fbdfdf9798b8b$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $789fbdfdf9798b8b$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $789fbdfdf9798b8b$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $789fbdfdf9798b8b$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $789fbdfdf9798b8b$var$shadowHostInDom(n);
}
let $789fbdfdf9798b8b$var$cachedRequestAnimationFrameImplementation;
function $789fbdfdf9798b8b$var$getRequestAnimationFrameImplementation() {
    if ($789fbdfdf9798b8b$var$cachedRequestAnimationFrameImplementation) return $789fbdfdf9798b8b$var$cachedRequestAnimationFrameImplementation;
    const document1 = window.document;
    let requestAnimationFrameImplementation = window.requestAnimationFrame;
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.requestAnimationFrame) requestAnimationFrameImplementation = contentWindow.requestAnimationFrame;
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $789fbdfdf9798b8b$var$cachedRequestAnimationFrameImplementation = requestAnimationFrameImplementation.bind(window);
}
function $789fbdfdf9798b8b$var$onRequestAnimationFrame(...rest) {
    return $789fbdfdf9798b8b$var$getRequestAnimationFrameImplementation()(...rest);
}
var $789fbdfdf9798b8b$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($789fbdfdf9798b8b$var$EventType || {});
var $789fbdfdf9798b8b$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($789fbdfdf9798b8b$var$IncrementalSource || {});
var $789fbdfdf9798b8b$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($789fbdfdf9798b8b$var$MouseInteractions || {});
var $789fbdfdf9798b8b$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($789fbdfdf9798b8b$var$PointerTypes || {});
function $789fbdfdf9798b8b$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $789fbdfdf9798b8b$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $789fbdfdf9798b8b$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = $789fbdfdf9798b8b$var$_optionalChain$3([
            current,
            "optionalAccess",
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $789fbdfdf9798b8b$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $789fbdfdf9798b8b$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $789fbdfdf9798b8b$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $789fbdfdf9798b8b$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $789fbdfdf9798b8b$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $789fbdfdf9798b8b$var$IGNORED_NODE;
                while(nextId === $789fbdfdf9798b8b$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$789fbdfdf9798b8b$var$inDom(n)) return;
                const parentId = $789fbdfdf9798b8b$var$isShadowRoot(n.parentNode) ? this.mirror.getId($789fbdfdf9798b8b$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $789fbdfdf9798b8b$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($789fbdfdf9798b8b$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($789fbdfdf9798b8b$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($789fbdfdf9798b8b$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($789fbdfdf9798b8b$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$789fbdfdf9798b8b$var$isAncestorInSet(this.droppedSet, n) && !$789fbdfdf9798b8b$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($789fbdfdf9798b8b$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($789fbdfdf9798b8b$var$isIgnored(m.target, this.mirror)) return;
            let unattachedDoc;
            try {
                unattachedDoc = document.implementation.createHTMLDocument();
            } catch (e) {
                unattachedDoc = this.doc;
            }
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$789fbdfdf9798b8b$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $789fbdfdf9798b8b$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $789fbdfdf9798b8b$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $789fbdfdf9798b8b$var$getInputValue(target, tagName, type);
                            const isInputMasked = $789fbdfdf9798b8b$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $789fbdfdf9798b8b$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $789fbdfdf9798b8b$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($789fbdfdf9798b8b$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributes.find((a)=>a.node === m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$789fbdfdf9798b8b$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $789fbdfdf9798b8b$var$transformAttribute(this.doc, $789fbdfdf9798b8b$var$toLowerCase(target.tagName), $789fbdfdf9798b8b$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                const old = unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($789fbdfdf9798b8b$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $789fbdfdf9798b8b$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($789fbdfdf9798b8b$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $789fbdfdf9798b8b$var$isIgnored(n, this.mirror) || !$789fbdfdf9798b8b$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $789fbdfdf9798b8b$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($789fbdfdf9798b8b$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$789fbdfdf9798b8b$var$moveKey(nodeId, parentId)]) $789fbdfdf9798b8b$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $789fbdfdf9798b8b$var$isShadowRoot(m.target) && $789fbdfdf9798b8b$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($789fbdfdf9798b8b$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$789fbdfdf9798b8b$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$789fbdfdf9798b8b$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($789fbdfdf9798b8b$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $789fbdfdf9798b8b$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$789fbdfdf9798b8b$var$deepDelete(addsSet, childN));
}
function $789fbdfdf9798b8b$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $789fbdfdf9798b8b$var$_isParentRemoved(removes, n, mirror);
}
function $789fbdfdf9798b8b$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $789fbdfdf9798b8b$var$_isParentRemoved(removes, parentNode, mirror);
}
function $789fbdfdf9798b8b$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $789fbdfdf9798b8b$var$_isAncestorInSet(set, n);
}
function $789fbdfdf9798b8b$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $789fbdfdf9798b8b$var$_isAncestorInSet(set, parentNode);
}
let $789fbdfdf9798b8b$var$errorHandler;
function $789fbdfdf9798b8b$var$registerErrorHandler(handler) {
    $789fbdfdf9798b8b$var$errorHandler = handler;
}
function $789fbdfdf9798b8b$var$unregisterErrorHandler() {
    $789fbdfdf9798b8b$var$errorHandler = undefined;
}
const $789fbdfdf9798b8b$var$callbackWrapper = (cb)=>{
    if (!$789fbdfdf9798b8b$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($789fbdfdf9798b8b$var$errorHandler && $789fbdfdf9798b8b$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $789fbdfdf9798b8b$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $789fbdfdf9798b8b$var$mutationBuffers = [];
function $789fbdfdf9798b8b$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $789fbdfdf9798b8b$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $789fbdfdf9798b8b$var$MutationBuffer();
    $789fbdfdf9798b8b$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $789fbdfdf9798b8b$var$_optionalChain$2([
        window,
        "optionalAccess",
        (_)=>_.Zone,
        "optionalAccess",
        (_2)=>_2.__symbol__,
        "optionalCall",
        (_3)=>_3("MutationObserver")
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($789fbdfdf9798b8b$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $789fbdfdf9798b8b$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $789fbdfdf9798b8b$var$throttle$1($789fbdfdf9798b8b$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $789fbdfdf9798b8b$var$callbackWrapper($789fbdfdf9798b8b$var$throttle$1($789fbdfdf9798b8b$var$callbackWrapper((evt)=>{
        const target = $789fbdfdf9798b8b$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $789fbdfdf9798b8b$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $789fbdfdf9798b8b$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $789fbdfdf9798b8b$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $789fbdfdf9798b8b$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $789fbdfdf9798b8b$var$IncrementalSource.MouseMove : $789fbdfdf9798b8b$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $789fbdfdf9798b8b$var$on("mousemove", updatePosition, doc),
        $789fbdfdf9798b8b$var$on("touchmove", updatePosition, doc),
        $789fbdfdf9798b8b$var$on("drag", updatePosition, doc)
    ];
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $789fbdfdf9798b8b$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $789fbdfdf9798b8b$var$getEventTarget(event);
            if ($789fbdfdf9798b8b$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $789fbdfdf9798b8b$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $789fbdfdf9798b8b$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $789fbdfdf9798b8b$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $789fbdfdf9798b8b$var$PointerTypes.Touch) {
                    if ($789fbdfdf9798b8b$var$MouseInteractions[eventKey] === $789fbdfdf9798b8b$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($789fbdfdf9798b8b$var$MouseInteractions[eventKey] === $789fbdfdf9798b8b$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $789fbdfdf9798b8b$var$PointerTypes.Pen;
            } else if ($789fbdfdf9798b8b$var$legacy_isTouchEvent(event)) pointerType = $789fbdfdf9798b8b$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $789fbdfdf9798b8b$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $789fbdfdf9798b8b$var$PointerTypes.Mouse) pointerType = null;
            } else if ($789fbdfdf9798b8b$var$MouseInteractions[eventKey] === $789fbdfdf9798b8b$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $789fbdfdf9798b8b$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $789fbdfdf9798b8b$var$callbackWrapper(mouseInteractionCb)({
                type: $789fbdfdf9798b8b$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($789fbdfdf9798b8b$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $789fbdfdf9798b8b$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($789fbdfdf9798b8b$var$MouseInteractions[eventKey]){
            case $789fbdfdf9798b8b$var$MouseInteractions.MouseDown:
            case $789fbdfdf9798b8b$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $789fbdfdf9798b8b$var$MouseInteractions.TouchStart:
            case $789fbdfdf9798b8b$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($789fbdfdf9798b8b$var$on(eventName, handler, doc));
    });
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $789fbdfdf9798b8b$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $789fbdfdf9798b8b$var$callbackWrapper($789fbdfdf9798b8b$var$throttle$1($789fbdfdf9798b8b$var$callbackWrapper((evt)=>{
        const target = $789fbdfdf9798b8b$var$getEventTarget(evt);
        if (!target || $789fbdfdf9798b8b$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $789fbdfdf9798b8b$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $789fbdfdf9798b8b$var$on("scroll", updatePosition, doc);
}
function $789fbdfdf9798b8b$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $789fbdfdf9798b8b$var$callbackWrapper($789fbdfdf9798b8b$var$throttle$1($789fbdfdf9798b8b$var$callbackWrapper(()=>{
        const height = $789fbdfdf9798b8b$var$getWindowHeight();
        const width = $789fbdfdf9798b8b$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $789fbdfdf9798b8b$var$on("resize", updateDimension, win);
}
const $789fbdfdf9798b8b$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $789fbdfdf9798b8b$var$lastInputValueMap = new WeakMap();
function $789fbdfdf9798b8b$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $789fbdfdf9798b8b$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $789fbdfdf9798b8b$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $789fbdfdf9798b8b$var$INPUT_TAGS.indexOf(tagName) < 0 || $789fbdfdf9798b8b$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $789fbdfdf9798b8b$var$getInputType(target);
        let text = $789fbdfdf9798b8b$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $789fbdfdf9798b8b$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $789fbdfdf9798b8b$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $789fbdfdf9798b8b$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $789fbdfdf9798b8b$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $789fbdfdf9798b8b$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $789fbdfdf9798b8b$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $789fbdfdf9798b8b$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $789fbdfdf9798b8b$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$789fbdfdf9798b8b$var$on(eventName, $789fbdfdf9798b8b$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$789fbdfdf9798b8b$var$hookSetter(p[0], p[1], {
            set () {
                $789fbdfdf9798b8b$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $789fbdfdf9798b8b$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($789fbdfdf9798b8b$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $789fbdfdf9798b8b$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $789fbdfdf9798b8b$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $789fbdfdf9798b8b$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $789fbdfdf9798b8b$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $789fbdfdf9798b8b$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($789fbdfdf9798b8b$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($789fbdfdf9798b8b$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($789fbdfdf9798b8b$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($789fbdfdf9798b8b$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$789fbdfdf9798b8b$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$789fbdfdf9798b8b$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $789fbdfdf9798b8b$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? $789fbdfdf9798b8b$var$_optionalChain$2([
        host,
        "access",
        (_4)=>_4.defaultView,
        "optionalAccess",
        (_5)=>_5.Document
    ]) : $789fbdfdf9798b8b$var$_optionalChain$2([
        host,
        "access",
        (_6)=>_6.ownerDocument,
        "optionalAccess",
        (_7)=>_7.defaultView,
        "optionalAccess",
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $789fbdfdf9798b8b$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($789fbdfdf9798b8b$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_10)=>_10.prototype
    ]), "adoptedStyleSheets") : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $789fbdfdf9798b8b$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_11)=>_11.get,
                "optionalAccess",
                (_12)=>_12.call,
                "call",
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $789fbdfdf9798b8b$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_14)=>_14.set,
                "optionalAccess",
                (_15)=>_15.call,
                "call",
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $789fbdfdf9798b8b$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId($789fbdfdf9798b8b$var$_optionalChain$2([
                thisArg,
                "access",
                (_17)=>_17.parentRule,
                "optionalAccess",
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $789fbdfdf9798b8b$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId($789fbdfdf9798b8b$var$_optionalChain$2([
                thisArg,
                "access",
                (_19)=>_19.parentRule,
                "optionalAccess",
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $789fbdfdf9798b8b$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $789fbdfdf9798b8b$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $789fbdfdf9798b8b$var$callbackWrapper((type)=>$789fbdfdf9798b8b$var$throttle$1($789fbdfdf9798b8b$var$callbackWrapper((event)=>{
            const target = $789fbdfdf9798b8b$var$getEventTarget(event);
            if (!target || $789fbdfdf9798b8b$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $789fbdfdf9798b8b$var$on("play", handler(0), doc),
        $789fbdfdf9798b8b$var$on("pause", handler(1), doc),
        $789fbdfdf9798b8b$var$on("seeked", handler(2), doc),
        $789fbdfdf9798b8b$var$on("volumechange", handler(3), doc),
        $789fbdfdf9798b8b$var$on("ratechange", handler(4), doc)
    ];
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $789fbdfdf9798b8b$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $789fbdfdf9798b8b$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout($789fbdfdf9798b8b$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $789fbdfdf9798b8b$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $789fbdfdf9798b8b$var$_optionalChain$2([
            selection,
            "optionalAccess",
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $789fbdfdf9798b8b$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $789fbdfdf9798b8b$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $789fbdfdf9798b8b$var$on("selectionchange", updateSelection);
}
function $789fbdfdf9798b8b$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $789fbdfdf9798b8b$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $789fbdfdf9798b8b$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = $789fbdfdf9798b8b$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $789fbdfdf9798b8b$var$initMoveObserver(o);
    const mouseInteractionHandler = $789fbdfdf9798b8b$var$initMouseInteractionObserver(o);
    const scrollHandler = $789fbdfdf9798b8b$var$initScrollObserver(o);
    const viewportResizeHandler = $789fbdfdf9798b8b$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $789fbdfdf9798b8b$var$initInputObserver(o);
    const mediaInteractionHandler = $789fbdfdf9798b8b$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $789fbdfdf9798b8b$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = $789fbdfdf9798b8b$var$initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = $789fbdfdf9798b8b$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $789fbdfdf9798b8b$var$initFontObserver(o) : ()=>{};
    const selectionObserver = $789fbdfdf9798b8b$var$initSelectionObserver(o);
    const customElementObserver = $789fbdfdf9798b8b$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        $789fbdfdf9798b8b$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $789fbdfdf9798b8b$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $789fbdfdf9798b8b$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $789fbdfdf9798b8b$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $789fbdfdf9798b8b$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $789fbdfdf9798b8b$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $789fbdfdf9798b8b$var$CrossOriginIframeMirror($789fbdfdf9798b8b$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $789fbdfdf9798b8b$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $789fbdfdf9798b8b$var$CrossOriginIframeMirror($789fbdfdf9798b8b$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $789fbdfdf9798b8b$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $789fbdfdf9798b8b$var$_optionalChain$1([
            this,
            "access",
            (_)=>_.loadListener,
            "optionalCall",
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $789fbdfdf9798b8b$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $789fbdfdf9798b8b$var$EventType.Meta:
            case $789fbdfdf9798b8b$var$EventType.Load:
            case $789fbdfdf9798b8b$var$EventType.DomContentLoaded:
                return false;
            case $789fbdfdf9798b8b$var$EventType.Plugin:
                return e;
            case $789fbdfdf9798b8b$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e;
            case $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $789fbdfdf9798b8b$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $789fbdfdf9798b8b$var$IncrementalSource.Drag:
                    case $789fbdfdf9798b8b$var$IncrementalSource.TouchMove:
                    case $789fbdfdf9798b8b$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $789fbdfdf9798b8b$var$IncrementalSource.ViewportResize:
                        return false;
                    case $789fbdfdf9798b8b$var$IncrementalSource.MediaInteraction:
                    case $789fbdfdf9798b8b$var$IncrementalSource.MouseInteraction:
                    case $789fbdfdf9798b8b$var$IncrementalSource.Scroll:
                    case $789fbdfdf9798b8b$var$IncrementalSource.CanvasMutation:
                    case $789fbdfdf9798b8b$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        return e;
                    case $789fbdfdf9798b8b$var$IncrementalSource.StyleSheetRule:
                    case $789fbdfdf9798b8b$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleId"
                        ]);
                        return e;
                    case $789fbdfdf9798b8b$var$IncrementalSource.Font:
                        return e;
                    case $789fbdfdf9798b8b$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e;
                    case $789fbdfdf9798b8b$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleIds"
                        ]);
                        $789fbdfdf9798b8b$var$_optionalChain$1([
                            e,
                            "access",
                            (_3)=>_3.data,
                            "access",
                            (_4)=>_4.styles,
                            "optionalAccess",
                            (_5)=>_5.forEach,
                            "call",
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $789fbdfdf9798b8b$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $789fbdfdf9798b8b$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $789fbdfdf9798b8b$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$789fbdfdf9798b8b$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $789fbdfdf9798b8b$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($789fbdfdf9798b8b$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        setTimeout(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($789fbdfdf9798b8b$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($789fbdfdf9798b8b$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $789fbdfdf9798b8b$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
class $789fbdfdf9798b8b$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class $789fbdfdf9798b8b$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $789fbdfdf9798b8b$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $789fbdfdf9798b8b$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $789fbdfdf9798b8b$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        $789fbdfdf9798b8b$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
function $789fbdfdf9798b8b$var$wrapEvent(e) {
    const eWithTime = e;
    eWithTime.timestamp = $789fbdfdf9798b8b$var$nowTimestamp();
    return eWithTime;
}
let $789fbdfdf9798b8b$var$_takeFullSnapshot;
const $789fbdfdf9798b8b$var$mirror = $789fbdfdf9798b8b$var$createMirror();
function $789fbdfdf9798b8b$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $789fbdfdf9798b8b$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $789fbdfdf9798b8b$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $789fbdfdf9798b8b$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    const wrappedEmit = (e, isCheckout)=>{
        if ((0, $fF2BR._optionalChain)([
            $789fbdfdf9798b8b$var$mutationBuffers,
            "access",
            (_)=>_[0],
            "optionalAccess",
            (_2)=>_2.isFrozen,
            "call",
            (_3)=>_3()
        ]) && e.type !== $789fbdfdf9798b8b$var$EventType.FullSnapshot && !(e.type === $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot && e.data.source === $789fbdfdf9798b8b$var$IncrementalSource.Mutation)) $789fbdfdf9798b8b$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $fF2BR._optionalChain)([
            emit,
            "optionalCall",
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e.type === $789fbdfdf9798b8b$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $789fbdfdf9798b8b$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
            type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
            data: {
                source: $789fbdfdf9798b8b$var$IncrementalSource.Mutation,
                ...m
            }
        }));
    };
    const wrappedScrollEmit = (p)=>wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
            type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
            data: {
                source: $789fbdfdf9798b8b$var$IncrementalSource.Scroll,
                ...p
            }
        }));
    const wrappedCanvasMutationEmit = (p)=>wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
            type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
            data: {
                source: $789fbdfdf9798b8b$var$IncrementalSource.CanvasMutation,
                ...p
            }
        }));
    const wrappedAdoptedStyleSheetEmit = (a)=>wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
            type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
            data: {
                source: $789fbdfdf9798b8b$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        }));
    const stylesheetManager = new $789fbdfdf9798b8b$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $789fbdfdf9798b8b$var$IframeManagerNoop() : new $789fbdfdf9798b8b$var$IframeManager({
        mirror: $789fbdfdf9798b8b$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $789fbdfdf9798b8b$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $789fbdfdf9798b8b$var$ProcessedNodeManager();
    const canvasManager = $789fbdfdf9798b8b$var$_getCanvasManager(getCanvasManager, {
        mirror: $789fbdfdf9798b8b$var$mirror,
        win: window,
        mutationCb: (p)=>wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
                type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                data: {
                    source: $789fbdfdf9798b8b$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            })),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $789fbdfdf9798b8b$var$ShadowDomManagerNoop() : new $789fbdfdf9798b8b$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $789fbdfdf9798b8b$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
            type: $789fbdfdf9798b8b$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $789fbdfdf9798b8b$var$getWindowWidth(),
                height: $789fbdfdf9798b8b$var$getWindowHeight()
            }
        }), isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $789fbdfdf9798b8b$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $789fbdfdf9798b8b$var$snapshot(document, {
            mirror: $789fbdfdf9798b8b$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($789fbdfdf9798b8b$var$isSerializedIframe(n, $789fbdfdf9798b8b$var$mirror)) iframeManager.addIframe(n);
                if ($789fbdfdf9798b8b$var$isSerializedStylesheet(n, $789fbdfdf9798b8b$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($789fbdfdf9798b8b$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
            type: $789fbdfdf9798b8b$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $789fbdfdf9798b8b$var$getWindowScroll(window)
            }
        }));
        $789fbdfdf9798b8b$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $789fbdfdf9798b8b$var$mirror.getId(document));
    };
    $789fbdfdf9798b8b$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $789fbdfdf9798b8b$var$callbackWrapper($789fbdfdf9798b8b$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    })),
                mouseInteractionCb: (d)=>wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    })),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    })),
                inputCb: (v)=>wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.Input,
                            ...v
                        }
                    })),
                mediaInteractionCb: (p)=>wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    })),
                styleSheetRuleCb: (r)=>wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    })),
                styleDeclarationCb: (r)=>wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    })),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.Font,
                            ...p
                        }
                    })),
                selectionCb: (p)=>{
                    wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.Selection,
                            ...p
                        }
                    }));
                },
                customElementCb: (c)=>{
                    wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    }));
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $789fbdfdf9798b8b$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $fF2BR._optionalChain)([
                    plugins,
                    "optionalAccess",
                    (_5)=>_5.filter,
                    "call",
                    (_6)=>_6((p)=>p.observer),
                    "optionalAccess",
                    (_7)=>_7.map,
                    "call",
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
                                        type: $789fbdfdf9798b8b$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    }))
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($789fbdfdf9798b8b$var$on("DOMContentLoaded", ()=>{
                wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
                    type: $789fbdfdf9798b8b$var$EventType.DomContentLoaded,
                    data: {}
                }));
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($789fbdfdf9798b8b$var$on("load", ()=>{
                wrappedEmit($789fbdfdf9798b8b$var$wrapEvent({
                    type: $789fbdfdf9798b8b$var$EventType.Load,
                    data: {}
                }));
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $789fbdfdf9798b8b$var$_takeFullSnapshot = undefined;
            $789fbdfdf9798b8b$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $789fbdfdf9798b8b$var$takeFullSnapshot(isCheckout) {
    if (!$789fbdfdf9798b8b$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $789fbdfdf9798b8b$var$_takeFullSnapshot(isCheckout);
}
$789fbdfdf9798b8b$var$record.mirror = $789fbdfdf9798b8b$var$mirror;
$789fbdfdf9798b8b$var$record.takeFullSnapshot = $789fbdfdf9798b8b$var$takeFullSnapshot;
function $789fbdfdf9798b8b$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $789fbdfdf9798b8b$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn("Unable to initialize CanvasManager");
        return new $789fbdfdf9798b8b$var$CanvasManagerNoop();
    }
}
const $789fbdfdf9798b8b$var$ReplayEventTypeIncrementalSnapshot = 3;
const $789fbdfdf9798b8b$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $789fbdfdf9798b8b$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $789fbdfdf9798b8b$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $789fbdfdf9798b8b$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $789fbdfdf9798b8b$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $5vnYi.normalize)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const $789fbdfdf9798b8b$var$INTERACTIVE_SELECTOR = "button,a";
/** Get the closest interactive parent element, or else return the given element. */ function $789fbdfdf9798b8b$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($789fbdfdf9798b8b$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $789fbdfdf9798b8b$var$getClickTargetNode(event) {
    const target = $789fbdfdf9798b8b$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $789fbdfdf9798b8b$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $789fbdfdf9798b8b$var$getTargetNode(event) {
    if ($789fbdfdf9798b8b$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $789fbdfdf9798b8b$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $789fbdfdf9798b8b$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $789fbdfdf9798b8b$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$789fbdfdf9798b8b$var$handlers) {
        $789fbdfdf9798b8b$var$handlers = [];
        $789fbdfdf9798b8b$var$monkeyPatchWindowOpen();
    }
    $789fbdfdf9798b8b$var$handlers.push(cb);
    return ()=>{
        const pos = $789fbdfdf9798b8b$var$handlers ? $789fbdfdf9798b8b$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $789fbdfdf9798b8b$var$handlers.splice(pos, 1);
    };
}
function $789fbdfdf9798b8b$var$monkeyPatchWindowOpen() {
    (0, $aajbp.fill)($789fbdfdf9798b8b$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($789fbdfdf9798b8b$var$handlers) try {
                $789fbdfdf9798b8b$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($789fbdfdf9798b8b$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $789fbdfdf9798b8b$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $789fbdfdf9798b8b$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $789fbdfdf9798b8b$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $789fbdfdf9798b8b$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $789fbdfdf9798b8b$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($789fbdfdf9798b8b$var$ignoreElement(node, this._ignoreSelector) || !$789fbdfdf9798b8b$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $789fbdfdf9798b8b$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $789fbdfdf9798b8b$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $789fbdfdf9798b8b$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $789fbdfdf9798b8b$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $789fbdfdf9798b8b$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $789fbdfdf9798b8b$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $789fbdfdf9798b8b$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const $789fbdfdf9798b8b$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function $789fbdfdf9798b8b$var$ignoreElement(node, ignoreSelector) {
    if (!$789fbdfdf9798b8b$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $789fbdfdf9798b8b$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $789fbdfdf9798b8b$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $789fbdfdf9798b8b$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$789fbdfdf9798b8b$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if (source === $789fbdfdf9798b8b$var$IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === $789fbdfdf9798b8b$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($789fbdfdf9798b8b$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $789fbdfdf9798b8b$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $789fbdfdf9798b8b$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $789fbdfdf9798b8b$var$isIncrementalEvent(event) {
    return event.type === $789fbdfdf9798b8b$var$ReplayEventTypeIncrementalSnapshot;
}
function $789fbdfdf9798b8b$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $789fbdfdf9798b8b$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $789fbdfdf9798b8b$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $789fbdfdf9798b8b$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($789fbdfdf9798b8b$var$NodeType || ($789fbdfdf9798b8b$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $789fbdfdf9798b8b$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $789fbdfdf9798b8b$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($789fbdfdf9798b8b$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $789fbdfdf9798b8b$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $789fbdfdf9798b8b$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $789fbdfdf9798b8b$var$handleClick(replay.clickDetector, result, $789fbdfdf9798b8b$var$getClickTargetNode(handlerData.event));
        $789fbdfdf9798b8b$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $789fbdfdf9798b8b$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $789fbdfdf9798b8b$var$record.mirror.getId(target);
    const node = nodeId && $789fbdfdf9798b8b$var$record.mirror.getNode(nodeId);
    const meta = node && $789fbdfdf9798b8b$var$record.mirror.getMeta(node);
    const element = meta && $789fbdfdf9798b8b$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $789fbdfdf9798b8b$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(""),
                attributes: $789fbdfdf9798b8b$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $789fbdfdf9798b8b$var$handleDom(handlerData) {
    const { target: target, message: message } = $789fbdfdf9798b8b$var$getDomTarget(handlerData);
    return $789fbdfdf9798b8b$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$789fbdfdf9798b8b$var$getBaseDomBreadcrumb(target, message)
    });
}
function $789fbdfdf9798b8b$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $789fbdfdf9798b8b$var$getClickTargetNode(handlerData.event) : $789fbdfdf9798b8b$var$getTargetNode(handlerData.event);
        message = (0, $04wr6.htmlTreeAsString)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $789fbdfdf9798b8b$var$isElement(node) {
    return node.type === $789fbdfdf9798b8b$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $789fbdfdf9798b8b$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $789fbdfdf9798b8b$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $789fbdfdf9798b8b$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $789fbdfdf9798b8b$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $789fbdfdf9798b8b$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $04wr6.htmlTreeAsString)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $789fbdfdf9798b8b$var$getBaseDomBreadcrumb(target, message);
    return $789fbdfdf9798b8b$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $789fbdfdf9798b8b$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $789fbdfdf9798b8b$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $789fbdfdf9798b8b$var$createResourceEntry,
    paint: $789fbdfdf9798b8b$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $789fbdfdf9798b8b$var$createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $789fbdfdf9798b8b$var$createPerformanceEntries(entries) {
    return entries.map($789fbdfdf9798b8b$var$createPerformanceEntry).filter(Boolean);
}
function $789fbdfdf9798b8b$var$createPerformanceEntry(entry) {
    if (!$789fbdfdf9798b8b$var$ENTRY_TYPES[entry.entryType]) return null;
    return $789fbdfdf9798b8b$var$ENTRY_TYPES[entry.entryType](entry);
}
function $789fbdfdf9798b8b$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $iGf0k.browserPerformanceTimeOrigin) || $789fbdfdf9798b8b$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $789fbdfdf9798b8b$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $789fbdfdf9798b8b$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $789fbdfdf9798b8b$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $789fbdfdf9798b8b$var$getAbsoluteTime(startTime),
        end: $789fbdfdf9798b8b$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $789fbdfdf9798b8b$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $789fbdfdf9798b8b$var$getAbsoluteTime(startTime),
        end: $789fbdfdf9798b8b$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function $789fbdfdf9798b8b$var$getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = $789fbdfdf9798b8b$var$getAbsoluteTime(value);
    const data = {
        type: "largest-contentful-paint",
        name: "largest-contentful-paint",
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? $789fbdfdf9798b8b$var$record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $789fbdfdf9798b8b$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $aiNal.addPerformanceInstrumentationHandler)(type, onEntries));
    });
    clearCallbacks.push((0, $aiNal.addLcpInstrumentationHandler)(({ metric: metric })=>{
        replay.replayPerformanceEntries.push($789fbdfdf9798b8b$var$getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $789fbdfdf9798b8b$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const $789fbdfdf9798b8b$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $789fbdfdf9798b8b$var$e() {
    const e = new Blob([
        $789fbdfdf9798b8b$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $789fbdfdf9798b8b$var$logInfo(message, shouldAddBreadcrumb) {
    if (!$789fbdfdf9798b8b$var$DEBUG_BUILD) return;
    (0, $7p8hL.logger).info(message);
    if (shouldAddBreadcrumb) $789fbdfdf9798b8b$var$addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $789fbdfdf9798b8b$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!$789fbdfdf9798b8b$var$DEBUG_BUILD) return;
    (0, $7p8hL.logger).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        $789fbdfdf9798b8b$var$addLogBreadcrumb(message);
    }, 0);
}
function $789fbdfdf9798b8b$var$addLogBreadcrumb(message) {
    (0, $hcepo.addBreadcrumb)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: "info",
        message: message
    }, {
        level: "info"
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $789fbdfdf9798b8b$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$789fbdfdf9798b8b$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $789fbdfdf9798b8b$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $789fbdfdf9798b8b$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $789fbdfdf9798b8b$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $789fbdfdf9798b8b$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $789fbdfdf9798b8b$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $789fbdfdf9798b8b$var$logInfo("[Replay] Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error("[Replay]", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $789fbdfdf9798b8b$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $789fbdfdf9798b8b$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $789fbdfdf9798b8b$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $789fbdfdf9798b8b$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $789fbdfdf9798b8b$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage("clear").then(null, (e)=>{
            $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $789fbdfdf9798b8b$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $789fbdfdf9798b8b$var$EventBufferArray();
        this._compression = new $789fbdfdf9798b8b$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $789fbdfdf9798b8b$var$logInfo("[Replay] Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn("[Replay] Failed to add events when switching buffers.", error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $789fbdfdf9798b8b$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $789fbdfdf9798b8b$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $789fbdfdf9798b8b$var$logInfo("[Replay] Using simple buffer");
    return new $789fbdfdf9798b8b$var$EventBufferArray();
}
function $789fbdfdf9798b8b$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $789fbdfdf9798b8b$var$_getWorkerUrl();
        if (!workerUrl) return;
        $789fbdfdf9798b8b$var$logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $789fbdfdf9798b8b$var$EventBufferProxy(worker);
    } catch (error) {
        $789fbdfdf9798b8b$var$logInfo("[Replay] Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
}
function $789fbdfdf9798b8b$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $789fbdfdf9798b8b$var$e();
    return "";
}
/** If sessionStorage is available. */ function $789fbdfdf9798b8b$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in $789fbdfdf9798b8b$var$WINDOW && !!$789fbdfdf9798b8b$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $789fbdfdf9798b8b$var$clearSession(replay) {
    $789fbdfdf9798b8b$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $789fbdfdf9798b8b$var$deleteSession() {
    if (!$789fbdfdf9798b8b$var$hasSessionStorage()) return;
    try {
        $789fbdfdf9798b8b$var$WINDOW.sessionStorage.removeItem($789fbdfdf9798b8b$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $789fbdfdf9798b8b$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $789fbdfdf9798b8b$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $iJH3x.uuid4)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $789fbdfdf9798b8b$var$saveSession(session) {
    if (!$789fbdfdf9798b8b$var$hasSessionStorage()) return;
    try {
        $789fbdfdf9798b8b$var$WINDOW.sessionStorage.setItem($789fbdfdf9798b8b$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $789fbdfdf9798b8b$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $789fbdfdf9798b8b$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $789fbdfdf9798b8b$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $789fbdfdf9798b8b$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $789fbdfdf9798b8b$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $789fbdfdf9798b8b$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $789fbdfdf9798b8b$var$fetchSession(traceInternals) {
    if (!$789fbdfdf9798b8b$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $789fbdfdf9798b8b$var$WINDOW.sessionStorage.getItem($789fbdfdf9798b8b$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $789fbdfdf9798b8b$var$logInfoNextTick("[Replay] Loading existing session", traceInternals);
        return $789fbdfdf9798b8b$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $789fbdfdf9798b8b$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $789fbdfdf9798b8b$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $789fbdfdf9798b8b$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $789fbdfdf9798b8b$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $789fbdfdf9798b8b$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$789fbdfdf9798b8b$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $789fbdfdf9798b8b$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $789fbdfdf9798b8b$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $789fbdfdf9798b8b$var$logInfoNextTick("[Replay] Creating new session", traceInternals);
        return $789fbdfdf9798b8b$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$789fbdfdf9798b8b$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $789fbdfdf9798b8b$var$logInfoNextTick("[Replay] Session in sessionStorage is expired, creating new one...");
    return $789fbdfdf9798b8b$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $789fbdfdf9798b8b$var$isCustomEvent(event) {
    return event.type === $789fbdfdf9798b8b$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $789fbdfdf9798b8b$var$addEventSync(replay, event, isCheckout) {
    if (!$789fbdfdf9798b8b$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $789fbdfdf9798b8b$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $789fbdfdf9798b8b$var$addEvent(replay, event, isCheckout) {
    if (!$789fbdfdf9798b8b$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $789fbdfdf9798b8b$var$_addEvent(replay, event, isCheckout);
}
async function $789fbdfdf9798b8b$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === "buffer") replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $789fbdfdf9798b8b$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $789fbdfdf9798b8b$var$EventBufferSizeExceededError ? "addEventSizeExceeded" : "addEvent";
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $hcepo.getClient)();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function $789fbdfdf9798b8b$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $789fbdfdf9798b8b$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $789fbdfdf9798b8b$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $789fbdfdf9798b8b$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $789fbdfdf9798b8b$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error("[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...", error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $789fbdfdf9798b8b$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $789fbdfdf9798b8b$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $789fbdfdf9798b8b$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/** If the event is a feedback event */ function $789fbdfdf9798b8b$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $789fbdfdf9798b8b$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $789fbdfdf9798b8b$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$789fbdfdf9798b8b$var$isErrorEvent(event) && !$789fbdfdf9798b8b$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if ($789fbdfdf9798b8b$var$isTransactionEvent(event)) {
            $789fbdfdf9798b8b$var$handleTransactionEvent(replay, event);
            return;
        }
        $789fbdfdf9798b8b$var$handleErrorEvent(replay, event);
    };
}
function $789fbdfdf9798b8b$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $789fbdfdf9798b8b$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== "buffer" || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    setTimeout(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
function $789fbdfdf9798b8b$var$isBaseTransportSend() {
    const client = (0, $hcepo.getClient)();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $789fbdfdf9798b8b$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$789fbdfdf9798b8b$var$isErrorEvent(event)) return;
        $789fbdfdf9798b8b$var$handleHydrationError(replay, event);
    };
}
function $789fbdfdf9798b8b$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $789fbdfdf9798b8b$var$createBreadcrumb({
            category: "replay.hydrate-error"
        });
        $789fbdfdf9798b8b$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $789fbdfdf9798b8b$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $789fbdfdf9798b8b$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $789fbdfdf9798b8b$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $789fbdfdf9798b8b$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $789fbdfdf9798b8b$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $789fbdfdf9798b8b$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $789fbdfdf9798b8b$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $789fbdfdf9798b8b$var$handleAfterSendEvent(replay) : undefined;
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($789fbdfdf9798b8b$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$789fbdfdf9798b8b$var$isErrorEvent(event) && !$789fbdfdf9798b8b$var$isTransactionEvent(event) && !$789fbdfdf9798b8b$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($789fbdfdf9798b8b$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $789fbdfdf9798b8b$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($789fbdfdf9798b8b$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).log("[Replay] Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $789fbdfdf9798b8b$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    }, {
        id: "Replay"
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $789fbdfdf9798b8b$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $789fbdfdf9798b8b$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $789fbdfdf9798b8b$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $789fbdfdf9798b8b$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $789fbdfdf9798b8b$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $789fbdfdf9798b8b$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $789fbdfdf9798b8b$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($789fbdfdf9798b8b$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $djmte.isSentryRequestUrl)(url, (0, $hcepo.getClient)());
}
/** Add a performance entry breadcrumb */ function $789fbdfdf9798b8b$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($789fbdfdf9798b8b$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $789fbdfdf9798b8b$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $789fbdfdf9798b8b$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: "resource.fetch",
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */ function $789fbdfdf9798b8b$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $789fbdfdf9798b8b$var$handleFetch(handlerData);
        $789fbdfdf9798b8b$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $789fbdfdf9798b8b$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $jOCzY.SENTRY_XHR_DATA_KEY];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: "resource.xhr",
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */ function $789fbdfdf9798b8b$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $789fbdfdf9798b8b$var$handleXhr(handlerData);
        $789fbdfdf9798b8b$var$addNetworkBreadcrumb(replay, result);
    };
}
/** Get the size of a body. */ function $789fbdfdf9798b8b$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $789fbdfdf9798b8b$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $789fbdfdf9798b8b$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $789fbdfdf9798b8b$var$getBodyString(body) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $789fbdfdf9798b8b$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
/** Merge a warning into an existing network request/response. */ function $789fbdfdf9798b8b$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $789fbdfdf9798b8b$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $aajbp.dropUndefinedKeys)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $789fbdfdf9798b8b$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $789fbdfdf9798b8b$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $789fbdfdf9798b8b$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $789fbdfdf9798b8b$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $789fbdfdf9798b8b$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $789fbdfdf9798b8b$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $789fbdfdf9798b8b$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $789fbdfdf9798b8b$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $789fbdfdf9798b8b$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $789fbdfdf9798b8b$var$urlMatches(url, urls) {
    const fullUrl = $789fbdfdf9798b8b$var$getFullUrl(url);
    return (0, $bMiqE.stringMatchesSomePattern)(fullUrl, urls);
}
/** exported for tests */ function $789fbdfdf9798b8b$var$getFullUrl(url, baseURI = $789fbdfdf9798b8b$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($789fbdfdf9798b8b$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $789fbdfdf9798b8b$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $789fbdfdf9798b8b$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $789fbdfdf9798b8b$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $789fbdfdf9798b8b$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $789fbdfdf9798b8b$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = input ? $789fbdfdf9798b8b$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $789fbdfdf9798b8b$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $789fbdfdf9798b8b$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $789fbdfdf9798b8b$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $789fbdfdf9798b8b$var$urlMatches(url, options.networkDetailAllowUrls) && !$789fbdfdf9798b8b$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $789fbdfdf9798b8b$var$_getRequestInfo(options, hint.input, requestBodySize) : $789fbdfdf9798b8b$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $789fbdfdf9798b8b$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $789fbdfdf9798b8b$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $789fbdfdf9798b8b$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $789fbdfdf9798b8b$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $789fbdfdf9798b8b$var$getBodyString(requestBody);
    const data = $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $789fbdfdf9798b8b$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $789fbdfdf9798b8b$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $789fbdfdf9798b8b$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $789fbdfdf9798b8b$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $789fbdfdf9798b8b$var$_parseFetchResponseBody(response);
    const result = $789fbdfdf9798b8b$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        textEncoder: textEncoder,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $789fbdfdf9798b8b$var$mergeWarning(result, warning);
    return result;
}
function $789fbdfdf9798b8b$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $789fbdfdf9798b8b$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $789fbdfdf9798b8b$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn("[Replay] Failed to serialize response body", error);
        // fallback
        return $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $789fbdfdf9798b8b$var$_parseFetchResponseBody(response) {
    const res = $789fbdfdf9798b8b$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $789fbdfdf9798b8b$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn("[Replay] Failed to get text body from response", error);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $789fbdfdf9798b8b$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function $789fbdfdf9798b8b$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $789fbdfdf9798b8b$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $789fbdfdf9798b8b$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $789fbdfdf9798b8b$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $789fbdfdf9798b8b$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $789fbdfdf9798b8b$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $789fbdfdf9798b8b$var$getAllowedHeaders(headers, allowedHeaders);
}
function $789fbdfdf9798b8b$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn("[Replay] Failed to clone response body", error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $789fbdfdf9798b8b$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $789fbdfdf9798b8b$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $789fbdfdf9798b8b$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $789fbdfdf9798b8b$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $789fbdfdf9798b8b$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $789fbdfdf9798b8b$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $789fbdfdf9798b8b$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error("[Replay] Failed to capture xhr breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $789fbdfdf9798b8b$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $789fbdfdf9798b8b$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader("content-length") ? $789fbdfdf9798b8b$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $789fbdfdf9798b8b$var$_getBodySize(xhr.response, xhr.responseType, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $789fbdfdf9798b8b$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$789fbdfdf9798b8b$var$urlMatches(url, options.networkDetailAllowUrls) || $789fbdfdf9798b8b$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $789fbdfdf9798b8b$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $789fbdfdf9798b8b$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $jOCzY.SENTRY_XHR_DATA_KEY];
    const networkRequestHeaders = xhrInfo ? $789fbdfdf9798b8b$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $789fbdfdf9798b8b$var$getAllowedHeaders($789fbdfdf9798b8b$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $789fbdfdf9798b8b$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $789fbdfdf9798b8b$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $789fbdfdf9798b8b$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $789fbdfdf9798b8b$var$mergeWarning(response, responseWarning) : response
    };
}
function $789fbdfdf9798b8b$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $789fbdfdf9798b8b$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $789fbdfdf9798b8b$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn("[Replay] Failed to get xhr response body", ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $789fbdfdf9798b8b$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $789fbdfdf9798b8b$var$_getBodySize(body, responseType, textEncoder) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return $789fbdfdf9798b8b$var$getBodySize(bodyStr, textEncoder);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $789fbdfdf9798b8b$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $hcepo.getClient)();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$789fbdfdf9798b8b$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $dQVMO.addFetchInstrumentationHandler)($789fbdfdf9798b8b$var$handleFetchSpanListener(replay));
            (0, $jOCzY.addXhrInstrumentationHandler)($789fbdfdf9798b8b$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $789fbdfdf9798b8b$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($789fbdfdf9798b8b$var$_isXhrBreadcrumb(breadcrumb) && $789fbdfdf9798b8b$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $789fbdfdf9798b8b$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $789fbdfdf9798b8b$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($789fbdfdf9798b8b$var$_isFetchBreadcrumb(breadcrumb) && $789fbdfdf9798b8b$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $789fbdfdf9798b8b$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $789fbdfdf9798b8b$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn("Error when enriching network breadcrumb");
    }
}
function $789fbdfdf9798b8b$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $789fbdfdf9798b8b$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $789fbdfdf9798b8b$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $789fbdfdf9798b8b$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $789fbdfdf9798b8b$var$_LAST_BREADCRUMB = null;
function $789fbdfdf9798b8b$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const $789fbdfdf9798b8b$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $789fbdfdf9798b8b$var$handleScope(scope);
        if (!result) return;
        $789fbdfdf9798b8b$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $789fbdfdf9798b8b$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($789fbdfdf9798b8b$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $789fbdfdf9798b8b$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (!$789fbdfdf9798b8b$var$isBreadcrumbWithCategory(newBreadcrumb) || [
        "fetch",
        "xhr",
        "sentry.event",
        "sentry.transaction"
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith("ui.")) return null;
    if (newBreadcrumb.category === "console") return $789fbdfdf9798b8b$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $789fbdfdf9798b8b$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $789fbdfdf9798b8b$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $789fbdfdf9798b8b$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $789fbdfdf9798b8b$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $789fbdfdf9798b8b$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $5vnYi.normalize)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $789fbdfdf9798b8b$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $789fbdfdf9798b8b$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $789fbdfdf9798b8b$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $789fbdfdf9798b8b$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $hcepo.getCurrentScope)();
    const client = (0, $hcepo.getClient)();
    scope.addScopeListener($789fbdfdf9798b8b$var$handleScopeListener(replay));
    (0, $lemS8.addClickKeypressInstrumentationHandler)($789fbdfdf9798b8b$var$handleDomListener(replay));
    (0, $hFlB3.addHistoryInstrumentationHandler)($789fbdfdf9798b8b$var$handleHistorySpanListener(replay));
    $789fbdfdf9798b8b$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $789fbdfdf9798b8b$var$handleGlobalEventListener(replay, !$789fbdfdf9798b8b$var$hasHooks(client));
    if (client && client.addEventProcessor) client.addEventProcessor(eventProcessor);
    else (0, $huK8b.addEventProcessor)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($789fbdfdf9798b8b$var$hasHooks(client)) {
        client.on("beforeSendEvent", $789fbdfdf9798b8b$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $789fbdfdf9798b8b$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("startTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on("finishTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We want to flush replay
        client.on("beforeSendFeedback", (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $789fbdfdf9798b8b$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $789fbdfdf9798b8b$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($789fbdfdf9798b8b$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $789fbdfdf9798b8b$var$createMemoryEntry($789fbdfdf9798b8b$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $789fbdfdf9798b8b$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $789fbdfdf9798b8b$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $789fbdfdf9798b8b$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn("[Replay] Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $789fbdfdf9798b8b$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$789fbdfdf9798b8b$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $789fbdfdf9798b8b$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $789fbdfdf9798b8b$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $789fbdfdf9798b8b$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === "session") // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $789fbdfdf9798b8b$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $789fbdfdf9798b8b$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $789fbdfdf9798b8b$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $789fbdfdf9798b8b$var$addEventSync(replay, $789fbdfdf9798b8b$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $789fbdfdf9798b8b$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $2pR2a.createEnvelope)((0, $2pR2a.createEventEnvelopeHeaders)(replayEvent, (0, $2pR2a.getSdkMetadataForEnvelopeHeader)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $789fbdfdf9798b8b$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $789fbdfdf9798b8b$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    if (client.emit) client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $5XnTz.prepareEvent)(client.getOptions(), event, eventHint, scope, client, (0, $fxUGN.getIsolationScope)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $789fbdfdf9798b8b$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $789fbdfdf9798b8b$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $hcepo.getClient)();
    const scope = (0, $hcepo.getCurrentScope)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $789fbdfdf9798b8b$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $789fbdfdf9798b8b$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        $789fbdfdf9798b8b$var$logInfo("An event processor returned `null`, will not send event.");
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $789fbdfdf9798b8b$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($789fbdfdf9798b8b$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $789fbdfdf9798b8b$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $3iBML.updateRateLimits)({}, response);
    if ((0, $3iBML.isRateLimited)(rateLimits, "replay")) throw new $789fbdfdf9798b8b$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $789fbdfdf9798b8b$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $789fbdfdf9798b8b$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $789fbdfdf9798b8b$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $789fbdfdf9798b8b$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $789fbdfdf9798b8b$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $789fbdfdf9798b8b$var$TransportStatusCodeError || err instanceof $789fbdfdf9798b8b$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $hcepo.setContext)("Replays", {
            _retryCount: retryConfig.count
        });
        if ($789fbdfdf9798b8b$var$DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, $hcepo.captureException)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $789fbdfdf9798b8b$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$789fbdfdf9798b8b$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $789fbdfdf9798b8b$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $789fbdfdf9798b8b$var$THROTTLED = "__THROTTLED";
const $789fbdfdf9798b8b$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $789fbdfdf9798b8b$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $789fbdfdf9798b8b$var$SKIPPED : $789fbdfdf9798b8b$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $789fbdfdf9798b8b$var$ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $789fbdfdf9798b8b$var$ReplayContainer.prototype.__init.call(this);
        $789fbdfdf9798b8b$var$ReplayContainer.prototype.__init2.call(this);
        $789fbdfdf9798b8b$var$ReplayContainer.prototype.__init3.call(this);
        $789fbdfdf9798b8b$var$ReplayContainer.prototype.__init4.call(this);
        $789fbdfdf9798b8b$var$ReplayContainer.prototype.__init5.call(this);
        $789fbdfdf9798b8b$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $789fbdfdf9798b8b$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $789fbdfdf9798b8b$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $789fbdfdf9798b8b$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $789fbdfdf9798b8b$var$throttle((event, isCheckout)=>$789fbdfdf9798b8b$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($789fbdfdf9798b8b$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $789fbdfdf9798b8b$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $789fbdfdf9798b8b$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $789fbdfdf9798b8b$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") throw new Error("Replay recording is already in progress");
        if (this._isEnabled && this.recordingMode === "buffer") throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
        $789fbdfdf9798b8b$var$logInfoNextTick("[Replay] Starting replay in session mode", this._options._experiments.traceInternals);
        const session = $789fbdfdf9798b8b$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error("Replay recording is already in progress");
        $789fbdfdf9798b8b$var$logInfoNextTick("[Replay] Starting replay in buffer mode", this._options._experiments.traceInternals);
        const session = $789fbdfdf9798b8b$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $789fbdfdf9798b8b$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" && {
                    checkoutEveryNms: $789fbdfdf9798b8b$var$BUFFER_CHECKOUT_TIME
                },
                emit: $789fbdfdf9798b8b$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $789fbdfdf9798b8b$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ""}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $789fbdfdf9798b8b$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $789fbdfdf9798b8b$var$logInfo("[Replay] Pausing replay", this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $789fbdfdf9798b8b$var$logInfo("[Replay] Resuming replay", this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $789fbdfdf9798b8b$var$logInfo("[Replay] Converting buffer to session", this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $789fbdfdf9798b8b$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$789fbdfdf9798b8b$var$WINDOW.location.pathname}${$789fbdfdf9798b8b$var$WINDOW.location.hash}${$789fbdfdf9798b8b$var$WINDOW.location.search}`;
        const url = `${$789fbdfdf9798b8b$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $789fbdfdf9798b8b$var$THROTTLED) {
            const breadcrumb = $789fbdfdf9798b8b$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$789fbdfdf9798b8b$var$addEventSync(this, {
                    type: $789fbdfdf9798b8b$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        // eslint-disable-next-line deprecation/deprecation
        const lastTransaction = this.lastTransaction || (0, $hcepo.getCurrentScope)().getTransaction();
        const attributes = lastTransaction && (0, $4RP7L.spanToJSON)(lastTransaction).data || {};
        const source = attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        if (!lastTransaction || !source || ![
            "route",
            "custom"
        ].includes(source)) return undefined;
        return (0, $4RP7L.spanToJSON)(lastTransaction).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $789fbdfdf9798b8b$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error("[Replay]", error);
        if ($789fbdfdf9798b8b$var$DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, $hcepo.captureException)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $789fbdfdf9798b8b$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($789fbdfdf9798b8b$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $789fbdfdf9798b8b$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $789fbdfdf9798b8b$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $789fbdfdf9798b8b$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $789fbdfdf9798b8b$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $789fbdfdf9798b8b$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = $789fbdfdf9798b8b$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $789fbdfdf9798b8b$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $789fbdfdf9798b8b$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $789fbdfdf9798b8b$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $789fbdfdf9798b8b$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($789fbdfdf9798b8b$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $789fbdfdf9798b8b$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $789fbdfdf9798b8b$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $789fbdfdf9798b8b$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $789fbdfdf9798b8b$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $789fbdfdf9798b8b$var$logInfo("[Replay] Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $789fbdfdf9798b8b$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $789fbdfdf9798b8b$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($789fbdfdf9798b8b$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error("[Replay] No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $789fbdfdf9798b8b$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $789fbdfdf9798b8b$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, $hcepo.getClient)();
            if (client) client.recordDroppedEvent("send_error", "replay");
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error("[Replay] Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $789fbdfdf9798b8b$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $789fbdfdf9798b8b$var$logInfo("[Replay] Flushing initial segment without checkout.", this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $789fbdfdf9798b8b$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $789fbdfdf9798b8b$var$createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: "mutationLimit",
                    forceFlush: this.recordingMode === "session"
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $789fbdfdf9798b8b$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === "string" ? deprecatedSelectorOption.split(",") : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== "undefined") {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === "string") allSelectors.push(`.${deprecatedClassOption}`);
        (0, $7p8hL.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.");
        });
    }
    return allSelectors.join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $789fbdfdf9798b8b$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $789fbdfdf9798b8b$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $789fbdfdf9798b8b$var$getOption(unmask, [
        ".sentry-unmask",
        "[data-sentry-unmask]"
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $789fbdfdf9798b8b$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $789fbdfdf9798b8b$var$getOption(unblock, [
            ".sentry-unblock",
            "[data-sentry-unblock]"
        ]),
        ignoreSelector: $789fbdfdf9798b8b$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $789fbdfdf9798b8b$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "")) return value.replace(/[\S]/g, "*");
    return value;
}
const $789fbdfdf9798b8b$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $789fbdfdf9798b8b$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $789fbdfdf9798b8b$var$_initialized = false;
const $789fbdfdf9798b8b$export$d7706faf7ab354bf = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new $789fbdfdf9798b8b$export$a35c789ed37ee0f7(options);
};
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */ class $789fbdfdf9798b8b$export$a35c789ed37ee0f7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $789fbdfdf9798b8b$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $789fbdfdf9798b8b$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $789fbdfdf9798b8b$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $789fbdfdf9798b8b$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = $789fbdfdf9798b8b$export$a35c789ed37ee0f7.id;
        const privacyOptions = $789fbdfdf9798b8b$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            ignoreClass: ignoreClass
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$789fbdfdf9798b8b$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $789fbdfdf9798b8b$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $789fbdfdf9798b8b$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $789fbdfdf9798b8b$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $789fbdfdf9798b8b$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $789fbdfdf9798b8b$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$789fbdfdf9798b8b$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $kVwzp.isBrowser)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $789fbdfdf9798b8b$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $789fbdfdf9798b8b$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, $kVwzp.isBrowser)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $789fbdfdf9798b8b$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $789fbdfdf9798b8b$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, $hcepo.getClient)();
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$789fbdfdf9798b8b$export$a35c789ed37ee0f7.__initStatic();
/** Parse Replay-related options from SDK options */ function $789fbdfdf9798b8b$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $hcepo.getClient)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $aajbp.dropUndefinedKeys)(initialOptions)
    };
    if (!opt) {
        (0, $7p8hL.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("SDK client is not available.");
        });
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) (0, $7p8hL.consoleSandbox)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (typeof opt.replaysSessionSampleRate === "number") finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === "number") finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $789fbdfdf9798b8b$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$789fbdfdf9798b8b$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ // eslint-disable-next-line deprecation/deprecation
function $789fbdfdf9798b8b$export$b28310b2f161456b() {
    const client = (0, $hcepo.getClient)();
    return client && client.getIntegrationByName && client.getIntegrationByName("Replay");
}

});
parcelRegister("hvuDy", function(module, exports) {

$parcel$export(module.exports, "_nullishCoalesce", function () { return $cbed18c7b3dde05a$export$8db64e83cc1a933c; });
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $cbed18c7b3dde05a$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

});

parcelRegister("fF2BR", function(module, exports) {

$parcel$export(module.exports, "_optionalChain", function () { return $b66cb594cb3b8f86$export$3cc482e6b02f32f7; });
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $b66cb594cb3b8f86$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}

});

parcelRegister("kVwzp", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $f3c26542921d54b7$export$4e09c449d6c407f7; });

var $asmVu = parcelRequire("asmVu");

var $lNVQ9 = parcelRequire("lNVQ9");
/**
 * Returns true if we are in the browser.
 */ function $f3c26542921d54b7$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $asmVu.isNodeEnv)() || $f3c26542921d54b7$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $f3c26542921d54b7$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $lNVQ9.GLOBAL_OBJ).process !== undefined && (0, $lNVQ9.GLOBAL_OBJ).process.type === "renderer");
}

});
parcelRegister("asmVu", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $f2UY0 = parcelRequire("f2UY0");

var $4TNnu = parcelRequire("4TNnu");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $f2UY0.isBrowserBundle)() && Object.prototype.toString.call(typeof $4TNnu !== "undefined" ? $4TNnu : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});


parcelRegister("aiNal", function(module, exports) {

$parcel$export(module.exports, "addClsInstrumentationHandler", function () { return $7801b91fe69631d0$export$861b82818b37ba5b; });
$parcel$export(module.exports, "addLcpInstrumentationHandler", function () { return $7801b91fe69631d0$export$3fd4b53331200102; });
$parcel$export(module.exports, "addFidInstrumentationHandler", function () { return $7801b91fe69631d0$export$2707d7471c0b918f; });
$parcel$export(module.exports, "addInpInstrumentationHandler", function () { return $7801b91fe69631d0$export$da3b76aa2022cbd7; });
$parcel$export(module.exports, "addPerformanceInstrumentationHandler", function () { return $7801b91fe69631d0$export$69816c1a049f8db6; });

var $kEJYx = parcelRequire("kEJYx");
var $7p8hL = parcelRequire("7p8hL");

var $221nn = parcelRequire("221nn");

var $jnMu7 = parcelRequire("jnMu7");

var $hCnge = parcelRequire("hCnge");

var $fUHEP = parcelRequire("fUHEP");

var $fLb5H = parcelRequire("fLb5H");

var $9zLwN = parcelRequire("9zLwN");
const $7801b91fe69631d0$var$handlers = {};
const $7801b91fe69631d0$var$instrumented = {};
let $7801b91fe69631d0$var$_previousCls;
let $7801b91fe69631d0$var$_previousFid;
let $7801b91fe69631d0$var$_previousLcp;
let $7801b91fe69631d0$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $7801b91fe69631d0$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $7801b91fe69631d0$var$addMetricObserver("cls", callback, $7801b91fe69631d0$var$instrumentCls, $7801b91fe69631d0$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $7801b91fe69631d0$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $7801b91fe69631d0$var$addMetricObserver("lcp", callback, $7801b91fe69631d0$var$instrumentLcp, $7801b91fe69631d0$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $7801b91fe69631d0$export$2707d7471c0b918f(callback) {
    return $7801b91fe69631d0$var$addMetricObserver("fid", callback, $7801b91fe69631d0$var$instrumentFid, $7801b91fe69631d0$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $7801b91fe69631d0$export$da3b76aa2022cbd7(callback) {
    return $7801b91fe69631d0$var$addMetricObserver("inp", callback, $7801b91fe69631d0$var$instrumentInp, $7801b91fe69631d0$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $7801b91fe69631d0$export$69816c1a049f8db6(type, callback) {
    $7801b91fe69631d0$var$addHandler(type, callback);
    if (!$7801b91fe69631d0$var$instrumented[type]) {
        $7801b91fe69631d0$var$instrumentPerformanceObserver(type);
        $7801b91fe69631d0$var$instrumented[type] = true;
    }
    return $7801b91fe69631d0$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $7801b91fe69631d0$var$triggerHandlers(type, data) {
    const typeHandlers = $7801b91fe69631d0$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $kEJYx.getFunctionName)(handler)}\nError:`, e);
    }
}
function $7801b91fe69631d0$var$instrumentCls() {
    return (0, $jnMu7.onCLS)((metric)=>{
        $7801b91fe69631d0$var$triggerHandlers("cls", {
            metric: metric
        });
        $7801b91fe69631d0$var$_previousCls = metric;
    });
}
function $7801b91fe69631d0$var$instrumentFid() {
    return (0, $hCnge.onFID)((metric)=>{
        $7801b91fe69631d0$var$triggerHandlers("fid", {
            metric: metric
        });
        $7801b91fe69631d0$var$_previousFid = metric;
    });
}
function $7801b91fe69631d0$var$instrumentLcp() {
    return (0, $fLb5H.onLCP)((metric)=>{
        $7801b91fe69631d0$var$triggerHandlers("lcp", {
            metric: metric
        });
        $7801b91fe69631d0$var$_previousLcp = metric;
    });
}
function $7801b91fe69631d0$var$instrumentInp() {
    return (0, $fUHEP.onINP)((metric)=>{
        $7801b91fe69631d0$var$triggerHandlers("inp", {
            metric: metric
        });
        $7801b91fe69631d0$var$_previousInp = metric;
    });
}
function $7801b91fe69631d0$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $7801b91fe69631d0$var$addHandler(type, callback);
    let stopListening;
    if (!$7801b91fe69631d0$var$instrumented[type]) {
        stopListening = instrumentFn();
        $7801b91fe69631d0$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $7801b91fe69631d0$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $7801b91fe69631d0$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $9zLwN.observe)(type, (entries)=>{
        $7801b91fe69631d0$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $7801b91fe69631d0$var$addHandler(type, handler) {
    $7801b91fe69631d0$var$handlers[type] = $7801b91fe69631d0$var$handlers[type] || [];
    $7801b91fe69631d0$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $7801b91fe69631d0$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $7801b91fe69631d0$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}

});
parcelRegister("221nn", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $17acd5eeea63751d$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $17acd5eeea63751d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("jnMu7", function(module, exports) {

$parcel$export(module.exports, "onCLS", function () { return $e1c5c663fd2a35f4$export$a7873055838e5ad8; });

var $gfJJk = parcelRequire("gfJJk");

var $5aga7 = parcelRequire("5aga7");

var $9zLwN = parcelRequire("9zLwN");

var $12rSf = parcelRequire("12rSf");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $e1c5c663fd2a35f4$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $5aga7.initMetric)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $9zLwN.observe)("layout-shift", handleEntries);
    if (po) {
        report = (0, $gfJJk.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $12rSf.onHidden)(stopListening);
        return stopListening;
    }
    return;
};

});
parcelRegister("gfJJk", function(module, exports) {

$parcel$export(module.exports, "bindReporter", function () { return $bd5185170f5d4928$export$17679dccdd551979; });
const $bd5185170f5d4928$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};

});

parcelRegister("5aga7", function(module, exports) {

$parcel$export(module.exports, "initMetric", function () { return $3c2a6c631ba7f21c$export$3c29b44508a0612b; });

var $hi3xY = parcelRequire("hi3xY");

var $5KNPZ = parcelRequire("5KNPZ");

var $5TTSp = parcelRequire("5TTSp");

var $gMnkn = parcelRequire("gMnkn");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3c2a6c631ba7f21c$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $gMnkn.getNavigationEntry)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $hi3xY.WINDOW).document.prerendering || (0, $5TTSp.getActivationStart)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $5KNPZ.generateUniqueID)(),
        navigationType: navigationType
    };
};

});
parcelRegister("hi3xY", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $c966de78e07f2fb1$export$56d8a8a25bd48b81; });

var $lNVQ9 = parcelRequire("lNVQ9");
const $c966de78e07f2fb1$export$56d8a8a25bd48b81 = (0, $lNVQ9.GLOBAL_OBJ);

});

parcelRegister("5KNPZ", function(module, exports) {

$parcel$export(module.exports, "generateUniqueID", function () { return $4307e853c9ece84f$export$407ea409d1f3b539; });
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $4307e853c9ece84f$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

});

parcelRegister("5TTSp", function(module, exports) {

$parcel$export(module.exports, "getActivationStart", function () { return $44bd6eb4b3fd1605$export$d3e828b3c7b5b845; });

var $gMnkn = parcelRequire("gMnkn");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $44bd6eb4b3fd1605$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $gMnkn.getNavigationEntry)();
    return navEntry && navEntry.activationStart || 0;
};

});
parcelRegister("gMnkn", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", function () { return $c37339674b8d248c$export$6431553786c94949; });

var $hi3xY = parcelRequire("hi3xY");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c37339674b8d248c$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $hi3xY.WINDOW).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $hi3xY.WINDOW).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $c37339674b8d248c$export$6431553786c94949 = ()=>{
    if ((0, $hi3xY.WINDOW).__WEB_VITALS_POLYFILL__) return (0, $hi3xY.WINDOW).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $c37339674b8d248c$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $hi3xY.WINDOW).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};

});



parcelRegister("9zLwN", function(module, exports) {

$parcel$export(module.exports, "observe", function () { return $6f8c40015604c1b9$export$d1203567a167490e; });
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $6f8c40015604c1b9$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

});

parcelRegister("12rSf", function(module, exports) {

$parcel$export(module.exports, "onHidden", function () { return $0c1b99844ab69310$export$91ec2be6fdd8f1b4; });

var $hi3xY = parcelRequire("hi3xY");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0c1b99844ab69310$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $hi3xY.WINDOW).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener("visibilitychange", onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener("pagehide", onHiddenOrPageHide, true);
};

});


parcelRegister("hCnge", function(module, exports) {

$parcel$export(module.exports, "onFID", function () { return $cd380764dbfc4a7f$export$39705a25c49af873; });

var $gfJJk = parcelRequire("gfJJk");

var $3zi5n = parcelRequire("3zi5n");

var $5aga7 = parcelRequire("5aga7");

var $9zLwN = parcelRequire("9zLwN");

var $12rSf = parcelRequire("12rSf");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $cd380764dbfc4a7f$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $3zi5n.getVisibilityWatcher)();
    const metric = (0, $5aga7.initMetric)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $9zLwN.observe)("first-input", handleEntries);
    report = (0, $gfJJk.bindReporter)(onReport, metric);
    if (po) (0, $12rSf.onHidden)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};

});
parcelRegister("3zi5n", function(module, exports) {

$parcel$export(module.exports, "getVisibilityWatcher", function () { return $2992ab71d9a3efdc$export$443f86b2c77012c4; });

var $hi3xY = parcelRequire("hi3xY");

var $12rSf = parcelRequire("12rSf");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $2992ab71d9a3efdc$var$firstHiddenTime = -1;
const $2992ab71d9a3efdc$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    return (0, $hi3xY.WINDOW).document.visibilityState === "hidden" && !(0, $hi3xY.WINDOW).document.prerendering ? 0 : Infinity;
};
const $2992ab71d9a3efdc$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $12rSf.onHidden)(({ timeStamp: timeStamp })=>{
        $2992ab71d9a3efdc$var$firstHiddenTime = timeStamp;
    }, true);
};
const $2992ab71d9a3efdc$export$443f86b2c77012c4 = ()=>{
    if ($2992ab71d9a3efdc$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $2992ab71d9a3efdc$var$firstHiddenTime = $2992ab71d9a3efdc$var$initHiddenTime();
        $2992ab71d9a3efdc$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $2992ab71d9a3efdc$var$firstHiddenTime;
        }
    };
};

});


parcelRegister("fUHEP", function(module, exports) {

$parcel$export(module.exports, "onINP", function () { return $b95df3783e127220$export$7df4b36ecaed99e1; });

var $gfJJk = parcelRequire("gfJJk");

var $5aga7 = parcelRequire("5aga7");

var $9zLwN = parcelRequire("9zLwN");

var $12rSf = parcelRequire("12rSf");

var $gqKd8 = parcelRequire("gqKd8");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $b95df3783e127220$var$getInteractionCountForNavigation = ()=>{
    return (0, $gqKd8.getInteractionCount)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $b95df3783e127220$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $b95df3783e127220$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $b95df3783e127220$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $b95df3783e127220$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $b95df3783e127220$var$longestInteractionList[$b95df3783e127220$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $b95df3783e127220$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $b95df3783e127220$var$longestInteractionList.length < $b95df3783e127220$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $b95df3783e127220$var$longestInteractionMap[interaction.id] = interaction;
            $b95df3783e127220$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $b95df3783e127220$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $b95df3783e127220$var$longestInteractionList.splice($b95df3783e127220$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $b95df3783e127220$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $b95df3783e127220$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($b95df3783e127220$var$longestInteractionList.length - 1, Math.floor($b95df3783e127220$var$getInteractionCountForNavigation() / 50));
    return $b95df3783e127220$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $b95df3783e127220$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $gqKd8.initInteractionCountPolyfill)();
    const metric = (0, $5aga7.initMetric)("INP");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $b95df3783e127220$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                const noMatchingEntry = !$b95df3783e127220$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $b95df3783e127220$var$processEntry(entry);
            }
        });
        const inp = $b95df3783e127220$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $9zLwN.observe)("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $gfJJk.bindReporter)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0, $12rSf.onHidden)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $b95df3783e127220$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};

});
parcelRegister("gqKd8", function(module, exports) {

$parcel$export(module.exports, "getInteractionCount", function () { return $bf62eb9683ec9d94$export$8a962f2683a476d1; });
$parcel$export(module.exports, "initInteractionCountPolyfill", function () { return $bf62eb9683ec9d94$export$67d90cda6b78a2eb; });

var $9zLwN = parcelRequire("9zLwN");
let $bf62eb9683ec9d94$var$interactionCountEstimate = 0;
let $bf62eb9683ec9d94$var$minKnownInteractionId = Infinity;
let $bf62eb9683ec9d94$var$maxKnownInteractionId = 0;
const $bf62eb9683ec9d94$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $bf62eb9683ec9d94$var$minKnownInteractionId = Math.min($bf62eb9683ec9d94$var$minKnownInteractionId, e.interactionId);
            $bf62eb9683ec9d94$var$maxKnownInteractionId = Math.max($bf62eb9683ec9d94$var$maxKnownInteractionId, e.interactionId);
            $bf62eb9683ec9d94$var$interactionCountEstimate = $bf62eb9683ec9d94$var$maxKnownInteractionId ? ($bf62eb9683ec9d94$var$maxKnownInteractionId - $bf62eb9683ec9d94$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $bf62eb9683ec9d94$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $bf62eb9683ec9d94$export$8a962f2683a476d1 = ()=>{
    return $bf62eb9683ec9d94$var$po ? $bf62eb9683ec9d94$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $bf62eb9683ec9d94$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $bf62eb9683ec9d94$var$po) return;
    $bf62eb9683ec9d94$var$po = (0, $9zLwN.observe)("event", $bf62eb9683ec9d94$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};

});


parcelRegister("fLb5H", function(module, exports) {

$parcel$export(module.exports, "onLCP", function () { return $b793d93d4758c2e1$export$947b1626ab8d5632; });

var $gfJJk = parcelRequire("gfJJk");

var $5TTSp = parcelRequire("5TTSp");

var $3zi5n = parcelRequire("3zi5n");

var $5aga7 = parcelRequire("5aga7");

var $9zLwN = parcelRequire("9zLwN");

var $12rSf = parcelRequire("12rSf");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b793d93d4758c2e1$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $b793d93d4758c2e1$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $3zi5n.getVisibilityWatcher)();
    const metric = (0, $5aga7.initMetric)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $5TTSp.getActivationStart)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $9zLwN.observe)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $gfJJk.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            if (!$b793d93d4758c2e1$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $b793d93d4758c2e1$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $12rSf.onHidden)(stopListening, true);
        return stopListening;
    }
    return;
};

});



parcelRegister("1Jtuk", function(module, exports) {

$parcel$export(module.exports, "replayCanvasIntegration", function () { return $1430de2803cfdb46$export$71ba62165d5c834d; });
$parcel$export(module.exports, "ReplayCanvas", function () { return $1430de2803cfdb46$export$5f05966c3e8baf2f; });

var $fF2BR = parcelRequire("fF2BR");

var $genhe = parcelRequire("genhe");
var $1430de2803cfdb46$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($1430de2803cfdb46$var$NodeType || ($1430de2803cfdb46$var$NodeType = {}));
function $1430de2803cfdb46$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $1430de2803cfdb46$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $1430de2803cfdb46$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $1430de2803cfdb46$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($1430de2803cfdb46$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
const $1430de2803cfdb46$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $1430de2803cfdb46$var$_mirror = {
    map: {},
    getId () {
        console.error($1430de2803cfdb46$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($1430de2803cfdb46$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($1430de2803cfdb46$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($1430de2803cfdb46$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($1430de2803cfdb46$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $1430de2803cfdb46$var$_mirror = new Proxy($1430de2803cfdb46$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($1430de2803cfdb46$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $1430de2803cfdb46$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$1430de2803cfdb46$var$hookSetter(target, key, original || {}, true);
}
function $1430de2803cfdb46$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
/[1-9][0-9]{12}/.test(Date.now().toString());
function $1430de2803cfdb46$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    if (!el) return false;
    const blockedPredicate = $1430de2803cfdb46$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $1430de2803cfdb46$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $1430de2803cfdb46$var$distanceToMatch(el, $1430de2803cfdb46$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
let $1430de2803cfdb46$var$cachedRequestAnimationFrameImplementation;
function $1430de2803cfdb46$var$getRequestAnimationFrameImplementation() {
    if ($1430de2803cfdb46$var$cachedRequestAnimationFrameImplementation) return $1430de2803cfdb46$var$cachedRequestAnimationFrameImplementation;
    const document = window.document;
    let requestAnimationFrameImplementation = window.requestAnimationFrame;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.requestAnimationFrame) requestAnimationFrameImplementation = contentWindow.requestAnimationFrame;
        document.head.removeChild(sandbox);
    } catch (e) {}
    return $1430de2803cfdb46$var$cachedRequestAnimationFrameImplementation = requestAnimationFrameImplementation.bind(window);
}
function $1430de2803cfdb46$var$onRequestAnimationFrame(...rest) {
    return $1430de2803cfdb46$var$getRequestAnimationFrameImplementation()(...rest);
}
var $1430de2803cfdb46$var$CanvasContext = /* @__PURE__ */ ((CanvasContext2)=>{
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
})($1430de2803cfdb46$var$CanvasContext || {});
let $1430de2803cfdb46$var$errorHandler;
function $1430de2803cfdb46$var$registerErrorHandler(handler) {
    $1430de2803cfdb46$var$errorHandler = handler;
}
const $1430de2803cfdb46$var$callbackWrapper = (cb)=>{
    if (!$1430de2803cfdb46$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($1430de2803cfdb46$var$errorHandler && $1430de2803cfdb46$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $1430de2803cfdb46$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
var $1430de2803cfdb46$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $1430de2803cfdb46$var$i = 0; $1430de2803cfdb46$var$i < $1430de2803cfdb46$var$chars.length; $1430de2803cfdb46$var$i++)$1430de2803cfdb46$var$lookup[$1430de2803cfdb46$var$chars.charCodeAt($1430de2803cfdb46$var$i)] = $1430de2803cfdb46$var$i;
var $1430de2803cfdb46$var$encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $1430de2803cfdb46$var$chars[bytes[i] >> 2];
        base64 += $1430de2803cfdb46$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $1430de2803cfdb46$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $1430de2803cfdb46$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $1430de2803cfdb46$var$canvasVarMap = new Map();
function $1430de2803cfdb46$var$variableListFor(ctx, ctor) {
    let contextMap = $1430de2803cfdb46$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        $1430de2803cfdb46$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const $1430de2803cfdb46$var$saveWebGLVar = (value, win, ctx)=>{
    if (!value || !($1430de2803cfdb46$var$isInstanceOfWebGLObject(value, win) || typeof value === "object")) return;
    const name = value.constructor.name;
    const list = $1430de2803cfdb46$var$variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $1430de2803cfdb46$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>$1430de2803cfdb46$var$serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = $1430de2803cfdb46$var$encode(value);
        return {
            rr_type: name,
            base64: base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $1430de2803cfdb46$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src: src } = value;
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof HTMLCanvasElement) {
        const name = "HTMLImageElement";
        const src = value.toDataURL();
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $1430de2803cfdb46$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($1430de2803cfdb46$var$isInstanceOfWebGLObject(value, win) || typeof value === "object") {
        const name = value.constructor.name;
        const index = $1430de2803cfdb46$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index
        };
    }
    return value;
}
const $1430de2803cfdb46$var$serializeArgs = (args, win, ctx)=>{
    return args.map((arg)=>$1430de2803cfdb46$var$serializeArg(arg, win, ctx));
};
const $1430de2803cfdb46$var$isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        "WebGLVertexArrayObjectOES"
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === "function");
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function $1430de2803cfdb46$var$initCanvas2DMutationObserver(cb, win, blockClass, blockSelector, unblockSelector) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") continue;
        const restoreHandler = $1430de2803cfdb46$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!$1430de2803cfdb46$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) setTimeout(()=>{
                    const recordArgs = $1430de2803cfdb46$var$serializeArgs(args, win, this);
                    cb(this.canvas, {
                        type: $1430de2803cfdb46$var$CanvasContext["2D"],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        const hookHandler = $1430de2803cfdb46$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: $1430de2803cfdb46$var$CanvasContext["2D"],
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $1430de2803cfdb46$var$getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function $1430de2803cfdb46$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
    const handlers = [];
    try {
        const restoreHandler = $1430de2803cfdb46$var$patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType, ...args) {
                if (!$1430de2803cfdb46$var$isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
                    const ctxName = $1430de2803cfdb46$var$getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && typeof args[0] === "object") {
                            const contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $1430de2803cfdb46$var$patchGLPrototype(prototype, type, cb, blockClass, blockSelector, unblockSelector, mirror, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props){
        if ([
            "isContextLost",
            "canvas",
            "drawingBufferWidth",
            "drawingBufferHeight"
        ].includes(prop)) continue;
        try {
            if (typeof prototype[prop] !== "function") continue;
            const restoreHandler = $1430de2803cfdb46$var$patch(prototype, prop, function(original) {
                return function(...args) {
                    const result = original.apply(this, args);
                    $1430de2803cfdb46$var$saveWebGLVar(result, win, this);
                    if ("tagName" in this.canvas && !$1430de2803cfdb46$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) {
                        const recordArgs = $1430de2803cfdb46$var$serializeArgs(args, win, this);
                        const mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            const hookHandler = $1430de2803cfdb46$var$hookSetter(prototype, prop, {
                set (v) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function $1430de2803cfdb46$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
    const handlers = [];
    handlers.push(...$1430de2803cfdb46$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $1430de2803cfdb46$var$CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== "undefined") handlers.push(...$1430de2803cfdb46$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $1430de2803cfdb46$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
var $1430de2803cfdb46$var$r = `for(var t="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",e="undefined"==typeof Uint8Array?[]:new Uint8Array(256),n=0;n<64;n++)e[t.charCodeAt(n)]=n;var a=function(e){var n,a=new Uint8Array(e),s=a.length,r="";for(n=0;n<s;n+=3)r+=t[a[n]>>2],r+=t[(3&a[n])<<4|a[n+1]>>4],r+=t[(15&a[n+1])<<2|a[n+2]>>6],r+=t[63&a[n+2]];return s%3==2?r=r.substring(0,r.length-1)+"=":s%3==1&&(r=r.substring(0,r.length-2)+"=="),r};const s=new Map,r=new Map;const i=self;i.onmessage=async function(t){if(!("OffscreenCanvas"in globalThis))return i.postMessage({id:t.data.id});{const{id:e,bitmap:n,width:o,height:f,dataURLOptions:c}=t.data,g=async function(t,e,n){const s=t+"-"+e;if("OffscreenCanvas"in globalThis){if(r.has(s))return r.get(s);const i=new OffscreenCanvas(t,e);i.getContext("2d");const o=await i.convertToBlob(n),f=await o.arrayBuffer(),c=a(f);return r.set(s,c),c}return""}(o,f,c),d=new OffscreenCanvas(o,f);d.getContext("2d").drawImage(n,0,0),n.close();const u=await d.convertToBlob(c),h=u.type,w=await u.arrayBuffer(),l=a(w);if(!s.has(e)&&await g===l)return s.set(e,l),i.postMessage({id:e});if(s.get(e)===l)return i.postMessage({id:e});i.postMessage({id:e,type:h,base64:l,width:o,height:f}),s.set(e,l)}};`;
function $1430de2803cfdb46$var$t() {
    const t = new Blob([
        $1430de2803cfdb46$var$r
    ]);
    return URL.createObjectURL(t);
}
class $1430de2803cfdb46$var$CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    constructor(options){
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.frozen = false;
        this.locked = false;
        this.processMutation = (target, mutation)=>{
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        const { sampling: sampling = "all", win: win, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, recordCanvas: recordCanvas, dataURLOptions: dataURLOptions, errorHandler: errorHandler } = options;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        this.options = options;
        if (errorHandler) $1430de2803cfdb46$var$registerErrorHandler(errorHandler);
        if (options.enableManualSnapshot) return;
        $1430de2803cfdb46$var$callbackWrapper(()=>{
            if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector);
            if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, unblockSelector, {
                dataURLOptions: dataURLOptions
            });
        })();
    }
    initCanvasFPSObserver(fps, win, blockClass, blockSelector, unblockSelector, options) {
        const canvasContextReset = $1430de2803cfdb46$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, true);
        const rafId = this.takeSnapshot(false, fps, win, blockClass, blockSelector, unblockSelector, options.dataURLOptions);
        this.resetObservers = ()=>{
            canvasContextReset();
            cancelAnimationFrame(rafId);
        };
    }
    initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = $1430de2803cfdb46$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, false);
        const canvas2DReset = $1430de2803cfdb46$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector);
        const canvasWebGL1and2Reset = $1430de2803cfdb46$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.resetObservers = ()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    snapshot(canvasElement) {
        const { options: options } = this;
        const rafId = this.takeSnapshot(true, options.sampling === "all" ? 2 : options.sampling || 2, options.win, options.blockClass, options.blockSelector, options.unblockSelector, options.dataURLOptions, canvasElement);
        this.resetObservers = ()=>{
            cancelAnimationFrame(rafId);
        };
    }
    takeSnapshot(isManualSnapshot, fps, win, blockClass, blockSelector, unblockSelector, dataURLOptions, canvasElement) {
        const snapshotInProgressMap = new Map();
        const worker = new Worker($1430de2803cfdb46$var$t());
        worker.onmessage = (e)=>{
            const data = e.data;
            const { id: id } = data;
            snapshotInProgressMap.set(id, false);
            if (!("base64" in data)) return;
            const { base64: base64, type: type, width: width, height: height } = data;
            this.mutationCb({
                id: id,
                type: $1430de2803cfdb46$var$CanvasContext["2D"],
                commands: [
                    {
                        property: "clearRect",
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: "drawImage",
                        args: [
                            {
                                rr_type: "ImageBitmap",
                                args: [
                                    {
                                        rr_type: "Blob",
                                        data: [
                                            {
                                                rr_type: "ArrayBuffer",
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0
                        ]
                    }
                ]
            });
        };
        const timeBetweenSnapshots = 1000 / fps;
        let lastSnapshotTime = 0;
        let rafId;
        const getCanvas = (canvasElement)=>{
            if (canvasElement) return [
                canvasElement
            ];
            const matchedCanvas = [];
            win.document.querySelectorAll("canvas").forEach((canvas)=>{
                if (!$1430de2803cfdb46$var$isBlocked(canvas, blockClass, blockSelector, unblockSelector, true)) matchedCanvas.push(canvas);
            });
            return matchedCanvas;
        };
        const takeCanvasSnapshots = (timestamp)=>{
            if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = $1430de2803cfdb46$var$onRequestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            getCanvas(canvasElement).forEach((canvas)=>{
                const id = this.mirror.getId(canvas);
                if (snapshotInProgressMap.get(id)) return;
                snapshotInProgressMap.set(id, true);
                if (!isManualSnapshot && [
                    "webgl",
                    "webgl2"
                ].includes(canvas.__context)) {
                    const context = canvas.getContext(canvas.__context);
                    if ((0, $fF2BR._optionalChain)([
                        context,
                        "optionalAccess",
                        (_)=>_.getContextAttributes,
                        "call",
                        (_2)=>_2(),
                        "optionalAccess",
                        (_3)=>_3.preserveDrawingBuffer
                    ]) === false) context.clear(context.COLOR_BUFFER_BIT);
                }
                createImageBitmap(canvas).then((bitmap)=>{
                    worker.postMessage({
                        id: id,
                        bitmap: bitmap,
                        width: canvas.width,
                        height: canvas.height,
                        dataURLOptions: dataURLOptions
                    }, [
                        bitmap
                    ]);
                }).catch((error)=>{
                    $1430de2803cfdb46$var$callbackWrapper(()=>{
                        throw error;
                    })();
                });
            });
            rafId = $1430de2803cfdb46$var$onRequestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = $1430de2803cfdb46$var$onRequestAnimationFrame(takeCanvasSnapshots);
        return rafId;
    }
    startPendingCanvasMutationFlusher() {
        $1430de2803cfdb46$var$onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            $1430de2803cfdb46$var$onRequestAnimationFrame(setLatestRAFTimestamp);
        };
        $1430de2803cfdb46$var$onRequestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        $1430de2803cfdb46$var$onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const { type: type, ...rest } = value;
            return rest;
        });
        const { type: type } = valuesWithType[0];
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
const $1430de2803cfdb46$var$CANVAS_QUALITY = {
    low: {
        sampling: {
            canvas: 1
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.25
        }
    },
    medium: {
        sampling: {
            canvas: 2
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.4
        }
    },
    high: {
        sampling: {
            canvas: 4
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.5
        }
    }
};
const $1430de2803cfdb46$var$INTEGRATION_NAME = "ReplayCanvas";
/** Exported only for type safe tests. */ const $1430de2803cfdb46$var$_replayCanvasIntegration = (options = {})=>{
    const _canvasOptions = {
        quality: options.quality || "medium",
        enableManualSnapshot: options.enableManualSnapshot
    };
    let canvasManagerResolve;
    const _canvasManager = new Promise((resolve)=>canvasManagerResolve = resolve);
    return {
        name: $1430de2803cfdb46$var$INTEGRATION_NAME,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce () {},
        getOptions () {
            const { quality: quality, enableManualSnapshot: enableManualSnapshot } = _canvasOptions;
            return {
                enableManualSnapshot: enableManualSnapshot,
                recordCanvas: true,
                getCanvasManager: (options)=>{
                    const manager = new $1430de2803cfdb46$var$CanvasManager({
                        ...options,
                        enableManualSnapshot: enableManualSnapshot,
                        errorHandler: (err)=>{
                            try {
                                if (typeof err === "object") err.__rrweb__ = true;
                            } catch (error) {
                            // ignore errors here
                            // this can happen if the error is frozen or does not allow mutation for other reasons
                            }
                        }
                    });
                    canvasManagerResolve(manager);
                    return manager;
                },
                ...$1430de2803cfdb46$var$CANVAS_QUALITY[quality || "medium"] || $1430de2803cfdb46$var$CANVAS_QUALITY.medium
            };
        },
        async snapshot (canvasElement) {
            const canvasManager = await _canvasManager;
            canvasManager.snapshot(canvasElement);
        }
    };
};
/**
 * Add this in addition to `replayIntegration()` to enable canvas recording.
 */ const $1430de2803cfdb46$export$71ba62165d5c834d = (0, $genhe.defineIntegration)($1430de2803cfdb46$var$_replayCanvasIntegration);
/**
 * @deprecated Use `replayCanvasIntegration()` instead
 */ // eslint-disable-next-line deprecation/deprecation
const $1430de2803cfdb46$export$5f05966c3e8baf2f = (0, $genhe.convertIntegrationFnToClass)($1430de2803cfdb46$var$INTEGRATION_NAME, $1430de2803cfdb46$export$71ba62165d5c834d);

});

parcelRegister("62zNO", function(module, exports) {

$parcel$export(module.exports, "sendFeedback", function () { return $465eb396911258a2$export$a65d69dd22caceda; });
$parcel$export(module.exports, "feedbackIntegration", function () { return $465eb396911258a2$export$b3f80fd9e808d6d7; });
$parcel$export(module.exports, "Feedback", function () { return $465eb396911258a2$export$175e500a48a60fd2; });

var $04wr6 = parcelRequire("04wr6");
var $lNVQ9 = parcelRequire("lNVQ9");
var $kVwzp = parcelRequire("kVwzp");
var $7p8hL = parcelRequire("7p8hL");

var $16rrK = parcelRequire("16rrK");
var $hcepo = parcelRequire("hcepo");
var $fxUGN = parcelRequire("fxUGN");
var $5XnTz = parcelRequire("5XnTz");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and feedback packages
const $465eb396911258a2$var$WINDOW = (0, $lNVQ9.GLOBAL_OBJ);
const $465eb396911258a2$var$LIGHT_BACKGROUND = "#ffffff";
const $465eb396911258a2$var$INHERIT = "inherit";
const $465eb396911258a2$var$SUBMIT_COLOR = "rgba(108, 95, 199, 1)";
const $465eb396911258a2$var$LIGHT_THEME = {
    fontFamily: "system-ui, 'Helvetica Neue', Arial, sans-serif",
    fontSize: "14px",
    background: $465eb396911258a2$var$LIGHT_BACKGROUND,
    backgroundHover: "#f6f6f7",
    foreground: "#2b2233",
    border: "1.5px solid rgba(41, 35, 47, 0.13)",
    borderRadius: "12px",
    boxShadow: "0px 4px 24px 0px rgba(43, 34, 51, 0.12)",
    success: "#268d75",
    error: "#df3338",
    submitBackground: "rgba(88, 74, 192, 1)",
    submitBackgroundHover: $465eb396911258a2$var$SUBMIT_COLOR,
    submitBorder: $465eb396911258a2$var$SUBMIT_COLOR,
    submitOutlineFocus: "#29232f",
    submitForeground: $465eb396911258a2$var$LIGHT_BACKGROUND,
    submitForegroundHover: $465eb396911258a2$var$LIGHT_BACKGROUND,
    cancelBackground: "transparent",
    cancelBackgroundHover: "var(--background-hover)",
    cancelBorder: "var(--border)",
    cancelOutlineFocus: "var(--input-outline-focus)",
    cancelForeground: "var(--foreground)",
    cancelForegroundHover: "var(--foreground)",
    inputBackground: $465eb396911258a2$var$INHERIT,
    inputForeground: $465eb396911258a2$var$INHERIT,
    inputBorder: "var(--border)",
    inputOutlineFocus: $465eb396911258a2$var$SUBMIT_COLOR,
    formBorderRadius: "20px",
    formContentBorderRadius: "6px"
};
const $465eb396911258a2$var$DEFAULT_THEME = {
    light: $465eb396911258a2$var$LIGHT_THEME,
    dark: {
        ...$465eb396911258a2$var$LIGHT_THEME,
        background: "#29232f",
        backgroundHover: "#352f3b",
        foreground: "#ebe6ef",
        border: "1.5px solid rgba(235, 230, 239, 0.15)",
        success: "#2da98c",
        error: "#f55459"
    }
};
const $465eb396911258a2$var$ACTOR_LABEL = "Report a Bug";
const $465eb396911258a2$var$CANCEL_BUTTON_LABEL = "Cancel";
const $465eb396911258a2$var$SUBMIT_BUTTON_LABEL = "Send Bug Report";
const $465eb396911258a2$var$FORM_TITLE = "Report a Bug";
const $465eb396911258a2$var$EMAIL_PLACEHOLDER = "your.email@example.org";
const $465eb396911258a2$var$EMAIL_LABEL = "Email";
const $465eb396911258a2$var$MESSAGE_PLACEHOLDER = "What's the bug? What did you expect?";
const $465eb396911258a2$var$MESSAGE_LABEL = "Description";
const $465eb396911258a2$var$NAME_PLACEHOLDER = "Your Name";
const $465eb396911258a2$var$NAME_LABEL = "Name";
const $465eb396911258a2$var$SUCCESS_MESSAGE_TEXT = "Thank you for your report!";
const $465eb396911258a2$var$FEEDBACK_WIDGET_SOURCE = "widget";
const $465eb396911258a2$var$FEEDBACK_API_SOURCE = "api";
/**
 * Prepare a feedback event & enrich it with the SDK metadata.
 */ async function $465eb396911258a2$var$prepareFeedbackEvent({ client: client, scope: scope, event: event }) {
    const eventHint = {};
    if (client.emit) client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $5XnTz.prepareEvent)(client.getOptions(), event, eventHint, scope, client, (0, $fxUGN.getIsolationScope)());
    if (preparedEvent === null) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "feedback", event);
        return null;
    }
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    return preparedEvent;
}
/**
 * Send feedback using transport
 */ async function $465eb396911258a2$var$sendFeedbackRequest({ feedback: { message: message, email: email, name: name, source: source, url: url } }, { includeReplay: includeReplay = true } = {}) {
    const client = (0, $hcepo.getClient)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn) return;
    const baseEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source
            }
        },
        type: "feedback"
    };
    return (0, $hcepo.withScope)(async (scope)=>{
        // No use for breadcrumbs in feedback
        scope.clearBreadcrumbs();
        if ([
            $465eb396911258a2$var$FEEDBACK_API_SOURCE,
            $465eb396911258a2$var$FEEDBACK_WIDGET_SOURCE
        ].includes(String(source))) scope.setLevel("info");
        const feedbackEvent = await $465eb396911258a2$var$prepareFeedbackEvent({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            scope: scope,
            client: client,
            event: baseEvent
        });
        if (!feedbackEvent) return;
        if (client.emit) client.emit("beforeSendFeedback", feedbackEvent, {
            includeReplay: Boolean(includeReplay)
        });
        const envelope = (0, $16rrK.createEventEnvelope)(feedbackEvent, dsn, client.getOptions()._metadata, client.getOptions().tunnel);
        let response;
        try {
            response = await transport.send(envelope);
        } catch (err) {
            const error = new Error("Unable to send Feedback");
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
        if (!response) return;
        // Require valid status codes, otherwise can assume feedback was not sent successfully
        if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new Error("Unable to send Feedback");
        return response;
    });
}
/*
 * For reference, the fully built event looks something like this:
 * {
 *     "type": "feedback",
 *     "event_id": "d2132d31b39445f1938d7e21b6bf0ec4",
 *     "timestamp": 1597977777.6189718,
 *     "dist": "1.12",
 *     "platform": "javascript",
 *     "environment": "production",
 *     "release": 42,
 *     "tags": {"transaction": "/organizations/:orgId/performance/:eventSlug/"},
 *     "sdk": {"name": "name", "version": "version"},
 *     "user": {
 *         "id": "123",
 *         "username": "user",
 *         "email": "user@site.com",
 *         "ip_address": "192.168.11.12",
 *     },
 *     "request": {
 *         "url": None,
 *         "headers": {
 *             "user-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.5 Safari/605.1.15"
 *         },
 *     },
 *     "contexts": {
 *         "feedback": {
 *             "message": "test message",
 *             "contact_email": "test@example.com",
 *             "type": "feedback",
 *         },
 *         "trace": {
 *             "trace_id": "4C79F60C11214EB38604F4AE0781BFB2",
 *             "span_id": "FA90FDEAD5F74052",
 *             "type": "trace",
 *         },
 *         "replay": {
 *             "replay_id": "e2d42047b1c5431c8cba85ee2a8ab25d",
 *         },
 *     },
 *   }
 */ /**
 * Public API to send a Feedback item to Sentry
 */ function $465eb396911258a2$export$a65d69dd22caceda({ name: name, email: email, message: message, source: source = $465eb396911258a2$var$FEEDBACK_API_SOURCE, url: url = (0, $04wr6.getLocationHref)() }, options = {}) {
    if (!message) throw new Error("Unable to submit feedback with empty message");
    return $465eb396911258a2$var$sendFeedbackRequest({
        feedback: {
            name: name,
            email: email,
            message: message,
            url: url,
            source: source
        }
    }, options);
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $465eb396911258a2$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
/**
 * Quick and dirty deep merge for the Feedback integration options
 */ function $465eb396911258a2$var$mergeOptions(defaultOptions, optionOverrides) {
    return {
        ...defaultOptions,
        ...optionOverrides,
        themeDark: {
            ...defaultOptions.themeDark,
            ...optionOverrides.themeDark
        },
        themeLight: {
            ...defaultOptions.themeLight,
            ...optionOverrides.themeLight
        }
    };
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function $465eb396911258a2$var$createActorStyles(d) {
    const style = d.createElement("style");
    style.textContent = `
.widget__actor {
  line-height: 25px;

  display: flex;
  align-items: center;
  gap: 8px;

  border-radius: var(--border-radius);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 16px;
  text-decoration: none;
  z-index: 9000;

  color: var(--foreground);
  background-color: var(--background);
  border: var(--border);
  box-shadow: var(--box-shadow);
  opacity: 1;
  transition: opacity 0.1s ease-in-out;
}

.widget__actor:hover {
  background-color: var(--background-hover);
}

.widget__actor svg {
  width: 16px;
  height: 16px;
}

.widget__actor--hidden {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}

.widget__actor__text {
}

.feedback-icon path {
  fill: var(--foreground);
}
`;
    return style;
}
/**
 * Creates <style> element for widget dialog
 */ function $465eb396911258a2$var$createDialogStyles(d) {
    const style = d.createElement("style");
    style.textContent = `
.dialog {
  line-height: 25px;
  background-color: rgba(0, 0, 0, 0.05);
  border: none;
  position: fixed;
  inset: 0;
  z-index: 10000;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

.dialog:not([open]) {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}
.dialog:not([open]) .dialog__content {
  transform: translate(0, -16px) scale(0.98);
}

.dialog__content {
  position: fixed;
  left: var(--left);
  right: var(--right);
  bottom: var(--bottom);
  top: var(--top);

  border: var(--border);
  border-radius: var(--form-border-radius);
  background-color: var(--background);
  color: var(--foreground);

  width: 320px;
  max-width: 100%;
  max-height: calc(100% - 2rem);
  display: flex;
  flex-direction: column;
  box-shadow: var(--box-shadow);
  transition: transform 0.2s ease-in-out;
  transform: translate(0, 0) scale(1);
}

.dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 600;
  padding: 24px 24px 0 24px;
  margin: 0;
  margin-bottom: 16px;
}

.brand-link {
  display: inline-flex;
}

.error {
  color: var(--error);
  margin-bottom: 16px;
}

.form {
  display: grid;
  overflow: auto;
  flex-direction: column;
  gap: 16px;
  padding: 0 24px 24px;
}

.form__error-container {
  color: var(--error);
}

.form__error-container--hidden {
  display: none;
}

.form__label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0px;
}

.form__label__text {
  display: grid;
  gap: 4px;
  align-items: center;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
}

.form__label__text--required {
  font-size: 0.85em;
}

.form__input {
  font-family: inherit;
  line-height: inherit;
  background-color: var(--input-background);
  box-sizing: border-box;
  border: var(--input-border);
  border-radius: var(--form-content-border-radius);
  color: var(--input-foreground);
  font-size: 14px;
  font-weight: 500;
  padding: 6px 12px;
}

.form__input:focus-visible {
  outline: 1px auto var(--input-outline-focus);
}

.form__input--textarea {
  font-family: inherit;
  resize: vertical;
}

.btn-group {
  display: grid;
  gap: 8px;
  margin-top: 8px;
}

.btn {
  line-height: inherit;
  border: var(--cancel-border);
  border-radius: var(--form-content-border-radius);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 16px;
}
.btn[disabled] {
  opacity: 0.6;
  pointer-events: none;
}

.btn--primary {
  background-color: var(--submit-background);
  border-color: var(--submit-border);
  color: var(--submit-foreground);
}
.btn--primary:hover {
  background-color: var(--submit-background-hover);
  color: var(--submit-foreground-hover);
}
.btn--primary:focus-visible {
  outline: 1px auto var(--submit-outline-focus);
}

.btn--default {
  background-color: var(--cancel-background);
  color: var(--cancel-foreground);
  font-weight: 500;
}
.btn--default:hover {
  background-color: var(--cancel-background-hover);
  color: var(--cancel-foreground-hover);
}
.btn--default:focus-visible {
  outline: 1px auto var(--cancel-outline-focus);
}

.success-message {
  background-color: var(--background);
  border: var(--border);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  font-weight: 600;
  color: var(--success);
  padding: 12px 24px;
  line-height: 25px;
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  gap: 6px;
  cursor: default;
}

.success-icon path {
  fill: var(--success);
}
`;
    return style;
}
function $465eb396911258a2$var$getThemedCssVariables(theme) {
    return `
  --background: ${theme.background};
  --background-hover: ${theme.backgroundHover};
  --foreground: ${theme.foreground};
  --error: ${theme.error};
  --success: ${theme.success};
  --border: ${theme.border};
  --border-radius: ${theme.borderRadius};
  --box-shadow: ${theme.boxShadow};

  --submit-background: ${theme.submitBackground};
  --submit-background-hover: ${theme.submitBackgroundHover};
  --submit-border: ${theme.submitBorder};
  --submit-outline-focus: ${theme.submitOutlineFocus};
  --submit-foreground: ${theme.submitForeground};
  --submit-foreground-hover: ${theme.submitForegroundHover};

  --cancel-background: ${theme.cancelBackground};
  --cancel-background-hover: ${theme.cancelBackgroundHover};
  --cancel-border: ${theme.cancelBorder};
  --cancel-outline-focus: ${theme.cancelOutlineFocus};
  --cancel-foreground: ${theme.cancelForeground};
  --cancel-foreground-hover: ${theme.cancelForegroundHover};

  --input-background: ${theme.inputBackground};
  --input-foreground: ${theme.inputForeground};
  --input-border: ${theme.inputBorder};
  --input-outline-focus: ${theme.inputOutlineFocus};

  --form-border-radius: ${theme.formBorderRadius};
  --form-content-border-radius: ${theme.formContentBorderRadius};
  `;
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function $465eb396911258a2$var$createMainStyles(d, colorScheme, themes) {
    const style = d.createElement("style");
    style.textContent = `
:host {
  --bottom: 1rem;
  --right: 1rem;
  --top: auto;
  --left: auto;
  --z-index: 100000;
  --font-family: ${themes.light.fontFamily};
  --font-size: ${themes.light.fontSize};

  position: fixed;
  left: var(--left);
  right: var(--right);
  bottom: var(--bottom);
  top: var(--top);
  z-index: var(--z-index);

  font-family: var(--font-family);
  font-size: var(--font-size);

  ${$465eb396911258a2$var$getThemedCssVariables(colorScheme === "dark" ? themes.dark : themes.light)}
}

${colorScheme === "system" ? `
@media (prefers-color-scheme: dark) {
  :host {
    ${$465eb396911258a2$var$getThemedCssVariables(themes.dark)}
  }
}` : ""}
}`;
    return style;
}
/**
 * Creates shadow host
 */ function $465eb396911258a2$var$createShadowHost({ id: id, colorScheme: colorScheme, themeDark: themeDark, themeLight: themeLight }) {
    try {
        const doc = $465eb396911258a2$var$WINDOW.document;
        // Create the host
        const host = doc.createElement("div");
        host.id = id;
        // Create the shadow root
        const shadow = host.attachShadow({
            mode: "open"
        });
        shadow.appendChild($465eb396911258a2$var$createMainStyles(doc, colorScheme, {
            dark: themeDark,
            light: themeLight
        }));
        shadow.appendChild($465eb396911258a2$var$createDialogStyles(doc));
        return {
            shadow: shadow,
            host: host
        };
    } catch (e) {
        // Shadow DOM probably not supported
        (0, $7p8hL.logger).warn("[Feedback] Browser does not support shadow DOM API");
        throw new Error("Browser does not support shadow DOM API.");
    }
}
/**
 * Handles UI behavior of dialog when feedback is submitted, calls
 * `sendFeedback` to send feedback.
 */ async function $465eb396911258a2$var$handleFeedbackSubmit(dialog, feedback, options) {
    if (!dialog) // Not sure when this would happen
    return;
    const showFetchError = ()=>{
        if (!dialog) return;
        dialog.showError("There was a problem submitting feedback, please wait and try again.");
    };
    dialog.hideError();
    try {
        const resp = await $465eb396911258a2$export$a65d69dd22caceda({
            ...feedback,
            source: $465eb396911258a2$var$FEEDBACK_WIDGET_SOURCE
        }, options);
        // Success!
        return resp;
    } catch (err) {
        $465eb396911258a2$var$DEBUG_BUILD && (0, $7p8hL.logger).error(err);
        showFetchError();
    }
}
/**
 * Helper function to set a dict of attributes on element (w/ specified namespace)
 */ function $465eb396911258a2$var$setAttributesNS(el, attributes) {
    Object.entries(attributes).forEach(([key, val])=>{
        el.setAttributeNS(null, key, val);
    });
    return el;
}
const $465eb396911258a2$var$SIZE = 20;
const $465eb396911258a2$var$XMLNS$2 = "http://www.w3.org/2000/svg";
/**
 * Feedback Icon
 */ function $465eb396911258a2$var$Icon() {
    const createElementNS = (tagName)=>$465eb396911258a2$var$WINDOW.document.createElementNS($465eb396911258a2$var$XMLNS$2, tagName);
    const svg = $465eb396911258a2$var$setAttributesNS(createElementNS("svg"), {
        class: "feedback-icon",
        width: `${$465eb396911258a2$var$SIZE}`,
        height: `${$465eb396911258a2$var$SIZE}`,
        viewBox: `0 0 ${$465eb396911258a2$var$SIZE} ${$465eb396911258a2$var$SIZE}`,
        fill: "none"
    });
    const g = $465eb396911258a2$var$setAttributesNS(createElementNS("g"), {
        clipPath: "url(#clip0_57_80)"
    });
    const path = $465eb396911258a2$var$setAttributesNS(createElementNS("path"), {
        ["fill-rule"]: "evenodd",
        ["clip-rule"]: "evenodd",
        d: "M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z"
    });
    svg.appendChild(g).appendChild(path);
    const speakerDefs = createElementNS("defs");
    const speakerClipPathDef = $465eb396911258a2$var$setAttributesNS(createElementNS("clipPath"), {
        id: "clip0_57_80"
    });
    const speakerRect = $465eb396911258a2$var$setAttributesNS(createElementNS("rect"), {
        width: `${$465eb396911258a2$var$SIZE}`,
        height: `${$465eb396911258a2$var$SIZE}`,
        fill: "white"
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Helper function to create an element. Could be used as a JSX factory
 * (i.e. React-like syntax).
 */ function $465eb396911258a2$var$createElement(tagName, attributes, ...children) {
    const doc = $465eb396911258a2$var$WINDOW.document;
    const element = doc.createElement(tagName);
    if (attributes) Object.entries(attributes).forEach(([attribute, attributeValue])=>{
        if (attribute === "className" && typeof attributeValue === "string") // JSX does not allow class as a valid name
        element.setAttribute("class", attributeValue);
        else if (typeof attributeValue === "boolean" && attributeValue) element.setAttribute(attribute, "");
        else if (typeof attributeValue === "string") element.setAttribute(attribute, attributeValue);
        else if (attribute.startsWith("on") && typeof attributeValue === "function") element.addEventListener(attribute.substring(2).toLowerCase(), attributeValue);
    });
    for (const child of children)$465eb396911258a2$var$appendChild(element, child);
    return element;
}
function $465eb396911258a2$var$appendChild(parent, child) {
    const doc = $465eb396911258a2$var$WINDOW.document;
    if (typeof child === "undefined" || child === null) return;
    if (Array.isArray(child)) for (const value of child)$465eb396911258a2$var$appendChild(parent, value);
    else if (child === false) ;
    else if (typeof child === "string") parent.appendChild(doc.createTextNode(child));
    else if (child instanceof Node) parent.appendChild(child);
    else parent.appendChild(doc.createTextNode(String(child)));
}
/**
 *
 */ function $465eb396911258a2$var$Actor({ buttonLabel: buttonLabel, onClick: onClick }) {
    function _handleClick(e) {
        onClick && onClick(e);
    }
    const el = $465eb396911258a2$var$createElement("button", {
        type: "button",
        className: "widget__actor",
        ["aria-label"]: buttonLabel,
        ["aria-hidden"]: "false"
    }, $465eb396911258a2$var$Icon().el, buttonLabel ? $465eb396911258a2$var$createElement("span", {
        className: "widget__actor__text"
    }, buttonLabel) : null);
    el.addEventListener("click", _handleClick);
    return {
        get el () {
            return el;
        },
        show: ()=>{
            el.classList.remove("widget__actor--hidden");
            el.setAttribute("aria-hidden", "false");
        },
        hide: ()=>{
            el.classList.add("widget__actor--hidden");
            el.setAttribute("aria-hidden", "true");
        }
    };
}
/**
 *
 */ function $465eb396911258a2$var$SubmitButton({ label: label }) {
    const el = $465eb396911258a2$var$createElement("button", {
        type: "submit",
        className: "btn btn--primary",
        ["aria-label"]: label
    }, label);
    return {
        el: el
    };
}
function $465eb396911258a2$var$retrieveStringValue(formData, key) {
    const value = formData.get(key);
    if (typeof value === "string") return value.trim();
    return "";
}
/**
 * Creates the form element
 */ function $465eb396911258a2$var$Form({ nameLabel: nameLabel, namePlaceholder: namePlaceholder, emailLabel: emailLabel, emailPlaceholder: emailPlaceholder, messageLabel: messageLabel, messagePlaceholder: messagePlaceholder, cancelButtonLabel: cancelButtonLabel, submitButtonLabel: submitButtonLabel, showName: showName, showEmail: showEmail, isNameRequired: isNameRequired, isEmailRequired: isEmailRequired, defaultName: defaultName, defaultEmail: defaultEmail, onCancel: onCancel, onSubmit: onSubmit }) {
    const { el: submitEl } = $465eb396911258a2$var$SubmitButton({
        label: submitButtonLabel
    });
    function handleSubmit(e) {
        e.preventDefault();
        if (!(e.target instanceof HTMLFormElement)) return;
        try {
            if (onSubmit) {
                const formData = new FormData(e.target);
                const feedback = {
                    name: $465eb396911258a2$var$retrieveStringValue(formData, "name"),
                    email: $465eb396911258a2$var$retrieveStringValue(formData, "email"),
                    message: $465eb396911258a2$var$retrieveStringValue(formData, "message")
                };
                onSubmit(feedback);
            }
        } catch (e2) {
        // pass
        }
    }
    const errorEl = $465eb396911258a2$var$createElement("div", {
        className: "form__error-container form__error-container--hidden",
        ["aria-hidden"]: "true"
    });
    function showError(message) {
        errorEl.textContent = message;
        errorEl.classList.remove("form__error-container--hidden");
        errorEl.setAttribute("aria-hidden", "false");
    }
    function hideError() {
        errorEl.textContent = "";
        errorEl.classList.add("form__error-container--hidden");
        errorEl.setAttribute("aria-hidden", "true");
    }
    const nameEl = $465eb396911258a2$var$createElement("input", {
        id: "name",
        type: showName ? "text" : "hidden",
        ["aria-hidden"]: showName ? "false" : "true",
        name: "name",
        required: isNameRequired,
        className: "form__input",
        placeholder: namePlaceholder,
        value: defaultName
    });
    const emailEl = $465eb396911258a2$var$createElement("input", {
        id: "email",
        type: showEmail ? "text" : "hidden",
        ["aria-hidden"]: showEmail ? "false" : "true",
        name: "email",
        required: isEmailRequired,
        className: "form__input",
        placeholder: emailPlaceholder,
        value: defaultEmail
    });
    const messageEl = $465eb396911258a2$var$createElement("textarea", {
        id: "message",
        autoFocus: "true",
        rows: "5",
        name: "message",
        required: true,
        className: "form__input form__input--textarea",
        placeholder: messagePlaceholder
    });
    const cancelEl = $465eb396911258a2$var$createElement("button", {
        type: "button",
        className: "btn btn--default",
        ["aria-label"]: cancelButtonLabel,
        onClick: (e)=>{
            onCancel && onCancel(e);
        }
    }, cancelButtonLabel);
    const formEl = $465eb396911258a2$var$createElement("form", {
        className: "form",
        onSubmit: handleSubmit
    }, [
        errorEl,
        showName && $465eb396911258a2$var$createElement("label", {
            htmlFor: "name",
            className: "form__label"
        }, [
            $465eb396911258a2$var$createElement("span", {
                className: "form__label__text"
            }, nameLabel, isNameRequired && $465eb396911258a2$var$createElement("span", {
                className: "form__label__text--required"
            }, " (required)")),
            nameEl
        ]),
        !showName && nameEl,
        showEmail && $465eb396911258a2$var$createElement("label", {
            htmlFor: "email",
            className: "form__label"
        }, [
            $465eb396911258a2$var$createElement("span", {
                className: "form__label__text"
            }, emailLabel, isEmailRequired && $465eb396911258a2$var$createElement("span", {
                className: "form__label__text--required"
            }, " (required)")),
            emailEl
        ]),
        !showEmail && emailEl,
        $465eb396911258a2$var$createElement("label", {
            htmlFor: "message",
            className: "form__label"
        }, [
            $465eb396911258a2$var$createElement("span", {
                className: "form__label__text"
            }, messageLabel, $465eb396911258a2$var$createElement("span", {
                className: "form__label__text--required"
            }, " (required)")),
            messageEl
        ]),
        $465eb396911258a2$var$createElement("div", {
            className: "btn-group"
        }, [
            submitEl,
            cancelEl
        ])
    ]);
    return {
        get el () {
            return formEl;
        },
        showError: showError,
        hideError: hideError
    };
}
const $465eb396911258a2$var$XMLNS$1 = "http://www.w3.org/2000/svg";
/**
 * Sentry Logo
 */ function $465eb396911258a2$var$Logo({ colorScheme: colorScheme }) {
    const createElementNS = (tagName)=>$465eb396911258a2$var$WINDOW.document.createElementNS($465eb396911258a2$var$XMLNS$1, tagName);
    const svg = $465eb396911258a2$var$setAttributesNS(createElementNS("svg"), {
        class: "sentry-logo",
        width: "32",
        height: "30",
        viewBox: "0 0 72 66",
        fill: "none"
    });
    const path = $465eb396911258a2$var$setAttributesNS(createElementNS("path"), {
        transform: "translate(11, 11)",
        d: "M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z"
    });
    svg.append(path);
    const defs = createElementNS("defs");
    const style = createElementNS("style");
    style.textContent = `
    path {
      fill: ${colorScheme === "dark" ? "#fff" : "#362d59"};
    }`;
    if (colorScheme === "system") style.textContent += `
    @media (prefers-color-scheme: dark) {
      path: {
        fill: '#fff';
      }
    }
    `;
    defs.append(style);
    svg.append(defs);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Feedback dialog component that has the form
 */ function $465eb396911258a2$var$Dialog({ formTitle: formTitle, showBranding: showBranding, showName: showName, showEmail: showEmail, isNameRequired: isNameRequired, isEmailRequired: isEmailRequired, colorScheme: colorScheme, defaultName: defaultName, defaultEmail: defaultEmail, onClosed: onClosed, onCancel: onCancel, onSubmit: onSubmit, ...textLabels }) {
    let el = null;
    /**
   * Handles when the dialog is clicked. In our case, the dialog is the
   * semi-transparent bg behind the form. We want clicks outside of the form to
   * hide the form.
   */ function handleDialogClick() {
        close();
        // Only this should trigger `onClose`, we don't want the `close()` method to
        // trigger it, otherwise it can cause cycles.
        onClosed && onClosed();
    }
    /**
   * Close the dialog
   */ function close() {
        if (el) el.open = false;
    }
    /**
   * Opens the dialog
   */ function open() {
        if (el) el.open = true;
    }
    /**
   * Check if dialog is currently opened
   */ function checkIsOpen() {
        return el && el.open === true || false;
    }
    const { el: formEl, showError: showError, hideError: hideError } = $465eb396911258a2$var$Form({
        showEmail: showEmail,
        showName: showName,
        isEmailRequired: isEmailRequired,
        isNameRequired: isNameRequired,
        defaultName: defaultName,
        defaultEmail: defaultEmail,
        onSubmit: onSubmit,
        onCancel: onCancel,
        ...textLabels
    });
    el = $465eb396911258a2$var$createElement("dialog", {
        className: "dialog",
        open: true,
        onClick: handleDialogClick
    }, $465eb396911258a2$var$createElement("div", {
        className: "dialog__content",
        onClick: (e)=>{
            // Stop event propagation so clicks on content modal do not propagate to dialog (which will close dialog)
            e.stopPropagation();
        }
    }, $465eb396911258a2$var$createElement("h2", {
        className: "dialog__header"
    }, formTitle, showBranding && $465eb396911258a2$var$createElement("a", {
        className: "brand-link",
        target: "_blank",
        href: "https://sentry.io/welcome/",
        title: "Powered by Sentry",
        rel: "noopener noreferrer"
    }, $465eb396911258a2$var$Logo({
        colorScheme: colorScheme
    }).el)), formEl));
    return {
        get el () {
            return el;
        },
        showError: showError,
        hideError: hideError,
        open: open,
        close: close,
        checkIsOpen: checkIsOpen
    };
}
const $465eb396911258a2$var$WIDTH = 16;
const $465eb396911258a2$var$HEIGHT = 17;
const $465eb396911258a2$var$XMLNS = "http://www.w3.org/2000/svg";
/**
 * Success Icon (checkmark)
 */ function $465eb396911258a2$var$SuccessIcon() {
    const createElementNS = (tagName)=>$465eb396911258a2$var$WINDOW.document.createElementNS($465eb396911258a2$var$XMLNS, tagName);
    const svg = $465eb396911258a2$var$setAttributesNS(createElementNS("svg"), {
        class: "success-icon",
        width: `${$465eb396911258a2$var$WIDTH}`,
        height: `${$465eb396911258a2$var$HEIGHT}`,
        viewBox: `0 0 ${$465eb396911258a2$var$WIDTH} ${$465eb396911258a2$var$HEIGHT}`,
        fill: "none"
    });
    const g = $465eb396911258a2$var$setAttributesNS(createElementNS("g"), {
        clipPath: "url(#clip0_57_156)"
    });
    const path2 = $465eb396911258a2$var$setAttributesNS(createElementNS("path"), {
        ["fill-rule"]: "evenodd",
        ["clip-rule"]: "evenodd",
        d: "M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z"
    });
    const path = $465eb396911258a2$var$setAttributesNS(createElementNS("path"), {
        d: "M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z"
    });
    svg.appendChild(g).append(path, path2);
    const speakerDefs = createElementNS("defs");
    const speakerClipPathDef = $465eb396911258a2$var$setAttributesNS(createElementNS("clipPath"), {
        id: "clip0_57_156"
    });
    const speakerRect = $465eb396911258a2$var$setAttributesNS(createElementNS("rect"), {
        width: `${$465eb396911258a2$var$WIDTH}`,
        height: `${$465eb396911258a2$var$WIDTH}`,
        fill: "white",
        transform: "translate(0 0.5)"
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Feedback dialog component that has the form
 */ function $465eb396911258a2$var$SuccessMessage({ message: message, onRemove: onRemove }) {
    function remove() {
        if (!el) return;
        el.remove();
        onRemove && onRemove();
    }
    const el = $465eb396911258a2$var$createElement("div", {
        className: "success-message",
        onClick: remove
    }, $465eb396911258a2$var$SuccessIcon().el, message);
    return {
        el: el,
        remove: remove
    };
}
/**
 * Creates a new widget. Returns public methods that control widget behavior.
 */ function $465eb396911258a2$var$createWidget({ shadow: shadow, options: { shouldCreateActor: shouldCreateActor = true, ...options }, attachTo: attachTo }) {
    let actor;
    let dialog;
    let isDialogOpen = false;
    /**
   * Show the success message for 5 seconds
   */ function showSuccessMessage() {
        if (!shadow) return;
        try {
            const success = $465eb396911258a2$var$SuccessMessage({
                message: options.successMessageText,
                onRemove: ()=>{
                    if (timeoutId) clearTimeout(timeoutId);
                    showActor();
                }
            });
            if (!success.el) throw new Error("Unable to show success message");
            shadow.appendChild(success.el);
            const timeoutId = setTimeout(()=>{
                if (success) success.remove();
            }, 5000);
        } catch (err) {
            // TODO: error handling
            (0, $7p8hL.logger).error(err);
        }
    }
    /**
   * Handler for when the feedback form is completed by the user. This will
   * create and send the feedback message as an event.
   */ async function _handleFeedbackSubmit(feedback) {
        if (!dialog) return;
        // Simple validation for now, just check for non-empty required fields
        const emptyField = [];
        if (options.isNameRequired && !feedback.name) emptyField.push(options.nameLabel);
        if (options.isEmailRequired && !feedback.email) emptyField.push(options.emailLabel);
        if (!feedback.message) emptyField.push(options.messageLabel);
        if (emptyField.length > 0) {
            dialog.showError(`Please enter in the following required fields: ${emptyField.join(", ")}`);
            return;
        }
        const result = await $465eb396911258a2$var$handleFeedbackSubmit(dialog, feedback);
        // Error submitting feedback
        if (!result) {
            if (options.onSubmitError) options.onSubmitError();
            return;
        }
        // Success
        removeDialog();
        showSuccessMessage();
        if (options.onSubmitSuccess) options.onSubmitSuccess();
    }
    /**
   * Internal handler when dialog is opened
   */ function handleOpenDialog() {
        // Flush replay if integration exists
        const client = (0, $hcepo.getClient)();
        const replay = client && client.getIntegrationByName && client.getIntegrationByName("Replay");
        if (!replay) return;
        replay.flush().catch((err)=>{
            $465eb396911258a2$var$DEBUG_BUILD && (0, $7p8hL.logger).error(err);
        });
    }
    /**
   * Displays the default actor
   */ function showActor() {
        actor && actor.show();
    }
    /**
   * Hides the default actor
   */ function hideActor() {
        actor && actor.hide();
    }
    /**
   * Removes the default actor element
   */ function removeActor() {
        actor && actor.el && actor.el.remove();
    }
    /**
   *
   */ function openDialog() {
        try {
            if (dialog) {
                dialog.open();
                isDialogOpen = true;
                if (options.onFormOpen) options.onFormOpen();
                handleOpenDialog();
                return;
            }
            const userKey = options.useSentryUser;
            const scope = (0, $hcepo.getCurrentScope)();
            const user = scope && scope.getUser();
            dialog = $465eb396911258a2$var$Dialog({
                colorScheme: options.colorScheme,
                showBranding: options.showBranding,
                showName: options.showName || options.isNameRequired,
                showEmail: options.showEmail || options.isEmailRequired,
                isNameRequired: options.isNameRequired,
                isEmailRequired: options.isEmailRequired,
                formTitle: options.formTitle,
                cancelButtonLabel: options.cancelButtonLabel,
                submitButtonLabel: options.submitButtonLabel,
                emailLabel: options.emailLabel,
                emailPlaceholder: options.emailPlaceholder,
                messageLabel: options.messageLabel,
                messagePlaceholder: options.messagePlaceholder,
                nameLabel: options.nameLabel,
                namePlaceholder: options.namePlaceholder,
                defaultName: userKey && user && user[userKey.name] || "",
                defaultEmail: userKey && user && user[userKey.email] || "",
                onClosed: ()=>{
                    showActor();
                    isDialogOpen = false;
                    if (options.onFormClose) options.onFormClose();
                },
                onCancel: ()=>{
                    closeDialog();
                    showActor();
                },
                onSubmit: _handleFeedbackSubmit
            });
            if (!dialog.el) throw new Error("Unable to open Feedback dialog");
            shadow.appendChild(dialog.el);
            // Hides the default actor whenever dialog is opened
            hideActor();
            if (options.onFormOpen) options.onFormOpen();
            handleOpenDialog();
        } catch (err) {
            // TODO: Error handling?
            (0, $7p8hL.logger).error(err);
        }
    }
    /**
   * Closes the dialog
   */ function closeDialog() {
        if (dialog) {
            dialog.close();
            isDialogOpen = false;
            if (options.onFormClose) options.onFormClose();
        }
    }
    /**
   * Removes the dialog element from DOM
   */ function removeDialog() {
        if (dialog) {
            closeDialog();
            const dialogEl = dialog.el;
            dialogEl && dialogEl.remove();
            dialog = undefined;
        }
    }
    /**
   *
   */ function handleActorClick() {
        // Open dialog
        if (!isDialogOpen) openDialog();
        // Hide actor button
        hideActor();
    }
    if (attachTo) attachTo.addEventListener("click", handleActorClick);
    else if (shouldCreateActor) {
        actor = $465eb396911258a2$var$Actor({
            buttonLabel: options.buttonLabel,
            onClick: handleActorClick
        });
        actor.el && shadow.appendChild(actor.el);
    }
    return {
        get actor () {
            return actor;
        },
        get dialog () {
            return dialog;
        },
        showActor: showActor,
        hideActor: hideActor,
        removeActor: removeActor,
        openDialog: openDialog,
        closeDialog: closeDialog,
        removeDialog: removeDialog
    };
}
const $465eb396911258a2$var$doc = $465eb396911258a2$var$WINDOW.document;
const $465eb396911258a2$export$b3f80fd9e808d6d7 = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new $465eb396911258a2$export$175e500a48a60fd2(options);
};
/**
 * Feedback integration. When added as an integration to the SDK, it will
 * inject a button in the bottom-right corner of the window that opens a
 * feedback modal when clicked.
 *
 * @deprecated Use `feedbackIntegration()` instead.
 */ class $465eb396911258a2$export$175e500a48a60fd2 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Feedback";
    }
    /**
   * @inheritDoc
   */ /**
   * Feedback configuration options
   */ /**
   * Reference to widget element that is created when autoInject is true
   */ /**
   * List of all widgets that are created from the integration
   */ /**
   * Reference to the host element where widget is inserted
   */ /**
   * Refernce to Shadow DOM root
   */ /**
   * Tracks if actor styles have ever been inserted into shadow DOM
   */ constructor({ autoInject: autoInject = true, id: id = "sentry-feedback", isEmailRequired: isEmailRequired = false, isNameRequired: isNameRequired = false, showBranding: showBranding = true, showEmail: showEmail = true, showName: showName = true, useSentryUser: useSentryUser = {
        email: "email",
        name: "username"
    }, themeDark: themeDark, themeLight: themeLight, colorScheme: colorScheme = "system", buttonLabel: buttonLabel = $465eb396911258a2$var$ACTOR_LABEL, cancelButtonLabel: cancelButtonLabel = $465eb396911258a2$var$CANCEL_BUTTON_LABEL, submitButtonLabel: submitButtonLabel = $465eb396911258a2$var$SUBMIT_BUTTON_LABEL, formTitle: formTitle = $465eb396911258a2$var$FORM_TITLE, emailPlaceholder: emailPlaceholder = $465eb396911258a2$var$EMAIL_PLACEHOLDER, emailLabel: emailLabel = $465eb396911258a2$var$EMAIL_LABEL, messagePlaceholder: messagePlaceholder = $465eb396911258a2$var$MESSAGE_PLACEHOLDER, messageLabel: messageLabel = $465eb396911258a2$var$MESSAGE_LABEL, namePlaceholder: namePlaceholder = $465eb396911258a2$var$NAME_PLACEHOLDER, nameLabel: nameLabel = $465eb396911258a2$var$NAME_LABEL, successMessageText: successMessageText = $465eb396911258a2$var$SUCCESS_MESSAGE_TEXT, onFormClose: onFormClose, onFormOpen: onFormOpen, onSubmitError: onSubmitError, onSubmitSuccess: onSubmitSuccess } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = $465eb396911258a2$export$175e500a48a60fd2.id;
        // tsc fails if these are not initialized explicitly constructor, e.g. can't call `_initialize()`
        this._host = null;
        this._shadow = null;
        this._widget = null;
        this._widgets = new Set();
        this._hasInsertedActorStyles = false;
        this.options = {
            autoInject: autoInject,
            showBranding: showBranding,
            id: id,
            isEmailRequired: isEmailRequired,
            isNameRequired: isNameRequired,
            showEmail: showEmail,
            showName: showName,
            useSentryUser: useSentryUser,
            colorScheme: colorScheme,
            themeDark: {
                ...$465eb396911258a2$var$DEFAULT_THEME.dark,
                ...themeDark
            },
            themeLight: {
                ...$465eb396911258a2$var$DEFAULT_THEME.light,
                ...themeLight
            },
            buttonLabel: buttonLabel,
            cancelButtonLabel: cancelButtonLabel,
            submitButtonLabel: submitButtonLabel,
            formTitle: formTitle,
            emailLabel: emailLabel,
            emailPlaceholder: emailPlaceholder,
            messageLabel: messageLabel,
            messagePlaceholder: messagePlaceholder,
            nameLabel: nameLabel,
            namePlaceholder: namePlaceholder,
            successMessageText: successMessageText,
            onFormClose: onFormClose,
            onFormOpen: onFormOpen,
            onSubmitError: onSubmitError,
            onSubmitSuccess: onSubmitSuccess
        };
    }
    /**
   * Setup and initialize feedback container
   */ setupOnce() {
        if (!(0, $kVwzp.isBrowser)()) return;
        try {
            this._cleanupWidgetIfExists();
            const { autoInject: autoInject } = this.options;
            if (!autoInject) // Nothing to do here
            return;
            this._createWidget(this.options);
        } catch (err) {
            $465eb396911258a2$var$DEBUG_BUILD && (0, $7p8hL.logger).error(err);
        }
    }
    /**
   * Allows user to open the dialog box. Creates a new widget if
   * `autoInject` was false, otherwise re-uses the default widget that was
   * created during initialization of the integration.
   */ openDialog() {
        if (!this._widget) this._createWidget({
            ...this.options,
            shouldCreateActor: false
        });
        if (!this._widget) return;
        this._widget.openDialog();
    }
    /**
   * Closes the dialog for the default widget, if it exists
   */ closeDialog() {
        if (!this._widget) // Nothing to do if widget does not exist
        return;
        this._widget.closeDialog();
    }
    /**
   * Adds click listener to attached element to open a feedback dialog
   */ attachTo(el, optionOverrides) {
        try {
            const options = $465eb396911258a2$var$mergeOptions(this.options, optionOverrides || {});
            return this._ensureShadowHost(options, ({ shadow: shadow })=>{
                const targetEl = typeof el === "string" ? $465eb396911258a2$var$doc.querySelector(el) : typeof el.addEventListener === "function" ? el : null;
                if (!targetEl) {
                    $465eb396911258a2$var$DEBUG_BUILD && (0, $7p8hL.logger).error("[Feedback] Unable to attach to target element");
                    return null;
                }
                const widget = $465eb396911258a2$var$createWidget({
                    shadow: shadow,
                    options: options,
                    attachTo: targetEl
                });
                this._widgets.add(widget);
                if (!this._widget) this._widget = widget;
                return widget;
            });
        } catch (err) {
            $465eb396911258a2$var$DEBUG_BUILD && (0, $7p8hL.logger).error(err);
            return null;
        }
    }
    /**
   * Creates a new widget. Accepts partial options to override any options passed to constructor.
   */ createWidget(optionOverrides) {
        try {
            return this._createWidget($465eb396911258a2$var$mergeOptions(this.options, optionOverrides || {}));
        } catch (err) {
            $465eb396911258a2$var$DEBUG_BUILD && (0, $7p8hL.logger).error(err);
            return null;
        }
    }
    /**
   * Removes a single widget
   */ removeWidget(widget) {
        if (!widget) return false;
        try {
            if (this._widgets.has(widget)) {
                widget.removeActor();
                widget.removeDialog();
                this._widgets.delete(widget);
                if (this._widget === widget) // TODO: is more clean-up needed? e.g. call remove()
                this._widget = null;
                return true;
            }
        } catch (err) {
            $465eb396911258a2$var$DEBUG_BUILD && (0, $7p8hL.logger).error(err);
        }
        return false;
    }
    /**
   * Returns the default (first-created) widget
   */ getWidget() {
        return this._widget;
    }
    /**
   * Removes the Feedback integration (including host, shadow DOM, and all widgets)
   */ remove() {
        if (this._host) this._host.remove();
        this._initialize();
    }
    /**
   * Initializes values of protected properties
   */ _initialize() {
        this._host = null;
        this._shadow = null;
        this._widget = null;
        this._widgets = new Set();
        this._hasInsertedActorStyles = false;
    }
    /**
   * Clean-up the widget if it already exists in the DOM. This shouldn't happen
   * in prod, but can happen in development with hot module reloading.
   */ _cleanupWidgetIfExists() {
        if (this._host) this.remove();
        const existingFeedback = $465eb396911258a2$var$doc.querySelector(`#${this.options.id}`);
        if (existingFeedback) existingFeedback.remove();
    }
    /**
   * Creates a new widget, after ensuring shadow DOM exists
   */ _createWidget(options) {
        return this._ensureShadowHost(options, ({ shadow: shadow })=>{
            const widget = $465eb396911258a2$var$createWidget({
                shadow: shadow,
                options: options
            });
            if (!this._hasInsertedActorStyles && widget.actor) {
                shadow.appendChild($465eb396911258a2$var$createActorStyles($465eb396911258a2$var$doc));
                this._hasInsertedActorStyles = true;
            }
            this._widgets.add(widget);
            if (!this._widget) this._widget = widget;
            return widget;
        });
    }
    /**
   * Ensures that shadow DOM exists and is added to the DOM
   */ _ensureShadowHost(options, cb) {
        let needsAppendHost = false;
        // Don't create if it already exists
        if (!this._shadow || !this._host) {
            const { id: id, colorScheme: colorScheme, themeLight: themeLight, themeDark: themeDark } = options;
            const { shadow: shadow, host: host } = $465eb396911258a2$var$createShadowHost({
                id: id,
                colorScheme: colorScheme,
                themeLight: themeLight,
                themeDark: themeDark
            });
            this._shadow = shadow;
            this._host = host;
            needsAppendHost = true;
        }
        // set data attribute on host for different themes
        this._host.dataset.sentryFeedbackColorscheme = options.colorScheme;
        const result = cb({
            shadow: this._shadow,
            host: this._host
        });
        if (needsAppendHost) $465eb396911258a2$var$doc.body.appendChild(this._host);
        return result;
    }
}
$465eb396911258a2$export$175e500a48a60fd2.__initStatic();

});

parcelRegister("52HK7", function(module, exports) {

$parcel$export(module.exports, "BrowserTracing", function () { return $3abf1211f0b3a095$export$46d3bbd0375f5fa4; });

var $jEn5j = parcelRequire("jEn5j");
var $7flMU = parcelRequire("7flMU");
var $kuS4l = parcelRequire("kuS4l");
var $k6xPV = parcelRequire("k6xPV");

var $04wr6 = parcelRequire("04wr6");
var $7p8hL = parcelRequire("7p8hL");
var $6jMr3 = parcelRequire("6jMr3");

var $221nn = parcelRequire("221nn");

var $hz9Jf = parcelRequire("hz9Jf");

var $6RLzi = parcelRequire("6RLzi");

var $l7Nlw = parcelRequire("l7Nlw");

var $71Rzy = parcelRequire("71Rzy");

var $hi3xY = parcelRequire("hi3xY");
const $3abf1211f0b3a095$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $3abf1211f0b3a095$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $k6xPV.TRACING_DEFAULTS),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $71Rzy.instrumentRoutingWithDefaults),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    _experiments: {},
    ...(0, $l7Nlw.defaultRequestInstrumentationOptions)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ class $3abf1211f0b3a095$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ constructor(_options){
        this.name = $3abf1211f0b3a095$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $jEn5j.addTracingExtensions)();
        if (0, $221nn.DEBUG_BUILD) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$3abf1211f0b3a095$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $6RLzi.startTrackingWebVitals)();
        if (this.options.enableLongTask) (0, $6RLzi.startTrackingLongTasks)();
        if (this.options._experiments.enableInteractions) (0, $6RLzi.startTrackingInteractions)();
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $221nn.DEBUG_BUILD) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $7p8hL.logger).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $hz9Jf.registerBackgroundTabDetection)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        (0, $l7Nlw.instrumentOutgoingRequests)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $3abf1211f0b3a095$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $3abf1211f0b3a095$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $6jMr3.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        this._latestRouteName = finalContext.name;
        this._latestRouteSource = $3abf1211f0b3a095$var$getSource(finalContext);
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $hi3xY.WINDOW);
        const idleTransaction = (0, $jEn5j.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            (0, $hi3xY.WINDOW).document.addEventListener("readystatechange", ()=>{
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $hi3xY.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                "interactive",
                "complete"
            ].includes((0, $hi3xY.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $6RLzi.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = "ui.action.click";
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, $7flMU.getActiveTransaction)();
            if (currentTransaction && currentTransaction.op && [
                "navigation",
                "pageload"
            ].includes(currentTransaction.op)) {
                (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRouteName) {
                (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $hi3xY.WINDOW);
            const context = {
                name: this._latestRouteName,
                op: op,
                trimEnd: true,
                data: {
                    [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: this._latestRouteSource || "url"
                }
            };
            inflightInteractionTransaction = (0, $jEn5j.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            "click"
        ].forEach((type)=>{
            addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
}
/** Returns the value of a meta tag */ function $3abf1211f0b3a095$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $04wr6.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
function $3abf1211f0b3a095$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

});
parcelRegister("hz9Jf", function(module, exports) {

$parcel$export(module.exports, "registerBackgroundTabDetection", function () { return $cc9d407a31c7c486$export$6f18f55521af71a1; });

var $7flMU = parcelRequire("7flMU");
var $4RP7L = parcelRequire("4RP7L");

var $7p8hL = parcelRequire("7p8hL");

var $221nn = parcelRequire("221nn");

var $hi3xY = parcelRequire("hi3xY");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $cc9d407a31c7c486$export$6f18f55521af71a1() {
    if ((0, $hi3xY.WINDOW) && (0, $hi3xY.WINDOW).document) (0, $hi3xY.WINDOW).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $7flMU.getActiveTransaction)();
        if ((0, $hi3xY.WINDOW).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op: op, status: status } = (0, $4RP7L.spanToJSON)(activeTransaction);
            (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}

});

parcelRegister("6RLzi", function(module, exports) {

$parcel$export(module.exports, "startTrackingWebVitals", function () { return $4ffc976292e16022$export$7c69f0412d101b88; });
$parcel$export(module.exports, "startTrackingLongTasks", function () { return $4ffc976292e16022$export$f396d19077034ad2; });
$parcel$export(module.exports, "startTrackingInteractions", function () { return $4ffc976292e16022$export$e27543e0976315e4; });
$parcel$export(module.exports, "startTrackingINP", function () { return $4ffc976292e16022$export$f17d06681a4744a3; });
$parcel$export(module.exports, "addPerformanceEntries", function () { return $4ffc976292e16022$export$5f8fa6b3467a7443; });

var $3U98K = parcelRequire("3U98K");
var $7flMU = parcelRequire("7flMU");
var $hcepo = parcelRequire("hcepo");
var $2aCxe = parcelRequire("2aCxe");
var $g05qq = parcelRequire("g05qq");
var $g6vjT = parcelRequire("g6vjT");
var $5mTXR = parcelRequire("5mTXR");
var $4RP7L = parcelRequire("4RP7L");

var $iGf0k = parcelRequire("iGf0k");
var $04wr6 = parcelRequire("04wr6");
var $7p8hL = parcelRequire("7p8hL");
var $bn8Da = parcelRequire("bn8Da");

var $221nn = parcelRequire("221nn");

var $aiNal = parcelRequire("aiNal");

var $hi3xY = parcelRequire("hi3xY");

var $3zi5n = parcelRequire("3zi5n");

var $3RDMn = parcelRequire("3RDMn");
const $4ffc976292e16022$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $4ffc976292e16022$var$msToSec(time) {
    return time / 1000;
}
function $4ffc976292e16022$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $hi3xY.WINDOW) && (0, $hi3xY.WINDOW).addEventListener && (0, $hi3xY.WINDOW).performance;
}
let $4ffc976292e16022$var$_performanceCursor = 0;
let $4ffc976292e16022$var$_measurements = {};
let $4ffc976292e16022$var$_lcpEntry;
let $4ffc976292e16022$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $4ffc976292e16022$export$7c69f0412d101b88() {
    const performance = $4ffc976292e16022$var$getBrowserPerformanceAPI();
    if (performance && (0, $iGf0k.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $hi3xY.WINDOW).performance.mark("sentry-tracing-init");
        const fidCallback = $4ffc976292e16022$var$_trackFID();
        const clsCallback = $4ffc976292e16022$var$_trackCLS();
        const lcpCallback = $4ffc976292e16022$var$_trackLCP();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $4ffc976292e16022$export$f396d19077034ad2() {
    (0, $aiNal.addPerformanceInstrumentationHandler)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $7flMU.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $4ffc976292e16022$var$msToSec((0, $iGf0k.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $4ffc976292e16022$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $4ffc976292e16022$export$e27543e0976315e4() {
    (0, $aiNal.addPerformanceInstrumentationHandler)("event", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $7flMU.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $4ffc976292e16022$var$msToSec((0, $iGf0k.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $4ffc976292e16022$var$msToSec(entry.duration);
                const span = {
                    description: (0, $04wr6.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $04wr6.getComponentName)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $4ffc976292e16022$export$f17d06681a4744a3(interactionIdtoRouteNameMapping) {
    const performance = $4ffc976292e16022$var$getBrowserPerformanceAPI();
    if (performance && (0, $iGf0k.browserPerformanceTimeOrigin)) {
        const inpCallback = $4ffc976292e16022$var$_trackINP(interactionIdtoRouteNameMapping);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $4ffc976292e16022$var$_trackCLS() {
    return (0, $aiNal.addClsInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Measurements] Adding CLS");
        $4ffc976292e16022$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $4ffc976292e16022$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $4ffc976292e16022$var$_trackLCP() {
    return (0, $aiNal.addLcpInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Measurements] Adding LCP");
        $4ffc976292e16022$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $4ffc976292e16022$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $4ffc976292e16022$var$_trackFID() {
    return (0, $aiNal.addFidInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $4ffc976292e16022$var$msToSec((0, $iGf0k.browserPerformanceTimeOrigin));
        const startTime = $4ffc976292e16022$var$msToSec(entry.startTime);
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Measurements] Adding FID");
        $4ffc976292e16022$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $4ffc976292e16022$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
/** Starts tracking the Interaction to Next Paint on the current page. */ function $4ffc976292e16022$var$_trackINP(interactionIdtoRouteNameMapping) {
    return (0, $aiNal.addInpInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries.find((e)=>e.name === "click");
        const client = (0, $hcepo.getClient)();
        if (!entry || !client) return;
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $4ffc976292e16022$var$msToSec((0, $iGf0k.browserPerformanceTimeOrigin) + entry.startTime);
        const duration = $4ffc976292e16022$var$msToSec(metric.value);
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = entry.interactionId !== undefined ? interactionIdtoRouteNameMapping[entry.interactionId] : {
            routeName: undefined,
            parentContext: undefined,
            activeTransaction: undefined,
            user: undefined,
            replayId: undefined
        };
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $5mTXR.Span)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: "ui.interaction.click",
            name: (0, $04wr6.htmlTreeAsString)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== "" ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $4ffc976292e16022$var$getSampleRate(parentContext, options);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $3U98K.createSpanEnvelope)([
                span
            ]) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).error("Error while sending interaction:", reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $4ffc976292e16022$export$5f8fa6b3467a7443(transaction) {
    const performance = $4ffc976292e16022$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $hi3xY.WINDOW).performance.getEntries || !(0, $iGf0k.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $4ffc976292e16022$var$msToSec((0, $iGf0k.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    let responseStartTimestamp;
    let requestStartTimestamp;
    const { op: op, start_timestamp: transactionStartTime } = (0, $4RP7L.spanToJSON)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($4ffc976292e16022$var$_performanceCursor).forEach((entry)=>{
        const startTime = $4ffc976292e16022$var$msToSec(entry.startTime);
        const duration = $4ffc976292e16022$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $4ffc976292e16022$var$_addNavigationSpans(transaction, entry, timeOrigin);
                responseStartTimestamp = timeOrigin + $4ffc976292e16022$var$msToSec(entry.responseStart);
                requestStartTimestamp = timeOrigin + $4ffc976292e16022$var$msToSec(entry.requestStart);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $4ffc976292e16022$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $3zi5n.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Measurements] Adding FP");
                        $4ffc976292e16022$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Measurements] Adding FCP");
                        $4ffc976292e16022$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $4ffc976292e16022$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $4ffc976292e16022$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $4ffc976292e16022$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $4ffc976292e16022$export$45095b07f0832bb1($4ffc976292e16022$var$_measurements, responseStartTimestamp, requestStartTimestamp, transactionStartTime);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$4ffc976292e16022$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $4ffc976292e16022$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $4ffc976292e16022$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $4ffc976292e16022$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $4ffc976292e16022$var$_measurements["mark.fid"];
        if (fidMark && $4ffc976292e16022$var$_measurements["fid"]) {
            // create span for FID
            (0, $3RDMn._startChild)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $4ffc976292e16022$var$msToSec($4ffc976292e16022$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $4ffc976292e16022$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $4ffc976292e16022$var$_measurements)) delete $4ffc976292e16022$var$_measurements.cls;
        Object.keys($4ffc976292e16022$var$_measurements).forEach((measurementName)=>{
            (0, $g6vjT.setMeasurement)(measurementName, $4ffc976292e16022$var$_measurements[measurementName].value, $4ffc976292e16022$var$_measurements[measurementName].unit);
        });
        $4ffc976292e16022$var$_tagMetricInfo(transaction);
    }
    $4ffc976292e16022$var$_lcpEntry = undefined;
    $4ffc976292e16022$var$_clsEntry = undefined;
    $4ffc976292e16022$var$_measurements = {};
}
/** Create measure related spans */ function $4ffc976292e16022$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $3RDMn._startChild)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4ffc976292e16022$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $4ffc976292e16022$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $4ffc976292e16022$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $4ffc976292e16022$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $4ffc976292e16022$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $4ffc976292e16022$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $4ffc976292e16022$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $3RDMn._startChild)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $4ffc976292e16022$var$msToSec(start),
        endTimestamp: timeOrigin + $4ffc976292e16022$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4ffc976292e16022$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $3RDMn._startChild)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + $4ffc976292e16022$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $4ffc976292e16022$var$msToSec(entry.responseEnd)
        });
        (0, $3RDMn._startChild)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + $4ffc976292e16022$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $4ffc976292e16022$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $4ffc976292e16022$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $bn8Da.parseUrl)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $4ffc976292e16022$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $4ffc976292e16022$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $4ffc976292e16022$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, $hi3xY.WINDOW).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $3RDMn._startChild)(transaction, {
        description: resourceUrl.replace((0, $hi3xY.WINDOW).location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $4ffc976292e16022$var$_trackNavigator(transaction) {
    const navigator = (0, $hi3xY.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, $3RDMn.isMeasurementValue)(connection.rtt)) $4ffc976292e16022$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $3RDMn.isMeasurementValue)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $3RDMn.isMeasurementValue)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $4ffc976292e16022$var$_tagMetricInfo(transaction) {
    if ($4ffc976292e16022$var$_lcpEntry) {
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($4ffc976292e16022$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, $04wr6.htmlTreeAsString)($4ffc976292e16022$var$_lcpEntry.element));
        if ($4ffc976292e16022$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", $4ffc976292e16022$var$_lcpEntry.id);
        if ($4ffc976292e16022$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", $4ffc976292e16022$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", $4ffc976292e16022$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($4ffc976292e16022$var$_clsEntry && $4ffc976292e16022$var$_clsEntry.sources) {
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Measurements] Adding CLS Data");
        $4ffc976292e16022$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $04wr6.htmlTreeAsString)(source.node)));
    }
}
function $4ffc976292e16022$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $4ffc976292e16022$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb information to measurements
 *
 * Exported for tests
 */ function $4ffc976292e16022$export$45095b07f0832bb1(_measurements, responseStartTimestamp, requestStartTimestamp, transactionStartTime) {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === "number" && transactionStartTime) {
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Measurements] Adding TTFB");
        _measurements["ttfb"] = {
            // As per https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStart,
            // responseStart can be 0 if the request is coming straight from the cache.
            // This might lead us to calculate a negative ttfb if we don't use Math.max here.
            //
            // This logic is the same as what is in the web-vitals library to calculate ttfb
            // https://github.com/GoogleChrome/web-vitals/blob/2301de5015e82b09925238a228a0893635854587/src/onTTFB.ts#L92
            // TODO(abhi): We should use the web-vitals library instead of this custom calculation.
            value: Math.max(responseStartTimestamp - transactionStartTime, 0) * 1000,
            unit: "millisecond"
        };
        if (typeof requestStartTimestamp === "number" && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements["ttfb.requestTime"] = {
            value: (responseStartTimestamp - requestStartTimestamp) * 1000,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $4ffc976292e16022$var$getSampleRate(transactionContext, options) {
    if (!(0, $2aCxe.hasTracingEnabled)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $hi3xY.WINDOW).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $g05qq.isValidSampleRate)(sampleRate)) {
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        return false;
    }
    return sampleRate;
}

});
parcelRegister("3RDMn", function(module, exports) {

$parcel$export(module.exports, "isMeasurementValue", function () { return $2d052dae999a9a23$export$27169ccae1b439e3; });
$parcel$export(module.exports, "_startChild", function () { return $2d052dae999a9a23$export$8bd469e1f37aa721; });
/**
 * Checks if a given value is a valid measurement value.
 */ function $2d052dae999a9a23$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $2d052dae999a9a23$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}

});


parcelRegister("l7Nlw", function(module, exports) {

$parcel$export(module.exports, "defaultRequestInstrumentationOptions", function () { return $f6108789ffc5fa34$export$cc17fb3c0bc95cd7; });
$parcel$export(module.exports, "instrumentOutgoingRequests", function () { return $f6108789ffc5fa34$export$864489cb3478db3e; });

var $hcepo = parcelRequire("hcepo");
var $2Grcj = parcelRequire("2Grcj");
var $fxUGN = parcelRequire("fxUGN");
var $2aCxe = parcelRequire("2aCxe");
var $kuS4l = parcelRequire("kuS4l");
var $bMwjP = parcelRequire("bMwjP");
var $4RP7L = parcelRequire("4RP7L");
var $mtWu0 = parcelRequire("mtWu0");

var $dQVMO = parcelRequire("dQVMO");
var $jOCzY = parcelRequire("jOCzY");
var $9dJTa = parcelRequire("9dJTa");
var $iGf0k = parcelRequire("iGf0k");
var $6jMr3 = parcelRequire("6jMr3");
var $bMiqE = parcelRequire("bMiqE");

var $hDXp5 = parcelRequire("hDXp5");

var $aiNal = parcelRequire("aiNal");
/* eslint-disable max-lines */ const $f6108789ffc5fa34$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $f6108789ffc5fa34$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $f6108789ffc5fa34$export$15bd0305d05ad07b,
    tracePropagationTargets: $f6108789ffc5fa34$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $f6108789ffc5fa34$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $f6108789ffc5fa34$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $f6108789ffc5fa34$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$f6108789ffc5fa34$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $dQVMO.addFetchInstrumentationHandler)((handlerData)=>{
        const createdSpan = (0, $hDXp5.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $f6108789ffc5fa34$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $jOCzY.addXhrInstrumentationHandler)((handlerData)=>{
        const createdSpan = $f6108789ffc5fa34$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $f6108789ffc5fa34$var$addHTTPTimings(createdSpan);
    });
}
function $f6108789ffc5fa34$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $f6108789ffc5fa34$var$addHTTPTimings(span) {
    const { url: url } = (0, $4RP7L.spanToJSON)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $aiNal.addPerformanceInstrumentationHandler)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($f6108789ffc5fa34$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $f6108789ffc5fa34$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $f6108789ffc5fa34$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $f6108789ffc5fa34$var$getAbsoluteTime(time = 0) {
    return (((0, $iGf0k.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $f6108789ffc5fa34$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $f6108789ffc5fa34$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $iGf0k.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $f6108789ffc5fa34$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $bMiqE.stringMatchesSomePattern)(url, tracePropagationTargets || $f6108789ffc5fa34$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $f6108789ffc5fa34$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $jOCzY.SENTRY_XHR_DATA_KEY];
    if (!(0, $2aCxe.hasTracingEnabled)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $bMwjP.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $hcepo.getCurrentScope)();
    const isolationScope = (0, $fxUGN.getIsolationScope)();
    const span = shouldCreateSpanResult ? (0, $mtWu0.startInactiveSpan)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            url: sentryXhrData.url,
            [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser"
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $hcepo.getClient)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $4RP7L.spanToTraceHeader)(span) : (0, $6jMr3.generateSentryTraceHeader)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $9dJTa.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $2Grcj.getDynamicSamplingContextFromSpan)(span) : (0, $2Grcj.getDynamicSamplingContextFromClient)(traceId, client, scope)));
        $f6108789ffc5fa34$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $f6108789ffc5fa34$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $9dJTa.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}

});
parcelRegister("hDXp5", function(module, exports) {

$parcel$export(module.exports, "instrumentFetchRequest", function () { return $cd842884c7e01b90$export$6d73c62358c655be; });

var $hcepo = parcelRequire("hcepo");
var $2Grcj = parcelRequire("2Grcj");
var $fxUGN = parcelRequire("fxUGN");
var $2aCxe = parcelRequire("2aCxe");
var $kuS4l = parcelRequire("kuS4l");
var $bMwjP = parcelRequire("bMwjP");
var $4RP7L = parcelRequire("4RP7L");
var $mtWu0 = parcelRequire("mtWu0");

var $9dJTa = parcelRequire("9dJTa");
var $6jMr3 = parcelRequire("6jMr3");
var $jPeZ4 = parcelRequire("jPeZ4");
/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $cd842884c7e01b90$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $2aCxe.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                (0, $bMwjP.setHttpStatus)(span, handlerData.response.status);
                const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
                if (contentLength) {
                    const contentLengthNum = parseInt(contentLength);
                    if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
                }
            } else if (handlerData.error) span.setStatus("internal_error");
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $hcepo.getCurrentScope)();
    const client = (0, $hcepo.getClient)();
    const { method: method, url: url } = handlerData.fetchData;
    const span = shouldCreateSpanResult ? (0, $mtWu0.startInactiveSpan)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $cd842884c7e01b90$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $cd842884c7e01b90$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $fxUGN.getIsolationScope)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $4RP7L.spanToTraceHeader)(span) : (0, $6jMr3.generateSentryTraceHeader)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $9dJTa.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $2Grcj.getDynamicSamplingContextFromSpan)(span) : (0, $2Grcj.getDynamicSamplingContextFromClient)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $jPeZ4.isInstanceOf)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $jPeZ4.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $9dJTa.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $9dJTa.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}

});


parcelRegister("71Rzy", function(module, exports) {

$parcel$export(module.exports, "instrumentRoutingWithDefaults", function () { return $51e22ec90545d5e4$export$86649cc09fe75143; });

var $hFlB3 = parcelRequire("hFlB3");
var $iGf0k = parcelRequire("iGf0k");
var $7p8hL = parcelRequire("7p8hL");

var $221nn = parcelRequire("221nn");

var $hi3xY = parcelRequire("hi3xY");
/**
 * Default function implementing pageload and navigation transactions
 */ function $51e22ec90545d5e4$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $hi3xY.WINDOW) || !(0, $hi3xY.WINDOW).location) {
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    let startingUrl = (0, $hi3xY.WINDOW).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $hi3xY.WINDOW).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $iGf0k.browserPerformanceTimeOrigin) ? (0, $iGf0k.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: "pageload",
        origin: "auto.pageload.browser",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, $hFlB3.addHistoryInstrumentationHandler)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $hi3xY.WINDOW).location.pathname,
                op: "navigation",
                origin: "auto.navigation.browser",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}

});


parcelRegister("cd71e", function(module, exports) {

$parcel$export(module.exports, "browserTracingIntegration", function () { return $8e3c24c114a33a8a$export$b4109253475213e9; });
$parcel$export(module.exports, "startBrowserTracingPageLoadSpan", function () { return $8e3c24c114a33a8a$export$aa44a07f82af519f; });
$parcel$export(module.exports, "startBrowserTracingNavigationSpan", function () { return $8e3c24c114a33a8a$export$7d159749bd9969ad; });

var $jEn5j = parcelRequire("jEn5j");
var $mtWu0 = parcelRequire("mtWu0");
var $7flMU = parcelRequire("7flMU");
var $hcepo = parcelRequire("hcepo");
var $fxUGN = parcelRequire("fxUGN");
var $kuS4l = parcelRequire("kuS4l");
var $4RP7L = parcelRequire("4RP7L");
var $k6xPV = parcelRequire("k6xPV");

var $hFlB3 = parcelRequire("hFlB3");
var $iGf0k = parcelRequire("iGf0k");
var $04wr6 = parcelRequire("04wr6");
var $7p8hL = parcelRequire("7p8hL");
var $6jMr3 = parcelRequire("6jMr3");

var $221nn = parcelRequire("221nn");

var $hz9Jf = parcelRequire("hz9Jf");

var $aiNal = parcelRequire("aiNal");

var $6RLzi = parcelRequire("6RLzi");

var $l7Nlw = parcelRequire("l7Nlw");

var $hi3xY = parcelRequire("hi3xY");
const $8e3c24c114a33a8a$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $8e3c24c114a33a8a$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $k6xPV.TRACING_DEFAULTS),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    _experiments: {},
    ...(0, $l7Nlw.defaultRequestInstrumentationOptions)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $8e3c24c114a33a8a$export$b4109253475213e9 = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, $221nn.DEBUG_BUILD) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, $jEn5j.addTracingExtensions)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...$8e3c24c114a33a8a$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $6RLzi.startTrackingWebVitals)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdtoRouteNameMapping = {};
    if (options.enableInp) (0, $6RLzi.startTrackingINP)(interactionIdtoRouteNameMapping);
    if (options.enableLongTask) (0, $6RLzi.startTrackingLongTasks)();
    if (options._experiments.enableInteractions) (0, $6RLzi.startTrackingInteractions)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $fxUGN.getCurrentHub)();
        const { beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $8e3c24c114a33a8a$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $8e3c24c114a33a8a$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $6jMr3.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $hi3xY.WINDOW);
        const idleTransaction = (0, $jEn5j.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, $hi3xY.WINDOW).document) {
            (0, $hi3xY.WINDOW).document.addEventListener("readystatechange", ()=>{
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $hi3xY.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                "interactive",
                "complete"
            ].includes((0, $hi3xY.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, $6RLzi.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: $8e3c24c114a33a8a$export$bbd2089f30bd3708,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, $221nn.DEBUG_BUILD) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $7p8hL.logger).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
            let activeSpan;
            let startingUrl = (0, $hi3xY.WINDOW).location && (0, $hi3xY.WINDOW).location.href;
            if (client.on) {
                client.on("startNavigationSpan", (context)=>{
                    if (activeSpan) {
                        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Finishing current transaction with op: ${(0, $4RP7L.spanToJSON)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "navigation",
                        ...context
                    });
                });
                client.on("startPageLoadSpan", (context)=>{
                    if (activeSpan) {
                        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Finishing current transaction with op: ${(0, $4RP7L.spanToJSON)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "pageload",
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, $hi3xY.WINDOW).location) {
                const context = {
                    name: (0, $hi3xY.WINDOW).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, $iGf0k.browserPerformanceTimeOrigin) ? (0, $iGf0k.browserPerformanceTimeOrigin) / 1000 : undefined,
                    origin: "auto.pageload.browser",
                    attributes: {
                        [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url"
                    }
                };
                $8e3c24c114a33a8a$export$aa44a07f82af519f(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, $hi3xY.WINDOW).location) (0, $hFlB3.addHistoryInstrumentationHandler)(({ to: to, from: from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, $hi3xY.WINDOW).location.pathname,
                        origin: "auto.navigation.browser",
                        attributes: {
                            [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url"
                        }
                    };
                    $8e3c24c114a33a8a$export$7d159749bd9969ad(client, context);
                }
            });
            if (markBackgroundSpan) (0, $hz9Jf.registerBackgroundTabDetection)();
            if (_experiments.enableInteractions) $8e3c24c114a33a8a$var$registerInteractionListener(options, latestRoute);
            if (options.enableInp) $8e3c24c114a33a8a$var$registerInpInteractionListener(interactionIdtoRouteNameMapping, latestRoute);
            (0, $l7Nlw.instrumentOutgoingRequests)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        options: // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $8e3c24c114a33a8a$export$aa44a07f82af519f(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startPageLoadSpan", spanOptions);
    const span = (0, $mtWu0.getActiveSpan)();
    const op = span && (0, $4RP7L.spanToJSON)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $8e3c24c114a33a8a$export$7d159749bd9969ad(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startNavigationSpan", spanOptions);
    const span = (0, $mtWu0.getActiveSpan)();
    const op = span && (0, $4RP7L.spanToJSON)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function $8e3c24c114a33a8a$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $04wr6.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function $8e3c24c114a33a8a$var$registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const op = "ui.action.click";
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, $7flMU.getActiveTransaction)();
        if (currentTransaction && currentTransaction.op && [
            "navigation",
            "pageload"
        ].includes(currentTransaction.op)) {
            (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason("interactionInterrupted");
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location: location } = (0, $hi3xY.WINDOW);
        const context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: {
                [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.context ? $8e3c24c114a33a8a$var$getSource(latestRoute.context) : "url"
            }
        };
        inflightInteractionTransaction = (0, $jEn5j.startIdleTransaction)(// eslint-disable-next-line deprecation/deprecation
        (0, $fxUGN.getCurrentHub)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        "click"
    ].forEach((type)=>{
        addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function $8e3c24c114a33a8a$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $8e3c24c114a33a8a$var$MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function $8e3c24c114a33a8a$var$registerInpInteractionListener(interactionIdtoRouteNameMapping, latestRoute) {
    (0, $aiNal.addPerformanceInstrumentationHandler)("event", ({ entries: entries })=>{
        const client = (0, $hcepo.getClient)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $7flMU.getActiveTransaction)();
        const currentScope = (0, $hcepo.getCurrentScope)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        for (const entry of entries)if ($8e3c24c114a33a8a$var$isPerformanceEventTiming(entry)) {
            const duration = entry.duration;
            const keys = Object.keys(interactionIdtoRouteNameMapping);
            const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                return interactionIdtoRouteNameMapping[a].duration < interactionIdtoRouteNameMapping[b].duration ? a : b;
            }) : undefined;
            if (minInteractionId === undefined || duration > interactionIdtoRouteNameMapping[minInteractionId].duration) {
                const interactionId = entry.interactionId;
                const routeName = latestRoute.name;
                const parentContext = latestRoute.context;
                if (interactionId && routeName && parentContext) {
                    if (minInteractionId && Object.keys(interactionIdtoRouteNameMapping).length >= $8e3c24c114a33a8a$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete interactionIdtoRouteNameMapping[minInteractionId];
                    interactionIdtoRouteNameMapping[interactionId] = {
                        routeName: routeName,
                        duration: duration,
                        parentContext: parentContext,
                        user: user,
                        activeTransaction: activeTransaction,
                        replayId: replayId
                    };
                }
            }
        }
    });
}
function $8e3c24c114a33a8a$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

});

parcelRegister("58sat", function(module, exports) {

$parcel$export(module.exports, "makeBrowserOfflineTransport", function () { return $3bd38cad35e56b89$export$79c8882827636cf2; });

var $9LClL = parcelRequire("9LClL");

var $2pR2a = parcelRequire("2pR2a");
// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original licence:
// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function $3bd38cad35e56b89$var$promisifyRequest(request) {
    return new Promise((resolve, reject)=>{
        // @ts-expect-error - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-expect-error - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
/** Create or open an IndexedDb store */ function $3bd38cad35e56b89$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $3bd38cad35e56b89$var$promisifyRequest(request);
    return (callback)=>dbp.then((db)=>callback(db.transaction(storeName, "readwrite").objectStore(storeName)));
}
function $3bd38cad35e56b89$var$keys(store) {
    return $3bd38cad35e56b89$var$promisifyRequest(store.getAllKeys());
}
/** Insert into the store */ function $3bd38cad35e56b89$export$21a5ca8aa77d35ff(store, value, maxQueueSize) {
    return store((store)=>{
        return $3bd38cad35e56b89$var$keys(store).then((keys)=>{
            if (keys.length >= maxQueueSize) return;
            // We insert with an incremented key so that the entries are popped in order
            store.put(value, Math.max(...keys, 0) + 1);
            return $3bd38cad35e56b89$var$promisifyRequest(store.transaction);
        });
    });
}
/** Pop the oldest value from the store */ function $3bd38cad35e56b89$export$3e41007ebfff0e64(store) {
    return store((store)=>{
        return $3bd38cad35e56b89$var$keys(store).then((keys)=>{
            if (keys.length === 0) return undefined;
            return $3bd38cad35e56b89$var$promisifyRequest(store.get(keys[0])).then((value)=>{
                store.delete(keys[0]);
                return $3bd38cad35e56b89$var$promisifyRequest(store.transaction).then(()=>value);
            });
        });
    });
}
function $3bd38cad35e56b89$var$createIndexedDbStore(options) {
    let store;
    // Lazily create the store only when it's needed
    function getStore() {
        if (store == undefined) store = $3bd38cad35e56b89$export$f51a9068ac82ea43(options.dbName || "sentry-offline", options.storeName || "queue");
        return store;
    }
    return {
        insert: async (env)=>{
            try {
                const serialized = await (0, $2pR2a.serializeEnvelope)(env, options.textEncoder);
                await $3bd38cad35e56b89$export$21a5ca8aa77d35ff(getStore(), serialized, options.maxQueueSize || 30);
            } catch (_) {
            //
            }
        },
        pop: async ()=>{
            try {
                const deserialized = await $3bd38cad35e56b89$export$3e41007ebfff0e64(getStore());
                if (deserialized) return (0, $2pR2a.parseEnvelope)(deserialized, options.textEncoder || new TextEncoder(), options.textDecoder || new TextDecoder());
            } catch (_) {
            //
            }
            return undefined;
        }
    };
}
function $3bd38cad35e56b89$var$makeIndexedDbOfflineTransport(createTransport) {
    return (options)=>createTransport({
            ...options,
            createStore: $3bd38cad35e56b89$var$createIndexedDbStore
        });
}
/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */ function $3bd38cad35e56b89$export$79c8882827636cf2(createTransport) {
    return $3bd38cad35e56b89$var$makeIndexedDbOfflineTransport((0, $9LClL.makeOfflineTransport)(createTransport));
}

});

parcelRegister("33qkX", function(module, exports) {

$parcel$export(module.exports, "onProfilingStartRouteTransaction", function () { return $239614e475a6033d$export$410ca53b300571c6; });
$parcel$export(module.exports, "startProfileForTransaction", function () { return $239614e475a6033d$export$a5c90b2530e76e64; });

var $4RP7L = parcelRequire("4RP7L");

var $7p8hL = parcelRequire("7p8hL");
var $iGf0k = parcelRequire("iGf0k");
var $iJH3x = parcelRequire("iJH3x");

var $e2xQm = parcelRequire("e2xQm");

var $d9NWo = parcelRequire("d9NWo");

var $4HiKl = parcelRequire("4HiKl");
/* eslint-disable complexity */ /**
 * Safety wrapper for startTransaction for the unlikely case that transaction starts before tracing is imported -
 * if that happens we want to avoid throwing an error from profiling code.
 * see https://github.com/getsentry/sentry-javascript/issues/4731.
 *
 * @experimental
 */ function $239614e475a6033d$export$410ca53b300571c6(transaction) {
    if (!transaction) {
        if (0, $e2xQm.DEBUG_BUILD) (0, $7p8hL.logger).log("[Profiling] Transaction is undefined, skipping profiling");
        return transaction;
    }
    if ((0, $4HiKl.shouldProfileTransaction)(transaction)) return $239614e475a6033d$export$a5c90b2530e76e64(transaction);
    return transaction;
}
/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfileForTransaction is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */ function $239614e475a6033d$export$a5c90b2530e76e64(transaction) {
    // Start the profiler and get the profiler instance.
    let startTimestamp;
    if ((0, $4HiKl.isAutomatedPageLoadTransaction)(transaction)) startTimestamp = (0, $iGf0k.timestampInSeconds)() * 1000;
    const profiler = (0, $4HiKl.startJSSelfProfile)();
    // We failed to construct the profiler, fallback to original transaction.
    // No need to log anything as this has already been logged in startProfile.
    if (!profiler) return transaction;
    if (0, $e2xQm.DEBUG_BUILD) (0, $7p8hL.logger).log(`[Profiling] started profiling transaction: ${(0, $4RP7L.spanToJSON)(transaction).description}`);
    // We create "unique" transaction names to avoid concurrent transactions with same names
    // from being ignored by the profiler. From here on, only this transaction name should be used when
    // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
    const profileId = (0, $iJH3x.uuid4)();
    /**
   * Idempotent handler for profile stop
   */ async function onProfileHandler() {
        // Check if the profile exists and return it the behavior has to be idempotent as users may call transaction.finish multiple times.
        if (!transaction) return null;
        // Satisfy the type checker, but profiler will always be defined here.
        if (!profiler) return null;
        return profiler.stop().then((profile)=>{
            if (maxDurationTimeoutID) {
                (0, $d9NWo.WINDOW).clearTimeout(maxDurationTimeoutID);
                maxDurationTimeoutID = undefined;
            }
            if (0, $e2xQm.DEBUG_BUILD) (0, $7p8hL.logger).log(`[Profiling] stopped profiling of transaction: ${(0, $4RP7L.spanToJSON)(transaction).description}`);
            // In case of an overlapping transaction, stopProfiling may return null and silently ignore the overlapping profile.
            if (!profile) {
                if (0, $e2xQm.DEBUG_BUILD) (0, $7p8hL.logger).log(`[Profiling] profiler returned null profile for: ${(0, $4RP7L.spanToJSON)(transaction).description}`, "this may indicate an overlapping transaction or a call to stopProfiling with a profile title that was never started");
                return null;
            }
            (0, $4HiKl.addProfileToGlobalCache)(profileId, profile);
            return null;
        }).catch((error)=>{
            if (0, $e2xQm.DEBUG_BUILD) (0, $7p8hL.logger).log("[Profiling] error while stopping profiler:", error);
            return null;
        });
    }
    // Enqueue a timeout to prevent profiles from running over max duration.
    let maxDurationTimeoutID = (0, $d9NWo.WINDOW).setTimeout(()=>{
        if (0, $e2xQm.DEBUG_BUILD) (0, $7p8hL.logger).log("[Profiling] max profile duration elapsed, stopping profiling for:", (0, $4RP7L.spanToJSON)(transaction).description);
        // If the timeout exceeds, we want to stop profiling, but not finish the transaction
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onProfileHandler();
    }, (0, $4HiKl.MAX_PROFILE_DURATION_MS));
    // We need to reference the original end call to avoid creating an infinite loop
    const originalEnd = transaction.end.bind(transaction);
    /**
   * Wraps startTransaction and stopTransaction with profiling related logic.
   * startProfiling is called after the call to startTransaction in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
   */ function profilingWrappedTransactionEnd() {
        if (!transaction) return originalEnd();
        // onProfileHandler should always return the same profile even if this is called multiple times.
        // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
        onProfileHandler().then(()=>{
            // TODO: Can we rewrite this to use attributes?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setContext("profile", {
                profile_id: profileId,
                start_timestamp: startTimestamp
            });
            originalEnd();
        }, ()=>{
            // If onProfileHandler fails, we still want to call the original finish method.
            originalEnd();
        });
        return transaction;
    }
    transaction.end = profilingWrappedTransactionEnd;
    return transaction;
}

});
parcelRegister("4HiKl", function(module, exports) {

$parcel$export(module.exports, "isAutomatedPageLoadTransaction", function () { return $36b9b83f4326dbd8$export$7c501dd6adb8177c; });
$parcel$export(module.exports, "addProfilesToEnvelope", function () { return $36b9b83f4326dbd8$export$4df36760a75f76bc; });
$parcel$export(module.exports, "findProfiledTransactionsFromEnvelope", function () { return $36b9b83f4326dbd8$export$df9bb0fc214ff8cd; });
$parcel$export(module.exports, "MAX_PROFILE_DURATION_MS", function () { return $36b9b83f4326dbd8$export$8640c0b5c7d98a81; });
$parcel$export(module.exports, "startJSSelfProfile", function () { return $36b9b83f4326dbd8$export$9f4f648547a4284f; });
$parcel$export(module.exports, "shouldProfileTransaction", function () { return $36b9b83f4326dbd8$export$ea6683c0c72c1201; });
$parcel$export(module.exports, "createProfilingEvent", function () { return $36b9b83f4326dbd8$export$5c2c5e805edd874f; });
$parcel$export(module.exports, "getActiveProfilesCount", function () { return $36b9b83f4326dbd8$export$9d723f414195854a; });
$parcel$export(module.exports, "takeProfileFromGlobalCache", function () { return $36b9b83f4326dbd8$export$6285310796363de1; });
$parcel$export(module.exports, "addProfileToGlobalCache", function () { return $36b9b83f4326dbd8$export$7ddae68097f7e530; });

var $kNF8J = parcelRequire("kNF8J");
var $hcepo = parcelRequire("hcepo");

var $iGf0k = parcelRequire("iGf0k");
var $2pR2a = parcelRequire("2pR2a");
var $lNVQ9 = parcelRequire("lNVQ9");
var $7p8hL = parcelRequire("7p8hL");
var $iJH3x = parcelRequire("iJH3x");

var $e2xQm = parcelRequire("e2xQm");

var $d9NWo = parcelRequire("d9NWo");
/* eslint-disable max-lines */ const $36b9b83f4326dbd8$var$MS_TO_NS = 1e6;
// Use 0 as main thread id which is identical to threadId in node:worker_threads
// where main logs 0 and workers seem to log in increments of 1
const $36b9b83f4326dbd8$var$THREAD_ID_STRING = String(0);
const $36b9b83f4326dbd8$var$THREAD_NAME = "main";
// Machine properties (eval only once)
let $36b9b83f4326dbd8$var$OS_PLATFORM = "";
let $36b9b83f4326dbd8$var$OS_PLATFORM_VERSION = "";
let $36b9b83f4326dbd8$var$OS_ARCH = "";
let $36b9b83f4326dbd8$var$OS_BROWSER = (0, $d9NWo.WINDOW).navigator && (0, $d9NWo.WINDOW).navigator.userAgent || "";
let $36b9b83f4326dbd8$var$OS_MODEL = "";
const $36b9b83f4326dbd8$var$OS_LOCALE = (0, $d9NWo.WINDOW).navigator && (0, $d9NWo.WINDOW).navigator.language || (0, $d9NWo.WINDOW).navigator && (0, $d9NWo.WINDOW).navigator.languages && (0, $d9NWo.WINDOW).navigator.languages[0] || "";
function $36b9b83f4326dbd8$var$isUserAgentData(data) {
    return typeof data === "object" && data !== null && "getHighEntropyValues" in data;
}
// @ts-expect-error userAgentData is not part of the navigator interface yet
const $36b9b83f4326dbd8$var$userAgentData = (0, $d9NWo.WINDOW).navigator && (0, $d9NWo.WINDOW).navigator.userAgentData;
if ($36b9b83f4326dbd8$var$isUserAgentData($36b9b83f4326dbd8$var$userAgentData)) $36b9b83f4326dbd8$var$userAgentData.getHighEntropyValues([
    "architecture",
    "model",
    "platform",
    "platformVersion",
    "fullVersionList"
]).then((ua)=>{
    $36b9b83f4326dbd8$var$OS_PLATFORM = ua.platform || "";
    $36b9b83f4326dbd8$var$OS_ARCH = ua.architecture || "";
    $36b9b83f4326dbd8$var$OS_MODEL = ua.model || "";
    $36b9b83f4326dbd8$var$OS_PLATFORM_VERSION = ua.platformVersion || "";
    if (ua.fullVersionList && ua.fullVersionList.length > 0) {
        const firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        $36b9b83f4326dbd8$var$OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
    }
}).catch((e)=>void 0);
function $36b9b83f4326dbd8$var$isProcessedJSSelfProfile(profile) {
    return !("thread_metadata" in profile);
}
// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */ function $36b9b83f4326dbd8$export$7cbe6c4f12ea8325(profile) {
    if (!$36b9b83f4326dbd8$var$isProcessedJSSelfProfile(profile)) return profile;
    return $36b9b83f4326dbd8$export$f4122c775dfac1c2(profile);
}
// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.
function $36b9b83f4326dbd8$var$getTraceId(event) {
    const traceId = event && event.contexts && event.contexts["trace"] && event.contexts["trace"]["trace_id"];
    // Log a warning if the profile has an invalid traceId (should be uuidv4).
    // All profiles and transactions are rejected if this is the case and we want to
    // warn users that this is happening if they enable debug flag
    if (typeof traceId === "string" && traceId.length !== 32) {
        if (0, $e2xQm.DEBUG_BUILD) (0, $7p8hL.logger).log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
    }
    if (typeof traceId !== "string") return "";
    return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */ /**
 * Creates a profiling event envelope from a Sentry event.
 */ function $36b9b83f4326dbd8$export$5c9f6e262288b7db(profile_id, start_timestamp, processed_profile, event) {
    if (event.type !== "transaction") // createProfilingEventEnvelope should only be called for transactions,
    // we type guard this behavior with isProfiledTransactionEvent.
    throw new TypeError("Profiling events may only be attached to transactions, this should never occur.");
    if (processed_profile === undefined || processed_profile === null) throw new TypeError(`Cannot construct profiling event envelope without a valid profile. Got ${processed_profile} instead.`);
    const traceId = $36b9b83f4326dbd8$var$getTraceId(event);
    const enrichedThreadProfile = $36b9b83f4326dbd8$export$7cbe6c4f12ea8325(processed_profile);
    const transactionStartMs = start_timestamp ? start_timestamp : typeof event.start_timestamp === "number" ? event.start_timestamp * 1000 : Date.now();
    const transactionEndMs = typeof event.timestamp === "number" ? event.timestamp * 1000 : Date.now();
    const profile = {
        event_id: profile_id,
        timestamp: new Date(transactionStartMs).toISOString(),
        platform: "javascript",
        version: "1",
        release: event.release || "",
        environment: event.environment || (0, $kNF8J.DEFAULT_ENVIRONMENT),
        runtime: {
            name: "javascript",
            version: (0, $d9NWo.WINDOW).navigator.userAgent
        },
        os: {
            name: $36b9b83f4326dbd8$var$OS_PLATFORM,
            version: $36b9b83f4326dbd8$var$OS_PLATFORM_VERSION,
            build_number: $36b9b83f4326dbd8$var$OS_BROWSER
        },
        device: {
            locale: $36b9b83f4326dbd8$var$OS_LOCALE,
            model: $36b9b83f4326dbd8$var$OS_MODEL,
            manufacturer: $36b9b83f4326dbd8$var$OS_BROWSER,
            architecture: $36b9b83f4326dbd8$var$OS_ARCH,
            is_emulator: false
        },
        debug_meta: {
            images: $36b9b83f4326dbd8$export$4c0b0d8ee0d018b5(processed_profile.resources)
        },
        profile: enrichedThreadProfile,
        transactions: [
            {
                name: event.transaction || "",
                id: event.event_id || (0, $iJH3x.uuid4)(),
                trace_id: traceId,
                active_thread_id: $36b9b83f4326dbd8$var$THREAD_ID_STRING,
                relative_start_ns: "0",
                relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0)
            }
        ]
    };
    return profile;
}
/*
  See packages/tracing-internal/src/browser/router.ts
*/ /**
 *
 */ function $36b9b83f4326dbd8$export$7c501dd6adb8177c(transaction) {
    return transaction.op === "pageload";
}
/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */ function $36b9b83f4326dbd8$export$f4122c775dfac1c2(input) {
    let EMPTY_STACK_ID = undefined;
    let STACK_ID = 0;
    // Initialize the profile that we will fill with data
    const profile = {
        samples: [],
        stacks: [],
        frames: [],
        thread_metadata: {
            [$36b9b83f4326dbd8$var$THREAD_ID_STRING]: {
                name: $36b9b83f4326dbd8$var$THREAD_NAME
            }
        }
    };
    if (!input.samples.length) return profile;
    // We assert samples.length > 0 above and timestamp should always be present
    const start = input.samples[0].timestamp;
    // The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
    // when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
    // Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
    // the drift between the SDK selected value and our profile time origin.
    const origin = typeof performance.timeOrigin === "number" ? performance.timeOrigin : (0, $iGf0k.browserPerformanceTimeOrigin) || 0;
    const adjustForOriginChange = origin - ((0, $iGf0k.browserPerformanceTimeOrigin) || origin);
    for(let i = 0; i < input.samples.length; i++){
        const jsSample = input.samples[i];
        // If sample has no stack, add an empty sample
        if (jsSample.stackId === undefined) {
            if (EMPTY_STACK_ID === undefined) {
                EMPTY_STACK_ID = STACK_ID;
                profile.stacks[EMPTY_STACK_ID] = [];
                STACK_ID++;
            }
            profile["samples"][i] = {
                // convert ms timestamp to ns
                elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $36b9b83f4326dbd8$var$MS_TO_NS).toFixed(0),
                stack_id: EMPTY_STACK_ID,
                thread_id: $36b9b83f4326dbd8$var$THREAD_ID_STRING
            };
            continue;
        }
        let stackTop = input.stacks[jsSample.stackId];
        // Functions in top->down order (root is last)
        // We follow the stackTop.parentId trail and collect each visited frameId
        const stack = [];
        while(stackTop){
            stack.push(stackTop.frameId);
            const frame = input.frames[stackTop.frameId];
            // If our frame has not been indexed yet, index it
            if (profile.frames[stackTop.frameId] === undefined) profile.frames[stackTop.frameId] = {
                function: frame.name,
                abs_path: typeof frame.resourceId === "number" ? input.resources[frame.resourceId] : undefined,
                lineno: frame.line,
                colno: frame.column
            };
            stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
        }
        const sample = {
            // convert ms timestamp to ns
            elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $36b9b83f4326dbd8$var$MS_TO_NS).toFixed(0),
            stack_id: STACK_ID,
            thread_id: $36b9b83f4326dbd8$var$THREAD_ID_STRING
        };
        profile["stacks"][STACK_ID] = stack;
        profile["samples"][i] = sample;
        STACK_ID++;
    }
    return profile;
}
/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */ function $36b9b83f4326dbd8$export$4df36760a75f76bc(envelope, profiles) {
    if (!profiles.length) return envelope;
    for (const profile of profiles)envelope[1].push([
        {
            type: "profile"
        },
        profile
    ]);
    return envelope;
}
/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */ function $36b9b83f4326dbd8$export$df9bb0fc214ff8cd(envelope) {
    const events = [];
    (0, $2pR2a.forEachEnvelopeItem)(envelope, (item, type)=>{
        if (type !== "transaction") return;
        for(let j = 1; j < item.length; j++){
            const event = item[j];
            if (event && event.contexts && event.contexts["profile"] && event.contexts["profile"]["profile_id"]) events.push(item[j]);
        }
    });
    return events;
}
const $36b9b83f4326dbd8$var$debugIdStackParserCache = new WeakMap();
/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */ function $36b9b83f4326dbd8$export$4c0b0d8ee0d018b5(resource_paths) {
    const debugIdMap = (0, $lNVQ9.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return [];
    const client = (0, $hcepo.getClient)();
    const options = client && client.getOptions();
    const stackParser = options && options.stackParser;
    if (!stackParser) return [];
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $36b9b83f4326dbd8$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $36b9b83f4326dbd8$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            const file = stackFrame && stackFrame.filename;
            if (stackFrame && file) {
                acc[file] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: "sourcemap",
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $36b9b83f4326dbd8$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if (typeof rate !== "number" && typeof rate !== "boolean" || typeof rate === "number" && isNaN(rate)) {
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // Boolean sample rates are always valid
    if (rate === true || rate === false) return true;
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
function $36b9b83f4326dbd8$var$isValidProfile(profile) {
    if (profile.samples.length < 2) {
        if (0, $e2xQm.DEBUG_BUILD) // Log a warning if the profile has less than 2 samples so users can know why
        // they are not seeing any profiling data and we cant avoid the back and forth
        // of asking them to provide us with a dump of the profile data.
        (0, $7p8hL.logger).log("[Profiling] Discarding profile because it contains less than 2 samples");
        return false;
    }
    if (!profile.frames.length) {
        if (0, $e2xQm.DEBUG_BUILD) (0, $7p8hL.logger).log("[Profiling] Discarding profile because it contains no frames");
        return false;
    }
    return true;
}
// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
let $36b9b83f4326dbd8$var$PROFILING_CONSTRUCTOR_FAILED = false;
const $36b9b83f4326dbd8$export$8640c0b5c7d98a81 = 30000;
/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */ function $36b9b83f4326dbd8$var$isJSProfilerSupported(maybeProfiler) {
    return typeof maybeProfiler === "function";
}
/**
 * Starts the profiler and returns the profiler instance.
 */ function $36b9b83f4326dbd8$export$9f4f648547a4284f() {
    // Feature support check first
    const JSProfilerConstructor = (0, $d9NWo.WINDOW).Profiler;
    if (!$36b9b83f4326dbd8$var$isJSProfilerSupported(JSProfilerConstructor)) {
        if (0, $e2xQm.DEBUG_BUILD) (0, $7p8hL.logger).log("[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.");
        return;
    }
    // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
    const samplingIntervalMS = 10;
    // Start the profiler
    const maxSamples = Math.floor($36b9b83f4326dbd8$export$8640c0b5c7d98a81 / samplingIntervalMS);
    // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
    // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
    // as we risk breaking the user's application, so just disable profiling and log an error.
    try {
        return new JSProfilerConstructor({
            sampleInterval: samplingIntervalMS,
            maxBufferSize: maxSamples
        });
    } catch (e) {
        if (0, $e2xQm.DEBUG_BUILD) {
            (0, $7p8hL.logger).log("[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.");
            (0, $7p8hL.logger).log("[Profiling] Disabling profiling for current user session.");
        }
        $36b9b83f4326dbd8$var$PROFILING_CONSTRUCTOR_FAILED = true;
    }
    return;
}
/**
 * Determine if a profile should be profiled.
 */ function $36b9b83f4326dbd8$export$ea6683c0c72c1201(transaction) {
    // If constructor failed once, it will always fail, so we can early return.
    if ($36b9b83f4326dbd8$var$PROFILING_CONSTRUCTOR_FAILED) {
        if (0, $e2xQm.DEBUG_BUILD) (0, $7p8hL.logger).log("[Profiling] Profiling has been disabled for the duration of the current user session.");
        return false;
    }
    if (!transaction.isRecording()) {
        if (0, $e2xQm.DEBUG_BUILD) (0, $7p8hL.logger).log("[Profiling] Discarding profile because transaction was not sampled.");
        return false;
    }
    const client = (0, $hcepo.getClient)();
    const options = client && client.getOptions();
    if (!options) {
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Profiling] Profiling disabled, no options found.");
        return false;
    }
    // @ts-expect-error profilesSampleRate is not part of the browser options yet
    const profilesSampleRate = options.profilesSampleRate;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$36b9b83f4326dbd8$export$2603c8d332a51c42(profilesSampleRate)) {
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).warn("[Profiling] Discarding profile because of invalid sample rate.");
        return false;
    }
    // if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
    if (!profilesSampleRate) {
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0");
        return false;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
    // Check if we should sample this profile
    if (!sampled) {
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(profilesSampleRate)})`);
        return false;
    }
    return true;
}
/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */ function $36b9b83f4326dbd8$export$5c2c5e805edd874f(profile_id, start_timestamp, profile, event) {
    if (!$36b9b83f4326dbd8$var$isValidProfile(profile)) return null;
    return $36b9b83f4326dbd8$export$5c9f6e262288b7db(profile_id, start_timestamp, profile, event);
}
// TODO (v8): We need to obtain profile ids in @sentry-internal/tracing,
// but we don't have access to this map because importing this map would
// cause a circular dependancy. We need to resolve this in v8.
const $36b9b83f4326dbd8$var$PROFILE_MAP = new Map();
/**
 *
 */ function $36b9b83f4326dbd8$export$9d723f414195854a() {
    return $36b9b83f4326dbd8$var$PROFILE_MAP.size;
}
/**
 * Retrieves profile from global cache and removes it.
 */ function $36b9b83f4326dbd8$export$6285310796363de1(profile_id) {
    const profile = $36b9b83f4326dbd8$var$PROFILE_MAP.get(profile_id);
    if (profile) $36b9b83f4326dbd8$var$PROFILE_MAP.delete(profile_id);
    return profile;
}
/**
 * Adds profile to global cache and evicts the oldest profile if the cache is full.
 */ function $36b9b83f4326dbd8$export$7ddae68097f7e530(profile_id, profile) {
    $36b9b83f4326dbd8$var$PROFILE_MAP.set(profile_id, profile);
    if ($36b9b83f4326dbd8$var$PROFILE_MAP.size > 30) {
        const last = $36b9b83f4326dbd8$var$PROFILE_MAP.keys().next().value;
        $36b9b83f4326dbd8$var$PROFILE_MAP.delete(last);
    }
}

});


parcelRegister("6qNgj", function(module, exports) {

$parcel$export(module.exports, "browserProfilingIntegration", function () { return $4aeb6230dc5cc7e0$export$2c7b5d6dd5622f23; });
$parcel$export(module.exports, "BrowserProfilingIntegration", function () { return $4aeb6230dc5cc7e0$export$b0fe88803ed435e0; });

var $genhe = parcelRequire("genhe");
var $hcepo = parcelRequire("hcepo");

var $7p8hL = parcelRequire("7p8hL");

var $e2xQm = parcelRequire("e2xQm");

var $33qkX = parcelRequire("33qkX");

var $4HiKl = parcelRequire("4HiKl");
const $4aeb6230dc5cc7e0$var$INTEGRATION_NAME = "BrowserProfiling";
const $4aeb6230dc5cc7e0$var$_browserProfilingIntegration = ()=>{
    return {
        name: $4aeb6230dc5cc7e0$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            const scope = (0, $hcepo.getCurrentScope)();
            // eslint-disable-next-line deprecation/deprecation
            const transaction = scope.getTransaction();
            if (transaction && (0, $4HiKl.isAutomatedPageLoadTransaction)(transaction)) {
                if ((0, $4HiKl.shouldProfileTransaction)(transaction)) (0, $33qkX.startProfileForTransaction)(transaction);
            }
            if (typeof client.on !== "function") {
                (0, $7p8hL.logger).warn("[Profiling] Client does not support hooks, profiling will be disabled");
                return;
            }
            client.on("startTransaction", (transaction)=>{
                if ((0, $4HiKl.shouldProfileTransaction)(transaction)) (0, $33qkX.startProfileForTransaction)(transaction);
            });
            client.on("beforeEnvelope", (envelope)=>{
                // if not profiles are in queue, there is nothing to add to the envelope.
                if (!(0, $4HiKl.getActiveProfilesCount)()) return;
                const profiledTransactionEvents = (0, $4HiKl.findProfiledTransactionsFromEnvelope)(envelope);
                if (!profiledTransactionEvents.length) return;
                const profilesToAddToEnvelope = [];
                for (const profiledTransaction of profiledTransactionEvents){
                    const context = profiledTransaction && profiledTransaction.contexts;
                    const profile_id = context && context["profile"] && context["profile"]["profile_id"];
                    const start_timestamp = context && context["profile"] && context["profile"]["start_timestamp"];
                    if (typeof profile_id !== "string") {
                        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Profiling] cannot find profile for a transaction without a profile context");
                        continue;
                    }
                    if (!profile_id) {
                        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).log("[Profiling] cannot find profile for a transaction without a profile context");
                        continue;
                    }
                    // Remove the profile from the transaction context before sending, relay will take care of the rest.
                    if (context && context["profile"]) delete context.profile;
                    const profile = (0, $4HiKl.takeProfileFromGlobalCache)(profile_id);
                    if (!profile) {
                        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Profiling] Could not retrieve profile for transaction: ${profile_id}`);
                        continue;
                    }
                    const profileEvent = (0, $4HiKl.createProfilingEvent)(profile_id, start_timestamp, profile, profiledTransaction);
                    if (profileEvent) profilesToAddToEnvelope.push(profileEvent);
                }
                (0, $4HiKl.addProfilesToEnvelope)(envelope, profilesToAddToEnvelope);
            });
        }
    };
};
const $4aeb6230dc5cc7e0$export$2c7b5d6dd5622f23 = (0, $genhe.defineIntegration)($4aeb6230dc5cc7e0$var$_browserProfilingIntegration);
/**
 * Browser profiling integration. Stores any event that has contexts["profile"]["profile_id"]
 * This exists because we do not want to await async profiler.stop calls as transaction.finish is called
 * in a synchronous context. Instead, we handle sending the profile async from the promise callback and
 * rely on being able to pull the event from the cache when we need to construct the envelope. This makes the
 * integration less reliable as we might be dropping profiles when the cache is full.
 *
 * @experimental
 * @deprecated Use `browserProfilingIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $4aeb6230dc5cc7e0$export$b0fe88803ed435e0 = (0, $genhe.convertIntegrationFnToClass)($4aeb6230dc5cc7e0$var$INTEGRATION_NAME, $4aeb6230dc5cc7e0$export$2c7b5d6dd5622f23);

});


parcelRegister("cwhMb", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $91d6432db26b3568$export$2cd8252107eb640b; });

var $cet0p = parcelRequire("cet0p");

var $5M0hM = parcelRequire("5M0hM");
/**
 * Inits the React SDK
 */ function $91d6432db26b3568$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $5M0hM.applySdkMetadata)(opts, "react");
    (0, $cet0p.init)(opts);
}

});

parcelRegister("bycal", function(module, exports) {

$parcel$export(module.exports, "Profiler", function () { return $868c4e92682aa542$export$e2c29f18771995cb; });
$parcel$export(module.exports, "withProfiler", function () { return $868c4e92682aa542$export$e1e354213dd1a8a7; });
$parcel$export(module.exports, "useProfiler", function () { return $868c4e92682aa542$export$972a52cbfaf8cf13; });

var $mtWu0 = parcelRequire("mtWu0");

var $4RP7L = parcelRequire("4RP7L");
var $hcepo = parcelRequire("hcepo");

var $iGf0k = parcelRequire("iGf0k");

var $adG4d = parcelRequire("adG4d");

var $bh6RR = parcelRequire("bh6RR");

var $bLoTQ = parcelRequire("bLoTQ");
const $868c4e92682aa542$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/profiler.tsx";
const $868c4e92682aa542$export$6ef4c0367e27f2d5 = "unknown";
/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */ class $868c4e92682aa542$export$e2c29f18771995cb extends $bh6RR.Component {
    /**
   * The span of the mount activity
   * Made protected for the React Native SDK to access
   */ /**
   * The span that represents the duration of time between shouldComponentUpdate and componentDidUpdate
   */ // eslint-disable-next-line @typescript-eslint/member-ordering
    static __initStatic() {
        this.defaultProps = {
            disabled: false,
            includeRender: true,
            includeUpdates: true
        };
    }
    constructor(props){
        super(props);
        const { name: name, disabled: disabled = false } = this.props;
        if (disabled) return;
        this._mountSpan = (0, $mtWu0.startInactiveSpan)({
            name: `<${name}>`,
            onlyIfParent: true,
            op: (0, $bLoTQ.REACT_MOUNT_OP),
            origin: "auto.ui.react.profiler",
            attributes: {
                "ui.component_name": name
            }
        });
    }
    // If a component mounted, we can finish the mount activity.
    componentDidMount() {
        if (this._mountSpan) this._mountSpan.end();
    }
    shouldComponentUpdate({ updateProps: updateProps, includeUpdates: includeUpdates = true }) {
        // Only generate an update span if includeUpdates is true, if there is a valid mountSpan,
        // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
        // We are just trying to give baseline clues for further investigation.
        if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
            // See what props haved changed between the previous props, and the current props. This is
            // set as data on the span. We just store the prop keys as the values could be potenially very large.
            const changedProps = Object.keys(updateProps).filter((k)=>updateProps[k] !== this.props.updateProps[k]);
            if (changedProps.length > 0) {
                const now = (0, $iGf0k.timestampInSeconds)();
                this._updateSpan = (0, $hcepo.withActiveSpan)(this._mountSpan, ()=>{
                    return (0, $mtWu0.startInactiveSpan)({
                        name: `<${this.props.name}>`,
                        onlyIfParent: true,
                        op: (0, $bLoTQ.REACT_UPDATE_OP),
                        origin: "auto.ui.react.profiler",
                        startTimestamp: now,
                        attributes: {
                            "ui.component_name": this.props.name,
                            "ui.react.changed_props": changedProps
                        }
                    });
                });
            }
        }
        return true;
    }
    componentDidUpdate() {
        if (this._updateSpan) {
            this._updateSpan.end();
            this._updateSpan = undefined;
        }
    }
    // If a component is unmounted, we can say it is no longer on the screen.
    // This means we can finish the span representing the component render.
    componentWillUnmount() {
        const endTimestamp = (0, $iGf0k.timestampInSeconds)();
        const { name: name, includeRender: includeRender = true } = this.props;
        if (this._mountSpan && includeRender) {
            const startTimestamp = (0, $4RP7L.spanToJSON)(this._mountSpan).timestamp;
            (0, $hcepo.withActiveSpan)(this._mountSpan, ()=>{
                const renderSpan = (0, $mtWu0.startInactiveSpan)({
                    onlyIfParent: true,
                    name: `<${name}>`,
                    op: (0, $bLoTQ.REACT_RENDER_OP),
                    origin: "auto.ui.react.profiler",
                    startTimestamp: startTimestamp,
                    attributes: {
                        "ui.component_name": name
                    }
                });
                if (renderSpan) // Have to cast to Span because the type of _mountSpan is Span | undefined
                // and not getting narrowed properly
                renderSpan.end(endTimestamp);
            });
        }
    }
    render() {
        return this.props.children;
    }
}
$868c4e92682aa542$export$e2c29f18771995cb.__initStatic();
/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $868c4e92682aa542$export$e1e354213dd1a8a7(WrappedComponent, // We do not want to have `updateProps` given in options, it is instead filled through the HOC.
options) {
    const componentDisplayName = options && options.name || WrappedComponent.displayName || WrappedComponent.name || $868c4e92682aa542$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$bh6RR.createElement($868c4e92682aa542$export$e2c29f18771995cb, {
            ...options,
            name: componentDisplayName,
            updateProps: props,
            __self: this,
            __source: {
                fileName: $868c4e92682aa542$var$_jsxFileName,
                lineNumber: 159
            }
        }, $bh6RR.createElement(WrappedComponent, {
            ...props,
            __self: this,
            __source: {
                fileName: $868c4e92682aa542$var$_jsxFileName,
                lineNumber: 160
            }
        }));
    Wrapped.displayName = `profiler(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(Wrapped, WrappedComponent);
    return Wrapped;
}
/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */ function $868c4e92682aa542$export$972a52cbfaf8cf13(name, options = {
    disabled: false,
    hasRenderSpan: true
}) {
    const [mountSpan] = $bh6RR.useState(()=>{
        if (options && options.disabled) return undefined;
        return (0, $mtWu0.startInactiveSpan)({
            name: `<${name}>`,
            onlyIfParent: true,
            op: (0, $bLoTQ.REACT_MOUNT_OP),
            origin: "auto.ui.react.profiler",
            attributes: {
                "ui.component_name": name
            }
        });
    });
    $bh6RR.useEffect(()=>{
        if (mountSpan) mountSpan.end();
        return ()=>{
            if (mountSpan && options.hasRenderSpan) {
                const startTimestamp = (0, $4RP7L.spanToJSON)(mountSpan).timestamp;
                const endTimestamp = (0, $iGf0k.timestampInSeconds)();
                const renderSpan = (0, $mtWu0.startInactiveSpan)({
                    name: `<${name}>`,
                    onlyIfParent: true,
                    op: (0, $bLoTQ.REACT_RENDER_OP),
                    origin: "auto.ui.react.profiler",
                    startTimestamp: startTimestamp,
                    attributes: {
                        "ui.component_name": name
                    }
                });
                if (renderSpan) // Have to cast to Span because the type of _mountSpan is Span | undefined
                // and not getting narrowed properly
                renderSpan.end(endTimestamp);
            }
        };
    // We only want this to run once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});
parcelRegister("bLoTQ", function(module, exports) {

$parcel$export(module.exports, "REACT_RENDER_OP", function () { return $890766121bae511b$export$a5a94ea2f791dca1; });
$parcel$export(module.exports, "REACT_UPDATE_OP", function () { return $890766121bae511b$export$ee0f1075b9437852; });
$parcel$export(module.exports, "REACT_MOUNT_OP", function () { return $890766121bae511b$export$2c5aa1bf688e9ea1; });
const $890766121bae511b$export$a5a94ea2f791dca1 = "ui.react.render";
const $890766121bae511b$export$ee0f1075b9437852 = "ui.react.update";
const $890766121bae511b$export$2c5aa1bf688e9ea1 = "ui.react.mount";

});


parcelRegister("d1YDb", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", function () { return $97ca6663ae0d4dab$export$e926676385687eaf; });
$parcel$export(module.exports, "withErrorBoundary", function () { return $97ca6663ae0d4dab$export$f0c7a449e0cfaec7; });

var $hcepo = parcelRequire("hcepo");
var $cet0p = parcelRequire("cet0p");

var $jPeZ4 = parcelRequire("jPeZ4");
var $7p8hL = parcelRequire("7p8hL");

var $adG4d = parcelRequire("adG4d");

var $bh6RR = parcelRequire("bh6RR");

var $3Cr5Z = parcelRequire("3Cr5Z");
const $97ca6663ae0d4dab$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";
function $97ca6663ae0d4dab$export$a87138b73900f5b(version) {
    const major = version.match(/^([^.]+)/);
    return major !== null && parseInt(major[0]) >= 17;
}
const $97ca6663ae0d4dab$export$6ef4c0367e27f2d5 = "unknown";
const $97ca6663ae0d4dab$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
function $97ca6663ae0d4dab$var$setCause(error, cause) {
    const seenErrors = new WeakMap();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.set(error, true);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $97ca6663ae0d4dab$export$e926676385687eaf extends $bh6RR.Component {
    constructor(props){
        super(props);
        $97ca6663ae0d4dab$export$e926676385687eaf.prototype.__init.call(this);
        this.state = $97ca6663ae0d4dab$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $hcepo.getClient)();
        if (client && client.on && props.showDialog) {
            this._openFallbackReportDialog = false;
            client.on("afterSendEvent", (event)=>{
                if (!event.type && event.event_id === this._lastEventId) // eslint-disable-next-line deprecation/deprecation
                (0, $cet0p.showReportDialog)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, { componentStack: componentStack }) {
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $hcepo.withScope)((scope)=>{
            // If on React version >= 17, create stack trace from componentStack param and links
            // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
            // Linking errors requires the `LinkedErrors` integration be enabled.
            // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
            //
            // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
            // with non-error objects. This is why we need to check if the error is an error-like object.
            // See: https://github.com/getsentry/sentry-javascript/issues/6167
            if ($97ca6663ae0d4dab$export$a87138b73900f5b($bh6RR.version) && (0, $jPeZ4.isError)(error)) {
                const errorBoundaryError = new Error(error.message);
                errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
                errorBoundaryError.stack = componentStack;
                // Using the `LinkedErrors` integration to link the errors together.
                $97ca6663ae0d4dab$var$setCause(error, errorBoundaryError);
            }
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const eventId = (0, $hcepo.captureException)(error, {
                captureContext: {
                    contexts: {
                        react: {
                            componentStack: componentStack
                        }
                    }
                },
                mechanism: {
                    handled: false
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $cet0p.showReportDialog)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount(error, componentStack, eventId);
    }
    __init() {
        this.resetErrorBoundary = ()=>{
            const { onReset: onReset } = this.props;
            const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
            if (onReset) onReset(error, componentStack, eventId);
            this.setState($97ca6663ae0d4dab$var$INITIAL_STATE);
        };
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        if (state.error) {
            let element = undefined;
            if (typeof fallback === "function") element = fallback({
                error: state.error,
                componentStack: state.componentStack,
                resetError: this.resetErrorBoundary,
                eventId: state.eventId
            });
            else element = fallback;
            if ($bh6RR.isValidElement(element)) return element;
            if (fallback) (0, $3Cr5Z.DEBUG_BUILD) && (0, $7p8hL.logger).warn("fallback did not produce a valid ReactElement");
            // Fail gracefully if no fallback provided or is not valid
            return null;
        }
        if (typeof children === "function") return children();
        return children;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $97ca6663ae0d4dab$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $97ca6663ae0d4dab$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$bh6RR.createElement($97ca6663ae0d4dab$export$e926676385687eaf, {
            ...errorBoundaryOptions,
            __self: this,
            __source: {
                fileName: $97ca6663ae0d4dab$var$_jsxFileName,
                lineNumber: 238
            }
        }, $bh6RR.createElement(WrappedComponent, {
            ...props,
            __self: this,
            __source: {
                fileName: $97ca6663ae0d4dab$var$_jsxFileName,
                lineNumber: 239
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(Wrapped, WrappedComponent);
    return Wrapped;
}

});
parcelRegister("3Cr5Z", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $2a29f059a9562ebf$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $2a29f059a9562ebf$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});


parcelRegister("4wVlt", function(module, exports) {

$parcel$export(module.exports, "createReduxEnhancer", function () { return $34c6a231efd83f85$export$c4506dd2040faa8a; });

var $hcepo = parcelRequire("hcepo");
var $2W3Nl = parcelRequire("2W3Nl");

var $aajbp = parcelRequire("aajbp");
/* eslint-disable @typescript-eslint/no-explicit-any */ const $34c6a231efd83f85$var$ACTION_BREADCRUMB_CATEGORY = "redux.action";
const $34c6a231efd83f85$var$ACTION_BREADCRUMB_TYPE = "info";
const $34c6a231efd83f85$var$defaultOptions = {
    attachReduxState: true,
    actionTransformer: (action)=>action,
    stateTransformer: (state)=>state || null
};
/**
 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
 *
 * @param enhancerOptions Options to pass to the enhancer
 */ function $34c6a231efd83f85$export$c4506dd2040faa8a(enhancerOptions) {
    // Note: We return an any type as to not have type conflicts.
    const options = {
        ...$34c6a231efd83f85$var$defaultOptions,
        ...enhancerOptions
    };
    return (next)=>(reducer, initialState)=>{
            options.attachReduxState && (0, $2W3Nl.getGlobalScope)().addEventProcessor((event, hint)=>{
                try {
                    // @ts-expect-error try catch to reduce bundle size
                    if (event.type === undefined && event.contexts.state.state.type === "redux") hint.attachments = [
                        ...hint.attachments || [],
                        // @ts-expect-error try catch to reduce bundle size
                        {
                            filename: "redux_state.json",
                            data: JSON.stringify(event.contexts.state.state.value)
                        }
                    ];
                } catch (_) {
                // empty
                }
                return event;
            });
            const sentryReducer = (state, action)=>{
                const newState = reducer(state, action);
                const scope = (0, $hcepo.getCurrentScope)();
                /* Action breadcrumbs */ const transformedAction = options.actionTransformer(action);
                if (typeof transformedAction !== "undefined" && transformedAction !== null) scope.addBreadcrumb({
                    category: $34c6a231efd83f85$var$ACTION_BREADCRUMB_CATEGORY,
                    data: transformedAction,
                    type: $34c6a231efd83f85$var$ACTION_BREADCRUMB_TYPE
                });
                /* Set latest state to scope */ const transformedState = options.stateTransformer(newState);
                if (typeof transformedState !== "undefined" && transformedState !== null) {
                    const client = (0, $hcepo.getClient)();
                    const options = client && client.getOptions();
                    const normalizationDepth = options && options.normalizeDepth || 3; // default state normalization depth to 3
                    // Set the normalization depth of the redux state to the configured `normalizeDepth` option or a sane number as a fallback
                    const newStateContext = {
                        state: {
                            type: "redux",
                            value: transformedState
                        }
                    };
                    (0, $aajbp.addNonEnumerableProperty)(newStateContext, "__sentry_override_normalization_depth__", 3 + // 3 layers for `state.value.transformedState`
                    normalizationDepth);
                    scope.setContext("state", newStateContext);
                } else scope.setContext("state", null);
                /* Allow user to configure scope with latest state */ const { configureScopeWithState: configureScopeWithState } = options;
                if (typeof configureScopeWithState === "function") configureScopeWithState(scope, newState);
                return newState;
            };
            return next(sentryReducer, initialState);
        };
}

});

parcelRegister("hPR7J", function(module, exports) {

$parcel$export(module.exports, "reactRouterV3BrowserTracingIntegration", function () { return $cfc0685ed3d5238c$export$8a5d05e8905d7257; });
$parcel$export(module.exports, "reactRouterV3Instrumentation", function () { return $cfc0685ed3d5238c$export$c7361565e4036030; });

var $cd71e = parcelRequire("cd71e");parcelRequire("9M4YH");
var $d9NWo = parcelRequire("d9NWo");

var $kuS4l = parcelRequire("kuS4l");
// Many of the types below had to be mocked out to prevent typescript issues
// these types are required for correct functionality.
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function $cfc0685ed3d5238c$export$8a5d05e8905d7257(options) {
    const integration = (0, $cd71e.browserTracingIntegration)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { history: history, routes: routes, match: match, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startPageloadCallback = (startSpanOptions)=>{
                (0, $cd71e.startBrowserTracingPageLoadSpan)(client, startSpanOptions);
                return undefined;
            };
            const startNavigationCallback = (startSpanOptions)=>{
                (0, $cd71e.startBrowserTracingNavigationSpan)(client, startSpanOptions);
                return undefined;
            };
            // eslint-disable-next-line deprecation/deprecation
            const instrumentation = $cfc0685ed3d5238c$export$c7361565e4036030(history, routes, match);
            // Now instrument page load & navigation with correct settings
            instrumentation(startPageloadCallback, instrumentPageLoad, false);
            instrumentation(startNavigationCallback, false, instrumentNavigation);
        }
    };
}
/**
 * Creates routing instrumentation for React Router v3
 * Works for React Router >= 3.2.0 and < 4.0.0
 *
 * @param history object from the `history` library
 * @param routes a list of all routes, should be
 * @param match `Router.match` utility
 *
 * @deprecated Use `reactRouterV3BrowserTracingIntegration()` instead
 */ function $cfc0685ed3d5238c$export$c7361565e4036030(history, routes, match) {
    return (startTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        let activeTransaction;
        let prevName;
        // Have to use window.location because history.location might not be defined.
        if (startTransactionOnPageLoad && (0, $d9NWo.WINDOW) && (0, $d9NWo.WINDOW).location) $cfc0685ed3d5238c$var$normalizeTransactionName(routes, (0, $d9NWo.WINDOW).location, match, (localName, source = "url")=>{
            prevName = localName;
            activeTransaction = startTransaction({
                name: prevName,
                attributes: {
                    [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "pageload",
                    [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.react.reactrouter_v3",
                    [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: source
                }
            });
        });
        if (startTransactionOnLocationChange && history.listen) history.listen((location)=>{
            if (location.action === "PUSH" || location.action === "POP") {
                if (activeTransaction) activeTransaction.end();
                $cfc0685ed3d5238c$var$normalizeTransactionName(routes, location, match, (localName, source = "url")=>{
                    prevName = localName;
                    const attributes = {
                        [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "navigation",
                        [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.react.reactrouter_v3",
                        [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: source
                    };
                    activeTransaction = startTransaction({
                        name: prevName,
                        attributes: attributes
                    });
                });
            }
        });
    };
}
/**
 * Normalize transaction names using `Router.match`
 */ function $cfc0685ed3d5238c$var$normalizeTransactionName(appRoutes, location, match, callback) {
    let name = location.pathname;
    match({
        location: location,
        routes: appRoutes
    }, (error, _redirectLocation, renderProps)=>{
        if (error || !renderProps) return callback(name);
        const routePath = $cfc0685ed3d5238c$var$getRouteStringFromRoutes(renderProps.routes || []);
        if (routePath.length === 0 || routePath === "/*") return callback(name);
        name = routePath;
        return callback(name, "route");
    });
}
/**
 * Generate route name from array of routes
 */ function $cfc0685ed3d5238c$var$getRouteStringFromRoutes(routes) {
    if (!Array.isArray(routes) || routes.length === 0) return "";
    const routesWithPaths = routes.filter((route)=>!!route.path);
    let index = -1;
    for(let x = routesWithPaths.length - 1; x >= 0; x--){
        const route = routesWithPaths[x];
        if (route.path && route.path.startsWith("/")) {
            index = x;
            break;
        }
    }
    return routesWithPaths.slice(index).filter(({ path: path })=>!!path).map(({ path: path })=>path).join("");
}

});

parcelRegister("iYjt0", function(module, exports) {

$parcel$export(module.exports, "reactRouterV4BrowserTracingIntegration", function () { return $dcfcee4e55f84f8e$export$474cac1fc5ec6ff8; });
$parcel$export(module.exports, "reactRouterV4Instrumentation", function () { return $dcfcee4e55f84f8e$export$6e634b456f232d5f; });
$parcel$export(module.exports, "reactRouterV5BrowserTracingIntegration", function () { return $dcfcee4e55f84f8e$export$1c913d0c067ca14f; });
$parcel$export(module.exports, "reactRouterV5Instrumentation", function () { return $dcfcee4e55f84f8e$export$2adda1b223c9dfaa; });
$parcel$export(module.exports, "withSentryRouting", function () { return $dcfcee4e55f84f8e$export$51a414dfd89dd222; });

var $cd71e = parcelRequire("cd71e");parcelRequire("9M4YH");
var $d9NWo = parcelRequire("d9NWo");

var $mtWu0 = parcelRequire("mtWu0");
var $7oVpT = parcelRequire("7oVpT");
var $kuS4l = parcelRequire("kuS4l");
var $4RP7L = parcelRequire("4RP7L");

var $adG4d = parcelRequire("adG4d");

var $bh6RR = parcelRequire("bh6RR");
const $dcfcee4e55f84f8e$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouter.tsx";
// We need to disable eslint no-explict-any because any is required for the
// react-router typings.
let $dcfcee4e55f84f8e$var$activeTransaction;
/**
 * A browser tracing integration that uses React Router v4 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function $dcfcee4e55f84f8e$export$474cac1fc5ec6ff8(options) {
    const integration = (0, $cd71e.browserTracingIntegration)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { history: history, routes: routes, matchPath: matchPath, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startPageloadCallback = (startSpanOptions)=>{
                (0, $cd71e.startBrowserTracingPageLoadSpan)(client, startSpanOptions);
                return undefined;
            };
            const startNavigationCallback = (startSpanOptions)=>{
                (0, $cd71e.startBrowserTracingNavigationSpan)(client, startSpanOptions);
                return undefined;
            };
            // eslint-disable-next-line deprecation/deprecation
            const instrumentation = $dcfcee4e55f84f8e$export$6e634b456f232d5f(history, routes, matchPath);
            // Now instrument page load & navigation with correct settings
            instrumentation(startPageloadCallback, instrumentPageLoad, false);
            instrumentation(startNavigationCallback, false, instrumentNavigation);
        }
    };
}
/**
 * A browser tracing integration that uses React Router v5 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function $dcfcee4e55f84f8e$export$1c913d0c067ca14f(options) {
    const integration = (0, $cd71e.browserTracingIntegration)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { history: history, routes: routes, matchPath: matchPath } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startPageloadCallback = (startSpanOptions)=>{
                (0, $cd71e.startBrowserTracingPageLoadSpan)(client, startSpanOptions);
                return undefined;
            };
            const startNavigationCallback = (startSpanOptions)=>{
                (0, $cd71e.startBrowserTracingNavigationSpan)(client, startSpanOptions);
                return undefined;
            };
            // eslint-disable-next-line deprecation/deprecation
            const instrumentation = $dcfcee4e55f84f8e$export$2adda1b223c9dfaa(history, routes, matchPath);
            // Now instrument page load & navigation with correct settings
            instrumentation(startPageloadCallback, options.instrumentPageLoad, false);
            instrumentation(startNavigationCallback, false, options.instrumentNavigation);
        }
    };
}
/**
 * @deprecated Use `browserTracingReactRouterV4()` instead.
 */ function $dcfcee4e55f84f8e$export$6e634b456f232d5f(history, routes, matchPath) {
    return $dcfcee4e55f84f8e$var$createReactRouterInstrumentation(history, "reactrouter_v4", routes, matchPath);
}
/**
 * @deprecated Use `browserTracingReactRouterV5()` instead.
 */ function $dcfcee4e55f84f8e$export$2adda1b223c9dfaa(history, routes, matchPath) {
    return $dcfcee4e55f84f8e$var$createReactRouterInstrumentation(history, "reactrouter_v5", routes, matchPath);
}
function $dcfcee4e55f84f8e$var$createReactRouterInstrumentation(history, instrumentationName, allRoutes = [], matchPath) {
    function getInitPathName() {
        if (history && history.location) return history.location.pathname;
        if ((0, $d9NWo.WINDOW) && (0, $d9NWo.WINDOW).location) return (0, $d9NWo.WINDOW).location.pathname;
        return undefined;
    }
    /**
   * Normalizes a transaction name. Returns the new name as well as the
   * source of the transaction.
   *
   * @param pathname The initial pathname we normalize
   */ function normalizeTransactionName(pathname) {
        if (allRoutes.length === 0 || !matchPath) return [
            pathname,
            "url"
        ];
        const branches = $dcfcee4e55f84f8e$var$matchRoutes(allRoutes, pathname, matchPath);
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let x = 0; x < branches.length; x++){
            if (branches[x].match.isExact) return [
                branches[x].match.path,
                "route"
            ];
        }
        return [
            pathname,
            "url"
        ];
    }
    return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        const initPathName = getInitPathName();
        if (startTransactionOnPageLoad && initPathName) {
            const [name, source] = normalizeTransactionName(initPathName);
            $dcfcee4e55f84f8e$var$activeTransaction = customStartTransaction({
                name: name,
                attributes: {
                    [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "pageload",
                    [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: `auto.pageload.react.${instrumentationName}`,
                    [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: source
                }
            });
        }
        if (startTransactionOnLocationChange && history.listen) history.listen((location, action)=>{
            if (action && (action === "PUSH" || action === "POP")) {
                if ($dcfcee4e55f84f8e$var$activeTransaction) $dcfcee4e55f84f8e$var$activeTransaction.end();
                const [name, source] = normalizeTransactionName(location.pathname);
                $dcfcee4e55f84f8e$var$activeTransaction = customStartTransaction({
                    name: name,
                    attributes: {
                        [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "navigation",
                        [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: `auto.navigation.react.${instrumentationName}`,
                        [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: source
                    }
                });
            }
        });
    };
}
/**
 * Matches a set of routes to a pathname
 * Based on implementation from
 */ function $dcfcee4e55f84f8e$var$matchRoutes(routes, pathname, matchPath, branch = []) {
    routes.some((route)=>{
        const match = route.path ? matchPath(pathname, route) : branch.length ? branch[branch.length - 1].match // use parent match
         : $dcfcee4e55f84f8e$var$computeRootMatch(pathname); // use default "root" match
        if (match) {
            branch.push({
                route: route,
                match: match
            });
            if (route.routes) $dcfcee4e55f84f8e$var$matchRoutes(route.routes, pathname, matchPath, branch);
        }
        return !!match;
    });
    return branch;
}
function $dcfcee4e55f84f8e$var$computeRootMatch(pathname) {
    return {
        path: "/",
        url: "/",
        params: {},
        isExact: pathname === "/"
    };
}
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ function $dcfcee4e55f84f8e$export$51a414dfd89dd222(Route) {
    const componentDisplayName = Route.displayName || Route.name;
    const activeRootSpan = $dcfcee4e55f84f8e$var$getActiveRootSpan();
    const WrappedRoute = (props)=>{
        if (activeRootSpan && props && props.computedMatch && props.computedMatch.isExact) {
            activeRootSpan.updateName(props.computedMatch.path);
            activeRootSpan.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), "route");
        }
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params:
        // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
        return $bh6RR.createElement(Route, {
            ...props,
            __self: this,
            __source: {
                fileName: $dcfcee4e55f84f8e$var$_jsxFileName,
                lineNumber: 277
            }
        });
    };
    WrappedRoute.displayName = `sentryRoute(${componentDisplayName})`;
    (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(WrappedRoute, Route);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params:
    // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
    return WrappedRoute;
}
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ function $dcfcee4e55f84f8e$var$getActiveRootSpan() {
    // Legacy behavior for "old" react router instrumentation
    if ($dcfcee4e55f84f8e$var$activeTransaction) return $dcfcee4e55f84f8e$var$activeTransaction;
    const span = (0, $mtWu0.getActiveSpan)();
    const rootSpan = span ? (0, $7oVpT.getRootSpan)(span) : undefined;
    if (!rootSpan) return undefined;
    const op = (0, $4RP7L.spanToJSON)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === "navigation" || op === "pageload" ? rootSpan : undefined;
}

});

parcelRegister("2PGsT", function(module, exports) {

$parcel$export(module.exports, "reactRouterV6BrowserTracingIntegration", function () { return $210148e080bee452$export$47113a480541ff59; });
$parcel$export(module.exports, "reactRouterV6Instrumentation", function () { return $210148e080bee452$export$e6e76890c5208db1; });
$parcel$export(module.exports, "withSentryReactRouterV6Routing", function () { return $210148e080bee452$export$c6111e8561a02a8b; });
$parcel$export(module.exports, "wrapUseRoutes", function () { return $210148e080bee452$export$1f41b3e298c8040f; });
$parcel$export(module.exports, "wrapCreateBrowserRouter", function () { return $210148e080bee452$export$7f4c656bd7ebbb6b; });

var $cd71e = parcelRequire("cd71e");parcelRequire("9M4YH");
var $d9NWo = parcelRequire("d9NWo");

var $mtWu0 = parcelRequire("mtWu0");
var $7oVpT = parcelRequire("7oVpT");
var $kuS4l = parcelRequire("kuS4l");
var $4RP7L = parcelRequire("4RP7L");

var $bn8Da = parcelRequire("bn8Da");
var $7p8hL = parcelRequire("7p8hL");

var $adG4d = parcelRequire("adG4d");

var $bh6RR = parcelRequire("bh6RR");

var $3Cr5Z = parcelRequire("3Cr5Z");
const $210148e080bee452$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx"; /* eslint-disable max-lines */ 
let $210148e080bee452$var$activeTransaction;
let $210148e080bee452$var$_useEffect;
let $210148e080bee452$var$_useLocation;
let $210148e080bee452$var$_useNavigationType;
let $210148e080bee452$var$_createRoutesFromChildren;
let $210148e080bee452$var$_matchRoutes;
let $210148e080bee452$var$_customStartTransaction;
let $210148e080bee452$var$_startTransactionOnLocationChange;
let $210148e080bee452$var$_stripBasename = false;
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function $210148e080bee452$export$47113a480541ff59(options) {
    const integration = (0, $cd71e.browserTracingIntegration)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { useEffect: useEffect, useLocation: useLocation, useNavigationType: useNavigationType, createRoutesFromChildren: createRoutesFromChildren, matchRoutes: matchRoutes, stripBasename: stripBasename, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startNavigationCallback = (startSpanOptions)=>{
                (0, $cd71e.startBrowserTracingNavigationSpan)(client, startSpanOptions);
                return undefined;
            };
            const initPathName = (0, $d9NWo.WINDOW) && (0, $d9NWo.WINDOW).location && (0, $d9NWo.WINDOW).location.pathname;
            if (instrumentPageLoad && initPathName) (0, $cd71e.startBrowserTracingPageLoadSpan)(client, {
                name: initPathName,
                attributes: {
                    [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                    [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "pageload",
                    [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.react.reactrouter_v6"
                }
            });
            $210148e080bee452$var$_useEffect = useEffect;
            $210148e080bee452$var$_useLocation = useLocation;
            $210148e080bee452$var$_useNavigationType = useNavigationType;
            $210148e080bee452$var$_matchRoutes = matchRoutes;
            $210148e080bee452$var$_createRoutesFromChildren = createRoutesFromChildren;
            $210148e080bee452$var$_stripBasename = stripBasename || false;
            $210148e080bee452$var$_customStartTransaction = startNavigationCallback;
            $210148e080bee452$var$_startTransactionOnLocationChange = instrumentNavigation;
        }
    };
}
/**
 * @deprecated Use `reactRouterV6BrowserTracingIntegration()` instead.
 */ function $210148e080bee452$export$e6e76890c5208db1(useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, stripBasename) {
    return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        const initPathName = (0, $d9NWo.WINDOW) && (0, $d9NWo.WINDOW).location && (0, $d9NWo.WINDOW).location.pathname;
        if (startTransactionOnPageLoad && initPathName) $210148e080bee452$var$activeTransaction = customStartTransaction({
            name: initPathName,
            attributes: {
                [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "pageload",
                [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.react.reactrouter_v6"
            }
        });
        $210148e080bee452$var$_useEffect = useEffect;
        $210148e080bee452$var$_useLocation = useLocation;
        $210148e080bee452$var$_useNavigationType = useNavigationType;
        $210148e080bee452$var$_matchRoutes = matchRoutes;
        $210148e080bee452$var$_createRoutesFromChildren = createRoutesFromChildren;
        $210148e080bee452$var$_stripBasename = stripBasename || false;
        $210148e080bee452$var$_customStartTransaction = customStartTransaction;
        $210148e080bee452$var$_startTransactionOnLocationChange = startTransactionOnLocationChange;
    };
}
/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */ function $210148e080bee452$var$stripBasenameFromPathname(pathname, basename) {
    if (!basename || basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return pathname;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    const startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    const nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return pathname;
    return pathname.slice(startIndex) || "/";
}
function $210148e080bee452$var$getNormalizedName(routes, location, branches, basename = "") {
    if (!routes || routes.length === 0) return [
        $210148e080bee452$var$_stripBasename ? $210148e080bee452$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
    let pathBuilder = "";
    if (branches) // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let x = 0; x < branches.length; x++){
        const branch = branches[x];
        const route = branch.route;
        if (route) {
            // Early return if index route
            if (route.index) return [
                $210148e080bee452$var$_stripBasename ? $210148e080bee452$var$stripBasenameFromPathname(branch.pathname, basename) : branch.pathname,
                "route"
            ];
            const path = route.path;
            if (path) {
                const newPath = path[0] === "/" || pathBuilder[pathBuilder.length - 1] === "/" ? path : `/${path}`;
                pathBuilder += newPath;
                if (basename + branch.pathname === location.pathname) {
                    if (// If the route defined on the element is something like
                    // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
                    // We should check against the branch.pathname for the number of / seperators
                    (0, $bn8Da.getNumberOfUrlSegments)(pathBuilder) !== (0, $bn8Da.getNumberOfUrlSegments)(branch.pathname) && // We should not count wildcard operators in the url segments calculation
                    pathBuilder.slice(-2) !== "/*") return [
                        ($210148e080bee452$var$_stripBasename ? "" : basename) + newPath,
                        "route"
                    ];
                    return [
                        ($210148e080bee452$var$_stripBasename ? "" : basename) + pathBuilder,
                        "route"
                    ];
                }
            }
        }
    }
    return [
        $210148e080bee452$var$_stripBasename ? $210148e080bee452$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
}
function $210148e080bee452$var$updatePageloadTransaction(activeRootSpan, location, routes, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $210148e080bee452$var$_matchRoutes(routes, location, basename);
    if (activeRootSpan && branches) {
        const [name, source] = $210148e080bee452$var$getNormalizedName(routes, location, branches, basename);
        activeRootSpan.updateName(name);
        activeRootSpan.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
    }
}
function $210148e080bee452$var$handleNavigation(location, routes, navigationType, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $210148e080bee452$var$_matchRoutes(routes, location, basename);
    if ($210148e080bee452$var$_startTransactionOnLocationChange && (navigationType === "PUSH" || navigationType === "POP") && branches) {
        if ($210148e080bee452$var$activeTransaction) $210148e080bee452$var$activeTransaction.end();
        const [name, source] = $210148e080bee452$var$getNormalizedName(routes, location, branches, basename);
        $210148e080bee452$var$activeTransaction = $210148e080bee452$var$_customStartTransaction({
            name: name,
            attributes: {
                [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: source,
                [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "navigation",
                [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.react.reactrouter_v6"
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $210148e080bee452$export$c6111e8561a02a8b(Routes) {
    if (!$210148e080bee452$var$_useEffect || !$210148e080bee452$var$_useLocation || !$210148e080bee452$var$_useNavigationType || !$210148e080bee452$var$_createRoutesFromChildren || !$210148e080bee452$var$_matchRoutes || !$210148e080bee452$var$_customStartTransaction) {
        (0, $3Cr5Z.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${$210148e080bee452$var$_useEffect}. useLocation: ${$210148e080bee452$var$_useLocation}. useNavigationType: ${$210148e080bee452$var$_useNavigationType}.
      createRoutesFromChildren: ${$210148e080bee452$var$_createRoutesFromChildren}. matchRoutes: ${$210148e080bee452$var$_matchRoutes}. customStartTransaction: ${$210148e080bee452$var$_customStartTransaction}.`);
        return Routes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const location = $210148e080bee452$var$_useLocation();
        const navigationType = $210148e080bee452$var$_useNavigationType();
        $210148e080bee452$var$_useEffect(()=>{
            const routes = $210148e080bee452$var$_createRoutesFromChildren(props.children);
            if (isMountRenderPass) {
                $210148e080bee452$var$updatePageloadTransaction($210148e080bee452$var$getActiveRootSpan(), location, routes);
                isMountRenderPass = false;
            } else $210148e080bee452$var$handleNavigation(location, routes, navigationType);
        }, // `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
        // when the children change. We only want to start transactions when the location or navigation type change.
        [
            location,
            navigationType
        ]);
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params
        return $bh6RR.createElement(Routes, {
            ...props,
            __self: this,
            __source: {
                fileName: $210148e080bee452$var$_jsxFileName,
                lineNumber: 329
            }
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(SentryRoutes, Routes);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return SentryRoutes;
}
function $210148e080bee452$export$1f41b3e298c8040f(origUseRoutes) {
    if (!$210148e080bee452$var$_useEffect || !$210148e080bee452$var$_useLocation || !$210148e080bee452$var$_useNavigationType || !$210148e080bee452$var$_matchRoutes || !$210148e080bee452$var$_customStartTransaction) {
        (0, $3Cr5Z.DEBUG_BUILD) && (0, $7p8hL.logger).warn("reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.");
        return origUseRoutes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const { routes: routes, locationArg: locationArg } = props;
        const Routes = origUseRoutes(routes, locationArg);
        const location = $210148e080bee452$var$_useLocation();
        const navigationType = $210148e080bee452$var$_useNavigationType();
        // A value with stable identity to either pick `locationArg` if available or `location` if not
        const stableLocationParam = typeof locationArg === "string" || locationArg && locationArg.pathname ? locationArg : location;
        $210148e080bee452$var$_useEffect(()=>{
            const normalizedLocation = typeof stableLocationParam === "string" ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass) {
                $210148e080bee452$var$updatePageloadTransaction($210148e080bee452$var$getActiveRootSpan(), normalizedLocation, routes);
                isMountRenderPass = false;
            } else $210148e080bee452$var$handleNavigation(normalizedLocation, routes, navigationType);
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    // eslint-disable-next-line react/display-name
    return (routes, locationArg)=>{
        return $bh6RR.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg,
            __self: this,
            __source: {
                fileName: $210148e080bee452$var$_jsxFileName,
                lineNumber: 386
            }
        });
    };
}
function $210148e080bee452$export$7f4c656bd7ebbb6b(createRouterFunction) {
    // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
    // `basename` is the only option that is relevant for us, and it is the same for all.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(routes, opts) {
        const router = createRouterFunction(routes, opts);
        const basename = opts && opts.basename;
        const activeRootSpan = $210148e080bee452$var$getActiveRootSpan();
        // The initial load ends when `createBrowserRouter` is called.
        // This is the earliest convenient time to update the transaction name.
        // Callbacks to `router.subscribe` are not called for the initial load.
        if (router.state.historyAction === "POP" && activeRootSpan) $210148e080bee452$var$updatePageloadTransaction(activeRootSpan, router.state.location, routes, undefined, basename);
        router.subscribe((state)=>{
            const location = state.location;
            if ($210148e080bee452$var$_startTransactionOnLocationChange && (state.historyAction === "PUSH" || state.historyAction === "POP")) $210148e080bee452$var$handleNavigation(location, routes, state.historyAction, undefined, basename);
        });
        return router;
    };
}
function $210148e080bee452$var$getActiveRootSpan() {
    // Legacy behavior for "old" react router instrumentation
    if ($210148e080bee452$var$activeTransaction) return $210148e080bee452$var$activeTransaction;
    const span = (0, $mtWu0.getActiveSpan)();
    const rootSpan = span ? (0, $7oVpT.getRootSpan)(span) : undefined;
    if (!rootSpan) return undefined;
    const op = (0, $4RP7L.spanToJSON)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === "navigation" || op === "pageload" ? rootSpan : undefined;
}

});




parcelRegister("lVvdy", function(module, exports) {

$parcel$export(module.exports, "setVoxCredentials", function () { return $ff672304e4cbf88d$export$f8610783904815ce; });
$parcel$export(module.exports, "reInitVoximplant", function () { return $ff672304e4cbf88d$export$aa8108c389a70ca1; });
$parcel$export(module.exports, "setVoximplantSupportData", function () { return $ff672304e4cbf88d$export$c953ee914c84a2be; });
const $ff672304e4cbf88d$export$f8610783904815ce = ()=>{
    const VOXIMPLANT_CHANNEL_UUID = (0, window.VoxKitWidgetSettings.channel_uuid);
    const VOXIMPLANT_TOKEN = (0, window.VoxKitWidgetSettings.token);
    if (window.VoxKitWidgetSettings.channel_uuid !== VOXIMPLANT_CHANNEL_UUID) window.VoxKitWidgetSettings.channel_uuid = VOXIMPLANT_CHANNEL_UUID;
    if (window.VoxKitWidgetSettings.token !== VOXIMPLANT_TOKEN) window.VoxKitWidgetSettings.token = VOXIMPLANT_TOKEN;
};
const $ff672304e4cbf88d$export$1131ee6d051cabb3 = ()=>{
    window.VoxKitWidgetSettings.client_data = {
        client_id: "",
        // Customer ID
        client_phone: "",
        // Customer phone number
        client_avatar: "",
        // Customer avatar link
        client_display_name: "",
        // Customer name
        client_email: "",
        // Customer email
        client_language: "ru" // Interface language: 'en' or 'ru'
    };
    if (window.VoxKitWidget) {
        if (document.getElementsByClassName("kit-widget-container is-open").length) document.getElementsByClassName("widget-btn")[0].click();
        $ff672304e4cbf88d$export$aa8108c389a70ca1();
    }
};
const $ff672304e4cbf88d$export$aa8108c389a70ca1 = ()=>{
    localStorage.removeItem("kit_chat_open");
    localStorage.setItem("kit_client_id", window.VoxKitWidgetSettings.client_data.client_id + "");
// if (!window.ReactNativeWebView) {
//   window.location.reload();
// }
};
const $ff672304e4cbf88d$export$c953ee914c84a2be = (data, overwrite = false, overwriteCustomData)=>{
    if (overwrite) window.VoxKitWidgetSettings.client_data = {
        ...data,
        client_email: JSON.stringify(data.client_email)
    };
    else {
        let client_email = window.VoxKitWidgetSettings.client_data.client_email; // Подаю сюда кастомные данные, чтоб в поддержке можно было увидеть.
        if (data.client_email) {
            const parseData = client_email && client_email !== "{}" ? JSON.parse(client_email) : {};
            if (overwriteCustomData) client_email = JSON.stringify({
                page: parseData.page || location.href,
                ...data
            });
            else client_email = client_email && client_email !== "{}" ? JSON.stringify({
                ...parseData,
                page: parseData.page || location.href,
                ...JSON.parse(typeof data.client_email === "string" ? data.client_email : JSON.stringify(data.client_email))
            }) : JSON.stringify({
                ...data.client_email
            });
        }
        window.VoxKitWidgetSettings.client_data = {
            ...window.VoxKitWidgetSettings.client_data,
            ...data,
            client_email: client_email
        };
    }
};

});

parcelRegister("dsDBD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ccc9cd08e234da9$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $9ccc9cd08e234da9$var$API_URL = (0, location.origin);
class $9ccc9cd08e234da9$var$OldAuth {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/auth", null, null, $9ccc9cd08e234da9$var$API_URL);
    }
    getCurrentUser() {
        return this.apiService.get("current-user");
    }
    postObtainToken({ username: username, password: password }) {
        return this.apiService.post("obtain-token", {}, {
            username: username,
            password: password
        });
    }
    postRefreshToken(token) {
        return this.apiService.post("refresh-token", {}, {
            token: token
        });
    }
    logout() {
        return this.apiService.post("logout");
    }
}
var $9ccc9cd08e234da9$export$2e2bcd8739ae039 = new $9ccc9cd08e234da9$var$OldAuth();

});

parcelRegister("60top", function(module, exports) {

$parcel$export(module.exports, "jwtDecode", function () { return $45f98aee66c4127f$export$fa1e2fb699b7861e; });
class $45f98aee66c4127f$export$b9721ef022f71a68 extends Error {
}
$45f98aee66c4127f$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $45f98aee66c4127f$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $45f98aee66c4127f$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $45f98aee66c4127f$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $45f98aee66c4127f$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $45f98aee66c4127f$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $45f98aee66c4127f$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $45f98aee66c4127f$var$base64UrlDecode(part);
    } catch (e) {
        throw new $45f98aee66c4127f$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $45f98aee66c4127f$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}

});

parcelRegister("jCgCX", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("keeSY", function(module, exports) {

var $60top = parcelRequire("60top");
const $eba0a97579514faa$export$9441bd936c2594f9 = (token)=>{
    if (!token) return false;
    try {
        const tokenData = (0, $60top.jwtDecode)(token);
        return true;
    } catch  {
        return false;
    }
};

});

parcelRegister("eYBKQ", function(module, exports) {

$parcel$export(module.exports, "setLocalStorage", function () { return $ae73f487984f0464$export$1f73f60bdb811cb1; });
$parcel$export(module.exports, "removeItemLocalStorage", function () { return $ae73f487984f0464$export$4bb2a8bef0a419dc; });
$parcel$export(module.exports, "getLocalStorage", function () { return $ae73f487984f0464$export$d3720feff416e85b; });
const $ae73f487984f0464$export$1f73f60bdb811cb1 = (name, value)=>{
    localStorage.setItem(name, JSON.stringify(value));
};
const $ae73f487984f0464$export$4bb2a8bef0a419dc = (name)=>{
    localStorage.removeItem(name);
};
const $ae73f487984f0464$export$d3720feff416e85b = (name)=>{
    if (localStorage.getItem(name)) return JSON.parse(localStorage.getItem(name));
};

});

parcelRegister("2kmDV", function(module, exports) {

$parcel$export(module.exports, "SCHEDULE_FILTERS_STORAGE_KEY", function () { return $1b1f0376a690c498$export$961526650118cae2; });
$parcel$export(module.exports, "howDidLearnOptions", function () { return $1b1f0376a690c498$export$e2673d69cc67f7ba; });
$parcel$export(module.exports, "visitFormatOptions", function () { return $1b1f0376a690c498$export$7ac5fe5be486e7c7; });
$parcel$export(module.exports, "paymentTypeOptions", function () { return $1b1f0376a690c498$export$e7fe2bc18b529f61; });
$parcel$export(module.exports, "notificationTypeOptions", function () { return $1b1f0376a690c498$export$92c29a270a457991; });
$parcel$export(module.exports, "entrySourceOptions", function () { return $1b1f0376a690c498$export$1dd427d14b269afd; });
const $1b1f0376a690c498$export$961526650118cae2 = "generalScheduleFilters";
const $1b1f0376a690c498$export$e2673d69cc67f7ba = [
    {
        label: "\u0411\u043B\u043E\u0433\u0435\u0440\u044B",
        value: "\u0411\u043B\u043E\u0433\u0435\u0440\u044B"
    },
    {
        label: "\u0416\u0438\u0432\u0443 \u0440\u044F\u0434\u043E\u043C (\u0432\u044B\u0432\u0435\u0441\u043A\u0430 \u043A\u043B\u0438\u043D\u0438\u043A\u0438)",
        value: "\u0416\u0438\u0432\u0443 \u0440\u044F\u0434\u043E\u043C (\u0432\u044B\u0432\u0435\u0441\u043A\u0430 \u043A\u043B\u0438\u043D\u0438\u043A\u0438)"
    },
    {
        label: "\u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 (\u041F\u043E\u0438\u0441\u043A: \u042F\u043D\u0434\u0435\u043A\u0441, \u0413\u0443\u0433\u043B)",
        value: "\u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 (\u041F\u043E\u0438\u0441\u043A:\u042F\u043D\u0434\u0435\u043A\u0441, \u0413\u0443\u0433\u043B)"
    },
    {
        label: "\u041A\u0430\u0440\u0442\u044B (\u042F\u043D\u0434\u0435\u043A\u0441, \u0413\u0443\u0433\u043B, 2\u0413\u0418\u0421)",
        value: "\u041A\u0430\u0440\u0442\u044B (\u042F\u043D\u0434\u0435\u043A\u0441, \u0413\u0443\u0433\u043B, 2\u0413\u0418\u0421)"
    },
    {
        label: "\u041D\u0430 \u043F\u043E\u043F\u0440\u0430\u0432\u043A\u0443",
        value: "\u041D\u0430 \u043F\u043E\u043F\u0440\u0430\u0432\u043A\u0443"
    },
    {
        label: "\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0432\u0440\u0430\u0447\u0430",
        value: "\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0432\u0440\u0430\u0447\u0430"
    },
    {
        label: "\u041D\u0430\u0440\u0443\u0436\u043D\u0430\u044F \u0440\u0435\u043A\u043B\u0430\u043C\u0430 (\u043D\u0435 \u0443 \u043A\u043B\u0438\u043D\u0438\u043A\u0438)",
        value: "\u041D\u0430\u0440\u0443\u0436\u043D\u0430\u044F \u0440\u0435\u043A\u043B\u0430\u043C\u0430 (\u043D\u0435 \u0443 \u043A\u043B\u0438\u043D\u0438\u043A\u0438)"
    },
    {
        label: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u044B\u0439 \u0432\u0438\u0437\u0438\u0442 \u0432 \u043A\u043B\u0438\u043D\u0438\u043A\u0443",
        value: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u044B\u0439 \u0432\u0438\u0437\u0438\u0442 \u0432 \u043A\u043B\u0438\u043D\u0438\u043A\u0443"
    },
    {
        label: "\u0420\u0430\u0434\u0438\u043E",
        value: "\u0420\u0430\u0434\u0438\u043E"
    },
    {
        label: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u0434\u043E\u043A\u0442\u043E\u0440\u043E\u0432 \u0434\u0440\u0443\u0433\u0438\u0445 \u043A\u043B\u0438\u043D\u0438\u043A",
        value: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u0434\u043E\u043A\u0442\u043E\u0440\u043E\u0432 \u0434\u0440\u0443\u0433\u0438\u0445 \u043A\u043B\u0438\u043D\u0438\u043A"
    },
    {
        label: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u0434\u043E\u043A\u0442\u043E\u0440\u043E\u0432 \u041D\u0410\u0428\u0418\u0425 \u043A\u043B\u0438\u043D\u0438\u043A",
        value: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u0434\u043E\u043A\u0442\u043E\u0440\u043E\u0432 \u041D\u0410\u0428\u0418\u0425 \u043A\u043B\u0438\u043D\u0438\u043A"
    },
    {
        label: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u0437\u043D\u0430\u043A\u043E\u043C\u044B\u0445",
        value: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u0437\u043D\u0430\u043A\u043E\u043C\u044B\u0445"
    },
    {
        label: "\u0421\u0430\u0439\u0442 \u041F\u0440\u043E \u0414\u043E\u043A\u0442\u043E\u0440\u043E\u0432",
        value: "\u0421\u0430\u0439\u0442 \u041F\u0440\u043E \u0414\u043E\u043A\u0442\u043E\u0440\u043E\u0432"
    },
    {
        label: "\u0421\u0431\u0435\u0440\u0417\u0434\u043E\u0440\u043E\u0432\u044C\u0435",
        value: "\u0421\u0431\u0435\u0440\u0417\u0434\u043E\u0440\u043E\u0432\u044C\u0435"
    },
    {
        label: "\u0421\u043E\u0446.\u0441\u0435\u0442\u0438",
        value: "\u0421\u043E\u0446.\u0441\u0435\u0442\u0438"
    },
    {
        label: "\u0422\u0435\u043B\u0435\u0432\u0438\u0434\u0435\u043D\u0438\u0435",
        value: "\u0422\u0435\u043B\u0435\u0432\u0438\u0434\u0435\u043D\u0438\u0435"
    },
    {
        label: "\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C",
        value: "\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C"
    },
    {
        label: "\u0414\u0440\u0443\u0433\u043E\u0435",
        value: "\u0414\u0440\u0443\u0433\u043E\u0435"
    }
];
const $1b1f0376a690c498$export$7ac5fe5be486e7c7 = [
    {
        value: "online",
        label: "\u041E\u043D\u043B\u0430\u0439\u043D"
    },
    {
        value: "clinic",
        label: "\u0412 \u043A\u043B\u0438\u043D\u0438\u043A\u0435"
    },
    {
        value: "chat",
        label: "\u0427\u0430\u0442"
    },
    {
        value: "home_visit",
        label: "\u0412\u044B\u0435\u0437\u0434 \u043D\u0430 \u0434\u043E\u043C"
    }
];
const $1b1f0376a690c498$export$e7fe2bc18b529f61 = [
    "\u041F\u043B\u0430\u0442\u043D\u044B\u0435",
    "\u0414\u041C\u0421",
    "\u041E\u041C\u0421"
].map((option)=>({
        label: option,
        value: option
    }));
const $1b1f0376a690c498$export$92c29a270a457991 = [
    "\u0421\u041C\u0421",
    "Email",
    "WhatsApp"
].map((option)=>({
        label: option,
        value: option
    }));
const $1b1f0376a690c498$export$1dd427d14b269afd = [
    "\u0421\u0430\u0439\u0442",
    "\u041C\u0418\u0421",
    "\u0412\u0445\u043E\u0434\u044F\u0449\u0438\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043D\u044B\u0439 \u0437\u0432\u043E\u043D\u043E\u043A",
    "\u0418\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043D\u044B\u0439 \u0437\u0432\u043E\u043D\u043E\u043A",
    "\u0427\u0430\u0442",
    "\u041B\u0438\u0447\u043D\u043E\u0435 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435 \u0432 \u043A\u043B\u0438\u043D\u0438\u043A\u0443",
    "\u041F\u0440\u043E\u0447\u0435\u0435",
    "\u0418\u043D\u0441\u0442\u0430\u0433\u0440\u0430\u043C\u043C",
    "\u0412\u0440\u0430\u0447\u0438 (\u0410\u0441\u044F)",
    "\u041F\u0440\u043E \u0434\u043E\u043A\u0442\u043E\u0440\u043E\u0432",
    "\u0421\u0431\u0435\u0440\u0417\u0434\u043E\u0440\u043E\u0432\u044C\u0435",
    "\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
    "\u041D\u0430 \u043F\u043E\u043F\u0440\u0430\u0432\u043A\u0443",
    "\u0427\u0430\u0442\u0431\u043E\u0442"
].map((option)=>({
        label: option,
        value: option
    }));

});


parcelRegister("3M0M5", function(module, exports) {

$parcel$export(module.exports, "MessageStatus", function () { return $2bf6749be9b2fb23$export$4963a2999b5870bb; });
$parcel$export(module.exports, "ChatMessageType", function () { return $2bf6749be9b2fb23$export$74fa6a95f10f26b; });
$parcel$export(module.exports, "ChatFilters", function () { return $2bf6749be9b2fb23$export$89366b7625933133; });
$parcel$export(module.exports, "default", function () { return $2bf6749be9b2fb23$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $jqdsN = parcelRequire("jqdsN");
parcelRequire("bh6RR");

var $9Qp9d = parcelRequire("9Qp9d");

var $bEzwx = parcelRequire("bEzwx");

var $cxTnx = parcelRequire("cxTnx");

var $kmHuZ = parcelRequire("kmHuZ");

var $iOlMk = parcelRequire("iOlMk");

var $kfcUT = parcelRequire("kfcUT");

var $bUAif = parcelRequire("bUAif");

var $5oGqh = parcelRequire("5oGqh");

var $f77a8 = parcelRequire("f77a8");

var $kEUo3 = parcelRequire("kEUo3");

var $i6z7r = parcelRequire("i6z7r");

var $lrsw3 = parcelRequire("lrsw3");

var $1cBan = parcelRequire("1cBan");

var $cVtTV = parcelRequire("cVtTV");

var $7HoMU = parcelRequire("7HoMU");

var $9Toj9 = parcelRequire("9Toj9");
const $2bf6749be9b2fb23$var$toastManager = (0, $5oGqh.useToast)();
const $2bf6749be9b2fb23$var$MessageType = {
    NEW: "new_message",
    DELETE: "delete_message",
    UPDATE: "update_message",
    LOAD_FILE: "load_file",
    NEW_ATTACHMENT: "new_attachment",
    CHANGE_CHAT_STATUS: "chat_status",
    NEW_SCHEDULE_INSERT: "new_schedule_insert",
    CONNECTION_CLOSE: "close_connection",
    PONG: "pong",
    SEND_IS_ONLINE: "send_is_online"
};
const $2bf6749be9b2fb23$export$c87fd205be4f689b = {
    CHAT: "chat",
    FOLDER: "folder"
};
const $2bf6749be9b2fb23$export$4963a2999b5870bb = {
    SENDING: "sending",
    SENT: "sent",
    ERROR: "error"
};
const $2bf6749be9b2fb23$export$74fa6a95f10f26b = {
    ONLY_FOR_PATIENT: "only_for_patient",
    APPOINTMENT: "appointment",
    TEXT: "text",
    IMAGES: "images",
    IMAGE: "image",
    FILE: "file",
    SYSTEM: "system"
};
const $2bf6749be9b2fb23$export$89366b7625933133 = {
    ALL: "all",
    NOT_READ: "not_read",
    OPENED: "opened",
    CLOSED: "closed",
    PAID: "paid"
};
const $2bf6749be9b2fb23$export$60c7f05ff615ace0 = {
    IMAGE: "image_message",
    FILE: "file_message"
};
class $2bf6749be9b2fb23$var$ChatStore {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "socket", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "chats", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "chatsData", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "currentChatId", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "currentCallId", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "chatsPagination", {
            perPage: 20,
            currentPage: 1,
            nextPage: 1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "unreadChatsCount", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "updateUnreadChatsCountTimeout", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isChatsLoading", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isChatsLoaded", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isAnonymousMode", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "allowAnonymousMode", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "callSettingsScreenShowed", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "loadingChatMessages", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "chatIsReadingNow", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "messagesPerPage", 20);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "currentDevices", {
            cameraId: 0,
            speakerId: 0,
            micId: 0
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "lastSelectedDevices", {
            cameraId: 0,
            speakerId: 0,
            micId: 0
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "videoEnabled", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "videoStateChangeInProgress", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "videoMinimized", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "voxCall", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "voxCallStats", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "voxAndDevicesInitializationStarted", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "voxAndDevicesInitialized", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "callOpponent", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "endpoints", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "voiceActive", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "microphoneMuted", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "microphoneMuteInProgress", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "videoDevices", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "audioDevices", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "outputDevices", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "audioContext", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "audioWavesTracks", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "events", {
            AudioLevelChange: "audio-level-change"
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "eventListeners", {
            "audio-level-change": []
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "searchText", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "selectedFilter", $2bf6749be9b2fb23$export$89366b7625933133.ALL);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isCallOpenChatConfirmShowed", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "showMediaPermissionNotDeviceModal", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "showMediaPermissionSelectModal", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "showMediaPermissionLockModal", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "showVoximplantConnectionErrorModal", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "voximplantIsReconnecting", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "disabledVideoButton", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isShowSettingChatsModal", false);
        (0, $9Qp9d.makeAutoObservable)(this);
        this._recalcEnpoints = this._recalcEnpoints.bind(this);
        this.searchChats = this.searchChats.bind(this);
        this.setVoximplantIsReconnecting = this.setVoximplantIsReconnecting.bind(this);
        this.showVoximlpantErrorModal = this.showVoximlpantErrorModal.bind(this);
        this.closeVoximplantErrorModal = this.closeVoximplantErrorModal.bind(this);
    }
    delay(time) {
        return new Promise((resolve)=>{
            setTimeout(resolve, time);
        });
    }
    get isMobileDevice() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent);
    }
    setVoximplantIsReconnecting(value) {
        this.voximplantIsReconnecting = value;
    }
    showVoximlpantErrorModal() {
        this.showVoximplantConnectionErrorModal = true;
    }
    closeVoximplantErrorModal() {
        this.showVoximplantConnectionErrorModal = false;
    }
    *initDevices(isOnlyAudio) {
        if (!this.voxAndDevicesInitialized) try {
            this.showMediaPermissionSelectModal = true;
            this.voxAndDevicesInitializationStarted = true;
            const params = {
                audio: true
            };
            if (!isOnlyAudio) params["video"] = true;
            const mediaStream = yield navigator.mediaDevices.getUserMedia(params);
            this.showMediaPermissionSelectModal = false;
            const tracks = mediaStream.getTracks();
            tracks.forEach((track)=>{
                track.stop();
            });
            try {
                yield (0, $kfcUT.default).getInstance();
            } catch (e) {
                this.voxAndDevicesInitializationStarted = false;
                console.error(e);
                return false;
            }
            yield this.delay(100);
            if (!isOnlyAudio) {
                const cameraManager = (0, $bUAif.Hardware).CameraManager.get();
                this.videoDevices = yield cameraManager.getInputDevices();
                this.setCameraId(this.videoDevices.length ? this.videoDevices[0].id : 0);
            }
            const audioManager = (0, $bUAif.Hardware).AudioDeviceManager.get();
            this.audioDevices = yield audioManager.getInputDevices();
            this.outputDevices = yield audioManager.getOutputDevices();
            this.setSpeakerId(this.outputDevices.length ? this.outputDevices[0].id : 0);
            this.setMicId(this.audioDevices.length ? this.audioDevices[0].id : 0);
        } catch (e) {
            if (!isOnlyAudio) {
                this.showMediaPermissionSelectModal = false;
                this.voxAndDevicesInitializationStarted = false;
                this.videoEnabled = false;
                this.disabledVideoButton = true;
                return yield this.initDevices(true);
            }
            if (e.toString() === "NotAllowedError: Permission denied by system" || e.toString().includes("NotFoundError") || e.toString() === "NotReadableError: Failed to allocate videosource") {
                this.showMediaPermissionSelectModal = false;
                this.voxAndDevicesInitializationStarted = false;
                this.showMediaPermissionNotDeviceModal = true;
                return false;
            }
            this.showMediaPermissionSelectModal = false;
            this.voxAndDevicesInitializationStarted = false;
            this.showMediaPermissionLockModal = true;
            return false;
        }
        else {
            this.showMediaPermissionSelectModal = false;
            this.voxAndDevicesInitializationStarted = false;
            this.showMediaPermissionLockModal = true;
            return false;
        }
        this.showMediaPermissionSelectModal = false;
        this.voxAndDevicesInitialized = true;
        return true;
    }
    setLastSelectedDevices() {
        this.setCameraId(this.lastSelectedDevices.cameraId);
        this.setSpeakerId(this.lastSelectedDevices.speakerId);
        this.setMicId(this.lastSelectedDevices.micId);
    }
    resetCurrentDevices() {
        this.currentDevices.cameraId = 0;
        this.currentDevices.speakerId = 0;
        this.currentDevices.micId = 0;
    }
    _detectAudioWorklet() {
        if (window["OfflineAudioContext"]) {
            const context = new window["OfflineAudioContext"](1, 1, 44100);
            return context.audioWorklet && typeof context.audioWorklet.addModule === "function";
        }
        return false;
    }
    *prepareAudioNodes(track) {
        const oldContext = this.audioContext;
        if (oldContext) yield oldContext.close();
        const audioContext = new AudioContext();
        yield audioContext.audioWorklet.addModule(`data:application/javascript;charset=utf8,${encodeURIComponent(`
      class AudioLevelProcessor extends AudioWorkletProcessor {
        constructor() {
          super();
          this.cycle = 0;
          this.fullValue = 0;
        }
        process(inputs, outputs, parameters) {
          this.cycle++;
          const sum = inputs[0].reduce((pred, item) => {
            const fItem = parseFloat(item);
            return pred + fItem * fItem;
          }, 0.0);
          this.fullValue += Math.sqrt(sum);
          if (this.cycle === 10) {
            this.port.postMessage({
              level: this.fullValue / this.cycle,
            });
            this.cycle = 0;
            this.fullValue = 0;
          }
          return true;
        }
      }
      
      registerProcessor('audio-level-processor', AudioLevelProcessor);
    `)}`);
        const audioLevelNode = new AudioWorkletNode(audioContext, "audio-level-processor");
        audioLevelNode.port.onmessage = (event)=>{
            if (this.eventListeners[this.events.AudioLevelChange].length) this.eventListeners[this.events.AudioLevelChange].forEach((callback)=>{
                callback(event);
            });
        };
        const micNode = audioContext.createMediaStreamSource(new MediaStream([
            track
        ]));
        micNode.connect(audioLevelNode);
        audioLevelNode.connect(audioContext.destination);
        return audioContext;
    }
    *initAudioWaves() {
        const constraints = {};
        if (this.currentDevices.micId !== 0) constraints.audio = {
            deviceId: this.currentDevices.micId
        };
        else constraints.audio = true;
        const media = yield navigator.mediaDevices.getUserMedia(constraints);
        this.audioWavesTracks = media.getAudioTracks();
        if (this._detectAudioWorklet()) this.audioContext = yield this.prepareAudioNodes(this.audioWavesTracks[0]);
    }
    stopAudioWaves() {
        if (this.audioContext) {
            this.audioWavesTracks.forEach((track)=>track.stop());
            this.audioContext.close();
            this.audioContext = null;
        }
    }
    on(event, callback) {
        if (this.eventListeners[event]) {
            this.eventListeners[event].push(callback);
            return ()=>{
                this.eventListeners[event] = this.eventListeners[event].filter((cb)=>cb !== callback);
            };
        }
    }
    *showCallSettingsScreen() {
        // врач Куваев(первый врач телемеда) не закрывает чаты после созвона, поэтому и отрывать заставлять не будем
        // if (this.currentChat && this.currentChat.opponent?.patient_id && !this.currentChat.can_patient_chat) {
        //   return this.showCallOpenChatConfirm();
        // }
        if (!this.audioDevices.length) {
            const deviceInitializationResult = yield this.initDevices();
            if (!deviceInitializationResult) return;
        } else this.setLastSelectedDevices();
        if (!this.showMediaPermissionNotDeviceModal && !this.showMediaPermissionLockModal) this.callSettingsScreenShowed = true;
    }
    closeCallSettingsScreen() {
        this.callSettingsScreenShowed = false;
    }
    changeShowMediaPermissionNotDeviceModal() {
        this.showMediaPermissionNotDeviceModal = !this.showMediaPermissionNotDeviceModal;
    }
    changeShowMediaPermissionLockModal() {
        this.showMediaPermissionLockModal = !this.showMediaPermissionLockModal;
    }
    changeOnline(chatId, online, timestamp) {
        const chat = this.findChat(chatId);
        chat.is_online = online;
        chat.last_date_online = timestamp.replace(" ", "T");
        this._updateChats();
    }
    fixSocketMessage(message) {
        var _message$data, _message$data2;
        if (((_message$data = message.data) === null || _message$data === void 0 ? void 0 : _message$data.message_type) === $2bf6749be9b2fb23$export$74fa6a95f10f26b.IMAGE) {
            message.data.type = $2bf6749be9b2fb23$export$74fa6a95f10f26b.IMAGE;
            message.data.type_message = $2bf6749be9b2fb23$export$60c7f05ff615ace0.IMAGE;
        }
        if (((_message$data2 = message.data) === null || _message$data2 === void 0 ? void 0 : _message$data2.message_type) === $2bf6749be9b2fb23$export$74fa6a95f10f26b.FILE) {
            message.data.type = $2bf6749be9b2fb23$export$74fa6a95f10f26b.FILE;
            message.data.type_message = $2bf6749be9b2fb23$export$60c7f05ff615ace0.FILE;
        }
        return message;
    }
    initWS() {
        if (this.socket && (this.socket.readyState === WebSocket.CONNECTING || this.socket.readyState === WebSocket.OPEN)) return;
        const url = new URL(`${(0, location.origin)}/api/ws/messages/?Authorization=${(0, $iOlMk.tokenStore).getState()}`);
        url.protocol = "wss:";
        this.socket = new WebSocket(url.toString());
        this.socket.onopen = ()=>{
            console.log("connection to the channel has been established");
        };
        this.socket.onclose = (0, $cVtTV.socketErrorHandler)(this.socket, ()=>this.initWS());
        this.socket.onmessage = (event)=>{
            var _message$data3;
            const message = JSON.parse(event.data);
            console.log("new ws message", message);
            if ((message === null || message === void 0 ? void 0 : message.code) === "unauthorized") // const refreshAndSaveToken = async () => {
            //     const newToken = connectionData.token ? await refreshToken(connectionData.token) : '';
            //     dispatch(userActions.tokenRefreshed({token: newToken}));
            // };
            //
            // refreshAndSaveToken();
            return;
            message.type, $2bf6749be9b2fb23$var$MessageType.CONNECTION_CLOSE;
            message.type, $2bf6749be9b2fb23$var$MessageType.PONG;
            if ((message === null || message === void 0 ? void 0 : (_message$data3 = message.data) === null || _message$data3 === void 0 ? void 0 : _message$data3.status) === "fail") {
                console.log("WS FAIL!!!");
                return;
            }
            switch(message.type){
                case $2bf6749be9b2fb23$var$MessageType.SEND_IS_ONLINE:
                    {
                        const data = message.data;
                        this.changeOnline(data.sender_id, data.online, data.timestamp);
                        break;
                    }
                case $2bf6749be9b2fb23$var$MessageType.CHANGE_CHAT_STATUS:
                    {
                        const chatToUpdate = this.findChat(message.data.chatroom_id);
                        if (!chatToUpdate) return;
                        chatToUpdate.can_patient_chat = message.data.can_patient_chat;
                        break;
                    }
                case $2bf6749be9b2fb23$var$MessageType.NEW:
                    {
                        var _fixedMessage$data$se;
                        const fixedMessage = this.fixSocketMessage(message);
                        const needSendNotification = ((_fixedMessage$data$se = fixedMessage.data.sender) === null || _fixedMessage$data$se === void 0 ? void 0 : _fixedMessage$data$se.id) !== (0, $i6z7r.default).user.id;
                        this.checkChatAndAddMessage(fixedMessage.data, fixedMessage.data.receiver_id, needSendNotification);
                        break;
                    }
                case $2bf6749be9b2fb23$var$MessageType.UPDATE:
                    {
                        const fixedMessage = this.fixSocketMessage(message);
                        this.checkChatAndUpdateMessage(fixedMessage.data, fixedMessage.data.receiver_id);
                        break;
                    }
                case $2bf6749be9b2fb23$var$MessageType.DELETE:
                    this.deleteMessageByOpponent(message.data, message.data.sender);
                    break;
                case $2bf6749be9b2fb23$var$MessageType.NEW_SCHEDULE_INSERT:
                    break;
                case $2bf6749be9b2fb23$var$MessageType.LOAD_FILE:
                    if (message.data.type === "load_file_result") {
                        const messageToEdit = this.findMessageInChat(message.data.receiver, message.data.message_id, message.data.message_uuid);
                        const attachment = this._createMessageAttachmentFromData(message.data);
                        if (!messageToEdit) {
                            this._createMessageWithAttachments(message.data, [
                                attachment
                            ], $2bf6749be9b2fb23$export$74fa6a95f10f26b.FILE, $2bf6749be9b2fb23$export$60c7f05ff615ace0.IMAGE, $2bf6749be9b2fb23$export$4963a2999b5870bb.SENT);
                            return;
                        }
                        messageToEdit.id = message.data.message_id;
                        messageToEdit.uuid = message.data.message_uuid;
                        // messageToEdit.attachments.push(attachment); // Больше не нужно, потому что файлы мы фактически обновляем у себя сами, когда заканчивается процесс загрузки.
                        messageToEdit.data.attachments_number = messageToEdit.attachments.length;
                        if (this.currentChatId === message.data.receiver) this.updateMessageInChat({
                            ...messageToEdit
                        }, message.data.receiver);
                    }
                    if (this.currentChatId === message.data.receiver) this._updateCurrentChatMessages();
                    break;
                case $2bf6749be9b2fb23$var$MessageType.NEW_ATTACHMENT:
                    break;
                default:
                    break;
            }
        };
    }
    get unreadMessagesCount() {
        return this.chats.length ? this.chats.reduce((acc, chat)=>acc + chat.unread_messages_count, 0) : 0;
    }
    _updateUnreadMessagesCountInChat(chat) {
        chat.unread_messages_count += 1;
    }
    setMessageText(text, setPrevText) {
        if (setPrevText) this.currentChatData.prevText = this.currentChatData.text;
        this.currentChatData.text = text;
    }
    get currentMessageText() {
        var _this$currentChatData;
        return ((_this$currentChatData = this.currentChatData) === null || _this$currentChatData === void 0 ? void 0 : _this$currentChatData.text) || "";
    }
    goToChat(chatroomId, needStartCall) {
        if (chatroomId) (0, $lrsw3.history).push(`/chats/${chatroomId}${needStartCall ? "?startCall=true" : ""}`);
    }
    *goToChatFromSchedule(schedule, needStartCall) {
        let roomId;
        // ToDo {6618} если все будет ОК, фичу можно будет удалить
        if (schedule.online_link && (0, $9Toj9.applicationFeatureEnabled)((0, $9Toj9.FEATURE).CHANGED_CHATROOM_CALCULATION)) {
            const separator = schedule.online_link.slice(0, -1).split("/");
            const callId = separator[separator.length - 1];
            const response = yield (0, $kmHuZ.default).call.get(callId);
            roomId = response.room;
        } else {
            const response = yield (0, $kmHuZ.default).chatroom.getByScheduleId(schedule.id);
            roomId = response.id;
        }
        if (!roomId) return;
        this.goToChat(roomId, needStartCall);
    }
    *goToChatWithPatient(patientId, needStartCall) {
        const chatroom = yield (0, $kmHuZ.default).chatroom.getByPatientId(patientId, true);
        if (!chatroom) return;
        this.goToChat(chatroom.id, needStartCall);
    }
    chatHaveMessage(chatId, messageId) {
        if (this.chatsData[chatId]) return this.chatsData[chatId].messages.some((chatMessage)=>chatMessage.id === messageId);
        return false;
    }
    setUnreadChatsCount(count) {
        this.unreadChatsCount = count > 0 ? count : 0;
    }
    updateUnreadChatsCount() {
        if (this.updateUnreadChatsCountTimeout) clearTimeout(this.updateUnreadChatsCountTimeout);
        this.updateUnreadChatsCountTimeout = setTimeout(async ()=>{
            const response = await (0, $kmHuZ.default).chatroom.getUnreadChatsCount();
            this.setUnreadChatsCount(response.count_unread_chat_rooms);
        }, 500);
    }
    *addMessage(message, chatId, needSendNotification) {
        this._checkAndCreateChatData(chatId);
        const chat = this.chats.splice(this.chats.findIndex((chat)=>chat.id === chatId), 1)[0];
        if (chat) {
            var _message$sender;
            this._prepareMessage(message);
            this._checkAndPrepareAttachmentMessage(message);
            if (message.type !== $2bf6749be9b2fb23$export$74fa6a95f10f26b.SYSTEM) chat.last_message = message;
            if (((_message$sender = message.sender) === null || _message$sender === void 0 ? void 0 : _message$sender.id) !== (0, $i6z7r.default).user.id) this._updateUnreadMessagesCountInChat(chat);
            this.chats.unshift(chat);
            if (this.chatHaveMessage(chat.id, message.id)) this.updateMessageInChat(message, chatId);
            else this.chatsData[chatId].messages.push(message);
        }
        if (needSendNotification && message.sender) (0, $1cBan.default)({
            id: message.id,
            data: {
                id: message.receiver_id
            },
            title: `${message.sender.first_name} ${message.sender.last_name}`,
            body: message.message_type === $2bf6749be9b2fb23$export$74fa6a95f10f26b.IMAGE ? "\u041F\u0440\u0438\u0441\u043B\u0430\u043B \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0443" : message.message_type === $2bf6749be9b2fb23$export$74fa6a95f10f26b.FILE ? "\u041F\u0440\u0438\u0441\u043B\u0430\u043B \u0444\u0430\u0439\u043B" : message.text
        });
        this.updateUnreadChatsCount();
    }
    updateMessageInChat(message, chatId) {
        this.chatsData[chatId].messages = this.chatsData[chatId].messages.map((chatMessage)=>{
            if (chatMessage.id === message.id || chatMessage.id === message.uuid) return {
                ...chatMessage,
                ...message
            };
            return chatMessage;
        });
    }
    deleteMessageByOpponent(data, initiator) {
        if (initiator.id === (0, $i6z7r.default).user.id) return;
        if (this.chatsData[data.receiver_id]) this.chatsData[data.receiver_id].messages = this.chatsData[data.receiver_id].messages.filter((message)=>message.id !== data.id);
        const chat = this.chats.find((chat)=>chat.id === data.receiver_id);
        if (chat && data.next_last_message) {
            chat.last_message = data.next_last_message;
            if (!data.is_read && !!chat.unread_messages_count) chat.unread_messages_count--;
        }
        this.updateUnreadChatsCount();
    }
    localUpdateMessage(message, chatId) {
        this._checkAndCreateChatData(chatId);
        const chat = this.chats.splice(this.chats.findIndex((chat)=>chat.id === chatId), 1)[0];
        if (chat) {
            this._prepareMessage(message);
            this._checkAndPrepareAttachmentMessage(message);
            if (chat.last_message && chat.last_message.id === message.id) chat.last_message = message;
            this.chats.unshift(chat);
            this.updateMessageInChat(message, chatId);
        }
    }
    *checkChatAndAddMessage(message, chatId, needSendNotification) {
        if (!this.hasChat(chatId)) yield this.loadChatById(chatId);
        this.addMessage(message, chatId, needSendNotification);
    }
    *checkChatAndUpdateMessage(message, chatId) {
        if (!this.hasChat(chatId)) yield this.loadChatById(chatId);
        this.localUpdateMessage(message, chatId);
    }
    _checkAndCreateChatData(chatId) {
        if (!this.chatsData[chatId]) this.chatsData[chatId] = {
            messages: [],
            text: "",
            prevText: "",
            editingMessageId: 0,
            firstMessagesFetched: false
        };
    }
    addMessages(messages, chatId) {
        this._checkAndCreateChatData(chatId);
        const toAddMessagesIds = messages.map((message)=>message.id);
        const currentMessagesIds = this.chatsData[chatId].messages.map((message)=>message.id);
        const newMessagesIds = (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).difference(toAddMessagesIds, currentMessagesIds);
        if (newMessagesIds.length) {
            const filteredNewMessages = this._prepareMessages(messages.filter((message)=>newMessagesIds.includes(message.id)));
            this.chatsData[chatId].messages = [
                ...filteredNewMessages,
                ...this.chatsData[chatId].messages
            ];
        }
    }
    get currentChatMessages() {
        var _this$currentChatData2, _this$currentChatData3;
        return ((_this$currentChatData2 = this.currentChatData) === null || _this$currentChatData2 === void 0 ? void 0 : (_this$currentChatData3 = _this$currentChatData2.messages) === null || _this$currentChatData3 === void 0 ? void 0 : _this$currentChatData3.filter((message)=>message._type !== $2bf6749be9b2fb23$export$74fa6a95f10f26b.ONLY_FOR_PATIENT)) || [];
    }
    _getMessageType(message) {
        var _message$data4, _message$data5;
        if ((_message$data4 = message.data) !== null && _message$data4 !== void 0 && _message$data4.only_for_patient) return $2bf6749be9b2fb23$export$74fa6a95f10f26b.ONLY_FOR_PATIENT;
        if (message.type === $2bf6749be9b2fb23$export$74fa6a95f10f26b.SYSTEM && ((_message$data5 = message.data) === null || _message$data5 === void 0 ? void 0 : _message$data5.type) === $2bf6749be9b2fb23$export$74fa6a95f10f26b.APPOINTMENT) return $2bf6749be9b2fb23$export$74fa6a95f10f26b.APPOINTMENT;
        if (message.type === $2bf6749be9b2fb23$export$74fa6a95f10f26b.FILE && message.type_message === $2bf6749be9b2fb23$export$60c7f05ff615ace0.FILE && message.attachments.length) return $2bf6749be9b2fb23$export$74fa6a95f10f26b.FILE;
        if (message.type === $2bf6749be9b2fb23$export$74fa6a95f10f26b.FILE && message.type_message === $2bf6749be9b2fb23$export$60c7f05ff615ace0.IMAGE && message.attachments.length) {
            const firstAttachment = message.attachments[0];
            if (!firstAttachment.image_140x120 && !firstAttachment.image_289x300) return $2bf6749be9b2fb23$export$74fa6a95f10f26b.FILE;
            return $2bf6749be9b2fb23$export$74fa6a95f10f26b.IMAGE;
        }
        if (message.type === $2bf6749be9b2fb23$export$74fa6a95f10f26b.IMAGE && message.type_message === $2bf6749be9b2fb23$export$60c7f05ff615ace0.IMAGE && message.attachments.length) return $2bf6749be9b2fb23$export$74fa6a95f10f26b.IMAGE;
        return $2bf6749be9b2fb23$export$74fa6a95f10f26b.TEXT;
    }
    _prepareMessage(message) {
        message._type = this._getMessageType(message);
        message._status = message._status || $2bf6749be9b2fb23$export$4963a2999b5870bb.SENT;
        if (message.receiver_id) message.receiver = message.receiver_id;
        else message.receiver_id = message.receiver;
    }
    _prepareMessages(messages) {
        messages.forEach((message)=>{
            this._prepareMessage(message);
            this._checkAndPrepareAttachmentMessage(message);
        });
        return messages;
    }
    _setChatMessagesPaginationData(pagination) {
        this._checkAndCreateChatData(this.currentChatId);
        if (!pagination.next_page) this.currentChatData.allMessagesLoaded = true;
        else this.currentChatData.nextPage = pagination.next_page;
    }
    async getCurrentChatMessages(page) {
        try {
            (0, $9Qp9d.runInAction)(()=>{
                this.loadingChatMessages = true;
            });
            const response = await (0, $kmHuZ.default).chat.getMessages(this.currentChatId, this.messagesPerPage, page);
            this._setChatMessagesPaginationData(response.pagination);
            return response.results;
        } catch (e) {
            console.log(e);
            $2bf6749be9b2fb23$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                children: [
                    "\u041F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 \u0447\u0430\u0442\u0430 \u0441 ID [",
                    this.currentChatId,
                    "] \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443, \u0441\u043E\u043E\u0431\u0449\u0438\u0432 \u043A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438: ",
                    e.code
                ]
            }), {
                duration: 20000
            });
            return [];
        } finally{
            (0, $9Qp9d.runInAction)(()=>{
                this.loadingChatMessages = false;
            });
        }
    }
    *loadCurrentChatMessages() {
        if (!this.chats.length) return;
        if (this.currentChatData && this.currentChatData.firstMessagesFetched) return;
        if (this.loadingChatMessages) return;
        const currentChatId = this.currentChatId;
        const newMessages = yield this.getCurrentChatMessages(1);
        this.addMessages(newMessages.reverse(), currentChatId);
        this.chatsData[currentChatId].firstMessagesFetched = true;
    }
    *fetchCurrentChatMessages() {
        if (this.loadingChatMessages) return;
        if (this.currentChatData.allMessagesLoaded) return;
        if (!this.currentChatData.firstMessagesFetched) {
            yield this.loadCurrentChatMessages();
            return;
        }
        const currentChatId = this.currentChatId;
        const newMessages = yield this.getCurrentChatMessages(this.currentChatData.nextPage);
        this.addMessages(newMessages.reverse(), currentChatId);
    }
    _getSenderObjectFromCurrentUser() {
        var _authStore$user$docto, _authStore$user$docto2, _authStore$user$docto3;
        return {
            id: (0, $i6z7r.default).user.id || "",
            avatar: (0, $i6z7r.default).user.hex_image || "",
            first_name: ((_authStore$user$docto = (0, $i6z7r.default).user.doctor) === null || _authStore$user$docto === void 0 ? void 0 : _authStore$user$docto.first_name) || "",
            middle_name: ((_authStore$user$docto2 = (0, $i6z7r.default).user.doctor) === null || _authStore$user$docto2 === void 0 ? void 0 : _authStore$user$docto2.middle_name) || "",
            last_name: ((_authStore$user$docto3 = (0, $i6z7r.default).user.doctor) === null || _authStore$user$docto3 === void 0 ? void 0 : _authStore$user$docto3.last_name) || ""
        };
    }
    *sendMessage(text) {
        if (!text) return;
        if (this.editingMessage) {
            this.setMessageText(this.currentChatData.prevText);
            this.currentChatData.prevText = "";
            this.updateMessage(this.editingMessage.id, text);
            this.setEditingMessage(0);
            return;
        }
        this.setMessageText("");
        const data = {
            receiver_id: this.currentChatId,
            receiver_model_name: "ChatRoom",
            text: text
        };
        try {
            const response = yield (0, $kmHuZ.default).chat.sendMessage(data);
            this.addMessage(response, this.currentChatId);
        } catch (e) {
            this._createErrorTextMessage(text);
            return;
        }
        this.readAllMessagesInChat(this.currentChatId);
    }
    *resendMessage(message) {
        const messageType = this._getMessageType(message);
        if (messageType === $2bf6749be9b2fb23$export$74fa6a95f10f26b.TEXT) {
            const text = message.text;
            yield this._deleteMessage(message.id);
            yield this.sendMessage(text);
        }
        if (messageType === $2bf6749be9b2fb23$export$74fa6a95f10f26b.FILE || messageType === $2bf6749be9b2fb23$export$74fa6a95f10f26b.IMAGE) {
            const attachments = [
                ...message.attachments
            ].map((attachment)=>attachment.original_file);
            const typeOfMessage = message.type;
            yield this._deleteMessage(message.id);
            yield this._sendFiles(attachments, typeOfMessage);
        }
    }
    _updateCurrentChatMessages() {
        this.currentChatData.messages = [
            ...this.currentChatData.messages
        ];
    }
    findChat(chatId) {
        if (!chatId) return null;
        return this.chats.find((chat)=>chat.id === chatId) || null;
    }
    findMessageInChat(chatId, messageId, messageUuid = "") {
        if (!this.chatsData[chatId]) return null;
        return this.chatsData[chatId].messages.find((message)=>message.id === messageId) || this.chatsData[chatId].messages.find((message)=>message.id === messageUuid || message.uuid === messageUuid) || null;
    }
    isChatMessageRead(chatId, messageId) {
        const message = this.findMessageInChat(chatId, messageId);
        if (!message) return false;
        return message.is_read;
    }
    messageSenderIsDoctor(chatId, messageId) {
        var _message$sender2, _authStore$user;
        const message = this.findMessageInChat(chatId, messageId);
        if (!message) return false;
        return ((_message$sender2 = message.sender) === null || _message$sender2 === void 0 ? void 0 : _message$sender2.id) === ((_authStore$user = (0, $i6z7r.default).user) === null || _authStore$user === void 0 ? void 0 : _authStore$user.id);
    }
    *updateMessage(id, text) {
        const message = this.currentChatMessages.find((m)=>m.id === id);
        message.text = text;
        this._updateCurrentChatMessages();
        try {
            yield (0, $kmHuZ.default).chat.updateMessage(id, text);
        } catch (e) {
            $2bf6749be9b2fb23$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                children: [
                    "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0441 ID [",
                    id,
                    "] \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443, \u0441\u043E\u043E\u0431\u0449\u0438\u0432 \u043A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438: ",
                    e.code
                ]
            }), {
                duration: 20000
            });
        }
    }
    updateInChatMessageStatus(chatId, message, status) {
        this.updateMessageInChat({
            ...message,
            _status: status
        }, chatId);
    }
    async _createAttachmentsFromFiles(files, type) {
        return Promise.all(files.map(async (file)=>{
            const base64Image = type === $2bf6749be9b2fb23$export$74fa6a95f10f26b.IMAGE ? await (0, $f77a8.getBase64)(file) : "";
            return {
                image_140x120: base64Image,
                image_289x300: base64Image,
                orientation: "",
                original_url: base64Image,
                filename: file.name,
                original_file: file,
                progress: 0,
                loaded: false,
                uuid: (0, $bEzwx.default)()
            };
        }));
    }
    _updateMessageAttachment(chatId, messageUuid, attachmentId, attachmentData) {
        const message = this.findMessageInChat(chatId, null, messageUuid);
        if (message && message.attachments) {
            message.attachments = message.attachments.map((attachment)=>{
                if (attachment.uuid === attachmentId) attachment = {
                    ...attachment,
                    ...attachmentData
                };
                return attachment;
            });
            this.updateInChatMessageStatus(chatId, message, message.attachments.every((attachment)=>attachment.loaded) ? $2bf6749be9b2fb23$export$4963a2999b5870bb.SENT : $2bf6749be9b2fb23$export$4963a2999b5870bb.SENDING);
        }
    }
    *_sendFiles(files, type) {
        const currentChatId = this.currentChatId;
        const messageUUID = (0, $bEzwx.default)();
        const sendMessageData = {
            receiver: currentChatId,
            message_uuid: messageUUID,
            message_type: type,
            receiver_model_name: "ChatRoom"
        };
        const messageData = {
            created_at: new Date().toISOString(),
            id: messageUUID,
            is_changed: false,
            is_read: false,
            receiver: currentChatId,
            sender: this._getSenderObjectFromCurrentUser()
        };
        const typeMessage = type === $2bf6749be9b2fb23$export$74fa6a95f10f26b.FILE ? $2bf6749be9b2fb23$export$60c7f05ff615ace0.FILE : $2bf6749be9b2fb23$export$60c7f05ff615ace0.IMAGE;
        const attachments = yield this._createAttachmentsFromFiles(files, type);
        this._createMessageWithAttachments(messageData, attachments, type, typeMessage, $2bf6749be9b2fb23$export$4963a2999b5870bb.SENDING);
        this._updateCurrentChatMessages();
        try {
            yield (0, $kmHuZ.default).messageAttachments.send(sendMessageData, attachments, (attachmentUuid, percent)=>{
                this._updateMessageAttachment(currentChatId, messageUUID, attachmentUuid, {
                    progress: percent,
                    loaded: percent >= 100
                });
            });
        } catch (e) {
            // TODO: Сообщение уже есть, если словили ошибку, надо менять его статус на ошибка отправки
            this.updateInChatMessageStatus(currentChatId, messageData, $2bf6749be9b2fb23$export$4963a2999b5870bb.ERROR);
        }
    }
    _createErrorTextMessage(text) {
        const messageUUID = (0, $bEzwx.default)();
        const errorMessageData = {
            id: messageUUID,
            uuid: messageUUID,
            sender: this._getSenderObjectFromCurrentUser(),
            receiver: this.currentChatId,
            attachments: [],
            text: text,
            type: $2bf6749be9b2fb23$export$74fa6a95f10f26b.TEXT,
            type_message: "text_message",
            _type: $2bf6749be9b2fb23$export$74fa6a95f10f26b.TEXT,
            _status: $2bf6749be9b2fb23$export$4963a2999b5870bb.ERROR
        };
        this.addMessage(errorMessageData, this.currentChatId);
    }
    _createMessageAttachmentFromData(data) {
        return {
            image_140x120: data.image_140x120,
            image_289x300: data.image_289x300,
            orientation: data.orientation,
            original_url: data.original_url,
            filename: data.name,
            uuid: data.uuid,
            progress: 100,
            loaded: true
        };
    }
    _getAttachmentMessageTextByType(type) {
        if (type === $2bf6749be9b2fb23$export$60c7f05ff615ace0.FILE) return "\uD83D\uDCC4 \u0424\u0430\u0439\u043B";
        if (type === $2bf6749be9b2fb23$export$60c7f05ff615ace0.IMAGE) return "\uD83D\uDDBC\uFE0F \u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435";
        return "";
    }
    _checkAndPrepareAttachmentMessage(message) {
        if ((message.type_message === $2bf6749be9b2fb23$export$60c7f05ff615ace0.FILE || message.type_message === $2bf6749be9b2fb23$export$60c7f05ff615ace0.IMAGE) && !message.text) message.text = this._getAttachmentMessageTextByType(message.type_message);
    }
    _createMessageWithAttachments(data, attachments, type, typeMessage, status) {
        const messageData = {
            attachments: attachments,
            created_at: data.created_at || new Date().toISOString(),
            data: {
                attachments_number: attachments.length
            },
            id: data.message_id || data.id,
            is_changed: data.is_changed,
            is_read: data.is_read,
            receiver: data.receiver,
            sender: data.sender,
            text: null,
            type: type,
            type_message: typeMessage
        };
        messageData._status = status;
        this.addMessage(messageData, data.receiver, false);
    }
    _filesContainIllegalType(files) {
        const checkRegexp = /(\.|\/)(bat|exe|cmd|sh|php([0-9])?|pl|cgi|386|dll|com|torrent|js|app|jar|pif|vb|vbscript|asp|cer|csr|jsp|drv|sys|ade|adp|bas|chm|cpl|crt|csh|fxp|hlp|hta|inf|ins|isp|jse|htaccess|htpasswd|ksh|lnk|mdb|mde|mdt|mdw|msc|msi|msp|mst|ops|pcd|prg|reg|scr|sct|shb|shs|url|vbe|vbs|wsc|wsf|wsh)$/i;
        return [
            ...files
        ].some((file)=>{
            return checkRegexp.test(file.name);
        });
    }
    sendFiles(files) {
        if (this._filesContainIllegalType(files)) {
            $2bf6749be9b2fb23$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                children: "\u0414\u0430\u043D\u043D\u044B\u0439 \u0442\u0438\u043F \u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0435 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D \u0434\u043B\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438."
            }), {
                duration: 20000
            });
            return;
        }
        this._sendFiles(files, $2bf6749be9b2fb23$export$74fa6a95f10f26b.FILE);
    }
    sendImages(images) {
        this._sendFiles(images, $2bf6749be9b2fb23$export$74fa6a95f10f26b.IMAGE);
    }
    deleteMessage(id) {
        this._deleteMessage(id);
    }
    findChatLastMessage(chatId, counter = 1) {
        const chatData = this.chatsData[chatId];
        if (!chatData) return;
        const lastMessage = chatData.messages[chatData.messages.length - counter];
        if ((lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) === $2bf6749be9b2fb23$export$74fa6a95f10f26b.SYSTEM) return this.findChatLastMessage(chatId, counter + 1);
        return lastMessage;
    }
    *_deleteMessage(id) {
        const messageIndex = this.currentChatData.messages.findIndex((m)=>m.id === id);
        const isLastMessage = messageIndex === this.currentChatData.messages.length - 1;
        const [messageToDelete] = this.currentChatData.messages.splice(messageIndex, 1);
        this._updateCurrentChatMessages();
        if ((messageToDelete === null || messageToDelete === void 0 ? void 0 : messageToDelete._status) === $2bf6749be9b2fb23$export$4963a2999b5870bb.ERROR) return;
        try {
            yield (0, $kmHuZ.default).chat.deleteMessage(id);
            if (isLastMessage && this.currentChat) {
                this.currentChat.last_message = this.findChatLastMessage(this.currentChatId);
                this._updateChats();
            }
        } catch (e) {
            $2bf6749be9b2fb23$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                children: [
                    "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0441 ID [",
                    this.currentChatId,
                    "] \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443, \u0441\u043E\u043E\u0431\u0449\u0438\u0432 \u043A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438: ",
                    e.code
                ]
            }), {
                duration: 20000
            });
        }
    }
    get currentChatData() {
        return this.chatsData[this.currentChatId];
    }
    setEditingMessage(id) {
        if (!this.currentChatData) return;
        if (this.currentChatData.editingMessageId === id) return;
        this.currentChatData.editingMessageId = id;
        if (id) this.setMessageText(this.editingMessage.text, true);
        else if (this.currentChatData) {
            this.setMessageText(this.currentChatData.prevText);
            this.currentChatData.prevText = "";
        }
    }
    get editingMessage() {
        return this.currentChatMessages.find((m)=>{
            var _this$currentChatData4;
            return m.id === ((_this$currentChatData4 = this.currentChatData) === null || _this$currentChatData4 === void 0 ? void 0 : _this$currentChatData4.editingMessageId);
        });
    }
    *sendSystemMessage(type) {
        // ToDo !!! нужно доделывать на бекенде
        const data = {
            receiver_id: this.currentChatId,
            receiver_model_name: "ChatRoom",
            data: {
                type: type
            },
            type: $2bf6749be9b2fb23$export$74fa6a95f10f26b.SYSTEM,
            text: type
        };
        const response = yield (0, $kmHuZ.default).chat.sendMessage(data);
        this.addMessage(response, this.currentChatId);
    }
    _prepareChats(chats) {
        chats.forEach((chat)=>{
            chat._type = chat.type === "private_patient" ? $2bf6749be9b2fb23$export$c87fd205be4f689b.CHAT : $2bf6749be9b2fb23$export$c87fd205be4f689b.FOLDER;
            chat.opponent.image = chat.opponent.image || chat.image;
            if (chat.last_message) {
                if (chat.last_message.type !== $2bf6749be9b2fb23$export$74fa6a95f10f26b.SYSTEM) {
                    this._prepareMessage(chat.last_message);
                    this._checkAndPrepareAttachmentMessage(chat.last_message);
                } else delete chat.last_message;
            }
        });
        return chats;
    }
    _setChatsPaginationData(pagination, currentPage = 1) {
        this.chatsPagination.currentPage = currentPage;
        this.chatsPagination.nextPage = pagination.next_page;
        this.chatsPagination.totalPageCount = pagination.total_pages;
    }
    get chatsSearchString() {
        return this.searchText.split(" ").join("-");
    }
    *getChats(page) {
        try {
            this.isChatsLoading = true;
            const response = yield (0, $kmHuZ.default).chatroom.get(this.chatsPagination.perPage, page, this.chatsSearchString, this.selectedFilter);
            response.results = response.results.filter((item)=>item.opponent && item.opponent.first_name && item.opponent.last_name);
            this._setChatsPaginationData(response.pagination, page);
            return response.results;
        } catch (e) {
            if (!e.code) throw e;
            if (e.code === 20) // Отмена запроса пользователем
            throw e;
            $2bf6749be9b2fb23$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                children: [
                    "\u041F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0447\u0430\u0442\u043E\u0432 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443, \u0441\u043E\u043E\u0431\u0449\u0438\u0432 \u043A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438: ",
                    e.code
                ]
            }), {
                duration: 20000
            });
            throw e;
        } finally{
            this.isChatsLoading = false;
        }
    }
    *loadChats() {
        try {
            const newChats = yield this.getChats(1);
            this.chats = this._prepareChats(newChats);
            if (!this.isChatsLoaded) this.isChatsLoaded = true;
        } catch (e) {}
    }
    *updateChats() {
        if (this.isChatsLoading) return;
        if (this.chatsPagination.currentPage >= this.chatsPagination.totalPageCount) return;
        try {
            const newChats = yield this.getChats(this.chatsPagination.nextPage);
            const currentChatIDs = this.chats.map((chat)=>chat.id);
            const responseChatIDs = newChats.map((chat)=>chat.id);
            const newChatsIds = (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).difference(responseChatIDs, currentChatIDs);
            if (newChatsIds.length) {
                const filteredNewChats = this._prepareChats(newChats.filter((chat)=>newChatsIds.includes(chat.id)));
                this.chats = [
                    ...this.chats,
                    ...filteredNewChats
                ];
            }
        } catch (e) {}
    }
    *loadChatById(chatId) {
        const currentChatIDs = this.chats.map((chat)=>chat.id);
        if (currentChatIDs.includes(chatId)) return;
        this.isChatsLoading = true;
        try {
            const response = yield (0, $kmHuZ.default).chatroom.getChatroom({
                chat_id: chatId
            });
            if (response && response.id !== null) {
                const newChats = this._prepareChats([
                    response
                ]);
                this.chats = [
                    ...newChats,
                    ...this.chats
                ];
            }
        } catch (e) {
            $2bf6749be9b2fb23$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                children: [
                    "\u041F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0447\u0430\u0442\u0430 \u0441 ID [",
                    chatId,
                    "] \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443, \u0441\u043E\u043E\u0431\u0449\u0438\u0432 \u043A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438: ",
                    e.code
                ]
            }), {
                duration: 20000
            });
        }
        this.isChatsLoading = false;
    }
    _updateChats() {
        this.chats = (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).cloneDeep(this.chats);
    }
    // *readMessage(message) {
    //   const chatToUpdate = this.findChat(message.receiver);
    //   if (!chatToUpdate) {
    //     return;
    //   }
    //   try {
    //     yield apiv2.chat.readMessageById(message.id);
    //     chatToUpdate.unread_messages_count = 0;
    //     this._updateChats();
    //     this.updateUnreadChatsCount();
    //   } catch(e) {
    //     console.error(e);
    //   }
    // }
    async readAllMessagesInChat(chatId) {
        const chatToUpdate = this.findChat(chatId);
        if (!chatToUpdate) return;
        try {
            this.chatIsReadingNow = true;
            await (0, $kmHuZ.default).chat.readAllMessages(chatId);
            chatToUpdate.unread_messages_count = 0;
            this._updateChats();
            this.chatIsReadingNow = false;
            this.setUnreadChatsCount(this.unreadChatsCount - 1);
        } catch (e) {
            console.error(e);
        }
    }
    hasChat(id) {
        return this.chats.findIndex((chat)=>chat.id === id) > -1;
    }
    setCurrentChatId(id) {
        this.currentChatId = id;
    }
    setCurrentChat(id) {
        this.setCurrentChatId(id);
        if (this.isAnonymousMode) return;
        if (id) {
            this.loadCurrentChatMessages();
            this.setCurrentChatURL(id);
        }
    }
    setPathName(pathname) {
        const currentURL = new URL(window.location.href);
        if (currentURL.pathname !== pathname) {
            currentURL.pathname = pathname;
            window.history.pushState(null, null, currentURL.toString());
        }
    }
    setCurrentChatURL(id) {
        this.setPathName(`/chats/${id}`);
    }
    *changeChatOpenState(chatId, canChat, closingDate) {
        var _authStore$user2;
        const chatToOpen = this.findChat(chatId);
        if (chatToOpen && chatToOpen.opponent && (_authStore$user2 = (0, $i6z7r.default).user) !== null && _authStore$user2 !== void 0 && _authStore$user2.doctor) try {
            yield (0, $kmHuZ.default).chat.changeChatOpenState(chatToOpen.opponent.patient_id, canChat, closingDate);
            chatToOpen.can_patient_chat = canChat;
        } catch (e) {
            console.log(e);
            $2bf6749be9b2fb23$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                children: [
                    "\u041D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u043E\u0441\u044C ",
                    canChat ? "\u043E\u0442\u043A\u0440\u044B\u0442\u044C" : "\u0437\u0430\u043A\u0440\u044B\u0442\u044C",
                    " \u0447\u0430\u0442. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443 \u0441\u043E\u043E\u0431\u0449\u0438\u0432 \u043F\u0440\u0438 \u044D\u0442\u043E\u043C \u043A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438: ",
                    e.code
                ]
            }), {
                duration: 20000
            });
        }
    }
    showCallOpenChatConfirm() {
        this.isCallOpenChatConfirmShowed = true;
    }
    closeCallOpenChatConfirm() {
        this.isCallOpenChatConfirmShowed = false;
    }
    *openChat(chatId, closingDate) {
        yield this.changeChatOpenState(chatId, true, closingDate);
    }
    *closeChat(chatId) {
        yield this.changeChatOpenState(chatId, false);
    }
    closeCurrentChat() {
        this.setCurrentChatId(null);
        this.setPathName(`/chats`);
    }
    *setCallId(callId) {
        if (callId === this.currentCallId) return;
        this.currentCallId = callId;
        try {
            const response = yield (0, $kmHuZ.default).call.get(callId);
            this.setAnonymousMode(response.start_time, response.end_time);
            this.setCurrentChat(response.room);
            this.showCallSettingsScreen();
        } catch (e) {
            $2bf6749be9b2fb23$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                children: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u043E\u043F\u044B\u0442\u043A\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0437\u0432\u043E\u043D\u043E\u043A, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443 \u0438\u043B\u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443."
            }), {
                duration: 20000
            });
        }
    }
    setSearchText(search) {
        this.searchText = search;
    }
    setAnonymousMode(start, end) {
        start = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(start).subtract(15, "minutes");
        end = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(end).add(15, "minutes");
        const callback = ()=>{
            const now = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))();
            this.allowAnonymousMode = true; //now.isAfter(start) && now.isBefore(end); // чтобы не было лишних проблем при запуске
        };
        setInterval(()=>(0, $9Qp9d.runInAction)(callback), 1000);
        callback();
        this.isAnonymousMode = true;
    }
    get currentChat() {
        return this.findChat(this.currentChatId);
    }
    _recalcEnpoints() {
        this.endpoints = this.voxCall.getEndpoints();
    }
    *setCameraId(id) {
        if (this.currentDevices.cameraId === id) return;
        this.currentDevices.cameraId = id;
        if (id !== 0) this.lastSelectedDevices.cameraId = id;
        const cameraManager = (0, $bUAif.Hardware).CameraManager.get();
        if (this.voxCall) yield cameraManager.setCallVideoSettings(this.voxCall, {
            cameraId: id
        });
        else yield cameraManager.setDefaultVideoSettings({
            cameraId: id
        });
    }
    *setMicId(id) {
        if (this.currentDevices.micId === id) return;
        this.currentDevices.micId = id;
        if (id !== 0) this.lastSelectedDevices.micId = id;
        const audioManager = (0, $bUAif.Hardware).AudioDeviceManager.get();
        if (this.voxCall) yield audioManager.setCallAudioSettings(this.voxCall, {
            inputId: id
        });
        else audioManager.setDefaultAudioSettings({
            inputId: id
        });
    }
    *setSpeakerId(id) {
        if (this.currentDevices.speakerId === id) return;
        this.currentDevices.speakerId = id;
        if (id !== 0) this.lastSelectedDevices.speakerId = id;
        const audioManager = (0, $bUAif.Hardware).AudioDeviceManager.get();
        if (this.voxCall) yield audioManager.setCallAudioSettings(this.voxCall, {
            outputId: id
        });
        else audioManager.setDefaultAudioSettings({
            outputId: id
        });
    }
    toggleMinimize() {
        this.videoMinimized = !this.videoMinimized;
    }
    *toggleCamera() {
        this.videoStateChangeInProgress = true;
        const newState = !this.videoEnabled;
        yield this.setCameraId(newState ? this.lastSelectedDevices.cameraId : 0);
        console.log("Camera id:", this.currentDevices.cameraId);
        if (this.voxCall) yield this.voxCall.sendVideo(newState);
        console.log("New videoEnabled state:", newState);
        this.videoEnabled = newState;
        this.videoStateChangeInProgress = false;
    }
    toggleMuteMicrophone() {
        this.microphoneMuteInProgress = true;
        if (this.voxCall) {
            if (this.microphoneMuted) this.voxCall.unmuteMicrophone();
            else this.voxCall.muteMicrophone();
        }
        this.microphoneMuted = !this.microphoneMuted;
        this.microphoneMuteInProgress = false;
    }
    *callConference() {
        var _this$currentChat;
        if (this.voxCall) return;
        let voximplantInstance;
        try {
            voximplantInstance = yield (0, $kfcUT.default).getInstance();
        } catch (e) {
            (0, $7HoMU.captureExceptionToSentry)(e);
            return;
        }
        if (!voximplantInstance.connected()) {
            const reconnectResult = yield (0, $kfcUT.default).connectVoximplantCloud();
            if (!reconnectResult) return;
        }
        if (!this.audioDevices.length) {
            const deviceInitializationResult = yield this.initDevices();
            if (!deviceInitializationResult) return;
        }
        if (this.videoDevices.length) {
            console.log(this.videoEnabled, this.currentDevices.cameraId);
            if (this.videoEnabled) {
                if (!this.currentDevices.cameraId) {
                    console.log("Video enabled but camera not selected");
                    this.setCameraId(this.videoDevices[0].id ?? this.lastSelectedDevices.cameraId);
                }
            } else {
                console.log("Video disabled or camera not selected");
                this.setCameraId(0);
            }
        }
        if (this.showMediaPermissionNotDeviceModal || this.showMediaPermissionLockModal) return;
        this.voxCall = voximplantInstance.callConference({
            number: this.currentChatId,
            simulcast: true,
            video: {
                receiveVideo: true,
                sendVideo: this.videoEnabled
            }
        });
        this.callOpponent = ((_this$currentChat = this.currentChat) === null || _this$currentChat === void 0 ? void 0 : _this$currentChat.opponent) || null;
        this.voxCall.on((0, $bUAif.CallEvents).Connected, (event)=>{
            if (!this.isAnonymousMode) try {
                (0, $kmHuZ.default).chatroom.startCall(this.currentChatId);
            } catch (e) {
                (0, $7HoMU.captureExceptionToSentry)(e);
                $2bf6749be9b2fb23$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: "\u041F\u0440\u0438 \u043F\u043E\u043F\u044B\u0442\u043A\u0435 \u043D\u0430\u0447\u0430\u0442\u044C \u0437\u0432\u043E\u043D\u043E\u043A \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443, \u0438\u043B\u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443."
                }), {
                    duration: 20000
                });
            }
            console.log("VOX Connected", event);
            if (this.microphoneMuted) this.voxCall.muteMicrophone();
        });
        this.voxCall.on((0, $bUAif.CallEvents).EndpointAdded, (event)=>{
            console.log("VOX EndpointAdded", event);
            event.endpoint.on((0, $bUAif.EndpointEvents).RemoteMediaAdded, this._recalcEnpoints);
            event.endpoint.on((0, $bUAif.EndpointEvents).RemoteMediaRemoved, this._recalcEnpoints);
            event.endpoint.on((0, $bUAif.EndpointEvents).RemoteMediaUpdated, this._recalcEnpoints);
            event.endpoint.on((0, $bUAif.EndpointEvents).VoiceStart, ()=>{
                this.setVoiceActive(event.endpoint.id, true);
            });
            event.endpoint.on((0, $bUAif.EndpointEvents).VoiceEnd, ()=>{
                this.setVoiceActive(event.endpoint.id, false);
            });
        });
        this.voxCall.on((0, $bUAif.CallEvents).EndpointRemoved, this._recalcEnpoints);
        this.voxCall.on((0, $bUAif.CallEvents).Failed, (event)=>{
            console.error("VOX Failed", event);
            (0, $7HoMU.captureEventToSentry)(event);
            this.setVoximplantIsReconnecting(false);
            this.showVoximlpantErrorModal();
        });
        this.voxCall.on((0, $bUAif.CallEvents).Disconnected, (event)=>{
            console.error("VOX Disconnected", event);
            (0, $7HoMU.captureEventToSentry)(event);
        });
        this.voxCall.on((0, $bUAif.CallEvents).CallStatsReceived, (event)=>{
            console.log(event);
            this.voxCallStats = event.stats;
        });
        console.log("call created: ", this.voxCall);
    // const cameraManager = CameraManager.get();
    // const devices = await cameraManager.getInputDevices();
    // const device = devices.find((device) => device.id === cameraManager.getCallVideoSettings(this.voxCall).cameraId);
    // const constraints = {
    //     audio: true,
    //     video: {
    //         deviceId: device.id,
    //     }
    // };
    // const media = await navigator.mediaDevices.getUserMedia(constraints);
    // media.getVideoTracks();
    }
    setVoiceActive(endpointId, active) {
        this.voiceActive[endpointId] = active;
    }
    hangup() {
        if (this.voxCall.state() !== "ENDED") // enum не импортнуть и в нем не те значения
        this.voxCall.hangup();
        this.voxCall = null;
        this.voxCallStats = {};
        this.callOpponent = null;
        this.videoMinimized = false;
        this.resetCurrentDevices();
    }
    *searchChats() {
        try {
            const newChats = yield this.getChats(1);
            if (newChats) this.chats = this._prepareChats(newChats);
        } catch (e) {}
    }
    setFilter(filter) {
        this.selectedFilter = filter;
    }
    *startCallForWebView(scheduleId, anonymousLink) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
            event: "callPatient",
            link: anonymousLink
        }));
        const chatroom = yield (0, $kmHuZ.default).chatroom.getByScheduleId(scheduleId);
        if (!chatroom) return;
        (0, $kmHuZ.default).chatroom.startCall(chatroom.id);
    }
    openSettingChatModal() {
        this.isShowSettingChatsModal = true;
    }
    closeSettingChatModal() {
        this.isShowSettingChatsModal = false;
    }
    async setChatSettings(settings) {
        this.closeSettingChatModal();
        try {
            await (0, $kmHuZ.default).chatroom.setSettingsChats(settings);
            (0, $i6z7r.default).updateUser(settings);
        } catch (e) {
            console.error(e);
        }
    }
}
var $2bf6749be9b2fb23$export$2e2bcd8739ae039 = new $2bf6749be9b2fb23$var$ChatStore();

});
parcelRegister("bEzwx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87befc68df50040c$export$2e2bcd8739ae039; });

var $7OiRl = parcelRequire("7OiRl");

var $kknQe = parcelRequire("kknQe");

var $7YxFJ = parcelRequire("7YxFJ");
function $87befc68df50040c$var$v4(options, buf, offset) {
    if ((0, $7OiRl.default).randomUUID && !buf && !options) return (0, $7OiRl.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $kknQe.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $7YxFJ.unsafeStringify)(rnds);
}
var $87befc68df50040c$export$2e2bcd8739ae039 = $87befc68df50040c$var$v4;

});
parcelRegister("7OiRl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5afbd4fb4df23c28$export$2e2bcd8739ae039; });
const $5afbd4fb4df23c28$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $5afbd4fb4df23c28$export$2e2bcd8739ae039 = {
    randomUUID: $5afbd4fb4df23c28$var$randomUUID
};

});

parcelRegister("kknQe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecc82b4b4d5334a5$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $ecc82b4b4d5334a5$var$getRandomValues;
const $ecc82b4b4d5334a5$var$rnds8 = new Uint8Array(16);
function $ecc82b4b4d5334a5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ecc82b4b4d5334a5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $ecc82b4b4d5334a5$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$ecc82b4b4d5334a5$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $ecc82b4b4d5334a5$var$getRandomValues($ecc82b4b4d5334a5$var$rnds8);
}

});

parcelRegister("7YxFJ", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", function () { return $5ce84198744ccadf$export$8fb373d660548968; });

var $jPUoq = parcelRequire("jPUoq");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $5ce84198744ccadf$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$5ce84198744ccadf$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $5ce84198744ccadf$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $5ce84198744ccadf$var$byteToHex[arr[offset + 0]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 1]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 2]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 3]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 4]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 5]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 6]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 7]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 8]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 9]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 10]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 11]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 12]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 13]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 14]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 15]];
}
function $5ce84198744ccadf$var$stringify(arr, offset = 0) {
    const uuid = $5ce84198744ccadf$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $jPUoq.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $5ce84198744ccadf$export$2e2bcd8739ae039 = $5ce84198744ccadf$var$stringify;

});
parcelRegister("jPUoq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e70e86397c656fa2$export$2e2bcd8739ae039; });

var $bjlDU = parcelRequire("bjlDU");
function $e70e86397c656fa2$var$validate(uuid) {
    return typeof uuid === "string" && (0, $bjlDU.default).test(uuid);
}
var $e70e86397c656fa2$export$2e2bcd8739ae039 = $e70e86397c656fa2$var$validate;

});
parcelRegister("bjlDU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83c241de251331e8$export$2e2bcd8739ae039; });
var $83c241de251331e8$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("cxTnx", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("kmHuZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed379aad8da22dff$export$2e2bcd8739ae039; });

var $BH6uL = parcelRequire("BH6uL");

var $VP8uO = parcelRequire("VP8uO");

var $bLYoR = parcelRequire("bLYoR");

var $bLAhB = parcelRequire("bLAhB");

var $2ACAi = parcelRequire("2ACAi");

var $62BIJ = parcelRequire("62BIJ");

var $lhKaP = parcelRequire("lhKaP");

var $joy3t = parcelRequire("joy3t");

var $5GzI7 = parcelRequire("5GzI7");

var $6q8q6 = parcelRequire("6q8q6");

var $l6cLw = parcelRequire("l6cLw");

var $5hCBm = parcelRequire("5hCBm");

var $bkhHb = parcelRequire("bkhHb");

var $cPpOY = parcelRequire("cPpOY");

var $41KWU = parcelRequire("41KWU");

var $3oYiD = parcelRequire("3oYiD");

var $h8EH0 = parcelRequire("h8EH0");

var $5V81B = parcelRequire("5V81B");

var $1YSA2 = parcelRequire("1YSA2");

var $jGbjz = parcelRequire("jGbjz");

var $dkxBT = parcelRequire("dkxBT");

var $iAk1O = parcelRequire("iAk1O");

var $7cLu9 = parcelRequire("7cLu9");

var $6PJu1 = parcelRequire("6PJu1");

var $e4RYP = parcelRequire("e4RYP");

var $eTPwn = parcelRequire("eTPwn");

var $fwL0j = parcelRequire("fwL0j");

var $6qTwl = parcelRequire("6qTwl");

var $22Dzw = parcelRequire("22Dzw");

var $87Nwe = parcelRequire("87Nwe");

var $i5576 = parcelRequire("i5576");

var $3leXE = parcelRequire("3leXE");

var $l2God = parcelRequire("l2God");

var $3NC4z = parcelRequire("3NC4z");

var $ioU0I = parcelRequire("ioU0I");

var $dDnC6 = parcelRequire("dDnC6");

var $c4WNF = parcelRequire("c4WNF");

var $gIhPw = parcelRequire("gIhPw");

var $d5xIL = parcelRequire("d5xIL");

var $QERdR = parcelRequire("QERdR");

var $3C4rQ = parcelRequire("3C4rQ");

var $laM70 = parcelRequire("laM70");

var $dsDBD = parcelRequire("dsDBD");

var $aLBlj = parcelRequire("aLBlj");

var $i31E6 = parcelRequire("i31E6");

var $iRjax = parcelRequire("iRjax");

var $a0zNM = parcelRequire("a0zNM");

var $bWcBU = parcelRequire("bWcBU");

var $g4m5h = parcelRequire("g4m5h");

var $eLvCc = parcelRequire("eLvCc");

var $krsST = parcelRequire("krsST");

var $ebkuB = parcelRequire("ebkuB");

var $gipKl = parcelRequire("gipKl");

var $iOKNH = parcelRequire("iOKNH");
var $ed379aad8da22dff$export$2e2bcd8739ae039 = {
    auth: $BH6uL.default,
    analyses: $VP8uO.default,
    appointmentEvaluation: $bLYoR.default,
    chat: $bLAhB.default,
    vox: $2ACAi.default,
    call: $62BIJ.default,
    config: $lhKaP.default,
    drugs: $joy3t.default,
    diagnoses: $5GzI7.default,
    chatroom: $6q8q6.default,
    payment: $l6cLw.default,
    fdoc: $5hCBm.default,
    fullSchedule: $bkhHb.default,
    schedule: $cPpOY.default,
    scheduleInserts: $41KWU.default,
    services: $3oYiD.default,
    shortcuts: $h8EH0.default,
    messageAttachments: $5V81B.default,
    medicines: $1YSA2.default,
    examinations: $jGbjz.default,
    qualityCriteria: $dkxBT.default,
    documents: $iAk1O.default,
    appointments: $7cLu9.default,
    doctors: $6PJu1.default,
    embryos: $e4RYP.default,
    medicalFiles: $eTPwn.default,
    medicalFilesV2: $fwL0j.default,
    medicalGenomics: $6qTwl.default,
    notices: $22Dzw.default,
    notifications: $87Nwe.default,
    review: $i5576.default,
    reviewStatistics: $3leXE.default,
    organizations: $l2God.default,
    ticket: $3NC4z.default,
    concierge: $ioU0I.default,
    stories: $dDnC6.default,
    metric: $c4WNF.default,
    feedback: $gIhPw.default,
    files: $d5xIL.default,
    uploads: $QERdR.default,
    questionnaire: $3C4rQ.default,
    hospitalAdmissions: $laM70.default,
    oldAuth: $dsDBD.default,
    survey: $aLBlj.default,
    surveyResult: $i31E6.default,
    salesFunnel: $iRjax.default,
    integrations: $bWcBU.default,
    communication: $a0zNM.default,
    prescribedServices: $g4m5h.default,
    VRTReports: $gipKl.default,
    voxPatientConsent: $eLvCc.default,
    dmsServices: $krsST.default,
    newGeneralSchedule: $ebkuB.default,
    programs: $iOKNH.default
};

});
parcelRegister("BH6uL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0714e4534113cf16$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $0714e4534113cf16$var$API_URL = (0, location.origin);
class $0714e4534113cf16$var$Auth {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/users/auth", null, null, $0714e4534113cf16$var$API_URL);
    }
    sendSms(phone) {
        return this.apiService.post("send_sms", {}, {
            phone: phone
        });
    }
    login({ phone: phone, code: code }) {
        return this.apiService.post("login", {}, {
            role: "doctor",
            phone: phone,
            sms_code: code
        });
    }
    registration(params) {
        return this.apiService.post("registration", {}, params);
    }
    refreshToken(refreshToken) {
        return this.apiService.post("refresh", {}, {}, {
            refresh_token: refreshToken
        });
    }
    getCurrentUser() {
        return this.apiService.get("current_user");
    }
    editCurrentUser(data) {
        return this.apiService.patch("current_user", {}, {
            doctor: data
        });
    }
    editCurrentUserDoctor(data) {
        return this.apiService.patch("current_user/doctor", {}, data, {}, false);
    }
}
var $0714e4534113cf16$export$2e2bcd8739ae039 = new $0714e4534113cf16$var$Auth();

});

parcelRegister("VP8uO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0adcfd89530bac93$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $0adcfd89530bac93$var$API_URL = (0, location.origin);
class $0adcfd89530bac93$var$Analyses {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $0adcfd89530bac93$var$API_URL);
    }
    patchAnalyse(id, params) {
        return this.apiService.patch(`analyses/${id}`, {}, params);
    }
    removeAnalyse(id) {
        return this.apiService.delete(`analyses/${id}`);
    }
}
var $0adcfd89530bac93$export$2e2bcd8739ae039 = new $0adcfd89530bac93$var$Analyses();

});

parcelRegister("bLYoR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8922efa9252da6bf$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $8922efa9252da6bf$var$API_URL = (0, location.origin);
class $8922efa9252da6bf$var$AppointmentEvaluation {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $8922efa9252da6bf$var$API_URL);
    }
    getEvaluationById(id) {
        return this.apiService.get(`evaluations/${id}`);
    }
    getAiEvaluationById(id) {
        return this.apiService.get(`ai-evaluations/${id}`);
    }
}
var $8922efa9252da6bf$export$2e2bcd8739ae039 = new $8922efa9252da6bf$var$AppointmentEvaluation();

});

parcelRegister("bLAhB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89103a8d419f430f$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");

var $i6z7r = parcelRequire("i6z7r");

var $kmHuZ = parcelRequire("kmHuZ");
const $89103a8d419f430f$var$API_URL = (0, location.origin);
class $89103a8d419f430f$var$Chat {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/doctor_mobile_api", null, null, $89103a8d419f430f$var$API_URL);
    }
    getMessages(chatId, per_page, page) {
        return this.apiService.get("messages", {
            receiver_id: chatId,
            receiver_model_name: "ChatRoom",
            per_page: per_page,
            page: page
        });
    }
    sendMessage(data) {
        return this.apiService.post("messages", {}, data);
    }
    updateMessage(id, text) {
        return this.apiService.patch(`messages/${id}`, {}, {
            text: text
        });
    }
    deleteMessage(id) {
        return this.apiService.delete(`messages/${id}`);
    }
    // readMessageById(messageId) {
    //   return this.apiService.patch(`mobile-api/messages/${messageId}`, {}, { read: true });
    // }
    readAllMessages(chatId) {
        return this.apiService.patch(`chatroom/${chatId}/unread`);
    }
    async changeChatOpenState(patientId, canChat, closingDate) {
        return await (0, $kmHuZ.default).doctors.patchDoctorPermission((0, $i6z7r.default).user.doctor.id, {
            patient_id: patientId,
            patient_can_chat: canChat,
            close_date: closingDate
        });
    }
}
var $89103a8d419f430f$export$2e2bcd8739ae039 = new $89103a8d419f430f$var$Chat();

});
parcelRegister("i6z7r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0366c65057a13ea6$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $jqdsN = parcelRequire("jqdsN");

var $9Qp9d = parcelRequire("9Qp9d");

var $cxTnx = parcelRequire("cxTnx");

var $kmHuZ = parcelRequire("kmHuZ");

var $iOlMk = parcelRequire("iOlMk");

var $aU5Wn = parcelRequire("aU5Wn");

var $lVvdy = parcelRequire("lVvdy");

var $2F0j2 = parcelRequire("2F0j2");
parcelRequire("bh6RR");

var $5oGqh = parcelRequire("5oGqh");
class $0366c65057a13ea6$var$AuthStore {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "token", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "refreshToken", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "user", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "nextSendTimeMoment", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "_nextSendTimeInterval", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "secondsToNextSend", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isSendButtonActive", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isCodeRequested", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "fieldErrors", {
            phone: "",
            code: ""
        });
        (0, $9Qp9d.makeAutoObservable)(this);
        this.setUser = this.setUser.bind(this);
        this.setToken = this.setToken.bind(this);
        this.setRefreshToken = this.setRefreshToken.bind(this);
        this.cleanFieldError = this.cleanFieldError.bind(this);
        this.resetState = this.resetState.bind(this);
        (0, $iOlMk.currentUser).watch(this.setUser);
        (0, $iOlMk.tokenStore).watch(this.setToken); // Подписываемся на изменения токена в старой сторе
        (0, $iOlMk.refreshTokenStore).watch(this.setRefreshToken); // Подписываемся на изменения токена в старой сторе
    }
    setUser(newUser) {
        this.user = newUser;
    }
    updateUser(data) {
        this.user = {
            ...this.user,
            ...data
        };
    }
    setToken(newToken) {
        this.token = newToken;
        if (newToken === null) this.resetState();
    }
    setRefreshToken(refreshToken) {
        this.refreshToken = refreshToken;
    }
    resetState() {
        this._clearNextSendTimeInterval();
        this.token = null;
        this.refreshToken = null;
        this.user = null;
        this.nextSendTimeMoment = null;
        this.secondsToNextSend = 0;
        this.isSendButtonActive = false;
        this.isCodeRequested = false;
        this.fieldErrors = {
            phone: "",
            code: ""
        };
    }
    _clearNextSendTimeInterval() {
        if (this._nextSendTimeInterval) clearInterval(this._nextSendTimeInterval);
        this._nextSendTimeInterval = null;
    }
    _recalcNextSendTime() {
        if (!this.nextSendTimeMoment) return;
        this.secondsToNextSend = this.nextSendTimeMoment.diff((0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(), "seconds");
        if (this.secondsToNextSend > 0 && !this._nextSendTimeInterval) this._nextSendTimeInterval = setInterval(()=>{
            this._recalcNextSendTime();
        }, 500);
        if (this.secondsToNextSend <= 0) {
            this.isSendButtonActive = true;
            this._clearNextSendTimeInterval();
        }
    }
    _reinitNextSendTimer(timestamp) {
        this.nextSendTimeMoment = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(timestamp);
        this._clearNextSendTimeInterval();
        this._recalcNextSendTime();
    }
    _validatePhoneNumber(phone) {
        const validationResult = (0, $aU5Wn.isValidNumberFunction)(phone);
        this.fieldErrors.phone = !validationResult;
        return validationResult;
    }
    _cleanupPhoneNumber(phone) {
        return phone.replace(/[^0-9]/gi, "");
    }
    cleanFieldError(field) {
        this.fieldErrors[field] = "";
    }
    *sendSms(phone) {
        if (!this._validatePhoneNumber(phone)) return;
        const cleanedPhone = this._cleanupPhoneNumber(phone);
        this.isSendButtonActive = false;
        try {
            const { next_send_time: next_send_time } = yield (0, $kmHuZ.default).auth.sendSms(cleanedPhone);
            this._reinitNextSendTimer(next_send_time);
            this.isCodeRequested = true;
        } catch (e) {
            switch(e.code){
                case 400:
                    this.fieldErrors.phone = "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043D\u043E\u043C\u0435\u0440\u0430";
                    return;
                case 429:
                    this._reinitNextSendTimer(e.result.additional_info.next_send_time);
                    this.isCodeRequested = true;
                    return;
                default:
                    console.error(e);
                    return;
            }
        }
    }
    *login(phone, code) {
        try {
            const cleanedPhone = this._cleanupPhoneNumber(phone);
            const { token: token, refresh_token: refresh_token } = yield (0, $kmHuZ.default).auth.login({
                phone: cleanedPhone,
                code: code
            });
            this.token = token;
            this.refreshToken = refresh_token;
            (0, $iOlMk.setToken)(this.token); // Устанавливаем токен для старой сторы.
            this.user = yield (0, $kmHuZ.default).auth.getCurrentUser();
            (0, $lVvdy.setVoximplantSupportData)({
                client_id: this.user.doctor ? this.user.doctor.id + "" : this.user.id + "",
                client_phone: this.user.username,
                client_display_name: this.user.doctor ? (0, $2F0j2.getLastNameWithInitials)(this.user.doctor) : this.user.username
            });
            if (window.VoxKitWidget) (0, $lVvdy.reInitVoximplant)();
            this.isCodeRequested = false;
        } catch (e) {
            switch(e.code){
                case 400:
                    this.fieldErrors.code = "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043A\u043E\u0434";
                    return;
                default:
                    console.error(e);
                    return;
            }
        }
    }
    async editUser(data) {
        const toastManager = (0, $5oGqh.useToast)();
        try {
            this.user = await (0, $kmHuZ.default).auth.editCurrentUserDoctor(data);
            await (0, $iOlMk.getCurrentUserEffect)({
                token: this.token
            }); // Этот эффект получает, и устанавливает пользователя для старой сторы, через асинхронный реквест внутри. В конструкторе мы подписаны на ее изменение. Токен тут передается в реквест.
            toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                children: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B"
            }), {
                duration: 5000
            });
            return this.user;
        } catch (e) {
            console.error(e);
            toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                children: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430"
            }), {
                duration: 5000
            });
        }
    }
}
var $0366c65057a13ea6$export$2e2bcd8739ae039 = new $0366c65057a13ea6$var$AuthStore();

});
parcelRegister("aU5Wn", function(module, exports) {

$parcel$export(module.exports, "PhoneInputWithIconContainer", function () { return $7f03be018ea8f7c4$export$631a9ee97dab1302; });
$parcel$export(module.exports, "isValidNumberFunction", function () { return $7f03be018ea8f7c4$export$66d323b271c7a32; });
$parcel$export(module.exports, "PhoneInputWithIcon", function () { return $7f03be018ea8f7c4$export$a94adc87035875d3; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $i0wFy = parcelRequire("i0wFy");

var $4eN8l = parcelRequire("4eN8l");

var $gIrEG = parcelRequire("gIrEG");

var $hrbJF = parcelRequire("hrbJF");

var $54eNv = parcelRequire("54eNv");

var $kEUo3 = parcelRequire("kEUo3");
const $7f03be018ea8f7c4$var$StyledInput = (0, $jCoLF.default)((0, $gIrEG.BaseStyledInput)).withConfig({
    displayName: "PhoneInputWithIcon__StyledInput",
    componentId: "sc-fxdghw-0"
})([
    "padding-top:18px;padding-bottom:18px;padding-left:51px;::placeholder{opacity:1;color:",
    ";}"
], (0, $i0wFy.colors).darkBlack);
const $7f03be018ea8f7c4$export$631a9ee97dab1302 = (0, $jCoLF.default).div.withConfig({
    displayName: "PhoneInputWithIcon__PhoneInputWithIconContainer",
    componentId: "sc-fxdghw-1"
})([
    "position:relative;width:100%;"
]);
const $7f03be018ea8f7c4$var$Icon = (0, $jCoLF.default).div.withConfig({
    displayName: "PhoneInputWithIcon__Icon",
    componentId: "sc-fxdghw-2"
})([
    "width:26px;height:26px;background:url(",
    ") no-repeat;background-size:contain;position:absolute;top:16px;left:13px;"
], (props)=>props.icon);
const $7f03be018ea8f7c4$export$66d323b271c7a32 = (value)=>{
    if (typeof value !== "string") return false;
    const obj = (0, $hrbJF.parsePhoneNumber)(value);
    let isValid = obj ? obj.isValid() : false;
    return isValid;
};
const $7f03be018ea8f7c4$export$a94adc87035875d3 = (props)=>{
    const { icon: icon, value: value, ...defaultIconProps } = props;
    const IconComponent = ()=>/*#__PURE__*/ (0, $ih19M.jsx)($7f03be018ea8f7c4$var$Icon, {
            icon: icon
        });
    const inputRef = (0, $bh6RR.useRef)(null);
    const [positionCaret, setPositionCaret] = (0, $bh6RR.useState)(0);
    const [countryISO, setCountryISO] = (0, $bh6RR.useState)("");
    const [country, setCountry] = (0, $bh6RR.useState)(value || "");
    const [oldCountry, setOldCountry] = (0, $bh6RR.useState)(value || "");
    const countryCodeFromValue = ()=>{
        if (!value) return "";
        const phoneInfo = (0, $hrbJF.parsePhoneNumber)(value);
        if (phoneInfo && phoneInfo.country) return (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).find((0, $54eNv.default), {
            iso: phoneInfo.country
        }).code;
        else for(let i = value.length; i > 1; i--){
            if ((0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).find((0, $54eNv.default), {
                code: value.substr(0, i)
            })) return value.substr(0, i);
        }
        return value;
    };
    (0, $bh6RR.useEffect)(()=>{
        if (inputRef !== null) {
            // возвращаем курсор на оригинальную позицию
            inputRef.current.selectionStart = positionCaret;
            inputRef.current.selectionEnd = positionCaret;
        }
    }, [
        positionCaret
    ]);
    (0, $bh6RR.useEffect)(()=>{
        watchCountry();
    }, [
        country
    ]);
    const watchCountry = ()=>{
        if (country) {
            let v = value;
            const countryCodeFromValueData = countryCodeFromValue();
            if (!countryCodeFromValueData && !oldCountry) {
                props.handleChange(country.code + " ");
                return;
            }
            if (countryCodeFromValueData === country.code && v[countryCodeFromValueData.length] === " ") return;
            if (v.indexOf(countryCodeFromValueData + " ") === 0) v = v.replace(countryCodeFromValueData + " ", country.code + " ");
            else v = v.replace(countryCodeFromValueData, country.code + " ");
            props.handleChange(v);
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        updateCountryISO();
        if (formatPhoneNumber(value) !== value) props.handleChange(formatPhoneNumber(value));
        else if (!value.startsWith("+") && $7f03be018ea8f7c4$export$66d323b271c7a32("+" + value)) props.handleChange("+" + formatPhoneNumber(value));
        if (!value) props.handleChange("+");
    }, [
        value
    ]);
    const onInput = (event)=>{
        if (!event.currentTarget.value.startsWith("+")) {
            let newValue = event.currentTarget.value;
            if (newValue.indexOf("+") > -1) {
                newValue = newValue.split("");
                newValue.splice(newValue.indexOf("+"), 1);
            }
            props.handleChange("+" + newValue);
            setPositionCaret(event.target.selectionStart + 1);
        } else {
            let newValue = event.currentTarget.value;
            if (newValue && value.split(" ").length > newValue.split(" ").length) {
                const changeIndex = value.split("").findIndex((item, index)=>item !== newValue.charAt(index));
                const dataSplit = newValue.split("");
                dataSplit.splice(changeIndex - 1, 1);
                newValue = dataSplit.join("");
            }
            const formatNumber = newValue ? formatPhoneNumber(newValue) : "";
            let countSpaceNewValue = newValue.split("");
            if (value.length > newValue.length) countSpaceNewValue.splice(0, event.target.selectionStart);
            countSpaceNewValue = countSpaceNewValue.join("").split(" ").length;
            let countSpaceFormatNumber = formatNumber.split("");
            if (value.length > newValue.length) countSpaceFormatNumber.splice(0, event.target.selectionStart);
            countSpaceFormatNumber = countSpaceFormatNumber.join("").split(" ").length;
            props.handleChange(formatNumber);
            if (value.length > newValue.length) setPositionCaret(newValue.length !== event.currentTarget.value.length ? event.target.selectionStart - (countSpaceNewValue - countSpaceFormatNumber + 1) : event.target.selectionStart);
            else if (countSpaceFormatNumber > countSpaceNewValue) setPositionCaret(event.target.selectionStart + (countSpaceFormatNumber - countSpaceNewValue));
        }
    };
    const onPaste = (pasteValue)=>{
        const v = pasteValue.replace(/(?:\r\n|\r|\n)/g, " ");
        setPhone(v);
    };
    const setPhone = (number)=>{
        let v = number;
        setTimeout(()=>{
            let trimmedV = v.replace(/[^0-9+]/gi, "");
            if (v.startsWith("+")) v = value;
            else {
                const plusValue = "+" + v;
                const obj = (0, $hrbJF.parsePhoneNumber)(plusValue);
                let isValid = obj ? obj.isValid() : false;
                if (isValid) {
                    v = value;
                    trimmedV = plusValue;
                } else if (v.startsWith("8")) {
                    const obj = (0, $hrbJF.parsePhoneNumber)(v.replace("8", "+7"));
                    let isValid = obj ? obj.isValid() : false;
                    if (isValid) v = value;
                }
            }
            if (v !== trimmedV) props.handleChange(formatPhoneNumber(trimmedV));
        });
        return true;
    };
    const updateCountryISO = ()=>{
        const phoneInfo = value ? (0, $hrbJF.parsePhoneNumber)(value) : null;
        let newCountryISO;
        if (phoneInfo && phoneInfo.country) newCountryISO = phoneInfo.country;
        else {
            // определяем страну по коду когда телефон не заполнен
            const newCountry = (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).find((0, $54eNv.default), {
                code: value.trim(),
                priority: 0
            });
            // берем iso из страны
            if (!country || country.code !== (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).get(newCountry, "code", null)) newCountryISO = (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).get(newCountry, "iso", null);
        }
        if (!newCountryISO && country && value.indexOf(country.code) === 0) return;
        setCountryISO(newCountryISO);
    };
    const setCountryValue = ()=>{
        setOldCountry(country);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).find((0, $54eNv.default), {
            iso: countryISO
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        setCountry(setCountryValue);
    }, [
        countryISO
    ]);
    const formatPhoneNumber = (value, notNeedReturnDefaultValue)=>{
        const number = (0, $hrbJF.parsePhoneNumber)(value, country ? country.ISO : "RU");
        if (number) {
            if (number.isValid()) return number.formatInternational().trim();
        }
        return notNeedReturnDefaultValue ? null : value;
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $4eN8l.DefaultInput), {
        ...defaultIconProps,
        handleChange: ()=>{},
        handleInput: onInput,
        onPaste: onPaste,
        value: value,
        onKeyDown: props.onKeyDown,
        inputRef: inputRef,
        overrides: {
            Container: {
                component: $7f03be018ea8f7c4$export$631a9ee97dab1302
            },
            Icon: {
                component: IconComponent
            },
            Input: {
                component: $7f03be018ea8f7c4$var$StyledInput,
                props: {
                    guide: true,
                    ...props.overrides && props.overrides.Input.props || {}
                }
            }
        }
    });
};

});
parcelRegister("4eN8l", function(module, exports) {

$parcel$export(module.exports, "DefaultInput", function () { return $315e9527703e87fa$export$ca23c4c1c3a82f91; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $gIrEG = parcelRequire("gIrEG");
parcelRequire("6m3m5");

var $WJg8y = parcelRequire("WJg8y");
const $315e9527703e87fa$var$Container = (0, $jCoLF.default).div.withConfig({
    displayName: "DefaultInput__Container",
    componentId: "sc-1liquql-0"
})([
    "width:239px;@media (max-width:576px){width:100%;}"
]);
const $315e9527703e87fa$var$Icon = ()=>null;
const $315e9527703e87fa$var$OverridableProps = {
    Container: $315e9527703e87fa$var$Container,
    Input: $gIrEG.BaseStyledInput,
    Icon: $315e9527703e87fa$var$Icon
};
const $315e9527703e87fa$export$ca23c4c1c3a82f91 = (props)=>{
    const onFocus = (event)=>{
        if (props.onFocus) return props.onFocus(event);
        if (props.selectValueAfterFocus) event.target.select();
        return null;
    };
    const overridableProps = typeof props !== "undefined" ? props : undefined && typeof undefined.props !== "undefined" ? undefined.props : arguments[0];
    const overridableComponents = {
        Container: typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Container && overridableProps.overrides.Container.component || $315e9527703e87fa$var$Container,
        Icon: typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Icon && overridableProps.overrides.Icon.component || $315e9527703e87fa$var$Icon,
        Input: typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Input && overridableProps.overrides.Input.component || (0, $gIrEG.BaseStyledInput),
        ErrorContainer: typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.ErrorContainer && overridableProps.overrides.ErrorContainer.component || (0, $WJg8y.ErrorContainer),
        ErrorText: typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.ErrorText && overridableProps.overrides.ErrorText.component || (0, $WJg8y.ErrorText)
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)(overridableComponents.Container, {
        ...typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Container && overridableProps.overrides.Container.props || {},
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)(overridableComponents.Icon, {
                ...typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Icon && overridableProps.overrides.Icon.props || {}
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)(overridableComponents.Input, {
                as: "input",
                name: props.name,
                tabIndex: props.tabIndex,
                type: props.type,
                accept: props.accept,
                ref: props.inputRef,
                className: props.error && "error-field",
                modifiers: [
                    props.error && "error",
                    ...(typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Input && overridableProps.overrides.Input.props || {}).modifiers instanceof Array ? (typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Input && overridableProps.overrides.Input.props || {}).modifiers : [
                        (typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Input && overridableProps.overrides.Input.props || {}).modifiers
                    ]
                ],
                placeholder: props.placeholder,
                value: props.value,
                onChange: (event)=>props.handleChange(event.currentTarget.value),
                onInput: (event)=>props.handleInput && props.handleInput(event),
                onPaste: (event)=>props.onPaste && props.onPaste(event.clipboardData.getData("text")),
                onBlur: props.onBlur && props.onBlur,
                onFocus: onFocus,
                autoFocus: props.autoFocus,
                onKeyDown: props.onKeyDown && props.onKeyDown,
                disabled: props.disabled,
                ...typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.Input && overridableProps.overrides.Input.props || {}
            }),
            props.suffix,
            props.error && typeof props.error === "string" && /*#__PURE__*/ (0, $ih19M.jsx)(overridableComponents.ErrorContainer, {
                ...typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.ErrorContainer && overridableProps.overrides.ErrorContainer.props || {},
                children: /*#__PURE__*/ (0, $ih19M.jsx)(overridableComponents.ErrorText, {
                    ...typeof overridableProps !== "undefined" && overridableProps.overrides && overridableProps.overrides.ErrorText && overridableProps.overrides.ErrorText.props || {},
                    children: props.error
                })
            })
        ]
    });
};

});
parcelRegister("gIrEG", function(module, exports) {

$parcel$export(module.exports, "BaseStyledInput", function () { return $c2b6352531130269$export$a112d3b358046c81; });

var $jCoLF = parcelRequire("jCoLF");

var $6m3m5 = parcelRequire("6m3m5");

var $i0wFy = parcelRequire("i0wFy");

var $bwRDU = parcelRequire("bwRDU");
const $c2b6352531130269$export$a112d3b358046c81 = (0, $bwRDU.withModifiers)({
    error: ()=>`
        border: 2px solid ${(0, $i0wFy.colors).watermelon};
        
        :focus {
            border-color: ${(0, $i0wFy.colors).watermelon};
        }
    `,
    big: ()=>`
        padding: 17px 18px;
    `
})((modifier)=>(0, $jCoLF.default)((0, $6m3m5.InputText)).withConfig({
        displayName: "BaseStyledInput",
        componentId: "sc-1dbw19t-0"
    })([
        "width:100%;padding:13px 18px;box-sizing:border-box;border-radius:4px;border:2px solid ",
        ";font-family:Graphik;transition:border-color 200ms;:focus{border-color:",
        ";outline:none;}::placeholder{opacity:0.6;}",
        ";"
    ], (0, $i0wFy.colors).gray100, (0, $i0wFy.colors).gray300, modifier));

});
parcelRegister("6m3m5", function(module, exports) {

$parcel$export(module.exports, "HeadingH2", function () { return $4a076674358e765e$export$c4e7e3b24473faa; });
$parcel$export(module.exports, "HeadingH3", function () { return $4a076674358e765e$export$b3a9dca7be69ed01; });
$parcel$export(module.exports, "HeadingH4", function () { return $4a076674358e765e$export$2252bf538e6f91f3; });
$parcel$export(module.exports, "HeadingH6", function () { return $4a076674358e765e$export$78e8d94c543fec68; });
$parcel$export(module.exports, "InputText", function () { return $4a076674358e765e$export$7034fcb7d6351061; });
$parcel$export(module.exports, "ButtonCaps", function () { return $4a076674358e765e$export$4959381e34d2cbb9; });
$parcel$export(module.exports, "PLarge", function () { return $4a076674358e765e$export$56096e8843b61787; });
$parcel$export(module.exports, "PNormal", function () { return $4a076674358e765e$export$bb0df77ef1ff8079; });
$parcel$export(module.exports, "PSmall", function () { return $4a076674358e765e$export$854aee7bab005ef7; });
$parcel$export(module.exports, "PXSmall", function () { return $4a076674358e765e$export$dbe1c06f1679d5ea; });
$parcel$export(module.exports, "PSidebar", function () { return $4a076674358e765e$export$23d7b2a5df81323d; });
$parcel$export(module.exports, "PList", function () { return $4a076674358e765e$export$38a65f4a1315300; });
$parcel$export(module.exports, "PPrintNormal", function () { return $4a076674358e765e$export$3ae7cca0ae70998a; });
$parcel$export(module.exports, "PSignNormal", function () { return $4a076674358e765e$export$9ab7696dec322ef7; });
$parcel$export(module.exports, "CaptionSmall", function () { return $4a076674358e765e$export$106a9dc29d409807; });

var $jCoLF = parcelRequire("jCoLF");

var $bwRDU = parcelRequire("bwRDU");

var $i0wFy = parcelRequire("i0wFy");
const $4a076674358e765e$var$color = ()=>`
    color: ${(0, $i0wFy.colors).magenta}
`;
const $4a076674358e765e$var$light = ()=>`
    color: ${(0, $i0wFy.colors).white};
`;
const $4a076674358e765e$var$gray = ()=>`
  color: ${(0, $i0wFy.colors).gray700};
`;
const $4a076674358e765e$var$center = ()=>`
    text-align: center;
`;
const $4a076674358e765e$var$left = ()=>`
    text-align: left;
`;
const $4a076674358e765e$var$uppercase = ()=>`
    text-transform: uppercase;
`;
const $4a076674358e765e$var$capitalize = ()=>`
    text-transform: capitalize;
`;
const $4a076674358e765e$var$nowrap = ()=>`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
const $4a076674358e765e$var$breakWords = ()=>`
    word-wrap: break-word;
    word-break: break-word;
`;
const $4a076674358e765e$var$TEXT_MODIFIER_CONFIG = {
    color: $4a076674358e765e$var$color,
    light: $4a076674358e765e$var$light,
    gray: $4a076674358e765e$var$gray,
    center: $4a076674358e765e$var$center,
    left: $4a076674358e765e$var$left,
    uppercase: $4a076674358e765e$var$uppercase,
    capitalize: $4a076674358e765e$var$capitalize,
    nowrap: $4a076674358e765e$var$nowrap,
    breakWords: $4a076674358e765e$var$breakWords
};
const $4a076674358e765e$var$BaseText = (0, $jCoLF.css)([
    "color:",
    ";"
], (0, $i0wFy.colors).black);
const $4a076674358e765e$export$afacfc15967fe88d = (0, $bwRDU.withModifiers)($4a076674358e765e$var$TEXT_MODIFIER_CONFIG)((modifier)=>(0, $jCoLF.default).p.withConfig({
        displayName: "typography__HeadingDisplay",
        componentId: "sc-g6wq1p-0"
    })([
        "font-size:56px;line-height:1.25;font-weight:500;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$595825224f3170c6 = (0, $bwRDU.withModifiers)($4a076674358e765e$var$TEXT_MODIFIER_CONFIG)((modifier)=>(0, $jCoLF.default).h1.withConfig({
        displayName: "typography__HeadingH1",
        componentId: "sc-g6wq1p-1"
    })([
        "font-size:53px;line-height:1.32;",
        ";",
        ";@media (max-width:768px){font-size:46px;}"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$c4e7e3b24473faa = (0, $bwRDU.withModifiers)($4a076674358e765e$var$TEXT_MODIFIER_CONFIG)((modifier)=>(0, $jCoLF.default).h2.withConfig({
        displayName: "typography__HeadingH2",
        componentId: "sc-g6wq1p-2"
    })([
        "font-size:38px;",
        ";",
        ";@media (max-width:768px){font-size:32px;}@media (max-width:480px){font-size:25px;}"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$b3a9dca7be69ed01 = (0, $bwRDU.withModifiers)($4a076674358e765e$var$TEXT_MODIFIER_CONFIG)((modifier)=>(0, $jCoLF.default).h3.withConfig({
        displayName: "typography__HeadingH3",
        componentId: "sc-g6wq1p-3"
    })([
        "font-size:30px;",
        ";",
        ";@media (max-width:768px){font-size:24px;}@media (max-width:480px){font-size:20px;}"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$2252bf538e6f91f3 = (0, $bwRDU.withModifiers)({
    left: ()=>`
        font-size: 22px;
        text-align: left;
    `,
    capitalize: $4a076674358e765e$var$capitalize
})((modifier)=>(0, $jCoLF.default).h4.withConfig({
        displayName: "typography__HeadingH4",
        componentId: "sc-g6wq1p-4"
    })([
        "font-size:22px;",
        ";",
        ";@media (max-width:768px){font-size:18px;}"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$58e93b2495d40467 = (0, $bwRDU.withModifiers)($4a076674358e765e$var$TEXT_MODIFIER_CONFIG)((modifier)=>(0, $jCoLF.default).h5.withConfig({
        displayName: "typography__HeadingH5",
        componentId: "sc-g6wq1p-5"
    })([
        "font-size:20px;line-height:1.5;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$78e8d94c543fec68 = (0, $bwRDU.withModifiers)($4a076674358e765e$var$TEXT_MODIFIER_CONFIG)((modifier)=>(0, $jCoLF.default).h6.withConfig({
        displayName: "typography__HeadingH6",
        componentId: "sc-g6wq1p-6"
    })([
        "font-size:17px;line-height:1.35;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$76d3231fec538b73 = (0, $bwRDU.withModifiers)({
    small: ()=>`
        font-size: 12px;
    `,
    normal: ()=>`
        font-size: 12px;

        letter-spacing: 0.77;
    `
})((modifier)=>(0, $jCoLF.default).span.withConfig({
        displayName: "typography__InputLabel",
        componentId: "sc-g6wq1p-7"
    })([
        "color:",
        ";",
        ";",
        ";"
    ], (0, $i0wFy.colors).darkBlack, $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$7034fcb7d6351061 = (0, $bwRDU.withModifiers)({
    small: ()=>`
    font-size: 14px;
  `,
    error: ()=>`
        color: ${(0, $i0wFy.colors).watermelon};
    `,
    success: ()=>`
        color: #45c53a;
    `,
    placeholder: ()=>`
        opacity: 0.6;
        line-height: 1.35;
        color: ${(0, $i0wFy.colors).darkBlack};
    `
})((modifier)=>(0, $jCoLF.default).span.withConfig({
        displayName: "typography__InputText",
        componentId: "sc-g6wq1p-8"
    })([
        "font-size:17px;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$4959381e34d2cbb9 = (0, $bwRDU.withModifiers)({
    center: ()=>`
        font-size: 13px;

        letter-spacing: 1.1;
        text-align: center;
    `,
    left: ()=>`
        font-size: 12px;

        letter-spacing: 0.2;
    `,
    uppercase: $4a076674358e765e$var$uppercase,
    color: $4a076674358e765e$var$color
})((modifier)=>(0, $jCoLF.default).span.withConfig({
        displayName: "typography__ButtonCaps",
        componentId: "sc-g6wq1p-9"
    })([
        "font-weight:500;",
        ";",
        ";font-size:",
        ";@media screen and (max-width:1200px){font-size:",
        ";text-align:center;}"
    ], $4a076674358e765e$var$BaseText, modifier, (props)=>!!props.fontSize && props.fontSize, (props)=>!!props.fontSize && "12px"));
const $4a076674358e765e$export$d9239abb93ac654b = (0, $bwRDU.withModifiers)({
    red: ()=>`
        color: #e3051c;
    `,
    primary: ()=>`
        font-size: 15px;
    
        color: #0067a2;
    `
})((modifier)=>(0, $jCoLF.default).span.withConfig({
        displayName: "typography__ButtonCenter",
        componentId: "sc-g6wq1p-10"
    })([
        "font-size:14px;font-weight:500;letter-spacing:0.21;text-align:center;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$56096e8843b61787 = (0, $bwRDU.withModifiers)($4a076674358e765e$var$TEXT_MODIFIER_CONFIG)((modifier)=>(0, $jCoLF.default).p.withConfig({
        displayName: "typography__PLarge",
        componentId: "sc-g6wq1p-11"
    })([
        "font-size:22px;line-height:1.5;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$bb0df77ef1ff8079 = (0, $bwRDU.withModifiers)({
    ...$4a076674358e765e$var$TEXT_MODIFIER_CONFIG,
    light: ()=>`
        font-size: 17px;
        line-height: 1.59;
        color: ${(0, $i0wFy.colors).white};
    `,
    left: ()=>`
        font-size: 15px;
        line-height: 1.53;
    `
})((modifier)=>(0, $jCoLF.default).p.withConfig({
        displayName: "typography__PNormal",
        componentId: "sc-g6wq1p-12"
    })([
        "font-size:16px;line-height:1.69;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$854aee7bab005ef7 = (0, $bwRDU.withModifiers)({
    ...$4a076674358e765e$var$TEXT_MODIFIER_CONFIG,
    "1": ()=>`
    font-size: 14px;
    line-height: 1.64;
    `,
    "2": ()=>`
    font-size: 18px;
    line-height: 1.64;
    `
})((modifier)=>(0, $jCoLF.default).p.withConfig({
        displayName: "typography__PSmall",
        componentId: "sc-g6wq1p-13"
    })([
        "font-size:15px;line-height:1.53;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$dbe1c06f1679d5ea = (0, $bwRDU.withModifiers)({
    ...$4a076674358e765e$var$TEXT_MODIFIER_CONFIG,
    center: ()=>`
        font-size: 11px;
        text-align: center;
    `,
    left: ()=>`
        font-size: 12px;
    `,
    averageSize: ()=>`
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 23px;
        letter-spacing: 0.3px;
    `
})((modifier)=>(0, $jCoLF.default).p.withConfig({
        displayName: "typography__PXSmall",
        componentId: "sc-g6wq1p-14"
    })([
        "color:#595959;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$23d7b2a5df81323d = (0, $bwRDU.withModifiers)($4a076674358e765e$var$TEXT_MODIFIER_CONFIG)((modifier)=>(0, $jCoLF.default).p.withConfig({
        displayName: "typography__PSidebar",
        componentId: "sc-g6wq1p-15"
    })([
        "font-size:15px;line-height:1.27;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$38a65f4a1315300 = (0, $bwRDU.withModifiers)({
    ...$4a076674358e765e$var$TEXT_MODIFIER_CONFIG,
    disabled: ()=>`
     line-height: 1.77;
     color: #595959;
`
})((modifier)=>(0, $jCoLF.default).p.withConfig({
        displayName: "typography__PList",
        componentId: "sc-g6wq1p-16"
    })([
        "font-size:13px;line-height:1.54;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$3ae7cca0ae70998a = (0, $bwRDU.withModifiers)($4a076674358e765e$var$TEXT_MODIFIER_CONFIG)((modifier)=>(0, $jCoLF.default).p.withConfig({
        displayName: "typography__PPrintNormal",
        componentId: "sc-g6wq1p-17"
    })([
        "font-size:17px;line-height:1.35;display:inline;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$9ab7696dec322ef7 = (0, $bwRDU.withModifiers)($4a076674358e765e$var$TEXT_MODIFIER_CONFIG)((modifier)=>(0, $jCoLF.default).p.withConfig({
        displayName: "typography__PSignNormal",
        componentId: "sc-g6wq1p-18"
    })([
        "font-size:14px;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$86243584e5b806d3 = (0, $bwRDU.withModifiers)($4a076674358e765e$var$TEXT_MODIFIER_CONFIG)((modifier)=>(0, $jCoLF.default).span.withConfig({
        displayName: "typography__CaptionLarge",
        componentId: "sc-g6wq1p-19"
    })([
        "font-size:18px;font-weight:500;line-height:1.56;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$dd24bf2deb791635 = (0, $bwRDU.withModifiers)($4a076674358e765e$var$TEXT_MODIFIER_CONFIG)((modifier)=>(0, $jCoLF.default).span.withConfig({
        displayName: "typography__CaptionNormal",
        componentId: "sc-g6wq1p-20"
    })([
        "font-size:16px;font-weight:500;line-height:1.44;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));
const $4a076674358e765e$export$106a9dc29d409807 = (0, $bwRDU.withModifiers)($4a076674358e765e$var$TEXT_MODIFIER_CONFIG)((modifier)=>(0, $jCoLF.default).span.withConfig({
        displayName: "typography__CaptionSmall",
        componentId: "sc-g6wq1p-21"
    })([
        "font-size:14px;font-weight:500;line-height:1.64;",
        ";",
        ";"
    ], $4a076674358e765e$var$BaseText, modifier));

});


parcelRegister("WJg8y", function(module, exports) {

$parcel$export(module.exports, "ButtonContainer", function () { return $0b08867196a83822$export$eddf54ea3db8d0f0; });
$parcel$export(module.exports, "ErrorContainer", function () { return $0b08867196a83822$export$97bdf39f6b82bb0; });
$parcel$export(module.exports, "ErrorText", function () { return $0b08867196a83822$export$7f714e6c560938e5; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $6m3m5 = parcelRequire("6m3m5");
const $0b08867196a83822$export$eddf54ea3db8d0f0 = (0, $jCoLF.default).div.withConfig({
    displayName: "form__ButtonContainer",
    componentId: "sc-1fsn2sn-0"
})([
    "display:flex;justify-content:center;width:100%;margin-top:42px;"
]);
const $0b08867196a83822$export$97bdf39f6b82bb0 = (0, $jCoLF.default).div.withConfig({
    displayName: "form__ErrorContainer",
    componentId: "sc-1fsn2sn-1"
})([
    "margin-top:9px;"
]);
const $0b08867196a83822$export$7f714e6c560938e5 = (props)=>{
    const modifiers = [
        "error"
    ];
    if (props.small) modifiers.push("small");
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $6m3m5.InputText), {
        ...props,
        modifiers: modifiers
    });
};

});


parcelRegister("hrbJF", function(module, exports) {

$parcel$export(module.exports, "parsePhoneNumber", function () { return $cb1e0fb97d7caca7$export$da44e4eaa54bc82e; });

var $hEzMX = parcelRequire("hEzMX");

var $jAzy7 = parcelRequire("jAzy7");
function $cb1e0fb97d7caca7$export$da44e4eaa54bc82e() {
    return (0, $hEzMX.default)((0, $jAzy7.default), arguments);
}

});
parcelRegister("hEzMX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cda1eef71ec16460$export$2e2bcd8739ae039; });
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.

var $1SFRu = parcelRequire("1SFRu");
function $cda1eef71ec16460$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $1SFRu.default));
    return func.apply(this, args);
}

});
parcelRegister("1SFRu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15eb4e709507c360$export$2e2bcd8739ae039; });
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $15eb4e709507c360$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "596\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[047]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|80\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-8]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:5056(?:[0-35-9]\\d|4[468])|7302[01]\\d)\\d{4}|(?:472[24]|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};

});


parcelRegister("jAzy7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e42cf474d7e9eeec$export$2e2bcd8739ae039; });

var $6PLTv = parcelRequire("6PLTv");

var $383DE = parcelRequire("383DE");
function $e42cf474d7e9eeec$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $6PLTv.default)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $383DE.default)(text, options, metadata);
}

});
parcelRegister("6PLTv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f9ca846d94f561c$export$2e2bcd8739ae039; });

var $lXLrE = parcelRequire("lXLrE");
function $4f9ca846d94f561c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4f9ca846d94f561c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4f9ca846d94f561c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4f9ca846d94f561c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4f9ca846d94f561c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4f9ca846d94f561c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4f9ca846d94f561c$var$_slicedToArray(arr, i) {
    return $4f9ca846d94f561c$var$_arrayWithHoles(arr) || $4f9ca846d94f561c$var$_iterableToArrayLimit(arr, i) || $4f9ca846d94f561c$var$_unsupportedIterableToArray(arr, i) || $4f9ca846d94f561c$var$_nonIterableRest();
}
function $4f9ca846d94f561c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4f9ca846d94f561c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4f9ca846d94f561c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4f9ca846d94f561c$var$_arrayLikeToArray(o, minLen);
}
function $4f9ca846d94f561c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4f9ca846d94f561c$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $4f9ca846d94f561c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $4f9ca846d94f561c$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $4f9ca846d94f561c$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === "string") text = arg_1;
    else throw new TypeError("A text for parsing must be a string."); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === "string") {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $4f9ca846d94f561c$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $lXLrE.default)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}

});
parcelRegister("lXLrE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffd3e93b82139779$export$2e2bcd8739ae039; });
var $ffd3e93b82139779$var$objectConstructor = {}.constructor;
function $ffd3e93b82139779$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $ffd3e93b82139779$var$objectConstructor;
}

});


parcelRegister("383DE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2474f0f6c921b3f2$export$2e2bcd8739ae039; });

var $9o2Cy = parcelRequire("9o2Cy");

var $g9Xi3 = parcelRequire("g9Xi3");

var $55Agv = parcelRequire("55Agv");
function $2474f0f6c921b3f2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2474f0f6c921b3f2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2474f0f6c921b3f2$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2474f0f6c921b3f2$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2474f0f6c921b3f2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2474f0f6c921b3f2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2474f0f6c921b3f2$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $55Agv.isSupportedCountry)(options.defaultCountry, metadata)) options = $2474f0f6c921b3f2$var$_objectSpread($2474f0f6c921b3f2$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $9o2Cy.default)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $g9Xi3.default)) ;
        else throw error;
    }
}

});
parcelRegister("9o2Cy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d586362e050fb84$export$2e2bcd8739ae039; });

var $7LoMS = parcelRequire("7LoMS");
function $6d586362e050fb84$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6d586362e050fb84$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6d586362e050fb84$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6d586362e050fb84$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6d586362e050fb84$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6d586362e050fb84$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6d586362e050fb84$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $7LoMS.default)(text, $6d586362e050fb84$var$_objectSpread($6d586362e050fb84$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}

});
parcelRegister("7LoMS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a70266c8af1f1ea$export$2e2bcd8739ae039; });
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js

var $k4lD9 = parcelRequire("k4lD9");

var $g9Xi3 = parcelRequire("g9Xi3");

var $55Agv = parcelRequire("55Agv");

var $2FyAa = parcelRequire("2FyAa");

var $2qz2P = parcelRequire("2qz2P");

var $ukbhN = parcelRequire("ukbhN");

var $55Agv = parcelRequire("55Agv");

var $iwTul = parcelRequire("iwTul");

var $29nxu = parcelRequire("29nxu");

var $iBVES = parcelRequire("iBVES");

var $6ChII = parcelRequire("6ChII");

var $goXCH = parcelRequire("goXCH");


var $77fVj = parcelRequire("77fVj");

var $5co6P = parcelRequire("5co6P");
// This prevents malicious input from consuming CPU.
var $5a70266c8af1f1ea$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $5a70266c8af1f1ea$var$PHONE_NUMBER_START_PATTERN = new RegExp("[" + (0, $k4lD9.PLUS_CHARS) + (0, $k4lD9.VALID_DIGITS) + "]"); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $5a70266c8af1f1ea$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + (0, $k4lD9.VALID_DIGITS) + "#" + "]+$");
var $5a70266c8af1f1ea$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $5a70266c8af1f1ea$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $55Agv.default)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $g9Xi3.default)("INVALID_COUNTRY");
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $5a70266c8af1f1ea$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === "TOO_SHORT") throw new (0, $g9Xi3.default)("TOO_SHORT");
            throw new (0, $g9Xi3.default)("NOT_A_NUMBER");
        }
        return {};
    }
    var _parsePhoneNumber = $5a70266c8af1f1ea$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $g9Xi3.default)("INVALID_COUNTRY");
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $k4lD9.MIN_LENGTH_FOR_NSN)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $g9Xi3.default)("TOO_SHORT");
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $k4lD9.MAX_LENGTH_FOR_NSN)) {
        if (options.v2) throw new (0, $g9Xi3.default)("TOO_LONG");
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $29nxu.default)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $iBVES.default)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $5a70266c8af1f1ea$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $iwTul.isPossibleNumber)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $5a70266c8af1f1ea$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $5a70266c8af1f1ea$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $g9Xi3.default)("TOO_LONG");
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($5a70266c8af1f1ea$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($5a70266c8af1f1ea$var$AFTER_PHONE_NUMBER_END_PATTERN, "");
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $5a70266c8af1f1ea$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $5co6P.default)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $5a70266c8af1f1ea$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $2FyAa.default)(number)) {
        if ((0, $2FyAa.isViablePhoneNumberStart)(number)) return {
            error: "TOO_SHORT"
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $2qz2P.default)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $5a70266c8af1f1ea$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $5a70266c8af1f1ea$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $6ChII.default)((0, $ukbhN.default)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($5a70266c8af1f1ea$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = "001";
            }
        }
        countryCallingCode = defaultCallingCode || (0, $55Agv.getCountryCallingCode)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $goXCH.default)((0, $ukbhN.default)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $77fVj.default)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === "001") ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}

});
parcelRegister("k4lD9", function(module, exports) {

$parcel$export(module.exports, "MIN_LENGTH_FOR_NSN", function () { return $e9c4f5b6788356e3$export$cd8355bcbe13154; });
$parcel$export(module.exports, "MAX_LENGTH_FOR_NSN", function () { return $e9c4f5b6788356e3$export$85ddd8c9b243679b; });
$parcel$export(module.exports, "MAX_LENGTH_COUNTRY_CODE", function () { return $e9c4f5b6788356e3$export$514717690676fb4a; });
$parcel$export(module.exports, "VALID_DIGITS", function () { return $e9c4f5b6788356e3$export$852d1d4a47329634; });
$parcel$export(module.exports, "VALID_PUNCTUATION", function () { return $e9c4f5b6788356e3$export$7f01587e28f9194; });
$parcel$export(module.exports, "PLUS_CHARS", function () { return $e9c4f5b6788356e3$export$207c99ccf3902df8; });
// The minimum length of the national significant number.
var $e9c4f5b6788356e3$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $e9c4f5b6788356e3$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $e9c4f5b6788356e3$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $e9c4f5b6788356e3$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $e9c4f5b6788356e3$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $e9c4f5b6788356e3$var$SLASHES = "\uFF0F/";
var $e9c4f5b6788356e3$var$DOTS = "\uFF0E.";
var $e9c4f5b6788356e3$export$20542845033f576e = " \xa0\xad\u200B\u2060\u3000";
var $e9c4f5b6788356e3$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $e9c4f5b6788356e3$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $e9c4f5b6788356e3$export$7f01587e28f9194 = "".concat($e9c4f5b6788356e3$var$DASHES).concat($e9c4f5b6788356e3$var$SLASHES).concat($e9c4f5b6788356e3$var$DOTS).concat($e9c4f5b6788356e3$export$20542845033f576e).concat($e9c4f5b6788356e3$var$BRACKETS).concat($e9c4f5b6788356e3$var$TILDES);
var $e9c4f5b6788356e3$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

});

parcelRegister("g9Xi3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc3b7a66960a1eb6$export$2e2bcd8739ae039; });
function $bc3b7a66960a1eb6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $bc3b7a66960a1eb6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bc3b7a66960a1eb6$var$_typeof(obj);
}
function $bc3b7a66960a1eb6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bc3b7a66960a1eb6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bc3b7a66960a1eb6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bc3b7a66960a1eb6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bc3b7a66960a1eb6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bc3b7a66960a1eb6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $bc3b7a66960a1eb6$var$_setPrototypeOf(subClass, superClass);
}
function $bc3b7a66960a1eb6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bc3b7a66960a1eb6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $bc3b7a66960a1eb6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bc3b7a66960a1eb6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bc3b7a66960a1eb6$var$_possibleConstructorReturn(this, result);
    };
}
function $bc3b7a66960a1eb6$var$_possibleConstructorReturn(self, call) {
    if (call && ($bc3b7a66960a1eb6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $bc3b7a66960a1eb6$var$_assertThisInitialized(self);
}
function $bc3b7a66960a1eb6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bc3b7a66960a1eb6$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $bc3b7a66960a1eb6$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$bc3b7a66960a1eb6$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $bc3b7a66960a1eb6$var$_construct(Class, arguments, $bc3b7a66960a1eb6$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $bc3b7a66960a1eb6$var$_setPrototypeOf(Wrapper, Class);
    };
    return $bc3b7a66960a1eb6$var$_wrapNativeSuper(Class);
}
function $bc3b7a66960a1eb6$var$_construct(Parent, args, Class) {
    if ($bc3b7a66960a1eb6$var$_isNativeReflectConstruct()) $bc3b7a66960a1eb6$var$_construct = Reflect.construct;
    else $bc3b7a66960a1eb6$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $bc3b7a66960a1eb6$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $bc3b7a66960a1eb6$var$_construct.apply(null, arguments);
}
function $bc3b7a66960a1eb6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bc3b7a66960a1eb6$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $bc3b7a66960a1eb6$var$_setPrototypeOf(o, p) {
    $bc3b7a66960a1eb6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bc3b7a66960a1eb6$var$_setPrototypeOf(o, p);
}
function $bc3b7a66960a1eb6$var$_getPrototypeOf(o) {
    $bc3b7a66960a1eb6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bc3b7a66960a1eb6$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $bc3b7a66960a1eb6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $bc3b7a66960a1eb6$var$_inherits(ParseError, _Error);
    var _super = $bc3b7a66960a1eb6$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $bc3b7a66960a1eb6$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($bc3b7a66960a1eb6$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $bc3b7a66960a1eb6$var$_createClass(ParseError);
}(/*#__PURE__*/ $bc3b7a66960a1eb6$var$_wrapNativeSuper(Error));

});

parcelRegister("55Agv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b498ce85b60edf8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getCountryCallingCode", function () { return $3b498ce85b60edf8$export$32876ca2f1919cf0; });
$parcel$export(module.exports, "isSupportedCountry", function () { return $3b498ce85b60edf8$export$bd9e113b8b17202a; });

var $ijgwv = parcelRequire("ijgwv");

var $lXLrE = parcelRequire("lXLrE");
function $3b498ce85b60edf8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3b498ce85b60edf8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3b498ce85b60edf8$var$_typeof(obj);
}
function $3b498ce85b60edf8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3b498ce85b60edf8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3b498ce85b60edf8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3b498ce85b60edf8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3b498ce85b60edf8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $3b498ce85b60edf8$var$V2 = "1.0.18"; // Added "idd_prefix" and "default_idd_prefix".
var $3b498ce85b60edf8$var$V3 = "1.2.0"; // Moved `001` country code to "nonGeographic" section of metadata.
var $3b498ce85b60edf8$var$V4 = "1.7.35";
var $3b498ce85b60edf8$var$DEFAULT_EXT_PREFIX = " ext. ";
var $3b498ce85b60edf8$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $3b498ce85b60edf8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $3b498ce85b60edf8$var$_classCallCheck(this, Metadata);
        $3b498ce85b60edf8$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $3b498ce85b60edf8$var$setVersion.call(this, metadata);
    }
    $3b498ce85b60edf8$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $3b498ce85b60edf8$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== "001") {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $3b498ce85b60edf8$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $3b498ce85b60edf8$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return this.metadata.countries["001"];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $3b498ce85b60edf8$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $3b498ce85b60edf8$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $3b498ce85b60edf8$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $3b498ce85b60edf8$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $3b498ce85b60edf8$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $3b498ce85b60edf8$var$getType(this.types(), _type2)) return new $3b498ce85b60edf8$var$Type($3b498ce85b60edf8$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $3b498ce85b60edf8$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $3b498ce85b60edf8$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $3b498ce85b60edf8$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $3b498ce85b60edf8$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $3b498ce85b60edf8$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$3b498ce85b60edf8$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $3b498ce85b60edf8$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $3b498ce85b60edf8$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $3b498ce85b60edf8$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $3b498ce85b60edf8$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $3b498ce85b60edf8$var$getType(types, type) {
    switch(type){
        case "FIXED_LINE":
            return types[0];
        case "MOBILE":
            return types[1];
        case "TOLL_FREE":
            return types[2];
        case "PREMIUM_RATE":
            return types[3];
        case "PERSONAL_NUMBER":
            return types[4];
        case "VOICEMAIL":
            return types[5];
        case "UAN":
            return types[6];
        case "PAGER":
            return types[7];
        case "VOIP":
            return types[8];
        case "SHARED_COST":
            return types[9];
    }
}
function $3b498ce85b60edf8$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!(0, $lXLrE.default)(metadata) || !(0, $lXLrE.default)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $lXLrE.default)(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + $3b498ce85b60edf8$var$typeOf(metadata) + ": " + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $3b498ce85b60edf8$var$typeOf = function typeOf(_) {
    return $3b498ce85b60edf8$var$_typeof(_);
};
function $3b498ce85b60edf8$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $3b498ce85b60edf8$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $3b498ce85b60edf8$var$DEFAULT_EXT_PREFIX;
}
function $3b498ce85b60edf8$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $3b498ce85b60edf8$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $3b498ce85b60edf8$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $3b498ce85b60edf8$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === "number") {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $ijgwv.default)(version, $3b498ce85b60edf8$var$V3) === -1) this.v2 = true;
        else if ((0, $ijgwv.default)(version, $3b498ce85b60edf8$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }

});
parcelRegister("ijgwv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d546d189d848efec$export$2e2bcd8739ae039; });
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $d546d189d848efec$export$2e2bcd8739ae039(a, b) {
    a = a.split("-");
    b = b.split("-");
    var pa = a[0].split(".");
    var pb = b[0].split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

});


parcelRegister("2FyAa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f1a3c70505e3073$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isViablePhoneNumberStart", function () { return $1f1a3c70505e3073$export$4c3f76c95c05197c; });

var $k4lD9 = parcelRequire("k4lD9");

var $cCG7S = parcelRequire("cCG7S");
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $1f1a3c70505e3073$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + (0, $k4lD9.VALID_DIGITS) + "]{" + (0, $k4lD9.MIN_LENGTH_FOR_NSN) + "}"; //
var $1f1a3c70505e3073$export$a77dd7471651eee = "[" + (0, $k4lD9.PLUS_CHARS) + "]{0,1}" + "(?:" + "[" + (0, $k4lD9.VALID_PUNCTUATION) + "]*" + "[" + (0, $k4lD9.VALID_DIGITS) + "]" + "){3,}" + "[" + (0, $k4lD9.VALID_PUNCTUATION) + (0, $k4lD9.VALID_DIGITS) + "]*"; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $1f1a3c70505e3073$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $k4lD9.PLUS_CHARS) + "]{0,1}" + "(?:" + "[" + (0, $k4lD9.VALID_PUNCTUATION) + "]*" + "[" + (0, $k4lD9.VALID_DIGITS) + "]" + "){1,2}" + "$", "i");
var $1f1a3c70505e3073$export$a2d12a04749c087d = $1f1a3c70505e3073$export$a77dd7471651eee + // Phone number extensions
"(?:" + (0, $cCG7S.default)() + ")?"; // The combined regular expression for valid phone numbers:
//
var $1f1a3c70505e3073$var$VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + $1f1a3c70505e3073$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + "$" + "|" + // Or a longer fully parsed phone number (min 3 characters)
"^" + $1f1a3c70505e3073$export$a2d12a04749c087d + "$", "i"); // Checks to see if the string of characters could possibly be a phone number at
function $1f1a3c70505e3073$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $k4lD9.MIN_LENGTH_FOR_NSN) && $1f1a3c70505e3073$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $1f1a3c70505e3073$export$4c3f76c95c05197c(number) {
    return $1f1a3c70505e3073$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

});
parcelRegister("cCG7S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9309b604bd6d887d$export$2e2bcd8739ae039; });

var $k4lD9 = parcelRequire("k4lD9");
var $9309b604bd6d887d$var$RFC3966_EXTN_PREFIX = ";ext=";
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $9309b604bd6d887d$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $k4lD9.VALID_DIGITS), "]{1,").concat(maxLength, "})");
};
function $9309b604bd6d887d$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = "20";
    /** @type {string} */ var extLimitAfterLikelyLabel = "15";
    /** @type {string} */ var extLimitAfterAmbiguousChar = "9";
    /** @type {string} */ var extLimitWhenNotSure = "6";
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xa0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xa0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xf3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xa0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $9309b604bd6d887d$var$RFC3966_EXTN_PREFIX + $9309b604bd6d887d$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $9309b604bd6d887d$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $9309b604bd6d887d$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $9309b604bd6d887d$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $9309b604bd6d887d$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $9309b604bd6d887d$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

});


parcelRegister("2qz2P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c49319c8a1f144b$export$2e2bcd8739ae039; });

var $cCG7S = parcelRequire("cCG7S");
// 1 or more valid digits, for use when parsing.
var $1c49319c8a1f144b$var$EXTN_PATTERN = new RegExp("(?:" + (0, $cCG7S.default)() + ")$", "i"); // Strips any extension (as in, the part of the number dialled after the call is
function $1c49319c8a1f144b$export$2e2bcd8739ae039(number) {
    var start = number.search($1c49319c8a1f144b$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($1c49319c8a1f144b$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}

});

parcelRegister("ukbhN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05b274fd5c983a8d$export$2e2bcd8739ae039; });

var $ia1wa = parcelRequire("ia1wa");
function $05b274fd5c983a8d$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $05b274fd5c983a8d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $05b274fd5c983a8d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $05b274fd5c983a8d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $05b274fd5c983a8d$var$_arrayLikeToArray(o, minLen);
}
function $05b274fd5c983a8d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $05b274fd5c983a8d$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $05b274fd5c983a8d$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $05b274fd5c983a8d$export$13d8790d7fb84c28(character, result) || "";
    }
    return result;
}
function $05b274fd5c983a8d$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === "+") {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === "function") emitEvent("end");
            return;
        }
        return "+";
    } // Allow digits.
    return (0, $ia1wa.parseDigit)(character);
}

});
parcelRegister("ia1wa", function(module, exports) {

$parcel$export(module.exports, "parseDigit", function () { return $d38a5697ba3e8ea3$export$1d16fddea1437169; });
function $d38a5697ba3e8ea3$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d38a5697ba3e8ea3$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d38a5697ba3e8ea3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d38a5697ba3e8ea3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d38a5697ba3e8ea3$var$_arrayLikeToArray(o, minLen);
}
function $d38a5697ba3e8ea3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $d38a5697ba3e8ea3$export$2848f3d68c08fe69 = {
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "\uFF10": "0",
    // Fullwidth digit 0
    "\uFF11": "1",
    // Fullwidth digit 1
    "\uFF12": "2",
    // Fullwidth digit 2
    "\uFF13": "3",
    // Fullwidth digit 3
    "\uFF14": "4",
    // Fullwidth digit 4
    "\uFF15": "5",
    // Fullwidth digit 5
    "\uFF16": "6",
    // Fullwidth digit 6
    "\uFF17": "7",
    // Fullwidth digit 7
    "\uFF18": "8",
    // Fullwidth digit 8
    "\uFF19": "9",
    // Fullwidth digit 9
    "\u0660": "0",
    // Arabic-indic digit 0
    "\u0661": "1",
    // Arabic-indic digit 1
    "\u0662": "2",
    // Arabic-indic digit 2
    "\u0663": "3",
    // Arabic-indic digit 3
    "\u0664": "4",
    // Arabic-indic digit 4
    "\u0665": "5",
    // Arabic-indic digit 5
    "\u0666": "6",
    // Arabic-indic digit 6
    "\u0667": "7",
    // Arabic-indic digit 7
    "\u0668": "8",
    // Arabic-indic digit 8
    "\u0669": "9",
    // Arabic-indic digit 9
    "\u06F0": "0",
    // Eastern-Arabic digit 0
    "\u06F1": "1",
    // Eastern-Arabic digit 1
    "\u06F2": "2",
    // Eastern-Arabic digit 2
    "\u06F3": "3",
    // Eastern-Arabic digit 3
    "\u06F4": "4",
    // Eastern-Arabic digit 4
    "\u06F5": "5",
    // Eastern-Arabic digit 5
    "\u06F6": "6",
    // Eastern-Arabic digit 6
    "\u06F7": "7",
    // Eastern-Arabic digit 7
    "\u06F8": "8",
    // Eastern-Arabic digit 8
    "\u06F9": "9" // Eastern-Arabic digit 9
};
function $d38a5697ba3e8ea3$export$1d16fddea1437169(character) {
    return $d38a5697ba3e8ea3$export$2848f3d68c08fe69[character];
}
function $d38a5697ba3e8ea3$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $d38a5697ba3e8ea3$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $d38a5697ba3e8ea3$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}

});


parcelRegister("iwTul", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $037b329ceea7e66e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isPossibleNumber", function () { return $037b329ceea7e66e$export$4f8890cedf1e0497; });

var $55Agv = parcelRequire("55Agv");

var $gF45U = parcelRequire("gF45U");
function $037b329ceea7e66e$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $55Agv.default)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $037b329ceea7e66e$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $037b329ceea7e66e$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $gF45U.default)(nationalNumber, metadata)){
        case "IS_POSSIBLE":
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}

});
parcelRegister("gF45U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c213a6b3921765f5$export$2e2bcd8739ae039; });

var $g3JkZ = parcelRequire("g3JkZ");
function $c213a6b3921765f5$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $c213a6b3921765f5$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $c213a6b3921765f5$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return "IS_POSSIBLE";
    if (type === "FIXED_LINE_OR_MOBILE") {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type("FIXED_LINE")) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $c213a6b3921765f5$export$69333f603c7d5931(nationalNumber, "MOBILE", metadata);
        var mobile_type = metadata.type("MOBILE");
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $g3JkZ.default)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return "INVALID_LENGTH";
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return "IS_POSSIBLE";
    if (minimum_length > actual_length) return "TOO_SHORT";
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return "TOO_LONG";
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}

});
parcelRegister("g3JkZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb10183ad34dad71$export$2e2bcd8739ae039; });
function $bb10183ad34dad71$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $bb10183ad34dad71$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bb10183ad34dad71$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bb10183ad34dad71$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bb10183ad34dad71$var$_arrayLikeToArray(o, minLen);
}
function $bb10183ad34dad71$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bb10183ad34dad71$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $bb10183ad34dad71$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}

});



parcelRegister("29nxu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $190eae6d6a30b16e$export$2e2bcd8739ae039; });

var $55Agv = parcelRequire("55Agv");

var $iwTul = parcelRequire("iwTul");

var $4RMtD = parcelRequire("4RMtD");

var $7uNYn = parcelRequire("7uNYn");

var $ezFsg = parcelRequire("ezFsg");

var $dO7GP = parcelRequire("dO7GP");
function $190eae6d6a30b16e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $190eae6d6a30b16e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $190eae6d6a30b16e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $190eae6d6a30b16e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $190eae6d6a30b16e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $190eae6d6a30b16e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $190eae6d6a30b16e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $190eae6d6a30b16e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $190eae6d6a30b16e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $190eae6d6a30b16e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $190eae6d6a30b16e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $190eae6d6a30b16e$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $190eae6d6a30b16e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $190eae6d6a30b16e$var$_classCallCheck(this, PhoneNumber);
        if (!countryOrCountryCallingCode) throw new TypeError("`country` or `countryCallingCode` not passed");
        if (!nationalNumber) throw new TypeError("`nationalNumber` not passed");
        if (!metadata) throw new TypeError("`metadata` not passed");
        var _getCountryAndCountry = $190eae6d6a30b16e$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = "+" + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $190eae6d6a30b16e$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $ezFsg.default)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $iwTul.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $4RMtD.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $55Agv.default)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $7uNYn.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $dO7GP.default)(this, _format, options ? $190eae6d6a30b16e$var$_objectSpread($190eae6d6a30b16e$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format("NATIONAL", options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format("INTERNATIONAL", options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format("RFC3966", options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $190eae6d6a30b16e$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $190eae6d6a30b16e$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $55Agv.default)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($190eae6d6a30b16e$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($190eae6d6a30b16e$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = "001";
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}

});
parcelRegister("4RMtD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38b1b72cb9c28323$export$2e2bcd8739ae039; });

var $55Agv = parcelRequire("55Agv");

var $iBVES = parcelRequire("iBVES");

var $7uNYn = parcelRequire("7uNYn");
function $38b1b72cb9c28323$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $55Agv.default)(metadata);
    /**
   * Checks if a phone number is "possible" (basically just checks its length).
   *
   * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
   * @param  {object} [options]
   * @param  {object} metadata
   * @return {string}
   */ metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $7uNYn.default)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $iBVES.default)(nationalNumber, metadata.nationalNumberPattern());
}

});
parcelRegister("iBVES", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8c8687055696f95$export$2e2bcd8739ae039; });
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $d8c8687055696f95$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || "";
    return new RegExp("^(?:" + regular_expression + ")$").test(text);
}

});

parcelRegister("7uNYn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57521951ae739c6c$export$2e2bcd8739ae039; });

var $55Agv = parcelRequire("55Agv");

var $iBVES = parcelRequire("iBVES");
function $57521951ae739c6c$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $57521951ae739c6c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $57521951ae739c6c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $57521951ae739c6c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $57521951ae739c6c$var$_arrayLikeToArray(o, minLen);
}
function $57521951ae739c6c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $57521951ae739c6c$var$NON_FIXED_LINE_PHONE_TYPES = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
]; // Finds out national phone number type (fixed line, mobile, etc)
function $57521951ae739c6c$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $55Agv.default)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $iBVES.default)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($57521951ae739c6c$export$7bd37b39ade0214d(nationalNumber, "FIXED_LINE", metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") return "FIXED_LINE_OR_MOBILE";
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type("MOBILE")) return "FIXED_LINE_OR_MOBILE";
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($57521951ae739c6c$export$7bd37b39ade0214d(nationalNumber, "MOBILE", metadata)) return "FIXED_LINE_OR_MOBILE";
        return "FIXED_LINE";
    }
    for(var _iterator = $57521951ae739c6c$var$_createForOfIteratorHelperLoose($57521951ae739c6c$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($57521951ae739c6c$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $57521951ae739c6c$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $iBVES.default)(nationalNumber, type.pattern());
}

});


parcelRegister("ezFsg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9c47da1bee91c5d$export$2e2bcd8739ae039; });

var $55Agv = parcelRequire("55Agv");
function $a9c47da1bee91c5d$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $55Agv.default)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $a9c47da1bee91c5d$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $a9c47da1bee91c5d$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $55Agv.default)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}

});

parcelRegister("dO7GP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0d5e8e1202fd4b4$export$2e2bcd8739ae039; });

var $iBVES = parcelRequire("iBVES");

var $by79G = parcelRequire("by79G");

var $55Agv = parcelRequire("55Agv");

var $90IGo = parcelRequire("90IGo");

var $dwCvp = parcelRequire("dwCvp");
function $a0d5e8e1202fd4b4$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $a0d5e8e1202fd4b4$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a0d5e8e1202fd4b4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a0d5e8e1202fd4b4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a0d5e8e1202fd4b4$var$_arrayLikeToArray(o, minLen);
}
function $a0d5e8e1202fd4b4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a0d5e8e1202fd4b4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a0d5e8e1202fd4b4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a0d5e8e1202fd4b4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a0d5e8e1202fd4b4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a0d5e8e1202fd4b4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a0d5e8e1202fd4b4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a0d5e8e1202fd4b4$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $a0d5e8e1202fd4b4$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $a0d5e8e1202fd4b4$var$_objectSpread($a0d5e8e1202fd4b4$var$_objectSpread({}, $a0d5e8e1202fd4b4$var$DEFAULT_OPTIONS), options);
    else options = $a0d5e8e1202fd4b4$var$DEFAULT_OPTIONS;
    metadata = new (0, $55Agv.default)(metadata);
    if (input.country && input.country !== "001") {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || "";
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case "NATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "";
            number = $a0d5e8e1202fd4b4$var$formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
            return $a0d5e8e1202fd4b4$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "INTERNATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $a0d5e8e1202fd4b4$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $a0d5e8e1202fd4b4$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "E.164":
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case "RFC3966":
            return (0, $dwCvp.formatRFC3966)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case "IDD":
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $a0d5e8e1202fd4b4$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $a0d5e8e1202fd4b4$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
    }
}
function $a0d5e8e1202fd4b4$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $a0d5e8e1202fd4b4$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $by79G.default)(number, format, {
        useInternationalFormat: formatAs === "INTERNATIONAL",
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $a0d5e8e1202fd4b4$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $a0d5e8e1202fd4b4$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $iBVES.default)(nationalNnumber, format.pattern())) return format;
    }
}
function $a0d5e8e1202fd4b4$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $a0d5e8e1202fd4b4$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $55Agv.getCountryCallingCode)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $a0d5e8e1202fd4b4$var$formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === "1") return countryCallingCode + " " + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $90IGo.default)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($a0d5e8e1202fd4b4$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
}

});
parcelRegister("by79G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86886b92e64cf273$export$2e2bcd8739ae039; });

var $e7mfg = parcelRequire("e7mfg");
var $86886b92e64cf273$export$4f32ad1c51a7a6be = /(\$\d)/;
function $86886b92e64cf273$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($86886b92e64cf273$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $e7mfg.default)(formattedNumber);
    return formattedNumber;
}

});
parcelRegister("e7mfg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a472f9949ca18406$export$2e2bcd8739ae039; });

var $k4lD9 = parcelRequire("k4lD9");
function $a472f9949ca18406$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $k4lD9.VALID_PUNCTUATION), "]+"), "g"), " ").trim();
}

});


parcelRegister("90IGo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68f6c6333d5e4e38$export$2e2bcd8739ae039; });

var $55Agv = parcelRequire("55Agv");
/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $68f6c6333d5e4e38$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $68f6c6333d5e4e38$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $55Agv.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($68f6c6333d5e4e38$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}

});

parcelRegister("dwCvp", function(module, exports) {

$parcel$export(module.exports, "formatRFC3966", function () { return $9d8c21f1a3d7b8bf$export$d4f2d2bc1159d115; });

var $2FyAa = parcelRequire("2FyAa");
function $9d8c21f1a3d7b8bf$var$_slicedToArray(arr, i) {
    return $9d8c21f1a3d7b8bf$var$_arrayWithHoles(arr) || $9d8c21f1a3d7b8bf$var$_iterableToArrayLimit(arr, i) || $9d8c21f1a3d7b8bf$var$_unsupportedIterableToArray(arr, i) || $9d8c21f1a3d7b8bf$var$_nonIterableRest();
}
function $9d8c21f1a3d7b8bf$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9d8c21f1a3d7b8bf$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9d8c21f1a3d7b8bf$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9d8c21f1a3d7b8bf$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $9d8c21f1a3d7b8bf$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9d8c21f1a3d7b8bf$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9d8c21f1a3d7b8bf$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9d8c21f1a3d7b8bf$var$_arrayLikeToArray(o, minLen);
}
function $9d8c21f1a3d7b8bf$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9d8c21f1a3d7b8bf$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, "tel=");
    for(var _iterator = $9d8c21f1a3d7b8bf$var$_createForOfIteratorHelperLoose(text.split(";")), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split("="), _part$split2 = $9d8c21f1a3d7b8bf$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case "tel":
                number = value;
                break;
            case "ext":
                ext = value;
                break;
            case "phone-context":
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === "+") number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $2FyAa.default)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $9d8c21f1a3d7b8bf$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return "";
    if (number[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}

});



parcelRegister("6ChII", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d140992bae0a532$export$2e2bcd8739ae039; });

var $e5Mne = parcelRequire("e5Mne");

var $fYkqf = parcelRequire("fYkqf");

var $55Agv = parcelRequire("55Agv");

var $k4lD9 = parcelRequire("k4lD9");
function $4d140992bae0a532$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== "+") {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $e5Mne.default)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = "+" + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $fYkqf.default)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === "0") return {};
    metadata = new (0, $55Agv.default)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $k4lD9.MAX_LENGTH_COUNTRY_CODE) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }

});
parcelRegister("e5Mne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4270e4f3e2092ea$export$2e2bcd8739ae039; });

var $55Agv = parcelRequire("55Agv");

var $k4lD9 = parcelRequire("k4lD9");
var $a4270e4f3e2092ea$var$CAPTURING_DIGIT_PATTERN = new RegExp("([" + (0, $k4lD9.VALID_DIGITS) + "])");
function $a4270e4f3e2092ea$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $55Agv.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($a4270e4f3e2092ea$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === "0") return;
    }
    return number;
}

});

parcelRegister("fYkqf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba0c4d0ce9df85ed$export$2e2bcd8739ae039; });

var $55Agv = parcelRequire("55Agv");

var $iBVES = parcelRequire("iBVES");

var $goXCH = parcelRequire("goXCH");

var $gF45U = parcelRequire("gF45U");

var $55Agv = parcelRequire("55Agv");
function $ba0c4d0ce9df85ed$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $55Agv.getCountryCallingCode)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $55Agv.default)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $goXCH.default)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $goXCH.default)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $iBVES.default)(nationalNumber, metadata.nationalNumberPattern()) && (0, $iBVES.default)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $gF45U.default)(nationalNumber, metadata) === "TOO_LONG") return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}

});
parcelRegister("goXCH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf0d2322317978bb$export$2e2bcd8739ae039; });

var $3WttB = parcelRequire("3WttB");

var $iBVES = parcelRequire("iBVES");

var $gF45U = parcelRequire("gF45U");
function $bf0d2322317978bb$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $3WttB.default)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$bf0d2322317978bb$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$bf0d2322317978bb$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $bf0d2322317978bb$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $iBVES.default)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $iBVES.default)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $bf0d2322317978bb$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $gF45U.default)(nationalNumber, metadata)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}

});
parcelRegister("3WttB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2deda74df2fbb95f$export$2e2bcd8739ae039; });
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $2deda74df2fbb95f$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}

});




parcelRegister("77fVj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52e589e6d6b983da$export$2e2bcd8739ae039; });

var $UJgPX = parcelRequire("UJgPX");
var $52e589e6d6b983da$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $52e589e6d6b983da$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($52e589e6d6b983da$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return "001";
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $UJgPX.default)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}

});
parcelRegister("UJgPX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0aa858de6b21b1a9$export$2e2bcd8739ae039; });

var $55Agv = parcelRequire("55Agv");

var $7uNYn = parcelRequire("7uNYn");
function $0aa858de6b21b1a9$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $0aa858de6b21b1a9$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0aa858de6b21b1a9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0aa858de6b21b1a9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0aa858de6b21b1a9$var$_arrayLikeToArray(o, minLen);
}
function $0aa858de6b21b1a9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0aa858de6b21b1a9$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $55Agv.default)(metadata);
    var matchingCountries = [];
    for(var _iterator = $0aa858de6b21b1a9$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $7uNYn.default)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) {
            // If the `defaultCountry` is among the `matchingCountries` then return it.
            if (defaultCountry) {
                if (country === defaultCountry) return country;
                matchingCountries.push(country);
            } else return country;
        }
    } // Return the first ("main") one of the `matchingCountries`.
    if (matchingCountries.length > 0) return matchingCountries[0];
}

});


parcelRegister("5co6P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c90c65309d26caa$export$2e2bcd8739ae039; });

var $rB0KU = parcelRequire("rB0KU");

var $g9Xi3 = parcelRequire("g9Xi3");
function $3c90c65309d26caa$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $rB0KU.default)(numberToParse);
    if (!(0, $rB0KU.isPhoneContextValid)(phoneContext)) throw new (0, $g9Xi3.default)("NOT_A_NUMBER");
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
    else {
        phoneNumberString = ""; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $rB0KU.PLUS_SIGN)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $rB0KU.RFC3966_PREFIX_));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $rB0KU.RFC3966_PREFIX_).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $rB0KU.RFC3966_PHONE_CONTEXT_));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $rB0KU.RFC3966_ISDN_SUBADDRESS_));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== "") return phoneNumberString;
}

});
parcelRegister("rB0KU", function(module, exports) {

$parcel$export(module.exports, "PLUS_SIGN", function () { return $052f3b61bb2444e1$export$1ddc7eed78155f68; });
$parcel$export(module.exports, "RFC3966_PREFIX_", function () { return $052f3b61bb2444e1$export$70d485ce3f6de783; });
$parcel$export(module.exports, "RFC3966_PHONE_CONTEXT_", function () { return $052f3b61bb2444e1$export$f6d5879d582c3a27; });
$parcel$export(module.exports, "RFC3966_ISDN_SUBADDRESS_", function () { return $052f3b61bb2444e1$export$9e356e12edb00a81; });
$parcel$export(module.exports, "default", function () { return $052f3b61bb2444e1$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isPhoneContextValid", function () { return $052f3b61bb2444e1$export$474a4aa22ad6959a; });
// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $k4lD9 = parcelRequire("k4lD9");
var $052f3b61bb2444e1$export$1ddc7eed78155f68 = "+";
var $052f3b61bb2444e1$var$RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var $052f3b61bb2444e1$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $k4lD9.VALID_DIGITS) + "]" + "|" + $052f3b61bb2444e1$var$RFC3966_VISUAL_SEPARATOR_ + ")";
var $052f3b61bb2444e1$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $052f3b61bb2444e1$export$1ddc7eed78155f68 + $052f3b61bb2444e1$var$RFC3966_PHONE_DIGIT_ + "*" + "[" + (0, $k4lD9.VALID_DIGITS) + "]" + $052f3b61bb2444e1$var$RFC3966_PHONE_DIGIT_ + "*" + "$";
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $052f3b61bb2444e1$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($052f3b61bb2444e1$var$RFC3966_GLOBAL_NUMBER_DIGITS_, "g"); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $052f3b61bb2444e1$var$ALPHANUM_ = (0, $k4lD9.VALID_DIGITS);
var $052f3b61bb2444e1$var$RFC3966_DOMAINLABEL_ = "[" + $052f3b61bb2444e1$var$ALPHANUM_ + "]+((\\-)*[" + $052f3b61bb2444e1$var$ALPHANUM_ + "])*";
var $052f3b61bb2444e1$var$VALID_ALPHA_ = "a-zA-Z";
var $052f3b61bb2444e1$var$RFC3966_TOPLABEL_ = "[" + $052f3b61bb2444e1$var$VALID_ALPHA_ + "]+((\\-)*[" + $052f3b61bb2444e1$var$ALPHANUM_ + "])*";
var $052f3b61bb2444e1$var$RFC3966_DOMAINNAME_ = "^(" + $052f3b61bb2444e1$var$RFC3966_DOMAINLABEL_ + "\\.)*" + $052f3b61bb2444e1$var$RFC3966_TOPLABEL_ + "\\.?$";
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $052f3b61bb2444e1$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($052f3b61bb2444e1$var$RFC3966_DOMAINNAME_, "g");
var $052f3b61bb2444e1$export$70d485ce3f6de783 = "tel:";
var $052f3b61bb2444e1$export$f6d5879d582c3a27 = ";phone-context=";
var $052f3b61bb2444e1$export$9e356e12edb00a81 = ";isub=";
function $052f3b61bb2444e1$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($052f3b61bb2444e1$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $052f3b61bb2444e1$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return "";
    var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $052f3b61bb2444e1$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $052f3b61bb2444e1$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $052f3b61bb2444e1$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}

});







parcelRegister("54eNv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b08cdf4040c7c7f$export$2e2bcd8739ae039; });
const $3b08cdf4040c7c7f$var$allCountries = [
    [
        "\u0410\u0444\u0433\u0430\u043D\u0438\u0441\u0442\u0430\u043D",
        "af",
        "93"
    ],
    [
        "\u0410\u043B\u0431\u0430\u043D\u0438\u044F",
        "al",
        "355"
    ],
    [
        "\u0410\u043B\u0436\u0438\u0440",
        "dz",
        "213"
    ],
    [
        "\u0410\u043C\u0435\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u043E\u0435",
        "as",
        "1684"
    ],
    [
        "\u0410\u043D\u0434\u043E\u0440\u0440\u0430",
        "ad",
        "376"
    ],
    [
        "\u0410\u043D\u0433\u043E\u043B\u0430",
        "ao",
        "244"
    ],
    [
        "\u0410\u043D\u0433\u0438\u043B\u044C\u044F",
        "ai",
        "1264"
    ],
    [
        "\u0410\u043D\u0442\u0438\u0433\u0443\u0430 \u0438 \u0411\u0430\u0440\u0431\u0443\u0434\u0430",
        "ag",
        "1268"
    ],
    [
        "\u0410\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0430",
        "ar",
        "54"
    ],
    [
        "\u0410\u0440\u043C\u0435\u043D\u0438\u044F",
        "am",
        "374"
    ],
    [
        "\u0410\u0440\u0443\u0431\u0430",
        "aw",
        "297"
    ],
    [
        "\u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0438\u044F",
        "au",
        "61",
        0
    ],
    [
        "\u0410\u0432\u0441\u0442\u0440\u0438\u044F",
        "at",
        "43"
    ],
    [
        "\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043D",
        "az",
        "994"
    ],
    [
        "\u0411\u0430\u0433\u0430\u043C\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        "bs",
        "1242"
    ],
    [
        "\u0411\u0430\u0445\u0440\u0435\u0439\u043D",
        "bh",
        "973"
    ],
    [
        "\u0411\u0430\u043D\u0433\u043B\u0430\u0434\u0435\u0448",
        "bd",
        "880"
    ],
    [
        "\u0411\u0430\u0440\u0431\u0430\u0434\u043E\u0441",
        "bb",
        "1246"
    ],
    [
        "\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C",
        "by",
        "375"
    ],
    [
        "\u0411\u0435\u043B\u044C\u0433\u0438\u044F",
        "be",
        "32"
    ],
    [
        "\u0411\u0435\u043B\u0438\u0437",
        "bz",
        "501"
    ],
    [
        "\u0411\u0435\u043D\u0438\u043D",
        "bj",
        "229"
    ],
    [
        "\u0411\u0435\u0440\u043C\u0443\u0434\u0441\u043A\u0438\u0439",
        "bm",
        "1441"
    ],
    [
        "\u0411\u0443\u0442\u0430\u043D",
        "bt",
        "975"
    ],
    [
        "\u0411\u043E\u043B\u0438\u0432\u0438\u044F",
        "bo",
        "591"
    ],
    [
        "\u0411\u043E\u0441\u043D\u0438\u044F \u0438 \u0413\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430",
        "ba",
        "387"
    ],
    [
        "\u0411\u043E\u0442\u0441\u0432\u0430\u043D\u0430",
        "bw",
        "267"
    ],
    [
        "\u0411\u0440\u0430\u0437\u0438\u043B\u0438\u044F",
        "br",
        "55"
    ],
    [
        "\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u043A\u0430\u044F \u0422\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F \u0432 \u0418\u043D\u0434\u0438\u0439\u0441\u043A\u043E\u043C \u041E\u043A\u0435\u0430\u043D\u0435",
        "io",
        "246"
    ],
    [
        "\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u043A\u0438\u0435 \u0412\u0438\u0440\u0433\u0438\u043D\u0441\u043A\u0438\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        "vg",
        "1284"
    ],
    [
        "\u0411\u0440\u0443\u043D\u0435\u0439",
        "bn",
        "673"
    ],
    [
        "\u0411\u043E\u043B\u0433\u0430\u0440\u0438\u044F",
        "bg",
        "359"
    ],
    [
        "\u0411\u0443\u0440\u043A\u0438\u043D\u0430 \u0424\u0430\u0441\u043E",
        "bf",
        "226"
    ],
    [
        "\u0411\u0443\u0440\u0443\u043D\u0434\u0438",
        "bi",
        "257"
    ],
    [
        "\u041A\u0430\u043C\u0431\u043E\u0434\u0436\u0430",
        "kh",
        "855"
    ],
    [
        "\u041A\u0430\u043C\u0435\u0440\u0443\u043D",
        "cm",
        "237"
    ],
    [
        "\u041A\u0430\u043D\u0430\u0434\u0430",
        "ca",
        "1",
        1,
        [
            "204",
            "226",
            "236",
            "249",
            "250",
            "289",
            "306",
            "343",
            "365",
            "387",
            "403",
            "416",
            "418",
            "431",
            "437",
            "438",
            "450",
            "506",
            "514",
            "519",
            "548",
            "579",
            "581",
            "587",
            "604",
            "613",
            "639",
            "647",
            "672",
            "705",
            "709",
            "742",
            "778",
            "780",
            "782",
            "807",
            "819",
            "825",
            "867",
            "873",
            "902",
            "905"
        ]
    ],
    [
        "\u041A\u0430\u0431\u043E-\u0412\u0435\u0440\u0434\u0435",
        "cv",
        "238"
    ],
    [
        "\u041A\u0430\u0440\u0438\u0431\u0441\u043A\u0438\u0435 \u041D\u0438\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u044B",
        "bq",
        "599",
        1
    ],
    [
        "\u041A\u0430\u0439\u043C\u0430\u043D\u043E\u0432\u044B \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        "ky",
        "1345"
    ],
    [
        "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0430\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
        "cf",
        "236"
    ],
    [
        "\u0427\u0430\u0434",
        "td",
        "235"
    ],
    [
        "\u0427\u0438\u043B\u0438",
        "cl",
        "56"
    ],
    [
        "\u041A\u0438\u0442\u0430\u0439",
        "cn",
        "86"
    ],
    [
        "\u043E\u0441\u0442\u0440\u043E\u0432 \u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0430",
        "cx",
        "61",
        2
    ],
    [
        "\u041A\u043E\u043A\u043E\u0441\u043E\u0432\u044B\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        "cc",
        "61",
        1
    ],
    [
        "\u041A\u043E\u043B\u0443\u043C\u0431\u0438\u044F",
        "co",
        "57"
    ],
    [
        "\u041A\u043E\u043C\u043E\u0440\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        "km",
        "269"
    ],
    [
        "\u041A\u043E\u043D\u0433\u043E",
        "cd",
        "243"
    ],
    [
        "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u043D\u0433\u043E",
        "cg",
        "242"
    ],
    [
        "\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u041A\u0443\u043A\u0430",
        "ck",
        "682"
    ],
    [
        "\u041A\u043E\u0441\u0442\u0430 \u0420\u0438\u043A\u0430",
        "cr",
        "506"
    ],
    [
        "\u041A\u043E\u0442-\u0434'\u0418\u0432\u0443\u0430\u0440",
        "ci",
        "225"
    ],
    [
        "\u0425\u043E\u0440\u0432\u0430\u0442\u0438\u044F",
        "hr",
        "385"
    ],
    [
        "\u041A\u0443\u0431\u0430",
        "cu",
        "53"
    ],
    [
        "\u041A\u0443\u0440\u0430\u0441\u0430\u043E",
        "cw",
        "599",
        0
    ],
    [
        "\u041A\u0438\u043F\u0440",
        "cy",
        "357"
    ],
    [
        "\u0427\u0435\u0448\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
        "cz",
        "420"
    ],
    [
        "\u0414\u0430\u043D\u0438\u044F",
        "dk",
        "45"
    ],
    [
        "\u0414\u0436\u0438\u0431\u0443\u0442\u0438",
        "dj",
        "253"
    ],
    [
        "\u0414\u043E\u043C\u0438\u043D\u0438\u043A\u0430",
        "dm",
        "1767"
    ],
    [
        "\u0414\u043E\u043C\u0438\u043D\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
        "do",
        "1",
        2,
        [
            "809",
            "829",
            "849"
        ]
    ],
    [
        "\u042D\u043A\u0432\u0430\u0434\u043E\u0440",
        "ec",
        "593"
    ],
    [
        "\u0415\u0433\u0438\u043F\u0435\u0442",
        "eg",
        "20"
    ],
    [
        "\u0421\u0430\u043B\u044C\u0432\u0430\u0434\u043E\u0440",
        "sv",
        "503"
    ],
    [
        "\u042D\u043A\u0432\u0430\u0442\u043E\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0413\u0432\u0438\u043D\u0435\u044F",
        "gq",
        "240"
    ],
    [
        "\u042D\u0440\u0438\u0442\u0440\u0435\u044F",
        "er",
        "291"
    ],
    [
        "\u042D\u0441\u0442\u043E\u043D\u0438\u044F",
        "ee",
        "372"
    ],
    [
        "\u042D\u0444\u0438\u043E\u043F\u0438\u044F",
        "et",
        "251"
    ],
    [
        "\u0424\u043E\u043B\u043A\u043B\u0435\u043D\u0434\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        "fk",
        "500"
    ],
    [
        "\u0424\u0430\u0440\u0435\u0440\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        "fo",
        "298"
    ],
    [
        "\u0424\u0438\u0434\u0436\u0438",
        "fj",
        "679"
    ],
    [
        "\u0424\u0438\u043D\u043B\u044F\u043D\u0434\u0438\u044F",
        "fi",
        "358",
        0
    ],
    [
        "\u0424\u0440\u0430\u043D\u0446\u0438\u044F",
        "fr",
        "33"
    ],
    [
        "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0430\u044F \u0413\u0432\u0438\u0430\u043D\u0430",
        "gf",
        "594"
    ],
    [
        "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0430\u044F \u041F\u043E\u043B\u0438\u043D\u0435\u0437\u0438\u044F",
        "pf",
        "689"
    ],
    [
        "\u0413\u0430\u0431\u043E\u043D",
        "ga",
        "241"
    ],
    [
        "\u0413\u0430\u043C\u0431\u0438\u044F",
        "gm",
        "220"
    ],
    [
        "\u0413\u0440\u0443\u0437\u0438\u044F",
        "ge",
        "995"
    ],
    [
        "\u0413\u0435\u0440\u043C\u0430\u043D\u0438\u044F",
        "de",
        "49"
    ],
    [
        "\u0413\u0430\u043D\u0430",
        "gh",
        "233"
    ],
    [
        "\u0413\u0438\u0431\u0440\u0430\u043B\u0442\u0430\u0440",
        "gi",
        "350"
    ],
    [
        "\u0413\u0440\u0435\u0446\u0438\u044F",
        "gr",
        "30"
    ],
    [
        "\u0413\u0440\u0435\u043D\u043B\u0430\u043D\u0434\u0438\u044F",
        "gl",
        "299"
    ],
    [
        "\u0413\u0440\u0435\u043D\u0430\u0434\u0430",
        "gd",
        "1473"
    ],
    [
        "\u0413\u0432\u0430\u0434\u0435\u043B\u0443\u043F\u0430",
        "gp",
        "590",
        0
    ],
    [
        "\u0413\u0443\u0430\u043C",
        "gu",
        "1671"
    ],
    [
        "\u0413\u0432\u0430\u0442\u0435\u043C\u0430\u043B\u0430",
        "gt",
        "502"
    ],
    [
        "\u0413\u0435\u0440\u043D\u0441\u0438",
        "gg",
        "44",
        1
    ],
    [
        "\u0413\u0432\u0438\u043D\u0435\u044F",
        "gn",
        "224"
    ],
    [
        "\u0413\u0432\u0438\u043D\u0435\u044F \u0411\u0438\u0441\u0430\u0443",
        "gw",
        "245"
    ],
    [
        "\u0413\u0430\u0439\u0430\u043D\u0430",
        "gy",
        "592"
    ],
    [
        "\u0413\u0430\u0438\u0442\u0438",
        "ht",
        "509"
    ],
    [
        "\u0413\u043E\u043D\u0434\u0443\u0440\u0430\u0441",
        "hn",
        "504"
    ],
    [
        "\u0413\u043E\u043D\u043A\u043E\u043D\u0433",
        "hk",
        "852"
    ],
    [
        "\u0412\u0435\u043D\u0433\u0440\u0438\u044F",
        "hu",
        "36"
    ],
    [
        "\u0418\u0441\u043B\u0430\u043D\u0434\u0438\u044F",
        "is",
        "354"
    ],
    [
        "\u0418\u043D\u0434\u0438\u044F",
        "in",
        "91"
    ],
    [
        "\u0418\u043D\u0434\u043E\u043D\u0435\u0437\u0438\u044F",
        "id",
        "62"
    ],
    [
        "\u0418\u0440\u0430\u043D",
        "ir",
        "98"
    ],
    [
        "\u0418\u0440\u0430\u043A",
        "iq",
        "964"
    ],
    [
        "\u0418\u0440\u043B\u0430\u043D\u0434\u0438\u044F",
        "ie",
        "353"
    ],
    [
        "\u041E\u0441\u0442\u0440\u043E\u0432 \u041C\u044D\u043D",
        "im",
        "44",
        2
    ],
    [
        "\u0418\u0437\u0440\u0430\u0438\u043B\u044C",
        "il",
        "972"
    ],
    [
        "\u0418\u0442\u0430\u043B\u0438\u044F",
        "it",
        "39",
        0
    ],
    [
        "\u042F\u043C\u0430\u0439\u043A\u0430",
        "jm",
        "1876"
    ],
    [
        "\u042F\u043F\u043E\u043D\u0438\u044F",
        "jp",
        "81"
    ],
    [
        "\u0414\u0436\u0435\u0440\u0441\u0438",
        "je",
        "44",
        3
    ],
    [
        "\u0418\u043E\u0440\u0434\u0430\u043D\u0438\u044F",
        "jo",
        "962"
    ],
    [
        "\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D",
        "kz",
        "7",
        1
    ],
    [
        "\u041A\u0435\u043D\u0438\u044F",
        "ke",
        "254"
    ],
    [
        "\u041A\u0438\u0440\u0438\u0431\u0430\u0442\u0438",
        "ki",
        "686"
    ],
    [
        "\u041A\u043E\u0441\u043E\u0432\u043E",
        "xk",
        "383"
    ],
    [
        "\u041A\u0443\u0432\u0435\u0439\u0442",
        "kw",
        "965"
    ],
    [
        "\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D",
        "kg",
        "996"
    ],
    [
        "\u041B\u0430\u043E\u0441",
        "la",
        "856"
    ],
    [
        "\u041B\u0430\u0442\u0432\u0438\u044F",
        "lv",
        "371"
    ],
    [
        "\u041B\u0438\u0432\u0430\u043D",
        "lb",
        "961"
    ],
    [
        "\u041B\u0435\u0441\u043E\u0442\u043E",
        "ls",
        "266"
    ],
    [
        "\u041B\u0438\u0431\u0435\u0440\u0438\u044F",
        "lr",
        "231"
    ],
    [
        "\u041B\u0438\u0432\u0438\u044F",
        "ly",
        "218"
    ],
    [
        "\u041B\u0438\u0445\u0442\u0435\u043D\u0448\u0442\u0435\u0439\u043D",
        "li",
        "423"
    ],
    [
        "\u041B\u0438\u0442\u0432\u0430",
        "lt",
        "370"
    ],
    [
        "\u041B\u044E\u043A\u0441\u0435\u043C\u0431\u0443\u0440\u0433",
        "lu",
        "352"
    ],
    [
        "\u041C\u0430\u043A\u0430\u043E",
        "mo",
        "853"
    ],
    [
        "\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u044F",
        "mk",
        "389"
    ],
    [
        "\u041C\u0430\u0434\u0430\u0433\u0430\u0441\u043A\u0430\u0440",
        "mg",
        "261"
    ],
    [
        "\u041C\u0430\u043B\u0430\u0432\u0438",
        "mw",
        "265"
    ],
    [
        "\u041C\u0430\u043B\u0430\u0439\u0437\u0438\u044F",
        "my",
        "60"
    ],
    [
        "\u041C\u0430\u043B\u044C\u0434\u0438\u0432\u044B",
        "mv",
        "960"
    ],
    [
        "\u041C\u0430\u043B\u0438",
        "ml",
        "223"
    ],
    [
        "\u041C\u0430\u043B\u044C\u0442\u0430",
        "mt",
        "356"
    ],
    [
        "\u041C\u0430\u0440\u0448\u0430\u043B\u043B\u043E\u0432\u044B \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        "mh",
        "692"
    ],
    [
        "\u041C\u0430\u0440\u0442\u0438\u043D\u0438\u043A\u0430",
        "mq",
        "596"
    ],
    [
        "\u041C\u0430\u0432\u0440\u0438\u0442\u0430\u043D\u0438\u044F",
        "mr",
        "222"
    ],
    [
        "\u041C\u0430\u0432\u0440\u0438\u043A\u0438\u0439",
        "mu",
        "230"
    ],
    [
        "\u041C\u0430\u0439\u043E\u0442\u0442\u0430",
        "yt",
        "262",
        1
    ],
    [
        "\u041C\u0435\u043A\u0441\u0438\u043A\u0430",
        "mx",
        "52"
    ],
    [
        "\u041C\u0438\u043A\u0440\u043E\u043D\u0435\u0437\u0438\u044F",
        "fm",
        "691"
    ],
    [
        "\u041C\u043E\u043B\u0434\u043E\u0432\u0430",
        "md",
        "373"
    ],
    [
        "\u041C\u043E\u043D\u0430\u043A\u043E",
        "mc",
        "377"
    ],
    [
        "\u041C\u043E\u043D\u0433\u043E\u043B\u0438\u044F",
        "mn",
        "976"
    ],
    [
        "\u0427\u0435\u0440\u043D\u043E\u0433\u043E\u0440\u0438\u044F",
        "me",
        "382"
    ],
    [
        "\u041C\u043E\u043D\u0442\u0441\u0435\u0440\u0440\u0430\u0442",
        "ms",
        "1664"
    ],
    [
        "\u041C\u0430\u0440\u043E\u043A\u043A\u043E",
        "ma",
        "212",
        0
    ],
    [
        "\u041C\u043E\u0437\u0430\u043C\u0431\u0438\u043A",
        "mz",
        "258"
    ],
    [
        "\u041C\u044C\u044F\u043D\u043C\u0430",
        "mm",
        "95"
    ],
    [
        "\u041D\u0430\u043C\u0438\u0431\u0438\u044F",
        "na",
        "264"
    ],
    [
        "\u041D\u0430\u0443\u0440\u0443",
        "nr",
        "674"
    ],
    [
        "\u041D\u0435\u043F\u0430\u043B",
        "np",
        "977"
    ],
    [
        "\u041D\u0438\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u044B",
        "nl",
        "31"
    ],
    [
        "\u041D\u043E\u0432\u0430\u044F \u041A\u0430\u043B\u0435\u0434\u043E\u043D\u0438\u044F",
        "nc",
        "687"
    ],
    [
        "\u041D\u043E\u0432\u0430\u044F \u0417\u0435\u043B\u0430\u043D\u0434\u0438\u044F",
        "nz",
        "64"
    ],
    [
        "\u041D\u0438\u043A\u0430\u0440\u0430\u0433\u0443\u0430",
        "ni",
        "505"
    ],
    [
        "\u041D\u0438\u0433\u0435\u0440",
        "ne",
        "227"
    ],
    [
        "\u041D\u0438\u0433\u0435\u0440\u0438\u044F",
        "ng",
        "234"
    ],
    [
        "\u041D\u0438\u0443\u044D",
        "nu",
        "683"
    ],
    [
        "\u041E\u0441\u0442\u0440\u043E\u0432 \u041D\u043E\u0440\u0444\u043E\u043B\u043A",
        "nf",
        "672"
    ],
    [
        "\u0421\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u041A\u043E\u0440\u0435\u044F",
        "kp",
        "850"
    ],
    [
        "\u0421\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u041C\u0430\u0440\u0438\u0430\u043D\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        "mp",
        "1670"
    ],
    [
        "\u041D\u043E\u0440\u0432\u0435\u0433\u0438\u044F",
        "no",
        "47",
        0
    ],
    [
        "\u041E\u043C\u0430\u043D",
        "om",
        "968"
    ],
    [
        "\u041F\u0430\u043A\u0438\u0441\u0442\u0430\u043D",
        "pk",
        "92"
    ],
    [
        "\u041F\u0430\u043B\u0430\u0443",
        "pw",
        "680"
    ],
    [
        "\u041F\u0430\u043B\u0435\u0441\u0442\u0438\u043D\u0430",
        "ps",
        "970"
    ],
    [
        "\u041F\u0430\u043D\u0430\u043C\u0430",
        "pa",
        "507"
    ],
    [
        "\u041F\u0430\u043F\u0443\u0430 \u041D\u043E\u0432\u0430\u044F \u0413\u0432\u0438\u043D\u0435\u044F",
        "pg",
        "675"
    ],
    [
        "\u041F\u0430\u0440\u0430\u0433\u0432\u0430\u0439",
        "py",
        "595"
    ],
    [
        "\u041F\u0435\u0440\u0443",
        "pe",
        "51"
    ],
    [
        "\u0424\u0438\u043B\u0438\u043F\u043F\u0438\u043D\u044B",
        "ph",
        "63"
    ],
    [
        "\u041F\u043E\u043B\u044C\u0448\u0430",
        "pl",
        "48"
    ],
    [
        "\u041F\u043E\u0440\u0442\u0443\u0433\u0430\u043B\u0438\u044F",
        "pt",
        "351"
    ],
    [
        "\u041F\u0443\u044D\u0440\u0442\u043E \u0420\u0438\u043A\u043E",
        "pr",
        "1",
        3,
        [
            "787",
            "939"
        ]
    ],
    [
        "\u041A\u0430\u0442\u0430\u0440",
        "qa",
        "974"
    ],
    [
        "\u0420\u0435\u044E\u043D\u044C\u043E\u043D",
        "re",
        "262",
        0
    ],
    [
        "\u0420\u0443\u043C\u044B\u043D\u0438\u044F",
        "ro",
        "40"
    ],
    [
        "\u0420\u043E\u0441\u0441\u0438\u044F",
        "ru",
        "7",
        0
    ],
    [
        "\u0420\u0443\u0430\u043D\u0434\u0430",
        "rw",
        "250"
    ],
    [
        "\u0421\u0435\u043D-\u0411\u0430\u0440\u0442\u0435\u043B\u0435\u043C\u0438",
        "bl",
        "590",
        1
    ],
    [
        "\u041E\u0441\u0442\u0440\u043E\u0432 \u0421\u0432\u044F\u0442\u043E\u0439 \u0415\u043B\u0435\u043D\u044B",
        "sh",
        "290"
    ],
    [
        "\u0421\u0435\u043D\u0442-\u041A\u0438\u0442\u0441 \u0438 \u041D\u0435\u0432\u0438\u0441",
        "kn",
        "1869"
    ],
    [
        "\u0421\u0435\u043D\u0442-\u041B\u044E\u0441\u0438\u044F",
        "lc",
        "1758"
    ],
    [
        "\u0421\u0435\u043D-\u041C\u0430\u0440\u0442\u0435\u043D",
        "mf",
        "590",
        2
    ],
    [
        "\u0421\u0435\u043D-\u041F\u044C\u0435\u0440 \u0438 \u041C\u0438\u043A\u0435\u043B\u043E\u043D",
        "pm",
        "508"
    ],
    [
        "\u0421\u0435\u043D\u0442-\u0412\u0438\u043D\u0441\u0435\u043D\u0442 \u0438 \u0413\u0440\u0435\u043D\u0430\u0434\u0438\u043D\u044B",
        "vc",
        "1784"
    ],
    [
        "\u0421\u0430\u043C\u043E\u0430",
        "ws",
        "685"
    ],
    [
        "\u0421\u0430\u043D \u041C\u0430\u0440\u0438\u043D\u043E",
        "sm",
        "378"
    ],
    [
        "\u0421\u0430\u043D-\u0422\u043E\u043C\u0435 \u0438 \u041F\u0440\u0438\u043D\u0441\u0438\u043F\u0438",
        "st",
        "239"
    ],
    [
        "\u0421\u0430\u0443\u0434\u043E\u0432\u0441\u043A\u0430\u044F \u0410\u0440\u0430\u0432\u0438\u044F",
        "sa",
        "966"
    ],
    [
        "\u0421\u0435\u043D\u0435\u0433\u0430\u043B",
        "sn",
        "221"
    ],
    [
        "\u0421\u0435\u0440\u0431\u0438\u044F",
        "rs",
        "381"
    ],
    [
        "\u0421\u0435\u0439\u0448\u0435\u043B\u044C\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        "sc",
        "248"
    ],
    [
        "\u0421\u044C\u0435\u0440\u0440\u0430 \u041B\u0435\u043E\u043D\u0435",
        "sl",
        "232"
    ],
    [
        "\u0421\u0438\u043D\u0433\u0430\u043F\u0443\u0440",
        "sg",
        "65"
    ],
    [
        "\u0421\u0438\u043D\u0442-\u041C\u0430\u0440\u0442\u0435\u043D",
        "sx",
        "1721"
    ],
    [
        "\u0421\u043B\u043E\u0432\u0430\u043A\u0438\u044F",
        "sk",
        "421"
    ],
    [
        "\u0421\u043B\u043E\u0432\u0435\u043D\u0438\u044F",
        "si",
        "386"
    ],
    [
        "\u0421\u043E\u043B\u043E\u043C\u043E\u043D\u043E\u0432\u044B \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        "sb",
        "677"
    ],
    [
        "\u0421\u043E\u043C\u0430\u043B\u0438",
        "so",
        "252"
    ],
    [
        "\u042E\u0436\u043D\u0430\u044F \u0410\u0444\u0440\u0438\u043A\u0430",
        "za",
        "27"
    ],
    [
        "\u042E\u0436\u043D\u0430\u044F \u041A\u043E\u0440\u0435\u044F",
        "kr",
        "82"
    ],
    [
        "\u042E\u0436\u043D\u044B\u0439 \u0421\u0443\u0434\u0430\u043D",
        "ss",
        "211"
    ],
    [
        "\u0418\u0441\u043F\u0430\u043D\u0438\u044F",
        "es",
        "34"
    ],
    [
        "\u0428\u0440\u0438-\u041B\u0430\u043D\u043A\u0430",
        "lk",
        "94"
    ],
    [
        "\u0421\u0443\u0434\u0430\u043D",
        "sd",
        "249"
    ],
    [
        "\u0421\u0443\u0440\u0438\u043D\u0430\u043C",
        "sr",
        "597"
    ],
    [
        "\u0428\u043F\u0438\u0446\u0431\u0435\u0440\u0433\u0435\u043D \u0438 \u042F\u043D \u041C\u0430\u0439\u0435\u043D",
        "sj",
        "47",
        1
    ],
    [
        "\u0421\u0432\u0430\u0437\u0438\u043B\u0435\u043D\u0434",
        "sz",
        "268"
    ],
    [
        "\u0428\u0432\u0435\u0446\u0438\u044F",
        "se",
        "46"
    ],
    [
        "\u0428\u0432\u0435\u0439\u0446\u0430\u0440\u0438\u044F",
        "ch",
        "41"
    ],
    [
        "\u0421\u0438\u0440\u0438\u044F",
        "sy",
        "963"
    ],
    [
        "\u0422\u0430\u0439\u0432\u0430\u043D\u044C",
        "tw",
        "886"
    ],
    [
        "\u0422\u0430\u0434\u0436\u0438\u043A\u0438\u0441\u0442\u0430\u043D",
        "tj",
        "992"
    ],
    [
        "\u0422\u0430\u043D\u0437\u0430\u043D\u0438\u044F",
        "tz",
        "255"
    ],
    [
        "\u0422\u0430\u0438\u043B\u0430\u043D\u0434",
        "th",
        "66"
    ],
    [
        "\u0412\u043E\u0441\u0442\u043E\u0447\u043D\u044B\u0439 \u0422\u0438\u043C\u043E\u0440",
        "tl",
        "670"
    ],
    [
        "\u0422\u043E\u0433\u043E",
        "tg",
        "228"
    ],
    [
        "\u0422\u043E\u043A\u0435\u043B\u0430\u0443",
        "tk",
        "690"
    ],
    [
        "\u0422\u043E\u043D\u0433\u0430",
        "to",
        "676"
    ],
    [
        "\u0422\u0440\u0438\u043D\u0438\u0434\u0430\u0434 \u0438 \u0422\u043E\u0431\u0430\u0433\u043E",
        "tt",
        "1868"
    ],
    [
        "\u0422\u0443\u043D\u0438\u0441",
        "tn",
        "216"
    ],
    [
        "\u0422\u0443\u0440\u0446\u0438\u044F",
        "tr",
        "90"
    ],
    [
        "\u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D",
        "tm",
        "993"
    ],
    [
        "\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u0422\u0435\u0440\u043A\u0441 \u0438 \u041A\u0430\u0439\u043A\u043E\u0441",
        "tc",
        "1649"
    ],
    [
        "\u0422\u0443\u0432\u0430\u043B\u0443",
        "tv",
        "688"
    ],
    [
        "\u0412\u0438\u0440\u0433\u0438\u043D\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u0421\u0428\u0410",
        "vi",
        "1340"
    ],
    [
        "\u0423\u0433\u0430\u043D\u0434\u0430",
        "ug",
        "256"
    ],
    [
        "\u0423\u043A\u0440\u0430\u0438\u043D\u0430",
        "ua",
        "380"
    ],
    [
        "\u041E\u0431\u044A\u0435\u0434\u0438\u043D\u0435\u043D\u043D\u044B\u0435 \u0410\u0440\u0430\u0431\u0441\u043A\u0438\u0435 \u042D\u043C\u0438\u0440\u0430\u0442\u044B",
        "ae",
        "971"
    ],
    [
        "\u0412\u0435\u043B\u0438\u043A\u043E\u0431\u0440\u0438\u0442\u0430\u043D\u0438\u044F",
        "gb",
        "44",
        0
    ],
    [
        "\u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u043D\u044B\u0435 \u0428\u0442\u0430\u0442\u044B",
        "us",
        "1",
        0
    ],
    [
        "\u0423\u0440\u0443\u0433\u0432\u0430\u0439",
        "uy",
        "598"
    ],
    [
        "\u0423\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u0430\u043D",
        "uz",
        "998"
    ],
    [
        "\u0412\u0430\u043D\u0443\u0430\u0442\u0443",
        "vu",
        "678"
    ],
    [
        "\u0412\u0430\u0442\u0438\u043A\u0430\u043D",
        "va",
        "39",
        1
    ],
    [
        "\u0412\u0435\u043D\u0435\u0441\u0443\u044D\u043B\u0430",
        "ve",
        "58"
    ],
    [
        "\u0412\u044C\u0435\u0442\u043D\u0430\u043C",
        "vn",
        "84"
    ],
    [
        "\u0423\u043E\u043B\u043B\u0438\u0441 \u0438 \u0424\u0443\u0442\u0443\u043D\u0430",
        "wf",
        "681"
    ],
    [
        "\u0417\u0430\u043F\u0430\u0434\u043D\u0430\u044F \u0421\u0430\u0445\u0430\u0440\u0430",
        "eh",
        "212",
        1
    ],
    [
        "\u0419\u0435\u043C\u0435\u043D",
        "ye",
        "967"
    ],
    [
        "\u0417\u0430\u043C\u0431\u0438\u044F",
        "zm",
        "260"
    ],
    [
        "\u0417\u0438\u043C\u0431\u0430\u0431\u0432\u0435",
        "zw",
        "263"
    ],
    [
        "\u0410\u043B\u0430\u043D\u0434\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        "ax",
        "358",
        1
    ]
];
const $3b08cdf4040c7c7f$var$allCountriesObj = $3b08cdf4040c7c7f$var$allCountries.map((country)=>({
        name: country[0],
        iso: country[1].toUpperCase(),
        code: "+" + country[2],
        priority: country[3] || 0
    })).sort((a, b)=>{
    let nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
});
var $3b08cdf4040c7c7f$export$2e2bcd8739ae039 = $3b08cdf4040c7c7f$var$allCountriesObj;

});




parcelRegister("2ACAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e2cdf9e25ef8cdc$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $1e2cdf9e25ef8cdc$var$API_URL = (0, location.origin);
class $1e2cdf9e25ef8cdc$var$Vox {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/vox", null, null, $1e2cdf9e25ef8cdc$var$API_URL);
    }
    getUrl(call_id) {
        if (!call_id) call_id = undefined;
        return this.apiService.get("get_url", {
            call_id: call_id
        });
    }
    getToken(key, call_id) {
        if (!call_id) call_id = undefined;
        return this.apiService.get("get_token", {
            key: key,
            call_id: call_id
        });
    }
}
var $1e2cdf9e25ef8cdc$export$2e2bcd8739ae039 = new $1e2cdf9e25ef8cdc$var$Vox();

});

parcelRegister("62BIJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $466030783980d2c3$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $466030783980d2c3$var$API_URL = (0, location.origin);
class $466030783980d2c3$var$Call {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/call", null, null, $466030783980d2c3$var$API_URL);
    }
    get(id) {
        return this.apiService.get(`${id}`);
    }
    create(room, start_time, end_time) {
        return this.apiService.post("", {}, {
            room: room,
            start_time: start_time,
            end_time: end_time
        });
    }
}
var $466030783980d2c3$export$2e2bcd8739ae039 = new $466030783980d2c3$var$Call();

});

parcelRegister("lhKaP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7ef009bfd06eeac$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $f7ef009bfd06eeac$var$API_URL = (0, location.origin);
class $f7ef009bfd06eeac$var$Config {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("", null, null, $f7ef009bfd06eeac$var$API_URL);
    }
    getConfig() {
        return this.apiService.get("mobile-api/configs");
    }
}
var $f7ef009bfd06eeac$export$2e2bcd8739ae039 = new $f7ef009bfd06eeac$var$Config();

});

parcelRegister("joy3t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1eaacd06877dd8d$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $e1eaacd06877dd8d$var$API_URL = (0, location.origin);
class $e1eaacd06877dd8d$var$Drugs {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $e1eaacd06877dd8d$var$API_URL);
    }
    getDrugs(query) {
        return this.apiService.get("drugs", {
            q: query
        });
    }
    postDrugs(name) {
        return this.apiService.post("drugs", {}, {
            name: name
        });
    }
}
var $e1eaacd06877dd8d$export$2e2bcd8739ae039 = new $e1eaacd06877dd8d$var$Drugs();

});

parcelRegister("5GzI7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $423c9361b57191d6$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $423c9361b57191d6$var$API_URL = (0, location.origin);
class $423c9361b57191d6$var$Diagnoses {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $423c9361b57191d6$var$API_URL);
    }
    getDiagnoses(params) {
        return this.apiService.get(`diagnoses`, params);
    }
    getDiagnosisParents(id) {
        return this.apiService.get(`diagnoses/${id}/parents`);
    }
}
var $423c9361b57191d6$export$2e2bcd8739ae039 = new $423c9361b57191d6$var$Diagnoses();

});

parcelRegister("6q8q6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4acbb3d57c852588$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $jqdsN = parcelRequire("jqdsN");
parcelRequire("bh6RR");

var $5lJLQ = parcelRequire("5lJLQ");

var $5oGqh = parcelRequire("5oGqh");

var $3M0M5 = parcelRequire("3M0M5");
const $4acbb3d57c852588$var$toastManager = (0, $5oGqh.useToast)();
const $4acbb3d57c852588$var$API_URL = (0, location.origin);
class $4acbb3d57c852588$var$Chatroom {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $4acbb3d57c852588$var$API_URL);
    }
    getAll() {
        return this.apiService.get("chatrooms", {
            per_page: 5000
        });
    }
    get(perPage, page = 0, search = "", filterBy = (0, $3M0M5.ChatFilters).ALL) {
        return this.apiService.get("chatrooms", {
            per_page: perPage,
            page: page,
            search: search,
            filter_by: filterBy
        }, {}, true, "", false, true);
    }
    startCall(id) {
        return this.apiService.post(`chatrooms/${id}/opponent_start_call`);
    }
    async getChatroom(params, withoutToast) {
        try {
            return await this.apiService.get("chatroom", params);
        } catch (e) {
            switch(e.code){
                case 404:
                    if (!withoutToast) $4acbb3d57c852588$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        children: e.result.details === "Not Found user patient" ? "\u0423 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430 \u043D\u0435 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435" : "\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D \u0447\u0430\u0442 \u0441 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u043E\u043C"
                    }), {
                        duration: 10000
                    });
                    return e.result;
                default:
                    if (!withoutToast) $4acbb3d57c852588$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        children: "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430"
                    }), {
                        duration: 10000
                    });
                    return e.result;
            }
        }
    }
    getByScheduleId(scheduleId, withoutToast) {
        return this.getChatroom({
            schedule_id: scheduleId
        }, withoutToast);
    }
    getByPatientId(patientId, getOrCreate, withoutToast) {
        return this.getChatroom({
            patient_id: patientId,
            get_or_create: getOrCreate
        }, withoutToast);
    }
    getUnreadChatsCount() {
        return this.apiService.get("chatrooms/counting-unread");
    }
    setSettingsChats(settings) {
        this.apiService.post("users/auth/current_user/doctor/status", {}, settings);
    }
}
var $4acbb3d57c852588$export$2e2bcd8739ae039 = new $4acbb3d57c852588$var$Chatroom();

});

parcelRegister("l6cLw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5c40f79e4737462$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $f5c40f79e4737462$var$API_URL = (0, location.origin);
class $f5c40f79e4737462$var$Payment {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/payment", null, null, $f5c40f79e4737462$var$API_URL);
    }
    getPayment(id) {
        return this.apiService.get(id);
    }
    getListPayments({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params }) {
        return this.apiService.post(`analytics/list`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params
        });
    }
    getServiceAmounts(filters) {
        return this.apiService.post(`analytics/service-amounts`, {}, filters);
    }
}
var $f5c40f79e4737462$export$2e2bcd8739ae039 = new $f5c40f79e4737462$var$Payment();

});

parcelRegister("5hCBm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d8c7bbe3f963f56$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $3d8c7bbe3f963f56$var$API_URL = (0, location.origin);
class $3d8c7bbe3f963f56$var$FDOC {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("api-v2/fdoc", null, null, $3d8c7bbe3f963f56$var$API_URL);
    }
    getDocumentsByAppointment(appointmentId) {
        return this.apiService.get(`documents/${appointmentId}`);
    }
    getDocumentLink(data) {
        const { appointmentId: appointmentId, packageId: packageId } = data;
        return this.apiService.get(`generate_url/${appointmentId}/${packageId}`);
    }
    uploadDocuments(data) {
        const { appointmentId: appointmentId, file: file, signers: signers } = data;
        return this.apiService.post(`upload_documents/${appointmentId}`, {}, {
            "documents": [
                {
                    "name": file.name,
                    "file": file.content
                }
            ],
            "package": {
                "needIdentification": true,
                "identificationType": "esia",
                "signers": signers
            }
        });
    }
}
var $3d8c7bbe3f963f56$export$2e2bcd8739ae039 = new $3d8c7bbe3f963f56$var$FDOC();

});

parcelRegister("bkhHb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83ef49f0ef37d62e$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $83ef49f0ef37d62e$var$API_URL = (0, location.origin);
class $83ef49f0ef37d62e$var$FullSchedule {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $83ef49f0ef37d62e$var$API_URL);
    }
    getFullSchedule(params, needAbortPreviousRequest) {
        return this.apiService.get(`full-schedule`, params, {}, true, "", false, needAbortPreviousRequest);
    }
}
var $83ef49f0ef37d62e$export$2e2bcd8739ae039 = new $83ef49f0ef37d62e$var$FullSchedule();

});

parcelRegister("cPpOY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $956e46fefd5baed7$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $956e46fefd5baed7$var$API_URL = (0, location.origin);
class $956e46fefd5baed7$var$Schedule {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/schedule", null, null, $956e46fefd5baed7$var$API_URL);
    }
    create(start, end) {
        return this.apiService.post("create", {}, {
            start: start,
            end: end
        });
    }
    get(params) {
        return this.apiService.get("", params);
    }
    getScheduleUpdatesUrl() {
        const url = new URL(`${$956e46fefd5baed7$var$API_URL}/api/ws/schedule-updates/`);
        url.protocol = "wss:";
        return url.toString();
    }
    delete(id) {
        return this.apiService.post("delete", {}, {
            id: id
        });
    }
    deleteDay(date) {
        return this.apiService.post("delete-day", {}, {
            date: date
        });
    }
    chatEnable(date) {
        return this.apiService.post("chat", {}, {
            date: date,
            is_deleted: false
        });
    }
    chatDisable(date) {
        return this.apiService.post("chat", {}, {
            date: date,
            is_deleted: true
        });
    }
    scheduleListWithValues({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params }) {
        return this.apiService.post(`list_dynamic_data_search`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params
        }, {}, true, "", true);
    }
}
var $956e46fefd5baed7$export$2e2bcd8739ae039 = new $956e46fefd5baed7$var$Schedule();

});

parcelRegister("41KWU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2eebac8c7b9f8b38$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $2eebac8c7b9f8b38$var$API_URL = (0, location.origin);
class $2eebac8c7b9f8b38$var$ScheduleInserts {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $2eebac8c7b9f8b38$var$API_URL);
    }
    postScheduleInserts(scheduleValues) {
        return this.apiService.post("schedule-inserts", {}, scheduleValues);
    }
    getListScheduleInserts({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params }) {
        return this.apiService.post(`dynamic/scheduleinsert/list`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params
        }, {}, true, "", true);
    }
    postRecordScheduleInserts(params) {
        return this.apiService.post("schedule-inserts-v2", {}, {
            ...params
        });
    }
    postCancelScheduleInserts(params) {
        return this.apiService.post("integration/schedule/cancel", {}, {
            ...params
        }, {
            Secretkey: "secret"
        });
    }
    postAdditionalRecordingAction(params) {
        return this.apiService.post("schedule-inserts-v2/buttons", {}, {
            ...params
        });
    }
    getDocumentForPrint(params) {
        return this.apiService.get("schedule-inserts-v2/document-print", {
            ...params
        });
    }
}
var $2eebac8c7b9f8b38$export$2e2bcd8739ae039 = new $2eebac8c7b9f8b38$var$ScheduleInserts();

});

parcelRegister("3oYiD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27a26334ad84e4c3$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $27a26334ad84e4c3$var$API_URL = (0, location.origin);
class $27a26334ad84e4c3$var$Services {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $27a26334ad84e4c3$var$API_URL);
    }
    list({ per_page: per_page }) {
        return this.apiService.get("services", {
            per_page: per_page
        });
    }
    create(data) {
        return this.apiService.post("services", {}, data);
    }
    delete(serviceId) {
        return this.apiService.delete(`services/${serviceId}`);
    }
    getOrganizationServices(organizationId, params) {
        return this.apiService.get(`organizations/${organizationId}/services`, params, {}, true, "", true);
    }
    getServiceCategories(organizationId) {
        return this.apiService.get(`organizations/${organizationId}/categories`, {}, {}, true, "", true);
    }
    clearCacheOrganizationServices(organizationId, params) {
        return this.apiService.clearCacheForRequest(`organizations/${organizationId}/services`, params, {}, true, "");
    }
}
var $27a26334ad84e4c3$export$2e2bcd8739ae039 = new $27a26334ad84e4c3$var$Services();

});

parcelRegister("h8EH0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7a2bfb5d8d7fe50$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $c7a2bfb5d8d7fe50$var$API_URL = (0, location.origin);
let $c7a2bfb5d8d7fe50$var$_organization_id = undefined;
class $c7a2bfb5d8d7fe50$var$Shortcuts {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $c7a2bfb5d8d7fe50$var$API_URL);
    }
    getShortcuts({ layout_id: layout_id, organization_id: organization_id }) {
        if (organization_id) // этот хак, чтобы в миллионах мест не пробрасывать эту переменную, пробросил только внутри EditAppointmentPage
        $c7a2bfb5d8d7fe50$var$_organization_id = organization_id;
        return this.apiService.get(`layouts/${layout_id}/shortcuts`, {
            organization_id: $c7a2bfb5d8d7fe50$var$_organization_id
        });
    }
    postShortcut(creationOptions) {
        return this.apiService.post(`shortcuts`, {}, creationOptions);
    }
    putShortcut(shortcutId, creationOptions) {
        return this.apiService.patch(`shortcuts/${shortcutId}`, {}, creationOptions);
    }
    postShortcutOrder(shortcutsOrderOptions) {
        return this.apiService.post(`shortcuts/set-order`, {}, shortcutsOrderOptions);
    }
    deleteShortcut(shortcutId) {
        return this.apiService.delete(`shortcuts/${shortcutId}`);
    }
}
var $c7a2bfb5d8d7fe50$export$2e2bcd8739ae039 = new $c7a2bfb5d8d7fe50$var$Shortcuts();

});

parcelRegister("5V81B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44f880325c573a4a$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");

var $iOlMk = parcelRequire("iOlMk");
const $44f880325c573a4a$var$uploadProgressHandler = (event)=>{
    return Math.round(event.loaded / event.total * 100);
};
const $44f880325c573a4a$var$sendFile = async (formData, attachmentUuid, onProgressUpdate)=>new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("progress", (event)=>{
            const loadedPercent = $44f880325c573a4a$var$uploadProgressHandler(event);
            onProgressUpdate(attachmentUuid, loadedPercent);
        }, false);
        xhr.addEventListener("load", resolve, false);
        xhr.addEventListener("error", reject);
        xhr.open("POST", $44f880325c573a4a$var$API_URL + "/api/attachments/");
        xhr.setRequestHeader("APP-TYPE", "doctor");
        xhr.setRequestHeader("Authorization", `JWT ${(0, $iOlMk.tokenStore).getState()}`);
        xhr.send(formData);
    });
const $44f880325c573a4a$var$API_URL = (0, location.origin);
class $44f880325c573a4a$var$MessageAttachments {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $44f880325c573a4a$var$API_URL);
    }
    send(data, attachments, onProgressUpdate) {
        const formData = new FormData();
        for(let key in data)if (Array.isArray(data[key])) data[key].forEach((item)=>{
            formData.append(key, item);
        });
        else formData.append(key, data[key]);
        for (let attachment of attachments){
            formData.set("file_list", attachment.original_file);
            $44f880325c573a4a$var$sendFile(formData, attachment.uuid, onProgressUpdate);
        }
    // return this.apiService.post("attachments", {}, formData, {}, false);
    }
}
var $44f880325c573a4a$export$2e2bcd8739ae039 = new $44f880325c573a4a$var$MessageAttachments();

});

parcelRegister("1YSA2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1715bb8f08a500f8$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $1715bb8f08a500f8$var$API_URL = (0, location.origin);
class $1715bb8f08a500f8$var$Medicines {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/decision-support/medicines", null, null, $1715bb8f08a500f8$var$API_URL);
    }
    get(search) {
        return this.apiService.get("", {
            search: search
        }, {}, true, "", false, true);
    }
    propose(name) {
        return this.apiService.post("propose", {}, {
            name: name
        });
    }
}
var $1715bb8f08a500f8$export$2e2bcd8739ae039 = new $1715bb8f08a500f8$var$Medicines();

});

parcelRegister("jGbjz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e53ab7663b5e7aec$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $e53ab7663b5e7aec$var$API_URL = (0, location.origin);
class $e53ab7663b5e7aec$var$Examinations {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/decision-support/examinations", null, null, $e53ab7663b5e7aec$var$API_URL);
    }
    get({ search: search, organizationId: organizationId }) {
        return this.apiService.get("", {
            search: search,
            organization_id: organizationId
        }, {}, true, "", false, true);
    }
    propose(name) {
        return this.apiService.post("propose", {}, {
            name: name
        });
    }
}
var $e53ab7663b5e7aec$export$2e2bcd8739ae039 = new $e53ab7663b5e7aec$var$Examinations();

});

parcelRegister("dkxBT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b4736e63b595a2c$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $9b4736e63b595a2c$var$API_URL = (0, location.origin);
class $9b4736e63b595a2c$var$QualityCriteria {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/decision-support/quality-criteria", null, null, $9b4736e63b595a2c$var$API_URL);
    }
    get({ search: search, organizationId: organizationId }) {
        return this.apiService.get("", {
            search: search,
            organization_id: organizationId
        }, {}, true, "", false, true);
    }
    propose(name) {
        return this.apiService.post("propose", {}, {
            name: name
        });
    }
}
var $9b4736e63b595a2c$export$2e2bcd8739ae039 = new $9b4736e63b595a2c$var$QualityCriteria();

});

parcelRegister("iAk1O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d87b1ff9fa3689d3$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $d87b1ff9fa3689d3$var$API_URL = (0, location.origin);
class $d87b1ff9fa3689d3$var$Documents {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $d87b1ff9fa3689d3$var$API_URL);
    }
    get() {
        return this.apiService.get("documents");
    }
    getTemplate(agreementId, { folderId: folderId, appointmentId: appointmentId }) {
        return this.apiService.get(`documents/${agreementId}/print`, {
            folder_id: folderId,
            appointment_id: appointmentId
        });
    }
    getCategories() {
        return this.apiService.get("document_categories");
    }
}
var $d87b1ff9fa3689d3$export$2e2bcd8739ae039 = new $d87b1ff9fa3689d3$var$Documents();

});

parcelRegister("7cLu9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53ee7cffef7b1ca0$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
parcelRequire("kJMeB");
const $53ee7cffef7b1ca0$var$API_URL = (0, location.origin);
class $53ee7cffef7b1ca0$var$Appointments {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $53ee7cffef7b1ca0$var$API_URL);
    }
    createAppointment(creationOptions) {
        return this.apiService.post(`appointments`, {}, creationOptions);
    }
    reopenAppointment(appointmentId) {
        return this.apiService.post(`appointments/${appointmentId}/reopen`);
    }
    getAppointmentById(appointmentId) {
        return this.apiService.get(`appointments/${appointmentId}`);
    }
    sendAppointmentPDF(appointmentId, pdfData) {
        return this.apiService.post(`appointments/${appointmentId}/send`, {}, {
            appointment_id: appointmentId,
            appointment_pdf: pdfData
        });
    }
    getAppointment(appointmentId) {
        return this.apiService.get(`appointments/${appointmentId}`);
    }
    getAppointments(params) {
        return this.apiService.get(`appointments/search`, params);
    }
    getAppointmentsNextToEvaluate() {
        return this.apiService.get(`appointments/next-to-evaluate`);
    }
    getLayoutsToEvaluate(layoutId) {
        return this.apiService.get(`layouts/${layoutId}/evaluation-criterion`);
    }
    postAppointmentEvaluation(evaluationData) {
        return this.apiService.post(`evaluations`, {}, evaluationData);
    }
    putAppointmentEvaluation(id, evaluationData) {
        return this.apiService.put(`evaluations/${id}`, {}, evaluationData, {}, true);
    }
    getAppointmentsForEvaluate(limit, offset) {
        return this.apiService.get(`appointments/next-to-evaluate/list`, {
            limit: limit,
            offset: offset
        });
    }
    getAppointmentsByPatientId(patientId, groupingFolders) {
        return this.apiService.get(`appointments`, {
            patient_id: patientId,
            grouping_folders: groupingFolders.toString()
        });
    }
    getAppointmentLayoutById(id) {
        return this.apiService.get(`layouts/${id}`, {}, {}, true, "", true);
    }
    deleteAppointment(appointmentId) {
        return this.apiService.delete(`appointments/${appointmentId}`);
    }
    getSectionHistory({ id: id, section_id: section_id }) {
        return this.apiService.get(`appointments/${id}/section-history/${section_id}`);
    }
    getLayout(id) {
        return this.apiService.get(`layouts/${id}`);
    }
    getLayoutGroups() {
        return this.apiService.get(`layout-groups`, {}, {}, true, "", true);
    }
    getLayoutsByGroupID(groupId) {
        return this.apiService.get(`layouts`, {
            group: groupId
        }, {}, true, "", true);
    }
    getPopularLayouts() {
        return this.apiService.get(`popular-layouts`);
    }
    addPopularLayout(layoutId) {
        return this.apiService.post(`popular-layouts`, {}, {
            layout_id: layoutId
        });
    }
    deletePopularLayout(layoutId) {
        return this.apiService.delete(`popular-layouts/${layoutId}`);
    }
    getUltrasoundScans(appointmentId) {
        return this.apiService.get(`ultrasound`, {
            appointment: appointmentId
        });
    }
    getShortcuts(layoutId) {
        return this.apiService.get(`layouts/${layoutId}/shortcuts`);
    }
    getAppointmentAISlices(appointmentId) {
        return this.apiService.get(`ai/appointment/ai_status/${appointmentId}`, {}, {}, true, "", false, false, "", true);
    }
    getAppointmentsOutcomes({ query: query, filter: filter, eventType: eventType }) {
        const params = {};
        if (query) params.patient_name = query;
        if (filter === "all") params.all = "true";
        if (eventType) params.layout_folder_id = eventType;
        return this.apiService.get(`appointments/outcomes`, params);
    }
    patchAppointmentsOutcomesFieldValue(id, value) {
        return this.apiService.patch(`field_values/${id}`, {}, {
            value: value
        });
    }
    postAppointmentsOutcomesFieldValue({ appointmentId: appointmentId, fieldId: fieldId, value: value }) {
        return this.apiService.post(`field_values`, {}, {
            value: value,
            appointment_id: appointmentId,
            copy_id: fieldId
        });
    }
    getFolders({ layoutId: layoutId, patientId: patientId }) {
        return this.apiService.get(`folders`, {
            layout_id: layoutId,
            patient_id: patientId
        });
    }
    getFolder(id) {
        return this.apiService.get(`folders/${id}`);
    }
    moveAppointmentFolder(params) {
        const { folderId: folderId, folderTypeId: folderTypeId, appointmentId: appointmentId } = params;
        const data = {};
        if (folderId) data.folder_id = folderId;
        if (folderTypeId) data.f_layout_id = folderTypeId;
        return this.apiService.patch(`appointments/${appointmentId}/folders`, {}, data);
    }
    removeAppointmentFromFolder(folderId, appointmentId) {
        return this.apiService.delete(`appointments/${appointmentId}/folders`, {}, {
            folder_id: folderId
        });
    }
    getFolderSummary(folderId) {
        return this.apiService.get(`folders/${folderId}/full_summary`);
    }
    getSummaryPrint(params) {
        const searchParams = new URLSearchParams();
        if (params.summary) params.summary.forEach((summaryId)=>{
            searchParams.append("summary", summaryId);
        });
        return this.apiService.get(`patient/${params.patient_id}/print_epicrises${searchParams ? `/?${searchParams}` : ""}`);
    }
    getFolderAnalyses(folderId) {
        return this.apiService.get(`folders/${folderId}/patient_examinations`);
    }
    updateFolderAnalyze(folderId, id, payload) {
        return this.apiService.patch(`folders/${folderId}/patient_examinations/${id}`, {}, payload);
    }
    getFolderAgreement(folderId, agreementId) {
        return this.apiService.get(`folders/${folderId}/patient_agreements/${agreementId}/print`);
    }
    getFolderAgreements(folderId) {
        return this.apiService.get(`folders/${folderId}/patient_agreements`);
    }
    updateFolderAgreement(folderId, id, payload) {
        return this.apiService.put(`folders/${folderId}/patient_agreements/${id}`, {}, payload, {}, true);
    }
    getFolderPrintDetails(params) {
        const { id: id, concreteFolder: concreteFolder } = params;
        let newParams = {};
        if (concreteFolder) newParams.only_folder_id = concreteFolder;
        return this.apiService.get(`folders/${id}/full_summary/print`, newParams);
    }
    getAppointmentList({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params }) {
        return this.apiService.post(`dynamic/prescribedserviceappointment/list`, {}, {
            values_params: values_params,
            filter_params: filter_params,
            per_page: meta.per_page,
            order_by_params: order_by_params
        });
    }
    completeAppointment(params) {
        return this.apiService.post(`dynamic/prescribedserviceappointment/update`, {}, params);
    }
    postAppointmentsSetValues({ appointment_id: appointment_id, fieldValues: fieldValues }) {
        return this.apiService.post(`appointments/${appointment_id}/set-values`, {}, fieldValues);
    }
    postAppointmentsFinish(data) {
        return this.apiService.post(`appointments/${data.appointment_id}/finish`, {}, data);
    }
    postAnalytics(params) {
        return this.apiService.post(`protocol_filling_analytics`, {}, params);
    }
    getConclusion(params) {
        return this.apiService.get(`decision-support/conclusion`, params);
    }
    postSetConclusion(params) {
        const { appointment_id: appointment_id, ...other } = params;
        return this.apiService.post(`appointments/${appointment_id}/set-conclusion`, {}, other);
    }
    postInvoiceForPayment({ appointment_id: appointment_id }) {
        return this.apiService.post(`invoice-for-payment`, {}, {
            appointment_id: appointment_id
        });
    }
    getFavoritesAppointmentList() {
        return this.apiService.get("favorite-appointments");
    }
    addFavoriteAppointment(appointment_id) {
        return this.apiService.post(`favorite-appointments`, {}, {
            appointment_id: appointment_id
        });
    }
    deleteFavoriteAppointment(appointment_id) {
        return this.apiService.delete(`favorite-appointments/${appointment_id}`);
    }
    getFinishCheckUp(folderId) {
        return this.apiService.get(`appointments/finish-check-up`, {
            folder_id: folderId
        });
    }
    getAppointmentPrescribedService(appointmentId) {
        return this.apiService.get(`appointments/prescribed-services`, {
            appointment_id: appointmentId
        });
    }
    postAppointmentPrescribedService(appointmentId, data) {
        return this.apiService.post(`appointments/prescribed-services`, {
            appointment_id: appointmentId
        }, data);
    }
}
var $53ee7cffef7b1ca0$export$2e2bcd8739ae039 = new $53ee7cffef7b1ca0$var$Appointments();

});
parcelRegister("kJMeB", function(module, exports) {

$parcel$export(module.exports, "getServiceCategories", function () { return $f18d6cfb12c96453$export$d1063e0a64370a43; });
$parcel$export(module.exports, "getServices", function () { return $f18d6cfb12c96453$export$a009e3a1163d46fb; });
$parcel$export(module.exports, "addServiceToFavorties", function () { return $f18d6cfb12c96453$export$e8eabb9ac665aa46; });
$parcel$export(module.exports, "removeServiceFromFavorties", function () { return $f18d6cfb12c96453$export$81000149f2a51f86; });
$parcel$export(module.exports, "addAppointmentService", function () { return $f18d6cfb12c96453$export$6ec996cb4fb42f1d; });
$parcel$export(module.exports, "removeAppointmentService", function () { return $f18d6cfb12c96453$export$1f7ee64b282ecbd; });
$parcel$export(module.exports, "addAppointmentPrescribedService", function () { return $f18d6cfb12c96453$export$2d13315de628cb21; });
$parcel$export(module.exports, "removeAppointmentPrescribedService", function () { return $f18d6cfb12c96453$export$e3250122ee7da2d9; });
$parcel$export(module.exports, "getPolicyDescription", function () { return $f18d6cfb12c96453$export$492796ee0ee9c4b8; });

var $4G40X = parcelRequire("4G40X");

var $kmHuZ = parcelRequire("kmHuZ");
parcelRequire("kEUo3");

var $fbfwH = parcelRequire("fbfwH");
const $f18d6cfb12c96453$export$d1063e0a64370a43 = (organizationId)=>(0, $kmHuZ.default).services.getServiceCategories(organizationId);
const $f18d6cfb12c96453$var$serviceToNum = (service)=>{
    return parseInt(service.ministry_of_health_code.replace(/\D/g, ""));
};
const $f18d6cfb12c96453$var$prescribedSectionServices = {};
const $f18d6cfb12c96453$export$a009e3a1163d46fb = async ({ organizationId: organizationId, searchQuery: searchQuery, favorites: favorites = false, id: id = null, forPrescribedSection: forPrescribedSection = false })=>{
    const params = {};
    if (favorites) params.only_favorites = true;
    // if (searchQuery) {
    //   params.search = searchQuery;
    // }
    let services = await (0, $kmHuZ.default).services.getOrganizationServices(organizationId, params);
    if (!searchQuery) {
        if (id) return services.filter((s)=>s.id === id);
        return services;
    }
    if (forPrescribedSection) {
        if (!$f18d6cfb12c96453$var$prescribedSectionServices[organizationId]) {
            if (organizationId === 30) {
                services = services.filter((s)=>!(0, $fbfwH.default).consultationsCategoriesIds.includes(s.category_id) || s.ministry_of_health_code.startsWith("B01") && s.ministry_of_health_code.endsWith(".001"));
                $f18d6cfb12c96453$var$prescribedSectionServices[organizationId] = services;
            } else {
                const servicesResult = [];
                for (const s of services){
                    /** Если услуга относится к папке с консультациями то должна быть выбрана только одна базовая услуга из всей папки */ if (!!s.ministry_of_health_code && (0, $fbfwH.default).consultationsCategoriesIds.includes(s.category_id)) {
                        const servCat = (0, $fbfwH.default).categoriesObject[s.category_id];
                        const consultCat = (0, $fbfwH.default).consultationsCategories.find((cs)=>servCat.category_code.startsWith(cs.category_code));
                        if (consultCat) {
                            if (consultCat.name === "\u041A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u0438 \u043F\u0441\u0438\u0445\u043E\u043B\u043E\u0433\u0430") {
                                if (s.kdf_code.trim() === "040401") {
                                    consultCat.mainService = s;
                                    continue;
                                }
                            }
                            if (!consultCat.mainService) consultCat.mainService = s;
                            else if ($f18d6cfb12c96453$var$serviceToNum(consultCat.mainService) > $f18d6cfb12c96453$var$serviceToNum(s)) consultCat.mainService = s;
                        }
                    } else if (!s.ministry_of_health_code) {
                        if ([
                            "\u043D\u0430\u043F1",
                            "\u043D\u0430\u043F2",
                            "\u043D\u0430\u043F3",
                            "\u043D\u0430\u043F4"
                        ].includes(s.kdf_code.trim())) servicesResult.push(s);
                        if (!s.category_id) servicesResult.push(s);
                        const servCat = (0, $fbfwH.default).categoriesObject[s.category_id];
                        if (servCat && (servCat.category_code.startsWith("24") || servCat.category_code.startsWith("08"))) servicesResult.push(s);
                    } else servicesResult.push(s);
                }
                for (const consultCat of (0, $fbfwH.default).consultationsCategories)if (consultCat.mainService) servicesResult.push(consultCat.mainService);
                $f18d6cfb12c96453$var$prescribedSectionServices[organizationId] = servicesResult;
            }
        }
        // ToDo возможно, нужно сделать, чтотпри выводе в компоненте, удаляем слово "первичный" и "первичная" - если речь про "B01."
        services = $f18d6cfb12c96453$var$prescribedSectionServices[organizationId];
    }
    searchQuery = searchQuery.toLowerCase();
    services = services.filter((s)=>{
        var _s$kdf_code, _s$kdf_code$toLowerCa;
        return s.name.toLowerCase().includes(searchQuery) || ((_s$kdf_code = s.kdf_code) === null || _s$kdf_code === void 0 ? void 0 : (_s$kdf_code$toLowerCa = _s$kdf_code.toLowerCase()) === null || _s$kdf_code$toLowerCa === void 0 ? void 0 : _s$kdf_code$toLowerCa.startsWith(searchQuery));
    });
    return services;
};
const $f18d6cfb12c96453$export$e8eabb9ac665aa46 = (organizationId, serviceId)=>{
    (0, $kmHuZ.default).services.clearCacheOrganizationServices(organizationId, {
        only_favorites: true
    });
    return (0, $4G40X.request)({
        method: "POST",
        url: `/organizations/${organizationId}/services/${serviceId}/favorites/`
    });
};
const $f18d6cfb12c96453$export$81000149f2a51f86 = (organizationId, serviceId)=>{
    (0, $kmHuZ.default).services.clearCacheOrganizationServices(organizationId, {
        only_favorites: true
    });
    return (0, $4G40X.request)({
        method: "DELETE",
        url: `/organizations/${organizationId}/services/${serviceId}/favorites/`
    });
};
const $f18d6cfb12c96453$export$6ec996cb4fb42f1d = ({ appointmentId: appointmentId, serviceId: serviceId, count: count, comment: comment, teeth: teeth })=>(0, $4G40X.request)({
        method: "POST",
        url: `/appointments/${appointmentId}/services/`,
        data: {
            service_id: serviceId,
            count: count,
            comment: comment,
            teeth: teeth
        }
    });
const $f18d6cfb12c96453$export$1f7ee64b282ecbd = ({ appointmentId: appointmentId, serviceId: serviceId })=>(0, $4G40X.request)({
        method: "DELETE",
        url: `/appointments/${appointmentId}/services/`,
        data: {
            service_id: serviceId
        }
    });
const $f18d6cfb12c96453$export$2d13315de628cb21 = ({ appointmentId: appointmentId, serviceId: serviceId, count: count, date_range: date_range, comment: comment, completed_appointment: completed_appointment, teeth: teeth })=>(0, $4G40X.request)({
        method: "POST",
        url: `/appointments/prescribed-services/?appointment_id=${appointmentId}`,
        data: {
            service_id: serviceId,
            count: count,
            comment: comment,
            teeth: teeth,
            completed_appointment_id: completed_appointment,
            date_range: {
                value: (date_range === null || date_range === void 0 ? void 0 : date_range.dates) || date_range
            }
        }
    });
const $f18d6cfb12c96453$export$e3250122ee7da2d9 = ({ appointmentId: appointmentId, serviceId: serviceId })=>(0, $4G40X.request)({
        method: "DELETE",
        url: `/appointments/prescribed-services/?appointment_id=${appointmentId}`,
        data: {
            service_id: serviceId
        }
    });
const $f18d6cfb12c96453$var$PolicyDescriptionData = {};
const $f18d6cfb12c96453$export$492796ee0ee9c4b8 = async (patientId)=>{
    if ($f18d6cfb12c96453$var$PolicyDescriptionData[patientId]) return $f18d6cfb12c96453$var$PolicyDescriptionData[patientId];
    const data = await (0, $4G40X.request)({
        method: "GET",
        url: `/policy-descriptions/${patientId}/`
    });
    $f18d6cfb12c96453$var$PolicyDescriptionData[patientId] = data;
    return data;
};

});
parcelRegister("4G40X", function(module, exports) {

$parcel$export(module.exports, "request", function () { return $367e32dd50b6707c$export$b5fe3f66a567bec0; });

var $gVub0 = parcelRequire("gVub0");

var $iOlMk = parcelRequire("iOlMk");
const $367e32dd50b6707c$export$b5fe3f66a567bec0 = async ({ method: method, url: url, data: data, options: options })=>{
    const response = await fetch(`${(0, $gVub0.EMS_API_URL)}${url}`, {
        ...(0, $gVub0.COMMON_FETCH_OPTIONS),
        ...options,
        method: method,
        body: data && JSON.stringify(data),
        headers: {
            ...(0, $gVub0.COMMON_FETCH_OPTIONS).headers,
            ...options && options.headers,
            Authorization: `JWT ${(0, $iOlMk.tokenStore).getState()}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return response.json().catch(()=>{});
};

});
parcelRegister("gVub0", function(module, exports) {

$parcel$export(module.exports, "EMS_API_URL", function () { return $c52960a56fc4a999$export$283c1cc386ea4ee7; });
$parcel$export(module.exports, "COMMON_FETCH_OPTIONS", function () { return $c52960a56fc4a999$export$42a1e8d8ce7b16d7; });

var $d8dol = parcelRequire("d8dol");
var $1FHr3 = parcelRequire("1FHr3");
var $2m6Qn = parcelRequire("2m6Qn");
var $g2qM6 = parcelRequire("g2qM6");
const $c52960a56fc4a999$export$283c1cc386ea4ee7 = (0, location.origin) + "/api";
const $c52960a56fc4a999$export$42a1e8d8ce7b16d7 = {
    headers: {
        Accept: "application/json, application/xml, text/plain, text/html, *.*",
        "Content-Type": "application/json; charset=utf-8"
    }
};
const $c52960a56fc4a999$var$transformParams = $d8dol.default($g2qM6.default, (params)=>new URLSearchParams(params), $2m6Qn.default($1FHr3.default));
const $c52960a56fc4a999$export$218fbc8100aba1a7 = async (options)=>{
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/auth/obtain-token/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        body: JSON.stringify(options)
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$be1491fbe5a1fece = async (options)=>{
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/auth/refresh-token/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        body: JSON.stringify(options)
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$2e2c0a8f27a55b11 = async (options)=>{
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/auth/logout/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${options.token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
};
const $c52960a56fc4a999$export$e5432d4c8eb97ea7 = async (options)=>{
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/auth/current-user/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${options.token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$4c3b9a50b0f698c8 = (options)=>{
    const { token: token, ...params } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/schedule/`);
    url.search = new URLSearchParams(params).toString();
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$87ec3275763240a7 = (options)=>async (params)=>{
        const { limit: limit, offset: offset } = params;
        const response = await fetch(...$c52960a56fc4a999$export$4c3b9a50b0f698c8({
            ...options,
            offset: offset,
            limit: limit
        }));
        if (!response.ok) throw Error(response.statusText);
        return await response.json();
    };
const $c52960a56fc4a999$export$2fd7697d956720e1 = async (options)=>{
    const { token: token, scheduleValues: scheduleValues } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/schedule-inserts/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        body: JSON.stringify(scheduleValues),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$18136d2c44cc1b87 = (options)=>{
    const { token: token, ...params } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/feedback/feedbacks/`);
    url.search = new URLSearchParams(params).toString();
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$b58fee5907db0e0 = (options)=>async (params)=>{
        const { limit: limit, offset: offset } = params;
        if (!options.order) delete options.order;
        const response = await fetch(...$c52960a56fc4a999$export$18136d2c44cc1b87({
            ...options,
            offset: offset,
            limit: limit
        }));
        if (!response.ok) throw Error(response.statusText);
        return await response.json();
    };
const $c52960a56fc4a999$export$f0cf29cf59885f03 = async (options)=>{
    const { layout_id: layout_id, appointment_id: appointment_id, notification_date: notification_date } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/feedback/feedbacks/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${options.token}`
        },
        body: JSON.stringify({
            layout_id: layout_id,
            appointment_id: appointment_id,
            notification_date: notification_date
        })
    });
    if (!response.ok) throw Error(response.statusText);
};
const $c52960a56fc4a999$export$7db3b7902aa972b0 = async (options)=>{
    const { token: token, id: id } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/feedback/feedbacks/${id}/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$d3a3358f9ea8214b = async (options)=>{
    const { token: token, id: id } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/feedback/layouts/${id}/fields/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$366ad814c344af14 = async (options)=>{
    const { token: token, id: id } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/feedback/feedbacks/${id}/response/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$aa0d422db945f049 = async (options)=>{
    const { token: token, id: id, doctors_comment: doctors_comment } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/feedback/feedbacks/${id}/complete/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        },
        body: JSON.stringify({
            doctors_comment: doctors_comment
        })
    });
    if (!response.ok) throw Error(response.statusText);
    return true;
};
const $c52960a56fc4a999$export$46a0b7547cd73a59 = (options)=>{
    const { token: token } = options;
    return [
        `${$c52960a56fc4a999$export$283c1cc386ea4ee7}/layout-groups/`,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$9340fad0531287fd = (options)=>{
    const { token: token, group: group } = options;
    return [
        `${$c52960a56fc4a999$export$283c1cc386ea4ee7}/layouts/?group=${group || ""}`,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$f7d0d23d9835b66 = (options)=>{
    const { token: token } = options;
    return [
        `${$c52960a56fc4a999$export$283c1cc386ea4ee7}/layouts/popular/`,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$c42427a69fdbdc11 = async (options)=>{
    const { token: token, creationOptions: creationOptions } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/appointments/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        body: JSON.stringify(creationOptions),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$var$cachedAppointmentsRequests = new Map();
let $c52960a56fc4a999$var$cachedClearTimeout = null;
const $c52960a56fc4a999$var$getCachedRequest = (url)=>{
    if ($c52960a56fc4a999$var$cachedAppointmentsRequests.has(url)) return $c52960a56fc4a999$var$cachedAppointmentsRequests.get(url);
    return false;
};
const $c52960a56fc4a999$var$saveRequestToHash = (url, data)=>{
    if (data) {
        $c52960a56fc4a999$var$cachedAppointmentsRequests.set(url, data);
        clearTimeout($c52960a56fc4a999$var$cachedClearTimeout);
        $c52960a56fc4a999$var$cachedClearTimeout = setTimeout(()=>{
            $c52960a56fc4a999$var$cachedAppointmentsRequests.clear();
        }, 60000);
    }
};
const $c52960a56fc4a999$var$makeCachedRequest = async (url, options)=>{
    const cachedRequest = $c52960a56fc4a999$var$getCachedRequest(url.href);
    if (cachedRequest) return cachedRequest;
    const response = await fetch(url, options);
    if (!response.ok) throw Error(response.statusText);
    const result = await response.json();
    $c52960a56fc4a999$var$saveRequestToHash(url.href, result);
    return result;
};
const $c52960a56fc4a999$export$9dc43dc05764d84b = (options)=>{
    const { token: token, ...params } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/appointments/`);
    url.search = new URLSearchParams(params).toString();
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$7029d7d2032a7978 = (options)=>async (params)=>{
        const { limit: limit, offset: offset } = params;
        const [url, appointmentOptions] = $c52960a56fc4a999$export$9dc43dc05764d84b({
            ...options,
            offset: offset,
            limit: limit
        });
        return await $c52960a56fc4a999$var$makeCachedRequest(url, appointmentOptions);
    };
const $c52960a56fc4a999$export$66d024159a2c51a = (options)=>{
    const { token: token, ...params } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/appointments/search/`);
    url.search = new URLSearchParams(params).toString();
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$59de7d92e42064ee = (options)=>async (params)=>{
        const { limit: limit, offset: offset } = params;
        const [url, appointmentOptions] = $c52960a56fc4a999$export$66d024159a2c51a({
            ...options,
            offset: offset,
            limit: limit
        });
        return await $c52960a56fc4a999$var$makeCachedRequest(url, appointmentOptions);
    };
const $c52960a56fc4a999$export$17e03faf3512a744 = (options)=>{
    const { token: token, id: id } = options;
    return [
        `${$c52960a56fc4a999$export$283c1cc386ea4ee7}/appointments/${id}/`,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$7a3a305b63ec4530 = (options)=>{
    const { token: token, id: id, section_id: section_id } = options;
    return [
        `${$c52960a56fc4a999$export$283c1cc386ea4ee7}/appointments/${id}/section-history/${section_id}/`,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$15b332947189bc50 = (options)=>{
    const { token: token, id: id } = options;
    return [
        `${$c52960a56fc4a999$export$283c1cc386ea4ee7}/layouts/${id}/`,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$4446b172b17662c4 = async (options)=>{
    const { token: token, appointment_id: appointment_id, fieldValues: fieldValues } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/appointments/${appointment_id}/set-values/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        body: JSON.stringify(fieldValues),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$91d5425e1e6c4ab8 = async (options)=>{
    const { token: token, appointment_id: appointment_id, services_description: services_description, next_visit_date: next_visit_date } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/appointments/${appointment_id}/finish/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        body: JSON.stringify(next_visit_date ? {
            services_description: services_description,
            next_visit_date: next_visit_date
        } : {
            services_description: services_description
        }),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return true;
};
const $c52960a56fc4a999$export$6172b55e32c12887 = async (options)=>{
    const { token: token, ...other } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/protocol_filling_analytics/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        body: JSON.stringify(other),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return true;
};
const $c52960a56fc4a999$export$dbc7b304cfcbd616 = async (options)=>{
    const { token: token, appointment_id: appointment_id, ...other } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/appointments/${appointment_id}/set-conclusion/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        body: JSON.stringify(other),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$a082eb101696de7a = async (options)=>{
    const { token: token, patient: patient, uploadOptions: uploadOptions, type: type } = options;
    let formData = new FormData();
    formData.append("file", uploadOptions.file);
    formData.append("original_name", uploadOptions.original_name || "");
    formData.append("type", type || "analysis");
    const response = await fetch(patient ? `${$c52960a56fc4a999$export$283c1cc386ea4ee7}/patients/${patient}/uploads/` : `${$c52960a56fc4a999$export$283c1cc386ea4ee7}/uploads/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        body: formData,
        headers: {
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$935536f6e4c62d5e = (options)=>{
    const { token: token } = options;
    return [
        `${$c52960a56fc4a999$export$283c1cc386ea4ee7}/organizations/`,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$7e61d855c21d0cf9 = (options)=>{
    const { token: token, id: id } = options;
    return [
        `${$c52960a56fc4a999$export$283c1cc386ea4ee7}/organizations/${id}/`,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$6e963a4a5d87243d = async (options)=>{
    const { token: token, appointment_id: appointment_id } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/appointments/${appointment_id}/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "delete",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return true;
};
const $c52960a56fc4a999$export$6b638d152ca2df20 = async (options)=>{
    const { token: token, appointment_id: appointment_id } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/appointments/${appointment_id}/reopen/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return true;
};
const $c52960a56fc4a999$export$42cda96077e697e2 = (options)=>{
    const { token: token, q: q } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/drugs/`);
    url.search = new URLSearchParams(q ? {
        q: q
    } : {}).toString();
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$bbc05a193b28d6de = async (options)=>{
    const { token: token, name: name } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/drugs/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        body: JSON.stringify({
            name: name
        }),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$58ba4cc3b29094c1 = (options)=>{
    const { token: token, patient: patient, ...params } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/patients/${patient}/uploads/`);
    url.search = new URLSearchParams(params).toString();
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$b5520a84f014fd6c = async (options)=>{
    const { token: token, id: id, ...params } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/uploads/${id}/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "PATCH",
        body: JSON.stringify({
            ...params
        }),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$52f1b8415e0404c2 = async (options)=>{
    const { token: token, id: id, ...params } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/analyses/${id}/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "PATCH",
        body: JSON.stringify({
            ...params
        }),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$2ac49123af734fd9 = async (options)=>{
    const { token: token, doctor_id: doctor_id, ...params } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/doctor/${doctor_id}/add_permission/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "PATCH",
        body: JSON.stringify({
            ...params
        }),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response;
};
const $c52960a56fc4a999$export$b4326676fc872175 = ()=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/ws/schedule-updates/`);
    url.protocol = "wss:";
    return url.toString();
};
const $c52960a56fc4a999$export$a818b5f6e11c96d = async (options)=>{
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/layouts/${options.layout_id}/shortcuts/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${options.token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$dbb2784ebaba59b7 = async (options)=>{
    const { token: token, creationOptions: creationOptions } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/shortcuts/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        body: JSON.stringify(creationOptions),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
};
const $c52960a56fc4a999$export$e62749d6790bf23e = async (options)=>{
    const { token: token, shortcut_id: shortcut_id, creationOptions: creationOptions } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/shortcuts/${shortcut_id}/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "PATCH",
        body: JSON.stringify(creationOptions),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
};
const $c52960a56fc4a999$export$1e395c7ef15ab460 = async (options)=>{
    const { token: token, shortcutsOrderOptions: shortcutsOrderOptions } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/shortcuts/set-order/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        body: JSON.stringify(shortcutsOrderOptions),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
};
const $c52960a56fc4a999$export$6b6aef8ae9fc96b5 = async (options)=>{
    const { token: token, shortcut_id: shortcut_id } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/shortcuts/${shortcut_id}/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "delete",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return true;
};
const $c52960a56fc4a999$export$a9c0bee36aeacc21 = (options)=>{
    const { token: token, ...params } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/diagnoses/`);
    url.search = $c52960a56fc4a999$var$transformParams(params);
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$e0ab58217a49958a = (options)=>{
    const { token: token, id: id } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/diagnoses/${id}/parents/`);
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$f3cc845fc1311f = (options)=>{
    const { token: token, ...params } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/decision-support/examinations/`);
    url.search = new URLSearchParams(params).toString();
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$7c4950df46a82263 = async (options)=>{
    const { token: token, name: name } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/decision-support/examinations/propose/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        body: JSON.stringify({
            name: name
        }),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return true;
};
const $c52960a56fc4a999$export$ced5030c2066db6 = (options)=>{
    const { token: token, ...params } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/decision-support/medicines/`);
    url.search = new URLSearchParams(params).toString();
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$47fcc224aa8fc0e9 = async (options)=>{
    const { token: token, name: name } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/decision-support/medicines/propose/`, {
        ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
        method: "post",
        body: JSON.stringify({
            name: name
        }),
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return true;
};
const $c52960a56fc4a999$export$8614167181e7ca95 = (options)=>{
    const { token: token, ...params } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/decision-support/conclusion/`);
    url.search = new URLSearchParams(params).toString();
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$188a0b88060af5b9 = (options)=>{
    const { token: token, ...params } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/ultrasound/`);
    url.search = new URLSearchParams(params).toString();
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$b97b5a11514f6796 = (options)=>{
    const { token: token, ...params } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/full-schedule/`);
    url.search = new URLSearchParams(params).toString();
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$4a3900ccd21df8d8 = (options)=>{
    const { token: token, patientId: patientId } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/embryos_count/?patient_id=${patientId}`);
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$76212b8254d77549 = (options)=>async (params)=>{
        // const { doctor, speciality, favorites_only } = params;
        const response = await fetch(...$c52960a56fc4a999$export$b97b5a11514f6796({
            ...options,
            ...params
        }));
        if (!response.ok) throw Error(response.statusText);
        return await response.json();
    };
const $c52960a56fc4a999$export$94ab574f190b122b = (options)=>{
    const { token: token, layout_id: layout_id, patient_id: patient_id } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/folders/`);
    if (layout_id) url.searchParams.append("layout_id", layout_id);
    if (patient_id) url.searchParams.append("patient_id", patient_id.toString());
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$443ac9551b56c78f = (options)=>{
    const { token: token, id: id } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/questionnaire/${id}/`);
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$fc73723927a0a4d3 = async (options)=>{
    const { token: token, id: id, payload: payload } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/questionnaire_values/${id}/`, {
        method: "PATCH",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        },
        body: JSON.stringify(payload)
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$e0dbb7870e500dfc = async (options)=>{
    const { token: token, id: id } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/questionnaire/${id}/finish/`, {
        method: "POST",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return true;
};
const $c52960a56fc4a999$export$c450b5d0c00f14fa = async (options)=>{
    const { token: token, id: id } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/folders/${id}/patient_examinations/`, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$e56469c9016f27d7 = async (options)=>{
    const { token: token, folderId: folderId, agreementId: agreementId } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/folders/${folderId}/patient_agreements/${agreementId}/print/`, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$c8dc70d326f1d4a1 = async (options)=>{
    const { token: token, id: id } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/folders/${id}/patient_agreements/`, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$cb5af9d7eec041a6 = (options)=>{
    const { token: token, id: id, concreteFolder: concreteFolder } = options;
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/folders/${id}/full_summary/print/`);
    if (concreteFolder) url.searchParams.append("only_folder_id", concreteFolder);
    return [
        url,
        {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7,
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            }
        }
    ];
};
const $c52960a56fc4a999$export$9fb5d965c76db70d = async (options)=>{
    const { token: token, folderId: folderId, id: id, payload: payload } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/folders/${folderId}/patient_examinations/${id}/`, {
        method: "PATCH",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        },
        body: JSON.stringify(payload)
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$a7e81173789b3aa9 = async (options)=>{
    const { token: token, folderId: folderId, id: id, payload: payload } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/folders/${folderId}/patient_agreements/${id}/`, {
        method: "PUT",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        },
        body: JSON.stringify(payload)
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$6bc777ffe21aeee7 = async (options)=>{
    const { token: token, folderId: folderId, folderTypeId: folderTypeId, appointmentId: appointmentId } = options;
    const data = {};
    if (folderId) data.folder_id = folderId;
    if (folderTypeId) data.f_layout_id = folderTypeId;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/appointments/${appointmentId}/folders/`, {
        method: "PATCH",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw Error(response.statusText);
    return true;
};
const $c52960a56fc4a999$export$c06b3d2a5440ef14 = async (options)=>{
    const { token: token, folderId: folderId, appointmentId: appointmentId } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/appointments/${appointmentId}/folders/`, {
        method: "DELETE",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        },
        body: JSON.stringify({
            folder_id: folderId
        })
    });
    if (!response.ok) throw Error(response.statusText);
    return true;
};
const $c52960a56fc4a999$export$8272c893502dba88 = async (options)=>{
    const { token: token, id: id } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/folders/${id}/full_summary/`, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$689e90bac2616378 = async (options)=>{
    const { token: token } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/hospital_admission/`, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$a0985b3308611b56 = async (options)=>{
    const { token: token, payload: payload } = options;
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/hospital_admission/${payload.id}/`, {
        method: "PATCH",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        },
        body: JSON.stringify(payload)
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$dc07ef8667f28816 = async ({ token: token, payload: { query: query, filter: filter, eventType: eventType } })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/appointments/outcomes/`);
    if (query) url.searchParams.append("patient_name", query);
    if (filter === "all") url.searchParams.append("all", "true");
    if (eventType) url.searchParams.append("layout_folder_id", eventType);
    const response = await fetch(url, {
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$d70e73b0450c92fd = async ({ token: token, payload: { value: value, id: id } })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/field_values/${id}/`);
    try {
        const response = await fetch(url, {
            method: "PATCH",
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            },
            body: JSON.stringify({
                value: value
            })
        });
        if (!response.ok) throw Error(response.statusText);
        return await response.json();
    } catch (err) {
        throw Error("\u041D\u0435\u0442 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F");
    }
};
const $c52960a56fc4a999$export$15cce881aaa25854 = async ({ token: token, payload: { appointmentId: appointmentId, fieldId: fieldId, value: value } })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/field_values/`);
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
                Authorization: `JWT ${token}`
            },
            body: JSON.stringify({
                value: value,
                appointment_id: appointmentId,
                copy_id: fieldId
            })
        });
        if (!response.ok) throw Error(response.statusText);
        return await response.json();
    } catch (err) {
        throw Error("\u041D\u0435\u0442 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F");
    }
};
const $c52960a56fc4a999$export$d2da31a8c68accda = async ({ token: token, payload: { gender: gender, embryoId: embryoId } })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/embryos/${embryoId}/medical-files/`);
    if (gender) url.searchParams.append("gender", gender);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$878f892c6e6b78bd = async ({ token: token, payload: { id: id, partnerId: partnerId } })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/questionnaire/${id}/`);
    const response = await fetch(url, {
        method: "PATCH",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        },
        body: JSON.stringify({
            partner_id: partnerId
        })
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$30bf38c3db40d533 = async ({ token: token, payload: { folderId: folderId } })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/folders/${folderId}/embryos_count/`);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$b5aa1d4d92833422 = async ({ token: token, payload: { folderId: folderId, viewType: viewType } })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/folders/${folderId}/embryos/`);
    if (viewType) url.searchParams.append("view_type", viewType);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$e74f2c8dddcfd2a5 = async ({ token: token, payload: { folderId: folderId } })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/folders/${folderId}/manipulations/`);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$40f6bfc602c32bb = async ({ token: token })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/doctors/embryologists/`);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$39e4d3b6252399d1 = async ({ token: token, payload: { id: id, folderId: folderId, time: time, doctorId: doctorId, date: date, clear: clear } })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/folders/${folderId}/manipulations/${id}/`);
    const response = await fetch(url, {
        method: "PATCH",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        },
        body: JSON.stringify({
            time: time,
            doctor_id: doctorId,
            date: date,
            clear: clear
        })
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$4ee7df08781d4691 = async ({ token: token, ...params })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/analyses/${params.id}/`);
    const response = await fetch(url, {
        method: "DELETE",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$489d2db20196600d = async ({ token: token, ...params })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/uploads/${params.id}/`);
    const response = await fetch(url, {
        method: "DELETE",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
};
const $c52960a56fc4a999$export$81c4e0d07c744991 = async ({ token: token, ...params })=>{
    const searchParams = new URLSearchParams();
    if (params.summary) params.summary.forEach((summaryId)=>{
        searchParams.append("summary", summaryId);
    });
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/patient/${params.patient_id}/print_epicrises/${searchParams ? `?${searchParams}` : ""}`);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$5661c392e19ea94a = async ({ token: token, ...params })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/ai/appointment/ai_status/${params.appointmentId}`);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$3a893d11d1bc95c = async ({ token: token })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/notifications/`);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$72234abcf4f2565d = async ({ token: token, id: id })=>{
    const response = await fetch(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/organizations/${id}/`, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$170ffe5d01877c33 = ({ token: token })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/ws/notifications/`);
    url.searchParams.append("token", token);
    url.protocol = "wss:";
    return url.toString();
};
const $c52960a56fc4a999$export$5233654eb6d4f3f6 = async ({ token: token, id: id })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/notifications/${id}/read/`);
    const response = await fetch(url, {
        method: "PATCH",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$d6ca461cf3de6811 = async ({ token: token, folderId: folderId, patientId: patientId, type: type })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/patients/${patientId}/embryos_print/`);
    url.searchParams.append("type", type);
    folderId && url.searchParams.append("folderId", folderId);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$fbaaffdf270b0978 = async ({ token: token, payload: payload })=>{
    const url = new URL(`${$c52960a56fc4a999$export$283c1cc386ea4ee7}/notifications/`);
    const response = await fetch(url, {
        method: "POST",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers,
            Authorization: `JWT ${token}`
        },
        body: JSON.stringify({
            appointment_id: payload.appointmentId,
            date_send: payload.date,
            text: payload.text
        })
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};
const $c52960a56fc4a999$export$b98672cf77c01417 = async ()=>{
    const url = new URL(`${(0, location.origin)}/mobile-api/configs/`);
    const response = await fetch(url, {
        method: "GET",
        headers: {
            ...$c52960a56fc4a999$export$42a1e8d8ce7b16d7.headers
        }
    });
    if (!response.ok) throw Error(response.statusText);
    return await response.json();
};

});
parcelRegister("d8dol", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98f66900c8aaac5b$export$2e2bcd8739ae039; });

var $10F1K = parcelRequire("10F1K");

var $cSdZE = parcelRequire("cSdZE");
function $98f66900c8aaac5b$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("compose requires at least one argument");
    return (0, $10F1K.default).apply(this, (0, $cSdZE.default)(arguments));
}

});
parcelRegister("10F1K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bc59dad427e50d1$export$2e2bcd8739ae039; });

var $fTxyT = parcelRequire("fTxyT");

var $nSzOQ = parcelRequire("nSzOQ");

var $9Zbrv = parcelRequire("9Zbrv");

var $g0wyi = parcelRequire("g0wyi");
function $0bc59dad427e50d1$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("pipe requires at least one argument");
    return (0, $fTxyT.default)(arguments[0].length, (0, $9Zbrv.default)((0, $nSzOQ.default), arguments[0], (0, $g0wyi.default)(arguments)));
}

});
parcelRegister("fTxyT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b92606b8e25b6843$export$2e2bcd8739ae039; });
function $b92606b8e25b6843$export$2e2bcd8739ae039(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
    }
}

});

parcelRegister("nSzOQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $047c7be6062fb0ab$export$2e2bcd8739ae039; });
function $047c7be6062fb0ab$export$2e2bcd8739ae039(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}

});

parcelRegister("9Zbrv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7452afdb416c43f8$export$2e2bcd8739ae039; });

var $jS880 = parcelRequire("jS880");

var $kwaQ3 = parcelRequire("kwaQ3");
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var $7452afdb416c43f8$var$reduce = /*#__PURE__*/ (0, $jS880.default)((0, $kwaQ3.default));
var $7452afdb416c43f8$export$2e2bcd8739ae039 = $7452afdb416c43f8$var$reduce;

});
parcelRegister("jS880", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7795d8db44cc84b$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $7SxCN = parcelRequire("7SxCN");

var $5ZRsy = parcelRequire("5ZRsy");
function $e7795d8db44cc84b$export$2e2bcd8739ae039(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, $5ZRsy.default)(a) ? f3 : (0, $7SxCN.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, $5ZRsy.default)(a) && (0, $5ZRsy.default)(b) ? f3 : (0, $5ZRsy.default)(a) ? (0, $7SxCN.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $5ZRsy.default)(b) ? (0, $7SxCN.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $1t1xO.default)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, $5ZRsy.default)(a) && (0, $5ZRsy.default)(b) && (0, $5ZRsy.default)(c) ? f3 : (0, $5ZRsy.default)(a) && (0, $5ZRsy.default)(b) ? (0, $7SxCN.default)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, $5ZRsy.default)(a) && (0, $5ZRsy.default)(c) ? (0, $7SxCN.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $5ZRsy.default)(b) && (0, $5ZRsy.default)(c) ? (0, $7SxCN.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $5ZRsy.default)(a) ? (0, $1t1xO.default)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, $5ZRsy.default)(b) ? (0, $1t1xO.default)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, $5ZRsy.default)(c) ? (0, $1t1xO.default)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}

});
parcelRegister("1t1xO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1119b291707c3284$export$2e2bcd8739ae039; });

var $5ZRsy = parcelRequire("5ZRsy");
function $1119b291707c3284$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $5ZRsy.default)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}

});
parcelRegister("5ZRsy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45dc1e3851ea45b5$export$2e2bcd8739ae039; });
function $45dc1e3851ea45b5$export$2e2bcd8739ae039(a) {
    return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}

});


parcelRegister("7SxCN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bc7a8bc494b0aa9$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $5ZRsy = parcelRequire("5ZRsy");
function $5bc7a8bc494b0aa9$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $5ZRsy.default)(a) ? f2 : (0, $1t1xO.default)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $5ZRsy.default)(a) && (0, $5ZRsy.default)(b) ? f2 : (0, $5ZRsy.default)(a) ? (0, $1t1xO.default)(function(_a) {
                    return fn(_a, b);
                }) : (0, $5ZRsy.default)(b) ? (0, $1t1xO.default)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}

});


parcelRegister("kwaQ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeff341e2e828e35$export$2e2bcd8739ae039; });

var $fl2xG = parcelRequire("fl2xG");

var $6DG1C = parcelRequire("6DG1C");

var $2K8fC = parcelRequire("2K8fC");
function $eeff341e2e828e35$var$_arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf["@@transducer/step"](acc, list[idx]);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        idx += 1;
    }
    return xf["@@transducer/result"](acc);
}
function $eeff341e2e828e35$var$_iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf["@@transducer/step"](acc, step.value);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        step = iter.next();
    }
    return xf["@@transducer/result"](acc);
}
function $eeff341e2e828e35$var$_methodReduce(xf, acc, obj, methodName) {
    return xf["@@transducer/result"](obj[methodName]((0, $2K8fC.default)(xf["@@transducer/step"], xf), acc));
}
var $eeff341e2e828e35$var$symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function $eeff341e2e828e35$export$2e2bcd8739ae039(fn, acc, list) {
    if (typeof fn === "function") fn = (0, $6DG1C.default)(fn);
    if ((0, $fl2xG.default)(list)) return $eeff341e2e828e35$var$_arrayReduce(fn, acc, list);
    if (typeof list["fantasy-land/reduce"] === "function") return $eeff341e2e828e35$var$_methodReduce(fn, acc, list, "fantasy-land/reduce");
    if (list[$eeff341e2e828e35$var$symIterator] != null) return $eeff341e2e828e35$var$_iterableReduce(fn, acc, list[$eeff341e2e828e35$var$symIterator]());
    if (typeof list.next === "function") return $eeff341e2e828e35$var$_iterableReduce(fn, acc, list);
    if (typeof list.reduce === "function") return $eeff341e2e828e35$var$_methodReduce(fn, acc, list, "reduce");
    throw new TypeError("reduce: list must be array or iterable");
}

});
parcelRegister("fl2xG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2aaca034408573f$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $3RBKV = parcelRequire("3RBKV");

var $k2UUn = parcelRequire("k2UUn");
/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */ var $b2aaca034408573f$var$_isArrayLike = /*#__PURE__*/ (0, $1t1xO.default)(function isArrayLike(x) {
    if ((0, $3RBKV.default)(x)) return true;
    if (!x) return false;
    if (typeof x !== "object") return false;
    if ((0, $k2UUn.default)(x)) return false;
    if (x.nodeType === 1) return !!x.length;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
var $b2aaca034408573f$export$2e2bcd8739ae039 = $b2aaca034408573f$var$_isArrayLike;

});
parcelRegister("3RBKV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d039bdca17f43bf$export$2e2bcd8739ae039; });
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var $2d039bdca17f43bf$export$2e2bcd8739ae039 = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};

});

parcelRegister("k2UUn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9802355e9a971f3$export$2e2bcd8739ae039; });
function $e9802355e9a971f3$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object String]";
}

});


parcelRegister("6DG1C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d56fbe3ec82dcda$export$2e2bcd8739ae039; });
var $4d56fbe3ec82dcda$var$XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype["@@transducer/init"] = function() {
        throw new Error("init not implemented on XWrap");
    };
    XWrap.prototype["@@transducer/result"] = function(acc) {
        return acc;
    };
    XWrap.prototype["@@transducer/step"] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function $4d56fbe3ec82dcda$export$2e2bcd8739ae039(fn) {
    return new $4d56fbe3ec82dcda$var$XWrap(fn);
}

});

parcelRegister("2K8fC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ff6471db06bc0ba$export$2e2bcd8739ae039; });

var $fTxyT = parcelRequire("fTxyT");

var $7SxCN = parcelRequire("7SxCN");
/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var $1ff6471db06bc0ba$var$bind = /*#__PURE__*/ (0, $7SxCN.default)(function bind(fn, thisObj) {
    return (0, $fTxyT.default)(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
var $1ff6471db06bc0ba$export$2e2bcd8739ae039 = $1ff6471db06bc0ba$var$bind;

});



parcelRegister("g0wyi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba75e59f86286cec$export$2e2bcd8739ae039; });

var $e4DWS = parcelRequire("e4DWS");

var $1t1xO = parcelRequire("1t1xO");

var $5KOxr = parcelRequire("5KOxr");
/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var $ba75e59f86286cec$var$tail = /*#__PURE__*/ (0, $1t1xO.default)(/*#__PURE__*/ (0, $e4DWS.default)("tail", /*#__PURE__*/ (0, $5KOxr.default)(1, Infinity)));
var $ba75e59f86286cec$export$2e2bcd8739ae039 = $ba75e59f86286cec$var$tail;

});
parcelRegister("e4DWS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3f06d6355efa679$export$2e2bcd8739ae039; });

var $3RBKV = parcelRequire("3RBKV");
function $a3f06d6355efa679$export$2e2bcd8739ae039(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, $3RBKV.default)(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}

});

parcelRegister("5KOxr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4308737fb8a829dd$export$2e2bcd8739ae039; });

var $e4DWS = parcelRequire("e4DWS");

var $jS880 = parcelRequire("jS880");
/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $4308737fb8a829dd$var$slice = /*#__PURE__*/ (0, $jS880.default)(/*#__PURE__*/ (0, $e4DWS.default)("slice", function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
var $4308737fb8a829dd$export$2e2bcd8739ae039 = $4308737fb8a829dd$var$slice;

});



parcelRegister("cSdZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95f561f65fac8c60$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $k2UUn = parcelRequire("k2UUn");
/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */ var $95f561f65fac8c60$var$reverse = /*#__PURE__*/ (0, $1t1xO.default)(function reverse(list) {
    return (0, $k2UUn.default)(list) ? list.split("").reverse().join("") : Array.prototype.slice.call(list, 0).reverse();
});
var $95f561f65fac8c60$export$2e2bcd8739ae039 = $95f561f65fac8c60$var$reverse;

});


parcelRegister("1FHr3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $137b501e3ff61b75$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */ var $137b501e3ff61b75$var$isNil = /*#__PURE__*/ (0, $1t1xO.default)(function isNil(x) {
    return x == null;
});
var $137b501e3ff61b75$export$2e2bcd8739ae039 = $137b501e3ff61b75$var$isNil;

});

parcelRegister("2m6Qn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b72f1e2ce8a2a5c$export$2e2bcd8739ae039; });

var $2G1lM = parcelRequire("2G1lM");

var $7SxCN = parcelRequire("7SxCN");

var $r0sUa = parcelRequire("r0sUa");
/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $1b72f1e2ce8a2a5c$var$reject = /*#__PURE__*/ (0, $7SxCN.default)(function reject(pred, filterable) {
    return (0, $r0sUa.default)((0, $2G1lM.default)(pred), filterable);
});
var $1b72f1e2ce8a2a5c$export$2e2bcd8739ae039 = $1b72f1e2ce8a2a5c$var$reject;

});
parcelRegister("2G1lM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f308d2c1fa8bdbd$export$2e2bcd8739ae039; });
function $1f308d2c1fa8bdbd$export$2e2bcd8739ae039(f) {
    return function() {
        return !f.apply(this, arguments);
    };
}

});

parcelRegister("r0sUa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0512e21c9d88d410$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $jVVlM = parcelRequire("jVVlM");

var $dzixe = parcelRequire("dzixe");

var $89mmD = parcelRequire("89mmD");

var $kwaQ3 = parcelRequire("kwaQ3");

var $1jAoy = parcelRequire("1jAoy");

var $aD5Zr = parcelRequire("aD5Zr");
/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $0512e21c9d88d410$var$filter = /*#__PURE__*/ (0, $7SxCN.default)(/*#__PURE__*/ (0, $jVVlM.default)([
    "filter"
], (0, $1jAoy.default), function(pred, filterable) {
    return (0, $89mmD.default)(filterable) ? (0, $kwaQ3.default)(function(acc, key) {
        if (pred(filterable[key])) acc[key] = filterable[key];
        return acc;
    }, {}, (0, $aD5Zr.default)(filterable)) : // else
    (0, $dzixe.default)(pred, filterable);
}));
var $0512e21c9d88d410$export$2e2bcd8739ae039 = $0512e21c9d88d410$var$filter;

});
parcelRegister("jVVlM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e82fd3c19264968c$export$2e2bcd8739ae039; });

var $3RBKV = parcelRequire("3RBKV");

var $ljSpW = parcelRequire("ljSpW");
function $e82fd3c19264968c$export$2e2bcd8739ae039(methodNames, xf, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var args = Array.prototype.slice.call(arguments, 0);
        var obj = args.pop();
        if (!(0, $3RBKV.default)(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === "function") return obj[methodNames[idx]].apply(obj, args);
                idx += 1;
            }
            if ((0, $ljSpW.default)(obj)) {
                var transducer = xf.apply(null, args);
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}

});
parcelRegister("ljSpW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f855957a4a9612bf$export$2e2bcd8739ae039; });
function $f855957a4a9612bf$export$2e2bcd8739ae039(obj) {
    return obj != null && typeof obj["@@transducer/step"] === "function";
}

});


parcelRegister("dzixe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e0cebe40b946a96$export$2e2bcd8739ae039; });
function $9e0cebe40b946a96$export$2e2bcd8739ae039(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    while(idx < len){
        if (fn(list[idx])) result[result.length] = list[idx];
        idx += 1;
    }
    return result;
}

});

parcelRegister("89mmD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ef083029079931f$export$2e2bcd8739ae039; });
function $5ef083029079931f$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
}

});

parcelRegister("1jAoy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f53cc1d32387337$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $a6y2L = parcelRequire("a6y2L");
var $0f53cc1d32387337$var$XFilter = /*#__PURE__*/ function() {
    function XFilter(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFilter.prototype["@@transducer/init"] = (0, $a6y2L.default).init;
    XFilter.prototype["@@transducer/result"] = (0, $a6y2L.default).result;
    XFilter.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : result;
    };
    return XFilter;
}();
var $0f53cc1d32387337$var$_xfilter = /*#__PURE__*/ (0, $7SxCN.default)(function _xfilter(f, xf) {
    return new $0f53cc1d32387337$var$XFilter(f, xf);
});
var $0f53cc1d32387337$export$2e2bcd8739ae039 = $0f53cc1d32387337$var$_xfilter;

});
parcelRegister("a6y2L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75b4df47bddaba3e$export$2e2bcd8739ae039; });
var $75b4df47bddaba3e$export$2e2bcd8739ae039 = {
    init: function() {
        return this.xf["@@transducer/init"]();
    },
    result: function(result) {
        return this.xf["@@transducer/result"](result);
    }
};

});


parcelRegister("aD5Zr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bd231648493210b$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $bKOTe = parcelRequire("bKOTe");

var $4Xe8k = parcelRequire("4Xe8k");
// cover IE < 9 keys issues
var $7bd231648493210b$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable("toString");
var $7bd231648493210b$var$nonEnumerableProps = [
    "constructor",
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
];
// Safari bug
var $7bd231648493210b$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    "use strict";
    return arguments.propertyIsEnumerable("length");
}();
var $7bd231648493210b$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $7bd231648493210b$var$keys = typeof Object.keys === "function" && !$7bd231648493210b$var$hasArgsEnumBug ? /*#__PURE__*/ (0, $1t1xO.default)(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ (0, $1t1xO.default)(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $7bd231648493210b$var$hasArgsEnumBug && (0, $4Xe8k.default)(obj);
    for(prop in obj)if ((0, $bKOTe.default)(prop, obj) && (!checkArgsLength || prop !== "length")) ks[ks.length] = prop;
    if ($7bd231648493210b$var$hasEnumBug) {
        nIdx = $7bd231648493210b$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $7bd231648493210b$var$nonEnumerableProps[nIdx];
            if ((0, $bKOTe.default)(prop, obj) && !$7bd231648493210b$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
var $7bd231648493210b$export$2e2bcd8739ae039 = $7bd231648493210b$var$keys;

});
parcelRegister("bKOTe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88eb77390bd89c62$export$2e2bcd8739ae039; });
function $88eb77390bd89c62$export$2e2bcd8739ae039(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});

parcelRegister("4Xe8k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39b7a2b3276535bb$export$2e2bcd8739ae039; });

var $bKOTe = parcelRequire("bKOTe");
var $39b7a2b3276535bb$var$toString = Object.prototype.toString;
var $39b7a2b3276535bb$var$_isArguments = /*#__PURE__*/ function() {
    return $39b7a2b3276535bb$var$toString.call(arguments) === "[object Arguments]" ? function _isArguments(x) {
        return $39b7a2b3276535bb$var$toString.call(x) === "[object Arguments]";
    } : function _isArguments(x) {
        return (0, $bKOTe.default)("callee", x);
    };
}();
var $39b7a2b3276535bb$export$2e2bcd8739ae039 = $39b7a2b3276535bb$var$_isArguments;

});




parcelRegister("g2qM6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bad19a2637b95cc5$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");

var $8n7mI = parcelRequire("8n7mI");
/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */ var $bad19a2637b95cc5$var$toString = /*#__PURE__*/ (0, $1t1xO.default)(function toString(val) {
    return (0, $8n7mI.default)(val, []);
});
var $bad19a2637b95cc5$export$2e2bcd8739ae039 = $bad19a2637b95cc5$var$toString;

});
parcelRegister("8n7mI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61862f56e8e76c96$export$2e2bcd8739ae039; });

var $4f6Vj = parcelRequire("4f6Vj");

var $j5PpZ = parcelRequire("j5PpZ");

var $jL97B = parcelRequire("jL97B");

var $iPM3N = parcelRequire("iPM3N");

var $aD5Zr = parcelRequire("aD5Zr");

var $2m6Qn = parcelRequire("2m6Qn");
function $61862f56e8e76c96$export$2e2bcd8739ae039(x, seen) {
    var recur = function recur(y) {
        var xs = seen.concat([
            x
        ]);
        return (0, $4f6Vj.default)(y, xs) ? "<Circular>" : $61862f56e8e76c96$export$2e2bcd8739ae039(y, xs);
    };
    //  mapPairs :: (Object, [String]) -> [String]
    var mapPairs = function(obj, keys) {
        return (0, $j5PpZ.default)(function(k) {
            return (0, $jL97B.default)(k) + ": " + recur(obj[k]);
        }, keys.slice().sort());
    };
    switch(Object.prototype.toString.call(x)){
        case "[object Arguments]":
            return "(function() { return arguments; }(" + (0, $j5PpZ.default)(recur, x).join(", ") + "))";
        case "[object Array]":
            return "[" + (0, $j5PpZ.default)(recur, x).concat(mapPairs(x, (0, $2m6Qn.default)(function(k) {
                return /^\d+$/.test(k);
            }, (0, $aD5Zr.default)(x)))).join(", ") + "]";
        case "[object Boolean]":
            return typeof x === "object" ? "new Boolean(" + recur(x.valueOf()) + ")" : x.toString();
        case "[object Date]":
            return "new Date(" + (isNaN(x.valueOf()) ? recur(NaN) : (0, $jL97B.default)((0, $iPM3N.default)(x))) + ")";
        case "[object Null]":
            return "null";
        case "[object Number]":
            return typeof x === "object" ? "new Number(" + recur(x.valueOf()) + ")" : 1 / x === -Infinity ? "-0" : x.toString(10);
        case "[object String]":
            return typeof x === "object" ? "new String(" + recur(x.valueOf()) + ")" : (0, $jL97B.default)(x);
        case "[object Undefined]":
            return "undefined";
        default:
            if (typeof x.toString === "function") {
                var repr = x.toString();
                if (repr !== "[object Object]") return repr;
            }
            return "{" + mapPairs(x, (0, $aD5Zr.default)(x)).join(", ") + "}";
    }
}

});
parcelRegister("4f6Vj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $316deeff7459867f$export$2e2bcd8739ae039; });

var $cydSV = parcelRequire("cydSV");
function $316deeff7459867f$export$2e2bcd8739ae039(a, list) {
    return (0, $cydSV.default)(list, a, 0) >= 0;
}

});
parcelRegister("cydSV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92336e3dbd59ce7b$export$2e2bcd8739ae039; });

var $g5jN3 = parcelRequire("g5jN3");
function $92336e3dbd59ce7b$export$2e2bcd8739ae039(list, a, idx) {
    var inf, item;
    // Array.prototype.indexOf doesn't exist below IE9
    if (typeof list.indexOf === "function") switch(typeof a){
        case "number":
            if (a === 0) {
                // manually crawl the list to distinguish between +0 and -0
                inf = 1 / a;
                while(idx < list.length){
                    item = list[idx];
                    if (item === 0 && 1 / item === inf) return idx;
                    idx += 1;
                }
                return -1;
            } else if (a !== a) {
                // NaN
                while(idx < list.length){
                    item = list[idx];
                    if (typeof item === "number" && item !== item) return idx;
                    idx += 1;
                }
                return -1;
            }
            // non-zero numbers can utilise Set
            return list.indexOf(a, idx);
        // all these types can utilise Set
        case "string":
        case "boolean":
        case "function":
        case "undefined":
            return list.indexOf(a, idx);
        case "object":
            if (a === null) // null can utilise Set
            return list.indexOf(a, idx);
    }
    // anything else not covered above, defer to R.equals
    while(idx < list.length){
        if ((0, $g5jN3.default)(list[idx], a)) return idx;
        idx += 1;
    }
    return -1;
}

});
parcelRegister("g5jN3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb5c76e6a1c0ede6$export$2e2bcd8739ae039; });

var $7SxCN = parcelRequire("7SxCN");

var $3FbHq = parcelRequire("3FbHq");
/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */ var $bb5c76e6a1c0ede6$var$equals = /*#__PURE__*/ (0, $7SxCN.default)(function equals(a, b) {
    return (0, $3FbHq.default)(a, b, [], []);
});
var $bb5c76e6a1c0ede6$export$2e2bcd8739ae039 = $bb5c76e6a1c0ede6$var$equals;

});
parcelRegister("3FbHq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2aae46b50a5bf9ed$export$2e2bcd8739ae039; });

var $l8jvl = parcelRequire("l8jvl");

var $fzpVf = parcelRequire("fzpVf");

var $8Rqmh = parcelRequire("8Rqmh");

var $bKOTe = parcelRequire("bKOTe");

var $fDReJ = parcelRequire("fDReJ");

var $aD5Zr = parcelRequire("aD5Zr");

var $6wxQA = parcelRequire("6wxQA");
/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */ function $2aae46b50a5bf9ed$var$_uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = (0, $l8jvl.default)(aIterator);
    var b = (0, $l8jvl.default)(bIterator);
    function eq(_a, _b) {
        return $2aae46b50a5bf9ed$export$2e2bcd8739ae039(_a, _b, stackA.slice(), stackB.slice());
    }
    // if *a* array contains any element that is not included in *b*
    return !(0, $fzpVf.default)(function(b, aItem) {
        return !(0, $fzpVf.default)(eq, aItem, b);
    }, b, a);
}
function $2aae46b50a5bf9ed$export$2e2bcd8739ae039(a, b, stackA, stackB) {
    if ((0, $fDReJ.default)(a, b)) return true;
    var typeA = (0, $6wxQA.default)(a);
    if (typeA !== (0, $6wxQA.default)(b)) return false;
    if (a == null || b == null) return false;
    if (typeof a["fantasy-land/equals"] === "function" || typeof b["fantasy-land/equals"] === "function") return typeof a["fantasy-land/equals"] === "function" && a["fantasy-land/equals"](b) && typeof b["fantasy-land/equals"] === "function" && b["fantasy-land/equals"](a);
    if (typeof a.equals === "function" || typeof b.equals === "function") return typeof a.equals === "function" && a.equals(b) && typeof b.equals === "function" && b.equals(a);
    switch(typeA){
        case "Arguments":
        case "Array":
        case "Object":
            if (typeof a.constructor === "function" && (0, $8Rqmh.default)(a.constructor) === "Promise") return a === b;
            break;
        case "Boolean":
        case "Number":
        case "String":
            if (!(typeof a === typeof b && (0, $fDReJ.default)(a.valueOf(), b.valueOf()))) return false;
            break;
        case "Date":
            if (!(0, $fDReJ.default)(a.valueOf(), b.valueOf())) return false;
            break;
        case "Error":
            return a.name === b.name && a.message === b.message;
        case "RegExp":
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
            break;
    }
    var idx = stackA.length - 1;
    while(idx >= 0){
        if (stackA[idx] === a) return stackB[idx] === b;
        idx -= 1;
    }
    switch(typeA){
        case "Map":
            if (a.size !== b.size) return false;
            return $2aae46b50a5bf9ed$var$_uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Set":
            if (a.size !== b.size) return false;
            return $2aae46b50a5bf9ed$var$_uniqContentEquals(a.values(), b.values(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Arguments":
        case "Array":
        case "Object":
        case "Boolean":
        case "Number":
        case "String":
        case "Date":
        case "Error":
        case "RegExp":
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "ArrayBuffer":
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = (0, $aD5Zr.default)(a);
    if (keysA.length !== (0, $aD5Zr.default)(b).length) return false;
    var extendedStackA = stackA.concat([
        a
    ]);
    var extendedStackB = stackB.concat([
        b
    ]);
    idx = keysA.length - 1;
    while(idx >= 0){
        var key = keysA[idx];
        if (!((0, $bKOTe.default)(key, b) && $2aae46b50a5bf9ed$export$2e2bcd8739ae039(b[key], a[key], extendedStackA, extendedStackB))) return false;
        idx -= 1;
    }
    return true;
}

});
parcelRegister("l8jvl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f629798414e95cd0$export$2e2bcd8739ae039; });
function $f629798414e95cd0$export$2e2bcd8739ae039(iter) {
    var list = [];
    var next;
    while(!(next = iter.next()).done)list.push(next.value);
    return list;
}

});

parcelRegister("fzpVf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b55e3b901f047f20$export$2e2bcd8739ae039; });
function $b55e3b901f047f20$export$2e2bcd8739ae039(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (pred(x, list[idx])) return true;
        idx += 1;
    }
    return false;
}

});

parcelRegister("8Rqmh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6737b82bd7305540$export$2e2bcd8739ae039; });
function $6737b82bd7305540$export$2e2bcd8739ae039(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? "" : match[1];
}

});

parcelRegister("fDReJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b633cb31cdb25bcb$export$2e2bcd8739ae039; });
// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $b633cb31cdb25bcb$var$_objectIs(a, b) {
    // SameValue algorithm
    if (a === b) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
    else // Step 6.a: NaN == NaN
    return a !== a && b !== b;
}
var $b633cb31cdb25bcb$export$2e2bcd8739ae039 = typeof Object.is === "function" ? Object.is : $b633cb31cdb25bcb$var$_objectIs;

});

parcelRegister("6wxQA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bfffc9135d5e302$export$2e2bcd8739ae039; });

var $1t1xO = parcelRequire("1t1xO");
/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */ var $4bfffc9135d5e302$var$type = /*#__PURE__*/ (0, $1t1xO.default)(function type(val) {
    return val === null ? "Null" : val === undefined ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
var $4bfffc9135d5e302$export$2e2bcd8739ae039 = $4bfffc9135d5e302$var$type;

});





parcelRegister("j5PpZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de665e827334f055$export$2e2bcd8739ae039; });
function $de665e827334f055$export$2e2bcd8739ae039(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}

});

parcelRegister("jL97B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6297b7408cbabc0$export$2e2bcd8739ae039; });
function $e6297b7408cbabc0$export$2e2bcd8739ae039(s) {
    var escaped = s.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b") // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
    return '"' + escaped.replace(/"/g, '\\"') + '"';
}

});

parcelRegister("iPM3N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db62453296ddf01c$export$2e2bcd8739ae039; });
/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */ var $db62453296ddf01c$var$pad = function pad(n) {
    return (n < 10 ? "0" : "") + n;
};
var $db62453296ddf01c$var$_toISOString = typeof Date.prototype.toISOString === "function" ? function _toISOString(d) {
    return d.toISOString();
} : function _toISOString(d) {
    return d.getUTCFullYear() + "-" + $db62453296ddf01c$var$pad(d.getUTCMonth() + 1) + "-" + $db62453296ddf01c$var$pad(d.getUTCDate()) + "T" + $db62453296ddf01c$var$pad(d.getUTCHours()) + ":" + $db62453296ddf01c$var$pad(d.getUTCMinutes()) + ":" + $db62453296ddf01c$var$pad(d.getUTCSeconds()) + "." + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + "Z";
};
var $db62453296ddf01c$export$2e2bcd8739ae039 = $db62453296ddf01c$var$_toISOString;

});





parcelRegister("fbfwH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0d3ed561ae6861c$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $9Qp9d = parcelRequire("9Qp9d");

var $kmHuZ = parcelRequire("kmHuZ");

var $hLS2D = parcelRequire("hLS2D");
parcelRequire("9Toj9");
const $b0d3ed561ae6861c$var$sortByNameWithSearchString = (a, b, search)=>{
    search = search.toLowerCase();
    a = a.toLowerCase();
    b = b.toLowerCase();
    if (search) {
        if (a.startsWith(search) && b.startsWith(search)) {
            if (a > b) return 1;
            if (a < b) return -1;
            return 0;
        }
        if (a.startsWith(search)) return -1;
        if (b.startsWith(search)) return 1;
    }
    if (a > b) return 1;
    if (a < b) return -1;
    return 0;
};
const $b0d3ed561ae6861c$var$categoriesRequest = {};
const $b0d3ed561ae6861c$var$servicesRequest = {};
const $b0d3ed561ae6861c$var$_calcMissedExamination = (examinations, prescribedServices)=>{
    const result = [];
    if (!examinations) return result;
    examinations.forEach((checklistItem)=>{
        if (checklistItem.items) result.push(...$b0d3ed561ae6861c$var$_calcMissedExamination(checklistItem.items, prescribedServices));
        else if (checklistItem.is_checked) {
            if (checklistItem.services && checklistItem.services.find((s)=>prescribedServices.find((ps)=>ps.id === s.id))) return;
            result.push(checklistItem.name);
        }
    });
    return result;
};
class $b0d3ed561ae6861c$var$ServiceStore {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "categories", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "services", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "organizationId", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "appointmentId", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "examinations", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "prescribedServices", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "appointmentServices", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "createdAppointmentWithCopy", false);
        (0, $9Qp9d.makeAutoObservable)(this);
    }
    setAppointmentId(appointmentId) {
        this.appointmentId = appointmentId;
    }
    setOrganizationId(organizationId) {
        if (this.organizationId === organizationId) return;
        this.organizationId = organizationId;
        this.getServiceCategories(organizationId);
        this.getServiceOrganizations(organizationId);
    }
    *getServiceCategories(organizationId) {
        const organization = organizationId || this.organizationId;
        if (!$b0d3ed561ae6861c$var$categoriesRequest[organization]) $b0d3ed561ae6861c$var$categoriesRequest[organization] = (0, $kmHuZ.default).services.getServiceCategories(organization);
        this.categories[organization] = yield $b0d3ed561ae6861c$var$categoriesRequest[organization];
    }
    *getServiceOrganizations(organizationId) {
        const organization = organizationId || this.organizationId;
        if (!$b0d3ed561ae6861c$var$servicesRequest[organization]) $b0d3ed561ae6861c$var$servicesRequest[organization] = (0, $kmHuZ.default).services.getOrganizationServices(organization);
        this.services[organization] = yield $b0d3ed561ae6861c$var$servicesRequest[organization];
    }
    get flatCategories() {
        if (!this.organizationId) return [];
        const calcFlatCategories = (categories)=>{
            const result = [];
            categories.forEach((cat)=>{
                result.push(cat);
                if (cat.subcategories.length) result.push(...calcFlatCategories(cat.subcategories));
            });
            return result;
        };
        return calcFlatCategories(this.categories[this.organizationId]);
    }
    get categoriesObject() {
        if (!this.organizationId) return {};
        return (0, $hLS2D.arrayToEntriesById)(this.flatCategories);
    }
    get consultationsCategories() {
        return this.flatCategories.filter((cat)=>cat.name.toLowerCase().startsWith("\u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u0438") && cat.category_code !== "10;10/30;10/30/1");
    }
    get consultationsCategoriesIds() {
        const calcFlatCategories = (categories)=>{
            const result = [];
            categories.forEach((cat)=>{
                result.push(cat);
                if (cat.subcategories.length) result.push(...calcFlatCategories(cat.subcategories));
            });
            return result;
        };
        return calcFlatCategories(this.consultationsCategories).map((cat)=>cat.id);
    }
    get serviceForCurrentOrganization() {
        return this.services[this.organizationId];
    }
    get categoriesText() {
        if (!this.organizationId) return ()=>"";
        // if (!featureEnabledForOrganization(FEATURE.CATEGORIES_IN_SERVICE, this.organizationId)) {
        //     return () => '';
        // }
        if (!this.categories[this.organizationId] || !this.services[this.organizationId]) return ()=>"";
        return (service)=>{
            if (service.ministry_of_health_code.startsWith("B01") && !service.kdf_code.startsWith("\u0414")) return "";
            // if (name && this.services[this.organizationId].filter(s => s.name === name && s.category_id !== categoryId).length === 0) {
            //     return '';
            // }
            const result = [];
            let categoryId = service.category_id;
            while(this.categoriesObject[categoryId]){
                result.push(this.categoriesObject[categoryId].name);
                categoryId = this.categoriesObject[categoryId].parent_id;
            }
            if (!service.kdf_code.startsWith("\u0414")) result.pop();
            return result.length ? result.reverse().join(" | ") : "";
        };
    }
    setCreatedAppointmentWithCopy(value) {
        this.createdAppointmentWithCopy = value;
    }
    setExaminationItems(value) {
        this.examinations = value;
    }
    setPrescribedServices(value) {
        this.prescribedServices = value;
    }
    setAppointmentServices(value) {
        this.appointmentServices = value;
    }
    get missedExamination() {
        return $b0d3ed561ae6861c$var$_calcMissedExamination(this.examinations, this.prescribedServices);
    }
    methodSortServices(services, value = "") {
        return services.sort((a, b)=>{
            const catA = this.categoriesObject[a.category_id];
            const catB = this.categoriesObject[b.category_id];
            // вверху показываем услуги-консультации-врачей
            if (catA && catB && this.consultationsCategoriesIds.includes(catA.id) && this.consultationsCategoriesIds.includes(catB.id)) return $b0d3ed561ae6861c$var$sortByNameWithSearchString(a.name, b.name, value);
            if (catA && this.consultationsCategoriesIds.includes(catA.id)) return -1;
            if (catB && this.consultationsCategoriesIds.includes(catB.id)) return 1;
            // вверху показываем услуги-от-ИНВИТРО
            if (catA && catB && catA.category_code.startsWith("24;24/9") && catB.category_code.startsWith("24;24/9")) return $b0d3ed561ae6861c$var$sortByNameWithSearchString(a.name, b.name, value);
            if (catA && catA.category_code.startsWith("24;24/9")) return -1;
            if (catB && catB.category_code.startsWith("24;24/9")) return 1;
            return $b0d3ed561ae6861c$var$sortByNameWithSearchString(a.name, b.name, value);
        });
    }
}
var $b0d3ed561ae6861c$export$2e2bcd8739ae039 = new $b0d3ed561ae6861c$var$ServiceStore();

});
parcelRegister("hLS2D", function(module, exports) {

$parcel$export(module.exports, "arrayToEntriesById", function () { return $cf00bef4f1453e17$export$e1589c9c07afd283; });
$parcel$export(module.exports, "entriesToArrayById", function () { return $cf00bef4f1453e17$export$2810da0402407373; });
$parcel$export(module.exports, "uniqueFilter", function () { return $cf00bef4f1453e17$export$48152b8af7a92cde; });
$parcel$export(module.exports, "declOfNum", function () { return $cf00bef4f1453e17$export$bbeabd2b5605572f; });
const $cf00bef4f1453e17$export$e1589c9c07afd283 = (arr, key = "id")=>Object.fromEntries(arr.map((item)=>[
            item[key],
            item
        ]));
const $cf00bef4f1453e17$export$2810da0402407373 = (entries, convertId, key = "id")=>Object.entries(entries).map(([id, item])=>({
            [key]: convertId ? convertId(id) : id,
            ...item
        }));
const $cf00bef4f1453e17$export$48152b8af7a92cde = (value, index, arr)=>arr.indexOf(value) === index;
const $cf00bef4f1453e17$export$bbeabd2b5605572f = (n, titles)=>{
    return titles[n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2];
};

});

parcelRegister("9Toj9", function(module, exports) {

$parcel$export(module.exports, "FEATURE", function () { return $733c1b2198b66685$export$64e44b33d657543d; });
$parcel$export(module.exports, "applicationFeatures", function () { return $733c1b2198b66685$export$5cd592527e17f408; });
$parcel$export(module.exports, "useApplicationFeaturesInitialized", function () { return $733c1b2198b66685$export$a4642df93db4a630; });
$parcel$export(module.exports, "useApplicationFeatures", function () { return $733c1b2198b66685$export$fdcaedae759a1731; });
$parcel$export(module.exports, "applicationFeatureEnabled", function () { return $733c1b2198b66685$export$aa2c51bb11f094e3; });
$parcel$export(module.exports, "featureEnabledForOrganization", function () { return $733c1b2198b66685$export$efd40a9af4fdea4c; });
$parcel$export(module.exports, "featureValueIdArray", function () { return $733c1b2198b66685$export$37f3008f12026cde; });
$parcel$export(module.exports, "useApplicationFeatureEnabled", function () { return $733c1b2198b66685$export$97551a5fec49bb5d; });
$parcel$export(module.exports, "useApplicationFeatureValue", function () { return $733c1b2198b66685$export$d0207fc4e66f0d23; });
$parcel$export(module.exports, "useApplicationFeatureValueIdArray", function () { return $733c1b2198b66685$export$e7ac55599de15478; });
$parcel$export(module.exports, "useApplicationFeatureValueForOrganization", function () { return $733c1b2198b66685$export$3c9431077b5985a2; });

var $jqdsN = parcelRequire("jqdsN");

var $bh6RR = parcelRequire("bh6RR");

var $9Qp9d = parcelRequire("9Qp9d");

var $iRxIj = parcelRequire("iRxIj");

var $iOlMk = parcelRequire("iOlMk");

var $kmHuZ = parcelRequire("kmHuZ");
const $733c1b2198b66685$export$64e44b33d657543d = {
    PRINT_LOGO_IN_DOCTOR_VERSION: "PRINT_LOGO_IN_DOCTOR_VERSION",
    PRESCRIBED_SERVICES: "PRESCRIBED_SERVICES",
    DOCUMENT_SIDEBAR: "DOCUMENT_SIDEBAR",
    COMMENT_IN_SERVICES: "COMMENT_IN_SERVICES",
    PRICE_IN_PRINT: "PRICE_IN_PRINT",
    CATEGORIES_IN_SERVICE: "CATEGORIES_IN_SERVICE",
    CHECK_DIAGNOSIS_FOR_DMS: "CHECK_DIAGNOSIS_FOR_DMS",
    IVB__DOCTOR__ID: "IVB__DOCTOR__ID",
    IVB__DOCTOR__NAME: "IVB__DOCTOR__NAME",
    PEDIATRICIAN__DOCTOR__ID: "PEDIATRICIAN__DOCTOR__ID",
    PEDIATRICIAN__DOCTOR__NAME: "PEDIATRICIAN__DOCTOR__NAME",
    FAMILY__DOCTOR__ID: "FAMILY__DOCTOR__ID",
    FAMILY__DOCTOR__NAME: "FAMILY__DOCTOR__NAME",
    CHAT: "CHAT",
    CHAT_FILTERS: "CHAT_FILTERS",
    COMMERCIAL_STAFF: "COMMERCIAL_STAFF",
    APPOINTMENT_PRINT_DOCTOR_TEMPLATE_ID: "APPOINTMENT_PRINT_DOCTOR_TEMPLATE_ID",
    APPOINTMENT_PRINT_PATIENT_TEMPLATE_ID: "APPOINTMENT_PRINT_PATIENT_TEMPLATE_ID",
    HC_QUESTIONNAIRE_USER_ID: "HC_QUESTIONNAIRE_USER_ID",
    HC_QUESTIONNAIRE_LAYOUT_ID: "HC_QUESTIONNAIRE_LAYOUT_ID",
    HC_QUESTIONNAIRE_SECTION_FEMALE_ID: "HC_QUESTIONNAIRE_SECTION_FEMALE_ID",
    PROFILE: "PROFILE",
    GENERAL_SCHEDULE_NEW: "GENERAL_SCHEDULE_NEW",
    MEDICAL_GENOMICS: "MEDICAL_GENOMICS",
    PATIENTS: "PATIENTS",
    TABLE_PRESCRIBED_SERVICES: "TABLE_PRESCRIBED_SERVICES",
    REQUIRED_FIELD_DIAGNOSIS_MKB: "REQUIRED_FIELD_DIAGNOSIS_MKB",
    SHOW_MY_TICKETS_PAGE: "SHOW_MY_TICKETS_PAGE",
    SHOW_CHATS_SETTING: "SHOW_CHATS_SETTING",
    SHOW_POPULAR_LAYOUTS: "SHOW_POPULAR_LAYOUTS",
    TICKET_DOCTOR_ASSIGNEE_MEDICAL_ERROR: "TICKET_DOCTOR_ASSIGNEE_MEDICAL_ERROR",
    TICKET_DOCTOR_ASSIGNEE_COMMON: "TICKET_DOCTOR_ASSIGNEE_COMMON",
    PAYMENT_VIA_APP: "PAYMENT_VIA_APP",
    AMBULANCE: "AMBULANCE",
    APPOINTMENT_HISTORY_NEW: "APPOINTMENT_HISTORY_NEW",
    FEEDBACK_NEW: "FEEDBACK_NEW",
    EDIT_SCHEDULE: "EDIT_SCHEDULE",
    CAN_BLOCK_CHAT_FOR_A_DAY: "CAN_BLOCK_CHAT_FOR_A_DAY",
    BONUS_SCHEMA: "BONUS_SCHEMA",
    CORPORATE_PORTAL: "CORPORATE_PORTAL",
    SHOW_NOTICE_HEADER: "SHOW_NOTICE_HEADER",
    SURVEY_EMPLOYEE_RESULT: "SURVEY_EMPLOYEE_RESULT",
    SURVEY_CORPORATE_PORTAL_RESULT: "SURVEY_CORPORATE_PORTAL_RESULT",
    SURVEY_FEEDBACK_CLINIC_RESULT: "SURVEY_FEEDBACK_CLINIC_RESULT",
    SURVEY_ENPS_CLINIC_RESULT: "SURVEY_ENPS_CLINIC_RESULT",
    CHANGED_CHATROOM_CALCULATION: "CHANGED_CHATROOM_CALCULATION",
    ENABLE_VOX_TEMPLATE_T_FEEDBACK_NEW: "ENABLE_VOX_TEMPLATE_T_FEEDBACK_NEW",
    EDIT_PREV_SERVICES: "EDIT_PREV_SERVICES",
    ELECTRONIC_DOCUMENTS: "ELECTRONIC_DOCUMENTS",
    ENABLE_ACTIONS_LOGGING_TOOL: "ENABLE_ACTIONS_LOGGING_TOOL",
    ALLOW_VIEWING_FILES_IN_TICKET: "ALLOW_VIEWING_FILES_IN_TICKET",
    SERVICE_STAFF: "SERVICE_STAFF",
    SERVICE_ADMIN: "SERVICE_ADMIN",
    SERVICE_2500: "SERVICE_2500",
    USERS_CAN_SEE_REVIEWS: "USERS_CAN_SEE_REVIEWS",
    TECHNICAL_WORK: "TECHNICAL_WORK",
    FDOC: "FDOC",
    FDOC_SIGNERS: "FDOC_SIGNERS",
    FDOC_SIGNERS_ORDER: "FDOC_SIGNERS_ORDER",
    CURRENCY_SYMBOL_OF_THE_COUNTRY: "CURRENCY_SYMBOL_OF_THE_COUNTRY",
    SERVER_TIME_WITH_UTC: "SERVER_TIME_WITH_UTC",
    APPOINTMENT_EVALUATION: "APPOINTMENT_EVALUATION",
    CORPORATE_PORTAL_SEARCH: "CORPORATE_PORTAL_SEARCH",
    SHOW_QUALITY_CRITERIA: "SHOW_QUALITY_CRITERIA"
};
class $733c1b2198b66685$var$ApplicationFeatures {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "initialized", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "config", {});
        (0, $9Qp9d.makeAutoObservable)(this);
    }
    *updateConfig() {
        const newConfig = yield (0, $kmHuZ.default).config.getConfig();
        if (newConfig) {
            this.config = newConfig;
            this.initialized = true;
        }
    }
    value(feature) {
        var _user$doctor, _user$doctor$organiza;
        if (!this.initialized) return false;
        const user = (0, $iOlMk.currentUser).getState();
        if (!user) return this.config[feature];
        const userFeature = this.config[`${feature}__USER__${user.id}`];
        if (userFeature !== undefined) return userFeature;
        const userOrganizationIdHasFeature = (_user$doctor = user.doctor) === null || _user$doctor === void 0 ? void 0 : (_user$doctor$organiza = _user$doctor.organizations) === null || _user$doctor$organiza === void 0 ? void 0 : _user$doctor$organiza.find((org_id)=>this.config[`${feature}__ORG__${org_id}`] !== undefined);
        if (userOrganizationIdHasFeature !== undefined) return this.config[`${feature}__ORG__${userOrganizationIdHasFeature}`];
        return this.config[feature];
    }
    enabled(feature) {
        return !!this.value(feature);
    }
    valueForOrganization(feature, organizationId) {
        if (!this.initialized || organizationId === undefined) return false;
        if (`${feature}__ORG__${organizationId}` in this.config) return this.config[`${feature}__ORG__${organizationId}`];
        return this.config[feature];
    }
    enabledForOrganization(feature, organizationId) {
        return !!this.valueForOrganization(feature, organizationId);
    }
}
const $733c1b2198b66685$export$5cd592527e17f408 = new $733c1b2198b66685$var$ApplicationFeatures();
const $733c1b2198b66685$export$a4642df93db4a630 = ()=>{
    return (0, $bh6RR.useMemo)(()=>{
        return $733c1b2198b66685$export$5cd592527e17f408.initialized;
    }, [
        $733c1b2198b66685$export$5cd592527e17f408.initialized
    ]);
};
const $733c1b2198b66685$export$fdcaedae759a1731 = ()=>{
    (0, $bh6RR.useEffect)(()=>{
        $733c1b2198b66685$export$5cd592527e17f408.updateConfig();
    }, []);
};
const $733c1b2198b66685$export$aa2c51bb11f094e3 = (feature)=>{
    return $733c1b2198b66685$export$5cd592527e17f408.enabled(feature);
};
const $733c1b2198b66685$export$efd40a9af4fdea4c = (feature, organizationId)=>{
    return $733c1b2198b66685$export$5cd592527e17f408.enabledForOrganization(feature, organizationId);
};
const $733c1b2198b66685$export$609dd3687ce45691 = (feature)=>{
    return $733c1b2198b66685$export$5cd592527e17f408.value(feature);
};
const $733c1b2198b66685$export$81654c3dc5fff0e0 = (feature, valueAdapter)=>{
    if (!valueAdapter) valueAdapter = (value)=>value.trim();
    const value = $733c1b2198b66685$export$5cd592527e17f408.value(feature);
    if (value && value.length > 0) return value.split(",").map(valueAdapter);
    if (!$733c1b2198b66685$export$5cd592527e17f408.initialized) return [];
    return [];
};
const $733c1b2198b66685$export$37f3008f12026cde = (feature)=>{
    return $733c1b2198b66685$export$81654c3dc5fff0e0(feature, (value)=>parseInt(value, 10));
};
const $733c1b2198b66685$export$97551a5fec49bb5d = (feature)=>{
    const user = (0, $iRxIj.useStore)((0, $iOlMk.currentUser));
    return (0, $bh6RR.useMemo)(()=>{
        return $733c1b2198b66685$export$aa2c51bb11f094e3(feature);
    }, [
        $733c1b2198b66685$export$5cd592527e17f408.initialized,
        $733c1b2198b66685$export$5cd592527e17f408.config,
        user
    ]);
};
const $733c1b2198b66685$export$d0207fc4e66f0d23 = (feature)=>{
    const user = (0, $iRxIj.useStore)((0, $iOlMk.currentUser));
    return (0, $bh6RR.useMemo)(()=>{
        return $733c1b2198b66685$export$609dd3687ce45691(feature);
    }, [
        $733c1b2198b66685$export$5cd592527e17f408.initialized,
        $733c1b2198b66685$export$5cd592527e17f408.config,
        user
    ]);
};
const $733c1b2198b66685$export$de29628b368e8542 = (feature, valueAdapter)=>{
    const user = (0, $iRxIj.useStore)((0, $iOlMk.currentUser));
    return (0, $bh6RR.useMemo)(()=>{
        return $733c1b2198b66685$export$81654c3dc5fff0e0(feature, valueAdapter);
    }, [
        $733c1b2198b66685$export$5cd592527e17f408.initialized,
        $733c1b2198b66685$export$5cd592527e17f408.config,
        user
    ]);
};
const $733c1b2198b66685$export$e7ac55599de15478 = (feature)=>{
    return $733c1b2198b66685$export$de29628b368e8542(feature, (value)=>parseInt(value, 10));
};
const $733c1b2198b66685$export$3c9431077b5985a2 = (feature, organizationId)=>{
    return (0, $bh6RR.useMemo)(()=>{
        return $733c1b2198b66685$export$5cd592527e17f408.valueForOrganization(feature, organizationId);
    }, [
        $733c1b2198b66685$export$5cd592527e17f408.initialized,
        $733c1b2198b66685$export$5cd592527e17f408.config,
        organizationId
    ]);
};

});
parcelRegister("iRxIj", function(module, exports) {

$parcel$export(module.exports, "useStore", function () { return $85b97ae2361ec21c$export$6ccbb43953eebf8; });
$parcel$export(module.exports, "useStoreMap", function () { return $85b97ae2361ec21c$export$8b87f165e6cd655; });
$parcel$export(module.exports, "useList", function () { return $85b97ae2361ec21c$export$f9763ecd339e95eb; });
$parcel$export(module.exports, "useGate", function () { return $85b97ae2361ec21c$export$41d95a587fecc5a0; });
$parcel$export(module.exports, "createGate", function () { return $85b97ae2361ec21c$export$b7eb246e5f4e5a66; });

var $bh6RR = parcelRequire("bh6RR");

var $b7l7Q = parcelRequire("b7l7Q");

var $h2bFT = parcelRequire("h2bFT");

var $hVYK3 = parcelRequire("hVYK3");
function $85b97ae2361ec21c$var$e(e, t, n, r) {
    let o = [
        (0, $b7l7Q.step).mov({
            store: e.stateRef,
            to: "stack"
        }),
        (0, $b7l7Q.step).run({
            fn: (e)=>t(e)
        })
    ];
    if (r && o.unshift(r), n) {
        let t = (0, $b7l7Q.createNode)({
            node: o,
            meta: {
                watchOp: "store"
            }
        }), r = e.graphite.id, u = n.additionalLinks, s = u[r] || [];
        return u[r] = s, s.push(t), ()=>{
            let e = s.indexOf(t);
            -1 !== e && s.splice(e, 1), (0, $b7l7Q.clearNode)(t);
        };
    }
    {
        let t = (0, $b7l7Q.createNode)({
            node: o,
            parent: [
                e
            ],
            family: {
                owners: e
            }
        });
        return ()=>{
            (0, $b7l7Q.clearNode)(t);
        };
    }
}
function $85b97ae2361ec21c$var$t(e, t) {
    return t.displayName = e, t;
}
function $85b97ae2361ec21c$var$n(t, n) {
    (0, $b7l7Q.is).store(t) || $85b97ae2361ec21c$var$N("expect useStore argument to be a store");
    let r = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((r)=>$85b97ae2361ec21c$var$e(t, r, n), [
        t,
        n
    ]), o = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>$85b97ae2361ec21c$var$V(t, n), [
        t,
        n
    ]);
    return $85b97ae2361ec21c$var$M(r, o, o);
}
function $85b97ae2361ec21c$var$r(t, n) {
    let r = (0, $b7l7Q.is).unit(t), o = {};
    r ? o = {
        unit: t
    } : "@@unitShape" in t ? "function" == typeof t["@@unitShape"] ? o = t["@@unitShape"]() : $85b97ae2361ec21c$var$N("expect @@unitShape to be a function") : o = t;
    let u = Array.isArray(o), s = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef({
        stale: 1,
        justSubscribed: 0,
        scope: n
    }), [l, a, i, c, f] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>{
        s.current.stale = 1;
        let e = Array.isArray(o) ? [] : {}, t = [], r = [], u = [], l = [];
        for(let s in o){
            let a = o[s];
            (0, $b7l7Q.is).unit(a) || $85b97ae2361ec21c$var$N("expect useUnit argument to be a unit"), (0, $b7l7Q.is).event(a) || (0, $b7l7Q.is).effect(a) ? (e[s] = n ? (0, $b7l7Q.scopeBind)(a, {
                scope: n
            }) : a, u.push(s), l.push(a)) : (e[s] = null, t.push(s), r.push(a));
        }
        return [
            e,
            t,
            r,
            u,
            l
        ];
    }, [
        s,
        n,
        ...Object.keys(o),
        ...Object.values(o)
    ]), p = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef({
        value: l,
        storeKeys: a,
        eventKeys: c,
        eventValues: f
    }), d = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((t)=>{
        let r = s.current;
        r.justSubscribed = 1;
        let o = ()=>{
            r.stale || (r.stale = 1, t());
        }, u = (0, $b7l7Q.step).compute({
            priority: "sampler",
            batch: 1
        }), l = i.map((t)=>$85b97ae2361ec21c$var$e(t, o, n, u));
        return ()=>{
            l.forEach((e)=>e());
        };
    }, [
        i,
        n,
        p,
        s
    ]), m = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>{
        let e, t = p.current, o = s.current, d = 0, m = t.value, y = t.storeKeys, h = t.eventKeys, v = t.eventValues, b = n !== o.scope;
        if (o.stale || o.justSubscribed || b) {
            d = !o.justSubscribed || b, e = u ? [
                ...l
            ] : {
                ...l
            }, y.length === a.length && h.length === c.length || (d = 1);
            for(let t = 0; t < a.length; t++){
                let r = $85b97ae2361ec21c$var$V(i[t], n), o = a[t];
                d || (d = y.includes(o) ? m[o] !== r : 1), e[o] = r;
            }
            for(let e = 0; e < c.length; e++){
                let t = f[e], n = c[e];
                d || (d = h.includes(n) ? v[h.indexOf(n)] !== t : 1);
            }
        }
        return d && (t.value = e), t.storeKeys = a, t.eventKeys = c, t.eventValues = f, o.stale = 0, o.justSubscribed = !d, o.scope = n, r ? t.value.unit : t.value;
    }, [
        d,
        i,
        f,
        n,
        p,
        s
    ]);
    return $85b97ae2361ec21c$var$M(d, m, m);
}
function $85b97ae2361ec21c$var$o([t, n], r) {
    let o, u, s, l, a = $85b97ae2361ec21c$var$L;
    n ? (o = n, s = t, l = []) : { fn: o, store: s, keys: l, defaultValue: u, updateFilter: a = $85b97ae2361ec21c$var$L } = t, (0, $b7l7Q.is).store(s) || $85b97ae2361ec21c$var$N("useStoreMap expects a store"), Array.isArray(l) || $85b97ae2361ec21c$var$N("useStoreMap expects an array as keys"), "function" != typeof o && $85b97ae2361ec21c$var$N("useStoreMap expects a function");
    let i = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((t)=>$85b97ae2361ec21c$var$e(s, t, r), [
        s,
        r
    ]), c = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>$85b97ae2361ec21c$var$V(s, r), [
        s,
        r
    ]), f = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(), p = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(), d = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(l);
    return $85b97ae2361ec21c$var$K(i, c, c, (e)=>{
        if (f.current !== e || !((e, t)=>{
            if (!e || !t || e.length !== t.length) return 0;
            let n = 1;
            for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) {
                n = 0;
                break;
            }
            return n;
        })(d.current, l)) {
            let t = o(e, l);
            void 0 === t && void 0 !== u && (t = u), f.current = e, d.current = l, void 0 !== t && (p.current = t);
        }
        return p.current;
    }, (e, t)=>!a(t, e));
}
function $85b97ae2361ec21c$var$u(e, t = {}, n) {
    let { open: o, close: u, set: s } = $85b97ae2361ec21c$var$r({
        open: e.open,
        close: e.close,
        set: e.set
    }, n), l = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>({
            open: o,
            close: u,
            set: s
        }), [
        e,
        o
    ]), a = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef({
        value: null,
        count: 0
    });
    $85b97ae2361ec21c$var$O(()=>(l.open(a.current.value), ()=>l.close(a.current.value)), [
        l
    ]), ((e, t)=>{
        if (e === t) return 1;
        if ("object" == typeof e && null !== e && "object" == typeof t && null !== t) {
            let n = Object.keys(e), r = Object.keys(t);
            if (n.length !== r.length) return 0;
            for(let r = 0; r < n.length; r++){
                let o = n[r];
                if (e[o] !== t[o]) return 0;
            }
            return 1;
        }
        return 0;
    })(a.current.value, t) || (a.current.value = t, a.current.count += 1), $85b97ae2361ec21c$var$O(()=>{
        l.set(a.current.value);
    }, [
        a.current.count
    ]);
}
function $85b97ae2361ec21c$var$s(e) {
    let t = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($85b97ae2361ec21c$var$U);
    return e && !t && $85b97ae2361ec21c$var$N("No scope found, consider adding <Provider> to app root"), t;
}
function $85b97ae2361ec21c$export$90fc3a17d93f704c(e, t) {
    return ((e, t)=>{
        if (!t) return e;
        let n = (0, $b7l7Q.is).unit(e) || "object" != typeof e ? {
            event: e
        } : e;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>{
            if ((0, $b7l7Q.is).unit(e)) return (0, $b7l7Q.scopeBind)(e, {
                scope: t
            });
            let n = Array.isArray(e) ? [] : {};
            for(let r in e)n[r] = (0, $b7l7Q.scopeBind)(e[r], {
                scope: t
            });
            return n;
        }, [
            t,
            ...Object.keys(n),
            ...Object.values(n)
        ]);
    })(e, $85b97ae2361ec21c$var$s(null == t ? void 0 : t.forceScope));
}
function $85b97ae2361ec21c$export$6ccbb43953eebf8(e, t) {
    return $85b97ae2361ec21c$var$n(e, $85b97ae2361ec21c$var$s(null == t ? void 0 : t.forceScope));
}
function $85b97ae2361ec21c$export$d048e1275d50b112(e, t) {
    return $85b97ae2361ec21c$var$r(e, $85b97ae2361ec21c$var$s(null == t ? void 0 : t.forceScope));
}
function $85b97ae2361ec21c$export$8b87f165e6cd655(e, t) {
    return $85b97ae2361ec21c$var$o([
        e,
        t
    ], $85b97ae2361ec21c$var$s(null == e ? void 0 : e.forceScope));
}
function $85b97ae2361ec21c$export$f9763ecd339e95eb(e, r, u) {
    return ((e, r, u)=>{
        let s, l, a, i = [];
        "object" == typeof r && null !== r ? (r.keys && (i = r.keys), { fn: s, getKey: l, placeholder: a } = r) : s = r, (0, $b7l7Q.is).store(e) || $85b97ae2361ec21c$var$N("expect useList first argument to be a store"), "function" != typeof s && $85b97ae2361ec21c$var$N("expect useList's renderItem to be a function"), Array.isArray(i) || $85b97ae2361ec21c$var$N("expect useList's keys to be an array");
        let c = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>{
            let n = $85b97ae2361ec21c$var$t(`${e.shortName || "Unknown"}.Item`, (t)=>{
                let { index: n, keys: r, keyVal: s, value: l } = t;
                if (f.current[1]) return f.current[0](l, s);
                let a = $85b97ae2361ec21c$var$o([
                    {
                        store: e,
                        keys: [
                            n,
                            ...r
                        ],
                        fn: (e, t)=>e[t[0]]
                    }
                ], u);
                return f.current[0](a, n);
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(n);
        }, [
            e,
            u,
            !!l
        ]), f = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef([
            s,
            l
        ]);
        f.current = [
            s,
            l
        ];
        let p = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>i, i);
        if (l) {
            let t = $85b97ae2361ec21c$var$n(e, u);
            return 0 === t.length && a ? a : t.map((e)=>{
                let t = f.current[1](e);
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(c, {
                    keyVal: t,
                    key: t,
                    keys: p,
                    value: e
                });
            });
        }
        {
            let t = $85b97ae2361ec21c$var$o([
                {
                    store: e,
                    keys: [
                        e
                    ],
                    fn: (e)=>e.length
                }
            ], u);
            return 0 === t && a ? a : Array.from({
                length: t
            }, (e, t)=>(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(c, {
                    index: t,
                    key: t,
                    keys: p
                }));
        }
    })(e, r, $85b97ae2361ec21c$var$s(null == u ? void 0 : u.forceScope));
}
function $85b97ae2361ec21c$export$41d95a587fecc5a0(e, t = {}, n) {
    return $85b97ae2361ec21c$var$u(e, t, $85b97ae2361ec21c$var$s(null == n ? void 0 : n.forceScope));
}
function $85b97ae2361ec21c$export$60e54eaca7e7fb38(e, n) {
    function r(e) {
        let t = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(e), r = $85b97ae2361ec21c$export$6ccbb43953eebf8(o);
        $85b97ae2361ec21c$var$O(()=>(s({
                props: t.current,
                state: o.getState()
            }), ()=>{
                l({
                    props: t.current,
                    state: o.getState()
                });
            }), []);
        let u = n(e, r);
        return t.current = e, u;
    }
    let o;
    (0, $b7l7Q.is).store(e) ? o = e : "object" == typeof e && null !== e ? o = (0, $b7l7Q.combine)(e) : $85b97ae2361ec21c$var$N("shape should be a store or object with stores");
    let u = "Unknown";
    o && o.shortName && (u = o.shortName);
    let s = (0, $b7l7Q.createEvent)(), l = (0, $b7l7Q.createEvent)();
    return r.mounted = s, r.unmounted = l, $85b97ae2361ec21c$var$t(`${u}.View`, r);
}
function $85b97ae2361ec21c$export$401a2ee3d210505c(e) {
    return $85b97ae2361ec21c$export$60e54eaca7e7fb38(e, ({ children: e }, t)=>e(t));
}
function $85b97ae2361ec21c$var$y(e, t) {
    let n = t ? e : e[0];
    var r;
    ((e)=>{
        if (!e) throw Error("expect first argument be an object");
    })($85b97ae2361ec21c$var$G(r = n) || ((e)=>"function" == typeof e)(r));
    let o = n.or, u = n.and;
    if (u) {
        let n = t ? u : u[0];
        if ($85b97ae2361ec21c$var$G(n) && "and" in n) {
            let n = $85b97ae2361ec21c$var$y(u, t);
            e = n[0], o = {
                ...o,
                ...n[1]
            };
        } else e = u;
    }
    return [
        e,
        o
    ];
}
function $85b97ae2361ec21c$var$h(e, t) {
    let n = t && $85b97ae2361ec21c$var$G(r = t[0]) && (r.and || r.or) ? t : [
        {
            and: t
        }
    ];
    var r;
    let o, [[u, s], l] = $85b97ae2361ec21c$var$y(n), a = {}, i = {}, c = l;
    var f;
    return "string" == typeof u ? (i = {
        name: u
    }, $85b97ae2361ec21c$var$G(f = s) && "sid" in f || (a = s || {})) : ((e)=>$85b97ae2361ec21c$var$G(e) && ("domain" in e || "defaultState" in e || "name" in e))(u) && (i = u, a = u.defaultState || {}, o = u.domain), {
        hook: e,
        domain: o,
        defaultState: a,
        mainConfig: i,
        maybeConfig: c
    };
}
function $85b97ae2361ec21c$export$b7eb246e5f4e5a66(...e) {
    return (({ domain: e, defaultState: n, hook: r, mainConfig: o, maybeConfig: u })=>{
        function l(e) {
            return r(l, e, $85b97ae2361ec21c$var$s()), null;
        }
        let a = $85b97ae2361ec21c$var$W({
            or: u,
            and: o
        }), i = `${e ? `${e.compositeName.fullName}/` : ""}${a.name || "gate"}`, c = (0, $b7l7Q.createEvent)({
            name: `${i}.set`,
            sid: a.sid ? `${a.sid}|set` : void 0
        }), f = (0, $b7l7Q.createEvent)({
            name: `${i}.open`,
            sid: a.sid ? `${a.sid}|open` : void 0
        }), p = (0, $b7l7Q.createEvent)({
            name: `${i}.close`,
            sid: a.sid ? `${a.sid}|close` : void 0
        }), d = (0, $b7l7Q.createStore)(Boolean(0), {
            name: `${i}.status`,
            serialize: "ignore"
        }).on(f, ()=>Boolean(1)).on(p, ()=>Boolean(0)), m = (0, $b7l7Q.createStore)(n, {
            name: `${i}.state`,
            sid: a.sid
        }).on(c, (e, t)=>t).on(f, (e, t)=>t).reset(p);
        if (e) {
            let { hooks: t } = e;
            (0, $b7l7Q.launch)({
                target: [
                    t.store,
                    t.store,
                    t.event,
                    t.event,
                    t.event
                ],
                params: [
                    d,
                    m,
                    f,
                    p,
                    c
                ]
            });
        }
        return l.open = f, l.close = p, l.status = d, l.state = m, l.set = c, $85b97ae2361ec21c$var$t(`Gate:${i}`, l);
    })($85b97ae2361ec21c$var$h($85b97ae2361ec21c$var$u, e));
}
let $85b97ae2361ec21c$var$N = (e)=>{
    throw Error(e);
}, $85b97ae2361ec21c$var$O = "undefined" != typeof window ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect;
const { useSyncExternalStore: $85b97ae2361ec21c$var$M } = (0, (/*@__PURE__*/$parcel$interopDefault($hVYK3))), { useSyncExternalStoreWithSelector: $85b97ae2361ec21c$var$K } = (0, (/*@__PURE__*/$parcel$interopDefault($h2bFT))), $85b97ae2361ec21c$var$V = (e, t)=>t ? t.getState(e) : e.getState(), $85b97ae2361ec21c$var$L = (e, t)=>e !== t, $85b97ae2361ec21c$var$U = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
let { Provider: $85b97ae2361ec21c$export$2881499e37b75b9a } = $85b97ae2361ec21c$var$U, $85b97ae2361ec21c$var$I = (e)=>console.error(`${e} is deprecated`), $85b97ae2361ec21c$export$fd50cb2633c11e6e = (e, n, r)=>($85b97ae2361ec21c$var$I("createContextComponent"), $85b97ae2361ec21c$var$t(`${e.shortName || "Unknown"}.ContextComponent`, (t)=>{
        let o = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext(n), u = $85b97ae2361ec21c$export$6ccbb43953eebf8(e);
        return r(t, u, o);
    })), $85b97ae2361ec21c$export$64605811ab45167f = (e)=>(n)=>{
        let r = e;
        return "function" != typeof e && (r = n, n = e), $85b97ae2361ec21c$var$t(`Connect(${r.displayName || r.name || "Unknown"})`, (e)=>(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(r, {
                ...e,
                ...$85b97ae2361ec21c$export$6ccbb43953eebf8(n)
            }));
    }, $85b97ae2361ec21c$export$e4f2caaf2e4db677 = (e, t)=>($85b97ae2361ec21c$var$I("createReactState"), $85b97ae2361ec21c$export$64605811ab45167f(t)(e)), $85b97ae2361ec21c$var$G = (e)=>"object" == typeof e && null !== e, $85b97ae2361ec21c$var$W = (e, t = {})=>($85b97ae2361ec21c$var$G(e) && ($85b97ae2361ec21c$var$W(e.or, t), ((e)=>{
        for(let o in e)r = o, ((e)=>void 0 === e)(n = e[o]) || "or" === r || "and" === r || (t[r] = n);
        var n, r;
    })(e), $85b97ae2361ec21c$var$W(e.and, t)), t);

});
parcelRegister("h2bFT", function(module, exports) {
"use strict";

module.exports = (parcelRequire("l4xzO"));

});
parcelRegister("l4xzO", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $f574044efaf07593$export$bf730a2d8bf68b42; }, function (v) { return $f574044efaf07593$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f574044efaf07593$export$bf730a2d8bf68b42;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $hVYK3 = parcelRequire("hVYK3");
function $f574044efaf07593$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f574044efaf07593$var$q = "function" === typeof Object.is ? Object.is : $f574044efaf07593$var$p, $f574044efaf07593$var$r = $hVYK3.useSyncExternalStore, $f574044efaf07593$var$t = $bh6RR.useRef, $f574044efaf07593$var$u = $bh6RR.useEffect, $f574044efaf07593$var$v = $bh6RR.useMemo, $f574044efaf07593$var$w = $bh6RR.useDebugValue;
$f574044efaf07593$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $f574044efaf07593$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $f574044efaf07593$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($f574044efaf07593$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $f574044efaf07593$var$r(a, c[0], c[1]);
    $f574044efaf07593$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $f574044efaf07593$var$w(d);
    return d;
};

});
parcelRegister("hVYK3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gdZJN"));

});
parcelRegister("gdZJN", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $bcfdc00ed56980e9$export$306c0aa65ff9ec16; }, function (v) { return $bcfdc00ed56980e9$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcfdc00ed56980e9$export$306c0aa65ff9ec16;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
function $bcfdc00ed56980e9$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bcfdc00ed56980e9$var$k = "function" === typeof Object.is ? Object.is : $bcfdc00ed56980e9$var$h, $bcfdc00ed56980e9$var$l = $bh6RR.useState, $bcfdc00ed56980e9$var$m = $bh6RR.useEffect, $bcfdc00ed56980e9$var$n = $bh6RR.useLayoutEffect, $bcfdc00ed56980e9$var$p = $bh6RR.useDebugValue;
function $bcfdc00ed56980e9$var$q(a, b) {
    var d = b(), f = $bcfdc00ed56980e9$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $bcfdc00ed56980e9$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $bcfdc00ed56980e9$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $bcfdc00ed56980e9$var$m(function() {
        $bcfdc00ed56980e9$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $bcfdc00ed56980e9$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $bcfdc00ed56980e9$var$p(d);
    return d;
}
function $bcfdc00ed56980e9$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$bcfdc00ed56980e9$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $bcfdc00ed56980e9$var$t(a, b) {
    return b();
}
var $bcfdc00ed56980e9$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $bcfdc00ed56980e9$var$t : $bcfdc00ed56980e9$var$q;
$bcfdc00ed56980e9$export$306c0aa65ff9ec16 = void 0 !== $bh6RR.useSyncExternalStore ? $bh6RR.useSyncExternalStore : $bcfdc00ed56980e9$var$u;

});









parcelRegister("6PJu1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f9ac984dfdb56ac$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $4f9ac984dfdb56ac$var$API_URL = (0, location.origin);
class $4f9ac984dfdb56ac$var$Doctors {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $4f9ac984dfdb56ac$var$API_URL);
    }
    getAll() {
        return this.apiService.get(`doctors`, {}, {}, true, "", true);
    }
    getListDoctors({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params }) {
        return this.apiService.post(`dynamic/doctor/list`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params
        });
    }
    getListDoctorsOrganization({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params }) {
        return this.apiService.post(`dynamic/doctororganization/list`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params
        });
    }
    getFavouriteDoctors() {
        return this.apiService.get(`favorite-doctors`, {}, {}, true, "", true);
    }
    addDoctorToFavourites(doctorId) {
        return this.apiService.post(`doctors/${doctorId}/favorite`);
    }
    removeDoctorFromFavourites(doctorId) {
        return this.apiService.delete(`favorite-doctors/${doctorId}`);
    }
    patchDoctorPermission(doctorId, params) {
        return this.apiService.patch(`doctor/${doctorId}/add_permission`, {}, params);
    }
    getEmbryologists() {
        return this.apiService.get(`doctors/embryologists`);
    }
    async getSalary(filters) {
        return this.apiService.get(`salary`, filters, {}, true, "", true);
    }
    sendTestPushNotification() {
        return this.apiService.get(`test-push-doctor`);
    }
    sendPinCodeNotification() {
        return this.apiService.get(`push-pin-code`);
    }
    checkPinCode(pin) {
        return this.apiService.post(`check-pin-code`, {}, {
            pin: pin
        });
    }
    analyticsDoctorsInChat() {
        return this.apiService.post(`chat_doctors/analytics/metric`);
    }
    getBonusSchemaData() {
        return this.apiService.get(`bonus-scheme`);
    }
}
var $4f9ac984dfdb56ac$export$2e2bcd8739ae039 = new $4f9ac984dfdb56ac$var$Doctors();

});

parcelRegister("e4RYP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3fb4fbae87ac982$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $a3fb4fbae87ac982$var$API_URL = (0, location.origin);
class $a3fb4fbae87ac982$var$Embryos {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $a3fb4fbae87ac982$var$API_URL);
    }
    get({ patientId: patientId, viewType: viewType }) {
        return this.apiService.get(`embryos`, {
            patient_id: patientId,
            view_type: viewType
        });
    }
    getCryoEmbryosCount(patientId, abortPreviousRequest) {
        return this.apiService.get(`embryos_count`, {
            patient_id: patientId
        }, {}, true, "", false, abortPreviousRequest);
    }
    getEmbryoMedicalFiles(params) {
        const { embryoId: embryoId, ...otherParams } = params;
        return this.apiService.get(`embryos/${embryoId}/medical-files`, otherParams);
    }
    getEmbryosByFolderId(folderId, viewType) {
        return this.apiService.get(`folders/${folderId}/embryos`, {
            view_type: viewType
        });
    }
    getEmbryosManipulations(folderId) {
        return this.apiService.get(`folders/${folderId}/manipulations`);
    }
    patchEmbryosManipulations({ id: id, folderId: folderId, time: time, doctorId: doctorId, date: date, clear: clear }) {
        return this.apiService.patch(`folders/${folderId}/manipulations/${id}`, {}, {
            time: time,
            doctor_id: doctorId,
            date: date,
            clear: clear
        });
    }
    getEmbryosPrintDocumentData({ folderId: folderId, patientId: patientId, type: type }) {
        const params = {
            type: type
        };
        if (folderId) params.folderId = folderId;
        return this.apiService.get(`patients/${patientId}/embryos_print`, params);
    }
    create({ folderId: folderId, number: number }) {
        return this.apiService.post(`folders/${folderId}/embryos`, {}, {
            batch_size: number
        });
    }
    async update({ id: id, payload: payload }) {
        try {
            return await this.apiService.patch(`embryos/${id}`, {}, payload);
        } catch (err) {
            if (err.code === 400) throw new Error("\u041D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435");
            throw new Error("\u041D\u0435\u0442 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F");
        }
    }
    async delete({ id: id }) {
        try {
            await this.apiService.delete(`embryos/${id}`);
            return true;
        } catch (err) {
            throw new Error("\u041D\u0435\u0442 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F");
        }
    }
    async copy({ id: id, viewType: viewType }) {
        try {
            return await this.apiService.post(`embryos/${id}/copy`, {}, {
                view_type: viewType
            });
        } catch (err) {
            throw new Error("\u041D\u0435\u0442 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F");
        }
    }
}
var $a3fb4fbae87ac982$export$2e2bcd8739ae039 = new $a3fb4fbae87ac982$var$Embryos();

});

parcelRegister("eTPwn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad8e2ac8a0412145$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $ad8e2ac8a0412145$var$API_URL = (0, location.origin);
class $ad8e2ac8a0412145$var$MedicalFiles {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $ad8e2ac8a0412145$var$API_URL);
    }
    get({ search: search, patientId: patientId }) {
        return this.apiService.get(`medical-files`, {
            search: search,
            patient_id: patientId
        }, {}, true, "");
    }
    getCancellable({ search: search, patientId: patientId }) {
        return this.apiService.get(`medical-files`, {
            search: search,
            patient_id: patientId
        }, {}, true, "", false, true);
    }
    getListMedicalFiles({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params, is_after_get: is_after_get }) {
        return this.apiService.post(`medical-files-search`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params,
            is_after_get: is_after_get
        }, {}, true, "", true);
    }
    getDynamicMedicalFileById({ id: id }) {
        return this.apiService.get(`dynamic/medicalfile/retrieve/${id}`, {}, {}, true, "", true);
    }
    postDynamicMedicalFileById(data) {
        return this.apiService.post(`dynamic/medicalfile/update`, {}, data);
    }
    sendRees({ filter_params: filter_params, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params, communication: communication }) {
        return this.apiService.post(`medical-files-search/communication/send`, {}, {
            filter_params: filter_params,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params,
            communication: communication
        }, {}, true, "", true);
    }
    getById(id) {
        return this.apiService.get(`medical-files/${id}`, {}, {}, true, "", true);
    }
    getByNumber(number) {
        return this.apiService.get(`medical-files-by-number/${number}`, {}, {}, true, "", true);
    }
}
var $ad8e2ac8a0412145$export$2e2bcd8739ae039 = new $ad8e2ac8a0412145$var$MedicalFiles();

});

parcelRegister("fwL0j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4de4e34bcd2ec7d$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $b4de4e34bcd2ec7d$var$API_URL = (0, location.origin);
class $b4de4e34bcd2ec7d$var$MedicalFilesV2 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api-v2", null, null, $b4de4e34bcd2ec7d$var$API_URL);
    }
    get({ patientId: patientId }) {
        return this.apiService.get(`medical-files`, {
            patient_id: patientId
        }, {}, true, "");
    }
}
var $b4de4e34bcd2ec7d$export$2e2bcd8739ae039 = new $b4de4e34bcd2ec7d$var$MedicalFilesV2();

});

parcelRegister("6qTwl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4af03d03870957ba$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $4af03d03870957ba$var$API_URL = (0, location.origin);
class $4af03d03870957ba$var$MedicalGenomics {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/medical-genomics", null, null, $4af03d03870957ba$var$API_URL);
    }
    createOrder({ folderId: folderId }) {
        return this.apiService.post(`orders`, {
            folder_id: folderId
        }, {});
    }
    updateOrder({ orderId: orderId, orderData: orderData }) {
        return this.apiService.patch(`orders/${orderId}`, {}, orderData);
    }
    sendOrder({ orderId: orderId }) {
        return this.apiService.post(`orders/${orderId}/send`, {}, {});
    }
    getOrderList(folderId) {
        return this.apiService.get(`orders`, {
            folder_id: folderId
        });
    }
}
var $4af03d03870957ba$export$2e2bcd8739ae039 = new $4af03d03870957ba$var$MedicalGenomics();

});

parcelRegister("22Dzw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17ca76dc76bfba22$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");

var $iOlMk = parcelRequire("iOlMk");
const $17ca76dc76bfba22$var$API_URL = (0, location.origin);
class $17ca76dc76bfba22$var$Notices {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $17ca76dc76bfba22$var$API_URL);
    }
    getSocketUrl() {
        const url = new URL(`${$17ca76dc76bfba22$var$API_URL}/api/ws/notices/?Authorization=${(0, $iOlMk.tokenStore).getState()}`);
        url.protocol = "wss:";
        return url.toString();
    }
    createNotice(noticeData) {
        return this.apiService.post("notices", {}, noticeData);
    }
    updateNotice(noticeId, noticeData) {
        return this.apiService.patch("notices", {}, {
            ...noticeData,
            id: noticeId
        });
    }
    deleteNotice(noticeId) {
        return this.apiService.delete(`notices/${noticeId}`);
    }
    getNotices() {
        return this.apiService.get(`notices`);
    }
    readNotice(noticeId) {
        return this.apiService.post(`read-notices`, {}, {
            notice: noticeId
        });
    }
    unreadNotice(noticeId) {
        return this.apiService.delete(`read-notices`, {}, {
            notice: noticeId
        });
    }
    getUnreadNotices() {
        return this.apiService.get(`notices`, {
            unread: "true"
        });
    }
    getUnreadAndReadNotices() {
        return this.apiService.get(`notices`, {
            unread_and_last_read: "true"
        });
    }
}
var $17ca76dc76bfba22$export$2e2bcd8739ae039 = new $17ca76dc76bfba22$var$Notices();

});

parcelRegister("87Nwe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ea5639b41bb777f$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $5ea5639b41bb777f$var$API_URL = (0, location.origin);
class $5ea5639b41bb777f$var$Notifications {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $5ea5639b41bb777f$var$API_URL);
    }
    createPatientReminder(payload) {
        return this.apiService.post(`notifications`, {}, {
            appointment_id: payload.appointmentId,
            date_send: payload.date,
            text: payload.text
        });
    }
    getPatientReminders() {
        return this.apiService.get(`notifications`);
    }
    getPatientRemindersUrl(token) {
        const url = new URL(`${$5ea5639b41bb777f$var$API_URL}/api/ws/notifications/`);
        url.searchParams.append("token", token);
        url.protocol = "wss:";
        return url.toString();
    }
    setPatientReminderRead(id) {
        return this.apiService.patch(`notifications/${id}/read`);
    }
}
var $5ea5639b41bb777f$export$2e2bcd8739ae039 = new $5ea5639b41bb777f$var$Notifications();

});

parcelRegister("i5576", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d29ca90f9b6204e7$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $d29ca90f9b6204e7$var$API_URL = (0, location.origin);
class $d29ca90f9b6204e7$var$Review {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $d29ca90f9b6204e7$var$API_URL);
    }
    getLink(token, app, city) {
        return this.apiService.get(`review/link`, {
            token: token,
            app: app,
            city: city
        });
    }
    putProgress(progress) {
        return this.apiService.put(`review/set_progress`, {}, progress, {}, true);
    }
}
var $d29ca90f9b6204e7$export$2e2bcd8739ae039 = new $d29ca90f9b6204e7$var$Review();

});

parcelRegister("3leXE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26eef03be36e708a$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $26eef03be36e708a$var$API_URL = (0, location.origin);
class $26eef03be36e708a$var$ReviewStatistics {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $26eef03be36e708a$var$API_URL);
    }
    getListReviews({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params }) {
        return this.apiService.post(`review/analytics/list`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params
        });
    }
    postReviews(data) {
        return this.apiService.post(`review/analytics`, {}, data);
    }
    createReview(data) {
        return this.apiService.post(`review`, {}, data);
    }
    getReviewTags() {
        return this.apiService.get(`review/analytics/tag`, {});
    }
    getAppointmentTypeDiagram(filters) {
        return this.apiService.post(`review/analytics/appointment-type`, {}, filters);
    }
    getSetRateDiagram(filters) {
        return this.apiService.post(`review/analytics/set-rate`, {}, filters);
    }
    getRedirectYandexDiagram(filters) {
        return this.apiService.post(`review/analytics/redirect-yandex`, {}, filters);
    }
    getHaveReviewTextDiagram(filters) {
        return this.apiService.post(`review/analytics/have-review-text`, {}, filters);
    }
    getRateDiagram(filters) {
        return this.apiService.post(`review/analytics/rate`, {}, filters);
    }
    getInternalRateDiagram(filters) {
        return this.apiService.post(`review/analytics/inner-rate`, {}, filters);
    }
    getRateDiagramBySource(filters) {
        return this.apiService.post(`review/analytics/map-name/rate`, {}, filters);
    }
    getUrlOpenDiagram(filters) {
        return this.apiService.post(`review/analytics/url-open`, {}, filters);
    }
    getUrlSendDiagram(filters) {
        return this.apiService.post(`review/analytics/url-send`, {}, filters);
    }
    getRegistrationLoyaltyDiagram(filters) {
        return this.apiService.post(`review/analytics/registration-loyalty`, {}, filters);
    }
    getTagsDiagram(filters) {
        return this.apiService.post(`review/analytics/tags`, {}, filters);
    }
    getNpsDiagram(filters) {
        return this.apiService.post(`review/analytics/nps`, {}, filters);
    }
    getNewNpsDiagram(filters) {
        return this.apiService.post(`review/analytics/new-nps`, {}, filters);
    }
    getCesDiagram(filters) {
        return this.apiService.post(`review/analytics/ces`, {}, filters);
    }
    getCsatDiagram(filters) {
        return this.apiService.post(`review/analytics/csat`, {}, filters);
    }
    getRprDiagram(filters) {
        return this.apiService.post(`appointments/analytics/rpr`, {}, filters);
    }
    getTotalReviewsDiagram(filters) {
        return this.apiService.post(`review/analytics/map-name/average-rate`, {}, filters);
    }
    reviewModeration(filters) {
        return this.apiService.post(`/review/analytics/moderation/`, {}, filters);
    }
    getNumberOfLoyaltyPointsByPatientId(id) {
        return this.apiService.get(`review/loyalty-card/${id}/balance`, {});
    }
    postAddLoyaltyPoint(patientId, reviewId) {
        return this.apiService.post(`review/loyalty-card/add-coins`, {}, {
            patient_id: patientId,
            review_id: reviewId
        });
    }
    getRatingByReviews(filters) {
        return this.apiService.post(`review/analytics/average-rating`, {}, filters);
    }
}
var $26eef03be36e708a$export$2e2bcd8739ae039 = new $26eef03be36e708a$var$ReviewStatistics();

});

parcelRegister("l2God", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f51aaa96af8699b7$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $f51aaa96af8699b7$var$API_URL = (0, location.origin);
class $f51aaa96af8699b7$var$Organizations {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $f51aaa96af8699b7$var$API_URL);
    }
    getOrganizations() {
        return this.apiService.get(`organizations`, {}, {}, true, "", true);
    }
    getOrganization(organizationId) {
        return this.apiService.get(`organizations/${organizationId}`, {}, {}, true, "", true);
    }
    getAllOrganizations() {
        return this.apiService.get(`all_organizations`, {});
    }
}
var $f51aaa96af8699b7$export$2e2bcd8739ae039 = new $f51aaa96af8699b7$var$Organizations();

});

parcelRegister("3NC4z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c437b2c3d5c0217$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $2c437b2c3d5c0217$var$API_URL = (0, location.origin);
class $2c437b2c3d5c0217$var$Ticket {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "presetFilterParams", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $2c437b2c3d5c0217$var$API_URL);
    }
    getListTickets({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params }) {
        if (this.presetFilterParams && !filter_params.area__in) filter_params = {
            ...filter_params,
            ...this.presetFilterParams
        };
        return this.apiService.post(`ticket/list`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params
        });
    }
    postEditedTicket(data) {
        return this.apiService.post(`ticket/update`, {}, data);
    }
    postCreateTicket(data) {
        return this.apiService.post(`ticket`, {}, data);
    }
    sendComment({ ticketId: ticketId, comment: comment }) {
        return this.apiService.post(`ticket/${ticketId}/comments`, {}, comment);
    }
    getComments(ticketId) {
        return this.apiService.get(`ticket/${ticketId}/comments`);
    }
    postCreateTicketFile(ticketId, formData) {
        return this.apiService.post(`ticket/${ticketId}/files`, {}, formData, {}, false);
    }
    getTicketFiles(ticketId) {
        return this.apiService.get(`ticket/${ticketId}/files`);
    }
    deleteTicketFiles(fileId) {
        return this.apiService.delete(`ticket/files/${fileId}`);
    }
}
var $2c437b2c3d5c0217$export$2e2bcd8739ae039 = new $2c437b2c3d5c0217$var$Ticket();

});

parcelRegister("ioU0I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d655ea65c55e06c5$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $d655ea65c55e06c5$var$API_URL = (0, location.origin);
class $d655ea65c55e06c5$var$Payment {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/concierge", null, null, $d655ea65c55e06c5$var$API_URL);
    }
    getAnalyticsMetric(filters) {
        return this.apiService.post(`analytics/metric`, {}, filters);
    }
}
var $d655ea65c55e06c5$export$2e2bcd8739ae039 = new $d655ea65c55e06c5$var$Payment();

});

parcelRegister("dDnC6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ed13c0b4777c5e1$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $9ed13c0b4777c5e1$var$API_URL = (0, location.origin);
class $9ed13c0b4777c5e1$var$Stories {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $9ed13c0b4777c5e1$var$API_URL);
    }
    getStories() {
        return this.apiService.get(`stories`, {});
    }
    getAnalyticsStories(filters) {
        return this.apiService.post(`common/metric/analytics/stories`, {}, filters);
    }
}
var $9ed13c0b4777c5e1$export$2e2bcd8739ae039 = new $9ed13c0b4777c5e1$var$Stories();

});

parcelRegister("c4WNF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cb37840ca5258a2$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $8cb37840ca5258a2$var$API_URL = (0, location.origin);
class $8cb37840ca5258a2$var$Metric {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/common/metric", null, null, $8cb37840ca5258a2$var$API_URL);
    }
    getAnalyticsContent(filters) {
        return this.apiService.post(`analytics/content`, {}, filters);
    }
    getAnalyticsFirstOnlineAppSale(filters) {
        return this.apiService.post(`analytics/first-online-app-sale`, {}, filters);
    }
}
var $8cb37840ca5258a2$export$2e2bcd8739ae039 = new $8cb37840ca5258a2$var$Metric();

});

parcelRegister("gIhPw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2ae960d13a16a5c$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $c2ae960d13a16a5c$var$API_URL = (0, location.origin);
class $c2ae960d13a16a5c$var$Feedback {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/feedback", null, null, $c2ae960d13a16a5c$var$API_URL);
    }
    getFeedback(id) {
        return this.apiService.get(`feedbacks/${id}`);
    }
    getFeedbackFields(id) {
        return this.apiService.get(`layouts/${id}/fields`);
    }
    getFeedbackResponse(id) {
        return this.apiService.get(`feedbacks/${id}/response`);
    }
    getFeedbackComplete({ id: id, doctors_comment: doctors_comment }) {
        return this.apiService.post(`feedbacks/${id}/complete`, {}, {
            doctors_comment: doctors_comment
        });
    }
    getFeedbacks(params) {
        if (!params.order) delete params.order;
        return this.apiService.get("feedbacks", params);
    }
    postFeedbacks({ layout_id: layout_id, appointment_id: appointment_id, notification_date: notification_date }) {
        return this.apiService.post("feedbacks", {}, {
            layout_id: layout_id,
            appointment_id: appointment_id,
            notification_date: notification_date
        });
    }
    // getFeedbacksCount() {
    //   return this.apiService.get('feedbacks/count');
    // }
    postRefreshToken(token) {
        return this.apiService.post("refresh-token", {}, {
            token: token
        });
    }
    logout() {
        return this.apiService.post("logout");
    }
}
var $c2ae960d13a16a5c$export$2e2bcd8739ae039 = new $c2ae960d13a16a5c$var$Feedback();

});

parcelRegister("d5xIL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9875e642d0610874$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $9875e642d0610874$var$API_URL = (0, location.origin);
class $9875e642d0610874$var$Files {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("", null, null, $9875e642d0610874$var$API_URL);
    }
    postUploadedFile({ patient: patient, uploadOptions: uploadOptions, type: type }) {
        let formData = new FormData();
        formData.append("file", uploadOptions.file);
        formData.append("original_name", uploadOptions.original_name || "");
        formData.append("type", type || "analysis");
        return this.apiService.post(patient ? `api/patients/${patient}/uploads` : `api/uploads`, {}, formData, {}, false);
    }
}
var $9875e642d0610874$export$2e2bcd8739ae039 = new $9875e642d0610874$var$Files();

});

parcelRegister("QERdR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09e48ce0b12aa18c$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $09e48ce0b12aa18c$var$API_URL = (0, location.origin);
class $09e48ce0b12aa18c$var$Uploads {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $09e48ce0b12aa18c$var$API_URL);
    }
    getUploads(params) {
        const { patient: patient, ...other } = params;
        return this.apiService.get(`patients/${patient}/uploads`, other);
    }
    patchUploads(id, params) {
        return this.apiService.patch(`uploads/${id}`, {}, params);
    }
    removeUploads(id) {
        this.apiService.delete(`uploads/${id}`);
    }
}
var $09e48ce0b12aa18c$export$2e2bcd8739ae039 = new $09e48ce0b12aa18c$var$Uploads();

});

parcelRegister("3C4rQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a185f0833e3373f$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $2a185f0833e3373f$var$API_URL = (0, location.origin);
class $2a185f0833e3373f$var$Questionnaire {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $2a185f0833e3373f$var$API_URL);
    }
    getQuestionnaire(id) {
        return this.apiService.get(`questionnaire/${id}`);
    }
    updateQuestionnaireValue(id, payload) {
        return this.apiService.patch(`questionnaire_values/${id}`, {}, payload);
    }
    finishQuestionnaire(id) {
        return this.apiService.post(`questionnaire/${id}/finish`);
    }
    patchQuestionnairePartner(id, partnerId) {
        return this.apiService.patch(`questionnaire/${id}`, {}, {
            partner_id: partnerId
        });
    }
}
var $2a185f0833e3373f$export$2e2bcd8739ae039 = new $2a185f0833e3373f$var$Questionnaire();

});

parcelRegister("laM70", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f69fda35f64e2ef9$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $f69fda35f64e2ef9$var$API_URL = (0, location.origin);
class $f69fda35f64e2ef9$var$HospitalAdmissions {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $f69fda35f64e2ef9$var$API_URL);
    }
    getHospitalAdmissions() {
        return this.apiService.get(`hospital_admission`);
    }
    patchHospitalAdmissions(payload) {
        return this.apiService.patch(`hospital_admission/${payload.id}`, {}, payload);
    }
}
var $f69fda35f64e2ef9$export$2e2bcd8739ae039 = new $f69fda35f64e2ef9$var$HospitalAdmissions();

});

parcelRegister("aLBlj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d6b42a86516b1b5$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $7d6b42a86516b1b5$var$API_URL = (0, location.origin);
class $7d6b42a86516b1b5$var$Survey {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "presetFilterParams", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/integration", null, null, $7d6b42a86516b1b5$var$API_URL);
    }
    getSurveyById({ id: id }) {
        return this.apiService.get(`dynamic/medicalfile/retrieve/${id}`, {}, {}, true, "", true);
    }
    getSurveyList(id) {
        return this.apiService.get(`survey/list`, {
            survey_id: id
        });
    }
    getSurveyResultById(id) {
        return this.apiService.get(`survey/result/${id}`);
    }
    createSurvey(data) {
        return this.apiService.post(`survey`, {}, data);
    }
    setValueSurvey(surveyId, data) {
        return this.apiService.post(`survey/${surveyId}/set-value`, {}, data);
    }
    finishStep(surveyId, data) {
        return this.apiService.post(`survey/${surveyId}/finish`, {}, data);
    }
    backStep(surveyId, data) {
        return this.apiService.post(`survey/${surveyId}/step-back`, {}, data);
    }
    getFeedbackResults() {
        return this.apiService.get("survey/feedback-result");
    }
}
var $7d6b42a86516b1b5$export$2e2bcd8739ae039 = new $7d6b42a86516b1b5$var$Survey();

});

parcelRegister("i31E6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d239c8a65bd5d57f$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $d239c8a65bd5d57f$var$API_URL = (0, location.origin);
class $d239c8a65bd5d57f$var$Survey {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "presetFilterParams", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $d239c8a65bd5d57f$var$API_URL);
    }
    getSurveyResultsForIdList({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params }) {
        values_params = values_params.filter((item)=>item !== "user__doctor__organizations");
        return this.apiService.post(`analytic/survey/result/list`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params
        });
    }
    postSurveyResult(data) {
        return this.apiService.post(`analytic/survey/result`, {}, data);
    }
    getSurveyResultById(id) {
        return this.apiService.get(`analytic/survey/result`, {
            id: id
        });
    }
    getENPSDiagram(filters) {
        return this.apiService.post(`analytic/survey/widgets/employees/enps`, {}, filters);
    }
    getENPSDiagram(filters) {
        return this.apiService.post(`analytic/survey/widgets/employees/enps`, {}, filters);
    }
}
var $d239c8a65bd5d57f$export$2e2bcd8739ae039 = new $d239c8a65bd5d57f$var$Survey();

});

parcelRegister("iRjax", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbac0bc456cf6600$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $dbac0bc456cf6600$var$API_URL = (0, location.origin);
class $dbac0bc456cf6600$var$SalesFunnel {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/common/metric/analytics", null, null, $dbac0bc456cf6600$var$API_URL);
    }
    getListData(params) {
        return this.apiService.post(`laboratory-promo`, {}, {
            ...params,
            per_page: 10000000
        });
    }
}
var $dbac0bc456cf6600$export$2e2bcd8739ae039 = new $dbac0bc456cf6600$var$SalesFunnel();

});

parcelRegister("a0zNM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7495acf76f7cf210$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");

var $9ZwOl = parcelRequire("9ZwOl");
const $7495acf76f7cf210$var$API_URL = (0, location.origin);
class $7495acf76f7cf210$var$Communication {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/communication", null, null, $7495acf76f7cf210$var$API_URL);
    }
    sendDynamicMessage({ messageData: messageData = {}, phone_number: phone_number, template: template }) {
        return this.sendDynamicMessageWithCustomTemplate({
            messageData: messageData,
            phone_number: phone_number,
            template: template,
            template_text: (0, $9ZwOl.TEMPLATE_TEXTS)[template]
        });
    }
    sendDynamicMessageWithCustomTemplate({ messageData: messageData = {}, phone_number: phone_number, template: template, template_text: template_text }) {
        return this.apiService.post(`send`, {}, {
            "message": {
                "token": template,
                "template": template_text
            },
            "channel": "edna",
            "push_title": "\u041A\u043B\u0438\u043D\u0438\u043A\u0430 \u0424\u043E\u043C\u0438\u043D\u0430",
            "allow_another_channel": false,
            "type": "INFO",
            // CONFIRM, INFO
            "receivers": [
                {
                    "phone": phone_number,
                    "birthdate": "1997-08-15",
                    "message_data": messageData
                }
            ]
        }, {
            "SECRETKEY": "fnihnx=l8xgfsmt12ol%5f#iaemyja2xez7whi!9@4smn_i#9+"
        }, true, "", false, "", true);
    }
}
var $7495acf76f7cf210$export$2e2bcd8739ae039 = new $7495acf76f7cf210$var$Communication();

});
parcelRegister("9ZwOl", function(module, exports) {

$parcel$export(module.exports, "TEMPLATES", function () { return $74634324c6589b5c$export$b8020e85ad90bfe5; });
$parcel$export(module.exports, "TEMPLATE_TEXTS", function () { return $74634324c6589b5c$export$401f5172686c6b06; });
$parcel$export(module.exports, "getTemplateText", function () { return $74634324c6589b5c$export$73c3bad50c343978; });
$parcel$export(module.exports, "LINK_TYPES", function () { return $74634324c6589b5c$export$d74591583ac34731; });
$parcel$export(module.exports, "LINKS", function () { return $74634324c6589b5c$export$7a948dda2e5abcb7; });
$parcel$export(module.exports, "paymentTableConfig", function () { return $74634324c6589b5c$export$53cfc33312455915; });
$parcel$export(module.exports, "default", function () { return $74634324c6589b5c$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $jqdsN = parcelRequire("jqdsN");

var $9Qp9d = parcelRequire("9Qp9d");

var $kmHuZ = parcelRequire("kmHuZ");
parcelRequire("bh6RR");

var $5oGqh = parcelRequire("5oGqh");

var $cxTnx = parcelRequire("cxTnx");

var $jo8NH = parcelRequire("jo8NH");

var $am7GZ = parcelRequire("am7GZ");
var $gDp1O = parcelRequire("gDp1O");

var $jiymJ = parcelRequire("jiymJ");

var $kEUo3 = parcelRequire("kEUo3");

var $c44wE = parcelRequire("c44wE");

var $iIg7Z = parcelRequire("iIg7Z");
const $74634324c6589b5c$var$URL = (0, location.origin);
const $74634324c6589b5c$var$toastManager = (0, $5oGqh.useToast)();
const $74634324c6589b5c$var$checkRequestForSuccess = (response, callback)=>{
    if (response.mailing_id) {
        if (callback) callback();
        $74634324c6589b5c$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsx)("div", {
            children: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0443 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u043E\u0441\u044C \u0443\u0441\u043F\u0435\u0448\u043D\u043E"
        }), {
            duration: 10000
        });
    } else $74634324c6589b5c$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsx)("div", {
        children: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F"
    }), {
        duration: 10000
    });
};
const $74634324c6589b5c$var$transformScheduleData = (data)=>{
    return data.map((item)=>{
        return {
            id: item.id,
            schedule_insert: {
                id: item.id
            },
            date: item.date,
            time: item.time,
            organization: {
                name: item.doctor_organization__organization__name
            },
            doctor_organization: {
                doctor: {
                    last_name: item.doctor_organization__doctor__last_name,
                    first_name: item.doctor_organization__doctor__first_name,
                    middle_name: item.doctor_organization__doctor__middle_name,
                    specialities: item.doctor_organization__doctor__specialities__name.map((speciality)=>({
                            name: speciality
                        }))
                }
            },
            online_link_for_patient: item.online_link_for_patient,
            type: item.type
        };
    });
};
const $74634324c6589b5c$export$b8020e85ad90bfe5 = {
    /** Отмена приема */ MESSAGE_INITIATION_CANCEL: "message_initiation_cancel_new_05",
    /** Перенос приема */ MESSAGE_INITIATION_TRANSFER: "message_initiation_transfer",
    /** Открытие расписания (лист ожидания) */ MESSAGE_INITIATION_OPENING_SCHEDULE: "message_initiation_opening_schedule",
    /** Освободившийся слот (лист ожидания) */ MESSAGE_INITIATION_VACANT_SLOT: "message_initiation_vacant_slot",
    /** Подготовка к процедурам */ MESSAGE_INITIATION_PREPARATION_PROCEDURES: "message_initiation_preparation_procedures",
    /** Динамическое сообщение */ MESSAGE_INITIATION_DYNAMIC_TEXT_1: "message_initiation_dynamic_text_utility_1",
    MESSAGE_INITIATION_DYNAMIC_TEXT_2: "message_initiation_dynamic_text_utility",
    MESSAGE_INITIATION_DYNAMIC_TEXT_3: "message_initiation_dynamic_text_utility_3_new",
    MESSAGE_INITIATION_DYNAMIC_TEXT_4: "message_initiation_dynamic_text_utility_4",
    /** Обратная связь */ T_FEEDBACK_NEW: "t_feedback_new"
};
const $74634324c6589b5c$export$401f5172686c6b06 = {
    [$74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_CANCEL]: "\u041F\u0440\u0438\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u043C! \uD83D\uDC4B\uD83C\uDFFB \n\n\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u0412\u0430\u0448 \u043F\u0440\u0438\u0435\u043C \u0432 \xab\u041A\u043B\u0438\u043D\u0438\u043A\u0430 \u0424\u043E\u043C\u0438\u043D\u0430\xbb \u043E\u0442\u043C\u0435\u043D\u0435\u043D. \uD83D\uDE14\n\u041F\u0440\u0438\u043D\u043E\u0441\u0438\u043C \u0438\u0437\u0432\u0438\u043D\u0435\u043D\u0438\u044F \u0437\u0430 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0435 \u043D\u0435\u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430.\n\u041C\u044B \u0431\u0443\u0434\u0435\u043C \u0440\u0430\u0434\u044B \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0438\u0442\u044C \u0412\u0430\u043C \u0430\u043B\u044C\u0442\u0435\u0440\u043D\u0430\u0442\u0438\u0432\u043D\u044B\u0435 \u0434\u0430\u0442\u044B \u0438 \u0432\u0440\u0435\u043C\u044F. \u041F\u043E\u0436\u0430\u043B\u0443\u0438\u0306\u0441\u0442\u0430, \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438, \u0447\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0442\u0438 \u0432\u0438\u0437\u0438\u0442 \u043D\u0430 \u0443\u0434\u043E\u0431\u043D\u043E\u0435 \u0434\u043B\u044F \u0412\u0430\u0441 \u0432\u0440\u0435\u043C\u044F. \uD83D\uDE4C\uD83C\uDFFB",
    // [TEMPLATES.MESSAGE_INITIATION_TRANSFER]:
    //   "Приветствуем вас 👋🏻\nЭто служба заботы сети «Клиника Фомина»\n\nМы хотели бы уведомить вас о необходимости переноса вашего приема 😔\n\nПожалуйста, свяжитесь с нами для выбора другого времени. \nБлагодарим за ваше понимание и терпение ❤️",
    // [TEMPLATES.MESSAGE_INITIATION_OPENING_SCHEDULE]:
    //   "Приветствуем вас 👋🏻\nЭто служба заботы сети «Клиника Фомина»\n\nРады сообщить, что у нас открылось расписание для приема у специалиста 😍\nМы увидели, что вы в списке ожидания, и приглашаем записаться на прием в удобное для вас время!\n\nПожалуйста, свяжитесь с нами, чтобы выбрать подходящую дату и время. \nМы будем рады видеть вас в нашей клинике ❤️",
    // [TEMPLATES.MESSAGE_INITIATION_VACANT_SLOT]:
    //   "Приветствуем вас 👋🏻\nЭто служба заботы сети «Клиника Фомина»\n\nРады сообщить, что у нас освободился слот для приема у специалиста 😍\nМы увидели, что вы в списке ожидания, и приглашаем записаться на прием! \n\nПожалуйста, свяжитесь с нами, чтобы выбрать подходящую дату и время. \nМы будем рады видеть вас в нашей клинике ❤️",
    // [TEMPLATES.MESSAGE_INITIATION_PREPARATION_PROCEDURES]:
    //   "Приветствуем вас 👋🏻\nЭто служба заботы сети «Клиника Фомина». \n\nМы рады помочь вам и расскажем, как правильно подготовиться к процедуре.\n\nПознакомиться с подготовкой вы можете здесь: {{link}}\n\nЕсли возникнут вопросы, всегда рады помочь ❤️",
    [$74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_DYNAMIC_TEXT_1]: "\u041F\u0440\u0438\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u043C \u0432\u0430\u0441 \uD83D\uDC4B\uD83C\uDFFB\n\u042D\u0442\u043E \u0441\u043B\u0443\u0436\u0431\u0430 \u0437\u0430\u0431\u043E\u0442\u044B \u0441\u0435\u0442\u0438 \xab\u041A\u043B\u0438\u043D\u0438\u043A\u0430 \u0424\u043E\u043C\u0438\u043D\u0430\xbb\n\n{{message_one}}",
    [$74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_DYNAMIC_TEXT_2]: "\u041F\u0440\u0438\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u043C \u0432\u0430\u0441 \uD83D\uDC4B\uD83C\uDFFB\n\u042D\u0442\u043E \u0441\u043B\u0443\u0436\u0431\u0430 \u0437\u0430\u0431\u043E\u0442\u044B \u0441\u0435\u0442\u0438 \xab\u041A\u043B\u0438\u043D\u0438\u043A\u0430 \u0424\u043E\u043C\u0438\u043D\u0430\xbb\n\n{{message_one}}\n\n{{message_two}}",
    [$74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_DYNAMIC_TEXT_3]: "\u041F\u0440\u0438\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u043C \u0432\u0430\u0441 \uD83D\uDC4B\uD83C\uDFFB\n\u042D\u0442\u043E \u0441\u043B\u0443\u0436\u0431\u0430 \u0437\u0430\u0431\u043E\u0442\u044B \u0441\u0435\u0442\u0438 \xab\u041A\u043B\u0438\u043D\u0438\u043A\u0430 \u0424\u043E\u043C\u0438\u043D\u0430\xbb\n\n{{message_one}}\n\n{{message_two}}\n\n{{message_three}}",
    [$74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_DYNAMIC_TEXT_4]: "\u041F\u0440\u0438\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u043C \u0432\u0430\u0441 \uD83D\uDC4B\uD83C\uDFFB\n\u042D\u0442\u043E \u0441\u043B\u0443\u0436\u0431\u0430 \u0437\u0430\u0431\u043E\u0442\u044B \u0441\u0435\u0442\u0438 \xab\u041A\u043B\u0438\u043D\u0438\u043A\u0430 \u0424\u043E\u043C\u0438\u043D\u0430\xbb\n\n{{message_one}}\n\n{{message_two}}\n\n{{message_three}}\n\n{{message_four}}",
    [$74634324c6589b5c$export$b8020e85ad90bfe5.T_FEEDBACK_NEW]: "{{last_name}} {{first_name}}, \u0437\u0434\u0440\u0430\u0432\u0441\u0442\u0432\u0443\u0439\u0442\u0435 \uD83D\uDE4C\uD83C\uDFFB\n\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0432\u0430\u0441 \u0437\u0430 \u0442\u043E, \u0447\u0442\u043E \u0432\u044B\u0431\u0440\u0430\u043B\u0438 \u043D\u0430\u0448\u0443 \u043A\u043B\u0438\u043D\u0438\u043A\u0443!\n\u0427\u0442\u043E\u0431\u044B \u0441\u0442\u0430\u0442\u044C \u0435\u0449\u0435 \u043B\u0443\u0447\u0448\u0435 \u0434\u043B\u044F \u043D\u0430\u0448\u0438\u0445 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u043E\u0432, \u043C\u044B \u0445\u043E\u0442\u0438\u043C \u0443\u0437\u043D\u0430\u0442\u044C \u0432\u0430\u0448\u0435 \u043C\u043D\u0435\u043D\u0438\u0435 \u043E \u043D\u0430\u0448\u0435\u043C \u0441\u0435\u0440\u0432\u0438\u0441\u0435 \u0438 \u0443\u0441\u043B\u0443\u0433\u0430\u0445 \u2764\uFE0F\n\u0411\u0443\u0434\u0435\u043C \u0431\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u043D\u044B, \u0435\u0441\u043B\u0438 \u0432\u044B \u043E\u0441\u0442\u0430\u0432\u0438\u0442\u0435 \u043E\u0442\u0437\u044B\u0432: {{link}}\n\n\u0412 \u0431\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u0432\u0430\u0448\u0435 \u043C\u043D\u0435\u043D\u0438\u0435 \u043C\u044B \u043F\u043E\u043F\u043E\u043B\u043D\u0438\u043C \u0432\u0430\u0448\u0443 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0443 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0431\u043E\u043D\u0443\u0441\u043D\u044B\u043C\u0438 \u0431\u0430\u043B\u043B\u0430\u043C\u0438 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 500 \u0440\u0443\u0431\u043B\u0435\u0439 \uD83D\uDE0D"
};
const $74634324c6589b5c$export$b5c052ec829e2470 = {
    [$74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_TRANSFER]: {
        message_one: "\u041C\u044B \u0445\u043E\u0442\u0435\u043B\u0438 \u0431\u044B \u0443\u0432\u0435\u0434\u043E\u043C\u0438\u0442\u044C \u0432\u0430\u0441 \u043E \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438 \u043F\u0435\u0440\u0435\u043D\u043E\u0441\u0430 \u0432\u0430\u0448\u0435\u0433\u043E \u043F\u0440\u0438\u0435\u043C\u0430 \uD83D\uDE14",
        message_two: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438 \u0434\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430 \u0434\u0440\u0443\u0433\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438.",
        message_three: "\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u0432\u0430\u0448\u0435 \u043F\u043E\u043D\u0438\u043C\u0430\u043D\u0438\u0435 \u0438 \u0442\u0435\u0440\u043F\u0435\u043D\u0438\u0435 \u2764\uFE0F",
        message_four: ""
    },
    [$74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_OPENING_SCHEDULE]: {
        message_one: "\u0420\u0430\u0434\u044B \u0441\u043E\u043E\u0431\u0449\u0438\u0442\u044C, \u0447\u0442\u043E \u0443 \u043D\u0430\u0441 \u043E\u0442\u043A\u0440\u044B\u043B\u043E\u0441\u044C \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0434\u043B\u044F \u043F\u0440\u0438\u0435\u043C\u0430 \u0443 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u0430 \uD83D\uDE0D",
        message_two: "\u041C\u044B \u0443\u0432\u0438\u0434\u0435\u043B\u0438, \u0447\u0442\u043E \u0432\u044B \u0432 \u0441\u043F\u0438\u0441\u043A\u0435 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F, \u0438 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0430\u0435\u043C \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F \u043D\u0430 \u043F\u0440\u0438\u0435\u043C \u0432 \u0443\u0434\u043E\u0431\u043D\u043E\u0435 \u0434\u043B\u044F \u0432\u0430\u0441 \u0432\u0440\u0435\u043C\u044F!",
        message_three: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438, \u0447\u0442\u043E\u0431\u044B \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043F\u043E\u0434\u0445\u043E\u0434\u044F\u0449\u0443\u044E \u0434\u0430\u0442\u0443 \u0438 \u0432\u0440\u0435\u043C\u044F.",
        message_four: "\u041C\u044B \u0431\u0443\u0434\u0435\u043C \u0440\u0430\u0434\u044B \u0432\u0438\u0434\u0435\u0442\u044C \u0432\u0430\u0441 \u0432 \u043D\u0430\u0448\u0435\u0439 \u043A\u043B\u0438\u043D\u0438\u043A\u0435 \u2764\uFE0F"
    },
    [$74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_VACANT_SLOT]: {
        message_one: "\u0420\u0430\u0434\u044B \u0441\u043E\u043E\u0431\u0449\u0438\u0442\u044C, \u0447\u0442\u043E \u0443 \u043D\u0430\u0441 \u043E\u0441\u0432\u043E\u0431\u043E\u0434\u0438\u043B\u0441\u044F \u0441\u043B\u043E\u0442 \u0434\u043B\u044F \u043F\u0440\u0438\u0435\u043C\u0430 \u0443 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u0430 \uD83D\uDE0D",
        message_two: "\u041C\u044B \u0443\u0432\u0438\u0434\u0435\u043B\u0438, \u0447\u0442\u043E \u0432\u044B \u0432 \u0441\u043F\u0438\u0441\u043A\u0435 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F, \u0438 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0430\u0435\u043C \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F \u043D\u0430 \u043F\u0440\u0438\u0435\u043C!",
        message_three: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438, \u0447\u0442\u043E\u0431\u044B \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043F\u043E\u0434\u0445\u043E\u0434\u044F\u0449\u0443\u044E \u0434\u0430\u0442\u0443 \u0438 \u0432\u0440\u0435\u043C\u044F.",
        message_four: "\u041C\u044B \u0431\u0443\u0434\u0435\u043C \u0440\u0430\u0434\u044B \u0432\u0438\u0434\u0435\u0442\u044C \u0432\u0430\u0441 \u0432 \u043D\u0430\u0448\u0435\u0439 \u043A\u043B\u0438\u043D\u0438\u043A\u0435 \u2764\uFE0F"
    },
    [$74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_PREPARATION_PROCEDURES]: {
        message_one: "\u041C\u044B \u0440\u0430\u0434\u044B \u043F\u043E\u043C\u043E\u0447\u044C \u0432\u0430\u043C \u0438 \u0440\u0430\u0441\u0441\u043A\u0430\u0436\u0435\u043C, \u043A\u0430\u043A \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u0438\u0442\u044C\u0441\u044F \u043A \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0435.",
        message_two: "\u041F\u043E\u0437\u043D\u0430\u043A\u043E\u043C\u0438\u0442\u044C\u0441\u044F \u0441 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u043E\u0439 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0437\u0434\u0435\u0441\u044C:",
        message_three: "{{link}}",
        message_four: "\u0415\u0441\u043B\u0438 \u0432\u043E\u0437\u043D\u0438\u043A\u043D\u0443\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u044B, \u0432\u0441\u0435\u0433\u0434\u0430 \u0440\u0430\u0434\u044B \u043F\u043E\u043C\u043E\u0447\u044C \u2764\uFE0F"
    }
};
const $74634324c6589b5c$export$73c3bad50c343978 = (template)=>{
    let templateText = $74634324c6589b5c$export$401f5172686c6b06[$74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_DYNAMIC_TEXT_4];
    const templateContent = $74634324c6589b5c$export$b5c052ec829e2470[template];
    for(let key in templateContent)templateText = templateText.replaceAll(`{{${key}}}`, templateContent[key]);
    return templateText;
};
const $74634324c6589b5c$export$d74591583ac34731 = {
    MEDICAL_FILE: "medical_file",
    PATIENT_GROUPS: "patient_groups",
    PAYMENT: "payment",
    APPOINTMENT_WEB: "appointment_web",
    APPOINTMENT_DJANGO: "appointment_django",
    SCHEDULE: "SCHEDULE"
};
const $74634324c6589b5c$export$7a948dda2e5abcb7 = {
    [$74634324c6589b5c$export$d74591583ac34731.MEDICAL_FILE]: (params)=>`${$74634324c6589b5c$var$URL}/django/appointments/medicalfile/${params.id}/change/`,
    [$74634324c6589b5c$export$d74591583ac34731.PATIENT_GROUPS]: (params)=>`${$74634324c6589b5c$var$URL}/django/appointments/patientgroup/${params.id}/change/`,
    [$74634324c6589b5c$export$d74591583ac34731.PAYMENT]: (params)=>`${$74634324c6589b5c$var$URL}/django/payment/payment/${params.id}/change/`,
    [$74634324c6589b5c$export$d74591583ac34731.APPOINTMENT_WEB]: (params)=>`${$74634324c6589b5c$var$URL}/appointment/${params.id}`,
    [$74634324c6589b5c$export$d74591583ac34731.APPOINTMENT_DJANGO]: (params)=>`${$74634324c6589b5c$var$URL}/django/appointments/appointment/${params.id}/change/`,
    [$74634324c6589b5c$export$d74591583ac34731.SCHEDULE]: (params)=>`${$74634324c6589b5c$var$URL}/django/appointments/scheduleinsert/${params.id}/change/`
};
const $74634324c6589b5c$export$53cfc33312455915 = {
    columnOrder: [
        "mrt-row-actions",
        "fullNamePatient",
        "fullNameDoctor",
        "schedule__doctor_organization__organization__name",
        "service__name",
        "service_amount",
        "payment_status"
    ],
    additionalColumns: [
        {
            accessorKey: "schedule__doctor_organization__organization__name",
            additionalFields: [
                "schedule",
                "schedule__date",
                "schedule__time"
            ],
            header: "\u042F\u0447\u0435\u0439\u043A\u0430 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F",
            size: 550,
            accessorFn: (originalRow)=>originalRow.schedule__doctor_organization__organization__name,
            filterFn: "icontains",
            Cell: ({ row: row })=>{
                if (!row.original.schedule) return "";
                const organization = row.original.schedule__doctor_organization__organization__name || "";
                const date = row.original.schedule__date ? (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(row.original.schedule__date).format((0, $jo8NH.READABLE_DATE_FORMAT)) : "";
                const time = row.original.schedule__time ? (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(row.original.schedule__time, (0, $jo8NH.SERVER_TIME_FORMAT)).format((0, $jo8NH.READABLE_TIME_FORMAT_MOMENT)) : "";
                return `${organization} ${date ? `- ${date}` : ""} ${time ? `, ${time}` : ""}`;
            }
        }
    ],
    columnHidden: [
        "format",
        "schedule__date",
        "payment_provider__name",
        "payment_id",
        "created_at",
        "comment"
    ],
    renderRowActions: ({ row: row })=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $c44wE.CustomMUITooltip), {
            title: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 Django",
            placement: "right",
            enablePressDuration: true,
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gDp1O.default), {
                underline: "none",
                href: $74634324c6589b5c$export$7a948dda2e5abcb7[$74634324c6589b5c$export$d74591583ac34731.PAYMENT]({
                    id: row.original.id
                }),
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $am7GZ.default), {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jiymJ))), {})
                })
            })
        });
    }
};
class $74634324c6589b5c$var$VoxInformationPatientStore {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isInitialized", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "phone_number", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "dynamicTextOneRow", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "dynamicTextTwoRow", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "dynamicTextThreeRow", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "dynamicTextFourRow", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "linkToInstructions", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "feedbackData", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "countCommunication", 5);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "countShowedScheduleItems", 3);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "is_vox", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "activeCity", null);
        this.resetState();
        (0, $iIg7Z.default).bind(this, $74634324c6589b5c$var$VoxInformationPatientStore);
        (0, $9Qp9d.makeAutoObservable)(this);
    }
    resetState() {
        this.medicalFiles = [];
        this.communications = [];
        this.scheduleFuture = [];
        this.schedulePast = [];
        /** Вкладка "Приемы" */ this.patients = [];
        this.countCommunication = 5;
        this.countShowedScheduleItems = 3;
        this.activeCity = null;
        this.appointmentsTableData = [];
        this.appointmentsTableDataInitialized = false;
    }
    setIsVox(value) {
        this.is_vox = value;
    }
    setPhoneNumber(value) {
        this.isInitialized = false;
        this.phone_number = value;
        this.resetState();
    }
    setDynamicTextOneRow(value) {
        this.dynamicTextOneRow = value;
    }
    setDynamicTextTwoRow(value) {
        this.dynamicTextTwoRow = value;
    }
    setDynamicTextThreeRow(value) {
        this.dynamicTextThreeRow = value;
    }
    setDynamicTextFourRow(value) {
        this.dynamicTextFourRow = value;
    }
    setCountCommunication(value) {
        this.countCommunication = value;
    }
    setCountShowedScheduleItems(value) {
        this.countShowedScheduleItems = value;
    }
    setLinkToInstructions(value) {
        this.linkToInstructions = value;
    }
    setFeedbackData(key, value) {
        this.feedbackData[key] = value;
    }
    setActiveCity(value) {
        this.activeCity = value;
        this.sendActiveCity();
    }
    async fetchCommunications() {
        try {
            const response = await (0, $kmHuZ.default).integrations.getCommunication(this.phone_number);
            this.communications = response.map((item)=>{
                item.templateWithVariables = item.communication_mailing.template || "";
                Object.keys(item.message_data).forEach((key)=>{
                    if (item.templateWithVariables.includes(`{{${key}}}`)) item.templateWithVariables = item.templateWithVariables.replaceAll(`{{${key}}}`, item.message_data[key]);
                });
                return item;
            });
        } catch (e) {
            console.log(e);
        }
    }
    async fetchSchedule() {
        try {
            const currentTime = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))().format((0, $jo8NH.SERVER_TIME_FORMAT));
            const currentDate = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))().format((0, $jo8NH.SERVER_DATE_FORMAT));
            const response = await (0, $kmHuZ.default).schedule.scheduleListWithValues({
                filter_params: {
                    patient_phone_number__icontains: this.phone_number
                },
                values_params: [
                    "id",
                    "datetime",
                    "date",
                    "time",
                    "doctor_organization__organization__name",
                    "doctor_organization__doctor__last_name",
                    "doctor_organization__doctor__first_name",
                    "doctor_organization__doctor__middle_name",
                    "online_link_for_patient",
                    "type",
                    "doctor_organization__doctor__specialities__name"
                ],
                annotate_mtm_params: {
                    "doctor_organization__doctor__specialities": "doctor_organization__doctor__specialities__name"
                },
                meta: {
                    per_page: 1000000
                }
            });
            const transformData = $74634324c6589b5c$var$transformScheduleData(response.data);
            this.scheduleFuture = transformData.filter((item)=>item.date === currentDate && item.time > currentTime || item.date > currentDate || item.date >= currentDate && !item.time);
            this.schedulePast = transformData.filter((item)=>item.date === currentDate && item.time < currentTime || item.date < currentDate || item.date < currentDate && !item.time).sort((a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(b.date) - (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(a.date));
        } catch (e) {
            console.log(e);
        }
    }
    async fetchMedicalFiles() {
        try {
            const response = await (0, $kmHuZ.default).integrations.getMedicalFiles(this.phone_number);
            if (!response.length) return;
            this.medicalFiles = response.map((item)=>{
                return {
                    number: item.number,
                    id: item.id,
                    patient: item.patient,
                    organization: item.organization,
                    badge: item.badge,
                    policies: item.patient.policies
                };
            });
            this.patients = (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).uniqBy(this.medicalFiles.map((medicalFile)=>({
                    fullNamePatient: `${medicalFile.patient.last_name} ${medicalFile.patient.first_name} ${medicalFile.patient.middle_name}`,
                    id: medicalFile.patient.id
                })), "id");
        } catch (e) {
            console.log(e);
        }
    }
    async initialize() {
        if (!this.phone_number) {
            console.log("\u041D\u0435\u0442\u0443 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430 phone_number");
            return;
        }
        await this.fetchCommunications();
        await this.fetchActiveCity();
        await this.fetchMedicalFiles();
        await this.fetchSchedule();
        this.isInitialized = true;
    }
    async sendMessageInitiationCancel() {
        const response = await (0, $kmHuZ.default).communication.sendDynamicMessage({
            phone_number: this.phone_number,
            template: $74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_CANCEL
        });
        $74634324c6589b5c$var$checkRequestForSuccess(response);
    }
    async sendMessageInitiationTransfer() {
        const response = await (0, $kmHuZ.default).communication.sendDynamicMessage({
            messageData: $74634324c6589b5c$export$b5c052ec829e2470[$74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_TRANSFER],
            phone_number: this.phone_number,
            template: $74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_DYNAMIC_TEXT_4
        });
        $74634324c6589b5c$var$checkRequestForSuccess(response);
    }
    async sendMessageInitiationOpeningSchedule() {
        const response = await (0, $kmHuZ.default).communication.sendDynamicMessage({
            messageData: $74634324c6589b5c$export$b5c052ec829e2470[$74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_OPENING_SCHEDULE],
            phone_number: this.phone_number,
            template: $74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_DYNAMIC_TEXT_4
        });
        $74634324c6589b5c$var$checkRequestForSuccess(response);
    }
    async sendMessageInitiationVacantSlot() {
        const response = await (0, $kmHuZ.default).communication.sendDynamicMessage({
            messageData: $74634324c6589b5c$export$b5c052ec829e2470[$74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_VACANT_SLOT],
            phone_number: this.phone_number,
            template: $74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_DYNAMIC_TEXT_4
        });
        $74634324c6589b5c$var$checkRequestForSuccess(response);
    }
    async sendMessageInitiationPreparationProcedures() {
        const response = await (0, $kmHuZ.default).communication.sendDynamicMessage({
            messageData: {
                ...$74634324c6589b5c$export$b5c052ec829e2470[$74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_PREPARATION_PROCEDURES],
                message_three: this.linkToInstructions
            },
            phone_number: this.phone_number,
            template: $74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_DYNAMIC_TEXT_4
        });
        $74634324c6589b5c$var$checkRequestForSuccess(response, ()=>this.linkToInstructions = "");
    }
    getDynamicMessageTemplateByFilledRowsCount() {
        if (this.dynamicTextFourRow.length) return $74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_DYNAMIC_TEXT_4;
        if (this.dynamicTextThreeRow.length) return $74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_DYNAMIC_TEXT_3;
        if (this.dynamicTextTwoRow.length) return $74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_DYNAMIC_TEXT_2;
        if (this.dynamicTextOneRow.length) return $74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_DYNAMIC_TEXT_1;
        return $74634324c6589b5c$export$b8020e85ad90bfe5.MESSAGE_INITIATION_DYNAMIC_TEXT_1;
    }
    getDynamicMessageDataByFilledRowsCount() {
        const messageData = {};
        if (this.dynamicTextOneRow.length) messageData.message_one = this.dynamicTextOneRow;
        if (this.dynamicTextTwoRow.length) messageData.message_two = this.dynamicTextTwoRow;
        if (this.dynamicTextThreeRow.length) messageData.message_three = this.dynamicTextThreeRow;
        if (this.dynamicTextFourRow.length) messageData.message_four = this.dynamicTextFourRow;
        return messageData;
    }
    async sendDynamicMessagePatient() {
        const messageData = this.getDynamicMessageDataByFilledRowsCount();
        const template = this.getDynamicMessageTemplateByFilledRowsCount();
        const response = await (0, $kmHuZ.default).communication.sendDynamicMessage({
            messageData: messageData,
            template: template,
            phone_number: this.phone_number
        });
        $74634324c6589b5c$var$checkRequestForSuccess(response, ()=>{
            this.dynamicTextOneRow = "";
            this.dynamicTextTwoRow = "";
            this.dynamicTextThreeRow = "";
            this.dynamicTextFourRow = "";
        });
    }
    async sendFeedbackNew() {
        var _this$feedbackData, _this$feedbackData2, _this$feedbackData3;
        const response = await (0, $kmHuZ.default).communication.sendDynamicMessage({
            messageData: {
                last_name: ((_this$feedbackData = this.feedbackData) === null || _this$feedbackData === void 0 ? void 0 : _this$feedbackData.last_name) || "",
                first_name: ((_this$feedbackData2 = this.feedbackData) === null || _this$feedbackData2 === void 0 ? void 0 : _this$feedbackData2.first_name) || "",
                link: ((_this$feedbackData3 = this.feedbackData) === null || _this$feedbackData3 === void 0 ? void 0 : _this$feedbackData3.link) || ""
            },
            phone_number: this.phone_number,
            template: $74634324c6589b5c$export$b8020e85ad90bfe5.T_FEEDBACK_NEW
        });
        $74634324c6589b5c$var$checkRequestForSuccess(response, ()=>this.feedbackData = {});
    }
    async getAppointmentsByPatient() {
        const response = await (0, $kmHuZ.default).appointments.getAppointmentsByPatientId(this.patients[0].id, false);
        const appointments = response.map((item)=>{
            var _item$data, _item$data$layout, _item$data2, _item$data3;
            return {
                appointmentId: item.data.id,
                fullNamePatient: this.patients[0].fullNamePatient,
                fullNameDoctor: `${item.data.doctor.last_name} ${item.data.doctor.first_name} ${item.data.doctor.middle_name}`,
                inProgress: item.data.date_finished,
                layout: (_item$data = item.data) === null || _item$data === void 0 ? void 0 : (_item$data$layout = _item$data.layout) === null || _item$data$layout === void 0 ? void 0 : _item$data$layout.name,
                isCancelled: item.data.is_cancelled,
                date: ((_item$data2 = item.data) === null || _item$data2 === void 0 ? void 0 : _item$data2.date) || "",
                time: (_item$data3 = item.data) !== null && _item$data3 !== void 0 && _item$data3.time ? (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(item.data.time, (0, $jo8NH.SERVER_TIME_FORMAT)).format((0, $jo8NH.READABLE_TIME_FORMAT_MOMENT)) : ""
            };
        });
        this.appointmentsTableData = [
            ...this.appointmentsTableData,
            ...appointments
        ];
        this.appointmentsTableDataInitialized = true;
    }
    async fetchActiveCity() {
        try {
            if (!this.phone_number) return;
            const response = await (0, $kmHuZ.default).integrations.getActiveCity(this.phone_number);
            this.activeCity = response;
        } catch (e) {
            console.error(e);
        }
    }
    async sendActiveCity() {
        try {
            if (!this.phone_number) return;
            await (0, $kmHuZ.default).integrations.setActiveCity(this.phone_number, {
                city_id: this.activeCity ? this.activeCity.id : null
            });
        } catch (e) {
            console.error(e);
        }
    }
}
var $74634324c6589b5c$export$2e2bcd8739ae039 = new $74634324c6589b5c$var$VoxInformationPatientStore();

});
parcelRegister("jo8NH", function(module, exports) {

$parcel$export(module.exports, "READABLE_DATE_FORMAT", function () { return $e1d715d644ad6f98$export$9e83fe5a6fb35fcd; });
$parcel$export(module.exports, "SERVER_DATE_FORMAT", function () { return $e1d715d644ad6f98$export$7198e3f8e2e93dd1; });
$parcel$export(module.exports, "READABLE_DATE_TIME_FORMAT", function () { return $e1d715d644ad6f98$export$544e5dd568ad19d4; });
$parcel$export(module.exports, "SERVER_DATE_TIME_FORMAT", function () { return $e1d715d644ad6f98$export$e7474cb74a0751d0; });
$parcel$export(module.exports, "SERVER_TIME_FORMAT", function () { return $e1d715d644ad6f98$export$74a5c936fa781587; });
$parcel$export(module.exports, "READABLE_TIME_FORMAT_MOMENT", function () { return $e1d715d644ad6f98$export$cbb8884d54ae49b6; });
$parcel$export(module.exports, "formatDateToReadableDateFormat", function () { return $e1d715d644ad6f98$export$2e87fcba13a4b280; });
$parcel$export(module.exports, "formatDatetimeToDatetimeFormat", function () { return $e1d715d644ad6f98$export$b4c7a989d8ad3d64; });
$parcel$export(module.exports, "parseDateFromReadableFormat", function () { return $e1d715d644ad6f98$export$2a2aedc44b6ae506; });

var $cxTnx = parcelRequire("cxTnx");
const $e1d715d644ad6f98$export$9e83fe5a6fb35fcd = "DD.MM.YYYY";
const $e1d715d644ad6f98$export$7198e3f8e2e93dd1 = "YYYY-MM-DD";
const $e1d715d644ad6f98$export$544e5dd568ad19d4 = "DD.MM.YYYY HH:mm:ss";
const $e1d715d644ad6f98$export$e7474cb74a0751d0 = "YYYY-MM-DD HH:mm:ss";
const $e1d715d644ad6f98$export$74a5c936fa781587 = "hh:mm:ss";
const $e1d715d644ad6f98$export$cbb8884d54ae49b6 = "HH:mm";
const $e1d715d644ad6f98$export$988fb76af9692722 = "hh:mm";
const $e1d715d644ad6f98$export$2e87fcba13a4b280 = (date)=>(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(date).format($e1d715d644ad6f98$export$9e83fe5a6fb35fcd);
const $e1d715d644ad6f98$export$99b79ab48ffd8b3d = (date)=>(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(date).format($e1d715d644ad6f98$export$988fb76af9692722);
const $e1d715d644ad6f98$export$b4c7a989d8ad3d64 = (date, time)=>(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(`${date} ${time}`, `${$e1d715d644ad6f98$export$9e83fe5a6fb35fcd} ${$e1d715d644ad6f98$export$988fb76af9692722}`);
const $e1d715d644ad6f98$export$2a2aedc44b6ae506 = (date)=>(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(date, $e1d715d644ad6f98$export$9e83fe5a6fb35fcd);

});

parcelRegister("am7GZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78a1ecfdeb9afc7a$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $cs0Pg = parcelRequire("cs0Pg");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $aEoM0 = parcelRequire("aEoM0");

var $fGH8N = parcelRequire("fGH8N");

var $6gjHo = parcelRequire("6gjHo");

var $ih19M = parcelRequire("ih19M");
"use client";
const $78a1ecfdeb9afc7a$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $78a1ecfdeb9afc7a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $fGH8N.default)(color)}`,
            edge && `edge${(0, $fGH8N.default)(edge)}`,
            `size${(0, $fGH8N.default)(size)}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $6gjHo.getIconButtonUtilityClass), classes);
};
const $78a1ecfdeb9afc7a$var$IconButtonRoot = (0, $g4l1t.default)((0, $aEoM0.default), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $fGH8N.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $fGH8N.default)(ownerState.edge)}`],
            styles[`size${(0, $fGH8N.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cs0Pg.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $4WYaH.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $4WYaH.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $4WYaH.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cs0Pg.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $6gjHo.default).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $78a1ecfdeb9afc7a$var$IconButton = /*#__PURE__*/ $bh6RR.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $hCIyK.default)(props, $78a1ecfdeb9afc7a$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $78a1ecfdeb9afc7a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($78a1ecfdeb9afc7a$var$IconButtonRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $78a1ecfdeb9afc7a$export$2e2bcd8739ae039 = $78a1ecfdeb9afc7a$var$IconButton;

});
parcelRegister("aPsoC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $fa1a2e608fb826ea$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $fa1a2e608fb826ea$export$2e2bcd8739ae039; });
function $fa1a2e608fb826ea$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $fa1a2e608fb826ea$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $fa1a2e608fb826ea$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $fa1a2e608fb826ea$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fa1a2e608fb826ea$export$2e2bcd8739ae039 = $fa1a2e608fb826ea$export$4f5d2d50c9deca37;

});

parcelRegister("96ZcP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a2426d16525cd13$export$2e2bcd8739ae039; });
function $6a2426d16525cd13$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("cs0Pg", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $9108bd93ab52b209$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $9108bd93ab52b209$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $9108bd93ab52b209$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $9108bd93ab52b209$export$c0816ed86df316af; });
$parcel$export(module.exports, "emphasize", function () { return $9108bd93ab52b209$export$e665714f76e581fd; });

var $avV9A = parcelRequire("avV9A");

var $8fhtc = parcelRequire("8fhtc");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $9108bd93ab52b209$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $8fhtc.default)(value, min, max);
}
function $9108bd93ab52b209$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $9108bd93ab52b209$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $9108bd93ab52b209$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $9108bd93ab52b209$export$677b39864803984e($9108bd93ab52b209$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $avV9A.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $avV9A.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $9108bd93ab52b209$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $9108bd93ab52b209$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $9108bd93ab52b209$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $9108bd93ab52b209$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $9108bd93ab52b209$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $9108bd93ab52b209$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $9108bd93ab52b209$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$9108bd93ab52b209$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $9108bd93ab52b209$export$29fb7152bd3f781a(color) {
    color = $9108bd93ab52b209$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $9108bd93ab52b209$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $9108bd93ab52b209$export$c852d90bf7403b62(color) {
    color = $9108bd93ab52b209$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $9108bd93ab52b209$export$677b39864803984e($9108bd93ab52b209$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $9108bd93ab52b209$export$d061e26956a60b0a(foreground, background) {
    const lumA = $9108bd93ab52b209$export$c852d90bf7403b62(foreground);
    const lumB = $9108bd93ab52b209$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $9108bd93ab52b209$export$58f0f39f63f3cf42(color, value) {
    color = $9108bd93ab52b209$export$677b39864803984e(color);
    value = $9108bd93ab52b209$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $9108bd93ab52b209$export$211a73f2b8c10ce4(color);
}
function $9108bd93ab52b209$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $9108bd93ab52b209$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $9108bd93ab52b209$export$4b073707ff63303(color, coefficient) {
    color = $9108bd93ab52b209$export$677b39864803984e(color);
    coefficient = $9108bd93ab52b209$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $9108bd93ab52b209$export$211a73f2b8c10ce4(color);
}
function $9108bd93ab52b209$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $9108bd93ab52b209$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $9108bd93ab52b209$export$c0816ed86df316af(color, coefficient) {
    color = $9108bd93ab52b209$export$677b39864803984e(color);
    coefficient = $9108bd93ab52b209$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $9108bd93ab52b209$export$211a73f2b8c10ce4(color);
}
function $9108bd93ab52b209$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $9108bd93ab52b209$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $9108bd93ab52b209$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $9108bd93ab52b209$export$c852d90bf7403b62(color) > 0.5 ? $9108bd93ab52b209$export$4b073707ff63303(color, coefficient) : $9108bd93ab52b209$export$c0816ed86df316af(color, coefficient);
}
function $9108bd93ab52b209$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $9108bd93ab52b209$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}

});
parcelRegister("avV9A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a79222bf14c8db7$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui-internal/babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $7a79222bf14c8db7$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});

parcelRegister("8fhtc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $600d469f4ea2b960$export$2e2bcd8739ae039; });
function $600d469f4ea2b960$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $600d469f4ea2b960$export$2e2bcd8739ae039 = $600d469f4ea2b960$var$clamp;

});


parcelRegister("g4l1t", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $bb2d53ba8ea7fa4b$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "slotShouldForwardProp", function () { return $bb2d53ba8ea7fa4b$export$f10c5a10d27438e5; });
$parcel$export(module.exports, "default", function () { return $bb2d53ba8ea7fa4b$export$2e2bcd8739ae039; });

var $9TBjJ = parcelRequire("9TBjJ");

var $OFmxN = parcelRequire("OFmxN");

var $wllwT = parcelRequire("wllwT");
"use client";
const $bb2d53ba8ea7fa4b$export$effb20ecdbf4d6aa = (prop)=>(0, $9TBjJ.shouldForwardProp)(prop) && prop !== "classes";
const $bb2d53ba8ea7fa4b$export$f10c5a10d27438e5 = (0, $9TBjJ.shouldForwardProp);
const $bb2d53ba8ea7fa4b$var$styled = (0, $9TBjJ.default)({
    themeId: (0, $wllwT.default),
    defaultTheme: $OFmxN.default,
    rootShouldForwardProp: $bb2d53ba8ea7fa4b$export$effb20ecdbf4d6aa
});
var $bb2d53ba8ea7fa4b$export$2e2bcd8739ae039 = $bb2d53ba8ea7fa4b$var$styled;

});
parcelRegister("9TBjJ", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $73463290c3338ebd$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $73463290c3338ebd$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $67aN3 = parcelRequire("67aN3");

var $5syur = parcelRequire("5syur");

var $eWibl = parcelRequire("eWibl");

var $jGOpJ = parcelRequire("jGOpJ");

var $cWrkM = parcelRequire("cWrkM");
const $73463290c3338ebd$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $73463290c3338ebd$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $73463290c3338ebd$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $73463290c3338ebd$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $73463290c3338ebd$var$transformVariants = (variants)=>{
    let numOfCallbacks = 0;
    const variantsStyles = {};
    if (variants) variants.forEach((definition)=>{
        let key = "";
        if (typeof definition.props === "function") {
            key = `callback${numOfCallbacks}`;
            numOfCallbacks += 1;
        } else key = (0, $jGOpJ.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $73463290c3338ebd$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    return $73463290c3338ebd$var$transformVariants(variants);
};
const $73463290c3338ebd$var$variantsResolver = (props, styles, variants)=>{
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    let numOfCallbacks = 0;
    if (variants) variants.forEach((variant)=>{
        let isMatch = true;
        if (typeof variant.props === "function") {
            const propsToCheck = (0, $4WYaH.default)({}, props, ownerState);
            isMatch = variant.props(propsToCheck);
        } else Object.keys(variant.props).forEach((key)=>{
            if (ownerState[key] !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
        });
        if (isMatch) {
            if (typeof variant.props === "function") variantsStyles.push(styles[`callback${numOfCallbacks}`]);
            else variantsStyles.push(styles[(0, $jGOpJ.default)(variant.props)]);
        }
        if (typeof variant.props === "function") numOfCallbacks += 1;
    });
    return variantsStyles;
};
const $73463290c3338ebd$var$themeVariantsResolver = (props, styles, theme, name)=>{
    var _theme$components;
    const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[name]) == null ? void 0 : _theme$components.variants;
    return $73463290c3338ebd$var$variantsResolver(props, styles, themeVariants);
};
function $73463290c3338ebd$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $73463290c3338ebd$export$35e57303dbd8a66 = (0, $eWibl.default)();
const $73463290c3338ebd$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $73463290c3338ebd$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $73463290c3338ebd$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $73463290c3338ebd$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
const $73463290c3338ebd$var$muiStyledFunctionResolver = ({ styledArg: styledArg, props: props, defaultTheme: defaultTheme, themeId: themeId })=>{
    const resolvedStyles = styledArg((0, $4WYaH.default)({}, props, {
        theme: $73463290c3338ebd$var$resolveTheme((0, $4WYaH.default)({}, props, {
            defaultTheme: defaultTheme,
            themeId: themeId
        }))
    }));
    let optionalVariants;
    if (resolvedStyles && resolvedStyles.variants) {
        optionalVariants = resolvedStyles.variants;
        delete resolvedStyles.variants;
    }
    if (optionalVariants) {
        const variantsStyles = $73463290c3338ebd$var$variantsResolver(props, $73463290c3338ebd$var$transformVariants(optionalVariants), optionalVariants);
        return [
            resolvedStyles,
            ...variantsStyles
        ];
    }
    return resolvedStyles;
};
function $73463290c3338ebd$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $73463290c3338ebd$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $73463290c3338ebd$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $73463290c3338ebd$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $cWrkM.default)((0, $4WYaH.default)({}, props, {
            theme: $73463290c3338ebd$var$resolveTheme((0, $4WYaH.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $67aN3.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $73463290c3338ebd$var$defaultOverridesResolver($73463290c3338ebd$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $hCIyK.default)(inputOptions, $73463290c3338ebd$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $73463290c3338ebd$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($73463290c3338ebd$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $67aN3.default)(tag, (0, $4WYaH.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg) return (props)=>$73463290c3338ebd$var$muiStyledFunctionResolver({
                        styledArg: stylesArg,
                        props: props,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    });
                if ((0, $5syur.isPlainObject)(stylesArg)) {
                    let transformedStylesArg = stylesArg;
                    let styledArgVariants;
                    if (stylesArg && stylesArg.variants) {
                        styledArgVariants = stylesArg.variants;
                        delete transformedStylesArg.variants;
                        transformedStylesArg = (props)=>{
                            let result = stylesArg;
                            const variantStyles = $73463290c3338ebd$var$variantsResolver(props, $73463290c3338ebd$var$transformVariants(styledArgVariants), styledArgVariants);
                            variantStyles.forEach((variantStyle)=>{
                                result = (0, $5syur.default)(result, variantStyle);
                            });
                            return result;
                        };
                    }
                    return transformedStylesArg;
                }
                return stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if ((0, $5syur.isPlainObject)(styleArg)) {
                let styledArgVariants;
                if (styleArg && styleArg.variants) {
                    styledArgVariants = styleArg.variants;
                    delete transformedStyleArg.variants;
                    transformedStyleArg = (props)=>{
                        let result = styleArg;
                        const variantStyles = $73463290c3338ebd$var$variantsResolver(props, $73463290c3338ebd$var$transformVariants(styledArgVariants), styledArgVariants);
                        variantStyles.forEach((variantStyle)=>{
                            result = (0, $5syur.default)(result, variantStyle);
                        });
                        return result;
                    };
                }
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>$73463290c3338ebd$var$muiStyledFunctionResolver({
                    styledArg: styleArg,
                    props: props,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $73463290c3338ebd$var$resolveTheme((0, $4WYaH.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $73463290c3338ebd$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $4WYaH.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $73463290c3338ebd$var$resolveTheme((0, $4WYaH.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $73463290c3338ebd$var$themeVariantsResolver(props, $73463290c3338ebd$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("67aN3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $473bc43f90710255$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $473bc43f90710255$export$e00380445f2b9e0c; });
/**
 * @mui/styled-engine v5.15.7
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $8dDdL = parcelRequire("8dDdL");

var $fPZvG = parcelRequire("fPZvG");
var $62brB = parcelRequire("62brB");


var $2BnRa = parcelRequire("2BnRa");
"use client";
function $473bc43f90710255$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $8dDdL.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $473bc43f90710255$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("8dDdL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fbdf620290b3477$export$2e2bcd8739ae039; });

var $4I7Ie = parcelRequire("4I7Ie");
parcelRequire("3Tqyg");
parcelRequire("bh6RR");
parcelRequire("dDWms");

parcelRequire("9fGzh");
parcelRequire("fT0AU");
parcelRequire("lSpak");
var $5fbdf620290b3477$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $5fbdf620290b3477$export$2e2bcd8739ae039 = (0, $4I7Ie.default).bind();
$5fbdf620290b3477$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $5fbdf620290b3477$export$2e2bcd8739ae039[tagName] = $5fbdf620290b3477$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("4I7Ie", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36e14100b8801cb7$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $dDWms = parcelRequire("dDWms");
parcelRequire("fPZvG");
var $62brB = parcelRequire("62brB");

var $9fGzh = parcelRequire("9fGzh");

var $fT0AU = parcelRequire("fT0AU");

var $lSpak = parcelRequire("lSpak");
var $36e14100b8801cb7$var$testOmitPropsOnStringTag = (0, $dDWms.default);
var $36e14100b8801cb7$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $36e14100b8801cb7$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $36e14100b8801cb7$var$testOmitPropsOnStringTag : $36e14100b8801cb7$var$testOmitPropsOnComponent;
};
var $36e14100b8801cb7$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $36e14100b8801cb7$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $36e14100b8801cb7$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $9fGzh.registerStyles)(cache, serialized, isStringTag);
    (0, $lSpak.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $9fGzh.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $36e14100b8801cb7$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $36e14100b8801cb7$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $36e14100b8801cb7$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $62brB.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $bh6RR.useContext((0, $62brB.T));
            }
            if (typeof props.className === "string") className = (0, $9fGzh.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $fT0AU.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $36e14100b8801cb7$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($36e14100b8801cb7$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $bh6RR.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $4WYaH.default)({}, options, nextOptions, {
                shouldForwardProp: $36e14100b8801cb7$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("dDWms", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9eec302f6b1a1323$export$2e2bcd8739ae039; });

var $cthCm = parcelRequire("cthCm");
var $9eec302f6b1a1323$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $9eec302f6b1a1323$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $cthCm.default)(function(prop) {
    return $9eec302f6b1a1323$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("cthCm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9145dbf8e0e857b1$export$2e2bcd8739ae039; });
function $9145dbf8e0e857b1$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("fPZvG", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $b87b550e76e09f68$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $b87b550e76e09f68$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $b87b550e76e09f68$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ClassNames", function () { return $b87b550e76e09f68$export$9b9c0f9d9f3552b8; });
$parcel$export(module.exports, "jsx", function () { return $b87b550e76e09f68$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("62brB")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("62brB")).w; });

var $62brB = parcelRequire("62brB");

var $bh6RR = parcelRequire("bh6RR");

var $4ooDY = parcelRequire("4ooDY");

var $lSpak = parcelRequire("lSpak");

var $2jWfj = parcelRequire("2jWfj");
parcelRequire("lNmZA");
parcelRequire("3Tqyg");
parcelRequire("ieFqf");

parcelRequire("adG4d");
var $b87b550e76e09f68$var$pkg = {
    name: "@emotion/react",
    version: "11.11.3",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $b87b550e76e09f68$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $62brB.h).call(props, "css")) // $FlowFixMe
    return $bh6RR.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $62brB.E);
    createElementArgArray[1] = (0, $62brB.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $bh6RR.createElement.apply(null, createElementArgArray);
};
var $b87b550e76e09f68$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $b87b550e76e09f68$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $62brB.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $2jWfj.serializeStyles)([
        styles
    ], undefined, $bh6RR.useContext((0, $62brB.T)));
    if (!(0, $62brB.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $bh6RR.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $bh6RR.useRef();
    (0, $lSpak.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $lSpak.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $4ooDY.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $b87b550e76e09f68$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $2jWfj.serializeStyles)(args);
}
var $b87b550e76e09f68$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $b87b550e76e09f68$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $b87b550e76e09f68$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $b87b550e76e09f68$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $4ooDY.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $b87b550e76e09f68$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $lSpak.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $4ooDY.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $b87b550e76e09f68$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $62brB.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $2jWfj.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $4ooDY.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $b87b550e76e09f68$var$merge(cache.registered, css, $b87b550e76e09f68$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $bh6RR.useContext((0, $62brB.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($b87b550e76e09f68$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $b87b550e76e09f68$var$isBrowser, $b87b550e76e09f68$var$isTestEnv, $b87b550e76e09f68$var$globalContext, $b87b550e76e09f68$var$globalKey;

});
parcelRegister("62brB", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $464bce95c77df256$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $464bce95c77df256$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $464bce95c77df256$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $464bce95c77df256$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $464bce95c77df256$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $464bce95c77df256$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $464bce95c77df256$export$a9c23c6ac3fc3eca; });

var $bh6RR = parcelRequire("bh6RR");

var $lNmZA = parcelRequire("lNmZA");

var $4WYaH = parcelRequire("4WYaH");

var $ieFqf = parcelRequire("ieFqf");

var $8GHIh = parcelRequire("8GHIh");

var $4ooDY = parcelRequire("4ooDY");

var $2jWfj = parcelRequire("2jWfj");

var $lSpak = parcelRequire("lSpak");
var $464bce95c77df256$export$23f2a1d2818174ef = true;
var $464bce95c77df256$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $464bce95c77df256$var$EmotionCacheContext = /* #__PURE__ */ $bh6RR.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $lNmZA.default)({
    key: "css"
}) : null);
var $464bce95c77df256$export$e7094788287c5e9b = $464bce95c77df256$var$EmotionCacheContext.Provider;
var $464bce95c77df256$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $bh6RR.useContext)($464bce95c77df256$var$EmotionCacheContext);
};
var $464bce95c77df256$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $bh6RR.useContext)($464bce95c77df256$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$464bce95c77df256$export$23f2a1d2818174ef) $464bce95c77df256$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $bh6RR.useContext)($464bce95c77df256$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $lNmZA.default)({
                key: "css"
            });
            return /*#__PURE__*/ $bh6RR.createElement($464bce95c77df256$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $464bce95c77df256$export$971d5caa766a69d7 = /* #__PURE__ */ $bh6RR.createContext({});
var $464bce95c77df256$export$3b14a55fb2447963 = function useTheme() {
    return $bh6RR.useContext($464bce95c77df256$export$971d5caa766a69d7);
};
var $464bce95c77df256$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $4WYaH.default)({}, outerTheme, theme);
};
var $464bce95c77df256$var$createCacheWithTheme = /* #__PURE__ */ (0, $ieFqf.default)(function(outerTheme) {
    return (0, $ieFqf.default)(function(theme) {
        return $464bce95c77df256$var$getTheme(outerTheme, theme);
    });
});
var $464bce95c77df256$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $bh6RR.useContext($464bce95c77df256$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $464bce95c77df256$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $bh6RR.createElement($464bce95c77df256$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $464bce95c77df256$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $bh6RR.useContext($464bce95c77df256$export$971d5caa766a69d7);
        return /*#__PURE__*/ $bh6RR.createElement(Component, (0, $4WYaH.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $bh6RR.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $8GHIh.default)(WithTheme, Component);
}
var $464bce95c77df256$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $464bce95c77df256$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $464bce95c77df256$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $464bce95c77df256$var$getLastPart(match[1]);
    return undefined;
};
var $464bce95c77df256$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $464bce95c77df256$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $464bce95c77df256$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $464bce95c77df256$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($464bce95c77df256$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $464bce95c77df256$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $464bce95c77df256$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $464bce95c77df256$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $464bce95c77df256$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($464bce95c77df256$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$464bce95c77df256$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $464bce95c77df256$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $4ooDY.registerStyles)(cache, serialized, isStringTag);
    (0, $lSpak.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $4ooDY.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $464bce95c77df256$var$Emotion = /* #__PURE__ */ $464bce95c77df256$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$464bce95c77df256$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $4ooDY.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $2jWfj.serializeStyles)(registeredStyles, undefined, $bh6RR.useContext($464bce95c77df256$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($464bce95c77df256$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $464bce95c77df256$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($464bce95c77df256$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $bh6RR.createElement(WrappedComponent, newProps));
});
var $464bce95c77df256$export$a9c23c6ac3fc3eca = $464bce95c77df256$var$Emotion;

});
parcelRegister("lNmZA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fde0026076b18275$export$2e2bcd8739ae039; });

var $io0H8 = parcelRequire("io0H8");

var $zwcBM = parcelRequire("zwcBM");
parcelRequire("ieFqf");
parcelRequire("cthCm");
var $fde0026076b18275$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $zwcBM.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $zwcBM.token)(character)) break;
        (0, $zwcBM.next)();
    }
    return (0, $zwcBM.slice)(begin, (0, $zwcBM.position));
};
var $fde0026076b18275$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $zwcBM.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $zwcBM.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fde0026076b18275$var$identifierWithPointTracking((0, $zwcBM.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $zwcBM.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $zwcBM.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $zwcBM.from)(character);
    }
    while (character = (0, $zwcBM.next)());
    return parsed;
};
var $fde0026076b18275$var$getRules = function getRules(value, points) {
    return (0, $zwcBM.dealloc)($fde0026076b18275$var$toRules((0, $zwcBM.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fde0026076b18275$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fde0026076b18275$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fde0026076b18275$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fde0026076b18275$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fde0026076b18275$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fde0026076b18275$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fde0026076b18275$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fde0026076b18275$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fde0026076b18275$var$ignoreFlag) > -1;
};
var $fde0026076b18275$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fde0026076b18275$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fde0026076b18275$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fde0026076b18275$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fde0026076b18275$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fde0026076b18275$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fde0026076b18275$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fde0026076b18275$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fde0026076b18275$var$nullifyElement(element);
    } else if ($fde0026076b18275$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fde0026076b18275$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fde0026076b18275$var$prefix(value, length) {
    switch((0, $zwcBM.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $zwcBM.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $zwcBM.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $zwcBM.WEBKIT) + value + (0, $zwcBM.MOZ) + value + (0, $zwcBM.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $zwcBM.WEBKIT) + value + (0, $zwcBM.MS) + value + value;
        // order
        case 6165:
            return (0, $zwcBM.WEBKIT) + value + (0, $zwcBM.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $zwcBM.WEBKIT) + value + (0, $zwcBM.replace)(value, /(\w+).+(:[^]+)/, (0, $zwcBM.WEBKIT) + "box-$1$2" + (0, $zwcBM.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $zwcBM.WEBKIT) + value + (0, $zwcBM.MS) + "flex-item-" + (0, $zwcBM.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $zwcBM.WEBKIT) + value + (0, $zwcBM.MS) + "flex-line-pack" + (0, $zwcBM.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $zwcBM.WEBKIT) + value + (0, $zwcBM.MS) + (0, $zwcBM.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $zwcBM.WEBKIT) + value + (0, $zwcBM.MS) + (0, $zwcBM.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $zwcBM.WEBKIT) + "box-" + (0, $zwcBM.replace)(value, "-grow", "") + (0, $zwcBM.WEBKIT) + value + (0, $zwcBM.MS) + (0, $zwcBM.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $zwcBM.WEBKIT) + (0, $zwcBM.replace)(value, /([^-])(transform)/g, "$1" + (0, $zwcBM.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $zwcBM.replace)((0, $zwcBM.replace)((0, $zwcBM.replace)(value, /(zoom-|grab)/, (0, $zwcBM.WEBKIT) + "$1"), /(image-set)/, (0, $zwcBM.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $zwcBM.replace)(value, /(image-set\([^]*)/, (0, $zwcBM.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $zwcBM.replace)((0, $zwcBM.replace)(value, /(.+:)(flex-)?(.*)/, (0, $zwcBM.WEBKIT) + "box-pack:$3" + (0, $zwcBM.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $zwcBM.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $zwcBM.replace)(value, /(.+)-inline(.+)/, (0, $zwcBM.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $zwcBM.strlen)(value) - 1 - length > 6) switch((0, $zwcBM.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $zwcBM.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $zwcBM.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $zwcBM.WEBKIT) + "$2-$3" + "$1" + (0, $zwcBM.MOZ) + ((0, $zwcBM.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $zwcBM.indexof)(value, "stretch") ? $fde0026076b18275$var$prefix((0, $zwcBM.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $zwcBM.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $zwcBM.charat)(value, (0, $zwcBM.strlen)(value) - 3 - (~(0, $zwcBM.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $zwcBM.replace)(value, ":", ":" + (0, $zwcBM.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $zwcBM.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $zwcBM.WEBKIT) + ((0, $zwcBM.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $zwcBM.WEBKIT) + "$2$3" + "$1" + (0, $zwcBM.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $zwcBM.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $zwcBM.WEBKIT) + value + (0, $zwcBM.MS) + (0, $zwcBM.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $zwcBM.WEBKIT) + value + (0, $zwcBM.MS) + (0, $zwcBM.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $zwcBM.WEBKIT) + value + (0, $zwcBM.MS) + (0, $zwcBM.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $zwcBM.WEBKIT) + value + (0, $zwcBM.MS) + value + value;
    }
    return value;
}
var $fde0026076b18275$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $zwcBM.DECLARATION:
                element["return"] = $fde0026076b18275$var$prefix(element.value, element.length);
                break;
            case 0, $zwcBM.KEYFRAMES:
                return (0, $zwcBM.serialize)([
                    (0, $zwcBM.copy)(element, {
                        value: (0, $zwcBM.replace)(element.value, "@", "@" + (0, $zwcBM.WEBKIT))
                    })
                ], callback);
            case 0, $zwcBM.RULESET:
                if (element.length) return (0, $zwcBM.combine)(element.props, function(value) {
                    switch((0, $zwcBM.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $zwcBM.serialize)([
                                (0, $zwcBM.copy)(element, {
                                    props: [
                                        (0, $zwcBM.replace)(value, /:(read-\w+)/, ":" + (0, $zwcBM.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $zwcBM.serialize)([
                                (0, $zwcBM.copy)(element, {
                                    props: [
                                        (0, $zwcBM.replace)(value, /:(plac\w+)/, ":" + (0, $zwcBM.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $zwcBM.copy)(element, {
                                    props: [
                                        (0, $zwcBM.replace)(value, /:(plac\w+)/, ":" + (0, $zwcBM.MOZ) + "$1")
                                    ]
                                }),
                                (0, $zwcBM.copy)(element, {
                                    props: [
                                        (0, $zwcBM.replace)(value, /:(plac\w+)/, (0, $zwcBM.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fde0026076b18275$var$defaultStylisPlugins = [
    $fde0026076b18275$var$prefixer
];
var $fde0026076b18275$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fde0026076b18275$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fde0026076b18275$var$compat,
        $fde0026076b18275$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $zwcBM.stringify),
        (0, $zwcBM.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $zwcBM.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $zwcBM.serialize)((0, $zwcBM.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $io0H8.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("io0H8", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $d62b01db36b9cbe7$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $d62b01db36b9cbe7$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $d62b01db36b9cbe7$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $d62b01db36b9cbe7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($d62b01db36b9cbe7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $d62b01db36b9cbe7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("zwcBM", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $bf45309a6d809d2d$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $bf45309a6d809d2d$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $bf45309a6d809d2d$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $bf45309a6d809d2d$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $bf45309a6d809d2d$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $bf45309a6d809d2d$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $bf45309a6d809d2d$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $bf45309a6d809d2d$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $bf45309a6d809d2d$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $bf45309a6d809d2d$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $bf45309a6d809d2d$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $bf45309a6d809d2d$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $bf45309a6d809d2d$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $bf45309a6d809d2d$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $bf45309a6d809d2d$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $bf45309a6d809d2d$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $bf45309a6d809d2d$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $bf45309a6d809d2d$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $bf45309a6d809d2d$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $bf45309a6d809d2d$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $bf45309a6d809d2d$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $bf45309a6d809d2d$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $bf45309a6d809d2d$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $bf45309a6d809d2d$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $bf45309a6d809d2d$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $bf45309a6d809d2d$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $bf45309a6d809d2d$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $bf45309a6d809d2d$export$38bcb760f1d4871c; });
var $bf45309a6d809d2d$export$71ad59f2e432cfe8 = "-ms-";
var $bf45309a6d809d2d$export$2c0f367103c8d01c = "-moz-";
var $bf45309a6d809d2d$export$39dfd62a25e0fe93 = "-webkit-";
var $bf45309a6d809d2d$export$a29989082612d0d9 = "comm";
var $bf45309a6d809d2d$export$aa3a2e812ca8570d = "rule";
var $bf45309a6d809d2d$export$527d108ccf083c2b = "decl";
var $bf45309a6d809d2d$export$d3d35020fa5b54f0 = "@page";
var $bf45309a6d809d2d$export$500415a86c544f73 = "@media";
var $bf45309a6d809d2d$export$a763edbf796b780a = "@import";
var $bf45309a6d809d2d$export$2790aeb8b4e5c826 = "@charset";
var $bf45309a6d809d2d$export$1cc683e23b84b133 = "@viewport";
var $bf45309a6d809d2d$export$9447a5efea57e862 = "@supports";
var $bf45309a6d809d2d$export$ef011b4e114b1fba = "@document";
var $bf45309a6d809d2d$export$6aad947bda0f3f46 = "@namespace";
var $bf45309a6d809d2d$export$b44a8529a35fcb60 = "@keyframes";
var $bf45309a6d809d2d$export$2c16de31893252e6 = "@font-face";
var $bf45309a6d809d2d$export$3d846dd52e150c6f = "@counter-style";
var $bf45309a6d809d2d$export$22314bfbb57653fe = "@font-feature-values";
var $bf45309a6d809d2d$export$d773506282b3cfe6 = "@layer";
var $bf45309a6d809d2d$export$2335f513bbd82c6d = Math.abs;
var $bf45309a6d809d2d$export$6788812c4e6611e6 = String.fromCharCode;
var $bf45309a6d809d2d$export$e6e34fd1f2686227 = Object.assign;
function $bf45309a6d809d2d$export$d6af199866bfb566(e, r) {
    return $bf45309a6d809d2d$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $bf45309a6d809d2d$export$a9db5e087081082d(e, 0)) << 2 ^ $bf45309a6d809d2d$export$a9db5e087081082d(e, 1)) << 2 ^ $bf45309a6d809d2d$export$a9db5e087081082d(e, 2)) << 2 ^ $bf45309a6d809d2d$export$a9db5e087081082d(e, 3) : 0;
}
function $bf45309a6d809d2d$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $bf45309a6d809d2d$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $bf45309a6d809d2d$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $bf45309a6d809d2d$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $bf45309a6d809d2d$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $bf45309a6d809d2d$export$36776f635604f274(e) {
    return e.length;
}
function $bf45309a6d809d2d$export$f9084667e487ed46(e) {
    return e.length;
}
function $bf45309a6d809d2d$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $bf45309a6d809d2d$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $bf45309a6d809d2d$export$53f1d5ea8de3d7c = 1;
var $bf45309a6d809d2d$export$4e0c71f277ca26b3 = 1;
var $bf45309a6d809d2d$export$f24224f1c91d8156 = 0;
var $bf45309a6d809d2d$export$5880b8b5730aff45 = 0;
var $bf45309a6d809d2d$export$c0306caf338ac095 = 0;
var $bf45309a6d809d2d$export$30a86d91af8ff6e6 = "";
function $bf45309a6d809d2d$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $bf45309a6d809d2d$export$53f1d5ea8de3d7c,
        column: $bf45309a6d809d2d$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $bf45309a6d809d2d$export$784d13d8ee351f07(e, r) {
    return $bf45309a6d809d2d$export$e6e34fd1f2686227($bf45309a6d809d2d$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $bf45309a6d809d2d$export$eba6f6f03b0a92e7() {
    return $bf45309a6d809d2d$export$c0306caf338ac095;
}
function $bf45309a6d809d2d$export$232faf9add678146() {
    $bf45309a6d809d2d$export$c0306caf338ac095 = $bf45309a6d809d2d$export$5880b8b5730aff45 > 0 ? $bf45309a6d809d2d$export$a9db5e087081082d($bf45309a6d809d2d$export$30a86d91af8ff6e6, --$bf45309a6d809d2d$export$5880b8b5730aff45) : 0;
    if ($bf45309a6d809d2d$export$4e0c71f277ca26b3--, $bf45309a6d809d2d$export$c0306caf338ac095 === 10) $bf45309a6d809d2d$export$4e0c71f277ca26b3 = 1, $bf45309a6d809d2d$export$53f1d5ea8de3d7c--;
    return $bf45309a6d809d2d$export$c0306caf338ac095;
}
function $bf45309a6d809d2d$export$48cfd1e771a65c4f() {
    $bf45309a6d809d2d$export$c0306caf338ac095 = $bf45309a6d809d2d$export$5880b8b5730aff45 < $bf45309a6d809d2d$export$f24224f1c91d8156 ? $bf45309a6d809d2d$export$a9db5e087081082d($bf45309a6d809d2d$export$30a86d91af8ff6e6, $bf45309a6d809d2d$export$5880b8b5730aff45++) : 0;
    if ($bf45309a6d809d2d$export$4e0c71f277ca26b3++, $bf45309a6d809d2d$export$c0306caf338ac095 === 10) $bf45309a6d809d2d$export$4e0c71f277ca26b3 = 1, $bf45309a6d809d2d$export$53f1d5ea8de3d7c++;
    return $bf45309a6d809d2d$export$c0306caf338ac095;
}
function $bf45309a6d809d2d$export$4d3fb11e950abb9e() {
    return $bf45309a6d809d2d$export$a9db5e087081082d($bf45309a6d809d2d$export$30a86d91af8ff6e6, $bf45309a6d809d2d$export$5880b8b5730aff45);
}
function $bf45309a6d809d2d$export$e88cb2efb12ae807() {
    return $bf45309a6d809d2d$export$5880b8b5730aff45;
}
function $bf45309a6d809d2d$export$58adb3bec8346d0f(e, r) {
    return $bf45309a6d809d2d$export$2f35ab04d2335697($bf45309a6d809d2d$export$30a86d91af8ff6e6, e, r);
}
function $bf45309a6d809d2d$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $bf45309a6d809d2d$export$2de70f21292aac9e(e) {
    return $bf45309a6d809d2d$export$53f1d5ea8de3d7c = $bf45309a6d809d2d$export$4e0c71f277ca26b3 = 1, $bf45309a6d809d2d$export$f24224f1c91d8156 = $bf45309a6d809d2d$export$36776f635604f274($bf45309a6d809d2d$export$30a86d91af8ff6e6 = e), $bf45309a6d809d2d$export$5880b8b5730aff45 = 0, [];
}
function $bf45309a6d809d2d$export$45918ac1574455b1(e) {
    return $bf45309a6d809d2d$export$30a86d91af8ff6e6 = "", e;
}
function $bf45309a6d809d2d$export$410ac95b9ec204b8(e) {
    return $bf45309a6d809d2d$export$87c2784dc9fc4ab($bf45309a6d809d2d$export$58adb3bec8346d0f($bf45309a6d809d2d$export$5880b8b5730aff45 - 1, $bf45309a6d809d2d$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $bf45309a6d809d2d$export$660b2ee2d4fb4eff(e) {
    return $bf45309a6d809d2d$export$45918ac1574455b1($bf45309a6d809d2d$export$5f8c09e3ae6f64e1($bf45309a6d809d2d$export$2de70f21292aac9e(e)));
}
function $bf45309a6d809d2d$export$7af1228ff777d175(e) {
    while($bf45309a6d809d2d$export$c0306caf338ac095 = $bf45309a6d809d2d$export$4d3fb11e950abb9e())if ($bf45309a6d809d2d$export$c0306caf338ac095 < 33) $bf45309a6d809d2d$export$48cfd1e771a65c4f();
    else break;
    return $bf45309a6d809d2d$export$9e1725a4cfeada27(e) > 2 || $bf45309a6d809d2d$export$9e1725a4cfeada27($bf45309a6d809d2d$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $bf45309a6d809d2d$export$5f8c09e3ae6f64e1(e) {
    while($bf45309a6d809d2d$export$48cfd1e771a65c4f())switch($bf45309a6d809d2d$export$9e1725a4cfeada27($bf45309a6d809d2d$export$c0306caf338ac095)){
        case 0:
            $bf45309a6d809d2d$export$10d8903dec122b9d($bf45309a6d809d2d$export$c2ab62c7bf24634($bf45309a6d809d2d$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $bf45309a6d809d2d$export$10d8903dec122b9d($bf45309a6d809d2d$export$410ac95b9ec204b8($bf45309a6d809d2d$export$c0306caf338ac095), e);
            break;
        default:
            $bf45309a6d809d2d$export$10d8903dec122b9d($bf45309a6d809d2d$export$6788812c4e6611e6($bf45309a6d809d2d$export$c0306caf338ac095), e);
    }
    return e;
}
function $bf45309a6d809d2d$export$955ba06d119e085e(e, r) {
    while(--r && $bf45309a6d809d2d$export$48cfd1e771a65c4f())if ($bf45309a6d809d2d$export$c0306caf338ac095 < 48 || $bf45309a6d809d2d$export$c0306caf338ac095 > 102 || $bf45309a6d809d2d$export$c0306caf338ac095 > 57 && $bf45309a6d809d2d$export$c0306caf338ac095 < 65 || $bf45309a6d809d2d$export$c0306caf338ac095 > 70 && $bf45309a6d809d2d$export$c0306caf338ac095 < 97) break;
    return $bf45309a6d809d2d$export$58adb3bec8346d0f(e, $bf45309a6d809d2d$export$e88cb2efb12ae807() + (r < 6 && $bf45309a6d809d2d$export$4d3fb11e950abb9e() == 32 && $bf45309a6d809d2d$export$48cfd1e771a65c4f() == 32));
}
function $bf45309a6d809d2d$export$c889f2fcc19dbf12(e) {
    while($bf45309a6d809d2d$export$48cfd1e771a65c4f())switch($bf45309a6d809d2d$export$c0306caf338ac095){
        case e:
            return $bf45309a6d809d2d$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $bf45309a6d809d2d$export$c889f2fcc19dbf12($bf45309a6d809d2d$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $bf45309a6d809d2d$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $bf45309a6d809d2d$export$48cfd1e771a65c4f();
            break;
    }
    return $bf45309a6d809d2d$export$5880b8b5730aff45;
}
function $bf45309a6d809d2d$export$4254d4e2b3745c4c(e, r) {
    while($bf45309a6d809d2d$export$48cfd1e771a65c4f())if (e + $bf45309a6d809d2d$export$c0306caf338ac095 === 57) break;
    else if (e + $bf45309a6d809d2d$export$c0306caf338ac095 === 84 && $bf45309a6d809d2d$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $bf45309a6d809d2d$export$58adb3bec8346d0f(r, $bf45309a6d809d2d$export$5880b8b5730aff45 - 1) + "*" + $bf45309a6d809d2d$export$6788812c4e6611e6(e === 47 ? e : $bf45309a6d809d2d$export$48cfd1e771a65c4f());
}
function $bf45309a6d809d2d$export$c2ab62c7bf24634(e) {
    while(!$bf45309a6d809d2d$export$9e1725a4cfeada27($bf45309a6d809d2d$export$4d3fb11e950abb9e()))$bf45309a6d809d2d$export$48cfd1e771a65c4f();
    return $bf45309a6d809d2d$export$58adb3bec8346d0f(e, $bf45309a6d809d2d$export$5880b8b5730aff45);
}
function $bf45309a6d809d2d$export$ef7acd7185315e22(e) {
    return $bf45309a6d809d2d$export$45918ac1574455b1($bf45309a6d809d2d$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $bf45309a6d809d2d$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $bf45309a6d809d2d$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $bf45309a6d809d2d$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $bf45309a6d809d2d$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($bf45309a6d809d2d$export$f8e21b1e77979a08(j += $bf45309a6d809d2d$export$77ad94ebf1c2b9ed($bf45309a6d809d2d$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $bf45309a6d809d2d$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $bf45309a6d809d2d$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $bf45309a6d809d2d$export$955ba06d119e085e($bf45309a6d809d2d$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($bf45309a6d809d2d$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $bf45309a6d809d2d$export$10d8903dec122b9d($bf45309a6d809d2d$export$4a34f930e789283c($bf45309a6d809d2d$export$4254d4e2b3745c4c($bf45309a6d809d2d$export$48cfd1e771a65c4f(), $bf45309a6d809d2d$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $bf45309a6d809d2d$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $bf45309a6d809d2d$export$36776f635604f274(j) - l) $bf45309a6d809d2d$export$10d8903dec122b9d(p > 32 ? $bf45309a6d809d2d$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $bf45309a6d809d2d$export$f8483753829ec8f3($bf45309a6d809d2d$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $bf45309a6d809d2d$export$10d8903dec122b9d(y = $bf45309a6d809d2d$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $bf45309a6d809d2d$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $bf45309a6d809d2d$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $bf45309a6d809d2d$export$98e6a39c04603d36(e, y, y, n && $bf45309a6d809d2d$export$10d8903dec122b9d($bf45309a6d809d2d$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $bf45309a6d809d2d$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $bf45309a6d809d2d$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $bf45309a6d809d2d$export$232faf9add678146() == 125) continue;
            }
            switch(j += $bf45309a6d809d2d$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($bf45309a6d809d2d$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($bf45309a6d809d2d$export$4d3fb11e950abb9e() === 45) j += $bf45309a6d809d2d$export$410ac95b9ec204b8($bf45309a6d809d2d$export$48cfd1e771a65c4f());
                    v = $bf45309a6d809d2d$export$4d3fb11e950abb9e(), o = l = $bf45309a6d809d2d$export$36776f635604f274(g = j += $bf45309a6d809d2d$export$c2ab62c7bf24634($bf45309a6d809d2d$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $bf45309a6d809d2d$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $bf45309a6d809d2d$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $bf45309a6d809d2d$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $bf45309a6d809d2d$export$2f35ab04d2335697(e, v + 1, v = $bf45309a6d809d2d$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $bf45309a6d809d2d$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $bf45309a6d809d2d$export$35059013cd4a06db(e, r, a, s === 0 ? $bf45309a6d809d2d$export$aa3a2e812ca8570d : i, f, o, l);
}
function $bf45309a6d809d2d$export$4a34f930e789283c(e, r, a) {
    return $bf45309a6d809d2d$export$35059013cd4a06db(e, r, a, $bf45309a6d809d2d$export$a29989082612d0d9, $bf45309a6d809d2d$export$6788812c4e6611e6($bf45309a6d809d2d$export$eba6f6f03b0a92e7()), $bf45309a6d809d2d$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $bf45309a6d809d2d$export$f8483753829ec8f3(e, r, a, n) {
    return $bf45309a6d809d2d$export$35059013cd4a06db(e, r, a, $bf45309a6d809d2d$export$527d108ccf083c2b, $bf45309a6d809d2d$export$2f35ab04d2335697(e, 0, n), $bf45309a6d809d2d$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $bf45309a6d809d2d$export$82e9f45cca5ba907(n, c, s) {
    switch($bf45309a6d809d2d$export$d6af199866bfb566(n, c)){
        case 5103:
            return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $bf45309a6d809d2d$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + n + $bf45309a6d809d2d$export$2c0f367103c8d01c + n + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($bf45309a6d809d2d$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + n + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + n + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + n + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + n + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + n + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + n + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $bf45309a6d809d2d$export$39dfd62a25e0fe93 + "box-$1$2" + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + n + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + "flex-item-" + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$bf45309a6d809d2d$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $bf45309a6d809d2d$export$71ad59f2e432cfe8 + "grid-row-" + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + n + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + "flex-line-pack" + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + n + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + n + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + "box-" + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, "-grow", "") + $bf45309a6d809d2d$export$39dfd62a25e0fe93 + n + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $bf45309a6d809d2d$export$39dfd62a25e0fe93 + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $bf45309a6d809d2d$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $bf45309a6d809d2d$export$77ad94ebf1c2b9ed($bf45309a6d809d2d$export$77ad94ebf1c2b9ed($bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $bf45309a6d809d2d$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $bf45309a6d809d2d$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $bf45309a6d809d2d$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $bf45309a6d809d2d$export$77ad94ebf1c2b9ed($bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $bf45309a6d809d2d$export$39dfd62a25e0fe93 + "box-pack:$3" + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $bf45309a6d809d2d$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$bf45309a6d809d2d$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $bf45309a6d809d2d$export$71ad59f2e432cfe8 + "grid-column-align" + $bf45309a6d809d2d$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $bf45309a6d809d2d$export$71ad59f2e432cfe8 + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $bf45309a6d809d2d$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$bf45309a6d809d2d$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $bf45309a6d809d2d$export$71ad59f2e432cfe8 + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$bf45309a6d809d2d$export$f8e21b1e77979a08(s, "span") ? $bf45309a6d809d2d$export$4659b591c19bdf3d(s, /\d+/) : +$bf45309a6d809d2d$export$4659b591c19bdf3d(s, /\d+/) - +$bf45309a6d809d2d$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $bf45309a6d809d2d$export$71ad59f2e432cfe8 + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $bf45309a6d809d2d$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $bf45309a6d809d2d$export$71ad59f2e432cfe8 + $bf45309a6d809d2d$export$77ad94ebf1c2b9ed($bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $bf45309a6d809d2d$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($bf45309a6d809d2d$export$36776f635604f274(n) - 1 - c > 6) switch($bf45309a6d809d2d$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($bf45309a6d809d2d$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $bf45309a6d809d2d$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $bf45309a6d809d2d$export$2c0f367103c8d01c + ($bf45309a6d809d2d$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$bf45309a6d809d2d$export$f8e21b1e77979a08(n, "stretch") ? $bf45309a6d809d2d$export$82e9f45cca5ba907($bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $bf45309a6d809d2d$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $bf45309a6d809d2d$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($bf45309a6d809d2d$export$a9db5e087081082d(n, c + 6) === 121) return $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, ":", ":" + $bf45309a6d809d2d$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($bf45309a6d809d2d$export$a9db5e087081082d(n, $bf45309a6d809d2d$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $bf45309a6d809d2d$export$39dfd62a25e0fe93 + ($bf45309a6d809d2d$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $bf45309a6d809d2d$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $bf45309a6d809d2d$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, ":", ":" + $bf45309a6d809d2d$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $bf45309a6d809d2d$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $bf45309a6d809d2d$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $bf45309a6d809d2d$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $bf45309a6d809d2d$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $bf45309a6d809d2d$export$a763edbf796b780a:
        case $bf45309a6d809d2d$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $bf45309a6d809d2d$export$a29989082612d0d9:
            return "";
        case $bf45309a6d809d2d$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $bf45309a6d809d2d$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $bf45309a6d809d2d$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $bf45309a6d809d2d$export$36776f635604f274(a = $bf45309a6d809d2d$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $bf45309a6d809d2d$export$5a7767152ae0305f(e) {
    var r = $bf45309a6d809d2d$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $bf45309a6d809d2d$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $bf45309a6d809d2d$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $bf45309a6d809d2d$export$527d108ccf083c2b:
                n.return = $bf45309a6d809d2d$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $bf45309a6d809d2d$export$b44a8529a35fcb60:
                return $bf45309a6d809d2d$export$dfdc1655ccc5b9cb([
                    $bf45309a6d809d2d$export$784d13d8ee351f07(n, {
                        value: $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $bf45309a6d809d2d$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $bf45309a6d809d2d$export$aa3a2e812ca8570d:
                if (n.length) return $bf45309a6d809d2d$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($bf45309a6d809d2d$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $bf45309a6d809d2d$export$dfdc1655ccc5b9cb([
                                $bf45309a6d809d2d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $bf45309a6d809d2d$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $bf45309a6d809d2d$export$dfdc1655ccc5b9cb([
                                $bf45309a6d809d2d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $bf45309a6d809d2d$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $bf45309a6d809d2d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $bf45309a6d809d2d$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $bf45309a6d809d2d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $bf45309a6d809d2d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $bf45309a6d809d2d$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $bf45309a6d809d2d$export$76a88f7de6507443(e) {
    switch(e.type){
        case $bf45309a6d809d2d$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $bf45309a6d809d2d$export$1be1fc439b849fdf($bf45309a6d809d2d$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($bf45309a6d809d2d$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $bf45309a6d809d2d$export$2f35ab04d2335697(r, 1, $bf45309a6d809d2d$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $bf45309a6d809d2d$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $bf45309a6d809d2d$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $bf45309a6d809d2d$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("ieFqf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d469aa6647f846c1$export$2e2bcd8739ae039; });
var $d469aa6647f846c1$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("8GHIh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65342784890a87de$export$2e2bcd8739ae039; });

var $adG4d = parcelRequire("adG4d");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $65342784890a87de$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(targetComponent, sourceComponent);
};

});

parcelRegister("4ooDY", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $332c850b9c82e549$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $332c850b9c82e549$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $332c850b9c82e549$export$6f077d94b33a01aa; });
var $332c850b9c82e549$var$isBrowser = true;
function $332c850b9c82e549$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $332c850b9c82e549$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $332c850b9c82e549$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $332c850b9c82e549$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $332c850b9c82e549$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("2jWfj", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $1b0a8993327ca6c5$export$6321afa313b251b5; });

var $171Pu = parcelRequire("171Pu");

var $3iPX2 = parcelRequire("3iPX2");

var $cthCm = parcelRequire("cthCm");
var $1b0a8993327ca6c5$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $1b0a8993327ca6c5$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $1b0a8993327ca6c5$var$hyphenateRegex = /[A-Z]|^ms/g;
var $1b0a8993327ca6c5$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $1b0a8993327ca6c5$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $1b0a8993327ca6c5$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $1b0a8993327ca6c5$var$processStyleName = /* #__PURE__ */ (0, $cthCm.default)(function(styleName) {
    return $1b0a8993327ca6c5$var$isCustomProperty(styleName) ? styleName : styleName.replace($1b0a8993327ca6c5$var$hyphenateRegex, "-$&").toLowerCase();
});
var $1b0a8993327ca6c5$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($1b0a8993327ca6c5$var$animationRegex, function(match, p1, p2) {
                $1b0a8993327ca6c5$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $1b0a8993327ca6c5$var$cursor
                };
                return p1;
            });
    }
    if ((0, $3iPX2.default)[key] !== 1 && !$1b0a8993327ca6c5$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $1b0a8993327ca6c5$var$contentValuePattern, $1b0a8993327ca6c5$var$contentValues, $1b0a8993327ca6c5$var$oldProcessStyleValue, $1b0a8993327ca6c5$var$msPattern, $1b0a8993327ca6c5$var$hyphenPattern, $1b0a8993327ca6c5$var$hyphenatedCache;
var $1b0a8993327ca6c5$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $1b0a8993327ca6c5$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $1b0a8993327ca6c5$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $1b0a8993327ca6c5$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $1b0a8993327ca6c5$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $1b0a8993327ca6c5$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $1b0a8993327ca6c5$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $1b0a8993327ca6c5$var$cursor;
                var result = interpolation(mergedProps);
                $1b0a8993327ca6c5$var$cursor = previousCursor;
                return $1b0a8993327ca6c5$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $1b0a8993327ca6c5$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $1b0a8993327ca6c5$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($1b0a8993327ca6c5$var$isProcessableValue(value)) string += $1b0a8993327ca6c5$var$processStyleName(_key) + ":" + $1b0a8993327ca6c5$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($1b0a8993327ca6c5$var$isProcessableValue(value[_i])) string += $1b0a8993327ca6c5$var$processStyleName(_key) + ":" + $1b0a8993327ca6c5$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $1b0a8993327ca6c5$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $1b0a8993327ca6c5$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $1b0a8993327ca6c5$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $1b0a8993327ca6c5$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $1b0a8993327ca6c5$var$cursor;
var $1b0a8993327ca6c5$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $1b0a8993327ca6c5$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $1b0a8993327ca6c5$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $1b0a8993327ca6c5$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $1b0a8993327ca6c5$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $1b0a8993327ca6c5$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $171Pu.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $1b0a8993327ca6c5$var$cursor
    };
};

});
parcelRegister("171Pu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cf7dd2d70c55cf3$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $0cf7dd2d70c55cf3$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("3iPX2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $267b59f2e6fe7643$export$2e2bcd8739ae039; });
var $267b59f2e6fe7643$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("lSpak", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $fed2297e202d3641$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $fed2297e202d3641$export$811a713a7276cb9d; });

var $bh6RR = parcelRequire("bh6RR");
var $fed2297e202d3641$var$syncFallback = function syncFallback(create) {
    return create();
};
var $fed2297e202d3641$var$useInsertionEffect = $bh6RR.useInsertionEffect ? $bh6RR.useInsertionEffect : false;
var $fed2297e202d3641$export$db21c7ffa21794e7 = $fed2297e202d3641$var$useInsertionEffect || $fed2297e202d3641$var$syncFallback;
var $fed2297e202d3641$export$811a713a7276cb9d = $fed2297e202d3641$var$useInsertionEffect || $bh6RR.useLayoutEffect;

});


parcelRegister("3Tqyg", function(module, exports) {
function $2d5b1ac1574da936$var$_extends() {
    module.exports = $2d5b1ac1574da936$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $2d5b1ac1574da936$var$_extends.apply(this, arguments);
}
module.exports = $2d5b1ac1574da936$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9fGzh", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $6bc688e198e0f276$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $6bc688e198e0f276$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $6bc688e198e0f276$export$6f077d94b33a01aa; });
var $6bc688e198e0f276$var$isBrowser = true;
function $6bc688e198e0f276$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $6bc688e198e0f276$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $6bc688e198e0f276$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $6bc688e198e0f276$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $6bc688e198e0f276$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("fT0AU", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $b90c7414cebf75c2$export$6321afa313b251b5; });

var $171Pu = parcelRequire("171Pu");

var $drMVo = parcelRequire("drMVo");

var $cthCm = parcelRequire("cthCm");
var $b90c7414cebf75c2$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $b90c7414cebf75c2$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $b90c7414cebf75c2$var$hyphenateRegex = /[A-Z]|^ms/g;
var $b90c7414cebf75c2$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $b90c7414cebf75c2$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $b90c7414cebf75c2$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $b90c7414cebf75c2$var$processStyleName = /* #__PURE__ */ (0, $cthCm.default)(function(styleName) {
    return $b90c7414cebf75c2$var$isCustomProperty(styleName) ? styleName : styleName.replace($b90c7414cebf75c2$var$hyphenateRegex, "-$&").toLowerCase();
});
var $b90c7414cebf75c2$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($b90c7414cebf75c2$var$animationRegex, function(match, p1, p2) {
                $b90c7414cebf75c2$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $b90c7414cebf75c2$var$cursor
                };
                return p1;
            });
    }
    if ((0, $drMVo.default)[key] !== 1 && !$b90c7414cebf75c2$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $b90c7414cebf75c2$var$contentValuePattern, $b90c7414cebf75c2$var$contentValues, $b90c7414cebf75c2$var$oldProcessStyleValue, $b90c7414cebf75c2$var$msPattern, $b90c7414cebf75c2$var$hyphenPattern, $b90c7414cebf75c2$var$hyphenatedCache;
var $b90c7414cebf75c2$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $b90c7414cebf75c2$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $b90c7414cebf75c2$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $b90c7414cebf75c2$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $b90c7414cebf75c2$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $b90c7414cebf75c2$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $b90c7414cebf75c2$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $b90c7414cebf75c2$var$cursor;
                var result = interpolation(mergedProps);
                $b90c7414cebf75c2$var$cursor = previousCursor;
                return $b90c7414cebf75c2$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $b90c7414cebf75c2$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $b90c7414cebf75c2$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($b90c7414cebf75c2$var$isProcessableValue(value)) string += $b90c7414cebf75c2$var$processStyleName(_key) + ":" + $b90c7414cebf75c2$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($b90c7414cebf75c2$var$isProcessableValue(value[_i])) string += $b90c7414cebf75c2$var$processStyleName(_key) + ":" + $b90c7414cebf75c2$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $b90c7414cebf75c2$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $b90c7414cebf75c2$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $b90c7414cebf75c2$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $b90c7414cebf75c2$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $b90c7414cebf75c2$var$cursor;
var $b90c7414cebf75c2$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $b90c7414cebf75c2$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $b90c7414cebf75c2$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $b90c7414cebf75c2$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $b90c7414cebf75c2$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $b90c7414cebf75c2$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $171Pu.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $b90c7414cebf75c2$var$cursor
    };
};

});
parcelRegister("drMVo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ca3bf6a0b9169a5$export$2e2bcd8739ae039; });
var $9ca3bf6a0b9169a5$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});




parcelRegister("2BnRa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e518ade8ff49208$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");


var $fPZvG = parcelRequire("fPZvG");

var $ih19M = parcelRequire("ih19M");
"use client";
function $1e518ade8ff49208$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $1e518ade8ff49208$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($1e518ade8ff49208$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $fPZvG.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("5syur", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $3f9a524a63e48d58$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $3f9a524a63e48d58$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");
function $3f9a524a63e48d58$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $3f9a524a63e48d58$var$deepClone(source) {
    if (!$3f9a524a63e48d58$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $3f9a524a63e48d58$var$deepClone(source[key]);
    });
    return output;
}
function $3f9a524a63e48d58$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $4WYaH.default)({}, target) : target;
    if ($3f9a524a63e48d58$export$53b83ca8eaab0383(target) && $3f9a524a63e48d58$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($3f9a524a63e48d58$export$53b83ca8eaab0383(source[key]) && key in target && $3f9a524a63e48d58$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $3f9a524a63e48d58$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $3f9a524a63e48d58$export$53b83ca8eaab0383(source[key]) ? $3f9a524a63e48d58$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("eWibl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae04960cd934c421$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $5syur = parcelRequire("5syur");

var $gKKtH = parcelRequire("gKKtH");

var $a3b0G = parcelRequire("a3b0G");

var $9u36r = parcelRequire("9u36r");

var $cWrkM = parcelRequire("cWrkM");

var $9lrgD = parcelRequire("9lrgD");

var $iGE4k = parcelRequire("iGE4k");
const $ae04960cd934c421$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $ae04960cd934c421$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $hCIyK.default)(options, $ae04960cd934c421$var$_excluded);
    const breakpoints = (0, $gKKtH.default)(breakpointsInput);
    const spacing = (0, $9u36r.default)(spacingInput);
    let muiTheme = (0, $5syur.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $4WYaH.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $4WYaH.default)({}, (0, $a3b0G.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $iGE4k.default);
    muiTheme = args.reduce((acc, argument)=>(0, $5syur.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $4WYaH.default)({}, (0, $9lrgD.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $cWrkM.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $ae04960cd934c421$export$2e2bcd8739ae039 = $ae04960cd934c421$var$createTheme;

});
parcelRegister("gKKtH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c324fec4465b9df7$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");
const $c324fec4465b9df7$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $c324fec4465b9df7$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $c324fec4465b9df7$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $4WYaH.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $c324fec4465b9df7$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $hCIyK.default)(breakpoints, $c324fec4465b9df7$var$_excluded);
    const sortedValues = $c324fec4465b9df7$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $4WYaH.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("a3b0G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7512b9915380a900$export$2e2bcd8739ae039; });
const $7512b9915380a900$var$shape = {
    borderRadius: 4
};
var $7512b9915380a900$export$2e2bcd8739ae039 = $7512b9915380a900$var$shape;

});

parcelRegister("9u36r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e795293593859d0$export$2e2bcd8739ae039; });

var $iBWQv = parcelRequire("iBWQv");
function $6e795293593859d0$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $iBWQv.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("iBWQv", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $d8c9543f58152c12$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $d8c9543f58152c12$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $d8c9543f58152c12$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $d8c9543f58152c12$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $d8c9543f58152c12$export$6f98e8eaf0be1996; });


var $fmKqo = parcelRequire("fmKqo");

var $2dEyt = parcelRequire("2dEyt");

var $goAHI = parcelRequire("goAHI");

var $45JDz = parcelRequire("45JDz");
const $d8c9543f58152c12$var$properties = {
    m: "margin",
    p: "padding"
};
const $d8c9543f58152c12$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $d8c9543f58152c12$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $d8c9543f58152c12$var$getCssProperties = (0, $45JDz.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($d8c9543f58152c12$var$aliases[prop]) prop = $d8c9543f58152c12$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $d8c9543f58152c12$var$properties[a];
    const direction = $d8c9543f58152c12$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $d8c9543f58152c12$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $d8c9543f58152c12$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $d8c9543f58152c12$var$spacingKeys = [
    ...$d8c9543f58152c12$export$aab52a0dde05ad8a,
    ...$d8c9543f58152c12$export$f8397d44f03ab6ad
];
function $d8c9543f58152c12$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $2dEyt.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $d8c9543f58152c12$export$1def6f833384e3d1(theme) {
    return $d8c9543f58152c12$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $d8c9543f58152c12$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $d8c9543f58152c12$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $d8c9543f58152c12$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $d8c9543f58152c12$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $d8c9543f58152c12$var$getCssProperties(prop);
    const styleFromPropValue = $d8c9543f58152c12$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $fmKqo.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $d8c9543f58152c12$var$style(props, keys) {
    const transformer = $d8c9543f58152c12$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$d8c9543f58152c12$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $goAHI.default), {});
}
function $d8c9543f58152c12$export$7ede87f9b603dd3c(props) {
    return $d8c9543f58152c12$var$style(props, $d8c9543f58152c12$export$aab52a0dde05ad8a);
}
$d8c9543f58152c12$export$7ede87f9b603dd3c.propTypes = {};
$d8c9543f58152c12$export$7ede87f9b603dd3c.filterProps = $d8c9543f58152c12$export$aab52a0dde05ad8a;
function $d8c9543f58152c12$export$6f98e8eaf0be1996(props) {
    return $d8c9543f58152c12$var$style(props, $d8c9543f58152c12$export$f8397d44f03ab6ad);
}
$d8c9543f58152c12$export$6f98e8eaf0be1996.propTypes = {};
$d8c9543f58152c12$export$6f98e8eaf0be1996.filterProps = $d8c9543f58152c12$export$f8397d44f03ab6ad;
function $d8c9543f58152c12$var$spacing(props) {
    return $d8c9543f58152c12$var$style(props, $d8c9543f58152c12$var$spacingKeys);
}
$d8c9543f58152c12$var$spacing.propTypes = {};
$d8c9543f58152c12$var$spacing.filterProps = $d8c9543f58152c12$var$spacingKeys;
var $d8c9543f58152c12$export$2e2bcd8739ae039 = $d8c9543f58152c12$var$spacing;

});
parcelRegister("fmKqo", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $b2fcec0ee7383fe6$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $b2fcec0ee7383fe6$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $b2fcec0ee7383fe6$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $b2fcec0ee7383fe6$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $b2fcec0ee7383fe6$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $b2fcec0ee7383fe6$export$980e6a259d807490; });

var $4WYaH = parcelRequire("4WYaH");


var $5syur = parcelRequire("5syur");

var $goAHI = parcelRequire("goAHI");
const $b2fcec0ee7383fe6$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $b2fcec0ee7383fe6$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$b2fcec0ee7383fe6$export$68c286be0e7e55b7[key]}px)`
};
function $b2fcec0ee7383fe6$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $b2fcec0ee7383fe6$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $b2fcec0ee7383fe6$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $b2fcec0ee7383fe6$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $b2fcec0ee7383fe6$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $b2fcec0ee7383fe6$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $4WYaH.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $goAHI.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $b2fcec0ee7383fe6$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $b2fcec0ee7383fe6$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $b2fcec0ee7383fe6$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $b2fcec0ee7383fe6$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $5syur.default)(prev, next), {});
    return $b2fcec0ee7383fe6$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $b2fcec0ee7383fe6$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $b2fcec0ee7383fe6$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $b2fcec0ee7383fe6$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $b2fcec0ee7383fe6$export$2e2bcd8739ae039 = $b2fcec0ee7383fe6$var$breakpoints;

});
parcelRegister("goAHI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $befb5be6d31885f4$export$2e2bcd8739ae039; });

var $5syur = parcelRequire("5syur");
function $befb5be6d31885f4$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $5syur.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $befb5be6d31885f4$export$2e2bcd8739ae039 = $befb5be6d31885f4$var$merge;

});


parcelRegister("2dEyt", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $19dc4109ea10d606$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $19dc4109ea10d606$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $19dc4109ea10d606$export$2e2bcd8739ae039; });

var $5pCmM = parcelRequire("5pCmM");


var $fmKqo = parcelRequire("fmKqo");
function $19dc4109ea10d606$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $19dc4109ea10d606$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $19dc4109ea10d606$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $19dc4109ea10d606$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $19dc4109ea10d606$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $19dc4109ea10d606$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $19dc4109ea10d606$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $5pCmM.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $fmKqo.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $19dc4109ea10d606$export$2e2bcd8739ae039 = $19dc4109ea10d606$var$style;

});
parcelRegister("5pCmM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f0d0c569d2896e9$export$2e2bcd8739ae039; });

var $avV9A = parcelRequire("avV9A");
function $3f0d0c569d2896e9$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $avV9A.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("45JDz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fab07ac6ad882aa$export$2e2bcd8739ae039; });
function $2fab07ac6ad882aa$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("cWrkM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96c01ad43b7c67ff$export$2e2bcd8739ae039; });

var $5pCmM = parcelRequire("5pCmM");

var $goAHI = parcelRequire("goAHI");

var $2dEyt = parcelRequire("2dEyt");

var $fmKqo = parcelRequire("fmKqo");

var $9lrgD = parcelRequire("9lrgD");
function $96c01ad43b7c67ff$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $96c01ad43b7c67ff$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $96c01ad43b7c67ff$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $2dEyt.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $2dEyt.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $2dEyt.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $5pCmM.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $fmKqo.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $9lrgD.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $fmKqo.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $96c01ad43b7c67ff$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $goAHI.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $fmKqo.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($96c01ad43b7c67ff$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $goAHI.default)(css, breakpointsValues);
                        }
                    } else css = (0, $goAHI.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $fmKqo.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $96c01ad43b7c67ff$var$styleFunctionSx = $96c01ad43b7c67ff$export$7d53d8bf2911e013();
$96c01ad43b7c67ff$var$styleFunctionSx.filterProps = [
    "sx"
];
var $96c01ad43b7c67ff$export$2e2bcd8739ae039 = $96c01ad43b7c67ff$var$styleFunctionSx;

});
parcelRegister("9lrgD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cdb39ef25f29a59$export$2e2bcd8739ae039; });

var $iBWQv = parcelRequire("iBWQv");

var $lihJL = parcelRequire("lihJL");

var $41Z6O = parcelRequire("41Z6O");

var $9Z5Sv = parcelRequire("9Z5Sv");

var $19Fsu = parcelRequire("19Fsu");
const $6cdb39ef25f29a59$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $lihJL.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $lihJL.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $lihJL.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $lihJL.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $lihJL.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $lihJL.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $lihJL.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $9Z5Sv.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $9Z5Sv.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $9Z5Sv.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $iBWQv.padding)
    },
    pt: {
        style: (0, $iBWQv.padding)
    },
    pr: {
        style: (0, $iBWQv.padding)
    },
    pb: {
        style: (0, $iBWQv.padding)
    },
    pl: {
        style: (0, $iBWQv.padding)
    },
    px: {
        style: (0, $iBWQv.padding)
    },
    py: {
        style: (0, $iBWQv.padding)
    },
    padding: {
        style: (0, $iBWQv.padding)
    },
    paddingTop: {
        style: (0, $iBWQv.padding)
    },
    paddingRight: {
        style: (0, $iBWQv.padding)
    },
    paddingBottom: {
        style: (0, $iBWQv.padding)
    },
    paddingLeft: {
        style: (0, $iBWQv.padding)
    },
    paddingX: {
        style: (0, $iBWQv.padding)
    },
    paddingY: {
        style: (0, $iBWQv.padding)
    },
    paddingInline: {
        style: (0, $iBWQv.padding)
    },
    paddingInlineStart: {
        style: (0, $iBWQv.padding)
    },
    paddingInlineEnd: {
        style: (0, $iBWQv.padding)
    },
    paddingBlock: {
        style: (0, $iBWQv.padding)
    },
    paddingBlockStart: {
        style: (0, $iBWQv.padding)
    },
    paddingBlockEnd: {
        style: (0, $iBWQv.padding)
    },
    m: {
        style: (0, $iBWQv.margin)
    },
    mt: {
        style: (0, $iBWQv.margin)
    },
    mr: {
        style: (0, $iBWQv.margin)
    },
    mb: {
        style: (0, $iBWQv.margin)
    },
    ml: {
        style: (0, $iBWQv.margin)
    },
    mx: {
        style: (0, $iBWQv.margin)
    },
    my: {
        style: (0, $iBWQv.margin)
    },
    margin: {
        style: (0, $iBWQv.margin)
    },
    marginTop: {
        style: (0, $iBWQv.margin)
    },
    marginRight: {
        style: (0, $iBWQv.margin)
    },
    marginBottom: {
        style: (0, $iBWQv.margin)
    },
    marginLeft: {
        style: (0, $iBWQv.margin)
    },
    marginX: {
        style: (0, $iBWQv.margin)
    },
    marginY: {
        style: (0, $iBWQv.margin)
    },
    marginInline: {
        style: (0, $iBWQv.margin)
    },
    marginInlineStart: {
        style: (0, $iBWQv.margin)
    },
    marginInlineEnd: {
        style: (0, $iBWQv.margin)
    },
    marginBlock: {
        style: (0, $iBWQv.margin)
    },
    marginBlockStart: {
        style: (0, $iBWQv.margin)
    },
    marginBlockEnd: {
        style: (0, $iBWQv.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $41Z6O.gap)
    },
    rowGap: {
        style: (0, $41Z6O.rowGap)
    },
    columnGap: {
        style: (0, $41Z6O.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $19Fsu.sizingTransform)
    },
    maxWidth: {
        style: (0, $19Fsu.maxWidth)
    },
    minWidth: {
        transform: (0, $19Fsu.sizingTransform)
    },
    height: {
        transform: (0, $19Fsu.sizingTransform)
    },
    maxHeight: {
        transform: (0, $19Fsu.sizingTransform)
    },
    minHeight: {
        transform: (0, $19Fsu.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $6cdb39ef25f29a59$export$2e2bcd8739ae039 = $6cdb39ef25f29a59$var$defaultSxConfig;

});
parcelRegister("lihJL", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $f80909a8a8befe05$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $f80909a8a8befe05$export$7a57f79000377ca2; });


var $2dEyt = parcelRequire("2dEyt");

var $hYCCH = parcelRequire("hYCCH");

var $iBWQv = parcelRequire("iBWQv");

var $fmKqo = parcelRequire("fmKqo");
function $f80909a8a8befe05$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $f80909a8a8befe05$var$createBorderStyle(prop, transform) {
    return (0, $2dEyt.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $f80909a8a8befe05$export$1edee58a52776cd9 = $f80909a8a8befe05$var$createBorderStyle("border", $f80909a8a8befe05$export$34e2febe53ae29cc);
const $f80909a8a8befe05$export$f9a7b6bd24892946 = $f80909a8a8befe05$var$createBorderStyle("borderTop", $f80909a8a8befe05$export$34e2febe53ae29cc);
const $f80909a8a8befe05$export$5abca33e6be905d2 = $f80909a8a8befe05$var$createBorderStyle("borderRight", $f80909a8a8befe05$export$34e2febe53ae29cc);
const $f80909a8a8befe05$export$e2ce9f12a980a822 = $f80909a8a8befe05$var$createBorderStyle("borderBottom", $f80909a8a8befe05$export$34e2febe53ae29cc);
const $f80909a8a8befe05$export$47658cca1a909427 = $f80909a8a8befe05$var$createBorderStyle("borderLeft", $f80909a8a8befe05$export$34e2febe53ae29cc);
const $f80909a8a8befe05$export$e7fb0694ba2404fc = $f80909a8a8befe05$var$createBorderStyle("borderColor");
const $f80909a8a8befe05$export$126a92c968acdb85 = $f80909a8a8befe05$var$createBorderStyle("borderTopColor");
const $f80909a8a8befe05$export$85cc51cb8fbb8c0e = $f80909a8a8befe05$var$createBorderStyle("borderRightColor");
const $f80909a8a8befe05$export$340b0327727f6d1a = $f80909a8a8befe05$var$createBorderStyle("borderBottomColor");
const $f80909a8a8befe05$export$60beef91a985b4bf = $f80909a8a8befe05$var$createBorderStyle("borderLeftColor");
const $f80909a8a8befe05$export$f9258c55612cbed7 = $f80909a8a8befe05$var$createBorderStyle("outline", $f80909a8a8befe05$export$34e2febe53ae29cc);
const $f80909a8a8befe05$export$621fe586efeb64b9 = $f80909a8a8befe05$var$createBorderStyle("outlineColor");
const $f80909a8a8befe05$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $iBWQv.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $iBWQv.getValue)(transformer, propValue)
            });
        return (0, $fmKqo.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$f80909a8a8befe05$export$7a57f79000377ca2.propTypes = {};
$f80909a8a8befe05$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $f80909a8a8befe05$var$borders = (0, $hYCCH.default)($f80909a8a8befe05$export$1edee58a52776cd9, $f80909a8a8befe05$export$f9a7b6bd24892946, $f80909a8a8befe05$export$5abca33e6be905d2, $f80909a8a8befe05$export$e2ce9f12a980a822, $f80909a8a8befe05$export$47658cca1a909427, $f80909a8a8befe05$export$e7fb0694ba2404fc, $f80909a8a8befe05$export$126a92c968acdb85, $f80909a8a8befe05$export$85cc51cb8fbb8c0e, $f80909a8a8befe05$export$340b0327727f6d1a, $f80909a8a8befe05$export$60beef91a985b4bf, $f80909a8a8befe05$export$7a57f79000377ca2, $f80909a8a8befe05$export$f9258c55612cbed7, $f80909a8a8befe05$export$621fe586efeb64b9);
var $f80909a8a8befe05$export$2e2bcd8739ae039 = $f80909a8a8befe05$var$borders;

});
parcelRegister("hYCCH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1660001eaf637a2$export$2e2bcd8739ae039; });

var $goAHI = parcelRequire("goAHI");
function $d1660001eaf637a2$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $goAHI.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $d1660001eaf637a2$export$2e2bcd8739ae039 = $d1660001eaf637a2$var$compose;

});


parcelRegister("41Z6O", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $2ef6a85a030ad1a8$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $2ef6a85a030ad1a8$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $2ef6a85a030ad1a8$export$8a833ffa5f5dbeda; });

var $2dEyt = parcelRequire("2dEyt");

var $hYCCH = parcelRequire("hYCCH");

var $iBWQv = parcelRequire("iBWQv");

var $fmKqo = parcelRequire("fmKqo");

const $2ef6a85a030ad1a8$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $iBWQv.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $iBWQv.getValue)(transformer, propValue)
            });
        return (0, $fmKqo.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$2ef6a85a030ad1a8$export$5df9adcb0db95e1e.propTypes = {};
$2ef6a85a030ad1a8$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $2ef6a85a030ad1a8$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $iBWQv.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $iBWQv.getValue)(transformer, propValue)
            });
        return (0, $fmKqo.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$2ef6a85a030ad1a8$export$ec60d70ff941a580.propTypes = {};
$2ef6a85a030ad1a8$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $2ef6a85a030ad1a8$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $iBWQv.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $iBWQv.getValue)(transformer, propValue)
            });
        return (0, $fmKqo.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$2ef6a85a030ad1a8$export$8a833ffa5f5dbeda.propTypes = {};
$2ef6a85a030ad1a8$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $2ef6a85a030ad1a8$export$baf44164ca3a34e8 = (0, $2dEyt.default)({
    prop: "gridColumn"
});
const $2ef6a85a030ad1a8$export$8f7213a1cd01e832 = (0, $2dEyt.default)({
    prop: "gridRow"
});
const $2ef6a85a030ad1a8$export$b0e0abbc49ba668 = (0, $2dEyt.default)({
    prop: "gridAutoFlow"
});
const $2ef6a85a030ad1a8$export$bcd8b929d4b4142 = (0, $2dEyt.default)({
    prop: "gridAutoColumns"
});
const $2ef6a85a030ad1a8$export$e5039a674e14c828 = (0, $2dEyt.default)({
    prop: "gridAutoRows"
});
const $2ef6a85a030ad1a8$export$42bd9088661ffb03 = (0, $2dEyt.default)({
    prop: "gridTemplateColumns"
});
const $2ef6a85a030ad1a8$export$920682ae05b999bc = (0, $2dEyt.default)({
    prop: "gridTemplateRows"
});
const $2ef6a85a030ad1a8$export$1b88fbdd482fd33a = (0, $2dEyt.default)({
    prop: "gridTemplateAreas"
});
const $2ef6a85a030ad1a8$export$bdb486e40d52d26f = (0, $2dEyt.default)({
    prop: "gridArea"
});
const $2ef6a85a030ad1a8$var$grid = (0, $hYCCH.default)($2ef6a85a030ad1a8$export$5df9adcb0db95e1e, $2ef6a85a030ad1a8$export$ec60d70ff941a580, $2ef6a85a030ad1a8$export$8a833ffa5f5dbeda, $2ef6a85a030ad1a8$export$baf44164ca3a34e8, $2ef6a85a030ad1a8$export$8f7213a1cd01e832, $2ef6a85a030ad1a8$export$b0e0abbc49ba668, $2ef6a85a030ad1a8$export$bcd8b929d4b4142, $2ef6a85a030ad1a8$export$e5039a674e14c828, $2ef6a85a030ad1a8$export$42bd9088661ffb03, $2ef6a85a030ad1a8$export$920682ae05b999bc, $2ef6a85a030ad1a8$export$1b88fbdd482fd33a, $2ef6a85a030ad1a8$export$bdb486e40d52d26f);
var $2ef6a85a030ad1a8$export$2e2bcd8739ae039 = $2ef6a85a030ad1a8$var$grid;

});

parcelRegister("9Z5Sv", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $744e5ed516790014$export$dbaffd4420ea0ac6; });

var $2dEyt = parcelRequire("2dEyt");

var $hYCCH = parcelRequire("hYCCH");
function $744e5ed516790014$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $744e5ed516790014$export$35e9368ef982300f = (0, $2dEyt.default)({
    prop: "color",
    themeKey: "palette",
    transform: $744e5ed516790014$export$dbaffd4420ea0ac6
});
const $744e5ed516790014$export$2506f56c10355b33 = (0, $2dEyt.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $744e5ed516790014$export$dbaffd4420ea0ac6
});
const $744e5ed516790014$export$8c5a050822fd698c = (0, $2dEyt.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $744e5ed516790014$export$dbaffd4420ea0ac6
});
const $744e5ed516790014$var$palette = (0, $hYCCH.default)($744e5ed516790014$export$35e9368ef982300f, $744e5ed516790014$export$2506f56c10355b33, $744e5ed516790014$export$8c5a050822fd698c);
var $744e5ed516790014$export$2e2bcd8739ae039 = $744e5ed516790014$var$palette;

});

parcelRegister("19Fsu", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $0d76ca8026d44e10$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $0d76ca8026d44e10$export$488fda99655ff65a; });

var $2dEyt = parcelRequire("2dEyt");

var $hYCCH = parcelRequire("hYCCH");

var $fmKqo = parcelRequire("fmKqo");
function $0d76ca8026d44e10$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $0d76ca8026d44e10$export$7e3df82ee760448c = (0, $2dEyt.default)({
    prop: "width",
    transform: $0d76ca8026d44e10$export$8afece71750ec241
});
const $0d76ca8026d44e10$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $fmKqo.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $0d76ca8026d44e10$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $fmKqo.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$0d76ca8026d44e10$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $0d76ca8026d44e10$export$ee148fbbe8357dd2 = (0, $2dEyt.default)({
    prop: "minWidth",
    transform: $0d76ca8026d44e10$export$8afece71750ec241
});
const $0d76ca8026d44e10$export$ac607276a8fe9f0a = (0, $2dEyt.default)({
    prop: "height",
    transform: $0d76ca8026d44e10$export$8afece71750ec241
});
const $0d76ca8026d44e10$export$dc0d8bd0b94f8570 = (0, $2dEyt.default)({
    prop: "maxHeight",
    transform: $0d76ca8026d44e10$export$8afece71750ec241
});
const $0d76ca8026d44e10$export$a43cf604e12f3b17 = (0, $2dEyt.default)({
    prop: "minHeight",
    transform: $0d76ca8026d44e10$export$8afece71750ec241
});
const $0d76ca8026d44e10$export$ffed9f14fb65e276 = (0, $2dEyt.default)({
    prop: "size",
    cssProperty: "width",
    transform: $0d76ca8026d44e10$export$8afece71750ec241
});
const $0d76ca8026d44e10$export$905076ed6620e671 = (0, $2dEyt.default)({
    prop: "size",
    cssProperty: "height",
    transform: $0d76ca8026d44e10$export$8afece71750ec241
});
const $0d76ca8026d44e10$export$6ccc93f785106a58 = (0, $2dEyt.default)({
    prop: "boxSizing"
});
const $0d76ca8026d44e10$var$sizing = (0, $hYCCH.default)($0d76ca8026d44e10$export$7e3df82ee760448c, $0d76ca8026d44e10$export$488fda99655ff65a, $0d76ca8026d44e10$export$ee148fbbe8357dd2, $0d76ca8026d44e10$export$ac607276a8fe9f0a, $0d76ca8026d44e10$export$dc0d8bd0b94f8570, $0d76ca8026d44e10$export$a43cf604e12f3b17, $0d76ca8026d44e10$export$6ccc93f785106a58);
var $0d76ca8026d44e10$export$2e2bcd8739ae039 = $0d76ca8026d44e10$var$sizing;

});



parcelRegister("iGE4k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9ab3b178497ab8b$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $d9ab3b178497ab8b$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("jGOpJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5590bc3e243cc3c$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $5pCmM = parcelRequire("5pCmM");
const $e5590bc3e243cc3c$var$_excluded = [
    "variant"
];
function $e5590bc3e243cc3c$var$isEmpty(string) {
    return string.length === 0;
}
function $e5590bc3e243cc3c$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $hCIyK.default)(props, $e5590bc3e243cc3c$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $e5590bc3e243cc3c$var$isEmpty(classKey) ? props[key] : (0, $5pCmM.default)(props[key]);
        else classKey += `${$e5590bc3e243cc3c$var$isEmpty(classKey) ? key : (0, $5pCmM.default)(key)}${(0, $5pCmM.default)(props[key].toString())}`;
    });
    return classKey;
}

});


parcelRegister("OFmxN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0984c161637848f6$export$2e2bcd8739ae039; });

var $gcMmG = parcelRequire("gcMmG");
"use client";
const $0984c161637848f6$var$defaultTheme = (0, $gcMmG.default)();
var $0984c161637848f6$export$2e2bcd8739ae039 = $0984c161637848f6$var$defaultTheme;

});
parcelRegister("gcMmG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcc348908a7dde4d$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $avV9A = parcelRequire("avV9A");

var $5syur = parcelRequire("5syur");

var $eWibl = parcelRequire("eWibl");
var $9lrgD = parcelRequire("9lrgD");
var $cWrkM = parcelRequire("cWrkM");


var $c8wlJ = parcelRequire("c8wlJ");

var $cjMfd = parcelRequire("cjMfd");

var $aXVsf = parcelRequire("aXVsf");

var $jyjJu = parcelRequire("jyjJu");

var $4SKzm = parcelRequire("4SKzm");

var $cVDai = parcelRequire("cVDai");
const $bcc348908a7dde4d$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $bcc348908a7dde4d$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $hCIyK.default)(options, $bcc348908a7dde4d$var$_excluded);
    if (options.vars) throw new Error((0, $avV9A.default)(18));
    const palette = (0, $cjMfd.default)(paletteInput);
    const systemTheme = (0, $eWibl.default)(options);
    let muiTheme = (0, $5syur.default)(systemTheme, {
        mixins: (0, $c8wlJ.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $jyjJu.default).slice(),
        typography: (0, $aXVsf.default)(palette, typographyInput),
        transitions: (0, $4SKzm.default)(transitionsInput),
        zIndex: (0, $4WYaH.default)({}, (0, $cVDai.default))
    });
    muiTheme = (0, $5syur.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $5syur.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $4WYaH.default)({}, (0, $9lrgD.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $cWrkM.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $bcc348908a7dde4d$var$warnedOnce = false;
function $bcc348908a7dde4d$export$c469355549431d9b(...args) {
    return $bcc348908a7dde4d$var$createTheme(...args);
}
var $bcc348908a7dde4d$export$2e2bcd8739ae039 = $bcc348908a7dde4d$var$createTheme;

});
parcelRegister("c8wlJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d5f535890108345$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");
function $8d5f535890108345$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $4WYaH.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("cjMfd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f7caeba5148dee4$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $avV9A = parcelRequire("avV9A");

var $5syur = parcelRequire("5syur");

var $cs0Pg = parcelRequire("cs0Pg");

var $7O7iL = parcelRequire("7O7iL");

var $8KKZ9 = parcelRequire("8KKZ9");

var $7KujM = parcelRequire("7KujM");

var $kJEL4 = parcelRequire("kJEL4");

var $bjzVt = parcelRequire("bjzVt");

var $gmWj5 = parcelRequire("gmWj5");

var $2hpx0 = parcelRequire("2hpx0");

var $bLCV4 = parcelRequire("bLCV4");
const $8f7caeba5148dee4$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $8f7caeba5148dee4$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $7O7iL.default).white,
        default: (0, $7O7iL.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $8f7caeba5148dee4$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $7O7iL.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $7O7iL.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $8f7caeba5148dee4$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $cs0Pg.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $cs0Pg.darken)(intent.main, tonalOffsetDark);
    }
}
function $8f7caeba5148dee4$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $gmWj5.default)[200],
        light: (0, $gmWj5.default)[50],
        dark: (0, $gmWj5.default)[400]
    };
    return {
        main: (0, $gmWj5.default)[700],
        light: (0, $gmWj5.default)[400],
        dark: (0, $gmWj5.default)[800]
    };
}
function $8f7caeba5148dee4$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $7KujM.default)[200],
        light: (0, $7KujM.default)[50],
        dark: (0, $7KujM.default)[400]
    };
    return {
        main: (0, $7KujM.default)[500],
        light: (0, $7KujM.default)[300],
        dark: (0, $7KujM.default)[700]
    };
}
function $8f7caeba5148dee4$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $kJEL4.default)[500],
        light: (0, $kJEL4.default)[300],
        dark: (0, $kJEL4.default)[700]
    };
    return {
        main: (0, $kJEL4.default)[700],
        light: (0, $kJEL4.default)[400],
        dark: (0, $kJEL4.default)[800]
    };
}
function $8f7caeba5148dee4$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $2hpx0.default)[400],
        light: (0, $2hpx0.default)[300],
        dark: (0, $2hpx0.default)[700]
    };
    return {
        main: (0, $2hpx0.default)[700],
        light: (0, $2hpx0.default)[500],
        dark: (0, $2hpx0.default)[900]
    };
}
function $8f7caeba5148dee4$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bLCV4.default)[400],
        light: (0, $bLCV4.default)[300],
        dark: (0, $bLCV4.default)[700]
    };
    return {
        main: (0, $bLCV4.default)[800],
        light: (0, $bLCV4.default)[500],
        dark: (0, $bLCV4.default)[900]
    };
}
function $8f7caeba5148dee4$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bjzVt.default)[400],
        light: (0, $bjzVt.default)[300],
        dark: (0, $bjzVt.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $bjzVt.default)[500],
        dark: (0, $bjzVt.default)[900]
    };
}
function $8f7caeba5148dee4$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $hCIyK.default)(palette, $8f7caeba5148dee4$var$_excluded);
    const primary = palette.primary || $8f7caeba5148dee4$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $8f7caeba5148dee4$var$getDefaultSecondary(mode);
    const error = palette.error || $8f7caeba5148dee4$var$getDefaultError(mode);
    const info = palette.info || $8f7caeba5148dee4$var$getDefaultInfo(mode);
    const success = palette.success || $8f7caeba5148dee4$var$getDefaultSuccess(mode);
    const warning = palette.warning || $8f7caeba5148dee4$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $cs0Pg.getContrastRatio)(background, $8f7caeba5148dee4$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $8f7caeba5148dee4$export$55ce6f3a06c59543.text.primary : $8f7caeba5148dee4$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $4WYaH.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $avV9A.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $avV9A.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $8f7caeba5148dee4$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $8f7caeba5148dee4$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $8f7caeba5148dee4$export$55ce6f3a06c59543,
        light: $8f7caeba5148dee4$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $5syur.default)((0, $4WYaH.default)({
        // A collection of common colors.
        common: (0, $4WYaH.default)({}, (0, $7O7iL.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $8KKZ9.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("7O7iL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5af2ddd86bb7d498$export$2e2bcd8739ae039; });
const $5af2ddd86bb7d498$var$common = {
    black: "#000",
    white: "#fff"
};
var $5af2ddd86bb7d498$export$2e2bcd8739ae039 = $5af2ddd86bb7d498$var$common;

});

parcelRegister("8KKZ9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65f710e911b7292d$export$2e2bcd8739ae039; });
const $65f710e911b7292d$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $65f710e911b7292d$export$2e2bcd8739ae039 = $65f710e911b7292d$var$grey;

});

parcelRegister("7KujM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a4458d5f7fc7bf6$export$2e2bcd8739ae039; });
const $5a4458d5f7fc7bf6$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $5a4458d5f7fc7bf6$export$2e2bcd8739ae039 = $5a4458d5f7fc7bf6$var$purple;

});

parcelRegister("kJEL4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f187a05573202cce$export$2e2bcd8739ae039; });
const $f187a05573202cce$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $f187a05573202cce$export$2e2bcd8739ae039 = $f187a05573202cce$var$red;

});

parcelRegister("bjzVt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83cd563b25e0fd36$export$2e2bcd8739ae039; });
const $83cd563b25e0fd36$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $83cd563b25e0fd36$export$2e2bcd8739ae039 = $83cd563b25e0fd36$var$orange;

});

parcelRegister("gmWj5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $beabedf7811f9d48$export$2e2bcd8739ae039; });
const $beabedf7811f9d48$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $beabedf7811f9d48$export$2e2bcd8739ae039 = $beabedf7811f9d48$var$blue;

});

parcelRegister("2hpx0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a90f95089dd0c31$export$2e2bcd8739ae039; });
const $1a90f95089dd0c31$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $1a90f95089dd0c31$export$2e2bcd8739ae039 = $1a90f95089dd0c31$var$lightBlue;

});

parcelRegister("bLCV4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $891246157fd9d9c5$export$2e2bcd8739ae039; });
const $891246157fd9d9c5$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $891246157fd9d9c5$export$2e2bcd8739ae039 = $891246157fd9d9c5$var$green;

});


parcelRegister("aXVsf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fbbfb5695036e2b$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $5syur = parcelRequire("5syur");
const $7fbbfb5695036e2b$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $7fbbfb5695036e2b$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $7fbbfb5695036e2b$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $7fbbfb5695036e2b$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $7fbbfb5695036e2b$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $7fbbfb5695036e2b$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $hCIyK.default)(_ref, $7fbbfb5695036e2b$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $4WYaH.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $7fbbfb5695036e2b$var$defaultFontFamily ? {
            letterSpacing: `${$7fbbfb5695036e2b$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $7fbbfb5695036e2b$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $7fbbfb5695036e2b$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $5syur.default)((0, $4WYaH.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jyjJu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3c07fd261e20251$export$2e2bcd8739ae039; });
const $e3c07fd261e20251$var$shadowKeyUmbraOpacity = 0.2;
const $e3c07fd261e20251$var$shadowKeyPenumbraOpacity = 0.14;
const $e3c07fd261e20251$var$shadowAmbientShadowOpacity = 0.12;
function $e3c07fd261e20251$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e3c07fd261e20251$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e3c07fd261e20251$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e3c07fd261e20251$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e3c07fd261e20251$var$shadows = [
    "none",
    $e3c07fd261e20251$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e3c07fd261e20251$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e3c07fd261e20251$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e3c07fd261e20251$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e3c07fd261e20251$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e3c07fd261e20251$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e3c07fd261e20251$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e3c07fd261e20251$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e3c07fd261e20251$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e3c07fd261e20251$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e3c07fd261e20251$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e3c07fd261e20251$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e3c07fd261e20251$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e3c07fd261e20251$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e3c07fd261e20251$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e3c07fd261e20251$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e3c07fd261e20251$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e3c07fd261e20251$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e3c07fd261e20251$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e3c07fd261e20251$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e3c07fd261e20251$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e3c07fd261e20251$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e3c07fd261e20251$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e3c07fd261e20251$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e3c07fd261e20251$export$2e2bcd8739ae039 = $e3c07fd261e20251$var$shadows;

});

parcelRegister("4SKzm", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $38e05443f54e4c38$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $38e05443f54e4c38$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");
const $38e05443f54e4c38$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $38e05443f54e4c38$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $38e05443f54e4c38$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $38e05443f54e4c38$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $38e05443f54e4c38$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $38e05443f54e4c38$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $4WYaH.default)({}, $38e05443f54e4c38$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $4WYaH.default)({}, $38e05443f54e4c38$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $hCIyK.default)(options, $38e05443f54e4c38$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $38e05443f54e4c38$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $38e05443f54e4c38$var$formatMs(delay)}`).join(",");
    };
    return (0, $4WYaH.default)({
        getAutoHeightDuration: $38e05443f54e4c38$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("cVDai", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9699304106843fdd$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $9699304106843fdd$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $9699304106843fdd$export$2e2bcd8739ae039 = $9699304106843fdd$var$zIndex;

});



parcelRegister("wllwT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06138c31a4420582$export$2e2bcd8739ae039; });
var $06138c31a4420582$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("cNBED", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9517450a96abd5a0$export$2e2bcd8739ae039; });

var $fdBjp = parcelRequire("fdBjp");

var $OFmxN = parcelRequire("OFmxN");

var $wllwT = parcelRequire("wllwT");
"use client";
function $9517450a96abd5a0$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $fdBjp.default)({
        props: props,
        name: name,
        defaultTheme: $OFmxN.default,
        themeId: (0, $wllwT.default)
    });
}

});
parcelRegister("fdBjp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1450348cea73e40$export$2e2bcd8739ae039; });

var $1ZZi7 = parcelRequire("1ZZi7");

var $2ox07 = parcelRequire("2ox07");
"use client";
function $b1450348cea73e40$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $2ox07.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $1ZZi7.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("1ZZi7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $174b08215d272674$export$2e2bcd8739ae039; });

var $e0O1m = parcelRequire("e0O1m");
function $174b08215d272674$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $e0O1m.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("e0O1m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a337dde2edf8b2e6$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");
function $a337dde2edf8b2e6$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $4WYaH.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $4WYaH.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $4WYaH.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $a337dde2edf8b2e6$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("2ox07", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1be76beeb15c2bd7$export$2e2bcd8739ae039; });

var $eWibl = parcelRequire("eWibl");

var $2Sd76 = parcelRequire("2Sd76");
"use client";
const $1be76beeb15c2bd7$export$35e57303dbd8a66 = (0, $eWibl.default)();
function $1be76beeb15c2bd7$var$useTheme(defaultTheme = $1be76beeb15c2bd7$export$35e57303dbd8a66) {
    return (0, $2Sd76.default)(defaultTheme);
}
var $1be76beeb15c2bd7$export$2e2bcd8739ae039 = $1be76beeb15c2bd7$var$useTheme;

});
parcelRegister("2Sd76", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $217acbfafe430ddb$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("fPZvG");
var $62brB = parcelRequire("62brB");
"use client";
function $217acbfafe430ddb$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $217acbfafe430ddb$var$useTheme(defaultTheme = null) {
    const contextTheme = $bh6RR.useContext((0, $62brB.T));
    return !contextTheme || $217acbfafe430ddb$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $217acbfafe430ddb$export$2e2bcd8739ae039 = $217acbfafe430ddb$var$useTheme;

});




parcelRegister("aEoM0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c10db4061610272$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $erAkb = parcelRequire("erAkb");

var $8M7SI = parcelRequire("8M7SI");

var $kVG1h = parcelRequire("kVG1h");

var $h0tYH = parcelRequire("h0tYH");

var $3jw06 = parcelRequire("3jw06");

var $ih19M = parcelRequire("ih19M");
"use client";
const $7c10db4061610272$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $7c10db4061610272$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $3jw06.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $7c10db4061610272$export$7ec0dcc5e3cdcd36 = (0, $g4l1t.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $3jw06.default).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $7c10db4061610272$var$ButtonBase = /*#__PURE__*/ $bh6RR.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $hCIyK.default)(props, $7c10db4061610272$var$_excluded);
    const buttonRef = $bh6RR.useRef(null);
    const rippleRef = $bh6RR.useRef(null);
    const handleRippleRef = (0, $erAkb.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $kVG1h.default)();
    const [focusVisible, setFocusVisible] = $bh6RR.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $bh6RR.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $bh6RR.useState(false);
    $bh6RR.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $bh6RR.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $8M7SI.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $8M7SI.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $bh6RR.useRef(false);
    const handleKeyDown = (0, $8M7SI.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $8M7SI.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $erAkb.default)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $4WYaH.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $7c10db4061610272$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($7c10db4061610272$export$7ec0dcc5e3cdcd36, (0, $4WYaH.default)({
        as: ComponentProp,
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $ih19M.jsx)((0, $h0tYH.default), (0, $4WYaH.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $7c10db4061610272$export$2e2bcd8739ae039 = $7c10db4061610272$var$ButtonBase;

});
parcelRegister("erAkb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a83fc3979212c585$export$2e2bcd8739ae039; });

var $6RXey = parcelRequire("6RXey");
"use client";
var $a83fc3979212c585$export$2e2bcd8739ae039 = (0, $6RXey.default);

});
parcelRegister("6RXey", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5005a3e0d996687a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $faL5S = parcelRequire("faL5S");
"use client";
function $5005a3e0d996687a$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $bh6RR.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $faL5S.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRegister("faL5S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0bc520ed4d58057$export$2e2bcd8739ae039; });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $b0bc520ed4d58057$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});



parcelRegister("8M7SI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6638eb82ff2b4a1f$export$2e2bcd8739ae039; });

var $87bEd = parcelRequire("87bEd");
"use client";
var $6638eb82ff2b4a1f$export$2e2bcd8739ae039 = (0, $87bEd.default);

});
parcelRegister("87bEd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e880324b7e05325$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $kLukk = parcelRequire("kLukk");
"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $5e880324b7e05325$var$useEventCallback(fn) {
    const ref = $bh6RR.useRef(fn);
    (0, $kLukk.default)(()=>{
        ref.current = fn;
    });
    return $bh6RR.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $5e880324b7e05325$export$2e2bcd8739ae039 = $5e880324b7e05325$var$useEventCallback;

});
parcelRegister("kLukk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1dfb8b2cafe41bb$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $f1dfb8b2cafe41bb$var$useEnhancedEffect = typeof window !== "undefined" ? $bh6RR.useLayoutEffect : $bh6RR.useEffect;
var $f1dfb8b2cafe41bb$export$2e2bcd8739ae039 = $f1dfb8b2cafe41bb$var$useEnhancedEffect;

});



parcelRegister("kVG1h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3c9b9c4f8ebb7e8$export$2e2bcd8739ae039; });

var $1t1Ky = parcelRequire("1t1Ky");
"use client";
var $f3c9b9c4f8ebb7e8$export$2e2bcd8739ae039 = (0, $1t1Ky.default);

});
parcelRegister("1t1Ky", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1119db5bc288513a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $c3mIq = parcelRequire("c3mIq");
"use client";
let $1119db5bc288513a$var$hadKeyboardEvent = true;
let $1119db5bc288513a$var$hadFocusVisibleRecently = false;
const $1119db5bc288513a$var$hadFocusVisibleRecentlyTimeout = new (0, $c3mIq.Timeout)();
const $1119db5bc288513a$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $1119db5bc288513a$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $1119db5bc288513a$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $1119db5bc288513a$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $1119db5bc288513a$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $1119db5bc288513a$var$handlePointerDown() {
    $1119db5bc288513a$var$hadKeyboardEvent = false;
}
function $1119db5bc288513a$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($1119db5bc288513a$var$hadFocusVisibleRecently) $1119db5bc288513a$var$hadKeyboardEvent = true;
    }
}
function $1119db5bc288513a$var$prepare(doc) {
    doc.addEventListener("keydown", $1119db5bc288513a$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $1119db5bc288513a$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $1119db5bc288513a$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $1119db5bc288513a$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $1119db5bc288513a$var$handleVisibilityChange, true);
}
function $1119db5bc288513a$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $1119db5bc288513a$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $1119db5bc288513a$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $1119db5bc288513a$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $1119db5bc288513a$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $1119db5bc288513a$var$handleVisibilityChange, true);
}
function $1119db5bc288513a$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $1119db5bc288513a$var$hadKeyboardEvent || $1119db5bc288513a$var$focusTriggersKeyboardModality(target);
}
function $1119db5bc288513a$export$2e2bcd8739ae039() {
    const ref = $bh6RR.useCallback((node)=>{
        if (node != null) $1119db5bc288513a$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $bh6RR.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $1119db5bc288513a$var$hadFocusVisibleRecently = true;
            $1119db5bc288513a$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $1119db5bc288513a$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($1119db5bc288513a$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}

});
parcelRegister("c3mIq", function(module, exports) {

$parcel$export(module.exports, "Timeout", function () { return $8c6762aec7cc866c$export$786b4da70f00938b; });
$parcel$export(module.exports, "default", function () { return $8c6762aec7cc866c$export$2e2bcd8739ae039; });

var $edp8o = parcelRequire("edp8o");

var $jUDOC = parcelRequire("jUDOC");
"use client";
class $8c6762aec7cc866c$export$786b4da70f00938b {
    constructor(){
        this.currentId = 0;
        this.clear = ()=>{
            if (this.currentId !== 0) {
                clearTimeout(this.currentId);
                this.currentId = 0;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $8c6762aec7cc866c$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = 0;
            fn();
        }, delay);
    }
}
function $8c6762aec7cc866c$export$2e2bcd8739ae039() {
    const timeout = (0, $edp8o.default)($8c6762aec7cc866c$export$786b4da70f00938b.create).current;
    (0, $jUDOC.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("edp8o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a595c6c315f57376$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
const $a595c6c315f57376$var$UNINITIALIZED = {};
function $a595c6c315f57376$export$2e2bcd8739ae039(init, initArg) {
    const ref = $bh6RR.useRef($a595c6c315f57376$var$UNINITIALIZED);
    if (ref.current === $a595c6c315f57376$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});

parcelRegister("jUDOC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7f221d2eaddb322$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
const $e7f221d2eaddb322$var$EMPTY = [];
function $e7f221d2eaddb322$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $bh6RR.useEffect(fn, $e7f221d2eaddb322$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});




parcelRegister("h0tYH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c619b0c04884f58c$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $b4M93 = parcelRequire("b4M93");

var $aPsoC = parcelRequire("aPsoC");

var $fPZvG = parcelRequire("fPZvG");

var $c3mIq = parcelRequire("c3mIq");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $ixTys = parcelRequire("ixTys");

var $e7JbL = parcelRequire("e7JbL");

var $ih19M = parcelRequire("ih19M");
"use client";
const $c619b0c04884f58c$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $c619b0c04884f58c$var$_ = (t)=>t, $c619b0c04884f58c$var$_t, $c619b0c04884f58c$var$_t2, $c619b0c04884f58c$var$_t3, $c619b0c04884f58c$var$_t4;
const $c619b0c04884f58c$var$DURATION = 550;
const $c619b0c04884f58c$export$95d0c9356b2231a3 = 80;
const $c619b0c04884f58c$var$enterKeyframe = (0, $fPZvG.keyframes)($c619b0c04884f58c$var$_t || ($c619b0c04884f58c$var$_t = $c619b0c04884f58c$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $c619b0c04884f58c$var$exitKeyframe = (0, $fPZvG.keyframes)($c619b0c04884f58c$var$_t2 || ($c619b0c04884f58c$var$_t2 = $c619b0c04884f58c$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $c619b0c04884f58c$var$pulsateKeyframe = (0, $fPZvG.keyframes)($c619b0c04884f58c$var$_t3 || ($c619b0c04884f58c$var$_t3 = $c619b0c04884f58c$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $c619b0c04884f58c$export$f6b7418508c72c25 = (0, $g4l1t.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $c619b0c04884f58c$export$676cfe7b12693c4b = (0, $g4l1t.default)((0, $ixTys.default), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($c619b0c04884f58c$var$_t4 || ($c619b0c04884f58c$var$_t4 = $c619b0c04884f58c$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $e7JbL.default).rippleVisible, $c619b0c04884f58c$var$enterKeyframe, $c619b0c04884f58c$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $e7JbL.default).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $e7JbL.default).child, (0, $e7JbL.default).childLeaving, $c619b0c04884f58c$var$exitKeyframe, $c619b0c04884f58c$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $e7JbL.default).childPulsate, $c619b0c04884f58c$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $c619b0c04884f58c$var$TouchRipple = /*#__PURE__*/ $bh6RR.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $hCIyK.default)(props, $c619b0c04884f58c$var$_excluded);
    const [ripples, setRipples] = $bh6RR.useState([]);
    const nextKey = $bh6RR.useRef(0);
    const rippleCallback = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $bh6RR.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $c3mIq.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $bh6RR.useRef(null);
    const container = $bh6RR.useRef(null);
    const startCommit = $bh6RR.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ih19M.jsx)($c619b0c04884f58c$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $aPsoC.default)(classes.ripple, (0, $e7JbL.default).ripple),
                        rippleVisible: (0, $aPsoC.default)(classes.rippleVisible, (0, $e7JbL.default).rippleVisible),
                        ripplePulsate: (0, $aPsoC.default)(classes.ripplePulsate, (0, $e7JbL.default).ripplePulsate),
                        child: (0, $aPsoC.default)(classes.child, (0, $e7JbL.default).child),
                        childLeaving: (0, $aPsoC.default)(classes.childLeaving, (0, $e7JbL.default).childLeaving),
                        childPulsate: (0, $aPsoC.default)(classes.childPulsate, (0, $e7JbL.default).childPulsate)
                    },
                    timeout: $c619b0c04884f58c$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $bh6RR.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($c619b0c04884f58c$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $bh6RR.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $bh6RR.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $bh6RR.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($c619b0c04884f58c$export$f6b7418508c72c25, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)((0, $e7JbL.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b4M93.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $c619b0c04884f58c$export$2e2bcd8739ae039 = $c619b0c04884f58c$var$TouchRipple;

});
parcelRegister("b4M93", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81056a06f149e948$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $hqR4t = parcelRequire("hqR4t");

var $gMqD6 = parcelRequire("gMqD6");


var $bh6RR = parcelRequire("bh6RR");

var $8kMIo = parcelRequire("8kMIo");

var $7V1lg = parcelRequire("7V1lg");
var $81056a06f149e948$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $81056a06f149e948$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $81056a06f149e948$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $hqR4t.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $7V1lg.getInitialChildMapping)(nextProps, handleExited) : (0, $7V1lg.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $7V1lg.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $4WYaH.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $hCIyK.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $81056a06f149e948$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8kMIo.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8kMIo.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$81056a06f149e948$var$TransitionGroup.propTypes = {};
$81056a06f149e948$var$TransitionGroup.defaultProps = $81056a06f149e948$var$defaultProps;
var $81056a06f149e948$export$2e2bcd8739ae039 = $81056a06f149e948$var$TransitionGroup;

});
parcelRegister("8kMIo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6115fac47ad01008$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
var $6115fac47ad01008$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);

});

parcelRegister("7V1lg", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $5c3ee5c66b2de9ae$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $5c3ee5c66b2de9ae$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $5c3ee5c66b2de9ae$export$36fd1af28d383ec0; });

var $bh6RR = parcelRequire("bh6RR");
function $5c3ee5c66b2de9ae$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $bh6RR.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $bh6RR.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $5c3ee5c66b2de9ae$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $5c3ee5c66b2de9ae$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $5c3ee5c66b2de9ae$export$fa71e2345c31d7a2(props, onExited) {
    return $5c3ee5c66b2de9ae$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $bh6RR.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $5c3ee5c66b2de9ae$var$getProp(child, "appear", props),
            enter: $5c3ee5c66b2de9ae$var$getProp(child, "enter", props),
            exit: $5c3ee5c66b2de9ae$var$getProp(child, "exit", props)
        });
    });
}
function $5c3ee5c66b2de9ae$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $5c3ee5c66b2de9ae$export$bbc8a025727ea824(nextProps.children);
    var children = $5c3ee5c66b2de9ae$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $bh6RR.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $bh6RR.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $bh6RR.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $5c3ee5c66b2de9ae$var$getProp(child, "exit", nextProps),
            enter: $5c3ee5c66b2de9ae$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $bh6RR.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $bh6RR.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $bh6RR.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $5c3ee5c66b2de9ae$var$getProp(child, "exit", nextProps),
            enter: $5c3ee5c66b2de9ae$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRegister("ixTys", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d806670e58944783$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $ih19M = parcelRequire("ih19M");
"use client";
function $d806670e58944783$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $bh6RR.useState(false);
    const rippleClassName = (0, $aPsoC.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $aPsoC.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $bh6RR.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
            className: childClassName
        })
    });
}
var $d806670e58944783$export$2e2bcd8739ae039 = $d806670e58944783$var$Ripple;

});

parcelRegister("e7JbL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a484c5b1e92c0283$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $a484c5b1e92c0283$export$b464606f735ab902(slot) {
    return (0, $dmzXD.default)("MuiTouchRipple", slot);
}
const $a484c5b1e92c0283$var$touchRippleClasses = (0, $fYlYP.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $a484c5b1e92c0283$export$2e2bcd8739ae039 = $a484c5b1e92c0283$var$touchRippleClasses;

});
parcelRegister("fYlYP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba0d826601bdb89a$export$2e2bcd8739ae039; });

var $dmzXD = parcelRequire("dmzXD");
function $ba0d826601bdb89a$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $dmzXD.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("dmzXD", function(module, exports) {

$parcel$export(module.exports, "globalStateClasses", function () { return $9ba9398501f2167d$export$9d6b9120de57c54; });
$parcel$export(module.exports, "default", function () { return $9ba9398501f2167d$export$2e2bcd8739ae039; });

var $7tI36 = parcelRequire("7tI36");
const $9ba9398501f2167d$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $9ba9398501f2167d$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $9ba9398501f2167d$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $7tI36.default).generate(componentName)}-${slot}`;
}
function $9ba9398501f2167d$export$34c0130b1f3e8ae3(slot) {
    return $9ba9398501f2167d$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("7tI36", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $571d691533056500$export$2e2bcd8739ae039; });
const $571d691533056500$var$defaultGenerator = (componentName)=>componentName;
const $571d691533056500$var$createClassNameGenerator = ()=>{
    let generate = $571d691533056500$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $571d691533056500$var$defaultGenerator;
        }
    };
};
const $571d691533056500$var$ClassNameGenerator = $571d691533056500$var$createClassNameGenerator();
var $571d691533056500$export$2e2bcd8739ae039 = $571d691533056500$var$ClassNameGenerator;

});





parcelRegister("3jw06", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", function () { return $269bf8204c4a8a34$export$fccb0498dcd99783; });
$parcel$export(module.exports, "default", function () { return $269bf8204c4a8a34$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $269bf8204c4a8a34$export$fccb0498dcd99783(slot) {
    return (0, $dmzXD.default)("MuiButtonBase", slot);
}
const $269bf8204c4a8a34$var$buttonBaseClasses = (0, $fYlYP.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $269bf8204c4a8a34$export$2e2bcd8739ae039 = $269bf8204c4a8a34$var$buttonBaseClasses;

});


parcelRegister("fGH8N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6bc3e223b7a0835$export$2e2bcd8739ae039; });

var $5pCmM = parcelRequire("5pCmM");
var $b6bc3e223b7a0835$export$2e2bcd8739ae039 = (0, $5pCmM.default);

});

parcelRegister("6gjHo", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", function () { return $48f3847998426035$export$5e8702d71474f093; });
$parcel$export(module.exports, "default", function () { return $48f3847998426035$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $48f3847998426035$export$5e8702d71474f093(slot) {
    return (0, $dmzXD.default)("MuiIconButton", slot);
}
const $48f3847998426035$var$iconButtonClasses = (0, $fYlYP.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $48f3847998426035$export$2e2bcd8739ae039 = $48f3847998426035$var$iconButtonClasses;

});


parcelRegister("gDp1O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1c3b3eeb700ae14$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $fGH8N = parcelRequire("fGH8N");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $kVG1h = parcelRequire("kVG1h");

var $erAkb = parcelRequire("erAkb");

var $aitry = parcelRequire("aitry");

var $iRpKu = parcelRequire("iRpKu");

var $1ibNF = parcelRequire("1ibNF");

var $ih19M = parcelRequire("ih19M");
"use client";
const $c1c3b3eeb700ae14$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $c1c3b3eeb700ae14$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $fGH8N.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $iRpKu.getLinkUtilityClass), classes);
};
const $c1c3b3eeb700ae14$var$LinkRoot = (0, $g4l1t.default)((0, $aitry.default), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $fGH8N.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $4WYaH.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, $4WYaH.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, $1ibNF.default)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $iRpKu.default).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $c1c3b3eeb700ae14$var$Link = /*#__PURE__*/ $bh6RR.forwardRef(function Link(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit", sx: sx } = props, other = (0, $hCIyK.default)(props, $c1c3b3eeb700ae14$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $kVG1h.default)();
    const [focusVisible, setFocusVisible] = $bh6RR.useState(false);
    const handlerRef = (0, $erAkb.default)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $c1c3b3eeb700ae14$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($c1c3b3eeb700ae14$var$LinkRoot, (0, $4WYaH.default)({
        color: color,
        className: (0, $aPsoC.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $1ibNF.colorTransformations)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $c1c3b3eeb700ae14$export$2e2bcd8739ae039 = $c1c3b3eeb700ae14$var$Link;

});
parcelRegister("aitry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77f26cb2b0fda3b7$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $9vXU4 = parcelRequire("9vXU4");

var $96ZcP = parcelRequire("96ZcP");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");

var $DLUvM = parcelRequire("DLUvM");

var $ih19M = parcelRequire("ih19M");
"use client";
const $77f26cb2b0fda3b7$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $77f26cb2b0fda3b7$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $fGH8N.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $DLUvM.getTypographyUtilityClass), classes);
};
const $77f26cb2b0fda3b7$export$140e2f5526d3cad8 = (0, $g4l1t.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $fGH8N.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $77f26cb2b0fda3b7$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $77f26cb2b0fda3b7$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $77f26cb2b0fda3b7$var$transformDeprecatedColors = (color)=>{
    return $77f26cb2b0fda3b7$var$colorTransformations[color] || color;
};
const $77f26cb2b0fda3b7$var$Typography = /*#__PURE__*/ $bh6RR.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $77f26cb2b0fda3b7$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $9vXU4.default)((0, $4WYaH.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $77f26cb2b0fda3b7$var$defaultVariantMapping } = props, other = (0, $hCIyK.default)(props, $77f26cb2b0fda3b7$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $77f26cb2b0fda3b7$var$defaultVariantMapping[variant]) || "span";
    const classes = $77f26cb2b0fda3b7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($77f26cb2b0fda3b7$export$140e2f5526d3cad8, (0, $4WYaH.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className)
    }, other));
});
var $77f26cb2b0fda3b7$export$2e2bcd8739ae039 = $77f26cb2b0fda3b7$var$Typography;

});
parcelRegister("9vXU4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ed579e35296888e$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $5syur = parcelRequire("5syur");

var $9lrgD = parcelRequire("9lrgD");
const $6ed579e35296888e$var$_excluded = [
    "sx"
];
const $6ed579e35296888e$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $9lrgD.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $6ed579e35296888e$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $hCIyK.default)(props, $6ed579e35296888e$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $6ed579e35296888e$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $5syur.isPlainObject)(result)) return systemProps;
        return (0, $4WYaH.default)({}, systemProps, result);
    };
    else finalSx = (0, $4WYaH.default)({}, systemProps, inSx);
    return (0, $4WYaH.default)({}, otherProps, {
        sx: finalSx
    });
}

});

parcelRegister("DLUvM", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", function () { return $0778cea7da3e9252$export$24c1f8f60cbac79e; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $0778cea7da3e9252$export$24c1f8f60cbac79e(slot) {
    return (0, $dmzXD.default)("MuiTypography", slot);
}
const $0778cea7da3e9252$var$typographyClasses = (0, $fYlYP.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $0778cea7da3e9252$export$2e2bcd8739ae039 = $0778cea7da3e9252$var$typographyClasses;

});


parcelRegister("iRpKu", function(module, exports) {

$parcel$export(module.exports, "getLinkUtilityClass", function () { return $dbb12663c27bfb2c$export$d6efab9620b78fec; });
$parcel$export(module.exports, "default", function () { return $dbb12663c27bfb2c$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $dbb12663c27bfb2c$export$d6efab9620b78fec(slot) {
    return (0, $dmzXD.default)("MuiLink", slot);
}
const $dbb12663c27bfb2c$var$linkClasses = (0, $fYlYP.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $dbb12663c27bfb2c$export$2e2bcd8739ae039 = $dbb12663c27bfb2c$var$linkClasses;

});

parcelRegister("1ibNF", function(module, exports) {

$parcel$export(module.exports, "colorTransformations", function () { return $0f10a022a711eccf$export$c4e140d5d351182b; });
$parcel$export(module.exports, "default", function () { return $0f10a022a711eccf$export$2e2bcd8739ae039; });

var $cs0Pg = parcelRequire("cs0Pg");
var $2dEyt = parcelRequire("2dEyt");
const $0f10a022a711eccf$export$c4e140d5d351182b = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $0f10a022a711eccf$var$transformDeprecatedColors = (color)=>{
    return $0f10a022a711eccf$export$c4e140d5d351182b[color] || color;
};
const $0f10a022a711eccf$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $0f10a022a711eccf$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $2dEyt.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $2dEyt.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $cs0Pg.alpha)(color, 0.4);
};
var $0f10a022a711eccf$export$2e2bcd8739ae039 = $0f10a022a711eccf$var$getTextDecoration;

});


parcelRegister("jiymJ", function(module, exports) {
"use strict";
"use client";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0ca5b134b83ce86$var$_createSvgIcon = $2ZnTs((parcelRequire("lpAdr")));

var $ih19M = parcelRequire("ih19M");
var $e0ca5b134b83ce86$var$_default = module.exports.default = (0, $e0ca5b134b83ce86$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), "OpenInNew");

});
parcelRegister("2ZnTs", function(module, exports) {
function $22d3d00379a62cb8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $22d3d00379a62cb8$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lpAdr", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7B0TL.default;
    }
});

var $7B0TL = parcelRequire("7B0TL");

});
parcelRegister("7B0TL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $587caf852a5d6450$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $35wch = parcelRequire("35wch");

var $ih19M = parcelRequire("ih19M");
"use client";
function $587caf852a5d6450$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $35wch.default), (0, $4WYaH.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $35wch.default).muiName;
    return /*#__PURE__*/ $bh6RR.memo(/*#__PURE__*/ $bh6RR.forwardRef(Component));
}

});
parcelRegister("35wch", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23fad063f0767f1f$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $fGH8N = parcelRequire("fGH8N");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $b2lJO = parcelRequire("b2lJO");

var $ih19M = parcelRequire("ih19M");
"use client";
const $23fad063f0767f1f$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $23fad063f0767f1f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $fGH8N.default)(color)}`,
            `fontSize${(0, $fGH8N.default)(fontSize)}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $b2lJO.getSvgIconUtilityClass), classes);
};
const $23fad063f0767f1f$var$SvgIconRoot = (0, $g4l1t.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $fGH8N.default)(ownerState.color)}`],
            styles[`fontSize${(0, $fGH8N.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $23fad063f0767f1f$var$SvgIcon = /*#__PURE__*/ $bh6RR.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $hCIyK.default)(props, $23fad063f0767f1f$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $bh6RR.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $23fad063f0767f1f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($23fad063f0767f1f$var$SvgIconRoot, (0, $4WYaH.default)({
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ih19M.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$23fad063f0767f1f$var$SvgIcon.muiName = "SvgIcon";
var $23fad063f0767f1f$export$2e2bcd8739ae039 = $23fad063f0767f1f$var$SvgIcon;

});
parcelRegister("b2lJO", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $8090be528a37166c$export$c7c50641356bdfa5; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $8090be528a37166c$export$c7c50641356bdfa5(slot) {
    return (0, $dmzXD.default)("MuiSvgIcon", slot);
}
const $8090be528a37166c$var$svgIconClasses = (0, $fYlYP.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $8090be528a37166c$export$2e2bcd8739ae039 = $8090be528a37166c$var$svgIconClasses;

});





parcelRegister("c44wE", function(module, exports) {

$parcel$export(module.exports, "CustomMUITooltip", function () { return $8c895e6e4cfd50b5$export$a289c1d5908db0f6; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $2f71M = parcelRequire("2f71M");
var $ij0sI = parcelRequire("ij0sI");
var $hsRiO = parcelRequire("hsRiO");
var $8gyMY = parcelRequire("8gyMY");

var $bwRDU = parcelRequire("bwRDU");
const $8c895e6e4cfd50b5$var$CustomTooltipContainer = (0, $bwRDU.withModifiers)({
    increaseSpecificity: ()=>`
    display: block;
    z-index: 1;
  `,
    centering: ()=>`
    display: flex;
    justify-content: center;
    align-items: center;
  `
})((modifier)=>(0, $jCoLF.default).div.withConfig({
        displayName: "CustomMUITooltip__CustomTooltipContainer",
        componentId: "sc-1m5tyok-0"
    })([
        "width:",
        ";height:",
        ";box-sizing:border-box;",
        ";"
    ], (props)=>props.width ? props.width : "inherit", (props)=>props.height ? props.height : "inherit", modifier));
const $8c895e6e4cfd50b5$export$a289c1d5908db0f6 = ({ width: width, height: height, longPressDuration: longPressDuration = 1000, enablePressDuration: enablePressDuration = false, modifiers: modifiers, enableExternalHook: enableExternalHook = false, isExternalRenderTooltip: isExternalRenderTooltip, setIsExternalRenderTooltip: setIsExternalRenderTooltip, children: children, ...rest })=>{
    const theme = (0, $8gyMY.default)();
    const isMobileDevices = (0, $hsRiO.default)(theme.breakpoints.down("md"));
    const [renderTooltip, setRenderTooltip] = (0, $bh6RR.useState)(false);
    const pressTimer = (0, $bh6RR.useRef)(null);
    const isRenderTooltip = enableExternalHook ? isExternalRenderTooltip : renderTooltip;
    const handleOnOpen = ()=>{
        if (isMobileDevices && enablePressDuration) return;
        if (enableExternalHook) setIsExternalRenderTooltip(true);
        else setRenderTooltip(true);
    };
    const handleOnClose = ()=>{
        if (enableExternalHook) setIsExternalRenderTooltip(false);
        else setRenderTooltip(false);
    };
    const handleOnMouseEnter = ()=>{
        if (isMobileDevices) return;
        handleOnOpen();
    };
    const handleOnMouseLeave = ()=>{
        if (isMobileDevices) return;
        handleOnClose();
    };
    const handleOnStartTouch = ()=>{
        if (!isMobileDevices || !enablePressDuration) return;
        clearPressTimer();
        pressTimer.current = setTimeout(()=>{
            if (enableExternalHook) setIsExternalRenderTooltip(true);
            else setRenderTooltip(true);
        }, longPressDuration);
    };
    const clearPressTimer = ()=>{
        if (!isMobileDevices || !enablePressDuration) return;
        clearTimeout(pressTimer.current);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $2f71M.ClickAwayListener), {
        onClickAway: handleOnClose,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)($8c895e6e4cfd50b5$var$CustomTooltipContainer, {
            className: "custom-tooltip",
            onClick: handleOnOpen,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            onTouchStart: handleOnStartTouch,
            onTouchMove: clearPressTimer,
            onTouchEnd: clearPressTimer,
            onTouchCancel: clearPressTimer,
            width: width,
            height: height,
            modifiers: modifiers,
            children: [
                !isRenderTooltip && children,
                isRenderTooltip && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ij0sI.default), {
                    open: isMobileDevices ? isRenderTooltip : undefined,
                    ...rest,
                    children: children
                })
            ]
        })
    });
};

});
parcelRegister("2f71M", function(module, exports) {

$parcel$export(module.exports, "ClickAwayListener", function () { return $1a226f09e382fa75$export$58385c17fee43f89; });

var $bh6RR = parcelRequire("bh6RR");


var $8HMMM = parcelRequire("8HMMM");
var $87bEd = parcelRequire("87bEd");
var $6RXey = parcelRequire("6RXey");

var $ih19M = parcelRequire("ih19M");
"use client";
function $1a226f09e382fa75$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $1a226f09e382fa75$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base-ui/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base-ui/react-click-away-listener/components-api/#click-away-listener)
 */ function $1a226f09e382fa75$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = "onClick", onClickAway: onClickAway, touchEvent: touchEvent = "onTouchEnd" } = props;
    const movedRef = $bh6RR.useRef(false);
    const nodeRef = $bh6RR.useRef(null);
    const activatedRef = $bh6RR.useRef(false);
    const syntheticEventRef = $bh6RR.useRef(false);
    $bh6RR.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $6RXey.default)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $87bEd.default)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $8HMMM.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $1a226f09e382fa75$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $bh6RR.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $1a226f09e382fa75$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $8HMMM.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $bh6RR.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $1a226f09e382fa75$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $8HMMM.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Fragment, {
        children: /*#__PURE__*/ $bh6RR.cloneElement(children, childrenProps)
    });
}

});
parcelRegister("8HMMM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65682eb7ee0e459a$export$2e2bcd8739ae039; });
function $65682eb7ee0e459a$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});


parcelRegister("ij0sI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d53a5c2058f97940$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $c3mIq = parcelRequire("c3mIq");

var $95U3o = parcelRequire("95U3o");
var $96ZcP = parcelRequire("96ZcP");

var $cs0Pg = parcelRequire("cs0Pg");

var $g4l1t = parcelRequire("g4l1t");

var $8gyMY = parcelRequire("8gyMY");

var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");

var $clZiP = parcelRequire("clZiP");

var $9tY0V = parcelRequire("9tY0V");

var $8M7SI = parcelRequire("8M7SI");

var $erAkb = parcelRequire("erAkb");

var $5R8eh = parcelRequire("5R8eh");

var $kVG1h = parcelRequire("kVG1h");

var $82V4F = parcelRequire("82V4F");

var $9FHWZ = parcelRequire("9FHWZ");

var $ih19M = parcelRequire("ih19M");
"use client";
const $d53a5c2058f97940$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $d53a5c2058f97940$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $d53a5c2058f97940$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $fGH8N.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $9FHWZ.getTooltipUtilityClass), classes);
};
const $d53a5c2058f97940$var$TooltipPopper = (0, $g4l1t.default)((0, $9tY0V.default), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $4WYaH.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $9FHWZ.default).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $9FHWZ.default).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $9FHWZ.default).arrow}`]: (0, $4WYaH.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $9FHWZ.default).arrow}`]: (0, $4WYaH.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $d53a5c2058f97940$var$TooltipTooltip = (0, $g4l1t.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $fGH8N.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $cs0Pg.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$d53a5c2058f97940$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $9FHWZ.default).popper}[data-popper-placement*="left"] &`]: (0, $4WYaH.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $4WYaH.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $4WYaH.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $9FHWZ.default).popper}[data-popper-placement*="right"] &`]: (0, $4WYaH.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $4WYaH.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $4WYaH.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $9FHWZ.default).popper}[data-popper-placement*="top"] &`]: (0, $4WYaH.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $9FHWZ.default).popper}[data-popper-placement*="bottom"] &`]: (0, $4WYaH.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $d53a5c2058f97940$var$TooltipArrow = (0, $g4l1t.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $cs0Pg.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $d53a5c2058f97940$var$hystersisOpen = false;
const $d53a5c2058f97940$var$hystersisTimer = new (0, $c3mIq.Timeout)();
let $d53a5c2058f97940$var$cursorPosition = {
    x: 0,
    y: 0
};
function $d53a5c2058f97940$export$b9ee5a7ace0541f8() {
    $d53a5c2058f97940$var$hystersisOpen = false;
    $d53a5c2058f97940$var$hystersisTimer.clear();
}
function $d53a5c2058f97940$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $d53a5c2058f97940$var$Tooltip = /*#__PURE__*/ $bh6RR.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $clZiP.default), TransitionProps: TransitionProps } = props, other = (0, $hCIyK.default)(props, $d53a5c2058f97940$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $bh6RR.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $8gyMY.default)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = $bh6RR.useState();
    const [arrowRef, setArrowRef] = $bh6RR.useState(null);
    const ignoreNonTouchEvents = $bh6RR.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $c3mIq.default)();
    const enterTimer = (0, $c3mIq.default)();
    const leaveTimer = (0, $c3mIq.default)();
    const touchTimer = (0, $c3mIq.default)();
    const [openState, setOpenState] = (0, $82V4F.default)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $5R8eh.default)(idProp);
    const prevUserSelect = $bh6RR.useRef();
    const stopTouchInteraction = (0, $8M7SI.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $bh6RR.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $d53a5c2058f97940$var$hystersisTimer.clear();
        $d53a5c2058f97940$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $8M7SI.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $d53a5c2058f97940$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $d53a5c2058f97940$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $d53a5c2058f97940$var$hystersisOpen && enterNextDelay) enterTimer.start($d53a5c2058f97940$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $kVG1h.default)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $bh6RR.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $bh6RR.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $erAkb.default)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    if (!title && title !== 0) open = false;
    const popperRef = $bh6RR.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $d53a5c2058f97940$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $4WYaH.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $aPsoC.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $d53a5c2058f97940$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $d53a5c2058f97940$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $d53a5c2058f97940$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $d53a5c2058f97940$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $bh6RR.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $4WYaH.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $4WYaH.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $d53a5c2058f97940$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $d53a5c2058f97940$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $clZiP.default);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $d53a5c2058f97940$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $d53a5c2058f97940$var$TooltipArrow;
    const popperProps = (0, $95U3o.appendOwnerState)(PopperComponent, (0, $4WYaH.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $aPsoC.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $95U3o.appendOwnerState)(TransitionComponent, (0, $4WYaH.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $95U3o.appendOwnerState)(TooltipComponent, (0, $4WYaH.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $aPsoC.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $95U3o.appendOwnerState)(ArrowComponent, (0, $4WYaH.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $aPsoC.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ $bh6RR.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ih19M.jsx)(PopperComponent, (0, $4WYaH.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $9tY0V.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $d53a5c2058f97940$var$cursorPosition.y,
                            left: $d53a5c2058f97940$var$cursorPosition.x,
                            right: $d53a5c2058f97940$var$cursorPosition.x,
                            bottom: $d53a5c2058f97940$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)(TooltipComponent, (0, $4WYaH.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ih19M.jsx)(ArrowComponent, (0, $4WYaH.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $d53a5c2058f97940$export$2e2bcd8739ae039 = $d53a5c2058f97940$var$Tooltip;

});
parcelRegister("95U3o", function(module, exports) {

$parcel$export(module.exports, "appendOwnerState", function () { return $69f00fcefdfcbe82$export$b089efb01a7bdf50; });

var $4WYaH = parcelRequire("4WYaH");

var $bLFa3 = parcelRequire("bLFa3");
function $69f00fcefdfcbe82$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $bLFa3.isHostComponent)(elementType)) return otherProps;
    return (0, $4WYaH.default)({}, otherProps, {
        ownerState: (0, $4WYaH.default)({}, otherProps.ownerState, ownerState)
    });
}

});
parcelRegister("bLFa3", function(module, exports) {

$parcel$export(module.exports, "isHostComponent", function () { return $89140338e0d83a08$export$e28348cc2430497; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $89140338e0d83a08$export$e28348cc2430497(element) {
    return typeof element === "string";
}

});


parcelRegister("8gyMY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $604acdb59e07bb0a$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $2ox07 = parcelRequire("2ox07");

var $OFmxN = parcelRequire("OFmxN");

var $wllwT = parcelRequire("wllwT");
"use client";
function $604acdb59e07bb0a$export$2e2bcd8739ae039() {
    const theme = (0, $2ox07.default)((0, $OFmxN.default));
    return theme[0, $wllwT.default] || theme;
}

});

parcelRegister("clZiP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fe6ff9ee2f854fb$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $c3mIq = parcelRequire("c3mIq");

var $Eapdw = parcelRequire("Eapdw");

var $8gyMY = parcelRequire("8gyMY");

var $6SHzw = parcelRequire("6SHzw");

var $erAkb = parcelRequire("erAkb");

var $ih19M = parcelRequire("ih19M");
"use client";
const $8fe6ff9ee2f854fb$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $8fe6ff9ee2f854fb$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $8fe6ff9ee2f854fb$var$styles = {
    entering: {
        opacity: 1,
        transform: $8fe6ff9ee2f854fb$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $8fe6ff9ee2f854fb$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $8fe6ff9ee2f854fb$var$Grow = /*#__PURE__*/ $bh6RR.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $Eapdw.default) } = props, other = (0, $hCIyK.default)(props, $8fe6ff9ee2f854fb$var$_excluded);
    const timer = (0, $c3mIq.default)();
    const autoTimeout = $bh6RR.useRef();
    const theme = (0, $8gyMY.default)();
    const nodeRef = $bh6RR.useRef(null);
    const handleRef = (0, $erAkb.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $6SHzw.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $6SHzw.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $8fe6ff9ee2f854fb$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $6SHzw.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $8fe6ff9ee2f854fb$var$isWebKit154 ? duration : duration * 0.666,
                delay: $8fe6ff9ee2f854fb$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $8fe6ff9ee2f854fb$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $bh6RR.cloneElement(children, (0, $4WYaH.default)({
                style: (0, $4WYaH.default)({
                    opacity: 0,
                    transform: $8fe6ff9ee2f854fb$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $8fe6ff9ee2f854fb$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$8fe6ff9ee2f854fb$var$Grow.muiSupportAuto = true;
var $8fe6ff9ee2f854fb$export$2e2bcd8739ae039 = $8fe6ff9ee2f854fb$var$Grow;

});
parcelRegister("Eapdw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $078bcee6f17d1ca2$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $gMqD6 = parcelRequire("gMqD6");


var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $5haFk = parcelRequire("5haFk");


var $8kMIo = parcelRequire("8kMIo");

var $1sg79 = parcelRequire("1sg79");
var $078bcee6f17d1ca2$export$bb38bb9a1161268 = "unmounted";
var $078bcee6f17d1ca2$export$84cbff306f539230 = "exited";
var $078bcee6f17d1ca2$export$df38205c966be359 = "entering";
var $078bcee6f17d1ca2$export$78e9e6e3e014d60a = "entered";
var $078bcee6f17d1ca2$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $078bcee6f17d1ca2$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $078bcee6f17d1ca2$export$84cbff306f539230;
                _this.appearStatus = $078bcee6f17d1ca2$export$df38205c966be359;
            } else initialStatus = $078bcee6f17d1ca2$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $078bcee6f17d1ca2$export$bb38bb9a1161268;
        else initialStatus = $078bcee6f17d1ca2$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $078bcee6f17d1ca2$export$bb38bb9a1161268) return {
            status: $078bcee6f17d1ca2$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $078bcee6f17d1ca2$export$df38205c966be359 && status !== $078bcee6f17d1ca2$export$78e9e6e3e014d60a) nextStatus = $078bcee6f17d1ca2$export$df38205c966be359;
            } else if (status === $078bcee6f17d1ca2$export$df38205c966be359 || status === $078bcee6f17d1ca2$export$78e9e6e3e014d60a) nextStatus = $078bcee6f17d1ca2$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $078bcee6f17d1ca2$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $1sg79.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $078bcee6f17d1ca2$export$84cbff306f539230) this.setState({
            status: $078bcee6f17d1ca2$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $5haFk.default).disabled) {
            this.safeSetState({
                status: $078bcee6f17d1ca2$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $078bcee6f17d1ca2$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $078bcee6f17d1ca2$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $5haFk.default).disabled) {
            this.safeSetState({
                status: $078bcee6f17d1ca2$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $078bcee6f17d1ca2$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $078bcee6f17d1ca2$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $078bcee6f17d1ca2$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $hCIyK.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8kMIo.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$078bcee6f17d1ca2$var$Transition.contextType = (0, $8kMIo.default);
$078bcee6f17d1ca2$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $078bcee6f17d1ca2$var$noop() {}
$078bcee6f17d1ca2$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $078bcee6f17d1ca2$var$noop,
    onEntering: $078bcee6f17d1ca2$var$noop,
    onEntered: $078bcee6f17d1ca2$var$noop,
    onExit: $078bcee6f17d1ca2$var$noop,
    onExiting: $078bcee6f17d1ca2$var$noop,
    onExited: $078bcee6f17d1ca2$var$noop
};
$078bcee6f17d1ca2$var$Transition.UNMOUNTED = $078bcee6f17d1ca2$export$bb38bb9a1161268;
$078bcee6f17d1ca2$var$Transition.EXITED = $078bcee6f17d1ca2$export$84cbff306f539230;
$078bcee6f17d1ca2$var$Transition.ENTERING = $078bcee6f17d1ca2$export$df38205c966be359;
$078bcee6f17d1ca2$var$Transition.ENTERED = $078bcee6f17d1ca2$export$78e9e6e3e014d60a;
$078bcee6f17d1ca2$var$Transition.EXITING = $078bcee6f17d1ca2$export$4aacc83d4d59139f;
var $078bcee6f17d1ca2$export$2e2bcd8739ae039 = $078bcee6f17d1ca2$var$Transition;

});
parcelRegister("5haFk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d76d03970c800ad$export$2e2bcd8739ae039; });
var $3d76d03970c800ad$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("1sg79", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $10f4e7f5a3a509e6$export$7d26bbb1236dafd6; });
var $10f4e7f5a3a509e6$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("6SHzw", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $502995b8d9f16242$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $502995b8d9f16242$export$8cb1e9b404609ae9; });
const $502995b8d9f16242$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $502995b8d9f16242$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

});


parcelRegister("9tY0V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e755ffe50bec2db$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $4vuMJ = parcelRequire("4vuMJ");

var $2Sd76 = parcelRequire("2Sd76");



var $bh6RR = parcelRequire("bh6RR");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $ih19M = parcelRequire("ih19M");
"use client";
const $6e755ffe50bec2db$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $6e755ffe50bec2db$var$PopperRoot = (0, $g4l1t.default)((0, $4vuMJ.Popper), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $6e755ffe50bec2db$var$Popper = /*#__PURE__*/ $bh6RR.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, $2Sd76.default)();
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $hCIyK.default)(props, $6e755ffe50bec2db$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $4WYaH.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $ih19M.jsx)($6e755ffe50bec2db$var$PopperRoot, (0, $4WYaH.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $6e755ffe50bec2db$export$2e2bcd8739ae039 = $6e755ffe50bec2db$var$Popper;

});
parcelRegister("4vuMJ", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $3481eff2a151f79e$export$badac9ada3a0bdf9; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");

var $8HMMM = parcelRequire("8HMMM");
var $kLukk = parcelRequire("kLukk");
var $6RXey = parcelRequire("6RXey");

var $fZq58 = parcelRequire("fZq58");


var $96ZcP = parcelRequire("96ZcP");

var $8FFT1 = parcelRequire("8FFT1");

var $gQU2u = parcelRequire("gQU2u");

var $7ITag = parcelRequire("7ITag");

var $9qLIm = parcelRequire("9qLIm");

var $ih19M = parcelRequire("ih19M");
"use client";
const $3481eff2a151f79e$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $3481eff2a151f79e$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $3481eff2a151f79e$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $3481eff2a151f79e$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $3481eff2a151f79e$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $3481eff2a151f79e$var$isVirtualElement(element) {
    return !$3481eff2a151f79e$var$isHTMLElement(element);
}
const $3481eff2a151f79e$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $9qLIm.useClassNamesOverride)((0, $gQU2u.getPopperUtilityClass)));
};
const $3481eff2a151f79e$var$defaultPopperOptions = {};
const $3481eff2a151f79e$var$PopperTooltip = /*#__PURE__*/ $bh6RR.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $hCIyK.default)(props, $3481eff2a151f79e$var$_excluded);
    const tooltipRef = $bh6RR.useRef(null);
    const ownRef = (0, $6RXey.default)(tooltipRef, forwardedRef);
    const popperRef = $bh6RR.useRef(null);
    const handlePopperRef = (0, $6RXey.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $bh6RR.useRef(handlePopperRef);
    (0, $kLukk.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $bh6RR.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $3481eff2a151f79e$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $bh6RR.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $bh6RR.useState($3481eff2a151f79e$var$resolveAnchorEl(anchorEl));
    $bh6RR.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $bh6RR.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($3481eff2a151f79e$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $kLukk.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $fZq58.createPopper)(resolvedAnchorElement, tooltipRef.current, (0, $4WYaH.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $3481eff2a151f79e$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $7ITag.useSlotProps)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)(Root, (0, $4WYaH.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $3481eff2a151f79e$export$badac9ada3a0bdf9 = /*#__PURE__*/ $bh6RR.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $3481eff2a151f79e$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $hCIyK.default)(props, $3481eff2a151f79e$var$_excluded2);
    const [exited, setExited] = $bh6RR.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $3481eff2a151f79e$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $3481eff2a151f79e$var$isHTMLElement(resolvedAnchorEl) ? (0, $8HMMM.default)(resolvedAnchorEl).body : (0, $8HMMM.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8FFT1.Portal), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($3481eff2a151f79e$var$PopperTooltip, (0, $4WYaH.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $4WYaH.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});

});
parcelRegister("fZq58", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $ba40c8d2bf74e5cd$export$8f7491d57c8f97a9; });

var $fTJao = parcelRequire("fTJao");

var $745n9 = parcelRequire("745n9");

var $4mt2C = parcelRequire("4mt2C");

var $2SszJ = parcelRequire("2SszJ");

var $5KdgE = parcelRequire("5KdgE");

var $eqE9J = parcelRequire("eqE9J");

var $5QuYB = parcelRequire("5QuYB");

var $fVANH = parcelRequire("fVANH");

var $7HVwH = parcelRequire("7HVwH");

var $9bSGP = parcelRequire("9bSGP");


var $ba40c8d2bf74e5cd$export$d34966752335dd47 = [
    (0, $745n9.default),
    (0, $4mt2C.default),
    (0, $2SszJ.default),
    (0, $5KdgE.default),
    (0, $eqE9J.default),
    (0, $5QuYB.default),
    (0, $fVANH.default),
    (0, $7HVwH.default),
    (0, $9bSGP.default)
];
var $ba40c8d2bf74e5cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $fTJao.popperGenerator)({
    defaultModifiers: $ba40c8d2bf74e5cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("fTJao", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $b92f073993d3fb52$export$ed5e13716264f202; });

var $2HKsI = parcelRequire("2HKsI");

var $7oVdA = parcelRequire("7oVdA");

var $iJYQU = parcelRequire("iJYQU");

var $aI24A = parcelRequire("aI24A");

var $2J8Wv = parcelRequire("2J8Wv");

var $1hlpY = parcelRequire("1hlpY");

var $jvpLE = parcelRequire("jvpLE");


var $1c9xk = parcelRequire("1c9xk");
var $b92f073993d3fb52$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $b92f073993d3fb52$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $b92f073993d3fb52$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b92f073993d3fb52$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $b92f073993d3fb52$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $1c9xk.isElement)(reference) ? (0, $iJYQU.default)(reference) : reference.contextElement ? (0, $iJYQU.default)(reference.contextElement) : [],
                    popper: (0, $iJYQU.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $2J8Wv.default)((0, $jvpLE.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b92f073993d3fb52$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $2HKsI.default)(reference, (0, $aI24A.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $7oVdA.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $1hlpY.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b92f073993d3fb52$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b92f073993d3fb52$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b92f073993d3fb52$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("2HKsI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f83a3590a58ca81$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");

var $arVrm = parcelRequire("arVrm");

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");

var $2vFiA = parcelRequire("2vFiA");

var $oVXMR = parcelRequire("oVXMR");

var $juuAX = parcelRequire("juuAX");

var $cQirN = parcelRequire("cQirN");
function $1f83a3590a58ca81$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cQirN.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cQirN.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1f83a3590a58ca81$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $1c9xk.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $1c9xk.isHTMLElement)(offsetParent) && $1f83a3590a58ca81$var$isElementScaled(offsetParent);
    var documentElement = (0, $oVXMR.default)(offsetParent);
    var rect = (0, $bsh7Q.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $a72Qo.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $juuAX.default)(documentElement)) scroll = (0, $arVrm.default)(offsetParent);
        if ((0, $1c9xk.isHTMLElement)(offsetParent)) {
            offsets = (0, $bsh7Q.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $2vFiA.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("bsh7Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $856f97fdf7a31786$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");

var $cQirN = parcelRequire("cQirN");

var $fWtCY = parcelRequire("fWtCY");

var $f2h41 = parcelRequire("f2h41");
function $856f97fdf7a31786$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $1c9xk.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cQirN.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cQirN.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $1c9xk.isElement)(element) ? (0, $fWtCY.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $f2h41.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("1c9xk", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $0dee4f2dddb22277$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $0dee4f2dddb22277$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $0dee4f2dddb22277$export$af51f0f06c0f328a; });

var $fWtCY = parcelRequire("fWtCY");
function $0dee4f2dddb22277$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $fWtCY.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $0dee4f2dddb22277$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $fWtCY.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $0dee4f2dddb22277$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $fWtCY.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("fWtCY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9b3413274c87e21$export$2e2bcd8739ae039; });
function $b9b3413274c87e21$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("cQirN", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $9598a69d154bbd1e$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $9598a69d154bbd1e$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $9598a69d154bbd1e$export$2077e0241d6afd3c; });
var $9598a69d154bbd1e$export$8960430cfd85939f = Math.max;
var $9598a69d154bbd1e$export$96ec731ed4dcb222 = Math.min;
var $9598a69d154bbd1e$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("f2h41", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af244778ac85956c$export$2e2bcd8739ae039; });

var $eFBAH = parcelRequire("eFBAH");
function $af244778ac85956c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $eFBAH.default)());
}

});
parcelRegister("eFBAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aae20dd24c8de568$export$2e2bcd8739ae039; });
function $aae20dd24c8de568$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("arVrm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01f698b37b56f293$export$2e2bcd8739ae039; });

var $6uoC5 = parcelRequire("6uoC5");

var $fWtCY = parcelRequire("fWtCY");

var $1c9xk = parcelRequire("1c9xk");

var $ea8tK = parcelRequire("ea8tK");
function $01f698b37b56f293$export$2e2bcd8739ae039(node) {
    if (node === (0, $fWtCY.default)(node) || !(0, $1c9xk.isHTMLElement)(node)) return (0, $6uoC5.default)(node);
    else return (0, $ea8tK.default)(node);
}

});
parcelRegister("6uoC5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b98a3172bacf8ec$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
function $4b98a3172bacf8ec$export$2e2bcd8739ae039(node) {
    var win = (0, $fWtCY.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ea8tK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4f89398deb81d5a$export$2e2bcd8739ae039; });
function $a4f89398deb81d5a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("a72Qo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75ccc39d2a806d7f$export$2e2bcd8739ae039; });
function $75ccc39d2a806d7f$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("2vFiA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d3e8317bca2b13b$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");

var $oVXMR = parcelRequire("oVXMR");

var $6uoC5 = parcelRequire("6uoC5");
function $1d3e8317bca2b13b$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $bsh7Q.default)((0, $oVXMR.default)(element)).left + (0, $6uoC5.default)(element).scrollLeft;
}

});
parcelRegister("oVXMR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04af344fb3b2461e$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");
function $04af344fb3b2461e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $1c9xk.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("juuAX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3088d3b293d3951$export$2e2bcd8739ae039; });

var $2L33g = parcelRequire("2L33g");
function $e3088d3b293d3951$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $2L33g.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("2L33g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $202256889fb084f4$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
function $202256889fb084f4$export$2e2bcd8739ae039(element) {
    return (0, $fWtCY.default)(element).getComputedStyle(element);
}

});



parcelRegister("7oVdA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $563728a12da0f86b$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");
function $563728a12da0f86b$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $bsh7Q.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("iJYQU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da4ba1ff29e25ddd$export$2e2bcd8739ae039; });

var $l4kGm = parcelRequire("l4kGm");

var $aSiof = parcelRequire("aSiof");

var $fWtCY = parcelRequire("fWtCY");

var $juuAX = parcelRequire("juuAX");
function $da4ba1ff29e25ddd$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $l4kGm.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $fWtCY.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $juuAX.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($da4ba1ff29e25ddd$export$2e2bcd8739ae039((0, $aSiof.default)(target)));
}

});
parcelRegister("l4kGm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f56a03bea423dc7d$export$2e2bcd8739ae039; });

var $aSiof = parcelRequire("aSiof");

var $juuAX = parcelRequire("juuAX");

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");
function $f56a03bea423dc7d$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $a72Qo.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $1c9xk.isHTMLElement)(node) && (0, $juuAX.default)(node)) return node;
    return $f56a03bea423dc7d$export$2e2bcd8739ae039((0, $aSiof.default)(node));
}

});
parcelRegister("aSiof", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ead366da1fe435a$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");

var $oVXMR = parcelRequire("oVXMR");

var $1c9xk = parcelRequire("1c9xk");
function $7ead366da1fe435a$export$2e2bcd8739ae039(element) {
    if ((0, $a72Qo.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $1c9xk.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $oVXMR.default)(element) // fallback
    );
}

});



parcelRegister("aI24A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cbf9f1a43b4b54b$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");

var $a72Qo = parcelRequire("a72Qo");

var $2L33g = parcelRequire("2L33g");

var $1c9xk = parcelRequire("1c9xk");

var $bJ3lS = parcelRequire("bJ3lS");

var $aSiof = parcelRequire("aSiof");

var $eFBAH = parcelRequire("eFBAH");
function $7cbf9f1a43b4b54b$var$getTrueOffsetParent(element) {
    if (!(0, $1c9xk.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $2L33g.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $7cbf9f1a43b4b54b$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $eFBAH.default)());
    var isIE = /Trident/i.test((0, $eFBAH.default)());
    if (isIE && (0, $1c9xk.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $2L33g.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $aSiof.default)(element);
    if ((0, $1c9xk.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $1c9xk.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $a72Qo.default)(currentNode)) < 0){
        var css = (0, $2L33g.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $7cbf9f1a43b4b54b$export$2e2bcd8739ae039(element) {
    var window = (0, $fWtCY.default)(element);
    var offsetParent = $7cbf9f1a43b4b54b$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $bJ3lS.default)(offsetParent) && (0, $2L33g.default)(offsetParent).position === "static")offsetParent = $7cbf9f1a43b4b54b$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $a72Qo.default)(offsetParent) === "html" || (0, $a72Qo.default)(offsetParent) === "body" && (0, $2L33g.default)(offsetParent).position === "static")) return window;
    return offsetParent || $7cbf9f1a43b4b54b$var$getContainingBlock(element) || window;
}

});
parcelRegister("bJ3lS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88967f4bf6e216d4$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");
function $88967f4bf6e216d4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $a72Qo.default)(element)) >= 0;
}

});


parcelRegister("2J8Wv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fc6b88d850995f4$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");
function $1fc6b88d850995f4$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $1fc6b88d850995f4$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $1fc6b88d850995f4$var$order(modifiers); // order based on phase
    return (0, $5juCh.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("5juCh", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $3de679e4868fd918$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $3de679e4868fd918$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $3de679e4868fd918$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $3de679e4868fd918$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $3de679e4868fd918$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $3de679e4868fd918$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $3de679e4868fd918$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $3de679e4868fd918$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $3de679e4868fd918$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $3de679e4868fd918$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $3de679e4868fd918$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $3de679e4868fd918$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $3de679e4868fd918$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $3de679e4868fd918$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $3de679e4868fd918$export$d087d3878fdf71d5; });
var $3de679e4868fd918$export$1e95b668f3b82d = "top";
var $3de679e4868fd918$export$40e543e69a8b3fbb = "bottom";
var $3de679e4868fd918$export$79ffe56a765070d2 = "right";
var $3de679e4868fd918$export$eabcd2c8791e7bf4 = "left";
var $3de679e4868fd918$export$dfb5619354ba860 = "auto";
var $3de679e4868fd918$export$aec2ce47c367b8c3 = [
    $3de679e4868fd918$export$1e95b668f3b82d,
    $3de679e4868fd918$export$40e543e69a8b3fbb,
    $3de679e4868fd918$export$79ffe56a765070d2,
    $3de679e4868fd918$export$eabcd2c8791e7bf4
];
var $3de679e4868fd918$export$b3571188c770cc5a = "start";
var $3de679e4868fd918$export$bd5df0f255a350f8 = "end";
var $3de679e4868fd918$export$390fd549c5303b4d = "clippingParents";
var $3de679e4868fd918$export$d7b7311ec04a3e8f = "viewport";
var $3de679e4868fd918$export$ae5ab1c730825774 = "popper";
var $3de679e4868fd918$export$ca50aac9f3ba507f = "reference";
var $3de679e4868fd918$export$368f9a87e87fa4e1 = /*#__PURE__*/ $3de679e4868fd918$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $3de679e4868fd918$export$b3571188c770cc5a,
        placement + "-" + $3de679e4868fd918$export$bd5df0f255a350f8
    ]);
}, []);
var $3de679e4868fd918$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($3de679e4868fd918$export$aec2ce47c367b8c3, [
    $3de679e4868fd918$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $3de679e4868fd918$export$b3571188c770cc5a,
        placement + "-" + $3de679e4868fd918$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $3de679e4868fd918$export$421679a7c3d56e = "beforeRead";
var $3de679e4868fd918$export$aafa59e2e03f2942 = "read";
var $3de679e4868fd918$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $3de679e4868fd918$export$c65e99957a05207c = "beforeMain";
var $3de679e4868fd918$export$f22da7240b7add18 = "main";
var $3de679e4868fd918$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $3de679e4868fd918$export$8d4d2d70e7d46032 = "beforeWrite";
var $3de679e4868fd918$export$68d8715fc104d294 = "write";
var $3de679e4868fd918$export$70a6e5159acce2e6 = "afterWrite";
var $3de679e4868fd918$export$d087d3878fdf71d5 = [
    $3de679e4868fd918$export$421679a7c3d56e,
    $3de679e4868fd918$export$aafa59e2e03f2942,
    $3de679e4868fd918$export$6964f6c886723980,
    $3de679e4868fd918$export$c65e99957a05207c,
    $3de679e4868fd918$export$f22da7240b7add18,
    $3de679e4868fd918$export$bab79516f2d662fe,
    $3de679e4868fd918$export$8d4d2d70e7d46032,
    $3de679e4868fd918$export$68d8715fc104d294,
    $3de679e4868fd918$export$70a6e5159acce2e6
];

});


parcelRegister("1hlpY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ee7fe20308229e3$export$2e2bcd8739ae039; });
function $0ee7fe20308229e3$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("jvpLE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e334e679a8da4fd2$export$2e2bcd8739ae039; });
function $e334e679a8da4fd2$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("745n9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $524d12f5e3f410b7$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
var $524d12f5e3f410b7$var$passive = {
    passive: true
};
function $524d12f5e3f410b7$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $fWtCY.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $524d12f5e3f410b7$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $524d12f5e3f410b7$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $524d12f5e3f410b7$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $524d12f5e3f410b7$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $524d12f5e3f410b7$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $524d12f5e3f410b7$var$effect,
    data: {}
};

});

parcelRegister("4mt2C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32cfbe7d0e900a5d$export$2e2bcd8739ae039; });

var $h8FhS = parcelRequire("h8FhS");
function $32cfbe7d0e900a5d$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $h8FhS.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $32cfbe7d0e900a5d$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $32cfbe7d0e900a5d$var$popperOffsets,
    data: {}
};

});
parcelRegister("h8FhS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7a335ce8d6c7e22$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $a9b5p = parcelRequire("a9b5p");

var $5JvSi = parcelRequire("5JvSi");

var $5juCh = parcelRequire("5juCh");
function $c7a335ce8d6c7e22$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $7HOne.default)(placement) : null;
    var variation = placement ? (0, $a9b5p.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $5juCh.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $5juCh.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $5juCh.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $5juCh.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $5JvSi.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $5juCh.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $5juCh.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("7HOne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59c39fbf33d0fa38$export$2e2bcd8739ae039; });

function $59c39fbf33d0fa38$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("a9b5p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $763358296bc7f0da$export$2e2bcd8739ae039; });
function $763358296bc7f0da$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("5JvSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42c9e163adb38c23$export$2e2bcd8739ae039; });
function $42c9e163adb38c23$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("2SszJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2186ca614d1914c5$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $aI24A = parcelRequire("aI24A");

var $fWtCY = parcelRequire("fWtCY");

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $7HOne = parcelRequire("7HOne");

var $a9b5p = parcelRequire("a9b5p");

var $cQirN = parcelRequire("cQirN");
var $2186ca614d1914c5$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $2186ca614d1914c5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cQirN.round)(x * dpr) / dpr || 0,
        y: (0, $cQirN.round)(y * dpr) / dpr || 0
    };
}
function $2186ca614d1914c5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $5juCh.left);
    var sideY = (0, $5juCh.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $aI24A.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $fWtCY.default)(popper)) {
            offsetParent = (0, $oVXMR.default)(popper);
            if ((0, $2L33g.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $5juCh.top) || (placement === (0, $5juCh.left) || placement === (0, $5juCh.right)) && variation === (0, $5juCh.end)) {
            sideY = (0, $5juCh.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $5juCh.left) || (placement === (0, $5juCh.top) || placement === (0, $5juCh.bottom)) && variation === (0, $5juCh.end)) {
            sideX = (0, $5juCh.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $2186ca614d1914c5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $2186ca614d1914c5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $fWtCY.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $2186ca614d1914c5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $7HOne.default)(state.placement),
        variation: (0, $a9b5p.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $2186ca614d1914c5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $2186ca614d1914c5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $2186ca614d1914c5$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $2186ca614d1914c5$var$computeStyles,
    data: {}
};

});

parcelRegister("5KdgE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42eb8a49ca42db39$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");
// and applies them to the HTMLElements such as popper and arrow
function $42eb8a49ca42db39$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $1c9xk.isHTMLElement)(element) || !(0, $a72Qo.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $42eb8a49ca42db39$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $1c9xk.isHTMLElement)(element) || !(0, $a72Qo.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $42eb8a49ca42db39$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $42eb8a49ca42db39$var$applyStyles,
    effect: $42eb8a49ca42db39$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("eqE9J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a812a48e30738572$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $5juCh = parcelRequire("5juCh");
function $a812a48e30738572$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $7HOne.default)(placement);
    var invertDistance = [
        (0, $5juCh.left),
        (0, $5juCh.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $5juCh.left),
        (0, $5juCh.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a812a48e30738572$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $5juCh.placements).reduce(function(acc, placement) {
        acc[placement] = $a812a48e30738572$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a812a48e30738572$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $a812a48e30738572$var$offset
};

});

parcelRegister("5QuYB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4419d659c5aee896$export$2e2bcd8739ae039; });

var $1rXBE = parcelRequire("1rXBE");

var $7HOne = parcelRequire("7HOne");

var $3PXal = parcelRequire("3PXal");

var $5uUmA = parcelRequire("5uUmA");

var $cPMZw = parcelRequire("cPMZw");

var $5juCh = parcelRequire("5juCh");

var $a9b5p = parcelRequire("a9b5p");
function $4419d659c5aee896$var$getExpandedFallbackPlacements(placement) {
    if ((0, $7HOne.default)(placement) === (0, $5juCh.auto)) return [];
    var oppositePlacement = (0, $1rXBE.default)(placement);
    return [
        (0, $3PXal.default)(placement),
        oppositePlacement,
        (0, $3PXal.default)(oppositePlacement)
    ];
}
function $4419d659c5aee896$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $7HOne.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $1rXBE.default)(preferredPlacement)
    ] : $4419d659c5aee896$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $7HOne.default)(placement) === (0, $5juCh.auto) ? (0, $cPMZw.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $7HOne.default)(placement);
        var isStartVariation = (0, $a9b5p.default)(placement) === (0, $5juCh.start);
        var isVertical = [
            (0, $5juCh.top),
            (0, $5juCh.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $5uUmA.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $5juCh.right) : (0, $5juCh.left) : isStartVariation ? (0, $5juCh.bottom) : (0, $5juCh.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $1rXBE.default)(mainVariationSide);
        var altVariationSide = (0, $1rXBE.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4419d659c5aee896$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $4419d659c5aee896$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("1rXBE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10e68ca32d71e128$export$2e2bcd8739ae039; });
var $10e68ca32d71e128$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $10e68ca32d71e128$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $10e68ca32d71e128$var$hash[matched];
    });
}

});

parcelRegister("3PXal", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cb407a558844daa$export$2e2bcd8739ae039; });
var $2cb407a558844daa$var$hash = {
    start: "end",
    end: "start"
};
function $2cb407a558844daa$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2cb407a558844daa$var$hash[matched];
    });
}

});

parcelRegister("5uUmA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $400b79aa76081eef$export$2e2bcd8739ae039; });

var $i1jxU = parcelRequire("i1jxU");

var $oVXMR = parcelRequire("oVXMR");

var $bsh7Q = parcelRequire("bsh7Q");

var $h8FhS = parcelRequire("h8FhS");

var $jWjgS = parcelRequire("jWjgS");

var $5juCh = parcelRequire("5juCh");

var $1c9xk = parcelRequire("1c9xk");

var $cg2ZW = parcelRequire("cg2ZW");

var $aSXwy = parcelRequire("aSXwy");
function $400b79aa76081eef$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $5juCh.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $5juCh.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $5juCh.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $cg2ZW.default)(typeof padding !== "number" ? padding : (0, $aSXwy.default)(padding, (0, $5juCh.basePlacements)));
    var altContext = elementContext === (0, $5juCh.popper) ? (0, $5juCh.reference) : (0, $5juCh.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $i1jxU.default)((0, $1c9xk.isElement)(element) ? element : element.contextElement || (0, $oVXMR.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $bsh7Q.default)(state.elements.reference);
    var popperOffsets = (0, $h8FhS.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $jWjgS.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $5juCh.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $5juCh.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $5juCh.right),
                (0, $5juCh.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $5juCh.top),
                (0, $5juCh.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("i1jxU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1e77b65493ae185$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $43VfI = parcelRequire("43VfI");

var $1xbC0 = parcelRequire("1xbC0");

var $iJYQU = parcelRequire("iJYQU");

var $aI24A = parcelRequire("aI24A");

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $1c9xk = parcelRequire("1c9xk");

var $bsh7Q = parcelRequire("bsh7Q");

var $aSiof = parcelRequire("aSiof");

var $jFWJP = parcelRequire("jFWJP");

var $a72Qo = parcelRequire("a72Qo");

var $jWjgS = parcelRequire("jWjgS");

var $cQirN = parcelRequire("cQirN");
function $d1e77b65493ae185$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $bsh7Q.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $d1e77b65493ae185$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $5juCh.viewport) ? (0, $jWjgS.default)((0, $43VfI.default)(element, strategy)) : (0, $1c9xk.isElement)(clippingParent) ? $d1e77b65493ae185$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $jWjgS.default)((0, $1xbC0.default)((0, $oVXMR.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $d1e77b65493ae185$var$getClippingParents(element) {
    var clippingParents = (0, $iJYQU.default)((0, $aSiof.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $2L33g.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $1c9xk.isHTMLElement)(element) ? (0, $aI24A.default)(element) : element;
    if (!(0, $1c9xk.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $1c9xk.isElement)(clippingParent) && (0, $jFWJP.default)(clippingParent, clipperElement) && (0, $a72Qo.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $d1e77b65493ae185$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $d1e77b65493ae185$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $d1e77b65493ae185$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cQirN.max)(rect.top, accRect.top);
        accRect.right = (0, $cQirN.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cQirN.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cQirN.max)(rect.left, accRect.left);
        return accRect;
    }, $d1e77b65493ae185$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("43VfI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f53da607b3746be$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");

var $oVXMR = parcelRequire("oVXMR");

var $2vFiA = parcelRequire("2vFiA");

var $f2h41 = parcelRequire("f2h41");
function $2f53da607b3746be$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $fWtCY.default)(element);
    var html = (0, $oVXMR.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $f2h41.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $2vFiA.default)(element),
        y: y
    };
}

});

parcelRegister("1xbC0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11e1e16d619599d0$export$2e2bcd8739ae039; });

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $2vFiA = parcelRequire("2vFiA");

var $6uoC5 = parcelRequire("6uoC5");

var $cQirN = parcelRequire("cQirN");
function $11e1e16d619599d0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $oVXMR.default)(element);
    var winScroll = (0, $6uoC5.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cQirN.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cQirN.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $2vFiA.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $2L33g.default)(body || html).direction === "rtl") x += (0, $cQirN.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("jFWJP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e52f68d10ea05d88$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");
function $e52f68d10ea05d88$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $1c9xk.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("jWjgS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e84261f8276e3310$export$2e2bcd8739ae039; });
function $e84261f8276e3310$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("cg2ZW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ec94e005bd060d7$export$2e2bcd8739ae039; });

var $kGFu9 = parcelRequire("kGFu9");
function $8ec94e005bd060d7$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $kGFu9.default)(), paddingObject);
}

});
parcelRegister("kGFu9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0f7e8fd5f6df53a$export$2e2bcd8739ae039; });
function $f0f7e8fd5f6df53a$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("aSXwy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039; });
function $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cPMZw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $958040209c61c1c6$export$2e2bcd8739ae039; });

var $a9b5p = parcelRequire("a9b5p");

var $5juCh = parcelRequire("5juCh");

var $5uUmA = parcelRequire("5uUmA");

var $7HOne = parcelRequire("7HOne");
function $958040209c61c1c6$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $5juCh.placements) : _options$allowedAutoP;
    var variation = (0, $a9b5p.default)(placement);
    var placements = variation ? flipVariations ? (0, $5juCh.variationPlacements) : (0, $5juCh.variationPlacements).filter(function(placement) {
        return (0, $a9b5p.default)(placement) === variation;
    }) : (0, $5juCh.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $5uUmA.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $7HOne.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("fVANH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b988b9b26e42e386$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $7HOne = parcelRequire("7HOne");

var $5JvSi = parcelRequire("5JvSi");

var $6Eqmz = parcelRequire("6Eqmz");

var $16lvl = parcelRequire("16lvl");

var $7oVdA = parcelRequire("7oVdA");

var $aI24A = parcelRequire("aI24A");

var $5uUmA = parcelRequire("5uUmA");

var $a9b5p = parcelRequire("a9b5p");

var $kGFu9 = parcelRequire("kGFu9");

var $cQirN = parcelRequire("cQirN");
function $b988b9b26e42e386$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $5uUmA.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $7HOne.default)(state.placement);
    var variation = (0, $a9b5p.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $5JvSi.default)(basePlacement);
    var altAxis = (0, $6Eqmz.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $5juCh.top) : (0, $5juCh.left);
        var altSide = mainAxis === "y" ? (0, $5juCh.bottom) : (0, $5juCh.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $5juCh.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $5juCh.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $7oVdA.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $kGFu9.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $16lvl.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $aI24A.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $16lvl.within)(tether ? (0, $cQirN.min)(min, tetherMin) : min, offset, tether ? (0, $cQirN.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $5juCh.top) : (0, $5juCh.left);
        var _altSide = mainAxis === "x" ? (0, $5juCh.bottom) : (0, $5juCh.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $5juCh.top),
            (0, $5juCh.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $16lvl.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $16lvl.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b988b9b26e42e386$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $b988b9b26e42e386$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("6Eqmz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d7aeda2d1cf8bc0$export$2e2bcd8739ae039; });
function $4d7aeda2d1cf8bc0$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("16lvl", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $0cd708593435dba4$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $0cd708593435dba4$export$86c8af6d3ef0b4a; });

var $cQirN = parcelRequire("cQirN");
function $0cd708593435dba4$export$f28d906d67a997f3(min, value, max) {
    return (0, $cQirN.max)(min, (0, $cQirN.min)(value, max));
}
function $0cd708593435dba4$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0cd708593435dba4$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("7HVwH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59c92c1fc46a893e$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $7oVdA = parcelRequire("7oVdA");

var $jFWJP = parcelRequire("jFWJP");

var $aI24A = parcelRequire("aI24A");

var $5JvSi = parcelRequire("5JvSi");

var $16lvl = parcelRequire("16lvl");

var $cg2ZW = parcelRequire("cg2ZW");

var $aSXwy = parcelRequire("aSXwy");

var $5juCh = parcelRequire("5juCh");
var $59c92c1fc46a893e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $cg2ZW.default)(typeof padding !== "number" ? padding : (0, $aSXwy.default)(padding, (0, $5juCh.basePlacements)));
};
function $59c92c1fc46a893e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $7HOne.default)(state.placement);
    var axis = (0, $5JvSi.default)(basePlacement);
    var isVertical = [
        (0, $5juCh.left),
        (0, $5juCh.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $59c92c1fc46a893e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $7oVdA.default)(arrowElement);
    var minProp = axis === "y" ? (0, $5juCh.top) : (0, $5juCh.left);
    var maxProp = axis === "y" ? (0, $5juCh.bottom) : (0, $5juCh.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $aI24A.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $16lvl.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $59c92c1fc46a893e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $jFWJP.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $59c92c1fc46a893e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $59c92c1fc46a893e$var$arrow,
    effect: $59c92c1fc46a893e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("9bSGP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b0f9068ca75a57d$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $5uUmA = parcelRequire("5uUmA");
function $6b0f9068ca75a57d$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $6b0f9068ca75a57d$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $5juCh.top),
        (0, $5juCh.right),
        (0, $5juCh.bottom),
        (0, $5juCh.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $6b0f9068ca75a57d$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $5uUmA.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $5uUmA.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $6b0f9068ca75a57d$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $6b0f9068ca75a57d$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $6b0f9068ca75a57d$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $6b0f9068ca75a57d$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $6b0f9068ca75a57d$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $6b0f9068ca75a57d$var$hide
};

});


parcelRegister("8FFT1", function(module, exports) {

$parcel$export(module.exports, "Portal", function () { return $6502a4d210ca8b64$export$602eac185826482c; });

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");


var $faL5S = parcelRequire("faL5S");
var $kLukk = parcelRequire("kLukk");
var $6RXey = parcelRequire("6RXey");

var $ih19M = parcelRequire("ih19M");
"use client";
function $6502a4d210ca8b64$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $6502a4d210ca8b64$export$602eac185826482c = /*#__PURE__*/ $bh6RR.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $bh6RR.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $6RXey.default)(/*#__PURE__*/ $bh6RR.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $kLukk.default)(()=>{
        if (!disablePortal) setMountNode($6502a4d210ca8b64$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $kLukk.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $faL5S.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $faL5S.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $bh6RR.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $bh6RR.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Fragment, {
        children: mountNode ? /*#__PURE__*/ $6afFj.createPortal(children, mountNode) : mountNode
    });
});

});

parcelRegister("gQU2u", function(module, exports) {

$parcel$export(module.exports, "getPopperUtilityClass", function () { return $c44cf8dd7a072fa6$export$1b69b6cd0fa638a1; });

var $1L7eH = parcelRequire("1L7eH");

var $lQUMu = parcelRequire("lQUMu");
const $c44cf8dd7a072fa6$var$COMPONENT_NAME = "Popper";
function $c44cf8dd7a072fa6$export$1b69b6cd0fa638a1(slot) {
    return (0, $1L7eH.generateUtilityClass)($c44cf8dd7a072fa6$var$COMPONENT_NAME, slot);
}
const $c44cf8dd7a072fa6$export$b6aa214021e734b0 = (0, $lQUMu.generateUtilityClasses)($c44cf8dd7a072fa6$var$COMPONENT_NAME, [
    "root"
]);

});
parcelRegister("1L7eH", function(module, exports) {

$parcel$export(module.exports, "generateUtilityClass", function () { return $147fcb3095faef89$export$1d132570e11858b0; });

var $dmzXD = parcelRequire("dmzXD");
const $147fcb3095faef89$var$GLOBAL_CLASS_PREFIX = "base";
function $147fcb3095faef89$var$buildStateClass(state) {
    return `${$147fcb3095faef89$var$GLOBAL_CLASS_PREFIX}--${state}`;
}
function $147fcb3095faef89$var$buildSlotClass(componentName, slot) {
    return `${$147fcb3095faef89$var$GLOBAL_CLASS_PREFIX}-${componentName}-${slot}`;
}
function $147fcb3095faef89$export$1d132570e11858b0(componentName, slot) {
    const globalStateClass = (0, $dmzXD.globalStateClasses)[slot];
    return globalStateClass ? $147fcb3095faef89$var$buildStateClass(globalStateClass) : $147fcb3095faef89$var$buildSlotClass(componentName, slot);
}
function $147fcb3095faef89$export$34c0130b1f3e8ae3(slot) {
    return (0, $dmzXD.globalStateClasses)[slot] !== undefined;
}

});

parcelRegister("lQUMu", function(module, exports) {

$parcel$export(module.exports, "generateUtilityClasses", function () { return $fe8a7fd47fd599bd$export$de4f15803c389669; });

var $1L7eH = parcelRequire("1L7eH");
function $fe8a7fd47fd599bd$export$de4f15803c389669(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $1L7eH.generateUtilityClass)(componentName, slot);
    });
    return result;
}

});


parcelRegister("7ITag", function(module, exports) {

$parcel$export(module.exports, "useSlotProps", function () { return $59f76f0115628c32$export$1e5c9e6e4e15efe3; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $6RXey = parcelRequire("6RXey");

var $95U3o = parcelRequire("95U3o");

var $7NHbQ = parcelRequire("7NHbQ");

var $4Mv5B = parcelRequire("4Mv5B");
"use client";
const $59f76f0115628c32$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $59f76f0115628c32$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $hCIyK.default)(parameters, $59f76f0115628c32$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $4Mv5B.resolveComponentProps)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $7NHbQ.mergeSlotProps)((0, $4WYaH.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $6RXey.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $95U3o.appendOwnerState)(elementType, (0, $4WYaH.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}

});
parcelRegister("7NHbQ", function(module, exports) {

$parcel$export(module.exports, "mergeSlotProps", function () { return $5ade9caa5bce179d$export$b01d1e419b049226; });

var $4WYaH = parcelRequire("4WYaH");

var $aPsoC = parcelRequire("aPsoC");

var $kLmLK = parcelRequire("kLmLK");

var $lGuRm = parcelRequire("lGuRm");
function $5ade9caa5bce179d$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $aPsoC.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $4WYaH.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $4WYaH.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $kLmLK.extractEventHandlers)((0, $4WYaH.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $lGuRm.omitEventHandlers)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $lGuRm.omitEventHandlers)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $aPsoC.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $4WYaH.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $4WYaH.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}

});
parcelRegister("kLmLK", function(module, exports) {

$parcel$export(module.exports, "extractEventHandlers", function () { return $f1d9dbe76af4afdb$export$24d5698b57eff81c; });
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $f1d9dbe76af4afdb$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

});

parcelRegister("lGuRm", function(module, exports) {

$parcel$export(module.exports, "omitEventHandlers", function () { return $fc95754d996e5d47$export$2ac0fa4d3a39be45; });
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $fc95754d996e5d47$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

});


parcelRegister("4Mv5B", function(module, exports) {

$parcel$export(module.exports, "resolveComponentProps", function () { return $37b3c2ce0c992b04$export$308c24034cde71de; });
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $37b3c2ce0c992b04$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}

});


parcelRegister("9qLIm", function(module, exports) {

$parcel$export(module.exports, "useClassNamesOverride", function () { return $6ddb8dde432e6936$export$b0f7603cd2f9ee15; });

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");
"use client";
const $6ddb8dde432e6936$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $6ddb8dde432e6936$var$ClassNameConfiguratorContext = /*#__PURE__*/ $bh6RR.createContext($6ddb8dde432e6936$var$defaultContextValue);
function $6ddb8dde432e6936$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $bh6RR.useContext($6ddb8dde432e6936$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $6ddb8dde432e6936$export$2efe1f5e70172ae9(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $bh6RR.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($6ddb8dde432e6936$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}

});



parcelRegister("5R8eh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4438492ebbd53597$export$2e2bcd8739ae039; });

var $dDKx6 = parcelRequire("dDKx6");
"use client";
var $4438492ebbd53597$export$2e2bcd8739ae039 = (0, $dDKx6.default);

});
parcelRegister("dDKx6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ee3035d4da2ac8a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
let $9ee3035d4da2ac8a$var$globalId = 0;
function $9ee3035d4da2ac8a$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $bh6RR.useState(idOverride);
    const id = idOverride || defaultId;
    $bh6RR.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $9ee3035d4da2ac8a$var$globalId += 1;
            setDefaultId(`mui-${$9ee3035d4da2ac8a$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $9ee3035d4da2ac8a$var$maybeReactUseId = $bh6RR["useId".toString()];
function $9ee3035d4da2ac8a$export$2e2bcd8739ae039(idOverride) {
    if ($9ee3035d4da2ac8a$var$maybeReactUseId !== undefined) {
        const reactId = $9ee3035d4da2ac8a$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $9ee3035d4da2ac8a$var$useGlobalId(idOverride);
}

});


parcelRegister("82V4F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dbac85f8c597fa5$export$2e2bcd8739ae039; });

var $d1JqZ = parcelRequire("d1JqZ");
"use client";
var $5dbac85f8c597fa5$export$2e2bcd8739ae039 = (0, $d1JqZ.default);

});
parcelRegister("d1JqZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97be9ca9a8d9ffc7$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
function $97be9ca9a8d9ffc7$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $bh6RR.useRef(controlled !== undefined);
    const [valueState, setValue] = $bh6RR.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $bh6RR.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("9FHWZ", function(module, exports) {

$parcel$export(module.exports, "getTooltipUtilityClass", function () { return $70aa0907006accc9$export$837848f5f6cee923; });
$parcel$export(module.exports, "default", function () { return $70aa0907006accc9$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $70aa0907006accc9$export$837848f5f6cee923(slot) {
    return (0, $dmzXD.default)("MuiTooltip", slot);
}
const $70aa0907006accc9$var$tooltipClasses = (0, $fYlYP.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $70aa0907006accc9$export$2e2bcd8739ae039 = $70aa0907006accc9$var$tooltipClasses;

});


parcelRegister("hsRiO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb6e65f4fdd325d8$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $1ZZi7 = parcelRequire("1ZZi7");
var $2Sd76 = parcelRequire("2Sd76");

var $iWGrV = parcelRequire("iWGrV");
"use client";
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $cb6e65f4fdd325d8$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $bh6RR.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $iWGrV.default)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $cb6e65f4fdd325d8$var$maybeReactUseSyncExternalStore = $bh6RR.useSyncExternalStore;
function $cb6e65f4fdd325d8$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $bh6RR.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $bh6RR.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $bh6RR.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $cb6e65f4fdd325d8$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $cb6e65f4fdd325d8$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $2Sd76.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $1ZZi7.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $cb6e65f4fdd325d8$var$maybeReactUseSyncExternalStore !== undefined ? $cb6e65f4fdd325d8$var$useMediaQueryNew : $cb6e65f4fdd325d8$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}

});
parcelRegister("iWGrV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcae9259d56f58e7$export$2e2bcd8739ae039; });

var $kLukk = parcelRequire("kLukk");
"use client";
var $dcae9259d56f58e7$export$2e2bcd8739ae039 = (0, $kLukk.default);

});



parcelRegister("iIg7Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9f8d8bb20972fab$export$2e2bcd8739ae039; });
const $d9f8d8bb20972fab$var$Binder = {
    getAllMethods: (instance, cls)=>{
        return Object.getOwnPropertyNames(Object.getPrototypeOf(instance)).filter((name)=>{
            const method = instance[name];
            return !(!(method instanceof Function) || method === cls);
        });
    },
    bind: (instance, cls)=>{
        $d9f8d8bb20972fab$var$Binder.getAllMethods(instance, cls).forEach((mtd)=>{
            try {
                let mtdFunc = instance[mtd].bind(instance);
                instance[mtd] = function setInstance(...args) {
                    return mtdFunc(...args);
                };
            } catch (e) {
                console.error(e);
            }
        });
    }
};
var $d9f8d8bb20972fab$export$2e2bcd8739ae039 = $d9f8d8bb20972fab$var$Binder;

});



parcelRegister("bWcBU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b0ee4ac92cb9f35$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $8b0ee4ac92cb9f35$var$API_URL = (0, location.origin);
class $8b0ee4ac92cb9f35$var$Integrations {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/integration", null, null, $8b0ee4ac92cb9f35$var$API_URL);
    }
    getCommunication(phone_number) {
        return this.apiService.post(`communication`, {}, {
            phone_number: phone_number
        }, {
            "Secretkey": "secret"
        });
    }
    getMedicalFiles(phone_number) {
        return this.apiService.post(`medical_files`, {}, {
            phone_number: phone_number
        }, {
            "Secretkey": "secret"
        });
    }
    getOrganizations() {
        return this.apiService.get(`organizations`, {}, {
            "Secretkey": "secret"
        });
    }
    getScheduleFuture(phone_number) {
        return this.apiService.post(`schedule/future`, {}, {
            phone_number: phone_number
        }, {
            "Secretkey": "secret"
        });
    }
    getSpecialities() {
        return this.apiService.get(`specialities`, {
            limit: 10000
        }, {
            "Secretkey": "secret"
        });
    }
    getActiveCity(phone_number) {
        return this.apiService.get(`phone-number/${phone_number}`, {}, {
            "Secretkey": "secret"
        });
    }
    setActiveCity(phone_number, data) {
        return this.apiService.post(`phone-number/${phone_number}`, {}, data, {
            "Secretkey": "secret"
        });
    }
}
var $8b0ee4ac92cb9f35$export$2e2bcd8739ae039 = new $8b0ee4ac92cb9f35$var$Integrations();

});

parcelRegister("g4m5h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb2e2686e5378522$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $bb2e2686e5378522$var$API_URL = (0, location.origin);
class $bb2e2686e5378522$var$PrescribedServices {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $bb2e2686e5378522$var$API_URL);
    }
    getPrescribedServicesReportOne({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params, is_after_get: is_after_get }) {
        return this.apiService.post(`prescribed-service-report/by-patient`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params,
            is_after_get: is_after_get
        }, {}, true, "", true);
    }
    getPrescribedServicesReportTwo({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params, is_after_get: is_after_get }) {
        return this.apiService.post(`prescribed-service-report/by-doctor`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params,
            is_after_get: is_after_get
        }, {}, true, "", true);
    }
    getPrescribedServicesReportThree({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params, is_after_get: is_after_get }) {
        return this.apiService.post(`prescribed-service-report/by-speciality`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params,
            is_after_get: is_after_get
        }, {}, true, "", true);
    }
    getPrescribedServicesReportFour({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params, is_after_get: is_after_get }) {
        return this.apiService.post(`prescribed-service-report/by-service`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params,
            is_after_get: is_after_get
        }, {}, true, "", true);
    }
    getPrescribedServicesReportFive({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params, is_after_get: is_after_get }) {
        return this.apiService.post(`prescribed-service-report/by-service-category`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params,
            is_after_get: is_after_get
        }, {}, true, "", true);
    }
}
var $bb2e2686e5378522$export$2e2bcd8739ae039 = new $bb2e2686e5378522$var$PrescribedServices();

});

parcelRegister("eLvCc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abfdfa9100e208f8$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $abfdfa9100e208f8$var$API_URL = (0, location.origin);
class $abfdfa9100e208f8$var$VoxPatientConsent {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "presetFilterParams", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $abfdfa9100e208f8$var$API_URL);
    }
    getListPatientConsent({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params, annotate_mtm_params: annotate_mtm_params, is_after_get: is_after_get }) {
        return this.apiService.post(`vox_patient_consent/list`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            values_params: values_params,
            order_by_params: order_by_params,
            annotate_mtm_params: annotate_mtm_params,
            is_after_get: is_after_get
        });
    }
}
var $abfdfa9100e208f8$export$2e2bcd8739ae039 = new $abfdfa9100e208f8$var$VoxPatientConsent();

});

parcelRegister("krsST", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee1cbc1368bd2f5c$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $ee1cbc1368bd2f5c$var$API_URL = (0, location.origin);
class $ee1cbc1368bd2f5c$var$DMSServices {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $ee1cbc1368bd2f5c$var$API_URL);
    }
    createOrUpdate(data) {
        return this.apiService.post(`dms/service-for-approval`, {}, data);
    }
    getServiceForApproval(appointmentId) {
        return this.apiService.get(`dms/service-for-approval`, {
            appointment_id: appointmentId
        });
    }
}
var $ee1cbc1368bd2f5c$export$2e2bcd8739ae039 = new $ee1cbc1368bd2f5c$var$DMSServices();

});

parcelRegister("ebkuB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a531fd26a6e8bfe2$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $a531fd26a6e8bfe2$var$API_URL = (0, location.origin);
class $a531fd26a6e8bfe2$var$NewGeneralSchedule {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $a531fd26a6e8bfe2$var$API_URL);
    }
    getSchedule({ start_date: start_date, end_date: end_date, organization_ids: organization_ids, doctor_ids: doctor_ids, patient_ids: patient_ids, service_ids: service_ids, type: type, online: online, opinion: opinion, is_dms_accepts: is_dms_accepts }) {
        return this.apiService.get(`new-schedule`, {
            start_date: start_date,
            end_date: end_date,
            organization_ids: organization_ids,
            doctor_ids: doctor_ids,
            patient_ids: patient_ids,
            service_ids: service_ids,
            type: type,
            online: online,
            opinion: opinion,
            is_dms_accepts: is_dms_accepts
        }, {}, true, "", false, true);
    }
    getScheduleBoard({ start_date: start_date, end_date: end_date, organization_ids: organization_ids, doctor_ids: doctor_ids, patient_ids: patient_ids, service_ids: service_ids, type: type, online: online, opinion: opinion, is_dms_accepts: is_dms_accepts }) {
        return this.apiService.get(`schedule-board`, {
            start_date: start_date,
            end_date: end_date,
            organization_ids: organization_ids,
            doctor_ids: doctor_ids,
            patient_ids: patient_ids,
            service_ids: service_ids,
            type: type,
            online: online,
            opinion: opinion,
            is_dms_accepts: is_dms_accepts
        }, {}, true, "", false, true);
    }
    getServices({ name: name, organization_ids: organization_ids, doctor_ids: doctor_ids, speciality_ids: speciality_ids }) {
        return this.apiService.get(`new-schedule/services`, {
            name: name,
            organization_ids: organization_ids,
            doctor_ids: doctor_ids,
            speciality_ids: speciality_ids
        });
    }
    getSpecialities({ organization_ids: organization_ids }) {
        return this.apiService.get(`new-schedule/specialities`, {
            organization_ids: organization_ids
        });
    }
    getDoctors({ start_date: start_date, end_date: end_date, full_name: full_name, organization_ids: organization_ids, service_ids: service_ids, type: type, online: online, opinion: opinion, is_dms_accepts: is_dms_accepts }) {
        return this.apiService.get(`new-schedule/doctors`, {
            start_date: start_date,
            end_date: end_date,
            full_name: full_name,
            organization_ids: organization_ids,
            service_ids: service_ids,
            type: type,
            online: online,
            opinion: opinion,
            is_dms_accepts: is_dms_accepts
        }, {}, true, "", false, true);
    }
    getPatients({ name: name, organization_ids: organization_ids }) {
        return this.apiService.get(`new-schedule/patients`, {
            full_name: name,
            organization_ids: organization_ids
        });
    }
    getDoctorServices({ doctorId: doctorId, organizationIds: organizationIds }) {
        return this.apiService.get(`new-schedule/doctor/${doctorId}/services`, {
            organization_ids: organizationIds
        });
    }
    postRecordScheduleInserts(params) {
        return this.apiService.post("schedule-inserts-v2", {}, {
            ...params
        });
    }
    postCancelScheduleInserts(params) {
        return this.apiService.post("integration/schedule/cancel", {}, {
            ...params
        }, {
            Secretkey: "secret"
        });
    }
    postAdditionalRecordingAction(params) {
        return this.apiService.post("schedule-inserts-v2/buttons", {}, {
            ...params
        });
    }
}
var $a531fd26a6e8bfe2$export$2e2bcd8739ae039 = new $a531fd26a6e8bfe2$var$NewGeneralSchedule();

});

parcelRegister("gipKl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdd24c7e34087cf0$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $bdd24c7e34087cf0$var$API_URL = (0, location.origin);
class $bdd24c7e34087cf0$var$VRTReports {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api/reports/vrt-report", null, null, $bdd24c7e34087cf0$var$API_URL);
    }
    getReportPuncture({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params }) {
        const interval = filter_params.interval;
        delete filter_params.interval;
        return this.apiService.post(`puncture`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            interval: interval,
            values_params: values_params,
            order_by_params: order_by_params
        }, {}, true, "", true);
    }
    getReportTransfer({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params }) {
        const interval = filter_params.interval;
        delete filter_params.interval;
        return this.apiService.post(`transfer`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            interval: interval,
            values_params: values_params,
            order_by_params: order_by_params
        }, {}, true, "", true);
    }
    getReportProgramsWithSM({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params }) {
        const interval = filter_params.interval;
        delete filter_params.interval;
        return this.apiService.post(`surogate-mothers`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            interval: interval,
            values_params: values_params,
            order_by_params: order_by_params
        }, {}, true, "", true);
    }
    getReportProgramsWithPGTStore({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params }) {
        const interval = filter_params.interval;
        delete filter_params.interval;
        return this.apiService.post(`program-pgt`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            interval: interval,
            values_params: values_params,
            order_by_params: order_by_params
        }, {}, true, "", true);
    }
    getReportPregnancyOutcomesStore({ filter_params: filter_params, meta: meta = {}, values_params: values_params, order_by_params: order_by_params }) {
        const interval = filter_params.interval;
        delete filter_params.interval;
        return this.apiService.post(`pregnancy-outcome`, {}, {
            filter_params: filter_params,
            current_page: meta.current_page,
            per_page: meta.per_page,
            interval: interval,
            values_params: values_params,
            order_by_params: order_by_params
        }, {}, true, "", true);
    }
    async getReportMariborConsensus(params) {
        return await this.apiService.post(`mariborian-concensus`, {}, params, {}, true, "", true);
    }
    async getReportOocyteDonationPrograms(params) {
        return await this.apiService.post(`program-oocyte-donors`, {}, params, {}, true, "", true);
    }
    async getReportProgramsWithDonorSperm(params) {
        return await this.apiService.post(`program-sperm-donor`, {}, params, {}, true, "", true);
    }
}
var $bdd24c7e34087cf0$export$2e2bcd8739ae039 = new $bdd24c7e34087cf0$var$VRTReports();

});

parcelRegister("iOKNH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db313326b3baf966$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $5lJLQ = parcelRequire("5lJLQ");
const $db313326b3baf966$var$API_URL = (0, location.origin);
class $db313326b3baf966$var$Programs {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "apiService", void 0);
        this.apiService = new (0, $5lJLQ.default)("/api", null, null, $db313326b3baf966$var$API_URL);
    }
    getPatientContracts(patientId) {
        return this.apiService.get(`contracts`, {
            patient_id: patientId
        });
    }
}
var $db313326b3baf966$export$2e2bcd8739ae039 = new $db313326b3baf966$var$Programs();

});


parcelRegister("kfcUT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebcf3a51f1606d77$export$2e2bcd8739ae039; });

var $bUAif = parcelRequire("bUAif");

var $kmHuZ = parcelRequire("kmHuZ");

var $3M0M5 = parcelRequire("3M0M5");

var $7HoMU = parcelRequire("7HoMU");
let $ebcf3a51f1606d77$var$voximplantInstance = null;
const $ebcf3a51f1606d77$var$connectVoximplantCloud = async ()=>{
    if (!$ebcf3a51f1606d77$var$voximplantInstance) return false;
    const voximplant = await $ebcf3a51f1606d77$var$voximplantInstance;
    try {
        const connectionResult = await voximplant.connect();
        if (connectionResult) {
            (0, $3M0M5.default).setVoximplantIsReconnecting(false);
            (0, $3M0M5.default).closeVoximplantErrorModal();
            return true;
        }
    } catch (e) {
        console.error(e);
        (0, $7HoMU.captureExceptionToSentry)(e);
        (0, $3M0M5.default).setVoximplantIsReconnecting(false);
        (0, $3M0M5.default).showVoximlpantErrorModal();
        return false;
    }
    (0, $3M0M5.default).setVoximplantIsReconnecting(false);
    (0, $3M0M5.default).showVoximlpantErrorModal();
    return false;
};
const $ebcf3a51f1606d77$var$initVoximplant = async ()=>{
    $ebcf3a51f1606d77$var$voximplantInstance = new Promise(async (resolve, reject)=>{
        try {
            (0, $3M0M5.default).closeVoximplantErrorModal();
            (0, $3M0M5.default).setVoximplantIsReconnecting(false);
            const urlResponse = await (0, $kmHuZ.default).vox.getUrl((0, $3M0M5.default).currentCallId);
            const voximplant = $bUAif.getInstance();
            // If the Voximplant instance is not initialized, initialize it
            if (!voximplant.alreadyInitialized) await voximplant.init({
                showDebugInfo: true
            }); //{ showDebugInfo: true } // Add to collect debug information
            // Connect to the cloud and request a key
            voximplant.connect().then(()=>voximplant.requestOneTimeLoginKey(urlResponse.url));
            let reconnectingTimeout;
            // Listen to the server response
            voximplant.on($bUAif.Events.AuthResult, async (e)=>{
                console.log(`[Voximplant] AuthResult: ${e.result}`);
                console.log(`[Voximplant] Auth code: ${e.code}`);
                if (e.result) resolve(voximplant);
                else if (e.code === 302) {
                    console.log(`[Voximplant] Key: ${e.key}`);
                    const tokenResponse = await (0, $kmHuZ.default).vox.getToken(e.key, (0, $3M0M5.default).currentCallId);
                    await voximplant.loginWithOneTimeKey(urlResponse.url, tokenResponse.token);
                }
            });
            voximplant.on($bUAif.Events.Reconnecting, async (e)=>{
                console.log("[Voximplant] Trying to reconnect...");
                (0, $7HoMU.captureEventToSentry)(e);
                reconnectingTimeout = setTimeout(()=>{
                    // Поскольку при 10 попыткахх реконнекта, сюда мы попадаем лишь единожды, пришлось сделать через таймаут
                    (0, $3M0M5.default).setVoximplantIsReconnecting(true);
                    (0, $3M0M5.default).showVoximlpantErrorModal();
                }, 5000);
            });
            voximplant.on($bUAif.Events.Reconnected, async (e)=>{
                console.log("[Voximplant] Reconnected.");
                (0, $7HoMU.captureEventToSentry)(e);
                if (reconnectingTimeout) // Если переподключились, значит и модалку показывать не надо
                clearTimeout(reconnectingTimeout);
                (0, $3M0M5.default).setVoximplantIsReconnecting(false);
                (0, $3M0M5.default).closeVoximplantErrorModal();
            });
            voximplant.on($bUAif.Events.ConnectionClosed, async (e)=>{
                // Сначала Voximplant пытается 10 раз переподключиться, если не получилось, попадаем сюда
                console.log("[Voximplant] Connection closed.");
                (0, $7HoMU.captureEventToSentry)(e);
                if (reconnectingTimeout) // Если отключились раньше чем показали подолку о переподключении
                clearTimeout(reconnectingTimeout);
                $ebcf3a51f1606d77$var$connectVoximplantCloud();
            });
        } catch (e) {
            reject(e);
            (0, $7HoMU.captureExceptionToSentry)(e);
            (0, $3M0M5.default).setVoximplantIsReconnecting(false);
            (0, $3M0M5.default).showVoximlpantErrorModal();
        }
    });
    return $ebcf3a51f1606d77$var$voximplantInstance;
};
const $ebcf3a51f1606d77$var$getInstance = async ()=>{
    if ($ebcf3a51f1606d77$var$voximplantInstance) {
        const v = await $ebcf3a51f1606d77$var$voximplantInstance;
        console.log("v:", v);
        if (v instanceof Error) {
            (0, $7HoMU.captureExceptionToSentry)(v);
            return await $ebcf3a51f1606d77$var$initVoximplant();
        }
        console.log("[Voximplant]:", v);
        return v;
    }
    console.log("not have instance:", $ebcf3a51f1606d77$var$voximplantInstance);
    return await $ebcf3a51f1606d77$var$initVoximplant();
};
var $ebcf3a51f1606d77$export$2e2bcd8739ae039 = {
    connectVoximplantCloud: $ebcf3a51f1606d77$var$connectVoximplantCloud,
    getInstance: $ebcf3a51f1606d77$var$getInstance
};

});
parcelRegister("bUAif", function(module, exports) {
(function() {
    var root = this;
    var VoxImplant;
    VoxImplant = (()=>{
        var e = {
            6143: function(e, t1) {
                !function(e) {
                    "use strict";
                    e.createStatelessFSM = (e, t1, n, r)=>{
                        const i = {
                            context: n,
                            prevValue: null,
                            get value () {
                                return e.value;
                            },
                            set value (t){
                                e.value = t;
                            },
                            states: t1,
                            transition (e) {
                                null == r || r.log("FSM: received event", e);
                                const t1 = this.states[this.value][e];
                                if (!t1) return null == r || r.warn(`FSM: there is no state for transition on ${this.value} state`), !1;
                                try {
                                    const e = "unknown" === t1 ? a(this.states.unknown, this.context) : t1;
                                    return e === this.value ? (null == r || r.log("FSM: there are not state changes"), !1) : (null == r || r.log(`FSM: transition from ${this.value} to ${e}`), this.prevValue = this.value, this.value = e, this.value);
                                } catch (e) {
                                    return null == r || r.error(`FSM: transition failed, rollback to ${this.value} state`), !1;
                                }
                            }
                        }, a = (e, t1)=>{
                            if (null == r || r.log("FSM: handling unknown state"), !e) throw Error("Transitions from unknown state are not provided");
                            let n = null;
                            for(const i in e){
                                const a = e[i];
                                if (null == a ? void 0 : a(t1)) {
                                    null == r || r.log(`FSM: the state ${i} matches conditions`), n = i;
                                    break;
                                }
                            }
                            if (!n) {
                                const e = "FSM: cannot make transition from unknown state";
                                throw null == r || r.error(e), Error(e);
                            }
                            return n;
                        };
                        return i;
                    }, Object.defineProperty(e, "__esModule", {
                        value: !0
                    });
                }(t1);
            },
            6185: function(e, t1) {
                !function(e) {
                    "use strict";
                    class t1 {
                        constructor(e){
                            this.content = e, this.observers = new Set;
                        }
                        notify() {
                            for (const e of this.observers)e(this.content);
                        }
                        watch(e) {
                            this.observers.add(e);
                        }
                        unwatch(e) {
                            this.observers.delete(e);
                        }
                        clear() {
                            this.observers.clear();
                        }
                        get value() {
                            return this.content;
                        }
                        set value(e) {
                            this.content = e, this.notify();
                        }
                    }
                    e.obs = (e)=>new t1(e), Object.defineProperty(e, "__esModule", {
                        value: !0
                    });
                }(t1);
            },
            1206: function(e) {
                e.exports = function(e) {
                    var t1 = {};
                    function n(r) {
                        if (t1[r]) return t1[r].exports;
                        var i = t1[r] = {
                            i: r,
                            l: !1,
                            exports: {}
                        };
                        return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
                    }
                    return n.m = e, n.c = t1, n.d = function(e, t1, r) {
                        n.o(e, t1) || Object.defineProperty(e, t1, {
                            enumerable: !0,
                            get: r
                        });
                    }, n.r = function(e) {
                        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                            value: "Module"
                        }), Object.defineProperty(e, "__esModule", {
                            value: !0
                        });
                    }, n.t = function(e, t1) {
                        if (1 & t1 && (e = n(e)), 8 & t1) return e;
                        if (4 & t1 && "object" == typeof e && e && e.__esModule) return e;
                        var r = Object.create(null);
                        if (n.r(r), Object.defineProperty(r, "default", {
                            enumerable: !0,
                            value: e
                        }), 2 & t1 && "string" != typeof e) for(var i in e)n.d(r, i, (function(t1) {
                            return e[t1];
                        }).bind(null, i));
                        return r;
                    }, n.n = function(e) {
                        var t1 = e && e.__esModule ? function() {
                            return e.default;
                        } : function() {
                            return e;
                        };
                        return n.d(t1, "a", t1), t1;
                    }, n.o = function(e, t1) {
                        return Object.prototype.hasOwnProperty.call(e, t1);
                    }, n.p = "", n(n.s = 90);
                }({
                    17: function(e, t1, n) {
                        "use strict";
                        t1.__esModule = !0, t1.default = void 0;
                        var r = n(18), i = function() {
                            function e() {}
                            return e.getFirstMatch = function(e, t1) {
                                var n = t1.match(e);
                                return n && n.length > 0 && n[1] || "";
                            }, e.getSecondMatch = function(e, t1) {
                                var n = t1.match(e);
                                return n && n.length > 1 && n[2] || "";
                            }, e.matchAndReturnConst = function(e, t1, n) {
                                if (e.test(t1)) return n;
                            }, e.getWindowsVersionName = function(e) {
                                switch(e){
                                    case "NT":
                                        return "NT";
                                    case "XP":
                                    case "NT 5.1":
                                        return "XP";
                                    case "NT 5.0":
                                        return "2000";
                                    case "NT 5.2":
                                        return "2003";
                                    case "NT 6.0":
                                        return "Vista";
                                    case "NT 6.1":
                                        return "7";
                                    case "NT 6.2":
                                        return "8";
                                    case "NT 6.3":
                                        return "8.1";
                                    case "NT 10.0":
                                        return "10";
                                    default:
                                        return;
                                }
                            }, e.getMacOSVersionName = function(e) {
                                var t1 = e.split(".").splice(0, 2).map(function(e) {
                                    return parseInt(e, 10) || 0;
                                });
                                if (t1.push(0), 10 === t1[0]) switch(t1[1]){
                                    case 5:
                                        return "Leopard";
                                    case 6:
                                        return "Snow Leopard";
                                    case 7:
                                        return "Lion";
                                    case 8:
                                        return "Mountain Lion";
                                    case 9:
                                        return "Mavericks";
                                    case 10:
                                        return "Yosemite";
                                    case 11:
                                        return "El Capitan";
                                    case 12:
                                        return "Sierra";
                                    case 13:
                                        return "High Sierra";
                                    case 14:
                                        return "Mojave";
                                    case 15:
                                        return "Catalina";
                                    default:
                                        return;
                                }
                            }, e.getAndroidVersionName = function(e) {
                                var t1 = e.split(".").splice(0, 2).map(function(e) {
                                    return parseInt(e, 10) || 0;
                                });
                                if (t1.push(0), !(1 === t1[0] && t1[1] < 5)) return 1 === t1[0] && t1[1] < 6 ? "Cupcake" : 1 === t1[0] && t1[1] >= 6 ? "Donut" : 2 === t1[0] && t1[1] < 2 ? "Eclair" : 2 === t1[0] && 2 === t1[1] ? "Froyo" : 2 === t1[0] && t1[1] > 2 ? "Gingerbread" : 3 === t1[0] ? "Honeycomb" : 4 === t1[0] && t1[1] < 1 ? "Ice Cream Sandwich" : 4 === t1[0] && t1[1] < 4 ? "Jelly Bean" : 4 === t1[0] && t1[1] >= 4 ? "KitKat" : 5 === t1[0] ? "Lollipop" : 6 === t1[0] ? "Marshmallow" : 7 === t1[0] ? "Nougat" : 8 === t1[0] ? "Oreo" : 9 === t1[0] ? "Pie" : void 0;
                            }, e.getVersionPrecision = function(e) {
                                return e.split(".").length;
                            }, e.compareVersions = function(t1, n, r) {
                                void 0 === r && (r = !1);
                                var i = e.getVersionPrecision(t1), a = e.getVersionPrecision(n), s = Math.max(i, a), o = 0, d = e.map([
                                    t1,
                                    n
                                ], function(t1) {
                                    var n = s - e.getVersionPrecision(t1), r = t1 + new Array(n + 1).join(".0");
                                    return e.map(r.split("."), function(e) {
                                        return new Array(20 - e.length).join("0") + e;
                                    }).reverse();
                                });
                                for(r && (o = s - Math.min(i, a)), s -= 1; s >= o;){
                                    if (d[0][s] > d[1][s]) return 1;
                                    if (d[0][s] === d[1][s]) {
                                        if (s === o) return 0;
                                        s -= 1;
                                    } else if (d[0][s] < d[1][s]) return -1;
                                }
                            }, e.map = function(e, t1) {
                                var n, r = [];
                                if (Array.prototype.map) return Array.prototype.map.call(e, t1);
                                for(n = 0; n < e.length; n += 1)r.push(t1(e[n]));
                                return r;
                            }, e.find = function(e, t1) {
                                var n, r;
                                if (Array.prototype.find) return Array.prototype.find.call(e, t1);
                                for(n = 0, r = e.length; n < r; n += 1){
                                    var i = e[n];
                                    if (t1(i, n)) return i;
                                }
                            }, e.assign = function(e) {
                                for(var t1, n, r = e, i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)a[s - 1] = arguments[s];
                                if (Object.assign) return Object.assign.apply(Object, [
                                    e
                                ].concat(a));
                                var o = function() {
                                    var e = a[t1];
                                    "object" == typeof e && null !== e && Object.keys(e).forEach(function(t1) {
                                        r[t1] = e[t1];
                                    });
                                };
                                for(t1 = 0, n = a.length; t1 < n; t1 += 1)o();
                                return e;
                            }, e.getBrowserAlias = function(e) {
                                return r.BROWSER_ALIASES_MAP[e];
                            }, e.getBrowserTypeByAlias = function(e) {
                                return r.BROWSER_MAP[e] || "";
                            }, e;
                        }();
                        t1.default = i, e.exports = t1.default;
                    },
                    18: function(e, t1, n) {
                        "use strict";
                        t1.__esModule = !0, t1.ENGINE_MAP = t1.OS_MAP = t1.PLATFORMS_MAP = t1.BROWSER_MAP = t1.BROWSER_ALIASES_MAP = void 0, t1.BROWSER_ALIASES_MAP = {
                            "Amazon Silk": "amazon_silk",
                            "Android Browser": "android",
                            Bada: "bada",
                            BlackBerry: "blackberry",
                            Chrome: "chrome",
                            Chromium: "chromium",
                            Electron: "electron",
                            Epiphany: "epiphany",
                            Firefox: "firefox",
                            Focus: "focus",
                            Generic: "generic",
                            "Google Search": "google_search",
                            Googlebot: "googlebot",
                            "Internet Explorer": "ie",
                            "K-Meleon": "k_meleon",
                            Maxthon: "maxthon",
                            "Microsoft Edge": "edge",
                            "MZ Browser": "mz",
                            "NAVER Whale Browser": "naver",
                            Opera: "opera",
                            "Opera Coast": "opera_coast",
                            PhantomJS: "phantomjs",
                            Puffin: "puffin",
                            QupZilla: "qupzilla",
                            QQ: "qq",
                            QQLite: "qqlite",
                            Safari: "safari",
                            Sailfish: "sailfish",
                            "Samsung Internet for Android": "samsung_internet",
                            SeaMonkey: "seamonkey",
                            Sleipnir: "sleipnir",
                            Swing: "swing",
                            Tizen: "tizen",
                            "UC Browser": "uc",
                            Vivaldi: "vivaldi",
                            "WebOS Browser": "webos",
                            WeChat: "wechat",
                            "Yandex Browser": "yandex",
                            Roku: "roku"
                        }, t1.BROWSER_MAP = {
                            amazon_silk: "Amazon Silk",
                            android: "Android Browser",
                            bada: "Bada",
                            blackberry: "BlackBerry",
                            chrome: "Chrome",
                            chromium: "Chromium",
                            electron: "Electron",
                            epiphany: "Epiphany",
                            firefox: "Firefox",
                            focus: "Focus",
                            generic: "Generic",
                            googlebot: "Googlebot",
                            google_search: "Google Search",
                            ie: "Internet Explorer",
                            k_meleon: "K-Meleon",
                            maxthon: "Maxthon",
                            edge: "Microsoft Edge",
                            mz: "MZ Browser",
                            naver: "NAVER Whale Browser",
                            opera: "Opera",
                            opera_coast: "Opera Coast",
                            phantomjs: "PhantomJS",
                            puffin: "Puffin",
                            qupzilla: "QupZilla",
                            qq: "QQ Browser",
                            qqlite: "QQ Browser Lite",
                            safari: "Safari",
                            sailfish: "Sailfish",
                            samsung_internet: "Samsung Internet for Android",
                            seamonkey: "SeaMonkey",
                            sleipnir: "Sleipnir",
                            swing: "Swing",
                            tizen: "Tizen",
                            uc: "UC Browser",
                            vivaldi: "Vivaldi",
                            webos: "WebOS Browser",
                            wechat: "WeChat",
                            yandex: "Yandex Browser"
                        }, t1.PLATFORMS_MAP = {
                            tablet: "tablet",
                            mobile: "mobile",
                            desktop: "desktop",
                            tv: "tv"
                        }, t1.OS_MAP = {
                            WindowsPhone: "Windows Phone",
                            Windows: "Windows",
                            MacOS: "macOS",
                            iOS: "iOS",
                            Android: "Android",
                            WebOS: "WebOS",
                            BlackBerry: "BlackBerry",
                            Bada: "Bada",
                            Tizen: "Tizen",
                            Linux: "Linux",
                            ChromeOS: "Chrome OS",
                            PlayStation4: "PlayStation 4",
                            Roku: "Roku"
                        }, t1.ENGINE_MAP = {
                            EdgeHTML: "EdgeHTML",
                            Blink: "Blink",
                            Trident: "Trident",
                            Presto: "Presto",
                            Gecko: "Gecko",
                            WebKit: "WebKit"
                        };
                    },
                    90: function(e, t1, n) {
                        "use strict";
                        t1.__esModule = !0, t1.default = void 0;
                        var r, i = (r = n(91)) && r.__esModule ? r : {
                            default: r
                        }, a = n(18);
                        function s(e, t1) {
                            for(var n = 0; n < t1.length; n++){
                                var r = t1[n];
                                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                            }
                        }
                        var o = function() {
                            function e() {}
                            var t1, n, r;
                            return e.getParser = function(e, t1) {
                                if (void 0 === t1 && (t1 = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                                return new i.default(e, t1);
                            }, e.parse = function(e) {
                                return new i.default(e).getResult();
                            }, t1 = e, r = [
                                {
                                    key: "BROWSER_MAP",
                                    get: function() {
                                        return a.BROWSER_MAP;
                                    }
                                },
                                {
                                    key: "ENGINE_MAP",
                                    get: function() {
                                        return a.ENGINE_MAP;
                                    }
                                },
                                {
                                    key: "OS_MAP",
                                    get: function() {
                                        return a.OS_MAP;
                                    }
                                },
                                {
                                    key: "PLATFORMS_MAP",
                                    get: function() {
                                        return a.PLATFORMS_MAP;
                                    }
                                }
                            ], n = null, r && s(t1, r), e;
                        }();
                        t1.default = o, e.exports = t1.default;
                    },
                    91: function(e, t1, n) {
                        "use strict";
                        t1.__esModule = !0, t1.default = void 0;
                        var r = d(n(92)), i = d(n(93)), a = d(n(94)), s = d(n(95)), o = d(n(17));
                        function d(e) {
                            return e && e.__esModule ? e : {
                                default: e
                            };
                        }
                        var c = function() {
                            function e(e, t1) {
                                if (void 0 === t1 && (t1 = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                                this._ua = e, this.parsedResult = {}, !0 !== t1 && this.parse();
                            }
                            var t1 = e.prototype;
                            return t1.getUA = function() {
                                return this._ua;
                            }, t1.test = function(e) {
                                return e.test(this._ua);
                            }, t1.parseBrowser = function() {
                                var e = this;
                                this.parsedResult.browser = {};
                                var t1 = o.default.find(r.default, function(t1) {
                                    if ("function" == typeof t1.test) return t1.test(e);
                                    if (t1.test instanceof Array) return t1.test.some(function(t1) {
                                        return e.test(t1);
                                    });
                                    throw new Error("Browser's test function is not valid");
                                });
                                return t1 && (this.parsedResult.browser = t1.describe(this.getUA())), this.parsedResult.browser;
                            }, t1.getBrowser = function() {
                                return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                            }, t1.getBrowserName = function(e) {
                                return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                            }, t1.getBrowserVersion = function() {
                                return this.getBrowser().version;
                            }, t1.getOS = function() {
                                return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                            }, t1.parseOS = function() {
                                var e = this;
                                this.parsedResult.os = {};
                                var t1 = o.default.find(i.default, function(t1) {
                                    if ("function" == typeof t1.test) return t1.test(e);
                                    if (t1.test instanceof Array) return t1.test.some(function(t1) {
                                        return e.test(t1);
                                    });
                                    throw new Error("Browser's test function is not valid");
                                });
                                return t1 && (this.parsedResult.os = t1.describe(this.getUA())), this.parsedResult.os;
                            }, t1.getOSName = function(e) {
                                var t1 = this.getOS().name;
                                return e ? String(t1).toLowerCase() || "" : t1 || "";
                            }, t1.getOSVersion = function() {
                                return this.getOS().version;
                            }, t1.getPlatform = function() {
                                return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                            }, t1.getPlatformType = function(e) {
                                void 0 === e && (e = !1);
                                var t1 = this.getPlatform().type;
                                return e ? String(t1).toLowerCase() || "" : t1 || "";
                            }, t1.parsePlatform = function() {
                                var e = this;
                                this.parsedResult.platform = {};
                                var t1 = o.default.find(a.default, function(t1) {
                                    if ("function" == typeof t1.test) return t1.test(e);
                                    if (t1.test instanceof Array) return t1.test.some(function(t1) {
                                        return e.test(t1);
                                    });
                                    throw new Error("Browser's test function is not valid");
                                });
                                return t1 && (this.parsedResult.platform = t1.describe(this.getUA())), this.parsedResult.platform;
                            }, t1.getEngine = function() {
                                return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                            }, t1.getEngineName = function(e) {
                                return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                            }, t1.parseEngine = function() {
                                var e = this;
                                this.parsedResult.engine = {};
                                var t1 = o.default.find(s.default, function(t1) {
                                    if ("function" == typeof t1.test) return t1.test(e);
                                    if (t1.test instanceof Array) return t1.test.some(function(t1) {
                                        return e.test(t1);
                                    });
                                    throw new Error("Browser's test function is not valid");
                                });
                                return t1 && (this.parsedResult.engine = t1.describe(this.getUA())), this.parsedResult.engine;
                            }, t1.parse = function() {
                                return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                            }, t1.getResult = function() {
                                return o.default.assign({}, this.parsedResult);
                            }, t1.satisfies = function(e) {
                                var t1 = this, n = {}, r = 0, i = {}, a = 0;
                                if (Object.keys(e).forEach(function(t1) {
                                    var s = e[t1];
                                    "string" == typeof s ? (i[t1] = s, a += 1) : "object" == typeof s && (n[t1] = s, r += 1);
                                }), r > 0) {
                                    var s = Object.keys(n), d = o.default.find(s, function(e) {
                                        return t1.isOS(e);
                                    });
                                    if (d) {
                                        var c = this.satisfies(n[d]);
                                        if (void 0 !== c) return c;
                                    }
                                    var l = o.default.find(s, function(e) {
                                        return t1.isPlatform(e);
                                    });
                                    if (l) {
                                        var g = this.satisfies(n[l]);
                                        if (void 0 !== g) return g;
                                    }
                                }
                                if (a > 0) {
                                    var u = Object.keys(i), h = o.default.find(u, function(e) {
                                        return t1.isBrowser(e, !0);
                                    });
                                    if (void 0 !== h) return this.compareVersion(i[h]);
                                }
                            }, t1.isBrowser = function(e, t1) {
                                void 0 === t1 && (t1 = !1);
                                var n = this.getBrowserName().toLowerCase(), r = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(r);
                                return t1 && i && (r = i.toLowerCase()), r === n;
                            }, t1.compareVersion = function(e) {
                                var t1 = [
                                    0
                                ], n = e, r = !1, i = this.getBrowserVersion();
                                if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (n = e.substr(1), "=" === e[1] ? (r = !0, n = e.substr(2)) : t1 = [], ">" === e[0] ? t1.push(1) : t1.push(-1)) : "=" === e[0] ? n = e.substr(1) : "~" === e[0] && (r = !0, n = e.substr(1)), t1.indexOf(o.default.compareVersions(i, n, r)) > -1;
                            }, t1.isOS = function(e) {
                                return this.getOSName(!0) === String(e).toLowerCase();
                            }, t1.isPlatform = function(e) {
                                return this.getPlatformType(!0) === String(e).toLowerCase();
                            }, t1.isEngine = function(e) {
                                return this.getEngineName(!0) === String(e).toLowerCase();
                            }, t1.is = function(e, t1) {
                                return void 0 === t1 && (t1 = !1), this.isBrowser(e, t1) || this.isOS(e) || this.isPlatform(e);
                            }, t1.some = function(e) {
                                var t1 = this;
                                return void 0 === e && (e = []), e.some(function(e) {
                                    return t1.is(e);
                                });
                            }, e;
                        }();
                        t1.default = c, e.exports = t1.default;
                    },
                    92: function(e, t1, n) {
                        "use strict";
                        t1.__esModule = !0, t1.default = void 0;
                        var r, i = (r = n(17)) && r.__esModule ? r : {
                            default: r
                        }, a = /version\/(\d+(\.?_?\d+)+)/i, s = [
                            {
                                test: [
                                    /googlebot/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Googlebot"
                                    }, n = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /opera/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Opera"
                                    }, n = i.default.getFirstMatch(a, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /opr\/|opios/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Opera"
                                    }, n = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /SamsungBrowser/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Samsung Internet for Android"
                                    }, n = i.default.getFirstMatch(a, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /Whale/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "NAVER Whale Browser"
                                    }, n = i.default.getFirstMatch(a, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /MZBrowser/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "MZ Browser"
                                    }, n = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /focus/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Focus"
                                    }, n = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /swing/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Swing"
                                    }, n = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /coast/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Opera Coast"
                                    }, n = i.default.getFirstMatch(a, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /opt\/\d+(?:.?_?\d+)+/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Opera Touch"
                                    }, n = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /yabrowser/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Yandex Browser"
                                    }, n = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /ucbrowser/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "UC Browser"
                                    }, n = i.default.getFirstMatch(a, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /Maxthon|mxios/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Maxthon"
                                    }, n = i.default.getFirstMatch(a, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /epiphany/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Epiphany"
                                    }, n = i.default.getFirstMatch(a, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /puffin/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Puffin"
                                    }, n = i.default.getFirstMatch(a, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /sleipnir/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Sleipnir"
                                    }, n = i.default.getFirstMatch(a, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /k-meleon/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "K-Meleon"
                                    }, n = i.default.getFirstMatch(a, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /micromessenger/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "WeChat"
                                    }, n = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /qqbrowser/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                                    }, n = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /msie|trident/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Internet Explorer"
                                    }, n = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /\sedg\//i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Microsoft Edge"
                                    }, n = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /edg([ea]|ios)/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Microsoft Edge"
                                    }, n = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /vivaldi/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Vivaldi"
                                    }, n = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /seamonkey/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "SeaMonkey"
                                    }, n = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /sailfish/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Sailfish"
                                    }, n = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /silk/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Amazon Silk"
                                    }, n = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /phantom/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "PhantomJS"
                                    }, n = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /slimerjs/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "SlimerJS"
                                    }, n = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /blackberry|\bbb\d+/i,
                                    /rim\stablet/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "BlackBerry"
                                    }, n = i.default.getFirstMatch(a, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /(web|hpw)[o0]s/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "WebOS Browser"
                                    }, n = i.default.getFirstMatch(a, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /bada/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Bada"
                                    }, n = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /tizen/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Tizen"
                                    }, n = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /qupzilla/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "QupZilla"
                                    }, n = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /firefox|iceweasel|fxios/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Firefox"
                                    }, n = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /electron/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Electron"
                                    }, n = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /MiuiBrowser/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Miui"
                                    }, n = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /chromium/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Chromium"
                                    }, n = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /chrome|crios|crmo/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Chrome"
                                    }, n = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /GSA/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Google Search"
                                    }, n = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: function(e) {
                                    var t1 = !e.test(/like android/i), n = e.test(/android/i);
                                    return t1 && n;
                                },
                                describe: function(e) {
                                    var t1 = {
                                        name: "Android Browser"
                                    }, n = i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /playstation 4/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "PlayStation 4"
                                    }, n = i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /safari|applewebkit/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: "Safari"
                                    }, n = i.default.getFirstMatch(a, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /.*/i
                                ],
                                describe: function(e) {
                                    var t1 = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                                    return {
                                        name: i.default.getFirstMatch(t1, e),
                                        version: i.default.getSecondMatch(t1, e)
                                    };
                                }
                            }
                        ];
                        t1.default = s, e.exports = t1.default;
                    },
                    93: function(e, t1, n) {
                        "use strict";
                        t1.__esModule = !0, t1.default = void 0;
                        var r, i = (r = n(17)) && r.__esModule ? r : {
                            default: r
                        }, a = n(18), s = [
                            {
                                test: [
                                    /Roku\/DVP/
                                ],
                                describe: function(e) {
                                    var t1 = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                                    return {
                                        name: a.OS_MAP.Roku,
                                        version: t1
                                    };
                                }
                            },
                            {
                                test: [
                                    /windows phone/i
                                ],
                                describe: function(e) {
                                    var t1 = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                                    return {
                                        name: a.OS_MAP.WindowsPhone,
                                        version: t1
                                    };
                                }
                            },
                            {
                                test: [
                                    /windows /i
                                ],
                                describe: function(e) {
                                    var t1 = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), n = i.default.getWindowsVersionName(t1);
                                    return {
                                        name: a.OS_MAP.Windows,
                                        version: t1,
                                        versionName: n
                                    };
                                }
                            },
                            {
                                test: [
                                    /Macintosh(.*?) FxiOS(.*?)\//
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: a.OS_MAP.iOS
                                    }, n = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /macintosh/i
                                ],
                                describe: function(e) {
                                    var t1 = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), n = i.default.getMacOSVersionName(t1), r = {
                                        name: a.OS_MAP.MacOS,
                                        version: t1
                                    };
                                    return n && (r.versionName = n), r;
                                }
                            },
                            {
                                test: [
                                    /(ipod|iphone|ipad)/i
                                ],
                                describe: function(e) {
                                    var t1 = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                                    return {
                                        name: a.OS_MAP.iOS,
                                        version: t1
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    var t1 = !e.test(/like android/i), n = e.test(/android/i);
                                    return t1 && n;
                                },
                                describe: function(e) {
                                    var t1 = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), n = i.default.getAndroidVersionName(t1), r = {
                                        name: a.OS_MAP.Android,
                                        version: t1
                                    };
                                    return n && (r.versionName = n), r;
                                }
                            },
                            {
                                test: [
                                    /(web|hpw)[o0]s/i
                                ],
                                describe: function(e) {
                                    var t1 = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), n = {
                                        name: a.OS_MAP.WebOS
                                    };
                                    return t1 && t1.length && (n.version = t1), n;
                                }
                            },
                            {
                                test: [
                                    /blackberry|\bbb\d+/i,
                                    /rim\stablet/i
                                ],
                                describe: function(e) {
                                    var t1 = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                                    return {
                                        name: a.OS_MAP.BlackBerry,
                                        version: t1
                                    };
                                }
                            },
                            {
                                test: [
                                    /bada/i
                                ],
                                describe: function(e) {
                                    var t1 = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                                    return {
                                        name: a.OS_MAP.Bada,
                                        version: t1
                                    };
                                }
                            },
                            {
                                test: [
                                    /tizen/i
                                ],
                                describe: function(e) {
                                    var t1 = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                                    return {
                                        name: a.OS_MAP.Tizen,
                                        version: t1
                                    };
                                }
                            },
                            {
                                test: [
                                    /linux/i
                                ],
                                describe: function() {
                                    return {
                                        name: a.OS_MAP.Linux
                                    };
                                }
                            },
                            {
                                test: [
                                    /CrOS/
                                ],
                                describe: function() {
                                    return {
                                        name: a.OS_MAP.ChromeOS
                                    };
                                }
                            },
                            {
                                test: [
                                    /PlayStation 4/
                                ],
                                describe: function(e) {
                                    var t1 = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                                    return {
                                        name: a.OS_MAP.PlayStation4,
                                        version: t1
                                    };
                                }
                            }
                        ];
                        t1.default = s, e.exports = t1.default;
                    },
                    94: function(e, t1, n) {
                        "use strict";
                        t1.__esModule = !0, t1.default = void 0;
                        var r, i = (r = n(17)) && r.__esModule ? r : {
                            default: r
                        }, a = n(18), s = [
                            {
                                test: [
                                    /googlebot/i
                                ],
                                describe: function() {
                                    return {
                                        type: "bot",
                                        vendor: "Google"
                                    };
                                }
                            },
                            {
                                test: [
                                    /huawei/i
                                ],
                                describe: function(e) {
                                    var t1 = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", n = {
                                        type: a.PLATFORMS_MAP.mobile,
                                        vendor: "Huawei"
                                    };
                                    return t1 && (n.model = t1), n;
                                }
                            },
                            {
                                test: [
                                    /nexus\s*(?:7|8|9|10).*/i
                                ],
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.tablet,
                                        vendor: "Nexus"
                                    };
                                }
                            },
                            {
                                test: [
                                    /ipad/i
                                ],
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.tablet,
                                        vendor: "Apple",
                                        model: "iPad"
                                    };
                                }
                            },
                            {
                                test: [
                                    /Macintosh(.*?) FxiOS(.*?)\//
                                ],
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.tablet,
                                        vendor: "Apple",
                                        model: "iPad"
                                    };
                                }
                            },
                            {
                                test: [
                                    /kftt build/i
                                ],
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.tablet,
                                        vendor: "Amazon",
                                        model: "Kindle Fire HD 7"
                                    };
                                }
                            },
                            {
                                test: [
                                    /silk/i
                                ],
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.tablet,
                                        vendor: "Amazon"
                                    };
                                }
                            },
                            {
                                test: [
                                    /tablet(?! pc)/i
                                ],
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.tablet
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    var t1 = e.test(/ipod|iphone/i), n = e.test(/like (ipod|iphone)/i);
                                    return t1 && !n;
                                },
                                describe: function(e) {
                                    var t1 = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                                    return {
                                        type: a.PLATFORMS_MAP.mobile,
                                        vendor: "Apple",
                                        model: t1
                                    };
                                }
                            },
                            {
                                test: [
                                    /nexus\s*[0-6].*/i,
                                    /galaxy nexus/i
                                ],
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.mobile,
                                        vendor: "Nexus"
                                    };
                                }
                            },
                            {
                                test: [
                                    /[^-]mobi/i
                                ],
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.mobile
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "blackberry" === e.getBrowserName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.mobile,
                                        vendor: "BlackBerry"
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "bada" === e.getBrowserName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.mobile
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "windows phone" === e.getBrowserName();
                                },
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.mobile,
                                        vendor: "Microsoft"
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    var t1 = Number(String(e.getOSVersion()).split(".")[0]);
                                    return "android" === e.getOSName(!0) && t1 >= 3;
                                },
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.tablet
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "android" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.mobile
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "macos" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.desktop,
                                        vendor: "Apple"
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "windows" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.desktop
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "linux" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.desktop
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "playstation 4" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.tv
                                    };
                                }
                            },
                            {
                                test: function(e) {
                                    return "roku" === e.getOSName(!0);
                                },
                                describe: function() {
                                    return {
                                        type: a.PLATFORMS_MAP.tv
                                    };
                                }
                            }
                        ];
                        t1.default = s, e.exports = t1.default;
                    },
                    95: function(e, t1, n) {
                        "use strict";
                        t1.__esModule = !0, t1.default = void 0;
                        var r, i = (r = n(17)) && r.__esModule ? r : {
                            default: r
                        }, a = n(18), s = [
                            {
                                test: function(e) {
                                    return "microsoft edge" === e.getBrowserName(!0);
                                },
                                describe: function(e) {
                                    if (/\sedg\//i.test(e)) return {
                                        name: a.ENGINE_MAP.Blink
                                    };
                                    var t1 = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                                    return {
                                        name: a.ENGINE_MAP.EdgeHTML,
                                        version: t1
                                    };
                                }
                            },
                            {
                                test: [
                                    /trident/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: a.ENGINE_MAP.Trident
                                    }, n = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: function(e) {
                                    return e.test(/presto/i);
                                },
                                describe: function(e) {
                                    var t1 = {
                                        name: a.ENGINE_MAP.Presto
                                    }, n = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: function(e) {
                                    var t1 = e.test(/gecko/i), n = e.test(/like gecko/i);
                                    return t1 && !n;
                                },
                                describe: function(e) {
                                    var t1 = {
                                        name: a.ENGINE_MAP.Gecko
                                    }, n = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            },
                            {
                                test: [
                                    /(apple)?webkit\/537\.36/i
                                ],
                                describe: function() {
                                    return {
                                        name: a.ENGINE_MAP.Blink
                                    };
                                }
                            },
                            {
                                test: [
                                    /(apple)?webkit/i
                                ],
                                describe: function(e) {
                                    var t1 = {
                                        name: a.ENGINE_MAP.WebKit
                                    }, n = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                                    return n && (t1.version = n), t1;
                                }
                            }
                        ];
                        t1.default = s, e.exports = t1.default;
                    }
                });
            },
            9091: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                });
                const r = n(209), i = n(7998), a = n(1150), s = n(4106), o = n(2957), d = n(141), c = n(125), l = n(245), g = "The operator status update failed by timeout.", u = "You try to perform multiple ACD operations at the same time. This can lead to an unexpected behavior of your application.", h = "You probably use the same credentials in the different browsers or multiple browser\u2019s windows. This error can also occur when you make a request, reload the page and receive response after the page reloads.", p = "Wrong ACD status name {0}";
                class f {
                    static get newUUID() {
                        return (new r.default).toString() + "_" + f._connectionId;
                    }
                    static setConnectionId(e) {
                        this._connectionId = e;
                    }
                    static removeConnectionId() {
                        this._connectionId = void 0;
                    }
                    static setStatus(e) {
                        return new Promise((t1, n)=>{
                            f._checkBeforeRun(i.OperatorACDStatuses[e], n);
                            const r = f.newUUID;
                            l.default.callRemoteFunction(s.RemoteFunction.setOperatorACDStatus, e, r), this._acdRequests.push({
                                resolve: t1,
                                reject: n,
                                timer: window.setTimeout(()=>{
                                    f._acdRequests = f._acdRequests.filter((e)=>e.uuid !== r), n(g);
                                }, 58e3),
                                uuid: r,
                                status: e
                            });
                        });
                    }
                    static getStatus() {
                        return new Promise((e, t1)=>{
                            f._checkBeforeRun(void 0, t1);
                            const n = f.newUUID;
                            l.default.callRemoteFunction(s.RemoteFunction.getOperatorACDStatus, n), this._acdRequests.push({
                                resolve: e,
                                reject: t1,
                                timer: window.setTimeout(()=>{
                                    f._acdRequests = f._acdRequests.filter((e)=>e.uuid !== n), t1(g);
                                }, 58e3),
                                uuid: n
                            });
                        });
                    }
                    static onError(e, t1, n) {
                        const { actor: r, actorIdx: i } = f._getActorByUUID(e);
                        r && (clearTimeout(r.timer), r.reject(new Error(o.Utils.strFormat(p, r.status || "get operation"))), f._acdRequests.splice(0, i + 1));
                    }
                    static onStatusUpdated(e, t1, n) {
                        f._checkConnectionId(t1);
                        const { actor: r, actorIdx: i } = f._getActorByUUID(t1);
                        if (r) {
                            if (clearTimeout(r.timer), 0 !== i) for(let t1 = 0; t1 < i; t1++)clearTimeout(f._acdRequests[t1].timer), f._acdRequests[t1].reject(new Error(o.Utils.strFormat("The {0} status is set in your code after {1}. The {0} status is ignored.", r.status || "get operation", e)));
                            void 0 === r.status || r.status === e ? r.resolve(e) : r.reject(new Error(o.Utils.strFormat("The {0} status is not acceptable for the current operator state. The operator is {1} now. Please, check the ACD module documentation for details.", r.status, e))), f._acdRequests.splice(0, i + 1);
                        }
                        c.Client.getInstance().dispatchEvent({
                            name: d.Events.ACDStatusUpdated,
                            id: f._getConnectonIdFromUUID(t1),
                            status: e,
                            description: n
                        });
                    }
                    static _checkBeforeRun(e, t1) {
                        f._connectionId || t1(new Error("You can't set an operator status before login.")), f._acdRequests.length > 0 && (a.LogManager.get().writeMessage(a.LogCategory.CLIENT, "ACD", a.LogLevel.WARNING, u), c.Client.getInstance().dispatchEvent({
                            name: d.Events.ACDError,
                            code: 5,
                            message: u
                        })), void 0 === e || Object.values(i.OperatorACDStatuses).includes(e) || t1(new Error(o.Utils.strFormat(p, e)));
                    }
                    static _getActorByUUID(e) {
                        let t1 = -1;
                        return {
                            actor: this._acdRequests.find((n, r)=>{
                                if (n.uuid === e) return t1 = r, !0;
                            }),
                            actorIdx: t1
                        };
                    }
                    static _getConnectonIdFromUUID(e) {
                        const t1 = e.split("_");
                        return 1 === t1.length || "gw" === t1[1] ? f._connectionId : t1[1];
                    }
                    static _checkConnectionId(e) {
                        var t1;
                        const n = e.split("_");
                        1 !== n.length && n[1] === (null === (t1 = f._connectionId) || void 0 === t1 ? void 0 : t1.split("_")[0]) || (c.Client.getInstance().dispatchEvent({
                            name: d.Events.ACDError,
                            code: 6,
                            message: h
                        }), a.LogManager.get().writeMessage(a.LogCategory.CLIENT, "ACD", a.LogLevel.WARNING, h));
                    }
                }
                t1.default = f, f._acdRequests = [];
            },
            2089: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                });
                const r = n(209), i = n(7998), a = n(1150), s = n(4106), o = n(2957), d = n(141), c = n(125), l = n(245), g = "The operator status update failed by timeout.", u = "You try to perform multiple ACD operations at the same time. This can lead to an unexpected behavior of your application.", h = "You probably use the same credentials in the different browsers or multiple browser\u2019s windows. This error can also occur when you make a request, reload the page and receive response after the page reloads.", p = "Wrong ACD status name {0}";
                class f {
                    static get newUUID() {
                        return (new r.default).toString() + "_" + f._connectionId;
                    }
                    static setConnectionId(e) {
                        this._connectionId = e;
                    }
                    static removeConnectionId() {
                        this._connectionId = void 0;
                    }
                    static setStatus(e) {
                        return new Promise((t1, n)=>{
                            f._checkBeforeRun(i.OperatorACDStatuses[e], n);
                            const r = f.newUUID;
                            l.default.callRemoteFunction(s.RemoteFunction.setOperatorMessagingStatus, e, r), this._acdRequests.push({
                                resolve: t1,
                                reject: n,
                                timer: window.setTimeout(()=>{
                                    f._acdRequests = f._acdRequests.filter((e)=>e.uuid !== r), n(g);
                                }, 58e3),
                                uuid: r,
                                status: e
                            });
                        });
                    }
                    static getStatus() {
                        return new Promise((e, t1)=>{
                            f._checkBeforeRun(void 0, t1);
                            const n = f.newUUID;
                            l.default.callRemoteFunction(s.RemoteFunction.getOperatorMessagingStatus, n), this._acdRequests.push({
                                resolve: e,
                                reject: t1,
                                timer: window.setTimeout(()=>{
                                    f._acdRequests = f._acdRequests.filter((e)=>e.uuid !== n), t1(g);
                                }, 58e3),
                                uuid: n
                            });
                        });
                    }
                    static onError(e, t1, n) {
                        const { actor: r, actorIdx: i } = f._getActorByUUID(e);
                        r && (clearTimeout(r.timer), r.reject(new Error(o.Utils.strFormat(p, r.status || "get operation"))), f._acdRequests.splice(0, i + 1));
                    }
                    static onStatusUpdated(e, t1, n) {
                        f._checkConnectionId(t1);
                        const { actor: r, actorIdx: i } = f._getActorByUUID(t1);
                        if (r) {
                            if (clearTimeout(r.timer), 0 !== i) for(let t1 = 0; t1 < i; t1++)clearTimeout(f._acdRequests[t1].timer), f._acdRequests[t1].reject(new Error(o.Utils.strFormat("The {0} status is set in your code after {1}. The {0} status is ignored.", r.status || "get operation", e)));
                            void 0 === r.status || r.status === e ? r.resolve(e) : r.reject(new Error(o.Utils.strFormat("The {0} status is not acceptable for the current operator state. The operator is {1} now. Please, check the ACD module documentation for details.", r.status, e))), f._acdRequests.splice(0, i + 1);
                        }
                        c.Client.getInstance().dispatchEvent({
                            name: d.Events.SQMessagingStatusUpdated,
                            id: f._getConnectonIdFromUUID(t1),
                            status: e,
                            description: n
                        });
                    }
                    static _checkBeforeRun(e, t1) {
                        f._connectionId || t1(new Error("You can't set an operator status before login.")), f._acdRequests.length > 0 && (a.LogManager.get().writeMessage(a.LogCategory.CLIENT, "ACD", a.LogLevel.WARNING, u), c.Client.getInstance().dispatchEvent({
                            name: d.Events.SQError,
                            code: 5,
                            message: u
                        })), void 0 === e || Object.values(i.OperatorACDStatuses).includes(e) || t1(new Error(o.Utils.strFormat(p, e)));
                    }
                    static _getActorByUUID(e) {
                        let t1 = -1;
                        return {
                            actor: this._acdRequests.find((n, r)=>{
                                if (n.uuid === e) return t1 = r, !0;
                            }),
                            actorIdx: t1
                        };
                    }
                    static _getConnectonIdFromUUID(e) {
                        const t1 = e.split("_");
                        return 1 === t1.length || "gw" === t1[1] ? f._connectionId : t1[1];
                    }
                    static _checkConnectionId(e) {
                        var t1;
                        const n = e.split("_");
                        1 !== n.length && n[1] === (null === (t1 = f._connectionId) || void 0 === t1 ? void 0 : t1.split("_")[0]) || (c.Client.getInstance().dispatchEvent({
                            name: d.Events.SQError,
                            code: 6,
                            message: h
                        }), a.LogManager.get().writeMessage(a.LogCategory.CLIENT, "ACD", a.LogLevel.WARNING, h));
                    }
                }
                t1.default = f, f._acdRequests = [];
            },
            3947: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Authenticator = t1.AuthenticatorState = void 0;
                const i = n(1150), a = n(84), s = n(4106), o = n(575), d = n(125), c = n(9091), l = n(4758), g = n(2089), u = n(245);
                var h;
                !function(e) {
                    e[e.IDLE = 0] = "IDLE", e[e.IN_PROGRESS = 1] = "IN_PROGRESS";
                }(h = t1.AuthenticatorState || (t1.AuthenticatorState = {}));
                class p {
                    constructor(){
                        this.FAIL_CODE_SECOND_STAGE = 301, this.FAIL_CODE_ONE_TIME_KEY = 302, this._displayName = null, this._username = null, this._authorized = !1, this.currentState = h.IDLE, this.logger = i.LogManager.get().createLogger(i.LogCategory.SIGNALING, this._traceName()), u.default.setRPCHandler(o.RemoteEvent.loginFailed, (e, t1)=>{
                            this.onLoginFailed(e, t1);
                        }), u.default.setRPCHandler(o.RemoteEvent.loginSuccessful, (e, t1)=>{
                            this.onLoginSuccesful(e, t1);
                        }), u.default.setRPCHandler(o.RemoteEvent.refreshOauthTokenFailed, (e)=>{
                            this.handler.onRefreshTokenFailed(e);
                        }), u.default.setRPCHandler(o.RemoteEvent.refreshOauthTokenSuccessful, (e)=>{
                            this.handler.onRefreshTokenSuccess(e.OAuth);
                        }), u.default.addHandler(this);
                    }
                    static get() {
                        return void 0 === this.inst && (this.inst = new p), this.inst;
                    }
                    setHandler(e) {
                        this.handler = e;
                    }
                    onLoginFailed(e, t1) {
                        switch(this.currentState = h.IDLE, e){
                            case this.FAIL_CODE_ONE_TIME_KEY:
                                this.handler.onOneTimeKeyGenerated(t1);
                                break;
                            case this.FAIL_CODE_SECOND_STAGE:
                                this.handler.onSecondStageInitiated();
                                break;
                            default:
                                this.handler.onLoginFailed(e);
                        }
                    }
                    onLoginSuccesful(e, t1) {
                        this.currentState = h.IDLE, this._authorized = !0, a.PCFactory.get().iceConfig = t1.iceConfig, c.default.setConnectionId(t1.connectionId), g.default.setConnectionId(t1.connectionId), d.Client.getInstance().setConnectionData(null, t1.connectionId), this._displayName = e, this.handler.onLoginSuccessful(e, t1.OAuth);
                    }
                    get displayName() {
                        return this._displayName;
                    }
                    basicLogin(e, t1, n) {
                        if (this.currentState != h.IDLE) return void this.logger.error("Login operation already in progress");
                        this._username = e, this.currentState = h.IN_PROGRESS;
                        let r = t1;
                        if ("md5" === n.credentialType) {
                            const n = e.split("@")[0];
                            r = l.Md5.hashStr(`${n}:voximplant.com:${t1}`).toString();
                        }
                        u.default.callRemoteFunction(s.RemoteFunction.login, e, r, n);
                    }
                    tokenLogin(e, t1) {
                        this.currentState == h.IDLE ? (this._username = e, this.currentState = h.IN_PROGRESS, u.default.callRemoteFunction(s.RemoteFunction.login, e, "", t1)) : this.logger.error("Login operation already in progress");
                    }
                    tokenRefresh(e, t1, n) {
                        n ? u.default.callRemoteFunction(s.RemoteFunction.refreshOauthToken, e, {
                            refreshToken: t1,
                            deviceToken: n
                        }) : u.default.callRemoteFunction(s.RemoteFunction.refreshOauthToken, e, t1);
                    }
                    loginUsingOneTimeKey(e, t1, n) {
                        this.logger.info("loginWithOneTimeKey running for " + e), this.currentState == h.IDLE ? (this._username = e, this.currentState = h.IN_PROGRESS, u.default.callRemoteFunction(s.RemoteFunction.loginUsingOneTimeKey, e, t1, n)) : this.logger.error("Login operation already in progress. loginWithOneTimeKey was canceled");
                    }
                    loginStage2(e, t1, n) {
                        this.logger.info("loginWithCode running for " + e), this.currentState == h.IDLE ? (this._username = e, this.currentState = h.IN_PROGRESS, u.default.callRemoteFunction(s.RemoteFunction.loginStage2, e, t1, n)) : this.logger.error("Login operation already in progress. loginWithCode was canceled.");
                    }
                    generateOneTimeKey(e) {
                        this.logger.info("requestOneTimeLoginKey running for " + e), this.currentState == h.IDLE ? (this.currentState = h.IN_PROGRESS, u.default.callRemoteFunction(s.RemoteFunction.loginGenerateOneTimeKey, e)) : this.logger.error("Login operation already in progress. requestOneTimeLoginKey was canceled.");
                    }
                    username() {
                        return this._username;
                    }
                    authorized() {
                        return this._authorized;
                    }
                    onSignalingConnected() {}
                    onSignalingConnectionFailed(e) {}
                    onSignalingClosed() {
                        this.currentState = h.IDLE, this._authorized = !1, this._displayName = null, this._username = null;
                    }
                    onMediaConnectionFailed() {
                        this.currentState = h.IDLE;
                    }
                    ziAuthorized(e) {
                        this._authorized = e;
                    }
                    _traceName() {
                        return "Authenticator";
                    }
                }
                r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "setHandler", null), r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "onLoginFailed", null), r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "onLoginSuccesful", null), r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "basicLogin", null), r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "tokenLogin", null), r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "tokenRefresh", null), r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "loginUsingOneTimeKey", null), r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "loginStage2", null), r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "generateOneTimeKey", null), r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "username", null), r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "authorized", null), r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "onSignalingConnected", null), r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "onSignalingConnectionFailed", null), r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "onSignalingClosed", null), r([
                    i.LogManager.d_trace(i.LogCategory.AUTHENTICATOR)
                ], p.prototype, "onMediaConnectionFailed", null), t1.Authenticator = p;
            },
            3869: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                });
                const r = n(1150), i = n(9165), a = n(6518), s = n(9551), o = n(9023), d = n(125), c = n(1206);
                var l;
                !function(e) {
                    let t1, n;
                    function l(e, t1, n) {
                        let r = e;
                        return "object" != typeof r && (r = {}), r[t1] = {
                            ideal: n
                        }, r;
                    }
                    !function(e) {
                        e[e.Firefox = 1] = "Firefox", e[e.Webkit = 2] = "Webkit", e[e.Edge = 3] = "Edge", e[e.Safari = 4] = "Safari";
                    }(t1 || (t1 = {}));
                    c.getParser(window.navigator.userAgent);
                    function g(e, t1) {
                        return new s.SignalingDTMFSender(t1);
                    }
                    function u() {
                        return new Promise((e)=>{
                            e(!1);
                        });
                    }
                    function h(e) {
                        let t1 = !1, n = !1;
                        return e.audioEnabled && (t1 = !0, e.audioInputId && (t1 = l(t1, "deviceId", e.audioInputId))), e.videoEnabled && (n = !0, e.videoSettings && (n = e.videoSettings), e.videoInputId && (n = l(n, "deviceId", e.videoInputId))), {
                            peerIdentity: null,
                            audio: t1,
                            video: n
                        };
                    }
                    function p() {
                        n = navigator.mozGetUserMedia ? t1.Firefox : navigator.webkitGetUserMedia ? t1.Webkit : t1.Safari;
                    }
                    e.isIphone = function() {
                        return !(!d.Client.getInstance().config().experiments || !d.Client.getInstance().config().experiments.emulate_ios) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i);
                    }, e.isIpad = function() {
                        return !(!d.Client.getInstance().config().experiments || !d.Client.getInstance().config().experiments.emulate_ios) || navigator.userAgent.match(/iPad/i) || navigator.maxTouchPoints > 0 && n === t1.Safari;
                    }, e.isScreenSharingSupported = function() {
                        return n === t1.Firefox || n === t1.Webkit || n === t1.Safari && 0 === navigator.maxTouchPoints;
                    }, e.getWSVendor = function(e = !0) {
                        switch(n || p(), n){
                            case t1.Firefox:
                                return "firefox";
                            case t1.Webkit:
                                return "chrome";
                            case t1.Safari:
                                return "safari";
                            default:
                                return "";
                        }
                    }, e.init = function() {
                        switch(n || p(), n && r.LogManager.get().writeMessage(r.LogCategory.RTC, "Core", r.LogLevel.INFO, "Detected browser " + t1[n]), e.getDTMFSender = g, e.screenSharingSupported = u, n){
                            case t1.Firefox:
                                e.attachMedia = i.FF.attachStream, e.detachMedia = i.FF.detachStream, e.getScreenMedia = i.FF.getScreenMedia, e.getRTCStats = i.FF.getRTCStats, e.screenSharingSupported = i.FF.screenSharingSupported, e.getDTMFSender = i.FF.getDTMFSender;
                                break;
                            case t1.Webkit:
                                e.attachMedia = a.Webkit.attachStream, e.detachMedia = a.Webkit.detachStream, e.getScreenMedia = a.Webkit.getScreenMedia, e.getRTCStats = a.Webkit.getRTCStats, e.screenSharingSupported = a.Webkit.screenSharingSupported, e.getDTMFSender = a.Webkit.getDTMFSender;
                                break;
                            case t1.Safari:
                                e.attachMedia = o.Safari.attachStream, e.detachMedia = o.Safari.detachStream, e.getScreenMedia = o.Safari.getScreenMedia, e.getRTCStats = o.Safari.getRTCStats, e.screenSharingSupported = o.Safari.screenSharingSupported, e.getDTMFSender = o.Safari.getDTMFSender;
                                break;
                            default:
                                r.LogManager.get().writeMessage(r.LogCategory.RTC, "Core", r.LogLevel.INFO, "Unsupported browser " + navigator.userAgent);
                        }
                        e.composeConstraints = h;
                    };
                }(l || (l = {})), t1.default = l;
            },
            9165: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.FF = void 0;
                const r = n(9551), i = n(1150);
                class a {
                    static attachStream(e) {
                        let t1 = e.element;
                        void 0 === t1.srcObject ? t1.mozSrcObject = e.stream : t1.srcObject = e.stream;
                    }
                    static detachStream(e) {
                        let t1 = e.element;
                        void 0 === t1.srcObject ? t1.mozSrcObject = null : t1.srcObject = null, t1.src = "";
                    }
                    static screenSharingSupported() {
                        return new Promise((e, t1)=>{
                            "https:" == window.location.protocol ? e(!0) : e(!1);
                        });
                    }
                    static getScreenMedia() {
                        const e = {
                            audio: !1,
                            video: {
                                mediaSource: "window"
                            }
                        };
                        return i.LogManager.get().writeMessage(i.LogCategory.USERMEDIA, "[constraints]", i.LogLevel.TRACE, JSON.stringify(e)), navigator.mediaDevices.getUserMedia(e);
                    }
                    static getRTCStats(e) {
                        return new Promise((t1, n)=>{
                            e.getStats(null).then((e)=>{
                                let n = [];
                                e.forEach((e)=>{
                                    "inbound-rtp" != e.type && "outbound-rtp" != e.type || n.push(e);
                                }), t1({
                                    raw: n,
                                    formatted: a.prepareRTCStats(e)
                                });
                            }).catch(n);
                        });
                    }
                    static prepareRTCStats(e) {
                        let t1 = [];
                        return e.forEach((e)=>{
                            "outbound-rtp" === e.type || e.isRemote ? t1.push(Object.assign(e, {
                                framesPerSecond: e.framesPerSecond ? e.framesPerSecond : e.framerateMean,
                                encoderBitrate: e.bitrateMean
                            })) : t1.push(e);
                        }), t1;
                    }
                    static getDTMFSender(e, t1) {
                        const n = /Firefox\/([0-9\.]+)(?:\s|$)/, i = navigator.userAgent;
                        if (n.test(i)) {
                            if (+n.exec(i)[1].split(".")[0] >= 53) {
                                const t1 = e.getSenders().map((e)=>{
                                    if (e.track && "audio" === e.track.kind && e.dtmf) return e.dtmf;
                                });
                                if (t1.length > 0) return t1[0];
                            }
                        }
                        return new r.SignalingDTMFSender(t1);
                    }
                    _traceName() {
                        return "FF";
                    }
                }
                t1.FF = a;
            },
            9023: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Safari = void 0;
                const r = n(9551), i = n(1150);
                class a {
                    static attachStream(e) {
                        try {
                            e.element.srcObject = e.stream;
                        } catch (t1) {
                            i.LogManager.get().writeMessage(i.LogCategory.USERMEDIA, "Safari: ", i.LogLevel.WARNING, `attachStream() has failed: ${JSON.stringify(t1)}. MediaRenderer.element is ${null == e ? void 0 : e.element} and MediaRenderer.stream is ${null == e ? void 0 : e.stream}`);
                        }
                    }
                    static detachStream(e) {
                        e.pauseElement(), e.element.src = "";
                    }
                    static getDTMFSender(e, t1) {
                        return new r.SignalingDTMFSender(t1);
                    }
                    static getScreenMedia() {
                        return navigator.mediaDevices.getDisplayMedia({
                            audio: !1,
                            video: !0
                        });
                    }
                    static screenSharingSupported() {
                        return navigator && navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia ? Promise.resolve(!0) : Promise.resolve(!1);
                    }
                    static getRTCStats(e) {
                        return new Promise((t1, n)=>{
                            let r = [];
                            e.getStats(null).then((e)=>{
                                e.forEach((e)=>{
                                    if ("ssrc" == e.type) {
                                        let t1 = {};
                                        t1.id = e.id, t1.type = e.type, t1.timestamp = e.timestamp, r.push(t1);
                                    }
                                }), t1({
                                    raw: r,
                                    formatted: a.prepareRTCStats(e)
                                });
                            }).catch(n);
                        });
                    }
                    static prepareRTCStats(e) {
                        let t1 = [];
                        return e.forEach((e)=>{
                            "track" !== e.type || e.kind ? "outbound-rtp" === e.type || "inbound-rtp" === e.type ? t1.push(Object.assign(e, {
                                trackId: e.mediaTrackId
                            })) : t1.push(e) : t1.push(Object.assign(e, {
                                kind: e.id.includes("audio") ? "audio" : e.id.includes("video") ? "video" : void 0
                            }));
                        }), t1;
                    }
                    _traceName() {
                        return "Safari";
                    }
                }
                t1.Safari = a;
            },
            9551: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.SignalingDTMFSender = void 0;
                const r = n(4106), i = n(245);
                t1.SignalingDTMFSender = class {
                    constructor(e){
                        this._id = e;
                    }
                    insertDTMF(e, t1, n) {
                        ("" + e).split("").forEach((e)=>this.sendKey(e));
                    }
                    sendKey(e) {
                        let t1;
                        t1 = "*" == e ? 10 : "#" == e ? 11 : parseInt(e), (t1 >= 0 || t1 <= 11) && i.default.callRemoteFunction(r.RemoteFunction.sendDTMF, this._id, t1);
                    }
                    _traceName() {
                        return "SignalingDTMFSender";
                    }
                };
            },
            6518: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Webkit = void 0;
                const r = n(9551), i = n(125), a = n(1150);
                class s {
                    static attachStream(e) {
                        let t1 = e.element;
                        try {
                            t1.srcObject = e.stream;
                            const n = i.Client.getInstance()._defaultSinkId;
                            null != n && "function" == typeof t1.setSinkId && t1.setSinkId(n);
                        } catch (e) {
                            a.LogManager.get().writeMessage(a.LogCategory.USERMEDIA, "Webkit: ", a.LogLevel.WARNING, JSON.stringify(e));
                        }
                    }
                    static detachStream(e) {
                        e.element.srcObject = null, e.pauseElement(), e.element.src = "";
                    }
                    static getDTMFSender(e, t1) {
                        if (!e.createDTMFSender) return new r.SignalingDTMFSender(t1);
                        {
                            let t1 = [];
                            if (e.getLocalStreams().forEach((e)=>{
                                e.getAudioTracks().forEach((e)=>{
                                    t1.push(e);
                                });
                            }), t1.length) return e.createDTMFSender(t1[0]);
                        }
                    }
                    static screenSharingSupported() {
                        return -1 !== navigator.userAgent.indexOf("Android") ? Promise.resolve(!1) : new Promise((e, t1)=>{
                            if (navigator.getDisplayMedia) e(!0);
                            else if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) e(!0);
                            else {
                                const t1 = (r)=>{
                                    r.origin === window.location.origin && "VoximplantWebsdkExtensionLoaded" === r.data && (window.removeEventListener("message", t1), clearTimeout(n), e(!0));
                                };
                                window.addEventListener("message", t1), window.postMessage("VoximplantWebsdkCheckExtension", "*");
                                const n = setTimeout(()=>{
                                    window.removeEventListener("message", t1), e(!1);
                                }, 800);
                            }
                        });
                    }
                    static getScreenMedia(e = !1) {
                        return navigator.getDisplayMedia ? navigator.getDisplayMedia({
                            video: !0,
                            audio: e
                        }) : navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia ? navigator.mediaDevices.getDisplayMedia({
                            video: !0,
                            audio: e
                        }) : new Promise((t1, n)=>{
                            window.postMessage("voximplantWebsdkGetSourceId", "*");
                            const r = (i)=>{
                                if (i.data && i.origin === window.location.origin && i.data.result) {
                                    if ("err" === i.data.result) return n(new Error(i.data.reason));
                                    if ("ok" === i.data.result && void 0 !== i.data.sourceId) {
                                        window.removeEventListener("message", r);
                                        const s = {
                                            audio: e,
                                            video: {
                                                mandatory: {
                                                    chromeMediaSource: "desktop",
                                                    maxWidth: screen.width > 1920 ? screen.width : 1920,
                                                    maxHeight: screen.height > 1080 ? screen.height : 1080,
                                                    chromeMediaSourceId: i.data.sourceId
                                                },
                                                optional: [
                                                    {
                                                        googTemporalLayeredScreencast: !0
                                                    }
                                                ]
                                            }
                                        };
                                        a.LogManager.get().writeMessage(a.LogCategory.USERMEDIA, "[constraints]", a.LogLevel.INFO, JSON.stringify(s)), navigator.mediaDevices.getUserMedia(s).then((e)=>{
                                            t1(e);
                                        }, (e)=>{
                                            n(e);
                                        });
                                    }
                                }
                            };
                            window.addEventListener("message", r);
                        });
                    }
                    static getRTCStats(e) {
                        return new Promise((t1, n)=>{
                            let r = [];
                            e.getStats(null).then((e)=>{
                                e.forEach((e)=>{
                                    "outbound-rtp" != e.type && "inbound-rtp" != e.type || r.push(e);
                                }), t1({
                                    raw: r,
                                    formatted: s.prepareRTCStats(e)
                                });
                            }).catch(n);
                        });
                    }
                    static prepareRTCStats(e) {
                        let t1 = [];
                        return e.forEach((e)=>{
                            "inbound-rtp" === e.type && e.isRemote ? t1.push(Object.assign(e, {
                                type: "remote-inbound-rtp"
                            })) : "outbound-rtp" === e.type && e.isRemote ? t1.push(Object.assign(e, {
                                type: "remote-outbound-rtp"
                            })) : t1.push(e);
                        }), t1;
                    }
                    _traceName() {
                        return "Webkit";
                    }
                }
                t1.Webkit = s;
            },
            4610: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.AbstractCall = t1.CallMode = t1.CallState = void 0;
                const i = n(3576), a = n(2282), s = n(1150), o = n(4106), d = n(3385), c = n(9411), l = n(245);
                var g;
                !function(e) {
                    e[e.ALERTING = "ALERTING"] = "ALERTING", e[e.PROGRESSING = "PROGRESSING"] = "PROGRESSING", e[e.CONNECTED = "CONNECTED"] = "CONNECTED", e[e.UPDATING = "UPDATING"] = "UPDATING", e[e.STOPPING = "STOPPING"] = "STOPPING", e[e.ENDED = "ENDED"] = "ENDED";
                }(g = t1.CallState || (t1.CallState = {})), function(e) {
                    e[e.P2P = 0] = "P2P", e[e.SERVER = 1] = "SERVER";
                }(t1.CallMode || (t1.CallMode = {}));
                class u extends i.EventTarget {
                    constructor(e){
                        super(), this.remoteMuteState = !0, this.logger = s.LogManager.get().createLogger(s.LogCategory.CALL, `Call ${e}`);
                    }
                    id() {
                        return this.settings ? this.settings.id : "new";
                    }
                    number() {
                        return this.settings.number;
                    }
                    displayName() {
                        return this.settings.displayName;
                    }
                    getCallDuration() {
                        return Date.now() - this.startTime;
                    }
                    headers() {
                        return this.settings.extraHeaders;
                    }
                    state() {
                        return this.settings.state;
                    }
                    checkCallMode(e) {
                        return this.settings.mode == e;
                    }
                    hangup(e) {
                        if (this.logger.info("hangup()"), this.settings.state == g.CONNECTED || this.settings.state == g.UPDATING || this.settings.state == g.PROGRESSING) l.default.callRemoteFunction(o.RemoteFunction.disconnectCall, this.settings.id, c.AbstractCallManager.cleanHeaders(e));
                        else {
                            if (this.settings.state != g.ALERTING) throw new Error("WRONG_CALL_STATE");
                            l.default.callRemoteFunction(o.RemoteFunction.rejectCall, this.settings.id, !0, c.AbstractCallManager.cleanHeaders(e));
                        }
                    }
                    mutePlayback() {
                        this.logger.info("mutePlayback()"), this.remoteMuteState = !1, this.getEndpoints().forEach((e)=>{
                            e.mediaRenderers.forEach((e)=>{
                                e.setVolume(0);
                            });
                        });
                    }
                    unmutePlayback() {
                        this.logger.info("unmutePlayback()"), this.remoteMuteState = !0, this.getEndpoints().forEach((e)=>{
                            e.mediaRenderers.forEach((e)=>{
                                e.setVolume(1);
                            });
                        });
                    }
                    restoreRMute() {
                        this.settings.active && this.getEndpoints().forEach((e)=>{
                            e.mediaRenderers.forEach((e)=>{
                                e.setVolume(this.remoteMuteState ? 1 : 0);
                            });
                        });
                    }
                    sendInfo(e, t1, n) {
                        this.logger.info(`sendInfo(${e}, ${JSON.stringify(t1)})`);
                        let r, i, a = e.indexOf("/");
                        -1 == a ? (r = "application", i = e) : (r = e.substring(0, a), i = e.substring(a + 1)), l.default.callRemoteFunction(o.RemoteFunction.sendSIPInfo, this.settings.id, r, i, t1, c.AbstractCallManager.cleanHeaders(n));
                    }
                    sendMessage(e) {
                        this.logger.info("sendMessage()"), this.sendInfo(d.Constants.ZINGAYA_IM_MIME_TYPE, e, {});
                    }
                    addEventListener(e, t1) {
                        super.addEventListener(e, t1);
                    }
                    on(e, t1, n) {
                        super.on(e, t1);
                    }
                    removeEventListener(e, t1) {
                        super.removeEventListener(e, t1);
                    }
                    off(e, t1) {
                        super.off(e, t1);
                    }
                    dispatchEvent(e) {
                        this.settings.state !== g.UPDATING || e.name !== a.CallEvents.Updated && e.name !== a.CallEvents.UpdateFailed || this._setState(g.CONNECTED), super.dispatchEvent(e);
                    }
                    onConnected(e, t1) {
                        if (this.signalingConnected) return !!this.checkState([
                            g.PROGRESSING,
                            g.ALERTING
                        ], "onConnected") && (this._setState(g.CONNECTED), this.startTime = Date.now(), this.dispatchEvent({
                            name: "Connected",
                            call: this,
                            headers: e
                        }), !0);
                    }
                    onFailed(e, t1, n) {
                        return this.dispatchEvent({
                            name: "Failed",
                            call: this,
                            headers: n,
                            code: e,
                            reason: t1
                        }), this._setState(g.ENDED), !0;
                    }
                    _setState(e) {
                        const t1 = {
                            call: this,
                            old: this.settings.state,
                            new: e,
                            name: a.CallEvents.StateUpdated
                        };
                        return this.settings.state = e, this.dispatchEvent(t1), e;
                    }
                    checkState(e, t1) {
                        if (e) {
                            if ("string" != typeof e) {
                                let n = !1, r = e;
                                for(let e = 0; e < r.length; e++)r[e] == this.settings.state && (n = !0);
                                if (!n) return this.logger.warning("Received " + t1 + " in invalid state " + this.settings.state), !1;
                            } else if (this.settings.state != e) return this.logger.warning("Received " + t1 + " in invalid state " + this.settings.state), !1;
                        }
                        return !0;
                    }
                }
                r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "number", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "displayName", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "headers", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "checkCallMode", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "hangup", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "mutePlayback", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "unmutePlayback", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "restoreRMute", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "sendInfo", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "sendMessage", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "addEventListener", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "on", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "removeEventListener", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "off", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "dispatchEvent", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "onConnected", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "onFailed", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "_setState", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], u.prototype, "checkState", null), t1.AbstractCall = u;
            },
            9411: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.AbstractCallManager = void 0;
                const i = n(3385), a = n(1150), s = n(125), o = n(575), d = n(245), c = n(4610), l = n(2282), g = n(141);
                class u {
                    constructor(){
                        this.protocolVersion = "3", this._h264first = !1, this.iceServers = {}, this.wsConfMap = new WeakMap, this.confEpManagerMap = new WeakMap, this.endpointManagers = new WeakMap, this._calls = {}, d.default.addHandler(this), d.default.setRPCHandler(o.RemoteEvent.onICEConfig, (e, t1)=>{
                            this.onICEResult(e, !0, t1);
                        }), d.default.setRPCHandler(o.RemoteEvent.onICEConfigFailed, (e)=>{
                            this.onICEResult(e, !1);
                        }), d.default.setRPCHandler(o.RemoteEvent.handleRejectReinvite, (e, t1, n)=>{
                            this.handleRejectReinvite(e, t1, n);
                        }), d.default.setRPCHandler(o.RemoteEvent.handleConnectionDisconnected, (e, t1, n)=>{
                            this.handleConnectionDisconnected(e, t1, n);
                        }), d.default.setRPCHandler(o.RemoteEvent.handleConnectionFailed, (e, t1, n, r)=>{
                            this.handleConnectionFailed(e, t1, n, r);
                        }), d.default.setRPCHandler(o.RemoteEvent.handleSIPInfo, (e, t1, n, r, i)=>{
                            this.handleSIPInfo(e, t1, n, r, i);
                        }), d.default.setRPCHandler(o.RemoteEvent.handleSipEvent, (e)=>{
                            this.handleSipEvent(e);
                        });
                    }
                    removeCall(e) {
                        delete this._calls[e];
                    }
                    get numCalls() {
                        return this._numCalls;
                    }
                    static cleanHeaders(e) {
                        let t1 = {};
                        for(let n in e)"X-" != n.substring(0, 2) && n != i.Constants.CALL_DATA_HEADER || (t1[n] = e[n]);
                        return t1;
                    }
                    static addCustomDataToHeaders(e) {
                        return void 0 !== e.customData && (void 0 === e.extraHeaders && (e.extraHeaders = {}), e.extraHeaders["VI-CallData"] = e.customData), e;
                    }
                    async handleConnectionFailed(e, t1, n, r) {
                        let i = this.findCall(e, "handleConnectionFailed");
                        i && "object" == typeof i && (await this.removeCall(e), s.Client.getInstance().stopProgressTone(), i.onFailed(t1, n, r));
                    }
                    getEndpointManager(e) {
                        return this.endpointManagers.get(e);
                    }
                    onICEResult(e, t1, n) {
                        if (t1) {
                            let t1 = n;
                            if (window.__VIIceServer__ && n) {
                                const e = /(stun:|turn:)(.*)*:(\d*)(\?transport=)?(tcp|udp)?/gm, r = "$1" + window.__VIIceServer__ + ":$3$4$5";
                                t1 = n.map((t1)=>(Array.isArray(t1.urls) ? t1.urls = t1.urls.map((t1)=>t1.replace(e, r)) : t1.urls = t1.urls.replace(e, r), t1));
                            }
                            this.iceServers[e] = t1, this.logger.info(`ice servers ${this.iceServers[e]}`);
                            const r = this.findCall(e, "onICEResult");
                            r && (r.peerConnection.setConfiguration ? r.peerConnection.setConfiguration(Object.assign(Object.assign({}, r.peerConnection.getConfiguration()), {
                                iceServers: t1
                            })) : this.logger.info("Failed to set ICE config due to RTCPeerConnection doesn't have the setConfiguration method"));
                        }
                    }
                    checkMaximumCallCount() {
                        if (Object.keys(this._calls).length > 199) throw new Error("The max calls number limit has been reached.");
                    }
                    handleConnectionDisconnected(e, t1, n) {
                        let r = this.findCall(e, "handleConnectionDisconnected");
                        r && (s.Client.getInstance().stopProgressTone(), r.onDisconnected(t1, n).then(()=>this.removeCall(e)).catch((t1)=>{
                            this.logger.error(`Can't remove the call ${e}: ${t1.message}`);
                        }));
                    }
                    handleSIPInfo(e, t1, n, r, i) {
                        let a = this.findCall(e, "handleSIPInfo");
                        a && a.onInfo(a, t1, n, r, i);
                    }
                    handleSipEvent(e) {}
                    onSignalingConnected() {}
                    onSignalingClosed() {
                        for(let e in this._calls)this._calls.hasOwnProperty(e) && (this._calls[e].hangup(), this._calls[e].onFailed(409, "Connection Closed", {}));
                        this._calls = {};
                    }
                    onSignalingConnectionFailed(e) {}
                    onMediaConnectionFailed() {}
                    handleRejectReinvite(e, t1, n) {
                        let r = this.findCall(e, "handleReinvite");
                        r && r.dispatchEvent({
                            code: 20,
                            call: r
                        });
                    }
                    async hangupAllCalls() {
                        const e = Object.values(this._calls).map((e)=>new Promise((t1)=>{
                                const n = setTimeout(()=>{
                                    this.logger.info(`The timeout of disconnected event for the call ${e.id()} has reached.`), this.removeCall(e.id()), e.settings.state = c.CallState.ENDED, t1();
                                }, 1500);
                                e.on(l.CallEvents.Disconnected, ()=>{
                                    clearTimeout(n), t1();
                                }, {
                                    once: !0
                                }), e.hangup();
                                const r = this.endpointManagers.get(e);
                                null == r || r.getEndpoints().forEach((e)=>r.destructEndpoint(e.id));
                            }));
                        await Promise.all(e);
                    }
                    patchAudioMixConf(e, t1) {
                        var n;
                        if (e.settings.isConference && t1) {
                            this.logger.info("patchAudioMixConf(): workaround for mixed audio conferences");
                            const t1 = null === (n = e.peerConnection.getTransceivers()) || void 0 === n ? void 0 : n[0].receiver.track;
                            if (t1) {
                                e.settings.mixedAudioTrackID = t1.id;
                                const n = (()=>{
                                    const e = document.createElement("audio");
                                    return e.autoplay = !0, e.id = t1.id, e.style.display = "none", e.srcObject = new MediaStream([
                                        t1
                                    ]), e;
                                })();
                                document.body.appendChild(n), n.play().catch((e)=>{
                                    this.logger.warning(`Can't start audio track: ${t1.id}. ${e.message}`), s.Client.getInstance().dispatchEvent({
                                        name: g.Events.PlaybackError,
                                        element: n,
                                        error: e
                                    });
                                });
                            }
                        }
                    }
                }
                r([
                    a.LogManager.d_trace(a.LogCategory.CALLMANAGER)
                ], u.prototype, "handleConnectionFailed", null), r([
                    a.LogManager.d_trace(a.LogCategory.CALLMANAGER)
                ], u.prototype, "onICEResult", null), r([
                    a.LogManager.d_trace(a.LogCategory.CALLMANAGER)
                ], u.prototype, "handleConnectionDisconnected", null), r([
                    a.LogManager.d_trace(a.LogCategory.CALLEXSERVER)
                ], u.prototype, "handleSIPInfo", null), r([
                    a.LogManager.d_trace(a.LogCategory.CALLMANAGER)
                ], u.prototype, "handleSipEvent", null), r([
                    a.LogManager.d_trace(a.LogCategory.CALLMANAGER)
                ], u.prototype, "onSignalingConnected", null), r([
                    a.LogManager.d_trace(a.LogCategory.CALLMANAGER)
                ], u.prototype, "onSignalingClosed", null), r([
                    a.LogManager.d_trace(a.LogCategory.CALLMANAGER)
                ], u.prototype, "onSignalingConnectionFailed", null), r([
                    a.LogManager.d_trace(a.LogCategory.CALLMANAGER)
                ], u.prototype, "handleRejectReinvite", null), r([
                    a.LogManager.d_trace(a.LogCategory.CALLMANAGER)
                ], u, "addCustomDataToHeaders", null), t1.AbstractCallManager = u;
            },
            3308: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Call = void 0;
                const i = n(2282), a = n(3385), s = n(1150), o = n(84), d = n(308), c = n(3869), l = n(4106), g = n(125), u = n(7272), h = n(4610), p = n(2957), f = n(9002), m = n(245), v = n(9699);
                var C = u.default.AudioDeviceManager, _ = u.default.StreamManager;
                const S = n(8237), E = n(787);
                class y extends h.AbstractCall {
                    constructor(e, t1, n, r){
                        super(e), this._audioSenderTransform = p.Utils.getDefaultStreamTransformer(), this._videoSenderTransform = p.Utils.getDefaultStreamTransformer(), this.signalingConnected = !1, this.settings = r, this.settings.id = e, this.settings.displayName = t1, this.settings.mode = h.CallMode.P2P, this.settings.active = !0, this.settings.usedSinkId = null, this.settings.incoming = n, this.settings.state = n ? h.CallState.ALERTING : h.CallState.PROGRESSING;
                        g.Client.getInstance().config();
                        this.settings.audioDirections = {
                            sendAudio: !0
                        }, this.settings.videoDirections = "boolean" == typeof r.video ? {
                            sendVideo: r.video,
                            receiveVideo: !0
                        } : r.video, this.settings.hasEarlyMedia = !1, r.audioSenderTransform && (this._audioSenderTransform = r.audioSenderTransform), r.videoSenderTransform && (this._videoSenderTransform = r.videoSenderTransform), navigator.mediaDevices.addEventListener("devicechange", this.onDeviceChange.bind(this));
                    }
                    async onDeviceChange() {
                        if (!this) return;
                        const e = C.get(), t1 = e.getDefaultAudioSettings();
                        if (t1 && !t1.inputId && !t1.outputId) return;
                        const n = [], r = [];
                        if ((await navigator.mediaDevices.enumerateDevices()).forEach((e)=>{
                            let t1 = {
                                id: e.deviceId,
                                name: e.label,
                                group: e.groupId
                            };
                            "audiooutput" === e.kind ? r.push(t1) : "audio" !== e.kind && "audioinput" !== e.kind || n.push(t1);
                        }), t1 && ("default" !== t1.inputId || "default" !== t1.outputId)) {
                            let i = (e, t1)=>{
                                var n, r, i;
                                let a = null;
                                return t1 && (a = null === (n = e.find((e)=>e.id === t1)) || void 0 === n ? void 0 : n.id), a || (a = null === (r = e.find((e)=>"default" === e.id)) || void 0 === r ? void 0 : r.id), a || (a = null === (i = e[0]) || void 0 === i ? void 0 : i.id), a;
                            };
                            const a = i(n, t1.inputId), s = i(r, t1.outputId);
                            await e.setCallAudioSettings(this, {
                                inputId: a,
                                outputId: s
                            }), await e.setDefaultAudioSettings({
                                inputId: a,
                                outputId: s
                            });
                        }
                    }
                    get promise() {
                        return this._promise;
                    }
                    get peerConnection() {
                        return this._peerConnection;
                    }
                    set peerConnection(e) {
                        this._peerConnection = e;
                    }
                    get stateValue() {
                        return this.settings.state;
                    }
                    active() {
                        return this.settings.active;
                    }
                    _setActive(e) {
                        const t1 = {
                            call: this,
                            old: this.settings.active,
                            new: e,
                            name: i.CallEvents.ActiveUpdated
                        };
                        return this.settings.active = e, this.dispatchEvent(t1), this.muteIncomingStreams(e), e;
                    }
                    muteIncomingStreams(e) {
                        this.getEndpoints().forEach((t1)=>{
                            t1.mediaRenderers.forEach((t1)=>{
                                t1.stream.getTracks().forEach((t1)=>{
                                    t1.enabled = e;
                                });
                            });
                        });
                    }
                    answer(e, t1, n, r) {
                        if (this.logger.info(`answer(\n        ${JSON.stringify(e)},\n        ${JSON.stringify(t1)},\n        ${JSON.stringify(n)},\n        H264first: ${Boolean(r)},\n      )`), void 0 !== e && (void 0 !== t1 && "object" == typeof t1 || (t1 = {}), t1[a.Constants.CALL_DATA_HEADER] = e), void 0 !== n && (n = {
                            sendVideo: g.Client.getInstance().config().videoSupport,
                            receiveVideo: g.Client.getInstance().config().videoSupport
                        }), this.settings.state != h.CallState.ALERTING) throw new Error("WRONG_CALL_STATE");
                        if (n && "object" == typeof n) {
                            const e = {
                                sendVideo: !1,
                                receiveVideo: !0
                            };
                            this._peerConnection.setVideoFlags(Object.assign(Object.assign({}, e), n));
                        }
                        this.dispatchEvent({
                            name: "AnswerAccepted",
                            call: this
                        });
                    }
                    decline(e) {
                        if (this.logger.info("decline()"), this.settings.state != h.CallState.ALERTING) throw new Error("WRONG_CALL_STATE");
                        m.default.callRemoteFunction(l.RemoteFunction.rejectCall, this.settings.id, !1, d.CallManager.cleanHeaders(e));
                    }
                    reject(e) {
                        if (this.logger.info("reject()"), this.settings.state != h.CallState.ALERTING) throw new Error("WRONG_CALL_STATE");
                        m.default.callRemoteFunction(l.RemoteFunction.rejectCall, this.settings.id, !0, d.CallManager.cleanHeaders(e));
                    }
                    hangup(e) {
                        super.hangup(e), this.logger.info(`Call ${this.settings.id} was disconnected by the user`), this._setState(h.CallState.STOPPING);
                        Object.keys(d.CallManager.get().calls).some((e)=>e !== this.settings.id) || (this.logger.info(`There are no other calls ${JSON.stringify(Object.keys(d.CallManager.get().calls))}, clean local streams`), _.clearUmCache().then(()=>{
                            this.logger.info("Streams from cache were stopped.");
                        }));
                    }
                    sendTone(e) {
                        this.logger.info(`sendTone(${e})`), this.settings.active && this._peerConnection.sendDTMF(e);
                    }
                    muteMicrophone() {
                        this.logger.info("muteMicrophone()"), this.peerConnection.muteMicrophone(!0);
                    }
                    unmuteMicrophone() {
                        this.logger.info("unmuteMicrophone()"), this.peerConnection.muteMicrophone(!1);
                    }
                    showRemoteVideo(e = !0) {
                        throw new Error("Deprecated: please use CSS to display each Media Renderer");
                    }
                    setRemoteVideoPosition(e, t1) {
                        throw new Error("Deprecated: please use CSS to position '#voximplantcontainer' element");
                    }
                    setRemoteVideoSize(e, t1) {
                        throw new Error("Deprecated: please use CSS to set size of '#voximplantcontainer' element");
                    }
                    setVideoSettings(e, t1, n) {
                        throw new Error("Deprecated: please use the Hardware interface instead");
                    }
                    getVideoElementId() {
                        throw new Error("Deprecated: please use the Media Renderer interface instead");
                    }
                    onDisconnected(e, t1) {
                        return new Promise((n, r)=>{
                            const i = u.default.StreamManager.get()._getScreenSharing(this);
                            if (i && i.forEach((e)=>{
                                u.default.StreamManager.get()._clearScreenSharing(this, e);
                            }), !this.checkState([
                                h.CallState.CONNECTED,
                                h.CallState.ALERTING,
                                h.CallState.PROGRESSING,
                                h.CallState.UPDATING,
                                h.CallState.STOPPING
                            ], "onDisconnected")) return r(new Error(`Call in the wrong state ${this.state()}`)), !1;
                            this._setState(h.CallState.ENDED), n(!0), this.dispatchEvent({
                                name: "Disconnected",
                                call: this,
                                headers: e,
                                params: t1
                            });
                        });
                    }
                    onStopRinging() {
                        return !!this.checkState([
                            h.CallState.PROGRESSING,
                            h.CallState.CONNECTED
                        ], "onStopRinging") && (this.dispatchEvent({
                            name: "ProgressToneStop",
                            call: this
                        }), !0);
                    }
                    onRingOut() {
                        return !!this.checkState(h.CallState.PROGRESSING, "onRingOut") && (this.dispatchEvent({
                            name: "ProgressToneStart",
                            call: this
                        }), !0);
                    }
                    onTransferComplete() {
                        return !!this.checkState(h.CallState.CONNECTED, "onTransferComplete") && (this.dispatchEvent({
                            name: "TransferComplete",
                            call: this
                        }), !0);
                    }
                    onTransferFailed() {
                        return !!this.checkState(h.CallState.CONNECTED, "onTransferFailed") && (this.dispatchEvent({
                            name: "TransferFailed",
                            call: this
                        }), !0);
                    }
                    onInfo(e, t1, n, r, i) {
                        if (e.stateValue == h.CallState.CONNECTED || e.stateValue == h.CallState.PROGRESSING || e.stateValue == h.CallState.ALERTING || e.stateValue == h.CallState.UPDATING) {
                            let s = t1 + "/" + n;
                            if (s == a.Constants.ZINGAYA_IM_MIME_TYPE) this.dispatchEvent({
                                name: "onSendMessage",
                                call: this,
                                text: r
                            });
                            else if (s == a.Constants.P2P_SPD_FRAG_MIME_TYPE) {
                                let t1 = JSON.parse(r);
                                for(let n in t1)void 0 !== e && void 0 !== e.peerConnection ? e.peerConnection.addRemoteCandidate(t1[n][1], t1[n][0]) : this.logger.info("Candidate skipped. Connection not created yet.");
                            } else s === a.Constants.VI_CONF_PARTICIPANT_INFO_ADDED || s === a.Constants.VI_CONF_PARTICIPANT_INFO_REMOVED || s === a.Constants.VI_CONF_PARTICIPANT_INFO_UPDATED || this.dispatchEvent({
                                name: "InfoReceived",
                                call: this,
                                body: r,
                                headers: i,
                                mimeType: s
                            });
                            return !0;
                        }
                        this.logger.warning("received handleSIPInfo for call: " + e.id() + " in invalid state: " + e.state());
                    }
                    setActive(e) {
                        return this.logger.info(`setActive(${e})`), new Promise((t1, n)=>{
                            e !== this.settings.active ? this.settings.state == h.CallState.CONNECTED ? (this._setActive(e), this.peerConnection.hold(!e), S.CallPromiseResolver.add(this, {
                                resolve: t1,
                                reject: n,
                                dispatchEvent: E.dispatchUpdatedEvent.bind(null, this)
                            })) : (E.dispatchUpdatedEvent(this, !1, v.CallFailedUpdateReasons.holdCallInWrongState), n({
                                name: i.CallEvents.UpdateFailed,
                                code: 11,
                                call: this
                            })) : t1(E.dispatchUpdatedEvent(this, !1, v.CallFailedUpdateReasons.sameActiveState(e)));
                        });
                    }
                    canStartSendingCandidates() {
                        void 0 === this._peerConnection && (this._peerConnection = o.PCFactory.get().peerConnections[this.settings.id]), this._peerConnection.canStartSendingCandidates();
                    }
                    sendVideo(e) {
                        if (this.logger.info(`sendVideo(${e})`), "boolean" != typeof e) return Promise.reject(E.dispatchUpdatedEvent(this, !1, v.CallFailedUpdateReasons.wrongTypeOfArgument(e)));
                        if (!this.active()) return Promise.reject(E.dispatchUpdatedEvent(this, !1, v.CallFailedUpdateReasons.mediaOnHold));
                        let t1 = this.peerConnection ? this.peerConnection.getTransceivers().filter((e)=>{
                            var t1;
                            return "video" === (null === (t1 = e.sender.track) || void 0 === t1 ? void 0 : t1.kind);
                        }) : [];
                        const n = u.default.StreamManager.get()._getScreenSharing(this) || [];
                        return this.peerConnection ? e && n.length ? new Promise((t1, r)=>{
                            S.CallPromiseResolver.add(this, {
                                resolve: t1,
                                reject: r,
                                dispatchEvent: E.dispatchUpdatedEvent.bind(null, this)
                            }), this.settings.videoDirections.sendVideo || (this.settings.videoDirections.sendVideo = !0);
                            const i = n[0];
                            u.default.StreamManager.get()._clearScreenSharing(this, i).then(()=>u.default.StreamManager.get().getCallStream(this, !0)).then((t1)=>{
                                let n = t1.getVideoTracks();
                                this.peerConnection.replaceSharingToVideo(n[0], "video"), this.settings.videoDirections.sendVideo = e;
                            }).catch((e)=>{
                                S.CallPromiseResolver.reject(this, e);
                            });
                        }) : !0 === this.settings.videoDirections.sendVideo && e || !1 === this.settings.videoDirections.sendVideo && !e && !t1.length ? Promise.resolve({
                            call: this,
                            name: i.CallEvents.Updated,
                            result: !0
                        }) : new Promise((t1, n)=>{
                            this.settings.videoDirections.sendVideo = e, this.peerConnection.enableVideo(e), S.CallPromiseResolver.add(this, {
                                dispatchEvent: E.dispatchUpdatedEvent.bind(null, this),
                                resolve: t1,
                                reject: n
                            });
                        }) : Promise.resolve({
                            call: this,
                            name: i.CallEvents.Updated,
                            result: !0
                        });
                    }
                    sendMedia(e, t1) {
                        return this._setState(h.CallState.UPDATING), null == e && (e = this.settings.audioDirections.sendAudio), null == t1 && (t1 = this.settings.videoDirections.sendVideo), this.peerConnection.sendMedia(e, t1).then((n)=>(null != t1 && (this.settings.videoDirections.sendVideo = t1), null != e && (this.settings.audioDirections.sendAudio = e), n));
                    }
                    shareScreen(e, t1) {
                        return void 0 === e && void 0 === t1 || this.logger.warning("The `showLocalView` and `replaceVideo` arguments of the `shareScreen` method are deprecated since v4.6.0. The `shareScreen` method now replaces local and sent video with screen sharing by default, sending video and sharing screen now unavailable.\nTo send both video and screen sharing in a conference, use the `joinAsSharing` method to join as a separate screen sharing member."), this.logger.info("shareScreen()"), this.settings.state !== h.CallState.CONNECTED ? Promise.reject(E.dispatchUpdatedEvent(this, !1, "Call is not connected.")) : this.active() ? new Promise((e, t1)=>{
                            u.default.StreamManager.get()._getScreenSharing(this).length && (this.logger.warning("Screen sharing already active."), t1(new Error("Screen sharing already active."))), c.default.isScreenSharingSupported() ? u.default.StreamManager.get()._newScreenSharing(this).then((n)=>{
                                if (this.settings.videoDirections.sendVideo) {
                                    let t1 = [];
                                    n.stream.getTracks().forEach((e)=>{
                                        "video" === e.kind && t1.push(this.peerConnection.replaceSharingToVideo(e, "sharing"));
                                    }), Promise.all(t1).then(()=>{
                                        this.peerConnection.restoreMute(), e(E.dispatchUpdatedEvent(this, !0));
                                    });
                                } else this.peerConnection.addCustomMedia(n.stream), S.CallPromiseResolver.add(this, {
                                    resolve: (t1)=>{
                                        this.peerConnection.restoreMute(), u.default.StreamManager.get().isLocalVideoRequested && u.default.StreamManager.get().updateLocalVideo("sharing"), e(t1);
                                    },
                                    reject: t1,
                                    dispatchEvent: E.dispatchUpdatedEvent.bind(null, this)
                                });
                            }).catch((e)=>{
                                this.logger.warning(e.message), t1(e);
                            }) : (this.logger.warning("Sorry, this browser does not support screen sharing."), t1(new Error("Sorry, this browser does not support screen sharing.")));
                        }) : Promise.reject(E.dispatchUpdatedEvent(this, !1, v.CallFailedUpdateReasons.mediaOnHold));
                    }
                    stopSharingScreen() {
                        return this.logger.info("stopSharingScreen()"), this.active() ? new Promise((e, t1)=>{
                            const n = u.default.StreamManager.get()._getScreenSharing(this);
                            if (n) {
                                let r = n.length;
                                n.forEach((n)=>{
                                    u.default.StreamManager.get()._clearScreenSharing(this, n).then(()=>{
                                        this.settings.videoDirections.sendVideo ? (u.default.StreamManager.get().updateCallStream(this), S.CallPromiseResolver.add(this, {
                                            resolve: e,
                                            reject: t1,
                                            dispatchEvent: E.dispatchUpdatedEvent.bind(null, this)
                                        })) : (this.peerConnection.removeCustomMedia(n.stream), S.CallPromiseResolver.add(this, {
                                            resolve: (t1)=>{
                                                this.settings.videoDirections.sendVideo && this.settings.simulcast && this.settings.isConference && this.peerConnection.getTransceivers().forEach((e)=>{
                                                    if ("inactive" !== e.currentDirection && e.sender.track && "video" === e.sender.track.kind) {
                                                        const t1 = p.Utils.buildSimulcastLayers({
                                                            trackSettings: e.sender.track.getSettings(),
                                                            trackType: "video",
                                                            profileName: this.settings.simulcastProfileName
                                                        });
                                                        this.peerConnection.setEncodingsParams(e, t1);
                                                    }
                                                }), n.stream = void 0, r--, r <= 0 && (u.default.StreamManager.get().updateLocalVideo("video"), this.peerConnection.restoreMute(), e(t1));
                                            },
                                            reject: t1,
                                            dispatchEvent: E.dispatchUpdatedEvent.bind(null, this)
                                        }));
                                    }).catch((e)=>{
                                        this.logger.warning(e.message), t1(e);
                                    });
                                });
                            } else this.logger.warning("Sorry, screen sharing not started yet."), t1(new Error("Sorry, screen sharing not started yet."));
                        }) : Promise.reject(E.dispatchUpdatedEvent(this, !1, v.CallFailedUpdateReasons.mediaOnHold));
                    }
                    getRemoteAudioStreams() {
                        throw new Error("Deprecated: please use the Media Renderer interface of each call instead");
                    }
                    getRemoteVideoStreams() {
                        throw new Error("Deprecated: please use the Media Renderer interface of each call instead");
                    }
                    useAudioOutput(e) {
                        throw new Error("Deprecated: please use the Media Renderer interface of each call instead");
                    }
                    getAudioElementId() {
                        throw new Error("Deprecated: please use the Media Renderer interface of each call instead");
                    }
                    runIncomingReInvite(e, t1) {
                        if (this.settings.state === h.CallState.UPDATING) m.default.callRemoteFunction(l.RemoteFunction.rejectReInvite, this.settings.id, {});
                        else {
                            this._setState(h.CallState.UPDATING);
                            const n = d.CallManager.get().isSDPHasVideo(t1);
                            this.peerConnection.handleRemoteOffer(e, t1, n).then(()=>{
                                this.peerConnection.restoreMute(), this.peerConnection.restoreVideoSending();
                            });
                        }
                    }
                    setActiveForce(e) {
                        this._setActive(e);
                    }
                    getEndpoints() {
                        return d.CallManager.get().getEndpointManager(this).getEndpoints();
                    }
                    scaleVideoResolutionDownBy(e) {
                        const t1 = [];
                        return this.peerConnection.getTransceivers().forEach((n)=>{
                            if (n.currentDirection && -1 !== n.currentDirection.indexOf("send") || n.direction && -1 !== n.direction.indexOf("send")) {
                                const r = n.sender.getParameters();
                                -1 != e ? r.encodings[0].scaleResolutionDownBy = e : delete r.encodings[0].scaleResolutionDownBy, t1.push(n.sender.setParameters(r));
                            }
                        }), Promise.all(t1);
                    }
                    get audioSenderTransform() {
                        return this._audioSenderTransform;
                    }
                    set audioSenderTransform(e) {
                        this._audioSenderTransform = e, this.peerConnection && this.peerConnection.updateSenderTransformers();
                    }
                    get videoSenderTransform() {
                        return this._videoSenderTransform;
                    }
                    set videoSenderTransform(e) {
                        this._videoSenderTransform = e, this.peerConnection && this.peerConnection.updateSenderTransformers();
                    }
                    get audioMediaTrackTransform() {
                        return this._audioMediaTrackTransform;
                    }
                    set audioMediaTrackTransform(e) {
                        this._audioMediaTrackTransform = e, this.peerConnection && this.peerConnection.updateSenderTrackTransformers();
                    }
                    get videoMediaTrackTransform() {
                        return this._videoMediaTrackTransform;
                    }
                    set videoMediaTrackTransform(e) {
                        this._videoMediaTrackTransform = e, this.peerConnection && this.peerConnection.updateSenderTrackTransformers();
                    }
                    _traceName() {
                        return "Call";
                    }
                }
                r([
                    f.debounceDecorator(200)
                ], y.prototype, "onDeviceChange", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "active", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "_setActive", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "answer", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "decline", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "reject", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "hangup", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "sendTone", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "muteMicrophone", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "unmuteMicrophone", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "showRemoteVideo", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "setRemoteVideoPosition", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "setRemoteVideoSize", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "setVideoSettings", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "getVideoElementId", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "onDisconnected", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "onStopRinging", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "onRingOut", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "onTransferComplete", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "onTransferFailed", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "onInfo", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "setActive", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "canStartSendingCandidates", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "sendVideo", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "shareScreen", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "stopSharingScreen", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "getRemoteAudioStreams", null), r([
                    s.LogManager.d_trace(s.LogCategory.CALL)
                ], y.prototype, "getRemoteVideoStreams", null), r([
                    s.LogManager.d_trace(s.LogCategory.CLIENT)
                ], y.prototype, "useAudioOutput", null), r([
                    s.LogManager.d_trace(s.LogCategory.CLIENT)
                ], y.prototype, "getAudioElementId", null), r([
                    s.LogManager.d_trace(s.LogCategory.CLIENT)
                ], y.prototype, "runIncomingReInvite", null), r([
                    s.LogManager.d_trace(s.LogCategory.CLIENT)
                ], y.prototype, "setActiveForce", null), t1.Call = y;
            },
            6081: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.CallError = void 0, function(e) {
                    e[e.NUMBER_IS_BUSY = 486] = "NUMBER_IS_BUSY", e[e.TERMINATED = 487] = "TERMINATED", e[e.INVALID_NUMBER = 404] = "INVALID_NUMBER", e[e.NUMBER_IS_UNAVAILABLE = 480] = "NUMBER_IS_UNAVAILABLE", e[e.REJECTED = 603] = "REJECTED", e[e.INSUFFICIENT_FUNDS = 402] = "INSUFFICIENT_FUNDS", e[e.ACCESS_DENIED = 403] = "ACCESS_DENIED", e[e.NOT_CONNECTED_TO_VOXIMPLANT = 1003] = "NOT_CONNECTED_TO_VOXIMPLANT", e[e.NOT_AUTHORIZED = 1004] = "NOT_AUTHORIZED", e[e.HTTP_NOT_SECURE = 1008] = "HTTP_NOT_SECURE";
                }(t1.CallError || (t1.CallError = {}));
            },
            2282: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.CallEvents = void 0, function(e) {
                    e[e.Connected = "Connected"] = "Connected", e[e.Disconnected = "Disconnected"] = "Disconnected", e[e.Failed = "Failed"] = "Failed", e[e.ProgressToneStart = "ProgressToneStart"] = "ProgressToneStart", e[e.ProgressToneStop = "ProgressToneStop"] = "ProgressToneStop", e[e.MessageReceived = "onSendMessage"] = "MessageReceived", e[e.InfoReceived = "InfoReceived"] = "InfoReceived", e[e.TransferComplete = "TransferComplete"] = "TransferComplete", e[e.TransferFailed = "TransferFailed"] = "TransferFailed", e[e.ICETimeout = "ICETimeout"] = "ICETimeout", e[e.RTCStatsReceived = "RTCStatsReceived"] = "RTCStatsReceived", e[e.CallStatsReceived = "CallStatsReceived"] = "CallStatsReceived", e[e.MediaElementCreated = "MediaElementCreated"] = "MediaElementCreated", e[e.MediaElementRemoved = "MediaElementRemoved"] = "MediaElementRemoved", e[e.ICECompleted = "ICECompleted"] = "ICECompleted", e[e.Updated = "Updated"] = "Updated", e[e.PendingUpdate = "PendingUpdate"] = "PendingUpdate", e[e.UpdateFailed = "UpdateFailed"] = "UpdateFailed", e[e.LocalVideoStreamAdded = "LocalVideoStreamAdded"] = "LocalVideoStreamAdded", e[e.EndpointAdded = "EndpointAdded"] = "EndpointAdded", e[e.EndpointRemoved = "EndpointRemoved"] = "EndpointRemoved", e[e.StateUpdated = "StateUpdated"] = "StateUpdated", e[e.ActiveUpdated = "ActiveUpdated"] = "ActiveUpdated", e[e.QualityIssueCodecMismatch = "QualityIssueCodecMismatch"] = "QualityIssueCodecMismatch", e[e.QualityIssueHighMediaLatency = "QualityIssueHighMediaLatency"] = "QualityIssueHighMediaLatency", e[e.QualityIssueICEDisconnected = "QualityIssueICEDisconnected"] = "QualityIssueICEDisconnected", e[e.QualityIssueLocalVideoDegradation = "QualityIssueLocalVideoDegradation"] = "QualityIssueLocalVideoDegradation", e[e.QualityIssueLowBandwidth = "QualityIssueLowBandwidth"] = "QualityIssueLowBandwidth", e[e.QualityIssueNoAudioSignal = "QualityIssueNoAudioSignal"] = "QualityIssueNoAudioSignal", e[e.QualityIssuePacketLoss = "QualityIssuePacketLoss"] = "QualityIssuePacketLoss", e[e.SharingStopped = "SharingStopped"] = "SharingStopped";
                }(t1.CallEvents || (t1.CallEvents = {}));
            },
            304: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.CallExMedia = void 0;
                const i = n(3308), a = n(1150), s = n(4106), o = n(3385), d = n(125), c = n(7272), l = n(245), g = n(3421);
                class u extends i.Call {
                    answer(e, t1, n, r) {
                        super.answer(e, t1, n, r), void 0 !== e && (void 0 !== t1 && "object" == typeof t1 || (t1 = {}), t1[o.Constants.CALL_DATA_HEADER] = e), this._answerHeaders = t1;
                        d.Client.getInstance().config();
                        return new Promise((e, t1)=>{
                            this._answerPromise = e, this.settings.videoDirections = {
                                sendVideo: "object" == typeof n && n.sendVideo,
                                receiveVideo: !0
                            }, r && (this.rearangeCodecs = g.CodecSorterHelpers.H264Sorter);
                            const i = ()=>{
                                c.default.StreamManager.get().getCallStream(this).then((e)=>{
                                    this._peerConnection.fastAddCustomMedia(e), this._peerConnection.getLocalAnswer().then((e)=>{
                                        const t1 = {
                                            mids: this.peerConnection.getMidKinds()
                                        };
                                        l.default.callRemoteFunction(s.RemoteFunction.acceptCall, this.id(), this._answerHeaders, e.sdp, t1), this._peerConnection._fixFFSoundBug(), this._answerPromise();
                                    }).catch(()=>{});
                                }).catch((e)=>t1(e));
                            };
                            this._peerConnection ? i() : setTimeout(i, 600);
                        });
                    }
                    _traceName() {
                        return "CallExMedia";
                    }
                }
                r([
                    a.LogManager.d_trace(a.LogCategory.CALL)
                ], u.prototype, "answer", null), t1.CallExMedia = u;
            },
            8748: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.CallExServer = void 0;
                const i = n(3308), a = n(308), s = n(1150), o = n(4106), d = n(4610), c = n(245);
                class l extends i.Call {
                    constructor(e, t1, n, r){
                        super(e, t1, n, r), this.settings.mode = d.CallMode.SERVER;
                    }
                    answer(e, t1) {
                        super.answer(e, t1);
                        const n = {
                            mids: this.peerConnection.getMidKinds()
                        };
                        c.default.callRemoteFunction(o.RemoteFunction.acceptCall, this.settings.id, a.CallManager.cleanHeaders(t1), n);
                    }
                    _traceName() {
                        return "CallExServer";
                    }
                }
                r([
                    s.LogManager.d_trace(s.LogCategory.CALLEXSERVER)
                ], l.prototype, "answer", null), t1.CallExServer = l;
            },
            9699: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.CallFailedUpdateReasons = void 0, t1.CallFailedUpdateReasons = {
                    mediaOnHold: "Operation can't be performed due to the call isn't active",
                    holdCallInWrongState: "Trying to make the call inactive in the wrong state",
                    sameActiveState: (e)=>"Call already " + (e ? "active" : "inactive"),
                    wrongTypeOfArgument: (e)=>`An argument for the sendVideo() method must be boolean type. Has received ${e}`
                };
            },
            308: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.CallManager = void 0;
                const i = n(2282), a = n(2957), s = n(3947), o = n(3385), d = n(1150), c = n(84), l = n(125), g = n(6746), u = n(4106), h = n(575), p = n(3421), f = n(8879), m = n(7272);
                var v = m.default.StreamManager;
                const C = n(6278), _ = n(9411), S = n(304), E = n(8748), y = n(9574), M = n(4610), R = n(9553), L = n(245);
                class T extends _.AbstractCallManager {
                    constructor(){
                        super(), this.logger = d.LogManager.get().createLogger(d.LogCategory.SIGNALING, this._traceName()), L.default.setRPCHandler(h.RemoteEvent.handleIncomingConnection, (e, t1, n, r, i, a)=>{
                            this.handleIncomingConnection(e, t1, n, r, i, a);
                        }), L.default.setRPCHandler(h.RemoteEvent.handleConnectionConnected, (e, t1, n, r, i)=>{
                            this.handleConnectionConnected(e, t1, n, i);
                        }), L.default.setRPCHandler(h.RemoteEvent.handleRingOut, (e)=>{
                            this.handleRingOut(e);
                        }), L.default.setRPCHandler(h.RemoteEvent.stopRinging, (e)=>{
                            this.stopRinging(e);
                        }), L.default.setRPCHandler(h.RemoteEvent.handleTransferStarted, (e)=>{
                            this.handleTransferStarted(e);
                        }), L.default.setRPCHandler(h.RemoteEvent.handleTransferComplete, (e)=>{
                            this.handleTransferComplete(e);
                        }), L.default.setRPCHandler(h.RemoteEvent.handleTransferFailed, (e)=>{
                            this.handleTransferFailed(e);
                        }), L.default.setRPCHandler(h.RemoteEvent.handleReInvite, (e, t1, n, r)=>{
                            this.handleInReinvite(e, t1, n, r);
                        }), L.default.setRPCHandler(h.RemoteEvent.handleAcceptReinvite, (e, t1, n, r)=>{
                            this.handleReinvite(e, t1, n, r);
                        }), L.default.setRPCHandler(h.RemoteEvent.startEarlyMedia, (e, t1, n, r)=>{
                            const i = this.findCall(e, "startEarlyMedia");
                            i && (i.settings.hasEarlyMedia = !0), this.startEarlyMedia(e, t1, n, r);
                        });
                    }
                    static get() {
                        return void 0 === this.inst && (this.inst = new T), this.inst;
                    }
                    get calls() {
                        return this._calls;
                    }
                    getCallInstance(e, t1, n, r) {
                        const i = "3" == this.protocolVersion ? new S.CallExMedia(e, t1, n, r) : new E.CallExServer(e, t1, n, r);
                        return this.endpointManagers.set(i, new y.default(i)), this._calls[e] = i, i;
                    }
                    call(e) {
                        this.checkMaximumCallCount();
                        let t1 = {
                            number: null,
                            video: {
                                sendVideo: !1,
                                receiveVideo: !0
                            },
                            isAudio: !1,
                            customData: null,
                            extraHeaders: {},
                            wiredLocal: !0,
                            wiredRemote: !0,
                            H264first: this._h264first,
                            VP8first: !1,
                            forceActive: !1,
                            extraParams: {}
                        }, n = a.Utils.mixObjectToLeft(t1, e);
                        n = T.addCustomDataToHeaders(n);
                        let r = a.Utils.generateUUID();
                        if (this._calls[r]) throw this.logger.error("Call " + r + " already exists"), new Error("Internal error");
                        const i = this.getCallInstance(r, s.Authenticator.get().displayName, !1, n);
                        n.H264first && (i.rearangeCodecs = p.CodecSorterHelpers.H264Sorter);
                        let d = !1;
                        return i.settings.active = !0, Object.keys(this._calls).length > 1 && !n.forceActive && (i.setActiveForce(!1), d = !0), void 0 === n.extraHeaders[o.Constants.DIRECT_CALL_HEADER] && "2" == this.protocolVersion ? L.default.callRemoteFunction(u.RemoteFunction.createCall, -1, n.number, n.video, r, null, null, n.extraHeaders, n.extraParams) : c.PCFactory.get().setupDirectPC(r, g.PeerConnectionMode.P2P, e.video, d).then((e)=>{
                            if (i.peerConnection = c.PCFactory.get().peerConnections[r], this.checkCallStateAndClosePC(i)) return;
                            const t1 = {
                                mids: i.peerConnection.getMidKinds()
                            };
                            L.default.callRemoteFunction(u.RemoteFunction.createCall, -1, n.number, !0, r, null, null, n.extraHeaders, "", e.sdp, t1);
                        }).catch((e)=>{
                            this.handleConnectionFailed(i.id(), 403, "Media access denied", {});
                        }), i.sendVideo(n.video.sendVideo || !1).catch(()=>{}), i;
                    }
                    callConference(e) {
                        var t1;
                        this.checkMaximumCallCount();
                        let n = {
                            number: null,
                            video: {
                                sendVideo: !1,
                                receiveVideo: !1
                            },
                            customData: null,
                            extraHeaders: {},
                            wiredLocal: !0,
                            wiredRemote: !0,
                            H264first: this._h264first,
                            VP8first: !1,
                            forceActive: !1,
                            extraParams: {},
                            simulcast: !1
                        }, r = a.Utils.mixObjectToLeft(n, e);
                        r = T.addCustomDataToHeaders(r);
                        let i = a.Utils.generateUUID();
                        if (this._calls[i]) throw this.logger.error("Call " + i + " already exists"), new Error("Internal error");
                        const o = this.getCallInstance(i, s.Authenticator.get().displayName, !1, r);
                        r.H264first && (o.rearangeCodecs = p.CodecSorterHelpers.H264ConfSorter);
                        let d = !1;
                        o.settings.active = !0, o.settings.isConference = !0, Object.keys(this._calls).length > 1 && !r.forceActive && (o.setActiveForce(!1), d = !0);
                        const l = c.PCFactory.get();
                        if (null === (t1 = l.iceConfig) || void 0 === t1 ? void 0 : t1.iceServers) {
                            const e = l.iceConfig.iceServers.filter(({ credential: e })=>!e);
                            l.iceConfig.iceServers = e;
                        }
                        return l.setupDirectPC(i, g.PeerConnectionMode.CONFERENCE, e.video, d).then((e)=>{
                            if (o.peerConnection = c.PCFactory.get().peerConnections[i], this.checkCallStateAndClosePC(o)) return;
                            const t1 = {
                                mids: o.peerConnection.getMidKinds()
                            };
                            L.default.callRemoteFunction(u.RemoteFunction.callConference, -1, r.number, !0, i, null, null, r.extraHeaders, "", e.sdp, t1);
                        }).catch((e)=>{
                            this.handleConnectionFailed(o.id(), 403, "Media access denied", {});
                        }), o.sendVideo(r.video.sendVideo || !1), this.confEpManagerMap.set(o, new R.ConferenceEndpointManager(o)), this.wsConfMap.set(o, new C.ConfSignaling(o)), o;
                    }
                    getConferenceEndpointManager(e) {
                        return this.confEpManagerMap.get(e);
                    }
                    getConfSignaling(e) {
                        return this.wsConfMap.get(e);
                    }
                    isSDPHasVideo(e) {
                        const t1 = e.indexOf("m=video");
                        if (-1 === t1) return !1;
                        const n = e.indexOf("a=sendrecv", t1), r = e.indexOf("a=sendonly", t1), i = e.indexOf("m=", t1);
                        return -1 !== n && (n < i || -1 === i) || -1 !== r && (r < i || -1 === i);
                    }
                    transferCall(e, t1) {
                        let n = [
                            e,
                            t1
                        ];
                        for(let e = 0; e < n.length; e++){
                            let t1 = this._calls[n[e].id()];
                            if (!t1) return void this.logger.error("trying to transfer unknown call " + t1.id());
                            if (t1.stateValue != M.CallState.CONNECTED) return void this.logger.error("trying to transfer call " + t1.id() + " in state " + t1.state());
                        }
                        L.default.callRemoteFunction(u.RemoteFunction.transferCall, e.id(), t1.id());
                    }
                    async removeCall(e) {
                        var t1;
                        const n = this._calls[e];
                        if (super.removeCall(e), (null == n ? void 0 : n.settings.isConference) && (null == n ? void 0 : n.settings.mixedAudioTrackID)) {
                            const e = document.getElementById(n.settings.mixedAudioTrackID);
                            e && (e.src = null, e.srcObject = null, null === (t1 = e.parentElement) || void 0 === t1 || t1.removeChild(e));
                        }
                        await m.default.StreamManager.get().updateLocalVideo();
                        Object.values(this._calls).some((e)=>e.state() !== M.CallState.ENDED) || v.clearUmCache().then(()=>{
                            this.logger.info("Streams from cache were stopped.");
                        });
                    }
                    setProtocolVersion(e) {
                        this.protocolVersion = e;
                    }
                    useVideoSource(e) {
                        let t1 = Object.keys(this._calls).length;
                        return new Promise((n, r)=>{
                            for(let i in this._calls)if (this._calls.hasOwnProperty(i)) {
                                const a = this._calls[i];
                                m.default.CameraManager.get().setCallVideoSettings(a, Object.assign(Object.assign({}, m.default.CameraManager.get().getCallVideoSettings(a)), {
                                    cameraId: e
                                })), m.default.StreamManager.get().updateCallStream(a).then((e)=>{
                                    t1--, t1 <= 0 && n();
                                }, (e)=>{
                                    r(e);
                                });
                            }
                        });
                    }
                    setVideoSettings(e) {
                        let t1 = Object.keys(this._calls).length;
                        return new Promise((n, r)=>{
                            0 === t1 && n();
                            for(let i in this._calls)if (this._calls.hasOwnProperty(i)) {
                                const a = this._calls[i];
                                m.default.CameraManager.get().setCallVideoSettings(a, m.default.CameraManager.legacyParamConverter(e)).then((e)=>{
                                    t1--, t1 <= 0 && n();
                                }, (e)=>{
                                    r(e);
                                });
                            }
                        });
                    }
                    useAudioSource(e) {
                        let t1 = Object.keys(this._calls).length;
                        return new Promise((n, r)=>{
                            0 === t1 && n();
                            for(let i in this._calls)if (this._calls.hasOwnProperty(i)) {
                                const a = this._calls[i];
                                m.default.AudioDeviceManager.get().setCallAudioSettings(a, Object.assign(Object.assign({}, m.default.AudioDeviceManager.get().getCallAudioSettings(a)), {
                                    inputId: e
                                })).then((e)=>{
                                    t1--, t1 <= 0 && n();
                                }, (e)=>{
                                    r(e);
                                });
                            }
                        });
                    }
                    handleIncomingConnection(e, t1, n, r, i, a) {
                        if (this._calls[e]) throw this.logger.error("Call " + e + " already exists"), new Error("Internal error");
                        const s = f.SDPMuggle.detectDirections(i).some((e)=>"video" === e.type && ("sendonly" === e.direction || "sendrecv" === e.direction));
                        let o = {
                            number: t1,
                            extraHeaders: r,
                            video: s,
                            isAudio: !s,
                            wiredLocal: !0,
                            wiredRemote: !0,
                            forceActive: !1
                        };
                        const d = this.getCallInstance(e, n, !0, o);
                        this._h264first && (d.rearangeCodecs = p.CodecSorterHelpers.H264Sorter);
                        let g = !1;
                        d.settings.active = !0, Object.keys(this._calls).length > 1 && (d.setActiveForce(!1), g = !0);
                        let u = [];
                        f.SDPMuggle.checkIsVimsSectionExistsIn(i) && !window.__VIIceServer__ || (u = this.iceServers[e], f.SDPMuggle.checkIsVimsSectionExistsIn(i) || (d.settings.isDirect = !0));
                        let h = i;
                        d.settings.incoming && (h = f.SDPMuggle.fixSetupSection(h)), d.settings.isDirect && (h = f.SDPMuggle.recoverVideoFmts(h, this.logger)), c.PCFactory.get().incomeDirectPC(e, {
                            receiveVideo: !0,
                            sendVideo: !0
                        }, h, g, u).then((a)=>{
                            d.peerConnection = a, l.Client.getInstance().onIncomingCall(e, t1, n, r, this.isSDPHasVideo(i));
                        }), d.sysOn("AnswerAccepted", (e)=>{
                            if (!d.settings.isConference && a) this.endpointManagers.get(d).setMIDInfo(a);
                        }), this.handleConfirmingIncomingConnection(d);
                    }
                    handleConfirmingIncomingConnection(e) {
                        e.settings.state !== M.CallState.ENDED && L.default.callRemoteFunction(u.RemoteFunction.confirmIncomingConnection, e.id());
                    }
                    handleRingOut(e) {
                        let t1 = this.findCall(e, "handleRingOut");
                        t1 && (l.Client.getInstance().playProgressTone(!0), t1.onRingOut(), t1.canStartSendingCandidates());
                    }
                    async handleConnectionConnected(e, t1, n, r) {
                        let i = this.findCall(e, "handleConnectionConnected");
                        if (i) {
                            if (this.logger.info(`handleConnectionConnected(), received SDP: \n${n}`), !i.settings.isConference && r) this.endpointManagers.get(i).setMIDInfo(r);
                            this.patchAudioMixConf(i, r), n && !f.SDPMuggle.checkIsVimsSectionExistsIn(n) && (i.settings.isDirect = !0), i.signalingConnected = !0, i.canStartSendingCandidates(), i.onConnected(t1, n);
                            try {
                                await m.default.StreamManager.get().updateLocalVideo();
                            } catch (e) {
                                this.logger.error(`handleConnectionConnected(): updating local video has failed ${JSON.stringify(e)}`);
                            }
                            if (void 0 !== n && n.length > 0) {
                                const e = n.indexOf("m=video");
                                if (-1 !== e) {
                                    const t1 = n.indexOf("a=sendrecv", e), r = n.indexOf("a=sendonly", e), i = n.indexOf("a=recvonly", e), a = n.indexOf("a=inactive", e);
                                    -1 === t1 && -1 === r && -1 === i && -1 === a && (n += "a=inactive\r\n");
                                }
                                i.settings.hasEarlyMedia || i.peerConnection.processRemoteAnswer(t1, n);
                            }
                        }
                    }
                    startEarlyMedia(e, t1, n, r) {
                        let i = this.findCall(e, "startEarlyMedia");
                        if (i) {
                            if (this.logger.info(`startEarlyMedia(), received SDP: \n${n}`), i.settings.hasEarlyMedia = !0, void 0 !== n && (i.peerConnection.processRemoteAnswer(t1, n), !i.settings.isConference && r)) this.endpointManagers.get(i).setMIDInfo(r);
                            l.Client.getInstance().stopProgressTone();
                        }
                    }
                    stopRinging(e) {
                        let t1 = this.findCall(e, "stopRinging");
                        t1 && (t1.canStartSendingCandidates(), l.Client.getInstance().stopProgressTone(), t1.onStopRinging());
                    }
                    handleTransferStarted(e) {}
                    handleTransferComplete(e) {
                        let t1 = this.findCall(e, "handleTransferComplete");
                        t1 && t1.onTransferComplete();
                    }
                    handleTransferFailed(e) {
                        let t1 = this.findCall(e, "handleTransferFailed");
                        t1 && t1.onTransferFailed();
                    }
                    async handleReinvite(e, t1, n, r) {
                        let i = this.findCall(e, "handleReinvite");
                        if (!i) return;
                        !i.settings.isConference && r && i.active() && await this.getEndpointManager(i).setMIDInfo(r);
                        const a = this.isSDPHasVideo(n);
                        let s = n;
                        i.settings.isDirect && (s = f.SDPMuggle.recoverVideoFmts(s, this.logger)), i.peerConnection.handleReinvite(t1, s, a);
                    }
                    handleInReinvite(e, t1, n, r) {
                        let a = this.findCall(e, "handleReinvite");
                        a && (this.logger.info(`handleInReinvite(), received SDP: \n${n}`), this.getEndpointManager(a).setMIDInfo(r).then(()=>{
                            let e = n;
                            a.settings.incoming && (e = f.SDPMuggle.fixSetupSection(e)), a.settings.isDirect && (e = f.SDPMuggle.recoverVideoFmts(e, this.logger)), a.runIncomingReInvite(t1, e), a.dispatchEvent({
                                name: i.CallEvents.PendingUpdate,
                                result: !0,
                                call: a
                            });
                        }));
                    }
                    checkCallStateAndClosePC(e) {
                        const t1 = e.state();
                        return (t1 === M.CallState.STOPPING || t1 === M.CallState.ENDED) && (this.logger.info(`Call ${e.id()} in ${t1} state. PeerConnection will be closed.`), e.peerConnection.close(), !0);
                    }
                    findCall(e, t1) {
                        let n = this._calls[e];
                        return "" === e && (n = this._calls[Object.keys(this._calls)[0]]), void 0 === n ? null : n;
                    }
                    recalculateNumCalls() {
                        this._numCalls = 0;
                        for(let e in this._calls)this._calls.hasOwnProperty(e) && this._numCalls++;
                    }
                    icerestart() {
                        Object.values(this._calls).forEach((e)=>{
                            let t1 = e.peerConnection.impl.iceConnectionState;
                            this.logger.info(`ICE connection state is ${t1} for call ${e.id()}`), e.settings.isDirect && e.settings.incoming || "stable" !== e.peerConnection.impl.signalingState || "failed" !== t1 && "disconnected" !== t1 || e.peerConnection._runReinvite(!0);
                        });
                    }
                    _traceName() {
                        return "CallManager";
                    }
                }
                r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "call", null), r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "removeCall", null), r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "useVideoSource", null), r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "setVideoSettings", null), r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "useAudioSource", null), r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "handleIncomingConnection", null), r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "handleRingOut", null), r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "handleConnectionConnected", null), r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "stopRinging", null), r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "handleTransferStarted", null), r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "handleTransferComplete", null), r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "handleTransferFailed", null), r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "handleReinvite", null), r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "handleInReinvite", null), r([
                    d.LogManager.d_trace(d.LogCategory.CALLMANAGER)
                ], T.prototype, "findCall", null), t1.CallManager = T;
            },
            8237: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.CallPromiseResolver = void 0;
                class n {
                    static add(e, t1) {
                        const n = this.callPromisesMap.get(e) || [];
                        this.callPromisesMap.set(e, n.concat(t1)), this.setCallPromiseTimeout(e, t1);
                    }
                    static remove(e) {
                        const t1 = this.callPromisesMap.get(e);
                        if (t1) {
                            this.callPromisesMap.delete(e);
                            for (const e of t1)this.clearCallPromiseTimeout(e);
                        }
                    }
                    static resolve(e) {
                        var t1;
                        const n = this.callPromisesMap.get(e);
                        if (n) {
                            for (const e of n){
                                const n = null === (t1 = e.dispatchEvent) || void 0 === t1 ? void 0 : t1.call(e, !0);
                                e.resolve(n);
                            }
                            this.remove(e);
                        }
                    }
                    static reject(e, t1) {
                        var n;
                        const r = this.callPromisesMap.get(e);
                        if (r) {
                            for (const e of r){
                                const r = null === (n = e.dispatchEvent) || void 0 === n ? void 0 : n.call(e, !1, t1);
                                e.reject(r);
                            }
                            this.remove(e);
                        }
                    }
                    static setCallPromiseTimeout(e, t1) {
                        const n = setTimeout(()=>{
                            this.reject(e, "Handling a reinvite has timed out");
                        }, 3e3);
                        this.timeoutIdMap.set(t1, n);
                    }
                    static clearCallPromiseTimeout(e) {
                        const t1 = this.timeoutIdMap.get(e);
                        t1 && (clearTimeout(t1), this.timeoutIdMap.delete(e));
                    }
                }
                t1.CallPromiseResolver = n, n.callPromisesMap = new WeakMap, n.timeoutIdMap = new WeakMap;
            },
            9144: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Endpoint = void 0;
                const r = n(3576), i = n(8597), a = n(1150);
                class s extends r.EventTarget {
                    constructor(e = !0){
                        super(), this.isDefault = e, this.sipUri = "", this.displayName = "", this.userName = "", this.wasAdded = !1, this.mediaRenderers = [], this.addDefaultEventListener(i.EndpointEvents.RemoteMediaAdded, (e)=>{
                            e.mediaRenderer.renderDefault();
                        }), this.logger = a.LogManager.get().createLogger(a.LogCategory.ENDPOINT, `${this._traceName()} ${this.id}`);
                    }
                    enableAll() {
                        this.mediaRenderers.map((e)=>e.enable());
                    }
                    disableAll() {
                        this.mediaRenderers.map((e)=>e.disable());
                    }
                    useAudioOutput(e) {
                        this.logger.info(`useAudioOutput(${e})`), this.mediaRenderers && this.mediaRenderers.forEach((t1)=>t1.useAudioOutput(e));
                    }
                    updateInfo(e) {
                        this.place = e.place, this.sipUri = e.sipURI, this.displayName = e.displayName, this.userName = e.username;
                    }
                    _traceName() {
                        return "Endpoint";
                    }
                }
                t1.Endpoint = s;
            },
            8597: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.EndpointEvents = void 0, function(e) {
                    e.InfoUpdated = "InfoUpdated", e.Removed = "Removed", e.RemoteMediaAdded = "RemoteMediaAdded", e.RemoteMediaRemoved = "RemoteMediaRemoved", e.RemoteMediaUpdated = "RemoteMediaUpdated", e.RTCStatsReceived = "RTCStatsReceived", e.VoiceStart = "VoiceStart", e.VoiceEnd = "VoiceEnd", e.MediaRenderDisabled = "MediaRenderDisabled", e.MediaRenderEnabled = "MediaRenderEnabled";
                }(t1.EndpointEvents || (t1.EndpointEvents = {}));
            },
            9574: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                });
                const i = n(9144), a = n(3992), s = n(2282), o = n(8597), d = n(7222), c = n(8707), l = n(308);
                class g {
                    constructor(e){
                        this.call = e, this.transceiverBucket = [], this.displayRules = {
                            new: {
                                audio: [
                                    "default"
                                ],
                                video: [
                                    "default"
                                ]
                            }
                        }, this.transceiverEndpointHashMap = new WeakMap, this.activeEndpoints = new Map, this.activeMR = new Map, this.mutex = new a.TaskMutex, this.endpointInfo = {
                            endpoints: {},
                            reinviteCauses: []
                        };
                    }
                    setDisplayRules(e) {
                        throw new Error("not implemented");
                    }
                    setMIDInfo(e) {
                        const t1 = JSON.parse(e);
                        t1.endpoints[""] && (t1.endpoints[this.call.id()] = t1.endpoints[""], delete t1.endpoints[""]);
                        const n = this.diffEndpoints(t1);
                        this.endpointInfo = t1;
                        for(let e in n.added)n.added.hasOwnProperty(e) && this.constructEndpoint(e, n.added[e]);
                        for(let e in n.removed)n.removed.hasOwnProperty(e) && this.destructEndpoint(e);
                        for(let e in n.changed)if (n.changed.hasOwnProperty(e)) {
                            const r = this.activeEndpoints.get(e);
                            for(let i in n.changed[e].midDiff.added)n.changed[e].midDiff.added.hasOwnProperty(i) && this.transceiverBucket.forEach((n)=>{
                                n.mid === i && this.createNewMR(n, r, t1.endpoints[e].mids);
                            });
                            for(let i in n.changed[e].midDiff.changed)if (n.changed[e].midDiff.changed.hasOwnProperty(i)) {
                                const a = this.activeMR.get(i);
                                a ? (a.kind = n.changed[e].midDiff.changed[i], r.dispatchEvent({
                                    name: o.EndpointEvents.RemoteMediaUpdated,
                                    call: this.call,
                                    endpoint: r,
                                    mediaRenderer: a
                                })) : this.transceiverBucket.forEach((n)=>{
                                    n.mid === i && this.createNewMR(n, r, t1.endpoints[e].mids);
                                });
                            }
                            for(let i in n.changed[e].midDiff.removed)if (n.changed[e].midDiff.removed.hasOwnProperty(i)) {
                                let n = t1.endpoints[e].mids;
                                if ("ViewerCall" === this.call._traceName() && Object.keys(n).find((e)=>"audio" === n[e])) {
                                    const e = this.activeMR.get(i);
                                    e && (e.kind = "audio", e.stream.getVideoTracks().forEach((t1)=>{
                                        t1.stop(), e.stream.removeTrack(t1);
                                    }), this.activeMR.delete(i)), r.dispatchEvent({
                                        name: o.EndpointEvents.RemoteMediaUpdated,
                                        call: this.call,
                                        endpoint: r,
                                        mediaRenderer: e
                                    });
                                } else {
                                    const e = this.activeMR.get(i);
                                    this.removeMediaRenderer(r, e), this.activeMR.delete(i);
                                }
                            }
                        }
                    }
                    updateTransceiver(e) {
                        if (!e.mid) return;
                        this.transceiverBucket.find((t1)=>t1 === e) || this.transceiverBucket.push(e);
                        const t1 = this.searchEndpointByMid(e.mid);
                        t1 && this.createNewMR(e, t1.endpoint, t1.mids);
                    }
                    getEndpointInfo() {
                        return this.endpointInfo;
                    }
                    destructEndpoint(e) {
                        const t1 = this.activeEndpoints.get(e);
                        t1 && (t1.mediaRenderers.forEach((e)=>{
                            t1.dispatchEvent({
                                name: o.EndpointEvents.RemoteMediaRemoved,
                                call: this.call,
                                endpoint: t1,
                                mediaRenderer: e
                            }), e.mids.forEach((e)=>this.activeMR.delete(e)), e.clear();
                        }), this.activeEndpoints.delete(e), t1.dispatchEvent({
                            name: o.EndpointEvents.Removed,
                            call: this.call,
                            endpoint: t1
                        }), this.call.dispatchEvent({
                            name: s.CallEvents.EndpointRemoved,
                            call: this.call,
                            endpoint: t1
                        }));
                    }
                    makeMids(e) {
                        const t1 = {};
                        return c.default.parse(e).media.forEach((e, n)=>{
                            const r = e.attr.find((e)=>"mid" === e.name);
                            t1[r ? r.value : n] = e.descr.media;
                        }), {
                            endpoints: {
                                [this.call.id()]: {
                                    place: 0,
                                    type: "call",
                                    mids: t1
                                }
                            },
                            reinviteCauses: []
                        };
                    }
                    constructEndpoint(e, t1, n = !1) {
                        const r = new i.Endpoint(n);
                        let a;
                        r.id = e, a = this.call.settings.isConference ? this.getDataForConference({
                            id: e,
                            place: t1.place
                        }) : {
                            id: e,
                            place: t1.place,
                            displayName: this.call.settings.displayName,
                            sipURI: "",
                            username: ""
                        }, r.updateInfo(a), this.activeEndpoints.set(e, r), this.call.dispatchEvent({
                            name: s.CallEvents.EndpointAdded,
                            endpoint: r,
                            call: this.call
                        }), this.transceiverBucket.forEach((e)=>this.updateTransceiver(e));
                    }
                    getDataForConference({ id: e, place: t1 }) {
                        const n = {
                            id: e,
                            place: t1,
                            displayName: "",
                            sipURI: "",
                            username: ""
                        }, r = this.endpointInfo.reinviteCauses.find((t1)=>t1.id === e);
                        return r && (r.displayName && (n.displayName = r.displayName), r.sipURI && (n.sipURI = r.sipURI), r.username && (n.username = r.username)), n;
                    }
                    diffMids(e, t1) {
                        const n = {
                            added: {},
                            changed: {},
                            removed: {},
                            unchanged: {}
                        };
                        let r = !1;
                        for(let i in t1)t1.hasOwnProperty(i) && (e.hasOwnProperty(i) ? e[i] !== t1[i] ? (n.changed[i] = t1[i], r = !0) : n.unchanged[i] = t1[i] : (n.added[i] = t1[i], r = !0));
                        for(let i in e)e.hasOwnProperty(i) && !t1.hasOwnProperty(i) && (n.removed[i] = e[i], r = !0);
                        return {
                            result: r,
                            diff: n
                        };
                    }
                    searchEndpointByMid(e) {
                        for(let t1 in this.endpointInfo.endpoints)if (this.endpointInfo.endpoints.hasOwnProperty(t1) && this.endpointInfo.endpoints[t1].mids[e]) return {
                            endpoint: this.activeEndpoints.get(t1),
                            mids: this.endpointInfo.endpoints[t1].mids
                        };
                        return null;
                    }
                    getEndpoints() {
                        return Array.from(this.activeEndpoints.values());
                    }
                    diffEndpoints(e) {
                        const t1 = {
                            added: {},
                            changed: {},
                            removed: {},
                            unchanged: {}
                        };
                        for(let n in e.endpoints)if (e.endpoints.hasOwnProperty(n)) {
                            if (this.endpointInfo.endpoints.hasOwnProperty(n)) {
                                const r = this.diffMids(this.endpointInfo.endpoints[n].mids, e.endpoints[n].mids);
                                r.result ? t1.changed[n] = Object.assign(Object.assign({}, e.endpoints[n]), {
                                    midDiff: r.diff
                                }) : t1.unchanged[n] = e.endpoints[n];
                            } else t1.added[n] = e.endpoints[n];
                        }
                        for(let n in this.endpointInfo.endpoints)this.endpointInfo.endpoints.hasOwnProperty(n) && !e.endpoints.hasOwnProperty(n) && (t1.removed[n] = this.endpointInfo.endpoints[n]);
                        return t1;
                    }
                    createNewMR(e, t1, n) {
                        if (!e.mid) return;
                        this.transceiverEndpointHashMap.set(e, t1);
                        const r = this.mediaRendererFabric(e, n);
                        r && (r.conferenceEpManagerUpdateState = ()=>{
                            var e;
                            null === (e = l.CallManager.get().getConferenceEndpointManager(this.call)) || void 0 === e || e.updateState();
                        }, r.conferenceEpManagerUpdateRenderSize = ()=>{
                            var e;
                            null === (e = l.CallManager.get().getConferenceEndpointManager(this.call)) || void 0 === e || e.updateRenderSize();
                        }, this.activeMR.set(e.mid, r), t1.mediaRenderers.push(r), t1.dispatchEvent({
                            name: o.EndpointEvents.RemoteMediaAdded,
                            call: this.call,
                            endpoint: t1,
                            mediaRenderer: r
                        }));
                    }
                    mediaRendererFabric(e, t1) {
                        if (e.mid) {
                            if (this.activeMR.has(e.mid)) return null;
                            if ("ViewerCall" !== this.call._traceName()) return new d.MediaRenderer({
                                stream: new MediaStream([
                                    e.receiver.track
                                ]),
                                kind: t1[e.mid],
                                transceivers: [
                                    e
                                ],
                                mids: [
                                    e.mid
                                ]
                            });
                            {
                                const n = Object.keys(t1), r = this.transceiverBucket.filter((e)=>n.includes(e.mid));
                                if ("audio" === t1[e.mid]) return n.length > r.length ? null : 2 === n.length && n.length === r.length ? new d.MediaRenderer({
                                    stream: new MediaStream([
                                        r[0].receiver.track,
                                        r[1].receiver.track
                                    ]),
                                    kind: "video",
                                    transceivers: [
                                        r[0],
                                        r[1]
                                    ],
                                    mids: [
                                        r[0].mid,
                                        r[1].mid
                                    ]
                                }) : new d.MediaRenderer({
                                    stream: new MediaStream([
                                        e.receiver.track
                                    ]),
                                    kind: "audio",
                                    transceivers: [
                                        e
                                    ],
                                    mids: [
                                        e.mid
                                    ]
                                });
                                if ("video" === t1[e.mid] || "sharing" === t1[e.mid]) {
                                    let i = n.find((e)=>"audio" === t1[e]), a = this.activeMR.get(i), s = r.find((e)=>e.mid === i);
                                    if (a && a.element instanceof HTMLVideoElement) return a.kind = "video", a.stream.addTrack(e.receiver.track), a.element.srcObject = a.stream, a.transceivers = [
                                        e,
                                        s
                                    ], a.mids = [
                                        e.mid,
                                        s.mid
                                    ], a;
                                    if (a) {
                                        let n = this.transceiverEndpointHashMap.get(e);
                                        this.removeMediaRenderer(n, a);
                                        const r = new d.MediaRenderer({
                                            stream: new MediaStream([
                                                s.receiver.track,
                                                e.receiver.track
                                            ]),
                                            kind: t1[e.mid],
                                            transceivers: [
                                                e
                                            ],
                                            mids: [
                                                e.mid
                                            ]
                                        });
                                        return this.activeMR.set(i, r), r;
                                    }
                                    if (!a && r.find((e)=>e.mid === i)) {
                                        const n = new d.MediaRenderer({
                                            stream: new MediaStream([
                                                s.receiver.track,
                                                e.receiver.track
                                            ]),
                                            kind: t1[e.mid],
                                            transceivers: [
                                                e
                                            ],
                                            mids: [
                                                e.mid
                                            ]
                                        });
                                        return this.activeMR.set(i, n), n;
                                    }
                                    return new d.MediaRenderer({
                                        stream: new MediaStream([
                                            e.receiver.track
                                        ]),
                                        kind: t1[e.mid],
                                        transceivers: [
                                            e
                                        ],
                                        mids: [
                                            e.mid
                                        ]
                                    });
                                }
                            }
                        }
                    }
                    removeMediaRenderer(e, t1) {
                        e.mediaRenderers = e.mediaRenderers.filter((e)=>e.id !== t1.id), e.dispatchEvent({
                            name: o.EndpointEvents.RemoteMediaRemoved,
                            call: this.call,
                            endpoint: e,
                            mediaRenderer: t1
                        }), t1.clear();
                    }
                }
                r([
                    a.queueDecorator()
                ], g.prototype, "setDisplayRules", null), r([
                    a.queueDecorator()
                ], g.prototype, "setMIDInfo", null), r([
                    a.queueDecorator()
                ], g.prototype, "updateTransceiver", null), t1.default = g;
            },
            6497: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.SharingCall = void 0;
                const i = n(1150), a = n(3947), s = n(3902), o = n(4610), d = n(3385), c = n(245), l = n(4106), g = n(125), u = n(575), h = n(3869);
                class p extends o.AbstractCall {
                    constructor(e, t1){
                        super(e), this.signalingConnected = !1, this.settings = {
                            id: e,
                            displayName: a.Authenticator.get().displayName,
                            mode: o.CallMode.P2P,
                            number: t1.number,
                            video: {
                                sendVideo: !0,
                                receiveVideo: !1
                            },
                            customData: null,
                            extraHeaders: t1.extraHeaders,
                            wiredLocal: !0,
                            wiredRemote: !0,
                            H264first: !0,
                            VP8first: !1,
                            forceActive: !1,
                            usedSinkId: null,
                            extraParams: {},
                            active: !0,
                            state: o.CallState.PROGRESSING,
                            audioDirections: {
                                sendAudio: t1.audioDirections.sendAudio
                            },
                            videoDirections: {
                                sendVideo: !0,
                                receiveVideo: !1
                            },
                            hasEarlyMedia: !1,
                            incoming: !1,
                            simulcast: !1,
                            isConference: !0,
                            simulcastProfileName: "general"
                        };
                        const n = new RTCPeerConnection;
                        let r;
                        n ? this.getNewScreenSharing().then((t1)=>{
                            if (null !== t1.stream) {
                                const i = t1.stream.getVideoTracks()[0], a = t1.stream.getAudioTracks()[0] || "audio";
                                n.addTransceiver(a, {
                                    direction: "sendonly",
                                    streams: [
                                        t1.stream
                                    ]
                                }), n.addTransceiver(i, {
                                    direction: "sendonly",
                                    streams: [
                                        t1.stream
                                    ]
                                }), n.createOffer({
                                    offerToReceiveAudio: !1,
                                    offerToReceiveVideo: !1
                                }).then((e)=>(r = e, n.setLocalDescription(e))).then(()=>{
                                    this.peerConnection = n;
                                    c.default.callRemoteFunction(l.RemoteFunction.callConference, -1, this.settings.number, !0, e, null, null, this.settings.extraHeaders, "", r.sdp, {
                                        mids: {
                                            0: "audio",
                                            1: "sharing"
                                        }
                                    });
                                }).catch(()=>{
                                    this.handleConnectionFailed(1001, "", {});
                                });
                            } else this.handleConnectionFailed(1001, "", {});
                        }) : this.handleConnectionFailed(1001, "", {}), this.setHandlers();
                    }
                    getEndpoints() {
                        return [];
                    }
                    getNewScreenSharing() {
                        return new Promise((e, t1)=>{
                            h.default.getScreenMedia(this.settings.audioDirections.sendAudio).then((t1)=>{
                                const n = {
                                    stream: t1,
                                    renderer: null
                                };
                                t1.getTracks().forEach((e)=>{
                                    e.onended = ()=>{
                                        this.hangup();
                                    };
                                }), e(n);
                            }).catch((e)=>{
                                this.logger.error(`Media access denied: ${e ? e.message || e.name || e : "unknown"}`), t1(e);
                            });
                        });
                    }
                    setHandlers() {
                        c.default.setRPCHandler(u.RemoteEvent.handleRejectReinvite, (e, t1, n)=>{
                            e === this.settings.id && this.handleRejectReinvite();
                        }), c.default.setRPCHandler(u.RemoteEvent.handleConnectionDisconnected, (e, t1, n)=>{
                            e === this.settings.id && this.handleConnectionDisconnected(e, t1, n);
                        }), c.default.setRPCHandler(u.RemoteEvent.handleConnectionFailed, (e, t1, n, r)=>{
                            e === this.settings.id && this.handleConnectionFailed(t1, n, r);
                        }), c.default.setRPCHandler(u.RemoteEvent.handleSIPInfo, (e, t1, n, r, i)=>{
                            e === this.settings.id && this.handleSIPInfo(t1, n, r, i);
                        }), c.default.setRPCHandler(u.RemoteEvent.handleConnectionConnected, (e, t1, n)=>{
                            e === this.settings.id && this.handleConnectionConnected(t1, n);
                        }), c.default.setRPCHandler(u.RemoteEvent.handleReInvite, (e, t1, n)=>{
                            e === this.settings.id && this.handleInReinvite(t1, n);
                        }), c.default.setRPCHandler(u.RemoteEvent.handleAcceptReinvite, (e, t1, n)=>{
                            e === this.settings.id && this.handleReinvite(n);
                        });
                    }
                    handleRejectReinvite() {
                        this.dispatchEvent({
                            code: 20,
                            call: this
                        });
                    }
                    handleInReinvite(e, t1) {
                        return new Promise((n)=>{
                            this.logger.info(`handleInReinvite(), received SDP: \n${t1}`);
                            const r = new RTCSessionDescription({
                                sdp: t1,
                                type: "offer"
                            });
                            this.peerConnection.setRemoteDescription(r).then(()=>this.peerConnection.createAnswer()).then((t1)=>{
                                this.peerConnection.setLocalDescription(t1).then(()=>{
                                    this.restoreRMute();
                                    c.default.callRemoteFunction(l.RemoteFunction.acceptReInvite, this.settings.id, e, t1.sdp, {
                                        mids: {
                                            0: "audio",
                                            1: "sharing"
                                        }
                                    }), n();
                                });
                            }).catch((e)=>{
                                this.dispatchEvent({
                                    name: "SDP",
                                    origin: "handleInReinvite",
                                    sdp: this.peerConnection.localDescription,
                                    description: `answer_reject: ${e.message}`
                                }), this.logger.error(e), n();
                            });
                        });
                    }
                    handleConnectionConnected(e, t1) {
                        return new Promise((n)=>{
                            this.logger.info(`handleConnectionConnected(), received SDP: \n${t1}`), void 0 !== t1 && "have-local-offer" === this.peerConnection.signalingState ? (this.signalingConnected = !0, this.onConnected(e, t1), this.processRemoteAnswer(t1).then(()=>n()).catch((e)=>{
                                this.logger.error(e), n();
                            })) : (this.logger.error(`handleConnectionConnected: Wrong connection state ${this.peerConnection.signalingState} or empty SDP`), n());
                        });
                    }
                    handleConnectionDisconnected(e, t1, n) {
                        g.Client.getInstance().stopProgressTone(), this.peerConnection.getTransceivers().forEach((e)=>{
                            const t1 = e.sender.track;
                            e.sender.replaceTrack(null).then(()=>{
                                t1 && (t1.onended = null, t1.onmute = null, t1.stop()), e.direction = "inactive";
                            });
                        }), this.onDisconnected(t1, n).catch((t1)=>{
                            this.logger.error(`Can't remove the call ${e}: ${t1.message}`);
                        });
                    }
                    handleSIPInfo(e, t1, n, r) {
                        this.onInfo(this, e, t1, n, r);
                    }
                    handleReinvite(e) {
                        return new Promise((t1)=>{
                            this.logger.info(`handleReinvite(), received SDP: \n${e}`), this.processRemoteAnswer(e).then(()=>t1()).catch((e)=>{
                                this.logger.error(e), t1();
                            });
                        });
                    }
                    handleConnectionFailed(e, t1, n) {
                        g.Client.getInstance().stopProgressTone(), this.onFailed(e, t1, n);
                    }
                    onDisconnected(e, t1) {
                        return new Promise((n, r)=>{
                            this._setState(o.CallState.ENDED), this.dispatchEvent({
                                name: "Disconnected",
                                call: this,
                                headers: e,
                                params: t1
                            }), n(!0);
                        });
                    }
                    onInfo(e, t1, n, r, i) {
                        return t1 + "/" + n == d.Constants.ZINGAYA_IM_MIME_TYPE ? this.dispatchEvent({
                            name: "onSendMessage",
                            call: this,
                            text: r
                        }) : this.dispatchEvent({
                            name: "InfoReceived",
                            call: this,
                            body: r,
                            headers: i,
                            mimeType: t1 + "/" + n
                        }), !0;
                    }
                    processRemoteAnswer(e) {
                        return new Promise((t1, n)=>{
                            if (void 0 !== e && e.length > 0) {
                                let r = {
                                    sdp: e,
                                    type: s.RTCSdpType.answer
                                };
                                this.peerConnection.setRemoteDescription(r).then(()=>{
                                    this.restoreRMute(), t1();
                                }).catch((e)=>{
                                    this.dispatchEvent({
                                        name: "SDP",
                                        origin: "_processRemoteAnswer",
                                        sdp: this.peerConnection.localDescription,
                                        description: `answer_reject: ${e.message}`
                                    }), n(e);
                                });
                            } else n();
                        });
                    }
                    _traceName() {
                        return "ViewerCall";
                    }
                }
                r([
                    i.LogManager.d_trace(i.LogCategory.CALL)
                ], p.prototype, "handleConnectionFailed", null), r([
                    i.LogManager.d_trace(i.LogCategory.CALL)
                ], p.prototype, "onDisconnected", null), t1.SharingCall = p;
            },
            4211: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                });
                const r = n(6497), i = n(2957), a = n(4610), s = n(2282), o = n(1150);
                class d {
                    constructor(){
                        this.calls = new Map, this.logger = o.LogManager.get().createLogger(o.LogCategory.SIGNALING, "SharingCallManager");
                    }
                    static get() {
                        var e;
                        return null !== (e = this.inst) && void 0 !== e || (this.inst = new d), this.inst;
                    }
                    findCall(e) {
                        return this.calls.get(e);
                    }
                    call(e) {
                        const t1 = i.Utils.generateUUID(), n = new r.SharingCall(t1, e);
                        return this.calls.set(t1, n), n;
                    }
                    removeCall(e) {
                        this.calls.delete(e);
                    }
                    async hangupAllCalls() {
                        const e = Array.from(this.calls.values()).map((e)=>new Promise((t1)=>{
                                const n = setTimeout(()=>{
                                    this.logger.info(`The timeout of disconnected event for the call ${e.id()} has reached.`), this.removeCall(e.id()), e.settings.state = a.CallState.ENDED, t1();
                                }, 1500);
                                e.on(s.CallEvents.Disconnected, ()=>{
                                    clearTimeout(n), t1();
                                }, {
                                    once: !0
                                }), e.hangup();
                            }));
                        await Promise.all(e);
                    }
                }
                t1.default = d;
            },
            8582: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.ViewerCall = void 0;
                const i = n(1150), a = n(3947), s = n(9774), o = n(3902), d = n(4610), c = n(3385);
                class l extends d.AbstractCall {
                    constructor(e, t1){
                        super(e), this.signalingConnected = !1, this.settings = {
                            id: e,
                            displayName: a.Authenticator.get().displayName,
                            mode: d.CallMode.P2P,
                            number: t1.number,
                            video: {
                                sendVideo: !1,
                                receiveVideo: !0
                            },
                            customData: null,
                            extraHeaders: t1.extraHeaders,
                            wiredLocal: !0,
                            wiredRemote: !0,
                            H264first: !0,
                            VP8first: !1,
                            forceActive: !1,
                            usedSinkId: null,
                            extraParams: {},
                            active: !0,
                            state: d.CallState.PROGRESSING,
                            audioDirections: {
                                sendAudio: !1
                            },
                            videoDirections: {
                                sendVideo: !1,
                                receiveVideo: !0
                            },
                            hasEarlyMedia: !1,
                            incoming: !1,
                            simulcast: !1,
                            isConference: !0,
                            simulcastProfileName: "general"
                        };
                    }
                    getEndpoints() {
                        return s.ViewerManager.get().getEndpointManager(this).getEndpoints();
                    }
                    onDisconnected(e, t1) {
                        return new Promise((n, r)=>{
                            this._setState(d.CallState.ENDED);
                            const i = s.ViewerManager.get().getEndpointManager(this);
                            i.getEndpoints().forEach((e)=>{
                                i.destructEndpoint(e.id);
                            }), this.dispatchEvent({
                                name: "Disconnected",
                                call: this,
                                headers: e,
                                params: t1
                            }), n(!0);
                        });
                    }
                    onInfo(e, t1, n, r, i) {
                        return t1 + "/" + n == c.Constants.ZINGAYA_IM_MIME_TYPE ? this.dispatchEvent({
                            name: "onSendMessage",
                            call: this,
                            text: r
                        }) : this.dispatchEvent({
                            name: "InfoReceived",
                            call: this,
                            body: r,
                            headers: i,
                            mimeType: t1 + "/" + n
                        }), !0;
                    }
                    processRemoteAnswer(e) {
                        return new Promise((t1, n)=>{
                            if (void 0 !== e && e.length > 0) {
                                let r = {
                                    sdp: e,
                                    type: o.RTCSdpType.answer
                                };
                                this.peerConnection.setRemoteDescription(r).then(()=>{
                                    this.restoreRMute(), t1();
                                }).catch((e)=>{
                                    this.dispatchEvent({
                                        name: "SDP",
                                        origin: "_processRemoteAnswer",
                                        sdp: this.peerConnection.localDescription,
                                        description: `answer_reject: ${e.message}`
                                    }), n(e);
                                });
                            } else n();
                        });
                    }
                    _traceName() {
                        return "ViewerCall";
                    }
                }
                r([
                    i.LogManager.d_trace(i.LogCategory.CALL)
                ], l.prototype, "onDisconnected", null), t1.ViewerCall = l;
            },
            9774: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.ViewerManager = void 0;
                const i = n(1150), a = n(2957), s = n(4106), o = n(575), d = n(9411), c = n(8582), l = n(9574), g = n(3992), u = n(245), h = n(9553), p = n(6278);
                class f extends d.AbstractCallManager {
                    constructor(){
                        super(), this.peerConnectionManagers = new WeakMap, this.mutex = new g.TaskMutex, this.logger = i.LogManager.get().createLogger(i.LogCategory.SIGNALING, this._traceName()), u.default.setRPCHandler(o.RemoteEvent.handleConnectionConnected, (e, t1, n, r, i)=>{
                            this.handleConnectionConnected(e, t1, n, i);
                        }), u.default.setRPCHandler(o.RemoteEvent.handleReInvite, (e, t1, n, r)=>{
                            this.handleInReinvite(e, t1, n, r);
                        }), u.default.setRPCHandler(o.RemoteEvent.handleAcceptReinvite, (e, t1, n)=>{
                            this.handleReinvite(e, t1, n);
                        }), u.default.setRPCHandler(o.RemoteEvent.startEarlyMedia, (e, t1, n)=>{
                            this.startEarlyMedia(e, t1, n);
                        });
                    }
                    static get() {
                        return void 0 === this.inst && (this.inst = new f), this.inst;
                    }
                    get calls() {
                        return this._calls;
                    }
                    joinAsViewer(e) {
                        let t1 = a.Utils.generateUUID();
                        if (this._calls[t1]) throw this.logger.error("Call " + t1 + " already exists"), new Error("Internal error");
                        const n = new c.ViewerCall(t1, e);
                        this._calls[t1] = n;
                        const r = f.get().calls[t1], i = new RTCPeerConnection;
                        let o;
                        return i.addEventListener("track", (e)=>this.onAddTrack(e, n)), i ? (i.addTransceiver("audio", {
                            direction: "recvonly"
                        }), i.addTransceiver("video", {
                            direction: "recvonly"
                        }), i.createOffer({
                            offerToReceiveAudio: !0,
                            offerToReceiveVideo: !0
                        }).then((e)=>(o = e, i.setLocalDescription(e))).then(()=>{
                            n.peerConnection = i, this.endpointManagers.set(n, new l.default(n)), u.default.callRemoteFunction(s.RemoteFunction.callConference, -1, n.settings.number, !0, t1, null, null, n.settings.extraHeaders, "", o.sdp);
                        }).catch(()=>{
                            f.get().handleConnectionFailed(r.settings.id, 1001, "", {});
                        })) : f.get().handleConnectionFailed(r.settings.id, 1001, "", {}), this.confEpManagerMap.set(n, new h.ConferenceEndpointManager(n)), this.wsConfMap.set(n, new p.ConfSignaling(n)), n;
                    }
                    getConferenceEndpointManager(e) {
                        return this.confEpManagerMap.get(e);
                    }
                    getConfSignaling(e) {
                        return this.wsConfMap.get(e);
                    }
                    _traceName() {
                        return "ViewerManager";
                    }
                    findCall(e, t1) {
                        let n = this._calls[e];
                        return "" === e && (n = this._calls[Object.keys(this._calls)[0]]), void 0 === n ? null : n;
                    }
                    handleConnectionConnected(e, t1, n, r) {
                        return new Promise((i)=>{
                            let a = this.findCall(e, "handleConnectionConnected");
                            a ? (this.logger.info(`handleConnectionConnected(), received SDP: \n${n}`), this.patchAudioMixConf(a, r), void 0 !== n && "have-local-offer" === a.peerConnection.signalingState ? (a.signalingConnected = !0, a.onConnected(t1, n), a.processRemoteAnswer(n).then(()=>i()).catch((e)=>{
                                this.logger.error(e), i();
                            })) : (this.logger.error(`handleConnectionConnected: Wrong connection state ${a.peerConnection.signalingState} or empty SDP`), i())) : i();
                        });
                    }
                    startEarlyMedia(e, t1, n) {
                        return new Promise((t1)=>{
                            let r = this.findCall(e, "startEarlyMedia");
                            r ? (this.logger.info(`startEarlyMedia(), received SDP: \n${n}`), void 0 !== n && "have-local-offer" === r.peerConnection.signalingState ? (r.settings.hasEarlyMedia = !0, r.processRemoteAnswer(n).then(()=>t1()).catch((e)=>{
                                this.logger.error(e), t1();
                            })) : (this.logger.error(`handleConnectionConnected: Wrong connection state ${r.peerConnection.signalingState} or empty SDP`), t1())) : t1();
                        });
                    }
                    handleReinvite(e, t1, n) {
                        return new Promise((t1)=>{
                            let r = this.findCall(e, "handleReinvite");
                            r ? (this.logger.info(`handleReinvite(), received SDP: \n${n}`), r.processRemoteAnswer(n).then(()=>t1()).catch((e)=>{
                                this.logger.error(e), t1();
                            })) : t1();
                        });
                    }
                    handleInReinvite(e, t1, n, r) {
                        return new Promise((i)=>{
                            const a = this.findCall(e, "handleInReinvite");
                            a ? (this.logger.info(`handleInReinvite(), received SDP: \n${n}`), this.getEndpointManager(a).setMIDInfo(r).then(()=>{
                                const e = new RTCSessionDescription({
                                    sdp: n,
                                    type: "offer"
                                });
                                return a.peerConnection.setRemoteDescription(e);
                            }).then(()=>a.peerConnection.createAnswer()).then((e)=>{
                                a.peerConnection.setLocalDescription(e).then(()=>{
                                    a.restoreRMute(), u.default.callRemoteFunction(s.RemoteFunction.acceptReInvite, a.settings.id, t1, e.sdp), i();
                                });
                            }).catch((e)=>{
                                a.dispatchEvent({
                                    name: "SDP",
                                    origin: "handleInReinvite",
                                    sdp: a.peerConnection.localDescription,
                                    description: `answer_reject: ${e.message}`
                                }), this.logger.error(e), i();
                            })) : i();
                        });
                    }
                    onAddTrack(e, t1) {
                        if (t1) {
                            const n = f.get().getEndpointManager(t1);
                            n && n.updateTransceiver(e.transceiver);
                        }
                    }
                }
                r([
                    i.LogManager.d_trace(i.LogCategory.CALLMANAGER)
                ], f.prototype, "findCall", null), r([
                    g.queueDecorator()
                ], f.prototype, "handleConnectionConnected", null), r([
                    g.queueDecorator()
                ], f.prototype, "startEarlyMedia", null), r([
                    g.queueDecorator()
                ], f.prototype, "handleReinvite", null), r([
                    g.queueDecorator()
                ], f.prototype, "handleInReinvite", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], f.prototype, "onAddTrack", null), t1.ViewerManager = f;
            },
            787: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.dispatchUpdatedEvent = void 0;
                const r = n(2282);
                t1.dispatchUpdatedEvent = (e, t1, n)=>{
                    var i;
                    const a = Object.assign({
                        name: r.CallEvents.Updated,
                        result: t1,
                        call: e
                    }, n && {
                        reason: n
                    });
                    return null === (i = null == e ? void 0 : e.dispatchEvent) || void 0 === i || i.call(e, a), a;
                };
            },
            125: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Client = void 0;
                const i = n(7998), a = n(141), s = n(2957), o = n(3947), d = n(3869), c = n(1150), l = n(84), g = n(308), u = n(3576), h = n(4106), p = n(575), f = n(6230), m = n(209), v = n(7272), C = n(9091), _ = n(2089), S = n(304), E = n(8582), y = n(9774), M = n(245), R = n(6081), L = n(4211), T = n(4007), I = n(8879), b = n(164);
                class w extends u.EventTarget {
                    constructor(){
                        if (super(), this._connected = !1, this.progressToneScript = {
                            US: "440@-19,480@-19;*(2/4/1+2)",
                            RU: "425@-19;*(1/3/1)"
                        }, this.playingNow = !1, this.serversList = [], this.level = 100, this.micRequired = !1, this.videoConstraints = null, this.progressToneCountry = "US", this.progressTone = !0, this.enableTrace = !1, this.showDebugInfo = !1, this.showWarnings = !1, this.RTCsupported = !1, this._deviceEnumAPI = !1, this._h264first = !1, this._VP8first = !1, this.limitVCodecs = void 0, this.limitACodecs = void 0, this._alreadyInitialized = !1, w.instance) throw new Error("Error - use Voximplant.getInstance()");
                        w.instance = this, this._promises = {}, d.default.init(), l.PCFactory.get().requireMedia = !1, this.voxCallManager = g.CallManager.get(), this.voxViewerManager = y.ViewerManager.get(), this.setLogLevelAll(c.LogLevel.NONE), M.default.setRPCHandler(p.RemoteEvent.onPCStats, (e, t1)=>{
                            l.PCFactory.get().getPeerConnect(e) && this.dispatchEvent({
                                name: "NetStatsReceived",
                                stats: t1
                            });
                        }), this.logger = c.LogManager.get().createLogger(c.LogCategory.CLIENT, this._traceName()), this._defaultSinkId = null, this.loginState = b.LoginState.LOGGED_OFF;
                    }
                    get version() {
                        return "4.6.3-2602";
                    }
                    static getInstance() {
                        return void 0 === w.instance && (w.instance = new w), w.instance;
                    }
                    playProgressTone(e = !1) {
                        (!e || e && this.progressTone) && null !== this.progressToneScript[this.progressToneCountry] && (this.playingNow || this.playToneScript(this.progressToneScript[this.progressToneCountry]), this.playingNow = !0);
                    }
                    stopProgressTone() {
                        this.playingNow && (this.stopPlayback(), this.playingNow = !1);
                    }
                    onIncomingCall(e, t1, n, r, i) {
                        this.dispatchEvent({
                            name: a.Events.IncomingCall,
                            call: g.CallManager.get().calls[e],
                            headers: r,
                            video: i
                        });
                    }
                    get alreadyInitialized() {
                        return this._alreadyInitialized;
                    }
                    init(e) {
                        return new Promise(async (t1, n)=>{
                            if (this.alreadyInitialized && n(new Error("WebSDK already initialized")), this._alreadyInitialized = !0, this._config = void 0 !== e ? e : {}, void 0 !== this._config.progressToneCountry && (this.progressToneCountry = this._config.progressToneCountry), !0 !== this._config.progressTone && (this.progressTone = !1), void 0 !== this._config.serverIp && (this.serverIp = this._config.serverIp), void 0 !== this._config.enableTrace && (this.enableTrace = this._config.enableTrace), void 0 !== this._config.showDebugInfo && (this.showDebugInfo = this._config.showDebugInfo), !1 !== this._config.showWarnings && (this.showWarnings = !0), "string" == typeof this._config.videoContainerId && (this.remoteVideoContainerId = this._config.videoContainerId), "string" == typeof this._config.remoteVideoContainerId && (this.remoteVideoContainerId = this._config.remoteVideoContainerId), "string" == typeof this._config.localVideoContainerId && (this.localVideoContainerId = this._config.localVideoContainerId), !1 !== this._config.micRequired && (this.micRequired = !0), void 0 !== this._config.videoSupport ? this.videoSupport = this._config.videoSupport : this.videoSupport = !1, void 0 === this._config.queueType && (this._config.queueType = i.QueueTypes.ACD), void 0 !== this._config.H264first && (this._h264first = this._config.H264first, g.CallManager.get()._h264first = this._h264first), void 0 !== this._config.VP8first && (this._VP8first = this._config.VP8first), void 0 !== this._config.rtcStatsCollectionInterval ? g.CallManager.get().rtcStatsCollectionInterval = this._config.rtcStatsCollectionInterval : g.CallManager.get().rtcStatsCollectionInterval = 1e4, void 0 !== w.getInstance().config().experiments && void 0 !== w.getInstance().config().experiments.rtcStatsInquiryInterval ? g.CallManager.get().rtcStatsInquiryInterval = w.getInstance().config().experiments.rtcStatsInquiryInterval : g.CallManager.get().rtcStatsInquiryInterval = 500, !this._config.protocolVersion || "2" !== this._config.protocolVersion && "3" !== this._config.protocolVersion ? this._callProtocolVersion = "3" : (this._callProtocolVersion = this._config.protocolVersion, g.CallManager.get().setProtocolVersion(this._callProtocolVersion)), this._config.prettyPrint && c.LogManager.get().setPrettyPrint(this._config.prettyPrint), this.showWarnings && this.setLogLevelAll(c.LogLevel.WARNING), this.showDebugInfo && this.setLogLevelAll(c.LogLevel.INFO), this.enableTrace && this.setLogLevelAll(c.LogLevel.TRACE), this.logger.info(`SDK version: ${this.version}`), this.logger.info(`init(${JSON.stringify(this._config)})`), !window.isSecureContext) {
                                const e = "getUserMedia() and other APIs required for the access to the user media devices are not available on insecure origins. You need to switch your application to a secure origin, such as HTTPS.";
                                throw this.logger.error(e), Error(e);
                            }
                            if (this._config.experiments && this._config.experiments.ignorewebrtc) this.RTCsupported = !0;
                            else if ("undefined" != typeof webkitRTCPeerConnection || void 0 !== this.mozRTCPeerConnection || "undefined" != typeof RTCPeerConnection || "undefined" != typeof RTCIceGatherer) {
                                if ("undefined" != typeof mozRTCPeerConnection) try {
                                    new mozRTCPeerConnection({
                                        iceServers: []
                                    }), this.RTCsupported = !0;
                                } catch (e) {}
                                else this.RTCsupported = !0;
                            }
                            if (!this.RTCsupported) throw n(new Error("NO_WEBRTC_SUPPORT")), new Error("NO_WEBRTC_SUPPORT");
                            var r;
                            if (void 0 !== this._config.videoConstraints) {
                                this.videoConstraints = this._config.videoConstraints;
                                const e = v.default.CameraManager.legacyParamConverter(this._config.videoConstraints);
                                try {
                                    await v.default.CameraManager.get().setDefaultVideoSettings(e);
                                } catch (t1) {
                                    n(new Error(`WebSDK haven't be able to set ${JSON.stringify(e)} as the default video settings`));
                                }
                            }
                            null != window.location.href.match(/^file\:\/{3}.*$/g) && void 0 !== console.error && this.showWarnings && console.error("WebRTC requires application to be loaded from a web server"), this.voxAuth = o.Authenticator.get(), this.voxAuth.setHandler({
                                onLoginSuccessful: (e, t1)=>{
                                    this.loginState = b.LoginState.LOGGED_IN;
                                    const n = {
                                        name: a.Events.AuthResult,
                                        displayName: e,
                                        result: !0,
                                        tokens: t1
                                    };
                                    this._resolvePromise("login", n), this.dispatchEvent(n);
                                },
                                onLoginFailed: (e)=>{
                                    this.loginState = b.LoginState.LOGGED_OFF;
                                    const t1 = {
                                        name: a.Events.AuthResult,
                                        code: e,
                                        result: !1
                                    };
                                    this._rejectPromise("login", t1), this.dispatchEvent(t1);
                                },
                                onSecondStageInitiated: ()=>{
                                    const e = {
                                        name: a.Events.AuthResult,
                                        code: 301,
                                        result: !1
                                    };
                                    this._rejectPromise("login", e), this.dispatchEvent(e);
                                },
                                onOneTimeKeyGenerated: (e)=>{
                                    const t1 = {
                                        name: a.Events.AuthResult,
                                        key: e,
                                        code: 302,
                                        result: !1
                                    };
                                    this._resolvePromise("loginkey", t1), this.dispatchEvent(t1);
                                },
                                onRefreshTokenFailed: (e)=>{
                                    const t1 = {
                                        name: a.Events.RefreshTokenResult,
                                        code: e,
                                        result: !1
                                    };
                                    this.dispatchEvent(t1);
                                },
                                onRefreshTokenSuccess: (e)=>{
                                    const t1 = {
                                        name: a.Events.RefreshTokenResult,
                                        tokens: e,
                                        result: !0
                                    };
                                    this.dispatchEvent(t1);
                                }
                            }), M.default.addHandler(this), M.default.setRPCHandler(p.RemoteEvent.sipRegisterSuccessful, (e, t1)=>{
                                this.dispatchEvent({
                                    name: "SIPRegistrationSuccessful",
                                    id: e,
                                    sipuri: t1
                                });
                            }), M.default.setRPCHandler(p.RemoteEvent.onACDStatus, (e, t1, n, r)=>{
                                C.default.onStatusUpdated(t1, n, r);
                            }), M.default.setRPCHandler(p.RemoteEvent.SQMessagingStatusUpdated, (e, t1, n, r)=>{
                                _.default.onStatusUpdated(t1, n, r);
                            }), M.default.setRPCHandler(p.RemoteEvent.onSQStatusError, (e, t1, n, r)=>{
                                _.default.onError(t1, n, r), C.default.onError(t1, n, r);
                            }), M.default.setRPCHandler(p.RemoteEvent.sipRegisterFailed, (e, t1, n, r)=>{
                                this.dispatchEvent({
                                    name: "SIPRegistrationFailed",
                                    id: e,
                                    sipuri: t1,
                                    status: n,
                                    reason: r
                                });
                            }), M.default.setRPCHandler(p.RemoteEvent.unregisterPushTokenResult, (e)=>{
                                f.PushService.updatePromiseResult(e);
                            }), M.default.setRPCHandler(p.RemoteEvent.registerPushTokenResult, (e)=>{
                                f.PushService.updatePromiseResult(e);
                            }), r = setInterval(()=>{
                                "undefined" != typeof document && (clearInterval(r), this.dispatchEvent({
                                    name: a.Events.SDKReady,
                                    version: this.version
                                }), t1({
                                    name: a.Events.SDKReady,
                                    version: this.version
                                }));
                            }, 100);
                        });
                    }
                    getErrorCall(e, t1, n, r) {
                        const i = "viewer" === e ? new E.ViewerCall(s.Utils.generateUUID(), t1) : new S.CallExMedia(s.Utils.generateUUID(), o.Authenticator.get().displayName, !1, t1);
                        return setTimeout(()=>{
                            i.onFailed(n, r, {});
                        }, 500), i;
                    }
                    isHttps() {
                        return "https:" === window.location.protocol || "localhost" === window.location.hostname || window.location.href.includes("127.0.0.1");
                    }
                    call(e, t1, n, r) {
                        void 0 === t1 && void 0 === n && void 0 === r || this.logger.warning("useVideo, customData, extraHeaders are deprecated since 4.6.0. Please use the same parameter in the CallSettings instead."), this.logger.info(`call(${JSON.stringify(e)}, ${JSON.stringify(t1)})`);
                        let i = {
                            H264first: this._h264first,
                            VP8first: this._VP8first
                        };
                        switch("string" == typeof e || "number" == typeof e ? ("object" == typeof t1 && (t1.receiveVideo = !0), i = {
                            number: e,
                            video: t1,
                            customData: n,
                            extraHeaders: r
                        }) : ("object" == typeof e.video && (e.video.receiveVideo = !0), i = e), typeof i.video){
                            case "boolean":
                                i.isAudio = !i.video, i.video = {
                                    sendVideo: i.video,
                                    receiveVideo: !0
                                };
                                break;
                            case "object":
                                i.isAudio = !i.video.receiveVideo && !i.video.sendVideo;
                                break;
                            case "undefined":
                                i.isAudio = !0, i.video = {
                                    sendVideo: !1,
                                    receiveVideo: !0
                                };
                        }
                        if (!this.isHttps()) return this.getErrorCall("call", i, R.CallError.HTTP_NOT_SECURE, "Sorry, your connection to this site is not secure, so the WebRTC call is prohibited. Please, use https:// instead");
                        try {
                            return s.Utils.checkCA(), this.voxCallManager.call(i);
                        } catch (e) {
                            return this.getErrorCall("call", i, +e.code, e.message);
                        }
                    }
                    callConference(e, t1, n, r) {
                        void 0 === t1 && void 0 === n && void 0 === r || this.logger.warning("useVideo, customData, extraHeaders are deprecated since 4.6.0. Please use the same parameter in the CallSettings instead."), this.logger.info(`callConference(callSettings: ${JSON.stringify(e)}, useVideo: ${JSON.stringify(t1)})`);
                        let i = {
                            H264first: this._h264first,
                            VP8first: this._VP8first
                        };
                        switch("string" == typeof e || "number" == typeof e ? ("object" == typeof t1 && (t1.receiveVideo = !0), i = {
                            number: e,
                            video: t1,
                            customData: n,
                            extraHeaders: r
                        }) : ("object" == typeof e.video && (e.video.receiveVideo = !0), i = e), typeof i.video){
                            case "boolean":
                                i.video = {
                                    sendVideo: i.video,
                                    receiveVideo: !0
                                };
                                break;
                            case "undefined":
                                i.video = {
                                    sendVideo: !1,
                                    receiveVideo: !0
                                };
                        }
                        if (i.isConference = !0, !this.isHttps()) return this.getErrorCall("conf", i, R.CallError.HTTP_NOT_SECURE, "Sorry, your connection to this site is not secure, so the WebRTC call is prohibited. Please, use https:// instead");
                        try {
                            return s.Utils.checkCA(), this.voxCallManager.callConference(i);
                        } catch (e) {
                            return console.error(e), this.getErrorCall("conf", i, +e.code, e.message);
                        }
                    }
                    joinAsSharing(e, t1 = !1, n) {
                        this.logger.info(`joinAsSharing(${e})`);
                        let r = {
                            number: e,
                            audioDirections: {
                                sendAudio: t1
                            },
                            extraHeaders: n
                        };
                        if (!this.isHttps()) return this.getErrorCall("sharing", r, R.CallError.HTTP_NOT_SECURE, "Sorry, your connection to this site is not secure, so the WebRTC call is prohibited. Please, use https:// instead");
                        try {
                            return s.Utils.checkCA(), L.default.get().call(r);
                        } catch (e) {
                            return this.getErrorCall("call", r, +e.code, e.message);
                        }
                    }
                    joinAsViewer(e, t1) {
                        this.logger.info(`joinAsViewer(${e})`);
                        let n = {
                            number: e,
                            extraHeaders: t1
                        };
                        if (!this.isHttps()) return this.getErrorCall("viewer", n, R.CallError.HTTP_NOT_SECURE, "Sorry, your connection to this site is not secure, so the WebRTC call is prohibited. Please, use https:// instead");
                        try {
                            return s.Utils.checkCA(), this.voxViewerManager.joinAsViewer(n);
                        } catch (e) {
                            return this.getErrorCall("viewer", n, +e.code, e.message);
                        }
                    }
                    config() {
                        return this._config;
                    }
                    async connect() {
                        return void 0 === this._config && this.logger.warning("Please, run Voximplant init before connect."), M.default.connect(this._config.queueType, this._config.serverIp);
                    }
                    async disconnect() {
                        this.logger.info("disconnect()"), this.checkConnection(), await Promise.all([
                            L.default.get().hangupAllCalls(),
                            y.ViewerManager.get().hangupAllCalls(),
                            g.CallManager.get().hangupAllCalls()
                        ]), await M.default.disconnect(), this.loginState = b.LoginState.LOGGED_OFF, v.default.StreamManager.get().clear(), M.default.removeRPCHandler(p.RemoteEvent.onCallRemoteFunctionError), M.default.removeRPCHandler(p.RemoteEvent.handleError);
                    }
                    setOperatorACDStatus(e) {
                        return this.logger.info(`setOperatorACDStatus(${e})`), C.default.setStatus(e);
                    }
                    setOperatorSQMessagingStatus(e) {
                        if (this._config.queueType == i.QueueTypes.SmartQueue || this._config.queueType == i.QueueTypes.SmartQueueV1Beta) return this.logger.info(`setOperatorSQMessagingStatus (${e})`), _.default.setStatus(e);
                        Promise.reject("This function only enabled in SmartQueue. You must set QueueType to QueueTypes.SmartQueue in the ClientConfig");
                    }
                    getOperatorACDStatus() {
                        return C.default.getStatus();
                    }
                    getOperatorSQMessagingStatus() {
                        return _.default.getStatus();
                    }
                    login(e, t1, n) {
                        return this.logger.info(`login(${e}, ${t1 ? "***" : void 0}, {receiveCalls: ${n && n.receiveCalls}})`), this.loginState = b.LoginState.LOGGING_IN, new Promise((r, i)=>{
                            this._promises.login = {
                                resolve: r,
                                reject: i
                            }, n = void 0 !== n ? n : {}, this.checkConnection(), this._config.experiments && this._config.experiments.mediaServer && (n.mediaServer = this._config.experiments.mediaServer), this.voxAuth.basicLogin(e, t1, n);
                        });
                    }
                    loginWithCode(e, t1, n) {
                        return this.loginState = b.LoginState.LOGGING_IN, new Promise((r, i)=>{
                            this._promises.login = {
                                resolve: r,
                                reject: i
                            }, n = void 0 !== n ? n : {}, n = Object.assign(Object.assign({}, n), {
                                serverPresenceControl: !1
                            }), this.checkConnection(), this.voxAuth.loginStage2(e, t1, n);
                        });
                    }
                    loginWithToken(e, t1, n) {
                        return this.logger.info(`loginWithToken(${e}, '***', {receiveCalls: ${n && n.receiveCalls}})`), this.loginState = b.LoginState.LOGGING_IN, new Promise((r, i)=>{
                            this._promises.login = {
                                resolve: r,
                                reject: i
                            }, n = void 0 !== n ? n : {}, (n = Object.assign(Object.assign({}, n), {
                                serverPresenceControl: !1
                            })).accessToken = t1, this.checkConnection(), this.voxAuth.tokenLogin(e, n);
                        });
                    }
                    tokenRefresh(e, t1, n) {
                        return this.logger.info(`tokenRefresh(${e})`), new Promise((r, i)=>{
                            const s = (e)=>{
                                e.result ? r(e) : i(e), this.off(a.Events.RefreshTokenResult, s);
                            };
                            this.on(a.Events.RefreshTokenResult, s), this.voxAuth.tokenRefresh(e, t1, n);
                        });
                    }
                    requestOneTimeLoginKey(e) {
                        return new Promise((t1, n)=>{
                            this._promises.loginkey = {
                                resolve: t1,
                                reject: n
                            }, this.checkConnection(), this.voxAuth.generateOneTimeKey(e);
                        });
                    }
                    loginWithOneTimeKey(e, t1, n) {
                        return this.logger.info(`loginWithOneTimeKey(${e}, '***' , {receiveCalls: ${n && n.receiveCalls}})`), this.loginState = b.LoginState.LOGGING_IN, new Promise((r, i)=>{
                            this._promises.login = {
                                resolve: r,
                                reject: i
                            }, n = void 0 !== n ? n : {}, n = Object.assign(Object.assign({}, n), {
                                serverPresenceControl: !1
                            }), this.checkConnection(), this.voxAuth.loginUsingOneTimeKey(e, t1, n);
                        });
                    }
                    connected() {
                        return this._connected;
                    }
                    showLocalVideo(e = !0, t1, n) {
                        return void 0 === t1 && void 0 === n || this.logger.warning("showLocalVideo: mirror and detachCamera parameters are deprecated! And will not lead to desired behaviour."), this.logger.info(`showLocalVideo(${e}, ${t1}, ${n})`), e ? v.default.StreamManager.get().showLocalVideo() : v.default.StreamManager.get().hideLocalVideo();
                    }
                    setLocalVideoPosition(e, t1) {
                        throw new Error("Deprecated: please use CSS to position '#voximplantlocalvideo' element");
                    }
                    setLocalVideoSize(e, t1) {
                        throw new Error("Deprecated: please use CSS to set size of '#voximplantlocalvideo' element");
                    }
                    setVideoSettings(e, t1, n) {
                        v.default.CameraManager.get().setDefaultVideoSettings(v.default.CameraManager.legacyParamConverter(e)), g.CallManager.get().setVideoSettings(e).then(()=>{
                            t1 && t1(null);
                        }, (e)=>{
                            n && n(null);
                        });
                    }
                    setVideoBandwidth(e) {
                        this.logger.info(`setVideoBandwidth(${e})`), this.checkConnection(), l.PCFactory.get().setBandwidthParams(e), M.default.callRemoteFunction(h.RemoteFunction.setDesiredVideoBandwidth, e);
                    }
                    playToneScript(e, t1 = !1) {
                        this.logger.info(`playToneScript('***', ${t1})`), s.Utils.playToneScript(e, t1);
                    }
                    stopPlayback() {
                        this.logger.info("stopPlayback()"), s.Utils.stopPlayback() && this.dispatchEvent({
                            name: a.Events.PlaybackFinished
                        });
                    }
                    volume(e) {
                        throw new Error("Deprecated: please use the Media Renderer interface of each call instead");
                    }
                    audioSources() {
                        throw Error("Deprecated: please use Hardware module to manipulate devices");
                    }
                    videoSources() {
                        throw Error("Deprecated: please use Hardware module to manipulate devices");
                    }
                    audioOutputs() {
                        throw Error("Deprecated: please use Hardware module to manipulate devices");
                    }
                    useAudioSource(e, t1, n) {
                        const r = v.default.AudioDeviceManager.get().getDefaultAudioSettings();
                        return v.default.AudioDeviceManager.get().setDefaultAudioSettings(Object.assign(Object.assign({}, r), {
                            inputId: e
                        })), new Promise((r, i)=>g.CallManager.get().useAudioSource(e).then(()=>{
                                t1 && t1(null), r(null);
                            }, (e)=>{
                                n && n(e), i(e);
                            }));
                    }
                    useVideoSource(e, t1, n) {
                        const r = v.default.CameraManager.get().getDefaultVideoSettings();
                        return v.default.CameraManager.get().setDefaultVideoSettings(Object.assign(Object.assign({}, r), {
                            cameraId: e
                        })), new Promise((r, i)=>g.CallManager.get().useVideoSource(e).then(()=>{
                                t1 && t1(null), r(null);
                            }, (e)=>{
                                n && n(e), i(e);
                            }));
                    }
                    useAudioOutput(e) {
                        return new Promise((t1, n)=>{
                            "chrome" !== d.default.getWSVendor(!0) && n(new Error("Unsupported browser. Only Google Chrome 49 and above.")), this._defaultSinkId = e, t1();
                        });
                    }
                    attachRecordingDevice(e, t1) {
                        c.LogManager.get().writeMessage(c.LogCategory.CLIENT, "DEPRECATED", c.LogLevel.ERROR, "Now all media connection on demand. There is no reason do it by hand."), e && e(null);
                    }
                    detachRecordingDevice() {
                        v.default.StreamManager.get().clear();
                    }
                    setCallActive(e, t1 = !0) {
                        return e.setActive(t1);
                    }
                    sendVideo(e = !0) {
                        c.LogManager.get().writeMessage(c.LogCategory.CLIENT, "DEPRECATED", c.LogLevel.ERROR, "This function deprecated. Use Call.sendVideo() instead.");
                    }
                    isRTCsupported() {
                        try {
                            const e = new RTCPeerConnection;
                            if (void 0 === navigator.getUserMedia && void 0 === navigator.mediaDevices.getUserMedia) throw new Error("No getUserMedia");
                            e.addTransceiver("audio");
                            return e.getTransceivers().forEach((e)=>{
                                if (!e.stopped && "stopped" !== e.direction && "stopped" !== e.currentDirection && (e.sender.replaceTrack(null), e.direction = "sendrecv", void 0 === e.currentDirection)) throw new Error("No currentDirection");
                            }), e.close(), !0;
                        } catch (e) {
                            return !1;
                        }
                    }
                    transferCall(e, t1) {
                        this.logger.info(`transferCall(${e}, ${e})`);
                        try {
                            s.Utils.checkCA(), this.voxCallManager.transferCall(e, t1);
                        } catch (n) {
                            this.voxCallManager.handleConnectionFailed(e.id(), +n.message, "", {}), this.voxCallManager.handleConnectionFailed(t1.id(), +n.message, "", {});
                        }
                    }
                    setLogLevel(e, t1) {
                        c.LogManager.get().setLogLevel(e, t1);
                    }
                    onSignalingConnected() {
                        this._connected = !0;
                        const e = {
                            name: a.Events.ConnectionEstablished
                        };
                        this._resolvePromise("connect", e), this.dispatchEvent(e);
                    }
                    onSignalingClosed() {
                        this._connected = !1, this.dispatchEvent({
                            name: a.Events.ConnectionClosed
                        }), this.progressTone && this.stopProgressTone();
                    }
                    onSignalingConnectionFailed(e) {
                        this._connected = !1, this._rejectPromise("connect", event);
                    }
                    onMediaConnectionFailed() {}
                    getCall(e) {
                        return g.CallManager.get().calls[e];
                    }
                    removeCall(e) {
                        g.CallManager.get().removeCall(e);
                    }
                    screenSharingSupported() {
                        return d.default.screenSharingSupported();
                    }
                    addEventListener(e, t1) {
                        super.addEventListener(e, t1);
                    }
                    removeEventListener(e, t1) {
                        super.removeEventListener(e, t1);
                    }
                    on(e, t1, n) {
                        super.on(e, t1);
                    }
                    off(e, t1) {
                        super.off(e, t1);
                    }
                    registerForPushNotificatuons(e) {
                        return this.logger.info("Deprecated registerForPushNotificatuons()"), f.PushService.register(e);
                    }
                    registerForPushNotifications(e) {
                        return this.logger.info("registerForPushNotifications()"), f.PushService.register(e);
                    }
                    unregisterForPushNotificatuons(e) {
                        return this.logger.info("Deprecated unregisterForPushNotificatuons()"), f.PushService.unregister(e);
                    }
                    unregisterForPushNotifications(e) {
                        return this.logger.info("unregisterForPushNotifications()"), f.PushService.unregister(e);
                    }
                    handlePushNotification(e) {
                        return this.logger.info("handlePushNotification()"), f.PushService.incomingPush(e);
                    }
                    getGUID() {
                        return (new m.default).toString();
                    }
                    enableSilentLogging(e) {
                        c.LogManager.get().shadowLogging = e;
                    }
                    clearSilentLog() {
                        c.LogManager.get().clearSilentLog();
                    }
                    getSilentLog() {
                        return c.LogManager.get().getSLog();
                    }
                    setLoggerCallback(e) {
                        c.LogManager.get().setLoggerCallback(e);
                    }
                    getClientState() {
                        const e = M.default.currentState();
                        return e == M.VoxSignalingState.CONNECTING || e == M.VoxSignalingState.WSCONNECTED ? c.ClientState.CONNECTING : e == M.VoxSignalingState.CLOSING || e == M.VoxSignalingState.IDLE ? c.ClientState.DISCONNECTED : e == M.VoxSignalingState.CONNECTED ? this.loginState == b.LoginState.LOGGING_IN ? c.ClientState.LOGGING_IN : this.loginState == b.LoginState.LOGGED_IN ? c.ClientState.LOGGED_IN : c.ClientState.CONNECTED : void 0;
                    }
                    setSwfColor() {
                        c.LogManager.get().writeMessage(c.LogCategory.CLIENT, "NOT SUPPORTED", c.LogLevel.ERROR, "setSwfColor deprecated, and not supported!");
                    }
                    _traceName() {
                        return "Client";
                    }
                    checkConnection() {
                        if (!this._connected) throw new Error("NOT_CONNECTED_TO_VOXIMPLANT");
                    }
                    _resolvePromise(e, t1) {
                        const n = this._promises[e];
                        n && (n.resolve(t1), this._promises[e] = void 0);
                    }
                    _rejectPromise(e, t1) {
                        const n = this._promises[e];
                        n && (n.reject(t1), this._promises[e] = void 0);
                    }
                    setLogLevelAll(e) {
                        const t1 = c.LogManager.get();
                        Object.keys(c.LogCategory).forEach((n)=>{
                            t1.setLogLevel(c.LogCategory[n], e);
                        });
                    }
                    setConnectionData(e, t1) {
                        e && (this._config.gateway = e), t1 && (this._config.connectionId = t1);
                    }
                    isInsertableStreamsSupported() {
                        var e, t1;
                        return (null === (t1 = null === (e = this.config()) || void 0 === e ? void 0 : e.experiments) || void 0 === t1 ? void 0 : t1.encodedInsertableStreams) && window.RTCRtpSender && !!RTCRtpSender.prototype.createEncodedStreams;
                    }
                    isMediaTrackInsertableStreamSupported() {
                        var e, t1;
                        return (null === (t1 = null === (e = this.config()) || void 0 === e ? void 0 : e.experiments) || void 0 === t1 ? void 0 : t1.mediaTrackInsertableStreams) && window.MediaStreamTrackProcessor && window.MediaStreamTrackGenerator;
                    }
                    limitAudioCodecs(e) {
                        return this.limitACodecs = e, this.logger.info(`limitAudioCodecs(): Trying to limit audio codecs to \n${JSON.stringify(e)}`), new Promise(async (t1, n)=>{
                            let r, i;
                            const a = ()=>{
                                null == r || r.getTracks().forEach((e)=>e.stop()), null == i || i.close();
                            };
                            try {
                                if (r = await T.StreamManager.getUserMedia({
                                    audio: !0,
                                    video: !1
                                }), i = new RTCPeerConnection, i) {
                                    await i.addTransceiver(r.getAudioTracks()[0]);
                                    const s = await i.createOffer().catch(()=>n("limitAudioCodecs(): cannot get local offer")), o = I.SDPMuggle.reduceCodecs(s, {
                                        audio: e
                                    });
                                    return this.logger.info(`limitAudioCodecs(): limit codecs was resolved with result ${o.isAudio} \n${o.sdp.sdp}`), a(), t1(o.isAudio);
                                }
                                return this.logger.info("limitAudioCodecs(): Cannot create a test peer connection"), a(), n("limitAudioCodecs(): Cannot create a test peer connection, audio codecs will be full reduced");
                            } catch (e) {
                                return this.logger.info(`limitAudioCodecs(): ${e.message}`), a(), n("limitAudioCodecs(): Media access denied, audio codecs will be full reduced");
                            }
                        });
                    }
                    limitVideoCodecs(e) {
                        return this.limitVCodecs = e, this.logger.info(`limitVideoCodecs(): Trying to limit video codecs to \n${JSON.stringify(e)}`), new Promise(async (t1, n)=>{
                            let r, i;
                            const a = ()=>{
                                null == r || r.getTracks().forEach((e)=>e.stop()), null == i || i.close();
                            };
                            try {
                                if (r = await T.StreamManager.getUserMedia({
                                    audio: !0,
                                    video: !0
                                }), i = new RTCPeerConnection, i) {
                                    await i.addTransceiver(r.getAudioTracks()[0]), await i.addTransceiver(r.getVideoTracks()[0]);
                                    const s = await i.createOffer().catch(()=>n("limitVideoCodecs(): cannot get local offer")), o = I.SDPMuggle.reduceCodecs(s, {
                                        video: e
                                    });
                                    return this.logger.info(`limitVideoCodecs(): limit codecs was resolved with result ${o.isVideo} \n${o.sdp.sdp}`), a(), t1(o.isVideo);
                                }
                                return this.logger.info("limitVideoCodecs(): Cannot create a test peer connection"), a(), n("limitVideoCodecs(): Cannot create a test peer connection, video codecs will be full reduced");
                            } catch (e) {
                                return this.logger.info(`limitVideoCodecs(): ${e.message}`), a(), n("limitVideoCodecs(): Media access denied, video codecs will be full reduced");
                            }
                        });
                    }
                }
                r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "playProgressTone", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "stopProgressTone", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "onIncomingCall", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "init", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "call", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "callConference", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "joinAsSharing", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "joinAsViewer", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "connect", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "disconnect", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "setOperatorACDStatus", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "setOperatorSQMessagingStatus", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "getOperatorACDStatus", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "getOperatorSQMessagingStatus", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "login", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "loginWithCode", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "loginWithToken", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "tokenRefresh", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "requestOneTimeLoginKey", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "loginWithOneTimeKey", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "connected", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "showLocalVideo", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "setLocalVideoPosition", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "setLocalVideoSize", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "setVideoSettings", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "setVideoBandwidth", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "playToneScript", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "stopPlayback", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "volume", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "audioSources", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "videoSources", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "audioOutputs", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "useAudioSource", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "useVideoSource", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "useAudioOutput", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "attachRecordingDevice", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "detachRecordingDevice", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "setCallActive", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "sendVideo", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "isRTCsupported", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "transferCall", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "setLogLevel", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "onSignalingConnected", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "onSignalingClosed", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "onSignalingConnectionFailed", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "onMediaConnectionFailed", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "getCall", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "removeCall", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "addEventListener", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "removeEventListener", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "on", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "off", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "checkConnection", null), r([
                    c.LogManager.d_trace(c.LogCategory.CLIENT)
                ], w.prototype, "setLogLevelAll", null), t1.Client = w;
            },
            9553: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.ConferenceEndpointManager = void 0;
                const i = n(3992), a = n(308), s = n(6278), o = n(9002), d = n(9001), c = n(1901), l = n(6980), g = n(1316);
                class u {
                    constructor(e){
                        this.call = e, this.currentState = {}, this.mutex = new i.TaskMutex, l.VideoStatusMachineMediator.subscribeOnEndpointEvents(e), c.registerEndpointStreamsUpdatedHandler(e);
                    }
                    updateState() {
                        const e = {};
                        this.call.getEndpoints().forEach((t1)=>{
                            e[t1.id] = {
                                audio: [],
                                video: []
                            }, t1.mediaRenderers.forEach((n)=>{
                                if ("audio" === n.kind && n.enabled) return void (e[t1.id].audio = [
                                    ...e[t1.id].audio,
                                    ...n.mids
                                ]);
                                const r = l.VideoStatusMachineMediator.retrieveVSMByMediaRenderer(n);
                                g.MediaRenderResolver.isVideoMR(n) && "disabledByUser" !== (null == r ? void 0 : r.value) && (e[t1.id].video = [
                                    ...e[t1.id].video,
                                    ...n.mids
                                ]);
                            });
                        });
                        const t1 = this.diffStates(e);
                        if (t1.dirty) {
                            this.currentState = e, this.call.getEndpoints().forEach((e)=>{
                                e.mediaRenderers.forEach((n)=>{
                                    n.mids.forEach((r)=>{
                                        g.MediaRenderResolver.isVideoMR(n) && l.VideoStatusMachineMediator.retrieveVSMByEndpoint(e) || (t1.mrEnabled.includes(r) && e.dispatchEvent({
                                            name: d.EndpointEvents.MediaRenderEnabled,
                                            endpoint: e,
                                            call: this.call,
                                            mediaRenderer: n
                                        }), t1.mrDisabled.includes(r) && e.dispatchEvent({
                                            name: d.EndpointEvents.MediaRenderDisabled,
                                            endpoint: e,
                                            call: this.call,
                                            mediaRenderer: n
                                        }));
                                    });
                                });
                            });
                            const n = a.CallManager.get().getConfSignaling(this.call);
                            n && n.runFunction(s.ConfSignalingRemoteFunctions.MANAGE_ENDPOINTS, e);
                        }
                    }
                    updateRenderSize() {
                        const e = {};
                        this.call.getEndpoints().forEach((t1)=>{
                            const n = {};
                            t1.mediaRenderers.forEach((e)=>{
                                if ("audio" !== e.kind && e.videoSize && e.videoSize.width && e.videoSize.height) {
                                    const t1 = [
                                        e.videoSize.width,
                                        e.videoSize.height
                                    ];
                                    e.mids.forEach((e)=>n[e] = t1);
                                }
                            }), Object.keys(n).length && (e[t1.id] = n);
                        });
                        const t1 = a.CallManager.get().getConfSignaling(this.call);
                        t1 && t1.runFunction(s.ConfSignalingRemoteFunctions.REQUEST_VIDEO_SIZE, e);
                    }
                    setCurrentState(e) {
                        throw Error("Not implemented");
                    }
                    diffStates(e) {
                        const t1 = [
                            "added",
                            "default"
                        ];
                        let n = !1, r = [], i = [], a = [], s = [], o = [], d = {};
                        for(let r in this.currentState)this.currentState.hasOwnProperty(r) && !t1.includes(r) && (e[r] ? [
                            "audio",
                            "video"
                        ].forEach((t1)=>{
                            this.currentState[r][t1] && this.currentState[r][t1].includes("default") ? (o.push(r), n = !0) : e[r][t1] && e[r][t1].includes("default") ? (s.push(r), n = !0) : (this.currentState[r][t1] && this.currentState[r][t1].forEach((i)=>{
                                e[r][t1] && e[r][t1].includes(i) || (a.push(i), n = !0);
                            }), e[r][t1] && e[r][t1].forEach((e)=>{
                                this.currentState[r][t1] && this.currentState[r][t1].includes(e) || (i.push(e), n = !0);
                            }));
                        }) : (n = !0, d[r] = e[r]));
                        for(let i in e)e.hasOwnProperty(i) && !t1.includes(i) && (this.currentState[i] || (n = !0, r.push(i)));
                        return {
                            dirty: n,
                            removed: r,
                            mrEnabled: i,
                            mrDisabled: a,
                            allEnabled: s,
                            allDisabled: o
                        };
                    }
                }
                r([
                    o.debounceDecorator(400, !1)
                ], u.prototype, "updateState", null), r([
                    o.debounceDecorator(400, !1)
                ], u.prototype, "updateRenderSize", null), r([
                    i.queueDecorator()
                ], u.prototype, "setCurrentState", null), t1.ConferenceEndpointManager = u;
            },
            4298: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.ConferenceEndpointResolver = void 0;
                const r = n(308);
                t1.ConferenceEndpointResolver = class {
                    constructor(e){
                        this.call = e;
                    }
                    get endpointManager() {
                        return r.CallManager.get().getEndpointManager(this.call);
                    }
                    resolveById(e) {
                        var t1;
                        const n = null === (t1 = this.endpointManager) || void 0 === t1 ? void 0 : t1.getEndpoints();
                        return null == n ? void 0 : n.find((t1)=>t1.id === e);
                    }
                    resolveByMid(e) {
                        var t1;
                        const n = null === (t1 = this.endpointManager) || void 0 === t1 ? void 0 : t1.getEndpointInfo();
                        if (!n) return;
                        const [r] = Object.entries(n.endpoints).find(([t1, n])=>{
                            const { mids: r = {} } = n;
                            return e in r;
                        }) || [];
                        return r ? this.resolveById(r) : void 0;
                    }
                };
            },
            1901: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.registerEndpointStreamsUpdatedHandler = t1.EndpointStreamsUpdatedHandler = void 0;
                const r = n(1150), i = n(4298), a = n(6980), s = new WeakMap;
                class o {
                    constructor(e){
                        this.endpointResolver = e, this.logger = r.LogManager.get().createLogger(r.LogCategory.VSM, "EndpointStreamsUpdatedHandler");
                    }
                    static getInstanceBy(e) {
                        return s.get(e);
                    }
                    handle(e) {
                        const { hidden: t1 = {}, appeared: n = {} } = e, r = [
                            ...Object.entries(t1),
                            ...Object.entries(n)
                        ];
                        for (const [e, t1] of r){
                            const n = this.endpointResolver.resolveByMid(e), r = t1 ? "ENDPOINT_STREAM_HIDDEN" : "ENDPOINT_STREAM_APPEARED";
                            if (!n) {
                                this.logger.info(`Endpoint with mid ${e} hasn't found`);
                                continue;
                            }
                            const i = a.VideoStatusMachineMediator.retrieveVSMByEndpoint(n);
                            i ? i.transition(r) : this.logger.warning(`Associated VSM with endpoint ${n.id} has not found`);
                        }
                    }
                }
                t1.EndpointStreamsUpdatedHandler = o;
                t1.registerEndpointStreamsUpdatedHandler = (e)=>{
                    const t1 = new i.ConferenceEndpointResolver(e), n = new o(t1);
                    return s.set(e, n), n;
                };
            },
            9124: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.createVideoStatusMachine = void 0;
                const r = n(6185), i = n(6143), a = n(1150), s = a.LogManager.get().createLogger(a.LogCategory.VSM, "VideoStatusMachine");
                t1.createVideoStatusMachine = (e)=>{
                    const t1 = r.obs("enabled"), n = {
                        log: (...t1)=>s.info(`[VSM of ${e.id}] ${t1.join("")}`),
                        warn: (...t1)=>s.warning(`[VSM of ${e.id}] ${t1.join("")}`),
                        error: (...t1)=>s.error(`[VSM of ${e.id}] ${t1.join("")}`)
                    };
                    return [
                        i.createStatelessFSM(t1, {
                            enabled: {
                                DISABLE_VIDEO: "disabledByUser",
                                ENDPOINT_STREAM_HIDDEN: "disabledByServer"
                            },
                            disabledByUser: {
                                ENABLE_VIDEO: "enabled"
                            },
                            disabledByServer: {
                                ENDPOINT_STREAM_APPEARED: "enabled"
                            }
                        }, null, n),
                        t1
                    ];
                };
            },
            6980: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.VideoStatusMachineMediator = void 0;
                const r = n(2282), i = n(9001), a = n(9124), s = n(1316), o = n(308), d = n(1150), c = n(1450), l = new WeakMap, g = new WeakMap, u = new WeakMap, h = new WeakMap, p = {
                    disabledByUser: c.MediaRenderDisablingReason.Manual,
                    disabledByServer: c.MediaRenderDisablingReason.Automatic
                };
                class f {
                    constructor(){}
                    static associateVSMWith(e) {
                        const [t1, n] = a.createVideoStatusMachine(e);
                        return l.set(e, t1), u.set(t1, e), n.watch((t1)=>{
                            this.handleVideoStatusUpdate(e, t1);
                        }), this.logger.info(`New VSM has been associated with endpoint ${e.id}`), t1;
                    }
                    static retrieveVSMByEndpoint(e) {
                        return l.get(e);
                    }
                    static retrieveVSMByMediaRenderer(e) {
                        return g.get(e);
                    }
                    static removeVSMAssociationOf(e) {
                        l.delete(e);
                    }
                    static subscribeOnEndpointEvents(e) {
                        e.on(r.CallEvents.EndpointAdded, ({ endpoint: t1 })=>{
                            const n = this.associateVSMWith(t1);
                            h.set(t1, e.id()), t1.on(i.EndpointEvents.RemoteMediaAdded, ({ mediaRenderer: e })=>{
                                s.MediaRenderResolver.isVideoMR(e) && g.set(e, n);
                            }), t1.on(i.EndpointEvents.RemoteMediaRemoved, ({ mediaRenderer: e })=>{
                                s.MediaRenderResolver.isVideoMR(e) && g.delete(e);
                            });
                        }), e.on(r.CallEvents.EndpointRemoved, ({ endpoint: e })=>{
                            this.removeVSMAssociationOf(e);
                        });
                    }
                    static makeTransition(e, t1) {
                        var n;
                        const r = null === (n = u.get(e)) || void 0 === n ? void 0 : n.id;
                        this.logger.info(`Start transition ${t1} for a VSM of the endpoint ${r}`);
                        const i = e.transition(t1);
                        return i || (this.logger.info("The transition has failed"), this.onTransitionFail(e)), i;
                    }
                    static dispatchMediaRenderEvent(e, t1, n) {
                        const r = "enabled" === t1 ? i.EndpointEvents.MediaRenderEnabled : i.EndpointEvents.MediaRenderDisabled, a = s.MediaRenderResolver.retrieveVideoMR(e.mediaRenderers);
                        if (!a) return this.logger.info(`Has not associated a media renderer. Dispatching ${r} has aborted`), !1;
                        const d = h.get(e);
                        if (!d) return this.logger.info(`Has not associated a call id with endpoint ${e.id}. Dispatching ${r} has aborted`), !1;
                        const c = o.CallManager.get().findCall(d, "");
                        if (!c) return this.logger.info(`Cannot find a call with id ${d}. Dispatching ${r} has aborted`), !1;
                        const l = {
                            name: r,
                            call: c,
                            endpoint: e,
                            mediaRenderer: a
                        };
                        return "disabled" === t1 && n && (l.reason = p[n]), e.dispatchEvent(l), this.logger.info(`The ${r} event has been dispatched ${n ? "with reason " + n : ""}`), !0;
                    }
                    static handleVideoStatusUpdate(e, t1) {
                        this.logger.info(`Video status of endpoint ${e.id} to ${t1}`), "enabled" === t1 && this.dispatchMediaRenderEvent(e, "enabled"), "disabledByServer" !== t1 && "disabledByUser" !== t1 || this.dispatchMediaRenderEvent(e, "disabled", t1);
                    }
                    static onTransitionFail(e) {
                        if ("enabled" !== e.value) {
                            const t1 = u.get(e);
                            if (!t1) return this.logger.warning("An endpoint has not found by VSM"), !1;
                            this.dispatchMediaRenderEvent(t1, "disabled", e.value);
                        }
                    }
                }
                t1.VideoStatusMachineMediator = f, f.logger = d.LogManager.get().createLogger(d.LogCategory.VSM, "VideoStatusMachineMediator");
            },
            3385: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Constants = void 0;
                class n {
                }
                t1.Constants = n, n.DIRECT_CALL_HEADER = "X-DirectCall", n.VIAMEDIA_CALL_HEADER = "X-ViaMedia", n.CALLSTATSIOID_HEADER = "X-CallstatsIOID", n.CALL_DATA_HEADER = "VI-CallData", n.ZINGAYA_IM_MIME_TYPE = "application/zingaya-im", n.P2P_SPD_FRAG_MIME_TYPE = "voximplant/sdpfrag", n.VI_HOLD_EMUL = "vi/holdemul", n.VI_SPD_OFFER_MIME_TYPE = "vi/sdpoffer", n.VI_SPD_ANSWER_MIME_TYPE = "vi/sdpanswer", n.VI_CONF_PARTICIPANT_INFO_ADDED = "vi/conf-info-added", n.VI_CONF_PARTICIPANT_INFO_REMOVED = "vi/conf-info-removed", n.VI_CONF_PARTICIPANT_INFO_UPDATED = "vi/conf-info-updated", n.VI_CONF_PARTICIPANT_BATCH = "vi/conf-batch";
            },
            9002: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.debounceDecorator = void 0;
                const r = n(1150);
                t1.debounceDecorator = function(e = 400, t1 = !1) {
                    let n;
                    return (i, a, s)=>({
                            value: function(...i) {
                                n && t1 && r.LogManager.get().writeMessage(r.LogCategory.UTILS, "Debounce", r.LogLevel.WARNING, "Function has been debounced."), clearTimeout(n), n = setTimeout(()=>{
                                    n = null, s.value.apply(this, i);
                                }, e);
                            }
                        });
                };
            },
            3576: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.EventTarget = void 0;
                const i = n(1150);
                class a {
                    sysOn(e, t1, n) {
                        this._ETonTo("system", e, t1, n);
                    }
                    sysOff(e, t1) {
                        this._EToffTo("system", e, t1);
                    }
                    on(e, t1, n) {
                        this._ETonTo("user", e, t1, n);
                    }
                    off(e, t1) {
                        this._EToffTo("user", e, t1);
                    }
                    _ETonTo(e, t1, n, r) {
                        void 0 === this.eventListeners && (this.eventListeners = {});
                        let i = this.eventListeners;
                        void 0 === i[t1] && (i[t1] = []);
                        const a = {
                            listener: n,
                            options: r,
                            _triggered: !1,
                            _namespace: e
                        };
                        r && r.capture ? i[t1].unshift(a) : i[t1].push(a);
                    }
                    _EToffTo(e, t1, n) {
                        const r = this.eventListeners;
                        if (void 0 !== r && void 0 !== r[t1]) {
                            if ("function" == typeof n) {
                                for(let i = 0; i < r[t1].length; i++)if (r[t1][i].listener == n && r[t1][i]._namespace === e) {
                                    r[t1].splice(i, 1);
                                    break;
                                }
                            } else r[t1] = r[t1].filter((t1)=>t1._namespace !== e);
                        }
                    }
                    dispatchEvent(e) {
                        var t1, n;
                        if (void 0 !== this.eventListeners && void 0 !== this.eventListeners[e.name]) {
                            const n = this.eventListeners[e.name].filter((e)=>"user" === e._namespace);
                            i.LogManager.get().writeMessage(i.LogCategory.UTILS, "[event]", i.LogLevel.INFO, `${e.name}${(null === (t1 = e.name) || void 0 === t1 ? void 0 : t1.includes("QualityIssue")) ? " " + e.level : ""}, listeners: ${n.length}`);
                            for(let t1 = 0; t1 < this.eventListeners[e.name].length; t1++)try {
                                if (!(this.eventListeners[e.name][t1].options && this.eventListeners[e.name][t1].options.once && this.eventListeners[e.name][t1]._triggered || "system" !== this.eventListeners[e.name][t1]._namespace && "user" !== this.eventListeners[e.name][t1]._namespace && ("default" !== this.eventListeners[e.name][t1]._namespace || n.length))) {
                                    this.eventListeners[e.name][t1]._triggered = !0;
                                    if (!1 === this.eventListeners[e.name][t1].listener(e)) return;
                                }
                            } catch (e) {
                                console.error(e);
                            }
                        } else i.LogManager.get().writeMessage(i.LogCategory.UTILS, "[event]", i.LogLevel.INFO, `${e.name}${(null === (n = e.name) || void 0 === n ? void 0 : n.includes("QualityIssue")) ? " " + e.level : ""}, listeners: 0`);
                    }
                    removeEventListener(e, t1) {
                        this.off(e, t1);
                    }
                    addEventListener(e, t1, n) {
                        this.on(e, t1, n);
                    }
                    addDefaultEventListener(e, t1) {
                        this._ETonTo("default", e, t1, {});
                    }
                    removeDefaultEventListener(e) {
                        this._EToffTo("default", e);
                    }
                    _traceName() {
                        return "EventTarget";
                    }
                }
                r([
                    i.LogManager.d_trace(i.LogCategory.EVENTTARGET)
                ], a.prototype, "sysOn", null), r([
                    i.LogManager.d_trace(i.LogCategory.EVENTTARGET)
                ], a.prototype, "sysOff", null), r([
                    i.LogManager.d_trace(i.LogCategory.EVENTTARGET)
                ], a.prototype, "on", null), r([
                    i.LogManager.d_trace(i.LogCategory.EVENTTARGET)
                ], a.prototype, "off", null), r([
                    i.LogManager.d_trace(i.LogCategory.EVENTTARGET)
                ], a.prototype, "removeEventListener", null), r([
                    i.LogManager.d_trace(i.LogCategory.EVENTTARGET)
                ], a.prototype, "addEventListener", null), r([
                    i.LogManager.d_trace(i.LogCategory.EVENTTARGET)
                ], a.prototype, "addDefaultEventListener", null), r([
                    i.LogManager.d_trace(i.LogCategory.EVENTTARGET)
                ], a.prototype, "removeDefaultEventListener", null), t1.EventTarget = a;
            },
            141: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Events = void 0, function(e) {
                    e[e.SDKReady = "SDKReady"] = "SDKReady", e[e.ConnectionEstablished = "ConnectionEstablished"] = "ConnectionEstablished", e[e.ConnectionFailed = "ConnectionFailed"] = "ConnectionFailed", e[e.ConnectionClosed = "ConnectionClosed"] = "ConnectionClosed", e[e.Reconnecting = "Reconnecting"] = "Reconnecting", e[e.Reconnected = "Reconnected"] = "Reconnected", e[e.AuthResult = "AuthResult"] = "AuthResult", e[e.RefreshTokenResult = "RefreshTokenResult"] = "RefreshTokenResult", e[e.PlaybackFinished = "PlaybackFinished"] = "PlaybackFinished", e[e.MicAccessResult = "MicAccessResult"] = "MicAccessResult", e[e.IncomingCall = "IncomingCall"] = "IncomingCall", e[e.SourcesInfoUpdated = "SourcesInfoUpdated"] = "SourcesInfoUpdated", e[e.NetStatsReceived = "NetStatsReceived"] = "NetStatsReceived", e[e.SIPRegistrationSuccessful = "SIPRegistrationSuccessful"] = "SIPRegistrationSuccessful", e[e.SIPRegistrationFailed = "SIPRegistrationFailed"] = "SIPRegistrationFailed", e[e.ACDStatusUpdated = "ACDStatusUpdated"] = "ACDStatusUpdated", e[e.SQMessagingStatusUpdated = "SQMessagingStatusUpdated"] = "SQMessagingStatusUpdated", e[e.ACDError = "ACDError"] = "ACDError", e[e.SQError = "SQError"] = "SQError", e[e.PlaybackError = "PlaybackError"] = "PlaybackError";
                }(t1.Events || (t1.Events = {}));
            },
            209: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                });
                class n {
                    constructor(e){
                        this.str = e || n.getNewGUIDString();
                    }
                    toString() {
                        return this.str;
                    }
                    static getNewGUIDString() {
                        let e = (new Date).getTime();
                        return window.performance && "function" == typeof window.performance.now && (e += performance.now()), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (t1)=>{
                            let n = (e + 16 * Math.random()) % 16 | 0;
                            return e = Math.floor(e / 16), ("x" == t1 ? n : 3 & n | 8).toString(16);
                        });
                    }
                    _traceName() {
                        return "GUID";
                    }
                }
                t1.default = n;
            },
            7272: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Hardware = void 0;
                const r = n(4855);
                var i;
                !function(e) {
                    let t1, n;
                    !function(e) {
                        e[e.DevicesUpdated = "DevicesUpdated"] = "DevicesUpdated", e[e.MediaRendererAdded = "MediaRendererAdded"] = "MediaRendererAdded", e[e.MediaRendererUpdated = "MediaRendererUpdated"] = "MediaRendererUpdated", e[e.MediaRendererRemoved = "MediaRendererRemoved"] = "MediaRendererRemoved", e[e.BeforeMediaRendererRemoved = "BeforeMediaRendererRemoved"] = "BeforeMediaRendererRemoved";
                    }(t1 = e.HardwareEvents || (e.HardwareEvents = {})), function(e) {
                        e[e.VIDEO_QUALITY_HIGH = "video_quality_high"] = "VIDEO_QUALITY_HIGH", e[e.VIDEO_QUALITY_LOW = "video_quality_low"] = "VIDEO_QUALITY_LOW", e[e.VIDEO_QUALITY_MEDIUM = "video_quality_medium"] = "VIDEO_QUALITY_MEDIUM", e[e.VIDEO_SIZE_QQVGA = "video_size_qqvga"] = "VIDEO_SIZE_QQVGA", e[e.VIDEO_SIZE_QCIF = "video_size_qcif"] = "VIDEO_SIZE_QCIF", e[e.VIDEO_SIZE_QVGA = "video_size_qvga"] = "VIDEO_SIZE_QVGA", e[e.VIDEO_SIZE_CIF = "video_size_cif"] = "VIDEO_SIZE_CIF", e[e.VIDEO_SIZE_nHD = "video_size_nhd"] = "VIDEO_SIZE_nHD", e[e.VIDEO_SIZE_VGA = "video_size_vga"] = "VIDEO_SIZE_VGA", e[e.VIDEO_SIZE_SVGA = "video_size_svga"] = "VIDEO_SIZE_SVGA", e[e.VIDEO_SIZE_HD = "video_size_hd"] = "VIDEO_SIZE_HD", e[e.VIDEO_SIZE_UXGA = "video_size_uxga"] = "VIDEO_SIZE_UXGA", e[e.VIDEO_SIZE_FHD = "video_size_fhd"] = "VIDEO_SIZE_FHD", e[e.VIDEO_SIZE_UHD = "video_size_uhd"] = "VIDEO_SIZE_UHD";
                    }(n = e.VideoQuality || (e.VideoQuality = {}));
                    class i extends r.AudioDeviceManager {
                    }
                    e.AudioDeviceManager = i;
                    class a extends r.CameraManager {
                    }
                    e.CameraManager = a;
                    class s extends r.StreamManager {
                    }
                    e.StreamManager = s;
                }(i = t1.Hardware || (t1.Hardware = {})), t1.default = i;
            },
            2709: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.AudioDeviceManager = void 0;
                const i = n(1150), a = n(4007), s = n(9699), o = n(787), d = n(2957), c = [
                    "inputId",
                    "noiseSuppression",
                    "echoCancellation",
                    "disableAudio"
                ];
                class l {
                    constructor(){
                        if (void 0 !== l.instance) throw new Error("Error - use StreamManager.get()");
                        navigator && navigator.mediaDevices && navigator.mediaDevices.getSupportedConstraints ? this._supportedConstraints = navigator.mediaDevices.getSupportedConstraints() : this._supportedConstraints = {}, this.__defaultParams = {}, this._lastAudioInputDevices = [], this._lastAudioOutputDevices = [], this._callParams = {}, this.logger = i.LogManager.get().createLogger(i.LogCategory.USERMEDIA, this._traceName());
                    }
                    getAudioContext() {
                        if (this.audioContext) return this.audioContext;
                        if (void 0 !== window.AudioContext || void 0 !== window.webkitAudioContext) {
                            window.AudioContext = window.AudioContext || window.webkitAudioContext;
                            try {
                                return this.audioContext = new AudioContext, this.audioContext;
                            } catch (e) {
                                return this.audioContext = null, null;
                            }
                        }
                    }
                    prepareAudioContext() {
                        this.getAudioContext();
                    }
                    static get() {
                        return void 0 === l.instance && (l.instance = new l), l.instance;
                    }
                    getInputDevices() {
                        return navigator.mediaDevices.enumerateDevices().then((e)=>(this.logger.info(`Got input devices: ${JSON.stringify(e)}`), this._lastAudioInputDevices = e.map((e)=>{
                                if ("audio" === e.kind || "audioinput" === e.kind) return {
                                    id: e.deviceId,
                                    name: e.label,
                                    group: e.groupId
                                };
                            }).filter((e)=>void 0 !== e), this._lastAudioInputDevices));
                    }
                    getOutputDevices() {
                        return navigator.mediaDevices.enumerateDevices().then((e)=>(this.logger.info(`Got output devices: ${JSON.stringify(e)}`), this._lastAudioOutputDevices = e.map((e)=>{
                                if ("audiooutput" === e.kind) return {
                                    id: e.deviceId,
                                    name: e.label,
                                    group: e.groupId
                                };
                            }).filter((e)=>void 0 !== e), this._lastAudioOutputDevices));
                    }
                    getDefaultAudioSettings() {
                        return this.__defaultParams;
                    }
                    setDefaultAudioSettings(e) {
                        this.logger.info(`Set default audio settings: ${JSON.stringify(e)}`), this.__defaultParams = e;
                    }
                    async setCallAudioSettings(e, t1) {
                        if (this.logger.info(`Setting call ${e.id()} audio settings: ${JSON.stringify(t1)}`), !e.active()) return Promise.reject(o.dispatchUpdatedEvent(e, !1, s.CallFailedUpdateReasons.mediaOnHold));
                        if (this._callParams[e.id()] === t1) return;
                        const n = this._callParams[e.id()], r = c.some((e)=>n[e] !== t1[e]), i = n.outputId !== t1.outputId;
                        if (this.logger.info(`Must update renderers: ${i}, must update source: ${r}`), this._callParams[e.id()] = t1, r) try {
                            await a.StreamManager.get().updateStreamSettings(e), this.logger.info("Audio settings were set successfully.");
                        } catch (t1) {
                            throw this.logger.warning(`Failed to update call ${e.id()} stream: ${d.Utils.stringifyError(t1)}`), Error(t1);
                        }
                        i && void 0 !== t1.outputId && await Promise.all(e.getEndpoints().map((e)=>e.mediaRenderers.filter(({ kind: e })=>"audio" === e).map((e)=>e.useAudioOutput(t1.outputId))));
                    }
                    getCallAudioSettings(e) {
                        return this._callParams[e.id()];
                    }
                    getCallConstraints(e) {
                        return this._callParams[e] ? this._getAudioConstraints(this._callParams[e]) : (this._callParams[e] = this.__defaultParams, this._getAudioConstraints(this.__defaultParams));
                    }
                    _getAudioConstraints(e) {
                        if (e.disableAudio) return !1;
                        let t1 = "ideal";
                        e.strict;
                        const n = {};
                        return e.inputId && (n.deviceId = {
                            exact: e.inputId
                        }), "boolean" == typeof e.echoCancellation && this._supportedConstraints.echoCancellation && (n.echoCancellation = e.echoCancellation), "boolean" == typeof e.noiseSuppression && this._supportedConstraints.noiseSuppression && (n.noiseSuppression = e.noiseSuppression), "boolean" == typeof e.autoGainControl && this._supportedConstraints.autoGainControl && (n.autoGainControl = e.autoGainControl), e.advanced && (n.advanced = e.advanced), n.echoCancellationType = "system", !Object.keys(n) || n;
                    }
                    _traceName() {
                        return "AudioDeviceManager";
                    }
                }
                r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "getInputDevices", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "getOutputDevices", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "getDefaultAudioSettings", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "setDefaultAudioSettings", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "setCallAudioSettings", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "getCallAudioSettings", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "getCallConstraints", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "_getAudioConstraints", null), t1.AudioDeviceManager = l;
            },
            2334: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.CameraManager = void 0;
                const i = n(1150), a = n(4007), s = n(7272), o = n(3869), d = n(9699), c = n(787);
                class l {
                    constructor(){
                        if (void 0 !== l.instance) throw new Error("Error - use StreamManager.get()");
                        navigator && navigator.mediaDevices && navigator.mediaDevices.getSupportedConstraints ? this._supportedConstraints = navigator.mediaDevices.getSupportedConstraints() : this._supportedConstraints = {}, this._callParams = {}, this._lastCameraDevices = [], this.__defaultParams = {}, this.logger = i.LogManager.get().createLogger(i.LogCategory.USERMEDIA, this._traceName());
                    }
                    static get() {
                        return void 0 === l.instance && (l.instance = new l), l.instance;
                    }
                    async setDefaultVideoSettings(e) {
                        const t1 = this._validateCameraParams(e);
                        this.logger.info(`Setting  default video settings, params: ${JSON.stringify(e)}, valid params: ${JSON.stringify(t1)}`), this.__defaultParams = t1, await s.Hardware.StreamManager.get().updateLocalVideo();
                    }
                    getDefaultVideoSettings() {
                        return this.__defaultParams;
                    }
                    setCallVideoSettings(e, t1) {
                        const n = this._validateCameraParams(t1);
                        return this.logger.info(`Setting call ${e.id()} video settings, params: ${JSON.stringify(t1)}, valid params: ${JSON.stringify(n)}`), e.active() ? (this._callParams[e.id()] = n, new Promise((t1, n)=>{
                            a.StreamManager.get().updateStreamSettings(e).then(()=>{
                                this.logger.info("Video settings were set successfully."), t1();
                            }).catch((t1)=>{
                                this.logger.warning(`Failed to set call ${e.id()} video settings: ${t1}`), n(t1);
                            });
                        })) : Promise.reject(c.dispatchUpdatedEvent(e, !1, d.CallFailedUpdateReasons.mediaOnHold));
                    }
                    getCallVideoSettings(e) {
                        return this._callParams[e.id()];
                    }
                    getCallConstraints(e) {
                        return "__local__" === e ? (this._callParams[e] = this.__defaultParams, this._getVideoConstraints(this.__defaultParams)) : this._callParams[e] ? this._getVideoConstraints(this._callParams[e]) : (this._callParams[e] = this.__defaultParams, this._getVideoConstraints(this.__defaultParams));
                    }
                    getInputDevices() {
                        return navigator.mediaDevices.enumerateDevices().then((e)=>(this.logger.info(`Got input devices: ${JSON.stringify(e)}`), this._lastCameraDevices = e.map((e)=>{
                                if ("video" === e.kind || "videoinput" === e.kind) return {
                                    id: e.deviceId,
                                    name: e.label,
                                    group: e.groupId
                                };
                            }).filter((e)=>void 0 !== e), this._lastCameraDevices));
                    }
                    _getVideoConstraints(e) {
                        const t1 = {};
                        return e.cameraId ? t1.deviceId = {
                            exact: e.cameraId
                        } : void 0 !== e.facingMode && (!1 === e.facingMode ? t1.facingMode = "environment" : t1.facingMode = "user"), e.frameHeight && (t1.height = {}, e.strict ? t1.height.min = e.frameHeight : t1.height.ideal = e.frameHeight), e.frameWidth && (t1.width = {}, e.strict ? t1.width.min = e.frameWidth : t1.width.ideal = e.frameWidth), e.frameRate && e.frameRate > 0 && this._supportedConstraints.frameRate && (t1.frameRate = e.frameRate + ""), e.aspectRatio && e.aspectRatio > 0 && this._supportedConstraints.aspectRatio && (t1.aspectRatio = {
                            exact: e.aspectRatio + ""
                        }), !Object.keys(t1) || t1;
                    }
                    _validateCameraParams(e) {
                        if (e.videoQuality) {
                            (e.frameHeight || e.frameWidth) && this.logger.warning('"videoQuality" parameter detected. The "frameHeight" and the "frameWidth" params will be ignored');
                            const t1 = this._videoQualityToSize(e.videoQuality);
                            e.frameWidth = t1.w, e.frameHeight = t1.h;
                        }
                        return o.default.isIphone() && (delete e.videoQuality, delete e.frameWidth, delete e.frameHeight, delete e.frameRate), e;
                    }
                    _videoQualityToSize(e) {
                        switch(e){
                            case s.Hardware.VideoQuality.VIDEO_QUALITY_HIGH:
                                return {
                                    w: 1280,
                                    h: 720
                                };
                            case s.Hardware.VideoQuality.VIDEO_QUALITY_MEDIUM:
                                return {
                                    w: 640,
                                    h: 480
                                };
                            case s.Hardware.VideoQuality.VIDEO_QUALITY_LOW:
                                return {
                                    w: 320,
                                    h: 240
                                };
                            case s.Hardware.VideoQuality.VIDEO_SIZE_QQVGA:
                                return {
                                    w: 160,
                                    h: 120
                                };
                            case s.Hardware.VideoQuality.VIDEO_SIZE_QCIF:
                                return {
                                    w: 176,
                                    h: 144
                                };
                            case s.Hardware.VideoQuality.VIDEO_SIZE_QVGA:
                                return {
                                    w: 320,
                                    h: 240
                                };
                            case s.Hardware.VideoQuality.VIDEO_SIZE_CIF:
                                return {
                                    w: 352,
                                    h: 288
                                };
                            case s.Hardware.VideoQuality.VIDEO_SIZE_nHD:
                                return {
                                    w: 640,
                                    h: 360
                                };
                            case s.Hardware.VideoQuality.VIDEO_SIZE_VGA:
                                return {
                                    w: 640,
                                    h: 480
                                };
                            case s.Hardware.VideoQuality.VIDEO_SIZE_SVGA:
                                return {
                                    w: 800,
                                    h: 600
                                };
                            case s.Hardware.VideoQuality.VIDEO_SIZE_HD:
                                return {
                                    w: 1280,
                                    h: 720
                                };
                            case s.Hardware.VideoQuality.VIDEO_SIZE_UXGA:
                                return {
                                    w: 1600,
                                    h: 1200
                                };
                            case s.Hardware.VideoQuality.VIDEO_SIZE_FHD:
                                return {
                                    w: 1920,
                                    h: 1080
                                };
                            case s.Hardware.VideoQuality.VIDEO_SIZE_UHD:
                                return {
                                    w: 3840,
                                    h: 2160
                                };
                            default:
                                return {
                                    w: 320,
                                    h: 240
                                };
                        }
                    }
                    static legacyParamConverter(e) {
                        const t1 = {
                            videoQuality: s.Hardware.VideoQuality.VIDEO_QUALITY_MEDIUM
                        };
                        return e.width && ("string" == typeof e.width || "number" == typeof e.width ? (delete t1.videoQuality, t1.frameWidth = e.width) : "string" == typeof e.width.exact || "number" == typeof e.width.exact ? (delete t1.videoQuality, t1.frameWidth = e.width.exact, t1.strict = !0) : "string" == typeof e.width.min || "number" == typeof e.width.min ? (delete t1.videoQuality, t1.frameWidth = e.width.min) : "string" == typeof e.width.max || "number" == typeof e.width.max ? (delete t1.videoQuality, t1.frameWidth = e.width.max) : "string" != typeof e.width.ideal && "number" != typeof e.width.ideal || (delete t1.videoQuality, t1.frameWidth = e.width.ideal)), e.height && ("string" == typeof e.height || "number" == typeof e.height ? (delete t1.videoQuality, t1.frameHeight = e.height) : "string" == typeof e.height.exact || "number" == typeof e.height.exact ? (delete t1.videoQuality, t1.frameHeight = e.height.exact, t1.strict = !0) : "string" == typeof e.height.min || "number" == typeof e.height.min ? (delete t1.videoQuality, t1.frameHeight = e.height.min) : "string" == typeof e.height.max || "number" == typeof e.height.max ? (delete t1.videoQuality, t1.frameHeight = e.height.max) : "string" != typeof e.height.ideal && "number" != typeof e.height.ideal || (delete t1.videoQuality, t1.frameHeight = e.height.ideal)), t1;
                    }
                    testResolutions(e) {
                        const t1 = [
                            s.Hardware.VideoQuality.VIDEO_SIZE_QQVGA,
                            s.Hardware.VideoQuality.VIDEO_SIZE_QCIF,
                            s.Hardware.VideoQuality.VIDEO_SIZE_QVGA,
                            s.Hardware.VideoQuality.VIDEO_SIZE_CIF,
                            s.Hardware.VideoQuality.VIDEO_SIZE_nHD,
                            s.Hardware.VideoQuality.VIDEO_SIZE_VGA,
                            s.Hardware.VideoQuality.VIDEO_SIZE_SVGA,
                            s.Hardware.VideoQuality.VIDEO_SIZE_HD,
                            s.Hardware.VideoQuality.VIDEO_SIZE_UXGA,
                            s.Hardware.VideoQuality.VIDEO_SIZE_FHD,
                            s.Hardware.VideoQuality.VIDEO_SIZE_UHD
                        ];
                        return this._lastResolutionTestResult ? new Promise((e, t1)=>{
                            e(this._lastResolutionTestResult);
                        }) : this._testResolutions(t1, {}, e);
                    }
                    _testResolutions(e, t1, n) {
                        if (e.length) {
                            let r = e.shift(), i = {
                                strict: !0
                            };
                            const o = this._videoQualityToSize(r);
                            i.frameWidth = o.w, i.frameHeight = o.h, n && (i.cameraId = n);
                            let d = {
                                video: this._getVideoConstraints(i)
                            };
                            return a.StreamManager.getUserMedia(d).then((i)=>(this.logger.info("_testResolutions(): Media access granted"), i.getTracks().forEach((e)=>e.stop()), t1[s.Hardware.VideoQuality[r]] = !0, this._testResolutions(e, t1, n)), (i)=>(this.logger.error(`_testResolutions(): Media access denied: ${i ? i.message || i.name || i : "unknown"}`), t1[s.Hardware.VideoQuality[r]] = !1, this._testResolutions(e, t1, n)));
                        }
                        return this._lastResolutionTestResult = t1, t1;
                    }
                    loadResolutionTestResult(e) {
                        return !![
                            s.Hardware.VideoQuality.VIDEO_SIZE_QQVGA,
                            s.Hardware.VideoQuality.VIDEO_SIZE_QCIF,
                            s.Hardware.VideoQuality.VIDEO_SIZE_QVGA,
                            s.Hardware.VideoQuality.VIDEO_SIZE_CIF,
                            s.Hardware.VideoQuality.VIDEO_SIZE_nHD,
                            s.Hardware.VideoQuality.VIDEO_SIZE_VGA,
                            s.Hardware.VideoQuality.VIDEO_SIZE_SVGA,
                            s.Hardware.VideoQuality.VIDEO_SIZE_HD,
                            s.Hardware.VideoQuality.VIDEO_SIZE_UXGA,
                            s.Hardware.VideoQuality.VIDEO_SIZE_FHD,
                            s.Hardware.VideoQuality.VIDEO_SIZE_UHD
                        ].every((t1)=>void 0 !== e[s.Hardware.VideoQuality[t1]]) && (this._lastResolutionTestResult = e, !0);
                    }
                    _traceName() {
                        return "CameraManager";
                    }
                }
                r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "setDefaultVideoSettings", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "getDefaultVideoSettings", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "setCallVideoSettings", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "getCallVideoSettings", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "getCallConstraints", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "getInputDevices", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "_getVideoConstraints", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l.prototype, "_validateCameraParams", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], l, "legacyParamConverter", null), t1.CameraManager = l;
            },
            4007: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.StreamManager = void 0;
                const i = n(1150), a = n(7272), s = n(3576), o = n(2334), d = n(3869), c = n(141), l = n(125), g = n(2709), u = n(7222), h = n(308), p = n(8237), f = n(787), m = n(4610), v = n(9001);
                class C extends s.EventTarget {
                    constructor(){
                        if (super(), this.isLocalVideoRequested = !1, this.localVideoPromises = [], this._dedicatedMirrorStream = null, void 0 !== C.instance) throw new Error("Error - use StreamManager.get()");
                        this._callStreams = {}, this._localMediaRenderers = [], this._sharingStreams = {}, this.logger = i.LogManager.get().createLogger(i.LogCategory.HARDWARE, this._traceName());
                    }
                    static get() {
                        return void 0 === C.instance && (C.instance = new C), C.instance;
                    }
                    async getCallStream(e, t1 = !1) {
                        const n = void 0 === e ? "__default" : e.id();
                        if (this._callStreams[n] && !t1) return this._callStreams[n];
                        {
                            const t1 = this._composeConstraints(e);
                            if (this.logger.info(`[constraints]: ${JSON.stringify(t1)}`), !t1.audio && !t1.video && "__default" !== n) return null;
                            try {
                                const r = await C.getUserMedia(t1);
                                this.logger.info("Media access granted"), this._callStreams[n] = r, r.getTracks().forEach((e)=>{
                                    e.onended = this.onCallEnded, e.onmute = this.onCallEnded;
                                });
                                const i = e.state();
                                return i === m.CallState.STOPPING || i === m.CallState.ENDED ? (this.logger.info(`Media Stream will be stopped, because call in ${i} state`), r) : (l.Client.getInstance().dispatchEvent({
                                    name: c.Events.MicAccessResult,
                                    result: !0,
                                    stream: r
                                }), r);
                            } catch (r) {
                                let i = null;
                                try {
                                    "NotFoundError" === (null == r ? void 0 : r.name) && (i = await this._handleNotFoundError(e, t1)), "NotReadableError" === (null == r ? void 0 : r.name) && (i = await this._handleNotReadableError(e, t1));
                                } catch (e) {
                                    throw this.logger.error(`Media access denied: ${(null == e ? void 0 : e.message) || (null == e ? void 0 : e.name) || e || "unknown"}`), l.Client.getInstance().dispatchEvent({
                                        name: c.Events.MicAccessResult,
                                        result: !1,
                                        stream: null
                                    }), e;
                                }
                                return this.logger.info("Media access granted"), i && (this._callStreams[n] = i), null == i || i.getTracks().forEach((e)=>{
                                    e.onended = this.onCallEnded, e.onmute = this.onCallEnded;
                                }), l.Client.getInstance().dispatchEvent({
                                    name: c.Events.MicAccessResult,
                                    result: Boolean(i),
                                    stream: i,
                                    fallback: !0
                                }), i;
                            }
                        }
                    }
                    async _handleNotFoundError(e, t1) {
                        let n = {
                            audio: !0
                        };
                        return this.logger.info(`[NotFoundError backup constraints]: ${JSON.stringify(t1)}`), void 0 !== e && (e.settings.videoDirections.sendVideo = !1, n = this._composeConstraints(e)), await C.getUserMedia(n);
                    }
                    async _handleNotReadableError(e, t1) {
                        var n, r;
                        const i = void 0 === e ? "__default" : e.id();
                        this.logger.info(`[NotReadableError constraints]: ${JSON.stringify(t1)}`);
                        this._callStreams[i].getTracks().forEach((e)=>e.stop());
                        try {
                            return await C.getUserMedia(t1);
                        } catch (t1) {
                            const i = {
                                video: Boolean(null === (r = null === (n = null == e ? void 0 : e.settings) || void 0 === n ? void 0 : n.videoDirections) || void 0 === r ? void 0 : r.sendVideo),
                                audio: !0
                            };
                            return this.logger.info(`[NotReadableError fallback constraints]: ${JSON.stringify(i)}`), await C.getUserMedia(i);
                        }
                    }
                    _updateCallStream(e) {
                        return this.remCallStream(e), this.getCallStream(e);
                    }
                    updateCallStream(e) {
                        return this.logger.info(`Updating call ${e.id()} stream`), new Promise((t1, n)=>{
                            const r = this._callStreams[e.id()], i = ()=>{
                                setTimeout(()=>this.updateLocalVideo(), 500), e.peerConnection.restoreMute();
                                const t1 = ()=>{
                                    r.getTracks().forEach((t1)=>{
                                        e.peerConnection.getTransceivers().some((e)=>e.sender.track && e.sender.track.id === t1.id) || d.default.isIphone() || t1.stop();
                                    });
                                };
                                setTimeout(t1, 500), setTimeout(t1, 2e3), setTimeout(t1, 5e3);
                            }, a = ()=>{
                                i(), t1();
                            };
                            this.getCallStream(e, !0).then((t1)=>{
                                const i = r.getTracks(), s = t1.getTracks(), o = i.map((e)=>e.kind).sort(), d = s.map((e)=>e.kind).sort();
                                return p.CallPromiseResolver.add(e, {
                                    resolve: a,
                                    reject: n,
                                    dispatchEvent: f.dispatchUpdatedEvent.bind(null, e)
                                }), i.length === s.length && o.every((e, t1)=>e === d[t1]) ? e.peerConnection.updateCustomMedia(t1) : (e.peerConnection.fastRemoveCustomMedia(r), this._remCallStream(r), e.peerConnection.addCustomMedia(t1));
                            }).catch(n);
                        });
                    }
                    async updateStreamSettings(e) {
                        this.logger.info(`Updating call ${e.id()} stream settings`);
                        try {
                            const t1 = await this.getCallStream(e, !0);
                            await e.peerConnection.updateMediaTracks(t1), await this.updateLocalVideo();
                        } catch (e) {
                            throw this.logger.error(`updateStreamSettings error: ${e.message}`), e;
                        }
                    }
                    remCallStream(e) {
                        const t1 = void 0 === e ? "__default" : e.id();
                        this._callStreams[t1] && (this._remCallStream(this._callStreams[t1]), this._callStreams[t1] = void 0, delete this._callStreams[t1]);
                    }
                    _remCallStream(e) {
                        e && (d.default.isIphone() || e.getTracks().forEach((t1)=>{
                            t1.onended = void 0, t1.onmute = void 0, t1.stop(), e.removeTrack(t1);
                        }));
                    }
                    clear() {
                        this._mirrorStream && this._mirrorStream.getTracks().forEach((e)=>{
                            e.onended = void 0, e.onmute = void 0, e.stop();
                        }), this._mirrorStream = void 0;
                        for(let e in this._callStreams)if (this._callStreams.hasOwnProperty(e)) {
                            const t1 = this._callStreams[e];
                            t1 && t1.getTracks().forEach((e)=>{
                                e.onended = void 0, e.onmute = void 0, e.stop();
                            });
                        }
                        this._callStreams = {};
                    }
                    getLocalMediaRenderers() {
                        return this._localMediaRenderers;
                    }
                    showLocalVideo(e = !0) {
                        return this.logger.info("Call to show local video."), new Promise((t1, n)=>{
                            const r = "voximplantlocalvideo";
                            if (this.isLocalVideoRequested) return this.logger.warning("The local video is already displaying."), t1(this._localMediaRenderers[0]);
                            const i = this._getVideoFromCalls();
                            if (this.isLocalVideoRequested = !0, i) {
                                const n = new u.MediaRenderer({
                                    stream: new MediaStream([
                                        i
                                    ]),
                                    kind: "video",
                                    placeOnDom: e,
                                    isLocal: !0,
                                    deprecatedId: r,
                                    mids: [
                                        "local"
                                    ]
                                });
                                this._localMediaRenderers.push(n), this.logger.info("New localMediaRenderer for existing track was added."), t1(n), this.dispatchEvent({
                                    name: a.default.HardwareEvents.MediaRendererAdded,
                                    renderer: n
                                });
                            } else {
                                const i = this.getDedicatedMirrorStream().then((n)=>{
                                    this._dedicatedMirrorStream && this.stopDedicatedMirrorStream(), this._dedicatedMirrorStream = n;
                                    const i = new u.MediaRenderer({
                                        stream: n,
                                        kind: "video",
                                        placeOnDom: e,
                                        isLocal: !0,
                                        deprecatedId: r,
                                        mids: [
                                            "local"
                                        ]
                                    });
                                    this._localMediaRenderers.push(i), this.logger.info("New localMediaRenderer was added. New stream was created."), t1(i), this.dispatchEvent({
                                        name: a.default.HardwareEvents.MediaRendererAdded,
                                        renderer: i
                                    });
                                }).catch((e)=>{
                                    this.isLocalVideoRequested = !1, n(e);
                                });
                                this.localVideoPromises.push(i);
                            }
                        });
                    }
                    async getDedicatedMirrorStream() {
                        try {
                            return this.logger.info("Getting dedicated mirror stream."), await C.getUserMedia({
                                video: o.CameraManager.get().getCallConstraints("__local__")
                            });
                        } catch (e) {
                            if ("NotReadableError" === (null == e ? void 0 : e.name)) return this.logger.info("Couldn't get mirror stream. Will do it again."), this.stopDedicatedMirrorStream(), await C.getUserMedia({
                                video: o.CameraManager.get().getCallConstraints("__local__")
                            });
                            throw e;
                        }
                    }
                    stopDedicatedMirrorStream() {
                        if (this._dedicatedMirrorStream) {
                            this._dedicatedMirrorStream.getTracks().forEach((e)=>{
                                e.onended = null, e.onmute = null, e.stop();
                            });
                            try {
                                this._dedicatedMirrorStream.stop(), this.logger.info("Dedicated mirror stream was stopped.");
                            } catch (e) {}
                            this._dedicatedMirrorStream = null;
                        }
                    }
                    async updateLocalVideo(e) {
                        if (this._localMediaRenderers && 0 === this._localMediaRenderers.length) return void this.logger.info("Local video wasn't updated because there is 0 local media renderers.");
                        if (!this.isLocalVideoRequested) return void this.logger.info("Local video wasn't updated because it wasn't requested.");
                        const t1 = this._getVideoFromCalls();
                        if (this.logger.info(`Local video for rendererKind: ${e} will be updated. Track from call exist: ${Boolean(t1)}`), t1) this._localMediaRenderers[0].stream.getVideoTracks()[0].id !== t1.id ? (this._localMediaRenderers[0].replaceVideo(new MediaStream([
                            t1
                        ])), this.stopDedicatedMirrorStream(), this.dispatchEvent({
                            name: a.default.HardwareEvents.MediaRendererUpdated,
                            renderer: this._localMediaRenderers[0],
                            type: e || this._localMediaRenderers[0].kind
                        })) : this.logger.info("Local media renderer contains different track from call.");
                        else try {
                            const t1 = await this.getDedicatedMirrorStream();
                            this._dedicatedMirrorStream && this.stopDedicatedMirrorStream(), this._dedicatedMirrorStream = t1, this._localMediaRenderers[0] && (this._localMediaRenderers[0].kind = e || "video", this._localMediaRenderers[0].replaceVideo(t1), this.dispatchEvent({
                                name: a.default.HardwareEvents.MediaRendererUpdated,
                                renderer: this._localMediaRenderers[0],
                                type: e || this._localMediaRenderers[0].kind
                            }));
                        } catch (e) {
                            this.logger.error(`Unable to update local video: ${e.message}`);
                        }
                    }
                    async hideLocalVideo() {
                        return this.isLocalVideoRequested ? (await Promise.all(this.localVideoPromises), this.logger.info("Start hiding local video."), this.localVideoPromises = [], 0 === this._localMediaRenderers.length ? (this.logger.info("There isn't local media renderer."), Promise.resolve()) : (this.dispatchEvent({
                            name: a.default.HardwareEvents.BeforeMediaRendererRemoved,
                            renderer: this._localMediaRenderers[0]
                        }), this.isLocalVideoRequested = !1, this._dedicatedMirrorStream && this.stopDedicatedMirrorStream(), this._localMediaRenderers[0].clear(), this._localMediaRenderers[0].stream = null, this._localMediaRenderers.shift(), this.dispatchEvent({
                            name: a.default.HardwareEvents.MediaRendererRemoved,
                            renderer: this._localMediaRenderers[0]
                        }), this.logger.info("Local video was hidden."), Promise.resolve())) : (this.logger.info("Nothing to hide. Local video wasn't requested."), Promise.resolve());
                    }
                    on(e, t1, n) {
                        super.on(e, t1);
                    }
                    off(e, t1) {
                        super.off(e, t1);
                    }
                    _newScreenSharing(e) {
                        return this.logger.info("Getting media for screen sharing."), new Promise((t1, n)=>{
                            d.default.getScreenMedia().then((n)=>{
                                var r;
                                this.logger.info("Media access granted");
                                const i = {
                                    stream: n,
                                    renderer: null
                                };
                                n.getTracks().forEach((t1)=>{
                                    t1.onended = ()=>e.stopSharingScreen();
                                });
                                let a = null === (r = this._localMediaRenderers) || void 0 === r ? void 0 : r[0];
                                a && (a.kind = "sharing"), void 0 === this._sharingStreams[e.id()] && (this._sharingStreams[e.id()] = []), this._sharingStreams[e.id()].push(i), t1(i);
                            }).catch((e)=>{
                                this.logger.error(`Media access denied: ${e ? e.message || e.name || e : "unknown"}`), n(e);
                            });
                        });
                    }
                    _getScreenSharing(e) {
                        return void 0 !== this._sharingStreams[e.id()] ? this._sharingStreams[e.id()] : [];
                    }
                    _clearScreenSharing(e, t1) {
                        return this.logger.info("Stopping sharing media stream."), new Promise((n)=>{
                            var r;
                            this._sharingStreams[e.id()] = this._sharingStreams[e.id()].filter((e)=>e.stream.id !== t1.stream.id), t1.renderer && (this._localMediaRenderers = this._localMediaRenderers.filter((e)=>e.id !== t1.renderer.id), t1.renderer.clear(), t1.renderer = void 0), t1.stream.getTracks().forEach((e)=>{
                                e.enabled = !1, e.onended = null, e.stop();
                            }), "sharing" === (null === (r = this._localMediaRenderers[0]) || void 0 === r ? void 0 : r.kind) && (this._localMediaRenderers[0].kind = "video"), this.logger.info("Sharing media stream was stopped."), e.dispatchEvent({
                                name: v.CallEvents.SharingStopped,
                                call: e,
                                result: !0
                            }), n();
                        });
                    }
                    _getTracksKind(e) {
                        let t1 = {};
                        const n = this._callStreams[e.id()];
                        void 0 !== n && n.getTracks().forEach((e)=>t1[e.id] = e.kind);
                        const r = this._sharingStreams[e.id()];
                        return void 0 !== r && r.forEach((e)=>{
                            e.stream.getTracks().forEach((e)=>t1[e.id] = "sharing");
                        }), t1;
                    }
                    _traceName() {
                        return "StreamManager";
                    }
                    _getVideoFromCalls() {
                        const e = h.CallManager.get(), t1 = [];
                        for(const n in e.calls)if (e.calls.hasOwnProperty(n)) {
                            const r = e.calls[n];
                            if (!r.active()) break;
                            const i = {
                                time: r.getCallDuration(),
                                track: null
                            };
                            if (r.peerConnection) r.peerConnection.getTransceivers().forEach((e)=>{
                                null === i.track && -1 !== e.direction.indexOf("send") && e.sender.track && "video" === e.sender.track.kind && "live" === e.sender.track.readyState && (i.track = e.sender.track);
                            });
                            i.track && t1.push(i);
                        }
                        return t1.length ? (t1.sort((e, t1)=>e.time > t1.time ? 1 : e.time < t1.time ? -1 : 0), t1[0].track) : null;
                    }
                    onCallEnded() {}
                    _composeConstraints(e) {
                        const t1 = void 0 === e ? "__default" : e.id(), n = {};
                        return "__default" !== t1 && void 0 !== e && e.settings.videoDirections.sendVideo ? n.video = o.CameraManager.get().getCallConstraints(t1) : n.video = !1, "__default" === t1 || e.settings.audioDirections.sendAudio ? n.audio = g.AudioDeviceManager.get().getCallConstraints(t1) : n.audio = !1, n;
                    }
                    static getUserMedia(e) {
                        return new Promise((t1, n)=>{
                            const r = navigator.mediaDevices.getUserMedia(e).then((e)=>{
                                C.umCache.push(e), t1(e);
                            }).catch(n);
                            C.umCachePromises.push(r);
                        });
                    }
                    static async clearUmCache() {
                        await Promise.all(C.umCachePromises), C.umCachePromises = [], C.umCache = C.umCache.filter((e)=>{
                            const t1 = C.get()._dedicatedMirrorStream;
                            return !(!t1 || e.id !== t1.id) || (e.getTracks().forEach((e)=>e.stop()), !1);
                        });
                    }
                }
                C.umCache = [], C.umCachePromises = [], r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "getCallStream", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "_handleNotFoundError", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "_handleNotReadableError", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "_updateCallStream", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "updateCallStream", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "remCallStream", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "_remCallStream", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "clear", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "getLocalMediaRenderers", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "showLocalVideo", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "hideLocalVideo", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "on", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "off", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "_newScreenSharing", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "_getScreenSharing", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "_clearScreenSharing", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "_getTracksKind", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "onCallEnded", null), r([
                    i.LogManager.d_trace(i.LogCategory.HARDWARE)
                ], C.prototype, "_composeConstraints", null), t1.StreamManager = C;
            },
            4855: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.StreamManager = t1.CameraManager = t1.AudioDeviceManager = void 0;
                var r = n(2709);
                Object.defineProperty(t1, "AudioDeviceManager", {
                    enumerable: !0,
                    get: function() {
                        return r.AudioDeviceManager;
                    }
                });
                var i = n(2334);
                Object.defineProperty(t1, "CameraManager", {
                    enumerable: !0,
                    get: function() {
                        return i.CameraManager;
                    }
                });
                var a = n(4007);
                Object.defineProperty(t1, "StreamManager", {
                    enumerable: !0,
                    get: function() {
                        return a.StreamManager;
                    }
                });
            },
            6230: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.PushService = void 0;
                const r = n(4106), i = n(209), a = n(245);
                class s {
                    static updatePromiseResult(e) {
                        const t1 = this._pushPromises[e.params];
                        t1 && (clearTimeout(t1.expire), e.msg ? t1.reject(e.msg) : t1.resolve(), delete this._pushPromises[e.params]);
                    }
                    static register(e) {
                        return new Promise((t1, n)=>{
                            const s = (new i.default).toString();
                            a.default.callRemoteFunction(r.RemoteFunction.registerPushToken, e, s) ? this._pushPromises[s] = {
                                resolve: t1,
                                reject: n,
                                expire: setTimeout(n, 3e4)
                            } : n();
                        });
                    }
                    static unregister(e) {
                        return new Promise((t1, n)=>{
                            const s = (new i.default).toString();
                            a.default.callRemoteFunction(r.RemoteFunction.unregisterPushToken, e, s) ? this._pushPromises[s] = {
                                resolve: t1,
                                reject: n,
                                expire: setTimeout(n, 3e4)
                            } : n();
                        });
                    }
                    static incomingPush(e) {
                        return new Promise((t1, n)=>{
                            a.default.callRemoteFunction(r.RemoteFunction.pushFeedback, e) ? t1() : n();
                        });
                    }
                    _traceName() {
                        return "PushService";
                    }
                }
                t1.PushService = s, s._pushPromises = {};
            },
            1150: (e, t1)=>{
                "use strict";
                var n, r;
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.LogManager = t1.Logger = t1.ClientState = t1.LogCategory = t1.LogLevel = void 0, function(e) {
                    e[e.NONE = 0] = "NONE", e[e.ERROR = 1] = "ERROR", e[e.WARNING = 2] = "WARNING", e[e.INFO = 3] = "INFO", e[e.TRACE = 4] = "TRACE";
                }(n = t1.LogLevel || (t1.LogLevel = {})), function(e) {
                    e[e.SIGNALING = 0] = "SIGNALING", e[e.RTC = 1] = "RTC", e[e.USERMEDIA = 2] = "USERMEDIA", e[e.CALL = 3] = "CALL", e[e.CALLEXP2P = 4] = "CALLEXP2P", e[e.CALLEXSERVER = 5] = "CALLEXSERVER", e[e.CALLMANAGER = 6] = "CALLMANAGER", e[e.CLIENT = 7] = "CLIENT", e[e.AUTHENTICATOR = 8] = "AUTHENTICATOR", e[e.PCFACTORY = 9] = "PCFACTORY", e[e.UTILS = 10] = "UTILS", e[e.ORTC = 11] = "ORTC", e[e.MESSAGING = 12] = "MESSAGING", e[e.REINVITEQ = 13] = "REINVITEQ", e[e.HARDWARE = 14] = "HARDWARE", e[e.ENDPOINT = 15] = "ENDPOINT", e[e.EVENTTARGET = 16] = "EVENTTARGET", e[e.VSM = 17] = "VSM";
                }(r = t1.LogCategory || (t1.LogCategory = {})), function(e) {
                    e[e.DISCONNECTED = "DISCONNECTED"] = "DISCONNECTED", e[e.CONNECTING = "CONNECTING"] = "CONNECTING", e[e.CONNECTED = "CONNECTED"] = "CONNECTED", e[e.LOGGING_IN = "LOGGING_IN"] = "LOGGING_IN", e[e.LOGGED_IN = "LOGGED_IN"] = "LOGGED_IN";
                }(t1.ClientState || (t1.ClientState = {}));
                class i {
                    constructor(e, t1, n){
                        this.category = e, this.label = t1, this.provider = n;
                    }
                    log(e, t1) {
                        this.provider.writeMessage(this.category, this.label, e, t1);
                    }
                    error(e) {
                        this.log(n.ERROR, e);
                    }
                    warning(e) {
                        this.log(n.WARNING, e);
                    }
                    info(e) {
                        this.log(n.INFO, e);
                    }
                    trace(e) {
                        this.log(n.TRACE, e);
                    }
                }
                t1.Logger = i;
                class a {
                    constructor(){
                        this.timeOriginGap = 0, this.isFirstPrint = !0, this.levels = {}, this.showTrace = !1, this._shadowLogging = !1;
                    }
                    get shadowLogging() {
                        return this._shadowLogging;
                    }
                    set shadowLogging(e) {
                        this._shadowLogging || (this._shadowLog = []), this._shadowLogging = e;
                    }
                    static get() {
                        return void 0 === this.inst && (this.inst = new a, this.inst.prettyPrint = !1), this.inst;
                    }
                    static d_trace(e) {
                        return (t1, r, i)=>({
                                value: function(...s) {
                                    const o = "login" === r || "basicLogin" === r || "sendWSMessage" === r && "login" === s[0], d = "sendWSMessage" === r ? 2 : 1, c = t1._traceName ? `${t1._traceName()}${this && this.settings ? ` ${this.settings.id}` : this && this.id && "function" != typeof this.id ? ` ${this.id}` : ""}` : "";
                                    let l = "";
                                    try {
                                        l = s.map((e, t1)=>o && t1 === d ? '"********"' : JSON.stringify(e)).join();
                                    } catch (e) {
                                        l = "circular structure";
                                    }
                                    return a.get().writeMessage(e, c, n.TRACE, `${r}(${l})`), i.value.apply(this, s);
                                }
                            });
                    }
                    getSLog() {
                        return this._shadowLog;
                    }
                    clearSilentLog() {
                        this._shadowLog = [];
                    }
                    setLoggerCallback(e) {
                        this._outerCallback = e;
                    }
                    setPrettyPrint(e) {
                        this.prettyPrint = e;
                    }
                    setLogLevel(e, t1) {
                        t1 === n.TRACE ? this.showTrace = !0 : this.levels[r[e]] = t1;
                    }
                    writeMessage(e, t1, i, s) {
                        i === n.TRACE ? a.traceTick++ : a.logTick++, this.timeOriginGap || (this.timeOriginGap = performance.now());
                        const o = "string" == typeof s ? s : JSON.stringify(s), d = this.isFirstPrint ? this.prettyPrint ? (new Date).toUTCString() : (new Date).toString() : parseInt("" + (performance.now() - this.timeOriginGap) / 1e3), c = i === n.TRACE ? `VIWSTR ${a.traceTick}` : `VIWSLR ${a.logTick}`, l = `${c} ${d} ${n[i]} ${t1}: ${o}`;
                        if (i <= (void 0 !== this.levels[r[e]] ? this.levels[r[e]] : n.NONE) || i === n.TRACE && this.showTrace) {
                            if (void 0 !== console.debug && void 0 !== console.info && void 0 !== console.error && void 0 !== console.warn) {
                                if (this.prettyPrint) {
                                    const e = `%c${c} ${d} [${n[i]}] %c${t1}: %c${o}`, r = {
                                        [n.ERROR]: "color:#fab005",
                                        [n.WARNING]: "color:#af2a2a",
                                        [n.INFO]: "color:#0ca678",
                                        [n.TRACE]: "color:#8f66ff"
                                    };
                                    i === n.ERROR ? console.error(l) : i === n.WARNING ? console.warn(e, r[i], "color:#2375a2", "color:#000") : i === n.INFO ? console.info(e, r[i], "color:#2375a2", "color:#000") : i === n.TRACE ? console.debug(e, r[i], "color:#2375a2", "color:#000") : console.log(e, r[i], "color:#2375a2", "color:#000");
                                } else i === n.ERROR ? console.error(l) : i === n.WARNING ? console.warn(l) : i === n.INFO ? console.info(l) : i === n.TRACE ? console.debug(l) : console.log(l);
                            } else console.log(l);
                            this.isFirstPrint && (this.isFirstPrint = !1);
                        }
                        this.shadowLogging && (i !== n.TRACE || this.showTrace) && this._shadowLog.push(l), "function" != typeof this._outerCallback || i === n.TRACE && !this.showTrace || this._outerCallback({
                            formattedText: l,
                            category: e,
                            label: t1,
                            level: i,
                            message: o
                        });
                    }
                    createLogger(e, t1) {
                        return new i(e, t1, this);
                    }
                    _traceName() {
                        return "Logger";
                    }
                }
                t1.LogManager = a, a.logTick = 0, a.traceTick = 0;
            },
            164: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.LoginState = void 0, function(e) {
                    e[e.LOGGED_OFF = 0] = "LOGGED_OFF", e[e.LOGGING_IN = 1] = "LOGGING_IN", e[e.LOGGED_IN = 2] = "LOGGED_IN";
                }(t1.LoginState || (t1.LoginState = {}));
            },
            1450: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.MediaRenderDisablingReason = void 0, function(e) {
                    e.Automatic = "automatic", e.Manual = "manual";
                }(t1.MediaRenderDisablingReason || (t1.MediaRenderDisablingReason = {}));
            },
            7222: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.MediaRenderer = void 0;
                const i = n(3869), a = n(125), s = n(1150), o = n(2957), d = n(2282), c = n(141), l = n(7272), g = n(8597), u = n(6980);
                class h {
                    constructor(e){
                        this._playElemLock = 0, this._encodedStreams = [], this._enabled = !0, this.isRemoving = !1, this._receiverTransform = o.Utils.getDefaultStreamTransformer();
                        const { stream: t1, kind: n, placeOnDom: r, isLocal: d, deprecatedId: c, transceivers: g, mids: u } = e;
                        if (this.transceivers = g, this.stream = t1, this.kind = n, this.mids = u, this.placeOnDom = r || !1, this.isLocal = d || !1, void 0 === this.kind && (this.kind = t1.getVideoTracks().length ? "video" : "audio"), this._id = o.Utils.generateUUID(), this.logger = s.LogManager.get().createLogger(s.LogCategory.USERMEDIA, this._traceName()), this.stream.getTracks().forEach((e)=>{
                            e.onended = ()=>{
                                this.checkStreamActive(t1);
                            };
                        }), this.stream.getTracks().length) {
                            if (this.element = document.getElementById(this.stream.getTracks()[0].id) || document.createElement("sharing" === this.kind ? "video" : this.kind), this.element.autoplay = !0, this.isLocal && (this.element.muted = !0), this.element.setAttribute("playsinline", null), c ? document.getElementById("voximplantlocalvideo") ? this.element.id = this.stream.getTracks()[0].id : this.element.id = "voximplantlocalvideo" : this.element.id = this.stream.getTracks()[0].id, "audio" !== n) this.stream.getAudioTracks().length || (this.element.muted = !0);
                            else {
                                const e = l.default.AudioDeviceManager.get().getDefaultAudioSettings();
                                e.outputId && "function" == typeof this.element.setSinkId && this.element.setSinkId("").then(()=>{
                                    this.element.setSinkId(e.outputId + "");
                                }).catch(()=>{
                                    this.element.setSinkId(e.outputId + "");
                                });
                            }
                            i.default.attachMedia(this), this.placeOnDom && this.renderDefault();
                        }
                        a.Client.getInstance().isInsertableStreamsSupported() && this.transceivers.length && this.transceivers.forEach((e)=>{
                            const t1 = e.receiver.createEncodedStreams();
                            this._encodedStreams.push(t1);
                        });
                    }
                    checkStreamActive(e) {
                        e.getTracks().some((e)=>"live" === e.readyState) || this.clear();
                    }
                    get id() {
                        return this._id;
                    }
                    renderDefault() {
                        const e = a.Client.getInstance(), t1 = this.isLocal ? e.config().localVideoContainerId : e.config().remoteVideoContainerId, n = document.getElementById(t1);
                        this.render(n);
                    }
                    get enabled() {
                        const e = u.VideoStatusMachineMediator.retrieveVSMByMediaRenderer(this);
                        return e ? "enabled" === e.value : this._enabled;
                    }
                    enable() {
                        if (!this.transceivers.length) throw Error("Transceiver list is empty");
                        this.makeVideoStatusTransition("enable"), this._enabled = !0, this.conferenceEpManagerUpdateState && this.conferenceEpManagerUpdateState();
                    }
                    disable() {
                        if (!this.transceivers.length) throw Error("Transceiver list is empty");
                        this.makeVideoStatusTransition("disable"), this._enabled = !1, this.conferenceEpManagerUpdateState && this.conferenceEpManagerUpdateState();
                    }
                    requestVideoSize(e, t1) {
                        return this.transceivers.length ? (this.videoSize = {
                            width: e,
                            height: t1
                        }, this.conferenceEpManagerUpdateRenderSize(), Promise.resolve()) : Promise.reject();
                    }
                    render(e) {
                        if (this.logger.info(`render() id: ${this._id} to ${e ? e.tagName.toLowerCase() : "no_container"} #${e ? e.id : "no_container"} class ${e ? e.className : "no_container"}`), !(a.Client.getInstance().config() && a.Client.getInstance().config().experiments && a.Client.getInstance().config().experiments.preventRendering)) {
                            if (e && ("video" === e.tagName.toLowerCase() && "audio" !== this.kind || "audio" === e.tagName.toLowerCase() && "audio" === this.kind)) this.isElementCreated = !1, this.element = e, i.default.attachMedia(this), this.addListeners();
                            else {
                                this.isElementCreated = !0;
                                const t1 = e || document.body;
                                void 0 !== this.element.parentElement && null !== this.element.parentElement ? this.element.parentElement && this.element.parentElement.removeChild(this.element) : this.element.parentNode && this.element.parentNode && this.element.parentNode.removeChild(this.element), t1.appendChild(this.element), this.addListeners();
                            }
                        }
                    }
                    addListeners() {
                        this.element.addEventListener("canplaythrough", this.onCanplaythrough.bind(this)), this.element.addEventListener("error", (e)=>this.logger.info(`An error occurred during the loading of an ${this.kind} for ${JSON.stringify(this.mids)}: ${JSON.stringify(e)}`)), this.element.addEventListener("abort", ()=>this.logger.info(`The loading of an ${this.kind} for ${JSON.stringify(this.mids)} is aborted.`)), this.element.addEventListener("stalled", ()=>{
                            this.logger.info(`Failed to fetch data, but trying for ${this.kind} ${JSON.stringify(this.mids)}`);
                        }), this.element.addEventListener("suspend", ()=>{
                            this.logger.info(`The media ${this.kind} for ${JSON.stringify(this.mids)} was suspended.`);
                        });
                    }
                    onCanplaythrough() {
                        this.element && (this.playElement(), this.element.onpause = this.playElement);
                    }
                    replaceVideo(e) {
                        e ? (this.stream = e, this.element ? i.default.attachMedia(this) : this.logger.info("replaceVideo(): replacing video has failed: DOM element is undefined")) : this.logger.error("replaceVideo(): replacing video has failed: a mediastream is not provided");
                    }
                    makeVideoStatusTransition(e) {
                        const t1 = u.VideoStatusMachineMediator.retrieveVSMByMediaRenderer(this);
                        if (t1) {
                            const n = `${e.toUpperCase()}_VIDEO`;
                            if (!u.VideoStatusMachineMediator.makeTransition(t1, n)) {
                                const n = t1.value.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase();
                                throw Error(`Cannot ${e} the media renderer due to the one is already ${n}`);
                            }
                        }
                    }
                    clear() {
                        this.isRemoving ? this.logger.info(`MediaRendered ID: already removing ${this._id}. Ignored.`) : (this.isRemoving = !0, this.onBeforeDestroy && this.onBeforeDestroy(), this.element && (this.element.removeEventListener("canplaythrough", this.onCanplaythrough), i.default.detachMedia(this), this.isElementCreated && (this.element.id = "", void 0 !== this.element.parentElement && null !== this.element.parentElement ? this.element.parentElement && this.element.parentElement.removeChild(this.element) : this.element.parentNode && this.element.parentNode && this.element.parentNode.removeChild(this.element))), this.onDestroy && this.onDestroy());
                    }
                    setVolume(e) {
                        this.logger.info(`setVolume(${e})`), this.element && (this.element.volume = e);
                    }
                    async useAudioOutput(e) {
                        if (this.logger.info(`useAudioOutput(${e}) on MediaRenderer ${this.kind}`), "audio" === this.kind) try {
                            "function" == typeof this.element.setSinkId ? await this.element.setSinkId(e) : this.logger.warning("Set audio output is impossible. Browser doesn't support this option.");
                        } catch (e) {
                            this.logger.error(`useAudioOutput(): error has occurred on MR with kind ${this.kind} ${o.Utils.stringifyError(e)}`);
                        }
                        else this.logger.info(`useAudioOutput(): media renderer with kind ${this.kind} has been skipped. Only audio media renderers support this function`);
                    }
                    _traceName() {
                        return "MediaRenderer";
                    }
                    playElement() {
                        this.element && this.element.paused && this.element.readyState > 3 && (this.logger.info(`MediaRenderer ID:${this._id} for ${JSON.stringify(this.mids)} is trying to play`), this.element.play().catch((e)=>{
                            this.logger.warning(`Can't start playing MediaRenderer ID:${this._id}. ${e.message}`), a.Client.getInstance().dispatchEvent({
                                name: c.Events.PlaybackError,
                                element: this.element,
                                error: e
                            });
                        }));
                    }
                    pauseElement() {
                        if (0 === this._playElemLock || this._playElemLock > 10) {
                            if (this.element instanceof HTMLVideoElement) {
                                let e = this.element.pause();
                                void 0 !== e && e.catch((e)=>{});
                            } else this.element.pause();
                        } else this._playElemLock += 1, setTimeout(this.pauseElement, 400);
                    }
                    notifyAboutCreation(e, t1) {
                        t1.wasAdded ? (t1.dispatchEvent({
                            name: g.EndpointEvents.RemoteMediaAdded,
                            call: e,
                            endpoint: t1,
                            mediaRenderer: this
                        }), e.dispatchEvent({
                            name: d.CallEvents.MediaElementCreated,
                            call: e,
                            stream: this.stream,
                            element: this.element,
                            type: this.kind
                        })) : setTimeout(()=>this.notifyAboutCreation(e, t1), 400);
                    }
                    get receiverTransform() {
                        return this._receiverTransform;
                    }
                    set receiverTransform(e) {
                        this._receiverTransform = e, this._encodedStreams.forEach((e)=>{
                            e.readable.pipeThrough(this._receiverTransform).pipeTo(e.writable);
                        });
                    }
                }
                r([
                    s.LogManager.d_trace(s.LogCategory.USERMEDIA)
                ], h.prototype, "checkStreamActive", null), r([
                    s.LogManager.d_trace(s.LogCategory.USERMEDIA)
                ], h.prototype, "renderDefault", null), r([
                    s.LogManager.d_trace(s.LogCategory.USERMEDIA)
                ], h.prototype, "render", null), r([
                    s.LogManager.d_trace(s.LogCategory.USERMEDIA)
                ], h.prototype, "clear", null), r([
                    s.LogManager.d_trace(s.LogCategory.USERMEDIA)
                ], h.prototype, "setVolume", null), r([
                    s.LogManager.d_trace(s.LogCategory.USERMEDIA)
                ], h.prototype, "useAudioOutput", null), t1.MediaRenderer = h;
            },
            1316: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.MediaRenderResolver = void 0;
                const n = [
                    "video",
                    "sharing"
                ], r = [
                    "audio"
                ];
                t1.MediaRenderResolver = class {
                    static isVideoMR(e) {
                        return n.includes(e.kind);
                    }
                    static isAudioMR(e) {
                        return r.includes(e.kind);
                    }
                    static retrieveVideoMR(e) {
                        return e.find(this.isVideoMR);
                    }
                    static retrieveAudioMR(e) {
                        return e.find(this.isAudioMR);
                    }
                };
            },
            6054: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Messaging = void 0;
                const r = n(7250), i = n(311), a = n(8635);
                var s;
                !function(e) {
                    e.getInstance = function() {
                        return t1.getInstance();
                    };
                    class t1 extends r.Messenger {
                    }
                    e.Messenger = t1;
                    class n extends i.Conversation {
                    }
                    e.Conversation = n;
                    class s extends a.Message {
                    }
                    let o, d, c;
                    e.Message = s, function(e) {
                        e.UNKNOWN = "UNKNOWN", e.createConversation = "createConversation", e.editConversation = "editConversation", e.removeConversation = "removeConversation", e.joinConversation = "joinConversation", e.leaveConversation = "leaveConversation", e.getConversation = "getConversation", e.getConversations = "getConversations", e.getPublicConversations = "getPublicConversations", e.searchConversations = "searchConversations", e.removeEmptyConversation = "removeEmptyConversation", e.addParticipants = "addParticipants", e.editParticipants = "editParticipants", e.removeParticipants = "removeParticipants", e.getUser = "getUser", e.getUsers = "getUsers", e.editUser = "editUser", e.setStatus = "setStatus", e.sendMessage = "sendMessage", e.editMessage = "editMessage", e.removeMessage = "removeMessage", e.typingMessage = "typingMessage", e.isRead = "isRead", e.subscribe = "subscribe", e.unsubscribe = "unsubscribe", e.manageNotification = "manageNotification", e.getSubscriptionList = "getSubscriptionList", e.createBot = "createBot", e.removeBot = "removeBot", e.retransmitEvents = "retransmitEvents";
                    }(o = e.MessengerAction || (e.MessengerAction = {})), function(e) {
                        e.CreateConversation = "CreateConversation", e.EditConversation = "EditConversation", e.RemoveConversation = "RemoveConversation", e.GetConversation = "GetConversation", e.GetPublicConversations = "GetPublicConversations", e.SendMessage = "SendMessage", e.EditMessage = "EditMessage", e.RemoveMessage = "RemoveMessage", e.Typing = "Typing", e.EditUser = "EditUser", e.GetUser = "GetUser", e.Error = "Error", e.RetransmitEvents = "RetransmitEvents", e.Read = "Read", e.Subscribe = "Subscribe", e.Unsubscribe = "Unsubscribe", e.SetStatus = "SetStatus", e.GetSubscriptionList = "GetSubscriptionList", e.CreateBot = "CreateBot", e.RemoveBot = "RemoveBot";
                    }(d = e.MessengerEvents || (e.MessengerEvents = {})), function(e) {
                        e[e.Error_0 = 0] = "Error_0", e[e.Error_1 = 1] = "Error_1", e[e.Error_2 = 2] = "Error_2", e[e.Error_3 = 3] = "Error_3", e[e.Error_8 = 8] = "Error_8", e[e.Error_10 = 10] = "Error_10", e[e.Error_11 = 11] = "Error_11", e[e.Error_12 = 12] = "Error_12", e[e.Error_13 = 13] = "Error_13", e[e.Error_15 = 15] = "Error_15", e[e.Error_16 = 16] = "Error_16", e[e.Error_18 = 18] = "Error_18", e[e.Error_19 = 19] = "Error_19", e[e.Error_21 = 21] = "Error_21", e[e.Error_22 = 22] = "Error_22", e[e.Error_23 = 23] = "Error_23", e[e.Error_24 = 24] = "Error_24", e[e.Error_25 = 25] = "Error_25", e[e.Error_26 = 26] = "Error_26", e[e.Error_28 = 28] = "Error_28", e[e.Error_30 = 30] = "Error_30", e[e.Error_32 = 32] = "Error_32", e[e.Error_33 = 33] = "Error_33", e[e.Error_34 = 34] = "Error_34", e[e.Error_35 = 35] = "Error_35", e[e.Error_36 = 36] = "Error_36", e[e.Error_37 = 37] = "Error_37", e[e.Error_38 = 38] = "Error_38", e[e.Error_39 = 39] = "Error_39", e[e.Error_40 = 40] = "Error_40", e[e.Error_41 = 41] = "Error_41", e[e.Error_42 = 42] = "Error_42", e[e.Error_43 = 43] = "Error_43", e[e.Error_500 = 500] = "Error_500";
                    }(c = e.MessengerError || (e.MessengerError = {}));
                }(s = t1.Messaging || (t1.Messaging = {})), t1.default = s;
            },
            311: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Conversation = void 0;
                const i = n(1150), a = n(7250), s = n(1855), o = n(8635), d = n(7050), c = n(8202), l = n(6968), g = n(6054);
                class u {
                    constructor(e){
                        this._backup = {}, this._uuid = e.uuid, this._participants = e.participants, this._title = e.title, this._direct = e.direct, this._publicJoin = e.publicJoin, this._uberConversation = e.uberConversation, this._customData = e.customData, this._createdAt = e.createdAt, this._lastUpdate = e.lastUpdate, this._lastSeq = Number(e.lastSeq);
                    }
                    get uuid() {
                        return this._uuid;
                    }
                    get title() {
                        return this._title;
                    }
                    set title(e) {
                        this._backup.title = this._title, this._title = e;
                    }
                    get createdAt() {
                        return this._createdAt;
                    }
                    get lastUpdate() {
                        return this._lastUpdate;
                    }
                    get direct() {
                        return this._direct;
                    }
                    get uberConversation() {
                        return this._uberConversation;
                    }
                    get publicJoin() {
                        return this._publicJoin;
                    }
                    set publicJoin(e) {
                        this._backup.publicJoin = this._publicJoin, this._publicJoin = e;
                    }
                    get participants() {
                        return this._participants;
                    }
                    get customData() {
                        return this._customData;
                    }
                    set customData(e) {
                        this._backup.customData = this._customData, this._customData = e;
                    }
                    get lastSeq() {
                        return this._lastSeq;
                    }
                    updateSeq(e) {
                        "number" == typeof e && e > this._lastSeq && (this._lastSeq = e), this._lastUpdate = Date.now() / 1e3 | 0;
                    }
                    static _createFromBus(e, t1) {
                        return new u({
                            participants: e.participants && Array.isArray(e.participants) ? e.participants.map((e)=>{
                                const t1 = Number(e.flags) === l.MsgPermissions.all, n = Number(e.flags) > l.MsgPermissions.is_owner && e.flags < l.MsgPermissions.all, r = Number(e.flags).toString(2).slice(-6).split("").reverse();
                                return {
                                    userId: Number(e.user_id),
                                    lastRead: e.last_read,
                                    isOwner: t1 || n,
                                    canWrite: t1 || "1" === r[0],
                                    canEdit: t1 || "1" === r[1],
                                    canRemove: t1 || "1" === r[2],
                                    canManageParticipants: t1 || "1" === r[3],
                                    canEditAll: t1 || "1" === r[4],
                                    canRemoveAll: t1 || "1" === r[5]
                                };
                            }) : [],
                            title: e.title,
                            uuid: e.uuid,
                            direct: e.direct,
                            publicJoin: e.enable_public_join,
                            uberConversation: e.uber_conversation,
                            createdAt: e.created_at,
                            lastUpdate: e.last_update,
                            lastSeq: t1,
                            customData: e.custom_data && "object" == typeof e.custom_data ? e.custom_data : void 0
                        });
                    }
                    static createFromCache(e) {
                        return new u({
                            uuid: e.uuid,
                            title: e.title,
                            participants: e.participants || [],
                            direct: e.direct,
                            publicJoin: e.publicJoin,
                            uberConversation: e.uberConversation,
                            createdAt: e.createdAt,
                            lastUpdate: e.lastUpdate,
                            customData: e.customData
                        });
                    }
                    toCache() {
                        return {
                            uuid: this._uuid,
                            title: this._title,
                            participants: this._participants,
                            direct: this._direct,
                            publicJoin: this._publicJoin,
                            uberConversation: this._uberConversation,
                            createdAt: this._createdAt,
                            lastUpdate: this._lastUpdate,
                            customData: this._customData,
                            lastSeq: this._lastSeq
                        };
                    }
                    _getCreatePayload() {
                        return {
                            participants: this._prepareParticipants(this._participants).map((e)=>Object.assign(e, {
                                    flags: e.flags ? e.flags : 7
                                })),
                            title: "string" == typeof this._title ? this._title : "",
                            direct: "boolean" == typeof this._direct && this._direct,
                            enable_public_join: "boolean" == typeof this._publicJoin && this._publicJoin,
                            uber_conversation: "boolean" == typeof this._uberConversation ? this._uberConversation : void 0,
                            custom_data: "object" == typeof this._customData ? this._customData : {}
                        };
                    }
                    _getEditPayload() {
                        if (void 0 === this._uuid) throw Error("You must get conversation UUID with MessengetAction.getConversation() action!");
                        return {
                            uuid: this._uuid,
                            title: "string" == typeof this._title ? this._title : "",
                            enable_public_join: "boolean" == typeof this._publicJoin && this._publicJoin,
                            custom_data: "object" == typeof this._customData ? this._customData : {}
                        };
                    }
                    _getUserPermissions(e) {
                        const t1 = (e.isOwner ? "1000000000" : "") + [
                            e.canRemoveAll,
                            e.canEditAll,
                            e.canManageParticipants,
                            e.canRemove,
                            e.canEdit,
                            e.canWrite
                        ].map((e)=>e ? 1 : 0).join("");
                        return parseInt(t1, 2);
                    }
                    _prepareParticipants(e) {
                        return e.map((e)=>({
                                user_id: e.userId,
                                flags: this._getUserPermissions(e),
                                last_read: e.lastRead
                            }));
                    }
                    _revertChanges() {
                        Object.keys(this._backup).forEach((e)=>{
                            this[e] = this._backup[e];
                        }), this._backup = {};
                    }
                    update() {
                        return s.default.get().editConversation(this);
                    }
                    setTitle(e) {
                        return "string" != typeof e ? a.Messenger.getInstance().reject(g.default.MessengerError.Error_0, g.default.MessengerAction.editConversation) : (this._backup.title = this._title, this._title = e, s.default.get().editConversation(this));
                    }
                    setPublicJoin(e) {
                        return "boolean" != typeof e ? a.Messenger.getInstance().reject(g.default.MessengerError.Error_0, g.default.MessengerAction.editConversation) : (this._backup.publicJoin = this._publicJoin, this._publicJoin = e, s.default.get().editConversation(this));
                    }
                    setCustomData(e) {
                        return !e || Array.isArray(e) || "object" != typeof e ? a.Messenger.getInstance().reject(g.default.MessengerError.Error_0, g.default.MessengerAction.editConversation) : (this._backup.customData = this._customData, this._customData = e, s.default.get().editConversation(this));
                    }
                    addParticipants(e) {
                        return Array.isArray(e) && 0 != e.length ? new Promise((t1, n)=>{
                            const r = d.MsgSignaling.get().sendWsMessage(c.MsgAction.addParticipants, {
                                uuid: this._uuid,
                                participants: this._prepareParticipants(e)
                            });
                            a.Messenger.getInstance()._registerPromise(r, t1, n);
                        }) : a.Messenger.getInstance().reject(g.default.MessengerError.Error_0, g.default.MessengerAction.addParticipants);
                    }
                    editParticipants(e) {
                        return Array.isArray(e) && 0 != e.length ? new Promise((t1, n)=>{
                            const r = d.MsgSignaling.get().sendWsMessage(c.MsgAction.editParticipants, {
                                uuid: this._uuid,
                                participants: this._prepareParticipants(e)
                            });
                            a.Messenger.getInstance()._registerPromise(r, t1, n);
                        }) : a.Messenger.getInstance().reject(g.default.MessengerError.Error_0, g.default.MessengerAction.editParticipants);
                    }
                    removeParticipants(e) {
                        return Array.isArray(e) && 0 != e.length ? new Promise((t1, n)=>{
                            const r = d.MsgSignaling.get().sendWsMessage(c.MsgAction.removeParticipants, {
                                uuid: this._uuid,
                                participants: e.filter((e)=>void 0 !== e.userId).map((e)=>e.userId)
                            });
                            a.Messenger.getInstance()._registerPromise(r, t1, n);
                        }) : a.Messenger.getInstance().reject(g.default.MessengerError.Error_0, g.default.MessengerAction.removeParticipants);
                    }
                    sendMessage(e, t1) {
                        if ("string" != typeof e) return a.Messenger.getInstance().reject(g.default.MessengerError.Error_0, g.default.MessengerAction.sendMessage);
                        return new o.Message(e, t1).sendTo(this);
                    }
                    typing() {
                        return this._debounceLock ? Promise.resolve(!1) : (setTimeout(()=>{
                            this._debounceLock = !1;
                        }, 1e4), this._debounceLock = !0, new Promise((e, t1)=>{
                            const n = d.MsgSignaling.get().sendWsMessage(c.MsgAction.typingMessage, {
                                conversation: this._uuid
                            });
                            a.Messenger.getInstance()._registerPromise(n, e, t1);
                        }));
                    }
                    markAsRead(e) {
                        return new Promise((t1, n)=>{
                            const r = d.MsgSignaling.get().sendWsMessage(c.MsgAction.isRead, {
                                conversation: this._uuid,
                                seq: e
                            });
                            a.Messenger.getInstance()._registerPromise(r, t1, n);
                        });
                    }
                    retransmitEvents(e, t1, n) {
                        return "number" != typeof t1 || "number" != typeof e ? a.Messenger.getInstance().reject(g.default.MessengerError.Error_0, g.default.MessengerAction.retransmitEvents) : new Promise((r, i)=>{
                            let s, o, l;
                            Promise.all(Array(t1 - e + 1).fill(0).map((t1, n)=>n + e).map((e)=>new Promise((t1, n)=>{
                                    const r = (n)=>{
                                        n.events && n.events[0] && Number(n.events[0].seq) === e && n.requestUuid === s && (clearTimeout(d), a.Messenger.getInstance().off(g.default.MessengerEvents.RetransmitEvents, r), a.Messenger.getInstance().off(g.default.MessengerEvents.Error, i), o || (o = n.initiator), l || (l = n.messengerAction), t1(n.events[0]));
                                    }, i = (t1)=>{
                                        t1.messengerAction == g.default.MessengerAction.retransmitEvents && t1.events && t1.events[0] && Number(t1.events[0].seq) === e && (clearTimeout(d), a.Messenger.getInstance().off(g.default.MessengerEvents.RetransmitEvents, r), a.Messenger.getInstance().off(g.default.MessengerEvents.Error, i), n(t1));
                                    }, d = setTimeout(()=>{
                                        a.Messenger.getInstance().off(g.default.MessengerEvents.RetransmitEvents, r), a.Messenger.getInstance().off(g.default.MessengerEvents.Error, i), a.Messenger.getInstance().reject(g.default.MessengerError.Error_0, g.default.MessengerAction.retransmitEvents).catch(n);
                                    }, a.Messenger.rejectTimeout);
                                    a.Messenger.getInstance().on(g.default.MessengerEvents.RetransmitEvents, r), a.Messenger.getInstance().on(g.default.MessengerEvents.Error, i);
                                }))).then((e)=>r({
                                    initiator: o,
                                    messengerAction: l,
                                    events: e,
                                    requestUuid: s
                                })).catch(i), s = d.MsgSignaling.get().sendWsMessage(c.MsgAction.retransmitEvents, {
                                conversation: this._uuid,
                                events_from: 0 | e,
                                events_to: 0 | t1,
                                count: n
                            });
                        });
                    }
                    _traceName() {
                        return "Conversation";
                    }
                }
                r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u.prototype, "updateSeq", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u.prototype, "toCache", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u.prototype, "_getCreatePayload", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u.prototype, "_getEditPayload", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u.prototype, "_prepareParticipants", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u.prototype, "_revertChanges", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u.prototype, "update", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u.prototype, "addParticipants", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u.prototype, "editParticipants", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u.prototype, "removeParticipants", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u.prototype, "typing", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u.prototype, "markAsRead", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u.prototype, "retransmitEvents", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u, "_createFromBus", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], u, "createFromCache", null), t1.Conversation = u;
            },
            1855: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                });
                const i = n(7050), a = n(7250), s = n(311), o = n(8635), d = n(1150), c = n(6054), l = n(249), g = n(6623), u = n(8202);
                class h {
                    constructor(){
                        if (h.instance) throw new Error(g.MESSAGING_ERR_2);
                        this.signalling = i.MsgSignaling.get(), this.signalling.addEventListener(l.MsgEvent.onCreateConversation, (e, t1)=>{
                            this.resolveEvent(e, c.default.MessengerEvents.CreateConversation, t1);
                        }), this.signalling.addEventListener(l.MsgEvent.onEditConversation, (e, t1)=>{
                            this.resolveEvent(e, c.default.MessengerEvents.EditConversation, t1);
                        }), this.signalling.addEventListener(l.MsgEvent.onRemoveConversation, (e, t1)=>{
                            a.Messenger.getInstance()._dispatchEvent(c.default.MessengerEvents.RemoveConversation, {
                                uuid: e.object.uuid,
                                seq: e.seq,
                                messengerAction: c.default.MessengerAction[e.on_incoming_event],
                                initiator: Number(e.initiator),
                                timestamp: "number" == typeof e.timestamp ? 1e3 * e.timestamp : void 0,
                                requestUuid: t1
                            }, t1);
                        }), this.signalling.addEventListener(l.MsgEvent.onGetConversation, (e, t1)=>{
                            this.resolveEvent(e, c.default.MessengerEvents.GetConversation, t1);
                        }), this.signalling.addEventListener(l.MsgEvent.onGetPublicConversations, (e, t1)=>{
                            a.Messenger.getInstance()._dispatchEvent(c.default.MessengerEvents.GetPublicConversations, {
                                conversations: e.object.uuid,
                                initiator: Number(e.initiator),
                                messengerAction: c.default.MessengerAction[e.on_incoming_event],
                                requestUuid: t1
                            }, t1);
                        }), this.signalling.addEventListener(l.MsgEvent.onSendMessage, (e, t1)=>{
                            this.resolveMessageEvent(e, c.default.MessengerEvents.SendMessage, t1);
                        }), this.signalling.addEventListener(l.MsgEvent.onEditMessage, (e, t1)=>{
                            this.resolveMessageEvent(e, c.default.MessengerEvents.EditMessage, t1);
                        }), this.signalling.addEventListener(l.MsgEvent.onRemoveMessage, (e, t1)=>{
                            this.resolveMessageEvent(e, c.default.MessengerEvents.RemoveMessage, t1);
                        }), this.signalling.addEventListener(l.MsgEvent.isRead, (e, t1)=>{
                            a.Messenger.getInstance()._dispatchEvent(c.default.MessengerEvents.Read, {
                                conversation: e.object.conversation,
                                seq: e.object.seq,
                                initiator: Number(e.initiator),
                                messengerAction: c.default.MessengerAction[e.on_incoming_event],
                                requestUuid: t1
                            }, t1);
                        }), this.signalling.addEventListener(l.MsgEvent.onTyping, (e, t1)=>{
                            a.Messenger.getInstance()._dispatchEvent(c.default.MessengerEvents.Typing, {
                                conversation: e.object.conversation,
                                initiator: Number(e.initiator),
                                messengerAction: c.default.MessengerAction[e.on_incoming_event],
                                requestUuid: t1
                            }, t1);
                        }), this.signalling.addEventListener(l.MsgEvent.onRetransmitEvents, (e, t1)=>{
                            a.Messenger.getInstance()._dispatchEvent(c.default.MessengerEvents.RetransmitEvents, {
                                events: [
                                    e.object && e.object.event ? -1 == e.object.event.indexOf("Message") && e.object.payload ? {
                                        conversation: s.Conversation._createFromBus(e.object.payload.object, e.object.payload.seq),
                                        initiator: Number(e.object.payload.initiator),
                                        seq: e.object.payload.seq,
                                        messengerAction: c.default.MessengerAction[e.object.payload.on_incoming_event],
                                        timestamp: "number" == typeof e.object.payload.timestamp ? 1e3 * e.object.payload.timestamp : void 0
                                    } : {
                                        message: o.Message._createFromBus(e.object.payload.object, Number(e.object.payload.initiator)),
                                        initiator: Number(e.object.payload.initiator),
                                        seq: e.object.payload.seq,
                                        timestamp: "number" == typeof e.object.payload.timestamp ? 1e3 * e.object.payload.timestamp : void 0,
                                        messengerAction: c.default.MessengerAction[e.object.payload.on_incoming_event]
                                    } : void 0
                                ],
                                initiator: Number(e.initiator),
                                messengerAction: c.default.MessengerAction[e.on_incoming_event],
                                requestUuid: t1
                            }, t1);
                        });
                    }
                    static get() {
                        return h.instance = h.instance || new h, h.instance;
                    }
                    resolveEvent(e, t1, n) {
                        const r = s.Conversation._createFromBus(e.object, e.seq);
                        void 0 !== r && r.updateSeq(e.seq), a.Messenger.getInstance()._dispatchEvent(t1, {
                            conversation: r,
                            initiator: Number(e.initiator),
                            seq: e.seq,
                            messengerAction: c.default.MessengerAction[e.on_incoming_event],
                            timestamp: "number" == typeof e.timestamp ? 1e3 * e.timestamp : void 0,
                            requestUuid: n
                        }, n);
                    }
                    resolveMessageEvent(e, t1, n) {
                        const r = o.Message._createFromBus(e.object, Number(e.initiator));
                        a.Messenger.getInstance()._dispatchEvent(t1, {
                            message: r,
                            initiator: Number(e.initiator),
                            seq: e.seq,
                            messengerAction: c.default.MessengerAction[e.on_incoming_event],
                            timestamp: "number" == typeof e.timestamp ? 1e3 * e.timestamp : void 0
                        }, n);
                    }
                    static deserialize(e) {
                        return s.Conversation.createFromCache(e);
                    }
                    static serialize(e) {
                        return e.toCache();
                    }
                    createConversation(e, t1, n, r, i, o) {
                        return new Promise((d, c)=>{
                            const l = this.signalling.sendWsMessage(u.MsgAction.createConversation, new s.Conversation({
                                participants: e,
                                title: t1,
                                direct: n,
                                publicJoin: r,
                                customData: o,
                                uberConversation: i
                            })._getCreatePayload());
                            a.Messenger.getInstance()._registerPromise(l, d, c);
                        });
                    }
                    editConversation(e) {
                        return new Promise((t1, n)=>{
                            let r;
                            const i = (e)=>{
                                e.requestUuid === r && (clearTimeout(o), a.Messenger.getInstance().off(c.default.MessengerEvents.EditConversation, i), a.Messenger.getInstance().off(c.default.MessengerEvents.Error, s), t1(e));
                            }, s = (t1)=>{
                                t1.requestUuid === r && (clearTimeout(o), a.Messenger.getInstance().off(c.default.MessengerEvents.EditConversation, i), a.Messenger.getInstance().off(c.default.MessengerEvents.Error, s), e._revertChanges(), n(t1));
                            }, o = setTimeout(()=>{
                                a.Messenger.getInstance().off(c.default.MessengerEvents.EditConversation, i), a.Messenger.getInstance().off(c.default.MessengerEvents.Error, s), a.Messenger.getInstance().reject(c.default.MessengerError.Error_0, c.default.MessengerAction.editConversation).catch(n);
                            }, a.Messenger.rejectTimeout);
                            a.Messenger.getInstance().on(c.default.MessengerEvents.EditConversation, i), a.Messenger.getInstance().on(c.default.MessengerEvents.Error, s), r = this.signalling.sendWsMessage(u.MsgAction.editConversation, e._getEditPayload());
                        });
                    }
                    getConversation(e) {
                        return new Promise((t1, n)=>{
                            const r = this.signalling.sendWsMessage(u.MsgAction.getConversation, {
                                uuid: e
                            });
                            a.Messenger.getInstance()._registerPromise(r, t1, n);
                        });
                    }
                    getConversations(e) {
                        if (!Array.isArray(e)) return a.Messenger.getInstance().reject(c.default.MessengerError.Error_0, c.default.MessengerAction.getConversations);
                        let t1;
                        const n = Promise.all(e.map((e)=>new Promise((n, r)=>{
                                const i = (r)=>{
                                    r.requestUuid === t1 && r.conversation.uuid === e && (clearTimeout(o), a.Messenger.getInstance().off(c.default.MessengerEvents.GetConversation, i), a.Messenger.getInstance().off(c.default.MessengerEvents.Error, s), n(r));
                                }, s = (e)=>{
                                    e.requestUuid === t1 && (clearTimeout(o), a.Messenger.getInstance().off(c.default.MessengerEvents.GetConversation, i), a.Messenger.getInstance().off(c.default.MessengerEvents.Error, s), r(e));
                                }, o = setTimeout(()=>{
                                    a.Messenger.getInstance().off(c.default.MessengerEvents.GetConversation, i), a.Messenger.getInstance().off(c.default.MessengerEvents.Error, s), a.Messenger.getInstance().reject(c.default.MessengerError.Error_0, c.default.MessengerAction.getConversation).catch(r);
                                }, a.Messenger.rejectTimeout);
                                a.Messenger.getInstance().on(c.default.MessengerEvents.GetConversation, i), a.Messenger.getInstance().on(c.default.MessengerEvents.Error, s);
                            })));
                        return t1 = this.signalling.sendWsMessage(u.MsgAction.getConversations, {
                            uuid: e
                        }), n;
                    }
                    getPublicConversations() {
                        return new Promise((e, t1)=>{
                            const n = this.signalling.sendWsMessage(u.MsgAction.getPublicConversations, {});
                            a.Messenger.getInstance()._registerPromise(n, e, t1);
                        });
                    }
                    static extractUserName(e) {
                        if (-1 === e.indexOf("@")) return e;
                        {
                            const t1 = e.split("@");
                            return t1[1] = t1[1].split(".").splice(0, 2).join("."), t1.join("@");
                        }
                    }
                    _traceName() {
                        return "ConversationManager";
                    }
                }
                r([
                    d.LogManager.d_trace(d.LogCategory.MESSAGING)
                ], h.prototype, "resolveEvent", null), r([
                    d.LogManager.d_trace(d.LogCategory.MESSAGING)
                ], h.prototype, "resolveMessageEvent", null), r([
                    d.LogManager.d_trace(d.LogCategory.MESSAGING)
                ], h.prototype, "createConversation", null), r([
                    d.LogManager.d_trace(d.LogCategory.MESSAGING)
                ], h.prototype, "editConversation", null), r([
                    d.LogManager.d_trace(d.LogCategory.MESSAGING)
                ], h.prototype, "getConversation", null), r([
                    d.LogManager.d_trace(d.LogCategory.MESSAGING)
                ], h.prototype, "getConversations", null), r([
                    d.LogManager.d_trace(d.LogCategory.MESSAGING)
                ], h.prototype, "getPublicConversations", null), r([
                    d.LogManager.d_trace(d.LogCategory.MESSAGING)
                ], h, "get", null), r([
                    d.LogManager.d_trace(d.LogCategory.MESSAGING)
                ], h, "deserialize", null), r([
                    d.LogManager.d_trace(d.LogCategory.MESSAGING)
                ], h, "serialize", null), r([
                    d.LogManager.d_trace(d.LogCategory.MESSAGING)
                ], h, "extractUserName", null), t1.default = h;
            },
            8635: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Message = void 0;
                const i = n(1150), a = n(7050), s = n(8202), o = n(7250);
                class d {
                    constructor(e, t1){
                        this._text = e, void 0 !== t1 && Array.isArray(t1) && t1.every((e)=>e && "object" == typeof e) ? this._payload = t1 : this._payload = [];
                    }
                    get uuid() {
                        return this._uuid;
                    }
                    get conversation() {
                        return this._conversation;
                    }
                    get text() {
                        return this._text;
                    }
                    set text(e) {
                        this._text = e;
                    }
                    get payload() {
                        return this._payload;
                    }
                    set payload(e) {
                        this._payload = e;
                    }
                    get sender() {
                        return this._sender;
                    }
                    static _createFromBus(e, t1) {
                        let n = new d(e.text, e.payload);
                        return n._uuid = e.uuid, n._conversation = e.conversation, n._sender = t1, n;
                    }
                    static createFromCache(e) {
                        let t1 = new d(e.text, e.payload);
                        return t1._uuid = e.uuid, t1._conversation = e.conversation, t1._sender = Number(e.sender), t1;
                    }
                    toCache() {
                        return {
                            uuid: this._uuid,
                            text: this._text,
                            payload: this._payload,
                            conversation: this._conversation,
                            sender: this._sender
                        };
                    }
                    getPayload() {
                        let e = {
                            text: this._text,
                            conversation: this._conversation
                        };
                        return void 0 !== this._payload && Array.isArray(this._payload) && this._payload.every((e)=>"object" == typeof e) ? e.payload = this._payload : e.payload = [], e;
                    }
                    sendTo(e) {
                        return this._conversation = e.uuid, new Promise((e, t1)=>{
                            const n = a.MsgSignaling.get().sendWsMessage(s.MsgAction.sendMessage, this.getPayload());
                            o.Messenger.getInstance()._registerPromise(n, e, t1);
                        });
                    }
                    update() {
                        return new Promise((e, t1)=>{
                            const n = a.MsgSignaling.get().sendWsMessage(s.MsgAction.editMessage, Object.assign(this.getPayload(), {
                                uuid: this._uuid
                            }));
                            o.Messenger.getInstance()._registerPromise(n, e, t1);
                        });
                    }
                    remove() {
                        return new Promise((e, t1)=>{
                            const n = a.MsgSignaling.get().sendWsMessage(s.MsgAction.removeMessage, {
                                uuid: this._uuid,
                                conversation: this.conversation
                            });
                            o.Messenger.getInstance()._registerPromise(n, e, t1);
                        });
                    }
                    _traceName() {
                        return "Message";
                    }
                }
                r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], d.prototype, "toCache", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], d.prototype, "getPayload", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], d.prototype, "sendTo", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], d.prototype, "update", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], d.prototype, "remove", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], d, "_createFromBus", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], d, "createFromCache", null), t1.Message = d;
            },
            7250: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Messenger = void 0;
                const i = n(1150), a = n(7050), s = n(249), o = n(1855), d = n(311), c = n(8635), l = n(6054), g = n(3947), u = n(6623), h = n(8202), p = {
                    0: "Something went wrong. Please check your input or required parameters."
                };
                class f {
                    constructor(){
                        if (f.instance) throw new Error(u.MESSAGING_ERR_1);
                        this.eventListeners = {}, this.awaitPromiseList = {}, this.cm = o.default.get(), this.signalling = a.MsgSignaling.get(), this.signalling.addEventListener(s.MsgEvent.onError, (e, t1)=>{
                            this._dispatchEvent(l.default.MessengerEvents.Error, {
                                initiator: this.currentUserId,
                                code: e.code,
                                description: e.description,
                                messengerAction: l.default.MessengerAction[e.on_incoming_event],
                                timestamp: "number" == typeof e.timestamp ? 1e3 * e.timestamp : void 0,
                                requestUuid: t1
                            }, t1);
                        }), this.signalling.addEventListener(s.MsgEvent.onEditUser, (e, t1)=>{
                            this._dispatchEvent(l.default.MessengerEvents.EditUser, {
                                user: {
                                    userId: Number(e.object.user_id),
                                    userName: e.object.user_name,
                                    displayName: e.object.display_name,
                                    conversationsList: e.object.conversations_list,
                                    notificationEvents: e.object.notification_events ? e.object.notification_events.map(this.msgEventToMessengerEvent) : void 0,
                                    customData: e.object.custom_data,
                                    privateCustomData: e.object.private_custom_data
                                },
                                initiator: Number(e.initiator),
                                messengerAction: l.default.MessengerAction[e.on_incoming_event],
                                timestamp: "number" == typeof e.timestamp ? 1e3 * e.timestamp : void 0,
                                requestUuid: t1
                            }, t1);
                        }), this.signalling.addEventListener(s.MsgEvent.onGetUser, (e, t1)=>{
                            this._dispatchEvent(l.default.MessengerEvents.GetUser, {
                                user: {
                                    userId: Number(e.object.user_id),
                                    userName: e.object.user_name,
                                    displayName: e.object.display_name,
                                    conversationsList: e.object.conversations_list,
                                    notificationEvents: e.object.notification_events ? e.object.notification_events.map(this.msgEventToMessengerEvent) : void 0,
                                    customData: e.object.custom_data,
                                    privateCustomData: e.object.private_custom_data
                                },
                                initiator: Number(e.initiator),
                                messengerAction: l.default.MessengerAction[e.on_incoming_event],
                                requestUuid: t1
                            }, t1);
                        }), this.signalling.addEventListener(s.MsgEvent.onSetStatus, (e, t1)=>{
                            this._dispatchEvent(l.default.MessengerEvents.SetStatus, {
                                online: e.object.online,
                                initiator: Number(e.initiator),
                                messengerAction: l.default.MessengerAction[e.on_incoming_event],
                                timestamp: "number" == typeof e.timestamp ? 1e3 * e.timestamp : void 0,
                                requestUuid: t1
                            }, t1);
                        }), this.signalling.addEventListener(s.MsgEvent.onSubscribe, (e, t1)=>{
                            this._dispatchEvent(l.default.MessengerEvents.Subscribe, {
                                users: e.object.user_id,
                                initiator: Number(e.initiator),
                                messengerAction: l.default.MessengerAction[e.on_incoming_event],
                                requestUuid: t1
                            }, t1);
                        }), this.signalling.addEventListener(s.MsgEvent.onUnsubscribe, (e, t1)=>{
                            this._dispatchEvent(l.default.MessengerEvents.Unsubscribe, {
                                users: e.object.user_id,
                                initiator: Number(e.initiator),
                                messengerAction: l.default.MessengerAction[e.on_incoming_event],
                                requestUuid: t1
                            }, t1);
                        }), this.signalling.addEventListener(s.MsgEvent.onGetSubscriptionList, (e, t1)=>{
                            this._dispatchEvent(l.default.MessengerEvents.GetSubscriptionList, {
                                users: e.object.subscriptions,
                                initiator: Number(e.initiator),
                                messengerAction: l.default.MessengerAction[e.on_incoming_event],
                                requestUuid: t1
                            }, t1);
                        });
                    }
                    static getInstance() {
                        return f.instance = f.instance || new f, f.instance;
                    }
                    addEventListener(e, t1) {
                        void 0 === this.eventListeners[e] && (this.eventListeners[e] = []), this.eventListeners[e].push(t1);
                    }
                    removeEventListener(e, t1) {
                        if (void 0 !== this.eventListeners[e]) {
                            if ("function" == typeof t1) {
                                for(let n = 0; n < this.eventListeners[e].length; n++)if (this.eventListeners[e][n] === t1) {
                                    this.eventListeners[e].splice(n, 1);
                                    break;
                                }
                            } else this.eventListeners[e] = [];
                        }
                    }
                    on(e, t1) {
                        this.addEventListener(e, t1);
                    }
                    off(e, t1) {
                        this.removeEventListener(e, t1);
                    }
                    _dispatchEvent(e, t1, n) {
                        void 0 !== this.eventListeners[e] && this.eventListeners[e].forEach((e)=>{
                            "function" == typeof e && e(t1);
                        }), n && void 0 !== this.awaitPromiseList[n] && (e === l.default.MessengerEvents.Error && "function" == typeof this.awaitPromiseList[n].reject && this.awaitPromiseList[n].reject(t1), "function" == typeof this.awaitPromiseList[n].resolve && this.awaitPromiseList[n].resolve(t1), window.clearTimeout(this.awaitPromiseList[n].expire)), void 0 !== this.eventListeners[e] && 0 != this.eventListeners[e].length || i.LogManager.get().writeMessage(i.LogCategory.MESSAGING, "", i.LogLevel.INFO, `The ${e} event dispatched, but no handler registered for this event type.`);
                    }
                    _registerPromise(e, t1, n) {
                        this.awaitPromiseList[e] = {
                            resolve: t1,
                            reject: n,
                            expire: window.setTimeout(n, f.rejectTimeout)
                        };
                    }
                    getConversation(e) {
                        return this.cm.getConversation(e);
                    }
                    getConversations(e) {
                        if (!(Array.isArray(e) && e.length > 30)) return this.cm.getConversations(e);
                        i.LogManager.get().writeMessage(i.LogCategory.MESSAGING, "Rate limit", i.LogLevel.ERROR, "you can get maximum 30 conversation in a single getConversations call");
                    }
                    getPublicConversations() {
                        return this.cm.getPublicConversations();
                    }
                    getRawConversations(e) {
                        return this.cm.getConversations(e);
                    }
                    createConversation(e, t1, n, r, i, a) {
                        return this.cm.createConversation(e, t1, n, r, i, a);
                    }
                    createConversationFromCache(e) {
                        return e && "object" == typeof e ? d.Conversation.createFromCache(e) : null;
                    }
                    joinConversation(e) {
                        return new Promise((t1, n)=>{
                            const r = this.signalling.sendWsMessage(h.MsgAction.joinConversation, {
                                uuid: e
                            });
                            f.getInstance()._registerPromise(r, t1, n);
                        });
                    }
                    leaveConversation(e) {
                        return new Promise((t1, n)=>{
                            const r = this.signalling.sendWsMessage(h.MsgAction.leaveConversation, {
                                uuid: e
                            });
                            f.getInstance()._registerPromise(r, t1, n);
                        });
                    }
                    getMe() {
                        return o.default.extractUserName(g.Authenticator.get().username());
                    }
                    getMyId() {
                        return this.currentUserId ? Promise.resolve(this.currentUserId) : this.getUser(this.getMe()).then((e)=>e.user.userId);
                    }
                    getUser(e) {
                        return new Promise((t1, n)=>{
                            let r;
                            const i = (e)=>{
                                e.requestUuid === r && (clearTimeout(s), this.off(l.default.MessengerEvents.GetUser, i), this.off(l.default.MessengerEvents.Error, a), e.user.userName === this.getMe() && (this.currentUserId = Number(e.user.userId)), t1(e));
                            }, a = (e)=>{
                                e.requestUuid === r && (clearTimeout(s), this.off(l.default.MessengerEvents.GetUser, i), this.off(l.default.MessengerEvents.Error, a), n(e));
                            }, s = setTimeout(()=>{
                                f.getInstance().off(l.default.MessengerEvents.GetUser, i), f.getInstance().off(l.default.MessengerEvents.Error, a), f.getInstance().reject(l.default.MessengerError.Error_0, l.default.MessengerAction.getUser).catch(n);
                            }, f.rejectTimeout);
                            this.on(l.default.MessengerEvents.GetUser, i), this.on(l.default.MessengerEvents.Error, a), r = this.signalling.sendWsMessage(h.MsgAction.getUser, {
                                user_name: e
                            });
                        });
                    }
                    getUserById(e) {
                        return new Promise((t1, n)=>{
                            const r = this.signalling.sendWsMessage(h.MsgAction.getUser, {
                                user_id: e
                            });
                            f.getInstance()._registerPromise(r, t1, n);
                        });
                    }
                    getUsers(e) {
                        if (!Array.isArray(e)) return f.getInstance().reject(l.default.MessengerError.Error_0, l.default.MessengerAction.getUsers);
                        let t1;
                        const n = Promise.all(e.map((e)=>new Promise((n, r)=>{
                                const i = (r)=>{
                                    r.requestUuid === t1 && r.user.userName === e && (clearTimeout(s), f.getInstance().off(l.default.MessengerEvents.GetUser, i), f.getInstance().off(l.default.MessengerEvents.Error, a), n(r));
                                }, a = (e)=>{
                                    e.requestUuid === t1 && (clearTimeout(s), f.getInstance().off(l.default.MessengerEvents.GetUser, i), f.getInstance().off(l.default.MessengerEvents.Error, a), r(e));
                                }, s = setTimeout(()=>{
                                    f.getInstance().off(l.default.MessengerEvents.GetUser, i), f.getInstance().off(l.default.MessengerEvents.Error, a), f.getInstance().reject(l.default.MessengerError.Error_0, l.default.MessengerAction.getUsers).catch(r);
                                }, f.rejectTimeout);
                                f.getInstance().on(l.default.MessengerEvents.GetUser, i), f.getInstance().on(l.default.MessengerEvents.Error, a);
                            })));
                        return t1 = this.signalling.sendWsMessage(h.MsgAction.getUsers, {
                            users: e.map((e)=>({
                                    user_name: e
                                }))
                        }), n;
                    }
                    getUsersById(e) {
                        if (!Array.isArray(e)) return f.getInstance().reject(l.default.MessengerError.Error_0, l.default.MessengerAction.getUsers);
                        let t1;
                        const n = Promise.all(e.map((e)=>new Promise((n, r)=>{
                                const i = (r)=>{
                                    r.requestUuid === t1 && r.user.userId === e && (clearTimeout(s), f.getInstance().off(l.default.MessengerEvents.GetUser, i), f.getInstance().off(l.default.MessengerEvents.Error, a), n(r));
                                }, a = (e)=>{
                                    e.requestUuid === t1 && (clearTimeout(s), f.getInstance().off(l.default.MessengerEvents.GetUser, i), f.getInstance().off(l.default.MessengerEvents.Error, a), r(e));
                                }, s = setTimeout(()=>{
                                    f.getInstance().off(l.default.MessengerEvents.GetUser, i), f.getInstance().off(l.default.MessengerEvents.Error, a), f.getInstance().reject(l.default.MessengerError.Error_0, l.default.MessengerAction.getUsers).catch(r);
                                }, f.rejectTimeout);
                                f.getInstance().on(l.default.MessengerEvents.GetUser, i), f.getInstance().on(l.default.MessengerEvents.Error, a);
                            })));
                        return t1 = this.signalling.sendWsMessage(h.MsgAction.getUsers, {
                            users: e.map((e)=>({
                                    user_id: e
                                }))
                        }), n;
                    }
                    editUser(e, t1) {
                        let n = {};
                        return e && (n.custom_data = e), t1 && (n.private_custom_data = t1), new Promise((e, t1)=>{
                            const r = this.signalling.sendWsMessage(h.MsgAction.editUser, n);
                            f.getInstance()._registerPromise(r, e, t1);
                        });
                    }
                    setStatus(e) {
                        return new Promise((t1, n)=>{
                            const r = this.signalling.sendWsMessage(h.MsgAction.setStatus, {
                                online: e
                            });
                            f.getInstance()._registerPromise(r, t1, n);
                        });
                    }
                    subscribe(e) {
                        return new Promise((t1, n)=>{
                            const r = this.signalling.sendWsMessage(h.MsgAction.subscribe, {
                                user_id: e
                            });
                            f.getInstance()._registerPromise(r, t1, n);
                        });
                    }
                    unsubscribe(e, t1) {
                        return new Promise((n, r)=>{
                            const i = this.signalling.sendWsMessage(h.MsgAction.unsubscribe, {
                                user_id: e,
                                all: t1
                            });
                            f.getInstance()._registerPromise(i, n, r);
                        });
                    }
                    getSubscriptionList() {
                        return new Promise((e, t1)=>{
                            const n = this.signalling.sendWsMessage(h.MsgAction.getSubscriptionList, {});
                            f.getInstance()._registerPromise(n, e, t1);
                        });
                    }
                    manageNotification(e) {
                        return new Promise((t1, n)=>{
                            const r = this.signalling.sendWsMessage(h.MsgAction.manageNotification, {
                                notifications: e.map((e)=>e === l.default.MessengerEvents.CreateConversation ? s.MsgEvent.onCreateConversation : e === l.default.MessengerEvents.SendMessage ? s.MsgEvent.onSendMessage : e === l.default.MessengerEvents.EditMessage ? s.MsgEvent.onEditMessage : void 0)
                            });
                            f.getInstance()._registerPromise(r, t1, n);
                        });
                    }
                    createMessageFromCache(e) {
                        return e && "object" == typeof e ? c.Message.createFromCache(e) : null;
                    }
                    reject(e, t1) {
                        const n = {
                            code: e,
                            description: p[e],
                            initiator: this.currentUserId,
                            messengerAction: t1
                        };
                        return this._dispatchEvent(l.default.MessengerEvents.Error, n), Promise.reject(n);
                    }
                    msgEventToMessengerEvent(e) {
                        return e === s.MsgEvent.onCreateConversation ? l.default.MessengerEvents.CreateConversation : e === s.MsgEvent.onSendMessage ? l.default.MessengerEvents.SendMessage : e === s.MsgEvent.onEditMessage ? l.default.MessengerEvents.EditMessage : e;
                    }
                    _traceName() {
                        return "Messenger";
                    }
                }
                f.rejectTimeout = 2e4, r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "addEventListener", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "removeEventListener", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "on", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "off", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "_dispatchEvent", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "_registerPromise", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "getConversation", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "getConversations", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "getPublicConversations", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "getRawConversations", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "createConversation", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "createConversationFromCache", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "joinConversation", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "leaveConversation", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "getMe", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "getMyId", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "getUser", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "getUserById", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "getUsers", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "getUsersById", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "editUser", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "setStatus", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "subscribe", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "unsubscribe", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "getSubscriptionList", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "manageNotification", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f.prototype, "createMessageFromCache", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], f, "getInstance", null), t1.Messenger = f;
            },
            6623: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.MESSAGING_ERR_2 = t1.MESSAGING_ERR_1 = void 0, t1.MESSAGING_ERR_1 = "Error - use Client.getIM()", t1.MESSAGING_ERR_2 = "Error - use ConversationManager.get()";
            },
            6968: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.MsgPermissions = t1.MsgService = void 0;
                n(249);
                !function(e) {
                    e[e.Chat = "chat"] = "Chat";
                }(t1.MsgService || (t1.MsgService = {})), function(e) {
                    e[e.none = 0] = "none", e[e.can_write = 1] = "can_write", e[e.can_edit = 2] = "can_edit", e[e.can_remove = 4] = "can_remove", e[e.can_manage_participants = 8] = "can_manage_participants", e[e.can_edit_all = 16] = "can_edit_all", e[e.can_remove_all = 32] = "can_remove_all", e[e.is_owner = 32768] = "is_owner", e[e.all = 65535] = "all";
                }(t1.MsgPermissions || (t1.MsgPermissions = {}));
            },
            84: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.PCFactory = void 0;
                const i = n(6746), a = n(1150), s = n(308), o = n(4610), d = n(3869), c = n(4106), l = n(575), g = n(125), u = n(7272), h = n(8879), p = n(245), f = n(3902);
                class m {
                    constructor(){
                        this.iceConfig = null, this._peerConnections = {}, this.waitingPeerConnections = {}, this.logger = a.LogManager.get().createLogger(a.LogCategory.RTC, this._traceName()), this._requireMedia = !0, "firefox" === d.default.getWSVendor() && (m.hasTransceivers = !0), p.default.setRPCHandler(l.RemoteEvent.createPC, (e, t1)=>{
                            this.rpcHandlerCreatePC(e, t1);
                        }), p.default.setRPCHandler(l.RemoteEvent.destroyPC, (e)=>{
                            this.rpcHandlerDestroyPC(e);
                        }), p.default.addHandler(this);
                    }
                    get peerConnections() {
                        return this._peerConnections;
                    }
                    get requireMedia() {
                        return this._requireMedia;
                    }
                    set requireMedia(e) {
                        this._requireMedia = e;
                    }
                    static get() {
                        return null === this.inst && (this.inst = new m), this.inst;
                    }
                    static sdpOffersVideo(e) {
                        return {
                            receiveVideo: -1 !== e.indexOf("m=video"),
                            sendVideo: !0
                        };
                    }
                    setupDirectPC(e, t1, n, r) {
                        let i = new f.TransreceiverPC(e, t1, n);
                        const a = s.CallManager.get().calls[e];
                        if (i) {
                            i.setHoldKey(r);
                            g.Client.getInstance().config();
                            return u.default.StreamManager.get().getCallStream(a).then((t1)=>(null !== t1 && i.fastAddCustomMedia(t1), this._peerConnections[e] = i, i.getLocalOffer()));
                        }
                        s.CallManager.get().handleConnectionFailed(a.id(), 1001, "", {});
                    }
                    incomeDirectPC(e, t1, n, r, a) {
                        let o = new f.TransreceiverPC(e, i.PeerConnectionMode.P2P, t1, a);
                        return o.setHoldKey(r), o._setRemoteDescription(n).then(()=>{
                            if (s.CallManager.get().calls[e]) return this._peerConnections[e] = o, o;
                            o.close();
                        });
                    }
                    getPeerConnect(e) {
                        return this._peerConnections[e];
                    }
                    onSignalingConnected() {}
                    onSignalingClosed() {
                        this.logger.info("Closing all peer connections because signaling connection has closed"), this.waitingPeerConnections = {};
                        for(let e in this._peerConnections)this._peerConnections[e].close();
                        this._peerConnections = {};
                    }
                    onSignalingConnectionFailed(e) {}
                    onMediaConnectionFailed() {}
                    closeAll() {
                        for(let e in this._peerConnections)this._peerConnections[e].close();
                        this._peerConnections = {};
                    }
                    setBandwidthParams(e) {
                        this._bandwidthParams = e;
                    }
                    addBandwidthParams(e) {
                        return this._bandwidthParams && (e.sdp = e.sdp.replace(/(a=mid:video.*\r\n)/g, "$1b=AS:" + this._bandwidthParams + "\r\n")), e;
                    }
                    rpcHandlerCreatePC(e, t1) {
                        this.logger.info(`rpcHandlerCreatePC(), received SDP: \n${t1.replace("<br>", "\n\r")}`), t1 = h.SDPMuggle.addSetupAttribute(t1);
                        const n = m.sdpOffersVideo(t1), r = i.PeerConnectionMode.CLIENT_SERVER_V1;
                        p.default.callRemoteFunction(c.RemoteFunction.muteLocal, e, !1);
                        const a = new f.TransreceiverPC(e, r, n);
                        this._peerConnections[e] = a;
                        let d = s.CallManager.get().calls[e];
                        u.default.StreamManager.get().getCallStream(d).then((n)=>{
                            "__default" === e && (t1 = t1.replace("a=sendrecv", "a=recvonly")), a.fastAddCustomMedia(n), a.processRemoteOffer(t1).then((t1)=>{
                                void 0 === d || d.checkCallMode(o.CallMode.SERVER) ? p.default.callRemoteFunction(c.RemoteFunction.confirmPC, e, t1) : p.default.callRemoteFunction(c.RemoteFunction.acceptCall, [
                                    e,
                                    s.CallManager.cleanHeaders(d.headers()),
                                    t1
                                ]), "__default" !== e && void 0 !== s.CallManager.get().calls[e] && (s.CallManager.get().calls[e].peerConnection = a);
                            });
                        }).catch((e)=>{
                            void 0 !== d ? s.CallManager.get().handleConnectionFailed(d.id(), 403, "Media access denied", {}) : p.default.onConnectionFailedRPC();
                        });
                    }
                    rpcHandlerDestroyPC(e) {
                        this._peerConnections[e] && ("__default" === e ? setTimeout(()=>{
                            this._peerConnections[e].close(), delete this._peerConnections[e];
                        }, 200) : (this._peerConnections[e].close(), delete this._peerConnections[e])), delete this.waitingPeerConnections[e];
                    }
                    _traceName() {
                        return "PCFactory";
                    }
                }
                m.inst = null, m.hasTransceivers = !1, r([
                    a.LogManager.d_trace(a.LogCategory.PCFACTORY)
                ], m.prototype, "setupDirectPC", null), r([
                    a.LogManager.d_trace(a.LogCategory.PCFACTORY)
                ], m.prototype, "incomeDirectPC", null), r([
                    a.LogManager.d_trace(a.LogCategory.PCFACTORY)
                ], m.prototype, "getPeerConnect", null), r([
                    a.LogManager.d_trace(a.LogCategory.PCFACTORY)
                ], m.prototype, "onSignalingConnected", null), r([
                    a.LogManager.d_trace(a.LogCategory.PCFACTORY)
                ], m.prototype, "onSignalingClosed", null), r([
                    a.LogManager.d_trace(a.LogCategory.PCFACTORY)
                ], m.prototype, "onSignalingConnectionFailed", null), r([
                    a.LogManager.d_trace(a.LogCategory.PCFACTORY)
                ], m.prototype, "onMediaConnectionFailed", null), r([
                    a.LogManager.d_trace(a.LogCategory.PCFACTORY)
                ], m.prototype, "closeAll", null), r([
                    a.LogManager.d_trace(a.LogCategory.PCFACTORY)
                ], m.prototype, "setBandwidthParams", null), r([
                    a.LogManager.d_trace(a.LogCategory.PCFACTORY)
                ], m.prototype, "addBandwidthParams", null), r([
                    a.LogManager.d_trace(a.LogCategory.PCFACTORY)
                ], m.prototype, "rpcHandlerCreatePC", null), r([
                    a.LogManager.d_trace(a.LogCategory.PCFACTORY)
                ], m.prototype, "rpcHandlerDestroyPC", null), r([
                    a.LogManager.d_trace(a.LogCategory.PCFACTORY)
                ], m, "sdpOffersVideo", null), t1.PCFactory = m;
            },
            6746: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.PeerConnection = t1.PeerConnectionMode = t1.PeerConnectionState = void 0;
                const i = n(1150), a = n(308), s = n(3385), o = n(4106), d = n(4265), c = n(125), l = n(7272), g = n(8707), u = n(4610), h = n(245), p = n(2282);
                var f, m;
                !function(e) {
                    e[e.IDLE = 0] = "IDLE", e[e.REMOTEOFFER = 1] = "REMOTEOFFER", e[e.LOCALOFFER = 2] = "LOCALOFFER", e[e.ESTABLISHING = 3] = "ESTABLISHING", e[e.ESTABLISHED = 4] = "ESTABLISHED", e[e.CLOSED = 5] = "CLOSED";
                }(f = t1.PeerConnectionState || (t1.PeerConnectionState = {})), function(e) {
                    e[e.CLIENT_SERVER_V1 = 0] = "CLIENT_SERVER_V1", e[e.P2P = 1] = "P2P", e[e.CONFERENCE = 2] = "CONFERENCE";
                }(m = t1.PeerConnectionMode || (t1.PeerConnectionMode = {}));
                class v {
                    constructor(e, t1, n){
                        this.id = e, this.mode = t1, this.videoEnabled = n, this.onHold = !1, this.muteMicState = !1, this.SEND_CANDIDATE_DELAY = 1e3, this.mediaRepository = [], this.candidateList = [], this.localCandidateTimer = -1, this.logger = i.LogManager.get().createLogger(i.LogCategory.RTC, `${this._traceName()} ${e}`), this.logger.info("PC created"), this.state = f.IDLE, this.pendingCandidates = [], "_default" !== e && a.CallManager.get().calls[e] && (this.reInviteQ = new d.ReInviteQ(a.CallManager.get().calls[e], this._canReInvite));
                    }
                    get remoteStreams() {
                        return this._remoteStreams;
                    }
                    getId() {
                        return this.id;
                    }
                    getState() {
                        return this.state;
                    }
                    processRemoteAnswer(e, t1) {
                        return this.state = f.ESTABLISHING, this._processRemoteAnswer(e, t1);
                    }
                    getLocalOffer() {
                        return this.state === f.IDLE || this.state === f.ESTABLISHED || f.LOCALOFFER ? (this.logger.info("getLocalOffer()"), this.state = f.LOCALOFFER, this._getLocalOffer()) : (this.logger.error("getLocalOffer() in state " + f[this.state]), new Promise((e, t1)=>{
                            t1("Invalid state");
                        }));
                    }
                    getLocalAnswer() {
                        return this._getLocalAnswer();
                    }
                    processRemoteOffer(e) {
                        return this.state === f.IDLE || this.state === f.ESTABLISHED ? (this.state = f.ESTABLISHING, this._processRemoteOffer(e)) : (this.logger.error("processRemoteOffer() in state " + f[this.state]), new Promise((e, t1)=>{
                            t1("Invalid state");
                        }));
                    }
                    close() {
                        this.logger.info("close()"), this._close();
                    }
                    addRemoteCandidate(e, t1) {
                        return this.logger.info(`addRemoteCandidate(${e}, ${t1})`), this._addRemoteCandidate(e, t1);
                    }
                    handleReinvite(e, t1, n) {
                        return this._handleReinvite(e, t1, n);
                    }
                    handleRemoteOffer(e, t1, n) {
                        return this._handleRemoteOffer(e, t1, n);
                    }
                    addCandidateToSend(e, t1) {
                        this.pendingCandidates.push([
                            t1,
                            e
                        ]), this.canSendCandidates && this.startCandidateSendTimer();
                    }
                    canStartSendingCandidates() {
                        this.canSendCandidates = !0, this.startCandidateSendTimer();
                    }
                    sendDTMF(e) {
                        this._sendDTMF(e, 500, 50);
                    }
                    setVideoEnabled(e) {
                        const t1 = this.videoEnabled.receiveVideo;
                        this.videoEnabled = e, t1 != e.receiveVideo && this._hold(this.onHold);
                    }
                    setVideoFlags(e) {
                        this.videoEnabled = e;
                    }
                    getDirections() {
                        return this._getDirections();
                    }
                    setHoldKey(e) {
                        this.onHold = e;
                    }
                    getMidKinds() {
                        if (this._call) {
                            const e = {}, t1 = this.getTransceivers(), n = l.default.StreamManager.get()._getScreenSharing(this._call) || [];
                            let r = [];
                            return n.forEach((e)=>{
                                r = [
                                    ...r,
                                    ...e.stream.getTracks().map((e)=>e.id)
                                ];
                            }), t1.forEach((t1)=>{
                                t1.sender && t1.sender.track && t1.sender.track.kind && ("video" === t1.sender.track.kind && r.length && ~r.indexOf(t1.sender.track.id) ? e[t1.mid] = "sharing" : e[t1.mid] = t1.sender.track.kind);
                            }), e;
                        }
                        return {};
                    }
                    getTrackKind(e) {
                        if (this._call) {
                            const t1 = l.default.StreamManager.get()._getTracksKind(this._call), n = this.getTransceivers(), r = g.default.parse(e);
                            let i = [];
                            for(const e in t1)if (t1.hasOwnProperty(e)) {
                                const t1 = n.find((t1)=>!(t1.stopped || "stopped" === t1.direction || "stopped" === t1.currentDirection) && t1.sender && t1.sender.track && t1.sender.track.id === e);
                                if (t1) {
                                    const n = r.media.find((e)=>e.attr.some((e)=>"mid" === e.name && e.value === t1.mid));
                                    if (n) {
                                        const t1 = n.attr.find((e)=>"msid" === e.name);
                                        if (t1) {
                                            const n = t1.value.split(" ");
                                            if (n.length > 1) {
                                                const t1 = n[1];
                                                t1 != e && i.push({
                                                    from: e,
                                                    to: t1
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                            let a = Object.assign({}, t1);
                            return i.forEach((e)=>{
                                const t1 = a[e.from];
                                delete a[e.from], a[e.to] = t1;
                            }), a;
                        }
                        return {};
                    }
                    sendMedia(e, t1) {
                        return new Promise((e, t1)=>{
                            this.onHold ? t1({
                                result: !1,
                                call: this._call
                            }) : this.reInviteQ.add({
                                fx: ()=>{
                                    c.Client.getInstance().config();
                                    l.default.StreamManager.get().updateCallStream(this._call);
                                },
                                reject: t1,
                                resolve: (t1)=>{
                                    this.restoreMute(), e(t1);
                                }
                            });
                        });
                    }
                    hold(e) {
                        return new Promise((t1, n)=>{
                            this.onHold === e && t1({
                                call: this._call,
                                name: p.CallEvents.Updated,
                                result: !0
                            }), this.reInviteQ.add({
                                fx: ()=>{
                                    this._hold(e);
                                },
                                reject: n,
                                resolve: (e)=>{
                                    this.restoreMute(), t1(e);
                                }
                            });
                        });
                    }
                    hdnFRS() {
                        return new Promise((e, t1)=>{
                            this.onHold ? t1({
                                result: !1,
                                call: this._call
                            }) : this.reInviteQ.add({
                                fx: ()=>{
                                    this._hdnFRS();
                                },
                                reject: t1,
                                resolve: (t1)=>{
                                    this.restoreMute(), e(t1);
                                }
                            });
                        });
                    }
                    muteMicrophone(e) {
                        this.muteMicState !== e ? (this.muteMicState = e, this.onHold ? this.logger.warning(`Can't change the microphone state to ${e}: the call is on hold.`) : this.getTransceivers().forEach((e)=>{
                            var t1, n;
                            const r = e.sender && e.sender.track ? e.sender.track.kind : null;
                            "audio" === r && "live" === e.sender.track.readyState ? (this.logger.warning(`Change track ${e.mid} with kind ${r}.`), e.sender.track.enabled = !this.muteMicState) : this.logger.warning(`Skip track ${e.mid} with kind ${r} in the ${null === (n = null === (t1 = e.sender) || void 0 === t1 ? void 0 : t1.track) || void 0 === n ? void 0 : n.readyState} state.`);
                        })) : this.logger.warning(`Can't change the microphone state to ${e}: already in the state.`);
                    }
                    restoreMute() {
                        this._call.settings.active && setTimeout(()=>{
                            this._call.settings.state !== u.CallState.ENDED && (this._call.restoreRMute(), this.getTransceivers().forEach((e)=>{
                                "audio" === (e.sender && e.sender.track ? e.sender.track.kind : null) && "live" === e.sender.track.readyState && (e.sender.track.enabled = !this.muteMicState);
                            }));
                        }, 100);
                    }
                    restoreVideoSending() {}
                    addCustomMedia(e) {
                        return new Promise((t1, n)=>{
                            this.reInviteQ.add({
                                fx: ()=>{
                                    this._addCustomMedia(e);
                                },
                                reject: n,
                                resolve: (e)=>{
                                    this.restoreMute(), t1();
                                }
                            });
                        });
                    }
                    fastAddCustomMedia(e) {
                        this._addCustomMedia(e);
                    }
                    fastRemoveCustomMedia(e) {
                        this._removeCustomMedia(e);
                    }
                    removeCustomMedia(e) {
                        return new Promise((t1, n)=>{
                            this.reInviteQ.add({
                                fx: ()=>{
                                    this._removeCustomMedia(e);
                                },
                                reject: n,
                                resolve: (e)=>{
                                    this.restoreMute(), t1();
                                }
                            });
                        });
                    }
                    updateMediaTracks(e) {
                        this.updateMediaTracks(e);
                    }
                    updateCustomMedia(e) {
                        this._updateCustomMedia(e);
                    }
                    replaceSharingToVideo(e, t1) {
                        return this._replaceSharingToVideo(e, t1);
                    }
                    setEncodingsParams(e, t1) {
                        this._setEncodingsParams(e, t1);
                    }
                    _traceName() {
                        return "PeerConnection";
                    }
                    setState(e) {
                        this.logger.info("Transmitting from " + f[this.state] + " to " + f[e]), this.state = e;
                    }
                    sendLocalCandidateToPeer(e, t1) {
                        this._call = a.CallManager.get().calls[this.id], this.mode === m.CLIENT_SERVER_V1 ? h.default.callRemoteFunction(o.RemoteFunction.addCandidate, this.id, e, t1) : (this.candidateList.push([
                            t1,
                            e
                        ]), this.localCandidateTimer <= 0 && (this.localCandidateTimer = window.setTimeout(()=>{
                            window.clearTimeout(this.localCandidateTimer), this.localCandidateTimer = -1, a.CallManager.get().calls[this.id] && a.CallManager.get().calls[this.id].sendInfo(s.Constants.P2P_SPD_FRAG_MIME_TYPE, JSON.stringify(this.candidateList), {}), this.candidateList = [];
                        }, 200)));
                    }
                    startCandidateSendTimer() {
                        null !== this.candidateSendTimer && void 0 !== this.candidateSendTimer || (this.candidateSendTimer = setTimeout(()=>{
                            this.candidateSendTimer = null, this.pendingCandidates.length > 0 && a.CallManager.get().calls[this.id] && a.CallManager.get().calls[this.id].sendInfo(s.Constants.P2P_SPD_FRAG_MIME_TYPE, JSON.stringify(this.pendingCandidates), {}), this.pendingCandidates = [];
                        }, this.SEND_CANDIDATE_DELAY));
                    }
                }
                r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "getState", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "processRemoteAnswer", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "getLocalOffer", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "getLocalAnswer", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "processRemoteOffer", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "close", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "addRemoteCandidate", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "handleReinvite", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "handleRemoteOffer", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "addCandidateToSend", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "canStartSendingCandidates", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "sendDTMF", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "setVideoEnabled", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "setVideoFlags", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "setHoldKey", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "getTrackKind", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "sendMedia", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "hold", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "hdnFRS", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "muteMicrophone", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "restoreMute", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "restoreVideoSending", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "addCustomMedia", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "fastAddCustomMedia", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "fastRemoveCustomMedia", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "removeCustomMedia", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "updateMediaTracks", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "updateCustomMedia", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "replaceSharingToVideo", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "setEncodingsParams", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "setState", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "sendLocalCandidateToPeer", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], v.prototype, "startCandidateSendTimer", null), t1.PeerConnection = v;
            },
            4265: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.ReInviteQ = void 0;
                const i = n(2282), a = n(1150);
                class s {
                    constructor(e, t1){
                        this._pcStatus = t1, this._q = [], e.on(i.CallEvents.Updated, (e)=>{
                            if (a.LogManager.get().writeMessage(a.LogCategory.REINVITEQ, "CallEvent", a.LogLevel.TRACE, `Updated with result ${e.result}`), s._currentReinvite) {
                                const t1 = s._currentReinvite;
                                e.result ? t1.resolve(e) : t1.reject(e), s._currentReinvite = void 0;
                            }
                            this.runNext();
                        }), e.on(i.CallEvents.PendingUpdate, (e)=>{
                            a.LogManager.get().writeMessage(a.LogCategory.REINVITEQ, "CallEvent", a.LogLevel.TRACE, "IncomingUpdate. Local RI==" + typeof s._currentReinvite), s._currentReinvite && (e.result ? s._currentReinvite.resolve(e) : s._currentReinvite.reject(e), s._currentReinvite = void 0);
                        }), e.on(i.CallEvents.UpdateFailed, (e)=>{
                            a.LogManager.get().writeMessage(a.LogCategory.REINVITEQ, "CallEvent", a.LogLevel.TRACE, "UpdateFailed"), s._currentReinvite && (s._currentReinvite.reject(), s._currentReinvite = void 0);
                        });
                    }
                    runNext() {
                        void 0 === s._currentReinvite && this._q.length > 0 && this._pcStatus() && (s._currentReinvite = this._q.splice(0, 1)[0], s._currentReinvite.fx());
                    }
                    add(e) {
                        this._q.push(e), this.runNext();
                    }
                    clear() {
                        this._q.forEach((e)=>{
                            e.reject();
                        });
                    }
                    _traceName() {
                        return "ReInviteQ";
                    }
                }
                r([
                    a.LogManager.d_trace(a.LogCategory.REINVITEQ)
                ], s.prototype, "runNext", null), r([
                    a.LogManager.d_trace(a.LogCategory.REINVITEQ)
                ], s.prototype, "add", null), r([
                    a.LogManager.d_trace(a.LogCategory.REINVITEQ)
                ], s.prototype, "clear", null), t1.ReInviteQ = s;
            },
            6127: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.CodecSorter = void 0;
                const r = n(8707);
                class i {
                    constructor(e){
                        this.originalSDP = e;
                    }
                    getUserCodecList() {
                        void 0 === this.originalCodecList && (this.originalCodecList = r.default.parse(this.originalSDP));
                        let e = {
                            sections: []
                        };
                        return e.sections = this.originalCodecList.media.filter((e)=>"video" === e.descr.media || "audio" === e.descr.media).map((e, t1, n)=>{
                            let r = /(rtx|red|ulpfec)/, i = e.attr.filter((e)=>"rtpmap" === e.name && !e.value.find((e)=>e.value.match(r)));
                            return {
                                kind: e.descr.media,
                                codec: i
                            };
                        }), e;
                    }
                    setUserCodecList(e) {
                        void 0 === this.originalCodecList && (this.originalCodecList = r.default.parse(this.originalSDP));
                        for(let t1 = 0; t1 < e.sections.length; t1++)if (e.sections[t1].kind === this.originalCodecList.media[t1].descr.media) {
                            let n = i.resortSection(e.sections[t1].codec, this.originalCodecList.media[t1].attr, this.originalCodecList.media[t1].descr.media);
                            this.originalCodecList.media[t1].attr = n.codecs, this.originalCodecList.media[t1].descr.fmt = n.order, this.originalCodecList.media[t1].descr.fmtCount = n.order.length;
                        }
                    }
                    static resortSection(e, t1, n) {
                        let r = [], i = [], a = [], s = [];
                        t1.forEach((e)=>"rtpmap" === e.name ? a.push(e) : "ssrc" === e.name ? i.push(e) : void r.push(e));
                        let o = e.map((e)=>{
                            let t1 = e.value.find((e)=>"rtpmap" === e.name).value, n = a.find((e)=>e.value.find((e)=>!!~e.value.indexOf(t1)));
                            if (n) return s.push(t1.split(" ")[0]), n;
                        }).filter(Boolean);
                        if ("video" === n.toLowerCase()) {
                            let e = [], t1 = [], n = a.filter((e)=>e.value.find((e)=>!!~e.value.indexOf("rtx"))), s = a.filter((e)=>e.value.find((e)=>e.value.match(/(red|ulpfec)/)));
                            return o = o.concat(s), o.forEach((r)=>{
                                e.push(r), t1.push(r.value.find((e)=>"rtpmap" === e.name).value.split(" ")[0]);
                                let i = this.matchRtx(r, n);
                                i && (e.push(i), t1.push(i.value.find((e)=>"rtpmap" === e.name).value.split(" ")[0]));
                            }), {
                                codecs: [
                                    ...r,
                                    ...e,
                                    ...i
                                ],
                                order: t1
                            };
                        }
                        return {
                            codecs: [
                                ...r,
                                ...o,
                                ...i
                            ],
                            order: s
                        };
                    }
                    static matchRtx(e, t1) {
                        let n = e.value.find((e)=>"rtpmap" === e.name).value.split(" ")[0], r = t1.find((e)=>e.value.find((e)=>!!~e.value.indexOf(`apt=${n}`)));
                        return r;
                    }
                    getSDP() {
                        return this.originalCodecList.toString();
                    }
                    _traceName() {
                        return "CodecSorter";
                    }
                }
                t1.CodecSorter = i;
            },
            3421: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.CodecSorterHelpers = void 0;
                const i = n(1150);
                class a {
                    static H264Sorter(e) {
                        return new Promise((t1)=>{
                            for(let t1 = 0; t1 < e.sections.length; t1++)"video" == e.sections[t1].kind.toLowerCase() && e.sections[t1].codec.sort((e, t1)=>{
                                let n = e.value.findIndex((e)=>"rtpmap" === e.name), r = t1.value.findIndex((e)=>"rtpmap" === e.name);
                                return -1 != e.value[n].value.toLowerCase().indexOf("h264") && -1 == e.value[n].value.toLowerCase().indexOf("uc") ? -1 : -1 != t1.value[r].value.toLowerCase().indexOf("h264") && -1 == t1.value[r].value.toLowerCase().indexOf("uc") ? 1 : 0;
                            });
                            t1(e);
                        });
                    }
                    static H264ConfSorter(e, t1) {
                        return new Promise(t1 ? (t1)=>{
                            for(let t1 = 0; t1 < e.sections.length; t1++)if ("video" == e.sections[t1].kind.toLowerCase()) {
                                let n = e.sections[t1].codec.filter((e)=>{
                                    let t1 = e.value.findIndex((e)=>"rtpmap" === e.name);
                                    return -1 != e.value[t1].value.toLowerCase().indexOf("h264") && -1 == e.value[t1].value.toLowerCase().indexOf("uc");
                                });
                                n.length && (e.sections[t1].codec = n);
                            }
                            t1(e);
                        } : (t1)=>{
                            for(let t1 = 0; t1 < e.sections.length; t1++)"video" == e.sections[t1].kind.toLowerCase() && (e.sections[t1].codec.sort((e, t1)=>{
                                let n = e.value.findIndex((e)=>"rtpmap" === e.name), r = t1.value.findIndex((e)=>"rtpmap" === e.name);
                                return -1 != e.value[n].value.toLowerCase().indexOf("h264") && -1 == e.value[n].value.toLowerCase().indexOf("uc") ? -1 : -1 != t1.value[r].value.toLowerCase().indexOf("h264") && -1 == t1.value[r].value.toLowerCase().indexOf("uc") ? 1 : 0;
                            }), e.sections[t1].codec.sort((e, t1)=>{
                                e.value.findIndex((e)=>"rtpmap" === e.name), t1.value.findIndex((e)=>"rtpmap" === e.name);
                                let n = e.value.findIndex((e)=>"fmtp" === e.name), r = t1.value.findIndex((e)=>"fmtp" === e.name);
                                return e.value[n] && t1.value[r] ? -1 !== e.value[n].value.toLowerCase().indexOf("profile-level-id=42e01f") && -1 !== e.value[n].value.toLowerCase().indexOf("packetization-mode=1") ? -1 : -1 !== t1.value[r].value.toLowerCase().indexOf("profile-level-id=42e01f") && -1 !== e.value[n].value.toLowerCase().indexOf("packetization-mode=1") ? 1 : 0 : 0;
                            }));
                            t1(e);
                        });
                    }
                    _traceName() {
                        return "CodecSorterHelpers";
                    }
                }
                r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], a, "H264Sorter", null), r([
                    i.LogManager.d_trace(i.LogCategory.RTC)
                ], a, "H264ConfSorter", null), t1.CodecSorterHelpers = a;
            },
            8707: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                });
                class n {
                    constructor(){
                        this.attrCount = 0, this.bandwCount = 0, this.mediaCount = 0, this.dummyLines = [];
                    }
                    static parse(e) {
                        const t1 = new n;
                        return n.splitLines(e).forEach((e, r)=>{
                            switch(e.trim().charAt(0)){
                                case "a":
                                    const i = n.parseAttr(e, r);
                                    if (i) {
                                        if (t1.mediaCount) {
                                            if (!(t1.media[t1.mediaCount - 1].attrCount < 260)) throw new Error("Error adding media attribute, attribute is ignored");
                                            t1.addMediaAttribute(i, t1.mediaCount - 1);
                                        } else {
                                            if (!(t1.attrCount < 260)) throw new Error("Error adding media attribute, attribute is ignored");
                                            t1.addSessionAttribute(i);
                                        }
                                    }
                                    break;
                                case "o":
                                    t1.origin = n.parseOrigin(e, r);
                                    break;
                                case "s":
                                    t1.name = n.parseGenericLine(e, r);
                                    break;
                                case "c":
                                    const a = n.parseConnectionInfo(e, r);
                                    t1.mediaCount ? t1.media[t1.mediaCount - 1].conn = a : t1.conn = a;
                                    break;
                                case "t":
                                    t1.time = n.parseTime(e, r);
                                    break;
                                case "m":
                                    const s = n.parseMedia(e, r);
                                    if (void 0 === t1.media && (t1.media = []), !(t1.mediaCount < 256)) throw new Error("Error adding media, media is ignored");
                                    t1.media[t1.mediaCount] = s, t1.mediaCount++;
                                    break;
                                case "v":
                                    n.parseVersion(e, r);
                                    break;
                                case "b":
                                    const o = n.parseBandwidthInfo(e, r);
                                    if (t1.mediaCount) {
                                        if (!(t1.media[t1.mediaCount - 1].bandwCount < 8)) throw new Error("Error adding session bandwidth info, info is ignored");
                                        t1.media[t1.mediaCount - 1].bandw.push(o), t1.media[t1.mediaCount - 1].bandwCount++;
                                    } else {
                                        if (!(t1.bandwCount < 8)) throw new Error("Error adding session bandwidth info, info is ignored");
                                        void 0 === t1.bandw && (t1.bandw = []), t1.bandw[t1.bandwCount] = o, t1.bandwCount++;
                                    }
                                    break;
                                default:
                                    t1.dummyLines.push(n.parseGenericLine(e, r));
                            }
                        }), t1;
                    }
                    static parseAttr(e, t1) {
                        0 !== e.indexOf("a=") && n.scannerError(e, t1);
                        const r = n.chopLine(e).split(":");
                        return {
                            name: r[0],
                            value: r.slice(1).join(":")
                        };
                    }
                    static splitLines(e) {
                        return e.split(/(\r\n|\r|\n)/).filter((e)=>e.length > 0).filter(RegExp.prototype.test.bind(/^([a-z])=(.*)/));
                    }
                    static parseGenericLine(e, t1) {
                        return 1 !== e.indexOf("=") && n.scannerError(e, t1), e.substr(2);
                    }
                    static parseOrigin(e, t1) {
                        0 !== e.indexOf("o=") && n.scannerError(e, t1);
                        const r = n.chopLine(e).split(/[\s\t]+/);
                        return {
                            user: r[0],
                            id: r[1],
                            version: r[2],
                            netType: r[3],
                            addrType: r[4],
                            addr: r[5]
                        };
                    }
                    static parseVersion(e, t1) {
                        0 !== e.indexOf("v=0") && n.scannerError(e, t1);
                    }
                    static parseTime(e, t1) {
                        0 !== e.indexOf("t=") && n.scannerError(e, t1);
                        const r = n.chopLine(e).split(/[\s\t]+/);
                        return {
                            start: parseInt(r[0]),
                            stop: parseInt(r[1])
                        };
                    }
                    static parseConnectionInfo(e, t1) {
                        0 !== e.indexOf("c=") && n.scannerError(e, t1);
                        const r = n.chopLine(e).split(/[\s\t]+/);
                        return {
                            netType: r[0],
                            addrType: r[1],
                            addr: r[2]
                        };
                    }
                    static parseBandwidthInfo(e, t1) {
                        0 !== e.indexOf("b=") && n.scannerError(e, t1);
                        const r = n.chopLine(e).split(/[:]+/);
                        return {
                            modifier: r[0],
                            value: parseInt(r[1])
                        };
                    }
                    static scannerError(e, t1) {
                        throw new Error(`Error parsing sdp in line ${t1}: "${e}" is not valid sdp line`);
                    }
                    static chopLine(e) {
                        return e.substr(2);
                    }
                    static parseMedia(e, t1) {
                        0 !== e.indexOf("m=") && n.scannerError(e, t1);
                        const r = n.chopLine(e).split(/[\s\t]+/), i = r[1].split("/");
                        return {
                            descr: {
                                media: r[0],
                                port: parseInt(i[0]),
                                portCount: parseInt(i[1] || "0"),
                                transport: r[2],
                                fmtCount: r.length - 3,
                                fmt: r.slice(3)
                            },
                            attrCount: 0,
                            bandwCount: 0,
                            attr: [],
                            bandw: []
                        };
                    }
                    addSessionAttribute(e) {
                        void 0 === this.attr && (this.attr = []), this.attr.push(e), this.attrCount++;
                    }
                    addMediaAttribute(e, t1) {
                        void 0 === this.media[t1].attr && (this.media[t1].attr = []);
                        let n = e.value.split(" ")[0];
                        ~[
                            "rtcp",
                            "ice-ufrag",
                            "ice-pwd",
                            "ice-options",
                            "fingerprint",
                            "setup"
                        ].indexOf(e.name) ? this.addAttr(t1, e, "ice") : ~[
                            "rtpmap",
                            "rtcp-fb",
                            "fmtp"
                        ].indexOf(e.name) ? this.addAttr(t1, e, "rtpmap", n) : ~[
                            "extmap"
                        ].indexOf(e.name) ? this.addAttr(t1, e, "extmap") : ~[
                            "ssrc"
                        ].indexOf(e.name) ? this.addAttr(t1, e, "ssrc") : this.media[t1].attr.push(e), this.media[t1].attrCount++;
                    }
                    addAttr(e, t1, n, r) {
                        let i = this.media[e].attr.findIndex((e)=>r ? e.name === n && e.value[0].value.split(" ")[0] === r : e.name === n);
                        -1 !== i ? this.media[e].attr[i].value.push(t1) : this.media[e].attr.push({
                            name: n,
                            value: [
                                t1
                            ]
                        });
                    }
                    toString() {
                        const e = [];
                        e.push("v=0"), e.push(`o=${this.origin.user} ${this.origin.id} ${this.origin.version} ${this.origin.netType} ${this.origin.addrType} ${this.origin.addr}`), e.push(`s=${this.name}`), this.conn && e.push(n.printConnectionInfo(this.conn));
                        for(let t1 = 0; t1 < this.bandwCount; t1++)e.push(n.printBandwidthInfo(this.bandw[t1]));
                        e.push(`t=${this.time.start} ${this.time.stop}`);
                        for(let t1 = 0; t1 < this.attrCount; t1++)e.push(n.printAttrInfo(this.attr[t1]));
                        for(let t1 = 0; t1 < this.mediaCount; t1++){
                            const r = this.media[t1];
                            let i = `m=${r.descr.media} ${r.descr.port}${r.descr.portCount ? "/" + r.descr.portCount : ""} ${r.descr.transport}`;
                            for(let e = 0; e < r.descr.fmtCount; e++)i += " " + r.descr.fmt[e];
                            e.push(i), r.conn && e.push(n.printConnectionInfo(r.conn));
                            for(let t1 = 0; t1 < r.bandwCount; t1++)e.push(n.printBandwidthInfo(r.bandw[t1]));
                            const a = [
                                "sendrecv",
                                "sendonly",
                                "recvonly",
                                "inactive"
                            ], s = r.attr.find((e)=>!!~a.indexOf(e.name));
                            s && e.push(n.printAttrInfo(s));
                            const o = r.attr.find((e)=>"ice" === e.name);
                            o && o.value.forEach((t1)=>{
                                e.push(n.printAttrInfo(t1));
                            });
                            let d = r.attr.filter((e)=>"ice" !== e.name && !~a.indexOf(e.name));
                            for(let t1 = 0; t1 < d.length; t1++)Array.isArray(d[t1].value) ? d[t1].value.forEach((t1)=>{
                                e.push(n.printAttrInfo(t1));
                            }) : e.push(n.printAttrInfo(d[t1]));
                        }
                        return e.join("\r\n") + "\r\n";
                    }
                    static printConnectionInfo(e) {
                        return `c=${e.netType} ${e.addrType} ${e.addr}`;
                    }
                    static printBandwidthInfo(e) {
                        return `b=${e.modifier}:${e.value}`;
                    }
                    static printAttrInfo(e) {
                        return `a=${e.name}${e.value ? ":" + e.value : ""}`;
                    }
                }
                t1.default = n, n.SDP_EINSDP = "Wrong sdp lines";
            },
            8879: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.SDPMuggle = void 0;
                const r = n(125), i = n(1206), a = n(8707);
                class s {
                    static getSDPLines(e) {
                        return e.split(/(\r\n|\r|\n)/).filter(s.validLine);
                    }
                    static createSDPFrom(e, t1) {
                        return new RTCSessionDescription({
                            sdp: e.join("\r\n") + "\r\n",
                            type: t1
                        });
                    }
                    static detectDirections(e) {
                        let t1 = [], n = e.split(/(\r\n|\r|\n)/).filter(s.validLine), r = "";
                        return n.forEach((e)=>{
                            if (0 === e.indexOf("m=")) {
                                let t1 = e.substr(2);
                                r = t1.split(" ")[0];
                            }
                            "" === r || "a=sendrecv" !== e && "a=sendonly" !== e && "a=recvonly" !== e && "a=inactive" !== e || (t1.push({
                                type: r,
                                direction: e.substr(2)
                            }), r = "");
                        }), t1;
                    }
                    static checkIsVimsSectionExistsIn(e) {
                        return e.includes("VIMS");
                    }
                    static removeTelephoneEvents(e) {
                        if (-1 !== e.sdp.indexOf("a=rtpmap:127 telephone-event/8000")) {
                            let t1 = e.sdp.split(/(\r\n|\r|\n)/).filter(s.validLine), n = -1;
                            for(let e = 0; e < t1.length; e++){
                                if (-1 !== t1[e].indexOf("m=audio")) {
                                    let n = t1[e];
                                    "string" == typeof n && (t1[e] = n.replace(" 127", ""));
                                }
                                -1 !== t1[e].indexOf("a=rtpmap:127 telephone-event/8000") && (n = e);
                            }
                            return t1.splice(n, 1), new RTCSessionDescription({
                                sdp: t1.join("\r\n") + "\r\n",
                                type: e.type
                            });
                        }
                        return e;
                    }
                    static removeDoubleOpus(e) {
                        if (-1 !== e.sdp.indexOf("a=rtpmap:109 opus") && -1 !== e.sdp.indexOf("a=rtpmap:111 opus")) {
                            let t1 = e.sdp.split(/(\r\n|\r|\n)/).filter(s.validLine), n = -1;
                            for(let e = 0; e < t1.length; e++){
                                if (-1 !== t1[e].indexOf("m=audio")) {
                                    let n = t1[e];
                                    "string" == typeof n && (t1[e] = n.replace(" 109", ""));
                                }
                                -1 !== t1[e].indexOf("a=rtpmap:109 opus") && (n = e);
                            }
                            return t1.splice(n, 1), new RTCSessionDescription({
                                sdp: t1.join("\r\n") + "\r\n",
                                type: e.type
                            });
                        }
                        return e;
                    }
                    static removeDoublePT(e) {
                        let t1 = e.sdp.split(/(\r\n|\r|\n)/).filter(s.validLine), n = [];
                        for(let e = 0; e < t1.length; e++){
                            let r = t1[e];
                            0 === r.indexOf("m=video") && (n = r.split(" "), t1[e] = n.filter((e, t1)=>{
                                if (0 === t1) return !0;
                                for(let r = t1 - 1; r >= 2; r--)if (n[r] === e) return !1;
                                return !0;
                            }).join(" "));
                        }
                        return new RTCSessionDescription({
                            sdp: t1.join("\r\n") + "\r\n",
                            type: e.type
                        });
                    }
                    static getSdpCodecs(e) {
                        return e.match(/a=rtpmap:\d+/g);
                    }
                    static removeDoubleCodecsInactiveSections(e) {
                        let t1 = e.sdp.split("m=");
                        for(let e = 0; e < t1.length; e += 1){
                            if (-1 === t1[e].indexOf("a=inactive")) continue;
                            const n = s.getSdpCodecs(t1[e]);
                            n && n.filter((e, t1)=>n.indexOf(e) !== t1).forEach((n)=>{
                                const r = new RegExp(`${n} .+\r\n`);
                                t1[e] = t1[e].replace(r, "");
                            });
                        }
                        return new RTCSessionDescription({
                            sdp: t1.join("m="),
                            type: e.type
                        });
                    }
                    static removeTransportCC(e) {
                        if (-1 !== e.sdp.indexOf("http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01")) {
                            let t1 = e.sdp.split(/(\r\n|\r|\n)/).filter(s.validLine), n = [];
                            return t1.forEach((e, t1)=>{
                                -1 !== e.indexOf("http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01") && n.unshift(t1);
                            }), n.forEach((e)=>t1.splice(e, 1)), new RTCSessionDescription({
                                sdp: t1.join("\r\n") + "\r\n",
                                type: e.type
                            });
                        }
                        return e;
                    }
                    static removeTIAS(e) {
                        if (-1 !== e.sdp.indexOf("b=TIAS:13888000") || -1 !== e.sdp.indexOf("b=AS:13888")) {
                            let t1 = e.sdp.split(/(\r\n|\r|\n)/).filter(s.validLine), n = [];
                            t1.forEach((e, t1)=>{
                                -1 === e.indexOf("b=TIAS:13888000") && -1 === e.indexOf("b=AS:13888") || n.unshift(t1);
                            }), n.forEach((e)=>t1.splice(e, 1)), e = {
                                type: e.type,
                                sdp: t1.join("\r\n") + "\r\n"
                            };
                        }
                        return e;
                    }
                    static fixVideoRecieve(e, t1) {
                        if (-1 !== e.sdp.indexOf("m=video") && !t1) {
                            let t1 = e.sdp.split(/(\r\n|\r|\n)/).filter(s.validLine), n = null;
                            return t1 = t1.map((e, t1)=>(null === n ? -1 !== e.indexOf("m=video") && (n = t1) : "a=sendrecv" === e ? e = "a=sendonly" : "a=recvonly" === e && (e = "a=inactive"), e)), new RTCSessionDescription({
                                sdp: t1.join("\r\n") + "\r\n",
                                type: e.type
                            });
                        }
                        return e;
                    }
                    static addSetupAttribute(e) {
                        return -1 == e.indexOf("a=setup:") && (e += "a=setup:actpass\r\n"), e;
                    }
                    static findTrackByMid(e, t1) {
                        let n = e.split(/(\r\n|\r|\n)/).filter(s.validLine), r = -1;
                        for(let e = 0; e < n.length && (-1 === n[e].indexOf("a=mid:") || -1 === r); e++)if (-1 !== n[e].indexOf(`a=mid:${t1}`) && (r = e), -1 !== n[e].indexOf("msid:") && -1 !== r) return n[e].split(" ").slice(-1).pop();
                        return "";
                    }
                    static addXAS(e) {
                        if (r.Client.getInstance().config().experiments.xas && r.Client.getInstance().config().experiments.xas) {
                            let t1 = e.sdp;
                            const n = r.Client.getInstance().config().experiments.xas;
                            return void 0 !== n.as && -1 !== n.as && (t1 = t1.replace(/(a=mid:video.*\r\n)/g, "$1b=AS:" + n.as + "\r\n")), void 0 !== n.tias && -1 !== n.tias && (t1 = t1.replace(/(a=mid:video.*\r\n)/g, "$1b=TIAS:" + n.as + "\r\n")), new RTCSessionDescription({
                                sdp: t1,
                                type: e.type
                            });
                        }
                        return e;
                    }
                    static fixFFMIDBug(e) {
                        if (-1 == e.sdp.indexOf("a=mid")) {
                            const t1 = e.sdp.replace(/(m=audio.*\r\n)/g, "$1a=mid:0\r\n");
                            return new RTCSessionDescription({
                                sdp: t1,
                                type: e.type
                            });
                        }
                        return e;
                    }
                    static fixFMTP(e) {
                        let t1 = e.sdp.split(/(\r\n|\r|\n)/).filter(s.validLine), n = [];
                        return t1 = t1.filter((t1)=>{
                            if (0 == t1.indexOf("a=fmtp")) {
                                let r = t1.split(" ")[1], i = r.replace("apt=", "");
                                return -1 !== e.sdp.indexOf(`a=rtpmap:${i}`) || (n.push(r[0].replace("a=fmtp:", "")), !1);
                            }
                            return !0;
                        }).filter((e)=>-1 === e.indexOf("a=rtpmap:") || -1 === n.indexOf(e.split(" ")[0].replace("a=rtpmap:", ""))).map((e)=>{
                            if (-1 !== e.indexOf("m=")) return e.split(" ").filter((e)=>-1 === n.indexOf(e)).join(" ");
                            return e;
                        }), {
                            sdp: t1.join("\r\n") + "\r\n",
                            type: e.type
                        };
                    }
                    static trimMediaAttr(e) {
                        let t1 = e.sdp.split(/(\r\n|\r|\n)/).filter(s.validLine);
                        return t1 = t1.map((e)=>(e.includes("a=fmtp") && (e = e.split(";").map((e)=>e.trim()).join(";")), e)), new RTCSessionDescription({
                            sdp: t1.join("\r\n") + "\r\n",
                            type: e.type
                        });
                    }
                    static fixSetupSection(e) {
                        if (!i.getParser(window.navigator.userAgent).satisfies({
                            chrome: ">94.00.0"
                        }) || navigator.userAgent.match(/BitrixDesktop/i)) return e;
                        return this.getSDPLines(e).map((e)=>e.includes("a=setup:") ? e.replace(/:.+$/, ":active") : e).join("\r\n") + "\r\n";
                    }
                    static forcePassiveSetupSection(e) {
                        if (!i.getParser(window.navigator.userAgent).satisfies({
                            chrome: ">94.00.0"
                        }) || navigator.userAgent.match(/BitrixDesktop/i)) return e;
                        const t1 = this.getSDPLines(e.sdp).map((e)=>e.includes("a=setup:") ? e.replace(/:.+$/, ":passive") : e);
                        return Object.assign(Object.assign({}, e), {
                            sdp: t1.join("\r\n") + "\r\n"
                        });
                    }
                    static reduceCodecs(e, t1) {
                        let n = a.default.parse(e.sdp), r = !1, i = !1;
                        return n.media.forEach((e, a)=>{
                            var o, d;
                            if (!e.attr.find((e)=>"inactive" === e.name)) {
                                let c = [], l = [], g = [], u = [];
                                if (e.attr.forEach((e)=>"rtpmap" === e.name ? g.push(e) : "ssrc" === e.name ? l.push(e) : void c.push(e)), "audio" === e.descr.media) {
                                    if (!(null === (o = t1.audio) || void 0 === o ? void 0 : o.length)) return;
                                    let e = s.reduceAudioCodecs(g, t1.audio);
                                    u.push(...e.reducedCodecs), i = e.isAudio;
                                } else if ("video" === e.descr.media) {
                                    if (!(null === (d = t1.video) || void 0 === d ? void 0 : d.length)) return;
                                    let e = s.reduceVideoCodecs(g, t1.video);
                                    u.push(...e.reducedCodecs), r = e.isVideo;
                                }
                                u.length ? (n.media[a].attr = [
                                    ...c,
                                    ...u,
                                    ...l
                                ], n.media[a].descr.fmtCount = u.length, n.media[a].descr.fmt = u.map((e)=>e.value[0].value.split(" ")[0]), n.media[a].attrCount = n.media[a].attr.length) : (delete n.media[a], n.mediaCount--);
                            }
                        }), {
                            sdp: {
                                type: e.type,
                                sdp: n.toString()
                            },
                            isVideo: r,
                            isAudio: i
                        };
                    }
                    static recoverVideoFmts(e, t1) {
                        var n, r;
                        null == t1 || t1.info(`SDPMuggle.recoverVideoFmts(): parsing SDP\n${e}`);
                        const i = a.default.parse(e), s = null === (n = i.media) || void 0 === n ? void 0 : n[1];
                        if (!s) return null == t1 || t1.info("SDPMuggle.recoverVideoFmts(): video description is undefined"), e;
                        const o = (null === (r = s.attr) || void 0 === r ? void 0 : r.filter(({ name: e })=>"rtpmap" === e)) || [];
                        if (s.descr.fmtCount === (null == o ? void 0 : o.length)) return null == t1 || t1.info("SDPMuggle.recorverVideoFmts(): fmts count and rtpmaps count are equal"), e;
                        const d = o.map(({ value: e })=>{
                            var t1;
                            const n = e[0], [r] = (null === (t1 = null == n ? void 0 : n.value) || void 0 === t1 ? void 0 : t1.split(" ")) || [];
                            return r;
                        }), c = ((e, t1)=>{
                            const n = new Set(e);
                            for (const e of t1)n.delete(e);
                            return Array.from(n.values());
                        })(d, s.descr.fmt);
                        null == t1 || t1.info(`SDPMuggle.recorverVideoFmts(): fmts are missed ${c}`), s.descr.fmt.push(...c), s.descr.fmtCount = s.descr.fmt.length;
                        const l = i.toString();
                        return null == t1 || t1.info(`SDPMuggle.recorverVideoFmts(): SDP is recovered\n${l}`), l;
                    }
                    static reduceVideoCodecs(e, t1) {
                        const n = [];
                        let r = !1;
                        const i = e.filter((e)=>e.value.find((e)=>!!~e.value.indexOf("rtx")));
                        return e.forEach((e)=>{
                            var a;
                            const s = e.value.find((e)=>"rtpmap" === e.name).value, o = t1.filter((e)=>!!~s.indexOf(e.name));
                            if (o.length) {
                                const t1 = null === (a = e.value.find((e)=>"fmtp" === e.name)) || void 0 === a ? void 0 : a.value;
                                o.forEach((a)=>{
                                    let s = Object.keys(a.params || {}).length;
                                    for(const e in a.params)~t1.indexOf(`${e}=${a.params[e]}`) && s--;
                                    if (0 === s && (a.optional || r || (r = !0), n.push(e), i.length)) {
                                        let t1 = ((e, t1)=>{
                                            const n = e.value.find((e)=>"rtpmap" === e.name).value.split(" ")[0];
                                            return t1.find((e)=>e.value.find((e)=>!!~e.value.indexOf(`apt=${n}`)));
                                        })(e, i);
                                        t1 && n.push(t1);
                                    }
                                });
                            }
                        }), {
                            reducedCodecs: n,
                            isVideo: r
                        };
                    }
                    static reduceAudioCodecs(e, t1) {
                        const n = [];
                        let r = !1;
                        return e.forEach((e)=>{
                            var i;
                            const a = e.value.find((e)=>"rtpmap" === e.name).value, s = t1.filter((e)=>!!~a.indexOf(e.name));
                            if (s.length) {
                                const t1 = null === (i = e.value.find((e)=>"fmtp" === e.name)) || void 0 === i ? void 0 : i.value;
                                s.forEach((i)=>{
                                    let a = Object.keys(i.params || {}).length;
                                    for(const e in i.params)~t1.indexOf(`${e}=${i.params[e]}`) && a--;
                                    0 === a && (i.optional || r || (r = !0), n.push(e));
                                });
                            }
                        }), {
                            reducedCodecs: n,
                            isAudio: r
                        };
                    }
                    _traceName() {
                        return "SDPMuggle";
                    }
                }
                t1.SDPMuggle = s, s.validLine = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
            },
            3902: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.TransreceiverPC = t1.RTCSdpType = void 0;
                const i = n(6746), a = n(3869), s = n(84), o = n(1150), d = n(9551), c = n(308), l = n(4106), g = n(6127), u = n(2282), h = n(8879), p = n(125), f = n(4265), m = n(7272), v = n(2957), C = n(245);
                var _ = m.default.StreamManager;
                const S = n(6665), E = n(8552), y = n(8237);
                var M, R;
                !function(e) {
                    e[e.offer = "offer"] = "offer", e[e.answer = "answer"] = "answer", e[e.pranswer = "pranswer"] = "pranswer", e[e.rollback = "rollback"] = "rollback";
                }(M = t1.RTCSdpType || (t1.RTCSdpType = {})), function(e) {
                    e[e.controlling = "controlling"] = "controlling", e[e.controlled = "controlled"] = "controlled";
                }(R || (R = {}));
                class L extends i.PeerConnection {
                    constructor(e, t1, n, r){
                        super(e, t1, n), this.candidatePool = [], this.candidateQueueMap = new Map([
                            [
                                "local",
                                []
                            ],
                            [
                                "remote",
                                []
                            ]
                        ]), this.iceTimer = null, this.needTransportRestart = !0, this.ICE_TIMEOUT = 2e4, this._needIceRestart = !1, this._canReInvite = ()=>"connected" === this.impl.iceConnectionState || "completed" === this.impl.iceConnectionState, this._TransceiverEncoderMap = new WeakMap;
                        let i = s.PCFactory.get().iceConfig;
                        null == i && (i = {
                            gatherPolicy: "all",
                            iceServers: []
                        }), r && (i.iceServers = r), i.bundlePolicy = "balanced", this._createImpl(i);
                    }
                    _getLocalOfferRegular() {
                        return this.iceRole = R.controlling, new Promise((e, t1)=>{
                            let n = {};
                            this._call && (a.default.isIphone() || !this._call.settings.isConference && !this._call.settings.isAudio) && (n = this.getReceiveOptions()), this.resetEncodings().then(()=>(this.logger.info("_getLocalOfferRegular(), start create local SDP"), this.impl.createOffer(n))).then((e)=>{
                                this.logger.info(`_getLocalOfferRegular(), created local SDP: \n${e.sdp}`);
                                let t1 = {
                                    type: e.type,
                                    sdp: e.sdp
                                };
                                return t1 = s.PCFactory.get().addBandwidthParams(t1), t1 = h.SDPMuggle.removeDoublePT(t1), t1 = this._reduceCodecs(t1), t1 = h.SDPMuggle.trimMediaAttr(t1), this.codecRearrange(t1);
                            }).then((e)=>(this.srcLocalSDP = e.sdp, this.logger.info(`_getLocalOfferRegular(), set local SDP: \n${e.sdp}`), this._call && this._call.dispatchEvent({
                                    name: "SDP",
                                    origin: "getLocalOffer",
                                    sdp: e
                                }), this.impl.setLocalDescription(e))).then(()=>{
                                e(this.impl.localDescription);
                            }).catch((e)=>{
                                this._call && this._call.dispatchEvent({
                                    name: "SDP",
                                    origin: "_getLocalOfferRegular",
                                    sdp: this.impl.localDescription,
                                    description: `offer_reject: ${e.message}`
                                }), t1(e);
                            });
                        });
                    }
                    updateHoldState() {
                        this.impl.getTransceivers().forEach((e)=>{
                            e.sender.track && ("audio" === e.sender.track.kind ? e.sender.track.enabled = !this.onHold && !this.muteMicState : e.sender.track.enabled = !this.onHold);
                        });
                    }
                    _processRemoteAnswer(e, t1) {
                        if (0 === t1.length && this._call) return this.logger.error("Empty SDP from server. Call will be terminated."), void this._call.hangup({
                            "X-WebRTCError": "no sdp"
                        });
                        if ("stable" === this.impl.signalingState) return;
                        let n = {
                            sdp: t1,
                            type: M.answer
                        };
                        return this.srcRemoteSDP = t1, n = h.SDPMuggle.removeTIAS(n), n = h.SDPMuggle.trimMediaAttr(n), this.logger.info(`_processRemoteAnswer(), set remote SDP: \n${n.sdp}`), this._call && this._call.dispatchEvent({
                            name: "SDP",
                            origin: "processRemoteAnswer",
                            sdp: n
                        }), this.impl.setRemoteDescription(n).then(()=>this.impl.getTransceivers().forEach(this.stopInactiveTransceiver.bind(this))).then((e)=>{
                            this._needIceRestart && (this._call.settings.isDirect && this._call.settings.incoming || this._runReinvite(!0));
                        }).catch((e)=>{
                            this._call && this._call.dispatchEvent({
                                name: "SDP",
                                origin: "_processRemoteAnswer",
                                sdp: this.impl.localDescription,
                                description: `answer_reject: ${e.message}`
                            });
                        });
                    }
                    _getLocalOffer() {
                        return "firefox" === a.default.getWSVendor() && this.impl.remoteDescription && this.impl.remoteDescription.sdp && -1 === this.impl.remoteDescription.sdp.indexOf("VIMS") ? this._getLocalOfferFF() : this._getLocalOfferRegular();
                    }
                    _getLocalOfferFF() {
                        return this.iceRole = R.controlling, new Promise((e, t1)=>{
                            let n = {};
                            !this._call || !a.default.isIphone() && this._call.settings.isConference || (n = this.getReceiveOptions()), this.resetEncodings().then(()=>this.impl.createOffer(n)).then((e)=>{
                                this.logger.info(`_getLocalOfferFF(), created local SDP: \n${e.sdp}`);
                                let t1 = {
                                    type: e.type,
                                    sdp: e.sdp
                                };
                                return t1 = s.PCFactory.get().addBandwidthParams(t1), t1 = h.SDPMuggle.removeDoublePT(t1), t1 = this._reduceCodecs(t1), t1 = h.SDPMuggle.trimMediaAttr(t1), this.codecRearrange(t1);
                            }).then((t1)=>{
                                this.srcLocalSDP = t1.sdp, this._pendingOffer = t1, e(t1);
                            }).catch((e)=>{
                                this._call && this._call.dispatchEvent({
                                    name: "SDP",
                                    origin: "_getLocalOfferFF",
                                    sdp: this._pendingOffer,
                                    description: `offer_reject: ${e.message}`
                                }), t1(e);
                            });
                        });
                    }
                    _getLocalAnswer() {
                        return this.iceRole = R.controlled, new Promise((e, t1)=>{
                            let n = {
                                mandatory: {}
                            };
                            !this._call || !a.default.isIphone() && this._call.settings.isConference || (n = {
                                mandatory: this.getReceiveOptions()
                            }), this.resetEncodings().then(()=>this.impl.createAnswer(n)).then((e)=>{
                                this.logger.info(`_getLocalAnswer(), created local SDP: \n${e.sdp}`);
                                let t1 = {
                                    type: e.type,
                                    sdp: e.sdp
                                };
                                return t1 = s.PCFactory.get().addBandwidthParams(t1), t1 = h.SDPMuggle.removeDoublePT(t1), t1 = h.SDPMuggle.fixVideoRecieve(t1, this._call.settings.videoDirections.receiveVideo), t1 = this._reduceCodecs(t1), t1 = h.SDPMuggle.trimMediaAttr(t1), this._call && this._call.settings.incoming && (t1 = h.SDPMuggle.forcePassiveSetupSection(t1)), this.codecRearrange(t1);
                            }).then((e)=>(this.srcLocalSDP = e.sdp, this.logger.info(`_getLocalAnswer(), set local SDP: \n${e.sdp}`), this._call && this._call.dispatchEvent({
                                    name: "SDP",
                                    origin: "getLocalAnswer",
                                    sdp: e
                                }), this.impl.setLocalDescription(Object.assign(Object.assign({}, e), {
                                    type: "answer"
                                })))).then(()=>{
                                e({
                                    type: M.answer,
                                    sdp: this.impl.localDescription.sdp
                                });
                            }).catch((e)=>{
                                this._call && this._call.dispatchEvent({
                                    name: "SDP",
                                    origin: "_getLocalAnswer",
                                    sdp: this.impl.localDescription,
                                    description: `answer_reject: ${e.message}`
                                }), t1(e);
                            });
                        });
                    }
                    _processRemoteOffer(e) {
                        return 0 === e.length && this._call ? (this.logger.error("Empty SDP from server. Call will be terminated."), void this._call.hangup({
                            "X-WebRTCError": "no sdp"
                        })) : (this.iceRole = R.controlled, new Promise((t1, n)=>{
                            let r = new RTCSessionDescription({
                                sdp: e,
                                type: M.offer
                            });
                            this.srcRemoteSDP = e, r = h.SDPMuggle.removeTIAS(r), r = h.SDPMuggle.fixFFMIDBug(r), r = h.SDPMuggle.trimMediaAttr(r), this.logger.info(`_processRemoteOffer(), set remote SDP: \n${r.sdp}`), this._call && this._call.dispatchEvent({
                                name: "SDP",
                                origin: "processRemoteOffer",
                                sdp: r
                            }), this.resetEncodings().then(()=>this.impl.setRemoteDescription(r)).then(()=>{
                                let e = {
                                    mandatory: {}
                                };
                                return !this._call || !a.default.isIphone() && this._call.settings.isConference || (e = {
                                    mandatory: this.getReceiveOptions()
                                }), this.impl.createAnswer(e);
                            }).then((e)=>(this.logger.info(`_processRemoteOffer(), created local SDP: \n${e.sdp}`), e = h.SDPMuggle.removeDoublePT(e), e = this._reduceCodecs(e), e = h.SDPMuggle.trimMediaAttr(e), this.codecRearrange(e))).then((e)=>(this.srcLocalSDP = e.sdp, this.logger.info(`_processRemoteOffer(), set local SDP: \n${e.sdp}`), this._call && this._call.dispatchEvent({
                                    name: "SDP",
                                    origin: "processRemoteOffer",
                                    sdp: e
                                }), this.impl.setLocalDescription(e))).then(()=>{
                                t1(this.impl.localDescription.sdp);
                            }).catch((e)=>{
                                this._call && this._call.dispatchEvent({
                                    name: "SDP",
                                    origin: "_processRemoteOffer",
                                    sdp: this.impl.localDescription,
                                    description: `answer_reject: ${e.message}`
                                }), n(e);
                            });
                        }));
                    }
                    _setRemoteDescription(e) {
                        if (0 === e.length && this._call) return this.logger.error("Empty SDP from server. Call will be terminated."), void this._call.hangup({
                            "X-WebRTCError": "no sdp"
                        });
                        let t1 = new RTCSessionDescription({
                            sdp: e,
                            type: M.offer
                        });
                        return t1 = h.SDPMuggle.removeTIAS(t1), t1 = h.SDPMuggle.trimMediaAttr(t1), this.srcRemoteSDP = e, this.logger.info(`_setRemoteDescription(), set remote SDP: \n${t1.sdp}`), this._call && this._call.dispatchEvent({
                            name: "SDP",
                            origin: "setRemoteDescription",
                            sdp: t1
                        }), this.impl.setRemoteDescription(t1);
                    }
                    _handleRemoteOffer(e, t1, n = !1) {
                        return this.renegotiationInProgress = !0, 0 === t1.length && this._call ? (this.logger.error("Empty SDP from server. Call will be terminated."), void this._call.hangup({
                            "X-WebRTCError": "no sdp"
                        })) : new Promise((r, i)=>{
                            const s = new RTCSessionDescription({
                                sdp: t1,
                                type: "offer"
                            });
                            "safari" !== a.default.getWSVendor() && "stable" !== this.impl.signalingState ? this.resetEncodings().then(()=>Promise.all([
                                    this.impl.setLocalDescription({
                                        type: "rollback"
                                    }),
                                    this.impl.setRemoteDescription(s)
                                ])).then(()=>this.impl.createAnswer()).then((t1)=>{
                                let n = {
                                    sdp: t1.sdp,
                                    type: t1.type
                                };
                                n = h.SDPMuggle.removeDoubleOpus(n), n = h.SDPMuggle.removeDoublePT(n), n = h.SDPMuggle.fixVideoRecieve(n, this.videoEnabled.receiveVideo), n = h.SDPMuggle.trimMediaAttr(n), n = this._reduceCodecs(n), this.impl.setLocalDescription(n).then(()=>{
                                    this.renegotiationInProgress = !1, this.updateHoldState();
                                    const t1 = {
                                        mids: this.getMidKinds()
                                    };
                                    C.default.callRemoteFunction(l.RemoteFunction.acceptReInvite, this._call.id(), e, n.sdp, t1), this._call && this._call.dispatchEvent({
                                        name: u.CallEvents.Updated,
                                        result: !0,
                                        call: this._call
                                    }), r();
                                });
                            }).catch((r)=>{
                                n ? console.error(r) : setTimeout(()=>{
                                    this._handleRemoteOffer(e, t1, !0);
                                }, 300);
                            }) : this.resetEncodings().then(()=>this.impl.setRemoteDescription(s)).then(()=>this.impl.createAnswer()).then((t1)=>{
                                let n = {
                                    sdp: t1.sdp,
                                    type: t1.type
                                };
                                n = this._reduceCodecs(n), n = h.SDPMuggle.trimMediaAttr(n), this.impl.setLocalDescription(n).then(()=>{
                                    const t1 = {
                                        mids: this.getMidKinds()
                                    };
                                    this.impl.getTransceivers().forEach(this.stopInactiveTransceiver.bind(this)), C.default.callRemoteFunction(l.RemoteFunction.acceptReInvite, this._call.id(), e, n.sdp, t1), this.renegotiationInProgress = !1, this._call && this._call.dispatchEvent({
                                        name: u.CallEvents.Updated,
                                        result: !0,
                                        call: this._call
                                    }), this.updateHoldState(), r();
                                });
                            }).catch((e)=>this.logger.error(e));
                        });
                    }
                    _handleReinvite(e, t1) {
                        if (0 === t1.length && this._call) {
                            const e = "Empty SDP from server. Call will be terminated.";
                            return this.logger.error(e), y.CallPromiseResolver.reject(this._call, e), this._call.hangup({
                                "X-WebRTCError": "no sdp"
                            }), Promise.reject(e);
                        }
                        return new Promise((e, n)=>{
                            const r = (e)=>{
                                const t1 = `answer_reject: ${e.message}`;
                                this._call && (this._call.dispatchEvent({
                                    name: "SDP",
                                    origin: "_handleReinvite",
                                    sdp: this.impl.localDescription,
                                    description: t1
                                }), y.CallPromiseResolver.reject(this._call, t1)), n(e);
                            };
                            if (this.banReinviteAnswer) {
                                const e = "Reinvite answer is banned";
                                return y.CallPromiseResolver.reject(this._call, e), n(new Error(e));
                            }
                            if (!1 === this.renegotiationInProgress) return y.CallPromiseResolver.resolve(this._call), e();
                            if (!0 === this.renegotiationInProgress) {
                                let n = {
                                    sdp: t1,
                                    type: M.answer
                                };
                                this.renegotiationInProgress = !1, this.srcRemoteSDP = t1, n = h.SDPMuggle.removeTIAS(n), n = h.SDPMuggle.trimMediaAttr(n), this.impl.setRemoteDescription(n).then(()=>{
                                    this._call && y.CallPromiseResolver.resolve(this._call), this.updateHoldState(), this.impl.getTransceivers().forEach(this.stopInactiveTransceiver.bind(this)), e();
                                }).catch((e)=>{
                                    this.renegotiationInProgress = !1, r(e), this.logger.error(JSON.stringify(e));
                                }), clearTimeout(this.renegotiationTimer);
                            } else {
                                const e = "Unreachable code for handling reinvite has reached";
                                y.CallPromiseResolver.reject(this._call, e), n(new Error(e));
                            }
                        });
                    }
                    _close() {
                        clearInterval(this.rtcCollectingCycle), this.impl.onnegotiationneeded = null;
                        p.Client.getInstance().config();
                        E.unregisterPeerConnection(this.impl), this.impl.close(), this._localStream = null, this._remoteStreams = null, this.logger.info("Peer Connection was closed.");
                    }
                    _addRemoteCandidate(e, t1) {
                        return new Promise((n, r)=>{
                            try {
                                const r = new RTCIceCandidate({
                                    candidate: e.substring(2),
                                    sdpMLineIndex: t1
                                });
                                this.candidatePool.push(r), this._addIceCandidateToQueue(r, "remote").then(n);
                            } catch (e) {
                                n();
                            }
                        });
                    }
                    async _addIceCandidatesFromQueue() {
                        if (this.logger.info(`Adding ICE candidates from pool in state ${this.impl.signalingState}`), "stable" !== this.impl.signalingState) return;
                        const e = "remote", t1 = this.candidateQueueMap.get(e);
                        this.candidateQueueMap.set(e, []), this.logger.info(`Adding ICE candidates ${t1.length ? t1 : "[]"}`), t1.forEach((e)=>{
                            this.impl.addIceCandidate(e);
                        });
                    }
                    async _addIceCandidateToQueue(e, t1) {
                        var n;
                        if (this.logger.info(`Adding ${t1} candidate ${e.candidate} in state ${this.impl.signalingState}`), "stable" === this.impl.signalingState) try {
                            await this.impl.addIceCandidate(e);
                        } catch (e) {
                            this.logger.error(`Error on adding ICE candidate: ${e}`);
                        }
                        else null === (n = this.candidateQueueMap.get(t1)) || void 0 === n || n.push(e);
                    }
                    setConfiguration(e) {
                        this.impl && setTimeout(()=>{
                            if (this.srcRemoteSDP && -1 === this.srcRemoteSDP.indexOf("VIMS") || window.__VIIceServer__) {
                                if (this.impl && this.impl.setConfiguration) this.impl.setConfiguration(e), this.renegotiationInProgress = !1, this._runReinvite(!0), setTimeout(()=>{
                                    this.candidatePool.forEach((e)=>{
                                        this.impl.addIceCandidate(e).catch(()=>{});
                                    });
                                }, 2e3);
                                else if (this._pendingOffer) {
                                    let t1 = [];
                                    this.impl.getTransceivers().map((e)=>{
                                        e.sender.track && t1.push(e.sender.track);
                                    }), this._createImpl(e), t1.forEach((e)=>{
                                        this.impl.addTrack(e, new MediaStream([
                                            e
                                        ]));
                                    }), this.impl.createOffer().then((e)=>(this.logger.info(`setConfiguration(), created local SDP: \n${e.sdp}`), this._needIceRestart = !0, this.logger.info(`setConfiguration(), set local SDP: \n${this._pendingOffer.sdp}`), this.impl.setLocalDescription(this._pendingOffer))).then(()=>{
                                        this._pendingOffer = void 0;
                                    }).catch((e)=>{
                                        this._call && this._call.dispatchEvent({
                                            name: "SDP",
                                            origin: "setConfiguration",
                                            sdp: this.impl.localDescription,
                                            description: `answer_reject: ${e.message}`
                                        }), console.error(e);
                                    });
                                }
                            }
                        }, 800);
                    }
                    _sendDTMF(e, t1, n) {
                        try {
                            this.dtmfSender.insertDTMF(e, t1, n);
                        } catch (r) {
                            this.dtmfSender = new d.SignalingDTMFSender(this._call.id()), this.dtmfSender.insertDTMF(e, t1, n);
                        }
                    }
                    _hdnFRSPrep() {
                        this.banReinviteAnswer = !0;
                    }
                    _hdnFRS() {
                        this.renegotiationInProgress = !1, this.onRenegotiation();
                    }
                    _traceName() {
                        return "TransreceiverPC";
                    }
                    hasLocalAudio() {
                        return this.impl.getLocalStreams().some((e)=>!!e.getAudioTracks().length);
                    }
                    enableVideo(e) {
                        let t1 = [];
                        this._call && (t1 = m.default.StreamManager.get()._getScreenSharing(this._call) || []);
                        const n = [];
                        t1.forEach((e)=>e.stream.getTracks().forEach((e)=>n.push(e.id))), e ? (this._call.settings.videoDirections.sendVideo = !0, m.default.StreamManager.get().getCallStream(this._call, !0).then((e)=>{
                            let t1 = [];
                            if (a.default.isIphone() || a.default.isIpad()) {
                                let n = e.getAudioTracks(), r = this._call.peerConnection.getTransceivers().find((e)=>e.sender.track && "audio" === e.sender.track.kind);
                                t1.push(this.__replaceTrack(r, n[0]));
                            }
                            let n = e.getVideoTracks();
                            n.length && (this._call.settings.isConference ? t1.push(this._addVideoTransceiver(n[0], e, "video")) : t1.push(this._addNewVideoTransceiver(n[0], e, "video"))), Promise.all(t1).then(()=>{
                                m.default.StreamManager.get().updateLocalVideo(), this.updateSenderTrackTransformers(), this.onRenegotiation();
                            });
                        })) : (t1.length && t1.forEach((e)=>{
                            m.default.StreamManager.get()._clearScreenSharing(this._call, e);
                        }), this.impl.getTransceivers().forEach((e)=>{
                            e.stopped || "sendrecv" !== e.currentDirection && "sendonly" !== e.currentDirection && "inactive" !== e.currentDirection || !e.sender.track || "video" !== e.sender.track.kind || this.__replaceTrack(e, null).then(()=>{
                                "sendonly" !== e.currentDirection || this._call.settings.isConference ? e.direction = "recvonly" : e.stop(), this._call.settings.videoDirections.sendVideo = !1, this.onRenegotiation();
                            }).catch((e)=>{
                                this.logger.warning("Wrong transceiver on replace");
                            });
                        }));
                    }
                    _addNewVideoTransceiver(e, t1, n) {
                        return new Promise((r, i)=>{
                            var a;
                            const s = c.CallManager.get().getEndpointManager(this._call), o = {
                                direction: this._getDefaultDirection(),
                                streams: [
                                    t1
                                ]
                            }, d = e.getSettings();
                            if (this.isSimulcast()) o.sendEncodings = v.Utils.buildSimulcastLayers({
                                trackSettings: d,
                                trackType: n,
                                profileName: null === (a = this._call) || void 0 === a ? void 0 : a.settings.simulcastProfileName
                            });
                            else {
                                const t1 = e.getSettings();
                                o.sendEncodings = v.Utils.buildNotSimulcastLayers({
                                    trackSettings: t1,
                                    trackType: n
                                }), this.logger.info(`New encodings params were applied for ${n} track: ${JSON.stringify(o.sendEncodings)}`);
                            }
                            let l = this.impl.addTransceiver(e, o);
                            this.onRenegotiation(), this.updateTransceiver(s, l), r();
                        });
                    }
                    _replaceSharingToVideo(e, t1) {
                        return new Promise((n)=>{
                            var r;
                            const i = this.getTransceivers().filter((e)=>e.sender.track && "video" === e.sender.track.kind);
                            if (i && i.length) {
                                if (this.isSimulcast()) {
                                    const n = v.Utils.buildSimulcastLayers({
                                        trackSettings: e.getSettings(),
                                        trackType: t1,
                                        profileName: null === (r = this._call) || void 0 === r ? void 0 : r.settings.simulcastProfileName
                                    });
                                    this._setEncodingsParams(i[0], n);
                                } else {
                                    const n = v.Utils.buildNotSimulcastLayers({
                                        trackSettings: e.getSettings(),
                                        trackType: t1
                                    });
                                    this.logger.info(`New encodings params were applied for ${t1} track: ${JSON.stringify(n)}`), this._setEncodingsParams(i[0], n);
                                }
                                this.__replaceTrack(i[0], e).then(()=>{
                                    m.default.StreamManager.get().isLocalVideoRequested && m.default.StreamManager.get().updateLocalVideo(), this._runReinvite(), n();
                                });
                            } else n();
                        });
                    }
                    getTransceivers() {
                        return this.impl.getTransceivers ? this.impl.getTransceivers() : [];
                    }
                    getRemoteDescription() {
                        return this.impl.remoteDescription && this.impl.remoteDescription.sdp ? this.impl.remoteDescription.sdp : "";
                    }
                    _addCustomMedia(e) {
                        var t1;
                        if (!e || "closed" === this.impl.signalingState) return;
                        let n = "video";
                        m.default.StreamManager.get()._getScreenSharing(this._call).forEach((t1)=>{
                            t1.stream.id === e.id && (n = "sharing");
                        });
                        const r = c.CallManager.get().getEndpointManager(this._call), i = e.getAudioTracks(), s = this._getDefaultDirection();
                        if (i.length) i.forEach((t1)=>{
                            let n = this.getEmptyTransceiverForKind("audio");
                            n ? ("inactive" !== n.direction && "recvonly" !== n.direction || (n.direction = this._getDefaultDirection()), this.impl.addTrack(t1, e), this.onRenegotiation()) : (n = this.impl.addTransceiver(t1, {
                                direction: s,
                                streams: [
                                    e
                                ]
                            }), this.onRenegotiation()), this.updateTransceiver(r, n);
                        });
                        else if ("sharing" !== n) {
                            const e = this.impl.addTransceiver("audio", {
                                direction: "recvonly"
                            });
                            this.onRenegotiation(), this.updateTransceiver(r, e);
                        }
                        const o = e.getVideoTracks();
                        if (o.length) {
                            const t1 = this.impl.getTransceivers().filter((e)=>"video" === e.receiver.track.kind && !("inactive" === e.direction || "stopped" === e.direction) && "inactive" !== e.currentDirection && !e.stopped);
                            "sharing" !== n && t1.length ? o.forEach((t1)=>{
                                this._addVideoTransceiver(t1, e, n);
                            }) : o.forEach((t1)=>{
                                this._addNewVideoTransceiver(t1, e, n);
                            });
                        } else {
                            if (!this._call.settings.isConference && this.impl.getTransceivers().filter((e)=>"video" === e.receiver.track.kind).length) return;
                            if (this._call.settings.isAudio) return;
                            const i = {
                                direction: "recvonly",
                                streams: [
                                    e
                                ]
                            };
                            this.isSimulcast() ? i.sendEncodings = v.Utils.buildSimulcastLayers({
                                trackSettings: null,
                                trackType: n,
                                profileName: null === (t1 = this._call) || void 0 === t1 ? void 0 : t1.settings.simulcastProfileName
                            }) : (i.sendEncodings = v.Utils.buildNotSimulcastLayers({
                                trackSettings: null,
                                trackType: n
                            }), this.logger.info(`New encodings params were applied for ${n} track: ${JSON.stringify(i.sendEncodings)}`));
                            const a = this.impl.addTransceiver("video", i);
                            this.onRenegotiation(), this.updateTransceiver(r, a);
                        }
                        if (!this.dtmfSender && this._call) {
                            const e = a.default.getDTMFSender(this.impl, this._call.id());
                            e && (this.dtmfSender = e);
                        }
                        setTimeout(()=>{
                            this.updateSenderTransformers(), this.updateSenderTrackTransformers();
                        }, 2e3);
                    }
                    getEmptyTransceiverForKind(e) {
                        return this._call && this._call.settings.isConference ? this.impl.getTransceivers().find((t1)=>"safari" === a.default.getWSVendor() ? !isNaN(Number(t1.mid)) && "recvonly" === t1.direction && t1.receiver.track.kind === e && !t1.sender.track : !(isNaN(Number(t1.mid)) || "recvonly" !== t1.direction && "inactive" !== t1.direction || t1.receiver.track.kind !== e || t1.sender.track || t1.stopped)) : this.impl.getTransceivers().find((t1)=>t1.receiver.track.kind === e && !t1.sender.track && !t1.stopped);
                    }
                    updateTransceiver(e, t1) {
                        e.updateTransceiver(t1);
                    }
                    _removeCustomMedia(e) {
                        if (!e) return;
                        this.renegotiationInProgress = !0;
                        const t1 = this.impl.getTransceivers();
                        e.getTracks().forEach((e)=>{
                            let n;
                            n = this._call.settings.isConference ? t1.find((t1)=>!isNaN(Number(t1.mid)) && t1.sender.track && t1.sender.track === e) : t1.find((t1)=>t1.sender.track && t1.sender.track === e), n && this.__replaceTrack(n, null).then(()=>{
                                "sendonly" !== n.currentDirection || this._call.settings.isConference || n.stop(), this.renegotiationInProgress = !1, this._runReinvite();
                            });
                        });
                    }
                    async _updateCustomMedia(e) {
                        const t1 = await this.updateMediaTracks(e);
                        t1 && t1.length && (this.updateSenderTrackTransformers(), this._runReinvite());
                    }
                    async updateMediaTracks(e) {
                        if (!e || "closed" === this.impl.signalingState) return;
                        const t1 = [];
                        return e.getTracks().forEach((e)=>{
                            const n = this.impl.getTransceivers().find((t1)=>t1.sender.track && t1.sender.track.kind === e.kind);
                            n && t1.push(this.__replaceTrack(n, e));
                        }), await Promise.all(t1);
                    }
                    _fixFFSoundBug() {
                        "firefox" === a.default.getWSVendor() && s.PCFactory.hasTransceivers && setTimeout(()=>{
                            if (this.impl.getSenders) this.impl.getSenders().forEach((e)=>{
                                if (e.replaceTrack) {
                                    const t1 = e.track;
                                    e.replaceTrack(t1);
                                }
                            });
                        }, 1e3);
                    }
                    getConfiguration() {
                        return this.impl ? this.impl.getConfiguration() : null;
                    }
                    _hold(e) {
                        this.onHold = e, this.impl.getTransceivers().forEach((t1)=>{
                            t1.stopped || "stopped" === t1.direction || "stopped" === t1.currentDirection || (t1.direction = e ? "sendonly" : "sendrecv");
                        }), this._runReinvite();
                    }
                    _getDirections() {
                        let e = {};
                        return e.local = h.SDPMuggle.detectDirections(this.impl.localDescription.sdp), e.remote = h.SDPMuggle.detectDirections(this.impl.remoteDescription.sdp), e;
                    }
                    _createImpl(e) {
                        if (p.Client.getInstance().config() && p.Client.getInstance().config().experiments && p.Client.getInstance().config().experiments.relayOnly && (e = Object.assign(Object.assign({}, e), {
                            iceTransportPolicy: "relay"
                        })), p.Client.getInstance().isInsertableStreamsSupported() && (this.logger.warning("encodedInsertableStreams is enabled"), e = Object.assign(Object.assign({}, e), {
                            encodedInsertableStreams: !0
                        })), this.mode === i.PeerConnectionMode.CONFERENCE && "chrome" === a.default.getWSVendor()) {
                            const t1 = {
                                mandatory: {},
                                optional: []
                            }, n = RTCPeerConnection;
                            this.impl = new n(e, t1);
                        } else this.impl = new RTCPeerConnection(e);
                        this._call = c.CallManager.get().calls[this.id], S.registerSource(this.impl, (e)=>{
                            if (this._call) {
                                const t1 = {};
                                this._call.getEndpoints().forEach((e)=>{
                                    e.mediaRenderers.forEach((n)=>{
                                        n.transceivers[0] && n.transceivers[0].receiver && n.transceivers[0].receiver.track && (t1[n.transceivers[0].receiver.track.id] = {
                                            mr: n.id,
                                            ep: e.id
                                        });
                                    });
                                });
                                const n = {};
                                for(let r in e.inbound)t1[r] ? (n[t1[r].mr] = e.inbound[r], n[t1[r].mr].endpoint = t1[r].ep) : n[r] = e.inbound[r];
                                e.inbound = n, this._call.dispatchEvent({
                                    name: u.CallEvents.CallStatsReceived,
                                    stats: e
                                });
                            }
                        }, null, this._call), this.impl.getTransceivers && "firefox" === a.default.getWSVendor() && (s.PCFactory.hasTransceivers = !0), this.impl.addEventListener("track", (e)=>this.onAddTrack(e)), this.impl.onicecandidate = (e)=>{
                            this.onICECandidate(e.candidate);
                        }, this.renegotiationInProgress = !1, this.impl.onsignalingstatechange = (e)=>this.onSignalingStateChange(), this.impl.oniceconnectionstatechange = (e)=>this.onConnectionChange(), this.impl.onconnectionstatechange = (e)=>{
                            this._call && this._call.dispatchEvent({
                                name: "SDP",
                                origin: "onconnectionstatechange",
                                description: this.impl.connectionState
                            });
                        }, this.impl.onicegatheringstatechange = (e)=>{
                            this._call && this._call.dispatchEvent({
                                name: "SDP",
                                origin: "onicegatheringstatechange",
                                description: this.impl.iceGatheringState
                            });
                        }, this.iceRole = R.controlling, this._remoteStreams = [], this.banReinviteAnswer = !1, void 0 !== this._call ? this.onHold = !this._call.active() : this.onHold = !1, this.needTransportRestart = !1, "_default" !== this.id && c.CallManager.get().calls[this.id] && (this.reInviteQ = new f.ReInviteQ(c.CallManager.get().calls[this.id], this._canReInvite));
                    }
                    onSignalingStateChange() {
                        this._call && this._call.dispatchEvent({
                            name: "SDP",
                            origin: "onsignalingstatechange",
                            description: this.impl.signalingState
                        }), this.logger.info("Signal state changed to " + this.impl.signalingState + " for PC: " + this.id), "stable" === this.impl.signalingState && (this.reInviteQ && this.reInviteQ.runNext(), this._addIceCandidatesFromQueue());
                    }
                    onConnectionChange() {
                        this.logger.info(`PCS: ${this.impl.connectionState} ${this.impl.iceConnectionState}`), this._call && this._call.dispatchEvent({
                            name: "SDP",
                            origin: "oniceconnectionstatechange",
                            description: this.impl.iceConnectionState
                        }), "failed" !== this.impl.iceConnectionState && "disconnected" !== this.impl.iceConnectionState || c.CallManager.get().icerestart(), "closed" === this.impl.connectionState && this._call && _.get().remCallStream(this._call), "completed" === this.impl.iceConnectionState && void 0 !== this._call && (this._call.dispatchEvent({
                            name: "ICECompleted",
                            call: this._call
                        }), clearTimeout(this.iceTimer)), "completed" !== this.impl.iceConnectionState && "connected" !== this.impl.iceConnectionState || (this.iceTimer && clearTimeout(this.iceTimer), this.iceTimer = null, this.reInviteQ && this.reInviteQ.runNext());
                    }
                    onRenegotiation() {
                        if (this._call && this._call.dispatchEvent({
                            name: "SDP",
                            origin: "negotiationneeded",
                            description: "negotiationneeded"
                        }), void 0 !== this.impl) {
                            if ("disconnected" !== this.impl.connectionState && "failed" !== this.impl.connectionState) {
                                if (null !== this.impl.localDescription) return "connected" !== this.impl.iceConnectionState && "completed" !== this.impl.iceConnectionState ? (this.logger.info("Renegotiation requested while ice state is " + this.impl.iceConnectionState + ". Postponing"), void setTimeout(this.onRenegotiation, 100)) : void (this.renegotiationInProgress ? this.logger.info("Renegotiation in progress. Queueing") : (this.logger.info("Renegotiation started"), this._runReinvite()));
                                this.logger.info("Renegotiation needed, but no local SD. Skipping");
                            } else this.logger.info("Renegotiation requested on closed PeerConnection");
                        }
                    }
                    getReceiveOptions() {
                        return {
                            offerToReceiveAudio: !this.onHold,
                            offerToReceiveVideo: !this.onHold,
                            voiceActivityDetection: !0
                        };
                    }
                    onICECandidate(e) {
                        e && "" !== e.candidate ? this.sendLocalCandidateToPeer("a=" + e.candidate, e.sdpMLineIndex) : this.logger.info("End of candidates");
                    }
                    onAddTrack(e) {
                        if (this._call) {
                            const t1 = c.CallManager.get().getEndpointManager(this._call);
                            this._call.settings.isConference || "inactive" !== e.transceiver.direction || (e.transceiver.direction = "recvonly"), this.updateTransceiver(t1, e.transceiver);
                        }
                    }
                    _runReinvite(e = !1) {
                        if (!1 === this.renegotiationInProgress) {
                            this.renegotiationInProgress = !0;
                            let t1 = {};
                            !a.default.isIphone() && (this._call.settings.isConference || this.impl.getTransceivers && "firefox" === a.default.getWSVendor()) || (t1 = this.getReceiveOptions()), e && (t1.iceRestart = !0), this.logger.trace(JSON.stringify(t1)), this.updateHoldState(), this.resetEncodings().then(()=>this.impl.createOffer(t1)).then((e)=>(this.logger.info(`_runReinvite(), created local SDP: \n${e.sdp}`), this.codecRearrange(e))).then((e)=>{
                                let t1 = {
                                    type: e.type,
                                    sdp: e.sdp
                                };
                                return t1 = s.PCFactory.get().addBandwidthParams(t1), t1 = h.SDPMuggle.removeTelephoneEvents(t1), t1 = h.SDPMuggle.removeDoubleOpus(t1), t1 = h.SDPMuggle.removeDoublePT(t1), t1 = h.SDPMuggle.trimMediaAttr(t1), t1 = h.SDPMuggle.removeDoubleCodecsInactiveSections(t1), t1 = this._reduceCodecs(t1), t1;
                            }).then((t1)=>{
                                this.srcLocalSDP = t1.sdp, this.impl.setLocalDescription(t1).then(()=>{
                                    this.logger.info(`_handleReinvite(), set remote SDP: \n${t1.sdp}`), this._call && this._call.dispatchEvent({
                                        name: "SDP",
                                        origin: "handleReinviteInProgress",
                                        sdp: t1.sdp
                                    });
                                    let n = {
                                        mids: this.getMidKinds(),
                                        iceRestart: e
                                    };
                                    C.default.callRemoteFunction(l.RemoteFunction.reInvite, this._call.id(), {}, t1.sdp, n);
                                });
                            }).catch((e)=>{
                                if (this._call) {
                                    const t1 = `offer_reject: Error when renegotiation start ${e.message}`;
                                    this._call.dispatchEvent({
                                        name: "SDP",
                                        origin: "_runReinvite",
                                        sdp: this.impl.localDescription,
                                        description: t1
                                    }), y.CallPromiseResolver.reject(this._call, t1);
                                }
                                this.logger.error("Error when renegotiation start " + e.message);
                            });
                        } else {
                            const e = "Another renegotiation in progress";
                            y.CallPromiseResolver.reject(this._call, e), this.logger.error(e);
                        }
                    }
                    codecRearrange(e) {
                        return new Promise((t1, n)=>{
                            let r = c.CallManager.get().calls[this.id];
                            if (void 0 !== r) {
                                let i = new g.CodecSorter(e.sdp), a = i.getUserCodecList();
                                void 0 !== r.rearangeCodecs ? r.rearangeCodecs(a, r.settings.incoming).then((n)=>{
                                    i.setUserCodecList(n), t1({
                                        type: e.type,
                                        sdp: i.getSDP()
                                    });
                                }, (e)=>{
                                    this.logger.error(JSON.stringify(e)), this._call && this._call.dispatchEvent({
                                        name: "SDP",
                                        origin: "codecRearrange",
                                        sdp: this.impl.localDescription,
                                        description: `reject: ${e.message}`
                                    }), n(e);
                                }) : (i.setUserCodecList(a), this.logger.info("No sdp codecs transformer registered"), t1({
                                    type: e.type,
                                    sdp: i.getSDP()
                                }));
                            } else t1(e);
                        });
                    }
                    __replaceTrack(e, t1) {
                        return new Promise((n, r)=>{
                            const i = e.sender.track;
                            a.default.isIpad() && !t1 ? (this.impl.removeTrack(e.sender), n()) : e.sender.replaceTrack(t1).then(()=>{
                                !i || t1 && i.id === t1.id || a.default.isIphone() || a.default.isIpad() || (i.enabled = !1, i.onended = null, i.onmute = null, i.stop()), n();
                            }).catch((t1)=>{
                                this.logger.warning(`The attempt to replace track for ${e.mid} failed`), r();
                            });
                        });
                    }
                    _setEncodingsParams(e, t1) {
                        if (this.isSimulcast()) {
                            let n = e.sender.getParameters();
                            n && n.encodings && n.encodings.length > 1 && n.encodings.forEach((e)=>{
                                let n = t1.find((t1)=>t1.rid === e.rid);
                                (null == n ? void 0 : n.maxBitrate) && (e.maxBitrate = n.maxBitrate), (null == n ? void 0 : n.maxFramerate) && (e.maxFramerate = n.maxFramerate), (null == n ? void 0 : n.scaleResolutionDownBy) && (e.scaleResolutionDownBy = n.scaleResolutionDownBy);
                            }), e.sender.setParameters(n);
                        } else {
                            let n = e.sender.getParameters();
                            n && n.encodings && n.encodings[0] && t1[0] && (t1[0].maxBitrate && (n.encodings[0].maxBitrate = t1[0].maxBitrate), t1[0].maxFramerate && (n.encodings[0].maxFramerate = t1[0].maxFramerate), t1[0].scaleResolutionDownBy && (n.encodings[0].scaleResolutionDownBy = t1[0].scaleResolutionDownBy)), e.sender.setParameters(n);
                        }
                    }
                    _getDefaultDirection() {
                        return this._call && this._call.settings.isConference && this._call.settings.simulcast ? "sendonly" : "sendrecv";
                    }
                    _addVideoTransceiver(e, t1, n) {
                        return new Promise((r, i)=>{
                            var a, s;
                            const o = c.CallManager.get().getEndpointManager(this._call), d = {
                                direction: this._getDefaultDirection(),
                                streams: [
                                    t1
                                ]
                            };
                            let l = this.getEmptyTransceiverForKind("video");
                            const g = e.getSettings();
                            if (l) {
                                if ("inactive" !== l.direction && "recvonly" !== l.direction || (l.direction = this._getDefaultDirection()), this.isSimulcast()) {
                                    const e = v.Utils.buildSimulcastLayers({
                                        trackSettings: g,
                                        trackType: n,
                                        profileName: null === (a = this._call) || void 0 === a ? void 0 : a.settings.simulcastProfileName
                                    });
                                    this._setEncodingsParams(l, e);
                                }
                                this.onHold && (l.direction = "sendonly"), this.__replaceTrack(l, e).then(()=>{
                                    this.updateTransceiver(o, l), this.onRenegotiation(), r();
                                });
                            } else {
                                if (this.isSimulcast()) d.sendEncodings = v.Utils.buildSimulcastLayers({
                                    trackSettings: g,
                                    trackType: n,
                                    profileName: null === (s = this._call) || void 0 === s ? void 0 : s.settings.simulcastProfileName
                                });
                                else {
                                    const t1 = e.getSettings();
                                    d.sendEncodings = v.Utils.buildNotSimulcastLayers({
                                        trackSettings: t1,
                                        trackType: n
                                    }), this.logger.info(`New encodings params were applied for ${n} track: ${JSON.stringify(d.sendEncodings)}`);
                                }
                                l = this.impl.addTransceiver(e, d), this.onRenegotiation(), this.updateTransceiver(o, l), r();
                            }
                        });
                    }
                    _reduceCodecs(e) {
                        const t1 = [
                            {
                                name: "H264",
                                params: {
                                    "profile-level-id": "42e0"
                                }
                            },
                            {
                                name: "VP8"
                            },
                            {
                                name: "red",
                                optional: !0
                            },
                            {
                                name: "ulpfec",
                                optional: !0
                            }
                        ], n = [
                            {
                                name: "telephone-event/8000"
                            },
                            {
                                name: "opus"
                            }
                        ], r = p.Client.getInstance().limitVCodecs || t1, i = p.Client.getInstance().limitACodecs || n;
                        if (p.Client.getInstance().limitVCodecs || p.Client.getInstance().limitACodecs) {
                            const t1 = h.SDPMuggle.reduceCodecs(e, {
                                video: r,
                                audio: i
                            }).sdp;
                            return this.logger.info(`_reduceCodecs(), SDP after codec was reduced: \n${t1.sdp}`), t1;
                        }
                        if (!this._call.settings.isConference) return e;
                        const a = h.SDPMuggle.reduceCodecs(e, {
                            audio: n,
                            video: t1
                        }).sdp;
                        return this.logger.info(`_reduceCodecs(), SDP after codec was reduced: \n${a.sdp}`), a;
                    }
                    isSimulcast() {
                        return this._call && !a.default.isIphone() && this._call.settings.isConference && this._call.settings.simulcast;
                    }
                    updateSenderTransformers() {
                        p.Client.getInstance().isInsertableStreamsSupported() && this._call && this.impl.getTransceivers().forEach((e)=>{
                            var t1;
                            if (null === (t1 = e.sender) || void 0 === t1 ? void 0 : t1.track) {
                                let t1;
                                this._TransceiverEncoderMap.has(e) ? t1 = this._TransceiverEncoderMap.get(e) : (t1 = e.sender.createEncodedStreams(), this._TransceiverEncoderMap.set(e, t1));
                                const n = "audio" === e.sender.track.kind ? this._call.audioSenderTransform : this._call.videoSenderTransform;
                                t1.readable.pipeThrough(n).pipeTo(t1.writable);
                            }
                        });
                    }
                    updateSenderTrackTransformers() {
                        if (!p.Client.getInstance().isMediaTrackInsertableStreamSupported() || !this._call) return;
                        let e = [];
                        e = m.default.StreamManager.get()._getScreenSharing(this._call) || [];
                        const t1 = [];
                        e.forEach((e)=>e.stream.getTracks().forEach((e)=>t1.push(e.id))), this.impl.getTransceivers().forEach(async (e)=>{
                            var n;
                            if ((null === (n = e.sender) || void 0 === n ? void 0 : n.track) && !t1.includes(e.sender.track.id)) {
                                let t1;
                                const n = e.sender.track;
                                "audio" === n.kind && "function" == typeof this._call.audioMediaTrackTransform ? t1 = await this._call.audioMediaTrackTransform(n) : "video" === n.kind && "function" == typeof this._call.videoMediaTrackTransform && (t1 = await this._call.videoMediaTrackTransform(n)), t1 && e.sender.replaceTrack(t1);
                            }
                        });
                    }
                    manageLayers(e) {
                        const t1 = this.impl.getTransceivers().filter((e)=>-1 !== e.currentDirection.indexOf("send")).filter((e)=>"video" === e.sender.track.kind);
                        t1.length && this.isSimulcast() && t1.forEach((t1)=>{
                            const n = t1.sender.getParameters();
                            n && n.encodings && n.encodings.length > 1 && (n.encodings = n.encodings.map((t1)=>(t1.rid && t1.maxBitrate && (t1.active = e.includes(t1.rid)), t1)));
                            try {
                                t1.sender.setParameters(n);
                            } catch (e) {
                                this.logger.error("Can't update simulcast parameters");
                            }
                        });
                    }
                    async resetEncodings() {
                        var e;
                        const t1 = this.impl.getTransceivers();
                        for (let n of t1)if (!isNaN(Number(n.mid)) && "audio" !== (null === (e = n.receiver.track) || void 0 === e ? void 0 : e.kind) && "inactive" !== n.direction && "stopped" !== n.direction && !n.stopped && (this.logger.info(`Reset simulcast layers for mid=${n.mid}`), "null" !== n.mid)) {
                            const e = n.sender.getParameters();
                            e && e.encodings && (e.encodings = e.encodings.map((e)=>(e.active = !0, e)), await n.sender.setParameters(e));
                        }
                    }
                    stopInactiveTransceiver(e) {
                        "inactive" !== e.currentDirection || this._call.settings.isConference || (e.stop(), this.logger.info(`Transceiver ${e.mid} was stopped.`));
                    }
                }
                r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_getLocalOfferRegular", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "updateHoldState", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_processRemoteAnswer", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_getLocalOffer", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_getLocalOfferFF", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_getLocalAnswer", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_setRemoteDescription", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_handleReinvite", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_close", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_addRemoteCandidate", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "setConfiguration", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_sendDTMF", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_hdnFRSPrep", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_hdnFRS", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "hasLocalAudio", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "enableVideo", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_replaceSharingToVideo", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_addCustomMedia", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_removeCustomMedia", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_updateCustomMedia", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_fixFFSoundBug", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "getConfiguration", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_hold", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_createImpl", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "onSignalingStateChange", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "onConnectionChange", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "onRenegotiation", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "getReceiveOptions", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "onICECandidate", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "onAddTrack", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "codecRearrange", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_setEncodingsParams", null), r([
                    o.LogManager.d_trace(o.LogCategory.RTC)
                ], L.prototype, "_reduceCodecs", null), t1.TransreceiverPC = L;
            },
            6278: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.ConfSignalingRemoteFunctions = t1.ConfSignalingRemoteEvents = t1.ConfSignaling = t1.ConfSignalingState = void 0;
                const i = n(1150), a = n(2282), s = n(8597), o = n(1901);
                var d;
                !function(e) {
                    e[e.CONNECTING = 0] = "CONNECTING", e[e.CONNECTED = 1] = "CONNECTED", e[e.CLOSED = 2] = "CLOSED";
                }(d = t1.ConfSignalingState || (t1.ConfSignalingState = {}));
                class c {
                    constructor(e){
                        this.call = e, this.reconnectionAttempts = 10, this.logger = i.LogManager.get().createLogger(i.LogCategory.SIGNALING, this._traceName()), this.currentState = d.CONNECTING, e.sysOn(a.CallEvents.Connected, (t1)=>{
                            const n = (t1)=>{
                                try {
                                    let r = JSON.parse(t1.text);
                                    "vi/upgrade" === r.event && (this.rand = r.rand, this.connectTo(r.url), e.sysOff(a.CallEvents.MessageReceived, n));
                                } catch (e) {
                                    this.logger.warning("Can't parse JSON data: " + e.text);
                                }
                            };
                            e.sysOn(a.CallEvents.MessageReceived, n), e.sendMessage("vi/upgrade");
                        });
                    }
                    _traceName() {
                        return "ConfSignaling";
                    }
                    connectTo(e) {
                        this.lastWSUrl = e, this.ws = new WebSocket(e), this.ws.onopen = (e)=>this.onWSConnected(), this.ws.onclose = (e)=>this.onWSClosed(e), this.ws.onerror = (e)=>this.onWSError(e), this.ws.onmessage = (e)=>this.onWSData(e.data);
                    }
                    onWSConnected() {
                        this.connectingTimer = setTimeout(()=>{
                            this.ws.close();
                        }, 2e3), this.ws.send(this.rand);
                    }
                    onWSClosed(e) {
                        this.ws && (this.ws.close(), this.ws = void 0), this.currentState = d.CLOSED, e.wasClean || this.reconnect();
                    }
                    reconnect() {
                        this.reconnectionAttempts > 0 && (this.reconnectionAttempts--, this.connectTo(this.lastWSUrl));
                    }
                    onWSError(e) {
                        this.ws.close(), this.ws = void 0, this.currentState = d.CLOSED, this.logger.warning("Error in onConfSignalingConnectionFailed callback: " + e);
                    }
                    onWSData(e) {
                        var t1;
                        let n;
                        try {
                            switch(n = JSON.parse(e), n.name){
                                case "vad":
                                    this.call.getEndpoints().forEach((e)=>{
                                        if (e.id === n.endpoint) {
                                            let t1 = s.EndpointEvents.VoiceEnd;
                                            n.enabled && (t1 = s.EndpointEvents.VoiceStart), e.dispatchEvent({
                                                name: t1,
                                                call: this.call,
                                                endpoint: e
                                            });
                                        }
                                    });
                                    break;
                                case "hello":
                                    clearInterval(this.connectingTimer), this.reconnectionAttempts = 10, this.currentState = d.CONNECTED;
                                    break;
                                case "endpointStreamsUpdated":
                                    this.logger.info(`Received endpointStreamsUpdated event with payload ${JSON.stringify(n.payload)}`), n.payload && (null === (t1 = o.EndpointStreamsUpdatedHandler.getInstanceBy(this.call)) || void 0 === t1 || t1.handle(n.payload));
                                    break;
                                case "message":
                                    this.call.dispatchEvent({
                                        name: a.CallEvents.MessageReceived,
                                        call: this.call,
                                        text: n.payload
                                    });
                                    break;
                                default:
                                    this.logger.info("Unknown command: " + n.name);
                            }
                        } catch (t1) {
                            this.logger.warning("Can't parse JSON data: " + e);
                        }
                    }
                    runFunction(e, t1) {
                        this.ws.send(JSON.stringify({
                            name: e,
                            payload: t1
                        }));
                    }
                }
                r([
                    i.LogManager.d_trace(i.LogCategory.SIGNALING)
                ], c.prototype, "connectTo", null), r([
                    i.LogManager.d_trace(i.LogCategory.SIGNALING)
                ], c.prototype, "onWSConnected", null), r([
                    i.LogManager.d_trace(i.LogCategory.SIGNALING)
                ], c.prototype, "onWSClosed", null), r([
                    i.LogManager.d_trace(i.LogCategory.SIGNALING)
                ], c.prototype, "reconnect", null), r([
                    i.LogManager.d_trace(i.LogCategory.SIGNALING)
                ], c.prototype, "onWSError", null), r([
                    i.LogManager.d_trace(i.LogCategory.SIGNALING)
                ], c.prototype, "onWSData", null), t1.ConfSignaling = c, function(e) {
                    e.VAD = "vad", e.MUTE = "mute", e.MANAGE_ENDPOINTS = "manageEndpoints", e.MESSAGE = "message", e.ENDPOINT_STREAMS_UPDATED = "endpointStreamsUpdated";
                }(t1.ConfSignalingRemoteEvents || (t1.ConfSignalingRemoteEvents = {})), function(e) {
                    e.MUTE = "mute", e.MANAGE_ENDPOINTS = "manageEndpoints", e.MESSAGE = "message", e.REQUEST_VIDEO_SIZE = "requestVideoSize";
                }(t1.ConfSignalingRemoteFunctions || (t1.ConfSignalingRemoteFunctions = {}));
            },
            8202: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.MsgAction = void 0, function(e) {
                    e.UNKNOWN = "UNKNOWN", e.createConversation = "createConversation", e.editConversation = "editConversation", e.removeConversation = "removeConversation", e.joinConversation = "joinConversation", e.leaveConversation = "leaveConversation", e.getConversation = "getConversation", e.getConversations = "getConversations", e.getPublicConversations = "getPublicConversations", e.searchConversations = "searchConversations", e.removeEmptyConversation = "removeEmptyConversation", e.addParticipants = "addParticipants", e.editParticipants = "editParticipants", e.removeParticipants = "removeParticipants", e.getUser = "getUser", e.getUsers = "getUsers", e.editUser = "editUser", e.setStatus = "setStatus", e.sendMessage = "sendMessage", e.editMessage = "editMessage", e.removeMessage = "removeMessage", e.typingMessage = "typingMessage", e.isRead = "isRead", e.subscribe = "subscribe", e.unsubscribe = "unsubscribe", e.manageNotification = "manageNotification", e.getSubscriptionList = "getSubscriptionList", e.createBot = "createBot", e.removeBot = "removeBot", e.retransmitEvents = "retransmitEvents";
                }(t1.MsgAction || (t1.MsgAction = {}));
            },
            249: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.MsgEvent = void 0, function(e) {
                    e.onError = "onError", e.onCreateConversation = "onCreateConversation", e.onEditConversation = "onEditConversation", e.onRemoveConversation = "onRemoveConversation", e.onGetConversation = "onGetConversation", e.onGetPublicConversations = "onGetPublicConversations", e.onGetUser = "onGetUser", e.onEditUser = "onEditUser", e.onSetStatus = "onSetStatus", e.onSendMessage = "onSendMessage", e.onEditMessage = "onEditMessage", e.onRemoveMessage = "onRemoveMessage", e.isRead = "isRead", e.onTyping = "onTyping", e.onSubscribe = "onSubscribe", e.onUnsubscribe = "onUnsubscribe", e.onGetSubscriptionList = "onGetSubscriptionList", e.onCreateBot = "onCreateBot", e.onRemoveBot = "onRemoveBot", e.onRetransmitEvents = "onRetransmitEvents";
                }(t1.MsgEvent || (t1.MsgEvent = {}));
            },
            7050: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.MsgSignaling = void 0;
                const i = n(1150), a = n(249), s = n(3576), o = n(6968), d = n(209), c = n(245);
                class l extends s.EventTarget {
                    constructor(){
                        if (super(), l.instance) throw new Error("Error - use Client.getMessagingInstance()");
                        this.query = [], setInterval(()=>{
                            this.updateQuery();
                        }, 220);
                    }
                    static get() {
                        return l.instance = l.instance || new l, l.instance;
                    }
                    capitalize(e) {
                        return e.toString()[0].toUpperCase() + e.toString().slice(1);
                    }
                    updateQuery() {
                        if (this.query.length) {
                            const e = this.query.splice(0, 1);
                            c.default.sendRaw(e[0]);
                        }
                    }
                    addEventListener(e, t1, n) {
                        super.addEventListener(e, t1, n);
                    }
                    dispatchMsgEvent(e, t1) {
                        var n, r;
                        if (null === (n = this.eventListeners) || void 0 === n ? void 0 : n[e]) {
                            const n = this.eventListeners[e];
                            for (let e of n)null === (r = e.listener) || void 0 === r || r.call(e, null == t1 ? void 0 : t1.payload, null == t1 ? void 0 : t1.request_uuid);
                        }
                    }
                    handleWsData(e) {
                        if (-1 == Object.values(a.MsgEvent).indexOf(e.event)) throw new Error("Unknown messaging event " + e.event + " with payload " + JSON.stringify(e.payload));
                        this.dispatchMsgEvent(e.event, e);
                    }
                    sendWsMessage(e, t1) {
                        const n = [
                            "subscribe",
                            "unsubscribe",
                            "typingMessage",
                            "isRead",
                            "setStatus"
                        ].includes(e) ? "CommonNamespace" : "IncomingNamespace", r = (new d.default).toString(), i = {
                            service: o.MsgService.Chat,
                            event: e,
                            payload: Object.assign(t1, {
                                "@type": `type/vox.store.${n}.${{
                                    setStatus: "PresenceMessage",
                                    isRead: "StatusMessage",
                                    typingMessage: "TypingMessage",
                                    subscribe: "ManageSubscribes",
                                    unsubscribe: "ManageSubscribes",
                                    addParticipants: "ManageParticipants",
                                    editParticipants: "ManageParticipants",
                                    manageNotification: "ManageNotifications",
                                    getPublicConversations: "GetConversations",
                                    retransmitEvents: "RetransmitRequest"
                                }[e] || this.capitalize(e)}`
                            }),
                            request_uuid: r
                        };
                        return this.query.push(i), r;
                    }
                    _traceName() {
                        return "MsgSignaling";
                    }
                }
                r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], l.prototype, "handleWsData", null), r([
                    i.LogManager.d_trace(i.LogCategory.MESSAGING)
                ], l.prototype, "sendWsMessage", null), t1.MsgSignaling = l;
            },
            575: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.RemoteEvent = void 0, function(e) {
                    e[e.loginFailed = "loginFailed"] = "loginFailed", e[e.loginSuccessful = "loginSuccessful"] = "loginSuccessful", e[e.handleError = "handleError"] = "handleError", e[e.onPCStats = "__onPCStats"] = "onPCStats", e[e.handleIncomingConnection = "handleIncomingConnection"] = "handleIncomingConnection", e[e.handleConnectionConnected = "handleConnectionConnected"] = "handleConnectionConnected", e[e.handleConnectionDisconnected = "handleConnectionDisconnected"] = "handleConnectionDisconnected", e[e.handleRingOut = "handleRingOut"] = "handleRingOut", e[e.startEarlyMedia = "startEarlyMedia"] = "startEarlyMedia", e[e.stopRinging = "stopRinging"] = "stopRinging", e[e.handleConnectionFailed = "handleConnectionFailed"] = "handleConnectionFailed", e[e.handleSIPInfo = "handleSIPInfo"] = "handleSIPInfo", e[e.handleSipEvent = "handleSipEvent"] = "handleSipEvent", e[e.handleTransferStarted = "handleTransferStarted"] = "handleTransferStarted", e[e.handleTransferComplete = "handleTransferComplete"] = "handleTransferComplete", e[e.handleTransferFailed = "handleTransferFailed"] = "handleTransferFailed", e[e.handleReInvite = "handleReInvite"] = "handleReInvite", e[e.handleAcceptReinvite = "handleAcceptReinvite"] = "handleAcceptReinvite", e[e.handleRejectReinvite = "handleRejectReinvite"] = "handleRejectReinvite", e[e.createPC = "__createPC"] = "createPC", e[e.destroyPC = "__destroyPC"] = "destroyPC", e[e.connectionSuccessful = "__connectionSuccessful"] = "connectionSuccessful", e[e.connectionFailed = "__connectionFailed"] = "connectionFailed", e[e.createConnection = "__createConnection"] = "createConnection", e[e.pong = "__pong"] = "pong", e[e.increaseGain = "increaseGain"] = "increaseGain", e[e.handlePreFlightCheckResult = "handlePreFlightCheckResult"] = "handlePreFlightCheckResult", e[e.handleVoicemail = "handleVoicemail"] = "handleVoicemail", e[e.onCallRemoteFunctionError = "onCallRemoteFunctionError"] = "onCallRemoteFunctionError", e[e.refreshOauthTokenFailed = "refreshOauthTokenFailed"] = "refreshOauthTokenFailed", e[e.refreshOauthTokenSuccessful = "refreshOauthTokenSuccessful"] = "refreshOauthTokenSuccessful", e[e.registerPushTokenResult = "registerPushTokenResult"] = "registerPushTokenResult", e[e.unregisterPushTokenResult = "unregisterPushTokenResult"] = "unregisterPushTokenResult", e[e.sipRegisterSuccessful = "sipRegisterSuccessful"] = "sipRegisterSuccessful", e[e.sipRegisterFailed = "sipRegisterFailed"] = "sipRegisterFailed", e[e.onACDStatus = "onACDStatus"] = "onACDStatus", e[e.SQMessagingStatusUpdated = "SQMessagingStatusUpdated"] = "SQMessagingStatusUpdated", e[e.onSQStatusError = "onSQStatusError"] = "onSQStatusError", e[e.onICEConfig = "onICEConfig"] = "onICEConfig", e[e.onICEConfigFailed = "onICEConfigFailed"] = "onICEConfigFailed";
                }(t1.RemoteEvent || (t1.RemoteEvent = {}));
            },
            4106: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.RemoteFunction = void 0, function(e) {
                    e[e.ping = "__ping"] = "ping", e[e.login = "login"] = "login", e[e.loginGenerateOneTimeKey = "loginGenerateOneTimeKey"] = "loginGenerateOneTimeKey", e[e.loginStage2 = "loginStage2"] = "loginStage2", e[e.setOperatorACDStatus = "setOperatorACDStatus"] = "setOperatorACDStatus", e[e.getOperatorACDStatus = "getOperatorACDStatus"] = "getOperatorACDStatus", e[e.setOperatorMessagingStatus = "setOperatorMessagingStatus"] = "setOperatorMessagingStatus", e[e.getOperatorMessagingStatus = "getOperatorMessagingStatus"] = "getOperatorMessagingStatus", e[e.setDesiredVideoBandwidth = "setDesiredVideoBandwidth"] = "setDesiredVideoBandwidth", e[e.rejectCall = "rejectCall"] = "rejectCall", e[e.disconnectCall = "disconnectCall"] = "disconnectCall", e[e.sendDTMF = "sendDTMF"] = "sendDTMF", e[e.sendSIPInfo = "sendSIPInfo"] = "sendSIPInfo", e[e.hold = "hold"] = "hold", e[e.unhold = "unhold"] = "unhold", e[e.acceptCall = "acceptCall"] = "acceptCall", e[e.createCall = "createCall"] = "createCall", e[e.callConference = "callConference"] = "callConference", e[e.transferCall = "transferCall"] = "transferCall", e[e.muteLocal = "__muteLocal"] = "muteLocal", e[e.reInvite = "ReInvite"] = "reInvite", e[e.acceptReInvite = "AcceptReInvite"] = "acceptReInvite", e[e.rejectReInvite = "RejectReInvite"] = "rejectReInvite", e[e.confirmPC = "__confirmPC"] = "confirmPC", e[e.addCandidate = "__addCandidate"] = "addCandidate", e[e.loginUsingOneTimeKey = "loginUsingOneTimeKey"] = "loginUsingOneTimeKey", e[e.refreshOauthToken = "refreshOauthToken"] = "refreshOauthToken", e[e.confirmIncomingConnection = "confirmIncomingConnection"] = "confirmIncomingConnection", e[e.zPromptFinished = "promptFinished"] = "zPromptFinished", e[e.zStartPreFlightCheck = "__startPreFlightCheck"] = "zStartPreFlightCheck", e[e.registerPushToken = "registerPushToken"] = "registerPushToken", e[e.unregisterPushToken = "unregisterPushToken"] = "unregisterPushToken", e[e.pushFeedback = "pushFeedback"] = "pushFeedback", e[e.refreshIceConfig = "refreshIceConfig"] = "refreshIceConfig";
                }(t1.RemoteFunction || (t1.RemoteFunction = {}));
            },
            245: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.VoxSignalingState = void 0;
                const r = n(2262), i = n(7050), a = n(3576), s = n(125), o = n(141), d = n(308), c = [];
                let l = null;
                class g extends a.EventTarget {
                }
                const u = new g;
                function h(e, t1) {
                    1 === e && 2 === t1 && c.forEach((e)=>e.onSignalingConnected()), 3 === t1 && c.forEach((e)=>e.onSignalingConnectionFailed("")), 4 === t1 && s.Client.getInstance().dispatchEvent({
                        name: o.Events.Reconnecting
                    }), 4 === e && 2 === t1 && (s.Client.getInstance().dispatchEvent({
                        name: o.Events.Reconnected
                    }), d.CallManager.get().icerestart()), 5 === t1 && c.forEach((e)=>e.onSignalingClosed());
                }
                function p(e) {
                    e.service ? i.MsgSignaling.get().handleWsData(e) : u.eventListeners[e.name] && u.eventListeners[e.name].forEach((t1)=>t1.listener.apply(null, e.params));
                }
                const f = {
                    setRPCHandler: function(e, t1) {
                        u.addEventListener(e, t1);
                    },
                    removeRPCHandler: function(e, t1) {
                        u.removeEventListener(e, t1);
                    },
                    callRemoteFunction: function(e, ...t1) {
                        return l.send({
                            name: e,
                            params: t1
                        }), !0;
                    },
                    addHandler: function(e) {
                        c.push(e);
                    },
                    onConnectionFailedRPC: function() {},
                    currentState: function() {
                        if (!l) return m.IDLE;
                        switch(l.state){
                            case 0:
                            case 3:
                            case 5:
                            default:
                                return m.IDLE;
                            case 1:
                                return m.CONNECTING;
                            case 2:
                            case 4:
                                return m.CONNECTED;
                        }
                    },
                    disconnect: async function() {
                        l && (await l.clear(), l = null);
                    },
                    connect: async function(e, t1) {
                        if (!l || 5 === l.state || 3 === l.state) return l = new r.Connection(e, 2, Array.isArray(t1) ? t1 : [
                            t1
                        ]), l.outerMessageHandler = p, l.outerStateHandler = h, await l.connect(), 2 === l.state || (await l.clear(), l = null, !1);
                    },
                    sendRaw: function(e) {
                        return l.send(e);
                    }
                };
                var m;
                !function(e) {
                    e[e.IDLE = 0] = "IDLE", e[e.CONNECTING = 1] = "CONNECTING", e[e.WSCONNECTED = 2] = "WSCONNECTED", e[e.CONNECTED = 3] = "CONNECTED", e[e.CLOSING = 4] = "CLOSING";
                }(m = t1.VoxSignalingState || (t1.VoxSignalingState = {})), t1.default = f;
            },
            2262: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                }, i = this && this.__asyncValues || function(e) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var t1, n = e[Symbol.asyncIterator];
                    return n ? n.call(e) : (e = "function" == typeof __values ? __values(e) : e[Symbol.iterator](), t1 = {}, r("next"), r("throw"), r("return"), t1[Symbol.asyncIterator] = function() {
                        return this;
                    }, t1);
                    function r(n) {
                        t1[n] = e[n] && function(t1) {
                            return new Promise(function(r, i) {
                                (function(e, t1, n, r) {
                                    Promise.resolve(r).then(function(t1) {
                                        e({
                                            value: t1,
                                            done: n
                                        });
                                    }, t1);
                                })(r, i, (t1 = e[n](t1)).done, t1.value);
                            });
                        };
                    }
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Connection = void 0;
                const a = n(4234), s = n(1783), o = n(5383), d = n(3658), c = n(2071), l = n(9367), g = n(1666), u = n(125), h = n(1150), p = n(5604);
                class f {
                    constructor(e, t1, n){
                        this.logger = h.LogManager.get().createLogger(0, "SIG2"), this.messageHandler = async (e, t1)=>{
                            this.logger.info(a.t("INFO_CONN_MESSAGE", t1.uuid, e));
                            try {
                                const n = JSON.parse(e);
                                if (!n.type) return void this.logger.error(a.t("ERR_CONN_MESSAGE_FORMAT_TYPE", "type"));
                                switch(n.type){
                                    case "close":
                                        this.validateSeq(n.seq, t1) && await this.processClose(n);
                                        break;
                                    case "ack":
                                        await this.processAck(n);
                                        break;
                                    case "error":
                                        this.awaitingTransportHandler && (this.destroyTransportSilent(this.awaitingTransportHandler.transport), this.awaitingTransportHandler.resolve(p.CONNECTION_CODE.SERVER_ERROR), this.awaitingTransportHandler = null);
                                        break;
                                    case "id":
                                        await this.setConnectionId(n), await this.sendData({
                                            type: "lastrx",
                                            seq: this.remoteClock
                                        });
                                        break;
                                    case "lastrx":
                                        await this.processLastRtx(n);
                                        break;
                                    case "msg":
                                        this.validateSeq(n.seq, t1) && await this.processMsg(n);
                                        break;
                                    default:
                                        this.logger.error(a.t("ERR_CONN_MESSAGE_FORMAT_TYPE", "type"));
                                }
                            } catch (e) {
                                this.logger.error(a.t("ERR_CONN_MESSAGE_PARSING_ERR")), console.error(e);
                            }
                        }, this.onTransportClose = async (e, t1)=>{
                            if (this.logger.info(a.t("INFO_CONN_TRANSPORT_CLOSED", e.uuid, t1.reason, t1.code.toString())), e.onClose = null, e.messageHandler = null, !this.transportList.has(e)) return;
                            const n = Array.from(this.transportList).some((e)=>1 === e.state || 0 === e.state);
                            this.transportList.delete(e), n || (this.connectionId ? (this.logger.info(a.t("INFO_CONN_RECONNECT_NEEDED")), 2 === this.state && (this.setState(4), await this.reconnect() ? this.setState(2) : this.setState(5))) : this.setState(3));
                        }, this.state = 0, this.config = {
                            balancerUrl: "https://balancer.voximplant.com/getNearestHost",
                            acdVersion: e,
                            imVersion: t1,
                            servers: Array.from(n)
                        };
                    }
                    validateSeq(e, t1) {
                        return e === this.remoteClock + 1 || (this.logger.warning(a.t("INFO_CONN_BALANCER", e.toString(), this.remoteClock.toString(), t1.uuid)), t1.destroy(g.TransportCloseCodes.WRONG_SEQ, "Wrong seq"), !1);
                    }
                    async setConnectionId(e) {
                        this.logger.info(a.t("INFO_CONN_CONNECTION_ID_SET", e.id)), this.connectionId = e.id, this.awaitingTransportHandler && (this.awaitingTransportHandler.resolve(p.CONNECTION_CODE.CONNECTED), this.awaitingTransportHandler = null);
                    }
                    async processAck(e) {
                        const t1 = Array.from(this.messagePool.keys()).sort()[0];
                        this.logger.trace(a.t("TRACE_CONN_ACK_RECEIVED", e.seq.toString(), this.localClock.toString(), t1.toString()));
                        let n = 0;
                        for(let r = t1; r <= e.seq; r++)this.messagePool.has(r) && (this.messagePool.delete(r), n++);
                        this.ackTimeout && (clearTimeout(this.ackTimeout), this.ackTimeout = null), this.logger.trace(a.t("TRACE_CONN_ACK_CLEARED", n.toString()));
                    }
                    async processLastRtx(e) {
                        const t1 = this.localClock - e.seq;
                        let n = 0;
                        for(let t1 = e.seq; t1 <= this.localClock; t1++){
                            const e = this.messagePool.get(t1);
                            e && (await this.sendData(e), n++);
                        }
                        this.logger.trace(a.t("TRACE_CONN_RETRANSMIT", e.seq.toString(), this.localClock.toString(), t1.toString(), n.toString()));
                    }
                    async processClose(e) {
                        await this.clearRoutine(!1);
                    }
                    async processMsg(e) {
                        this.remoteClock = e.seq, this.outerMessageHandler && this.outerMessageHandler(e.payload), this.sendACK();
                    }
                    transformMsgPayload(e) {
                        if (e.payload.service) {
                            const t1 = e.payload;
                            return Object.assign({
                                name: `${t1.service}.${t1.event}`
                            }, e.payload);
                        }
                        if (e.payload.name) {
                            const t1 = e.payload;
                            return Object.assign({
                                name: `GW.${t1.name}`
                            }, c.hydratePayload(t1.name, t1.params));
                        }
                        return {
                            name: "UnknownGWMessage",
                            payload: e.payload
                        };
                    }
                    sendACK() {
                        this.sendData({
                            type: "ack",
                            seq: this.remoteClock
                        }).catch((e)=>{});
                    }
                    async send(e) {
                        if (1 !== this.state && 2 !== this.state && 4 !== this.state) return void this.logger.warning(a.t("WARN_CONN_WRONG_STATE", "send message", u.Client.getInstance().getClientState().toString(), "" + this.state));
                        const t1 = ++this.localClock, n = {
                            type: "msg",
                            seq: t1,
                            payload: e
                        };
                        this.messagePool.set(t1, n), this.ackTimeout || 2 !== this.state || (this.ackTimeout = setTimeout(()=>{
                            this.transportList.forEach((e)=>e.destroy(g.TransportCloseCodes.TIMEOUT)), clearTimeout(this.ackTimeout);
                        }, 6e3)), await this.sendData(n);
                    }
                    async sendData(e) {
                        var t1, n;
                        const r = this.transportList.values();
                        try {
                            for(var s, o = i(r); !(s = await o.next()).done;){
                                const t1 = s.value;
                                this.logger.info(a.t("INFO_CONN_TO_MESSAGE", t1.uuid, JSON.stringify(e))), await t1.send(JSON.stringify(e));
                            }
                        } catch (e) {
                            t1 = {
                                error: e
                            };
                        } finally{
                            try {
                                s && !s.done && (n = o.return) && await n.call(o);
                            } finally{
                                if (t1) throw t1.error;
                            }
                        }
                    }
                    async requestBalancer() {
                        var e, t1, r, i;
                        let s = "https://balancer.voximplant.com/getNearestHost";
                        (null === (e = this.config) || void 0 === e ? void 0 : e.balancerUrl) && (0 === (null === (t1 = this.config) || void 0 === t1 ? void 0 : t1.balancerUrl.indexOf("https://")) ? s = null === (r = this.config) || void 0 === r ? void 0 : r.balancerUrl : this.logger.warning(a.t("WARN_CONN_WRONG_BALANCER_URL", null === (i = this.config) || void 0 === i ? void 0 : i.balancerUrl))), this.logger.info(a.t("INFO_CONN_BALANCER", s));
                        try {
                            const e = await n.g.fetch(s), t1 = await e.text();
                            if (200 !== e.status) throw new Error(`Response code: ${e.status}`);
                            if (0 === t1.length) throw new Error("Response body is empty");
                            return t1.split(";");
                        } catch (e) {
                            console.error(e), this.logger.error(a.t("ERR_CONN_WRONG_BALANCER_RESPONSE", e.message, s));
                        }
                        return [];
                    }
                    makeConnectionURL(e) {
                        var t1, r;
                        let i = "nodejs";
                        const a = n.g.navigator;
                        return (null == a ? void 0 : a.mozGetUserMedia) ? i = "firefox" : (null == a ? void 0 : a.webkitGetUserMedia) ? i = "chrome" : a && (i = "safari"), `wss://${e}/platform?version=5&client_version=4.6.3-2602&video=true&ccheck=false&client_platform=${i}&im_version=${(null === (t1 = this.config) || void 0 === t1 ? void 0 : t1.imVersion) || 2}&acd_version=${(null === (r = this.config) || void 0 === r ? void 0 : r.acdVersion) || 1}${this.connectionId ? "&id=" + this.connectionId : ""}&features=1`;
                    }
                    async connect() {
                        var e;
                        if (this.logger.info(a.t("INFO_CONN_START_CONNECTION")), this.state > 0) return void this.logger.warning(a.t("WARN_CONN_WRONG_STATE", "connect", s.VIConnectionStateStrings[this.state], "" + this.state));
                        this.setState(1), this.localClock = 0, this.remoteClock = 0, this.messagePool = new Map, this.transportList = new Set;
                        let t1 = null === (e = this.config) || void 0 === e ? void 0 : e.servers;
                        if (t1 && t1.length && t1[0] || (t1 = await this.requestBalancer()), 0 === t1.length) {
                            const e = a.t("ERR_CONN_FAILED", "No gateways to connect");
                            throw this.logger.error(e), this.setState(3), new Error(e);
                        }
                        this.logger.info(a.t("INFO_CONN_CONNECTION_POOL", t1.join(", ")));
                        if (await this.firstConnection(t1)) this.setState(2), this.pingInterval && clearInterval(this.pingInterval), this.pingInterval = setInterval(()=>this.doPing(), 2e3);
                        else {
                            a.t("ERR_CONN_FAILED", a.t("ERR_CONN_CLOUD_IS_UNREACHABLE", t1.join(", ")));
                            this.setState(3);
                        }
                    }
                    doPing() {
                        2 === this.state && this.send({
                            name: "__ping"
                        });
                    }
                    async reconnect() {
                        this.logger.info(a.t("INFO_CONN_RECONNECT", "1"));
                        let e = await this.connectToServer(this.currentServer);
                        if (console.error(e), e === p.CONNECTION_CODE.CONNECTED) return !0;
                        const t1 = async ()=>await this.connectToServer(this.currentServer), n = d.makePromiseTimeout(t1, 200), r = d.makePromiseTimeout(t1, 1e3), i = d.makePromiseTimeout(t1, 5e3), s = [
                            n,
                            n,
                            r,
                            r,
                            r,
                            i,
                            i,
                            i,
                            i
                        ];
                        for(let t1 = 0; t1 < s.length; t1++)if (e !== p.CONNECTION_CODE.CONNECTED) switch(this.logger.info(a.t("INFO_CONN_RECONNECT", (t1 + 2).toString())), e = await s[t1](this.currentServer), console.error(e), e){
                            case p.CONNECTION_CODE.NOT_CONNECTED:
                                this.logger.info(a.t("INFO_CONN_RECONNECT_ATTEMPT_FAILED", (t1 + 2).toString()));
                                break;
                            case p.CONNECTION_CODE.SERVER_ERROR:
                                return !1;
                        }
                        return e === p.CONNECTION_CODE.CONNECTED;
                    }
                    async firstConnection(e) {
                        for (const t1 of e){
                            this.logger.info(a.t("INFO_CONN_CONNECT", t1));
                            if (await this.connectToServer(t1) === p.CONNECTION_CODE.CONNECTED) return this.logger.info(a.t("INFO_CONN_CONNECT_SUCCESSFUL", t1)), this.currentServer = t1, !0;
                        }
                        return !1;
                    }
                    async connectToServer(e) {
                        const t1 = this.makeConnectionURL(e), n = new o.Transport;
                        return await n.connect(t1) ? (this.transportList.add(n), this.logger.info(a.t("INFO_CONN_TRANSPORT_CONNECTED", n.uuid)), n.messageHandler = this.messageHandler, n.onClose = this.onTransportClose, await new Promise((e)=>{
                            this.awaitingTransportHandler && (this.destroyTransportSilent(this.awaitingTransportHandler.transport), this.awaitingTransportHandler.resolve(p.CONNECTION_CODE.NOT_CONNECTED)), this.awaitingTransportHandler = {
                                resolve: e,
                                transport: n
                            };
                        })) : (n.destroy(g.TransportCloseCodes.NOT_CONNECTED), 1);
                    }
                    async clear() {
                        await this.clearRoutine(!0);
                    }
                    async clearRoutine(e) {
                        if (0 === this.state || 3 === this.state || 5 === this.state) return void this.logger.warning(a.t("WARN_CONN_WRONG_STATE", "disconnect", s.VIConnectionStateStrings[this.state], "" + this.state));
                        this.pingInterval && clearInterval(this.pingInterval), this.logger.info(a.t("INFO_CONN_CLEAR")), this.setState(5);
                        const t1 = {
                            type: "close",
                            seq: this.localClock++
                        };
                        this.transportList.forEach((n)=>{
                            2 === n.state && e && n.send(JSON.stringify(t1)), this.destroyTransportSilent(n);
                        });
                    }
                    destroyTransportSilent(e) {
                        this.transportList.delete(e), e.onClose = null, e.messageHandler = null, e.destroy(g.TransportCloseCodes.CLIENT_ERROR, "Closing by connection"), this.logger.info(a.t("INFO_CONN_TRANSPORT_DESTROY", e.uuid));
                    }
                    setState(e) {
                        const t1 = this.state;
                        this.state = e, this.outerStateHandler && this.outerStateHandler(t1, e);
                    }
                }
                r([
                    l.throttleDecorator(5e3)
                ], f.prototype, "sendACK", null), t1.Connection = f;
            },
            5604: (e, t1)=>{
                "use strict";
                var n;
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.CONNECTION_CODE = void 0, function(e) {
                    e[e.CONNECTED = 0] = "CONNECTED", e[e.NOT_CONNECTED = 1] = "NOT_CONNECTED", e[e.SERVER_ERROR = 2] = "SERVER_ERROR";
                }(n || (n = {})), t1.CONNECTION_CODE = n;
            },
            1783: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.VIConnectionStateStrings = t1.VIConnectionState = void 0;
                const n = {
                    disconnected: 0,
                    connecting: 1,
                    connected: 2,
                    failed: 3,
                    reconnecting: 4,
                    closed: 5
                };
                t1.VIConnectionState = n;
                const r = Object.keys(n);
                t1.VIConnectionStateStrings = r;
            },
            2071: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.dehydratePayload = t1.hydratePayload = void 0;
                const n = {
                    loginFailed: [
                        "code",
                        "extra"
                    ],
                    loginSuccessful: [
                        "displayName",
                        "params"
                    ],
                    __onPCStats: [
                        "stats"
                    ],
                    handleIncomingConnection: [
                        "id",
                        "headers",
                        "sdp",
                        "extra"
                    ],
                    handleConnectionConnected: [
                        "id",
                        "headers",
                        "sdp",
                        "endpointData",
                        "scheme"
                    ],
                    handleConnectionDisconnected: [
                        "id",
                        "headers",
                        "params"
                    ],
                    handleRingOut: [
                        "id"
                    ],
                    startEarlyMedia: [
                        "id",
                        "headers",
                        "sdp",
                        "scheme"
                    ],
                    stopRinging: [
                        "id"
                    ],
                    handleConnectionFailed: [
                        "id",
                        "code",
                        "reason",
                        "headers"
                    ],
                    handleSIPInfo: [
                        "id",
                        "type",
                        "subType",
                        "body",
                        "headers"
                    ],
                    handleSipEvent: [
                        "id"
                    ],
                    handleTransferStarted: [
                        "id"
                    ],
                    handleTransferComplete: [
                        "id"
                    ],
                    handleTransferFailed: [
                        "id"
                    ],
                    handleReInvite: [
                        "id",
                        "headers",
                        "sdp",
                        "scheme"
                    ],
                    handleAcceptReinvite: [
                        "id",
                        "headers",
                        "sdp"
                    ],
                    handleRejectReinvite: [
                        "id",
                        "headers",
                        "sdp"
                    ],
                    __createPC: [
                        "id",
                        "sdp"
                    ],
                    __destroyPC: [
                        "id"
                    ],
                    __connectionSuccessful: [
                        "token"
                    ],
                    __connectionFailed: [],
                    __createConnection: [
                        "token"
                    ],
                    __pong: [],
                    increaseGain: [],
                    handlePreFlightCheckResult: [
                        "a",
                        "b",
                        "c"
                    ],
                    handleVoicemail: [
                        "event"
                    ],
                    refreshOauthTokenFailed: [
                        "code"
                    ],
                    refreshOauthTokenSuccessful: [
                        "oauth"
                    ],
                    registerPushTokenResult: [
                        "result"
                    ],
                    unregisterPushTokenResult: [
                        "result"
                    ],
                    sipRegisterSuccessful: [
                        "id",
                        "sipUri"
                    ],
                    sipRegisterFailed: [
                        "id",
                        "sipUri",
                        "status",
                        "reason"
                    ],
                    onACDStatus: [
                        "id",
                        "status",
                        "uuid",
                        "description"
                    ],
                    SQMessagingStatusUpdated: [
                        "id",
                        "status",
                        "uuid",
                        "description"
                    ],
                    onSQStatusError: [
                        "id",
                        "uuid",
                        "code",
                        "description"
                    ],
                    onICEConfig: [
                        "id",
                        "config"
                    ],
                    onICEConfigFailed: [
                        "id"
                    ]
                }, r = {
                    __ping: [],
                    login: [
                        "username",
                        "password"
                    ],
                    loginGenerateOneTimeKey: [],
                    setOperatorACDStatus: [],
                    getOperatorACDStatus: [],
                    setOperatorMessagingStatus: [],
                    getOperatorMessagingStatus: [],
                    setDesiredVideoBandwidth: [],
                    rejectCall: [],
                    disconnectCall: [],
                    sendDTMF: [],
                    sendSIPInfo: [],
                    hold: [],
                    unhold: [],
                    acceptCall: [],
                    createCall: [],
                    callConference: [],
                    transferCall: [],
                    __muteLocal: [],
                    ReInvite: [],
                    AcceptReInvite: [],
                    RejectReInvite: [],
                    __confirmPC: [],
                    __addCandidate: [],
                    loginUsingOneTimeKey: [],
                    refreshOauthToken: [],
                    promptFinished: [],
                    registerPushToken: [],
                    unregisterPushToken: [],
                    pushFeedback: []
                };
                t1.hydratePayload = function(e, t1) {
                    const r = n[e];
                    if (!r) throw new Error(`Rule unknown for ${e}`);
                    return t1.reduce((e, t1, n)=>(e[r[n]] = t1, e), {});
                }, t1.dehydratePayload = function(e, t1) {
                    const n = r[e];
                    if (!n) throw new Error(`Rule unknown for ${e}`);
                    return n.reduce((e, n)=>{
                        const r = t1[n] || null;
                        return e.push(r), e;
                    }, []);
                };
            },
            9367: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.throttleDecorator = void 0, t1.throttleDecorator = function(e = 200) {
                    let t1, r;
                    return (i, a, s)=>({
                            value: function(...i) {
                                var a;
                                t1 || (t1 = Date.now()), n.g.clearTimeout(r), t1 && Date.now() - t1 >= e ? (null === (a = s.value) || void 0 === a || a.apply(this, i), t1 = Date.now()) : r = n.g.setTimeout(()=>{
                                    var n;
                                    Date.now() - t1 >= e && (null === (n = s.value) || void 0 === n || n.apply(this, i), t1 = Date.now());
                                }, e - (Date.now() - t1));
                            }
                        });
                };
            },
            5383: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Transport = void 0;
                const r = n(1666), i = n(2957);
                t1.Transport = class {
                    constructor(){
                        this.state = 0, this.uuid = i.Utils.generateUUID();
                    }
                    send(e) {
                        if (this.ws.readyState === WebSocket.CLOSED || this.ws.readyState === WebSocket.CLOSING) return this.state = 4, this.parentOnClose("Client error", r.TransportCloseCodes.CLIENT_ERROR, !1), void this.ws.close(r.TransportCloseCodes.CLIENT_ERROR, "Client error");
                        this.ws.send(e);
                    }
                    destroy(e, t1) {
                        e !== r.TransportCloseCodes.NOT_CONNECTED ? this.ws.close(e, t1) : this.state = 4;
                    }
                    async connect(e) {
                        return new Promise((t1)=>{
                            this.state = 1, this.ws = new WebSocket(e);
                            const n = (e)=>{
                                this.state = 0, t1(!1);
                            };
                            this.ws.addEventListener("open", ()=>{
                                this.state = 2, this.ws.removeEventListener("error", n), this.ws.addEventListener("message", (e)=>{
                                    this.messageHandler && this.messageHandler(e.data, this);
                                }), this.ws.addEventListener("close", ({ reason: e, code: t1, wasClean: n })=>{
                                    4 !== this.state && (this.state = 4, this.parentOnClose(e, t1, n));
                                }), this.ws.addEventListener("error", (e)=>{
                                    this.state = 4, this.parentOnClose("Client error", r.TransportCloseCodes.CLIENT_ERROR, !1), this.ws.close(r.TransportCloseCodes.CLIENT_ERROR, "Client error");
                                }), t1(!0);
                            }), this.ws.addEventListener("error", n);
                        });
                    }
                    parentOnClose(e, t1, n) {
                        this.onClose && this.onClose(this, {
                            reason: e,
                            code: t1,
                            wasClean: n
                        });
                    }
                };
            },
            1666: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.TransportCloseCodes = void 0;
                t1.TransportCloseCodes = {
                    NOT_CONNECTED: -1,
                    NORMAL: 1e3,
                    WRONG_SEQ: 4001,
                    SERVER_ERROR: 4002,
                    CLIENT_ERROR: 4003,
                    TIMEOUT: 4004
                };
            },
            3658: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.makePromiseTimeout = void 0, t1.makePromiseTimeout = function(e, t1) {
                    return function(...n) {
                        return new Promise((r)=>{
                            setTimeout(async function() {
                                const t1 = await e.apply(n);
                                r(t1);
                            }, t1);
                        });
                    };
                };
            },
            4234: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.t = void 0;
                const n = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, {
                    TEST_REPLACE: "This is a {1} {2} replace"
                }), {
                    TRACE_CONN_ACK_RECEIVED: "ASK message: received ask {1}, local clock {2}, minimal stored clock {3}",
                    TRACE_CONN_ACK_CLEARED: "ASK message: cleared {1} msg from the pool.",
                    TRACE_CONN_RETRANSMIT: "LastRTX message: requested from {1} current {2} total requested {3} can be sent {4}"
                }), {
                    INFO_CONN_START_CONNECTION: "Start connecting procedure",
                    INFO_CONN_BALANCER: "Request balancer url {1}",
                    INFO_CONN_TRANSPORT_CONNECTED: "Transport was connected uuid:{1}",
                    INFO_CONN_TRANSPORT_CLOSED: "Transport was closed unexpectedly uuid:{1} reason:{2} code {3}",
                    INFO_CONN_TRANSPORT_DESTROY: "Transport was successful closed uuid:{1}",
                    INFO_CONN_CONNECTION_POOL: "Connecting to Voximplant gateways: {1}",
                    INFO_CONN_CONNECT: "Trying to connect with {1}",
                    INFO_CONN_CONNECT_SUCCESSFUL: "Connection with {1} was successful",
                    INFO_CONN_RECONNECT_NEEDED: "Trying to restore connection",
                    INFO_CONN_RECONNECT: "Attempt to reconnect #{1}",
                    INFO_CONN_RECONNECT_ATTEMPT_FAILED: "Attempt #{1} failed. Timeout.",
                    INFO_CONN_CLEAR: "Start disconnecting procedure.",
                    INFO_CONN_MESSAGE: 'New message from Transport uuid: {1}. "{2}"',
                    INFO_CONN_TO_MESSAGE: 'New message to Transport uuid: {1}. "{2}"',
                    INFO_CONN_CONNECTION_ID_SET: "Set new connection id: {1}",
                    INFO_TRANSPORT_CLOSED: "Transport {1} was closed with code {2} reason: {3}"
                }), {
                    WARN_CORE_WRONG_EVENT: "{1} internal event is unhandled. Looks like you forgot to connect some module. If you can't solve this yourself, please contact our technical support at support@voximplant.com.",
                    WARN_CONN_WRONG_BALANCER_URL: 'The Balancer URL must be secure. "{1}" not starts with "https://"',
                    WARN_CONN_WRONG_STATE: "You try to {1} in the wrong state {2}({3})",
                    WARN_CONN_WRONG_SEQ: "Received seq={1}, last seq={2}. Transport {3} will terminated.",
                    WARN_TRANSPORT_NO_HANDLER: "Transport {1} has no message handler. Message was dropped.",
                    WARN_TRANSPORT_NO_CLOSE_HANDLER: "Transport {1} has no close handler."
                }), {
                    ERR_LOADING_MODULE: "Error loading module: ",
                    ERR_MODULE_CONSTRUCTOR: "The modules field must be array",
                    ERR_CORE_HANDLER_THROW: 'Some module throw error while handle the "{1}" event. Error message is "{2}"',
                    ERR_CORE_PRE_HANDLER_THROW: 'Some module throw error while pre handle the "{1}" event. Error message is "{2}"',
                    ERR_CORE_POST_HANDLER_THROW: 'Some module throw error while post handle the "{1}" event. Error message is "{2}"',
                    ERR_STATE_IS_READONLY: "SDK.state is read only.",
                    ERR_CONFIG_IS_READONLY: "SDK.config is read only.",
                    ERR_AlREADY_CONNECTED: 'SDK already connected. Please use "async SDK.disconnect()" at first place.',
                    ERR_NOT_CONNECTED_YET: 'SDK not connected yet. Please use "async SDK.connect()" at first place.',
                    ERR_CONN_WRONG_BALANCER_RESPONSE: 'Wrong balancer response. "{1}" from "{2}"',
                    ERR_CONN_FAILED: "Connection failed. Reason: {1}",
                    ERR_CONN_CLOUD_IS_UNREACHABLE: "Voximplant cloud is unreachable. List of servers {1}",
                    ERR_CONN_MESSAGE_PARSING_ERR: "Error while parsing message from Transport",
                    ERR_CONN_MESSAGE_FORMAT_TYPE: 'Error in message from Transport: "{1}" field not set.',
                    ERR_CONN_CONNECTION_ID_ALREADY_SET: "Connection id already set and can't be updated."
                }), {
                    THROW_WRONG_ENVIRONMENT: "Wrong environment",
                    THROW_WRONG_MODULES_CONSTRUCTOR: "Modules config must be an array or a function that returns array"
                });
                t1.t = (e, ...t1)=>{
                    const i = n[e];
                    return i ? r(i, ...t1) : e;
                };
                const r = (e, ...t1)=>e.replace(/{(\d+)}/g, function(e, n) {
                        return void 0 !== t1[n - 1] ? t1[n - 1] : e;
                    });
            },
            9007: (e, t1)=>{
                "use strict";
                function n({ trackType: e, layerCount: t1, minTrackSize: n }) {
                    return "video" === e ? {
                        bitrateParams: [
                            n >= 1080 ? 24e5 : 18e5,
                            5e5,
                            1e5
                        ],
                        scaleDownParams: [
                            1,
                            n / 360,
                            n / 280
                        ],
                        framerateParams: [
                            30,
                            30,
                            15
                        ]
                    } : {
                        framerateParams: [
                            30,
                            2 === t1 ? 30 : 10,
                            1 === t1 ? 30 : 1
                        ],
                        scaleDownParams: [
                            1,
                            1,
                            1
                        ]
                    };
                }
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.getSimulcastProfile = void 0, t1.getSimulcastProfile = function(e) {
                    return "b24" === e.profileName ? function({ trackType: e, layerCount: t1, minTrackSize: n }) {
                        if ("video" === e) return {
                            framerateParams: [
                                25,
                                2 === t1 ? 25 : 15,
                                1 === t1 ? 25 : 2 === t1 ? 15 : 25
                            ],
                            bitrateParams: [
                                n >= 1080 ? 24e5 : 18e5,
                                8e5,
                                3e5
                            ],
                            scaleDownParams: [
                                1,
                                1,
                                1 === t1 ? 1 : n / 320
                            ]
                        };
                        return {
                            framerateParams: [
                                30,
                                2 === t1 ? 30 : 10,
                                1 === t1 ? 30 : 1
                            ],
                            scaleDownParams: [
                                1,
                                1,
                                1
                            ]
                        };
                    }(e) : n(e);
                };
            },
            4893: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.getCollectInterval = t1.LOW_BATTERY_COLLECT_INTERVAL = t1.BATTERY_COLLECT_INTERVAL = t1.DEFAULT_COLLECT_INTERVAL = void 0;
                t1.DEFAULT_COLLECT_INTERVAL = 1e3;
                t1.BATTERY_COLLECT_INTERVAL = 3e3;
                t1.LOW_BATTERY_COLLECT_INTERVAL = 1e4, t1.getCollectInterval = async function() {
                    try {
                        const e = navigator.getBattery;
                        if (e) {
                            const t1 = await e();
                            if (!t1.charging) return t1.level && t1.level <= .3 ? 1e4 : 3e3;
                        }
                    } catch (e) {}
                    return 1e3;
                };
            },
            8552: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.unregisterPeerConnection = t1.registerSource = void 0;
                const r = n(4893), i = n(7141), a = n(2746), s = n(9258), o = n(171), d = n(5229), c = n(2182), l = n(1954), g = n(1150), u = "voximplant_statistics_collectStats", h = "voximplant_statistics_collectStats_measure";
                let p = !1;
                const f = new Set, m = new WeakMap, v = new WeakMap;
                let C, _ = !1, S = r.DEFAULT_COLLECT_INTERVAL;
                let E = i.baseStatsStrategy;
                async function y() {
                    performance.mark(u), r.getCollectInterval().then((e)=>{
                        S = e;
                    });
                    let e = 0;
                    for (const n of f.values())if ("connected" === n.connectionState) {
                        e++;
                        const r = await n.getStats(), u = (t1 = r, d.checkBlink(t1, p) ? o.blinkStatsStrategy : l.checkWebkit(t1, p) ? s.webkitStatsStrategy : c.checkGecko(t1, p) ? a.geckoStatsStrategy : i.baseStatsStrategy);
                        u.name !== E.name && (g.LogManager.get().writeMessage(g.LogCategory.RTC, "Stat2", g.LogLevel.INFO, `Stats strategy changed from ${E.name} to ${u.name}`), E = u);
                        const h = v.get(n), f = E.process(r, h);
                        v.set(n, JSON.parse(JSON.stringify(f)));
                        const C = m.get(n);
                        C && C(f);
                    }
                    var t1;
                    performance.measure(h, u);
                    const n = performance.getEntriesByName(h);
                    g.LogManager.get().writeMessage(g.LogCategory.RTC, "Stat2", g.LogLevel.INFO, `Collected stats for ${e} of ${f.size}. Time: ${n[0].duration}`), performance.clearMarks(u), performance.clearMeasures(h), 0 === f.size && (_ = !1, clearInterval(C));
                }
                function M(e) {
                    f.delete(e), g.LogManager.get().writeMessage(g.LogCategory.RTC, "Stat2", g.LogLevel.INFO, "Statics source was removed "), 0 === f.size && (g.LogManager.get().writeMessage(g.LogCategory.RTC, "Stat2", g.LogLevel.INFO, "Statics interval was stopped"), _ = !1);
                }
                t1.unregisterPeerConnection = M, t1.registerSource = function(e, t1, n, r) {
                    g.LogManager.get().writeMessage(g.LogCategory.RTC, "Stat2", g.LogLevel.INFO, "Add a new statistic source"), n && n.addEventListener("abort", function() {
                        g.LogManager.get().writeMessage(g.LogCategory.RTC, "Stat2", g.LogLevel.INFO, "Abort statistic source"), M(e);
                    }), m.set(e, t1), function(e) {
                        f.add(e), g.LogManager.get().writeMessage(g.LogCategory.RTC, "Stat2", g.LogLevel.INFO, "Statics source was added "), _ || (_ = !0, C = setInterval(y, S));
                    }(e);
                };
            },
            6665: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.registerSource = void 0;
                const r = n(8552);
                Object.defineProperty(t1, "registerSource", {
                    enumerable: !0,
                    get: function() {
                        return r.registerSource;
                    }
                });
            },
            7141: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.baseStatsStrategy = void 0;
                const n = {
                    process: function(e) {
                        return {
                            connection: {
                                timestamp: 0,
                                availableOutgoingBitrate: 0,
                                bytesReceived: 0,
                                bytesSent: 0,
                                rtt: 0,
                                localPort: 0,
                                localProtocol: "udp",
                                localType: "relay",
                                remotePort: 0,
                                remoteProtocol: "tcp",
                                remoteType: "relay"
                            },
                            inbound: {},
                            outbound: {}
                        };
                    },
                    name: "rfc"
                };
                t1.baseStatsStrategy = n;
            },
            171: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.blinkStatsStrategy = void 0;
                const r = n(3236);
                const i = {
                    process: function(e, t1) {
                        const [n, i] = r.utils.formatStats(e), a = {}, s = {};
                        let o = {};
                        return n.forEach((e)=>{
                            var n, d;
                            switch(e.type){
                                case "outbound-rtp":
                                    {
                                        if (!e.mediaSourceId) break;
                                        const a = i.get(e.remoteId), o = i.get(e.codecId), c = i.get(e.mediaSourceId), l = c.trackIdentifier, g = e.rid ? null === (n = null == t1 ? void 0 : t1.outbound[l]) || void 0 === n ? void 0 : n.find((t1)=>t1.rid === e.rid) : null === (d = null == t1 ? void 0 : t1.outbound[l]) || void 0 === d ? void 0 : d[0];
                                        let u = 0;
                                        g && (u = r.utils.calculateBitrate(e.bytesSent, g.bytesSent, e.timestamp, g.timestamp));
                                        const h = {
                                            bytesSent: e.bytesSent,
                                            packetsSent: e.packetsSent,
                                            rid: e.rid,
                                            jitter: 0,
                                            rtt: 0,
                                            totalRtt: 0,
                                            packetsLost: 0,
                                            loss: 0,
                                            codec: o.mimeType,
                                            pt: o.payloadType,
                                            timestamp: e.timestamp,
                                            bitrate: u
                                        };
                                        switch(a && (h.jitter = a.jitter, h.rtt = a.roundTripTime, h.totalRtt = a.totalRoundTripTime || a.roundTripTime, h.packetsLost = a.packetsLost, h.loss = a.packetsLost / (e.packetsSent + a.packetsLost)), e.kind){
                                            case "audio":
                                                {
                                                    const e = c;
                                                    h.kind = "audio", h.audioLevel = e.audioLevel || 0, h.totalAudioEnergy = e.totalAudioEnergy || 0;
                                                    break;
                                                }
                                            case "video":
                                                {
                                                    const t1 = c;
                                                    h.kind = "video", h.baseWidth = t1.width, h.baseHeight = t1.height, h.width = e.frameWidth || 0, h.height = e.frameHeight || 0, h.framesPerSecond = e.framesPerSecond || 0, h.baseFramesPerSecond = t1.framesPerSecond, h.qualityLimitationReason = e.qualityLimitationReason, h.qualityLimitationResolutionChanges = e.qualityLimitationResolutionChanges, h.firCount = e.firCount, h.pliCount = e.pliCount, h.nackCount = e.nackCount, h.qpSum = e.qpSum, h.framesEncoded = e.framesEncoded, h.keyFramesEncoded = e.keyFramesEncoded;
                                                    break;
                                                }
                                        }
                                        s[l] || (s[l] = []), s[l].push(h);
                                        break;
                                    }
                                case "inbound-rtp":
                                    {
                                        const n = e.trackIdentifier, i = null == t1 ? void 0 : t1.inbound[n];
                                        let s = 0;
                                        switch(i && (s = r.utils.calculateBitrate(e.bytesReceived, i.bytesReceived, e.timestamp, i.timestamp)), a[n] = {
                                            timestamp: e.timestamp,
                                            kind: e.kind,
                                            bytesReceived: e.bytesReceived || 0,
                                            packetsReceived: e.packetsReceived || 0,
                                            packetsLost: e.packetsLost || 0,
                                            loss: e.packetsLost / (e.packetsReceived + e.packetsLost),
                                            jitter: e.jitter || 0,
                                            bitrate: s
                                        }, e.kind){
                                            case "audio":
                                                a[n] = Object.assign(Object.assign({}, a[n]), {
                                                    audioLevel: e.audioLevel || 0,
                                                    totalAudioEnergy: e.totalAudioEnergy || 0,
                                                    totalSamplesReceived: e.totalSamplesReceived || 0,
                                                    totalSamplesDuration: e.totalSamplesDuration || 0,
                                                    insertedSamplesForDeceleration: e.insertedSamplesForDeceleration || 0,
                                                    silentConcealedSamples: e.silentConcealedSamples || 0
                                                });
                                                break;
                                            case "video":
                                                {
                                                    let t1 = 0;
                                                    if (i && i.framesReceived) {
                                                        const n = i.framesReceived || e.framesReceived;
                                                        t1 = (e.framesReceived - n) / (e.timestamp - i.timestamp) * 1e3 | 0;
                                                    }
                                                    a[n] = Object.assign(Object.assign({}, a[n]), {
                                                        height: e.frameHeight || 0,
                                                        width: e.frameWidth || 0,
                                                        framesReceived: e.framesReceived || 0,
                                                        framesDecoded: e.framesDecoded || 0,
                                                        framesDropped: e.framesDropped || 0,
                                                        framesPerSecond: t1
                                                    });
                                                    break;
                                                }
                                        }
                                        break;
                                    }
                                case "candidate-pair":
                                    {
                                        if ("succeeded" !== e.state || !e.nominated) return;
                                        const t1 = i.get(e.remoteCandidateId), n = i.get(e.localCandidateId);
                                        if (!t1 || !n) return;
                                        const r = t1.candidateType, a = t1.ip || t1.address, s = t1.protocol, d = t1.port, c = n.candidateType, l = n.ip || n.address, g = n.protocol, u = n.port, h = e.totalRoundTripTime, p = e.currentRoundTripTime, { bytesSent: f, bytesReceived: m, availableOutgoingBitrate: v, timestamp: C } = e;
                                        o = {
                                            timestamp: C,
                                            remoteType: r,
                                            remoteIp: a,
                                            remoteProtocol: s,
                                            remotePort: d,
                                            localType: c,
                                            localIp: l,
                                            localProtocol: g,
                                            localPort: u,
                                            bytesSent: f,
                                            bytesReceived: m,
                                            availableOutgoingBitrate: v,
                                            rtt: h,
                                            currentRtt: p
                                        };
                                        break;
                                    }
                            }
                        }), {
                            connection: o,
                            outbound: s,
                            inbound: a
                        };
                    },
                    name: "blink"
                };
                t1.blinkStatsStrategy = i;
            },
            5229: (e, t1)=>{
                "use strict";
                function n(e) {
                    return void 0 !== e.address && void 0 !== e.isRemote || void 0 !== e.ip && void 0 !== e.isRemote;
                }
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.checkBlink = void 0, t1.checkBlink = function(e, t1 = !1) {
                    let r = !0, i = !1;
                    return e.forEach((e)=>{
                        if (r) {
                            switch(e.type){
                                case "peer-connection":
                                    i = !0;
                                    break;
                                case "media-source":
                                    r = "audio" === (a = e).kind ? void 0 !== a.audioLevel && void 0 !== a.totalAudioEnergy && void 0 !== a.totalSamplesDuration : "video" === a.kind && void 0 !== a.width && void 0 !== a.height && void 0 !== a.framesPerSecond;
                                    break;
                                case "local-candidate":
                                case "remote-candidate":
                                    r = n(e);
                                    break;
                                case "transport":
                                    r = function(e) {
                                        return void 0 !== e.packetsSent && void 0 !== e.packetsReceived;
                                    }(e);
                                    break;
                                case "inbound-rtp":
                                    r = function(e) {
                                        return "audio" === e.kind || "video" === e.kind && void 0 !== e.decoderImplementation;
                                    }(e);
                                    break;
                                case "outbound-rtp":
                                    r = function(e) {
                                        return "audio" === e.kind || "video" === e.kind && void 0 !== e.qualityLimitationReason && void 0 !== e.encoderImplementation;
                                    }(e);
                                    break;
                                case "track":
                                    r = function(e) {
                                        return void 0 !== e.kind;
                                    }(e);
                            }
                            t1 && console.error("After " + e.type, r);
                        }
                        var a;
                    }), i || (r = !1), t1 && console.error("Blink detection result is:", r), r;
                };
            },
            2182: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.checkGecko = void 0, t1.checkGecko = function(e, t1 = !1) {
                    let n = !0;
                    return e.forEach((e)=>{
                        if (n) {
                            switch(e.type){
                                case "candidate-pair":
                                    n = void 0 !== (r = e).lastPacketReceivedTimestamp && void 0 !== r.lastPacketSentTimestamp;
                                    break;
                                case "inbound-rtp":
                                    n = function(e) {
                                        return "video" !== e.kind || void 0 !== e.discardedPackets && void 0 !== e.bitrateMean && void 0 !== e.bitrateStdDev && void 0 !== e.framerateMean && void 0 !== e.framerateStdDev && void 0 !== e.framesDecoded;
                                    }(e);
                            }
                            t1 && console.error("After " + e.type, n);
                        }
                        var r;
                    }), t1 && console.error("Gecko detection result is:", n), n;
                };
            },
            1954: (e, t1)=>{
                "use strict";
                function n(e) {
                    return void 0 !== e.deleted;
                }
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.checkWebkit = void 0, t1.checkWebkit = function(e, t1 = !1) {
                    let r = !0, i = !1;
                    return e.forEach((e)=>{
                        if (r) {
                            switch(e.type){
                                case "peer-connection":
                                    i = !0;
                                    break;
                                case "local-candidate":
                                case "remote-candidate":
                                    r = n(e);
                                    break;
                                case "track":
                                    r = function(e) {
                                        if (e.framesReceived) {
                                            const t1 = e;
                                            return void 0 !== t1.freezeCount && void 0 !== t1.pauseCount && void 0 !== t1.sumOfSquaredFramesDuration && void 0 !== t1.totalFramesDuration && void 0 !== t1.totalFreezesDuration && void 0 !== t1.totalPausesDuration;
                                        }
                                        return !0;
                                    }(e);
                            }
                            t1 && console.error("After " + e.type, r);
                        }
                    }), i || (r = !1), r;
                };
            },
            2746: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.geckoStatsStrategy = void 0;
                const r = n(3236);
                const i = {
                    process: function(e, t1) {
                        const [n, i] = r.utils.formatStats(e), a = {}, s = {};
                        let o = {};
                        return n.forEach((e)=>{
                            switch(e.type){
                                case "outbound-rtp":
                                    {
                                        const t1 = e.ssrc, n = {
                                            kind: e.kind,
                                            bytesSent: e.bytesSent,
                                            packetsSent: e.packetsSent,
                                            timestamp: e.timestamp,
                                            bitrate: 0
                                        };
                                        "video" === e.kind && (n.framesPerSecond = e.framerateMean, n.bitrate = e.bitrateMean, n.firCount = e.firCount, n.pliCount = e.pliCount, n.nackCount = e.nackCount), s[t1] = [
                                            n
                                        ];
                                        const r = i.get(e.remoteId);
                                        r && (n.jitter = r.jitter, n.rtt = r.roundTripTime, n.totalRtt = r.roundTripTime, n.packetsLost = r.packetsLost, n.loss = r.packetsLost / (e.packetsSent + r.packetsLost));
                                        break;
                                    }
                                case "inbound-rtp":
                                    {
                                        const n = e.ssrc, i = null == t1 ? void 0 : t1.inbound[n];
                                        let s = 0;
                                        if (i && (s = r.utils.calculateBitrate(e.bytesReceived, i.bytesReceived, e.timestamp, i.timestamp)), a[n] = {
                                            timestamp: e.timestamp,
                                            kind: e.kind,
                                            bytesReceived: e.bytesReceived || 0,
                                            packetsReceived: e.packetsReceived || 0,
                                            packetsLost: e.packetsLost || 0,
                                            loss: e.packetsLost / (e.packetsReceived + e.packetsLost),
                                            jitter: e.jitter || 0,
                                            bitrate: s
                                        }, "video" === e.kind) a[n] = Object.assign(Object.assign({}, a[n]), {
                                            framesDecoded: e.framesDecoded || 0,
                                            framesPerSecond: e.framerateMean,
                                            bitrate: e.bitrateMean
                                        });
                                        break;
                                    }
                                case "candidate-pair":
                                    {
                                        if ("succeeded" !== e.state || !e.nominated) return;
                                        const t1 = i.get(e.remoteCandidateId), n = i.get(e.localCandidateId);
                                        if (!t1 || !n) return;
                                        const r = t1.candidateType, a = t1.ip || t1.address, s = t1.protocol, d = t1.port, c = n.candidateType, l = n.ip || n.address, g = n.protocol, u = n.port, { bytesSent: h, bytesReceived: p, timestamp: f } = e;
                                        o = {
                                            timestamp: f,
                                            remoteType: r,
                                            remoteIp: a,
                                            remoteProtocol: s,
                                            remotePort: d,
                                            localType: c,
                                            localIp: l,
                                            localProtocol: g,
                                            localPort: u,
                                            bytesSent: h,
                                            bytesReceived: p
                                        };
                                        break;
                                    }
                            }
                        }), {
                            connection: o,
                            outbound: s,
                            inbound: a
                        };
                    },
                    name: "gecko"
                };
                t1.geckoStatsStrategy = i;
            },
            3236: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.utils = void 0;
                const n = {
                    calculateBitrate: function(e, t1, n, r) {
                        return (e - t1) / (n - r) * 8e3;
                    },
                    formatStats: function(e) {
                        const t1 = e, n = new Map;
                        return t1.forEach((e)=>n.set(e.id, e)), [
                            t1,
                            n
                        ];
                    }
                };
                t1.utils = n;
            },
            9258: (e, t1, n)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.webkitStatsStrategy = void 0;
                const r = n(3236);
                const i = {
                    process: function(e, t1) {
                        const [n, i] = r.utils.formatStats(e), a = {}, s = {};
                        let o = {};
                        return n.forEach((e)=>{
                            var n, d;
                            switch(e.type){
                                case "outbound-rtp":
                                    {
                                        const a = i.get(e.remoteId), o = i.get(e.codecId), c = i.get(e.trackId);
                                        if (!c) return;
                                        const l = c.trackIdentifier, g = e.rid ? null === (n = null == t1 ? void 0 : t1.outbound[l]) || void 0 === n ? void 0 : n.find((t1)=>t1.rid === e.rid) : null === (d = null == t1 ? void 0 : t1.outbound[l]) || void 0 === d ? void 0 : d[0];
                                        let u = 0;
                                        g && (u = r.utils.calculateBitrate(e.bytesSent, g.bytesSent, e.timestamp, g.timestamp));
                                        const h = {
                                            bytesSent: e.bytesSent,
                                            packetsSent: e.packetsSent,
                                            rid: e.rid,
                                            jitter: 0,
                                            rtt: 0,
                                            totalRtt: 0,
                                            packetsLost: 0,
                                            loss: 0,
                                            codec: o.mimeType,
                                            pt: o.payloadType,
                                            timestamp: e.timestamp,
                                            bitrate: u
                                        };
                                        if (a) {
                                            h.jitter = a.jitter, h.rtt = a.roundTripTime, h.packetsLost = a.packetsLost;
                                            const t1 = a.packetsLost || 0;
                                            h.loss = t1 / (e.packetsSent + t1);
                                        }
                                        switch(e.kind){
                                            case "audio":
                                                h.kind = "audio";
                                                break;
                                            case "video":
                                                {
                                                    const { frameWidth: t1, frameHeight: n } = c;
                                                    h.kind = "video", h.baseWidth = t1, h.baseHeight = n, h.width = e.frameWidth || 0, h.height = e.frameHeight || 0, h.framesPerSecond = e.framesPerSecond || 0, h.qualityLimitationReason = e.qualityLimitationReason, h.qualityLimitationResolutionChanges = e.qualityLimitationResolutionChanges, h.firCount = e.firCount, h.pliCount = e.pliCount, h.nackCount = e.nackCount, h.qpSum = e.qpSum, h.framesEncoded = e.framesEncoded, h.keyFramesEncoded = e.keyFramesEncoded;
                                                    break;
                                                }
                                        }
                                        s[l] || (s[l] = []), s[l].push(h);
                                        break;
                                    }
                                case "inbound-rtp":
                                    {
                                        const n = i.get(e.trackId);
                                        if (!n) return;
                                        const s = n.trackIdentifier, o = null == t1 ? void 0 : t1.inbound[s];
                                        let d = 0;
                                        switch(o && (d = r.utils.calculateBitrate(e.bytesReceived, o.bytesReceived, e.timestamp, o.timestamp)), a[s] = {
                                            timestamp: e.timestamp,
                                            kind: e.kind,
                                            bytesReceived: e.bytesReceived || 0,
                                            packetsReceived: e.packetsReceived || 0,
                                            packetsLost: e.packetsLost || 0,
                                            loss: e.packetsLost / (e.packetsReceived + e.packetsLost),
                                            jitter: 0,
                                            bitrate: d
                                        }, e.kind){
                                            case "audio":
                                                {
                                                    const { audioLevel: t1 } = n;
                                                    a[s] = Object.assign(Object.assign({}, a[s]), {
                                                        jitter: e.jitter,
                                                        audioLevel: t1,
                                                        totalAudioEnergy: e.totalAudioEnergy || 0,
                                                        totalSamplesReceived: e.totalSamplesReceived || 0,
                                                        totalSamplesDuration: e.totalSamplesDuration || 0,
                                                        insertedSamplesForDeceleration: e.insertedSamplesForDeceleration || 0,
                                                        silentConcealedSamples: e.silentConcealedSamples || 0
                                                    });
                                                    break;
                                                }
                                            case "video":
                                                {
                                                    let t1 = 0;
                                                    if (o && o.framesReceived) {
                                                        const n = o.framesReceived || e.framesReceived;
                                                        t1 = (e.framesReceived - n) / (e.timestamp - o.timestamp) * 1e3 | 0;
                                                    }
                                                    const { freezeCount: r, pauseCount: i, totalFramesDuration: d, totalFreezesDuration: c, totalPausesDuration: l } = n;
                                                    a[s] = Object.assign(Object.assign({}, a[s]), {
                                                        height: e.frameHeight || 0,
                                                        width: e.frameWidth || 0,
                                                        framesReceived: e.framesReceived || 0,
                                                        framesDecoded: e.framesDecoded || 0,
                                                        freezeCount: r,
                                                        pauseCount: i,
                                                        totalFramesDuration: d,
                                                        totalFreezesDuration: c,
                                                        totalPausesDuration: l,
                                                        framesPerSecond: t1
                                                    });
                                                    break;
                                                }
                                        }
                                        break;
                                    }
                                case "candidate-pair":
                                    {
                                        if ("succeeded" !== e.state || !e.nominated) return;
                                        const t1 = i.get(e.remoteCandidateId), n = i.get(e.localCandidateId);
                                        if (!t1 || !n) return;
                                        const r = t1.candidateType, a = t1.protocol, s = t1.port, d = n.candidateType, c = n.protocol, l = n.port, g = e.totalRoundTripTime, u = e.currentRoundTripTime, { bytesSent: h, bytesReceived: p, availableOutgoingBitrate: f, timestamp: m } = e;
                                        o = {
                                            timestamp: m,
                                            remoteType: r,
                                            remoteProtocol: a,
                                            remotePort: s,
                                            localType: d,
                                            localProtocol: c,
                                            localPort: l,
                                            bytesSent: h,
                                            bytesReceived: p,
                                            availableOutgoingBitrate: f,
                                            rtt: g,
                                            currentRtt: u
                                        };
                                        break;
                                    }
                            }
                        }), {
                            connection: o,
                            outbound: s,
                            inbound: a
                        };
                    },
                    name: "webkit"
                };
                t1.webkitStatsStrategy = i;
            },
            7998: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.OperatorACDStatuses = t1.QueueTypes = void 0, function(e) {
                    e[e.ACD = 1] = "ACD", e[e.SmartQueue = 2] = "SmartQueue", e[e.SmartQueueV1Beta = 3] = "SmartQueueV1Beta";
                }(t1.QueueTypes || (t1.QueueTypes = {})), function(e) {
                    e[e.Offline = "OFFLINE"] = "Offline", e[e.Online = "ONLINE"] = "Online", e[e.Ready = "READY"] = "Ready", e[e.InService = "IN_SERVICE"] = "InService", e[e.AfterService = "AFTER_SERVICE"] = "AfterService", e[e.Timeout = "TIMEOUT"] = "Timeout", e[e.DND = "DND"] = "DND", e[e.CustomStatus_1 = "CUSTOM_1"] = "CustomStatus_1", e[e.CustomStatus_2 = "CUSTOM_2"] = "CustomStatus_2", e[e.CustomStatus_3 = "CUSTOM_3"] = "CustomStatus_3", e[e.CustomStatus_4 = "CUSTOM_4"] = "CustomStatus_4", e[e.CustomStatus_5 = "CUSTOM_5"] = "CustomStatus_5", e[e.CustomStatus_6 = "CUSTOM_6"] = "CustomStatus_6", e[e.CustomStatus_7 = "CUSTOM_7"] = "CustomStatus_7", e[e.CustomStatus_8 = "CUSTOM_8"] = "CustomStatus_8", e[e.CustomStatus_9 = "CUSTOM_9"] = "CustomStatus_9", e[e.CustomStatus_10 = "CUSTOM_10"] = "CustomStatus_10";
                }(t1.OperatorACDStatuses || (t1.OperatorACDStatuses = {}));
            },
            3992: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.queueDecorator = t1.TaskMutex = void 0;
                t1.TaskMutex = class {
                    constructor(){
                        this.queue = [], this.locked = !1;
                    }
                    acquire() {
                        return this.locked ? new Promise((e)=>this.queue.push(e)) : (this.locked = !0, Promise.resolve());
                    }
                    release() {
                        if (this.queue.length) return this.queue.shift()();
                        this.locked = !1;
                    }
                    use(e) {
                        return this.acquire().then(()=>Promise.resolve().then(()=>e.descriptor.value.apply(e.instance, e.args)).then((e)=>(this.release(), e)).catch((e)=>{
                                throw this.release(), e;
                            }));
                    }
                }, t1.queueDecorator = function() {
                    return (e, t1, n)=>({
                            value: function(...e) {
                                return this.mutex.use({
                                    args: e,
                                    descriptor: n,
                                    instance: this
                                });
                            }
                        });
                };
            },
            2957: function(e, t1, n) {
                "use strict";
                var r = this && this.__decorate || function(e, t1, n, r) {
                    var i, a = arguments.length, s = a < 3 ? t1 : null === r ? r = Object.getOwnPropertyDescriptor(t1, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t1, n, r);
                    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (s = (a < 3 ? i(s) : a > 3 ? i(t1, n, s) : i(t1, n)) || s);
                    return a > 3 && s && Object.defineProperty(t1, n, s), s;
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.Utils = void 0;
                const i = n(1150), a = n(125), s = n(3947), o = n(7272), d = n(6081), c = n(9007);
                class l {
                    static cadScript(e) {
                        return e.split(";").map(function(e) {
                            if (0 !== e.length) {
                                var t1 = e.match(/\([0-9\/\.,\*\+]*\)$/), n = e.substring(0, t1.index), r = t1.pop();
                                if (t1.length) throw new Error("cadence script should be of the form `%f(%f/%f[,%f/%f])`");
                                if (n = "*" === n ? 1 / 0 : parseFloat(n), isNaN(n)) throw new Error("cadence length should be of the form `%f`");
                                return {
                                    duration: n,
                                    sections: r = r.slice(1, r.length - 1).split(",").map(function(e) {
                                        try {
                                            var t1 = e.split("/");
                                            if (t1.length > 3) throw new Error;
                                            return {
                                                on: (t1 = t1.map(function(e, t1) {
                                                    var n;
                                                    if (2 === t1) return e.split("+").map(function(e) {
                                                        var t1 = parseInt(e, 10);
                                                        if (isNaN(t1)) throw new Error;
                                                        return t1 - 1;
                                                    });
                                                    if ("*" == e && (n = 1 / 0), n = n || parseFloat(e), isNaN(n)) throw new Error;
                                                    return n;
                                                }))[0],
                                                off: t1[1],
                                                frequencies: t1[2]
                                            };
                                        } catch (e) {
                                            throw new Error("cadence segments should be of the form `%f/%f[%d[+%d]]`");
                                        }
                                    })
                                };
                            }
                        });
                    }
                    static freqScript(e) {
                        return e.split(",").map(function(e) {
                            try {
                                var t1 = e.split("@"), n = parseInt(t1.shift()), r = parseFloat(t1.shift());
                                if (t1.length) throw Error();
                                return {
                                    frequency: n,
                                    decibels: r
                                };
                            } catch (e) {
                                throw new Error("freqScript pairs are expected to be of the form `%d@%f[,%d@%f]`");
                            }
                        });
                    }
                    static toneScript(e) {
                        var t1 = e.split(";");
                        return {
                            frequencies: this.freqScript(t1.shift()),
                            cadences: this.cadScript(t1.join(";"))
                        };
                    }
                    static playToneScript(e, t1 = !1) {
                        if (void 0 !== window.AudioContext || void 0 !== window.webkitAudioContext) {
                            var n = o.default.AudioDeviceManager.get().getAudioContext();
                            if (null === n) return;
                            var r = this.toneScript(e), i = [], a = 0, s = function(e) {
                                for(var t1 = 0; t1 < n.sampleRate * e; t1++)i.push(0);
                            }, d = function(e, t1) {
                                for(var a = 0; a < n.sampleRate * t1; a++){
                                    for(var s = 0, o = 0; o < e.length; o++)s += Math.pow(10, r.frequencies[e[o]].decibels / 20) * Math.sin((i.length + a) * (3.14159265359 / n.sampleRate) * r.frequencies[e[o]].frequency), a < 10 && (s *= a / 10), a > n.sampleRate * t1 - 10 && (s *= (n.sampleRate * t1 - a) / 10);
                                    i.push(s);
                                }
                            }, c = function(e, t1) {
                                if (t1 != 1 / 0) var n = t1;
                                else n = t1 = 20;
                                if (0 !== e.off && e.off != 1 / 0) for(; n > 0;){
                                    d(e.frequencies, e.on), n -= e.on, s(e.off);
                                    n -= e.off;
                                    n = parseInt(String(10 * n)) / 10;
                                }
                                else d(e.frequencies, t1);
                            }, l = function(e) {
                                e.duration != 1 / 0 ? a += e.duration : a += 20;
                                for(var t1 = 0; t1 < e.sections.length; t1++)c(e.sections[t1], e.duration);
                            };
                            this.source = n.createBufferSource();
                            for(var g = 0; g < r.cadences.length; g++)r.cadences[g].duration == 1 / 0 && (this.source.loop = !0), l(r.cadences[g]);
                            this.source.connect(n.destination);
                            for(var u = n.createBuffer(1, a * n.sampleRate, n.sampleRate), h = u.getChannelData(0), p = 0; p < a * n.sampleRate; p++)h[p] = i[p];
                            i = null, this.source.buffer = u, !0 === t1 && (this.source.loop = !0), this.source.start(0);
                        }
                    }
                    static stopPlayback() {
                        return void 0 !== this.source && null !== this.source && (this.source.stop(0), this.source = null, !0);
                    }
                    static getServers(e = !1) {
                        return fetch("https://balancer.voximplant.com/getNearestHost").then((e)=>e.text());
                    }
                    static generateUUID() {
                        let e = this._gri, t1 = this._ha;
                        return t1(e(32), 8) + "-" + t1(e(16), 4) + "-" + t1(16384 | e(12), 4) + "-" + t1(32768 | e(14), 4) + "-" + t1(e(48), 12);
                    }
                    static _gri(e) {
                        return e < 0 ? NaN : e <= 30 ? 0 | Math.random() * (1 << e) : e <= 53 ? (0 | Math.random() * 1073741824) + (0 | Math.random() * (1 << e - 30)) * 1073741824 : NaN;
                    }
                    static _ha(e, t1) {
                        let n = e.toString(16), r = t1 - n.length, i = "0";
                        for(; r > 0; r >>>= 1, i += i)1 & r && (n = i + n);
                        return n;
                    }
                    static checkCA() {
                        if (!a.Client.getInstance().connected()) throw new Error(d.CallError.NOT_CONNECTED_TO_VOXIMPLANT.toString());
                        if (!s.Authenticator.get().authorized()) throw new Error(d.CallError.NOT_AUTHORIZED.toString());
                    }
                    static mixObjectToLeft(e, t1) {
                        for(var n in e)void 0 !== t1[n] && (e[n] = t1[n]);
                        return e;
                    }
                    static strFormat(e, ...t1) {
                        return e.replace(/{(\d+)}/g, function(e, n) {
                            return void 0 !== t1[n] ? t1[n] : e;
                        });
                    }
                    _traceName() {
                        return "Utils";
                    }
                    static buildSimulcastLayers({ trackSettings: e, trackType: t1, profileName: n }) {
                        e || (e = {
                            width: 1920,
                            height: 1080
                        });
                        const r = e.width > e.height ? e.height : e.width, i = l.getSimulcastLayerCount(r), a = c.getSimulcastProfile({
                            profileName: n,
                            trackType: t1,
                            layerCount: i,
                            minTrackSize: r
                        });
                        return l.buildSimulcastBuilderByProfile(i, a);
                    }
                    static getSimulcastLayerCount(e) {
                        return e >= 720 ? 3 : e >= 480 ? 2 : 1;
                    }
                    static buildSimulcastBuilderByProfile(e, t1) {
                        const n = [
                            "h",
                            "m",
                            "l"
                        ].slice(3 - e), r = [];
                        let i, a, s;
                        t1.bitrateParams && (i = t1.bitrateParams.slice(3 - e), i[0] = t1.bitrateParams[0]), t1.scaleDownParams && (a = t1.scaleDownParams.slice(3 - e), a[0] = t1.scaleDownParams[0]), t1.framerateParams && (s = t1.framerateParams.slice(3 - e), s[0] = t1.framerateParams[0]);
                        for(let t1 = 0; t1 < e; t1++){
                            const e = {
                                rid: n[t1]
                            };
                            i && (e.maxBitrate = i[t1]), a && (e.scaleResolutionDownBy = a[t1]), s && (e.maxFramerate = s[t1]), r.push(e);
                        }
                        return r;
                    }
                    static getDefaultStreamTransformer() {
                        return window.RTCRtpSender && RTCRtpSender.prototype.createEncodedStreams ? new TransformStream({
                            start () {},
                            async transform (e, t1) {
                                t1.enqueue(e);
                            },
                            flush () {}
                        }) : void 0;
                    }
                    static buildNotSimulcastLayers({ trackSettings: e, trackType: t1 }) {
                        var n;
                        e || (e = {
                            width: 1920,
                            height: 1080
                        });
                        const r = null === (n = a.Client.getInstance().limitVCodecs) || void 0 === n ? void 0 : n.filter((e)=>"red" !== e.name && "ulpfec" !== e.name), i = !(null == r ? void 0 : r.filter((e)=>!("H264" === e.name && "42e01f" === e.params["profile-level-id"])).length);
                        let s = 1;
                        if ("sharing" === t1 && i) {
                            const t1 = e.height / 720, n = e.width / 1280;
                            t1 >= n && n > 1 && (s = n), n <= t1 && t1 > 1 && (s = t1);
                        }
                        const o = e.width > e.height ? e.height : e.width;
                        return [
                            {
                                maxBitrate: o >= 1080 ? 25e5 : o >= 720 ? 15e5 : 5e5,
                                maxFramerate: 30,
                                scaleResolutionDownBy: s
                            }
                        ];
                    }
                    static stringifyError(e) {
                        const t1 = Object.getOwnPropertyNames(e);
                        return t1.length ? JSON.stringify(e, t1) : JSON.stringify(e, [
                            "name",
                            "message"
                        ]);
                    }
                }
                l.source = null, r([
                    i.LogManager.d_trace(i.LogCategory.UTILS)
                ], l, "cadScript", null), r([
                    i.LogManager.d_trace(i.LogCategory.UTILS)
                ], l, "freqScript", null), r([
                    i.LogManager.d_trace(i.LogCategory.UTILS)
                ], l, "toneScript", null), r([
                    i.LogManager.d_trace(i.LogCategory.UTILS)
                ], l, "playToneScript", null), r([
                    i.LogManager.d_trace(i.LogCategory.UTILS)
                ], l, "stopPlayback", null), r([
                    i.LogManager.d_trace(i.LogCategory.UTILS)
                ], l, "getServers", null), t1.Utils = l;
            },
            9001: function(e, t1, n) {
                "use strict";
                var r = this && this.__createBinding || (Object.create ? function(e, t1, n, r) {
                    void 0 === r && (r = n), Object.defineProperty(e, r, {
                        enumerable: !0,
                        get: function() {
                            return t1[n];
                        }
                    });
                } : function(e, t1, n, r) {
                    void 0 === r && (r = n), e[r] = t1[n];
                }), i = this && this.__exportStar || function(e, t1) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t1, n) || r(t1, e, n);
                };
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                }), t1.getMessenger = t1.version = t1.getInstance = t1.MediaRenderDisablingReason = t1.ClientState = t1.LogLevel = t1.LogCategory = t1.QueueTypes = t1.OperatorACDStatuses = t1.EndpointEvents = t1.Endpoint = t1.CallEvents = t1.Events = t1.Messaging = void 0;
                const a = n(125), s = n(3947), o = n(6054);
                var d = n(6054);
                Object.defineProperty(t1, "Messaging", {
                    enumerable: !0,
                    get: function() {
                        return d.Messaging;
                    }
                });
                var c = n(141);
                Object.defineProperty(t1, "Events", {
                    enumerable: !0,
                    get: function() {
                        return c.Events;
                    }
                });
                var l = n(2282);
                Object.defineProperty(t1, "CallEvents", {
                    enumerable: !0,
                    get: function() {
                        return l.CallEvents;
                    }
                });
                var g = n(9144);
                Object.defineProperty(t1, "Endpoint", {
                    enumerable: !0,
                    get: function() {
                        return g.Endpoint;
                    }
                });
                var u = n(8597);
                Object.defineProperty(t1, "EndpointEvents", {
                    enumerable: !0,
                    get: function() {
                        return u.EndpointEvents;
                    }
                });
                var h = n(7998);
                Object.defineProperty(t1, "OperatorACDStatuses", {
                    enumerable: !0,
                    get: function() {
                        return h.OperatorACDStatuses;
                    }
                }), Object.defineProperty(t1, "QueueTypes", {
                    enumerable: !0,
                    get: function() {
                        return h.QueueTypes;
                    }
                });
                var p = n(1150);
                Object.defineProperty(t1, "LogCategory", {
                    enumerable: !0,
                    get: function() {
                        return p.LogCategory;
                    }
                }), Object.defineProperty(t1, "LogLevel", {
                    enumerable: !0,
                    get: function() {
                        return p.LogLevel;
                    }
                }), Object.defineProperty(t1, "ClientState", {
                    enumerable: !0,
                    get: function() {
                        return p.ClientState;
                    }
                }), i(n(7272), t1);
                var f = n(1450);
                Object.defineProperty(t1, "MediaRenderDisablingReason", {
                    enumerable: !0,
                    get: function() {
                        return f.MediaRenderDisablingReason;
                    }
                }), t1.getInstance = function() {
                    return a.Client.getInstance();
                }, t1.version = a.Client.getInstance().version, t1.getMessenger = function() {
                    if (!s.Authenticator.get().authorized()) throw new Error("NOT_AUTHORIZED");
                    return o.default.Messenger.getInstance();
                };
            },
            4758: (e, t1)=>{
                "use strict";
                Object.defineProperty(t1, "__esModule", {
                    value: !0
                });
                var n = function() {
                    function e() {
                        this._state = new Int32Array(4), this._buffer = new ArrayBuffer(68), this._buffer8 = new Uint8Array(this._buffer, 0, 68), this._buffer32 = new Uint32Array(this._buffer, 0, 17), this.start();
                    }
                    return e.hashStr = function(e, t1) {
                        return void 0 === t1 && (t1 = !1), this.onePassHasher.start().appendStr(e).end(t1);
                    }, e.hashAsciiStr = function(e, t1) {
                        return void 0 === t1 && (t1 = !1), this.onePassHasher.start().appendAsciiStr(e).end(t1);
                    }, e._hex = function(t1) {
                        var n, r, i, a, s = e.hexChars, o = e.hexOut;
                        for(a = 0; a < 4; a += 1)for(r = 8 * a, n = t1[a], i = 0; i < 8; i += 2)o[r + 1 + i] = s.charAt(15 & n), n >>>= 4, o[r + 0 + i] = s.charAt(15 & n), n >>>= 4;
                        return o.join("");
                    }, e._md5cycle = function(e, t1) {
                        var n = e[0], r = e[1], i = e[2], a = e[3];
                        r = ((r += ((i = ((i += ((a = ((a += ((n = ((n += (r & i | ~r & a) + t1[0] - 680876936 | 0) << 7 | n >>> 25) + r | 0) & r | ~n & i) + t1[1] - 389564586 | 0) << 12 | a >>> 20) + n | 0) & n | ~a & r) + t1[2] + 606105819 | 0) << 17 | i >>> 15) + a | 0) & a | ~i & n) + t1[3] - 1044525330 | 0) << 22 | r >>> 10) + i | 0, r = ((r += ((i = ((i += ((a = ((a += ((n = ((n += (r & i | ~r & a) + t1[4] - 176418897 | 0) << 7 | n >>> 25) + r | 0) & r | ~n & i) + t1[5] + 1200080426 | 0) << 12 | a >>> 20) + n | 0) & n | ~a & r) + t1[6] - 1473231341 | 0) << 17 | i >>> 15) + a | 0) & a | ~i & n) + t1[7] - 45705983 | 0) << 22 | r >>> 10) + i | 0, r = ((r += ((i = ((i += ((a = ((a += ((n = ((n += (r & i | ~r & a) + t1[8] + 1770035416 | 0) << 7 | n >>> 25) + r | 0) & r | ~n & i) + t1[9] - 1958414417 | 0) << 12 | a >>> 20) + n | 0) & n | ~a & r) + t1[10] - 42063 | 0) << 17 | i >>> 15) + a | 0) & a | ~i & n) + t1[11] - 1990404162 | 0) << 22 | r >>> 10) + i | 0, r = ((r += ((i = ((i += ((a = ((a += ((n = ((n += (r & i | ~r & a) + t1[12] + 1804603682 | 0) << 7 | n >>> 25) + r | 0) & r | ~n & i) + t1[13] - 40341101 | 0) << 12 | a >>> 20) + n | 0) & n | ~a & r) + t1[14] - 1502002290 | 0) << 17 | i >>> 15) + a | 0) & a | ~i & n) + t1[15] + 1236535329 | 0) << 22 | r >>> 10) + i | 0, r = ((r += ((i = ((i += ((a = ((a += ((n = ((n += (r & a | i & ~a) + t1[1] - 165796510 | 0) << 5 | n >>> 27) + r | 0) & i | r & ~i) + t1[6] - 1069501632 | 0) << 9 | a >>> 23) + n | 0) & r | n & ~r) + t1[11] + 643717713 | 0) << 14 | i >>> 18) + a | 0) & n | a & ~n) + t1[0] - 373897302 | 0) << 20 | r >>> 12) + i | 0, r = ((r += ((i = ((i += ((a = ((a += ((n = ((n += (r & a | i & ~a) + t1[5] - 701558691 | 0) << 5 | n >>> 27) + r | 0) & i | r & ~i) + t1[10] + 38016083 | 0) << 9 | a >>> 23) + n | 0) & r | n & ~r) + t1[15] - 660478335 | 0) << 14 | i >>> 18) + a | 0) & n | a & ~n) + t1[4] - 405537848 | 0) << 20 | r >>> 12) + i | 0, r = ((r += ((i = ((i += ((a = ((a += ((n = ((n += (r & a | i & ~a) + t1[9] + 568446438 | 0) << 5 | n >>> 27) + r | 0) & i | r & ~i) + t1[14] - 1019803690 | 0) << 9 | a >>> 23) + n | 0) & r | n & ~r) + t1[3] - 187363961 | 0) << 14 | i >>> 18) + a | 0) & n | a & ~n) + t1[8] + 1163531501 | 0) << 20 | r >>> 12) + i | 0, r = ((r += ((i = ((i += ((a = ((a += ((n = ((n += (r & a | i & ~a) + t1[13] - 1444681467 | 0) << 5 | n >>> 27) + r | 0) & i | r & ~i) + t1[2] - 51403784 | 0) << 9 | a >>> 23) + n | 0) & r | n & ~r) + t1[7] + 1735328473 | 0) << 14 | i >>> 18) + a | 0) & n | a & ~n) + t1[12] - 1926607734 | 0) << 20 | r >>> 12) + i | 0, r = ((r += ((i = ((i += ((a = ((a += ((n = ((n += (r ^ i ^ a) + t1[5] - 378558 | 0) << 4 | n >>> 28) + r | 0) ^ r ^ i) + t1[8] - 2022574463 | 0) << 11 | a >>> 21) + n | 0) ^ n ^ r) + t1[11] + 1839030562 | 0) << 16 | i >>> 16) + a | 0) ^ a ^ n) + t1[14] - 35309556 | 0) << 23 | r >>> 9) + i | 0, r = ((r += ((i = ((i += ((a = ((a += ((n = ((n += (r ^ i ^ a) + t1[1] - 1530992060 | 0) << 4 | n >>> 28) + r | 0) ^ r ^ i) + t1[4] + 1272893353 | 0) << 11 | a >>> 21) + n | 0) ^ n ^ r) + t1[7] - 155497632 | 0) << 16 | i >>> 16) + a | 0) ^ a ^ n) + t1[10] - 1094730640 | 0) << 23 | r >>> 9) + i | 0, r = ((r += ((i = ((i += ((a = ((a += ((n = ((n += (r ^ i ^ a) + t1[13] + 681279174 | 0) << 4 | n >>> 28) + r | 0) ^ r ^ i) + t1[0] - 358537222 | 0) << 11 | a >>> 21) + n | 0) ^ n ^ r) + t1[3] - 722521979 | 0) << 16 | i >>> 16) + a | 0) ^ a ^ n) + t1[6] + 76029189 | 0) << 23 | r >>> 9) + i | 0, r = ((r += ((i = ((i += ((a = ((a += ((n = ((n += (r ^ i ^ a) + t1[9] - 640364487 | 0) << 4 | n >>> 28) + r | 0) ^ r ^ i) + t1[12] - 421815835 | 0) << 11 | a >>> 21) + n | 0) ^ n ^ r) + t1[15] + 530742520 | 0) << 16 | i >>> 16) + a | 0) ^ a ^ n) + t1[2] - 995338651 | 0) << 23 | r >>> 9) + i | 0, r = ((r += ((a = ((a += (r ^ ((n = ((n += (i ^ (r | ~a)) + t1[0] - 198630844 | 0) << 6 | n >>> 26) + r | 0) | ~i)) + t1[7] + 1126891415 | 0) << 10 | a >>> 22) + n | 0) ^ ((i = ((i += (n ^ (a | ~r)) + t1[14] - 1416354905 | 0) << 15 | i >>> 17) + a | 0) | ~n)) + t1[5] - 57434055 | 0) << 21 | r >>> 11) + i | 0, r = ((r += ((a = ((a += (r ^ ((n = ((n += (i ^ (r | ~a)) + t1[12] + 1700485571 | 0) << 6 | n >>> 26) + r | 0) | ~i)) + t1[3] - 1894986606 | 0) << 10 | a >>> 22) + n | 0) ^ ((i = ((i += (n ^ (a | ~r)) + t1[10] - 1051523 | 0) << 15 | i >>> 17) + a | 0) | ~n)) + t1[1] - 2054922799 | 0) << 21 | r >>> 11) + i | 0, r = ((r += ((a = ((a += (r ^ ((n = ((n += (i ^ (r | ~a)) + t1[8] + 1873313359 | 0) << 6 | n >>> 26) + r | 0) | ~i)) + t1[15] - 30611744 | 0) << 10 | a >>> 22) + n | 0) ^ ((i = ((i += (n ^ (a | ~r)) + t1[6] - 1560198380 | 0) << 15 | i >>> 17) + a | 0) | ~n)) + t1[13] + 1309151649 | 0) << 21 | r >>> 11) + i | 0, r = ((r += ((a = ((a += (r ^ ((n = ((n += (i ^ (r | ~a)) + t1[4] - 145523070 | 0) << 6 | n >>> 26) + r | 0) | ~i)) + t1[11] - 1120210379 | 0) << 10 | a >>> 22) + n | 0) ^ ((i = ((i += (n ^ (a | ~r)) + t1[2] + 718787259 | 0) << 15 | i >>> 17) + a | 0) | ~n)) + t1[9] - 343485551 | 0) << 21 | r >>> 11) + i | 0, e[0] = n + e[0] | 0, e[1] = r + e[1] | 0, e[2] = i + e[2] | 0, e[3] = a + e[3] | 0;
                    }, e.prototype.start = function() {
                        return this._dataLength = 0, this._bufferLength = 0, this._state.set(e.stateIdentity), this;
                    }, e.prototype.appendStr = function(t1) {
                        var n, r, i = this._buffer8, a = this._buffer32, s = this._bufferLength;
                        for(r = 0; r < t1.length; r += 1){
                            if ((n = t1.charCodeAt(r)) < 128) i[s++] = n;
                            else if (n < 2048) i[s++] = 192 + (n >>> 6), i[s++] = 63 & n | 128;
                            else if (n < 55296 || n > 56319) i[s++] = 224 + (n >>> 12), i[s++] = n >>> 6 & 63 | 128, i[s++] = 63 & n | 128;
                            else {
                                if ((n = 1024 * (n - 55296) + (t1.charCodeAt(++r) - 56320) + 65536) > 1114111) throw new Error("Unicode standard supports code points up to U+10FFFF");
                                i[s++] = 240 + (n >>> 18), i[s++] = n >>> 12 & 63 | 128, i[s++] = n >>> 6 & 63 | 128, i[s++] = 63 & n | 128;
                            }
                            s >= 64 && (this._dataLength += 64, e._md5cycle(this._state, a), s -= 64, a[0] = a[16]);
                        }
                        return this._bufferLength = s, this;
                    }, e.prototype.appendAsciiStr = function(t1) {
                        for(var n, r = this._buffer8, i = this._buffer32, a = this._bufferLength, s = 0;;){
                            for(n = Math.min(t1.length - s, 64 - a); n--;)r[a++] = t1.charCodeAt(s++);
                            if (a < 64) break;
                            this._dataLength += 64, e._md5cycle(this._state, i), a = 0;
                        }
                        return this._bufferLength = a, this;
                    }, e.prototype.appendByteArray = function(t1) {
                        for(var n, r = this._buffer8, i = this._buffer32, a = this._bufferLength, s = 0;;){
                            for(n = Math.min(t1.length - s, 64 - a); n--;)r[a++] = t1[s++];
                            if (a < 64) break;
                            this._dataLength += 64, e._md5cycle(this._state, i), a = 0;
                        }
                        return this._bufferLength = a, this;
                    }, e.prototype.getState = function() {
                        var e = this, t1 = e._state;
                        return {
                            buffer: String.fromCharCode.apply(null, e._buffer8),
                            buflen: e._bufferLength,
                            length: e._dataLength,
                            state: [
                                t1[0],
                                t1[1],
                                t1[2],
                                t1[3]
                            ]
                        };
                    }, e.prototype.setState = function(e) {
                        var t1, n = e.buffer, r = e.state, i = this._state;
                        for(this._dataLength = e.length, this._bufferLength = e.buflen, i[0] = r[0], i[1] = r[1], i[2] = r[2], i[3] = r[3], t1 = 0; t1 < n.length; t1 += 1)this._buffer8[t1] = n.charCodeAt(t1);
                    }, e.prototype.end = function(t1) {
                        void 0 === t1 && (t1 = !1);
                        var n, r = this._bufferLength, i = this._buffer8, a = this._buffer32, s = 1 + (r >> 2);
                        if (this._dataLength += r, i[r] = 128, i[r + 1] = i[r + 2] = i[r + 3] = 0, a.set(e.buffer32Identity.subarray(s), s), r > 55 && (e._md5cycle(this._state, a), a.set(e.buffer32Identity)), (n = 8 * this._dataLength) <= 4294967295) a[14] = n;
                        else {
                            var o = n.toString(16).match(/(.*?)(.{0,8})$/);
                            if (null === o) return;
                            var d = parseInt(o[2], 16), c = parseInt(o[1], 16) || 0;
                            a[14] = d, a[15] = c;
                        }
                        return e._md5cycle(this._state, a), t1 ? this._state : e._hex(this._state);
                    }, e.stateIdentity = new Int32Array([
                        1732584193,
                        -271733879,
                        -1732584194,
                        271733878
                    ]), e.buffer32Identity = new Int32Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]), e.hexChars = "0123456789abcdef", e.hexOut = [], e.onePassHasher = new e, e;
                }();
                t1.Md5 = n, "5d41402abc4b2a76b9719d911017c592" !== n.hashStr("hello") && console.error("Md5 self test failed.");
            }
        }, t1 = {};
        function n(r) {
            if (t1[r]) return t1[r].exports;
            var i = t1[r] = {
                exports: {}
            };
            return e[r].call(i.exports, i, i.exports, n), i.exports;
        }
        return n.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), n(9001);
    })();
    exports["default"] = exports.VoxImplant = VoxImplant;
    if (0, module.exports) exports = module.exports = exports["default"];
}).call(this);

});


parcelRegister("f77a8", function(module, exports) {

$parcel$export(module.exports, "getBase64", function () { return $b00d10ca064e28f4$export$fefac22278f31950; });
const $b00d10ca064e28f4$export$fefac22278f31950 = (file)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = ()=>{
            resolve(reader.result);
        };
        reader.onerror = (error)=>{
            reject(error);
        };
    });

});

parcelRegister("lrsw3", function(module, exports) {

$parcel$export(module.exports, "history", function () { return $f9c23d43b855528e$export$55abd4691b317664; });

var $4mTVz = parcelRequire("4mTVz");
const $f9c23d43b855528e$export$55abd4691b317664 = (0, $4mTVz.createBrowserHistory)();

});

parcelRegister("1cBan", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e03bded17ba5267$export$2e2bcd8739ae039; });

var $2sHtU = parcelRequire("2sHtU");

var $9Toj9 = parcelRequire("9Toj9");
const $0e03bded17ba5267$var$createNotification = (data)=>{
    if (!(0, $9Toj9.applicationFeatureEnabled)((0, $9Toj9.FEATURE).CHAT)) return;
    navigator.serviceWorker.ready.then((registration)=>{
        registration.showNotification(data.title || "\u041D\u043E\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435", {
            body: data.body,
            data: data.data,
            icon: data.icon || (0, (/*@__PURE__*/$parcel$interopDefault($2sHtU))),
            tag: data.id // Нужен что бы браузер отличал сообщения. Если по сокету прийдет 2 сообщения с одинаковым id, вместо того что бы создавать новое уведомление, обновит уже созданное
        });
    });
};
var $0e03bded17ba5267$export$2e2bcd8739ae039 = async (data)=>{
    if (!(0, $9Toj9.applicationFeatureEnabled)((0, $9Toj9.FEATURE).CHAT) || window.ReactNativeWebView) return;
    if (!("Notification" in window)) alert("\u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F.");
    else if (Notification.permission === "granted") $0e03bded17ba5267$var$createNotification(data);
    else if (Notification.permission !== "denied") {
        let permission = await Notification.requestPermission();
        if (permission === "granted") $0e03bded17ba5267$var$createNotification(data);
    }
};

});
parcelRegister("2sHtU", function(module, exports) {
module.exports = new URL("logo.63bd902e.svg", import.meta.url).toString();

});


parcelRegister("cVtTV", function(module, exports) {

$parcel$export(module.exports, "socketErrorHandler", function () { return $969200a47c1bf5ae$export$d3de50a1ff00372b; });

var $le8XK = parcelRequire("le8XK");
const $969200a47c1bf5ae$export$d3de50a1ff00372b = (socket, onReconnect, timeout = 5000)=>{
    return (event)=>{
        const reconnectWebSocket = ()=>{
            setTimeout(()=>onReconnect(), timeout);
        };
        switch(event.code){
            case 1000:
                break;
            case 1001:
            case 1012:
            case 1013:
                // Сервер уходит или перегружен, переподключение через некоторое время
                console.log(`WebSocket[${socket.url}]: \u{421}\u{435}\u{440}\u{432}\u{435}\u{440} \u{443}\u{445}\u{43E}\u{434}\u{438}\u{442} \u{438}\u{43B}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{433}\u{440}\u{443}\u{436}\u{435}\u{43D}, \u{43F}\u{44B}\u{442}\u{430}\u{435}\u{43C}\u{441}\u{44F} \u{43F}\u{435}\u{440}\u{435}\u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C}\u{441}\u{44F}...`);
                reconnectWebSocket();
                break;
            case 1002:
            case 1003:
            case 1007:
            case 1008:
            case 1009:
            case 1010:
                // Эти коды могут указывать на проблему с протоколом или данными,
                // возможно, переподключение сразу не имеет смысла, нужно разбираться в причинах
                console.error(`WebSocket[${socket.url}]: \u{41F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{430} \u{441} \u{43F}\u{440}\u{43E}\u{442}\u{43E}\u{43A}\u{43E}\u{43B}\u{43E}\u{43C} \u{438}\u{43B}\u{438} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{43C}\u{438}, \u{442}\u{440}\u{435}\u{431}\u{443}\u{435}\u{442}\u{441}\u{44F} \u{434}\u{438}\u{430}\u{433}\u{43D}\u{43E}\u{441}\u{442}\u{438}\u{43A}\u{430}.`);
                break;
            case 1011:
                // Внутренняя ошибка сервера, переподключение через некоторое время
                console.log(`WebSocket[${socket.url}]: \u{412}\u{43D}\u{443}\u{442}\u{440}\u{435}\u{43D}\u{43D}\u{44F}\u{44F} \u{43E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{441}\u{435}\u{440}\u{432}\u{435}\u{440}\u{430}, \u{43F}\u{44B}\u{442}\u{430}\u{435}\u{43C}\u{441}\u{44F} \u{43F}\u{435}\u{440}\u{435}\u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C}\u{441}\u{44F}...`);
                reconnectWebSocket();
                break;
            case 1006:
            default:
                // Ненормальное закрытие или неизвестный код, переподключение через некоторое время
                console.log(`WebSocket[${socket.url}]: \u{41D}\u{435}\u{43D}\u{43E}\u{440}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435} \u{437}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{438}\u{435} \u{438}\u{43B}\u{438} \u{43D}\u{435}\u{438}\u{437}\u{432}\u{435}\u{441}\u{442}\u{43D}\u{44B}\u{439} \u{43A}\u{43E}\u{434} \u{43E}\u{448}\u{438}\u{431}\u{43A}\u{438}, \u{43F}\u{44B}\u{442}\u{430}\u{435}\u{43C}\u{441}\u{44F} \u{43F}\u{435}\u{440}\u{435}\u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C}\u{441}\u{44F}...`);
                reconnectWebSocket();
                break;
        }
        if (typeof $le8XK !== "undefined") {
            console.log(event);
            $le8XK.captureEvent(event);
        }
    };
};

});


parcelRegister("5fdtD", function(module, exports) {

$parcel$export(module.exports, "NOTICE_TYPES", function () { return $3d18cebc7bc4c86b$export$77e1908bd3247e53; });
$parcel$export(module.exports, "NOTICE_TYPES_RU", function () { return $3d18cebc7bc4c86b$export$bf9ca66640b438e0; });
$parcel$export(module.exports, "default", function () { return $3d18cebc7bc4c86b$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $jqdsN = parcelRequire("jqdsN");
parcelRequire("bh6RR");

var $9Qp9d = parcelRequire("9Qp9d");

var $iIg7Z = parcelRequire("iIg7Z");

var $5oGqh = parcelRequire("5oGqh");

var $cVtTV = parcelRequire("cVtTV");

var $kmHuZ = parcelRequire("kmHuZ");

var $43Ifw = parcelRequire("43Ifw");

var $cxTnx = parcelRequire("cxTnx");

var $jCoLF = parcelRequire("jCoLF");

var $1WnR3 = parcelRequire("1WnR3");

var $aitry = parcelRequire("aitry");

var $dQQxH = parcelRequire("dQQxH");

var $2jyC1 = parcelRequire("2jyC1");

var $6QcKa = parcelRequire("6QcKa");
const $3d18cebc7bc4c86b$var$AnimatedToastBody = (0, $jCoLF.default)((0, $1WnR3.DefaultToastBody)).withConfig({
    displayName: "noticesStore__AnimatedToastBody",
    componentId: "sc-11kae0q-0"
})([
    "animation:pulse 2s infinite ease-in-out;"
]);
const $3d18cebc7bc4c86b$var$toastManager = (0, $5oGqh.useToast)();
const $3d18cebc7bc4c86b$var$MessageType = {
    NEW_NOTICE: "new_notice"
};
const $3d18cebc7bc4c86b$export$77e1908bd3247e53 = {
    INFO: "info",
    ANALYSIS: "analysis",
    QUESTIONNAIRE: "questionnaire",
    LINK: "link",
    IMPORTANT: "important",
    AI_EVALUATION_STARTED: "ai_evaluation_started",
    AI_EVALUATION_FINISHED: "ai_evaluation_finished"
};
const $3d18cebc7bc4c86b$export$bf9ca66640b438e0 = {
    [$3d18cebc7bc4c86b$export$77e1908bd3247e53.INFO]: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F",
    [$3d18cebc7bc4c86b$export$77e1908bd3247e53.ANALYSIS]: "\u0410\u043D\u0430\u043B\u0438\u0437",
    [$3d18cebc7bc4c86b$export$77e1908bd3247e53.QUESTIONNAIRE]: "\u0410\u043D\u043A\u0435\u0442\u0430",
    [$3d18cebc7bc4c86b$export$77e1908bd3247e53.LINK]: "\u0412\u043D\u0435\u0448\u043D\u044F\u044F \u0441\u0441\u044B\u043B\u043A\u0430",
    [$3d18cebc7bc4c86b$export$77e1908bd3247e53.IMPORTANT]: "\u0412\u0430\u0436\u043D\u043E\u0435"
};
class $3d18cebc7bc4c86b$var$NoticesStore {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "socket", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "notices", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "noticesHeader", []);
        // unreadNotices = [];
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isInitialized", false);
        (0, $iIg7Z.default).bind(this, $3d18cebc7bc4c86b$var$NoticesStore);
        (0, $9Qp9d.makeAutoObservable)(this);
    }
    async initialize() {
        if (!this.isInitialized) {
            await this.fetchUnreadAndReadNotices();
            this.isInitialized = true;
            if (this.unreadNoticesCount) {
                const isImportantUnreadNotices = !!this.importantUnreadNotices.length;
                const title = isImportantUnreadNotices ? "\u0423 \u0412\u0430\u0441 \u0435\u0441\u0442\u044C \u0432\u0430\u0436\u043D\u044B\u0435 \u043D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F" : "\u0423 \u0412\u0430\u0441 \u0435\u0441\u0442\u044C \u043D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F";
                $3d18cebc7bc4c86b$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsx)((0, $43Ifw.NoticeToast), {
                    title: title,
                    modifiers: [
                        isImportantUnreadNotices ? "flickering" : ""
                    ]
                }), {
                    duration: 10000,
                    container: {
                        component: isImportantUnreadNotices ? $3d18cebc7bc4c86b$var$AnimatedToastBody : (0, $1WnR3.DefaultToastBody)
                    }
                });
            }
        }
    }
    initWS() {
        this.socket = new WebSocket((0, $kmHuZ.default).notices.getSocketUrl().toString());
        this.socket.onopen = ()=>{
            console.info("connection to notices channel established");
        };
        this.socket.onclose = (0, $cVtTV.socketErrorHandler)(this.socket, ()=>this.initWS());
        this.socket.onmessage = (event)=>{
            const message = JSON.parse(event.data);
            // Сделал еще один switch-case так как сообщения для оценки приемов имеют тот же message.type
            switch(message.type){
                case $3d18cebc7bc4c86b$var$MessageType.NEW_NOTICE:
                    switch(message.data.type){
                        case $3d18cebc7bc4c86b$export$77e1908bd3247e53.AI_EVALUATION_STARTED:
                            $3d18cebc7bc4c86b$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsx)((0, $43Ifw.NoticeToast), {
                                title: message.data.title,
                                text: message.data.description
                            }), {
                                duration: 10000,
                                container: {
                                    component: (0, $1WnR3.DefaultToastBody)
                                }
                            });
                            break;
                        case $3d18cebc7bc4c86b$export$77e1908bd3247e53.AI_EVALUATION_FINISHED:
                            {
                                var _message$data$params, _message$data$params$, _message$data$params2;
                                const text = "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442: ";
                                const colorIcon = (0, $2jyC1.EVALUATION_COLOR_MAP)[((_message$data$params = message.data.params) === null || _message$data$params === void 0 ? void 0 : (_message$data$params$ = _message$data$params.ai_evaluation) === null || _message$data$params$ === void 0 ? void 0 : _message$data$params$.total_color) ?? null];
                                const appointmentId = (_message$data$params2 = message.data.params) === null || _message$data$params2 === void 0 ? void 0 : _message$data$params2.appointment_id;
                                const description = /*#__PURE__*/ (0, $ih19M.jsxs)((0, $aitry.default), {
                                    component: "span",
                                    children: [
                                        text,
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dQQxH))), {
                                            sx: {
                                                color: colorIcon,
                                                verticalAlign: "middle",
                                                width: 16,
                                                height: 16
                                            }
                                        })
                                    ]
                                });
                                $3d18cebc7bc4c86b$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsx)((0, $43Ifw.NoticeToast), {
                                    title: message.data.title,
                                    customDescription: description
                                }), {
                                    duration: 10000,
                                    container: {
                                        component: (0, $1WnR3.DefaultToastBody)
                                    }
                                });
                                if (appointmentId) (0, $6QcKa.default).getAppointmentById(appointmentId, true);
                                break;
                            }
                        default:
                            {
                                const isImportantUnreadNotices = message.data.type === $3d18cebc7bc4c86b$export$77e1908bd3247e53.IMPORTANT;
                                const title = isImportantUnreadNotices ? "\u0423 \u0412\u0430\u0441 \u043D\u043E\u0432\u043E\u0435 \u0432\u0430\u0436\u043D\u043E\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435" : "\u0423 \u0412\u0430\u0441 \u043D\u043E\u0432\u043E\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435";
                                $3d18cebc7bc4c86b$var$toastManager.showToast(/*#__PURE__*/ (0, $ih19M.jsx)((0, $43Ifw.NoticeToast), {
                                    title: title,
                                    text: message.data.title
                                }), {
                                    duration: 10000,
                                    container: {
                                        component: isImportantUnreadNotices ? $3d18cebc7bc4c86b$var$AnimatedToastBody : (0, $1WnR3.DefaultToastBody)
                                    }
                                });
                                break;
                            }
                    }
                    /** В сообщении нет полного тела уведомления, пришлось перезапрашиваться */ this.fetchUnreadAndReadNotices();
                    break;
                default:
                    break;
            }
        };
    }
    get readedNotices() {
        return this.noticesHeader.filter((notice)=>notice.is_read).sort((a, b)=>$cxTnx(b.created_at) - $cxTnx(a.created_at));
    }
    get unreadNotices() {
        return this.noticesHeader.filter((notice)=>!notice.is_read && notice.type !== $3d18cebc7bc4c86b$export$77e1908bd3247e53.IMPORTANT);
    }
    get importantUnreadNotices() {
        return this.noticesHeader.filter((notice)=>!notice.is_read && notice.type === $3d18cebc7bc4c86b$export$77e1908bd3247e53.IMPORTANT);
    }
    get unreadNoticesCount() {
        return this.unreadNotices.length + this.importantUnreadNotices.length;
    }
    async createNotice(noticeData) {
        try {
            return await (0, $kmHuZ.default).notices.createNotice(noticeData);
        } catch (e) {
            console.log(e);
        }
    }
    async fetchAllNotices() {
        try {
            let response = await (0, $kmHuZ.default).notices.getNotices();
            if (response) this.notices = response;
            return response;
        } catch (e) {
            console.log(e);
        }
    }
    async fetchUnreadNotices() {
        try {
            let response = await (0, $kmHuZ.default).notices.getUnreadNotices();
            response;
            return response;
        } catch (e) {
            console.log(e);
        }
    }
    async fetchUnreadAndReadNotices() {
        try {
            let response = await (0, $kmHuZ.default).notices.getUnreadAndReadNotices();
            if (response) this.noticesHeader = response;
        } catch (e) {
            console.log(e);
        }
    }
    async readNotice(noticeId) {
        try {
            const response = await (0, $kmHuZ.default).notices.readNotice(noticeId);
            this.noticesHeader = this.noticesHeader.map((notice)=>{
                if (notice.id === noticeId) notice.is_read = true;
                return notice;
            });
            return response;
        } catch (e) {
            console.log(e);
        }
    }
    async makeNoticeUnread(noticeId) {
        try {
            return await (0, $kmHuZ.default).notices.unreadNotice(noticeId);
        } catch (e) {
            console.log(e);
        }
    }
    async editNotice(noticeId, noticeData) {
        try {
            return await (0, $kmHuZ.default).notices.updateNotice(noticeId, noticeData);
        } catch (e) {
            console.log(e);
        }
    }
    async deleteNotice(noticeId) {
        try {
            return await (0, $kmHuZ.default).notices.deleteNotice(noticeId);
        } catch (e) {
            console.log(e);
        }
    }
}
var $3d18cebc7bc4c86b$export$2e2bcd8739ae039 = new $3d18cebc7bc4c86b$var$NoticesStore();

});
parcelRegister("43Ifw", function(module, exports) {

$parcel$export(module.exports, "NoticeToast", function () { return $2f49c436a7668529$export$4bb2aa7d3aa7dd1c; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $i0wFy = parcelRequire("i0wFy");
const $2f49c436a7668529$var$ToastContainer = (0, $jCoLF.default).div.withConfig({
    displayName: "NoticeToast__ToastContainer",
    componentId: "sc-e10iy4-0"
})([
    "display:flex;flex-direction:column;gap:5px;"
]);
const $2f49c436a7668529$var$ToastTitle = (0, $jCoLF.default).span.withConfig({
    displayName: "NoticeToast__ToastTitle",
    componentId: "sc-e10iy4-1"
})([
    "font-size:14px;font-weight:500;"
]);
const $2f49c436a7668529$var$ToastDescription = (0, $jCoLF.default).span.withConfig({
    displayName: "NoticeToast__ToastDescription",
    componentId: "sc-e10iy4-2"
})([
    "font-size:13px;line-height:15px;color:",
    ";display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;"
], (0, $i0wFy.colors).gray700);
const $2f49c436a7668529$export$4bb2aa7d3aa7dd1c = ({ title: title = "\u0423 \u0412\u0430\u0441 \u043D\u043E\u0432\u043E\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435", text: text = "", customDescription: customDescription })=>{
    return /*#__PURE__*/ (0, $ih19M.jsxs)($2f49c436a7668529$var$ToastContainer, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($2f49c436a7668529$var$ToastTitle, {
                children: title
            }),
            customDescription ? customDescription : !!text && /*#__PURE__*/ (0, $ih19M.jsx)($2f49c436a7668529$var$ToastDescription, {
                children: text
            })
        ]
    });
};

});

parcelRegister("dQQxH", function(module, exports) {
"use strict";
"use client";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a158e386f7924969$var$_createSvgIcon = $2ZnTs((parcelRequire("lpAdr")));

var $ih19M = parcelRequire("ih19M");
var $a158e386f7924969$var$_default = module.exports.default = (0, $a158e386f7924969$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), "Star");

});

parcelRegister("2jyC1", function(module, exports) {

$parcel$export(module.exports, "EVALUATION_COLOR_MAP", function () { return $1af8346a97ef9474$export$488059ddbbcacb3c; });
$parcel$export(module.exports, "EVALUATION_COLORS", function () { return $1af8346a97ef9474$export$b89e25cef2be91b7; });
$parcel$export(module.exports, "EVALUATION_SCORE", function () { return $1af8346a97ef9474$export$39c22c059e0fcccb; });
$parcel$export(module.exports, "default", function () { return $1af8346a97ef9474$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");
parcelRequire("bh6RR");

var $9Qp9d = parcelRequire("9Qp9d");

var $5oGqh = parcelRequire("5oGqh");

var $iIg7Z = parcelRequire("iIg7Z");

var $kmHuZ = parcelRequire("kmHuZ");

var $i0wFy = parcelRequire("i0wFy");

var $i6z7r = parcelRequire("i6z7r");

var $6QcKa = parcelRequire("6QcKa");
parcelRequire("lrsw3");
const $1af8346a97ef9474$var$toastManager = (0, $5oGqh.useToast)(); // Добавил для дальнейшей работы с сокетами
const $1af8346a97ef9474$export$488059ddbbcacb3c = {
    green: (0, $i0wFy.colors).success0,
    yellow: "#FFDC00",
    red: (0, $i0wFy.colors).error0,
    null: "#808080"
};
const $1af8346a97ef9474$export$b89e25cef2be91b7 = {
    GREEN: "green",
    YELLOW: "yellow",
    RED: "red"
};
const $1af8346a97ef9474$export$39c22c059e0fcccb = [
    {
        from: 85,
        to: 100,
        color: $1af8346a97ef9474$export$488059ddbbcacb3c.green
    },
    {
        from: 70,
        to: 84,
        color: $1af8346a97ef9474$export$488059ddbbcacb3c.yellow
    },
    {
        from: 0,
        to: 69,
        color: $1af8346a97ef9474$export$488059ddbbcacb3c.red
    }
];
class $1af8346a97ef9474$var$AppointmentEvaluationStore {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isEvaluationsLoading", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "aiEvaluation", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isHideAiEvaluation", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "selectedExpert1", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "selectedExpert2", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "expertEvaluations", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "expandedSections", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "criterions", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "appointment", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "currentCriterionIndex", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "currentUserEvaluation", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isEditMode", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "evaluationData", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "choicedCriteria", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isEndEvaluateLoading", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isOpenModal", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isValidForm", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isValidReasonForm", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "prevEvaluateAppointmentIds", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "expandedReasons", []);
        (0, $iIg7Z.default).bind(this, $1af8346a97ef9474$var$AppointmentEvaluationStore);
        (0, $9Qp9d.makeAutoObservable)(this, {}, {
            deep: true
        });
    }
    startEvaluation() {
        if (this.checkEvaluationFromLocalstorage()) this.setIsEditMode(true);
        return true;
    }
    setEvaluationsLoading(value) {
        this.isEvaluationsLoading = value;
    }
    setIsEndEvaluateLoading(value) {
        this.isEndEvaluateLoading = value;
    }
    onOpenModal() {
        var _this$choicedCriteria;
        this.isOpenModal = true;
        this.expandedReasons = (_this$choicedCriteria = this.choicedCriteria) === null || _this$choicedCriteria === void 0 ? void 0 : _this$choicedCriteria.selected_reasons.filter((reason)=>reason.checked).map((reason)=>reason.reason_id);
        this.expandedSections = this.evaluationData.criterion_values.filter((criteria)=>(criteria === null || criteria === void 0 ? void 0 : criteria.color) && (criteria === null || criteria === void 0 ? void 0 : criteria.color) !== "green").map((criteria)=>criteria.criterion_id);
    }
    onEditCriteria(criterionIndex) {
        var _this$choicedCriteria2;
        this.setCurrentCriterionIndex(criterionIndex);
        this.choicedCriteria = {
            ...this.evaluationData.criterion_values[criterionIndex]
        };
        this.choicedCriteria.selected_reasons = ((_this$choicedCriteria2 = this.choicedCriteria) === null || _this$choicedCriteria2 === void 0 ? void 0 : _this$choicedCriteria2.selected_reasons.slice().map((criterion_reason)=>({
                ...criterion_reason
            }))) || null;
        this.onOpenModal();
    }
    onCloseModal() {
        this.isOpenModal = false;
        this.setIsValidForm();
    }
    setIsEndEvaluateLoading(value) {
        this.isEndEvaluateLoading = value;
    }
    onOpenModal() {
        var _this$choicedCriteria3;
        this.isOpenModal = true;
        this.expandedReasons = (_this$choicedCriteria3 = this.choicedCriteria) === null || _this$choicedCriteria3 === void 0 ? void 0 : _this$choicedCriteria3.selected_reasons.filter((reason)=>reason.checked).map((reason)=>reason.reason_id);
        this.setIsValidReasonForm();
    }
    onCloseModal() {
        this.isOpenModal = false;
        this.setIsValidForm();
    }
    setCurrentCriterionIndex(value) {
        this.currentCriterionIndex = value;
    }
    onSaveDataModal(criterionIndex) {
        var _this$choicedCriteria4;
        this.evaluationData.criterion_values[criterionIndex] = {
            ...this.choicedCriteria,
            selected_reasons: ((_this$choicedCriteria4 = this.choicedCriteria.selected_reasons) === null || _this$choicedCriteria4 === void 0 ? void 0 : _this$choicedCriteria4.slice().map((criterion_reason)=>({
                    ...criterion_reason
                }))) || null
        };
        this.expandedSections.push(this.choicedCriteria.criterion_id);
        this.choicedCriteria;
        this.onCloseModal();
    }
    setExpandedSection(id, forcedClose) {
        if (this.isSectionExpanded(id) || forcedClose) this.expandedSections = this.expandedSections.filter((sectionId)=>sectionId !== id);
        else this.expandedSections.push(id);
    }
    setExpandedSections(value) {
        this.expandedSections = value;
    }
    setExpandedReasons(id, reason) {
        if (this.isReasonExpanded(id)) {
            this.expandedReasons = this.expandedReasons.filter((sectionId)=>sectionId !== id);
            reason.checked = false;
        } else {
            this.expandedReasons.push(id);
            reason.checked = true;
        }
        this.setIsValidReasonForm();
    }
    isSectionExpanded(id) {
        return this.expandedSections.includes(id);
    }
    isReasonExpanded(id) {
        return this.expandedReasons.includes(id);
    }
    setSelectedExpert(id, target) {
        var _this$aiEvaluation;
        const expert = target === "expert2" && id === ((_this$aiEvaluation = this.aiEvaluation) === null || _this$aiEvaluation === void 0 ? void 0 : _this$aiEvaluation.id) ? this.aiEvaluation : this.expertEvaluations.find((e)=>e.id === id) ?? null;
        if (target === "expert1") this.selectedExpert1 = expert;
        else this.selectedExpert2 = expert;
    }
    setCurrentUserEvaluation() {
        const evaluation = this.expertEvaluations.find((evaluation)=>{
            var _evaluation$expert, _authStore$user, _authStore$user$exper;
            return (evaluation === null || evaluation === void 0 ? void 0 : (_evaluation$expert = evaluation.expert) === null || _evaluation$expert === void 0 ? void 0 : _evaluation$expert.id) === ((0, $i6z7r.default) === null || (0, $i6z7r.default) === void 0 ? void 0 : (_authStore$user = (0, $i6z7r.default).user) === null || _authStore$user === void 0 ? void 0 : (_authStore$user$exper = _authStore$user.expert) === null || _authStore$user$exper === void 0 ? void 0 : _authStore$user$exper.id);
        });
        this.currentUserEvaluation = evaluation;
    }
    setIsEditMode(value) {
        this.isEditMode = value;
    }
    setIsDefected(value) {
        this.evaluationData.is_defected = value;
        if (value === false) this.setDefectedComment("");
        this.setIsValidForm();
    }
    setDefectedComment(value) {
        this.evaluationData.defect_comment = value;
        this.setIsValidForm();
    }
    setOverallComment(value) {
        this.evaluationData.overall_comment = value;
        this.setIsValidForm();
    }
    setCriterions(value) {
        this.criterions = value;
    }
    setStarColor(color, criterionIndex, criterionId) {
        if (this.evaluationData.criterion_values[criterionIndex].color !== color) {
            this.setCurrentCriterionIndex(criterionIndex);
            if (color === "red" || color === "yellow") {
                this.choicedCriteria = {
                    ...this.evaluationData.criterion_values[criterionIndex]
                };
                this.choicedCriteria.selected_reasons = this.choicedCriteria[color].slice().map((criterion_reason)=>({
                        ...criterion_reason
                    })) || null;
                this.onOpenModal();
            }
            if (color === "green") {
                this.choicedCriteria = this.evaluationData.criterion_values[criterionIndex];
                this.choicedCriteria.selected_reasons = [];
                this.setExpandedSection(this.choicedCriteria.criterion_id, true);
            }
            this.choicedCriteria.color = color;
        } else this.evaluationData.criterion_values[criterionIndex].color = "";
        this.setIsValidForm();
    }
    setCriterionComment(comment, criterion) {
        criterion.comment = comment;
        this.setIsValidReasonForm();
    }
    setIsValidForm() {
        const isDefected = this.evaluationData.is_defected && this.evaluationData.defect_comment.trim();
        if (isDefected) {
            this.isValidForm = true;
            return;
        }
        const isCriteriaValid = this.evaluationData.criterion_values.every((criterion)=>(criterion === null || criterion === void 0 ? void 0 : criterion.color) === $1af8346a97ef9474$export$b89e25cef2be91b7.GREEN || ((criterion === null || criterion === void 0 ? void 0 : criterion.color) === $1af8346a97ef9474$export$b89e25cef2be91b7.RED || (criterion === null || criterion === void 0 ? void 0 : criterion.color) === $1af8346a97ef9474$export$b89e25cef2be91b7.YELLOW) && ((criterion === null || criterion === void 0 ? void 0 : criterion.selected_reasons.some((reason)=>reason.checked)) || (criterion === null || criterion === void 0 ? void 0 : criterion.comment.trim())));
        this.isValidForm = isCriteriaValid && !this.evaluationData.is_defected;
    }
    setIsValidReasonForm() {
        this.isValidReasonForm = this.choicedCriteria.selected_reasons.some((reason)=>reason.checked) || this.choicedCriteria.comment.trim();
    }
    hideNotCurrentEvaluations() {
        this.setCurrentUserEvaluation();
        this.isHideAiEvaluation = true;
        this.aiEvaluation = null;
        this.selectedExpert1 = this.currentUserEvaluation;
        this.selectedExpert2 = null;
    }
    // Обогощение формы оценки, если начала или редактирования оценки
    setEvaluationData(criterions, expert) {
        var _appointmentStore$app;
        const data = localStorage.getItem("evaluation");
        if (data) {
            this.evaluationData = JSON.parse(data);
            return;
        }
        this.evaluationData = {
            overall_comment: expert ? expert.overall_comment : "",
            is_created_by_ai: false,
            appointment_id: (_appointmentStore$app = (0, $6QcKa.default).appointment) === null || _appointmentStore$app === void 0 ? void 0 : _appointmentStore$app.id,
            criterion_values: (criterions === null || criterions === void 0 ? void 0 : criterions.map((item, index)=>{
                var _item$criterion, _expert$criterion_val, _expert$criterion_val2, _expert$criterion_val3, _expert$criterion_val4, _item$criterion_reaso, _item$criterion_reaso2, _item$criterion_reaso3;
                return {
                    criterion_id: (_item$criterion = item.criterion) === null || _item$criterion === void 0 ? void 0 : _item$criterion.id,
                    color: expert ? expert === null || expert === void 0 ? void 0 : (_expert$criterion_val = expert.criterion_values) === null || _expert$criterion_val === void 0 ? void 0 : (_expert$criterion_val2 = _expert$criterion_val[index]) === null || _expert$criterion_val2 === void 0 ? void 0 : _expert$criterion_val2.color : "",
                    comment: expert ? expert === null || expert === void 0 ? void 0 : (_expert$criterion_val3 = expert.criterion_values) === null || _expert$criterion_val3 === void 0 ? void 0 : (_expert$criterion_val4 = _expert$criterion_val3[index]) === null || _expert$criterion_val4 === void 0 ? void 0 : _expert$criterion_val4.comment : "",
                    selected_reasons: expert ? item === null || item === void 0 ? void 0 : (_item$criterion_reaso = item.criterion_reasons) === null || _item$criterion_reaso === void 0 ? void 0 : _item$criterion_reaso.filter((criterion_reason)=>{
                        var _expert$criterion_val5, _expert$criterion_val6;
                        return criterion_reason === null || criterion_reason === void 0 ? void 0 : criterion_reason.selectable_colors.includes(expert === null || expert === void 0 ? void 0 : (_expert$criterion_val5 = expert.criterion_values) === null || _expert$criterion_val5 === void 0 ? void 0 : (_expert$criterion_val6 = _expert$criterion_val5[index]) === null || _expert$criterion_val6 === void 0 ? void 0 : _expert$criterion_val6.color);
                    }).map((criterion_reason)=>{
                        var _expert$criterion_val7, _expert$criterion_val8;
                        const selected = expert === null || expert === void 0 ? void 0 : (_expert$criterion_val7 = expert.criterion_values) === null || _expert$criterion_val7 === void 0 ? void 0 : (_expert$criterion_val8 = _expert$criterion_val7[index]) === null || _expert$criterion_val8 === void 0 ? void 0 : _expert$criterion_val8.selected_reasons.find((r)=>r.reason.id === (criterion_reason === null || criterion_reason === void 0 ? void 0 : criterion_reason.reason.id));
                        return {
                            reason_id: (criterion_reason === null || criterion_reason === void 0 ? void 0 : criterion_reason.reason.id) ?? "",
                            comment: (selected === null || selected === void 0 ? void 0 : selected.comment) ?? "",
                            name: (criterion_reason === null || criterion_reason === void 0 ? void 0 : criterion_reason.reason.name) ?? "",
                            checked: !!selected
                        };
                    }) : [],
                    red: (item === null || item === void 0 ? void 0 : (_item$criterion_reaso2 = item.criterion_reasons) === null || _item$criterion_reaso2 === void 0 ? void 0 : _item$criterion_reaso2.filter((criterion_reason)=>criterion_reason === null || criterion_reason === void 0 ? void 0 : criterion_reason.selectable_colors.includes("red")).map((criterion_reason)=>({
                            reason_id: (criterion_reason === null || criterion_reason === void 0 ? void 0 : criterion_reason.reason.id) ?? "",
                            comment: "",
                            name: (criterion_reason === null || criterion_reason === void 0 ? void 0 : criterion_reason.reason.name) ?? "",
                            checked: false
                        }))) || null,
                    yellow: (item === null || item === void 0 ? void 0 : (_item$criterion_reaso3 = item.criterion_reasons) === null || _item$criterion_reaso3 === void 0 ? void 0 : _item$criterion_reaso3.filter((criterion_reason)=>criterion_reason === null || criterion_reason === void 0 ? void 0 : criterion_reason.selectable_colors.includes("yellow")).map((criterion_reason)=>({
                            reason_id: (criterion_reason === null || criterion_reason === void 0 ? void 0 : criterion_reason.reason.id) ?? "",
                            comment: "",
                            name: (criterion_reason === null || criterion_reason === void 0 ? void 0 : criterion_reason.reason.name) ?? "",
                            checked: false
                        }))) || null
                };
            })) || null,
            is_defected: expert ? expert.is_defected : false,
            defect_comment: expert ? expert.defect_comment : ""
        };
    }
    prepareEvaluationDataForSend() {
        var _this$evaluationData;
        return {
            ...this.evaluationData,
            criterion_values: (_this$evaluationData = this.evaluationData) === null || _this$evaluationData === void 0 ? void 0 : _this$evaluationData.criterion_values.map((item)=>{
                var _item$selected_reason;
                return {
                    criterion_id: item === null || item === void 0 ? void 0 : item.criterion_id,
                    color: (item === null || item === void 0 ? void 0 : item.color) ?? "",
                    comment: (item === null || item === void 0 ? void 0 : item.comment) ?? "",
                    selected_reasons: item === null || item === void 0 ? void 0 : (_item$selected_reason = item.selected_reasons) === null || _item$selected_reason === void 0 ? void 0 : _item$selected_reason.filter((reason)=>reason.checked).map((reason)=>({
                            reason_id: (reason === null || reason === void 0 ? void 0 : reason.reason_id) ?? "",
                            comment: (reason === null || reason === void 0 ? void 0 : reason.comment) ?? ""
                        }))
                };
            })
        };
    }
    clearStores() {
        this.expertEvaluations = [];
        this.expandedSections = [];
        this.expandedReasons = [];
        this.expertEvaluations = [];
        this.criterions = [];
        this.evaluationData = null;
        this.choicedCriteria = null;
        this.currentUserEvaluation = null;
        this.currentCriterionIndex = null;
    }
    saveEvaluationToLocalstorage() {
        if (this.isEditMode) {
            var _this$evaluationData2;
            const data = JSON.stringify(this.evaluationData);
            localStorage.setItem("evaluation", data);
            localStorage.setItem("appointment_evaluation_id", (_this$evaluationData2 = this.evaluationData) === null || _this$evaluationData2 === void 0 ? void 0 : _this$evaluationData2.appointment_id);
        }
    }
    checkEvaluationFromLocalstorage() {
        return !!localStorage.getItem("evaluation");
    }
    cleanEvaluationFromLocalstorage() {
        localStorage.removeItem("evaluation");
        localStorage.removeItem("appointment_evaluation_id");
    }
    async getAiEvaluationById(id) {
        if (!this.isHideAiEvaluation) this.aiEvaluation = await (0, $kmHuZ.default).appointmentEvaluation.getAiEvaluationById(id);
    }
    async getEvaluationById(ids) {
        this.expertEvaluations[0] = await (0, $kmHuZ.default).appointmentEvaluation.getEvaluationById(ids[0].id);
        if (ids.length > 1) this.expertEvaluations[1] = await (0, $kmHuZ.default).appointmentEvaluation.getEvaluationById(ids[1].id);
    }
    async getCriterionsForEvaluate(appointment, isSetEvaluationData) {
        try {
            var _appointment$layout;
            this.setEvaluationsLoading(true);
            if (appointment !== null && appointment !== void 0 && (_appointment$layout = appointment.layout) !== null && _appointment$layout !== void 0 && _appointment$layout.id) {
                var _appointment$layout2;
                const response = await (0, $kmHuZ.default).appointments.getLayoutsToEvaluate(appointment === null || appointment === void 0 ? void 0 : (_appointment$layout2 = appointment.layout) === null || _appointment$layout2 === void 0 ? void 0 : _appointment$layout2.id);
                this.setCriterions(response === null || response === void 0 ? void 0 : response.results);
            }
            this.setEvaluationData(this.criterions, this.currentUserEvaluation);
            if (localStorage.getItem("appointment_evaluation_id") == this.appointment.id) {
                const isEmptyTable = this.expertEvaluations.length === 0 && !this.aiEvaluation && !this.isEditMode;
                this.expandedSections = isEmptyTable ? [] : this.evaluationData.criterion_values.filter((criteria)=>(criteria === null || criteria === void 0 ? void 0 : criteria.color) && (criteria === null || criteria === void 0 ? void 0 : criteria.color) !== "green").map((criteria)=>criteria.criterion_id);
            }
        } catch (err) {
            throw Error("\u041E\u0448\u0438\u0431\u043A\u0430 \u0432 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0438 \u043A\u0440\u0438\u0442\u0435\u0440\u0438\u0435\u0432");
        } finally{
            this.setEvaluationsLoading(false);
        }
    }
    async updateEvaluationsByAppointment(appointment, forced) {
        var _this$appointment;
        if (((_this$appointment = this.appointment) === null || _this$appointment === void 0 ? void 0 : _this$appointment.id) !== (appointment === null || appointment === void 0 ? void 0 : appointment.id) || forced) try {
            var _appointment$ai_evalu, _appointment$my_exper, _this$expertEvaluatio, _this$aiEvaluation2, _this$expertEvaluatio2;
            this.appointment = appointment;
            this.setEvaluationsLoading(true);
            this.expertEvaluations = [];
            if ((_appointment$ai_evalu = appointment.ai_evaluation) !== null && _appointment$ai_evalu !== void 0 && _appointment$ai_evalu.id) await this.getAiEvaluationById(appointment.ai_evaluation.id);
            if (appointment.expert_evaluations && appointment.expert_evaluations.length > 0) await this.getEvaluationById(appointment.expert_evaluations);
            if (appointment !== null && appointment !== void 0 && (_appointment$my_exper = appointment.my_expert_evaluation) !== null && _appointment$my_exper !== void 0 && _appointment$my_exper.id) {
                var _appointment$my_exper2;
                this.expertEvaluations[0] = await (0, $kmHuZ.default).appointmentEvaluation.getEvaluationById(appointment === null || appointment === void 0 ? void 0 : (_appointment$my_exper2 = appointment.my_expert_evaluation) === null || _appointment$my_exper2 === void 0 ? void 0 : _appointment$my_exper2.id);
            }
            this.setCurrentUserEvaluation();
            await this.getCriterionsForEvaluate(appointment, false);
            this.setSelectedExpert(((_this$expertEvaluatio = this.expertEvaluations[0]) === null || _this$expertEvaluatio === void 0 ? void 0 : _this$expertEvaluatio.id) || null, "expert1");
            this.setSelectedExpert(((_this$aiEvaluation2 = this.aiEvaluation) === null || _this$aiEvaluation2 === void 0 ? void 0 : _this$aiEvaluation2.id) || ((_this$expertEvaluatio2 = this.expertEvaluations[1]) === null || _this$expertEvaluatio2 === void 0 ? void 0 : _this$expertEvaluatio2.id) || null, "expert2");
            this.setExpandedSections([
                ...this.expandedSections,
                "overall-comment",
                "defect_comment"
            ]);
        } catch (err) {
            throw Error("\u041E\u0448\u0438\u0431\u043A\u0430 \u0432 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0438 \u043E\u0446\u0435\u043D\u043E\u043A");
        } finally{
            this.setEvaluationsLoading(false);
        }
    }
    async getNextToEvaluate(id) {
        var _this$appointment2;
        this.setEvaluationsLoading(true);
        this.clearStores();
        this.cleanEvaluationFromLocalstorage();
        if ((_this$appointment2 = this.appointment) !== null && _this$appointment2 !== void 0 && _this$appointment2.id) this.prevEvaluateAppointmentIds.push(this.appointment.id);
        this.appointment = await (0, $6QcKa.default).getAppointmentsNextToEvaluate();
        await this.updateEvaluationsByAppointment(this.appointment, true);
        this.setEvaluationsLoading(false);
    }
    async getPrevToEvaluate() {
        if (this.prevEvaluateAppointmentIds.length > 0) {
            this.clearStores();
            this.cleanEvaluationFromLocalstorage();
            const id = this.prevEvaluateAppointmentIds.pop();
            this.appointment = await (0, $6QcKa.default).getAppointmentById(id);
            await this.updateEvaluationsByAppointment(this.appointment, true);
        }
    }
    async sendEvaluation(id) {
        try {
            this.setIsEndEvaluateLoading(true);
            this.cleanEvaluationFromLocalstorage();
            const prepareData = this.prepareEvaluationDataForSend();
            if (id) {
                const response = await (0, $kmHuZ.default).appointments.putAppointmentEvaluation(id, prepareData);
                await (0, $6QcKa.default).getAppointmentById(response.appointment_id);
                this.expertEvaluations[0] = await (0, $kmHuZ.default).appointmentEvaluation.getEvaluationById(response.id);
                this.selectedExpert1 = this.expertEvaluations[0];
            } else {
                const response = await (0, $kmHuZ.default).appointments.postAppointmentEvaluation(prepareData);
                await (0, $6QcKa.default).getAppointmentById(response.appointment_id);
                this.expertEvaluations[0] = await (0, $kmHuZ.default).appointmentEvaluation.getEvaluationById(response.id);
                this.selectedExpert1 = this.expertEvaluations[0];
            }
        } catch (err) {
            throw Error("\u041E\u0448\u0438\u0431\u043A\u0430 \u0432 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u043E\u0446\u0435\u043D\u043A\u0438");
        } finally{
            this.setIsEditMode(false);
            this.setIsEndEvaluateLoading(false);
        }
    }
    getEvaluationColor(color) {
        return $1af8346a97ef9474$export$488059ddbbcacb3c[color];
    }
}
var $1af8346a97ef9474$export$2e2bcd8739ae039 = new $1af8346a97ef9474$var$AppointmentEvaluationStore();

});
parcelRegister("6QcKa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fb17c063c9849ed$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $9Qp9d = parcelRequire("9Qp9d");

var $kmHuZ = parcelRequire("kmHuZ");

var $1lysy = parcelRequire("1lysy");
class $4fb17c063c9849ed$var$AppointmentStore {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "appointments", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "appointment", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "copyAppointment", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "medicalFile", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "medicalFiles", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "patientId", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "oldPatientId", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "folder", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isEndAppointmentsLoading", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isMedicalFileLoading", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "loadingAppointment", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isDisplayFolders", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "changeCopyAppointment", (value)=>{
            this.copyAppointment = value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "setLoadingAppointment", (value)=>{
            this.loadingAppointment = value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "setFolder", (value)=>{
            this.folder = value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "changeIsEndAppointmentsLoading", (value)=>{
            this.isEndAppointmentsLoading = value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "changeIsMedicalFileLoading", (value)=>{
            this.isMedicalFileLoading = value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "changeIsDisplayFolders", (value)=>{
            this.isDisplayFolders = value;
        });
        (0, $9Qp9d.makeAutoObservable)(this);
    }
    setAppointment(appointment) {
        this.appointment = appointment;
    }
    setMedicalFile(medicalFile) {
        var _medicalFile$patient;
        this.medicalFile = medicalFile;
        this.setPatientId(medicalFile === null || medicalFile === void 0 ? void 0 : (_medicalFile$patient = medicalFile.patient) === null || _medicalFile$patient === void 0 ? void 0 : _medicalFile$patient.id);
        this.getAppointments();
        this.isMedicalFileLoading = false;
    }
    setPatientId(patientId) {
        this.patientId = patientId;
    }
    setAppointments(appointments) {
        this.appointments = appointments;
    }
    async getAppointmentsNextToEvaluate(id) {
        try {
            this.setLoadingAppointment(true);
            if (id) this.setAppointment(await (0, $kmHuZ.default).appointments.getAppointmentById(id));
            else this.setAppointment(await (0, $kmHuZ.default).appointments.getAppointmentsNextToEvaluate());
        } catch (e) {
            console.log(e);
        } finally{
            this.setLoadingAppointment(false);
        }
        return this.appointment;
    }
    async getAppointmentById(id, noLoader) {
        try {
            if (!noLoader) this.setLoadingAppointment(true);
            this.appointment = await (0, $kmHuZ.default).appointments.getAppointmentById(id);
        } catch (e) {
            console.log(e);
        } finally{
            this.setLoadingAppointment(false);
        }
        return this.appointment;
    }
    async getAppointments(isChange) {
        try {
            if ((typeof this.patientId !== "number" || this.oldPatientId === this.patientId) && !isChange) {
                this.isEndAppointmentsLoading = true;
                return;
            }
            this.isEndAppointmentsLoading = false;
            const result = await (0, $kmHuZ.default).appointments.getAppointmentsByPatientId(this.patientId, this.isDisplayFolders);
            this.oldPatientId = this.patientId;
            this.setAppointments(result.map((obj)=>({
                    ...obj.data,
                    type: obj.type
                })));
        } catch (e) {
            console.log(e);
        } finally{
            this.isEndAppointmentsLoading = true;
        }
    }
    async getMedicalFile(medicalFileId) {
        try {
            this.isMedicalFileLoading = true;
            if (!this.medicalFile || this.medicalFile.id !== medicalFileId) {
                const result = await (0, $kmHuZ.default).medicalFiles.getById(medicalFileId);
                this.setMedicalFile(result);
            } else this.getAppointments();
        } catch (e) {
            console.log(e);
        } finally{
            this.isMedicalFileLoading = false;
        }
    }
    async getMedicalFiles() {
        try {
            if ((typeof this.patientId !== "number" || this.oldPatientId === this.patientId) && this.medicalFiles.length) return;
            const response = await (0, $kmHuZ.default).medicalFilesV2.get({
                patientId: this.patientId
            });
            this.medicalFiles = response;
            this.oldPatientId = this.patientId;
        } catch (e) {
            console.log(e);
        }
    }
    async getMedicalFilesForOrganizations() {
        await this.getMedicalFiles();
        return this.medicalFiles.filter((medicalFile)=>{
            return (0, $1lysy.default).getDoctorOrganizations().findIndex((organization)=>organization.id === medicalFile.organization.id) >= 0;
        });
    }
    getOpeningCheckupAppointments() {
        if (!this.isDisplayFolders) {
            const checkupAppointments = this.appointments.filter((appointment)=>appointment.folder && appointment.folder.name.startsWith("\u0427\u0435\u043A\u0430\u043F"));
            let counterOpeningCheckUp = 0;
            let counterClosingCheckUp = 0;
            return checkupAppointments.reduce((acc, appointment)=>{
                appointment.layout.opening_check_up && counterOpeningCheckUp++;
                appointment.layout.closing_check_up && counterClosingCheckUp++;
                if (counterOpeningCheckUp !== counterClosingCheckUp || !appointment.date_finished) acc.push(appointment);
                return acc;
            }, []);
        }
        const checkupAppointments = this.appointments.filter((appointment)=>appointment.type === "folder" && appointment.name.startsWith("\u0427\u0435\u043A\u0430\u043F"));
        return checkupAppointments.reduce((acc, current)=>{
            let counterOpeningCheckUp = 0;
            let counterClosingCheckUp = 0;
            current.appointments.forEach((item)=>{
                item.layout.opening_check_up && counterOpeningCheckUp++;
                item.layout.closing_check_up && counterClosingCheckUp++;
            });
            const isFinishedAppointmentClosingCheckUp = current.appointments.every((appointment)=>appointment.date_finished);
            if (counterOpeningCheckUp !== counterClosingCheckUp || !isFinishedAppointmentClosingCheckUp) acc.push(current);
            return acc;
        }, []);
    }
    get appointmentTickets() {
        var _this$appointment;
        return ((_this$appointment = this.appointment) === null || _this$appointment === void 0 ? void 0 : _this$appointment.stat_tickets) || [];
    }
    get appointmentHasRedeemedStatTickets() {
        return this.appointmentTickets.some((ticket)=>ticket.is_redeemed);
    }
}
var $4fb17c063c9849ed$export$2e2bcd8739ae039 = new $4fb17c063c9849ed$var$AppointmentStore();

});
parcelRegister("1lysy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fb27b89cd4607d5$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $kmHuZ = parcelRequire("kmHuZ");

var $9Qp9d = parcelRequire("9Qp9d");

var $kEUo3 = parcelRequire("kEUo3");

var $i6z7r = parcelRequire("i6z7r");
class $0fb27b89cd4607d5$var$OrganizationsStore {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "organizations", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "loadingData", false);
        (0, $9Qp9d.makeAutoObservable)(this);
    }
    async getOrganizations(isAnonymous) {
        if (!this.organizations.length && !this.loadingData) try {
            this.loadingData = true;
            let response = [];
            if (isAnonymous) response = await (0, $kmHuZ.default).integrations.getOrganizations();
            else response = await (0, $kmHuZ.default).organizations.getAllOrganizations();
            this.organizations = (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).sortBy(response, "name");
            this.loadingData = false;
            return this.organizations;
        } catch (e) {
            console.error(e);
            this.loadingData = false;
            return false;
        }
        else return this.organizations;
    }
    getOrganization(id) {
        return this.organizations.find((item)=>item.id === id);
    }
    getDoctorOrganizations() {
        var _authStore$user, _authStore$user$docto;
        const organizationsDoctorIds = (_authStore$user = (0, $i6z7r.default).user) === null || _authStore$user === void 0 ? void 0 : (_authStore$user$docto = _authStore$user.doctor) === null || _authStore$user$docto === void 0 ? void 0 : _authStore$user$docto.organizations;
        return this.organizations.filter((item)=>organizationsDoctorIds.includes(item.id));
    }
    /** Администратору доступны все организации в рамках города (IDs городов получаем из доступных организации) */ getAdministratorOrganizations() {
        const availableCities = this.getDoctorOrganizations().map((organization)=>organization.city.id);
        return this.organizations.filter((item)=>{
            var _item$city;
            return availableCities.includes((_item$city = item.city) === null || _item$city === void 0 ? void 0 : _item$city.id);
        });
    }
    /** С переносом клиники Рассвет из города "Москва Рассвет" с id 19 в город "Москва" с id 12 */ getGroupedOrganizationByCity(isAdministrator = false) {
        const organizations = isAdministrator ? this.getAdministratorOrganizations() : this.getDoctorOrganizations();
        return organizations.reduce((acc, organization)=>{
            if (!organization.city) return acc;
            let cityId = organization.city.id === 19 ? 12 : organization.city.id;
            if (!acc[cityId]) acc[cityId] = [];
            acc[cityId].push(organization);
            return acc;
        }, {});
    }
    getCities() {
        return this.organizations.reduce((cities, item)=>{
            if (!cities.find((city)=>city.id === item.city.id)) {
                if (item.city.id !== 19) cities.push(item.city);
            }
            return cities;
        }, []);
    }
    getCities() {
        return this.organizations.reduce((cities, item)=>{
            if (!cities.find((city)=>city.id === item.city.id)) {
                if (item.city.id !== 19) cities.push(item.city);
            }
            return cities;
        }, []);
    }
}
var $0fb27b89cd4607d5$export$2e2bcd8739ae039 = new $0fb27b89cd4607d5$var$OrganizationsStore();

});




parcelRegister("c00UK", function(module, exports) {

$parcel$export(module.exports, "TABS", function () { return $8bc631b20740936a$export$73b877b58963a4f; });
$parcel$export(module.exports, "TABS_NAME", function () { return $8bc631b20740936a$export$9a118bc9d66623fe; });
$parcel$export(module.exports, "TABS_URL", function () { return $8bc631b20740936a$export$f23c537d19b38531; });
$parcel$export(module.exports, "default", function () { return $8bc631b20740936a$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $9Qp9d = parcelRequire("9Qp9d");

var $iOlMk = parcelRequire("iOlMk");
parcelRequire("iG4aO");

var $3SASg = parcelRequire("3SASg");
const $8bc631b20740936a$export$73b877b58963a4f = {
    SCHEDULE: "schedule",
    HISTORY: "history",
    ACCOUNT: "account",
    FEEDBACK: "feedback",
    MY_PATIENTS: "my_patients",
    GENERAL_SCHEDULE: "general_schedule",
    GENERAL_SCHEDULE_NEW: "general_schedule_new",
    HOSPITAL: "hospital",
    CARD_CHECK: "card-check",
    CHATS: "chats",
    UPDATE_NEWS: "update_news",
    PROFILE: "profile",
    MORE_NAVIGATION_TABS: "more_navigation_tabs",
    SUPPORT: "support",
    EXIT: "exit",
    PATIENTS: "patients",
    CORPORATE_PORTAL: "corporate_portal",
    REVIEW_STATISTICS: "review_statistics",
    REPORTS_VRT: "reports_vrt",
    IDEAS_2500: "2500_ideas"
};
const $8bc631b20740936a$export$9a118bc9d66623fe = {
    [$8bc631b20740936a$export$73b877b58963a4f.SCHEDULE]: "\u041C\u043E\u0435 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
    [$8bc631b20740936a$export$73b877b58963a4f.HISTORY]: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u043F\u0440\u0438\u0435\u043C\u043E\u0432",
    [$8bc631b20740936a$export$73b877b58963a4f.ACCOUNT]: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C",
    [$8bc631b20740936a$export$73b877b58963a4f.FEEDBACK]: "\u041E\u0431\u0440\u0430\u0442\u043D\u0430\u044F \u0441\u0432\u044F\u0437\u044C",
    [$8bc631b20740936a$export$73b877b58963a4f.MY_PATIENTS]: "\u0418\u0441\u0445\u043E\u0434\u044B \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0412\u0420\u0422",
    [$8bc631b20740936a$export$73b877b58963a4f.GENERAL_SCHEDULE]: "\u041E\u0431\u0449\u0435\u0435 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
    [$8bc631b20740936a$export$73b877b58963a4f.GENERAL_SCHEDULE_NEW]: "\u041D\u043E\u0432\u043E\u0435 \u043E\u0431\u0449\u0435\u0435 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
    [$8bc631b20740936a$export$73b877b58963a4f.HOSPITAL]: "\u0421\u0442\u0430\u0446\u0438\u043E\u043D\u0430\u0440",
    [$8bc631b20740936a$export$73b877b58963a4f.CARD_CHECK]: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043A\u0430\u0440\u0442",
    [$8bc631b20740936a$export$73b877b58963a4f.CHATS]: "\u0427\u0430\u0442\u044B",
    // [TABS.UPDATE_NEWS]: "Что нового",
    [$8bc631b20740936a$export$73b877b58963a4f.PROFILE]: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C",
    [$8bc631b20740936a$export$73b877b58963a4f.SUPPORT]: "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
    [$8bc631b20740936a$export$73b877b58963a4f.MORE_NAVIGATION_TABS]: "\u0415\u0449\u0435",
    [$8bc631b20740936a$export$73b877b58963a4f.PATIENTS]: "\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u043E\u0432",
    [$8bc631b20740936a$export$73b877b58963a4f.REVIEW_STATISTICS]: "\u041E\u0442\u0437\u044B\u0432\u044B \u0437\u0430 \u0431\u0430\u043B\u043B\u044B",
    [$8bc631b20740936a$export$73b877b58963a4f.REPORTS_VRT]: "\u041E\u0442\u0447\u0435\u0442\u044B \u0412\u0420\u0422",
    [$8bc631b20740936a$export$73b877b58963a4f.IDEAS_2500]: "2500 \u0438\u0434\u0435\u0439"
};
const $8bc631b20740936a$export$f23c537d19b38531 = {
    [$8bc631b20740936a$export$73b877b58963a4f.SCHEDULE]: "/schedule",
    [$8bc631b20740936a$export$73b877b58963a4f.HISTORY]: "/schedule/history",
    [$8bc631b20740936a$export$73b877b58963a4f.ACCOUNT]: "/account",
    [$8bc631b20740936a$export$73b877b58963a4f.FEEDBACK]: "/schedule/feedback",
    [$8bc631b20740936a$export$73b877b58963a4f.MY_PATIENTS]: "/my-patients",
    [$8bc631b20740936a$export$73b877b58963a4f.GENERAL_SCHEDULE]: "/general-schedule",
    [$8bc631b20740936a$export$73b877b58963a4f.GENERAL_SCHEDULE_NEW]: "/general-schedule-new",
    [$8bc631b20740936a$export$73b877b58963a4f.HOSPITAL]: "/schedule/hospital",
    [$8bc631b20740936a$export$73b877b58963a4f.CARD_CHECK]: "/card-check",
    [$8bc631b20740936a$export$73b877b58963a4f.CHATS]: "/chats",
    // [TABS.UPDATE_NEWS]: UPDATE_NEWS_LINK,
    [$8bc631b20740936a$export$73b877b58963a4f.PROFILE]: "/profile",
    [$8bc631b20740936a$export$73b877b58963a4f.MORE_NAVIGATION_TABS]: "/more-navigation-tabs",
    [$8bc631b20740936a$export$73b877b58963a4f.PATIENTS]: "/patients",
    [$8bc631b20740936a$export$73b877b58963a4f.CORPORATE_PORTAL]: "/corporate-portal",
    [$8bc631b20740936a$export$73b877b58963a4f.REVIEW_STATISTICS]: "/review-statistics",
    [$8bc631b20740936a$export$73b877b58963a4f.REPORTS_VRT]: "/reports-vrt",
    [$8bc631b20740936a$export$73b877b58963a4f.IDEAS_2500]: {
        link: "/survey/10",
        external: true,
        allowBack: true
    }
};
class $8bc631b20740936a$var$HeaderStore {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "activeTab", "schedule");
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "lastMainNavigationTab", $8bc631b20740936a$export$73b877b58963a4f.SCHEDULE);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isNurse", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isHospitalApproved", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "outcomesExists", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "drawerIsCollapsed", false);
        (0, $9Qp9d.makeAutoObservable)(this);
        this.setActiveTab = this.setActiveTab.bind(this);
        (0, $iOlMk.currentUser).watch((user)=>{
            // Подписываемся на изменения пользователя в старой сторе
            this.setIsHospitalApproved(Boolean(user && (user.role === "doctor" && user.doctor && user.doctor.specialities && Boolean(user.doctor.specialities.find((item)=>item.name === "\u0425\u0438\u0440\u0443\u0440\u0433")) || user.role === "post_nurse")));
            this.setOutcomesExists(Boolean(user && user.role === "doctor" && user.doctor && user.doctor.outcomes_exists));
            this.setIsNurse(Boolean(user && user.role === "post_nurse"));
        });
    }
    isShowNavigationTab(isMobileDevice) {
        if (!isMobileDevice) return !this.isNurse;
        else return !this.isNurse && [
            $8bc631b20740936a$export$73b877b58963a4f.HISTORY,
            $8bc631b20740936a$export$73b877b58963a4f.SCHEDULE,
            $8bc631b20740936a$export$73b877b58963a4f.GENERAL_SCHEDULE,
            $8bc631b20740936a$export$73b877b58963a4f.GENERAL_SCHEDULE_NEW,
            $8bc631b20740936a$export$73b877b58963a4f.CHATS,
            $8bc631b20740936a$export$73b877b58963a4f.MORE_NAVIGATION_TABS
        ].includes(this.activeTab);
    }
    setActiveTab(tab) {
        if (tab === this.activeTab) return;
        if ([
            $8bc631b20740936a$export$73b877b58963a4f.HISTORY,
            $8bc631b20740936a$export$73b877b58963a4f.SCHEDULE,
            $8bc631b20740936a$export$73b877b58963a4f.GENERAL_SCHEDULE,
            $8bc631b20740936a$export$73b877b58963a4f.CARD_CHECK,
            $8bc631b20740936a$export$73b877b58963a4f.CHATS,
            $8bc631b20740936a$export$73b877b58963a4f.MORE_NAVIGATION_TABS
        ].includes(tab)) this.setLastMainNavigationTab(tab);
        this.activeTab = tab;
        if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(JSON.stringify({
            isNavigationVisible: [
                $8bc631b20740936a$export$73b877b58963a4f.HISTORY,
                $8bc631b20740936a$export$73b877b58963a4f.SCHEDULE,
                $8bc631b20740936a$export$73b877b58963a4f.GENERAL_SCHEDULE,
                $8bc631b20740936a$export$73b877b58963a4f.GENERAL_SCHEDULE_NEW,
                $8bc631b20740936a$export$73b877b58963a4f.CHATS,
                $8bc631b20740936a$export$73b877b58963a4f.MORE_NAVIGATION_TABS
            ].includes(this.activeTab)
        }));
    }
    setLastMainNavigationTab(tab) {
        this.lastMainNavigationTab = tab;
    }
    setActiveTabByLocationPath(path) {
        const activeTab = Object.keys($8bc631b20740936a$export$f23c537d19b38531).filter((tab)=>path.includes($8bc631b20740936a$export$f23c537d19b38531[tab]));
        this.setActiveTab(activeTab.length === 1 ? activeTab[0] : activeTab[1]);
    }
    setIsHospitalApproved(value) {
        this.isHospitalApproved = value;
    }
    setIsNurse(value) {
        this.isNurse = value;
    }
    setOutcomesExists(value) {
        this.outcomesExists = value;
    }
    handlerChangeTab(tab, history) {
        if (tab === $8bc631b20740936a$export$73b877b58963a4f.EXIT) return;
        const remoteURLReg = /https?:/;
        let url = $8bc631b20740936a$export$f23c537d19b38531[tab];
        let isUrlExternal;
        if (url instanceof Object) {
            isUrlExternal = url.external || remoteURLReg.test(url.link) || false;
            if (url.allowBack) localStorage.setItem("back-url", location.pathname);
            url = url.link;
        } else isUrlExternal = remoteURLReg.test(url);
        if (isUrlExternal) {
            if (window.ReactNativeWebView) {
                window.scrollTo(0, 0);
                history.push(url);
            } else window.open(url, "_blank");
            if (tab === $8bc631b20740936a$export$73b877b58963a4f.UPDATE_NEWS) (0, $3SASg.default).changeIsShowedUpdateVersion(true);
        } else {
            this.setActiveTab(tab);
            window.scrollTo(0, 0);
            history.push($8bc631b20740936a$export$f23c537d19b38531[tab]);
        }
    }
    handlerOnCollapseDrawer(flag) {
        this.drawerIsCollapsed = flag;
    }
}
var $8bc631b20740936a$export$2e2bcd8739ae039 = new $8bc631b20740936a$var$HeaderStore();

});
parcelRegister("iG4aO", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $d98f62f68fad36a9$export$a4ad2735b021c132; });
$parcel$export(module.exports, "UPDATE_NEWS_LINK", function () { return $d98f62f68fad36a9$export$6baf532172a34572; });
const $d98f62f68fad36a9$export$a4ad2735b021c132 = "2024.09";
const $d98f62f68fad36a9$export$6baf532172a34572 = "https://public.app.shortcut.com/bf/fomin-clinic/docs/38Ao0m6TxhfuyQMyj2LA8k/september-2024";

});

parcelRegister("3SASg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d3304b5d86b5b89$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $9Qp9d = parcelRequire("9Qp9d");

var $iG4aO = parcelRequire("iG4aO");

var $iOlMk = parcelRequire("iOlMk");
const $2d3304b5d86b5b89$var$SHOW_UPDATE_KEY = "show_ems_update_data";
class $2d3304b5d86b5b89$var$CommonStore {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "showUpdateVersionModal", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isShowedUpdateVersion", false);
        (0, $9Qp9d.makeAutoObservable)(this);
    }
    saveDataShow(data) {
        localStorage.setItem($2d3304b5d86b5b89$var$SHOW_UPDATE_KEY, JSON.stringify(data));
    }
    showUpdateVersion(data, user) {
        if (user && user.role === "doctor") {
            if (!data.version || data.version !== (0, $iG4aO.VERSION)) {
                data.version = (0, $iG4aO.VERSION);
                data.doctorList = [];
                this.saveDataShow(data);
            }
            if (!data.doctorList.includes(user.doctor.id)) {
                data.doctorList.push(user.doctor.id);
                this.saveDataShow(data);
            }
        }
    }
    checkShowedUpdateVersion() {
        const showUpdateLocalData = localStorage.getItem($2d3304b5d86b5b89$var$SHOW_UPDATE_KEY);
        if (showUpdateLocalData) {
            const user = (0, $iOlMk.currentUser).getState();
            const parsedDataShow = JSON.parse(showUpdateLocalData);
            if (parsedDataShow.doctorList.includes(user.doctor.id)) this.changeIsShowedUpdateVersion(true);
        }
    }
    changeShowUpdateVersionModal(value) {
        this.showUpdateVersionModal = value;
    }
    changeIsShowedUpdateVersion(value) {
        this.isShowedUpdateVersion = value;
        if (this.isShowedUpdateVersion) {
            const user = (0, $iOlMk.currentUser).getState();
            const showUpdateLocalData = localStorage.getItem($2d3304b5d86b5b89$var$SHOW_UPDATE_KEY);
            let showParsedData = {
                version: (0, $iG4aO.VERSION),
                doctorList: []
            };
            if (showUpdateLocalData) showParsedData = JSON.parse(showUpdateLocalData);
            this.showUpdateVersion(showParsedData, user);
        }
    }
}
var $2d3304b5d86b5b89$export$2e2bcd8739ae039 = new $2d3304b5d86b5b89$var$CommonStore();

});


parcelRegister("dyAGA", function(module, exports) {

$parcel$export(module.exports, "TICKET_STATUSES", function () { return $9deae8639aea4ab2$export$7233a6c549e5376c; });
$parcel$export(module.exports, "TICKET_PRIORITIES", function () { return $9deae8639aea4ab2$export$61e1ce5eb351a620; });
$parcel$export(module.exports, "AREAS_FIELD", function () { return $9deae8639aea4ab2$export$571fc321d148eac; });
$parcel$export(module.exports, "getTicketOptionsByAccessorKey", function () { return $9deae8639aea4ab2$export$f4c422c0b8f983b6; });
$parcel$export(module.exports, "TICKET_SEGMENTS", function () { return $9deae8639aea4ab2$export$b785703f0923c5b5; });
$parcel$export(module.exports, "TICKET_SEGMENTS_URL", function () { return $9deae8639aea4ab2$export$fb2debb33ecbbf2b; });
$parcel$export(module.exports, "convertedFieldAdditionalInfo", function () { return $9deae8639aea4ab2$export$3e3c6491ec66784b; });
$parcel$export(module.exports, "default", function () { return $9deae8639aea4ab2$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $jqdsN = parcelRequire("jqdsN");

var $9Qp9d = parcelRequire("9Qp9d");

var $jCgCX = parcelRequire("jCgCX");

var $aW3mw = parcelRequire("aW3mw");

var $kmHuZ = parcelRequire("kmHuZ");

var $jo8NH = parcelRequire("jo8NH");

var $hnKMr = parcelRequire("hnKMr");

var $9Toj9 = parcelRequire("9Toj9");

var $ariGN = parcelRequire("ariGN");

var $cxTnx = parcelRequire("cxTnx");

var $gu8wR = parcelRequire("gu8wR");

var $i6z7r = parcelRequire("i6z7r");

var $2F0j2 = parcelRequire("2F0j2");

var $1lysy = parcelRequire("1lysy");
const $9deae8639aea4ab2$var$transformCommentData = (comment)=>{
    var _comment$author$docto, _comment$author$docto2, _comment$author$docto3, _comment$author$docto4;
    const fullName = comment.author.doctor ? (0, $hnKMr.getPatientLastNameWithInitials)(comment.author.doctor) : comment.author.username;
    const placeholderAvatar = !comment.author.doctor.last_name || !comment.author.doctor.first_name ? "" : `${(_comment$author$docto = comment.author.doctor) === null || _comment$author$docto === void 0 ? void 0 : (_comment$author$docto2 = _comment$author$docto.last_name) === null || _comment$author$docto2 === void 0 ? void 0 : _comment$author$docto2.slice(0, 1)}${(_comment$author$docto3 = comment.author.doctor) === null || _comment$author$docto3 === void 0 ? void 0 : (_comment$author$docto4 = _comment$author$docto3.first_name) === null || _comment$author$docto4 === void 0 ? void 0 : _comment$author$docto4.slice(0, 1)}`;
    return {
        id: comment.id,
        text: comment.comment.split("\n"),
        avatar: {
            src: comment.author.photo,
            placeholder: placeholderAvatar
        },
        fullName: fullName,
        date: (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX)))(comment.created_at).format((0, $jo8NH.READABLE_DATE_TIME_FORMAT))
    };
};
const $9deae8639aea4ab2$export$7233a6c549e5376c = {
    created: "\u0421\u043E\u0437\u0434\u0430\u043D",
    clarify: "\u041D\u0430 \u0443\u0442\u043E\u0447\u043D\u0435\u043D\u0438\u0438",
    inprogress: "\u0412 \u0440\u0430\u0431\u043E\u0442\u0435",
    testing: "\u041D\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0435",
    done: "\u0413\u043E\u0442\u043E\u0432"
};
const $9deae8639aea4ab2$export$29eb3227fb1c3f68 = {
    created: "\u041D\u043E\u0432\u0430\u044F \u0437\u0430\u044F\u0432\u043A\u0430",
    inprogress: "\u0412 \u0440\u0430\u0431\u043E\u0442\u0435",
    waitingInsurance: "\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0430 \u0421\u041A",
    waitingGuaranteeLetter: "\u041E\u0436\u0438\u0434\u0430\u0435\u043C \u0413\u041F",
    done: "\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u0430\u044F"
};
const $9deae8639aea4ab2$export$fe8e47c4f1b7ad1f = {
    created: "default",
    inprogress: "warning",
    waitingInsurance: "warning",
    waitingGuaranteeLetter: "warning",
    done: "success"
};
const $9deae8639aea4ab2$export$61e1ce5eb351a620 = {
    urgent: "\u0421\u0440\u043E\u0447\u043D\u044B\u0439",
    high: "\u0412\u044B\u0441\u043E\u043A\u0438\u0439",
    medium: "\u0421\u0440\u0435\u0434\u043D\u0438\u0439",
    low: "\u041D\u0438\u0437\u043A\u0438\u0439"
};
const $9deae8639aea4ab2$export$571fc321d148eac = {
    app: "\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430",
    doctor_app: "\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0432\u0440\u0430\u0447\u0430",
    telemed: "\u0422\u0435\u043B\u0435\u043C\u0435\u0434 (\u0432\u0438\u0434\u0435\u043E\u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u0438 \u0438 \u0447\u0430\u0442\u044B)",
    asya: "\u0410\u0441\u044F",
    site: "\u0421\u0430\u0439\u0442 Fomin-Clinic",
    mis: "\u041C\u0418\u0421 (1C)",
    ["Legal lab"]: "Legal Lab",
    new_feature: "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u043E \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044E",
    other: "\u0414\u0440\u0443\u0433\u043E\u0435"
};
const $9deae8639aea4ab2$var$BASIC_OPTIONS_TABLE = {
    initialState: {
        showColumnFilters: true,
        columnVisibility: {
            updated_at: false,
            author_text: false,
            author__username: false,
            plus_authors: false
        }
    },
    actions: [
        "edit"
    ]
};
const $9deae8639aea4ab2$var$OPTIONS_BY_KEY = {
    status: $9deae8639aea4ab2$export$7233a6c549e5376c,
    statusDMS: $9deae8639aea4ab2$export$29eb3227fb1c3f68,
    priority: $9deae8639aea4ab2$export$61e1ce5eb351a620
};
const $9deae8639aea4ab2$export$f4c422c0b8f983b6 = (accessorKey)=>{
    return Object.entries($9deae8639aea4ab2$var$OPTIONS_BY_KEY[accessorKey]).map(([value, label])=>({
            value: value,
            label: label
        }));
};
const $9deae8639aea4ab2$export$b785703f0923c5b5 = {
    COMMON: {
        name: "common",
        additionalFilters: ()=>{},
        hiddenColumns: [],
        disabledFieldsForCreation: [],
        disabledFieldsForEditing: [],
        hiddenFieldForCreation: [],
        hiddenFieldForEditing: [],
        additionalEditValues: [
            "files__file",
            "files__name",
            "files__id"
        ],
        annotate_mtm_edit_params: {
            "files": [
                "files__file",
                "files__name",
                "files__id"
            ]
        },
        doctorAssignee: ()=>{
            return (0, $9Toj9.featureValueIdArray)((0, $9Toj9.FEATURE).TICKET_DOCTOR_ASSIGNEE_COMMON) || [];
        },
        optionsTable: $9deae8639aea4ab2$var$BASIC_OPTIONS_TABLE,
        defaultData: ()=>{}
    },
    LEGAL_LAB: {
        name: "legal-lab",
        additionalFilters: ()=>({
                area: "Legal lab"
            }),
        hiddenColumns: [
            "area",
            "plus_authors",
            "author_text",
            "author__username"
        ],
        disabledFieldsForCreation: [],
        disabledFieldsForEditing: [],
        hiddenFieldForCreation: [
            "area",
            "plus_authors",
            "author_text",
            "author__username",
            "new_files"
        ],
        hiddenFieldForEditing: [
            "area",
            "plus_authors",
            "author_text",
            "author__username",
            "new_files"
        ],
        optionsTable: $9deae8639aea4ab2$var$BASIC_OPTIONS_TABLE,
        doctorAssignee: ()=>{
            return (0, $9Toj9.featureValueIdArray)((0, $9Toj9.FEATURE).TICKET_DOCTOR_ASSIGNEE_COMMON) || [];
        },
        defaultData: ()=>({
                area: "Legal lab"
            })
    },
    PROFILE: {
        name: "profile",
        // ToDo бек не умеет принимать {value} || {value}
        additionalFilters: (userID)=>({
                author: userID
            }),
        hiddenColumns: [
            "author_text",
            "author__username"
        ],
        disabledFieldsForCreation: [],
        disabledFieldsForEditing: [],
        hiddenFieldForCreation: [
            "author_text",
            "author__username",
            "new_files"
        ],
        hiddenFieldForEditing: [
            "author_text",
            "author__username",
            "new_files"
        ],
        doctorAssignee: ()=>{
            return (0, $9Toj9.featureValueIdArray)((0, $9Toj9.FEATURE).TICKET_DOCTOR_ASSIGNEE_COMMON) || [];
        },
        optionsTable: $9deae8639aea4ab2$var$BASIC_OPTIONS_TABLE,
        defaultData: ()=>{}
    },
    MEDICAL_ERROR: {
        name: "medical-error",
        additionalFilters: ()=>({
                area: "\u0412\u0440\u0430\u0447\u0435\u0431\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430"
            }),
        hiddenColumns: [
            "area",
            "plus_authors",
            "author_text",
            "author__username"
        ],
        disabledFieldsForCreation: [
            "description"
        ],
        disabledFieldsForEditing: [
            "description"
        ],
        hiddenFieldForCreation: [
            "area",
            "plus_authors",
            "status",
            "theme",
            "author_text",
            "author__username",
            "new_files"
        ],
        hiddenFieldForEditing: [
            "area",
            "plus_authors",
            "theme",
            "author_text",
            "author__username",
            "new_files"
        ],
        optionsTable: $9deae8639aea4ab2$var$BASIC_OPTIONS_TABLE,
        doctorAssignee: ()=>{
            return (0, $9Toj9.featureValueIdArray)((0, $9Toj9.FEATURE).TICKET_DOCTOR_ASSIGNEE_MEDICAL_ERROR) || [];
        },
        defaultData: ()=>({
                area: "\u0412\u0440\u0430\u0447\u0435\u0431\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430",
                status: "created",
                theme: "\u0412\u0440\u0430\u0447\u0435\u0431\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430"
            })
    },
    MANAGER_DMS: {
        name: "manager-dms",
        annotateMtmParams: {
            "appointment__medical_file__patient__policies": "appointment__medical_file__patient__policies__org_name",
            "appointment__medical_file__patient__letters_guarantee": "appointment__medical_file__patient__letters_guarantee__counterparty"
        },
        additionalFilters: ()=>({
                area: "manager_dms",
                appointment__medical_file__organization__in: (0, $i6z7r.default).user.doctor.organizations
            }),
        optionsTable: $9deae8639aea4ab2$var$BASIC_OPTIONS_TABLE,
        disabledFieldsForCreation: [],
        disabledFieldsForEditing: [],
        hiddenFieldForCreation: [],
        hiddenFieldForEditing: [],
        additionalEditValues: [
            "doctor_fullname",
            "patient_fullname",
            "appointment__medical_file__patient__birthdate",
            "appointment__medical_file__patient__letters_guarantee__counterparty",
            "appointment__medical_file__patient__letters_guarantee__number_letter_guarantee",
            "appointment__medical_file__patient__letters_guarantee__start_date",
            "appointment__medical_file__patient__letters_guarantee__end_date",
            "appointment__medical_file__patient__policies__org_name",
            "appointment__medical_file__patient__policies__number",
            "appointment__medical_file__patient__policies__start_date",
            "appointment__medical_file__patient__policies__end_date",
            "created_at",
            "appointment__layout__name",
            "appointment__primary_diagnoses__diagnosis__name",
            "appointment__primary_diagnoses__comment",
            "appointment__id",
            "files__file",
            "files__name",
            "files__id"
        ],
        annotate_mtm_edit_params: {
            "appointment__primary_diagnoses__diagnosis__name": "appointment__primary_diagnoses__diagnosis__name",
            "appointment__primary_diagnoses__comment": "appointment__primary_diagnoses__comment",
            "files": [
                "files__file",
                "files__name",
                "files__id"
            ],
            "appointment__medical_file__patient__policies": [
                "appointment__medical_file__patient__policies__org_name",
                "appointment__medical_file__patient__policies__number",
                "appointment__medical_file__patient__policies__start_date",
                "appointment__medical_file__patient__policies__end_date"
            ],
            "appointment__medical_file__patient__letters_guarantee": [
                "appointment__medical_file__patient__letters_guarantee__counterparty",
                "appointment__medical_file__patient__letters_guarantee__number_letter_guarantee",
                "appointment__medical_file__patient__letters_guarantee__start_date",
                "appointment__medical_file__patient__letters_guarantee__end_date"
            ]
        },
        defaultEditData: ()=>({
                fullname_manager_dms: (0, $2F0j2.getLastNameWithInitials)((0, $i6z7r.default).user.doctor),
                approval_period_dms: 30,
                area: "manager_dms"
            }),
        defaultData: ()=>({
                area: "manager_dms",
                status: "created",
                theme: "\u041C\u044D\u043D\u0435\u0434\u0436\u0435\u0440 \u0414\u041C\u0421"
            }),
        patchFields: [
            "id",
            "fullname_manager_dms",
            "fullname_curator_insurance_dms",
            "approval_date_dms",
            "approval_period_dms",
            "description",
            "letter_guarantee_number",
            "status",
            "area"
        ],
        handlerWatcherOnChangeField: (updatedData, reset, changedKey)=>{
            if (changedKey !== "fullname_curator_insurance_dms" && changedKey !== "letter_guarantee_number") return {};
            /** Обработка, если пользователь успеет внести изменения в разрез debounceTime */ if (updatedData.fullname_curator_insurance_dms.length && updatedData.letter_guarantee_number.length) {
                /** Сбросить значение для поля, которое устанавливалось изначально */ reset({
                    ...updatedData,
                    [changedKey]: ""
                });
                /** Заблокировать данное поле */ return {
                    disabledFields: {
                        "fullname_curator_insurance_dms": changedKey === "fullname_curator_insurance_dms",
                        "letter_guarantee_number": changedKey === "letter_guarantee_number"
                    }
                };
            }
            return {
                disabledFields: {
                    "fullname_curator_insurance_dms": changedKey === "fullname_curator_insurance_dms" ? false : !!updatedData[changedKey].length,
                    "letter_guarantee_number": changedKey === "letter_guarantee_number" ? false : !!updatedData[changedKey].length
                }
            };
        },
        editSchema: [
            {
                type: "text",
                name: "area",
                label: "",
                hiddenField: true,
                disabled: true
            },
            {
                type: "text",
                name: "fullname_manager_dms",
                label: "\u0424\u0418\u041E \u0430\u0432\u0442\u043E\u0440\u0430 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0430",
                disabled: true
            },
            {
                type: "text",
                name: "fullname_curator_insurance_dms",
                label: "\u0424\u0418\u041E \u043A\u0443\u0440\u0430\u0442\u043E\u0440\u0430 \u043E\u0442 \u0421\u041A"
            },
            {
                type: "date",
                typePicker: "dateTime",
                name: "approval_date_dms",
                label: "\u0414\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043C\u044F \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u044F"
            },
            {
                type: "number",
                name: "approval_period_dms",
                label: "\u0421\u0440\u043E\u043A \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u044F"
            },
            {
                type: "textarea",
                name: "description",
                label: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439"
            },
            {
                type: "text",
                name: "letter_guarantee_number",
                label: "\u041D\u043E\u043C\u0435\u0440 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0439\u043D\u043E\u0433\u043E \u043F\u0438\u0441\u044C\u043C\u0430"
            },
            {
                type: "file",
                name: "new_files",
                currentFiles: "files",
                multiple: true,
                deleteMethod: async (value)=>{
                    await (0, $kmHuZ.default).ticket.deleteTicketFiles(value.id);
                },
                placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u0430\u0439\u043B"
            },
            {
                type: "select",
                name: "status",
                label: "\u0421\u0442\u0430\u0442\u0443\u0441",
                options: $9deae8639aea4ab2$export$f4c422c0b8f983b6("statusDMS")
            }
        ],
        tableColumns: ()=>[
                {
                    accessorKey: "appointment__medical_file__patient__policies__org_name",
                    //normal accessorKey
                    additionalFields: [
                        "appointment__medical_file__patient__letters_guarantee__counterparty"
                    ],
                    header: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u043E\u0439 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438",
                    grow: false,
                    size: 400,
                    filterFn: "icontains",
                    Cell: ({ row: row })=>{
                        if (row.original.appointment__medical_file__patient__policies__org_name && row.original.appointment__medical_file__patient__policies__org_name[0] !== null) {
                            let orgNames = "";
                            row.original.appointment__medical_file__patient__policies__org_name.forEach((item, index)=>{
                                orgNames += index === 0 ? item : `, ${item}`;
                            });
                            return orgNames;
                        }
                        if (row.original.appointment__medical_file__patient__letters_guarantee__counterparty && row.original.appointment__medical_file__patient__letters_guarantee__counterparty[0] !== null) {
                            let orgNames = "";
                            row.original.appointment__medical_file__patient__letters_guarantee__counterparty.forEach((item, index)=>{
                                orgNames += index === 0 ? item : `, ${item}`;
                            });
                            return orgNames;
                        }
                        return "";
                    }
                },
                {
                    accessorKey: "status",
                    additionalFields: [
                        "updated_at_status"
                    ],
                    header: "\u0421\u0442\u0430\u0442\u0443\u0441",
                    filterFn: "in",
                    filterVariant: "multi-select",
                    filterSelectOptions: $9deae8639aea4ab2$export$f4c422c0b8f983b6("statusDMS"),
                    Cell: ({ row: row })=>{
                        const getColor = ()=>{
                            if ((row.original.status === "created" || row.original.status === "inprogress") && (row.original.updated_at_status ? (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))().diff((0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(row.original.updated_at_status), "days") : (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))().diff((0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(row.original.created_at), "days"))) return "error";
                            else return $9deae8639aea4ab2$export$fe8e47c4f1b7ad1f[row.original.status];
                        };
                        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                            label: $9deae8639aea4ab2$export$29eb3227fb1c3f68[row.original.status],
                            variant: "outlined",
                            color: getColor()
                        });
                    },
                    size: 300
                },
                {
                    accessorKey: "appointment__medical_file__organization__name",
                    header: "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F",
                    filterFn: "in",
                    filterVariant: "multi-select",
                    filterSelectOptions: (0, $1lysy.default).organizations.filter((item)=>(0, $i6z7r.default).user.doctor.organizations.includes(item.id)).map((item)=>({
                            value: item.name,
                            label: item.name
                        })),
                    size: 300
                },
                {
                    accessorKey: "doctor_fullname",
                    //normal accessorKey
                    header: "\u0424\u0418\u041E \u0432\u0440\u0430\u0447\u0430",
                    grow: false,
                    size: 300,
                    filterFn: "icontains",
                    Cell: ({ row: row })=>(0, $ariGN.trimLongTextValueField)(row.original.doctor_fullname)
                },
                {
                    accessorKey: "patient_fullname",
                    //normal accessorKey
                    header: "\u0424\u0418\u041E \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430",
                    grow: false,
                    size: 300,
                    filterFn: "icontains",
                    Cell: ({ row: row })=>(0, $ariGN.trimLongTextValueField)(row.original.patient_fullname)
                },
                {
                    accessorKey: "created_at",
                    header: "\u0414\u0430\u0442\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u0437\u0430\u044F\u0432\u043A\u0438",
                    size: 250,
                    enableColumnFilter: false,
                    Cell: ({ cell: cell })=>cell.getValue() ? (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(cell.getValue()).format((0, $jo8NH.READABLE_DATE_FORMAT)) : ""
                },
                {
                    accessorKey: "id",
                    header: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440",
                    size: 200,
                    filterFn: "icontains",
                    enableHiding: false
                }
            ]
    }
};
const $9deae8639aea4ab2$export$fb2debb33ecbbf2b = {
    "legal-lab": $9deae8639aea4ab2$export$b785703f0923c5b5.LEGAL_LAB,
    "common": $9deae8639aea4ab2$export$b785703f0923c5b5.COMMON,
    "profile": $9deae8639aea4ab2$export$b785703f0923c5b5.PROFILE,
    "medical-error": $9deae8639aea4ab2$export$b785703f0923c5b5.MEDICAL_ERROR,
    "manager-dms": $9deae8639aea4ab2$export$b785703f0923c5b5.MANAGER_DMS
};
const $9deae8639aea4ab2$export$51344410a61e265c = {
    client_phone: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D: ",
    client_email: "\u041F\u043E\u0447\u0442\u0430: ",
    client_id: "ID: ",
    client_city: "\u0413\u043E\u0440\u043E\u0434: ",
    client_device: "\u041C\u043E\u0434\u0435\u043B\u044C \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430: "
};
const $9deae8639aea4ab2$export$3e3c6491ec66784b = (value)=>{
    return Object.entries(value).map(([key, value])=>`${$9deae8639aea4ab2$export$51344410a61e265c[key] || ""}${value}; `).join("\n");
};
class $9deae8639aea4ab2$var$TicketStore extends (0, $aW3mw.default) {
    static getSegmentUrl() {
        const splitPathName = location.pathname.split("/");
        let segment = $9deae8639aea4ab2$export$b785703f0923c5b5.COMMON.name;
        if (location.pathname.includes("/profile/")) segment = $9deae8639aea4ab2$export$b785703f0923c5b5.PROFILE.name;
        else if (location.pathname.includes("/segment/")) segment = splitPathName[splitPathName.indexOf("segment") + 1];
        return $9deae8639aea4ab2$export$fb2debb33ecbbf2b[segment];
    }
    constructor(){
        const segment = $9deae8639aea4ab2$var$TicketStore.getSegmentUrl().name;
        super((0, $kmHuZ.default).ticket.getListTickets.bind({
            ...(0, $kmHuZ.default).ticket,
            presetFilterParams: segment !== $9deae8639aea4ab2$export$b785703f0923c5b5.MEDICAL_ERROR.name && segment !== $9deae8639aea4ab2$export$b785703f0923c5b5.MANAGER_DMS.name ? {
                area__in: Object.keys($9deae8639aea4ab2$export$571fc321d148eac)
            } : null
        }));
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "ticketID", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "ticket", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "segment", $9deae8639aea4ab2$export$b785703f0923c5b5.COMMON.name);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "feedbackData", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "comments", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "DMSServices", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "mobileTicketVoxData", null);
        this.setSegment(segment);
        (0, $9Qp9d.makeObservable)(this, {
            setTicketID: (0, $9Qp9d.action),
            ticketID: (0, $9Qp9d.observable),
            getTicket: (0, $9Qp9d.action),
            setTicket: (0, $9Qp9d.action),
            ticket: (0, $9Qp9d.observable),
            setFeedbackData: (0, $9Qp9d.action),
            feedbackData: (0, $9Qp9d.observable),
            setComments: (0, $9Qp9d.action),
            updateComments: (0, $9Qp9d.action),
            setMobileTicketVoxData: (0, $9Qp9d.action),
            resetMobileTicketVoxData: (0, $9Qp9d.action),
            comments: (0, $9Qp9d.observable),
            DMSServices: (0, $9Qp9d.observable),
            mobileTicketVoxData: (0, $9Qp9d.observable)
        });
    }
    setTicketID(id) {
        this.ticket = null;
        this.ticketID = id;
    }
    setTicket(ticket) {
        if (ticket && ticket.area === "\u0412\u0440\u0430\u0447\u0435\u0431\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430") ticket.author__username = "";
        this.ticket = ticket;
    }
    setSegment(segment) {
        this.segment = segment;
    }
    async getTicket(valuesParams) {
        try {
            let newValuesParams = [
                ...valuesParams.filter((item)=>item !== "new_files"),
                "id"
            ];
            let annotate_mtm_params = null;
            if ($9deae8639aea4ab2$export$fb2debb33ecbbf2b[this.segment].additionalEditValues && $9deae8639aea4ab2$export$fb2debb33ecbbf2b[this.segment].additionalEditValues.length) newValuesParams = [
                ...newValuesParams,
                ...$9deae8639aea4ab2$export$fb2debb33ecbbf2b[this.segment].additionalEditValues
            ];
            if ($9deae8639aea4ab2$export$fb2debb33ecbbf2b[this.segment].annotate_mtm_edit_params) annotate_mtm_params = $9deae8639aea4ab2$export$fb2debb33ecbbf2b[this.segment].annotate_mtm_edit_params;
            const params = {
                filter_params: {
                    id: this.ticketID
                },
                values_params: newValuesParams,
                annotate_mtm_params: annotate_mtm_params
            };
            const response = await (0, $kmHuZ.default).ticket.getListTickets(params);
            if ($9deae8639aea4ab2$export$fb2debb33ecbbf2b[this.segment].defaultEditData) {
                const defaultData = $9deae8639aea4ab2$export$fb2debb33ecbbf2b[this.segment].defaultEditData();
                Object.keys(defaultData).forEach((key)=>{
                    if (!response.data[0][key]) response.data[0][key] = defaultData[key];
                });
            }
            if (response.data[0]["files__file"] && response.data[0]["files__file"].length) {
                response.data[0].files = [];
                response.data[0]["files__file"].forEach((item, index)=>{
                    response.data[0].files.push({
                        name: response.data[0]["files__name"][index],
                        file: item,
                        id: response.data[0]["files__id"][index]
                    });
                });
            }
            this.setTicket(response.data[0]);
            if (this.segment === $9deae8639aea4ab2$export$b785703f0923c5b5.MANAGER_DMS.name) {
                const dmsServices = await (0, $kmHuZ.default).dmsServices.getServiceForApproval(response.data[0].appointment__id);
                this.setDMSServices(dmsServices);
            }
            await this.getCommentsByTicket();
        } catch (e) {
            console.error(e);
            return false;
        }
    }
    async postEditedTicket(data) {
        data.plus_authors_ids = data.plus_authors;
        delete data.plus_authors;
        delete data.created_at;
        delete data.updated_at;
        if (data.new_files) {
            for (const file of data.new_files){
                let formData = new FormData();
                formData.append("name", file.name);
                formData.append("file", file);
                await (0, $kmHuZ.default).ticket.postCreateTicketFile(this.ticketID, formData);
            }
            delete data.new_files;
        }
        if (this.DMSServices.length) this.DMSServices.forEach((item)=>{
            (0, $kmHuZ.default).dmsServices.createOrUpdate({
                appointment_id: data.appointment__id,
                service_id: item.service.id,
                status: item.status
            });
        });
        if ($9deae8639aea4ab2$export$fb2debb33ecbbf2b[this.segment].patchFields) data = Object.keys(data).reduce((acc, key)=>{
            if ($9deae8639aea4ab2$export$fb2debb33ecbbf2b[this.segment].patchFields.includes(key)) acc[key] = data[key];
            return acc;
        }, {});
        try {
            await (0, $kmHuZ.default).ticket.postEditedTicket([
                data
            ]);
            return true;
        } catch (e) {
            console.error(e);
            return false;
        }
    }
    async postCreateTicket(data, isNeededConvertedFiles) {
        try {
            const newData = {
                ...data
            };
            if (newData.new_files) delete newData.new_files;
            const response = await (0, $kmHuZ.default).ticket.postCreateTicket(newData);
            if (data.new_files) for (const file of data.new_files){
                let formData = new FormData();
                if (isNeededConvertedFiles) {
                    formData.append("name", file.name);
                    formData.append("file", file);
                }
                await (0, $kmHuZ.default).ticket.postCreateTicketFile(response.id, isNeededConvertedFiles ? formData : file);
            }
            return response;
        } catch (e) {
            console.error(e);
            return false;
        }
    }
    setFeedbackData(data) {
        this.feedbackData = data;
    }
    resetFeedbackData() {
        this.feedbackData = {};
    }
    async sendCommentByTicket(comment) {
        try {
            const response = await (0, $kmHuZ.default).ticket.sendComment({
                ticketId: this.ticketID,
                comment: comment
            });
            this.updateComments(response);
        } catch (e) {
            console.error(e);
        }
    }
    async getCommentsByTicket() {
        if (!this.ticketID) return;
        try {
            const response = await (0, $kmHuZ.default).ticket.getComments(this.ticketID);
            this.setComments(response.reverse());
        } catch (e) {
            console.error(e);
        }
    }
    setComments(comments) {
        this.comments = comments.map((comment)=>$9deae8639aea4ab2$var$transformCommentData(comment));
    }
    updateComments(comment) {
        this.comments.push($9deae8639aea4ab2$var$transformCommentData(comment));
    }
    clearComments() {
        this.comments = [];
    }
    setDMSServices(data) {
        this.DMSServices = data;
    }
    changeDMSServices(dmsService, status) {
        this.setDMSServices(this.DMSServices.map((item)=>{
            if (item.id === dmsService.id) item.status = status;
            return item;
        }));
    }
    setMobileTicketVoxData(data) {
        this.mobileTicketVoxData = data;
    }
    resetMobileTicketVoxData() {
        this.mobileTicketVoxData = null;
    }
}
var $9deae8639aea4ab2$export$2e2bcd8739ae039 = new $9deae8639aea4ab2$var$TicketStore();

});
parcelRegister("aW3mw", function(module, exports) {

$parcel$export(module.exports, "filtersAfterCheck", function () { return $7f61edd17ec1e818$export$68f989d8c98bd576; });
$parcel$export(module.exports, "default", function () { return $7f61edd17ec1e818$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $9Qp9d = parcelRequire("9Qp9d");

var $ariGN = parcelRequire("ariGN");

var $kEUo3 = parcelRequire("kEUo3");
const $7f61edd17ec1e818$export$68f989d8c98bd576 = (filters)=>{
    const newFilters = Object.keys(filters).reduce((acc, key)=>{
        const filterValue = filters[key];
        const checkNotArray = !(filterValue || filterValue === 0 || filterValue === false || (key.endsWith("__gt") ? filterValue === "" : false));
        const checkArray = Array.isArray(filterValue) && (!filterValue.length || filterValue.length === 1 && !filterValue[0]);
        if (checkNotArray || checkArray) return acc;
        acc[key] = filterValue;
        return acc;
    }, {});
    return newFilters;
};
class $7f61edd17ec1e818$var$DynamicTableStore {
    constructor(fetchDataFunction, additionalParamsValues = [], transformData){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "dataTable", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "othersTableData", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "metaTable", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "filtersTable", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "sortingTable", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "valuesParamsTable", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "globalFiltersTable", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "oldParams", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "annotate_mtm_params", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "fetchFunction", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isInitialized", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "columnPinning", {
            left: [],
            right: []
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "additionalParamsValues", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "additionalFilterValues", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isLoading", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "transformData", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isEnableSavingPresets", true);
        this.fetchFunction = fetchDataFunction;
        this.additionalParamsValues = additionalParamsValues;
        this.transformData = transformData;
        (0, $9Qp9d.makeObservable)(this, {
            transformData: (0, $9Qp9d.observable),
            dataTable: (0, $9Qp9d.observable),
            othersTableData: (0, $9Qp9d.observable),
            metaTable: (0, $9Qp9d.observable),
            filtersTable: (0, $9Qp9d.observable),
            sortingTable: (0, $9Qp9d.observable),
            valuesParamsTable: (0, $9Qp9d.observable),
            annotate_mtm_params: (0, $9Qp9d.observable),
            globalFiltersTable: (0, $9Qp9d.observable),
            isLoading: (0, $9Qp9d.observable),
            additionalFilterValues: (0, $9Qp9d.observable),
            oldParams: (0, $9Qp9d.observable),
            isEnableSavingPresets: (0, $9Qp9d.observable),
            fetchFunction: (0, $9Qp9d.action),
            setColumnPinning: (0, $9Qp9d.action),
            setFiltersTable: (0, $9Qp9d.action),
            setValuesParamsTable: (0, $9Qp9d.action),
            setAdditionalFilterValues: (0, $9Qp9d.action),
            setSortingTable: (0, $9Qp9d.action),
            setGlobalFiltersTable: (0, $9Qp9d.action),
            setAnnotateMtmParams: (0, $9Qp9d.action),
            setMetaTable: (0, $9Qp9d.action),
            setOthersTableData: (0, $9Qp9d.action),
            fetchDataTable: (0, $9Qp9d.action),
            generateSearch: (0, $9Qp9d.action),
            changeOldParams: (0, $9Qp9d.action),
            enableSavingPresets: (0, $9Qp9d.action)
        });
    }
    enableSavingPresets(flag) {
        this.isEnableSavingPresets = flag;
    }
    setAdditionalFilterValues(filters) {
        this.additionalFilterValues = filters;
    }
    setColumnPinning(columnPinning) {
        if (columnPinning !== null && columnPinning !== void 0 && columnPinning.left.length || columnPinning !== null && columnPinning !== void 0 && columnPinning.right.length) this.columnPinning = columnPinning;
        if (this.isEnableSavingPresets) history.pushState(null, null, `${location.pathname}${this.generateSearch()}`);
    }
    setFiltersTable(filtersTable, isNeedFetch = true) {
        this.filtersTable = filtersTable;
        if (isNeedFetch) this.fetchDataTable();
    }
    setAnnotateMtmParams(annotate_mtm_params) {
        this.annotate_mtm_params = annotate_mtm_params;
    }
    setValuesParamsTable(valuesParamsTable, isNeedFetch = true) {
        this.valuesParamsTable = (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).concat(valuesParamsTable, this.additionalParamsValues);
        if (isNeedFetch) this.fetchDataTable();
    }
    setSortingTable(sortingTable, isNeedFetch = true) {
        this.sortingTable = sortingTable || [];
        if (isNeedFetch) this.fetchDataTable();
    }
    setGlobalFiltersTable(globalFiltersTable, isNeedFetch = true) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).isEqual({
            ...globalFiltersTable,
            ...this.additionalFilterValues
        }, this.globalFiltersTable)) {
            this.globalFiltersTable = {
                ...globalFiltersTable,
                ...this.additionalFilterValues
            };
            if (isNeedFetch) this.fetchDataTable();
        }
    }
    setMetaTable(metaTable, isNeedFetch = true, isInitializedParams, setMeta) {
        const pagination = {
            ...metaTable
        };
        pagination.pageIndex = parseInt((metaTable.pageIndex > -1 && isInitializedParams ? metaTable.pageIndex : this.metaTable.pageIndex) || 0);
        pagination.pageSize = parseInt(metaTable.pageSize || this.metaTable.pageSize || 10);
        pagination.total_items = parseInt(metaTable.total_items || metaTable.total_items === 0 ? metaTable.total_items : this.metaTable.total_items || 0);
        if (this.metaTable.pageSize && this.metaTable.pageSize !== metaTable.pageSize && isInitializedParams) pagination.pageIndex = 0;
        if (setMeta) setMeta(pagination);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).isEqual(this.metaTable, pagination)) {
            this.metaTable = pagination;
            if (isNeedFetch) this.fetchDataTable();
        }
    }
    setOthersTableData(response) {
        this.othersTableData = response;
    }
    generateSearch(meta) {
        return `?${(0, $ariGN.stringifyAllParams)({
            filter: (0, $ariGN.filtersToParams)($7f61edd17ec1e818$export$68f989d8c98bd576(this.filtersTable), "filters"),
            globalFilters: (0, $ariGN.filtersToParams)($7f61edd17ec1e818$export$68f989d8c98bd576(this.globalFiltersTable), "globalFilters"),
            sorting: (0, $ariGN.sortingToParams)(this.sortingTable),
            meta: (0, $ariGN.metaToParams)(meta || this.metaTable),
            columnPinning: this.columnPinning && (this.columnPinning.left.length || this.columnPinning.right.length) ? (0, $ariGN.filtersToParams)(this.columnPinning, "columnPinning") : undefined
        })}`;
    }
    async fetchDataTable(isIgnoreCheck) {
        try {
            if (this.valuesParamsTable.length) {
                const params = {
                    filter_params: {
                        ...$7f61edd17ec1e818$export$68f989d8c98bd576(this.filtersTable),
                        ...$7f61edd17ec1e818$export$68f989d8c98bd576(this.globalFiltersTable)
                    },
                    values_params: this.valuesParamsTable,
                    order_by_params: this.sortingTable,
                    meta: null
                };
                if (this.annotate_mtm_params) params.annotate_mtm_params = this.annotate_mtm_params;
                const isChangeParams = !(0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).isEqual({
                    ...this.oldParams,
                    meta: null
                }, params);
                params.meta = (0, $ariGN.paramsMeta)(isChangeParams && this.isInitialized ? {
                    ...this.metaTable,
                    pageIndex: 0
                } : this.metaTable);
                if (!!isIgnoreCheck || !(0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).isEqual(this.oldParams, params)) {
                    this.oldParams = params;
                    this.isLoading = true;
                    let response = await this.fetchFunction(params);
                    if (this.transformData) response = this.transformData(response);
                    this.dataTable = response.data;
                    this.setMetaTable((0, $ariGN.getMeta)(response.meta), false, true);
                    this.setOthersTableData(response);
                    if (this.isEnableSavingPresets) history.pushState(null, null, `${location.pathname}${this.generateSearch((0, $ariGN.getMeta)(response.meta))}`);
                    this.isLoading = false;
                    this.isInitialized = true;
                }
            }
        } catch (e) {
            if (e.toString() !== "AbortError: The user aborted a request.") this.isLoading = false;
            console.error(e);
            return false;
        }
    }
    changeOldParams(value) {
        this.oldParams = value;
    }
}
var $7f61edd17ec1e818$export$2e2bcd8739ae039 = $7f61edd17ec1e818$var$DynamicTableStore;

});
parcelRegister("ariGN", function(module, exports) {

$parcel$export(module.exports, "NUMBER_FIELD_STRING_PARAMS", function () { return $799aec4c17a71ef2$export$6b63880e4182a2f5; });
$parcel$export(module.exports, "sortingToParamsTable", function () { return $799aec4c17a71ef2$export$95b77a0e4bc50090; });
$parcel$export(module.exports, "sortingToString", function () { return $799aec4c17a71ef2$export$9761022f6ba522a1; });
$parcel$export(module.exports, "sortingToParams", function () { return $799aec4c17a71ef2$export$ee36369edbd86273; });
$parcel$export(module.exports, "filtersStoreToFiltersTable", function () { return $799aec4c17a71ef2$export$2e1636aca1329bc8; });
$parcel$export(module.exports, "filtersToParams", function () { return $799aec4c17a71ef2$export$1c576953cd33bc48; });
$parcel$export(module.exports, "getMeta", function () { return $799aec4c17a71ef2$export$c47913ca32a5c6f7; });
$parcel$export(module.exports, "paramsMeta", function () { return $799aec4c17a71ef2$export$c73e5ae1b1ee529d; });
$parcel$export(module.exports, "metaToParams", function () { return $799aec4c17a71ef2$export$46fa9951ffa1d72b; });
$parcel$export(module.exports, "stringifyAllParams", function () { return $799aec4c17a71ef2$export$48972fcea11f7fa0; });
$parcel$export(module.exports, "parseAllParams", function () { return $799aec4c17a71ef2$export$99ef36946f960075; });
$parcel$export(module.exports, "trimLongTextValueField", function () { return $799aec4c17a71ef2$export$c09815023e3a111d; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $kEUo3 = parcelRequire("kEUo3");

var $c44wE = parcelRequire("c44wE");
const $799aec4c17a71ef2$export$6b63880e4182a2f5 = [
    "per_page",
    "current_page",
    "organization__in",
    "doctor_organization__doctor__in",
    "doctor_organization__organization",
    "doctor_organization__organization__in"
];
const $799aec4c17a71ef2$export$95b77a0e4bc50090 = (sorting)=>{
    if (!sorting) return [];
    return sorting.map((value)=>{
        const splitString = value.split("-");
        if (splitString.length === 2) return {
            id: splitString[1],
            desc: true
        };
        else return {
            id: splitString[0],
            desc: false
        };
    });
};
const $799aec4c17a71ef2$export$9761022f6ba522a1 = (sorting)=>{
    if (!sorting) return "";
    return sorting.map((item)=>{
        return item.desc ? `-${item.id}` : item.id;
    }, []);
};
const $799aec4c17a71ef2$export$ee36369edbd86273 = (sorting)=>{
    if (!sorting.length) return "";
    return sorting.reduce((acc, item, index)=>{
        if (index === 0) acc += item;
        else acc += `;${item}`;
        return acc;
    }, "sorting=");
};
const $799aec4c17a71ef2$export$2e1636aca1329bc8 = (filters, columns)=>{
    if (!filters) return [];
    return Object.keys(filters).map((key)=>{
        const column = columns.find((item)=>{
            /** regex /_/g очищает все символы "_" в строке */ /** Для колонок, где filterFn === "" */ if (item.accessorKey === key) return item;
            const filterFn = item._filterFn || item.filterFn;
            const keySplit = key.split(/_/g);
            if (keySplit.find((item)=>item === filterFn)) return keySplit.filter((item)=>item !== filterFn).join("") === item.accessorKey.replace(/_/g, "");
        });
        let newKey = null;
        const filterFn = column._filterFn || column.filterFn;
        if (filterFn) newKey = key.replace(`__${filterFn}`, "");
        else newKey = key;
        return {
            id: newKey,
            value: filters[key]
        };
    });
};
const $799aec4c17a71ef2$export$15fe252d214e7ca9 = (paramsArrayString, isColumnPinning)=>{
    if (!paramsArrayString) return {};
    return paramsArrayString.reduce((acc, value)=>{
        const splitString = value.split("|");
        let newValue = splitString[0].includes("__in") || isColumnPinning ? decodeURI(splitString[1]).split(",").map((item)=>{
            if ($799aec4c17a71ef2$export$6b63880e4182a2f5.includes(splitString[0])) return parseInt(item);
            return item;
        }) : $799aec4c17a71ef2$export$6b63880e4182a2f5.includes(splitString[0]) ? parseInt(decodeURI(splitString[1])) : decodeURI(splitString[1]);
        if (newValue === "true") newValue = true;
        if (newValue === "false") newValue = false;
        acc[splitString[0]] = newValue;
        return acc;
    }, {});
};
const $799aec4c17a71ef2$export$1c576953cd33bc48 = (filters, type)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).size(filters)) return "";
    const newFilters = Object.keys(filters).filter((key)=>{
        if (!filters[key] || Array.isArray(filters.key) && !filters[key].length) return false;
        return true;
    });
    if (!newFilters.length) return "";
    return newFilters.reduce((acc, key, index)=>{
        if (index === 0) acc += `${key}|${filters[key]}`;
        else acc += `;${key}|${filters[key]}`;
        return acc;
    }, `${type}=`);
};
const $799aec4c17a71ef2$export$c47913ca32a5c6f7 = (meta)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).size(meta)) return {
        pageIndex: parseInt(meta.current_page - 1),
        pageSize: parseInt(meta.per_page || 10),
        total_items: parseInt(meta.total_items)
    };
    return {};
};
const $799aec4c17a71ef2$export$c73e5ae1b1ee529d = (meta)=>{
    return {
        current_page: meta.pageIndex + 1,
        per_page: meta.pageSize || 10,
        total_items: meta.total_items
    };
};
const $799aec4c17a71ef2$export$46fa9951ffa1d72b = (meta)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).size(meta)) {
        const newMeta = $799aec4c17a71ef2$export$c73e5ae1b1ee529d(meta);
        return `meta=current_page|${newMeta.current_page};per_page|${newMeta.per_page};total_items|${newMeta.total_items}`;
    }
    return "";
};
const $799aec4c17a71ef2$export$e3400cfcb762facb = (meta)=>{
    return `current_page|${meta.current_page};per_page|${meta.per_page}`;
};
const $799aec4c17a71ef2$export$48972fcea11f7fa0 = (params)=>{
    let stringParams = "";
    Object.keys(params).forEach((key)=>{
        if (params[key]) {
            if (stringParams) stringParams += `&${params[key]}`;
            else stringParams += `${params[key]}`;
        }
    });
    return stringParams;
};
const $799aec4c17a71ef2$export$99ef36946f960075 = (params, columns)=>{
    const parseParams = {
        sorting: [],
        meta: {},
        filters: {},
        columnPinning: {}
    };
    params.forEach((param)=>{
        var _splitParam$;
        const splitParam = param.split("=");
        const splitParamValue = (_splitParam$ = splitParam[1]) === null || _splitParam$ === void 0 ? void 0 : _splitParam$.split(";");
        if (splitParam[0] === "sorting") parseParams.sorting = splitParamValue;
        else if (splitParam[0] === "meta") parseParams.meta = $799aec4c17a71ef2$export$15fe252d214e7ca9(splitParamValue);
        else if (splitParam[0] === "filters") parseParams.filters = $799aec4c17a71ef2$export$15fe252d214e7ca9(splitParamValue);
        else if (splitParam[0] === "globalFilters") parseParams.globalfilters = $799aec4c17a71ef2$export$15fe252d214e7ca9(splitParamValue);
        else if (splitParam[0] === "columnPinning") parseParams.columnPinning = $799aec4c17a71ef2$export$15fe252d214e7ca9(splitParamValue, true);
    });
    return parseParams;
};
const $799aec4c17a71ef2$export$c09815023e3a111d = (value, width = "auto")=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $c44wE.CustomMUITooltip), {
        title: value,
        width: width,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
            style: {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
                display: "block"
            },
            children: value
        })
    });
};

});


parcelRegister("hnKMr", function(module, exports) {

$parcel$export(module.exports, "getPatientFullName", function () { return $ca78df454c5c6f9a$export$9b8ec2dace8f66e3; });
$parcel$export(module.exports, "getPatientLastNameWithInitials", function () { return $ca78df454c5c6f9a$export$d66d35468931bec7; });
$parcel$export(module.exports, "getAgeByBirthDate", function () { return $ca78df454c5c6f9a$export$fdefc5f5de78a2fd; });
$parcel$export(module.exports, "getMonthAgeByBirthDate", function () { return $ca78df454c5c6f9a$export$a85ba262c61ed490; });
$parcel$export(module.exports, "formatPatientBirthDate", function () { return $ca78df454c5c6f9a$export$2aa4f88d261e0856; });

var $jCgCX = parcelRequire("jCgCX");
const $ca78df454c5c6f9a$export$9b8ec2dace8f66e3 = (patient)=>{
    return [
        patient.last_name,
        patient.first_name,
        patient.middle_name
    ].join(" ");
};
const $ca78df454c5c6f9a$export$d66d35468931bec7 = (patient)=>{
    const first_nameLetter = patient.first_name.length > 0 && patient.first_name[0];
    const middle_nameLetter = patient.last_name.length > 0 && patient.middle_name[0];
    return `${patient.last_name} ${first_nameLetter ? first_nameLetter + "." : ""}${middle_nameLetter ? middle_nameLetter + "." : ""}`;
};
const $ca78df454c5c6f9a$export$fdefc5f5de78a2fd = (patient)=>{
    if (!patient.birthdate) return;
    const birthdate = (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX)))(new Date(patient.birthdate));
    return (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX)))().diff(birthdate, "year");
};
const $ca78df454c5c6f9a$export$a85ba262c61ed490 = (patient)=>{
    if (!patient.birthdate) return;
    const birthdate = (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX)))(new Date(patient.birthdate));
    return (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX)))().diff(birthdate, "month") % 12;
};
const $ca78df454c5c6f9a$export$2aa4f88d261e0856 = (patient)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).utc(patient.birthdate).format("DD.MM.YYYY");
};

});

parcelRegister("gu8wR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c006105814d3ce35$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $cs0Pg = parcelRequire("cs0Pg");

var $5V7S3 = parcelRequire("5V7S3");

var $erAkb = parcelRequire("erAkb");


var $fGH8N = parcelRequire("fGH8N");

var $aEoM0 = parcelRequire("aEoM0");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $lLxkV = parcelRequire("lLxkV");

var $ih19M = parcelRequire("ih19M");
"use client";
const $c006105814d3ce35$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $c006105814d3ce35$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $fGH8N.default)(size)}`,
            `color${(0, $fGH8N.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $fGH8N.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $fGH8N.default)(color)}`,
            `${variant}${(0, $fGH8N.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, $fGH8N.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $fGH8N.default)(size)}`,
            `avatarColor${(0, $fGH8N.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $fGH8N.default)(size)}`,
            `iconColor${(0, $fGH8N.default)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $fGH8N.default)(size)}`,
            `deleteIconColor${(0, $fGH8N.default)(color)}`,
            `deleteIcon${(0, $fGH8N.default)(variant)}Color${(0, $fGH8N.default)(color)}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $lLxkV.getChipUtilityClass), classes);
};
const $c006105814d3ce35$var$ChipRoot = (0, $g4l1t.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $lLxkV.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $lLxkV.default).avatar}`]: styles[`avatar${(0, $fGH8N.default)(size)}`]
            },
            {
                [`& .${(0, $lLxkV.default).avatar}`]: styles[`avatarColor${(0, $fGH8N.default)(color)}`]
            },
            {
                [`& .${(0, $lLxkV.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, $lLxkV.default).icon}`]: styles[`icon${(0, $fGH8N.default)(size)}`]
            },
            {
                [`& .${(0, $lLxkV.default).icon}`]: styles[`iconColor${(0, $fGH8N.default)(iconColor)}`]
            },
            {
                [`& .${(0, $lLxkV.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $lLxkV.default).deleteIcon}`]: styles[`deleteIcon${(0, $fGH8N.default)(size)}`]
            },
            {
                [`& .${(0, $lLxkV.default).deleteIcon}`]: styles[`deleteIconColor${(0, $fGH8N.default)(color)}`]
            },
            {
                [`& .${(0, $lLxkV.default).deleteIcon}`]: styles[`deleteIcon${(0, $fGH8N.default)(variant)}Color${(0, $fGH8N.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $fGH8N.default)(size)}`],
            styles[`color${(0, $fGH8N.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $fGH8N.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $fGH8N.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $fGH8N.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $4WYaH.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: "unset",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $lLxkV.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $lLxkV.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $lLxkV.default).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $lLxkV.default).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $lLxkV.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $lLxkV.default).icon}`]: (0, $4WYaH.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $4WYaH.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, $lLxkV.default).deleteIcon}`]: (0, $4WYaH.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $cs0Pg.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $cs0Pg.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $cs0Pg.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $lLxkV.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cs0Pg.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $lLxkV.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cs0Pg.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $lLxkV.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cs0Pg.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $lLxkV.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $lLxkV.default).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $lLxkV.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $lLxkV.default).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $lLxkV.default).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $lLxkV.default).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $lLxkV.default).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $lLxkV.default).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $lLxkV.default).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $cs0Pg.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $lLxkV.default).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cs0Pg.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $lLxkV.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $cs0Pg.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $lLxkV.default).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $cs0Pg.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $c006105814d3ce35$var$ChipLabel = (0, $g4l1t.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $fGH8N.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.variant === "outlined" && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $c006105814d3ce35$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $c006105814d3ce35$var$Chip = /*#__PURE__*/ $bh6RR.forwardRef(function Chip(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = "medium", variant: variant = "filled", tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $hCIyK.default)(props, $c006105814d3ce35$var$_excluded);
    const chipRef = $bh6RR.useRef(null);
    const handleRef = (0, $erAkb.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $c006105814d3ce35$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $c006105814d3ce35$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $aEoM0.default) : ComponentProp || "div";
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $bh6RR.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $c006105814d3ce35$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $aEoM0.default) ? (0, $4WYaH.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $bh6RR.isValidElement(deleteIconProp) ? /*#__PURE__*/ $bh6RR.cloneElement(deleteIconProp, {
        className: (0, $aPsoC.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $5V7S3.default), {
        className: (0, $aPsoC.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $bh6RR.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $bh6RR.cloneElement(avatarProp, {
        className: (0, $aPsoC.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $bh6RR.isValidElement(iconProp)) icon = /*#__PURE__*/ $bh6RR.cloneElement(iconProp, {
        className: (0, $aPsoC.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)($c006105814d3ce35$var$ChipRoot, (0, $4WYaH.default)({
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ih19M.jsx)($c006105814d3ce35$var$ChipLabel, {
                className: (0, $aPsoC.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $c006105814d3ce35$export$2e2bcd8739ae039 = $c006105814d3ce35$var$Chip;

});
parcelRegister("5V7S3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44f86198119aa73f$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $44f86198119aa73f$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");

});

parcelRegister("lLxkV", function(module, exports) {

$parcel$export(module.exports, "getChipUtilityClass", function () { return $fd87d8adf0590d8e$export$31444911e4ee6fdd; });
$parcel$export(module.exports, "default", function () { return $fd87d8adf0590d8e$export$2e2bcd8739ae039; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $fd87d8adf0590d8e$export$31444911e4ee6fdd(slot) {
    return (0, $dmzXD.default)("MuiChip", slot);
}
const $fd87d8adf0590d8e$var$chipClasses = (0, $fYlYP.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
var $fd87d8adf0590d8e$export$2e2bcd8739ae039 = $fd87d8adf0590d8e$var$chipClasses;

});



parcelRegister("a2asV", function(module, exports) {

$parcel$export(module.exports, "COMPANY_LINKS", function () { return $74e2358a64fe4fef$export$a21e602d6fb63185; });
$parcel$export(module.exports, "CLINIC_NAME", function () { return $74e2358a64fe4fef$export$584463fdb49f023; });
$parcel$export(module.exports, "CLINIC_CODE", function () { return $74e2358a64fe4fef$export$2d8d60afb4b33ae8; });
$parcel$export(module.exports, "default", function () { return $74e2358a64fe4fef$export$2e2bcd8739ae039; });

var $jqdsN = parcelRequire("jqdsN");

var $9Qp9d = parcelRequire("9Qp9d");

var $kmHuZ = parcelRequire("kmHuZ");

var $PW6XX = parcelRequire("PW6XX");
const $74e2358a64fe4fef$export$a21e602d6fb63185 = {
    yandex: "yandex_link",
    google: "google_link",
    twogis: "twogis_link",
    aboutDoctorsLink: "about_doctors_link"
};
const $74e2358a64fe4fef$export$584463fdb49f023 = {
    rassvet: "\u0420\u0430\u0441\u0441\u0432\u0435\u0442",
    fomina: "\u0424\u043E\u043C\u0438\u043D\u0430",
    ceg: "\u0413\u0443\u0441\u0435\u0432\u0430"
};
const $74e2358a64fe4fef$export$2d8d60afb4b33ae8 = {
    rassvet: "rassvet",
    fomina: "fomina",
    ceg: "ceg"
};
class $74e2358a64fe4fef$var$ReviewStore {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "token", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "rate", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "doctor_rate", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "administrators_rate", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "middle_medical_staff_rate", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "service_rate", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "company", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "current_page", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "review", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "is_need_callback", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "yandex_link", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "google_link", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "twogis_link", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "about_doctors_link", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "city", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "is_loyalty_card", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isInitialized", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "clinic_code", $74e2358a64fe4fef$export$2d8d60afb4b33ae8.fomina);
        (0, (/*@__PURE__*/$parcel$interopDefault($jqdsN)))(this, "isMobile", false);
        (0, $9Qp9d.makeAutoObservable)(this);
    }
    setToken(token) {
        this.token = token;
    }
    setIsMobile(value) {
        this.isMobile = value;
    }
    setClinicCode(name) {
        this.clinic_code = name;
    }
    setRate(rate) {
        this.rate = rate;
        this.doctor_rate = rate;
        this.administrators_rate = rate;
        this.middle_medical_staff_rate = rate;
        this.service_rate = rate;
    }
    setCompany(company) {
        this.company = company;
    }
    setCurrentPage(current_page) {
        this.current_page = current_page;
    }
    setReview(review) {
        this.review = review;
    }
    setCity(city) {
        this.city = city;
    }
    setIsNeedCallback(is_need_callback) {
        this.is_need_callback = is_need_callback;
    }
    *getCompanyLink() {
        try {
            this.isInitialized = true;
            const response = yield (0, $kmHuZ.default).review.getLink(this.token, this.isMobile, this.city); // {map_link: ''} - по нажатию на yandex дергаем этот url
            this.yandex_link = response.yandex_link;
            this.google_link = response.google_link;
            this.twogis_link = response.twogis_link;
            this.about_doctors_link = response.about_doctors_link;
            this.city = response.city;
            this.is_loyalty_card = response.is_loyalty_card;
            return true;
        } catch (e) {
            console.error(e);
            return false;
        }
    }
    *setProgress() {
        try {
            yield (0, $kmHuZ.default).review.putProgress({
                token: this.token,
                rate: this.rate || undefined,
                doctor_rate: this.doctor_rate || undefined,
                administrators_rate: this.administrators_rate || undefined,
                middle_medical_staff_rate: this.middle_medical_staff_rate || undefined,
                service_rate: this.service_rate || undefined,
                company: this.company || undefined,
                current_page: this.current_page || undefined,
                review: this.review || undefined,
                isMobile: this.isMobile || undefined,
                city: this.city || undefined,
                is_need_callback: this.is_need_callback === null ? undefined : this.is_need_callback
            });
            return true;
        } catch (e) {
            console.error(e);
            return false;
        }
    }
    get flavorByClinicCode() {
        const flavor = {
            [$74e2358a64fe4fef$export$2d8d60afb4b33ae8.fomina]: (0, $PW6XX.AvailableApplicationFlavors).DEFAULT,
            [$74e2358a64fe4fef$export$2d8d60afb4b33ae8.rassvet]: (0, $PW6XX.AvailableApplicationFlavors).SUNRISE,
            [$74e2358a64fe4fef$export$2d8d60afb4b33ae8.ceg]: (0, $PW6XX.AvailableApplicationFlavors).CEG
        };
        return flavor[this.clinic_code];
    }
}
var $74e2358a64fe4fef$export$2e2bcd8739ae039 = new $74e2358a64fe4fef$var$ReviewStore();

});

parcelRegister("9DKAX", function(module, exports) {
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = "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";
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = "!";
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = "strict";
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                "normal",
                "auto",
                "loose"
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === "strict" ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: "normal",
            wordBreak: "normal"
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === "break-all" || options.wordBreak === "break-word") classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === "undefined" ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ""
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = "";
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = "";
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = "";
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === "undefined" ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== "undefined" ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case "rem":
            case "em":
                return 16 * token.number; // TODO use correct font-size
            case "px":
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = "deg";
    var GRAD = "grad";
    var RAD = "rad";
    var TURN = "turn";
    var angle = {
        name: "angle",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(" ");
        switch(sideOrCorner){
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case "to top":
            case "bottom":
                return deg(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case "to right":
            case "left":
                return deg(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case "to bottom":
            case "top":
                return deg(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case "to left":
            case "right":
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: "color",
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === "undefined") throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== "undefined") return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: "background-clip",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === "number" ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === "to") {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    "top",
                    "left",
                    "right",
                    "bottom"
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === "linear") {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === "from") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === "to") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === "color-stop") {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = "closest-side";
    var FARTHEST_SIDE = "farthest-side";
    var CLOSEST_CORNER = "closest-corner";
    var FARTHEST_CORNER = "farthest-corner";
    var CIRCLE = "circle";
    var ELLIPSE = "ellipse";
    var COVER = "cover";
    var CONTAIN = "contain";
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case "center":
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case "top":
                            case "left":
                                position.push(ZERO_LENGTH);
                                return acc;
                            case "right":
                            case "bottom":
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case "at":
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case "center":
                        position.push(FIFTY_PERCENT);
                        return false;
                    case "top":
                    case "left":
                        position.push(ZERO_LENGTH);
                        return false;
                    case "right":
                    case "bottom":
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: "image",
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === "undefined") throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === "none") && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        "linear-gradient": linearGradient,
        "-moz-linear-gradient": prefixLinearGradient,
        "-ms-linear-gradient": prefixLinearGradient,
        "-o-linear-gradient": prefixLinearGradient,
        "-webkit-linear-gradient": prefixLinearGradient,
        "radial-gradient": radialGradient,
        "-moz-radial-gradient": prefixRadialGradient,
        "-ms-radial-gradient": prefixRadialGradient,
        "-o-radial-gradient": prefixRadialGradient,
        "-webkit-radial-gradient": prefixRadialGradient,
        "-webkit-gradient": webkitGradient
    };
    var backgroundImage = {
        name: "background-image",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: "background-origin",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: "background-position",
        initialValue: "0% 0%",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: "background-repeat",
        initialValue: "repeat",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(" ");
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case "no-repeat":
                return 1 /* NO_REPEAT */ ;
            case "repeat-x":
            case "repeat no-repeat":
                return 2 /* REPEAT_X */ ;
            case "repeat-y":
            case "no-repeat repeat":
                return 3 /* REPEAT_Y */ ;
            case "repeat":
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: "background-size",
        initialValue: "0",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: "transparent",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "color"
        };
    };
    var borderTopColor = borderColorForSide("top");
    var borderRightColor = borderColorForSide("right");
    var borderBottomColor = borderColorForSide("bottom");
    var borderLeftColor = borderColorForSide("left");
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: "0 0",
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide("top-left");
    var borderTopRightRadius = borderRadiusForSide("top-right");
    var borderBottomRightRadius = borderRadiusForSide("bottom-right");
    var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: "solid",
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case "none":
                        return 0 /* NONE */ ;
                    case "dashed":
                        return 2 /* DASHED */ ;
                    case "dotted":
                        return 3 /* DOTTED */ ;
                    case "double":
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide("top");
    var borderRightStyle = borderStyleForSide("right");
    var borderBottomStyle = borderStyleForSide("bottom");
    var borderLeftStyle = borderStyleForSide("left");
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: "0",
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide("top");
    var borderRightWidth = borderWidthForSide("right");
    var borderBottomWidth = borderWidthForSide("bottom");
    var borderLeftWidth = borderWidthForSide("left");
    var color = {
        name: "color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var direction = {
        name: "direction",
        initialValue: "ltr",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case "rtl":
                    return 1 /* RTL */ ;
                case "ltr":
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: "display",
        initialValue: "inline-block",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case "block":
            case "-webkit-box":
                return 2 /* BLOCK */ ;
            case "inline":
                return 4 /* INLINE */ ;
            case "run-in":
                return 8 /* RUN_IN */ ;
            case "flow":
                return 16 /* FLOW */ ;
            case "flow-root":
                return 32 /* FLOW_ROOT */ ;
            case "table":
                return 64 /* TABLE */ ;
            case "flex":
            case "-webkit-flex":
                return 128 /* FLEX */ ;
            case "grid":
            case "-ms-grid":
                return 256 /* GRID */ ;
            case "ruby":
                return 512 /* RUBY */ ;
            case "subgrid":
                return 1024 /* SUBGRID */ ;
            case "list-item":
                return 2048 /* LIST_ITEM */ ;
            case "table-row-group":
                return 4096 /* TABLE_ROW_GROUP */ ;
            case "table-header-group":
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case "table-footer-group":
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case "table-row":
                return 32768 /* TABLE_ROW */ ;
            case "table-cell":
                return 65536 /* TABLE_CELL */ ;
            case "table-column-group":
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case "table-column":
                return 262144 /* TABLE_COLUMN */ ;
            case "table-caption":
                return 524288 /* TABLE_CAPTION */ ;
            case "ruby-base":
                return 1048576 /* RUBY_BASE */ ;
            case "ruby-text":
                return 2097152 /* RUBY_TEXT */ ;
            case "ruby-base-container":
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case "ruby-text-container":
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case "contents":
                return 16777216 /* CONTENTS */ ;
            case "inline-block":
                return 33554432 /* INLINE_BLOCK */ ;
            case "inline-list-item":
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case "inline-table":
                return 134217728 /* INLINE_TABLE */ ;
            case "inline-flex":
                return 268435456 /* INLINE_FLEX */ ;
            case "inline-grid":
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: "float",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case "left":
                    return 1 /* LEFT */ ;
                case "right":
                    return 2 /* RIGHT */ ;
                case "inline-start":
                    return 3 /* INLINE_START */ ;
                case "inline-end":
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: "letter-spacing",
        initialValue: "0",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "normal") return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: "line-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case "strict":
                    return LINE_BREAK.STRICT;
                case "normal":
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: "line-height",
        initialValue: "normal",
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === "normal") return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: "list-style-image",
        initialValue: "none",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: "list-style-position",
        initialValue: "outside",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "inside":
                    return 0 /* INSIDE */ ;
                case "outside":
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: "list-style-type",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case "disc":
                    return 0 /* DISC */ ;
                case "circle":
                    return 1 /* CIRCLE */ ;
                case "square":
                    return 2 /* SQUARE */ ;
                case "decimal":
                    return 3 /* DECIMAL */ ;
                case "cjk-decimal":
                    return 4 /* CJK_DECIMAL */ ;
                case "decimal-leading-zero":
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case "lower-roman":
                    return 6 /* LOWER_ROMAN */ ;
                case "upper-roman":
                    return 7 /* UPPER_ROMAN */ ;
                case "lower-greek":
                    return 8 /* LOWER_GREEK */ ;
                case "lower-alpha":
                    return 9 /* LOWER_ALPHA */ ;
                case "upper-alpha":
                    return 10 /* UPPER_ALPHA */ ;
                case "arabic-indic":
                    return 11 /* ARABIC_INDIC */ ;
                case "armenian":
                    return 12 /* ARMENIAN */ ;
                case "bengali":
                    return 13 /* BENGALI */ ;
                case "cambodian":
                    return 14 /* CAMBODIAN */ ;
                case "cjk-earthly-branch":
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case "cjk-heavenly-stem":
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case "cjk-ideographic":
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case "devanagari":
                    return 18 /* DEVANAGARI */ ;
                case "ethiopic-numeric":
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case "georgian":
                    return 20 /* GEORGIAN */ ;
                case "gujarati":
                    return 21 /* GUJARATI */ ;
                case "gurmukhi":
                    return 22 /* GURMUKHI */ ;
                case "hebrew":
                    return 22 /* HEBREW */ ;
                case "hiragana":
                    return 23 /* HIRAGANA */ ;
                case "hiragana-iroha":
                    return 24 /* HIRAGANA_IROHA */ ;
                case "japanese-formal":
                    return 25 /* JAPANESE_FORMAL */ ;
                case "japanese-informal":
                    return 26 /* JAPANESE_INFORMAL */ ;
                case "kannada":
                    return 27 /* KANNADA */ ;
                case "katakana":
                    return 28 /* KATAKANA */ ;
                case "katakana-iroha":
                    return 29 /* KATAKANA_IROHA */ ;
                case "khmer":
                    return 30 /* KHMER */ ;
                case "korean-hangul-formal":
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case "korean-hanja-formal":
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case "korean-hanja-informal":
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case "lao":
                    return 34 /* LAO */ ;
                case "lower-armenian":
                    return 35 /* LOWER_ARMENIAN */ ;
                case "malayalam":
                    return 36 /* MALAYALAM */ ;
                case "mongolian":
                    return 37 /* MONGOLIAN */ ;
                case "myanmar":
                    return 38 /* MYANMAR */ ;
                case "oriya":
                    return 39 /* ORIYA */ ;
                case "persian":
                    return 40 /* PERSIAN */ ;
                case "simp-chinese-formal":
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case "simp-chinese-informal":
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case "tamil":
                    return 43 /* TAMIL */ ;
                case "telugu":
                    return 44 /* TELUGU */ ;
                case "thai":
                    return 45 /* THAI */ ;
                case "tibetan":
                    return 46 /* TIBETAN */ ;
                case "trad-chinese-formal":
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case "trad-chinese-informal":
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case "upper-armenian":
                    return 49 /* UPPER_ARMENIAN */ ;
                case "disclosure-open":
                    return 50 /* DISCLOSURE_OPEN */ ;
                case "disclosure-closed":
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case "none":
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: "0",
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide("top");
    var marginRight = marginForSide("right");
    var marginBottom = marginForSide("bottom");
    var marginLeft = marginForSide("left");
    var overflow = {
        name: "overflow",
        initialValue: "visible",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case "hidden":
                        return 1 /* HIDDEN */ ;
                    case "scroll":
                        return 2 /* SCROLL */ ;
                    case "clip":
                        return 3 /* CLIP */ ;
                    case "auto":
                        return 4 /* AUTO */ ;
                    case "visible":
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: "overflow-wrap",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "break-word":
                    return "break-word" /* BREAK_WORD */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: "0",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "length-percentage"
        };
    };
    var paddingTop = paddingForSide("top");
    var paddingRight = paddingForSide("right");
    var paddingBottom = paddingForSide("bottom");
    var paddingLeft = paddingForSide("left");
    var textAlign = {
        name: "text-align",
        initialValue: "left",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case "right":
                    return 2 /* RIGHT */ ;
                case "center":
                case "justify":
                    return 1 /* CENTER */ ;
                case "left":
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: "position",
        initialValue: "static",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "relative":
                    return 1 /* RELATIVE */ ;
                case "absolute":
                    return 2 /* ABSOLUTE */ ;
                case "fixed":
                    return 3 /* FIXED */ ;
                case "sticky":
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: "text-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: "text-transform",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case "uppercase":
                    return 2 /* UPPERCASE */ ;
                case "lowercase":
                    return 1 /* LOWERCASE */ ;
                case "capitalize":
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: "transform",
        initialValue: "none",
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === "undefined") throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: "transform-origin",
        initialValue: "50% 50%",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: "visible",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case "hidden":
                    return 1 /* HIDDEN */ ;
                case "collapse":
                    return 2 /* COLLAPSE */ ;
                case "visible":
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: "word-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case "break-all":
                    return WORD_BREAK.BREAK_ALL;
                case "keep-all":
                    return WORD_BREAK.KEEP_ALL;
                case "normal":
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: "z-index",
        initialValue: "auto",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: "time",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case "s":
                    return 1000 * value.number;
                case "ms":
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: "opacity",
        initialValue: "1",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var textDecorationLine = {
        name: "text-decoration-line",
        initialValue: "none",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case "underline":
                        return 1 /* UNDERLINE */ ;
                    case "overline":
                        return 2 /* OVERLINE */ ;
                    case "line-through":
                        return 3 /* LINE_THROUGH */ ;
                    case "none":
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: "",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(" "));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(" "));
            return results.map(function(result) {
                return result.indexOf(" ") === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: "0",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "length"
    };
    var fontWeight = {
        name: "font-weight",
        initialValue: "normal",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case "bold":
                    return 700;
                case "normal":
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: "font-variant",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: "font-style",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "oblique":
                    return "oblique" /* OBLIQUE */ ;
                case "italic":
                    return "italic" /* ITALIC */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: "content",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: "counter-increment",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: "counter-reset",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== "none") {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: "duration",
        initialValue: "0s",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: "quotes",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return "";
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return "";
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: "box-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, "inset")) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: "paint-order",
        initialValue: "normal",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case "stroke":
                        layers.push(1 /* STROKE */ );
                        break;
                    case "fill":
                        layers.push(0 /* FILL */ );
                        break;
                    case "markers":
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: "currentcolor",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: "0",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case "angle":
                        return angle.parse(context, parser.parseComponentValue());
                    case "color":
                        return color$1.parse(context, parser.parseComponentValue());
                    case "image":
                        return image.parse(context, parser.parseComponentValue());
                    case "length":
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case "length-percentage":
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case "time":
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = "data-html2canvas-debug";
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case "all":
                return 1 /* ALL */ ;
            case "clone":
                return 2 /* CLONE */ ;
            case "parse":
                return 3 /* PARSE */ ;
            case "render":
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = "0s";
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = "none";
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = "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";
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement("boundtest");
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = "block";
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement("boundtest");
        testElement.style.width = "50px";
        testElement.style.display = "block";
        testElement.style.fontSize = "12px";
        testElement.style.letterSpacing = "0px";
        testElement.style.wordSpacing = "0px";
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== "undefined";
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === "string";
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement("canvas");
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext("2d");
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = "rgb(0, 255, 0)";
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = "red";
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement("div");
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(xmlns, "svg");
        var foreignObject = document.createElementNS(xmlns, "foreignObject");
        svg.setAttributeNS(null, "width", width.toString());
        svg.setAttributeNS(null, "height", height.toString());
        foreignObject.setAttributeNS(null, "width", "100%");
        foreignObject.setAttributeNS(null, "height", "100%");
        foreignObject.setAttributeNS(null, "x", x.toString());
        foreignObject.setAttributeNS(null, "y", y.toString());
        foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = "withCredentials" in new XMLHttpRequest();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== "undefined" && Intl.Segmenter);
            Object.defineProperty(FEATURES, "SUPPORT_NATIVE_TEXT_SEGMENTATION", {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement("html2canvaswrapper");
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error("Node has no owner document");
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "grapheme"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "word"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? "break-word" : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = "";
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = "";
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute("width", bounds.width + "px");
            img.setAttribute("height", bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: "px",
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join("\u2022") : node.value;
        return value.length === 0 ? node.placeholder || "" : value;
    };
    var CHECKBOX = "checkbox";
    var RADIO = "radio";
    var PASSWORD = "password";
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || "" : "";
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        "OL",
        "UL",
        "MENU"
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== "undefined" && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === "object";
    };
    var isLIElement = function(node) {
        return node.tagName === "LI";
    };
    var isOLElement = function(node) {
        return node.tagName === "OL";
    };
    var isInputElement = function(node) {
        return node.tagName === "INPUT";
    };
    var isHTMLElement = function(node) {
        return node.tagName === "HTML";
    };
    var isSVGElement = function(node) {
        return node.tagName === "svg";
    };
    var isBodyElement = function(node) {
        return node.tagName === "BODY";
    };
    var isCanvasElement = function(node) {
        return node.tagName === "CANVAS";
    };
    var isVideoElement = function(node) {
        return node.tagName === "VIDEO";
    };
    var isImageElement = function(node) {
        return node.tagName === "IMG";
    };
    var isIFrameElement = function(node) {
        return node.tagName === "IFRAME";
    };
    var isStyleElement = function(node) {
        return node.tagName === "STYLE";
    };
    var isScriptElement = function(node) {
        return node.tagName === "SCRIPT";
    };
    var isTextareaElement = function(node) {
        return node.tagName === "TEXTAREA";
    };
    var isSelectElement = function(node) {
        return node.tagName === "SELECT";
    };
    var isSlotElement = function(node) {
        return node.tagName === "SLOT";
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf("-") > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            "M",
            "CM",
            "D",
            "CD",
            "C",
            "XC",
            "L",
            "XL",
            "X",
            "IX",
            "V",
            "IV",
            "I"
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, "") + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = "";
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = ". ";
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : "") + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? ". " : "";
        var cjkSuffix = appendSuffix ? "\u3001" : "";
        var koreanSuffix = appendSuffix ? ", " : "";
        var spaceSuffix = appendSuffix ? " " : "";
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error("Cloned element does not have an owner document");
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn("Unable to restore scroll position for cloned document");
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === "undefined") return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === "function") return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = "";
                }
                if (clone.loading === "lazy") clone.loading = "eager";
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement("html2canvascustomelement");
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === "string") return css + rule.cssText;
                        return css;
                    }, "");
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error("Unable to access cssRules property", e);
                if (e.name !== "SecurityError") throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement("img");
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext("2d");
                var clonedCtx = clonedCanvas.getContext("2d");
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext("webgl2")) !== null && _a !== void 0 ? _a : canvas.getContext("webgl");
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement("canvas");
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext("2d");
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement("canvas");
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === "function") {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = "none";
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ":before");
                var styleAfter = window1.getComputedStyle(node, ":after");
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement("html2canvaspseudoelement");
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement("img");
                    img.src = token.value;
                    img.style.opacity = "1";
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === "attr") {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ""));
                    } else if (token.name === "counter") {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === "counters") {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : "";
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case "open-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case "close-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement("iframe");
        cloneIframeContainer.className = "html2canvas-container";
        cloneIframeContainer.style.visibility = "hidden";
        cloneIframeContainer.style.position = "fixed";
        cloneIframeContainer.style.left = "-10000px";
        cloneIframeContainer.style.top = "0px";
        cloneIframeContainer.style.border = "0";
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = "no"; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        "all",
        "d",
        "content" // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = "";
        if (doctype) {
            str += "<!DOCTYPE ";
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += '"' + doctype.publicId + '"';
            if (doctype.systemId) str += '"' + doctype.systemId + '"';
            str += ">";
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ":before";
    var PSEUDO_AFTER = ":after";
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
    var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement("style");
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return "about:blank";
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement("a");
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = "about:blank";
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = "anonymous";
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== "undefined";
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error("No proxy defined");
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === "text") resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener("load", function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener("error", function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
                xhr.open("GET", "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== "text" && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === "blob";
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === "number";
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === "undefined") return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    var SAMPLE_TEXT = "Hidden Text";
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement("div");
            var img = this._document.createElement("img");
            var span = this._document.createElement("span");
            var body = this._document.body;
            container.style.visibility = "hidden";
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = "0";
            container.style.padding = "0";
            container.style.whiteSpace = "nowrap";
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = "0";
            img.style.padding = "0";
            img.style.verticalAlign = "baseline";
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = "0";
            span.style.padding = "0";
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = "normal";
            img.style.verticalAlign = "super";
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === "undefined") this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = "bottom";
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === "normal" || variant === "small-caps";
            }).join("");
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(", ");
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(" "),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? "rtl" : "ltr";
                    this.ctx.textAlign = "left";
                    this.ctx.textBaseline = "alphabetic";
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = "";
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = "";
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = "miter";
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = "left";
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "middle";
                                this.ctx.textAlign = "right";
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = "bottom";
                                this.ctx.textAlign = "left";
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement("canvas");
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), "repeat");
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext("2d");
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, "repeat");
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = "round";
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return "center";
            case 2 /* RIGHT */ :
                return "right";
            case 0 /* LEFT */ :
            default:
                return "left";
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        "-apple-system",
        "system-ui"
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.debug === "function") // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== "undefined" && window.console && typeof console.info === "function") // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.warn === "function") // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.error === "function") // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== "undefined") CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== "object") return [
                            2 /*return*/ ,
                            Promise.reject("Invalid element provided as first argument")
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === "string" ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

});

parcelRegister("lNW6o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdfb3e733ecfeecf$export$2e2bcd8739ae039; });

var $l73V3 = parcelRequire("l73V3");

var $bh6RR = parcelRequire("bh6RR");

var $9Owz0 = parcelRequire("9Owz0");
function $fdfb3e733ecfeecf$export$2e2bcd8739ae039(fn, deps, initialState) {
    if (deps === void 0) deps = [];
    if (initialState === void 0) initialState = {
        loading: false
    };
    var lastCallId = (0, $bh6RR.useRef)(0);
    var isMounted = (0, $9Owz0.default)();
    var _a = (0, $bh6RR.useState)(initialState), state = _a[0], set = _a[1];
    var callback = (0, $bh6RR.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var callId = ++lastCallId.current;
        if (!state.loading) set(function(prevState) {
            return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, prevState), {
                loading: true
            });
        });
        return fn.apply(void 0, args).then(function(value) {
            isMounted() && callId === lastCallId.current && set({
                value: value,
                loading: false
            });
            return value;
        }, function(error) {
            isMounted() && callId === lastCallId.current && set({
                error: error,
                loading: false
            });
            return error;
        });
    }, deps);
    return [
        state,
        callback
    ];
}

});
parcelRegister("l73V3", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $f5ed4ab2a4d1861b$export$18ce0697a983be9b; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $f5ed4ab2a4d1861b$var$extendStatics = function(d, b) {
    $f5ed4ab2a4d1861b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f5ed4ab2a4d1861b$var$extendStatics(d, b);
};
function $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f5ed4ab2a4d1861b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f5ed4ab2a4d1861b$export$18ce0697a983be9b = function() {
    $f5ed4ab2a4d1861b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5ed4ab2a4d1861b$export$18ce0697a983be9b.apply(this, arguments);
};
function $f5ed4ab2a4d1861b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f5ed4ab2a4d1861b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f5ed4ab2a4d1861b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f5ed4ab2a4d1861b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f5ed4ab2a4d1861b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f5ed4ab2a4d1861b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f5ed4ab2a4d1861b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f5ed4ab2a4d1861b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f5ed4ab2a4d1861b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f5ed4ab2a4d1861b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f5ed4ab2a4d1861b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f5ed4ab2a4d1861b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(o, m, p);
}
function $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f5ed4ab2a4d1861b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f5ed4ab2a4d1861b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5ed4ab2a4d1861b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f5ed4ab2a4d1861b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f5ed4ab2a4d1861b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v) {
    return this instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? (this.v = v, this) : new $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v);
}
function $f5ed4ab2a4d1861b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f5ed4ab2a4d1861b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f5ed4ab2a4d1861b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f5ed4ab2a4d1861b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f5ed4ab2a4d1861b$export$19a8beecd37a4c45 === "function" ? $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f5ed4ab2a4d1861b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f5ed4ab2a4d1861b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f5ed4ab2a4d1861b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(result, mod, k);
    }
    $f5ed4ab2a4d1861b$var$__setModuleDefault(result, mod);
    return result;
}
function $f5ed4ab2a4d1861b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f5ed4ab2a4d1861b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f5ed4ab2a4d1861b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f5ed4ab2a4d1861b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f5ed4ab2a4d1861b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f5ed4ab2a4d1861b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f5ed4ab2a4d1861b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f5ed4ab2a4d1861b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f5ed4ab2a4d1861b$export$2e2bcd8739ae039 = {
    __extends: $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a,
    __assign: $f5ed4ab2a4d1861b$export$18ce0697a983be9b,
    __rest: $f5ed4ab2a4d1861b$export$3c9a16f847548506,
    __decorate: $f5ed4ab2a4d1861b$export$29e00dfd3077644b,
    __param: $f5ed4ab2a4d1861b$export$d5ad3fd78186038f,
    __metadata: $f5ed4ab2a4d1861b$export$f1db080c865becb9,
    __awaiter: $f5ed4ab2a4d1861b$export$1050f835b63b671e,
    __generator: $f5ed4ab2a4d1861b$export$67ebef60e6f28a6,
    __createBinding: $f5ed4ab2a4d1861b$export$45d3717a4c69092e,
    __exportStar: $f5ed4ab2a4d1861b$export$f33643c0debef087,
    __values: $f5ed4ab2a4d1861b$export$19a8beecd37a4c45,
    __read: $f5ed4ab2a4d1861b$export$8d051b38c9118094,
    __spread: $f5ed4ab2a4d1861b$export$afc72e2116322959,
    __spreadArrays: $f5ed4ab2a4d1861b$export$6388937ca91ccae8,
    __spreadArray: $f5ed4ab2a4d1861b$export$1216008129fb82ed,
    __await: $f5ed4ab2a4d1861b$export$10c90e4f7922046c,
    __asyncGenerator: $f5ed4ab2a4d1861b$export$e427f37a30a4de9b,
    __asyncDelegator: $f5ed4ab2a4d1861b$export$bbd80228419bb833,
    __asyncValues: $f5ed4ab2a4d1861b$export$e3b29a3d6162315f,
    __makeTemplateObject: $f5ed4ab2a4d1861b$export$4fb47efe1390b86f,
    __importStar: $f5ed4ab2a4d1861b$export$c21735bcef00d192,
    __importDefault: $f5ed4ab2a4d1861b$export$da59b14a69baef04,
    __classPrivateFieldGet: $f5ed4ab2a4d1861b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f5ed4ab2a4d1861b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f5ed4ab2a4d1861b$export$81fdc39f203e4e04,
    __addDisposableResource: $f5ed4ab2a4d1861b$export$88ac25d8e944e405,
    __disposeResources: $f5ed4ab2a4d1861b$export$8f076105dc360e92
};

});

parcelRegister("9Owz0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72520b04646f5dd2$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
function $72520b04646f5dd2$export$2e2bcd8739ae039() {
    var mountedRef = (0, $bh6RR.useRef)(false);
    var get = (0, $bh6RR.useCallback)(function() {
        return mountedRef.current;
    }, []);
    (0, $bh6RR.useEffect)(function() {
        mountedRef.current = true;
        return function() {
            mountedRef.current = false;
        };
    }, []);
    return get;
}

});


parcelRegister("32dsx", function(module, exports) {
$parcel$export(module.exports, "__RouterContext", function () { return (parcelRequire("1LCZd")).__RouterContext; });
$parcel$export(module.exports, "Redirect", function () { return (parcelRequire("1LCZd")).Redirect; });
$parcel$export(module.exports, "Route", function () { return (parcelRequire("1LCZd")).Route; });
$parcel$export(module.exports, "Router", function () { return (parcelRequire("1LCZd")).Router; });
$parcel$export(module.exports, "Switch", function () { return (parcelRequire("1LCZd")).Switch; });
$parcel$export(module.exports, "withRouter", function () { return (parcelRequire("1LCZd")).withRouter; });

$parcel$export(module.exports, "Link", function () { return $235bffbda6f2a3d0$export$a6c7ac8248d6e38a; });

var $gMqD6 = parcelRequire("gMqD6");

var $bh6RR = parcelRequire("bh6RR");

var $1LCZd = parcelRequire("1LCZd");

var $4mTVz = parcelRequire("4mTVz");



var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $2Blw4 = parcelRequire("2Blw4");
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $235bffbda6f2a3d0$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $4mTVz.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $1LCZd.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $235bffbda6f2a3d0$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $4mTVz.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $1LCZd.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
function $235bffbda6f2a3d0$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */ var $235bffbda6f2a3d0$export$a6c7ac8248d6e38a = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(Link, _React$Component);
    function Link() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Link.prototype;
    _proto.handleClick = function handleClick(event, history) {
        if (this.props.onClick) this.props.onClick(event);
        if (!event.defaultPrevented && // onClick prevented default
        event.button === 0 && (!this.props.target || this.props.target === "_self") && // let browser handle "target=_blank" etc.
        !$235bffbda6f2a3d0$var$isModifiedEvent(event) // ignore clicks with modifier keys
        ) {
            event.preventDefault();
            var method = this.props.replace ? history.replace : history.push;
            method(this.props.to);
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _this$props = this.props, innerRef = _this$props.innerRef, replace = _this$props.replace, to = _this$props.to, rest = (0, $hCIyK.default)(_this$props, [
            "innerRef",
            "replace",
            "to"
        ]); // eslint-disable-line no-unused-vars
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $1LCZd.__RouterContext).Consumer, null, function(context) {
            !context && (0, $2Blw4.default)(false);
            var location = typeof to === "string" ? (0, $4mTVz.createLocation)(to, null, null, context.location) : to;
            var href = location ? context.history.createHref(location) : "";
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("a", (0, $4WYaH.default)({}, rest, {
                onClick: function onClick(event) {
                    return _this.handleClick(event, context.history);
                },
                href: href,
                ref: innerRef
            }));
        });
    };
    return Link;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
var $235bffbda6f2a3d0$var$toType, $235bffbda6f2a3d0$var$innerRefType;
function $235bffbda6f2a3d0$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ function $235bffbda6f2a3d0$export$b0d92dbee9b5b60d(_ref) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, location = _ref.location, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, rest = (0, $hCIyK.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "strict",
        "style",
        "to"
    ]);
    var path = typeof to === "object" ? to.pathname : to; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $1LCZd.Route), {
        path: escapedPath,
        exact: exact,
        strict: strict,
        location: location,
        children: function children(_ref2) {
            var location = _ref2.location, match = _ref2.match;
            var isActive = !!(isActiveProp ? isActiveProp(match, location) : match);
            var className = isActive ? $235bffbda6f2a3d0$var$joinClassnames(classNameProp, activeClassName) : classNameProp;
            var style = isActive ? (0, $4WYaH.default)({}, styleProp, activeStyle) : styleProp;
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($235bffbda6f2a3d0$export$a6c7ac8248d6e38a, (0, $4WYaH.default)({
                "aria-current": isActive && ariaCurrent || null,
                className: className,
                style: style,
                to: to
            }, rest));
        }
    });
}
var $235bffbda6f2a3d0$var$ariaCurrentType;

});

parcelRegister("7xUPZ", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $57e7b43af2dd4554$export$42a852a2b6b56249; });
$parcel$export(module.exports, "ContainerWithIcon", function () { return $57e7b43af2dd4554$export$9315f613639564ee; });
$parcel$export(module.exports, "Title", function () { return $57e7b43af2dd4554$export$f99233281efd08a0; });
$parcel$export(module.exports, "Form", function () { return $57e7b43af2dd4554$export$a7fed597f4b8afd8; });
$parcel$export(module.exports, "Content", function () { return $57e7b43af2dd4554$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "Text", function () { return $57e7b43af2dd4554$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Item", function () { return $57e7b43af2dd4554$export$6d08773d2e66f8f2; });
$parcel$export(module.exports, "Cross", function () { return $57e7b43af2dd4554$export$3c877bb842c36952; });
$parcel$export(module.exports, "Alert", function () { return $57e7b43af2dd4554$export$caec2af78bcc877f; });
$parcel$export(module.exports, "Toast", function () { return $57e7b43af2dd4554$export$8d8dc7d5f743331b; });
$parcel$export(module.exports, "ToastTitle", function () { return $57e7b43af2dd4554$export$16d42d7c29b95a4; });
$parcel$export(module.exports, "ToastText", function () { return $57e7b43af2dd4554$export$69fd8082829062a0; });
$parcel$export(module.exports, "ToastBody", function () { return $57e7b43af2dd4554$export$a2fc124486ff7b59; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $bcluV = parcelRequire("bcluV");

var $i0wFy = parcelRequire("i0wFy");

var $1WnR3 = parcelRequire("1WnR3");
var $57e7b43af2dd4554$var$crossIcon = function crossIcon(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "m1.25 1.25 9.753 9.753M11.25 1.25l-9.753 9.753",
            stroke: "#4A4A4A",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
$57e7b43af2dd4554$var$crossIcon.defaultProps = {
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $57e7b43af2dd4554$export$42a852a2b6b56249 = (0, $jCoLF.default).div.withConfig({
    displayName: "PatientReminderstyled__Container",
    componentId: "sc-1fk7j7j-0"
})([
    "box-sizing:border-box;position:relative;border-radius:8px;font-size:15px;max-width:600px;",
    ""
], ({ edit: edit })=>!edit && (0, $jCoLF.css)([
        "cursor:pointer;&:hover{background:",
        ";}"
    ], (0, $i0wFy.colors).gray900));
const $57e7b43af2dd4554$export$9315f613639564ee = (0, $jCoLF.default).div.withConfig({
    displayName: "PatientReminderstyled__ContainerWithIcon",
    componentId: "sc-1fk7j7j-1"
})([
    "display:flex;& svg{padding-right:10px;}"
]);
const $57e7b43af2dd4554$export$f99233281efd08a0 = (0, $jCoLF.default).div.withConfig({
    displayName: "PatientReminderstyled__Title",
    componentId: "sc-1fk7j7j-2"
})([
    "line-height:23px;color:",
    ";",
    ":hover &{color:",
    ";}",
    ""
], (0, $i0wFy.colors).silver, $57e7b43af2dd4554$export$42a852a2b6b56249, (0, $i0wFy.colors).gray700, ({ active: active })=>active && (0, $jCoLF.css)([
        "color:",
        ";"
    ], (0, $i0wFy.colors).gray700));
const $57e7b43af2dd4554$export$a7fed597f4b8afd8 = (0, $jCoLF.default).div.withConfig({
    displayName: "PatientReminderstyled__Form",
    componentId: "sc-1fk7j7j-3"
})([
    "display:none;align-items:flex-start;line-height:23px;@media (max-width:768px){flex-direction:column;}",
    ""
], ({ visible: visible })=>visible && (0, $jCoLF.css)([
        "display:flex;"
    ]));
const $57e7b43af2dd4554$export$7c6e2c02157bb7d2 = (0, $jCoLF.default).div.withConfig({
    displayName: "PatientReminderstyled__Content",
    componentId: "sc-1fk7j7j-4"
})([
    "line-height:23px;"
]);
const $57e7b43af2dd4554$export$5f1af8db9871e1d6 = (0, $jCoLF.default)((0, $bcluV.default)).withConfig({
    displayName: "PatientReminderstyled__Text",
    componentId: "sc-1fk7j7j-5"
})([
    "width:348px;padding:0;border:none;outline:none;resize:none;background:inherit;font-family:inherit;font-size:inherit;line-height:23px;@media (max-width:768px){width:100%;}&::placeholder{color:",
    ";}"
], (0, $i0wFy.colors).silver);
const $57e7b43af2dd4554$export$6d08773d2e66f8f2 = (0, $jCoLF.default).div.withConfig({
    displayName: "PatientReminderstyled__Item",
    componentId: "sc-1fk7j7j-6"
})([
    'position:relative;@media (min-width:768px){&:not(:last-child){margin-right:32px;}&:not(:first-child):before{content:"";position:absolute;left:-16px;width:1px;background:',
    ";height:23px;}}"
], (0, $i0wFy.colors).gray150);
const $57e7b43af2dd4554$export$3c877bb842c36952 = (0, $jCoLF.default)($57e7b43af2dd4554$var$crossIcon).withConfig({
    displayName: "PatientReminderstyled__Cross",
    componentId: "sc-1fk7j7j-7"
})([
    "position:absolute;top:3px;right:-2px;padding:10px;width:11px;height:11px;"
]);
const $57e7b43af2dd4554$export$caec2af78bcc877f = (0, $jCoLF.default).div.withConfig({
    displayName: "PatientReminderstyled__Alert",
    componentId: "sc-1fk7j7j-8"
})([
    "font-size:15px;line-height:23px;color:",
    ";"
], (0, $i0wFy.colors).pomegranate);
const $57e7b43af2dd4554$export$8d8dc7d5f743331b = (0, $jCoLF.default).div.withConfig({
    displayName: "PatientReminderstyled__Toast",
    componentId: "sc-1fk7j7j-9"
})([
    "font-size:13px;line-height:19px;cursor:pointer;"
]);
const $57e7b43af2dd4554$export$16d42d7c29b95a4 = (0, $jCoLF.default).div.withConfig({
    displayName: "PatientReminderstyled__ToastTitle",
    componentId: "sc-1fk7j7j-10"
})([
    "font-weight:500;color:",
    ";"
], (0, $i0wFy.colors).gray600);
const $57e7b43af2dd4554$export$69fd8082829062a0 = (0, $jCoLF.default).div.withConfig({
    displayName: "PatientReminderstyled__ToastText",
    componentId: "sc-1fk7j7j-11"
})([
    "display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;color:",
    ";"
], (0, $i0wFy.colors).gray700);
const $57e7b43af2dd4554$export$a2fc124486ff7b59 = (0, $jCoLF.default)((0, $1WnR3.DefaultToastBody)).withConfig({
    displayName: "PatientReminderstyled__ToastBody",
    componentId: "sc-1fk7j7j-12"
})([
    "display:block;text-decoration:none;"
]);

});
parcelRegister("bcluV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82717db4e24dded8$export$2e2bcd8739ae039; }, function (v) { return $82717db4e24dded8$export$2e2bcd8739ae039 = v; });
var $82717db4e24dded8$export$1e511d4a378977f5;
var $82717db4e24dded8$export$2e2bcd8739ae039;
"use strict";
$82717db4e24dded8$export$1e511d4a378977f5 = true;

var $bItFB = parcelRequire("bItFB");
$82717db4e24dded8$export$2e2bcd8739ae039 = $bItFB.TextareaAutosize;

});
parcelRegister("bItFB", function(module, exports) {
"use strict";
var $887ad1a1a7ce03b4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $887ad1a1a7ce03b4$var$__assign = module.exports && module.exports.__assign || Object.assign || function(t) {
    for(var s, i = 1, n = arguments.length; i < n; i++){
        s = arguments[i];
        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};
var $887ad1a1a7ce03b4$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
};
module.exports.__esModule = true;

var $bh6RR = parcelRequire("bh6RR");

var $eCfBx = parcelRequire("eCfBx");

var $cNQft = parcelRequire("cNQft");

var $jTFqz = parcelRequire("jTFqz");
var $887ad1a1a7ce03b4$var$getLineHeight = $jTFqz;
var $887ad1a1a7ce03b4$var$RESIZED = "autosize:resized";
/**
 * A light replacement for built-in textarea component
 * which automaticaly adjusts its height to match the content
 */ var $887ad1a1a7ce03b4$var$TextareaAutosizeClass = /** @class */ function(_super) {
    $887ad1a1a7ce03b4$var$__extends(TextareaAutosizeClass, _super);
    function TextareaAutosizeClass() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            lineHeight: null
        };
        _this.textarea = null;
        _this.onResize = function(e) {
            if (_this.props.onResize) _this.props.onResize(e);
        };
        _this.updateLineHeight = function() {
            if (_this.textarea) _this.setState({
                lineHeight: $887ad1a1a7ce03b4$var$getLineHeight(_this.textarea)
            });
        };
        _this.onChange = function(e) {
            var onChange = _this.props.onChange;
            _this.currentValue = e.currentTarget.value;
            onChange && onChange(e);
        };
        return _this;
    }
    TextareaAutosizeClass.prototype.componentDidMount = function() {
        var _this = this;
        var _a = this.props, maxRows = _a.maxRows, async = _a.async;
        if (typeof maxRows === "number") this.updateLineHeight();
        if (typeof maxRows === "number" || async) /*
              the defer is needed to:
                - force "autosize" to activate the scrollbar when this.props.maxRows is passed
                - support StyledComponents (see #71)
            */ setTimeout(function() {
            return _this.textarea && $cNQft(_this.textarea);
        });
        else this.textarea && $cNQft(this.textarea);
        if (this.textarea) this.textarea.addEventListener($887ad1a1a7ce03b4$var$RESIZED, this.onResize);
    };
    TextareaAutosizeClass.prototype.componentWillUnmount = function() {
        if (this.textarea) {
            this.textarea.removeEventListener($887ad1a1a7ce03b4$var$RESIZED, this.onResize);
            $cNQft.destroy(this.textarea);
        }
    };
    TextareaAutosizeClass.prototype.render = function() {
        var _this = this;
        var _a = this, _b = _a.props, onResize = _b.onResize, maxRows = _b.maxRows, onChange = _b.onChange, style = _b.style, innerRef = _b.innerRef, children = _b.children, props = $887ad1a1a7ce03b4$var$__rest(_b, [
            "onResize",
            "maxRows",
            "onChange",
            "style",
            "innerRef",
            "children"
        ]), lineHeight = _a.state.lineHeight;
        var maxHeight = maxRows && lineHeight ? lineHeight * maxRows : null;
        return $bh6RR.createElement("textarea", $887ad1a1a7ce03b4$var$__assign({}, props, {
            onChange: this.onChange,
            style: maxHeight ? $887ad1a1a7ce03b4$var$__assign({}, style, {
                maxHeight: maxHeight
            }) : style,
            ref: function(element) {
                _this.textarea = element;
                if (typeof _this.props.innerRef === "function") _this.props.innerRef(element);
                else if (_this.props.innerRef) _this.props.innerRef.current = element;
            }
        }), children);
    };
    TextareaAutosizeClass.prototype.componentDidUpdate = function() {
        this.textarea && $cNQft.update(this.textarea);
    };
    TextareaAutosizeClass.defaultProps = {
        rows: 1,
        async: false
    };
    TextareaAutosizeClass.propTypes = {
        rows: $eCfBx.number,
        maxRows: $eCfBx.number,
        onResize: $eCfBx.func,
        innerRef: $eCfBx.any,
        async: $eCfBx.bool
    };
    return TextareaAutosizeClass;
}($bh6RR.Component);
module.exports.TextareaAutosize = $bh6RR.forwardRef(function(props, ref) {
    return $bh6RR.createElement($887ad1a1a7ce03b4$var$TextareaAutosizeClass, $887ad1a1a7ce03b4$var$__assign({}, props, {
        innerRef: ref
    }));
});

});
parcelRegister("cNQft", function(module, exports) {
/*!
	autosize 4.0.4
	license: MIT
	http://www.jacklmoore.com/autosize
*/ (function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "module",
        "exports"
    ], factory);
    else {
        var mod;
        factory(module, exports);
    }
})(this, function(module1, exports1) {
    "use strict";
    var map = typeof Map === "function" ? new Map() : function() {
        var keys = [];
        var values = [];
        return {
            has: function has(key) {
                return keys.indexOf(key) > -1;
            },
            get: function get(key) {
                return values[keys.indexOf(key)];
            },
            set: function set(key, value) {
                if (keys.indexOf(key) === -1) {
                    keys.push(key);
                    values.push(value);
                }
            },
            delete: function _delete(key) {
                var index = keys.indexOf(key);
                if (index > -1) {
                    keys.splice(index, 1);
                    values.splice(index, 1);
                }
            }
        };
    }();
    var createEvent = function createEvent(name) {
        return new Event(name, {
            bubbles: true
        });
    };
    try {
        new Event("test");
    } catch (e) {
        // IE does not support `new Event()`
        createEvent = function createEvent(name) {
            var evt = document.createEvent("Event");
            evt.initEvent(name, true, false);
            return evt;
        };
    }
    function assign(ta) {
        if (!ta || !ta.nodeName || ta.nodeName !== "TEXTAREA" || map.has(ta)) return;
        var heightOffset = null;
        var clientWidth = null;
        var cachedHeight = null;
        function init() {
            var style = window.getComputedStyle(ta, null);
            if (style.resize === "vertical") ta.style.resize = "none";
            else if (style.resize === "both") ta.style.resize = "horizontal";
            if (style.boxSizing === "content-box") heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
            else heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
            // Fix when a textarea is not on document body and heightOffset is Not a Number
            if (isNaN(heightOffset)) heightOffset = 0;
            update();
        }
        function changeOverflow(value) {
            // Chrome/Safari-specific fix:
            // When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
            // made available by removing the scrollbar. The following forces the necessary text reflow.
            var width = ta.style.width;
            ta.style.width = "0px";
            // Force reflow:
            /* jshint ignore:start */ ta.offsetWidth;
            /* jshint ignore:end */ ta.style.width = width;
            ta.style.overflowY = value;
        }
        function getParentOverflows(el) {
            var arr = [];
            while(el && el.parentNode && el.parentNode instanceof Element){
                if (el.parentNode.scrollTop) arr.push({
                    node: el.parentNode,
                    scrollTop: el.parentNode.scrollTop
                });
                el = el.parentNode;
            }
            return arr;
        }
        function resize() {
            if (ta.scrollHeight === 0) // If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
            return;
            var overflows = getParentOverflows(ta);
            var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)
            ta.style.height = "";
            ta.style.height = ta.scrollHeight + heightOffset + "px";
            // used to check if an update is actually necessary on window.resize
            clientWidth = ta.clientWidth;
            // prevents scroll-position jumping
            overflows.forEach(function(el) {
                el.node.scrollTop = el.scrollTop;
            });
            if (docTop) document.documentElement.scrollTop = docTop;
        }
        function update() {
            resize();
            var styleHeight = Math.round(parseFloat(ta.style.height));
            var computed = window.getComputedStyle(ta, null);
            // Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
            var actualHeight = computed.boxSizing === "content-box" ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;
            // The actual height not matching the style height (set via the resize method) indicates that 
            // the max-height has been exceeded, in which case the overflow should be allowed.
            if (actualHeight < styleHeight) {
                if (computed.overflowY === "hidden") {
                    changeOverflow("scroll");
                    resize();
                    actualHeight = computed.boxSizing === "content-box" ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
                }
            } else // Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
            if (computed.overflowY !== "hidden") {
                changeOverflow("hidden");
                resize();
                actualHeight = computed.boxSizing === "content-box" ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
            }
            if (cachedHeight !== actualHeight) {
                cachedHeight = actualHeight;
                var evt = createEvent("autosize:resized");
                try {
                    ta.dispatchEvent(evt);
                } catch (err) {
                // Firefox will throw an error on dispatchEvent for a detached element
                // https://bugzilla.mozilla.org/show_bug.cgi?id=889376
                }
            }
        }
        var pageResize = function pageResize() {
            if (ta.clientWidth !== clientWidth) update();
        };
        var destroy = (function(style) {
            window.removeEventListener("resize", pageResize, false);
            ta.removeEventListener("input", update, false);
            ta.removeEventListener("keyup", update, false);
            ta.removeEventListener("autosize:destroy", destroy, false);
            ta.removeEventListener("autosize:update", update, false);
            Object.keys(style).forEach(function(key) {
                ta.style[key] = style[key];
            });
            map.delete(ta);
        }).bind(ta, {
            height: ta.style.height,
            resize: ta.style.resize,
            overflowY: ta.style.overflowY,
            overflowX: ta.style.overflowX,
            wordWrap: ta.style.wordWrap
        });
        ta.addEventListener("autosize:destroy", destroy, false);
        // IE9 does not fire onpropertychange or oninput for deletions,
        // so binding to onkeyup to catch most of those events.
        // There is no way that I know of to detect something like 'cut' in IE9.
        if ("onpropertychange" in ta && "oninput" in ta) ta.addEventListener("keyup", update, false);
        window.addEventListener("resize", pageResize, false);
        ta.addEventListener("input", update, false);
        ta.addEventListener("autosize:update", update, false);
        ta.style.overflowX = "hidden";
        ta.style.wordWrap = "break-word";
        map.set(ta, {
            destroy: destroy,
            update: update
        });
        init();
    }
    function destroy(ta) {
        var methods = map.get(ta);
        if (methods) methods.destroy();
    }
    function update(ta) {
        var methods = map.get(ta);
        if (methods) methods.update();
    }
    var autosize = null;
    // Do nothing in Node.js environment and IE8 (or lower)
    if (typeof window === "undefined" || typeof window.getComputedStyle !== "function") {
        autosize = function autosize(el) {
            return el;
        };
        autosize.destroy = function(el) {
            return el;
        };
        autosize.update = function(el) {
            return el;
        };
    } else {
        autosize = function autosize(el, options) {
            if (el) Array.prototype.forEach.call(el.length ? el : [
                el
            ], function(x) {
                return assign(x, options);
            });
            return el;
        };
        autosize.destroy = function(el) {
            if (el) Array.prototype.forEach.call(el.length ? el : [
                el
            ], destroy);
            return el;
        };
        autosize.update = function(el) {
            if (el) Array.prototype.forEach.call(el.length ? el : [
                el
            ], update);
            return el;
        };
    }
    exports1.default = autosize;
    module1.exports = exports1["default"];
});

});

parcelRegister("jTFqz", function(module, exports) {
// Load in dependencies

var $lJWio = parcelRequire("lJWio");
/**
 * Calculate the `line-height` of a given node
 * @param {HTMLElement} node Element to calculate line height of. Must be in the DOM.
 * @returns {Number} `line-height` of the element in pixels
 */ function $e7c34a0899662b5c$var$lineHeight(node) {
    // Grab the line-height via style
    var lnHeightStr = $lJWio(node, "line-height");
    var lnHeight = parseFloat(lnHeightStr, 10);
    // If the lineHeight did not contain a unit (i.e. it was numeric), convert it to ems (e.g. '2.3' === '2.3em')
    if (lnHeightStr === lnHeight + "") {
        // Save the old lineHeight style and update the em unit to the element
        var _lnHeightStyle = node.style.lineHeight;
        node.style.lineHeight = lnHeightStr + "em";
        // Calculate the em based height
        lnHeightStr = $lJWio(node, "line-height");
        lnHeight = parseFloat(lnHeightStr, 10);
        // Revert the lineHeight style
        if (_lnHeightStyle) node.style.lineHeight = _lnHeightStyle;
        else delete node.style.lineHeight;
    }
    // If the lineHeight is in `pt`, convert it to pixels (4px for 3pt)
    // DEV: `em` units are converted to `pt` in IE6
    // Conversion ratio from https://developer.mozilla.org/en-US/docs/Web/CSS/length
    if (lnHeightStr.indexOf("pt") !== -1) {
        lnHeight *= 4;
        lnHeight /= 3;
    // Otherwise, if the lineHeight is in `mm`, convert it to pixels (96px for 25.4mm)
    } else if (lnHeightStr.indexOf("mm") !== -1) {
        lnHeight *= 96;
        lnHeight /= 25.4;
    // Otherwise, if the lineHeight is in `cm`, convert it to pixels (96px for 2.54cm)
    } else if (lnHeightStr.indexOf("cm") !== -1) {
        lnHeight *= 96;
        lnHeight /= 2.54;
    // Otherwise, if the lineHeight is in `in`, convert it to pixels (96px for 1in)
    } else if (lnHeightStr.indexOf("in") !== -1) lnHeight *= 96;
    else if (lnHeightStr.indexOf("pc") !== -1) lnHeight *= 16;
    // Continue our computation
    lnHeight = Math.round(lnHeight);
    // If the line-height is "normal", calculate by font-size
    if (lnHeightStr === "normal") {
        // Create a temporary node
        var nodeName = node.nodeName;
        var _node = document.createElement(nodeName);
        _node.innerHTML = "&nbsp;";
        // If we have a text area, reset it to only 1 row
        // https://github.com/twolfson/line-height/issues/4
        if (nodeName.toUpperCase() === "TEXTAREA") _node.setAttribute("rows", "1");
        // Set the font-size of the element
        var fontSizeStr = $lJWio(node, "font-size");
        _node.style.fontSize = fontSizeStr;
        // Remove default padding/border which can affect offset height
        // https://github.com/twolfson/line-height/issues/4
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetHeight
        _node.style.padding = "0px";
        _node.style.border = "0px";
        // Append it to the body
        var body = document.body;
        body.appendChild(_node);
        // Assume the line height of the element is the height
        var height = _node.offsetHeight;
        lnHeight = height;
        // Remove our child from the DOM
        body.removeChild(_node);
    }
    // Return the calculated height
    return lnHeight;
}
// Export lineHeight
module.exports = $e7c34a0899662b5c$var$lineHeight;

});
parcelRegister("lJWio", function(module, exports) {
// This code has been refactored for 140 bytes
// You can see the original here: https://github.com/twolfson/computedStyle/blob/04cd1da2e30fa45844f95f5cb1ac898e9b9ef050/lib/computedStyle.js
var $fd3b05445df10c4f$var$computedStyle = function(el, prop, getComputedStyle) {
    getComputedStyle = window.getComputedStyle;
    // In one fell swoop
    return(// If we have getComputedStyle
    (getComputedStyle ? // Query it
    // TODO: From CSS-Query notes, we might need (node, null) for FF
    getComputedStyle(el) : // Otherwise, we are in IE and use currentStyle
    el.currentStyle)[// Switch to camelCase for CSSOM
    // DEV: Grabbed from jQuery
    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
    prop.replace(/-(\w)/gi, function(word, letter) {
        return letter.toUpperCase();
    })]);
};
module.exports = $fd3b05445df10c4f$var$computedStyle;

});





parcelRegister("aphpl", function(module, exports) {

$parcel$export(module.exports, "newColorsRassvet", function () { return $7939bdff13cc710d$export$16f383fba3e5bf4e; });
const $7939bdff13cc710d$export$16f383fba3e5bf4e = {
    brown: "#581728",
    brown30: "#CAB5BE",
    brown75: "#836077",
    pink: "#E65100",
    backgroundPrimary: "linear-gradient(180deg, #FFF5F0 0%, #FEEADD 78.65%, #FFDAC3 100%)",
    white: "#FFFFFF"
};

});

parcelRegister("lXS21", function(module, exports) {

$parcel$export(module.exports, "newColors", function () { return $ffd9053690ead15d$export$b9be3b0cf199c722; });
const $ffd9053690ead15d$export$b9be3b0cf199c722 = {
    brown: "#5B3150",
    brown30: "#CAB5BE",
    brown75: "#836077",
    pink: "#D647AA",
    backgroundPrimary: "#F9EEED",
    white: "#FFFFFF",
    yellow: "#FFCC00"
};

});

parcelRegister("cYFxl", function(module, exports) {

$parcel$export(module.exports, "AbsoluteLoader", function () { return $02702eb17aeccbb5$export$b23a8f6b6cca83fb; });
$parcel$export(module.exports, "BlockLoader", function () { return $02702eb17aeccbb5$export$a5477d2fd01414ef; });
$parcel$export(module.exports, "BackdropLoader", function () { return $02702eb17aeccbb5$export$d5dd9959c86efdbc; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $lC4lc = parcelRequire("lC4lc");

var $74PV0 = parcelRequire("74PV0");

var $jCoLF = parcelRequire("jCoLF");

var $g4l1t = parcelRequire("g4l1t");
const $02702eb17aeccbb5$var$BackdropLoaderContainer = (0, $g4l1t.default)((0, $74PV0.default))(({ theme: theme })=>`
    background-color: rgba(255, 255, 255, 0.68);
    z-index: ${theme.zIndex.modal};
  `);
const $02702eb17aeccbb5$var$AbsoluteLoaderContainer = (0, $jCoLF.default).div.withConfig({
    displayName: "Loader__AbsoluteLoaderContainer",
    componentId: "sc-11u1zc9-0"
})([
    "display:flex;justify-content:center;align-items:center;width:100%;height:100%;position:absolute;left:0;top:",
    ";bottom:0;right:0;z-index:",
    ";background:",
    ";pointer-events:",
    ";"
], (props)=>(props === null || props === void 0 ? void 0 : props.top) + "px", (props)=>(props === null || props === void 0 ? void 0 : props.zIndex) || 100, (props)=>props.withoutBackground ? "transparent" : "rgba(255, 255, 255, 0.68)", (props)=>props.disablePointerEvents ? "none" : "auto");
const $02702eb17aeccbb5$export$f31ffcede5cbeee5 = (0, $jCoLF.default)($02702eb17aeccbb5$var$AbsoluteLoaderContainer).withConfig({
    displayName: "Loader__BlockLoaderContainer",
    componentId: "sc-11u1zc9-1"
})([
    "",
    " position:relative;margin:16px 0;",
    ";",
    ";z-index:10;"
], (props)=>props.transparent ? (0, $jCoLF.css)([
        "background:transparent;"
    ]) : null, (props)=>props.withoutMargin && "margin: 0;", (props)=>props.customHeight && `height: ${props.customHeight};`);
const $02702eb17aeccbb5$export$b23a8f6b6cca83fb = ({ size: size = 50, zIndex: zIndex = 100, withoutBackground: withoutBackground, disablePointerEvents: disablePointerEvents, top: top })=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)($02702eb17aeccbb5$var$AbsoluteLoaderContainer, {
        top: top,
        zIndex: zIndex,
        withoutBackground: withoutBackground,
        disablePointerEvents: disablePointerEvents,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lC4lc.default), {
            size: size
        })
    });
};
const $02702eb17aeccbb5$export$a5477d2fd01414ef = ({ transparent: transparent, size: size = 50, withoutMargin: withoutMargin, customHeight: customHeight })=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)($02702eb17aeccbb5$export$f31ffcede5cbeee5, {
        transparent: transparent,
        withoutMargin: withoutMargin,
        customHeight: customHeight,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lC4lc.default), {
            size: size
        })
    });
};
const $02702eb17aeccbb5$export$d5dd9959c86efdbc = ({ isOpen: isOpen = false, size: size = 50 })=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)($02702eb17aeccbb5$var$BackdropLoaderContainer, {
        open: isOpen,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lC4lc.default), {
            size: size
        })
    });
};

});
parcelRegister("lC4lc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbc0839b019d85cb$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $96ZcP = parcelRequire("96ZcP");

var $fPZvG = parcelRequire("fPZvG");

var $fGH8N = parcelRequire("fGH8N");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $2JdtB = parcelRequire("2JdtB");

var $ih19M = parcelRequire("ih19M");
"use client";
const $fbc0839b019d85cb$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $fbc0839b019d85cb$var$_ = (t)=>t, $fbc0839b019d85cb$var$_t, $fbc0839b019d85cb$var$_t2, $fbc0839b019d85cb$var$_t3, $fbc0839b019d85cb$var$_t4;
const $fbc0839b019d85cb$var$SIZE = 44;
const $fbc0839b019d85cb$var$circularRotateKeyframe = (0, $fPZvG.keyframes)($fbc0839b019d85cb$var$_t || ($fbc0839b019d85cb$var$_t = $fbc0839b019d85cb$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $fbc0839b019d85cb$var$circularDashKeyframe = (0, $fPZvG.keyframes)($fbc0839b019d85cb$var$_t2 || ($fbc0839b019d85cb$var$_t2 = $fbc0839b019d85cb$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $fbc0839b019d85cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $fGH8N.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $fGH8N.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $2JdtB.getCircularProgressUtilityClass), classes);
};
const $fbc0839b019d85cb$var$CircularProgressRoot = (0, $g4l1t.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $fGH8N.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $4WYaH.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $fPZvG.css)($fbc0839b019d85cb$var$_t3 || ($fbc0839b019d85cb$var$_t3 = $fbc0839b019d85cb$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $fbc0839b019d85cb$var$circularRotateKeyframe));
const $fbc0839b019d85cb$var$CircularProgressSVG = (0, $g4l1t.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $fbc0839b019d85cb$var$CircularProgressCircle = (0, $g4l1t.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $fGH8N.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $4WYaH.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $fPZvG.css)($fbc0839b019d85cb$var$_t4 || ($fbc0839b019d85cb$var$_t4 = $fbc0839b019d85cb$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $fbc0839b019d85cb$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $fbc0839b019d85cb$var$CircularProgress = /*#__PURE__*/ $bh6RR.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $hCIyK.default)(props, $fbc0839b019d85cb$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $fbc0839b019d85cb$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($fbc0839b019d85cb$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $ih19M.jsx)($fbc0839b019d85cb$var$CircularProgressRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        style: (0, $4WYaH.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)($fbc0839b019d85cb$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$fbc0839b019d85cb$var$SIZE / 2} ${$fbc0839b019d85cb$var$SIZE / 2} ${$fbc0839b019d85cb$var$SIZE} ${$fbc0839b019d85cb$var$SIZE}`,
            children: /*#__PURE__*/ (0, $ih19M.jsx)($fbc0839b019d85cb$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $fbc0839b019d85cb$var$SIZE,
                cy: $fbc0839b019d85cb$var$SIZE,
                r: ($fbc0839b019d85cb$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $fbc0839b019d85cb$export$2e2bcd8739ae039 = $fbc0839b019d85cb$var$CircularProgress;

});
parcelRegister("2JdtB", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", function () { return $1fca3cdfd0dc88eb$export$29cad1383b3f235d; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $1fca3cdfd0dc88eb$export$29cad1383b3f235d(slot) {
    return (0, $dmzXD.default)("MuiCircularProgress", slot);
}
const $1fca3cdfd0dc88eb$var$circularProgressClasses = (0, $fYlYP.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $1fca3cdfd0dc88eb$export$2e2bcd8739ae039 = $1fca3cdfd0dc88eb$var$circularProgressClasses;

});


parcelRegister("74PV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52712e091ff6e80b$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $96ZcP = parcelRequire("96ZcP");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $9q08x = parcelRequire("9q08x");

var $7CQdS = parcelRequire("7CQdS");

var $ih19M = parcelRequire("ih19M");
"use client";
const $52712e091ff6e80b$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $52712e091ff6e80b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $7CQdS.getBackdropUtilityClass), classes);
};
const $52712e091ff6e80b$var$BackdropRoot = (0, $g4l1t.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $52712e091ff6e80b$var$Backdrop = /*#__PURE__*/ $bh6RR.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $9q08x.default), transitionDuration: transitionDuration } = props, other = (0, $hCIyK.default)(props, $52712e091ff6e80b$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $52712e091ff6e80b$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)($52712e091ff6e80b$var$BackdropRoot, (0, $4WYaH.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $aPsoC.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $4WYaH.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $52712e091ff6e80b$export$2e2bcd8739ae039 = $52712e091ff6e80b$var$Backdrop;

});
parcelRegister("9q08x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6db6a5e8cee46790$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $Eapdw = parcelRequire("Eapdw");


var $8gyMY = parcelRequire("8gyMY");

var $6SHzw = parcelRequire("6SHzw");

var $erAkb = parcelRequire("erAkb");

var $ih19M = parcelRequire("ih19M");
"use client";
const $6db6a5e8cee46790$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $6db6a5e8cee46790$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $6db6a5e8cee46790$var$Fade = /*#__PURE__*/ $bh6RR.forwardRef(function Fade(props, ref) {
    const theme = (0, $8gyMY.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $Eapdw.default) } = props, other = (0, $hCIyK.default)(props, $6db6a5e8cee46790$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $bh6RR.useRef(null);
    const handleRef = (0, $erAkb.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $6SHzw.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $6SHzw.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $6SHzw.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $bh6RR.cloneElement(children, (0, $4WYaH.default)({
                style: (0, $4WYaH.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $6db6a5e8cee46790$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $6db6a5e8cee46790$export$2e2bcd8739ae039 = $6db6a5e8cee46790$var$Fade;

});

parcelRegister("7CQdS", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", function () { return $58d497618cd73966$export$9927a91fd93152bd; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $58d497618cd73966$export$9927a91fd93152bd(slot) {
    return (0, $dmzXD.default)("MuiBackdrop", slot);
}
const $58d497618cd73966$var$backdropClasses = (0, $fYlYP.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $58d497618cd73966$export$2e2bcd8739ae039 = $58d497618cd73966$var$backdropClasses;

});



parcelRegister("fqYVq", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("b3WZd").then(()=>parcelRequire("2X7m1"));

});
parcelRegister("hffE7", function(module, exports) {
"use strict";

function $c8dff9588896671a$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("kyEFX")).resolve(id));
}
module.exports = $c8dff9588896671a$var$load;

});


parcelRegister("2ldow", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("2ivfv"),
    $hffE7("23fvw")
]).then(()=>parcelRequire("l44HZ"));

});

parcelRegister("1D5oj", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("9ESuq").then(()=>parcelRequire("8B2aV"));

});

parcelRegister("kcu6a", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");


module.exports = Promise.all([
    $hffE7("4dwnS"),
    $hffE7("knBfL"),
    $hffE7("1zvZF"),
    $hffE7("dWyRF"),
    $hffE7("hwJJb"),
    $hffE7("66Rj4"),
    $hffE7("aspOL"),
    $hffE7("bpkhB"),
    $hffE7("hezGw"),
    $hffE7("c51FZ"),
    $hffE7("kCcAF"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("kpZYX"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("1C4ZA"),
    (parcelRequire("7jkLd"))((parcelRequire("kyEFX")).resolve("lFp4E")),
    $hffE7("9TOQK")
]).then(()=>parcelRequire("02toD"));

});
parcelRegister("7jkLd", function(module, exports) {
"use strict";

var $boLNp = parcelRequire("boLNp");
module.exports = $boLNp(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("boLNp", function(module, exports) {
"use strict";
var $84c702df89f2997b$var$cachedBundles = {};
var $84c702df89f2997b$var$cachedPreloads = {};
var $84c702df89f2997b$var$cachedPrefetches = {};
function $84c702df89f2997b$var$getCache(type) {
    switch(type){
        case "preload":
            return $84c702df89f2997b$var$cachedPreloads;
        case "prefetch":
            return $84c702df89f2997b$var$cachedPrefetches;
        default:
            return $84c702df89f2997b$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $84c702df89f2997b$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("bqffk", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("aoOYI").then(()=>parcelRequire("aFaOO"));

});

parcelRegister("1ywk2", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("lKFc6").then(()=>parcelRequire("iGYZN"));

});

parcelRegister("7Tisi", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("lKFc6"),
    $hffE7("cXcXp")
]).then(()=>parcelRequire("8JaCN"));

});

parcelRegister("a6ltr", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("lKFc6"),
    $hffE7("8uIEM")
]).then(()=>parcelRequire("f6lfa"));

});

parcelRegister("8rFvZ", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("lKFc6"),
    $hffE7("9clM0")
]).then(()=>parcelRequire("3rWeA"));

});

parcelRegister("cB523", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("lKFc6"),
    $hffE7("1Y4fe")
]).then(()=>parcelRequire("2tnpv"));

});

parcelRegister("6VNNt", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("lKFc6"),
    $hffE7("gzuW3")
]).then(()=>parcelRequire("2yc9m"));

});

parcelRegister("iVD2I", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("lKFc6"),
    $hffE7("5AJyY")
]).then(()=>parcelRequire("3a4cC"));

});

parcelRegister("4usJy", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("lKFc6"),
    $hffE7("3eE6Z")
]).then(()=>parcelRequire("d3Io7"));

});

parcelRegister("243qA", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("lKFc6"),
    $hffE7("4lpNl")
]).then(()=>parcelRequire("9MTJo"));

});

parcelRegister("gZPvm", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("fDdGp").then(()=>parcelRequire("jVsL8"));

});

parcelRegister("hMdtq", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("72URc").then(()=>parcelRequire("b75Er"));

});

parcelRegister("5basR", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("h2o3R").then(()=>parcelRequire("hrluM"));

});

parcelRegister("acapg", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("kl1cO"),
    $hffE7("diQ7c")
]).then(()=>parcelRequire("e83j3"));

});

parcelRegister("7OoNX", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("2ivfv"),
    $hffE7("l4LNI")
]).then(()=>parcelRequire("fLM4w"));

});

parcelRegister("78onZ", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("e1RBR").then(()=>parcelRequire("gJOeO"));

});

parcelRegister("7xHWt", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("aspOL"),
    $hffE7("1QCdE")
]).then(()=>parcelRequire("3NIhD"));

});

parcelRegister("jKmnK", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("1zvZF"),
    $hffE7("bpkhB"),
    $hffE7("hezGw"),
    $hffE7("8bDf2"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("4TX3s")
]).then(()=>parcelRequire("l4DV2"));

});

parcelRegister("7zLLx", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("dWyRF"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("kpZYX"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("87ivN")
]).then(()=>parcelRequire("eoBew"));

});

parcelRegister("eSX54", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("1zvZF"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("kpZYX"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("j0bov")
]).then(()=>parcelRequire("2Tp3z"));

});

parcelRegister("fJVhM", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("cRBAZ"),
    $hffE7("dWyRF"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("kpZYX"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("3erX7")
]).then(()=>parcelRequire("4pID9"));

});

parcelRegister("i6jaZ", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");


module.exports = Promise.all([
    $hffE7("2Aa3L"),
    $hffE7("dWyRF"),
    $hffE7("bpkhB"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("kpZYX"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    (parcelRequire("7jkLd"))((parcelRequire("kyEFX")).resolve("4QxR9")),
    $hffE7("dYAgP")
]).then(()=>parcelRequire("lta9i"));

});

parcelRegister("9TwGF", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("ciyIx").then(()=>parcelRequire("eLdnG"));

});

parcelRegister("74y3f", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("37t3t").then(()=>parcelRequire("6qdGX"));

});

parcelRegister("l5jC2", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("22iEh").then(()=>parcelRequire("jgoSB"));

});

parcelRegister("cDChm", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("hO4MC"),
    $hffE7("31KS5"),
    $hffE7("42jCv"),
    $hffE7("aLMzV"),
    $hffE7("f0RQJ"),
    $hffE7("2DTyb"),
    $hffE7("lgMYs"),
    $hffE7("d3bav"),
    $hffE7("kl1cO"),
    $hffE7("bpkhB"),
    $hffE7("dhJXC"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("cOZo0")
]).then(()=>parcelRequire("9iEAA"));

});

parcelRegister("2kzbi", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");


module.exports = Promise.all([
    $hffE7("hwYZ5"),
    $hffE7("cRBAZ"),
    $hffE7("4dwnS"),
    $hffE7("knBfL"),
    $hffE7("1zvZF"),
    $hffE7("dWyRF"),
    $hffE7("hwJJb"),
    $hffE7("66Rj4"),
    $hffE7("aspOL"),
    $hffE7("bpkhB"),
    $hffE7("hezGw"),
    $hffE7("c51FZ"),
    $hffE7("kCcAF"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("kpZYX"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("1C4ZA"),
    (parcelRequire("7jkLd"))((parcelRequire("kyEFX")).resolve("lFp4E")),
    $hffE7("9TOQK"),
    $hffE7("grQ9R")
]).then(()=>parcelRequire("9tAuz"));

});

parcelRegister("eQTwM", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("hwYZ5"),
    $hffE7("cRBAZ"),
    $hffE7("bpkhB"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("lPeFT")
]).then(()=>parcelRequire("L5fan"));

});

parcelRegister("gelfo", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("dWyRF"),
    $hffE7("c51FZ"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("kpZYX"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("d1uHR")
]).then(()=>parcelRequire("6iJqD"));

});

parcelRegister("BPdTM", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");


module.exports = Promise.all([
    $hffE7("1zvZF"),
    $hffE7("dWyRF"),
    $hffE7("hwJJb"),
    $hffE7("66Rj4"),
    $hffE7("aspOL"),
    $hffE7("bpkhB"),
    $hffE7("hezGw"),
    $hffE7("c51FZ"),
    (parcelRequire("7jkLd"))((parcelRequire("kyEFX")).resolve("lFp4E")),
    $hffE7("kCcAF"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("kpZYX"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("1C4ZA")
]).then(()=>parcelRequire("lFlwZ"));

});

parcelRegister("8rlQC", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("bpkhB"),
    $hffE7("hezGw"),
    $hffE7("8bDf2"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("ek3zf")
]).then(()=>parcelRequire("dGbaS"));

});

parcelRegister("gx53c", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");


module.exports = Promise.all([
    $hffE7("1zvZF"),
    $hffE7("dWyRF"),
    $hffE7("hwJJb"),
    $hffE7("66Rj4"),
    $hffE7("aspOL"),
    $hffE7("bpkhB"),
    $hffE7("hezGw"),
    $hffE7("c51FZ"),
    (parcelRequire("7jkLd"))((parcelRequire("kyEFX")).resolve("lFp4E")),
    $hffE7("kCcAF"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("kpZYX"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("9s5AI")
]).then(()=>parcelRequire("i6xzh"));

});

parcelRegister("kD2JO", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("hwYZ5"),
    $hffE7("cRBAZ"),
    $hffE7("hwJJb"),
    $hffE7("bpkhB"),
    $hffE7("hezGw"),
    $hffE7("c51FZ"),
    $hffE7("8bDf2"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("lmncK")
]).then(()=>parcelRequire("llFy8"));

});

parcelRegister("dI2ln", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");


module.exports = Promise.all([
    $hffE7("4dwnS"),
    $hffE7("dWyRF"),
    $hffE7("bpkhB"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("kpZYX"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    (parcelRequire("7jkLd"))((parcelRequire("kyEFX")).resolve("17UYv")),
    $hffE7("icomT")
]).then(()=>parcelRequire("caaSW"));

});

parcelRegister("ivARo", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("dmpwv"),
    $hffE7("dOjIV"),
    $hffE7("8IvlJ"),
    $hffE7("hhOCd"),
    $hffE7("f3HW8"),
    $hffE7("lXSXF"),
    $hffE7("hwYZ5"),
    $hffE7("31KS5"),
    $hffE7("42jCv"),
    $hffE7("aLMzV"),
    $hffE7("2Aa3L"),
    $hffE7("cRBAZ"),
    $hffE7("kl1cO"),
    $hffE7("bpkhB"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("kpZYX"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("hiDge")
]).then(()=>parcelRequire("fJjHr"));

});

parcelRegister("fKJPz", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");


module.exports = Promise.all([
    $hffE7("G9iKu"),
    $hffE7("dmpwv"),
    $hffE7("hwYZ5"),
    $hffE7("2Aa3L"),
    $hffE7("cRBAZ"),
    $hffE7("kl1cO"),
    $hffE7("hwJJb"),
    $hffE7("66Rj4"),
    $hffE7("j0bov"),
    $hffE7("dWyRF"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("kpZYX"),
    $hffE7("87ivN"),
    $hffE7("1zvZF"),
    $hffE7("bpkhB"),
    $hffE7("hezGw"),
    $hffE7("8bDf2"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("4TX3s"),
    (parcelRequire("7jkLd"))((parcelRequire("kyEFX")).resolve("iT28t")),
    $hffE7("iZwfH")
]).then(()=>parcelRequire("gLLfo"));

});

parcelRegister("dlYTa", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("gfzFe"),
    $hffE7("bpkhB"),
    $hffE7("hezGw"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("kpZYX"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("54TiM")
]).then(()=>parcelRequire("2b19T"));

});

parcelRegister("cZACf", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("gfzFe"),
    $hffE7("dmpwv"),
    $hffE7("hwYZ5"),
    $hffE7("2Aa3L"),
    $hffE7("cRBAZ"),
    $hffE7("kl1cO"),
    $hffE7("bpkhB"),
    $hffE7("hezGw"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("kpZYX"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("23Knm")
]).then(()=>parcelRequire("b0phW"));

});

parcelRegister("dyLEx", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("dmpwv"),
    $hffE7("hwYZ5"),
    $hffE7("2Aa3L"),
    $hffE7("cRBAZ"),
    $hffE7("kl1cO"),
    $hffE7("eprfK"),
    $hffE7("fSLtg"),
    $hffE7("2ivfv"),
    $hffE7("7GcCJ")
]).then(()=>parcelRequire("19YR4"));

});

parcelRegister("iBodj", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("hGTmH"),
    $hffE7("hO4MC"),
    $hffE7("2DTyb"),
    $hffE7("lgMYs"),
    $hffE7("7X02k")
]).then(()=>parcelRequire("kab4c"));

});

parcelRegister("chQWi", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("1pZrR").then(()=>parcelRequire("1e1kM"));

});

parcelRegister("f8W0a", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("cW6ph").then(()=>parcelRequire("7yljI"));

});

parcelRegister("hN9lV", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("9SY9F").then(()=>parcelRequire("gxh1T"));

});

parcelRegister("kfn7o", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("kazFc").then(()=>parcelRequire("7Ja44"));

});

parcelRegister("1ciCC", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("az7mb").then(()=>parcelRequire("9uV8u"));

});

parcelRegister("ecmRC", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("2DTyb"),
    $hffE7("6QOCn")
]).then(()=>parcelRequire("asrY2"));

});

parcelRegister("cKwry", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("42jCv"),
    $hffE7("aLMzV"),
    $hffE7("f0RQJ"),
    $hffE7("2DTyb"),
    $hffE7("lgMYs"),
    $hffE7("8byYC")
]).then(()=>parcelRequire("cfrwB"));

});

parcelRegister("6jYW6", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("2qGqz"),
    $hffE7("hGTmH"),
    $hffE7("dOjIV"),
    $hffE7("8IvlJ"),
    $hffE7("31KS5"),
    $hffE7("42jCv"),
    $hffE7("aLMzV"),
    $hffE7("kl1cO"),
    $hffE7("8ueO4")
]).then(()=>parcelRequire("8K1XZ"));

});

parcelRegister("lhjOz", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("8IvlJ"),
    $hffE7("hhOCd"),
    $hffE7("42jCv"),
    $hffE7("aLMzV"),
    $hffE7("fJZDO")
]).then(()=>parcelRequire("3c4DD"));

});

parcelRegister("eQLfD", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("8IvlJ"),
    $hffE7("hhOCd"),
    $hffE7("42jCv"),
    $hffE7("aLMzV"),
    $hffE7("hLsbi")
]).then(()=>parcelRequire("fQhIy"));

});

parcelRegister("iNhkT", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("2qGqz"),
    $hffE7("dmpwv"),
    $hffE7("dOjIV"),
    $hffE7("8IvlJ"),
    $hffE7("hhOCd"),
    $hffE7("lXSXF"),
    $hffE7("hwYZ5"),
    $hffE7("cW6ph"),
    $hffE7("hO4MC"),
    $hffE7("1pZrR"),
    $hffE7("42jCv"),
    $hffE7("f0RQJ"),
    $hffE7("lgMYs"),
    $hffE7("d3bav"),
    $hffE7("cRBAZ"),
    $hffE7("kl1cO"),
    $hffE7("4dwnS"),
    $hffE7("knBfL"),
    $hffE7("bpkhB"),
    $hffE7("hezGw"),
    $hffE7("eprfK"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("7Bg9v")
]).then(()=>parcelRequire("a0cPm"));

});

parcelRegister("8nKBP", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");




module.exports = Promise.all([
    $hffE7("G9iKu"),
    $hffE7("dmpwv"),
    $hffE7("f3HW8"),
    $hffE7("hwYZ5"),
    $hffE7("aLMzV"),
    $hffE7("2Aa3L"),
    $hffE7("cRBAZ"),
    $hffE7("kl1cO"),
    $hffE7("1zvZF"),
    $hffE7("66Rj4"),
    $hffE7("eprfK"),
    $hffE7("fSLtg"),
    $hffE7("2ivfv"),
    (parcelRequire("7jkLd"))((parcelRequire("kyEFX")).resolve("iT28t")),
    (parcelRequire("7jkLd"))((parcelRequire("kyEFX")).resolve("ct5oz")),
    $hffE7("3QElD")
]).then(()=>parcelRequire("7RC73"));

});

parcelRegister("7KgDa", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("dmpwv"),
    $hffE7("hwYZ5"),
    $hffE7("2Aa3L"),
    $hffE7("cRBAZ"),
    $hffE7("kl1cO"),
    $hffE7("diQ7c"),
    $hffE7("h2o3R"),
    $hffE7("72URc"),
    $hffE7("dWyRF"),
    $hffE7("dhJXC"),
    $hffE7("eprfK"),
    $hffE7("4GUPm"),
    $hffE7("8bDf2"),
    $hffE7("kpZYX"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("l4LNI"),
    $hffE7("bnCau")
]).then(()=>parcelRequire("lhNs7"));

});

parcelRegister("HzDT0", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("dmpwv"),
    $hffE7("hwYZ5"),
    $hffE7("2Aa3L"),
    $hffE7("cRBAZ"),
    $hffE7("kl1cO"),
    $hffE7("1zvZF"),
    $hffE7("bpkhB"),
    $hffE7("hezGw"),
    $hffE7("eprfK"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("ifbuY")
]).then(()=>parcelRequire("5ohJD"));

});

parcelRegister("8o1GQ", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("hO4MC"),
    $hffE7("31KS5"),
    $hffE7("42jCv"),
    $hffE7("aLMzV"),
    $hffE7("f0RQJ"),
    $hffE7("2DTyb"),
    $hffE7("lgMYs"),
    $hffE7("d3bav"),
    $hffE7("kl1cO"),
    $hffE7("bpkhB"),
    $hffE7("dhJXC"),
    $hffE7("fSLtg"),
    $hffE7("bqvfF"),
    $hffE7("2ivfv"),
    $hffE7("aGXM8")
]).then(()=>parcelRequire("26mrf"));

});

parcelRegister("ad4Y1", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("dmpwv"),
    $hffE7("dOjIV"),
    $hffE7("hwYZ5"),
    $hffE7("31KS5"),
    $hffE7("42jCv"),
    $hffE7("aLMzV"),
    $hffE7("2Aa3L"),
    $hffE7("cRBAZ"),
    $hffE7("kl1cO"),
    $hffE7("eprfK"),
    $hffE7("fSLtg"),
    $hffE7("2ivfv"),
    $hffE7("111Nd")
]).then(()=>parcelRequire("fZeMT"));

});

parcelRegister("7WFbh", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("dmpwv"),
    $hffE7("hwYZ5"),
    $hffE7("2Aa3L"),
    $hffE7("cRBAZ"),
    $hffE7("kl1cO"),
    $hffE7("eprfK"),
    $hffE7("fSLtg"),
    $hffE7("2ivfv"),
    $hffE7("9WSgn")
]).then(()=>parcelRequire("55cOi"));

});

parcelRegister("ceckB", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("73Sbh").then(()=>parcelRequire("kw7Gf"));

});

parcelRegister("8xZcN", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("gYVsF").then(()=>parcelRequire("iDU1v"));

});

parcelRegister("8poMo", function(module, exports) {

$parcel$export(module.exports, "getPickersLocalization", function () { return $61f3e13ea8dfab81$export$67c96d35a1b010b3; });

var $4WYaH = parcelRequire("4WYaH");
const $61f3e13ea8dfab81$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $4WYaH.default)({}, pickersTranslations)
                }
            }
        }
    };
};

});

parcelRegister("6BF6w", function(module, exports) {
//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

(function(global, factory) {
    factory((parcelRequire("cxTnx")));
})(module.exports, function(moment) {
    "use strict";
    //! moment.js locale configuration
    function plural(word, num) {
        var forms = word.split("_");
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? "\u0441\u0435\u043A\u0443\u043D\u0434\u0430_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434" : "\u0441\u0435\u043A\u0443\u043D\u0434\u0443_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434",
            mm: withoutSuffix ? "\u043C\u0438\u043D\u0443\u0442\u0430_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442" : "\u043C\u0438\u043D\u0443\u0442\u0443_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442",
            hh: "\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043E\u0432",
            dd: "\u0434\u0435\u043D\u044C_\u0434\u043D\u044F_\u0434\u043D\u0435\u0439",
            ww: "\u043D\u0435\u0434\u0435\u043B\u044F_\u043D\u0435\u0434\u0435\u043B\u0438_\u043D\u0435\u0434\u0435\u043B\u044C",
            MM: "\u043C\u0435\u0441\u044F\u0446_\u043C\u0435\u0441\u044F\u0446\u0430_\u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            yy: "\u0433\u043E\u0434_\u0433\u043E\u0434\u0430_\u043B\u0435\u0442"
        };
        if (key === "m") return withoutSuffix ? "\u043C\u0438\u043D\u0443\u0442\u0430" : "\u043C\u0438\u043D\u0443\u0442\u0443";
        else return number + " " + plural(format[key], +number);
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i
    ];
    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale("ru", {
        months: {
            format: "\u044F\u043D\u0432\u0430\u0440\u044F_\u0444\u0435\u0432\u0440\u0430\u043B\u044F_\u043C\u0430\u0440\u0442\u0430_\u0430\u043F\u0440\u0435\u043B\u044F_\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F_\u043E\u043A\u0442\u044F\u0431\u0440\u044F_\u043D\u043E\u044F\u0431\u0440\u044F_\u0434\u0435\u043A\u0430\u0431\u0440\u044F".split("_"),
            standalone: "\u044F\u043D\u0432\u0430\u0440\u044C_\u0444\u0435\u0432\u0440\u0430\u043B\u044C_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B\u044C_\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C_\u043E\u043A\u0442\u044F\u0431\u0440\u044C_\u043D\u043E\u044F\u0431\u0440\u044C_\u0434\u0435\u043A\u0430\u0431\u0440\u044C".split("_")
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440._\u0430\u043F\u0440._\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split("_"),
            standalone: "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440\u0442_\u0430\u043F\u0440._\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split("_")
        },
        weekdays: {
            standalone: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043F\u044F\u0442\u043D\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043E\u0442\u0430".split("_"),
            format: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043F\u044F\u0442\u043D\u0438\u0446\u0443_\u0441\u0443\u0431\u0431\u043E\u0442\u0443".split("_"),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
        },
        weekdaysShort: "\u0432\u0441_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
        weekdaysMin: "\u0432\u0441_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0433.",
            LLL: "D MMMM YYYY \u0433., H:mm",
            LLLL: "dddd, D MMMM YYYY \u0433., H:mm"
        },
        calendar: {
            sameDay: "[\u0421\u0435\u0433\u043E\u0434\u043D\u044F, \u0432] LT",
            nextDay: "[\u0417\u0430\u0432\u0442\u0440\u0430, \u0432] LT",
            lastDay: "[\u0412\u0447\u0435\u0440\u0430, \u0432] LT",
            nextWeek: function(now) {
                if (now.week() !== this.week()) switch(this.day()){
                    case 0:
                        return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435] dddd, [\u0432] LT";
                    case 1:
                    case 2:
                    case 4:
                        return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439] dddd, [\u0432] LT";
                    case 3:
                    case 5:
                    case 6:
                        return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E] dddd, [\u0432] LT";
                }
                else {
                    if (this.day() === 2) return "[\u0412\u043E] dddd, [\u0432] LT";
                    else return "[\u0412] dddd, [\u0432] LT";
                }
            },
            lastWeek: function(now) {
                if (now.week() !== this.week()) switch(this.day()){
                    case 0:
                        return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u043E\u0435] dddd, [\u0432] LT";
                    case 1:
                    case 2:
                    case 4:
                        return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u044B\u0439] dddd, [\u0432] LT";
                    case 3:
                    case 5:
                    case 6:
                        return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u0443\u044E] dddd, [\u0432] LT";
                }
                else {
                    if (this.day() === 2) return "[\u0412\u043E] dddd, [\u0432] LT";
                    else return "[\u0412] dddd, [\u0432] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0447\u0435\u0440\u0435\u0437 %s",
            past: "%s \u043D\u0430\u0437\u0430\u0434",
            s: "\u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434",
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: "\u0447\u0430\u0441",
            hh: relativeTimeWithPlural,
            d: "\u0434\u0435\u043D\u044C",
            dd: relativeTimeWithPlural,
            w: "\u043D\u0435\u0434\u0435\u043B\u044F",
            ww: relativeTimeWithPlural,
            M: "\u043C\u0435\u0441\u044F\u0446",
            MM: relativeTimeWithPlural,
            y: "\u0433\u043E\u0434",
            yy: relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function(input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 4) return "\u043D\u043E\u0447\u0438";
            else if (hour < 12) return "\u0443\u0442\u0440\u0430";
            else if (hour < 17) return "\u0434\u043D\u044F";
            else return "\u0432\u0435\u0447\u0435\u0440\u0430";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function(number, period) {
            switch(period){
                case "M":
                case "d":
                case "DDD":
                    return number + "-\u0439";
                case "D":
                    return number + "-\u0433\u043E";
                case "w":
                case "W":
                    return number + "-\u044F";
                default:
                    return number;
            }
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    return ru;
});

});

parcelRegister("beWgj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82ee3221eaadbd63$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");
parcelRequire("bh6RR");


var $gSIOK = parcelRequire("gSIOK");

var $wllwT = parcelRequire("wllwT");

var $ih19M = parcelRequire("ih19M");
"use client";
const $82ee3221eaadbd63$var$_excluded = [
    "theme"
];
function $82ee3221eaadbd63$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $hCIyK.default)(_ref, $82ee3221eaadbd63$var$_excluded);
    const scopedTheme = themeInput[0, $wllwT.default];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $gSIOK.default), (0, $4WYaH.default)({}, props, {
        themeId: scopedTheme ? (0, $wllwT.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}

});
parcelRegister("gSIOK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4a47454759f565e$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $4Xy7x = parcelRequire("4Xy7x");
var $3xecU = parcelRequire("3xecU");

parcelRequire("fPZvG");
var $62brB = parcelRequire("62brB");

var $2Sd76 = parcelRequire("2Sd76");

var $ih19M = parcelRequire("ih19M");
"use client";
const $c4a47454759f565e$var$EMPTY_THEME = {};
function $c4a47454759f565e$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $bh6RR.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $4WYaH.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $4WYaH.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $4WYaH.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $c4a47454759f565e$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $2Sd76.default)($c4a47454759f565e$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $3xecU.default)() || $c4a47454759f565e$var$EMPTY_THEME;
    const engineTheme = $c4a47454759f565e$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $c4a47454759f565e$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $4Xy7x.default), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $62brB.T).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
var $c4a47454759f565e$export$2e2bcd8739ae039 = $c4a47454759f565e$var$ThemeProvider;

});
parcelRegister("4Xy7x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39c723c1215b7980$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");



var $1i796 = parcelRequire("1i796");

var $3xecU = parcelRequire("3xecU");

var $9v37N = parcelRequire("9v37N");

var $ih19M = parcelRequire("ih19M");
function $39c723c1215b7980$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $4WYaH.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $39c723c1215b7980$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $3xecU.default)();
    const theme = $bh6RR.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $39c723c1215b7980$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $9v37N.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1i796.default).Provider, {
        value: theme,
        children: children
    });
}
var $39c723c1215b7980$export$2e2bcd8739ae039 = $39c723c1215b7980$var$ThemeProvider;

});
parcelRegister("1i796", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f0d03ea95531b67$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
const $0f0d03ea95531b67$var$ThemeContext = /*#__PURE__*/ $bh6RR.createContext(null);
var $0f0d03ea95531b67$export$2e2bcd8739ae039 = $0f0d03ea95531b67$var$ThemeContext;

});

parcelRegister("3xecU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $292f796dbfb739ac$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $1i796 = parcelRequire("1i796");
function $292f796dbfb739ac$export$2e2bcd8739ae039() {
    const theme = $bh6RR.useContext((0, $1i796.default));
    return theme;
}

});

parcelRegister("9v37N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ea96ed1f248d8d4$export$2e2bcd8739ae039; });
const $6ea96ed1f248d8d4$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $6ea96ed1f248d8d4$export$2e2bcd8739ae039 = $6ea96ed1f248d8d4$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});




parcelRegister("jvuxX", function(module, exports) {

$parcel$export(module.exports, "__privateGet", function () { return $e3389b84c0ea620d$export$18a094aefa070634; });
$parcel$export(module.exports, "__privateAdd", function () { return $e3389b84c0ea620d$export$addf369becd23283; });
$parcel$export(module.exports, "__privateSet", function () { return $e3389b84c0ea620d$export$42432efe6614d3b4; });
$parcel$export(module.exports, "__privateWrapper", function () { return $e3389b84c0ea620d$export$b1fe7cbb4502036b; });
$parcel$export(module.exports, "__privateMethod", function () { return $e3389b84c0ea620d$export$fa92d15b718fce20; });
var $e3389b84c0ea620d$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $e3389b84c0ea620d$export$18a094aefa070634 = (obj, member, getter)=>{
    $e3389b84c0ea620d$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $e3389b84c0ea620d$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $e3389b84c0ea620d$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $e3389b84c0ea620d$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $e3389b84c0ea620d$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $e3389b84c0ea620d$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $e3389b84c0ea620d$export$18a094aefa070634(obj, member, getter);
        }
    });
var $e3389b84c0ea620d$export$fa92d15b718fce20 = (obj, member, method)=>{
    $e3389b84c0ea620d$var$__accessCheck(obj, member, "access private method");
    return method;
};

});

parcelRegister("f9jQ6", function(module, exports) {

$parcel$export(module.exports, "isServer", function () { return $b07715f701fb11cd$export$6acf61af03e62db; });
$parcel$export(module.exports, "noop", function () { return $b07715f701fb11cd$export$8793edee2d425525; });
$parcel$export(module.exports, "functionalUpdate", function () { return $b07715f701fb11cd$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "isValidTimeout", function () { return $b07715f701fb11cd$export$e539f754e934e270; });
$parcel$export(module.exports, "timeUntilStale", function () { return $b07715f701fb11cd$export$811b83d62bcf47f0; });
$parcel$export(module.exports, "resolveStaleTime", function () { return $b07715f701fb11cd$export$cb3145f011bda3ac; });
$parcel$export(module.exports, "resolveEnabled", function () { return $b07715f701fb11cd$export$8c88ee6f2357230d; });
$parcel$export(module.exports, "matchQuery", function () { return $b07715f701fb11cd$export$c5d1efe363797780; });
$parcel$export(module.exports, "hashQueryKeyByOptions", function () { return $b07715f701fb11cd$export$cc90ca97bc0d73fd; });
$parcel$export(module.exports, "partialMatchKey", function () { return $b07715f701fb11cd$export$2f07189bb9fa26a7; });
$parcel$export(module.exports, "matchMutation", function () { return $b07715f701fb11cd$export$a1ea5fb559f63ae3; });
$parcel$export(module.exports, "hashKey", function () { return $b07715f701fb11cd$export$1e87d19d4aab5805; });
$parcel$export(module.exports, "shallowEqualObjects", function () { return $b07715f701fb11cd$export$3e67810a3f0e9f1c; });
$parcel$export(module.exports, "sleep", function () { return $b07715f701fb11cd$export$e772c8ff12451969; });
$parcel$export(module.exports, "replaceData", function () { return $b07715f701fb11cd$export$17619bac5b909b23; });
$parcel$export(module.exports, "addToEnd", function () { return $b07715f701fb11cd$export$ccce65a22a26f2bc; });
$parcel$export(module.exports, "addToStart", function () { return $b07715f701fb11cd$export$8c6246b73dd61f4a; });
$parcel$export(module.exports, "skipToken", function () { return $b07715f701fb11cd$export$1aa5a89531b7670d; });
$parcel$export(module.exports, "ensureQueryFn", function () { return $b07715f701fb11cd$export$c71c44209368a3bc; });

// src/utils.ts
var $b07715f701fb11cd$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $b07715f701fb11cd$export$8793edee2d425525() {
    return void 0;
}
function $b07715f701fb11cd$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $b07715f701fb11cd$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $b07715f701fb11cd$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $b07715f701fb11cd$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $b07715f701fb11cd$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $b07715f701fb11cd$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $b07715f701fb11cd$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$b07715f701fb11cd$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $b07715f701fb11cd$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($b07715f701fb11cd$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $b07715f701fb11cd$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$b07715f701fb11cd$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $b07715f701fb11cd$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $b07715f701fb11cd$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $b07715f701fb11cd$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$b07715f701fb11cd$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $b07715f701fb11cd$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$b07715f701fb11cd$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $b07715f701fb11cd$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $b07715f701fb11cd$export$7a8558113332b71e(a) && $b07715f701fb11cd$export$7a8558113332b71e(b);
    if (array || $b07715f701fb11cd$export$53b83ca8eaab0383(a) && $b07715f701fb11cd$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $b07715f701fb11cd$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $b07715f701fb11cd$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $b07715f701fb11cd$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $b07715f701fb11cd$export$53b83ca8eaab0383(o) {
    if (!$b07715f701fb11cd$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$b07715f701fb11cd$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $b07715f701fb11cd$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $b07715f701fb11cd$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $b07715f701fb11cd$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) return $b07715f701fb11cd$export$77a71fc411098696(prevData, data);
    return data;
}
function $b07715f701fb11cd$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $b07715f701fb11cd$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $b07715f701fb11cd$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $b07715f701fb11cd$export$1aa5a89531b7670d = Symbol();
var $b07715f701fb11cd$export$c71c44209368a3bc = (options, fetchOptions)=>{
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $b07715f701fb11cd$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
};

});

parcelRegister("ihLQ3", function(module, exports) {

$parcel$export(module.exports, "Query", function () { return $d4feec464ffff228$export$62297b13309008b2; });
$parcel$export(module.exports, "fetchState", function () { return $d4feec464ffff228$export$f3df9013f2b58bce; });

var $jvuxX = parcelRequire("jvuxX");

var $f9jQ6 = parcelRequire("f9jQ6");

var $iLk26 = parcelRequire("iLk26");

var $g9Hbg = parcelRequire("g9Hbg");

var $kyUYW = parcelRequire("kyUYW");
var $d4feec464ffff228$var$_initialState, $d4feec464ffff228$var$_revertState, $d4feec464ffff228$var$_cache, $d4feec464ffff228$var$_retryer, $d4feec464ffff228$var$_defaultOptions, $d4feec464ffff228$var$_abortSignalConsumed, $d4feec464ffff228$var$_dispatch, $d4feec464ffff228$var$dispatch_fn;
var $d4feec464ffff228$export$62297b13309008b2 = class extends (0, $kyUYW.Removable) {
    constructor(config){
        super();
        (0, $jvuxX.__privateAdd)(this, $d4feec464ffff228$var$_dispatch);
        (0, $jvuxX.__privateAdd)(this, $d4feec464ffff228$var$_initialState, void 0);
        (0, $jvuxX.__privateAdd)(this, $d4feec464ffff228$var$_revertState, void 0);
        (0, $jvuxX.__privateAdd)(this, $d4feec464ffff228$var$_cache, void 0);
        (0, $jvuxX.__privateAdd)(this, $d4feec464ffff228$var$_retryer, void 0);
        (0, $jvuxX.__privateAdd)(this, $d4feec464ffff228$var$_defaultOptions, void 0);
        (0, $jvuxX.__privateAdd)(this, $d4feec464ffff228$var$_abortSignalConsumed, void 0);
        (0, $jvuxX.__privateSet)(this, $d4feec464ffff228$var$_abortSignalConsumed, false);
        (0, $jvuxX.__privateSet)(this, $d4feec464ffff228$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $jvuxX.__privateSet)(this, $d4feec464ffff228$var$_cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $jvuxX.__privateSet)(this, $d4feec464ffff228$var$_initialState, config.state || $d4feec464ffff228$var$getDefaultState(this.options));
        this.state = (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _a;
        return (_a = (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $f9jQ6.replaceData)(this.state.data, newData, this.options);
        (0, $jvuxX.__privateMethod)(this, $d4feec464ffff228$var$_dispatch, $d4feec464ffff228$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $jvuxX.__privateMethod)(this, $d4feec464ffff228$var$_dispatch, $d4feec464ffff228$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $f9jQ6.noop)).catch((0, $f9jQ6.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_initialState));
    }
    isActive() {
        return this.observers.some((observer)=>(0, $f9jQ6.resolveEnabled)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $f9jQ6.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_retryer)) {
                    if ((0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_abortSignalConsumed)) (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $jvuxX.__privateMethod)(this, $d4feec464ffff228$var$_dispatch, $d4feec464ffff228$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_retryer)) {
                (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_retryer).continueRetry();
                return (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $jvuxX.__privateSet)(this, $d4feec464ffff228$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $f9jQ6.ensureQueryFn)(this.options, fetchOptions);
            const queryFnContext = {
                queryKey: this.queryKey,
                meta: this.meta
            };
            addSignalProperty(queryFnContext);
            (0, $jvuxX.__privateSet)(this, $d4feec464ffff228$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_a = this.options.behavior) == null || _a.onFetch(context, this);
        (0, $jvuxX.__privateSet)(this, $d4feec464ffff228$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_b = context.fetchOptions) == null ? void 0 : _b.meta)) (0, $jvuxX.__privateMethod)(this, $d4feec464ffff228$var$_dispatch, $d4feec464ffff228$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_c = context.fetchOptions) == null ? void 0 : _c.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d;
            if (!((0, $g9Hbg.isCancelledError)(error) && error.silent)) (0, $jvuxX.__privateMethod)(this, $d4feec464ffff228$var$_dispatch, $d4feec464ffff228$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $g9Hbg.isCancelledError)(error)) {
                (_b2 = (_a2 = (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d = (_c2 = (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_cache).config).onSettled) == null || _d.call(_c2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) this.scheduleGc();
            this.isFetchingOptimistic = false;
        };
        (0, $jvuxX.__privateSet)(this, $d4feec464ffff228$var$_retryer, (0, $g9Hbg.createRetryer)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d;
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                this.setData(data);
                (_b2 = (_a2 = (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d = (_c2 = (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_cache).config).onSettled) == null || _d.call(_c2, data, this.state.error, this);
                if (!this.isFetchingOptimistic) this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $jvuxX.__privateMethod)(this, $d4feec464ffff228$var$_dispatch, $d4feec464ffff228$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $jvuxX.__privateMethod)(this, $d4feec464ffff228$var$_dispatch, $d4feec464ffff228$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $jvuxX.__privateMethod)(this, $d4feec464ffff228$var$_dispatch, $d4feec464ffff228$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        return (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_retryer).start();
    }
};
$d4feec464ffff228$var$_initialState = new WeakMap();
$d4feec464ffff228$var$_revertState = new WeakMap();
$d4feec464ffff228$var$_cache = new WeakMap();
$d4feec464ffff228$var$_retryer = new WeakMap();
$d4feec464ffff228$var$_defaultOptions = new WeakMap();
$d4feec464ffff228$var$_abortSignalConsumed = new WeakMap();
$d4feec464ffff228$var$_dispatch = new WeakSet();
$d4feec464ffff228$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$d4feec464ffff228$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $g9Hbg.isCancelledError)(error) && error.revert && (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_revertState)) return {
                    ...(0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $iLk26.notifyManager).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $jvuxX.__privateGet)(this, $d4feec464ffff228$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $d4feec464ffff228$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $g9Hbg.canFetch)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $d4feec464ffff228$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}

});
parcelRegister("iLk26", function(module, exports) {

$parcel$export(module.exports, "notifyManager", function () { return $da8c27e8b4a5d4b7$export$520687f44db6e1ab; });

// src/notifyManager.ts
function $da8c27e8b4a5d4b7$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const setScheduler = (fn)=>{
        scheduleFn = fn;
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction,
        setScheduler: setScheduler
    };
}
var $da8c27e8b4a5d4b7$export$520687f44db6e1ab = $da8c27e8b4a5d4b7$export$316a8efd03cd1458();

});

parcelRegister("g9Hbg", function(module, exports) {

$parcel$export(module.exports, "canFetch", function () { return $0309040df792e6fe$export$61b92f63f30245cf; });
$parcel$export(module.exports, "isCancelledError", function () { return $0309040df792e6fe$export$986cc6445c1d323; });
$parcel$export(module.exports, "createRetryer", function () { return $0309040df792e6fe$export$2cbd00fe8a2c8d85; });


var $jqVGt = parcelRequire("jqVGt");

var $43Ycb = parcelRequire("43Ycb");

var $f9jQ6 = parcelRequire("f9jQ6");
function $0309040df792e6fe$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $0309040df792e6fe$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $43Ycb.onlineManager).isOnline() : true;
}
var $0309040df792e6fe$export$a8430ed4188f35a9 = class {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $0309040df792e6fe$export$986cc6445c1d323(value) {
    return value instanceof $0309040df792e6fe$export$a8430ed4188f35a9;
}
function $0309040df792e6fe$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $0309040df792e6fe$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $jqVGt.focusManager).isFocused() && (config.networkMode === "always" || (0, $43Ycb.onlineManager).isOnline()) && config.canRun();
    const canStart = ()=>$0309040df792e6fe$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $f9jQ6.isServer) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $0309040df792e6fe$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $f9jQ6.sleep)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return promise;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return promise;
        }
    };
}

});
parcelRegister("jqVGt", function(module, exports) {

$parcel$export(module.exports, "focusManager", function () { return $e25d30e157ac0b7d$export$6bf54661be5b02cf; });

var $jvuxX = parcelRequire("jvuxX");

var $hPqEP = parcelRequire("hPqEP");

var $f9jQ6 = parcelRequire("f9jQ6");
var $e25d30e157ac0b7d$var$_focused, $e25d30e157ac0b7d$var$_cleanup, $e25d30e157ac0b7d$var$_setup;
var $e25d30e157ac0b7d$export$86f1af424b2ca4de = class extends (0, $hPqEP.Subscribable) {
    constructor(){
        super();
        (0, $jvuxX.__privateAdd)(this, $e25d30e157ac0b7d$var$_focused, void 0);
        (0, $jvuxX.__privateAdd)(this, $e25d30e157ac0b7d$var$_cleanup, void 0);
        (0, $jvuxX.__privateAdd)(this, $e25d30e157ac0b7d$var$_setup, void 0);
        (0, $jvuxX.__privateSet)(this, $e25d30e157ac0b7d$var$_setup, (onFocus)=>{
            if (!(0, $f9jQ6.isServer) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $jvuxX.__privateGet)(this, $e25d30e157ac0b7d$var$_cleanup)) this.setEventListener((0, $jvuxX.__privateGet)(this, $e25d30e157ac0b7d$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $jvuxX.__privateGet)(this, $e25d30e157ac0b7d$var$_cleanup)) == null || _a.call(this);
            (0, $jvuxX.__privateSet)(this, $e25d30e157ac0b7d$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $jvuxX.__privateSet)(this, $e25d30e157ac0b7d$var$_setup, setup);
        (_a = (0, $jvuxX.__privateGet)(this, $e25d30e157ac0b7d$var$_cleanup)) == null || _a.call(this);
        (0, $jvuxX.__privateSet)(this, $e25d30e157ac0b7d$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $jvuxX.__privateGet)(this, $e25d30e157ac0b7d$var$_focused) !== focused;
        if (changed) {
            (0, $jvuxX.__privateSet)(this, $e25d30e157ac0b7d$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $jvuxX.__privateGet)(this, $e25d30e157ac0b7d$var$_focused) === "boolean") return (0, $jvuxX.__privateGet)(this, $e25d30e157ac0b7d$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$e25d30e157ac0b7d$var$_focused = new WeakMap();
$e25d30e157ac0b7d$var$_cleanup = new WeakMap();
$e25d30e157ac0b7d$var$_setup = new WeakMap();
var $e25d30e157ac0b7d$export$6bf54661be5b02cf = new $e25d30e157ac0b7d$export$86f1af424b2ca4de();

});
parcelRegister("hPqEP", function(module, exports) {

$parcel$export(module.exports, "Subscribable", function () { return $cfabe0bb73bdc253$export$d26086b469ecdbcc; });

// src/subscribable.ts
var $cfabe0bb73bdc253$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};

});


parcelRegister("43Ycb", function(module, exports) {

$parcel$export(module.exports, "onlineManager", function () { return $2f5622c970f6942f$export$b113e788b2dd3fdc; });

var $jvuxX = parcelRequire("jvuxX");

var $hPqEP = parcelRequire("hPqEP");

var $f9jQ6 = parcelRequire("f9jQ6");
var $2f5622c970f6942f$var$_online, $2f5622c970f6942f$var$_cleanup, $2f5622c970f6942f$var$_setup;
var $2f5622c970f6942f$export$58774fb55d5ff7fc = class extends (0, $hPqEP.Subscribable) {
    constructor(){
        super();
        (0, $jvuxX.__privateAdd)(this, $2f5622c970f6942f$var$_online, true);
        (0, $jvuxX.__privateAdd)(this, $2f5622c970f6942f$var$_cleanup, void 0);
        (0, $jvuxX.__privateAdd)(this, $2f5622c970f6942f$var$_setup, void 0);
        (0, $jvuxX.__privateSet)(this, $2f5622c970f6942f$var$_setup, (onOnline)=>{
            if (!(0, $f9jQ6.isServer) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $jvuxX.__privateGet)(this, $2f5622c970f6942f$var$_cleanup)) this.setEventListener((0, $jvuxX.__privateGet)(this, $2f5622c970f6942f$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $jvuxX.__privateGet)(this, $2f5622c970f6942f$var$_cleanup)) == null || _a.call(this);
            (0, $jvuxX.__privateSet)(this, $2f5622c970f6942f$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $jvuxX.__privateSet)(this, $2f5622c970f6942f$var$_setup, setup);
        (_a = (0, $jvuxX.__privateGet)(this, $2f5622c970f6942f$var$_cleanup)) == null || _a.call(this);
        (0, $jvuxX.__privateSet)(this, $2f5622c970f6942f$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $jvuxX.__privateGet)(this, $2f5622c970f6942f$var$_online) !== online;
        if (changed) {
            (0, $jvuxX.__privateSet)(this, $2f5622c970f6942f$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $jvuxX.__privateGet)(this, $2f5622c970f6942f$var$_online);
    }
};
$2f5622c970f6942f$var$_online = new WeakMap();
$2f5622c970f6942f$var$_cleanup = new WeakMap();
$2f5622c970f6942f$var$_setup = new WeakMap();
var $2f5622c970f6942f$export$b113e788b2dd3fdc = new $2f5622c970f6942f$export$58774fb55d5ff7fc();

});


parcelRegister("kyUYW", function(module, exports) {

$parcel$export(module.exports, "Removable", function () { return $ef832f0b323defd8$export$e09608847fcc8c59; });

var $jvuxX = parcelRequire("jvuxX");

var $f9jQ6 = parcelRequire("f9jQ6");
var $ef832f0b323defd8$var$_gcTimeout;
var $ef832f0b323defd8$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $jvuxX.__privateAdd)(this, $ef832f0b323defd8$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $f9jQ6.isValidTimeout)(this.gcTime)) (0, $jvuxX.__privateSet)(this, $ef832f0b323defd8$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $f9jQ6.isServer) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $jvuxX.__privateGet)(this, $ef832f0b323defd8$var$_gcTimeout)) {
            clearTimeout((0, $jvuxX.__privateGet)(this, $ef832f0b323defd8$var$_gcTimeout));
            (0, $jvuxX.__privateSet)(this, $ef832f0b323defd8$var$_gcTimeout, void 0);
        }
    }
};
$ef832f0b323defd8$var$_gcTimeout = new WeakMap();

});


parcelRegister("bfkpQ", function(module, exports) {

$parcel$export(module.exports, "infiniteQueryBehavior", function () { return $8300ee9afccf6bc7$export$84470d1367601e8d; });
$parcel$export(module.exports, "hasNextPage", function () { return $8300ee9afccf6bc7$export$b9c88add8b8b5e6a; });
$parcel$export(module.exports, "hasPreviousPage", function () { return $8300ee9afccf6bc7$export$db1663b730a8e6e4; });


var $f9jQ6 = parcelRequire("f9jQ6");
function $8300ee9afccf6bc7$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const fetchFn = async ()=>{
                var _a, _b, _c, _d, _e;
                const options = context.options;
                const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
                const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
                const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
                const empty = {
                    pages: [],
                    pageParams: []
                };
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $f9jQ6.ensureQueryFn)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $f9jQ6.addToStart) : (0, $f9jQ6.addToEnd);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                let result;
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $8300ee9afccf6bc7$var$getPreviousPageParam : $8300ee9afccf6bc7$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    result = await fetchPage(empty, oldPageParams[0] ?? options.initialPageParam);
                    const remainingPages = pages ?? oldPages.length;
                    for(let i = 1; i < remainingPages; i++){
                        const param = $8300ee9afccf6bc7$var$getNextPageParam(options, result);
                        result = await fetchPage(result, param);
                    }
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a, _b;
                return (_b = (_a = context.options).persister) == null ? void 0 : _b.call(_a, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $8300ee9afccf6bc7$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams);
}
function $8300ee9afccf6bc7$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams);
}
function $8300ee9afccf6bc7$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $8300ee9afccf6bc7$var$getNextPageParam(options, data) != null;
}
function $8300ee9afccf6bc7$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $8300ee9afccf6bc7$var$getPreviousPageParam(options, data) != null;
}

});

parcelRegister("kTmOQ", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", function () { return $f35aa511d5975752$export$22e77b9572c4fded; });
$parcel$export(module.exports, "QueryClientProvider", function () { return $f35aa511d5975752$export$45604f0cc8ae667b; });

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");
"use client";
var $f35aa511d5975752$export$da112d31b0149f31 = $bh6RR.createContext(void 0);
var $f35aa511d5975752$export$22e77b9572c4fded = (queryClient)=>{
    const client = $bh6RR.useContext($f35aa511d5975752$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $f35aa511d5975752$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $bh6RR.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $ih19M.jsx)($f35aa511d5975752$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};

});

parcelRegister("ejD0p", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});

});

parcelRegister("6s8rf", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});

});


var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";

var $6afFj = parcelRequire("6afFj");
var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $6afFj.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $6afFj.hydrateRoot;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1LCZd = parcelRequire("1LCZd");

var $bh6RR = parcelRequire("bh6RR");
const $3cac67d7df2ee1ae$export$430714d8a6ce587f = (loader)=>new Proxy({}, {
        get: (target, componentName)=>{
            if (typeof componentName === "string") return (0, $bh6RR.lazy)(()=>loader(componentName).then((x)=>({
                        default: x[componentName]
                    })));
        }
    });



var $hUmGa = parcelRequire("hUmGa");

var $1LCZd = parcelRequire("1LCZd");

var $5aMF5 = parcelRequire("5aMF5");

var $iOlMk = parcelRequire("iOlMk");

var $3M0M5 = parcelRequire("3M0M5");

var $5fdtD = parcelRequire("5fdtD");

var $i6z7r = parcelRequire("i6z7r");

var $c00UK = parcelRequire("c00UK");

var $dyAGA = parcelRequire("dyAGA");

var $igCUb = parcelRequire("igCUb");

var $a2asV = parcelRequire("a2asV");

var $9Toj9 = parcelRequire("9Toj9");

var $lVvdy = parcelRequire("lVvdy");

var $bh6RR = parcelRequire("bh6RR");

var $iRxIj = parcelRequire("iRxIj");

var $iOlMk = parcelRequire("iOlMk");

var $cxTnx = parcelRequire("cxTnx");

var $jo8NH = parcelRequire("jo8NH");

var $9DKAX = parcelRequire("9DKAX");

var $9Toj9 = parcelRequire("9Toj9");

var $dyAGA = parcelRequire("dyAGA");
const $27efaa6f26635f92$var$date = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))().utc().format((0, $jo8NH.SERVER_DATE_FORMAT));
const $27efaa6f26635f92$var$time = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))().utc().format((0, $jo8NH.SERVER_TIME_FORMAT));
// https://stackoverflow.com/a/48845206
function $27efaa6f26635f92$var$cleanStringify(object) {
    if (object && typeof object === "object") object = copyWithoutCircularReferences([
        object
    ], object);
    return JSON.stringify(object);
    function copyWithoutCircularReferences(references, object) {
        let cleanObject = {};
        if (object.constructor && object.constructor.name !== "Object" && object.constructor.name !== "Array") return {
            info: `Instance of ${object.constructor.name}`
        };
        Object.keys(object).forEach(function(key) {
            let value = object[key];
            if (value && typeof value === "object") {
                if (references.indexOf(value) < 0) {
                    references.push(value);
                    cleanObject[key] = copyWithoutCircularReferences(references, value);
                    references.pop();
                } else cleanObject[key] = "###_Circular_###";
            } else if (typeof value !== "function") cleanObject[key] = value;
        });
        return cleanObject;
    }
}
const $27efaa6f26635f92$var$getBlobJSONFile = (data, name, ...additionalData)=>{
    const fileFormData = new FormData();
    const blobFile = new Blob([
        $27efaa6f26635f92$var$cleanStringify({
            log: data,
            ...additionalData
        })
    ], {
        type: "application/json;charset=utf-8"
    });
    fileFormData.append("name", name);
    fileFormData.append("file", blobFile, name);
    return fileFormData;
};
/** - html2canvas(document.body) - создание слепка дом-дерева
 * - .then(canvas) - сформированное изображение canvas
 * - canvas.toBlob - конвертация в blob-формат */ const $27efaa6f26635f92$var$getBlobCanvasScreenshotFile = async ()=>{
    const imageFormData = new FormData();
    const image = await new Promise((resolve)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($9DKAX)))(document.body).then((canvas)=>canvas.toBlob(resolve, "image/png"));
    });
    imageFormData.append("name", `screenshot.png`);
    imageFormData.append("file", image, `screenshot.png`);
    return imageFormData;
};
const $27efaa6f26635f92$export$eb5d562072b91edf = ()=>{
    const ENABLE_ACTIONS_LOGGING_TOOL = (0, $9Toj9.useApplicationFeatureEnabled)((0, $9Toj9.FEATURE).ENABLE_ACTIONS_LOGGING_TOOL && true);
    const [widgetSupport, setWidgetSupport] = (0, $bh6RR.useState)(null);
    const [bodyObserver, setBodyObserver] = (0, $bh6RR.useState)(null);
    const user = (0, $iRxIj.useStore)((0, $iOlMk.currentUser));
    const info = {
        userId: (user === null || user === void 0 ? void 0 : user.id) || "not authorized",
        datetime: `${$27efaa6f26635f92$var$date}, ${$27efaa6f26635f92$var$time} - utc`,
        url: location.href
    };
    setTimeout(()=>setWidgetSupport(document.getElementById("KitWidgetContainer")), 100);
    (0, $bh6RR.useMemo)(()=>{
        if (!ENABLE_ACTIONS_LOGGING_TOOL) return;
        if (console.everything === undefined || window._loggingRequests === undefined) {
            /** defaultLog | defaultError - для того, чтобы не нарушить работу стандартных функций консоли */ const getDateTime = ()=>`${(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))().utc().format((0, $jo8NH.READABLE_DATE_TIME_FORMAT))} UTC`;
            console.everything = [];
            window._loggingRequests = [];
            console.defaultLog = console.log.bind(console);
            console.log = function() {
                console.everything.push({
                    type: "LOG",
                    datetime: getDateTime(),
                    value: Array.from(arguments)
                });
                console.defaultLog(...arguments);
            };
            console.defaultInfo = console.info.bind(console);
            console.info = function() {
                console.everything.push({
                    type: "INFO",
                    datetime: getDateTime(),
                    value: Array.from(arguments)
                });
                console.defaultInfo(...arguments);
            };
            console.defaultError = console.error.bind(console);
            console.error = function() {
                console.everything.push({
                    type: "ERROR",
                    datetime: getDateTime(),
                    value: Array.from(arguments)
                });
                console.defaultError(...arguments);
            };
            window.loggingRequest = function() {
                const { url: url, status: status, params: params, body: body } = arguments[0];
                window._loggingRequests.push({
                    type: "REST API",
                    datetime: getDateTime(),
                    value: {
                        url: url,
                        status: status,
                        params: params,
                        body: body
                    }
                });
            };
        }
    }, [
        ENABLE_ACTIONS_LOGGING_TOOL
    ]);
    /** Наблюдатель для изменения класса виджета (is-closed | is-open) */ const observer = (0, $bh6RR.useMemo)(()=>{
        if (!ENABLE_ACTIONS_LOGGING_TOOL) return null;
        return new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                if (mutation.attributeName === "class") {
                    if (mutation.target.classList.contains("is-open")) setBodyObserver(mutation.target.getElementsByClassName("kit-widget-messages")[0]);
                    else setBodyObserver(null);
                }
            });
        });
    }, [
        ENABLE_ACTIONS_LOGGING_TOOL
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!ENABLE_ACTIONS_LOGGING_TOOL || !widgetSupport || !observer) return;
        /** Наблюдаем за элементом widgetSupport */ observer.observe(widgetSupport, {
            attributes: true
        });
    }, [
        widgetSupport,
        observer,
        ENABLE_ACTIONS_LOGGING_TOOL
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!ENABLE_ACTIONS_LOGGING_TOOL || !bodyObserver) return;
        /** Слушатель за нажатием на кнопку widgetSupport - "Оператор" */ const handleOnClick = async (event)=>{
            if (event.target.innerText !== "\u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440" || event.target.nodeName !== "BUTTON") return;
            const screenshotBlobFile = await $27efaa6f26635f92$var$getBlobCanvasScreenshotFile();
            const consoleBlobFile = $27efaa6f26635f92$var$getBlobJSONFile(console.everything, "console.json", info);
            const requestBlobFile = $27efaa6f26635f92$var$getBlobJSONFile(window._loggingRequests, "requests.json", info);
            const response = await (0, $dyAGA.default).postCreateTicket({
                status: "created",
                priority: "medium",
                author: (user === null || user === void 0 ? void 0 : user.id) || "",
                description: "vox-support",
                title: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F",
                area: "asya",
                new_files: [
                    consoleBlobFile,
                    requestBlobFile,
                    screenshotBlobFile
                ]
            });
            const input = widgetSupport.getElementsByClassName("kit-widget-chat-input")[0].querySelector("p");
            const button = widgetSupport.getElementsByClassName("kit-widget-chat-input__send-btn")[0];
            if (!response || !input || !button) return;
            input.textContent = `\u{41C}\u{43E}\u{435} \u{43E}\u{431}\u{440}\u{430}\u{449}\u{435}\u{43D}\u{438}\u{435} \u{432} \u{442}\u{435}\u{445}\u{43D}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{443}\u{44E} \u{43F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{443} \u{43F}\u{43E}\u{434} \u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{43E}\u{43C} ${response.id}.`;
            setTimeout(()=>button.click());
        };
        bodyObserver.addEventListener("click", handleOnClick);
        return ()=>bodyObserver.removeEventListener("click", handleOnClick);
    }, [
        bodyObserver,
        ENABLE_ACTIONS_LOGGING_TOOL
    ]);
};



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lNW6o = parcelRequire("lNW6o");

var $iRxIj = parcelRequire("iRxIj");

var $32dsx = parcelRequire("32dsx");

var $5oGqh = parcelRequire("5oGqh");

var $iOlMk = parcelRequire("iOlMk");

var $7xUPZ = parcelRequire("7xUPZ");

var $cVtTV = parcelRequire("cVtTV");

var $kmHuZ = parcelRequire("kmHuZ");
const $ed30f978738c5821$export$82ebed91b52c089b = ()=>{
    const token = (0, $iRxIj.useStore)((0, $iOlMk.tokenStore));
    const showedRemindersOnMount = (0, $bh6RR.useRef)();
    const webSocket = (0, $bh6RR.useRef)();
    const { showToast: showToast, closeToast: closeToast } = (0, $5oGqh.useToast)();
    const [{ value: reminders }, fetchReminders] = (0, $lNW6o.default)(()=>(0, $kmHuZ.default).notifications.getPatientReminders(), [
        token
    ]);
    const handleReminderClick = (0, $bh6RR.useCallback)((id)=>{
        (0, $kmHuZ.default).notifications.setPatientReminderRead(id);
    }, [
        token
    ]);
    const showReminder = (0, $bh6RR.useCallback)((id, name, text, appointmentId, animation)=>{
        return showToast(/*#__PURE__*/ (0, $ih19M.jsxs)((0, $7xUPZ.Toast), {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $7xUPZ.ToastTitle), {
                    children: [
                        "\u041D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u0435 - ",
                        name
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $7xUPZ.ToastText), {
                    children: text
                })
            ]
        }), {
            container: {
                component: (0, $7xUPZ.ToastBody),
                props: {
                    to: `/appointment/${appointmentId}`,
                    as: (0, $32dsx.Link)
                }
            },
            onClick: (toast)=>{
                closeToast(toast.id);
                handleReminderClick(id);
            },
            onClose: ()=>handleReminderClick(id),
            duration: 1000000,
            animation: animation
        });
    }, [
        showToast,
        handleReminderClick,
        closeToast
    ]);
    const initSocket = ()=>{
        if (webSocket.current && webSocket.current instanceof WebSocket) webSocket.current.close();
        webSocket.current = new WebSocket((0, $kmHuZ.default).notifications.getPatientRemindersUrl(token));
        webSocket.current.onclose = (0, $cVtTV.socketErrorHandler)(webSocket.current, initSocket);
        webSocket.current.onmessage = (event)=>{
            const parsedData = event && event.data && typeof event.data === "string" ? JSON.parse(event.data) : {};
            if (!(parsedData !== null && parsedData !== void 0 && parsedData.data)) return;
            showReminder(parsedData.data.id, parsedData.data.patient_name, parsedData.data.text, parsedData.data.appointment_id);
        };
    };
    (0, $bh6RR.useEffect)(()=>{
        if (reminders && !showedRemindersOnMount.current) {
            showedRemindersOnMount.current = true;
            for (const item of reminders)showReminder(item.id, item.patient_name, item.text, item.appointment, (visible)=>visible ? "toast-anim-fade-in 0.3s ease-in-out forwards" : "toast-anim-out 0.8s ease-in-out forwards");
        }
    }, [
        reminders,
        showToast,
        showReminder
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (token) {
            fetchReminders();
            initSocket();
        }
    }, [
        token
    ]);
};



var $aphpl = parcelRequire("aphpl");

var $lXS21 = parcelRequire("lXS21");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $kmHuZ = parcelRequire("kmHuZ");
const $b28bfe2ed59d7759$export$e8e84ccd09fbede1 = ({ id: id })=>{
    (0, $bh6RR.useEffect)(()=>{
        (async ()=>{
            const response = await (0, $kmHuZ.default).payment.getPayment(id);
            const script = document.createElement("script");
            script.onload = ()=>{
                const params = new URLSearchParams(location.search);
                //Инициализация виджета. Все параметры обязательные.
                const checkout = new window.YooMoneyCheckoutWidget({
                    customer: {
                        email: params.get("email") || ""
                    },
                    confirmation_token: response.payment_token,
                    //Токен, который перед проведением оплаты нужно получить от ЮKassa
                    return_url: location.origin + "/finish-payment",
                    //Ссылка на страницу завершения оплаты
                    error_callback: function(error) {
                        console.error(error);
                        alert(JSON.stringify(error));
                    }
                });
                //Отображение платежной формы в контейнере
                checkout.render("payment-form")//Метод возвращает Promise, исполнение которого говорит о полной загрузке платежной формы (можно не использовать).
                .then(()=>{
                //Код, который нужно выполнить после отображения платежной формы.
                });
            };
            script.src = "https://yookassa.ru/checkout-widget/v1/checkout-widget.js";
            document.body.appendChild(script);
        })();
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        id: "payment-form"
    });
};



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lVvdy = parcelRequire("lVvdy");
const $f621d71f2bfbea12$export$3b628956c133cac7 = ()=>{
    (0, $bh6RR.useEffect)(()=>{
        const params = new URLSearchParams(location.search);
        const clientId = params.get("clientId");
        const name = params.get("name");
        (0, $lVvdy.setVoximplantSupportData)({
            client_id: clientId,
            client_display_name: name
        });
        if (window.VoxKitWidget) (0, $lVvdy.reInitVoximplant)();
        if (!document.getElementsByClassName("kit-widget-container is-open").length) document.getElementsByClassName("widget-btn")[0].click();
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {});
};



var $1lysy = parcelRequire("1lysy");

var $cYFxl = parcelRequire("cYFxl");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $92681901d5600f43$var$__assign = function() {
    $92681901d5600f43$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $92681901d5600f43$var$__assign.apply(this, arguments);
};
function $92681901d5600f43$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $92681901d5600f43$var$__read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
typeof SuppressedError === "function" && SuppressedError;
/**
 * Load script on src and run function on script load
 */ function $92681901d5600f43$var$loadScript(src, onload, onerror, onJavascriptError, immediate) {
    if (onload === void 0) onload = null;
    if (onerror === void 0) onerror = null;
    if (immediate === void 0) immediate = true;
    var script = document.createElement("script");
    script.src = src;
    script.onload = onload;
    script.onerror = onerror;
    script.type = "text/javascript";
    script.crossOrigin = "anonymous";
    if (typeof window !== "undefined") window.addEventListener("error", function handleJavascriptError(e) {
        if (e.filename.indexOf(src) === 0 && onJavascriptError) onJavascriptError({
            filename: e.filename,
            message: e.message,
            col: e.colno,
            line: e.lineno
        });
    });
    var addScript = function() {
        return document.body.appendChild(script);
    };
    if (immediate) addScript();
    else window.addEventListener("load", addScript);
}
/**
 * RegExps.
 * A URL must match #1 and then at least one of #2/#3.
 * Use two levels of REs to avoid REDOS.
 */ var $92681901d5600f43$var$domainRE = /^(\S+)$/;
var $92681901d5600f43$var$localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
var $92681901d5600f43$var$nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;
var $92681901d5600f43$var$IPv4RE = /^(https?:\/\/)?([0-9]{1,3}\.){3}[0-9]{1,3}\:\d+$/;
var $92681901d5600f43$var$IPv6RE = /^(https?:\/\/)?\[([0-9a-fA-F]{0,4}\:){7}([0-9a-fA-F]){0,4}\]\:\d+$/;
function $92681901d5600f43$var$isValidHost(str) {
    if (typeof str !== "string") return false;
    var match = str.match($92681901d5600f43$var$domainRE);
    if (!match) return false;
    var everythingAfterProtocol = match[0];
    if (!everythingAfterProtocol) return false;
    if ($92681901d5600f43$var$localhostDomainRE.test(everythingAfterProtocol) || $92681901d5600f43$var$nonLocalhostDomainRE.test(everythingAfterProtocol) || $92681901d5600f43$var$IPv4RE.test(everythingAfterProtocol) || $92681901d5600f43$var$IPv6RE.test(everythingAfterProtocol)) return true;
    return false;
}
var $92681901d5600f43$var$API_LINK = function(host) {
    if (host === void 0) host = "smartcaptcha.yandexcloud.net";
    var base = /^https?/.test(host) ? host : "https://".concat(host);
    return "".concat(base, "/captcha.js?render=onload&onload=__onSmartCaptchaReady");
};
/**
 * @internal
 */ var $92681901d5600f43$export$b89c5c1b934d8237 = [];
var $92681901d5600f43$var$startLoading = new Map();
function $92681901d5600f43$export$6725508ee79d6883(host, onJavascriptError) {
    var _a = $92681901d5600f43$var$__read((0, $bh6RR.useState)(), 2), smartCaptcha = _a[0], setSmartCaptcha = _a[1];
    (0, $bh6RR.useEffect)(function() {
        if (host !== undefined && !$92681901d5600f43$var$isValidHost(host)) throw new Error("[SmartCaptcha] ".concat(host, " host is invalid. It should be of a kind: domain.ru, localhost:3000"));
        if (smartCaptcha !== undefined || host !== undefined && !$92681901d5600f43$var$isValidHost(host)) return;
        if (window.__onSmartCaptchaReady === undefined) window.__onSmartCaptchaReady = function() {
            $92681901d5600f43$export$b89c5c1b934d8237.forEach(function(callback) {
                return callback();
            });
        };
        if (window.smartCaptcha) setSmartCaptcha(window.smartCaptcha);
        var index = $92681901d5600f43$export$b89c5c1b934d8237.push(function() {
            return setSmartCaptcha(window.smartCaptcha);
        });
        var handleError = function() {
            onJavascriptError === null || onJavascriptError === void 0 || onJavascriptError({
                filename: $92681901d5600f43$var$API_LINK(host),
                message: "Unknown error on script loading",
                col: 0,
                line: 0
            });
        };
        if (!$92681901d5600f43$var$startLoading.get(host)) {
            $92681901d5600f43$var$loadScript($92681901d5600f43$var$API_LINK(host), null, handleError, onJavascriptError);
            $92681901d5600f43$var$startLoading.set(host, true);
        }
        return function() {
            $92681901d5600f43$export$b89c5c1b934d8237.splice(index, 1);
        };
    }, [
        host,
        onJavascriptError,
        smartCaptcha
    ]);
    return smartCaptcha;
}
function $92681901d5600f43$var$useSubscriptions(props) {
    var propsRef = (0, $bh6RR.useRef)({});
    var widgetId = props.widgetId, smartCaptcha = props.smartCaptcha, onChallengeHidden = props.onChallengeHidden, onChallengeVisible = props.onChallengeVisible, onSuccess = props.onSuccess, onNetworkError = props.onNetworkError, onTokenExpired = props.onTokenExpired, onJavascriptError = props.onJavascriptError;
    propsRef.current = {
        onChallengeHidden: onChallengeHidden,
        onChallengeVisible: onChallengeVisible,
        onSuccess: onSuccess,
        onNetworkError: onNetworkError,
        onTokenExpired: onTokenExpired,
        onJavascriptError: onJavascriptError
    };
    (0, $bh6RR.useEffect)(function() {
        if (!smartCaptcha || typeof widgetId !== "number") return;
        var unsubscribeFns = [
            smartCaptcha.subscribe(widgetId, "challenge-visible", function() {
                var _a, _b;
                (_b = (_a = propsRef.current).onChallengeVisible) === null || _b === void 0 || _b.call(_a);
            }),
            smartCaptcha.subscribe(widgetId, "challenge-hidden", function() {
                var _a, _b;
                (_b = (_a = propsRef.current).onChallengeHidden) === null || _b === void 0 || _b.call(_a);
            }),
            smartCaptcha.subscribe(widgetId, "network-error", function() {
                var _a, _b;
                (_b = (_a = propsRef.current).onNetworkError) === null || _b === void 0 || _b.call(_a);
            }),
            smartCaptcha.subscribe(widgetId, "success", function(token) {
                var _a, _b;
                (_b = (_a = propsRef.current).onSuccess) === null || _b === void 0 || _b.call(_a, token);
            }),
            smartCaptcha.subscribe(widgetId, "token-expired", function() {
                var _a, _b;
                (_b = (_a = propsRef.current).onTokenExpired) === null || _b === void 0 || _b.call(_a);
            }),
            smartCaptcha.subscribe(widgetId, "javascript-error", function(error) {
                var _a, _b;
                (_b = (_a = propsRef.current).onJavascriptError) === null || _b === void 0 || _b.call(_a, error);
            })
        ];
        return function() {
            return unsubscribeFns.forEach(function(fn) {
                return fn === null || fn === void 0 ? void 0 : fn();
            });
        };
    }, [
        widgetId,
        smartCaptcha
    ]);
}
var $92681901d5600f43$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);
var $92681901d5600f43$var$style = {
    height: 102
};
var $92681901d5600f43$export$6d9c139ddeac5f02 = function(props) {
    var containerRef = (0, $bh6RR.useRef)(null);
    var onChallengeHidden = props.onChallengeHidden, onChallengeVisible = props.onChallengeVisible, onSuccess = props.onSuccess, onNetworkError = props.onNetworkError, onTokenExpired = props.onTokenExpired, onJavascriptError = props.onJavascriptError, language = props.language, host = props.host, theme = props.theme, restProps = $92681901d5600f43$var$__rest(props, [
        "onChallengeHidden",
        "onChallengeVisible",
        "onSuccess",
        "onNetworkError",
        "onTokenExpired",
        "onJavascriptError",
        "language",
        "host",
        "theme"
    ]);
    var smartCaptcha = $92681901d5600f43$export$6725508ee79d6883(host, onJavascriptError);
    var _a = $92681901d5600f43$var$__read((0, $bh6RR.useState)(), 2), widgetId = _a[0], setWidgetId = _a[1];
    var destroyedRef = (0, $bh6RR.useRef)({});
    $92681901d5600f43$var$useSubscriptions({
        widgetId: widgetId,
        smartCaptcha: smartCaptcha,
        onChallengeHidden: onChallengeHidden,
        onChallengeVisible: onChallengeVisible,
        onSuccess: onSuccess,
        onNetworkError: onNetworkError,
        onTokenExpired: onTokenExpired,
        onJavascriptError: onJavascriptError
    });
    $92681901d5600f43$var$useIsomorphicLayoutEffect(function() {
        if (!containerRef.current || !smartCaptcha) return;
        var id = smartCaptcha.render(containerRef.current, $92681901d5600f43$var$__assign($92681901d5600f43$var$__assign({}, restProps), {
            hl: language,
            theme: theme
        }));
        setWidgetId(id);
        return function() {
            smartCaptcha.destroy(id);
            setWidgetId(undefined);
            // eslint-disable-next-line react-hooks/exhaustive-deps
            destroyedRef.current[id] = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        smartCaptcha,
        language,
        restProps.sitekey,
        restProps.test,
        restProps.webview
    ]);
    (0, $bh6RR.useEffect)(function() {
        if (!widgetId || !theme) return;
        window.smartCaptcha.setTheme(widgetId, theme);
    }, [
        theme,
        widgetId
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ref: containerRef,
        className: "smart-captcha",
        style: $92681901d5600f43$var$style
    });
};
var $92681901d5600f43$export$a10ea59a0e7fb2f2 = function(props) {
    var containerRef = (0, $bh6RR.useRef)(null);
    var onChallengeHidden = props.onChallengeHidden, onChallengeVisible = props.onChallengeVisible, onSuccess = props.onSuccess, onNetworkError = props.onNetworkError, onTokenExpired = props.onTokenExpired, onJavascriptError = props.onJavascriptError, language = props.language, host = props.host, theme = props.theme, restProps = $92681901d5600f43$var$__rest(props, [
        "onChallengeHidden",
        "onChallengeVisible",
        "onSuccess",
        "onNetworkError",
        "onTokenExpired",
        "onJavascriptError",
        "language",
        "host",
        "theme"
    ]);
    var smartCaptcha = $92681901d5600f43$export$6725508ee79d6883(host, onJavascriptError);
    var _a = $92681901d5600f43$var$__read((0, $bh6RR.useState)(), 2), widgetId = _a[0], setWidgetId = _a[1];
    var destroyedRef = (0, $bh6RR.useRef)({});
    $92681901d5600f43$var$useSubscriptions({
        widgetId: widgetId,
        smartCaptcha: smartCaptcha,
        onChallengeHidden: onChallengeHidden,
        onChallengeVisible: onChallengeVisible,
        onSuccess: onSuccess,
        onNetworkError: onNetworkError,
        onTokenExpired: onTokenExpired,
        onJavascriptError: onJavascriptError
    });
    $92681901d5600f43$var$useIsomorphicLayoutEffect(function() {
        if (!containerRef.current || !smartCaptcha) return;
        var id = smartCaptcha.render(containerRef.current, $92681901d5600f43$var$__assign($92681901d5600f43$var$__assign({}, restProps), {
            invisible: true,
            hl: language,
            theme: theme
        }));
        setWidgetId(id);
        return function() {
            smartCaptcha === null || smartCaptcha === void 0 || smartCaptcha.destroy(id);
            setWidgetId(undefined);
            // eslint-disable-next-line react-hooks/exhaustive-deps
            destroyedRef.current[id] = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        smartCaptcha,
        language,
        restProps.hideShield,
        restProps.shieldPosition,
        restProps.sitekey,
        restProps.test,
        restProps.webview
    ]);
    (0, $bh6RR.useEffect)(function() {
        if (smartCaptcha && restProps.visible && typeof widgetId === "number" && !destroyedRef.current[widgetId]) smartCaptcha.execute(widgetId);
    }, [
        smartCaptcha,
        restProps.visible,
        widgetId
    ]);
    (0, $bh6RR.useEffect)(function() {
        if (!widgetId || !theme) return;
        // TODO: Удалить, когда выкатится внешка с поддержкой тем
        if (!window.smartCaptcha.setTheme) return;
        window.smartCaptcha.setTheme(widgetId, theme);
    }, [
        theme,
        widgetId
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ref: containerRef,
        className: "smart-captcha"
    });
};



var $jCoLF = parcelRequire("jCoLF");
const $6b642381b8bbdb3a$var$CaptchaContainer = (0, $jCoLF.default).div.withConfig({
    displayName: "YandexCaptchaWebView__CaptchaContainer",
    componentId: "sc-r76q6l-0"
})([
    "position:relative;height:100vh;width:100vw;display:flex;justify-content:center;align-items:center;background-color:#f4f4f4;"
]);
const $6b642381b8bbdb3a$var$CaptchaBox = (0, $jCoLF.default).div.withConfig({
    displayName: "YandexCaptchaWebView__CaptchaBox",
    componentId: "sc-r76q6l-1"
})([
    "width:90%;max-width:320px;padding:24px;background-color:white;border-radius:16px;"
]);
const $6b642381b8bbdb3a$var$IconButton = (0, $jCoLF.default).div.withConfig({
    displayName: "YandexCaptchaWebView__IconButton",
    componentId: "sc-r76q6l-2"
})([
    "position:absolute;top:10px;left:15px;border-radius:50%;width:30px;height:30px;display:flex;align-items:center;justify-content:center;"
]);
const $6b642381b8bbdb3a$var$BackIconButton = ({ handleClick: handleClick })=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)($6b642381b8bbdb3a$var$IconButton, {
        onClick: handleClick,
        id: "back-button",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M8.75 5C8.75 7.71744 7.64916 10.2288 5.89258 11.75H22V13.25H5.89258C7.64916 14.7712 8.75 17.2826 8.75 20H7.25C7.25 16.1061 4.75286 13.25 2 13.25V11.75L2.25684 11.7412C4.90623 11.5703 7.25 8.77236 7.25 5H8.75Z",
                fill: "#212223"
            })
        })
    });
};
const $6b642381b8bbdb3a$var$EVENT_TYPES = {
    LOADED: "captchaLoaded",
    CLOSE: "captchaClose",
    SUCCESS: "captchaSuccess",
    CHALLENGE_VISIBLE: "captchaChallengeVisible"
};
const $6b642381b8bbdb3a$var$postToWebView = (data)=>{
    var _window$ReactNativeWe;
    (_window$ReactNativeWe = window.ReactNativeWebView) === null || _window$ReactNativeWe === void 0 || _window$ReactNativeWe.postMessage(JSON.stringify(data));
};
const $6b642381b8bbdb3a$export$a6bdaedb4860c4b0 = ()=>{
    const [resetCaptcha, setResetCaptcha] = (0, $bh6RR.useState)(0);
    (0, $bh6RR.useEffect)(()=>{
        $6b642381b8bbdb3a$var$postToWebView({
            type: $6b642381b8bbdb3a$var$EVENT_TYPES.LOADED
        });
    }, []);
    const handleSuccess = (captchaToken)=>{
        $6b642381b8bbdb3a$var$postToWebView({
            type: $6b642381b8bbdb3a$var$EVENT_TYPES.SUCCESS,
            token: captchaToken
        });
    };
    const handleChallengeVisible = ()=>{
        $6b642381b8bbdb3a$var$postToWebView({
            type: $6b642381b8bbdb3a$var$EVENT_TYPES.CHALLENGE_VISIBLE,
            value: true
        });
    };
    const handleChallengeHidden = ()=>{
        $6b642381b8bbdb3a$var$postToWebView({
            type: $6b642381b8bbdb3a$var$EVENT_TYPES.CHALLENGE_VISIBLE,
            value: false
        });
    };
    const handleCloseCaptcha = ()=>{
        $6b642381b8bbdb3a$var$postToWebView({
            type: $6b642381b8bbdb3a$var$EVENT_TYPES.CLOSE
        });
    };
    const handleTokenExpired = ()=>{
        setResetCaptcha((prev)=>prev + 1);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)($6b642381b8bbdb3a$var$CaptchaContainer, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($6b642381b8bbdb3a$var$BackIconButton, {
                handleClick: handleCloseCaptcha
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)($6b642381b8bbdb3a$var$CaptchaBox, {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $92681901d5600f43$export$6d9c139ddeac5f02), {
                    sitekey: "ysc1_lEYLoLW5qP08Jreg0ZY3JGMjFAafeZJqp5BJKlgre3a94e54",
                    webview: true,
                    onSuccess: handleSuccess,
                    onChallengeVisible: handleChallengeVisible,
                    onChallengeHidden: handleChallengeHidden,
                    onTokenExpired: handleTokenExpired
                }, resetCaptcha)
            })
        ]
    });
};


// Компонент для обработки ошибок при ленивой загрузке
class $aa831a3b70830250$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u0432 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0435:", error, errorInfo);
    // Можно добавить отправку ошибки в Sentry
    }
    render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            style: {
                padding: "30px",
                textAlign: "center",
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                maxWidth: "500px",
                width: "90%",
                backgroundColor: "white",
                borderRadius: "10px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                fontFamily: "Graphik, Arial, sans-serif",
                zIndex: 1000
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    style: {
                        width: "70px",
                        height: "70px",
                        margin: "0 auto 20px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(198, 0, 127, 0.1)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        style: {
                            fontSize: "40px",
                            color: "rgb(198, 0, 127)",
                            fontWeight: "bold"
                        },
                        children: "!"
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                    style: {
                        color: "#333",
                        fontSize: "24px",
                        fontWeight: "600",
                        marginBottom: "15px"
                    },
                    children: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    style: {
                        color: "#666",
                        fontSize: "16px",
                        lineHeight: "1.5",
                        marginBottom: "25px"
                    },
                    children: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438\u043B\u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435."
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                    onClick: ()=>window.location.reload(),
                    style: {
                        padding: "12px 24px",
                        backgroundColor: "rgb(198, 0, 127)",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontSize: "16px",
                        fontWeight: "500",
                        transition: "background-color 0.2s ease"
                    },
                    onMouseOver: (e)=>e.currentTarget.style.backgroundColor = "rgba(198, 0, 127, 0.85)",
                    onMouseOut: (e)=>e.currentTarget.style.backgroundColor = "rgb(198, 0, 127)",
                    children: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443"
                })
            ]
        });
        return this.props.children;
    }
}
// Компонент загрузки
const $aa831a3b70830250$var$LoadingFallback = ()=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $cYFxl.AbsoluteLoader), {});

const { MaintenancePage: $aa831a3b70830250$var$MaintenancePage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("fqYVq")));

const { Toaster: $aa831a3b70830250$var$Toaster } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>Promise.resolve((parcelRequire("1WnR3"))));

const { ConnectionErrorModal: $aa831a3b70830250$var$ConnectionErrorModal } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("2ldow")));

const { VoximplantSupport: $aa831a3b70830250$var$VoximplantSupport } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("1D5oj")));

const { VoxInformationPatient: $aa831a3b70830250$var$VoxInformationPatient } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("kcu6a")));

const { VoximplantSupportWebView: $aa831a3b70830250$var$VoximplantSupportWebView } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("bqffk")));

const { ReviewPage: $aa831a3b70830250$var$ReviewPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("1ywk2")));

const { ReviewStepTwo: $aa831a3b70830250$var$ReviewStepTwo } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("7Tisi")));

const { ReviewStepThree: $aa831a3b70830250$var$ReviewStepThree } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("a6ltr")));

const { ReviewStepThreeNegative: $aa831a3b70830250$var$ReviewStepThreeNegative } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("8rFvZ")));

const { ReviewStepFour: $aa831a3b70830250$var$ReviewStepFour } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("cB523")));

const { ReviewStepFourNegative: $aa831a3b70830250$var$ReviewStepFourNegative } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("6VNNt")));

const { ReviewStepFiveNegative: $aa831a3b70830250$var$ReviewStepFiveNegative } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("iVD2I")));

const { ReviewStepSixWithCall: $aa831a3b70830250$var$ReviewStepSixWithCall } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("4usJy")));

const { ReviewStepSixNotCall: $aa831a3b70830250$var$ReviewStepSixNotCall } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("243qA")));

const { ReviewAlready: $aa831a3b70830250$var$ReviewAlready } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("gZPvm")));

const { MediaPermissionLockModal: $aa831a3b70830250$var$MediaPermissionLockModal } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("hMdtq")));

const { MediaPermissionSelectModal: $aa831a3b70830250$var$MediaPermissionSelectModal } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("5basR")));

const { MediaPermissionNotDeviceModal: $aa831a3b70830250$var$MediaPermissionNotDeviceModal } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("acapg")));

const { VoximplantConnectionErrorModal: $aa831a3b70830250$var$VoximplantConnectionErrorModal } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("7OoNX")));

const { LoginPage: $aa831a3b70830250$var$LoginPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("78onZ")));

const { VideoCall: $aa831a3b70830250$var$VideoCall } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("7xHWt")));

const { TicketPage: $aa831a3b70830250$var$TicketPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("jKmnK")));

const { TicketCreatePage: $aa831a3b70830250$var$TicketCreatePage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("7zLLx")));

const { TicketEditPage: $aa831a3b70830250$var$TicketEditPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("eSX54")));

const { SurveyPage: $aa831a3b70830250$var$SurveyPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("fJVhM")));

const { CorporatePortal: $aa831a3b70830250$var$CorporatePortal } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("i6jaZ")));

const { ProfilePageTelemed: $aa831a3b70830250$var$ProfilePageTelemed } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("9TwGF")));

const { CheckupsPage: $aa831a3b70830250$var$CheckupsPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("74y3f")));

const { CheckupsPageThanks: $aa831a3b70830250$var$CheckupsPageThanks } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("l5jC2")));

const { CheckupsPageAppointments: $aa831a3b70830250$var$CheckupsPageAppointments } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("cDChm")));

const { AnalyticsPage: $aa831a3b70830250$var$AnalyticsPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("2kzbi")));

const { CommercialPage: $aa831a3b70830250$var$CommercialPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("eQTwM")));

const { ReviewStatisticsCreatePage: $aa831a3b70830250$var$ReviewStatisticsCreatePage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("gelfo")));

const { PaymentsStatisticsPage: $aa831a3b70830250$var$PaymentsStatisticsPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("BPdTM")));

const { VoxPatientConsent: $aa831a3b70830250$var$VoxPatientConsent } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("8rlQC")));

const { DashboardPage: $aa831a3b70830250$var$DashboardPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("gx53c")));

const { VRTReportsPage: $aa831a3b70830250$var$VRTReportsPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("kD2JO")));

const { GeneralScheduleNew: $aa831a3b70830250$var$GeneralScheduleNew } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("dI2ln")));

const { ScheduleSwitchPage: $aa831a3b70830250$var$ScheduleSwitchPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("ivARo")));

const { EmployeeProfilePage: $aa831a3b70830250$var$EmployeeProfilePage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("fKJPz")));

const { PrescribedServicesPage: $aa831a3b70830250$var$PrescribedServicesPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("dlYTa")));

const { PatientsPage: $aa831a3b70830250$var$PatientsPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("cZACf")));

const { AccountPage: $aa831a3b70830250$var$AccountPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("dyLEx")));

const { PrintableAppointmentPage: $aa831a3b70830250$var$PrintableAppointmentPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("iBodj")));

const { FolderPrintPage: $aa831a3b70830250$var$FolderPrintPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("chQWi")));

const { FolderAnalysesPrintPage: $aa831a3b70830250$var$FolderAnalysesPrintPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("f8W0a")));

const { AgreementPrintPage: $aa831a3b70830250$var$AgreementPrintPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("hN9lV")));

const { AgreementNewPrintPage: $aa831a3b70830250$var$AgreementNewPrintPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("kfn7o")));

const { PrintableHistoryTablePage: $aa831a3b70830250$var$PrintableHistoryTablePage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("1ciCC")));

const { PrintablePrescriptionTablePage: $aa831a3b70830250$var$PrintablePrescriptionTablePage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("ecmRC")));

const { PrintableTablePage: $aa831a3b70830250$var$PrintableTablePage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("cKwry")));

const { PrintableEmbryosDocumentPage: $aa831a3b70830250$var$PrintableEmbryosDocumentPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("6jYW6")));

const { PrintableEmbryosPage: $aa831a3b70830250$var$PrintableEmbryosPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("lhjOz")));

const { PrintableOocytesPage: $aa831a3b70830250$var$PrintableOocytesPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("eQLfD")));

const { AppointmentsSwitchPage: $aa831a3b70830250$var$AppointmentsSwitchPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("iNhkT")));

const { GeneralSchedulePage: $aa831a3b70830250$var$GeneralSchedulePage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("8nKBP")));

const { ChatsPage: $aa831a3b70830250$var$ChatsPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("7KgDa")));

const { CardCheckPage: $aa831a3b70830250$var$CardCheckPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("HzDT0")));

const { NextToEvaluatePage: $aa831a3b70830250$var$NextToEvaluatePage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("8o1GQ")));

const { MyPatientsPage: $aa831a3b70830250$var$MyPatientsPage } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("ad4Y1")));

const { MoreNavigationTabs: $aa831a3b70830250$var$MoreNavigationTabs } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("7WFbh")));

const { ImageViewerNew: $aa831a3b70830250$var$ImageViewerNew } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("ceckB")));

const { PrintEditor: $aa831a3b70830250$var$PrintEditor } = (0, $3cac67d7df2ee1ae$export$430714d8a6ce587f)(()=>(parcelRequire("8xZcN")));
const $aa831a3b70830250$var$ADDITIONAL_ROUTES = [
    "vox-support",
    "vox-information-patient",
    "support",
    "review",
    "finish-payment",
    "payment",
    "videocall",
    "corporate-portal",
    "review-statistics",
    "quest",
    "survey",
    "corporate-portal-statistics",
    "feedback-clinic-statistics",
    "survey-result",
    "analytics",
    "tickets",
    "payments",
    "vox-patient-consent",
    "dashboard",
    "reports-vrt",
    "general-schedule-new",
    "profile"
];
var $28241a72c31c9458$exports = {};
$28241a72c31c9458$exports = new URL("sw.js", import.meta.url).toString();


const $aa831a3b70830250$var$App = (0, $1LCZd.withRouter)((0, $hUmGa.observer)((props)=>{
    var _user$expert, _authStore$user$docto, _authStore$user;
    const { history: history } = (0, (/*@__PURE__*/$parcel$interopDefault($5aMF5)))();
    const paths = location.pathname.split("/");
    const user = (0, $iOlMk.currentUser).getState();
    let isTechnicalWork = (0, $9Toj9.useApplicationFeatureEnabled)((0, $9Toj9.FEATURE).TECHNICAL_WORK);
    if (user && user.id === 850) isTechnicalWork = false;
    const showCardCheckPage = user === null || user === void 0 ? void 0 : (_user$expert = user.expert) === null || _user$expert === void 0 ? void 0 : _user$expert.id;
    const isChatsEnabled = (0, $9Toj9.useApplicationFeatureEnabled)((0, $9Toj9.FEATURE).CHAT);
    const showEmployeeProfilePage = (0, $9Toj9.useApplicationFeatureEnabled)((0, $9Toj9.FEATURE).PROFILE);
    const showPatientsPage = (0, $9Toj9.useApplicationFeatureEnabled)((0, $9Toj9.FEATURE).PATIENTS);
    const questionnaireUserId = (0, $9Toj9.useApplicationFeatureValue)((0, $9Toj9.FEATURE).HC_QUESTIONNAIRE_USER_ID);
    const serviceWorkersIDs = (0, $9Toj9.useApplicationFeatureValueIdArray)((0, $9Toj9.FEATURE).SERVICE_STAFF);
    const serviceAdminsIDs = (0, $9Toj9.useApplicationFeatureValueIdArray)((0, $9Toj9.FEATURE).SERVICE_ADMIN);
    const TICKET_DOCTOR_ASSIGNEE_MEDICAL_ERROR = (0, $9Toj9.useApplicationFeatureValueIdArray)((0, $9Toj9.FEATURE).TICKET_DOCTOR_ASSIGNEE_MEDICAL_ERROR);
    const generalScheduleNewEnabled = (0, $9Toj9.useApplicationFeatureEnabled)((0, $9Toj9.FEATURE).GENERAL_SCHEDULE_NEW);
    const serviceUsersIDs = Array.from(new Set([
        ...serviceWorkersIDs || [],
        ...serviceAdminsIDs || []
    ]));
    (0, $bh6RR.useEffect)(()=>{
        if (isTechnicalWork) return;
        if (isChatsEnabled && user && !$aa831a3b70830250$var$ADDITIONAL_ROUTES.includes(paths[1])) {
            (0, $3M0M5.default).initWS();
            if (!history.location.pathname.includes("appointment") && !(0, $3M0M5.default).isChatsLoaded && !(0, $3M0M5.default).isChatsLoading) {
                (0, $3M0M5.default).loadChats();
                (0, $3M0M5.default).updateUnreadChatsCount();
            }
        }
    }, [
        isChatsEnabled,
        user,
        history.location.pathname
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (isTechnicalWork) return;
        if (user) (0, $5fdtD.default).initWS();
    }, [
        user
    ]);
    const handleMessageListener = (0, $bh6RR.useCallback)((message)=>{
        var _message$data;
        if ((message === null || message === void 0 ? void 0 : message.data) === "eventGoBack") props.history.push((0, $c00UK.TABS_URL)[(0, $c00UK.default).lastMainNavigationTab]);
        if ((message === null || message === void 0 ? void 0 : (_message$data = message.data) === null || _message$data === void 0 ? void 0 : _message$data.type) === "createMobileTicket") (0, $dyAGA.default).setMobileTicketVoxData(message.data.payload);
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (isTechnicalWork) return;
        window.addEventListener("message", handleMessageListener);
        return ()=>window.removeEventListener("message", handleMessageListener);
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (isTechnicalWork) return;
        const unlisten = props.history.listen((location1)=>{
            const voximplantData = {
                page: location1.href
            };
            (0, $lVvdy.setVoximplantSupportData)({
                client_email: voximplantData,
                ...window.VoxKitWidgetSettings.client_data
            });
        });
        return ()=>{
            unlisten();
        };
    }, []);
    (0, $9Toj9.useApplicationFeatures)();
    (0, $ed30f978738c5821$export$82ebed91b52c089b)();
    (0, $27efaa6f26635f92$export$eb5d562072b91edf)();
    (0, $bh6RR.useEffect)(()=>{
        (async ()=>{
            if ((0, $i6z7r.default).token) await (0, $1lysy.default).getOrganizations();
        })();
    }, [
        (0, $i6z7r.default).token
    ]);
    if (user !== null && user !== void 0 && user.is_administrator && !paths.includes("general-schedule-new")) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Redirect), {
        from: "*",
        to: "general-schedule-new/calendar"
    });
    if (paths.length === 3 && paths[1] === "payment") {
        document.documentElement.style.background = "transparent";
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $b28bfe2ed59d7759$export$e8e84ccd09fbede1), {
            id: paths[2]
        });
    }
    if (isTechnicalWork) return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
            children: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$MaintenancePage, {})
        })
    });
    /** Для WebView {7413} */ if (paths[1] === "vox-support") {
        document.documentElement.style.background = "#fafafa";
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoximplantSupportWebView, {})
            })
        });
    }
    /** Для WebView {18124} */ if (paths[1] === "yandex-captcha") {
        document.documentElement.style.background = "#f9f4f4";
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $6b642381b8bbdb3a$export$a6bdaedb4860c4b0), {});
    }
    if (!document.documentElement.style.getPropertyValue("--vh")) {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
        window.addEventListener("resize", ()=>{
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        });
    }
    if (paths.length === 2 && paths[1] === "support") {
        document.documentElement.style.background = "transparent";
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $f621d71f2bfbea12$export$3b628956c133cac7), {});
    }
    if (paths[1] === "review") {
        if ((0, $a2asV.default).clinic_code === (0, $a2asV.CLINIC_CODE).rassvet || location.search.includes("clinic=rassvet")) {
            (0, $a2asV.default).setClinicCode((0, $a2asV.CLINIC_CODE).rassvet);
            document.documentElement.style.background = (0, $aphpl.newColorsRassvet).backgroundPrimary;
        } else {
            (0, $a2asV.default).setClinicCode((0, $a2asV.CLINIC_CODE).fomina);
            document.documentElement.style.background = (0, $lXS21.newColors).backgroundPrimary;
        }
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1LCZd.Switch), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/review/:token",
                            component: $aa831a3b70830250$var$ReviewPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/review/:token/step-two",
                            component: $aa831a3b70830250$var$ReviewStepTwo
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/review/:token/step-three",
                            component: $aa831a3b70830250$var$ReviewStepThree
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/review/:token/step-three-negative",
                            component: $aa831a3b70830250$var$ReviewStepThreeNegative
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/review/:token/step-four",
                            component: $aa831a3b70830250$var$ReviewStepFour
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/review/:token/step-four-negative",
                            component: $aa831a3b70830250$var$ReviewStepFourNegative
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/review/:token/step-five-negative",
                            component: $aa831a3b70830250$var$ReviewStepFiveNegative
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/review/:token/step-six-with-call",
                            component: $aa831a3b70830250$var$ReviewStepSixWithCall
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/review/:token/step-six-not-call",
                            component: $aa831a3b70830250$var$ReviewStepSixNotCall
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/review/:token/already",
                            component: $aa831a3b70830250$var$ReviewAlready
                        })
                    ]
                })
            })
        });
    }
    if ((0, $i6z7r.default).token && !(0, $i6z7r.default).user && !window.ReactNativeWebView) return null;
    const registerServiceWorker = ()=>{
        if ("serviceWorker" in navigator) navigator.serviceWorker.getRegistrations().then((registrations)=>{
            if (registrations.length) return;
            navigator.serviceWorker.register($28241a72c31c9458$exports, {
                scope: "/"
            });
        });
    };
    registerServiceWorker();
    if (paths.length === 2 && paths[1] === "finish-payment") {
        document.documentElement.style.background = "transparent";
        try {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                status: "finished"
            }));
        // eslint-disable-next-line no-empty
        } catch (e) {}
        return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            style: {
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                padding: "10px",
                width: "80vw"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    style: {
                        textAlign: "center",
                        paddingBottom: "20px",
                        fontSize: "120%"
                    },
                    children: "\u041E\u043F\u043B\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: "\u0414\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u0432\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435"
                })
            ]
        });
    }
    if (paths.length >= 3 && paths[1] === "videocall") {
        (0, $3M0M5.default).setCallId(paths[2]);
        if (!(0, $3M0M5.default).currentChatId) return null;
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$Toaster, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$MediaPermissionLockModal, {
                        isShown: (0, $3M0M5.default).showMediaPermissionLockModal
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$MediaPermissionSelectModal, {
                        isShown: (0, $3M0M5.default).showMediaPermissionSelectModal
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$MediaPermissionNotDeviceModal, {
                        isShown: (0, $3M0M5.default).showMediaPermissionNotDeviceModal
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoximplantConnectionErrorModal, {
                        isShown: (0, $3M0M5.default).showVoximplantConnectionErrorModal
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VideoCall, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoximplantSupport, {})
                ]
            })
        });
    }
    if (location.pathname === "/tickets/segment/medical-error/create") {
        document.documentElement.style.background = "#fafafa";
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$Toaster, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Switch), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/tickets/segment/medical-error/create",
                            component: $aa831a3b70830250$var$TicketCreatePage
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                        isShown: (0, $igCUb.default).isConnectionModalVisible
                    })
                ]
            })
        });
    }
    if (location.pathname.includes("/survey/")) {
        document.documentElement.style.background = "#F9F4F4";
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$Toaster, {}),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1LCZd.Switch), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/survey/:id",
                                component: $aa831a3b70830250$var$SurveyPage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/survey/result/:id",
                                component: $aa831a3b70830250$var$SurveyPage
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                        isShown: (0, $igCUb.default).isConnectionModalVisible
                    })
                ]
            })
        });
    }
    if (paths[1] === "corporate-portal" || user !== null && user !== void 0 && user.is_corporate_portal) {
        if (paths[1] !== "corporate-portal") history.push("/corporate-portal");
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$Toaster, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Switch), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/corporate-portal",
                            component: $aa831a3b70830250$var$CorporatePortal
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                        isShown: (0, $igCUb.default).isConnectionModalVisible
                    })
                ]
            })
        });
    }
    if (paths[1] === "review-statistics" && paths[2] === "create") {
        document.documentElement.style.background = "#fafafa";
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$Toaster, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Switch), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/review-statistics/create",
                            component: $aa831a3b70830250$var$ReviewStatisticsCreatePage
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoximplantSupport, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                        isShown: (0, $igCUb.default).isConnectionModalVisible
                    })
                ]
            })
        });
    }
    if (!(0, $i6z7r.default).token || !(0, $i6z7r.default).user) return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$Toaster, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoginPage, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoximplantSupport, {
                    showMobile: true
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                    isShown: (0, $igCUb.default).isConnectionModalVisible
                })
            ]
        })
    });
    if (paths[1] === "vox-information-patient") {
        document.documentElement.style.background = "#fafafa";
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$Toaster, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoxInformationPatient, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                        isShown: (0, $igCUb.default).isConnectionModalVisible
                    })
                ]
            })
        });
    }
    if (location.pathname.includes("/tickets/segment/medical-error") && TICKET_DOCTOR_ASSIGNEE_MEDICAL_ERROR && TICKET_DOCTOR_ASSIGNEE_MEDICAL_ERROR.includes((0, $i6z7r.default).user.doctor.id)) {
        document.documentElement.style.background = "#fafafa";
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$Toaster, {}),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1LCZd.Switch), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/medical-error",
                                component: $aa831a3b70830250$var$TicketPage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/medical-error/create",
                                component: $aa831a3b70830250$var$TicketCreatePage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/medical-error/:id",
                                component: $aa831a3b70830250$var$TicketEditPage
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                        isShown: (0, $igCUb.default).isConnectionModalVisible
                    })
                ]
            })
        });
    }
    (_authStore$user$docto = (0, $i6z7r.default).user.doctor) !== null && _authStore$user$docto !== void 0 && _authStore$user$docto.last_name;
    if (((_authStore$user = (0, $i6z7r.default).user) === null || _authStore$user === void 0 ? void 0 : _authStore$user.id) === questionnaireUserId) {
        window.QUEST_MODE = true;
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1LCZd.Switch), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/quest",
                                component: $aa831a3b70830250$var$CheckupsPage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/quest/thanks",
                                component: $aa831a3b70830250$var$CheckupsPageThanks
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/quest/:appointment_id",
                                component: $aa831a3b70830250$var$CheckupsPageAppointments
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                        isShown: (0, $igCUb.default).isConnectionModalVisible
                    })
                ]
            })
        });
    }
    if (paths[1] === "analytics" || paths[1] === "review-statistics") return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$Toaster, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$AnalyticsPage, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoximplantSupport, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                    isShown: (0, $igCUb.default).isConnectionModalVisible
                })
            ]
        })
    });
    if (paths[1] === "commercial-department") return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$Toaster, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$CommercialPage, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoximplantSupport, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                    isShown: (0, $igCUb.default).isConnectionModalVisible
                })
            ]
        })
    });
    if (paths[1] === "tickets") {
        document.documentElement.style.background = "#fafafa";
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1LCZd.Switch), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets",
                                component: $aa831a3b70830250$var$TicketPage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/create",
                                component: $aa831a3b70830250$var$TicketCreatePage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/:id",
                                component: $aa831a3b70830250$var$TicketEditPage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/profile",
                                component: $aa831a3b70830250$var$TicketPage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/profile/create",
                                component: $aa831a3b70830250$var$TicketCreatePage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/profile/:id",
                                component: $aa831a3b70830250$var$TicketEditPage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/legal-lab",
                                component: $aa831a3b70830250$var$TicketPage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/legal-lab/create",
                                component: $aa831a3b70830250$var$TicketCreatePage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/legal-lab/:id",
                                component: $aa831a3b70830250$var$TicketEditPage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/manager-dms",
                                component: $aa831a3b70830250$var$TicketPage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/manager-dms/create",
                                component: $aa831a3b70830250$var$TicketCreatePage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/manager-dms/:id",
                                component: $aa831a3b70830250$var$TicketEditPage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/common",
                                component: $aa831a3b70830250$var$TicketPage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/common/create",
                                component: $aa831a3b70830250$var$TicketCreatePage
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                                exact: true,
                                path: "/tickets/segment/common/:id",
                                component: $aa831a3b70830250$var$TicketEditPage
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoximplantSupport, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                        isShown: (0, $igCUb.default).isConnectionModalVisible
                    })
                ]
            })
        });
    }
    if (paths[1] === "payments") {
        document.documentElement.style.background = "#fafafa";
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Switch), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/payments",
                            component: $aa831a3b70830250$var$PaymentsStatisticsPage
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoximplantSupport, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                        isShown: (0, $igCUb.default).isConnectionModalVisible
                    })
                ]
            })
        });
    }
    if (paths[1] === "vox-patient-consent") {
        document.documentElement.style.background = "#fafafa";
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Switch), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/vox-patient-consent",
                            component: $aa831a3b70830250$var$VoxPatientConsent
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoximplantSupport, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                        isShown: (0, $igCUb.default).isConnectionModalVisible
                    })
                ]
            })
        });
    }
    if (paths[1] === "dashboard") {
        document.documentElement.style.background = "#fafafa";
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Switch), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/dashboard",
                            component: $aa831a3b70830250$var$DashboardPage
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoximplantSupport, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                        isShown: (0, $igCUb.default).isConnectionModalVisible
                    })
                ]
            })
        });
    }
    if (paths[1] === "reports-vrt") {
        document.documentElement.style.background = "#fafafa";
        return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
                fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Switch), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/reports-vrt",
                            component: $aa831a3b70830250$var$VRTReportsPage
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoximplantSupport, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                        isShown: (0, $igCUb.default).isConnectionModalVisible
                    })
                ]
            })
        });
    }
    if (generalScheduleNewEnabled && paths[1] === "general-schedule-new") return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$Toaster, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$GeneralScheduleNew, {}),
                ![
                    "/general-schedule-new/calendar",
                    "/general-schedule-new/board"
                ].includes(location.pathname) && /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoximplantSupport, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                    isShown: (0, $igCUb.default).isConnectionModalVisible
                })
            ]
        })
    });
    if (paths[1] === "card-check-next") return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1LCZd.Switch), {
                    children: [
                        showCardCheckPage && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/card-check-next",
                            component: $aa831a3b70830250$var$NextToEvaluatePage
                        }),
                        showCardCheckPage && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/card-check-next/:id",
                            component: $aa831a3b70830250$var$NextToEvaluatePage
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                    isShown: (0, $igCUb.default).isConnectionModalVisible
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ErrorBoundary, {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$LoadingFallback, {}),
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$Toaster, {}),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1LCZd.Switch), {
                    children: [
                        serviceWorkersIDs && (serviceUsersIDs.includes(user.id) ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Redirect), {
                            exact: true,
                            from: "/",
                            to: "/review-statistics"
                        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Redirect), {
                            exact: true,
                            from: "/",
                            to: "/schedule"
                        })),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/schedule",
                            component: $aa831a3b70830250$var$ScheduleSwitchPage
                        }),
                        showEmployeeProfilePage && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/profile",
                            component: $aa831a3b70830250$var$EmployeeProfilePage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/prescribed-services-report",
                            component: $aa831a3b70830250$var$PrescribedServicesPage
                        }),
                        showPatientsPage && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/patients",
                            component: $aa831a3b70830250$var$PatientsPage
                        }),
                        false,
                        false,
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/appointment/:appointment_id/print/:for",
                            component: $aa831a3b70830250$var$PrintableAppointmentPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/appointment/folder/:id/print/:concrete_folder?",
                            component: $aa831a3b70830250$var$FolderPrintPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/appointment/folder/:id/analyzes/print/:type",
                            component: $aa831a3b70830250$var$FolderAnalysesPrintPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/appointment/folder/:id/agreements/print/:agreementId",
                            component: $aa831a3b70830250$var$AgreementPrintPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/appointment/:id/agreements/print/:agreementId",
                            component: $aa831a3b70830250$var$AgreementNewPrintPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/appointment/:appointment_id/:section_id/print/history",
                            component: $aa831a3b70830250$var$PrintableHistoryTablePage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/appointment/:appointment_id/:section_id/print/prescriptions",
                            component: $aa831a3b70830250$var$PrintablePrescriptionTablePage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/appointment/:appointment_id/:section_id/print/table",
                            component: $aa831a3b70830250$var$PrintableTablePage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/embryos/:folder_id/:medical_file_id/print/documents/:document",
                            component: $aa831a3b70830250$var$PrintableEmbryosDocumentPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/embryos/:folder_id/:medical_file_id/print/:filter",
                            component: $aa831a3b70830250$var$PrintableEmbryosPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/oocytes/:folder_id/:medical_file_id/print/:filter",
                            component: $aa831a3b70830250$var$PrintableOocytesPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/embryos/:medical_file_id/print/documents/:document",
                            component: $aa831a3b70830250$var$PrintableEmbryosDocumentPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/embryos/:medical_file_id/print/:filter",
                            component: $aa831a3b70830250$var$PrintableEmbryosPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/oocytes/:medical_file_id/print/:filter",
                            component: $aa831a3b70830250$var$PrintableOocytesPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/appointment",
                            component: $aa831a3b70830250$var$AppointmentsSwitchPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/general-schedule",
                            component: $aa831a3b70830250$var$GeneralSchedulePage
                        }),
                        showCardCheckPage && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/card-check",
                            component: $aa831a3b70830250$var$CardCheckPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/chats/:id",
                            component: $aa831a3b70830250$var$ChatsPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            path: "/chats",
                            component: $aa831a3b70830250$var$ChatsPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/my-patients",
                            component: $aa831a3b70830250$var$MyPatientsPage
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Route), {
                            exact: true,
                            path: "/more-navigation-tabs",
                            component: $aa831a3b70830250$var$MoreNavigationTabs
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VideoCall, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ImageViewerNew, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$PrintEditor, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$VoximplantSupport, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)($aa831a3b70830250$var$ConnectionErrorModal, {
                    isShown: (0, $igCUb.default).isConnectionModalVisible
                })
            ]
        })
    });
}));
var $aa831a3b70830250$export$2e2bcd8739ae039 = $aa831a3b70830250$var$App;



var $1LCZd = parcelRequire("1LCZd");

var $lrsw3 = parcelRequire("lrsw3");

var $3DzKC = parcelRequire("3DzKC");

var $le8XK = parcelRequire("le8XK");

var $8poMo = parcelRequire("8poMo");
// Translation map for Clock Label
const $f653e8a6748acf89$var$timeViews = {
    hours: "\u0447\u0430\u0441\u044B",
    minutes: "\u043C\u0438\u043D\u0443\u0442\u044B",
    seconds: "\u0441\u0435\u043A\u0443\u043D\u0434\u044B",
    meridiem: "\u043C\u0435\u0440\u0438\u0434\u0438\u0435\u043C"
};
const $f653e8a6748acf89$var$ruRUPickers = {
    // Calendar navigation
    previousMonth: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u043C\u0435\u0441\u044F\u0446",
    nextMonth: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u043C\u0435\u0441\u044F\u0446",
    // View navigation
    openPreviousView: "\u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0432\u0438\u0434",
    openNextView: "\u043E\u0442\u043A\u0440\u044B\u0442\u044C \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0432\u0438\u0434",
    calendarViewSwitchingButtonAriaLabel: (view)=>view === "year" ? "\u043E\u0442\u043A\u0440\u044B\u0442 \u0433\u043E\u0434\u043E\u0432\u043E\u0439 \u0432\u0438\u0434, \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043D\u0430 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u044B\u0439 \u0432\u0438\u0434" : "\u043E\u0442\u043A\u0440\u044B\u0442 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u044B\u0439 \u0432\u0438\u0434, \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043D\u0430 \u0433\u043E\u0434\u043E\u0432\u043E\u0439 \u0432\u0438\u0434",
    // DateRange placeholders
    start: "\u041D\u0430\u0447\u0430\u043B\u043E",
    end: "\u041A\u043E\u043D\u0435\u0446",
    // Action bar
    cancelButtonLabel: "\u041E\u0442\u043C\u0435\u043D\u0430",
    clearButtonLabel: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C",
    okButtonLabel: "\u041E\u043A",
    todayButtonLabel: "\u0421\u0435\u0433\u043E\u0434\u043D\u044F",
    // Toolbar titles
    datePickerToolbarTitle: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0434\u0430\u0442\u0443",
    dateTimePickerToolbarTitle: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0434\u0430\u0442\u0443 \u0438 \u0432\u0440\u0435\u043C\u044F",
    timePickerToolbarTitle: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0440\u0435\u043C\u044F",
    dateRangePickerToolbarTitle: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043F\u0435\u0440\u0438\u043E\u0434",
    // Clock labels
    clockLabelText: (view, time, adapter)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C} ${$f653e8a6748acf89$var$timeViews[view]}. ${time === null ? "\u0412\u0440\u0435\u043C\u044F \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043E" : `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{44F} ${adapter.format(time, "fullTime")}`}`,
    hoursClockNumberText: (hours)=>`${hours} \u{447}\u{430}\u{441}\u{43E}\u{432}`,
    minutesClockNumberText: (minutes)=>`${minutes} \u{43C}\u{438}\u{43D}\u{443}\u{442}`,
    secondsClockNumberText: (seconds)=>`${seconds} \u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}`,
    // Digital clock labels
    selectViewText: (view)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C} ${$f653e8a6748acf89$var$timeViews[view]}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: "\u041D\u043E\u043C\u0435\u0440 \u043D\u0435\u0434\u0435\u043B\u0438",
    calendarWeekNumberHeaderText: "\u2116",
    calendarWeekNumberAriaLabelText: (weekNumber)=>`\u{41D}\u{435}\u{434}\u{435}\u{43B}\u{44F} ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{434}\u{430}\u{442}\u{443}, \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430} ${utils.format(value, "fullDate")}` : "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0430\u0442\u0443",
    openTimePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{44F}, \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{44F} ${utils.format(value, "fullTime")}` : "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0440\u0435\u043C\u044F",
    fieldClearLabel: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435",
    // Table labels
    timeTableLabel: "\u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0440\u0435\u043C\u044F",
    dateTableLabel: "\u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0434\u0430\u0442\u0443",
    // Field section placeholders
    fieldYearPlaceholder: (params)=>"\u0413".repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === "letter" ? "\u041C\u041C\u041C\u041C" : "\u041C\u041C",
    fieldDayPlaceholder: ()=>"\u0414\u0414",
    // fieldWeekDayPlaceholder: params => params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>"\u0447\u0447",
    fieldMinutesPlaceholder: ()=>"\u043C\u043C",
    fieldSecondsPlaceholder: ()=>"\u0441\u0441",
    fieldMeridiemPlaceholder: ()=>"(\u0434|\u043F)\u043F"
};
const $f653e8a6748acf89$export$6eca8b94a4798dda = (0, $8poMo.getPickersLocalization)($f653e8a6748acf89$var$ruRUPickers);


const $b0a7e8b55b633e35$export$40025ed683ae15e2 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u1218\u1295\u1308\u12F5 \u12A0\u1233\u12ED"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u12C8\u12F0 \u1218\u1300\u1218\u122A\u12EB\u12CD \u1308\u133D \u12ED\u1202\u12F1";
                    if (type === "last") return "\u12C8\u12F0 \u1218\u1328\u1228\u123B\u12CD \u1308\u133D \u12ED\u1202\u12F1";
                    if (type === "next") return "\u12C8\u12F0 \u1240\u1323\u12E9 \u1308\u133D \u12ED\u1202\u12F1";
                    // if (type === 'previous') {
                    return "\u12C8\u12F0 \u1240\u12F3\u121A\u12CD \u1308\u133D \u12ED\u1202\u12F1";
                },
                labelRowsPerPage: "\u1228\u12F5\u134E\u127D \u1260\u12A0\u1295\u12F5 \u1308\u133D:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}-${to} \u{12A8} ${count !== -1 ? count : `${to} \u{1260}\u{120B}\u{12ED}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{12AE}\u{12A8}${value !== 1 ? "\u1266\u127D" : "\u1265"}`,
                emptyLabelText: "\u1263\u12F6"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u12A0\u133D\u12F3",
                closeText: "\u12DD\u130B",
                loadingText: "\u1260\u1218\u132B\u1295 \u120B\u12ED\u2026",
                noOptionsText: "\u12A0\u121B\u122B\u132E\u127D \u12E8\u1209\u121D",
                openText: "\u12AD\u1348\u1275"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u12DD\u130B"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u12E8\u1308\u133D \u12A0\u1230\u1233",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u12C8\u12F0 "}\u{1308}\u{133D} ${page}${selected ? "" : " \u1202\u12F5"}`;
                    if (type === "first") return "\u12C8\u12F0 \u1218\u1300\u1218\u122A\u12EB\u12CD \u1308\u133D \u12ED\u1202\u12F1";
                    if (type === "last") return "\u12C8\u12F0 \u1218\u1328\u1228\u123B\u12CD \u1308\u133D \u12ED\u1202\u12F1";
                    if (type === "next") return "\u12C8\u12F0 \u1240\u1323\u12E9 \u1308\u133D \u12ED\u1202\u12F1";
                    // if (type === 'previous') {
                    return "\u12C8\u12F0 \u1240\u12F3\u121A\u12CD \u1308\u133D \u12ED\u1202\u12F1";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$121716977511c975 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0645\u0633\u0627\u0631"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u0648\u0644\u0649";
                    if (type === "last") return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u062E\u064A\u0631\u0629";
                    if (type === "next") return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629";
                    // if (type === 'previous') {
                    return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629";
                },
                labelRowsPerPage: "\u0639\u062F\u062F \u0627\u0644\u0635\u0641\u0648\u0641 \u0641\u064A \u0627\u0644\u0635\u0641\u062D\u0629:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{645}\u{646} ${count !== -1 ? count : ` \u{623}\u{643}\u{62B}\u{631} \u{645}\u{646}${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} ${value !== 1 ? "\u0646\u062C\u0648\u0645" : "\u0646\u062C\u0645\u0629"}`,
                emptyLabelText: "\u0641\u0627\u0631\u063A"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u0645\u0633\u062D",
                closeText: "\u0625\u063A\u0644\u0627\u0642",
                loadingText: "\u062C\u0627\u0631 \u0627\u0644\u062A\u062D\u0645\u064A\u0644...",
                noOptionsText: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062E\u064A\u0627\u0631\u0627\u062A",
                openText: "\u0641\u062A\u062D"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0625\u063A\u0644\u0627\u0642"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u0627\u0644\u062A\u0646\u0642\u0644 \u0639\u0628\u0631 \u0627\u0644\u0635\u0641\u062D\u0627\u062A",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 "} \u{635}\u{641}\u{62D}\u{629} ${page}`;
                    if (type === "first") return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u0648\u0644\u0649";
                    if (type === "last") return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u062E\u064A\u0631\u0629";
                    if (type === "next") return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629";
                    // if (type === 'previous') {
                    return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$f6f6c9668e179f08 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0645\u0633\u0627\u0631"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u0648\u0644\u0649";
                    if (type === "last") return "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u062E\u064A\u0631\u0629";
                    if (type === "next") return "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629";
                    // if (type === 'previous') {
                    return "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629";
                },
                labelRowsPerPage: "\u0639\u062F\u062F \u0627\u0644\u0635\u0641\u0648\u0641 \u0641\u064A \u0627\u0644\u0635\u0641\u062D\u0629:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{645}\u{646} ${count !== -1 ? count : ` \u{623}\u{643}\u{62B}\u{631} \u{645}\u{646}${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} ${value !== 1 ? "\u0646\u062C\u0648\u0645" : "\u0646\u062C\u0645\u0629"}`,
                emptyLabelText: "\u0641\u0627\u0631\u063A"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u0645\u0633\u062D",
                closeText: "\u0625\u063A\u0644\u0627\u0642",
                loadingText: "\u062C\u0627\u0631 \u0627\u0644\u062A\u062D\u0645\u064A\u0644...",
                noOptionsText: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062E\u064A\u0627\u0631\u0627\u062A",
                openText: "\u0641\u062A\u062D"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0625\u063A\u0644\u0627\u0642"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u0627\u0644\u062A\u0646\u0642\u0644 \u0639\u0628\u0631 \u0627\u0644\u0635\u0641\u062D\u0627\u062A",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 "} \u{635}\u{641}\u{62D}\u{629} ${page}`;
                    if (type === "first") return "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u0648\u0644\u0649";
                    if (type === "last") return "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0627\u0644\u064A \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u062E\u064A\u0631\u0629";
                    if (type === "next") return "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629";
                    // if (type === 'previous') {
                    return "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$3eb6759aa1da3c0e = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0645\u0633\u0627\u0631"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u0648\u0644\u0649";
                    if (type === "last") return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u062E\u064A\u0631\u0629";
                    if (type === "next") return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629";
                    // if (type === 'previous') {
                    return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629";
                },
                labelRowsPerPage: "\u0639\u062F\u062F \u0627\u0644\u0635\u0641\u0648\u0641 \u0641\u064A \u0627\u0644\u0635\u0641\u062D\u0629:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{645}\u{646} ${count !== -1 ? count : ` \u{623}\u{643}\u{62B}\u{631} \u{645}\u{646}${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} ${value !== 1 ? "\u0646\u062C\u0648\u0645" : "\u0646\u062C\u0645\u0629"}`,
                emptyLabelText: "\u0641\u0627\u0631\u063A"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u0645\u0633\u062D",
                closeText: "\u0625\u063A\u0644\u0627\u0642",
                loadingText: "\u062C\u0627\u0631 \u0627\u0644\u062A\u062D\u0645\u064A\u0644...",
                noOptionsText: "\u0644\u0627 \u064A\u0648\u062C\u062F \u062E\u064A\u0627\u0631\u0627\u062A",
                openText: "\u0641\u062A\u062D"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0625\u063A\u0644\u0627\u0642"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u0627\u0644\u062A\u0646\u0642\u0644 \u0639\u0628\u0631 \u0627\u0644\u0635\u0641\u062D\u0627\u062A",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 "} \u{635}\u{641}\u{62D}\u{629} ${page}`;
                    if (type === "first") return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u0648\u0644\u0649";
                    if (type === "last") return "\u0627\u0646\u062A\u0642\u0644 \u0627\u0644\u064A \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u062E\u064A\u0631\u0629";
                    if (type === "next") return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629";
                    // if (type === 'previous') {
                    return "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$b7d21d901a38ba40 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Yolu g\xf6st\u0259r"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Birinci s\u0259hif\u0259y\u0259 ke\xe7";
                    if (type === "last") return "Sonuncu s\u0259hif\u0259y\u0259 ke\xe7";
                    if (type === "next") return "N\xf6vb\u0259ti s\u0259hif\u0259y\u0259 ke\xe7";
                    // if (type === 'previous') {
                    return "\u018Fvv\u0259lki s\u0259hif\u0259y\u0259 ke\xe7";
                },
                labelRowsPerPage: "S\u0259hif\u0259y\u0259 d\xfc\u015F\u0259n s\u0259trl\u0259r:"
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>{
                    let pluralForm = "Ulduz";
                    const lastDigit = value % 10;
                    if (lastDigit > 1 && lastDigit < 5) pluralForm = "Ulduzlar";
                    return `${value} ${pluralForm}`;
                },
                emptyLabelText: "Bo\u015F"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Silm\u0259k",
                closeText: "Ba\u011Flamaq",
                loadingText: "Y\xfckl\u0259nir\u2026",
                noOptionsText: "Se\xe7iml\u0259r m\xf6vcud deyil",
                openText: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Ba\u011Flamaq"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "S\u0259hif\u0259nin naviqasiyas\u0131",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${page} ${selected ? "s\u0259hif\u0259" : "s\u0259hif\u0259y\u0259 ke\xe7"}`;
                    if (type === "first") return "Birinci s\u0259hif\u0259y\u0259 ke\xe7";
                    if (type === "last") return "Sonuncu s\u0259hif\u0259y\u0259 ke\xe7";
                    if (type === "next") return "N\xf6vb\u0259ti s\u0259hif\u0259y\u0259 ke\xe7";
                    // if (type === 'previous') {
                    return "\u018Fvv\u0259lki s\u0259hif\u0259y\u0259 ke\xe7";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$8142f484a011d82e = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u09AA\u09A5 \u09A6\u09C7\u0996\u09BE\u09A8"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u09AA\u09CD\u09B0\u09A5\u09AE \u09AA\u09C3\u09B7\u09CD\u09A0\u09BE\u09DF \u09AF\u09BE\u09A8";
                    if (type === "last") return "\u09B6\u09C7\u09B7 \u09AA\u09C3\u09B7\u09CD\u09A0\u09BE\u09DF \u09AF\u09BE\u09A8";
                    if (type === "next") return "\u09AA\u09B0\u09AC\u09B0\u09CD\u09A4\u09C0 \u09AA\u09C3\u09B7\u09CD\u09A0\u09BE\u09DF \u09AF\u09BE\u09A8";
                    // if (type === 'previous') {
                    return "\u0986\u0997\u09C7\u09B0 \u09AA\u09C3\u09B7\u09CD\u09A0\u09BE\u09DF \u09AF\u09BE\u09A8";
                },
                labelRowsPerPage: "\u09AA\u09CD\u09B0\u09A4\u09BF \u09AA\u09C3\u09B7\u09CD\u09A0\u09BE\u09AF\u09BC \u09B8\u09BE\u09B0\u09BF:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} / ${count !== -1 ? count : `${to} \u{9A5}\u{9C7}\u{995}\u{9C7} \u{9AC}\u{9C7}\u{9B6}\u{9BF}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{9B8}\u{9CD}\u{99F}\u{9BE}\u{9B0}`,
                emptyLabelText: "\u0996\u09BE\u09B2\u09BF"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u09AA\u09B0\u09BF\u09B7\u09CD\u0995\u09BE\u09B0 \u0995\u09B0\u09C1\u09A8",
                closeText: "\u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8",
                loadingText: "\u09B2\u09CB\u09A1 \u09B9\u099A\u09CD\u099B\u09C7\u2026",
                noOptionsText: "\u0995\u09CB\u09A8 \u0985\u09AA\u09B6\u09A8 \u09A8\u09C7\u0987",
                openText: "\u0993\u09AA\u09C7\u09A8 \u0995\u09B0\u09C1\u09A8"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u09AA\u09C7\u099C\u09BF\u09A8\u09C7\u09B6\u09A8 \u09A8\u09C7\u09AD\u09BF\u0997\u09C7\u09B6\u09A8",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u09AF\u09BE\u09A8 "}\u{9AA}\u{9C3}\u{9B7}\u{9CD}\u{9A0}\u{9BE} ${page}-\u{98F}`;
                    if (type === "first") return "\u09AA\u09CD\u09B0\u09A5\u09AE \u09AA\u09C3\u09B7\u09CD\u09A0\u09BE\u09DF \u09AF\u09BE\u09A8";
                    if (type === "last") return "\u09B6\u09C7\u09B7 \u09AA\u09C3\u09B7\u09CD\u09A0\u09BE\u09DF \u09AF\u09BE\u09A8";
                    if (type === "next") return "\u09AA\u09B0\u09AC\u09B0\u09CD\u09A4\u09C0 \u09AA\u09C3\u09B7\u09CD\u09A0\u09BE\u09DF \u09AF\u09BE\u09A8";
                    // if (type === 'previous') {
                    return "\u0986\u0997\u09C7\u09B0 \u09AA\u09C3\u09B7\u09CD\u09A0\u09BE\u09DF \u09AF\u09BE\u09A8";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$93d0116b775d4bbd = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u041F\u0430\u043A\u0430\u0437\u0430\u0446\u044C \u0448\u043B\u044F\u0445"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u041F\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u043D\u0430 \u043F\u0435\u0440\u0448\u0443\u044E \u0441\u0442\u0430\u0440\u043E\u043D\u043A\u0443";
                    if (type === "last") return "\u041F\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u043D\u0430 \u0430\u043F\u043E\u0448\u043D\u044E\u044E \u0441\u0442\u0430\u0440\u043E\u043D\u043A\u0443";
                    if (type === "next") return "\u041F\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u043D\u0430 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E \u0441\u0442\u0430\u0440\u043E\u043D\u043A\u0443";
                    // if (type === 'previous') {
                    return "\u041F\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u043D\u0430 \u043F\u0430\u043F\u044F\u0440\u044D\u0434\u043D\u044E\u044E \u0441\u0442\u0430\u0440\u043E\u043D\u043A\u0443";
                },
                labelRowsPerPage: "\u0420\u0430\u0434\u043A\u043E\u045E \u043D\u0430 \u0441\u0442\u0430\u0440\u043E\u043D\u0446\u044B:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{437} ${count !== -1 ? count : `\u{431}\u{43E}\u{43B}\u{44C}\u{448} \u{447}\u{44B}\u{43C} ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>{
                    let pluralForm = "\u0417\u043E\u0440\u0430\u043A";
                    const lastDigit = value % 10;
                    if (lastDigit > 1 && lastDigit < 5 && (value < 10 || value > 20)) pluralForm = "\u0417\u043E\u0440\u043A\u0456";
                    else if (lastDigit === 1 && value % 100 !== 11) pluralForm = "\u0417\u043E\u0440\u043A\u0430";
                    return `${value} ${pluralForm}`;
                },
                emptyLabelText: "\u0420\u044D\u0439\u0442\u044B\u043D\u0433 \u0430\u0434\u0441\u0443\u0442\u043D\u0456\u0447\u0430\u0435"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u0410\u0447\u044B\u0441\u0446\u0456\u0446\u044C",
                closeText: "\u0417\u0430\u043A\u0440\u044B\u0446\u044C",
                loadingText: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
                noOptionsText: "\u041D\u044F\u043C\u0430 \u0432\u0430\u0440\u044B\u044F\u043D\u0442\u0430\u045E",
                openText: "\u0410\u0434\u043A\u0440\u044B\u0446\u044C"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0417\u0430\u043A\u0440\u044B\u0446\u044C"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u041D\u0430\u0432\u0456\u0433\u0430\u0446\u044B\u044F \u043F\u0430 \u0441\u0442\u0430\u0440\u043E\u043D\u043A\u0430\u043C",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") {
                        if (selected) return `${page} \u{441}\u{442}\u{430}\u{440}\u{43E}\u{43D}\u{43A}\u{430}`;
                        return `\u{41F}\u{435}\u{440}\u{430}\u{439}\u{441}\u{446}\u{456} \u{43D}\u{430} ${page} \u{441}\u{442}\u{430}\u{440}\u{43E}\u{43D}\u{43A}\u{443}`;
                    }
                    if (type === "first") return "\u041F\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u043D\u0430 \u043F\u0435\u0440\u0448\u0443\u044E \u0441\u0442\u0430\u0440\u043E\u043D\u043A\u0443";
                    if (type === "last") return "\u041F\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u043D\u0430 \u0430\u043F\u043E\u0448\u043D\u044E\u044E \u0441\u0442\u0430\u0440\u043E\u043D\u043A\u0443";
                    if (type === "next") return "\u041F\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u043D\u0430 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E \u0441\u0442\u0430\u0440\u043E\u043D\u043A\u0443";
                    // if (type === 'previous') {
                    return "\u041F\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u043D\u0430 \u043F\u0430\u043F\u044F\u0440\u044D\u0434\u043D\u044E\u044E \u0441\u0442\u0430\u0440\u043E\u043D\u043A\u0443";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$5e64e83bd61774cb = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u041F\u043E\u043A\u0430\u0437\u0432\u0430\u043D\u0435 \u043D\u0430 \u043F\u044A\u0442\u044F"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u041E\u0442\u0438\u0434\u0438 \u043D\u0430 \u043F\u044A\u0440\u0432\u0430\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                    if (type === "last") return "\u041E\u0442\u0438\u0434\u0438 \u043D\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                    if (type === "next") return "\u041E\u0442\u0438\u0434\u0438 \u043D\u0430 \u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                    // if (type === 'previous') {
                    return "\u041E\u0442\u0438\u0434\u0438 \u043D\u0430 \u043F\u0440\u0435\u0434\u0438\u0448\u043D\u0430\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                },
                labelRowsPerPage: "\u0420\u0435\u0434\u043E\u0432\u0435 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430:"
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{417}\u{432}\u{435}\u{437}\u{434}${value !== 1 ? "\u0438" : "\u0430"}`,
                emptyLabelText: "\u0418\u0437\u0447\u0438\u0441\u0442\u0438"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u0418\u0437\u0447\u0438\u0441\u0442\u0438",
                closeText: "\u0417\u0430\u0442\u0432\u043E\u0440\u0438",
                loadingText: "\u0417\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435\u2026",
                noOptionsText: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0438 \u043E\u043F\u0446\u0438\u0438",
                openText: "\u041E\u0442\u0432\u043E\u0440\u0438"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u041F\u0430\u0433\u0438\u043D\u0430\u0446\u0438\u044F",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u041A\u044A\u043C "}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430} ${page}`;
                    if (type === "first") return "\u041E\u0442\u0438\u0434\u0438 \u043D\u0430 \u043F\u044A\u0440\u0432\u0430\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                    if (type === "last") return "\u041E\u0442\u0438\u0434\u0438 \u043D\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                    if (type === "next") return "\u041E\u0442\u0438\u0434\u0438 \u043D\u0430 \u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                    // if (type === 'previous') {
                    return "\u041E\u0442\u0438\u0434\u0438 \u043D\u0430 \u043F\u0440\u0435\u0434\u0438\u0448\u043D\u0430\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$2a06e82593e71f45 = {
    components: {
        // MuiBreadcrumbs: {
        //   defaultProps: {
        //    expandText: 'Show path',
        //   },
        // },
        MuiTablePagination: {
            defaultProps: {
                // getItemAriaLabel: (type) => {
                //   if (type === 'first') {
                //     return 'Go to first page';
                //   }
                //   if (type === 'last') {
                //     return 'Go to last page';
                //   }
                //   if (type === 'next') {
                //     return 'Go to next page';
                //   }
                //   // if (type === 'previous') {
                //   return 'Go to previous page';
                // },
                labelRowsPerPage: "Files per p\xe0gina:"
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} ${value !== 1 ? "Estrelles" : "Estrella"}`,
                emptyLabelText: "Buit"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Netejar",
                closeText: "Tancar",
                loadingText: "Carregant\u2026",
                noOptionsText: "Sense opcions",
                openText: "Obert"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Tancat"
            }
        }
    }
};
const $b0a7e8b55b633e35$export$2e63a9024efcc137 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Uk\xe1zat cestu"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "J\xedt na prvn\xed str\xe1nku";
                    if (type === "last") return "J\xedt na posledn\xed str\xe1nku";
                    if (type === "next") return "J\xedt na dal\u0161\xed str\xe1nku";
                    // if (type === 'previous') {
                    return "J\xedt na p\u0159edchoz\xed str\xe1nku";
                },
                labelRowsPerPage: "\u0158\xe1dk\u016F na str\xe1nce:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} z ${count !== -1 ? count : `v\xedce ne\u{17E} ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>{
                    if (value === 1) return `${value} hv\u{11B}zdi\u{10D}ka`;
                    if (value >= 2 && value <= 4) return `${value} hv\u{11B}zdi\u{10D}ky`;
                    return `${value} hv\u{11B}zdi\u{10D}ek`;
                },
                emptyLabelText: "Pr\xe1zdn\xe9"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Vymazat",
                closeText: "Zav\u0159\xedt",
                loadingText: "Na\u010D\xedt\xe1n\xed\u2026",
                noOptionsText: "\u017D\xe1dn\xe9 mo\u017Enosti",
                openText: "Otev\u0159\xedt"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Zav\u0159\xedt"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Navigace str\xe1nkov\xe1n\xedm",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "J\xedt na "}${page}. str\xe1nku`;
                    if (type === "first") return "J\xedt na prvn\xed str\xe1nku";
                    if (type === "last") return "J\xedt na posledn\xed str\xe1nku";
                    if (type === "next") return "J\xedt na dal\u0161\xed str\xe1nku";
                    // if (type === 'previous') {
                    return "J\xedt na p\u0159edchoz\xed str\xe1nku";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$45c7f40aa8bd7378 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Vis sti"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "G\xe5 til den f\xf8rste side";
                    if (type === "last") return "G\xe5 til den sidste side";
                    if (type === "next") return "G\xe5 til den n\xe6ste side";
                    // if (type === 'previous') {
                    return "G\xe5 til den forrige side";
                },
                labelRowsPerPage: "R\xe6kker pr side:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}-${to} af ${count !== -1 ? count : `mere end ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} Stjern${value !== 1 ? "er" : ""}`,
                emptyLabelText: "Tom"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Slet",
                closeText: "Luk",
                loadingText: "Indl\xe6ser\u2026",
                noOptionsText: "Ingen muligheder",
                openText: "\xc5ben"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Luk"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Sideinddelings navigation",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Go to "}page ${page}`;
                    if (type === "first") return "G\xe5 til den f\xf8rste side";
                    if (type === "last") return "G\xe5 til den sidste side";
                    if (type === "next") return "G\xe5 til den n\xe6ste side";
                    // if (type === 'previous') {
                    return "G\xe5 til den forrige side";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$71de6dd85432e4cd = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Pfad anzeigen"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Zur ersten Seite";
                    if (type === "last") return "Zur letzten Seite";
                    if (type === "next") return "Zur n\xe4chsten Seite";
                    // if (type === 'previous') {
                    return "Zur vorherigen Seite";
                },
                labelRowsPerPage: "Zeilen pro Seite:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} von ${count !== -1 ? count : `mehr als ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} ${value !== 1 ? "Sterne" : "Stern"}`,
                emptyLabelText: "Keine Wertung"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Leeren",
                closeText: "Schlie\xdfen",
                loadingText: "Wird geladen\u2026",
                noOptionsText: "Keine Optionen",
                openText: "\xd6ffnen"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Schlie\xdfen"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Navigation via Seitennummerierung",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Gehe zu "}Seite ${page}`;
                    if (type === "first") return "Zur ersten Seite";
                    if (type === "last") return "Zur letzten Seite";
                    if (type === "next") return "Zur n\xe4chsten Seite";
                    // if (type === 'previous') {
                    return "Zur vorherigen Seite";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$36da114db0496e7a = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE\u03C2"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u03A0\u03C1\u03CE\u03C4\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1";
                    if (type === "last") return "\u03A4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1";
                    if (type === "next") return "\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1";
                    // if (type === "previous") {
                    return "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1";
                },
                labelRowsPerPage: "\u0393\u03C1\u03B1\u03BC\u03BC\u03AD\u03C2 \u03B1\u03BD\u03B1 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{3B1}\u{3C0}\u{3CC} ${count !== -1 ? count : `\u{3C0}\u{3AC}\u{3BD}\u{3C9} \u{3B1}\u{3C0}\u{3CC} ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{391}\u{3C3}\u{3C4}\u{3AD}\u{3C1}\u{3B9}${value !== 1 ? "\u03B1" : ""}`,
                emptyLabelText: "\u03A7\u03C9\u03C1\u03AF\u03C2 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u039A\u03B1\u03B8\u03B1\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2",
                closeText: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF",
                loadingText: "\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u2026",
                noOptionsText: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2",
                openText: "\u0386\u03BD\u03BF\u03B9\u03B3\u03BC\u03B1"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u03A0\u03BB\u03BF\u03AE\u03B3\u03B7\u03C3\u03B7 \u03C3\u03B5 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B5\u03C2",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 "}\u{3C3}\u{3B5}\u{3BB}\u{3AF}\u{3B4}\u{3B1} ${page}`;
                    if (type === "first") return "\u03A0\u03C1\u03CE\u03C4\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1";
                    if (type === "last") return "\u03A4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1";
                    if (type === "next") return "\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1";
                    // if (type === "previous") {
                    return "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$137380d9ce54f7f = {
};
const $b0a7e8b55b633e35$export$e3f6634382f135e9 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Mostrar ruta"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Ir a la primera p\xe1gina";
                    if (type === "last") return "Ir a la \xfaltima p\xe1gina";
                    if (type === "next") return "Ir a la p\xe1gina siguiente";
                    // if (type === 'previous') {
                    return "Ir a la p\xe1gina anterior";
                },
                labelRowsPerPage: "Filas por p\xe1gina:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} de ${count !== -1 ? count : `m\xe1s de ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} Estrella${value !== 1 ? "s" : ""}`,
                emptyLabelText: "Vac\xedo"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Limpiar",
                closeText: "Cerrar",
                loadingText: "Cargando\u2026",
                noOptionsText: "Sin opciones",
                openText: "Abierto"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Cerrar"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Paginador",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Ir a la "}p\xe1gina ${page}`;
                    if (type === "first") return "Ir a la primera p\xe1gina";
                    if (type === "last") return "Ir a la \xfaltima p\xe1gina";
                    if (type === "next") return "Ir a la p\xe1gina siguiente";
                    // if (type === 'previous') {
                    return "Ir a la p\xe1gina anterior";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$5821b2895d2af364 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "N\xe4ita teed"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Vali esimene lehek\xfclg";
                    if (type === "last") return "Vali viimane lehek\xfclg";
                    if (type === "next") return "Vali j\xe4rgmine lehek\xfclg";
                    // if (type === 'previous') {
                    return "Vali eelmine lehek\xfclg";
                },
                labelRowsPerPage: "Ridu lehek\xfcljel:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} / ${count !== -1 ? count : `rohkem kui ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} T\xe4rn${value !== 1 ? "i" : ""}`,
                emptyLabelText: "T\xfchi"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "T\xfchjenda",
                closeText: "Sulge",
                loadingText: "Laen\u2026",
                noOptionsText: "Valikuid ei ole",
                openText: "Ava"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Sulge"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Lehek\xfclgede valik",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Vali "}lehek\xfclg ${page}`;
                    if (type === "first") return "Vali esimene lehek\xfclg";
                    if (type === "last") return "Vali viimane lehek\xfclg";
                    if (type === "next") return "Vali j\xe4rgmine lehek\xfclg";
                    // if (type === 'previous') {
                    return "Vali eelmine lehek\xfclg";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$355e05e1e35701f3 = {
    components: {
        // MuiBreadcrumbs: {
        //   defaultProps: {
        //     expandText: 'Show path',
        //   },
        // },
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u0646\u0645\u0627\u06CC\u0634 \u0645\u0633\u06CC\u0631"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u0631\u0641\u062A\u0646 \u0628\u0647 \u0627\u0648\u0644\u06CC\u0646 \u0635\u0641\u062D\u0647";
                    if (type === "last") return "\u0631\u0641\u062A\u0646 \u0628\u0647 \u0622\u062E\u0631\u06CC\u0646 \u0635\u0641\u062D\u0647";
                    if (type === "next") return "\u0631\u0641\u062A\u0646 \u0628\u0647 \u0635\u0641\u062D\u0647\u200C\u06CC \u0628\u0639\u062F\u06CC";
                    // if (type === 'previous') {
                    return "\u0631\u0641\u062A\u0646 \u0628\u0647 \u0635\u0641\u062D\u0647\u200C\u06CC \u0642\u0628\u0644\u06CC";
                },
                labelRowsPerPage: "\u062A\u0639\u062F\u0627\u062F \u0633\u0637\u0631\u0647\u0627\u06CC \u0647\u0631 \u0635\u0641\u062D\u0647:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{627}\u{632} ${count !== -1 ? count : `\u{628}\u{6CC}\u{634}\u{62A}\u{631} \u{627}\u{632} ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{633}\u{62A}\u{627}\u{631}\u{647}`,
                emptyLabelText: "\u062E\u0627\u0644\u06CC"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u067E\u0627\u06A9\u200C\u06A9\u0631\u062F\u0646",
                closeText: "\u0628\u0633\u062A\u0646",
                loadingText: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC\u2026",
                noOptionsText: "\u0628\u06CC\u200C\u0646\u062A\u06CC\u062C\u0647",
                openText: "\u0628\u0627\u0632\u06A9\u0631\u062F\u0646"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0628\u0633\u062A\u0646"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u0646\u0627\u0648\u0628\u0631\u06CC \u0635\u0641\u062D\u0647",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u0631\u0641\u062A\u0646 \u0628\u0647 "}\u{635}\u{641}\u{62D}\u{647}\u{654} ${page}`;
                    if (type === "first") return "\u0631\u0641\u062A\u0646 \u0628\u0647 \u0627\u0648\u0644\u06CC\u0646 \u0635\u0641\u062D\u0647";
                    if (type === "last") return "\u0631\u0641\u062A\u0646 \u0628\u0647 \u0622\u062E\u0631\u06CC\u0646 \u0635\u0641\u062D\u0647";
                    if (type === "next") return "\u0631\u0641\u062A\u0646 \u0628\u0647 \u0635\u0641\u062D\u0647\u200C\u06CC \u0628\u0639\u062F\u06CC";
                    // if (type === 'previous') {
                    return "\u0631\u0641\u062A\u0646 \u0628\u0647 \u0635\u0641\u062D\u0647\u200C\u06CC \u0642\u0628\u0644\u06CC";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$58ce1b9d0396abba = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "N\xe4yt\xe4 reitti"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Mene ensimm\xe4iselle sivulle";
                    if (type === "last") return "Mene viimeiselle sivulle";
                    if (type === "next") return "Mene seuraavalle sivulle";
                    // if (type === 'previous') {
                    return "Mene edelliselle sivulle";
                },
                labelRowsPerPage: "Rivej\xe4 per sivu:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} / ${count !== -1 ? count : `enemm\xe4n kuin ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} T\xe4ht${value !== 1 ? "e\xe4" : "i"}`,
                emptyLabelText: "Tyhj\xe4"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Tyhjenn\xe4",
                closeText: "Sulje",
                loadingText: "Ladataan\u2026",
                noOptionsText: "Ei valintoja",
                openText: "Avaa"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Sulje"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Sivutus navigaatio",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "sivu" : "Mene sivulle"} ${page}`;
                    if (type === "first") return "Mene ensimm\xe4iselle sivulle";
                    if (type === "last") return "Mene viimeiselle sivulle";
                    if (type === "next") return "Mene seuraavalle sivulle";
                    // if (type === 'previous') {
                    return "Mene edelliselle sivulle";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$3cf78fd0a7299aaf = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Montrer le chemin"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Aller \xe0 la premi\xe8re page";
                    if (type === "last") return "Aller \xe0 la derni\xe8re page";
                    if (type === "next") return "Aller \xe0 la page suivante";
                    // if (type === 'previous') {
                    return "Aller \xe0 la page pr\xe9c\xe9dente";
                },
                labelRowsPerPage: "Lignes par page :",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} sur ${count !== -1 ? count : `plus que ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} Etoile${value !== 1 ? "s" : ""}`,
                emptyLabelText: "Vide"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Vider",
                closeText: "Fermer",
                loadingText: "Chargement\u2026",
                noOptionsText: "Pas de r\xe9sultats",
                openText: "Ouvrir"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Fermer"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "navigation de pagination",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Aller \xe0 la "}page ${page}`;
                    if (type === "first") return "Aller \xe0 la premi\xe8re page";
                    if (type === "last") return "Aller \xe0 la derni\xe8re page";
                    if (type === "next") return "Aller \xe0 la page suivante";
                    // if (type === 'previous') {
                    return "Aller \xe0 la page pr\xe9c\xe9dente";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$bde2986ea0626310 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u05D4\u05E6\u05D2 \u05E0\u05EA\u05D9\u05D1"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u05DC\u05E2\u05DE\u05D5\u05D3 \u05D4\u05E8\u05D0\u05E9\u05D5\u05DF";
                    if (type === "last") return "\u05DC\u05E2\u05DE\u05D5\u05D3 \u05D4\u05D0\u05D7\u05E8\u05D5\u05DF";
                    if (type === "next") return "\u05DC\u05E2\u05DE\u05D5\u05D3 \u05D4\u05D1\u05D0";
                    // if (type === 'previous') {
                    return "\u05DC\u05E2\u05DE\u05D5\u05D3 \u05D4\u05E7\u05D5\u05D3\u05DD";
                },
                labelRowsPerPage: "\u05E9\u05D5\u05E8\u05D5\u05EA \u05D1\u05E2\u05DE\u05D5\u05D3:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{5DE}\u{5EA}\u{5D5}\u{5DA} ${count !== -1 ? count : `\u{5D9}\u{5D5}\u{5EA}\u{5E8} \u{5DE} ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{5DB}\u{5D5}\u{5DB}\u{5D1}${value !== 1 ? "\u05D9\u05DD" : ""}`,
                emptyLabelText: "\u05E8\u05D9\u05E7"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u05E0\u05E7\u05D4",
                closeText: "\u05E1\u05D2\u05D5\u05E8",
                loadingText: "\u05D8\u05D5\u05E2\u05DF\u2026",
                noOptionsText: "\u05D0\u05D9\u05DF \u05D0\u05D5\u05E4\u05E6\u05D9\u05D5\u05EA",
                openText: "\u05E4\u05EA\u05D7"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u05E1\u05D2\u05D5\u05E8"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u05E0\u05D9\u05D5\u05D5\u05D8 \u05D1\u05E2\u05DE\u05D5\u05D3\u05D9\u05DD",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u05DC "}\u{5E2}\u{5DE}\u{5D5}\u{5D3} ${page}`;
                    if (type === "first") return "\u05DC\u05E2\u05DE\u05D5\u05D3 \u05D4\u05E8\u05D0\u05E9\u05D5\u05DF";
                    if (type === "last") return "\u05DC\u05E2\u05DE\u05D5\u05D3 \u05D4\u05D0\u05D7\u05E8\u05D5\u05DF";
                    if (type === "next") return "\u05DC\u05E2\u05DE\u05D5\u05D3 \u05D4\u05D1\u05D0";
                    // if (type === 'previous') {
                    return "\u05DC\u05E2\u05DE\u05D5\u05D3 \u05D4\u05E7\u05D5\u05D3\u05DD";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$474458fd7164260b = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u0930\u093E\u0938\u094D\u0924\u093E \u0926\u093F\u0916\u093E\u092F\u0947\u0902"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u092A\u0939\u0932\u0947 \u092A\u0943\u0937\u094D\u0920 \u092A\u0930 \u091C\u093E\u090F\u0901";
                    if (type === "last") return "\u0905\u0902\u0924\u093F\u092E \u092A\u0943\u0937\u094D\u0920 \u092A\u0930 \u091C\u093E\u090F\u0901";
                    if (type === "next") return "\u0905\u0917\u0932\u0947 \u092A\u0943\u0937\u094D\u0920 \u092A\u0930 \u091C\u093E\u090F\u0901";
                    // if (type === 'previous') {
                    return "\u092A\u093F\u091B\u0932\u0947 \u092A\u0943\u0937\u094D\u0920 \u092A\u0930 \u091C\u093E\u090F\u0901";
                },
                labelRowsPerPage: "\u092A\u0902\u0915\u094D\u0924\u093F\u092F\u093E\u0901 \u092A\u094D\u0930\u0924\u093F \u092A\u0943\u0937\u094D\u0920:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}-${to === -1 ? count : to} \u{915}\u{941}\u{932} ${count} \u{92E}\u{947}\u{902}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{924}\u{93E}\u{930}${value !== 1 ? "\u0947" : "\u093E"}`,
                emptyLabelText: "\u0930\u093F\u0915\u094D\u0924"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u0939\u091F\u093E\u092F\u0947\u0902",
                closeText: "\u092C\u0902\u0926 \u0915\u0930\u0947\u0902",
                loadingText: "\u0932\u094B\u0921 \u0939\u094B \u0930\u0939\u093E \u0939\u0948\u2026",
                noOptionsText: "\u0915\u094B\u0908 \u0935\u093F\u0915\u0932\u094D\u092A \u0928\u0939\u0940\u0902",
                openText: "\u0916\u094B\u0932\u0947\u0902"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u092C\u0902\u0926 \u0915\u0930\u0947\u0902"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u092A\u0943\u0938\u094D\u0920\u093E\u0928\u0941\u0938\u093E\u0930 \u0938\u0902\u091A\u093E\u0932\u0928",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `\u{92A}\u{943}\u{937}\u{94D}\u{920} ${page} ${selected ? "" : " \u092A\u0930 \u091C\u093E\u090F\u0901"}`;
                    if (type === "first") return "\u092A\u0939\u0932\u0947 \u092A\u0943\u0937\u094D\u0920 \u092A\u0930 \u091C\u093E\u090F\u0901";
                    if (type === "last") return "\u0905\u0902\u0924\u093F\u092E \u092A\u0943\u0937\u094D\u0920 \u092A\u0930 \u091C\u093E\u090F\u0901";
                    if (type === "next") return "\u0905\u0917\u0932\u0947 \u092A\u0943\u0937\u094D\u0920 \u092A\u0930 \u091C\u093E\u090F\u0901";
                    // if (type === 'previous') {
                    return "\u092A\u093F\u091B\u0932\u0947 \u092A\u0943\u0937\u094D\u0920 \u092A\u0930 \u091C\u093E\u090F\u0901";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$cb1063faa90b7ea0 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Poka\u017Ei putanju"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Idi na prvu stranicu";
                    if (type === "last") return "Idi na posljednju stranicu";
                    if (type === "next") return "Idi na sljede\u0107u stranicu";
                    // if (type === 'previous') {
                    return "Idi na prethodnu stranicu";
                },
                labelRowsPerPage: "Redova po stranici:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} od ${count !== -1 ? count : `vi\u{161}e nego ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>{
                    const lastDigit = value % 10;
                    const lastTwoDigits = value % 100;
                    if ([
                        2,
                        3,
                        4
                    ].includes(lastDigit) && ![
                        12,
                        13,
                        14
                    ].includes(lastTwoDigits)) return "Zvijezde";
                    return "Zvijezda";
                },
                emptyLabelText: "Prazno"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Bri\u0161i",
                closeText: "Zatvori",
                loadingText: "U\u010Ditavanje\u2026",
                noOptionsText: "Nema opcija",
                openText: "Otvori"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Zatvori"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Navigacija po stranicama",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Idi na "}stranicu ${page}`;
                    if (type === "first") return "Idi na prvu stranicu";
                    if (type === "last") return "Idi na zadnju stranicu";
                    if (type === "next") return "Idi na sljede\u0107u stranicu";
                    // if (type === 'previous') {
                    return "Idi na prethodnu stranicu";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$9e50be43f2c76bae = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\xdatvonal"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Els\u0151 oldalra";
                    if (type === "last") return "Utols\xf3 oldalra";
                    if (type === "next") return "K\xf6vetkez\u0151 oldalra";
                    // if (type === 'previous') {
                    return "El\u0151z\u0151 oldalra";
                },
                labelRowsPerPage: "Sorok sz\xe1ma:"
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} Csillag`,
                emptyLabelText: "\xdcres"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "T\xf6rl\xe9s",
                closeText: "Bez\xe1r\xe1s",
                loadingText: "T\xf6lt\xe9s\u2026",
                noOptionsText: "Nincs tal\xe1lat",
                openText: "Megnyit\xe1s"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Bez\xe1r\xe1s"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Lapoz\xe1s",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${page}. oldal${selected ? "" : "ra"}`;
                    if (type === "first") return "Els\u0151 oldalra";
                    if (type === "last") return "Utols\xf3 oldalra";
                    if (type === "next") return "K\xf6vetkez\u0151 oldalra";
                    // if (type === 'previous') {
                    return "El\u0151z\u0151 oldalra";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$97c93d1a61ccdf0b = {
    components: {
        // MuiBreadcrumbs: {
        //   defaultProps: {
        //     expandText: 'Show path',
        //   },
        // },
        MuiTablePagination: {
            defaultProps: {
                // getItemAriaLabel: (type) => {
                //   if (type === 'first') {
                //     return 'Go to first page';
                //   }
                //   if (type === 'last') {
                //     return 'Go to last page';
                //   }
                //   if (type === 'next') {
                //     return 'Go to next page';
                //   }
                //   // if (type === 'previous') {
                //   return 'Go to previous page';
                // },
                labelRowsPerPage: "\u054F\u0578\u0572\u0565\u0580 \u0574\u0565\u056F \u0567\u057B\u0578\u0582\u0574`"
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{531}\u{57D}\u{57F}\u{572}`,
                emptyLabelText: "\u0534\u0561\u057F\u0561\u0580\u056F"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u0544\u0561\u0584\u0580\u0565\u056C",
                closeText: "\u0553\u0561\u056F\u0565\u056C",
                loadingText: "\u0532\u0565\u057C\u0576\u0578\u0582\u0574\u2026",
                noOptionsText: "\u054F\u0561\u0580\u0562\u0565\u0580\u0561\u056F\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
                openText: "\u0532\u0561\u0581\u0565\u056C"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0553\u0561\u056F\u0565\u056C"
            }
        }
    }
};
const $b0a7e8b55b633e35$export$df180ad6c1a23cb6 = {
    components: {
        // MuiBreadcrumbs: {
        //   defaultProps: {
        //     expandText: 'Show path',
        //   },
        // },
        MuiTablePagination: {
            defaultProps: {
                // getItemAriaLabel: (type) => {
                //   if (type === 'first') {
                //     return 'Go to first page';
                //   }
                //   if (type === 'last') {
                //     return 'Go to last page';
                //   }
                //   if (type === 'next') {
                //     return 'Go to next page';
                //   }
                //   // if (type === 'previous') {
                //   return 'Go to previous page';
                // },
                labelRowsPerPage: "Baris per halaman:"
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} Bintang`
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Hapus",
                closeText: "Tutup",
                loadingText: "Memuat\u2026",
                noOptionsText: "Tidak ada opsi",
                openText: "Buka"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Tutup"
            }
        }
    }
};
const $b0a7e8b55b633e35$export$13dc4f1b23132a5e = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "S\xfdna sl\xf3\xf0"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Fara \xe1 fyrstu s\xed\xf0u";
                    if (type === "last") return "Fara \xe1 s\xed\xf0ustu s\xed\xf0u";
                    if (type === "next") return "Fara \xe1 n\xe6stu s\xed\xf0u";
                    // if (type === 'previous') {
                    return "Fara \xe1 fyrri s\xed\xf0u";
                },
                labelRowsPerPage: "Ra\xf0ir \xe1 s\xed\xf0u:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} af ${count !== -1 ? count : `fleiri enn ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} ${value === 1 ? "stjarna" : "stj\xf6rnur"}`,
                emptyLabelText: "T\xf3mt"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Hreinsa",
                closeText: "Loka",
                loadingText: "Hla\xf0a\u2026",
                noOptionsText: "Engar ni\xf0urst\xf6\xf0ur",
                openText: "Opna"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Loka"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "S\xed\xf0uflakk",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "S\xed\xf0a" : "Fara \xe1 s\xed\xf0u"} ${page}`;
                    if (type === "first") return "Fara \xe1 fyrstu s\xed\xf0u";
                    if (type === "last") return "Fara \xe1 s\xed\xf0ustu s\xed\xf0u";
                    if (type === "next") return "Fara \xe1 n\xe6stu s\xed\xf0u";
                    // if (type === 'previous') {
                    return "Fara \xe1 fyrri s\xed\xf0u";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$3d81fcf58458275 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Visualizza percorso"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Vai alla prima pagina";
                    if (type === "last") return "Vai all'ultima pagina";
                    if (type === "next") return "Vai alla pagina successiva";
                    // if (type === 'previous') {
                    return "Vai alla pagina precedente";
                },
                labelRowsPerPage: "Righe per pagina:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} di ${count !== -1 ? count : `pi\xf9 di ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} Stell${value !== 1 ? "e" : "a"}`,
                emptyLabelText: "Vuoto"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Svuota",
                closeText: "Chiudi",
                loadingText: "Caricamento in corso\u2026",
                noOptionsText: "Nessuna opzione",
                openText: "Apri"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Chiudi"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Navigazione impaginata",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Vai alla "}pagina ${page}`;
                    if (type === "first") return "Vai alla prima pagina";
                    if (type === "last") return "Vai all'ultima pagina";
                    if (type === "next") return "Vai alla pagina successiva";
                    // if (type === 'previous') {
                    return "Vai alla pagina precedente";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$8ecb678b62727551 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u3059\u3079\u3066\u8868\u793A"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u6700\u521D\u306E\u30DA\u30FC\u30B8\u3078";
                    if (type === "last") return "\u6700\u5F8C\u306E\u30DA\u30FC\u30B8\u3078";
                    if (type === "next") return "\u6B21\u306E\u30DA\u30FC\u30B8\u3078";
                    // if (type === 'previous') {
                    return "\u524D\u306E\u30DA\u30FC\u30B8\u3078";
                },
                labelRowsPerPage: "\u30DA\u30FC\u30B8\u3042\u305F\u308A\u306E\u884C\u6570:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{FF5E}${to} / ${count !== -1 ? count : `${to}\u{4EE5}\u{4E0A}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`\u{661F}${value}`,
                emptyLabelText: "\u661F\u306A\u3057"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u30AF\u30EA\u30A2",
                closeText: "\u9589\u3058\u308B",
                loadingText: "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026",
                noOptionsText: "\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093",
                openText: "\u958B\u304F"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u9589\u3058\u308B"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u30DA\u30FC\u30B8\u9078\u629E",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `\u{30DA}\u{30FC}\u{30B8}${page}${selected ? "" : "\u3078"}`;
                    if (type === "first") return "\u6700\u521D\u306E\u30DA\u30FC\u30B8\u3078";
                    if (type === "last") return "\u6700\u5F8C\u306E\u30DA\u30FC\u30B8\u3078";
                    if (type === "next") return "\u6B21\u306E\u30DA\u30FC\u30B8\u3078";
                    // if (type === 'previous') {
                    return "\u524D\u306E\u30DA\u30FC\u30B8\u3078";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$c58e5d39f13465fc = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u1794\u1784\u17D2\u17A0\u17B6\u1789\u1795\u17D2\u179B\u17BC\u179C"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u1791\u17C5\u1791\u17C6\u1796\u17D0\u179A\u178A\u17C6\u1794\u17BC\u1784";
                    if (type === "last") return "\u1791\u17C5\u1791\u17C6\u1796\u17D0\u179A\u1785\u17BB\u1784\u1780\u17D2\u179A\u17C4\u1799";
                    if (type === "next") return "\u1791\u17C5\u1791\u17C6\u1796\u17D0\u179A\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB";
                    // if (type === 'previous') {
                    return "\u1791\u17C5\u1791\u17C6\u1796\u17D0\u179A\u1798\u17BB\u1793";
                },
                labelRowsPerPage: "\u1785\u17C6\u1793\u17BD\u1793\u1787\u17BD\u179A\u178A\u17C1\u1780\u1780\u17D2\u1793\u17BB\u1784\u1798\u17BD\u1799\u1791\u17C6\u1796\u17D0\u179A:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from} - ${to} \u{1793}\u{17C3} ${count !== -1 ? count : `\u{1785}\u{17D2}\u{179A}\u{17BE}\u{1793}\u{1787}\u{17B6}\u{1784} ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{1795}\u{17D2}\u{1780}\u{17B6}\u{1799}${value !== 1 ? "" : ""}`,
                emptyLabelText: "\u1791\u1791\u17C1"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u179B\u17BB\u1794\u1785\u17C4\u179B",
                closeText: "\u1794\u17B7\u1791",
                loadingText: "\u1780\u17C6\u1796\u17BB\u1784\u179B\u17C4\u178F\u2026",
                noOptionsText: "\u1782\u17D2\u1798\u17B6\u1793\u1787\u1798\u17D2\u179A\u17BE\u179F",
                openText: "\u1794\u17BE\u1780"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u1794\u17B7\u1791"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u179A\u17BB\u1780\u179A\u1780\u1791\u17C6\u1796\u17D0\u179A",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u1791\u17C5 "}\u{1791}\u{17C6}\u{1796}\u{17D0}\u{179A} ${page}`;
                    if (type === "first") return "\u1791\u17C5\u1791\u17C6\u1796\u17D0\u179A\u178A\u17C6\u1794\u17BC\u1784";
                    if (type === "last") return "\u1791\u17C5\u1791\u17C6\u1796\u17D0\u179A\u1785\u17BB\u1784\u1780\u17D2\u179A\u17C4\u1799";
                    if (type === "next") return "\u1791\u17C5\u1791\u17C6\u1796\u17D0\u179A\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB";
                    // if (type === 'previous') {
                    return "\u1791\u17C5\u1791\u17C6\u1796\u17D0\u179A\u1798\u17BB\u1793";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$3560ad4eaf44532 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\uACBD\uB85C \uBCF4\uAE30"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\uCCAB \uBC88\uC9F8 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9";
                    if (type === "last") return "\uB9C8\uC9C0\uB9C9 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9";
                    if (type === "next") return "\uB2E4\uC74C \uD398\uC774\uC9C0\uB85C \uC774\uB3D9";
                    // if (type === 'previous') {
                    return "\uC774\uC804 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9";
                },
                labelRowsPerPage: "\uD398\uC774\uC9C0 \uB2F9 \uD589:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} / ${count !== -1 ? count : `${to}\u{AC1C} \u{C774}\u{C0C1}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{C810}`,
                emptyLabelText: "\uBE48 \uD14D\uC2A4\uD2B8"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\uC9C0\uC6B0\uAE30",
                closeText: "\uB2EB\uAE30",
                loadingText: "\uBD88\uB7EC\uC624\uB294 \uC911\u2026",
                noOptionsText: "\uC635\uC158 \uC5C6\uC74C",
                openText: "\uC5F4\uAE30"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\uB2EB\uAE30"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\uD398\uC774\uC9C0\uB124\uC774\uC158 \uB124\uBE44\uAC8C\uC774\uC158",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${page} \u{BC88}\u{C9F8} \u{D398}\u{C774}\u{C9C0}${selected ? "" : "\uB85C \uC774\uB3D9"}`;
                    if (type === "first") return "\uCCAB \uBC88\uC9F8 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9";
                    if (type === "last") return "\uB9C8\uC9C0\uB9C9 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9";
                    if (type === "next") return "\uB2E4\uC74C \uD398\uC774\uC9C0\uB85C \uC774\uB3D9";
                    // if (type === 'previous') {
                    return "\uC774\uC804 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$ea3a572deb97014e = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u0695\u06CE\u0686\u06A9\u06D5 \u067E\u06CC\u0634\u0627\u0646 \u0628\u062F\u06D5"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u0686\u0648\u0648\u0646\u06D5 \u06CC\u06D5\u06A9\u06D5\u0645 \u067E\u06D5\u0695\u06D5";
                    if (type === "last") return "\u0686\u0648\u0648\u0646\u06D5 \u06A9\u06C6\u062A\u0627 \u067E\u06D5\u0695\u06D5";
                    if (type === "next") return "\u0686\u0648\u0648\u0646\u06D5 \u067E\u06D5\u0695\u06D5\u06CC \u062F\u0648\u0627\u062A\u0631";
                    // if (type === 'previous') {
                    return "\u06AF\u06D5\u0695\u0627\u0646\u06D5\u0648\u06D5 \u0628\u06C6 \u067E\u06D5\u0695\u06D5\u06CC \u067E\u06CE\u0634\u0648\u0648";
                },
                labelRowsPerPage: "\u0698\u0645\u0627\u0631\u06D5\u06CC \u0695\u06CC\u0632\u06D5\u06A9\u0627\u0646 \u0644\u06D5 \u0647\u06D5\u0631 \u067E\u06D5\u0695\u06D5\u06CC\u06D5\u06A9:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{644}\u{6D5} ${count !== -1 ? count : ` \u{632}\u{6CC}\u{627}\u{62A}\u{631}\u{6D5} \u{644}\u{6D5}${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} ${value !== 1 ? "\u0626\u06D5\u0633\u062A\u06CE\u0631\u06D5\u06A9\u0627\u0646" : "\u0626\u06D5\u0633\u062A\u06CE\u0631\u06D5"}`,
                emptyLabelText: "\u062E\u0627\u06B5\u06CC\u06D5"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u0633\u0695\u06CC\u0646\u06D5\u0648\u06D5",
                closeText: "\u062F\u0627\u062E\u0633\u062A\u0646",
                loadingText: "\u0644\u06D5 \u0628\u0627\u0631\u06A9\u0631\u062F\u0646\u062F\u0627\u06CC\u06D5...",
                noOptionsText: "\u0647\u06CC\u0686 \u0628\u0698\u0627\u0631\u062F\u06D5\u06CC\u06D5\u06A9 \u0646\u06CC\u06D5",
                openText: "\u06A9\u0631\u062F\u0646\u06D5\u0648\u06D5"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u062F\u0627\u062E\u0633\u062A\u0646"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u06AF\u06D5\u0695\u0627\u0646 \u0644\u06D5 \u067E\u06D5\u0695\u06D5\u06A9\u0627\u0646",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u0686\u0648\u0648\u0646 \u0628\u06C6 "} \u{67E}\u{6D5}\u{695}\u{6D5}\u{6CC} ${page}`;
                    if (type === "first") return "\u0686\u0648\u0648\u0646\u06D5 \u06CC\u06D5\u06A9\u06D5\u0645 \u067E\u06D5\u0695\u06D5";
                    if (type === "last") return "\u0686\u0648\u0648\u0646\u06D5 \u06A9\u06C6\u062A\u0627 \u067E\u06D5\u0695\u06D5";
                    if (type === "next") return "\u0686\u0648\u0648\u0646\u06D5 \u067E\u06D5\u0695\u06D5\u06CC \u062F\u0648\u0627\u062A\u0631";
                    // if (type === 'previous') {
                    return "\u06AF\u06D5\u0695\u0627\u0646\u06D5\u0648\u06D5 \u0628\u06C6 \u067E\u06D5\u0695\u06D5\u06CC \u067E\u06CE\u0634\u0648\u0648";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$f893aec3d46e4365 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "R\xea n\xee\u015Fan bide"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Bi\xe7e r\xfbpela yekem";
                    if (type === "last") return "Bi\xe7e r\xfbpela daw\xee";
                    if (type === "next") return "Bi\xe7e r\xfbpela din";
                    // if (type === 'previous') {
                    return "Bi\xe7e r\xfbpela ber\xea";
                },
                labelRowsPerPage: "R\xeaz li ser r\xfbpel\xea:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} of ${count !== -1 ? count : `z\xeadetir ji ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} St\xeark`,
                emptyLabelText: "Vala"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Paqij bike",
                closeText: "Bigre",
                loadingText: "T\xea barkirin\u2026",
                noOptionsText: "Vebij\xeark tune",
                openText: "Veke"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Bigre"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Nav\xeegasyona r\xfbpelan",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Bi\xe7e "}r\xfbpel ${page}`;
                    if (type === "first") return "Bi\xe7e r\xfbpela yekem";
                    if (type === "last") return "Bi\xe7e r\xfbpela daw\xee";
                    if (type === "next") return "Bi\xe7e r\xfbpela din";
                    // if (type === 'previous') {
                    return "Bi\xe7e r\xfbpela ber\xea";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$201af39b4805810a = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u0422\u043E\u043B\u044B\u049B \u0436\u043E\u043B\u0434\u044B \u043A\u04E9\u0440\u0441\u0435\u0442\u0443"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u0435\u0442\u043A\u0435 \u04E9\u0442\u0443";
                    if (type === "last") return "\u0421\u043E\u04A3\u0493\u044B \u0431\u0435\u0442\u043A\u0435 \u04E9\u0442\u0443";
                    if (type === "next") return "\u041A\u0435\u043B\u0435\u0441\u0456 \u0431\u0435\u0442\u043A\u0435 \u04E9\u0442\u0443";
                    // if (type === 'previous') {
                    return "\u0410\u043B\u0434\u044B\u04A3\u0493\u044B \u0431\u0435\u0442\u043A\u0435 \u04E9\u0442\u0443";
                },
                labelRowsPerPage: "\u0411\u0435\u0442\u0442\u0435\u0433\u0456 \u049B\u0430\u0442\u0430\u0440\u043B\u0430\u0440:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${count !== -1 ? count : `+${to}`} \u{49B}\u{430}\u{442}\u{430}\u{440}\u{434}\u{44B}\u{4A3} \u{456}\u{448}\u{456}\u{43D}\u{435}\u{43D} ${from}\u{2013}${to}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{436}\u{4B1}\u{43B}\u{434}\u{44B}\u{437}`,
                emptyLabelText: "\u0420\u0435\u0439\u0442\u0438\u043D\u0433 \u0436\u043E\u049B"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u0422\u0430\u0437\u0430\u0440\u0442\u0443",
                closeText: "\u0416\u0430\u0431\u0443",
                loadingText: "\u0416\u04AF\u043A\u0442\u0435\u043B\u0443\u0434\u0435\u2026",
                noOptionsText: "\u049A\u043E\u043B \u0436\u0435\u0442\u0456\u043C\u0434\u0456 \u043D\u04B1\u0441\u049B\u0430\u043B\u0430\u0440 \u0436\u043E\u049B",
                openText: "\u0410\u0448\u0443"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0416\u0430\u0431\u0443"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u0411\u0435\u0442\u0442\u0435\u0440\u0434\u0456 \u0448\u0430\u0440\u043B\u0430\u0443",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") {
                        if (selected) return `${page} \u{2014} \u{431}\u{435}\u{442}`;
                        return `${page} \u{2014} \u{431}\u{435}\u{442}\u{43A}\u{435} \u{4E9}\u{442}\u{443}`;
                    }
                    if (type === "first") return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u0435\u0442\u043A\u0435 \u04E9\u0442\u0443";
                    if (type === "last") return "\u0421\u043E\u04A3\u0493\u044B \u0431\u0435\u0442\u043A\u0435 \u04E9\u0442\u0443";
                    if (type === "next") return "\u041A\u0435\u043B\u0435\u0441\u0456 \u0431\u0435\u0442\u043A\u0435 \u04E9\u0442\u0443";
                    // if (type === 'previous') {
                    return "\u0410\u043B\u0434\u044B\u04A3\u0493\u044B \u0431\u0435\u0442\u043A\u0435 \u04E9\u0442\u0443";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$58de423c0bddc8fc = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u041F\u0440\u0438\u043A\u0430\u0436\u0438 \u043F\u0430\u0442\u0435\u043A\u0430"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u041E\u0434\u0438 \u043D\u0430 \u043F\u0440\u0432\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                    if (type === "last") return "\u041E\u0434\u0438 \u043D\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                    if (type === "next") return "\u041E\u0434\u0438 \u043D\u0430 \u0441\u043B\u0435\u0434\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                    // if (type === 'previous') {
                    return "\u041E\u0434\u0438 \u043D\u0430 \u043F\u0440\u0435\u0434\u0445\u043E\u0434\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                },
                labelRowsPerPage: "\u0420\u0435\u0434\u043E\u0432\u0438 \u043F\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{43E}\u{434} ${count !== -1 ? count : `\u{43F}\u{43E}\u{432}\u{435}\u{45C}\u{435} \u{43E}\u{434} ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>{
                    const lastDigit = value % 10;
                    return `${value} \u{405}\u{432}\u{435}\u{437}\u{434}${lastDigit === 1 ? "\u0430" : "\u0438"}`;
                },
                emptyLabelText: "\u041F\u0440\u0430\u0437\u043D\u043E"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u0418\u0437\u0431\u0440\u0438\u0448\u0438",
                closeText: "\u0417\u0430\u0442\u0432\u043E\u0440\u0438",
                loadingText: "\u0421\u0435 \u043F\u0440\u0435\u0437\u0435\u043C\u0430",
                noOptionsText: "\u041D\u0435\u043C\u0430 \u043E\u043F\u0446\u0438\u0458\u0430",
                openText: "\u041E\u0442\u0432\u043E\u0440\u0438"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u041D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u0458\u0430 \u043D\u0438\u0437 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0438",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u041E\u0434\u0438 \u043D\u0430 "}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430} ${page}`;
                    if (type === "first") return "\u041E\u0434\u0438 \u043D\u0430 \u043F\u0440\u0432\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                    if (type === "last") return "\u041E\u0434\u0438 \u043D\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                    if (type === "next") return "\u041E\u0434\u0438 \u043D\u0430 \u0441\u043B\u0435\u0434\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                    // if (type === 'previous') {
                    return "\u041E\u0434\u0438 \u043D\u0430 \u043F\u0440\u0435\u0434\u0445\u043E\u0434\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$a93823d7fe1dce6d = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u101C\u1019\u103A\u1038\u1000\u103C\u1031\u102C\u1004\u103A\u1038\u1015\u103C\u1015\u102B\u104B"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u1015\u1011\u1019\u1005\u102C\u1019\u103B\u1000\u103A\u1014\u103E\u102C\u101E\u102D\u102F\u1037\u101E\u103D\u102C\u1038\u1015\u102B\u104B";
                    if (type === "last") return "\u1014\u1031\u102C\u1000\u103A\u1006\u102F\u1036\u1038\u1005\u102C\u1019\u103B\u1000\u103A\u1014\u103E\u102C\u101E\u102D\u102F\u1037\u101E\u103D\u102C\u1038\u1015\u102B\u104B";
                    if (type === "next") return "\u1014\u1031\u102C\u1000\u103A\u1005\u102C\u1019\u103B\u1000\u103A\u1014\u103E\u102C\u101E\u102D\u102F\u1037\u101E\u103D\u102C\u1038\u1015\u102B\u104B";
                    // if (type === 'previous') {
                    return "\u101A\u1001\u1004\u103A\u1005\u102C\u1019\u103B\u1000\u103A\u1014\u103E\u102C\u101E\u102D\u102F\u1037\u101E\u103D\u102C\u1038\u1015\u102B\u104B";
                },
                labelRowsPerPage: "\u1005\u102C\u1019\u103B\u1000\u103A\u1014\u103E\u102C\u1021\u101C\u102D\u102F\u1000\u103A \u1021\u1010\u1014\u103A\u1038\u1019\u103B\u102C\u1038:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{104F} ${count !== -1 ? count : `\u{1011}\u{1000}\u{103A}\u{1015}\u{102D}\u{102F}\u{1015}\u{103C}\u{102E}\u{1038} ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>{
                    const lastDigit = value % 10;
                    return `${value} \u{1000}\u{103C}\u{101A}\u{103A}\u{1015}\u{103D}\u{1004}\u{1037}\u{103A}${lastDigit === 1 ? "\u104E" : ""}`;
                },
                emptyLabelText: "\u1017\u101C\u102C"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u101B\u103E\u1004\u103A\u1038\u101C\u1004\u103A\u1038\u101E\u1031\u102C",
                closeText: "\u1015\u102D\u1010\u103A\u101C\u102D\u102F\u1000\u103A",
                loadingText: "\u1016\u103D\u1004\u1037\u103A\u1014\u1031\u101E\u100A\u103A\u2026",
                noOptionsText: "\u101B\u103D\u1031\u1038\u1001\u103B\u101A\u103A\u1001\u103D\u1004\u1037\u103A\u1019\u101B\u103E\u102D\u1015\u102B\u104B",
                openText: "\u1016\u103D\u1004\u1037\u103A\u101E\u100A\u103A\u104B"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u1015\u102D\u1010\u103A\u101C\u102D\u102F\u1000\u103A"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Pagination \u1021\u100A\u103D\u103E\u1014\u103A\u1038",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u101E\u103D\u102C\u1038\u1015\u102B\u104B "}\u{1005}\u{102C}\u{1019}\u{103B}\u{1000}\u{103A}\u{1014}\u{103E}\u{102C} ${page}`;
                    if (type === "first") return "\u1015\u1011\u1019\u1005\u102C\u1019\u103B\u1000\u103A\u1014\u103E\u102C\u101E\u102D\u102F\u1037\u101E\u103D\u102C\u1038\u1015\u102B\u104B";
                    if (type === "last") return "\u1014\u1031\u102C\u1000\u103A\u1006\u102F\u1036\u1038\u1005\u102C\u1019\u103B\u1000\u103A\u1014\u103E\u102C\u101E\u102D\u102F\u1037\u101E\u103D\u102C\u1038\u1015\u102B\u104B";
                    if (type === "next") return "\u1014\u1031\u102C\u1000\u103A\u1005\u102C\u1019\u103B\u1000\u103A\u1014\u103E\u102C\u101E\u102D\u102F\u1037\u101E\u103D\u102C\u1038\u1015\u102B\u104B";
                    // if (type === 'previous') {
                    return "\u101A\u1001\u1004\u103A\u1005\u102C\u1019\u103B\u1000\u103A\u1014\u103E\u102C\u101E\u102D\u102F\u1037\u101E\u103D\u102C\u1038\u1015\u102B\u104B";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$8d4aba5b9dcc5f4 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Tunjukkan laluan"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Pergi ke halaman pertama";
                    if (type === "last") return "Pergi ke halaman terakhir";
                    if (type === "next") return "Pergi ke halaman seterusnya";
                    // if (type === 'previous') {
                    return "Pergi ke halaman sebelumnya";
                },
                labelRowsPerPage: "Baris setiap halaman:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} daripada ${count !== -1 ? count : `lebih daripada ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>{
                    const lastDigit = value % 10;
                    return `${value} Bintang${lastDigit === 1 ? "s" : ""}`;
                },
                emptyLabelText: "kosong"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Jelas",
                closeText: "tutup",
                loadingText: "Memuatkan\u2026",
                noOptionsText: "Tiada pilihan",
                openText: "Buka"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "tutup"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Navigasi penomboran",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Pergi ke "}muka surat ${page}`;
                    if (type === "first") return "Pergi ke halaman pertama";
                    if (type === "last") return "Pergi ke halaman terakhir";
                    if (type === "next") return "Pergi ke halaman seterusnya";
                    // if (type === 'previous') {
                    return "Pergi ke halaman sebelumnya";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$4c2a6f3aedcd7321 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u092C\u093E\u091F\u094B \u0926\u0947\u0916\u093E\u0909\u0928\u0941\u0939\u094B\u0938\u094D"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u092A\u0939\u093F\u0932\u094B \u092A\u0943\u0937\u094D\u0920\u092E\u093E \u091C\u093E\u0928\u0941\u0939\u094B\u0938\u094D";
                    if (type === "last") return "\u0905\u0928\u094D\u0924\u093F\u092E \u092A\u0943\u0937\u094D\u0920\u092E\u093E \u091C\u093E\u0928\u0941\u0939\u094B\u0938\u094D";
                    if (type === "next") return "\u0905\u0930\u094D\u0915\u094B \u092A\u0943\u0937\u094D\u0920\u092E\u093E \u091C\u093E\u0928\u0941\u0939\u094B\u0938\u094D";
                    // if (type === 'previous') {
                    return "\u0905\u0918\u093F\u0932\u094D\u0932\u094B \u092A\u0943\u0937\u094D\u0920\u092E\u093E \u091C\u093E\u0928\u0941\u0939\u094B\u0938\u094D";
                },
                labelRowsPerPage: "\u092A\u094D\u0930\u0924\u093F \u092A\u0943\u0937\u094D\u0920 \u092A\u0919\u094D\u0915\u094D\u0924\u093F\u0939\u0930\u0942:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{915}\u{94B} ${count !== -1 ? count : `\u{927}\u{947}\u{930}\u{948} ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>{
                    const lastDigit = value % 10;
                    return `${value} \u{924}\u{93E}\u{930}\u{93E}${lastDigit === 1 ? "\u0938" : ""}`;
                },
                emptyLabelText: "\u0916\u093E\u0932\u0940"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u0916\u093E\u0932\u0940 \u0917\u0930\u094D\u0928\u0941\u0939\u094B\u0938\u094D",
                closeText: "\u092C\u0928\u094D\u0926 \u0917\u0930\u094D\u0928\u0941\u0939\u094B\u0938\u094D",
                loadingText: "\u0932\u094B\u0921 \u0939\u0941\u0901\u0926\u0948...",
                noOptionsText: "\u0915\u0941\u0928\u0948 \u0935\u093F\u0915\u0932\u094D\u092A \u091B\u0948\u0928",
                openText: "\u0916\u094B\u0932\u094D\u0928\u0941\u0939\u094B\u0938\u094D"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u092C\u0928\u094D\u0926 \u0917\u0930\u094D\u0928\u0941\u0939\u094B\u0938\u094D"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u092A\u0943\u0937\u094D\u0920\u093E\u0902\u0915\u0928 \u0928\u0947\u092D\u093F\u0917\u0947\u0938\u0928",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u091C\u093E\u090A \u0924\u094D\u092F\u0939\u093E\u0901 "}\u{92A}\u{943}\u{937}\u{94D}\u{920} ${page}`;
                    if (type === "first") return "\u092A\u0939\u093F\u0932\u094B \u092A\u0943\u0937\u094D\u0920\u092E\u093E \u091C\u093E\u0928\u0941\u0939\u094B\u0938\u094D";
                    if (type === "last") return "\u0905\u0928\u094D\u0924\u093F\u092E \u092A\u0943\u0937\u094D\u0920\u092E\u093E \u091C\u093E\u0928\u0941\u0939\u094B\u0938\u094D";
                    if (type === "next") return "\u0905\u0930\u094D\u0915\u094B \u092A\u0943\u0937\u094D\u0920\u092E\u093E \u091C\u093E\u0928\u0941\u0939\u094B\u0938\u094D";
                    // if (type === 'previous') {
                    return "\u0905\u0918\u093F\u0932\u094D\u0932\u094B \u092A\u0943\u0937\u094D\u0920\u092E\u093E \u091C\u093E\u0928\u0941\u0939\u094B\u0938\u094D";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$cf06debb2b9327c4 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Vis sti"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "G\xe5 til f\xf8rste side";
                    if (type === "last") return "G\xe5 til siste side";
                    if (type === "next") return "G\xe5 til neste side";
                    // if (type === 'previous') {
                    return "G\xe5 til forrige side";
                },
                labelRowsPerPage: "Rader per side:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} av ${count !== -1 ? count : `mer enn ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} Stjerne${value !== 1 ? "r" : ""}`,
                emptyLabelText: "Tom"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "T\xf8m",
                closeText: "Lukk",
                loadingText: "Laster inn\u2026",
                noOptionsText: "Ingen alternativer",
                openText: "\xc5pne"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Lukk"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Paginering navigasjon",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "G\xe5 til "}side ${page}`;
                    if (type === "first") return "G\xe5 til f\xf8rste side";
                    if (type === "last") return "G\xe5 til siste side";
                    if (type === "next") return "G\xe5 til neste side";
                    // if (type === 'previous') {
                    return "G\xe5 til forrige side";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$5cc668ef92dea75a = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Vis sti"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "G\xe5 til f\xf8rste side";
                    if (type === "last") return "G\xe5 til siste side";
                    if (type === "next") return "G\xe5 til neste side";
                    // if (type === 'previous') {
                    return "G\xe5 til f\xf8rre side";
                },
                labelRowsPerPage: "Rader per side:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} av ${count !== -1 ? count : `fleire enn ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} stjerne${value !== 1 ? "r" : ""}`,
                emptyLabelText: "Tom"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "T\xf8m",
                closeText: "Lukk",
                loadingText: "Lastar inn\u2026",
                noOptionsText: "Ingen alternativ",
                openText: "Opna"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Lukk"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Navigasjon for paginering",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "G\xe5 til "}side ${page}`;
                    if (type === "first") return "G\xe5 til f\xf8rste side";
                    if (type === "last") return "G\xe5 til siste side";
                    if (type === "next") return "G\xe5 til neste side";
                    // if (type === 'previous') {
                    return "G\xe5 til f\xf8rre side";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$d37ad3aa929f0b03 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Pad tonen"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Ga naar eerste pagina";
                    if (type === "last") return "Ga naar laatste pagina";
                    if (type === "next") return "Ga naar volgende pagina";
                    // if (type === 'previous') {
                    return "Ga naar vorige pagina";
                },
                labelRowsPerPage: "Regels per pagina:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} van ${count !== -1 ? count : `meer dan ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} Ster${value !== 1 ? "ren" : ""}`,
                emptyLabelText: "Leeg"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Wissen",
                closeText: "Sluiten",
                loadingText: "Laden\u2026",
                noOptionsText: "Geen opties",
                openText: "Openen"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Sluiten"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Navigatie via paginering",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Ga naar "}pagina ${page}`;
                    if (type === "first") return "Ga naar eerste pagina";
                    if (type === "last") return "Ga naar laatste pagina";
                    if (type === "next") return "Ga naar volgende pagina";
                    // if (type === 'previous') {
                    return "Ga naar vorige pagina";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$10e968533ea7520d = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Poka\u017C \u015Bcie\u017Ck\u0119"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Przejd\u017A do pierwszej strony";
                    if (type === "last") return "Przejd\u017A do ostatniej strony";
                    if (type === "next") return "Przejd\u017A do nast\u0119pnej strony";
                    // if (type === 'previous') {
                    return "Przejd\u017A do poprzedniej strony";
                },
                labelRowsPerPage: "Wierszy na stron\u0119:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} z ${count !== -1 ? count : `ponad ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>{
                    let pluralForm = "gwiazdek";
                    const lastDigit = value % 10;
                    if ((value < 10 || value > 20) && lastDigit > 1 && lastDigit < 5) pluralForm = "gwiazdki";
                    else if (value === 1) pluralForm = "gwiazdka";
                    return `${value} ${pluralForm}`;
                },
                emptyLabelText: "Brak gwiazdek"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Wyczy\u015B\u0107",
                closeText: "Zamknij",
                loadingText: "\u0141adowanie\u2026",
                noOptionsText: "Brak opcji",
                openText: "Otw\xf3rz"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Zamknij"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Nawigacja podzia\u0142u na strony",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return selected ? `${page}. strona` : `Przejd\u{17A} do ${page}. strony`;
                    if (type === "first") return "Przejd\u017A do pierwszej strony";
                    if (type === "last") return "Przejd\u017A do ostatniej strony";
                    if (type === "next") return "Przejd\u017A do nast\u0119pnej strony";
                    // if (type === 'previous') {
                    return "Przejd\u017A do poprzedniej strony";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$93dd81123f5ddbcd = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Mostrar caminho"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Ir para a primeira p\xe1gina";
                    if (type === "last") return "Ir para a \xfaltima p\xe1gina";
                    if (type === "next") return "Ir para a pr\xf3xima p\xe1gina";
                    // if (type === 'previous') {
                    return "Ir para a p\xe1gina anterior";
                },
                labelRowsPerPage: "Linhas por p\xe1gina:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} de ${count !== -1 ? count : `mais de ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} Estrela${value !== 1 ? "s" : ""}`,
                emptyLabelText: "Vazio"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Limpar",
                closeText: "Fechar",
                loadingText: "Carregando\u2026",
                noOptionsText: "Sem op\xe7\xf5es",
                openText: "Abrir"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Fechar"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Navegar pela pagina\xe7\xe3o",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Ir para a "}p\xe1gina ${page}`;
                    if (type === "first") return "Ir para a primeira p\xe1gina";
                    if (type === "last") return "Ir para a \xfaltima p\xe1gina";
                    if (type === "next") return "Ir para a pr\xf3xima p\xe1gina";
                    // if (type === 'previous') {
                    return "Ir para a p\xe1gina anterior";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$37e90a824a2cfdc9 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Mostrar caminho"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Primeira p\xe1gina";
                    if (type === "last") return "\xdaltima p\xe1gina";
                    if (type === "next") return "Pr\xf3xima p\xe1gina";
                    // if (type === 'previous') {
                    return "P\xe1gina anterior";
                },
                labelRowsPerPage: "Linhas por p\xe1gina:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} de ${count !== -1 ? count : `mais de ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} Estrela${value !== 1 ? "s" : ""}`,
                emptyLabelText: "Vazio"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Limpar",
                closeText: "Fechar",
                loadingText: "A carregar\u2026",
                noOptionsText: "Sem op\xe7\xf5es",
                openText: "Abrir"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Fechar"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Navegar por p\xe1ginas",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Ir para a "}p\xe1gina ${page}`;
                    if (type === "first") return "Primeira p\xe1gina";
                    if (type === "last") return "\xdaltima p\xe1gina";
                    if (type === "next") return "Pr\xf3xima p\xe1gina";
                    // if (type === 'previous') {
                    return "P\xe1gina anterior";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$604825d36fea6f4b = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Arat\u0103 calea"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Mergi la prima pagin\u0103";
                    if (type === "last") return "Mergi la ultima pagin\u0103";
                    if (type === "next") return "Mergi la pagina urm\u0103toare";
                    // if (type === 'previous') {
                    return "Mergi la pagina precedent\u0103";
                },
                labelRowsPerPage: "R\xe2nduri pe pagin\u0103:"
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} St${value !== 1 ? "ele" : "ea"}`,
                emptyLabelText: "Gol"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u0218terge",
                closeText: "\xcenchide",
                loadingText: "Se \xeencarc\u0103\u2026",
                noOptionsText: "Nicio op\u021Biune",
                openText: "Deschide"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\xcenchide"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Navigare prin paginare",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Mergi la "}pagina ${page}`;
                    if (type === "first") return "Mergi la prima pagin\u0103";
                    if (type === "last") return "Mergi la ultima pagin\u0103";
                    if (type === "next") return "Mergi la pagina urm\u0103toare";
                    // if (type === 'previous') {
                    return "Mergi la pagina precedent\u0103";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$41c4067650f36ac6 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Poka\u017Ei putanju"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Idi na prvu stranicu";
                    if (type === "last") return "Idi na poslednju stranicu";
                    if (type === "next") return "Idi na slede\u0107u stranicu";
                    // if (type === 'previous') {
                    return "Idi na prethodnu stranicu";
                },
                labelRowsPerPage: "Redova po stranici:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} od ${count !== -1 ? count : `vi\u{161}e nego ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>{
                    const lastDigit = value % 10;
                    const lastTwoDigits = value % 100;
                    if ([
                        2,
                        3,
                        4
                    ].includes(lastDigit) && ![
                        12,
                        13,
                        14
                    ].includes(lastTwoDigits)) return "Zvezde";
                    return "Zvezda";
                },
                emptyLabelText: "Prazno"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Bri\u0161i",
                closeText: "Zatvori",
                loadingText: "U\u010Ditavanje\u2026",
                noOptionsText: "Nema opcija",
                openText: "Otvori"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Zatvori"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Navigacija po stranicama",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Idi na "}stranicu ${page}`;
                    if (type === "first") return "Idi na prvu stranicu";
                    if (type === "last") return "Idi na zadnju stranicu";
                    if (type === "next") return "Idi na slede\u0107u stranicu";
                    // if (type === 'previous') {
                    return "Idi na prethodnu stranicu";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$6eca8b94a4798dda = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 \u043F\u0443\u0442\u044C"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043F\u0435\u0440\u0432\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443";
                    if (type === "last") return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u044E\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443";
                    if (type === "next") return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443";
                    // if (type === 'previous') {
                    return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443";
                },
                labelRowsPerPage: "\u0421\u0442\u0440\u043E\u043A \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{438}\u{437} ${count !== -1 ? count : `\u{431}\u{43E}\u{43B}\u{435}\u{435} \u{447}\u{435}\u{43C} ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>{
                    let pluralForm = "\u0417\u0432\u0451\u0437\u0434";
                    const lastDigit = value % 10;
                    if (lastDigit > 1 && lastDigit < 5) pluralForm = "\u0417\u0432\u0435\u0437\u0434\u044B";
                    else if (lastDigit === 1) pluralForm = "\u0417\u0432\u0435\u0437\u0434\u0430";
                    return `${value} ${pluralForm}`;
                },
                emptyLabelText: "\u0420\u0435\u0439\u0442\u0438\u043D\u0433 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C",
                closeText: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
                loadingText: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
                noOptionsText: "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0432",
                openText: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u041D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u044F \u043F\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u043C",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") {
                        if (selected) return `${page} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430}`;
                        return `\u{41F}\u{435}\u{440}\u{435}\u{439}\u{442}\u{438} \u{43D}\u{430} ${page} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{443}`;
                    }
                    if (type === "first") return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043F\u0435\u0440\u0432\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443";
                    if (type === "last") return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u044E\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443";
                    if (type === "next") return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443";
                    // if (type === 'previous') {
                    return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$35c64c6e9fb0fc71 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u0D9C\u0DB8\u0DB1\u0DCA \u0DB8\u0D9F \u0DB4\u0DD9\u0DB1\u0DCA\u0DC0\u0DB1\u0DCA\u0DB1"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u0DB4\u0DC5\u0DB8\u0DD4 \u0DB4\u0DD2\u0DA7\u0DD4\u0DC0\u0DA7 \u0DBA\u0DB1\u0DCA\u0DB1";
                    if (type === "last") return "\u0D85\u0DC0\u0DC3\u0DCF\u0DB1 \u0DB4\u0DD2\u0DA7\u0DD4\u0DC0\u0DA7 \u0DBA\u0DB1\u0DCA\u0DB1";
                    if (type === "next") return "\u0DB8\u0DD3\u0DC5\u0D9F \u0DB4\u0DD2\u0DA7\u0DD4\u0DC0\u0DA7 \u0DBA\u0DB1\u0DCA\u0DB1";
                    // if (type === 'previous') {
                    return "\u0DB4\u0DD9\u0DBB \u0DB4\u0DD2\u0DA7\u0DD4\u0DC0\u0DA7 \u0DBA\u0DB1\u0DCA\u0DB1";
                },
                labelRowsPerPage: "\u0DB4\u0DD2\u0DA7\u0DD4\u0DC0\u0D9A \u0DB4\u0DDA\u0DC5\u0DD2:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{DAF}\u{D9A}\u{DCA}\u{DC0}\u{DCF} ${count !== -1 ? count : `${to} \u{DA7} \u{DC0}\u{DD0}\u{DA9}\u{DD2} \u{DB4}\u{DCA}\u{200D}\u{DBB}\u{DB8}\u{DCF}\u{DAB}\u{DBA}\u{D9A}\u{DD2}\u{DB1}\u{DCA}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`\u{DAD}\u{DBB}\u{DD4} ${value}`,
                emptyLabelText: "\u0DC4\u0DD2\u0DC3\u0DCA"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u0DB8\u0D9A\u0DB1\u0DCA\u0DB1",
                closeText: "\u0DC0\u0DC3\u0DB1\u0DCA\u0DB1",
                loadingText: "\u0DB1\u0DD0\u0D82\u0DC0\u0DD9\u0DB8\u0DD2\u0DB1\u0DCA\u2026",
                noOptionsText: "\u0DC0\u0DD2\u0D9A\u0DBD\u0DCA\u0DB4 \u0DB1\u0DD0\u0DAD",
                openText: "\u0DC0\u0DD2\u0DC0\u0DD8\u0DAD \u0D9A\u0DBB\u0DB1\u0DCA\u0DB1"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0DC0\u0DC3\u0DB1\u0DCA\u0DB1"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u0DB4\u0DD2\u0DA7\u0DD4 \u0D85\u0DAD\u0DBB \u0DC3\u0D82\u0DA0\u0DBB\u0DAB\u0DBA",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `\u{DB4}\u{DD2}\u{DA7}\u{DD4}\u{DC0} ${page} ${selected ? "" : "\u0DA7 \u0DBA\u0DB1\u0DCA\u0DB1"}`;
                    if (type === "first") return "\u0DB4\u0DC5\u0DB8\u0DD4 \u0DB4\u0DD2\u0DA7\u0DD4\u0DC0\u0DA7 \u0DBA\u0DB1\u0DCA\u0DB1";
                    if (type === "last") return "\u0D85\u0DC0\u0DC3\u0DCF\u0DB1 \u0DB4\u0DD2\u0DA7\u0DD4\u0DC0\u0DA7 \u0DBA\u0DB1\u0DCA\u0DB1";
                    if (type === "next") return "\u0DB8\u0DD3\u0DC5\u0D9F \u0DB4\u0DD2\u0DA7\u0DD4\u0DC0\u0DA7 \u0DBA\u0DB1\u0DCA\u0DB1";
                    // if (type === 'previous') {
                    return "\u0DB4\u0DD9\u0DBB \u0DB4\u0DD2\u0DA7\u0DD4\u0DC0\u0DA7 \u0DBA\u0DB1\u0DCA\u0DB1";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$3bffe31f95eb43ee = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Uk\xe1za\u0165 cestu "
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\xcds\u0165 na prv\xfa str\xe1nku";
                    if (type === "last") return "\xcds\u0165 na posledn\xfa str\xe1nku";
                    if (type === "next") return "\xcds\u0165 na \u010Fa\u013E\u0161iu str\xe1nku";
                    // if (type === 'previous') {
                    return "\xcds\u0165 na predch\xe1dzaj\xfacu str\xe1nku";
                },
                labelRowsPerPage: "Riadkov na str\xe1nke:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} z ${count !== -1 ? count : `viac ako ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>{
                    if (value === 1) return `${value} hviezdi\u{10D}ka`;
                    if (value >= 2 && value <= 4) return `${value} hviezdi\u{10D}ky`;
                    return `${value} hviezdi\u{10D}iek`;
                },
                emptyLabelText: "Pr\xe1zdne"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Vymaza\u0165",
                closeText: "Zavrie\u0165",
                loadingText: "Na\u010D\xedtanie\u2026",
                noOptionsText: "\u017Diadne mo\u017Enosti",
                openText: "Otvori\u0165"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Zavrie\u0165"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Navig\xe1cia str\xe1nkovanim",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\xcds\u0165 na "}str\xe1nku ${page}`;
                    if (type === "first") return "\xcds\u0165 na prv\xfa str\xe1nku";
                    if (type === "last") return "\xcds\u0165 na posledn\xfa str\xe1nku";
                    if (type === "next") return "\xcds\u0165 na \u010Fa\u013E\u0161iu str\xe1nku";
                    // if (type === 'previous') {
                    return "\xcds\u0165 na predch\xe1dzaj\xfacu str\xe1nku";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$9756da06c0cd98fb = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Visa s\xf6kv\xe4g"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "G\xe5 till f\xf6rsta sidan";
                    if (type === "last") return "G\xe5 till sista sidan";
                    if (type === "next") return "G\xe5 till n\xe4sta sida";
                    // if (type === 'previous') {
                    return "G\xe5 till f\xf6reg\xe5ende sida";
                },
                labelRowsPerPage: "Rader per sida:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} av ${count !== -1 ? count : `fler \xe4n ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} ${value !== 1 ? "Stj\xe4rnor" : "Stj\xe4rna"}`,
                emptyLabelText: "Tom"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Rensa",
                closeText: "St\xe4ng",
                loadingText: "Laddar\u2026",
                noOptionsText: "Inga alternativ",
                openText: "\xd6ppna"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "St\xe4ng"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Sidnavigering",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "G\xe5 till "}sida ${page}`;
                    if (type === "first") return "G\xe5 till f\xf6rsta sidan";
                    if (type === "last") return "G\xe5 till sista sidan";
                    if (type === "next") return "G\xe5 till n\xe4sta sida";
                    // if (type === 'previous') {
                    return "G\xe5 till f\xf6reg\xe5ende sida";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$c0132af597dbc66f = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E23\u0E01";
                    if (type === "last") return "\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E2A\u0E38\u0E14\u0E17\u0E49\u0E32\u0E22";
                    if (type === "next") return "\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E16\u0E31\u0E14\u0E44\u0E1B";
                    // if (type === 'previous') {
                    return "\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E01\u0E48\u0E2D\u0E19";
                },
                labelRowsPerPage: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E41\u0E16\u0E27\u0E15\u0E48\u0E2D\u0E2B\u0E19\u0E49\u0E32:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{E08}\u{E32}\u{E01} ${count !== -1 ? count : `\u{E21}\u{E32}\u{E01}\u{E01}\u{E27}\u{E48}\u{E32} ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{E14}\u{E32}\u{E27}`,
                emptyLabelText: "\u0E27\u0E48\u0E32\u0E07\u0E40\u0E1B\u0E25\u0E48\u0E32"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u0E40\u0E04\u0E25\u0E35\u0E22\u0E23\u0E4C",
                closeText: "\u0E1B\u0E34\u0E14",
                loadingText: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14\u2026",
                noOptionsText: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01",
                openText: "\u0E40\u0E1B\u0E34\u0E14"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0E1B\u0E34\u0E14"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u0E44\u0E1B\u0E17\u0E35\u0E48"}\u{E2B}\u{E19}\u{E49}\u{E32} ${page}`;
                    if (type === "first") return "\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E23\u0E01";
                    if (type === "last") return "\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E2A\u0E38\u0E14\u0E17\u0E49\u0E32\u0E22";
                    if (type === "next") return "\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E16\u0E31\u0E14\u0E44\u0E1B";
                    // if (type === 'previous') {
                    return "\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E01\u0E48\u0E2D\u0E19";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$114b46492f6a26a7 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Yolu g\xf6ster"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u0130lk sayfaya git";
                    if (type === "last") return "Son sayfaya git";
                    if (type === "next") return "Sonraki sayfaya git";
                    // if (type === 'previous') {
                    return "\xd6nceki sayfaya git";
                },
                labelRowsPerPage: "Sayfa ba\u015F\u0131na sat\u0131r:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}-${to} / ${count !== -1 ? count : `${to}'den fazla`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} Y\u{131}ld\u{131}z`,
                emptyLabelText: "Bo\u015F"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Temizle",
                closeText: "Kapat",
                loadingText: "Y\xfckleniyor\u2026",
                noOptionsText: "Se\xe7enek yok",
                openText: "A\xe7"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Kapat"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Sayfa navigasyonu",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${page}. ${selected ? "sayfa" : "sayfaya git"}`;
                    if (type === "first") return "\u0130lk sayfaya git";
                    if (type === "last") return "Son sayfaya git";
                    if (type === "next") return "Sonraki sayfaya git";
                    // if (type === 'previous') {
                    return "\xd6nceki sayfaya git";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$8b0dc4a5f7d4e610 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "Ipakita ang landas"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "Pumunta sa unang pahina";
                    if (type === "last") return "Pumunta sa huling pahina";
                    if (type === "next") return "Pumunta sa susunod na pahina";
                    // if (type === 'previous') {
                    return "Pumunta sa nakaraang pahina";
                },
                labelRowsPerPage: "Mga hilera bawat pahina:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} ng ${count !== -1 ? count : `higit sa ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} Bituin${value !== 1 ? "s" : ""}`,
                emptyLabelText: "Walang laman"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "Maaliwalas",
                closeText: "Isara",
                loadingText: "Naglo-load\u2026",
                noOptionsText: "Walang mga pagpipilian",
                openText: "Bukas"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "Isara"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Sayfa navigasyonu",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "Pumunta sa"}pahina ${page}`;
                    if (type === "first") return "Pumunta sa unang pahina";
                    if (type === "last") return "Pumunta sa huling pahina";
                    if (type === "next") return "Pumunta sa susunod na pahina";
                    // if (type === 'previous') {
                    return "Pumunta sa nakaraang pahina";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$82210383458e9e6f = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0448\u043B\u044F\u0445 \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043F\u0435\u0440\u0448\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443";
                    if (type === "last") return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043E\u0441\u0442\u0430\u043D\u043D\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443";
                    if (type === "next") return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443";
                    // if (type === 'previous') {
                    return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443";
                },
                labelRowsPerPage: "\u0420\u044F\u0434\u043A\u0456\u0432 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} \u{437} ${count !== -1 ? count : `\u{43F}\u{43E}\u{43D}\u{430}\u{434} ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>{
                    let pluralForm = "\u0417\u0456\u0440\u043E\u043A";
                    const lastDigit = value % 10;
                    if (lastDigit > 1 && lastDigit < 5) pluralForm = "\u0417\u0456\u0440\u043A\u0438";
                    else if (lastDigit === 1) pluralForm = "\u0417\u0456\u0440\u043A\u0430";
                    return `${value} ${pluralForm}`;
                },
                emptyLabelText: "\u0420\u0435\u0439\u0442\u0438\u043D\u0433 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0439"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438",
                closeText: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
                loadingText: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u2026",
                noOptionsText: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0430\u0440\u0456\u0430\u043D\u0442\u0456\u0432",
                openText: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u041D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430\u043C\u0438",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 "}\u{441}\u{442}\u{43E}\u{440}\u{456}\u{43D}\u{43A}\u{443} ${page}`;
                    if (type === "first") return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043F\u0435\u0440\u0448\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443";
                    if (type === "last") return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043E\u0441\u0442\u0430\u043D\u043D\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443";
                    if (type === "next") return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443";
                    // if (type === 'previous') {
                    return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$9f7584329e441d93 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u0631\u0627\u0633\u062A\u06C1 \u062F\u06A9\u06BE\u0627\u0626\u06CC\u06BA"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u067E\u06C1\u0644\u06D2 \u0635\u0641\u062D\u06D2 \u067E\u0631 \u062C\u0627\u0626\u06CC\u06BA";
                    if (type === "last") return "\u0627\u0653\u062E\u0631\u06CC \u0635\u0641\u062D\u06D2 \u067E\u0631 \u062C\u0627\u0626\u06CC\u06BA";
                    if (type === "next") return "\u0627\u06AF\u0644\u06D2 \u0635\u0641\u062D\u06D2 \u067E\u0631 \u062C\u0627\u0626\u06CC\u06BA";
                    // if (type === 'previous') {
                    return "\u067E\u0686\u06BE\u0644\u06D2 \u0635\u0641\u062D\u06D2 \u067E\u0631 \u062C\u0627\u0626\u06CC\u06BA";
                },
                labelRowsPerPage: "\u0627\u06CC\u06A9 \u0635\u0641\u062D\u06D2 \u067E\u0631 \u0642\u0637\u0627\u0631\u06CC\u06BA:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${count !== -1 ? `${count} \u{645}\u{6CC}\u{6BA} \u{633}\u{6D2}` : `${to} \u{633}\u{6D2} \u{630}\u{6CC}\u{627}\u{62F}\u{6C1} \u{645}\u{6CC}\u{6BA} \u{633}\u{6D2}`} ${from} \u{633}\u{6D2} ${to} \u{642}\u{637}\u{627}\u{631}\u{6CC}\u{6BA}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{633}\u{62A}\u{627}\u{631}${value !== 1 ? "\u06D2" : "\u06C1"}`,
                emptyLabelText: "\u062E\u0627\u0644\u06CC"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u06A9\u0644\u0626\u06CC\u0631",
                closeText: "\u0628\u0646\u062F \u06A9\u0631\u06CC\u06BA",
                loadingText: "\u0644\u0648\u0688 \u06C1\u0648 \u0631\u06C1\u0627 \u06C1\u06D2\u06D4\u06D4\u06D4",
                noOptionsText: "\u06A9\u0648\u0626\u06CC \u0627\u0653\u067E\u0634\u0646 \u0646\u06C1\u06CC\u06BA",
                openText: "\u06A9\u06BE\u0648\u0644\u06CC\u06BA"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0628\u0646\u062F \u06A9\u0631\u06CC\u06BA"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "\u0635\u0641\u062D\u0627\u062A \u06A9\u06CC \u062A\u0631\u062A\u06CC\u0628",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `\u{635}\u{641}\u{62D}\u{6C1} \u{646}\u{645}\u{628}\u{631} ${page}${selected ? "" : " \u067E\u0631 \u062C\u0627\u0626\u06CC\u06BA"}`;
                    if (type === "first") return "\u067E\u06C1\u0644\u06D2 \u0635\u0641\u062D\u06D2 \u067E\u0631 \u062C\u0627\u0626\u06CC\u06BA";
                    if (type === "last") return "\u0627\u0653\u062E\u0631\u06CC \u0635\u0641\u062D\u06D2 \u067E\u0631 \u062C\u0627\u0626\u06CC\u06BA";
                    if (type === "next") return "\u0627\u06AF\u0644\u06D2 \u0635\u0641\u062D\u06D2 \u067E\u0631 \u062C\u0627\u0626\u06CC\u06BA";
                    // if (type === 'previous') {
                    return "\u067E\u0686\u06BE\u0644\u06D2 \u0635\u0641\u062D\u06D2 \u067E\u0631 \u062C\u0627\u0626\u06CC\u06BA";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$177916e8a9d2e083 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "M\u1EDF ra"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "T\u1EDBi trang \u0111\u1EA7u ti\xean";
                    if (type === "last") return "T\u1EDBi trang cu\u1ED1i c\xf9ng";
                    if (type === "next") return "T\u1EDBi trang ti\u1EBFp theo";
                    // if (type === 'previous') {
                    return "V\u1EC1 trang tr\u01B0\u1EDBc \u0111\xf3";
                },
                labelRowsPerPage: "S\u1ED1 h\xe0ng m\u1ED7i trang:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}\u{2013}${to} trong ${count !== -1 ? count : `nhi\u{1EC1}u h\u{1A1}n ${to}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} sao`,
                emptyLabelText: "Kh\xf4ng c\xf3 d\u1EEF li\u1EC7u"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "X\xf3a",
                closeText: "\u0110\xf3ng",
                loadingText: "\u0110ang t\u1EA3i\u2026",
                noOptionsText: "Kh\xf4ng c\xf3 l\u1EF1a ch\u1ECDn n\xe0o",
                openText: "M\u1EDF"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u0110\xf3ng"
            }
        },
        MuiPagination: {
            defaultProps: {
                "aria-label": "Thanh \u0111i\u1EC1u khi\u1EC3n trang",
                getItemAriaLabel: (type, page, selected)=>{
                    if (type === "page") return `${selected ? "" : "T\u1EDBi "}trang ${page}`;
                    if (type === "first") return "T\u1EDBi trang \u0111\u1EA7u ti\xean";
                    if (type === "last") return "T\u1EDBi trang cu\u1ED1i c\xf9ng";
                    if (type === "next") return "T\u1EDBi trang ti\u1EBFp theo";
                    // if (type === 'previous') {
                    return "V\u1EC1 trang tr\u01B0\u1EDBc \u0111\xf3";
                }
            }
        }
    }
};
const $b0a7e8b55b633e35$export$836e793ad054f4a7 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u5C55\u5F00"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u7B2C\u4E00\u9875";
                    if (type === "last") return "\u6700\u540E\u4E00\u9875";
                    if (type === "next") return "\u4E0B\u4E00\u9875";
                    return "\u4E0A\u4E00\u9875";
                },
                labelRowsPerPage: "\u6BCF\u9875\u884C\u6570:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`\u{7B2C} ${from} \u{6761}\u{5230}\u{7B2C} ${to} \u{6761}\u{FF0C}${count !== -1 ? `\u{5171} ${count} \u{6761}` : `\u{81F3}\u{5C11} ${to} \u{6761}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{9897}\u{661F}`,
                emptyLabelText: "\u65E0\u6807\u7B7E"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u6E05\u7A7A",
                closeText: "\u5173\u95ED",
                loadingText: "\u52A0\u8F7D\u4E2D\u2026\u2026",
                noOptionsText: "\u6CA1\u6709\u53EF\u7528\u9009\u9879",
                openText: "\u6253\u5F00"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u5173\u95ED"
            }
        }
    }
};
const $b0a7e8b55b633e35$export$2099e693528da242 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u5C55\u958B"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u7B2C\u4E00\u9801";
                    if (type === "last") return "\u6700\u5F8C\u4E00\u9801";
                    if (type === "next") return "\u4E0B\u4E00\u9801";
                    return "\u4E0A\u4E00\u9801";
                },
                labelRowsPerPage: "\u6BCF\u9801\u884C\u6578:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`\u{7B2C} ${from} \u{9805}\u{81F3}\u{7B2C} ${to} \u{9805}\u{FF0C}${count !== -1 ? `\u{5171} ${count} \u{9805}` : `\u{8D85}\u{904E} ${to} \u{9805}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{7C92}\u{661F}`,
                emptyLabelText: "\u7121\u6A19\u7C64"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u6E05\u9664",
                closeText: "\u95DC\u9589",
                loadingText: "\u8F09\u5165\u4E2D\u2026\u2026",
                noOptionsText: "\u6C92\u6709\u53EF\u7528\u9078\u9805",
                openText: "\u958B\u555F"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u95DC\u9589"
            }
        }
    }
};
const $b0a7e8b55b633e35$export$3991fdf1bb6f66b9 = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: "\u5C55\u958B"
            }
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type)=>{
                    if (type === "first") return "\u7B2C\u4E00\u9801";
                    if (type === "last") return "\u6700\u5F8C\u4E00\u9801";
                    if (type === "next") return "\u4E0B\u4E00\u9801";
                    return "\u4E0A\u4E00\u9801";
                },
                labelRowsPerPage: "\u6BCF\u9801\u6578\u91CF:",
                labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from} ~ ${to} / ${count !== -1 ? count : `${to} \u{4EE5}\u{4E0A}`}`
            }
        },
        MuiRating: {
            defaultProps: {
                getLabelText: (value)=>`${value} \u{9846}\u{661F}`,
                emptyLabelText: "\u7121\u6A19\u7C64"
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: "\u6E05\u7A7A",
                closeText: "\u95DC\u9589",
                loadingText: "\u8F09\u5165\u4E2D\u2026",
                noOptionsText: "\u6C92\u6709\u53EF\u7528\u9078\u9805",
                openText: "\u6253\u958B"
            }
        },
        MuiAlert: {
            defaultProps: {
                closeText: "\u95DC\u9589"
            }
        }
    }
};


parcelRequire("6BF6w");

var $gcMmG = parcelRequire("gcMmG");
var $beWgj = parcelRequire("beWgj");

var $i0wFy = parcelRequire("i0wFy");

var $iG4aO = parcelRequire("iG4aO");

var $jvuxX = parcelRequire("jvuxX");

var $f9jQ6 = parcelRequire("f9jQ6");

var $jvuxX = parcelRequire("jvuxX");

var $f9jQ6 = parcelRequire("f9jQ6");

var $ihLQ3 = parcelRequire("ihLQ3");

var $iLk26 = parcelRequire("iLk26");

var $hPqEP = parcelRequire("hPqEP");
var $a2d74ef062024d8a$var$_queries;
var $a2d74ef062024d8a$export$5dde0cd941da8468 = class extends (0, $hPqEP.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $jvuxX.__privateAdd)(this, $a2d74ef062024d8a$var$_queries, void 0);
        (0, $jvuxX.__privateSet)(this, $a2d74ef062024d8a$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $f9jQ6.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $ihLQ3.Query)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $jvuxX.__privateGet)(this, $a2d74ef062024d8a$var$_queries).has(query.queryHash)) {
            (0, $jvuxX.__privateGet)(this, $a2d74ef062024d8a$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $jvuxX.__privateGet)(this, $a2d74ef062024d8a$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $jvuxX.__privateGet)(this, $a2d74ef062024d8a$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $iLk26.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $jvuxX.__privateGet)(this, $a2d74ef062024d8a$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $jvuxX.__privateGet)(this, $a2d74ef062024d8a$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $f9jQ6.matchQuery)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $f9jQ6.matchQuery)(filters, query)) : queries;
    }
    notify(event) {
        (0, $iLk26.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $iLk26.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $iLk26.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$a2d74ef062024d8a$var$_queries = new WeakMap();



var $jvuxX = parcelRequire("jvuxX");

var $iLk26 = parcelRequire("iLk26");

var $jvuxX = parcelRequire("jvuxX");

var $iLk26 = parcelRequire("iLk26");

var $kyUYW = parcelRequire("kyUYW");

var $g9Hbg = parcelRequire("g9Hbg");
var $5118a6d65d2fa2e1$var$_observers, $5118a6d65d2fa2e1$var$_mutationCache, $5118a6d65d2fa2e1$var$_retryer, $5118a6d65d2fa2e1$var$_dispatch, $5118a6d65d2fa2e1$var$dispatch_fn;
var $5118a6d65d2fa2e1$export$17b8b19c814bcf56 = class extends (0, $kyUYW.Removable) {
    constructor(config){
        super();
        (0, $jvuxX.__privateAdd)(this, $5118a6d65d2fa2e1$var$_dispatch);
        (0, $jvuxX.__privateAdd)(this, $5118a6d65d2fa2e1$var$_observers, void 0);
        (0, $jvuxX.__privateAdd)(this, $5118a6d65d2fa2e1$var$_mutationCache, void 0);
        (0, $jvuxX.__privateAdd)(this, $5118a6d65d2fa2e1$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $jvuxX.__privateSet)(this, $5118a6d65d2fa2e1$var$_mutationCache, config.mutationCache);
        (0, $jvuxX.__privateSet)(this, $5118a6d65d2fa2e1$var$_observers, []);
        this.state = config.state || $5118a6d65d2fa2e1$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_observers).includes(observer)) {
            (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $jvuxX.__privateSet)(this, $5118a6d65d2fa2e1$var$_observers, (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        (0, $jvuxX.__privateSet)(this, $5118a6d65d2fa2e1$var$_retryer, (0, $g9Hbg.createRetryer)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                (0, $jvuxX.__privateMethod)(this, $5118a6d65d2fa2e1$var$_dispatch, $5118a6d65d2fa2e1$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $jvuxX.__privateMethod)(this, $5118a6d65d2fa2e1$var$_dispatch, $5118a6d65d2fa2e1$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $jvuxX.__privateMethod)(this, $5118a6d65d2fa2e1$var$_dispatch, $5118a6d65d2fa2e1$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_retryer).canStart();
        try {
            if (!restored) {
                (0, $jvuxX.__privateMethod)(this, $5118a6d65d2fa2e1$var$_dispatch, $5118a6d65d2fa2e1$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await ((_b = (_a = (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $jvuxX.__privateMethod)(this, $5118a6d65d2fa2e1$var$_dispatch, $5118a6d65d2fa2e1$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_retryer).start();
            await ((_f = (_e = (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $jvuxX.__privateMethod)(this, $5118a6d65d2fa2e1$var$_dispatch, $5118a6d65d2fa2e1$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $jvuxX.__privateMethod)(this, $5118a6d65d2fa2e1$var$_dispatch, $5118a6d65d2fa2e1$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        } finally{
            (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_mutationCache).runNext(this);
        }
    }
};
$5118a6d65d2fa2e1$var$_observers = new WeakMap();
$5118a6d65d2fa2e1$var$_mutationCache = new WeakMap();
$5118a6d65d2fa2e1$var$_retryer = new WeakMap();
$5118a6d65d2fa2e1$var$_dispatch = new WeakSet();
$5118a6d65d2fa2e1$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $iLk26.notifyManager).batch(()=>{
        (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $jvuxX.__privateGet)(this, $5118a6d65d2fa2e1$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $5118a6d65d2fa2e1$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}



var $f9jQ6 = parcelRequire("f9jQ6");

var $hPqEP = parcelRequire("hPqEP");
var $4015c29731271684$var$_mutations, $4015c29731271684$var$_mutationId;
var $4015c29731271684$export$1fcfd9a244434844 = class extends (0, $hPqEP.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $jvuxX.__privateAdd)(this, $4015c29731271684$var$_mutations, void 0);
        (0, $jvuxX.__privateAdd)(this, $4015c29731271684$var$_mutationId, void 0);
        (0, $jvuxX.__privateSet)(this, $4015c29731271684$var$_mutations, /* @__PURE__ */ new Map());
        (0, $jvuxX.__privateSet)(this, $4015c29731271684$var$_mutationId, Date.now());
    }
    build(client, options, state) {
        const mutation = new (0, $5118a6d65d2fa2e1$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $jvuxX.__privateWrapper)(this, $4015c29731271684$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        const scope = $4015c29731271684$var$scopeFor(mutation);
        const mutations = (0, $jvuxX.__privateGet)(this, $4015c29731271684$var$_mutations).get(scope) ?? [];
        mutations.push(mutation);
        (0, $jvuxX.__privateGet)(this, $4015c29731271684$var$_mutations).set(scope, mutations);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        var _a;
        const scope = $4015c29731271684$var$scopeFor(mutation);
        if ((0, $jvuxX.__privateGet)(this, $4015c29731271684$var$_mutations).has(scope)) {
            const mutations = (_a = (0, $jvuxX.__privateGet)(this, $4015c29731271684$var$_mutations).get(scope)) == null ? void 0 : _a.filter((x)=>x !== mutation);
            if (mutations) {
                if (mutations.length === 0) (0, $jvuxX.__privateGet)(this, $4015c29731271684$var$_mutations).delete(scope);
                else (0, $jvuxX.__privateGet)(this, $4015c29731271684$var$_mutations).set(scope, mutations);
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        var _a;
        const firstPendingMutation = (_a = (0, $jvuxX.__privateGet)(this, $4015c29731271684$var$_mutations).get($4015c29731271684$var$scopeFor(mutation))) == null ? void 0 : _a.find((m)=>m.state.status === "pending");
        return !firstPendingMutation || firstPendingMutation === mutation;
    }
    runNext(mutation) {
        var _a;
        const foundMutation = (_a = (0, $jvuxX.__privateGet)(this, $4015c29731271684$var$_mutations).get($4015c29731271684$var$scopeFor(mutation))) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
        return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
    }
    clear() {
        (0, $iLk26.notifyManager).batch(()=>{
            this.getAll().forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return [
            ...(0, $jvuxX.__privateGet)(this, $4015c29731271684$var$_mutations).values()
        ].flat();
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $f9jQ6.matchMutation)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $f9jQ6.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $iLk26.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $iLk26.notifyManager).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $f9jQ6.noop)))));
    }
};
$4015c29731271684$var$_mutations = new WeakMap();
$4015c29731271684$var$_mutationId = new WeakMap();
function $4015c29731271684$var$scopeFor(mutation) {
    var _a;
    return ((_a = mutation.options.scope) == null ? void 0 : _a.id) ?? String(mutation.mutationId);
}



var $jqVGt = parcelRequire("jqVGt");

var $43Ycb = parcelRequire("43Ycb");

var $iLk26 = parcelRequire("iLk26");

var $bfkpQ = parcelRequire("bfkpQ");
var $751fd4c12c07f092$var$_queryCache, $751fd4c12c07f092$var$_mutationCache, $751fd4c12c07f092$var$_defaultOptions, $751fd4c12c07f092$var$_queryDefaults, $751fd4c12c07f092$var$_mutationDefaults, $751fd4c12c07f092$var$_mountCount, $751fd4c12c07f092$var$_unsubscribeFocus, $751fd4c12c07f092$var$_unsubscribeOnline;
var $751fd4c12c07f092$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $jvuxX.__privateAdd)(this, $751fd4c12c07f092$var$_queryCache, void 0);
        (0, $jvuxX.__privateAdd)(this, $751fd4c12c07f092$var$_mutationCache, void 0);
        (0, $jvuxX.__privateAdd)(this, $751fd4c12c07f092$var$_defaultOptions, void 0);
        (0, $jvuxX.__privateAdd)(this, $751fd4c12c07f092$var$_queryDefaults, void 0);
        (0, $jvuxX.__privateAdd)(this, $751fd4c12c07f092$var$_mutationDefaults, void 0);
        (0, $jvuxX.__privateAdd)(this, $751fd4c12c07f092$var$_mountCount, void 0);
        (0, $jvuxX.__privateAdd)(this, $751fd4c12c07f092$var$_unsubscribeFocus, void 0);
        (0, $jvuxX.__privateAdd)(this, $751fd4c12c07f092$var$_unsubscribeOnline, void 0);
        (0, $jvuxX.__privateSet)(this, $751fd4c12c07f092$var$_queryCache, config.queryCache || new (0, $a2d74ef062024d8a$export$5dde0cd941da8468)());
        (0, $jvuxX.__privateSet)(this, $751fd4c12c07f092$var$_mutationCache, config.mutationCache || new (0, $4015c29731271684$export$1fcfd9a244434844)());
        (0, $jvuxX.__privateSet)(this, $751fd4c12c07f092$var$_defaultOptions, config.defaultOptions || {});
        (0, $jvuxX.__privateSet)(this, $751fd4c12c07f092$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $jvuxX.__privateSet)(this, $751fd4c12c07f092$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $jvuxX.__privateSet)(this, $751fd4c12c07f092$var$_mountCount, 0);
    }
    mount() {
        (0, $jvuxX.__privateWrapper)(this, $751fd4c12c07f092$var$_mountCount)._++;
        if ((0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_mountCount) !== 1) return;
        (0, $jvuxX.__privateSet)(this, $751fd4c12c07f092$var$_unsubscribeFocus, (0, $jqVGt.focusManager).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).onFocus();
            }
        }));
        (0, $jvuxX.__privateSet)(this, $751fd4c12c07f092$var$_unsubscribeOnline, (0, $43Ycb.onlineManager).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $jvuxX.__privateWrapper)(this, $751fd4c12c07f092$var$_mountCount)._--;
        if ((0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_mountCount) !== 0) return;
        (_a = (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $jvuxX.__privateSet)(this, $751fd4c12c07f092$var$_unsubscribeFocus, void 0);
        (_b = (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $jvuxX.__privateSet)(this, $751fd4c12c07f092$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        if (cachedData === void 0) return this.fetchQuery(options);
        else {
            const defaultedOptions = this.defaultQueryOptions(options);
            const query = (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).build(this, defaultedOptions);
            if (options.revalidateIfStale && query.isStaleByTime((0, $f9jQ6.resolveStaleTime)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
            return Promise.resolve(cachedData);
        }
    }
    getQueriesData(filters) {
        return (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $f9jQ6.functionalUpdate)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $iLk26.notifyManager).batch(()=>(0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache);
        (0, $iLk26.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $iLk26.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $iLk26.notifyManager).batch(()=>(0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $f9jQ6.noop)).catch((0, $f9jQ6.noop));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, $iLk26.notifyManager).batch(()=>{
            (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: (options == null ? void 0 : options.cancelRefetch) ?? true
        };
        const promises = (0, $iLk26.notifyManager).batch(()=>(0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $f9jQ6.noop));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $f9jQ6.noop));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $f9jQ6.resolveStaleTime)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $f9jQ6.noop)).catch((0, $f9jQ6.noop));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $bfkpQ.infiniteQueryBehavior)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $f9jQ6.noop)).catch((0, $f9jQ6.noop));
    }
    resumePausedMutations() {
        if ((0, $43Ycb.onlineManager).isOnline()) return (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache);
    }
    getMutationCache() {
        return (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $jvuxX.__privateSet)(this, $751fd4c12c07f092$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryDefaults).set((0, $f9jQ6.hashKey)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $f9jQ6.partialMatchKey)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_mutationDefaults).set((0, $f9jQ6.hashKey)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $f9jQ6.partialMatchKey)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $f9jQ6.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.enabled !== true && defaultedOptions.queryFn === (0, $f9jQ6.skipToken)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_queryCache).clear();
        (0, $jvuxX.__privateGet)(this, $751fd4c12c07f092$var$_mutationCache).clear();
    }
};
$751fd4c12c07f092$var$_queryCache = new WeakMap();
$751fd4c12c07f092$var$_mutationCache = new WeakMap();
$751fd4c12c07f092$var$_defaultOptions = new WeakMap();
$751fd4c12c07f092$var$_queryDefaults = new WeakMap();
$751fd4c12c07f092$var$_mutationDefaults = new WeakMap();
$751fd4c12c07f092$var$_mountCount = new WeakMap();
$751fd4c12c07f092$var$_unsubscribeFocus = new WeakMap();
$751fd4c12c07f092$var$_unsubscribeOnline = new WeakMap();


var $kTmOQ = parcelRequire("kTmOQ");

var $jCgCX = parcelRequire("jCgCX");
var $8f92751dd9566d7a$exports = {};

!function(_, t) {
    $8f92751dd9566d7a$exports = t((parcelRequire("jCgCX")));
}($8f92751dd9566d7a$exports, function(_) {
    "use strict";
    function t(_) {
        return _ && "object" == typeof _ && "default" in _ ? _ : {
            default: _
        };
    }
    var e = t(_), n = "\u044F\u043D\u0432\u0430\u0440\u044F_\u0444\u0435\u0432\u0440\u0430\u043B\u044F_\u043C\u0430\u0440\u0442\u0430_\u0430\u043F\u0440\u0435\u043B\u044F_\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F_\u043E\u043A\u0442\u044F\u0431\u0440\u044F_\u043D\u043E\u044F\u0431\u0440\u044F_\u0434\u0435\u043A\u0430\u0431\u0440\u044F".split("_"), s = "\u044F\u043D\u0432\u0430\u0440\u044C_\u0444\u0435\u0432\u0440\u0430\u043B\u044C_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B\u044C_\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C_\u043E\u043A\u0442\u044F\u0431\u0440\u044C_\u043D\u043E\u044F\u0431\u0440\u044C_\u0434\u0435\u043A\u0430\u0431\u0440\u044C".split("_"), r = "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440._\u0430\u043F\u0440._\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split("_"), o = "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440\u0442_\u0430\u043F\u0440._\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split("_"), i = /D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;
    function d(_, t, e) {
        var n, s;
        return "m" === e ? t ? "\u043C\u0438\u043D\u0443\u0442\u0430" : "\u043C\u0438\u043D\u0443\u0442\u0443" : _ + " " + (n = +_, s = ({
            mm: t ? "\u043C\u0438\u043D\u0443\u0442\u0430_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442" : "\u043C\u0438\u043D\u0443\u0442\u0443_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442",
            hh: "\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043E\u0432",
            dd: "\u0434\u0435\u043D\u044C_\u0434\u043D\u044F_\u0434\u043D\u0435\u0439",
            MM: "\u043C\u0435\u0441\u044F\u0446_\u043C\u0435\u0441\u044F\u0446\u0430_\u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            yy: "\u0433\u043E\u0434_\u0433\u043E\u0434\u0430_\u043B\u0435\u0442"
        })[e].split("_"), n % 10 == 1 && n % 100 != 11 ? s[0] : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? s[1] : s[2]);
    }
    var u = function(_, t) {
        return i.test(t) ? n[_.month()] : s[_.month()];
    };
    u.s = s, u.f = n;
    var a = function(_, t) {
        return i.test(t) ? r[_.month()] : o[_.month()];
    };
    a.s = o, a.f = r;
    var m = {
        name: "ru",
        weekdays: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043F\u044F\u0442\u043D\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043E\u0442\u0430".split("_"),
        weekdaysShort: "\u0432\u0441\u043A_\u043F\u043D\u0434_\u0432\u0442\u0440_\u0441\u0440\u0434_\u0447\u0442\u0432_\u043F\u0442\u043D_\u0441\u0431\u0442".split("_"),
        weekdaysMin: "\u0432\u0441_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
        months: u,
        monthsShort: a,
        weekStart: 1,
        yearStart: 4,
        formats: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0433.",
            LLL: "D MMMM YYYY \u0433., H:mm",
            LLLL: "dddd, D MMMM YYYY \u0433., H:mm"
        },
        relativeTime: {
            future: "\u0447\u0435\u0440\u0435\u0437 %s",
            past: "%s \u043D\u0430\u0437\u0430\u0434",
            s: "\u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434",
            m: d,
            mm: d,
            h: "\u0447\u0430\u0441",
            hh: d,
            d: "\u0434\u0435\u043D\u044C",
            dd: d,
            M: "\u043C\u0435\u0441\u044F\u0446",
            MM: d,
            y: "\u0433\u043E\u0434",
            yy: d
        },
        ordinal: function(_) {
            return _;
        },
        meridiem: function(_) {
            return _ < 4 ? "\u043D\u043E\u0447\u0438" : _ < 12 ? "\u0443\u0442\u0440\u0430" : _ < 17 ? "\u0434\u043D\u044F" : "\u0432\u0435\u0447\u0435\u0440\u0430";
        }
    };
    return e.default.locale(m, null, !0), m;
});


var $1c4405f900e5d44a$exports = {};
!function(t, s) {
    $1c4405f900e5d44a$exports = s();
}($1c4405f900e5d44a$exports, function() {
    "use strict";
    var t, s, n = 1e3, i = 6e4, e = 36e5, r = 864e5, o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, d = 2628e6, a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, h = {
        years: u,
        months: d,
        days: r,
        hours: e,
        minutes: i,
        seconds: n,
        milliseconds: 1,
        weeks: 6048e5
    }, c = function(t) {
        return t instanceof g;
    }, f = function(t, s, n) {
        return new g(t, n, s.$l);
    }, m = function(t) {
        return s.p(t) + "s";
    }, l = function(t) {
        return t < 0;
    }, $ = function(t) {
        return l(t) ? Math.ceil(t) : Math.floor(t);
    }, y = function(t) {
        return Math.abs(t);
    }, v = function(t, s) {
        return t ? l(t) ? {
            negative: !0,
            format: "" + y(t) + s
        } : {
            negative: !1,
            format: "" + t + s
        } : {
            negative: !1,
            format: ""
        };
    }, g = function() {
        function l(t, s, n) {
            var i = this;
            if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
            if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
            if ("object" == typeof t) return Object.keys(t).forEach(function(s) {
                i.$d[m(s)] = t[s];
            }), this.calMilliseconds(), this;
            if ("string" == typeof t) {
                var e = t.match(a);
                if (e) {
                    var r = e.slice(2).map(function(t) {
                        return null != t ? Number(t) : 0;
                    });
                    return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
                }
            }
            return this;
        }
        var y = l.prototype;
        return y.calMilliseconds = function() {
            var t = this;
            this.$ms = Object.keys(this.$d).reduce(function(s, n) {
                return s + (t.$d[n] || 0) * h[n];
            }, 0);
        }, y.parseFromMilliseconds = function() {
            var t = this.$ms;
            this.$d.years = $(t / u), t %= u, this.$d.months = $(t / d), t %= d, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
        }, y.toISOString = function() {
            var t = v(this.$d.years, "Y"), s = v(this.$d.months, "M"), n = +this.$d.days || 0;
            this.$d.weeks && (n += 7 * this.$d.weeks);
            var i = v(n, "D"), e = v(this.$d.hours, "H"), r = v(this.$d.minutes, "M"), o = this.$d.seconds || 0;
            this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
            var u = v(o, "S"), d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative, a = e.format || r.format || u.format ? "T" : "", h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
            return "P" === h || "-P" === h ? "P0D" : h;
        }, y.toJSON = function() {
            return this.toISOString();
        }, y.format = function(t) {
            var n = t || "YYYY-MM-DDTHH:mm:ss", i = {
                Y: this.$d.years,
                YY: s.s(this.$d.years, 2, "0"),
                YYYY: s.s(this.$d.years, 4, "0"),
                M: this.$d.months,
                MM: s.s(this.$d.months, 2, "0"),
                D: this.$d.days,
                DD: s.s(this.$d.days, 2, "0"),
                H: this.$d.hours,
                HH: s.s(this.$d.hours, 2, "0"),
                m: this.$d.minutes,
                mm: s.s(this.$d.minutes, 2, "0"),
                s: this.$d.seconds,
                ss: s.s(this.$d.seconds, 2, "0"),
                SSS: s.s(this.$d.milliseconds, 3, "0")
            };
            return n.replace(o, function(t, s) {
                return s || String(i[t]);
            });
        }, y.as = function(t) {
            return this.$ms / h[m(t)];
        }, y.get = function(t) {
            var s = this.$ms, n = m(t);
            return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
        }, y.add = function(t, s, n) {
            var i;
            return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
        }, y.subtract = function(t, s) {
            return this.add(t, s, !0);
        }, y.locale = function(t) {
            var s = this.clone();
            return s.$l = t, s;
        }, y.clone = function() {
            return f(this.$ms, this);
        }, y.humanize = function(s) {
            return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
        }, y.valueOf = function() {
            return this.asMilliseconds();
        }, y.milliseconds = function() {
            return this.get("milliseconds");
        }, y.asMilliseconds = function() {
            return this.as("milliseconds");
        }, y.seconds = function() {
            return this.get("seconds");
        }, y.asSeconds = function() {
            return this.as("seconds");
        }, y.minutes = function() {
            return this.get("minutes");
        }, y.asMinutes = function() {
            return this.as("minutes");
        }, y.hours = function() {
            return this.get("hours");
        }, y.asHours = function() {
            return this.as("hours");
        }, y.days = function() {
            return this.get("days");
        }, y.asDays = function() {
            return this.as("days");
        }, y.weeks = function() {
            return this.get("weeks");
        }, y.asWeeks = function() {
            return this.as("weeks");
        }, y.months = function() {
            return this.get("months");
        }, y.asMonths = function() {
            return this.as("months");
        }, y.years = function() {
            return this.get("years");
        }, y.asYears = function() {
            return this.as("years");
        }, l;
    }(), p = function(t, s, n) {
        return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
    };
    return function(n, i, e) {
        t = e, s = e().$utils(), e.duration = function(t, s) {
            var n = e.locale();
            return f(t, {
                $l: n
            }, s);
        }, e.isDuration = c;
        var r = i.prototype.add, o = i.prototype.subtract;
        i.prototype.add = function(t, s) {
            return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
        }, i.prototype.subtract = function(t, s) {
            return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
        };
    };
});


var $4517ebf54c856f13$exports = {};
!function(t, i) {
    $4517ebf54c856f13$exports = i();
}($4517ebf54c856f13$exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});


var $6c1f643ab522b86a$exports = {};
!function(t, e) {
    $6c1f643ab522b86a$exports = e();
}($6c1f643ab522b86a$exports, function() {
    "use strict";
    var t = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    }, e = {};
    return function(n, i, o) {
        var r, a = function(t, n, i) {
            void 0 === i && (i = {});
            var o = new Date(t), r = function(t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short", o = t + "|" + i, r = e[o];
                return r || (r = new Intl.DateTimeFormat("en-US", {
                    hour12: !1,
                    timeZone: t,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZoneName: i
                }), e[o] = r), r;
            }(n, i);
            return r.formatToParts(o);
        }, u = function(e, n) {
            for(var i = a(e, n), r = [], u = 0; u < i.length; u += 1){
                var f = i[u], s = f.type, m = f.value, c = t[s];
                c >= 0 && (r[c] = parseInt(m, 10));
            }
            var d = r[3], l = 24 === d ? 0 : d, h = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000", v = +e;
            return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t, e) {
            void 0 === t && (t = r);
            var n, i = this.utcOffset(), a = this.toDate(), u = a.toLocaleString("en-US", {
                timeZone: t
            }), f = Math.round((a - new Date(u)) / 1e3 / 60), s = 15 * -Math.round(a.getTimezoneOffset() / 15) - f;
            if (!Number(s)) n = this.utcOffset(0, e);
            else if (n = o(u, {
                locale: this.$L
            }).$set("millisecond", this.$ms).utcOffset(s, !0), e) {
                var m = n.utcOffset();
                n = n.add(i - m, "minute");
            }
            return n.$x.$timezone = t, n;
        }, f.offsetName = function(t) {
            var e = this.$x.$timezone || o.tz.guess(), n = a(this.valueOf(), e, {
                timeZoneName: t
            }).find(function(t) {
                return "timezonename" === t.type.toLowerCase();
            });
            return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function(t, e) {
            if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
            var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
                locale: this.$L
            });
            return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, o.tz = function(t, e, n) {
            var i = n && e, a = n || e || r, f = u(+o(), a);
            if ("string" != typeof t) return o(t).tz(a);
            var s = function(t, e, n) {
                var i = t - 60 * e * 1e3, o = u(i, n);
                if (e === o) return [
                    i,
                    e
                ];
                var r = u(i -= 60 * (o - e) * 1e3, n);
                return o === r ? [
                    i,
                    o
                ] : [
                    t - 60 * Math.min(o, r) * 1e3,
                    Math.max(o, r)
                ];
            }(o.utc(t, i).valueOf(), f, a), m = s[0], c = s[1], d = o(m).utcOffset(c);
            return d.$x.$timezone = a, d;
        }, o.tz.guess = function() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t) {
            r = t;
        };
    };
});



var $ejD0p = parcelRequire("ejD0p");

var $6s8rf = parcelRequire("6s8rf");
var $b0b06d03fd95816e$exports = {};
!function(e, t) {
    $b0b06d03fd95816e$exports = t();
}($b0b06d03fd95816e$exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.weekday = function(e) {
            var t = this.$locale().weekStart || 0, i = this.$W, n = (i < t ? i + 7 : i) - t;
            return this.$utils().u(e) ? n : this.subtract(n, "day").add(e, "day");
        };
    };
});


const $ca9fb5e5aa5f5031$export$1d6cc1bb9eba8b8f = (locale = "ru")=>{
    /** https://day.js.org/docs/ru-RU/plugin/custom-parse-format для поддержки кастомных форматов (исправление Invalid Date) */ (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).extend((0, (/*@__PURE__*/$parcel$interopDefault($ejD0p))));
    (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).extend((0, (/*@__PURE__*/$parcel$interopDefault($1c4405f900e5d44a$exports))));
    (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).extend((0, (/*@__PURE__*/$parcel$interopDefault($4517ebf54c856f13$exports))));
    (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).extend((0, (/*@__PURE__*/$parcel$interopDefault($6c1f643ab522b86a$exports))));
    (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).extend((0, (/*@__PURE__*/$parcel$interopDefault($6s8rf))));
    (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).extend((0, (/*@__PURE__*/$parcel$interopDefault($b0b06d03fd95816e$exports))));
    (0, (/*@__PURE__*/$parcel$interopDefault($jCgCX))).locale(locale);
};


(0, $ca9fb5e5aa5f5031$export$1d6cc1bb9eba8b8f)("ru");
if (null) null.accept();
if (typeof $le8XK !== "undefined" && location.hostname === "asya.fomin-clinic.ru") {
    console.log("Sentry started", location.origin);
    $le8XK.init({
        dsn: location.hostname === "asya.fomin-clinic.ru" ? "https://3cadc3a27a972abf8889adcbf06dd14c@sentry.fomin-clinic.ru/5" : "https://1a341fe854c5e2685da85116108a0ea3@sentry.fomin-clinic.ru/11",
        release: (0, $iG4aO.VERSION),
        integrations: [
            $le8XK.reactRouterV4BrowserTracingIntegration({
                history: $lrsw3.history
            }),
            $le8XK.replayIntegration()
        ],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        tracesSampleRate: 1.0,
        tracePropagationTargets: [
            /^https:\/\/asya\.fomic-clinic\.ru/,
            /^https:\/\/asya-dev\.dev\.fomic-clinic\.ru/
        ]
    });
}
if (location.host.startsWith("asya.")) (0, (/*@__PURE__*/$parcel$interopDefault($3DzKC))).init("hn5tf3/mis-prod");
if (location.host.startsWith("asya-dev.")) (0, (/*@__PURE__*/$parcel$interopDefault($3DzKC))).init("hn5tf3/mis-test");
const $1f0dc3b9307be026$var$THEME = (0, $gcMmG.default)({
    components: {
        MuiTooltip: {
            defaultProps: {
                arrow: true
            }
        }
    },
    typography: {
        allVariants: {
            fontFamily: "Graphik"
        }
    },
    palette: {
        primary: {
            main: (0, $i0wFy.colors).lightMagenta
        },
        success: {
            main: (0, $i0wFy.colors).lightMagenta
        },
        grey: {
            main: (0, $i0wFy.colors).gray400
        },
        gray200: {
            main: (0, $i0wFy.colors).gray200
        },
        gray500: {
            main: (0, $i0wFy.colors).gray500
        },
        black: {
            main: (0, $i0wFy.colors).darkBlack
        },
        neutral15: {
            main: (0, $i0wFy.colors).neutral15
        }
    }
}, (0, $f653e8a6748acf89$export$6eca8b94a4798dda), (0, $b0a7e8b55b633e35$export$6eca8b94a4798dda));
const $1f0dc3b9307be026$var$queryClient = new (0, $751fd4c12c07f092$export$405d0624ed55a03f)();
const $1f0dc3b9307be026$var$root = document.getElementById("root");
if ($1f0dc3b9307be026$var$root) (0, $6fc264ec92100d3a$export$882461b6382ed46c)($1f0dc3b9307be026$var$root).render(/*#__PURE__*/ (0, $ih19M.jsx)((0, $beWgj.default), {
    theme: $1f0dc3b9307be026$var$THEME,
    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kTmOQ.QueryClientProvider), {
        client: $1f0dc3b9307be026$var$queryClient,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1LCZd.Router), {
            history: (0, $lrsw3.history),
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aa831a3b70830250$export$2e2bcd8739ae039), {})
        })
    })
}));


//# sourceMappingURL=index.0335ff9e.js.map
